/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/builds/prod/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ((function(modules) {
	// Check all modules for deduplicated modules
	for(var i in modules) {
		if(Object.prototype.hasOwnProperty.call(modules, i)) {
			switch(typeof modules[i]) {
			case "function": break;
			case "object":
				// Module can be created from a template
				modules[i] = (function(_m) {
					var args = _m.slice(1), fn = modules[_m[0]];
					return function (a,b,c) {
						fn.apply(this, [a,b,c].concat(args));
					};
				}(modules[i]));
				break;
			default:
				// Module is a copy of another module
				modules[i] = modules[modules[i]];
				break;
			}
		}
	}
	return modules;
}([
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(200);
	module.exports = __webpack_require__(206);


/***/ },
/* 1 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = __webpack_require__(314);


/***/ },
/* 2 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	/**
	 * Use invariant() to assert state which your program assumes to be true.
	 *
	 * Provide sprintf-style format (only %s is supported) and arguments
	 * to provide information about what broke and what you were
	 * expecting.
	 *
	 * The invariant message will be stripped in production, but the invariant
	 * will remain to ensure logic does not differ in production.
	 */
	
	function invariant(condition, format, a, b, c, d, e, f) {
	  if (false) {
	    if (format === undefined) {
	      throw new Error('invariant requires an error message argument');
	    }
	  }
	
	  if (!condition) {
	    var error;
	    if (format === undefined) {
	      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
	    } else {
	      var args = [a, b, c, d, e, f];
	      var argIndex = 0;
	      error = new Error(format.replace(/%s/g, function () {
	        return args[argIndex++];
	      }));
	      error.name = 'Invariant Violation';
	    }
	
	    error.framesToPop = 1; // we don't care about invariant's own frame
	    throw error;
	  }
	}
	
	module.exports = invariant;

/***/ },
/* 3 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule reactProdInvariant
	 * 
	 */
	'use strict';
	
	/**
	 * WARNING: DO NOT manually require this module.
	 * This is a replacement for `invariant(...)` used by the error code system
	 * and will _only_ be required by the corresponding babel pass.
	 * It always throws.
	 */
	
	function reactProdInvariant(code) {
	  var argCount = arguments.length - 1;
	
	  var message = 'Minified React error #' + code + '; visit ' + 'http://facebook.github.io/react/docs/error-decoder.html?invariant=' + code;
	
	  for (var argIdx = 0; argIdx < argCount; argIdx++) {
	    message += '&args[]=' + encodeURIComponent(arguments[argIdx + 1]);
	  }
	
	  message += ' for the full message or use the non-minified dev environment' + ' for full errors and additional helpful warnings.';
	
	  var error = new Error(message);
	  error.name = 'Invariant Violation';
	  error.framesToPop = 1; // we don't care about reactProdInvariant's own frame
	
	  throw error;
	}
	
	module.exports = reactProdInvariant;

/***/ },
/* 4 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var emptyFunction = __webpack_require__(10);
	
	/**
	 * Similar to invariant but only logs a warning if the condition is not met.
	 * This can be used to log issues in development environments in critical
	 * paths. Removing the logging code for production environments will keep the
	 * same logic and follow the same code paths.
	 */
	
	var warning = emptyFunction;
	
	if (false) {
	  (function () {
	    var printWarning = function printWarning(format) {
	      for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	        args[_key - 1] = arguments[_key];
	      }
	
	      var argIndex = 0;
	      var message = 'Warning: ' + format.replace(/%s/g, function () {
	        return args[argIndex++];
	      });
	      if (typeof console !== 'undefined') {
	        console.error(message);
	      }
	      try {
	        // --- Welcome to debugging React ---
	        // This error was thrown as a convenience so that you can use this stack
	        // to find the callsite that caused this warning to fire.
	        throw new Error(message);
	      } catch (x) {}
	    };
	
	    warning = function warning(condition, format) {
	      if (format === undefined) {
	        throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
	      }
	
	      if (format.indexOf('Failed Composite propType: ') === 0) {
	        return; // Ignore CompositeComponent proptype check.
	      }
	
	      if (!condition) {
	        for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
	          args[_key2 - 2] = arguments[_key2];
	        }
	
	        printWarning.apply(undefined, [format].concat(args));
	      }
	    };
	  })();
	}
	
	module.exports = warning;

/***/ },
/* 5 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.default = {
		APP_STATUS: {
			INITIALIZING: 1,
			AUTHENTICATING: 2,
			UNAUTHENTICATED: 3,
			READY: 4
		},
		HIDE_OPEN_TRAYS: 'HIDE_OPEN_TRAYS',
		CHANGE_LOADING: 'CHANGE_LOADING',
		REQUEST_AUTHENTICATION: 'REQUEST_AUTHENTICATION',
		REQUEST_AUTHENTICATION_SUCCESS: 'REQUEST_AUTHENTICATION_SUCCESS',
		REQUEST_AUTHENTICATION_FAIL: 'REQUEST_AUTHENTICATION_FAIL',
		REQUEST_SIGN_IN: 'REQUEST_SIGN_IN',
		SELECT_SCHOOL: 'SELECT_SCHOOL',
		CHANGE_SCHEDULE: 'CHANGE_SCHEDULE',
		REQUEST_SCHEDULES: 'REQUEST_SCHEDULES',
		REQUEST_SCHEDULES_SUCCESS: 'REQUEST_SCHEDULES_SUCCESS',
		REQUEST_SCHEDULES_FAIL: 'REQUEST_SCHEDULES_FAIL',
		REQUEST_SCHEDULE: 'REQUEST_SCHEDULE',
		REQUEST_SCHEDULE_SUCCESS: 'REQUEST_SCHEDULE_SUCCESS',
		REQUEST_SCHEDULE_FAIL: 'REQUEST_SCHEDULE_FAIL',
		REQUEST_TEACHERS_SUCCESS: 'REQUEST_TEACHERS_SUCCESS',
		REQUEST_COHORTS_SUCCESS: 'REQUEST_COHORTS_SUCCESS',
		REQUEST_MEETINGS_SUCCESS: 'REQUEST_MEETINGS_SUCCESS',
		REQUEST_SCHEDULED_MEETINGS_SUCCESS: 'REQUEST_SCHEDULED_MEETINGS_SUCCESS',
		SELECT_TEACHER: 'SELECT_TEACHER',
		SELECT_TEACHERS: 'SELECT_TEACHERS',
		SELECT_PARTICIPANTS_GROUP: 'SELECT_PARTICIPANTS_GROUP',
		UNSELECT_TEACHERS: 'UNSELECT_TEACHERS',
		SELECT_COHORT: 'SELECT_COHORT',
		UNSELECT_COHORTS: 'UNSELECT_COHORTS',
		SELECT_CONTROLS_MENU_ITEM: 'SELECT_CONTROLS_MENU_ITEM',
		SELECT_LAYERS_MENU_ITEM: 'SELECT_LAYERS_MENU_ITEM',
		SELECT_TOOLS_MENU_ITEM: 'SELECT_TOOLS_MENU_ITEM',
		SELECT_VIEWER_CELL: 'SELECT_VIEWER_CELL',
		SELECT_VIEWER_COLUMN: 'SELECT_VIEWER_COLUMN',
		SELECT_VIEWER_SUBCOLUMN: 'SELECT_VIEWER_SUBCOLUMN',
		HIDE_VIEWER_COLUMN: 'HIDE_VIEWER_COLUMN',
		UNHIDE_VIEWER_COLUMNS: 'UNHIDE_VIEWER_COLUMNS',
		SELECT_MEETING_LAYER: 'SELECT_MEETING_LAYER',
		SELECT_MEETING_LABEL: 'SELECT_MEETING_LABEL',
		CHANGE_SCHEDULED_MEETING_NAMES: 'CHANGE_SCHEDULED_MEETING_NAMES',
		CHANGE_STUDENT_COHORT_FILTER: 'CHANGE_STUDENT_COHORT_FILTER',
		SHOW_MODAL: 'SHOW_MODAL'
	};

/***/ },
/* 6 */
/***/ function(module, exports) {

	'use strict';
	/* eslint-disable no-unused-vars */
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	var propIsEnumerable = Object.prototype.propertyIsEnumerable;
	
	function toObject(val) {
		if (val === null || val === undefined) {
			throw new TypeError('Object.assign cannot be called with null or undefined');
		}
	
		return Object(val);
	}
	
	function shouldUseNative() {
		try {
			if (!Object.assign) {
				return false;
			}
	
			// Detect buggy property enumeration order in older V8 versions.
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=4118
			var test1 = new String('abc');  // eslint-disable-line
			test1[5] = 'de';
			if (Object.getOwnPropertyNames(test1)[0] === '5') {
				return false;
			}
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test2 = {};
			for (var i = 0; i < 10; i++) {
				test2['_' + String.fromCharCode(i)] = i;
			}
			var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
				return test2[n];
			});
			if (order2.join('') !== '0123456789') {
				return false;
			}
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test3 = {};
			'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
				test3[letter] = letter;
			});
			if (Object.keys(Object.assign({}, test3)).join('') !==
					'abcdefghijklmnopqrst') {
				return false;
			}
	
			return true;
		} catch (e) {
			// We don't expect any of the above to throw, but better to be safe.
			return false;
		}
	}
	
	module.exports = shouldUseNative() ? Object.assign : function (target, source) {
		var from;
		var to = toObject(target);
		var symbols;
	
		for (var s = 1; s < arguments.length; s++) {
			from = Object(arguments[s]);
	
			for (var key in from) {
				if (hasOwnProperty.call(from, key)) {
					to[key] = from[key];
				}
			}
	
			if (Object.getOwnPropertySymbols) {
				symbols = Object.getOwnPropertySymbols(from);
				for (var i = 0; i < symbols.length; i++) {
					if (propIsEnumerable.call(from, symbols[i])) {
						to[symbols[i]] = from[symbols[i]];
					}
				}
			}
		}
	
		return to;
	};


/***/ },
/* 7 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;//     Underscore.js 1.8.3
	//     http://underscorejs.org
	//     (c) 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	//     Underscore may be freely distributed under the MIT license.
	
	(function() {
	
	  // Baseline setup
	  // --------------
	
	  // Establish the root object, `window` in the browser, or `exports` on the server.
	  var root = this;
	
	  // Save the previous value of the `_` variable.
	  var previousUnderscore = root._;
	
	  // Save bytes in the minified (but not gzipped) version:
	  var ArrayProto = Array.prototype, ObjProto = Object.prototype, FuncProto = Function.prototype;
	
	  // Create quick reference variables for speed access to core prototypes.
	  var
	    push             = ArrayProto.push,
	    slice            = ArrayProto.slice,
	    toString         = ObjProto.toString,
	    hasOwnProperty   = ObjProto.hasOwnProperty;
	
	  // All **ECMAScript 5** native function implementations that we hope to use
	  // are declared here.
	  var
	    nativeIsArray      = Array.isArray,
	    nativeKeys         = Object.keys,
	    nativeBind         = FuncProto.bind,
	    nativeCreate       = Object.create;
	
	  // Naked function reference for surrogate-prototype-swapping.
	  var Ctor = function(){};
	
	  // Create a safe reference to the Underscore object for use below.
	  var _ = function(obj) {
	    if (obj instanceof _) return obj;
	    if (!(this instanceof _)) return new _(obj);
	    this._wrapped = obj;
	  };
	
	  // Export the Underscore object for **Node.js**, with
	  // backwards-compatibility for the old `require()` API. If we're in
	  // the browser, add `_` as a global object.
	  if (true) {
	    if (typeof module !== 'undefined' && module.exports) {
	      exports = module.exports = _;
	    }
	    exports._ = _;
	  } else {
	    root._ = _;
	  }
	
	  // Current version.
	  _.VERSION = '1.8.3';
	
	  // Internal function that returns an efficient (for current engines) version
	  // of the passed-in callback, to be repeatedly applied in other Underscore
	  // functions.
	  var optimizeCb = function(func, context, argCount) {
	    if (context === void 0) return func;
	    switch (argCount == null ? 3 : argCount) {
	      case 1: return function(value) {
	        return func.call(context, value);
	      };
	      case 2: return function(value, other) {
	        return func.call(context, value, other);
	      };
	      case 3: return function(value, index, collection) {
	        return func.call(context, value, index, collection);
	      };
	      case 4: return function(accumulator, value, index, collection) {
	        return func.call(context, accumulator, value, index, collection);
	      };
	    }
	    return function() {
	      return func.apply(context, arguments);
	    };
	  };
	
	  // A mostly-internal function to generate callbacks that can be applied
	  // to each element in a collection, returning the desired result — either
	  // identity, an arbitrary callback, a property matcher, or a property accessor.
	  var cb = function(value, context, argCount) {
	    if (value == null) return _.identity;
	    if (_.isFunction(value)) return optimizeCb(value, context, argCount);
	    if (_.isObject(value)) return _.matcher(value);
	    return _.property(value);
	  };
	  _.iteratee = function(value, context) {
	    return cb(value, context, Infinity);
	  };
	
	  // An internal function for creating assigner functions.
	  var createAssigner = function(keysFunc, undefinedOnly) {
	    return function(obj) {
	      var length = arguments.length;
	      if (length < 2 || obj == null) return obj;
	      for (var index = 1; index < length; index++) {
	        var source = arguments[index],
	            keys = keysFunc(source),
	            l = keys.length;
	        for (var i = 0; i < l; i++) {
	          var key = keys[i];
	          if (!undefinedOnly || obj[key] === void 0) obj[key] = source[key];
	        }
	      }
	      return obj;
	    };
	  };
	
	  // An internal function for creating a new object that inherits from another.
	  var baseCreate = function(prototype) {
	    if (!_.isObject(prototype)) return {};
	    if (nativeCreate) return nativeCreate(prototype);
	    Ctor.prototype = prototype;
	    var result = new Ctor;
	    Ctor.prototype = null;
	    return result;
	  };
	
	  var property = function(key) {
	    return function(obj) {
	      return obj == null ? void 0 : obj[key];
	    };
	  };
	
	  // Helper for collection methods to determine whether a collection
	  // should be iterated as an array or as an object
	  // Related: http://people.mozilla.org/~jorendorff/es6-draft.html#sec-tolength
	  // Avoids a very nasty iOS 8 JIT bug on ARM-64. #2094
	  var MAX_ARRAY_INDEX = Math.pow(2, 53) - 1;
	  var getLength = property('length');
	  var isArrayLike = function(collection) {
	    var length = getLength(collection);
	    return typeof length == 'number' && length >= 0 && length <= MAX_ARRAY_INDEX;
	  };
	
	  // Collection Functions
	  // --------------------
	
	  // The cornerstone, an `each` implementation, aka `forEach`.
	  // Handles raw objects in addition to array-likes. Treats all
	  // sparse array-likes as if they were dense.
	  _.each = _.forEach = function(obj, iteratee, context) {
	    iteratee = optimizeCb(iteratee, context);
	    var i, length;
	    if (isArrayLike(obj)) {
	      for (i = 0, length = obj.length; i < length; i++) {
	        iteratee(obj[i], i, obj);
	      }
	    } else {
	      var keys = _.keys(obj);
	      for (i = 0, length = keys.length; i < length; i++) {
	        iteratee(obj[keys[i]], keys[i], obj);
	      }
	    }
	    return obj;
	  };
	
	  // Return the results of applying the iteratee to each element.
	  _.map = _.collect = function(obj, iteratee, context) {
	    iteratee = cb(iteratee, context);
	    var keys = !isArrayLike(obj) && _.keys(obj),
	        length = (keys || obj).length,
	        results = Array(length);
	    for (var index = 0; index < length; index++) {
	      var currentKey = keys ? keys[index] : index;
	      results[index] = iteratee(obj[currentKey], currentKey, obj);
	    }
	    return results;
	  };
	
	  // Create a reducing function iterating left or right.
	  function createReduce(dir) {
	    // Optimized iterator function as using arguments.length
	    // in the main function will deoptimize the, see #1991.
	    function iterator(obj, iteratee, memo, keys, index, length) {
	      for (; index >= 0 && index < length; index += dir) {
	        var currentKey = keys ? keys[index] : index;
	        memo = iteratee(memo, obj[currentKey], currentKey, obj);
	      }
	      return memo;
	    }
	
	    return function(obj, iteratee, memo, context) {
	      iteratee = optimizeCb(iteratee, context, 4);
	      var keys = !isArrayLike(obj) && _.keys(obj),
	          length = (keys || obj).length,
	          index = dir > 0 ? 0 : length - 1;
	      // Determine the initial value if none is provided.
	      if (arguments.length < 3) {
	        memo = obj[keys ? keys[index] : index];
	        index += dir;
	      }
	      return iterator(obj, iteratee, memo, keys, index, length);
	    };
	  }
	
	  // **Reduce** builds up a single result from a list of values, aka `inject`,
	  // or `foldl`.
	  _.reduce = _.foldl = _.inject = createReduce(1);
	
	  // The right-associative version of reduce, also known as `foldr`.
	  _.reduceRight = _.foldr = createReduce(-1);
	
	  // Return the first value which passes a truth test. Aliased as `detect`.
	  _.find = _.detect = function(obj, predicate, context) {
	    var key;
	    if (isArrayLike(obj)) {
	      key = _.findIndex(obj, predicate, context);
	    } else {
	      key = _.findKey(obj, predicate, context);
	    }
	    if (key !== void 0 && key !== -1) return obj[key];
	  };
	
	  // Return all the elements that pass a truth test.
	  // Aliased as `select`.
	  _.filter = _.select = function(obj, predicate, context) {
	    var results = [];
	    predicate = cb(predicate, context);
	    _.each(obj, function(value, index, list) {
	      if (predicate(value, index, list)) results.push(value);
	    });
	    return results;
	  };
	
	  // Return all the elements for which a truth test fails.
	  _.reject = function(obj, predicate, context) {
	    return _.filter(obj, _.negate(cb(predicate)), context);
	  };
	
	  // Determine whether all of the elements match a truth test.
	  // Aliased as `all`.
	  _.every = _.all = function(obj, predicate, context) {
	    predicate = cb(predicate, context);
	    var keys = !isArrayLike(obj) && _.keys(obj),
	        length = (keys || obj).length;
	    for (var index = 0; index < length; index++) {
	      var currentKey = keys ? keys[index] : index;
	      if (!predicate(obj[currentKey], currentKey, obj)) return false;
	    }
	    return true;
	  };
	
	  // Determine if at least one element in the object matches a truth test.
	  // Aliased as `any`.
	  _.some = _.any = function(obj, predicate, context) {
	    predicate = cb(predicate, context);
	    var keys = !isArrayLike(obj) && _.keys(obj),
	        length = (keys || obj).length;
	    for (var index = 0; index < length; index++) {
	      var currentKey = keys ? keys[index] : index;
	      if (predicate(obj[currentKey], currentKey, obj)) return true;
	    }
	    return false;
	  };
	
	  // Determine if the array or object contains a given item (using `===`).
	  // Aliased as `includes` and `include`.
	  _.contains = _.includes = _.include = function(obj, item, fromIndex, guard) {
	    if (!isArrayLike(obj)) obj = _.values(obj);
	    if (typeof fromIndex != 'number' || guard) fromIndex = 0;
	    return _.indexOf(obj, item, fromIndex) >= 0;
	  };
	
	  // Invoke a method (with arguments) on every item in a collection.
	  _.invoke = function(obj, method) {
	    var args = slice.call(arguments, 2);
	    var isFunc = _.isFunction(method);
	    return _.map(obj, function(value) {
	      var func = isFunc ? method : value[method];
	      return func == null ? func : func.apply(value, args);
	    });
	  };
	
	  // Convenience version of a common use case of `map`: fetching a property.
	  _.pluck = function(obj, key) {
	    return _.map(obj, _.property(key));
	  };
	
	  // Convenience version of a common use case of `filter`: selecting only objects
	  // containing specific `key:value` pairs.
	  _.where = function(obj, attrs) {
	    return _.filter(obj, _.matcher(attrs));
	  };
	
	  // Convenience version of a common use case of `find`: getting the first object
	  // containing specific `key:value` pairs.
	  _.findWhere = function(obj, attrs) {
	    return _.find(obj, _.matcher(attrs));
	  };
	
	  // Return the maximum element (or element-based computation).
	  _.max = function(obj, iteratee, context) {
	    var result = -Infinity, lastComputed = -Infinity,
	        value, computed;
	    if (iteratee == null && obj != null) {
	      obj = isArrayLike(obj) ? obj : _.values(obj);
	      for (var i = 0, length = obj.length; i < length; i++) {
	        value = obj[i];
	        if (value > result) {
	          result = value;
	        }
	      }
	    } else {
	      iteratee = cb(iteratee, context);
	      _.each(obj, function(value, index, list) {
	        computed = iteratee(value, index, list);
	        if (computed > lastComputed || computed === -Infinity && result === -Infinity) {
	          result = value;
	          lastComputed = computed;
	        }
	      });
	    }
	    return result;
	  };
	
	  // Return the minimum element (or element-based computation).
	  _.min = function(obj, iteratee, context) {
	    var result = Infinity, lastComputed = Infinity,
	        value, computed;
	    if (iteratee == null && obj != null) {
	      obj = isArrayLike(obj) ? obj : _.values(obj);
	      for (var i = 0, length = obj.length; i < length; i++) {
	        value = obj[i];
	        if (value < result) {
	          result = value;
	        }
	      }
	    } else {
	      iteratee = cb(iteratee, context);
	      _.each(obj, function(value, index, list) {
	        computed = iteratee(value, index, list);
	        if (computed < lastComputed || computed === Infinity && result === Infinity) {
	          result = value;
	          lastComputed = computed;
	        }
	      });
	    }
	    return result;
	  };
	
	  // Shuffle a collection, using the modern version of the
	  // [Fisher-Yates shuffle](http://en.wikipedia.org/wiki/Fisher–Yates_shuffle).
	  _.shuffle = function(obj) {
	    var set = isArrayLike(obj) ? obj : _.values(obj);
	    var length = set.length;
	    var shuffled = Array(length);
	    for (var index = 0, rand; index < length; index++) {
	      rand = _.random(0, index);
	      if (rand !== index) shuffled[index] = shuffled[rand];
	      shuffled[rand] = set[index];
	    }
	    return shuffled;
	  };
	
	  // Sample **n** random values from a collection.
	  // If **n** is not specified, returns a single random element.
	  // The internal `guard` argument allows it to work with `map`.
	  _.sample = function(obj, n, guard) {
	    if (n == null || guard) {
	      if (!isArrayLike(obj)) obj = _.values(obj);
	      return obj[_.random(obj.length - 1)];
	    }
	    return _.shuffle(obj).slice(0, Math.max(0, n));
	  };
	
	  // Sort the object's values by a criterion produced by an iteratee.
	  _.sortBy = function(obj, iteratee, context) {
	    iteratee = cb(iteratee, context);
	    return _.pluck(_.map(obj, function(value, index, list) {
	      return {
	        value: value,
	        index: index,
	        criteria: iteratee(value, index, list)
	      };
	    }).sort(function(left, right) {
	      var a = left.criteria;
	      var b = right.criteria;
	      if (a !== b) {
	        if (a > b || a === void 0) return 1;
	        if (a < b || b === void 0) return -1;
	      }
	      return left.index - right.index;
	    }), 'value');
	  };
	
	  // An internal function used for aggregate "group by" operations.
	  var group = function(behavior) {
	    return function(obj, iteratee, context) {
	      var result = {};
	      iteratee = cb(iteratee, context);
	      _.each(obj, function(value, index) {
	        var key = iteratee(value, index, obj);
	        behavior(result, value, key);
	      });
	      return result;
	    };
	  };
	
	  // Groups the object's values by a criterion. Pass either a string attribute
	  // to group by, or a function that returns the criterion.
	  _.groupBy = group(function(result, value, key) {
	    if (_.has(result, key)) result[key].push(value); else result[key] = [value];
	  });
	
	  // Indexes the object's values by a criterion, similar to `groupBy`, but for
	  // when you know that your index values will be unique.
	  _.indexBy = group(function(result, value, key) {
	    result[key] = value;
	  });
	
	  // Counts instances of an object that group by a certain criterion. Pass
	  // either a string attribute to count by, or a function that returns the
	  // criterion.
	  _.countBy = group(function(result, value, key) {
	    if (_.has(result, key)) result[key]++; else result[key] = 1;
	  });
	
	  // Safely create a real, live array from anything iterable.
	  _.toArray = function(obj) {
	    if (!obj) return [];
	    if (_.isArray(obj)) return slice.call(obj);
	    if (isArrayLike(obj)) return _.map(obj, _.identity);
	    return _.values(obj);
	  };
	
	  // Return the number of elements in an object.
	  _.size = function(obj) {
	    if (obj == null) return 0;
	    return isArrayLike(obj) ? obj.length : _.keys(obj).length;
	  };
	
	  // Split a collection into two arrays: one whose elements all satisfy the given
	  // predicate, and one whose elements all do not satisfy the predicate.
	  _.partition = function(obj, predicate, context) {
	    predicate = cb(predicate, context);
	    var pass = [], fail = [];
	    _.each(obj, function(value, key, obj) {
	      (predicate(value, key, obj) ? pass : fail).push(value);
	    });
	    return [pass, fail];
	  };
	
	  // Array Functions
	  // ---------------
	
	  // Get the first element of an array. Passing **n** will return the first N
	  // values in the array. Aliased as `head` and `take`. The **guard** check
	  // allows it to work with `_.map`.
	  _.first = _.head = _.take = function(array, n, guard) {
	    if (array == null) return void 0;
	    if (n == null || guard) return array[0];
	    return _.initial(array, array.length - n);
	  };
	
	  // Returns everything but the last entry of the array. Especially useful on
	  // the arguments object. Passing **n** will return all the values in
	  // the array, excluding the last N.
	  _.initial = function(array, n, guard) {
	    return slice.call(array, 0, Math.max(0, array.length - (n == null || guard ? 1 : n)));
	  };
	
	  // Get the last element of an array. Passing **n** will return the last N
	  // values in the array.
	  _.last = function(array, n, guard) {
	    if (array == null) return void 0;
	    if (n == null || guard) return array[array.length - 1];
	    return _.rest(array, Math.max(0, array.length - n));
	  };
	
	  // Returns everything but the first entry of the array. Aliased as `tail` and `drop`.
	  // Especially useful on the arguments object. Passing an **n** will return
	  // the rest N values in the array.
	  _.rest = _.tail = _.drop = function(array, n, guard) {
	    return slice.call(array, n == null || guard ? 1 : n);
	  };
	
	  // Trim out all falsy values from an array.
	  _.compact = function(array) {
	    return _.filter(array, _.identity);
	  };
	
	  // Internal implementation of a recursive `flatten` function.
	  var flatten = function(input, shallow, strict, startIndex) {
	    var output = [], idx = 0;
	    for (var i = startIndex || 0, length = getLength(input); i < length; i++) {
	      var value = input[i];
	      if (isArrayLike(value) && (_.isArray(value) || _.isArguments(value))) {
	        //flatten current level of array or arguments object
	        if (!shallow) value = flatten(value, shallow, strict);
	        var j = 0, len = value.length;
	        output.length += len;
	        while (j < len) {
	          output[idx++] = value[j++];
	        }
	      } else if (!strict) {
	        output[idx++] = value;
	      }
	    }
	    return output;
	  };
	
	  // Flatten out an array, either recursively (by default), or just one level.
	  _.flatten = function(array, shallow) {
	    return flatten(array, shallow, false);
	  };
	
	  // Return a version of the array that does not contain the specified value(s).
	  _.without = function(array) {
	    return _.difference(array, slice.call(arguments, 1));
	  };
	
	  // Produce a duplicate-free version of the array. If the array has already
	  // been sorted, you have the option of using a faster algorithm.
	  // Aliased as `unique`.
	  _.uniq = _.unique = function(array, isSorted, iteratee, context) {
	    if (!_.isBoolean(isSorted)) {
	      context = iteratee;
	      iteratee = isSorted;
	      isSorted = false;
	    }
	    if (iteratee != null) iteratee = cb(iteratee, context);
	    var result = [];
	    var seen = [];
	    for (var i = 0, length = getLength(array); i < length; i++) {
	      var value = array[i],
	          computed = iteratee ? iteratee(value, i, array) : value;
	      if (isSorted) {
	        if (!i || seen !== computed) result.push(value);
	        seen = computed;
	      } else if (iteratee) {
	        if (!_.contains(seen, computed)) {
	          seen.push(computed);
	          result.push(value);
	        }
	      } else if (!_.contains(result, value)) {
	        result.push(value);
	      }
	    }
	    return result;
	  };
	
	  // Produce an array that contains the union: each distinct element from all of
	  // the passed-in arrays.
	  _.union = function() {
	    return _.uniq(flatten(arguments, true, true));
	  };
	
	  // Produce an array that contains every item shared between all the
	  // passed-in arrays.
	  _.intersection = function(array) {
	    var result = [];
	    var argsLength = arguments.length;
	    for (var i = 0, length = getLength(array); i < length; i++) {
	      var item = array[i];
	      if (_.contains(result, item)) continue;
	      for (var j = 1; j < argsLength; j++) {
	        if (!_.contains(arguments[j], item)) break;
	      }
	      if (j === argsLength) result.push(item);
	    }
	    return result;
	  };
	
	  // Take the difference between one array and a number of other arrays.
	  // Only the elements present in just the first array will remain.
	  _.difference = function(array) {
	    var rest = flatten(arguments, true, true, 1);
	    return _.filter(array, function(value){
	      return !_.contains(rest, value);
	    });
	  };
	
	  // Zip together multiple lists into a single array -- elements that share
	  // an index go together.
	  _.zip = function() {
	    return _.unzip(arguments);
	  };
	
	  // Complement of _.zip. Unzip accepts an array of arrays and groups
	  // each array's elements on shared indices
	  _.unzip = function(array) {
	    var length = array && _.max(array, getLength).length || 0;
	    var result = Array(length);
	
	    for (var index = 0; index < length; index++) {
	      result[index] = _.pluck(array, index);
	    }
	    return result;
	  };
	
	  // Converts lists into objects. Pass either a single array of `[key, value]`
	  // pairs, or two parallel arrays of the same length -- one of keys, and one of
	  // the corresponding values.
	  _.object = function(list, values) {
	    var result = {};
	    for (var i = 0, length = getLength(list); i < length; i++) {
	      if (values) {
	        result[list[i]] = values[i];
	      } else {
	        result[list[i][0]] = list[i][1];
	      }
	    }
	    return result;
	  };
	
	  // Generator function to create the findIndex and findLastIndex functions
	  function createPredicateIndexFinder(dir) {
	    return function(array, predicate, context) {
	      predicate = cb(predicate, context);
	      var length = getLength(array);
	      var index = dir > 0 ? 0 : length - 1;
	      for (; index >= 0 && index < length; index += dir) {
	        if (predicate(array[index], index, array)) return index;
	      }
	      return -1;
	    };
	  }
	
	  // Returns the first index on an array-like that passes a predicate test
	  _.findIndex = createPredicateIndexFinder(1);
	  _.findLastIndex = createPredicateIndexFinder(-1);
	
	  // Use a comparator function to figure out the smallest index at which
	  // an object should be inserted so as to maintain order. Uses binary search.
	  _.sortedIndex = function(array, obj, iteratee, context) {
	    iteratee = cb(iteratee, context, 1);
	    var value = iteratee(obj);
	    var low = 0, high = getLength(array);
	    while (low < high) {
	      var mid = Math.floor((low + high) / 2);
	      if (iteratee(array[mid]) < value) low = mid + 1; else high = mid;
	    }
	    return low;
	  };
	
	  // Generator function to create the indexOf and lastIndexOf functions
	  function createIndexFinder(dir, predicateFind, sortedIndex) {
	    return function(array, item, idx) {
	      var i = 0, length = getLength(array);
	      if (typeof idx == 'number') {
	        if (dir > 0) {
	            i = idx >= 0 ? idx : Math.max(idx + length, i);
	        } else {
	            length = idx >= 0 ? Math.min(idx + 1, length) : idx + length + 1;
	        }
	      } else if (sortedIndex && idx && length) {
	        idx = sortedIndex(array, item);
	        return array[idx] === item ? idx : -1;
	      }
	      if (item !== item) {
	        idx = predicateFind(slice.call(array, i, length), _.isNaN);
	        return idx >= 0 ? idx + i : -1;
	      }
	      for (idx = dir > 0 ? i : length - 1; idx >= 0 && idx < length; idx += dir) {
	        if (array[idx] === item) return idx;
	      }
	      return -1;
	    };
	  }
	
	  // Return the position of the first occurrence of an item in an array,
	  // or -1 if the item is not included in the array.
	  // If the array is large and already in sort order, pass `true`
	  // for **isSorted** to use binary search.
	  _.indexOf = createIndexFinder(1, _.findIndex, _.sortedIndex);
	  _.lastIndexOf = createIndexFinder(-1, _.findLastIndex);
	
	  // Generate an integer Array containing an arithmetic progression. A port of
	  // the native Python `range()` function. See
	  // [the Python documentation](http://docs.python.org/library/functions.html#range).
	  _.range = function(start, stop, step) {
	    if (stop == null) {
	      stop = start || 0;
	      start = 0;
	    }
	    step = step || 1;
	
	    var length = Math.max(Math.ceil((stop - start) / step), 0);
	    var range = Array(length);
	
	    for (var idx = 0; idx < length; idx++, start += step) {
	      range[idx] = start;
	    }
	
	    return range;
	  };
	
	  // Function (ahem) Functions
	  // ------------------
	
	  // Determines whether to execute a function as a constructor
	  // or a normal function with the provided arguments
	  var executeBound = function(sourceFunc, boundFunc, context, callingContext, args) {
	    if (!(callingContext instanceof boundFunc)) return sourceFunc.apply(context, args);
	    var self = baseCreate(sourceFunc.prototype);
	    var result = sourceFunc.apply(self, args);
	    if (_.isObject(result)) return result;
	    return self;
	  };
	
	  // Create a function bound to a given object (assigning `this`, and arguments,
	  // optionally). Delegates to **ECMAScript 5**'s native `Function.bind` if
	  // available.
	  _.bind = function(func, context) {
	    if (nativeBind && func.bind === nativeBind) return nativeBind.apply(func, slice.call(arguments, 1));
	    if (!_.isFunction(func)) throw new TypeError('Bind must be called on a function');
	    var args = slice.call(arguments, 2);
	    var bound = function() {
	      return executeBound(func, bound, context, this, args.concat(slice.call(arguments)));
	    };
	    return bound;
	  };
	
	  // Partially apply a function by creating a version that has had some of its
	  // arguments pre-filled, without changing its dynamic `this` context. _ acts
	  // as a placeholder, allowing any combination of arguments to be pre-filled.
	  _.partial = function(func) {
	    var boundArgs = slice.call(arguments, 1);
	    var bound = function() {
	      var position = 0, length = boundArgs.length;
	      var args = Array(length);
	      for (var i = 0; i < length; i++) {
	        args[i] = boundArgs[i] === _ ? arguments[position++] : boundArgs[i];
	      }
	      while (position < arguments.length) args.push(arguments[position++]);
	      return executeBound(func, bound, this, this, args);
	    };
	    return bound;
	  };
	
	  // Bind a number of an object's methods to that object. Remaining arguments
	  // are the method names to be bound. Useful for ensuring that all callbacks
	  // defined on an object belong to it.
	  _.bindAll = function(obj) {
	    var i, length = arguments.length, key;
	    if (length <= 1) throw new Error('bindAll must be passed function names');
	    for (i = 1; i < length; i++) {
	      key = arguments[i];
	      obj[key] = _.bind(obj[key], obj);
	    }
	    return obj;
	  };
	
	  // Memoize an expensive function by storing its results.
	  _.memoize = function(func, hasher) {
	    var memoize = function(key) {
	      var cache = memoize.cache;
	      var address = '' + (hasher ? hasher.apply(this, arguments) : key);
	      if (!_.has(cache, address)) cache[address] = func.apply(this, arguments);
	      return cache[address];
	    };
	    memoize.cache = {};
	    return memoize;
	  };
	
	  // Delays a function for the given number of milliseconds, and then calls
	  // it with the arguments supplied.
	  _.delay = function(func, wait) {
	    var args = slice.call(arguments, 2);
	    return setTimeout(function(){
	      return func.apply(null, args);
	    }, wait);
	  };
	
	  // Defers a function, scheduling it to run after the current call stack has
	  // cleared.
	  _.defer = _.partial(_.delay, _, 1);
	
	  // Returns a function, that, when invoked, will only be triggered at most once
	  // during a given window of time. Normally, the throttled function will run
	  // as much as it can, without ever going more than once per `wait` duration;
	  // but if you'd like to disable the execution on the leading edge, pass
	  // `{leading: false}`. To disable execution on the trailing edge, ditto.
	  _.throttle = function(func, wait, options) {
	    var context, args, result;
	    var timeout = null;
	    var previous = 0;
	    if (!options) options = {};
	    var later = function() {
	      previous = options.leading === false ? 0 : _.now();
	      timeout = null;
	      result = func.apply(context, args);
	      if (!timeout) context = args = null;
	    };
	    return function() {
	      var now = _.now();
	      if (!previous && options.leading === false) previous = now;
	      var remaining = wait - (now - previous);
	      context = this;
	      args = arguments;
	      if (remaining <= 0 || remaining > wait) {
	        if (timeout) {
	          clearTimeout(timeout);
	          timeout = null;
	        }
	        previous = now;
	        result = func.apply(context, args);
	        if (!timeout) context = args = null;
	      } else if (!timeout && options.trailing !== false) {
	        timeout = setTimeout(later, remaining);
	      }
	      return result;
	    };
	  };
	
	  // Returns a function, that, as long as it continues to be invoked, will not
	  // be triggered. The function will be called after it stops being called for
	  // N milliseconds. If `immediate` is passed, trigger the function on the
	  // leading edge, instead of the trailing.
	  _.debounce = function(func, wait, immediate) {
	    var timeout, args, context, timestamp, result;
	
	    var later = function() {
	      var last = _.now() - timestamp;
	
	      if (last < wait && last >= 0) {
	        timeout = setTimeout(later, wait - last);
	      } else {
	        timeout = null;
	        if (!immediate) {
	          result = func.apply(context, args);
	          if (!timeout) context = args = null;
	        }
	      }
	    };
	
	    return function() {
	      context = this;
	      args = arguments;
	      timestamp = _.now();
	      var callNow = immediate && !timeout;
	      if (!timeout) timeout = setTimeout(later, wait);
	      if (callNow) {
	        result = func.apply(context, args);
	        context = args = null;
	      }
	
	      return result;
	    };
	  };
	
	  // Returns the first function passed as an argument to the second,
	  // allowing you to adjust arguments, run code before and after, and
	  // conditionally execute the original function.
	  _.wrap = function(func, wrapper) {
	    return _.partial(wrapper, func);
	  };
	
	  // Returns a negated version of the passed-in predicate.
	  _.negate = function(predicate) {
	    return function() {
	      return !predicate.apply(this, arguments);
	    };
	  };
	
	  // Returns a function that is the composition of a list of functions, each
	  // consuming the return value of the function that follows.
	  _.compose = function() {
	    var args = arguments;
	    var start = args.length - 1;
	    return function() {
	      var i = start;
	      var result = args[start].apply(this, arguments);
	      while (i--) result = args[i].call(this, result);
	      return result;
	    };
	  };
	
	  // Returns a function that will only be executed on and after the Nth call.
	  _.after = function(times, func) {
	    return function() {
	      if (--times < 1) {
	        return func.apply(this, arguments);
	      }
	    };
	  };
	
	  // Returns a function that will only be executed up to (but not including) the Nth call.
	  _.before = function(times, func) {
	    var memo;
	    return function() {
	      if (--times > 0) {
	        memo = func.apply(this, arguments);
	      }
	      if (times <= 1) func = null;
	      return memo;
	    };
	  };
	
	  // Returns a function that will be executed at most one time, no matter how
	  // often you call it. Useful for lazy initialization.
	  _.once = _.partial(_.before, 2);
	
	  // Object Functions
	  // ----------------
	
	  // Keys in IE < 9 that won't be iterated by `for key in ...` and thus missed.
	  var hasEnumBug = !{toString: null}.propertyIsEnumerable('toString');
	  var nonEnumerableProps = ['valueOf', 'isPrototypeOf', 'toString',
	                      'propertyIsEnumerable', 'hasOwnProperty', 'toLocaleString'];
	
	  function collectNonEnumProps(obj, keys) {
	    var nonEnumIdx = nonEnumerableProps.length;
	    var constructor = obj.constructor;
	    var proto = (_.isFunction(constructor) && constructor.prototype) || ObjProto;
	
	    // Constructor is a special case.
	    var prop = 'constructor';
	    if (_.has(obj, prop) && !_.contains(keys, prop)) keys.push(prop);
	
	    while (nonEnumIdx--) {
	      prop = nonEnumerableProps[nonEnumIdx];
	      if (prop in obj && obj[prop] !== proto[prop] && !_.contains(keys, prop)) {
	        keys.push(prop);
	      }
	    }
	  }
	
	  // Retrieve the names of an object's own properties.
	  // Delegates to **ECMAScript 5**'s native `Object.keys`
	  _.keys = function(obj) {
	    if (!_.isObject(obj)) return [];
	    if (nativeKeys) return nativeKeys(obj);
	    var keys = [];
	    for (var key in obj) if (_.has(obj, key)) keys.push(key);
	    // Ahem, IE < 9.
	    if (hasEnumBug) collectNonEnumProps(obj, keys);
	    return keys;
	  };
	
	  // Retrieve all the property names of an object.
	  _.allKeys = function(obj) {
	    if (!_.isObject(obj)) return [];
	    var keys = [];
	    for (var key in obj) keys.push(key);
	    // Ahem, IE < 9.
	    if (hasEnumBug) collectNonEnumProps(obj, keys);
	    return keys;
	  };
	
	  // Retrieve the values of an object's properties.
	  _.values = function(obj) {
	    var keys = _.keys(obj);
	    var length = keys.length;
	    var values = Array(length);
	    for (var i = 0; i < length; i++) {
	      values[i] = obj[keys[i]];
	    }
	    return values;
	  };
	
	  // Returns the results of applying the iteratee to each element of the object
	  // In contrast to _.map it returns an object
	  _.mapObject = function(obj, iteratee, context) {
	    iteratee = cb(iteratee, context);
	    var keys =  _.keys(obj),
	          length = keys.length,
	          results = {},
	          currentKey;
	      for (var index = 0; index < length; index++) {
	        currentKey = keys[index];
	        results[currentKey] = iteratee(obj[currentKey], currentKey, obj);
	      }
	      return results;
	  };
	
	  // Convert an object into a list of `[key, value]` pairs.
	  _.pairs = function(obj) {
	    var keys = _.keys(obj);
	    var length = keys.length;
	    var pairs = Array(length);
	    for (var i = 0; i < length; i++) {
	      pairs[i] = [keys[i], obj[keys[i]]];
	    }
	    return pairs;
	  };
	
	  // Invert the keys and values of an object. The values must be serializable.
	  _.invert = function(obj) {
	    var result = {};
	    var keys = _.keys(obj);
	    for (var i = 0, length = keys.length; i < length; i++) {
	      result[obj[keys[i]]] = keys[i];
	    }
	    return result;
	  };
	
	  // Return a sorted list of the function names available on the object.
	  // Aliased as `methods`
	  _.functions = _.methods = function(obj) {
	    var names = [];
	    for (var key in obj) {
	      if (_.isFunction(obj[key])) names.push(key);
	    }
	    return names.sort();
	  };
	
	  // Extend a given object with all the properties in passed-in object(s).
	  _.extend = createAssigner(_.allKeys);
	
	  // Assigns a given object with all the own properties in the passed-in object(s)
	  // (https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/Object/assign)
	  _.extendOwn = _.assign = createAssigner(_.keys);
	
	  // Returns the first key on an object that passes a predicate test
	  _.findKey = function(obj, predicate, context) {
	    predicate = cb(predicate, context);
	    var keys = _.keys(obj), key;
	    for (var i = 0, length = keys.length; i < length; i++) {
	      key = keys[i];
	      if (predicate(obj[key], key, obj)) return key;
	    }
	  };
	
	  // Return a copy of the object only containing the whitelisted properties.
	  _.pick = function(object, oiteratee, context) {
	    var result = {}, obj = object, iteratee, keys;
	    if (obj == null) return result;
	    if (_.isFunction(oiteratee)) {
	      keys = _.allKeys(obj);
	      iteratee = optimizeCb(oiteratee, context);
	    } else {
	      keys = flatten(arguments, false, false, 1);
	      iteratee = function(value, key, obj) { return key in obj; };
	      obj = Object(obj);
	    }
	    for (var i = 0, length = keys.length; i < length; i++) {
	      var key = keys[i];
	      var value = obj[key];
	      if (iteratee(value, key, obj)) result[key] = value;
	    }
	    return result;
	  };
	
	   // Return a copy of the object without the blacklisted properties.
	  _.omit = function(obj, iteratee, context) {
	    if (_.isFunction(iteratee)) {
	      iteratee = _.negate(iteratee);
	    } else {
	      var keys = _.map(flatten(arguments, false, false, 1), String);
	      iteratee = function(value, key) {
	        return !_.contains(keys, key);
	      };
	    }
	    return _.pick(obj, iteratee, context);
	  };
	
	  // Fill in a given object with default properties.
	  _.defaults = createAssigner(_.allKeys, true);
	
	  // Creates an object that inherits from the given prototype object.
	  // If additional properties are provided then they will be added to the
	  // created object.
	  _.create = function(prototype, props) {
	    var result = baseCreate(prototype);
	    if (props) _.extendOwn(result, props);
	    return result;
	  };
	
	  // Create a (shallow-cloned) duplicate of an object.
	  _.clone = function(obj) {
	    if (!_.isObject(obj)) return obj;
	    return _.isArray(obj) ? obj.slice() : _.extend({}, obj);
	  };
	
	  // Invokes interceptor with the obj, and then returns obj.
	  // The primary purpose of this method is to "tap into" a method chain, in
	  // order to perform operations on intermediate results within the chain.
	  _.tap = function(obj, interceptor) {
	    interceptor(obj);
	    return obj;
	  };
	
	  // Returns whether an object has a given set of `key:value` pairs.
	  _.isMatch = function(object, attrs) {
	    var keys = _.keys(attrs), length = keys.length;
	    if (object == null) return !length;
	    var obj = Object(object);
	    for (var i = 0; i < length; i++) {
	      var key = keys[i];
	      if (attrs[key] !== obj[key] || !(key in obj)) return false;
	    }
	    return true;
	  };
	
	
	  // Internal recursive comparison function for `isEqual`.
	  var eq = function(a, b, aStack, bStack) {
	    // Identical objects are equal. `0 === -0`, but they aren't identical.
	    // See the [Harmony `egal` proposal](http://wiki.ecmascript.org/doku.php?id=harmony:egal).
	    if (a === b) return a !== 0 || 1 / a === 1 / b;
	    // A strict comparison is necessary because `null == undefined`.
	    if (a == null || b == null) return a === b;
	    // Unwrap any wrapped objects.
	    if (a instanceof _) a = a._wrapped;
	    if (b instanceof _) b = b._wrapped;
	    // Compare `[[Class]]` names.
	    var className = toString.call(a);
	    if (className !== toString.call(b)) return false;
	    switch (className) {
	      // Strings, numbers, regular expressions, dates, and booleans are compared by value.
	      case '[object RegExp]':
	      // RegExps are coerced to strings for comparison (Note: '' + /a/i === '/a/i')
	      case '[object String]':
	        // Primitives and their corresponding object wrappers are equivalent; thus, `"5"` is
	        // equivalent to `new String("5")`.
	        return '' + a === '' + b;
	      case '[object Number]':
	        // `NaN`s are equivalent, but non-reflexive.
	        // Object(NaN) is equivalent to NaN
	        if (+a !== +a) return +b !== +b;
	        // An `egal` comparison is performed for other numeric values.
	        return +a === 0 ? 1 / +a === 1 / b : +a === +b;
	      case '[object Date]':
	      case '[object Boolean]':
	        // Coerce dates and booleans to numeric primitive values. Dates are compared by their
	        // millisecond representations. Note that invalid dates with millisecond representations
	        // of `NaN` are not equivalent.
	        return +a === +b;
	    }
	
	    var areArrays = className === '[object Array]';
	    if (!areArrays) {
	      if (typeof a != 'object' || typeof b != 'object') return false;
	
	      // Objects with different constructors are not equivalent, but `Object`s or `Array`s
	      // from different frames are.
	      var aCtor = a.constructor, bCtor = b.constructor;
	      if (aCtor !== bCtor && !(_.isFunction(aCtor) && aCtor instanceof aCtor &&
	                               _.isFunction(bCtor) && bCtor instanceof bCtor)
	                          && ('constructor' in a && 'constructor' in b)) {
	        return false;
	      }
	    }
	    // Assume equality for cyclic structures. The algorithm for detecting cyclic
	    // structures is adapted from ES 5.1 section 15.12.3, abstract operation `JO`.
	
	    // Initializing stack of traversed objects.
	    // It's done here since we only need them for objects and arrays comparison.
	    aStack = aStack || [];
	    bStack = bStack || [];
	    var length = aStack.length;
	    while (length--) {
	      // Linear search. Performance is inversely proportional to the number of
	      // unique nested structures.
	      if (aStack[length] === a) return bStack[length] === b;
	    }
	
	    // Add the first object to the stack of traversed objects.
	    aStack.push(a);
	    bStack.push(b);
	
	    // Recursively compare objects and arrays.
	    if (areArrays) {
	      // Compare array lengths to determine if a deep comparison is necessary.
	      length = a.length;
	      if (length !== b.length) return false;
	      // Deep compare the contents, ignoring non-numeric properties.
	      while (length--) {
	        if (!eq(a[length], b[length], aStack, bStack)) return false;
	      }
	    } else {
	      // Deep compare objects.
	      var keys = _.keys(a), key;
	      length = keys.length;
	      // Ensure that both objects contain the same number of properties before comparing deep equality.
	      if (_.keys(b).length !== length) return false;
	      while (length--) {
	        // Deep compare each member
	        key = keys[length];
	        if (!(_.has(b, key) && eq(a[key], b[key], aStack, bStack))) return false;
	      }
	    }
	    // Remove the first object from the stack of traversed objects.
	    aStack.pop();
	    bStack.pop();
	    return true;
	  };
	
	  // Perform a deep comparison to check if two objects are equal.
	  _.isEqual = function(a, b) {
	    return eq(a, b);
	  };
	
	  // Is a given array, string, or object empty?
	  // An "empty" object has no enumerable own-properties.
	  _.isEmpty = function(obj) {
	    if (obj == null) return true;
	    if (isArrayLike(obj) && (_.isArray(obj) || _.isString(obj) || _.isArguments(obj))) return obj.length === 0;
	    return _.keys(obj).length === 0;
	  };
	
	  // Is a given value a DOM element?
	  _.isElement = function(obj) {
	    return !!(obj && obj.nodeType === 1);
	  };
	
	  // Is a given value an array?
	  // Delegates to ECMA5's native Array.isArray
	  _.isArray = nativeIsArray || function(obj) {
	    return toString.call(obj) === '[object Array]';
	  };
	
	  // Is a given variable an object?
	  _.isObject = function(obj) {
	    var type = typeof obj;
	    return type === 'function' || type === 'object' && !!obj;
	  };
	
	  // Add some isType methods: isArguments, isFunction, isString, isNumber, isDate, isRegExp, isError.
	  _.each(['Arguments', 'Function', 'String', 'Number', 'Date', 'RegExp', 'Error'], function(name) {
	    _['is' + name] = function(obj) {
	      return toString.call(obj) === '[object ' + name + ']';
	    };
	  });
	
	  // Define a fallback version of the method in browsers (ahem, IE < 9), where
	  // there isn't any inspectable "Arguments" type.
	  if (!_.isArguments(arguments)) {
	    _.isArguments = function(obj) {
	      return _.has(obj, 'callee');
	    };
	  }
	
	  // Optimize `isFunction` if appropriate. Work around some typeof bugs in old v8,
	  // IE 11 (#1621), and in Safari 8 (#1929).
	  if (typeof /./ != 'function' && typeof Int8Array != 'object') {
	    _.isFunction = function(obj) {
	      return typeof obj == 'function' || false;
	    };
	  }
	
	  // Is a given object a finite number?
	  _.isFinite = function(obj) {
	    return isFinite(obj) && !isNaN(parseFloat(obj));
	  };
	
	  // Is the given value `NaN`? (NaN is the only number which does not equal itself).
	  _.isNaN = function(obj) {
	    return _.isNumber(obj) && obj !== +obj;
	  };
	
	  // Is a given value a boolean?
	  _.isBoolean = function(obj) {
	    return obj === true || obj === false || toString.call(obj) === '[object Boolean]';
	  };
	
	  // Is a given value equal to null?
	  _.isNull = function(obj) {
	    return obj === null;
	  };
	
	  // Is a given variable undefined?
	  _.isUndefined = function(obj) {
	    return obj === void 0;
	  };
	
	  // Shortcut function for checking if an object has a given property directly
	  // on itself (in other words, not on a prototype).
	  _.has = function(obj, key) {
	    return obj != null && hasOwnProperty.call(obj, key);
	  };
	
	  // Utility Functions
	  // -----------------
	
	  // Run Underscore.js in *noConflict* mode, returning the `_` variable to its
	  // previous owner. Returns a reference to the Underscore object.
	  _.noConflict = function() {
	    root._ = previousUnderscore;
	    return this;
	  };
	
	  // Keep the identity function around for default iteratees.
	  _.identity = function(value) {
	    return value;
	  };
	
	  // Predicate-generating functions. Often useful outside of Underscore.
	  _.constant = function(value) {
	    return function() {
	      return value;
	    };
	  };
	
	  _.noop = function(){};
	
	  _.property = property;
	
	  // Generates a function for a given object that returns a given property.
	  _.propertyOf = function(obj) {
	    return obj == null ? function(){} : function(key) {
	      return obj[key];
	    };
	  };
	
	  // Returns a predicate for checking whether an object has a given set of
	  // `key:value` pairs.
	  _.matcher = _.matches = function(attrs) {
	    attrs = _.extendOwn({}, attrs);
	    return function(obj) {
	      return _.isMatch(obj, attrs);
	    };
	  };
	
	  // Run a function **n** times.
	  _.times = function(n, iteratee, context) {
	    var accum = Array(Math.max(0, n));
	    iteratee = optimizeCb(iteratee, context, 1);
	    for (var i = 0; i < n; i++) accum[i] = iteratee(i);
	    return accum;
	  };
	
	  // Return a random integer between min and max (inclusive).
	  _.random = function(min, max) {
	    if (max == null) {
	      max = min;
	      min = 0;
	    }
	    return min + Math.floor(Math.random() * (max - min + 1));
	  };
	
	  // A (possibly faster) way to get the current timestamp as an integer.
	  _.now = Date.now || function() {
	    return new Date().getTime();
	  };
	
	   // List of HTML entities for escaping.
	  var escapeMap = {
	    '&': '&amp;',
	    '<': '&lt;',
	    '>': '&gt;',
	    '"': '&quot;',
	    "'": '&#x27;',
	    '`': '&#x60;'
	  };
	  var unescapeMap = _.invert(escapeMap);
	
	  // Functions for escaping and unescaping strings to/from HTML interpolation.
	  var createEscaper = function(map) {
	    var escaper = function(match) {
	      return map[match];
	    };
	    // Regexes for identifying a key that needs to be escaped
	    var source = '(?:' + _.keys(map).join('|') + ')';
	    var testRegexp = RegExp(source);
	    var replaceRegexp = RegExp(source, 'g');
	    return function(string) {
	      string = string == null ? '' : '' + string;
	      return testRegexp.test(string) ? string.replace(replaceRegexp, escaper) : string;
	    };
	  };
	  _.escape = createEscaper(escapeMap);
	  _.unescape = createEscaper(unescapeMap);
	
	  // If the value of the named `property` is a function then invoke it with the
	  // `object` as context; otherwise, return it.
	  _.result = function(object, property, fallback) {
	    var value = object == null ? void 0 : object[property];
	    if (value === void 0) {
	      value = fallback;
	    }
	    return _.isFunction(value) ? value.call(object) : value;
	  };
	
	  // Generate a unique integer id (unique within the entire client session).
	  // Useful for temporary DOM ids.
	  var idCounter = 0;
	  _.uniqueId = function(prefix) {
	    var id = ++idCounter + '';
	    return prefix ? prefix + id : id;
	  };
	
	  // By default, Underscore uses ERB-style template delimiters, change the
	  // following template settings to use alternative delimiters.
	  _.templateSettings = {
	    evaluate    : /<%([\s\S]+?)%>/g,
	    interpolate : /<%=([\s\S]+?)%>/g,
	    escape      : /<%-([\s\S]+?)%>/g
	  };
	
	  // When customizing `templateSettings`, if you don't want to define an
	  // interpolation, evaluation or escaping regex, we need one that is
	  // guaranteed not to match.
	  var noMatch = /(.)^/;
	
	  // Certain characters need to be escaped so that they can be put into a
	  // string literal.
	  var escapes = {
	    "'":      "'",
	    '\\':     '\\',
	    '\r':     'r',
	    '\n':     'n',
	    '\u2028': 'u2028',
	    '\u2029': 'u2029'
	  };
	
	  var escaper = /\\|'|\r|\n|\u2028|\u2029/g;
	
	  var escapeChar = function(match) {
	    return '\\' + escapes[match];
	  };
	
	  // JavaScript micro-templating, similar to John Resig's implementation.
	  // Underscore templating handles arbitrary delimiters, preserves whitespace,
	  // and correctly escapes quotes within interpolated code.
	  // NB: `oldSettings` only exists for backwards compatibility.
	  _.template = function(text, settings, oldSettings) {
	    if (!settings && oldSettings) settings = oldSettings;
	    settings = _.defaults({}, settings, _.templateSettings);
	
	    // Combine delimiters into one regular expression via alternation.
	    var matcher = RegExp([
	      (settings.escape || noMatch).source,
	      (settings.interpolate || noMatch).source,
	      (settings.evaluate || noMatch).source
	    ].join('|') + '|$', 'g');
	
	    // Compile the template source, escaping string literals appropriately.
	    var index = 0;
	    var source = "__p+='";
	    text.replace(matcher, function(match, escape, interpolate, evaluate, offset) {
	      source += text.slice(index, offset).replace(escaper, escapeChar);
	      index = offset + match.length;
	
	      if (escape) {
	        source += "'+\n((__t=(" + escape + "))==null?'':_.escape(__t))+\n'";
	      } else if (interpolate) {
	        source += "'+\n((__t=(" + interpolate + "))==null?'':__t)+\n'";
	      } else if (evaluate) {
	        source += "';\n" + evaluate + "\n__p+='";
	      }
	
	      // Adobe VMs need the match returned to produce the correct offest.
	      return match;
	    });
	    source += "';\n";
	
	    // If a variable is not specified, place data values in local scope.
	    if (!settings.variable) source = 'with(obj||{}){\n' + source + '}\n';
	
	    source = "var __t,__p='',__j=Array.prototype.join," +
	      "print=function(){__p+=__j.call(arguments,'');};\n" +
	      source + 'return __p;\n';
	
	    try {
	      var render = new Function(settings.variable || 'obj', '_', source);
	    } catch (e) {
	      e.source = source;
	      throw e;
	    }
	
	    var template = function(data) {
	      return render.call(this, data, _);
	    };
	
	    // Provide the compiled source as a convenience for precompilation.
	    var argument = settings.variable || 'obj';
	    template.source = 'function(' + argument + '){\n' + source + '}';
	
	    return template;
	  };
	
	  // Add a "chain" function. Start chaining a wrapped Underscore object.
	  _.chain = function(obj) {
	    var instance = _(obj);
	    instance._chain = true;
	    return instance;
	  };
	
	  // OOP
	  // ---------------
	  // If Underscore is called as a function, it returns a wrapped object that
	  // can be used OO-style. This wrapper holds altered versions of all the
	  // underscore functions. Wrapped objects may be chained.
	
	  // Helper function to continue chaining intermediate results.
	  var result = function(instance, obj) {
	    return instance._chain ? _(obj).chain() : obj;
	  };
	
	  // Add your own custom functions to the Underscore object.
	  _.mixin = function(obj) {
	    _.each(_.functions(obj), function(name) {
	      var func = _[name] = obj[name];
	      _.prototype[name] = function() {
	        var args = [this._wrapped];
	        push.apply(args, arguments);
	        return result(this, func.apply(_, args));
	      };
	    });
	  };
	
	  // Add all of the Underscore functions to the wrapper object.
	  _.mixin(_);
	
	  // Add all mutator Array functions to the wrapper.
	  _.each(['pop', 'push', 'reverse', 'shift', 'sort', 'splice', 'unshift'], function(name) {
	    var method = ArrayProto[name];
	    _.prototype[name] = function() {
	      var obj = this._wrapped;
	      method.apply(obj, arguments);
	      if ((name === 'shift' || name === 'splice') && obj.length === 0) delete obj[0];
	      return result(this, obj);
	    };
	  });
	
	  // Add all accessor Array functions to the wrapper.
	  _.each(['concat', 'join', 'slice'], function(name) {
	    var method = ArrayProto[name];
	    _.prototype[name] = function() {
	      return result(this, method.apply(this._wrapped, arguments));
	    };
	  });
	
	  // Extracts the result from a wrapped and chained object.
	  _.prototype.value = function() {
	    return this._wrapped;
	  };
	
	  // Provide unwrapping proxy for some methods used in engine operations
	  // such as arithmetic and JSON stringification.
	  _.prototype.valueOf = _.prototype.toJSON = _.prototype.value;
	
	  _.prototype.toString = function() {
	    return '' + this._wrapped;
	  };
	
	  // AMD registration happens at the end for compatibility with AMD loaders
	  // that may not enforce next-turn semantics on modules. Even though general
	  // practice for AMD registration is to be anonymous, underscore registers
	  // as a named module because, like jQuery, it is a base library that is
	  // popular enough to be bundled in a third party lib, but not be part of
	  // an AMD load request. Those cases could generate an error when an
	  // anonymous define() is called outside of a loader request.
	  if (true) {
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function() {
	      return _;
	    }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  }
	}.call(this));


/***/ },
/* 8 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDOMComponentTree
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(3);
	
	var DOMProperty = __webpack_require__(27);
	var ReactDOMComponentFlags = __webpack_require__(107);
	
	var invariant = __webpack_require__(2);
	
	var ATTR_NAME = DOMProperty.ID_ATTRIBUTE_NAME;
	var Flags = ReactDOMComponentFlags;
	
	var internalInstanceKey = '__reactInternalInstance$' + Math.random().toString(36).slice(2);
	
	/**
	 * Drill down (through composites and empty components) until we get a host or
	 * host text component.
	 *
	 * This is pretty polymorphic but unavoidable with the current structure we have
	 * for `_renderedChildren`.
	 */
	function getRenderedHostOrTextFromComponent(component) {
	  var rendered;
	  while (rendered = component._renderedComponent) {
	    component = rendered;
	  }
	  return component;
	}
	
	/**
	 * Populate `_hostNode` on the rendered host/text component with the given
	 * DOM node. The passed `inst` can be a composite.
	 */
	function precacheNode(inst, node) {
	  var hostInst = getRenderedHostOrTextFromComponent(inst);
	  hostInst._hostNode = node;
	  node[internalInstanceKey] = hostInst;
	}
	
	function uncacheNode(inst) {
	  var node = inst._hostNode;
	  if (node) {
	    delete node[internalInstanceKey];
	    inst._hostNode = null;
	  }
	}
	
	/**
	 * Populate `_hostNode` on each child of `inst`, assuming that the children
	 * match up with the DOM (element) children of `node`.
	 *
	 * We cache entire levels at once to avoid an n^2 problem where we access the
	 * children of a node sequentially and have to walk from the start to our target
	 * node every time.
	 *
	 * Since we update `_renderedChildren` and the actual DOM at (slightly)
	 * different times, we could race here and see a newer `_renderedChildren` than
	 * the DOM nodes we see. To avoid this, ReactMultiChild calls
	 * `prepareToManageChildren` before we change `_renderedChildren`, at which
	 * time the container's child nodes are always cached (until it unmounts).
	 */
	function precacheChildNodes(inst, node) {
	  if (inst._flags & Flags.hasCachedChildNodes) {
	    return;
	  }
	  var children = inst._renderedChildren;
	  var childNode = node.firstChild;
	  outer: for (var name in children) {
	    if (!children.hasOwnProperty(name)) {
	      continue;
	    }
	    var childInst = children[name];
	    var childID = getRenderedHostOrTextFromComponent(childInst)._domID;
	    if (childID === 0) {
	      // We're currently unmounting this child in ReactMultiChild; skip it.
	      continue;
	    }
	    // We assume the child nodes are in the same order as the child instances.
	    for (; childNode !== null; childNode = childNode.nextSibling) {
	      if (childNode.nodeType === 1 && childNode.getAttribute(ATTR_NAME) === String(childID) || childNode.nodeType === 8 && childNode.nodeValue === ' react-text: ' + childID + ' ' || childNode.nodeType === 8 && childNode.nodeValue === ' react-empty: ' + childID + ' ') {
	        precacheNode(childInst, childNode);
	        continue outer;
	      }
	    }
	    // We reached the end of the DOM children without finding an ID match.
	     true ?  false ? invariant(false, 'Unable to find element with ID %s.', childID) : _prodInvariant('32', childID) : void 0;
	  }
	  inst._flags |= Flags.hasCachedChildNodes;
	}
	
	/**
	 * Given a DOM node, return the closest ReactDOMComponent or
	 * ReactDOMTextComponent instance ancestor.
	 */
	function getClosestInstanceFromNode(node) {
	  if (node[internalInstanceKey]) {
	    return node[internalInstanceKey];
	  }
	
	  // Walk up the tree until we find an ancestor whose instance we have cached.
	  var parents = [];
	  while (!node[internalInstanceKey]) {
	    parents.push(node);
	    if (node.parentNode) {
	      node = node.parentNode;
	    } else {
	      // Top of the tree. This node must not be part of a React tree (or is
	      // unmounted, potentially).
	      return null;
	    }
	  }
	
	  var closest;
	  var inst;
	  for (; node && (inst = node[internalInstanceKey]); node = parents.pop()) {
	    closest = inst;
	    if (parents.length) {
	      precacheChildNodes(inst, node);
	    }
	  }
	
	  return closest;
	}
	
	/**
	 * Given a DOM node, return the ReactDOMComponent or ReactDOMTextComponent
	 * instance, or null if the node was not rendered by this React.
	 */
	function getInstanceFromNode(node) {
	  var inst = getClosestInstanceFromNode(node);
	  if (inst != null && inst._hostNode === node) {
	    return inst;
	  } else {
	    return null;
	  }
	}
	
	/**
	 * Given a ReactDOMComponent or ReactDOMTextComponent, return the corresponding
	 * DOM node.
	 */
	function getNodeFromInstance(inst) {
	  // Without this first invariant, passing a non-DOM-component triggers the next
	  // invariant for a missing parent, which is super confusing.
	  !(inst._hostNode !== undefined) ?  false ? invariant(false, 'getNodeFromInstance: Invalid argument.') : _prodInvariant('33') : void 0;
	
	  if (inst._hostNode) {
	    return inst._hostNode;
	  }
	
	  // Walk up the tree until we find an ancestor whose DOM node we have cached.
	  var parents = [];
	  while (!inst._hostNode) {
	    parents.push(inst);
	    !inst._hostParent ?  false ? invariant(false, 'React DOM tree root should always have a node reference.') : _prodInvariant('34') : void 0;
	    inst = inst._hostParent;
	  }
	
	  // Now parents contains each ancestor that does *not* have a cached native
	  // node, and `inst` is the deepest ancestor that does.
	  for (; parents.length; inst = parents.pop()) {
	    precacheChildNodes(inst, inst._hostNode);
	  }
	
	  return inst._hostNode;
	}
	
	var ReactDOMComponentTree = {
	  getClosestInstanceFromNode: getClosestInstanceFromNode,
	  getInstanceFromNode: getInstanceFromNode,
	  getNodeFromInstance: getNodeFromInstance,
	  precacheChildNodes: precacheChildNodes,
	  precacheNode: precacheNode,
	  uncacheNode: uncacheNode
	};
	
	module.exports = ReactDOMComponentTree;

/***/ },
/* 9 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
	
	/**
	 * Simple, lightweight module assisting with the detection and context of
	 * Worker. Helps avoid circular dependencies and allows code to reason about
	 * whether or not they are in a Worker, even if they never include the main
	 * `ReactWorker` dependency.
	 */
	var ExecutionEnvironment = {
	
	  canUseDOM: canUseDOM,
	
	  canUseWorkers: typeof Worker !== 'undefined',
	
	  canUseEventListeners: canUseDOM && !!(window.addEventListener || window.attachEvent),
	
	  canUseViewport: canUseDOM && !!window.screen,
	
	  isInWorker: !canUseDOM // For now, this is true - might change in the future.
	
	};
	
	module.exports = ExecutionEnvironment;

/***/ },
/* 10 */
/***/ function(module, exports) {

	"use strict";
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	function makeEmptyFunction(arg) {
	  return function () {
	    return arg;
	  };
	}
	
	/**
	 * This function accepts and discards inputs; it has no side effects. This is
	 * primarily useful idiomatically for overridable function endpoints which
	 * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
	 */
	var emptyFunction = function emptyFunction() {};
	
	emptyFunction.thatReturns = makeEmptyFunction;
	emptyFunction.thatReturnsFalse = makeEmptyFunction(false);
	emptyFunction.thatReturnsTrue = makeEmptyFunction(true);
	emptyFunction.thatReturnsNull = makeEmptyFunction(null);
	emptyFunction.thatReturnsThis = function () {
	  return this;
	};
	emptyFunction.thatReturnsArgument = function (arg) {
	  return arg;
	};
	
	module.exports = emptyFunction;

/***/ },
/* 11 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2016-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactInstrumentation
	 */
	
	'use strict';
	
	var debugTool = null;
	
	if (false) {
	  var ReactDebugTool = require('./ReactDebugTool');
	  debugTool = ReactDebugTool;
	}
	
	module.exports = { debugTool: debugTool };

/***/ },
/* 12 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _backbone = __webpack_require__(76);
	
	var _backbone2 = _interopRequireDefault(_backbone);
	
	var _config = __webpack_require__(203);
	
	var _config2 = _interopRequireDefault(_config);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var abl = {
		config: _config2.default,
	
		convertString: function convertString(str) {
			if (str) {
				if (str.toLowerCase() === 'true') {
					str = true;
				} else if (str.toLowerCase() === 'false') {
					str = false;
				} else if (!isNaN(str)) {
					str = JSON.parse(str);
				}
			}
	
			return str;
		},
	
		createClass: function createClass(members) {
			var initialize = members.initialize || function () {};
			delete members.initialize;
	
			Object.keys(members).forEach(function (member) {
				initialize.prototype[member] = members[member];
			});
	
			return initialize;
		},
	
		setRouter: function setRouter(router) {
			_backbone2.default.history.start();
			this.currentRouter = router;
		},
	
		navigate: function navigate(url, updateHref, trigger) {
			this.currentRouter.navigate(url, { trigger: trigger, replace: updateHref });
		}
	};
	
	exports.default = abl;

/***/ },
/* 13 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactElement
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(6);
	
	var ReactCurrentOwner = __webpack_require__(23);
	
	var warning = __webpack_require__(4);
	var canDefineProperty = __webpack_require__(120);
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	
	// The Symbol used to tag the ReactElement type. If there is no native Symbol
	// nor polyfill, then a plain number is used for performance.
	var REACT_ELEMENT_TYPE = typeof Symbol === 'function' && Symbol['for'] && Symbol['for']('react.element') || 0xeac7;
	
	var RESERVED_PROPS = {
	  key: true,
	  ref: true,
	  __self: true,
	  __source: true
	};
	
	var specialPropKeyWarningShown, specialPropRefWarningShown;
	
	function hasValidRef(config) {
	  if (false) {
	    if (hasOwnProperty.call(config, 'ref')) {
	      var getter = Object.getOwnPropertyDescriptor(config, 'ref').get;
	      if (getter && getter.isReactWarning) {
	        return false;
	      }
	    }
	  }
	  return config.ref !== undefined;
	}
	
	function hasValidKey(config) {
	  if (false) {
	    if (hasOwnProperty.call(config, 'key')) {
	      var getter = Object.getOwnPropertyDescriptor(config, 'key').get;
	      if (getter && getter.isReactWarning) {
	        return false;
	      }
	    }
	  }
	  return config.key !== undefined;
	}
	
	function defineKeyPropWarningGetter(props, displayName) {
	  var warnAboutAccessingKey = function () {
	    if (!specialPropKeyWarningShown) {
	      specialPropKeyWarningShown = true;
	       false ? warning(false, '%s: `key` is not a prop. Trying to access it will result ' + 'in `undefined` being returned. If you need to access the same ' + 'value within the child component, you should pass it as a different ' + 'prop. (https://fb.me/react-special-props)', displayName) : void 0;
	    }
	  };
	  warnAboutAccessingKey.isReactWarning = true;
	  Object.defineProperty(props, 'key', {
	    get: warnAboutAccessingKey,
	    configurable: true
	  });
	}
	
	function defineRefPropWarningGetter(props, displayName) {
	  var warnAboutAccessingRef = function () {
	    if (!specialPropRefWarningShown) {
	      specialPropRefWarningShown = true;
	       false ? warning(false, '%s: `ref` is not a prop. Trying to access it will result ' + 'in `undefined` being returned. If you need to access the same ' + 'value within the child component, you should pass it as a different ' + 'prop. (https://fb.me/react-special-props)', displayName) : void 0;
	    }
	  };
	  warnAboutAccessingRef.isReactWarning = true;
	  Object.defineProperty(props, 'ref', {
	    get: warnAboutAccessingRef,
	    configurable: true
	  });
	}
	
	/**
	 * Factory method to create a new React element. This no longer adheres to
	 * the class pattern, so do not use new to call it. Also, no instanceof check
	 * will work. Instead test $$typeof field against Symbol.for('react.element') to check
	 * if something is a React Element.
	 *
	 * @param {*} type
	 * @param {*} key
	 * @param {string|object} ref
	 * @param {*} self A *temporary* helper to detect places where `this` is
	 * different from the `owner` when React.createElement is called, so that we
	 * can warn. We want to get rid of owner and replace string `ref`s with arrow
	 * functions, and as long as `this` and owner are the same, there will be no
	 * change in behavior.
	 * @param {*} source An annotation object (added by a transpiler or otherwise)
	 * indicating filename, line number, and/or other information.
	 * @param {*} owner
	 * @param {*} props
	 * @internal
	 */
	var ReactElement = function (type, key, ref, self, source, owner, props) {
	  var element = {
	    // This tag allow us to uniquely identify this as a React Element
	    $$typeof: REACT_ELEMENT_TYPE,
	
	    // Built-in properties that belong on the element
	    type: type,
	    key: key,
	    ref: ref,
	    props: props,
	
	    // Record the component responsible for creating this element.
	    _owner: owner
	  };
	
	  if (false) {
	    // The validation flag is currently mutative. We put it on
	    // an external backing store so that we can freeze the whole object.
	    // This can be replaced with a WeakMap once they are implemented in
	    // commonly used development environments.
	    element._store = {};
	    var shadowChildren = Array.isArray(props.children) ? props.children.slice(0) : props.children;
	
	    // To make comparing ReactElements easier for testing purposes, we make
	    // the validation flag non-enumerable (where possible, which should
	    // include every environment we run tests in), so the test framework
	    // ignores it.
	    if (canDefineProperty) {
	      Object.defineProperty(element._store, 'validated', {
	        configurable: false,
	        enumerable: false,
	        writable: true,
	        value: false
	      });
	      // self and source are DEV only properties.
	      Object.defineProperty(element, '_self', {
	        configurable: false,
	        enumerable: false,
	        writable: false,
	        value: self
	      });
	      Object.defineProperty(element, '_shadowChildren', {
	        configurable: false,
	        enumerable: false,
	        writable: false,
	        value: shadowChildren
	      });
	      // Two elements created in two different places should be considered
	      // equal for testing purposes and therefore we hide it from enumeration.
	      Object.defineProperty(element, '_source', {
	        configurable: false,
	        enumerable: false,
	        writable: false,
	        value: source
	      });
	    } else {
	      element._store.validated = false;
	      element._self = self;
	      element._shadowChildren = shadowChildren;
	      element._source = source;
	    }
	    if (Object.freeze) {
	      Object.freeze(element.props);
	      Object.freeze(element);
	    }
	  }
	
	  return element;
	};
	
	/**
	 * Create and return a new ReactElement of the given type.
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.createelement
	 */
	ReactElement.createElement = function (type, config, children) {
	  var propName;
	
	  // Reserved names are extracted
	  var props = {};
	
	  var key = null;
	  var ref = null;
	  var self = null;
	  var source = null;
	
	  if (config != null) {
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(
	      /* eslint-disable no-proto */
	      config.__proto__ == null || config.__proto__ === Object.prototype,
	      /* eslint-enable no-proto */
	      'React.createElement(...): Expected props argument to be a plain object. ' + 'Properties defined in its prototype chain will be ignored.') : void 0;
	    }
	
	    if (hasValidRef(config)) {
	      ref = config.ref;
	    }
	    if (hasValidKey(config)) {
	      key = '' + config.key;
	    }
	
	    self = config.__self === undefined ? null : config.__self;
	    source = config.__source === undefined ? null : config.__source;
	    // Remaining properties are added to a new props object
	    for (propName in config) {
	      if (hasOwnProperty.call(config, propName) && !RESERVED_PROPS.hasOwnProperty(propName)) {
	        props[propName] = config[propName];
	      }
	    }
	  }
	
	  // Children can be more than one argument, and those are transferred onto
	  // the newly allocated props object.
	  var childrenLength = arguments.length - 2;
	  if (childrenLength === 1) {
	    props.children = children;
	  } else if (childrenLength > 1) {
	    var childArray = Array(childrenLength);
	    for (var i = 0; i < childrenLength; i++) {
	      childArray[i] = arguments[i + 2];
	    }
	    props.children = childArray;
	  }
	
	  // Resolve default props
	  if (type && type.defaultProps) {
	    var defaultProps = type.defaultProps;
	    for (propName in defaultProps) {
	      if (props[propName] === undefined) {
	        props[propName] = defaultProps[propName];
	      }
	    }
	  }
	  if (false) {
	    if (key || ref) {
	      if (typeof props.$$typeof === 'undefined' || props.$$typeof !== REACT_ELEMENT_TYPE) {
	        var displayName = typeof type === 'function' ? type.displayName || type.name || 'Unknown' : type;
	        if (key) {
	          defineKeyPropWarningGetter(props, displayName);
	        }
	        if (ref) {
	          defineRefPropWarningGetter(props, displayName);
	        }
	      }
	    }
	  }
	  return ReactElement(type, key, ref, self, source, ReactCurrentOwner.current, props);
	};
	
	/**
	 * Return a function that produces ReactElements of a given type.
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.createfactory
	 */
	ReactElement.createFactory = function (type) {
	  var factory = ReactElement.createElement.bind(null, type);
	  // Expose the type on the factory and the prototype so that it can be
	  // easily accessed on elements. E.g. `<Foo />.type === Foo`.
	  // This should not be named `constructor` since this may not be the function
	  // that created the element, and it may not even be a constructor.
	  // Legacy hook TODO: Warn if this is accessed
	  factory.type = type;
	  return factory;
	};
	
	ReactElement.cloneAndReplaceKey = function (oldElement, newKey) {
	  var newElement = ReactElement(oldElement.type, newKey, oldElement.ref, oldElement._self, oldElement._source, oldElement._owner, oldElement.props);
	
	  return newElement;
	};
	
	/**
	 * Clone and return a new ReactElement using element as the starting point.
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.cloneelement
	 */
	ReactElement.cloneElement = function (element, config, children) {
	  var propName;
	
	  // Original props are copied
	  var props = _assign({}, element.props);
	
	  // Reserved names are extracted
	  var key = element.key;
	  var ref = element.ref;
	  // Self is preserved since the owner is preserved.
	  var self = element._self;
	  // Source is preserved since cloneElement is unlikely to be targeted by a
	  // transpiler, and the original source is probably a better indicator of the
	  // true owner.
	  var source = element._source;
	
	  // Owner will be preserved, unless ref is overridden
	  var owner = element._owner;
	
	  if (config != null) {
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(
	      /* eslint-disable no-proto */
	      config.__proto__ == null || config.__proto__ === Object.prototype,
	      /* eslint-enable no-proto */
	      'React.cloneElement(...): Expected props argument to be a plain object. ' + 'Properties defined in its prototype chain will be ignored.') : void 0;
	    }
	
	    if (hasValidRef(config)) {
	      // Silently steal the ref from the parent.
	      ref = config.ref;
	      owner = ReactCurrentOwner.current;
	    }
	    if (hasValidKey(config)) {
	      key = '' + config.key;
	    }
	
	    // Remaining properties override existing props
	    var defaultProps;
	    if (element.type && element.type.defaultProps) {
	      defaultProps = element.type.defaultProps;
	    }
	    for (propName in config) {
	      if (hasOwnProperty.call(config, propName) && !RESERVED_PROPS.hasOwnProperty(propName)) {
	        if (config[propName] === undefined && defaultProps !== undefined) {
	          // Resolve default props
	          props[propName] = defaultProps[propName];
	        } else {
	          props[propName] = config[propName];
	        }
	      }
	    }
	  }
	
	  // Children can be more than one argument, and those are transferred onto
	  // the newly allocated props object.
	  var childrenLength = arguments.length - 2;
	  if (childrenLength === 1) {
	    props.children = children;
	  } else if (childrenLength > 1) {
	    var childArray = Array(childrenLength);
	    for (var i = 0; i < childrenLength; i++) {
	      childArray[i] = arguments[i + 2];
	    }
	    props.children = childArray;
	  }
	
	  return ReactElement(element.type, key, ref, self, source, owner, props);
	};
	
	/**
	 * Verifies the object is a ReactElement.
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.isvalidelement
	 * @param {?object} object
	 * @return {boolean} True if `object` is a valid component.
	 * @final
	 */
	ReactElement.isValidElement = function (object) {
	  return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
	};
	
	ReactElement.REACT_ELEMENT_TYPE = REACT_ELEMENT_TYPE;
	
	module.exports = ReactElement;

/***/ },
/* 14 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactUpdates
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(3),
	    _assign = __webpack_require__(6);
	
	var CallbackQueue = __webpack_require__(103);
	var PooledClass = __webpack_require__(22);
	var ReactFeatureFlags = __webpack_require__(110);
	var ReactReconciler = __webpack_require__(28);
	var Transaction = __webpack_require__(38);
	
	var invariant = __webpack_require__(2);
	
	var dirtyComponents = [];
	var updateBatchNumber = 0;
	var asapCallbackQueue = CallbackQueue.getPooled();
	var asapEnqueued = false;
	
	var batchingStrategy = null;
	
	function ensureInjected() {
	  !(ReactUpdates.ReactReconcileTransaction && batchingStrategy) ?  false ? invariant(false, 'ReactUpdates: must inject a reconcile transaction class and batching strategy') : _prodInvariant('123') : void 0;
	}
	
	var NESTED_UPDATES = {
	  initialize: function () {
	    this.dirtyComponentsLength = dirtyComponents.length;
	  },
	  close: function () {
	    if (this.dirtyComponentsLength !== dirtyComponents.length) {
	      // Additional updates were enqueued by componentDidUpdate handlers or
	      // similar; before our own UPDATE_QUEUEING wrapper closes, we want to run
	      // these new updates so that if A's componentDidUpdate calls setState on
	      // B, B will update before the callback A's updater provided when calling
	      // setState.
	      dirtyComponents.splice(0, this.dirtyComponentsLength);
	      flushBatchedUpdates();
	    } else {
	      dirtyComponents.length = 0;
	    }
	  }
	};
	
	var UPDATE_QUEUEING = {
	  initialize: function () {
	    this.callbackQueue.reset();
	  },
	  close: function () {
	    this.callbackQueue.notifyAll();
	  }
	};
	
	var TRANSACTION_WRAPPERS = [NESTED_UPDATES, UPDATE_QUEUEING];
	
	function ReactUpdatesFlushTransaction() {
	  this.reinitializeTransaction();
	  this.dirtyComponentsLength = null;
	  this.callbackQueue = CallbackQueue.getPooled();
	  this.reconcileTransaction = ReactUpdates.ReactReconcileTransaction.getPooled(
	  /* useCreateElement */true);
	}
	
	_assign(ReactUpdatesFlushTransaction.prototype, Transaction.Mixin, {
	  getTransactionWrappers: function () {
	    return TRANSACTION_WRAPPERS;
	  },
	
	  destructor: function () {
	    this.dirtyComponentsLength = null;
	    CallbackQueue.release(this.callbackQueue);
	    this.callbackQueue = null;
	    ReactUpdates.ReactReconcileTransaction.release(this.reconcileTransaction);
	    this.reconcileTransaction = null;
	  },
	
	  perform: function (method, scope, a) {
	    // Essentially calls `this.reconcileTransaction.perform(method, scope, a)`
	    // with this transaction's wrappers around it.
	    return Transaction.Mixin.perform.call(this, this.reconcileTransaction.perform, this.reconcileTransaction, method, scope, a);
	  }
	});
	
	PooledClass.addPoolingTo(ReactUpdatesFlushTransaction);
	
	function batchedUpdates(callback, a, b, c, d, e) {
	  ensureInjected();
	  batchingStrategy.batchedUpdates(callback, a, b, c, d, e);
	}
	
	/**
	 * Array comparator for ReactComponents by mount ordering.
	 *
	 * @param {ReactComponent} c1 first component you're comparing
	 * @param {ReactComponent} c2 second component you're comparing
	 * @return {number} Return value usable by Array.prototype.sort().
	 */
	function mountOrderComparator(c1, c2) {
	  return c1._mountOrder - c2._mountOrder;
	}
	
	function runBatchedUpdates(transaction) {
	  var len = transaction.dirtyComponentsLength;
	  !(len === dirtyComponents.length) ?  false ? invariant(false, 'Expected flush transaction\'s stored dirty-components length (%s) to match dirty-components array length (%s).', len, dirtyComponents.length) : _prodInvariant('124', len, dirtyComponents.length) : void 0;
	
	  // Since reconciling a component higher in the owner hierarchy usually (not
	  // always -- see shouldComponentUpdate()) will reconcile children, reconcile
	  // them before their children by sorting the array.
	  dirtyComponents.sort(mountOrderComparator);
	
	  // Any updates enqueued while reconciling must be performed after this entire
	  // batch. Otherwise, if dirtyComponents is [A, B] where A has children B and
	  // C, B could update twice in a single batch if C's render enqueues an update
	  // to B (since B would have already updated, we should skip it, and the only
	  // way we can know to do so is by checking the batch counter).
	  updateBatchNumber++;
	
	  for (var i = 0; i < len; i++) {
	    // If a component is unmounted before pending changes apply, it will still
	    // be here, but we assume that it has cleared its _pendingCallbacks and
	    // that performUpdateIfNecessary is a noop.
	    var component = dirtyComponents[i];
	
	    // If performUpdateIfNecessary happens to enqueue any new updates, we
	    // shouldn't execute the callbacks until the next render happens, so
	    // stash the callbacks first
	    var callbacks = component._pendingCallbacks;
	    component._pendingCallbacks = null;
	
	    var markerName;
	    if (ReactFeatureFlags.logTopLevelRenders) {
	      var namedComponent = component;
	      // Duck type TopLevelWrapper. This is probably always true.
	      if (component._currentElement.props === component._renderedComponent._currentElement) {
	        namedComponent = component._renderedComponent;
	      }
	      markerName = 'React update: ' + namedComponent.getName();
	      console.time(markerName);
	    }
	
	    ReactReconciler.performUpdateIfNecessary(component, transaction.reconcileTransaction, updateBatchNumber);
	
	    if (markerName) {
	      console.timeEnd(markerName);
	    }
	
	    if (callbacks) {
	      for (var j = 0; j < callbacks.length; j++) {
	        transaction.callbackQueue.enqueue(callbacks[j], component.getPublicInstance());
	      }
	    }
	  }
	}
	
	var flushBatchedUpdates = function () {
	  // ReactUpdatesFlushTransaction's wrappers will clear the dirtyComponents
	  // array and perform any updates enqueued by mount-ready handlers (i.e.,
	  // componentDidUpdate) but we need to check here too in order to catch
	  // updates enqueued by setState callbacks and asap calls.
	  while (dirtyComponents.length || asapEnqueued) {
	    if (dirtyComponents.length) {
	      var transaction = ReactUpdatesFlushTransaction.getPooled();
	      transaction.perform(runBatchedUpdates, null, transaction);
	      ReactUpdatesFlushTransaction.release(transaction);
	    }
	
	    if (asapEnqueued) {
	      asapEnqueued = false;
	      var queue = asapCallbackQueue;
	      asapCallbackQueue = CallbackQueue.getPooled();
	      queue.notifyAll();
	      CallbackQueue.release(queue);
	    }
	  }
	};
	
	/**
	 * Mark a component as needing a rerender, adding an optional callback to a
	 * list of functions which will be executed once the rerender occurs.
	 */
	function enqueueUpdate(component) {
	  ensureInjected();
	
	  // Various parts of our code (such as ReactCompositeComponent's
	  // _renderValidatedComponent) assume that calls to render aren't nested;
	  // verify that that's the case. (This is called by each top-level update
	  // function, like setState, forceUpdate, etc.; creation and
	  // destruction of top-level components is guarded in ReactMount.)
	
	  if (!batchingStrategy.isBatchingUpdates) {
	    batchingStrategy.batchedUpdates(enqueueUpdate, component);
	    return;
	  }
	
	  dirtyComponents.push(component);
	  if (component._updateBatchNumber == null) {
	    component._updateBatchNumber = updateBatchNumber + 1;
	  }
	}
	
	/**
	 * Enqueue a callback to be run at the end of the current batching cycle. Throws
	 * if no updates are currently being performed.
	 */
	function asap(callback, context) {
	  !batchingStrategy.isBatchingUpdates ?  false ? invariant(false, 'ReactUpdates.asap: Can\'t enqueue an asap callback in a context whereupdates are not being batched.') : _prodInvariant('125') : void 0;
	  asapCallbackQueue.enqueue(callback, context);
	  asapEnqueued = true;
	}
	
	var ReactUpdatesInjection = {
	  injectReconcileTransaction: function (ReconcileTransaction) {
	    !ReconcileTransaction ?  false ? invariant(false, 'ReactUpdates: must provide a reconcile transaction class') : _prodInvariant('126') : void 0;
	    ReactUpdates.ReactReconcileTransaction = ReconcileTransaction;
	  },
	
	  injectBatchingStrategy: function (_batchingStrategy) {
	    !_batchingStrategy ?  false ? invariant(false, 'ReactUpdates: must provide a batching strategy') : _prodInvariant('127') : void 0;
	    !(typeof _batchingStrategy.batchedUpdates === 'function') ?  false ? invariant(false, 'ReactUpdates: must provide a batchedUpdates() function') : _prodInvariant('128') : void 0;
	    !(typeof _batchingStrategy.isBatchingUpdates === 'boolean') ?  false ? invariant(false, 'ReactUpdates: must provide an isBatchingUpdates boolean attribute') : _prodInvariant('129') : void 0;
	    batchingStrategy = _batchingStrategy;
	  }
	};
	
	var ReactUpdates = {
	  /**
	   * React references `ReactReconcileTransaction` using this property in order
	   * to allow dependency injection.
	   *
	   * @internal
	   */
	  ReactReconcileTransaction: null,
	
	  batchedUpdates: batchedUpdates,
	  enqueueUpdate: enqueueUpdate,
	  flushBatchedUpdates: flushBatchedUpdates,
	  injection: ReactUpdatesInjection,
	  asap: asap
	};
	
	module.exports = ReactUpdates;

/***/ },
/* 15 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports.defaultMemoize = defaultMemoize;
	exports.createSelectorCreator = createSelectorCreator;
	exports.createSelector = createSelector;
	exports.createStructuredSelector = createStructuredSelector;
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function defaultEqualityCheck(a, b) {
	  return a === b;
	}
	
	function defaultMemoize(func) {
	  var equalityCheck = arguments.length <= 1 || arguments[1] === undefined ? defaultEqualityCheck : arguments[1];
	
	  var lastArgs = null;
	  var lastResult = null;
	  return function () {
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    if (lastArgs !== null && lastArgs.length === args.length && args.every(function (value, index) {
	      return equalityCheck(value, lastArgs[index]);
	    })) {
	      return lastResult;
	    }
	    lastResult = func.apply(undefined, args);
	    lastArgs = args;
	    return lastResult;
	  };
	}
	
	function getDependencies(funcs) {
	  var dependencies = Array.isArray(funcs[0]) ? funcs[0] : funcs;
	
	  if (!dependencies.every(function (dep) {
	    return typeof dep === 'function';
	  })) {
	    var dependencyTypes = dependencies.map(function (dep) {
	      return typeof dep;
	    }).join(', ');
	    throw new Error('Selector creators expect all input-selectors to be functions, ' + ('instead received the following types: [' + dependencyTypes + ']'));
	  }
	
	  return dependencies;
	}
	
	function createSelectorCreator(memoize) {
	  for (var _len2 = arguments.length, memoizeOptions = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
	    memoizeOptions[_key2 - 1] = arguments[_key2];
	  }
	
	  return function () {
	    for (var _len3 = arguments.length, funcs = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
	      funcs[_key3] = arguments[_key3];
	    }
	
	    var recomputations = 0;
	    var resultFunc = funcs.pop();
	    var dependencies = getDependencies(funcs);
	
	    var memoizedResultFunc = memoize.apply(undefined, [function () {
	      recomputations++;
	      return resultFunc.apply(undefined, arguments);
	    }].concat(memoizeOptions));
	
	    var selector = function selector(state, props) {
	      for (var _len4 = arguments.length, args = Array(_len4 > 2 ? _len4 - 2 : 0), _key4 = 2; _key4 < _len4; _key4++) {
	        args[_key4 - 2] = arguments[_key4];
	      }
	
	      var params = dependencies.map(function (dependency) {
	        return dependency.apply(undefined, [state, props].concat(args));
	      });
	      return memoizedResultFunc.apply(undefined, _toConsumableArray(params));
	    };
	
	    selector.resultFunc = resultFunc;
	    selector.recomputations = function () {
	      return recomputations;
	    };
	    selector.resetRecomputations = function () {
	      return recomputations = 0;
	    };
	    return selector;
	  };
	}
	
	function createSelector() {
	  return createSelectorCreator(defaultMemoize).apply(undefined, arguments);
	}
	
	function createStructuredSelector(selectors) {
	  var selectorCreator = arguments.length <= 1 || arguments[1] === undefined ? createSelector : arguments[1];
	
	  if (typeof selectors !== 'object') {
	    throw new Error('createStructuredSelector expects first argument to be an object ' + ('where each property is a selector, instead received a ' + typeof selectors));
	  }
	  var objectKeys = Object.keys(selectors);
	  return selectorCreator(objectKeys.map(function (key) {
	    return selectors[key];
	  }), function () {
	    for (var _len5 = arguments.length, values = Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
	      values[_key5] = arguments[_key5];
	    }
	
	    return values.reduce(function (composition, value, index) {
	      composition[objectKeys[index]] = value;
	      return composition;
	    }, {});
	  });
	}

/***/ },
/* 16 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = __webpack_require__(318);


/***/ },
/* 17 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.default = makeEntitiesSelector;
	
	var _underscore = __webpack_require__(7);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _reselect = __webpack_require__(15);
	
	var _selected_selector = __webpack_require__(285);
	
	var _selected_selector2 = _interopRequireDefault(_selected_selector);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function makeEntitiesSelector(stateSelector, getAttributes, getAssociations) {
	
		getAttributes = getAttributes || function (entity) {
			return entity;
		};
		getAssociations = getAssociations || function () {};
	
		var create = (0, _reselect.createSelector)(function (entity, localState, associations) {
			return entity;
		}, function (entity, localState, associations) {
			return localState;
		}, function (entity, localState, associations) {
			return associations;
		}, function (entity, localState, associations) {
			return Object.assign({}, entity, getAttributes(entity, localState, associations), (0, _selected_selector2.default)(entity, 'selected', localState.selected), (0, _selected_selector2.default)(entity, 'inspected', localState.inspected));
		});
	
		var getState = stateSelector;
	
		var get = (0, _reselect.createSelector)(function (state, id) {
			return stateSelector(state);
		}, function (state, id) {
			return getAssociations(state);
		}, function (state, id) {
			return id;
		}, function (localState, associations, id) {
			var entity = void 0;
	
			if (!localState.entities[id.toString()]) {
				console.log('Could not find entity: ' + id, localState);
			} else {
				entity = create(localState.entities[id.toString()], localState, associations);
			}
	
			return entity;
		});
	
		var getAll = (0, _reselect.createSelector)(function (state) {
			return stateSelector(state);
		}, function (state) {
			return getAssociations(state);
		}, function (localState, associations) {
			return localState.items.map(function (id) {
				return create(localState.entities[id.toString()], localState, associations);
			});
		});
	
		var getSelected = (0, _reselect.createSelector)(function (state) {
			return getAll(state);
		}, function (state) {
			return stateSelector(state).selected;
		}, function (entities, selected) {
			return entities.filter(function (entity) {
				return entity.selected;
			});
		});
	
		var filter = (0, _reselect.createSelector)(function (state, filters) {
			return getAll(state);
		}, function (state, filters) {
			return filters;
		}, function (items, predicate) {
			return _underscore2.default.filter(items, predicate) || [];
		});
	
		var getInspected = (0, _reselect.createSelector)(function (state) {
			return getAll(state);
		}, function (entities) {
			return entities.filter(function (entity) {
				return entity.inspected;
			});
		});
	
		return {
			create: create,
			getState: getState,
			get: get,
			getAll: getAll,
			filter: filter,
			getSelected: getSelected,
			getInspected: getInspected
		};
	};

/***/ },
/* 18 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule EventConstants
	 */
	
	'use strict';
	
	var keyMirror = __webpack_require__(39);
	
	var PropagationPhases = keyMirror({ bubbled: null, captured: null });
	
	/**
	 * Types of raw signals from the browser caught at the top level.
	 */
	var topLevelTypes = keyMirror({
	  topAbort: null,
	  topAnimationEnd: null,
	  topAnimationIteration: null,
	  topAnimationStart: null,
	  topBlur: null,
	  topCanPlay: null,
	  topCanPlayThrough: null,
	  topChange: null,
	  topClick: null,
	  topCompositionEnd: null,
	  topCompositionStart: null,
	  topCompositionUpdate: null,
	  topContextMenu: null,
	  topCopy: null,
	  topCut: null,
	  topDoubleClick: null,
	  topDrag: null,
	  topDragEnd: null,
	  topDragEnter: null,
	  topDragExit: null,
	  topDragLeave: null,
	  topDragOver: null,
	  topDragStart: null,
	  topDrop: null,
	  topDurationChange: null,
	  topEmptied: null,
	  topEncrypted: null,
	  topEnded: null,
	  topError: null,
	  topFocus: null,
	  topInput: null,
	  topInvalid: null,
	  topKeyDown: null,
	  topKeyPress: null,
	  topKeyUp: null,
	  topLoad: null,
	  topLoadedData: null,
	  topLoadedMetadata: null,
	  topLoadStart: null,
	  topMouseDown: null,
	  topMouseMove: null,
	  topMouseOut: null,
	  topMouseOver: null,
	  topMouseUp: null,
	  topPaste: null,
	  topPause: null,
	  topPlay: null,
	  topPlaying: null,
	  topProgress: null,
	  topRateChange: null,
	  topReset: null,
	  topScroll: null,
	  topSeeked: null,
	  topSeeking: null,
	  topSelectionChange: null,
	  topStalled: null,
	  topSubmit: null,
	  topSuspend: null,
	  topTextInput: null,
	  topTimeUpdate: null,
	  topTouchCancel: null,
	  topTouchEnd: null,
	  topTouchMove: null,
	  topTouchStart: null,
	  topTransitionEnd: null,
	  topVolumeChange: null,
	  topWaiting: null,
	  topWheel: null
	});
	
	var EventConstants = {
	  topLevelTypes: topLevelTypes,
	  PropagationPhases: PropagationPhases
	};
	
	module.exports = EventConstants;

/***/ },
/* 19 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule SyntheticEvent
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(6);
	
	var PooledClass = __webpack_require__(22);
	
	var emptyFunction = __webpack_require__(10);
	var warning = __webpack_require__(4);
	
	var didWarnForAddedNewProperty = false;
	var isProxySupported = typeof Proxy === 'function';
	
	var shouldBeReleasedProperties = ['dispatchConfig', '_targetInst', 'nativeEvent', 'isDefaultPrevented', 'isPropagationStopped', '_dispatchListeners', '_dispatchInstances'];
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var EventInterface = {
	  type: null,
	  target: null,
	  // currentTarget is set when dispatching; no use in copying it here
	  currentTarget: emptyFunction.thatReturnsNull,
	  eventPhase: null,
	  bubbles: null,
	  cancelable: null,
	  timeStamp: function (event) {
	    return event.timeStamp || Date.now();
	  },
	  defaultPrevented: null,
	  isTrusted: null
	};
	
	/**
	 * Synthetic events are dispatched by event plugins, typically in response to a
	 * top-level event delegation handler.
	 *
	 * These systems should generally use pooling to reduce the frequency of garbage
	 * collection. The system should check `isPersistent` to determine whether the
	 * event should be released into the pool after being dispatched. Users that
	 * need a persisted event should invoke `persist`.
	 *
	 * Synthetic events (and subclasses) implement the DOM Level 3 Events API by
	 * normalizing browser quirks. Subclasses do not necessarily have to implement a
	 * DOM interface; custom application-specific events can also subclass this.
	 *
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {*} targetInst Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @param {DOMEventTarget} nativeEventTarget Target node.
	 */
	function SyntheticEvent(dispatchConfig, targetInst, nativeEvent, nativeEventTarget) {
	  if (false) {
	    // these have a getter/setter for warnings
	    delete this.nativeEvent;
	    delete this.preventDefault;
	    delete this.stopPropagation;
	  }
	
	  this.dispatchConfig = dispatchConfig;
	  this._targetInst = targetInst;
	  this.nativeEvent = nativeEvent;
	
	  var Interface = this.constructor.Interface;
	  for (var propName in Interface) {
	    if (!Interface.hasOwnProperty(propName)) {
	      continue;
	    }
	    if (false) {
	      delete this[propName]; // this has a getter/setter for warnings
	    }
	    var normalize = Interface[propName];
	    if (normalize) {
	      this[propName] = normalize(nativeEvent);
	    } else {
	      if (propName === 'target') {
	        this.target = nativeEventTarget;
	      } else {
	        this[propName] = nativeEvent[propName];
	      }
	    }
	  }
	
	  var defaultPrevented = nativeEvent.defaultPrevented != null ? nativeEvent.defaultPrevented : nativeEvent.returnValue === false;
	  if (defaultPrevented) {
	    this.isDefaultPrevented = emptyFunction.thatReturnsTrue;
	  } else {
	    this.isDefaultPrevented = emptyFunction.thatReturnsFalse;
	  }
	  this.isPropagationStopped = emptyFunction.thatReturnsFalse;
	  return this;
	}
	
	_assign(SyntheticEvent.prototype, {
	
	  preventDefault: function () {
	    this.defaultPrevented = true;
	    var event = this.nativeEvent;
	    if (!event) {
	      return;
	    }
	
	    if (event.preventDefault) {
	      event.preventDefault();
	    } else {
	      event.returnValue = false;
	    }
	    this.isDefaultPrevented = emptyFunction.thatReturnsTrue;
	  },
	
	  stopPropagation: function () {
	    var event = this.nativeEvent;
	    if (!event) {
	      return;
	    }
	
	    if (event.stopPropagation) {
	      event.stopPropagation();
	    } else if (typeof event.cancelBubble !== 'unknown') {
	      // eslint-disable-line valid-typeof
	      // The ChangeEventPlugin registers a "propertychange" event for
	      // IE. This event does not support bubbling or cancelling, and
	      // any references to cancelBubble throw "Member not found".  A
	      // typeof check of "unknown" circumvents this issue (and is also
	      // IE specific).
	      event.cancelBubble = true;
	    }
	
	    this.isPropagationStopped = emptyFunction.thatReturnsTrue;
	  },
	
	  /**
	   * We release all dispatched `SyntheticEvent`s after each event loop, adding
	   * them back into the pool. This allows a way to hold onto a reference that
	   * won't be added back into the pool.
	   */
	  persist: function () {
	    this.isPersistent = emptyFunction.thatReturnsTrue;
	  },
	
	  /**
	   * Checks if this event should be released back into the pool.
	   *
	   * @return {boolean} True if this should not be released, false otherwise.
	   */
	  isPersistent: emptyFunction.thatReturnsFalse,
	
	  /**
	   * `PooledClass` looks for `destructor` on each instance it releases.
	   */
	  destructor: function () {
	    var Interface = this.constructor.Interface;
	    for (var propName in Interface) {
	      if (false) {
	        Object.defineProperty(this, propName, getPooledWarningPropertyDefinition(propName, Interface[propName]));
	      } else {
	        this[propName] = null;
	      }
	    }
	    for (var i = 0; i < shouldBeReleasedProperties.length; i++) {
	      this[shouldBeReleasedProperties[i]] = null;
	    }
	    if (false) {
	      Object.defineProperty(this, 'nativeEvent', getPooledWarningPropertyDefinition('nativeEvent', null));
	      Object.defineProperty(this, 'preventDefault', getPooledWarningPropertyDefinition('preventDefault', emptyFunction));
	      Object.defineProperty(this, 'stopPropagation', getPooledWarningPropertyDefinition('stopPropagation', emptyFunction));
	    }
	  }
	
	});
	
	SyntheticEvent.Interface = EventInterface;
	
	if (false) {
	  if (isProxySupported) {
	    /*eslint-disable no-func-assign */
	    SyntheticEvent = new Proxy(SyntheticEvent, {
	      construct: function (target, args) {
	        return this.apply(target, Object.create(target.prototype), args);
	      },
	      apply: function (constructor, that, args) {
	        return new Proxy(constructor.apply(that, args), {
	          set: function (target, prop, value) {
	            if (prop !== 'isPersistent' && !target.constructor.Interface.hasOwnProperty(prop) && shouldBeReleasedProperties.indexOf(prop) === -1) {
	              process.env.NODE_ENV !== 'production' ? warning(didWarnForAddedNewProperty || target.isPersistent(), 'This synthetic event is reused for performance reasons. If you\'re ' + 'seeing this, you\'re adding a new property in the synthetic event object. ' + 'The property is never released. See ' + 'https://fb.me/react-event-pooling for more information.') : void 0;
	              didWarnForAddedNewProperty = true;
	            }
	            target[prop] = value;
	            return true;
	          }
	        });
	      }
	    });
	    /*eslint-enable no-func-assign */
	  }
	}
	/**
	 * Helper to reduce boilerplate when creating subclasses.
	 *
	 * @param {function} Class
	 * @param {?object} Interface
	 */
	SyntheticEvent.augmentClass = function (Class, Interface) {
	  var Super = this;
	
	  var E = function () {};
	  E.prototype = Super.prototype;
	  var prototype = new E();
	
	  _assign(prototype, Class.prototype);
	  Class.prototype = prototype;
	  Class.prototype.constructor = Class;
	
	  Class.Interface = _assign({}, Super.Interface, Interface);
	  Class.augmentClass = Super.augmentClass;
	
	  PooledClass.addPoolingTo(Class, PooledClass.fourArgumentPooler);
	};
	
	PooledClass.addPoolingTo(SyntheticEvent, PooledClass.fourArgumentPooler);
	
	module.exports = SyntheticEvent;
	
	/**
	  * Helper to nullify syntheticEvent instance properties when destructing
	  *
	  * @param {object} SyntheticEvent
	  * @param {String} propName
	  * @return {object} defineProperty object
	  */
	function getPooledWarningPropertyDefinition(propName, getVal) {
	  var isFunction = typeof getVal === 'function';
	  return {
	    configurable: true,
	    set: set,
	    get: get
	  };
	
	  function set(val) {
	    var action = isFunction ? 'setting the method' : 'setting the property';
	    warn(action, 'This is effectively a no-op');
	    return val;
	  }
	
	  function get() {
	    var action = isFunction ? 'accessing the method' : 'accessing the property';
	    var result = isFunction ? 'This is a no-op function' : 'This is set to null';
	    warn(action, result);
	    return getVal;
	  }
	
	  function warn(action, result) {
	    var warningCondition = false;
	     false ? warning(warningCondition, 'This synthetic event is reused for performance reasons. If you\'re seeing this, ' + 'you\'re %s `%s` on a released/nullified synthetic event. %s. ' + 'If you must keep the original synthetic event around, use event.persist(). ' + 'See https://fb.me/react-event-pooling for more information.', action, propName, result) : void 0;
	  }
	}

/***/ },
/* 20 */
/***/ function(module, exports) {

	"use strict";
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	/**
	 * Allows extraction of a minified key. Let's the build system minify keys
	 * without losing the ability to dynamically use key strings as values
	 * themselves. Pass in an object with a single key/val pair and it will return
	 * you the string key of that single record. Suppose you want to grab the
	 * value for a key 'className' inside of an object. Key/val minification may
	 * have aliased that key to be 'xa12'. keyOf({className: null}) will return
	 * 'xa12' in that case. Resolve keys you want to use once at startup time, then
	 * reuse those resolutions.
	 */
	var keyOf = function keyOf(oneKeyObj) {
	  var key;
	  for (key in oneKeyObj) {
	    if (!oneKeyObj.hasOwnProperty(key)) {
	      continue;
	    }
	    return key;
	  }
	  return null;
	};
	
	module.exports = keyOf;

/***/ },
/* 21 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.default = normalize;
	
	var _underscore = __webpack_require__(7);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function normalize(state, entities, references) {
		state = Object.assign({
			items: [],
			entities: {}
		}, state);
	
		entities = entities || [];
		references = references || state.references || [];
	
		return Object.assign({}, state, {
			items: state.items.concat(entities.map(function (entity) {
				return entity.id;
			})),
			entities: Object.assign({}, state.entities, _underscore2.default.indexBy(entities, 'id')),
			references: references
		});
	};

/***/ },
/* 22 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule PooledClass
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(3);
	
	var invariant = __webpack_require__(2);
	
	/**
	 * Static poolers. Several custom versions for each potential number of
	 * arguments. A completely generic pooler is easy to implement, but would
	 * require accessing the `arguments` object. In each of these, `this` refers to
	 * the Class itself, not an instance. If any others are needed, simply add them
	 * here, or in their own files.
	 */
	var oneArgumentPooler = function (copyFieldsFrom) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, copyFieldsFrom);
	    return instance;
	  } else {
	    return new Klass(copyFieldsFrom);
	  }
	};
	
	var twoArgumentPooler = function (a1, a2) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, a1, a2);
	    return instance;
	  } else {
	    return new Klass(a1, a2);
	  }
	};
	
	var threeArgumentPooler = function (a1, a2, a3) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, a1, a2, a3);
	    return instance;
	  } else {
	    return new Klass(a1, a2, a3);
	  }
	};
	
	var fourArgumentPooler = function (a1, a2, a3, a4) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, a1, a2, a3, a4);
	    return instance;
	  } else {
	    return new Klass(a1, a2, a3, a4);
	  }
	};
	
	var fiveArgumentPooler = function (a1, a2, a3, a4, a5) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, a1, a2, a3, a4, a5);
	    return instance;
	  } else {
	    return new Klass(a1, a2, a3, a4, a5);
	  }
	};
	
	var standardReleaser = function (instance) {
	  var Klass = this;
	  !(instance instanceof Klass) ?  false ? invariant(false, 'Trying to release an instance into a pool of a different type.') : _prodInvariant('25') : void 0;
	  instance.destructor();
	  if (Klass.instancePool.length < Klass.poolSize) {
	    Klass.instancePool.push(instance);
	  }
	};
	
	var DEFAULT_POOL_SIZE = 10;
	var DEFAULT_POOLER = oneArgumentPooler;
	
	/**
	 * Augments `CopyConstructor` to be a poolable class, augmenting only the class
	 * itself (statically) not adding any prototypical fields. Any CopyConstructor
	 * you give this may have a `poolSize` property, and will look for a
	 * prototypical `destructor` on instances.
	 *
	 * @param {Function} CopyConstructor Constructor that can be used to reset.
	 * @param {Function} pooler Customizable pooler.
	 */
	var addPoolingTo = function (CopyConstructor, pooler) {
	  var NewKlass = CopyConstructor;
	  NewKlass.instancePool = [];
	  NewKlass.getPooled = pooler || DEFAULT_POOLER;
	  if (!NewKlass.poolSize) {
	    NewKlass.poolSize = DEFAULT_POOL_SIZE;
	  }
	  NewKlass.release = standardReleaser;
	  return NewKlass;
	};
	
	var PooledClass = {
	  addPoolingTo: addPoolingTo,
	  oneArgumentPooler: oneArgumentPooler,
	  twoArgumentPooler: twoArgumentPooler,
	  threeArgumentPooler: threeArgumentPooler,
	  fourArgumentPooler: fourArgumentPooler,
	  fiveArgumentPooler: fiveArgumentPooler
	};
	
	module.exports = PooledClass;

/***/ },
/* 23 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactCurrentOwner
	 */
	
	'use strict';
	
	/**
	 * Keeps track of the current owner.
	 *
	 * The current owner is the component who should own any components that are
	 * currently being constructed.
	 */
	
	var ReactCurrentOwner = {
	
	  /**
	   * @internal
	   * @type {ReactComponent}
	   */
	  current: null
	
	};
	
	module.exports = ReactCurrentOwner;

/***/ },
/* 24 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	var Time = {
		new: function _new(hour, minutes) {
			var pm = hour >= 12;
			var mString = (minutes < 10 ? '0' + minutes : minutes).toString();
			var hString = (pm && hour !== 12 ? hour - 12 : hour).toString();
			var str = hString + ':' + mString;
			str += pm ? 'pm' : 'am';
			return this.parse(str, true);
		},
	
		parse: function parse(str) {
			var timeSpan = { hour: 0, minutes: 0 };
			var range = str.match(/^(\d+):(\d\d)\s*(\w\w)$/);
			timeSpan.hour = parseInt(range[1], 10);
			timeSpan.minutes = parseInt(range[2], 10);
			timeSpan.value = str;
	
			if (range[3] === 'pm' && timeSpan.hour !== 12) {
				timeSpan.hour += 12;
			}
			timeSpan.totalMinutes = timeSpan.hour * 60 + timeSpan.minutes;
			return timeSpan;
		},
	
		stringFromMinutes: function stringFromMinutes(minutes) {
			var hour = Math.floor(minutes / 60);
			minutes %= 60;
			return this.new(hour, minutes).value;
		},
	
		getId: function getId(str) {
			var timeSpan = this.parse(str);
			var hour = timeSpan.hour.toString();
			var minutes = timeSpan.minutes;
			if (timeSpan.minutes < 10) {
				minutes = '0' + minutes.toString();
			}
			return parseInt(hour.toString() + minutes.toString(), 10);
		},
	
		duration: function duration(startStr, endStr) {
			var start = this.parse(startStr);
			var end = this.parse(endStr);
			var hours = end.hour - start.hour;
			var minutes = end.minutes - start.minutes;
			var startMinutes = void 0;
	
			if (hours > 0) {
				minutes = hours * 60;
				if (minutes === 60) {
					minutes -= start.minutes;
					minutes += end.minutes;
				} else {
					startMinutes = start.minutes !== 0 ? 60 - start.minutes : 0;
					if (startMinutes + end.minutes !== 60 && startMinutes + end.minutes !== 0) {
						hours = (hours - 1) * 60;
						minutes = hours + startMinutes + end.minutes;
					}
				}
			}
			return { hours: minutes / 60, minutes: minutes };
		}
	};
	
	exports.default = Time;

/***/ },
/* 25 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Selectable = _react2.default.createClass({
	  displayName: 'Selectable',
	
	
	  propTypes: {
	    selectedClass: _react2.default.PropTypes.oneOfType([_react2.default.PropTypes.string, _react2.default.PropTypes.func]).isRequired,
	    id: _react2.default.PropTypes.any.isRequired,
	    data: _react2.default.PropTypes.object,
	    clickTargetClassName: _react2.default.PropTypes.string
	  },
	
	  getInitialState: function getInitialState() {
	    return {
	      selected: this.props.selected === true
	    };
	  },
	
	  componentWillReceiveProps: function componentWillReceiveProps(props) {
	    if (props !== undefined && props.selected !== this.state.selected) {
	      this._updateState(props.selected);
	    }
	  },
	
	  render: function render() {
	    var child = _react2.default.Children.only(this.props.children);
	    var className = this._getClassName();
	    var props = Object.assign({}, child.props, {
	      onClick: this.props.overrideClick ? this._getOverrideClickHandler(child) : this._wrapClickHandler(child),
	      selected: this.state.selected,
	      className: [this.props.className, child.props.className, className].join(' ')
	    });
	
	    return _react2.default.createElement(child.type, props);
	  },
	
	  toggleSelect: function toggleSelect() {
	    var selected = !this.state.selected;
	    this._updateState(selected);
	    return selected;
	  },
	
	  select: function select() {
	    this._updateState(true);
	  },
	
	  unselect: function unselect() {
	    this._updateState(false);
	  },
	
	  handleClick: function handleClick(e) {
	    if (!this.props.clickTargetClassName || e.target.className.indexOf(this.props.clickTargetClassName) !== -1) {
	      this.toggleSelect();
	    }
	  },
	
	  _updateState: function _updateState(selected) {
	    if (selected === this.state.selected) {
	      return;
	    }
	
	    this.setState({
	      selected: selected
	    });
	
	    if (this.props.onChange) {
	      this.props.onChange(this.props.id, this, this.props.data, selected);
	    }
	  },
	
	  _getClassName: function _getClassName(selected) {
	    var _this = this;
	
	    var className = null;
	    var selectedClass = this.props.selectedClass;
	    if (typeof this.props.selectedClass !== 'function') {
	      selectedClass = function selectedClass() {
	        return _this.props.selectedClass;
	      };
	    }
	
	    if (this.state.selected) {
	      className = selectedClass(this.props.data);
	    }
	
	    return className;
	  },
	
	  _wrapClickHandler: function _wrapClickHandler(child) {
	    var _this2 = this;
	
	    return function (e) {
	      _this2.handleClick(e);
	      if (child.props.onClick) {
	        child.props.onClick(e);
	      }
	    };
	  },
	
	  _getOverrideClickHandler: function _getOverrideClickHandler(child) {
	    var handleClick = null;
	    if (child.props.onClick) {
	      handleClick = child.props.onClick.bind(null, this);
	    }
	
	    return handleClick;
	  }
	
	});
	
	exports.default = Selectable;

/***/ },
/* 26 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule DOMLazyTree
	 */
	
	'use strict';
	
	var DOMNamespaces = __webpack_require__(53);
	var setInnerHTML = __webpack_require__(46);
	
	var createMicrosoftUnsafeLocalFunction = __webpack_require__(67);
	var setTextContent = __webpack_require__(127);
	
	var ELEMENT_NODE_TYPE = 1;
	var DOCUMENT_FRAGMENT_NODE_TYPE = 11;
	
	/**
	 * In IE (8-11) and Edge, appending nodes with no children is dramatically
	 * faster than appending a full subtree, so we essentially queue up the
	 * .appendChild calls here and apply them so each node is added to its parent
	 * before any children are added.
	 *
	 * In other browsers, doing so is slower or neutral compared to the other order
	 * (in Firefox, twice as slow) so we only do this inversion in IE.
	 *
	 * See https://github.com/spicyj/innerhtml-vs-createelement-vs-clonenode.
	 */
	var enableLazy = typeof document !== 'undefined' && typeof document.documentMode === 'number' || typeof navigator !== 'undefined' && typeof navigator.userAgent === 'string' && /\bEdge\/\d/.test(navigator.userAgent);
	
	function insertTreeChildren(tree) {
	  if (!enableLazy) {
	    return;
	  }
	  var node = tree.node;
	  var children = tree.children;
	  if (children.length) {
	    for (var i = 0; i < children.length; i++) {
	      insertTreeBefore(node, children[i], null);
	    }
	  } else if (tree.html != null) {
	    setInnerHTML(node, tree.html);
	  } else if (tree.text != null) {
	    setTextContent(node, tree.text);
	  }
	}
	
	var insertTreeBefore = createMicrosoftUnsafeLocalFunction(function (parentNode, tree, referenceNode) {
	  // DocumentFragments aren't actually part of the DOM after insertion so
	  // appending children won't update the DOM. We need to ensure the fragment
	  // is properly populated first, breaking out of our lazy approach for just
	  // this level. Also, some <object> plugins (like Flash Player) will read
	  // <param> nodes immediately upon insertion into the DOM, so <object>
	  // must also be populated prior to insertion into the DOM.
	  if (tree.node.nodeType === DOCUMENT_FRAGMENT_NODE_TYPE || tree.node.nodeType === ELEMENT_NODE_TYPE && tree.node.nodeName.toLowerCase() === 'object' && (tree.node.namespaceURI == null || tree.node.namespaceURI === DOMNamespaces.html)) {
	    insertTreeChildren(tree);
	    parentNode.insertBefore(tree.node, referenceNode);
	  } else {
	    parentNode.insertBefore(tree.node, referenceNode);
	    insertTreeChildren(tree);
	  }
	});
	
	function replaceChildWithTree(oldNode, newTree) {
	  oldNode.parentNode.replaceChild(newTree.node, oldNode);
	  insertTreeChildren(newTree);
	}
	
	function queueChild(parentTree, childTree) {
	  if (enableLazy) {
	    parentTree.children.push(childTree);
	  } else {
	    parentTree.node.appendChild(childTree.node);
	  }
	}
	
	function queueHTML(tree, html) {
	  if (enableLazy) {
	    tree.html = html;
	  } else {
	    setInnerHTML(tree.node, html);
	  }
	}
	
	function queueText(tree, text) {
	  if (enableLazy) {
	    tree.text = text;
	  } else {
	    setTextContent(tree.node, text);
	  }
	}
	
	function toString() {
	  return this.node.nodeName;
	}
	
	function DOMLazyTree(node) {
	  return {
	    node: node,
	    children: [],
	    html: null,
	    text: null,
	    toString: toString
	  };
	}
	
	DOMLazyTree.insertTreeBefore = insertTreeBefore;
	DOMLazyTree.replaceChildWithTree = replaceChildWithTree;
	DOMLazyTree.queueChild = queueChild;
	DOMLazyTree.queueHTML = queueHTML;
	DOMLazyTree.queueText = queueText;
	
	module.exports = DOMLazyTree;

/***/ },
/* 27 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule DOMProperty
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(3);
	
	var invariant = __webpack_require__(2);
	
	function checkMask(value, bitmask) {
	  return (value & bitmask) === bitmask;
	}
	
	var DOMPropertyInjection = {
	  /**
	   * Mapping from normalized, camelcased property names to a configuration that
	   * specifies how the associated DOM property should be accessed or rendered.
	   */
	  MUST_USE_PROPERTY: 0x1,
	  HAS_BOOLEAN_VALUE: 0x4,
	  HAS_NUMERIC_VALUE: 0x8,
	  HAS_POSITIVE_NUMERIC_VALUE: 0x10 | 0x8,
	  HAS_OVERLOADED_BOOLEAN_VALUE: 0x20,
	
	  /**
	   * Inject some specialized knowledge about the DOM. This takes a config object
	   * with the following properties:
	   *
	   * isCustomAttribute: function that given an attribute name will return true
	   * if it can be inserted into the DOM verbatim. Useful for data-* or aria-*
	   * attributes where it's impossible to enumerate all of the possible
	   * attribute names,
	   *
	   * Properties: object mapping DOM property name to one of the
	   * DOMPropertyInjection constants or null. If your attribute isn't in here,
	   * it won't get written to the DOM.
	   *
	   * DOMAttributeNames: object mapping React attribute name to the DOM
	   * attribute name. Attribute names not specified use the **lowercase**
	   * normalized name.
	   *
	   * DOMAttributeNamespaces: object mapping React attribute name to the DOM
	   * attribute namespace URL. (Attribute names not specified use no namespace.)
	   *
	   * DOMPropertyNames: similar to DOMAttributeNames but for DOM properties.
	   * Property names not specified use the normalized name.
	   *
	   * DOMMutationMethods: Properties that require special mutation methods. If
	   * `value` is undefined, the mutation method should unset the property.
	   *
	   * @param {object} domPropertyConfig the config as described above.
	   */
	  injectDOMPropertyConfig: function (domPropertyConfig) {
	    var Injection = DOMPropertyInjection;
	    var Properties = domPropertyConfig.Properties || {};
	    var DOMAttributeNamespaces = domPropertyConfig.DOMAttributeNamespaces || {};
	    var DOMAttributeNames = domPropertyConfig.DOMAttributeNames || {};
	    var DOMPropertyNames = domPropertyConfig.DOMPropertyNames || {};
	    var DOMMutationMethods = domPropertyConfig.DOMMutationMethods || {};
	
	    if (domPropertyConfig.isCustomAttribute) {
	      DOMProperty._isCustomAttributeFunctions.push(domPropertyConfig.isCustomAttribute);
	    }
	
	    for (var propName in Properties) {
	      !!DOMProperty.properties.hasOwnProperty(propName) ?  false ? invariant(false, 'injectDOMPropertyConfig(...): You\'re trying to inject DOM property \'%s\' which has already been injected. You may be accidentally injecting the same DOM property config twice, or you may be injecting two configs that have conflicting property names.', propName) : _prodInvariant('48', propName) : void 0;
	
	      var lowerCased = propName.toLowerCase();
	      var propConfig = Properties[propName];
	
	      var propertyInfo = {
	        attributeName: lowerCased,
	        attributeNamespace: null,
	        propertyName: propName,
	        mutationMethod: null,
	
	        mustUseProperty: checkMask(propConfig, Injection.MUST_USE_PROPERTY),
	        hasBooleanValue: checkMask(propConfig, Injection.HAS_BOOLEAN_VALUE),
	        hasNumericValue: checkMask(propConfig, Injection.HAS_NUMERIC_VALUE),
	        hasPositiveNumericValue: checkMask(propConfig, Injection.HAS_POSITIVE_NUMERIC_VALUE),
	        hasOverloadedBooleanValue: checkMask(propConfig, Injection.HAS_OVERLOADED_BOOLEAN_VALUE)
	      };
	      !(propertyInfo.hasBooleanValue + propertyInfo.hasNumericValue + propertyInfo.hasOverloadedBooleanValue <= 1) ?  false ? invariant(false, 'DOMProperty: Value can be one of boolean, overloaded boolean, or numeric value, but not a combination: %s', propName) : _prodInvariant('50', propName) : void 0;
	
	      if (false) {
	        DOMProperty.getPossibleStandardName[lowerCased] = propName;
	      }
	
	      if (DOMAttributeNames.hasOwnProperty(propName)) {
	        var attributeName = DOMAttributeNames[propName];
	        propertyInfo.attributeName = attributeName;
	        if (false) {
	          DOMProperty.getPossibleStandardName[attributeName] = propName;
	        }
	      }
	
	      if (DOMAttributeNamespaces.hasOwnProperty(propName)) {
	        propertyInfo.attributeNamespace = DOMAttributeNamespaces[propName];
	      }
	
	      if (DOMPropertyNames.hasOwnProperty(propName)) {
	        propertyInfo.propertyName = DOMPropertyNames[propName];
	      }
	
	      if (DOMMutationMethods.hasOwnProperty(propName)) {
	        propertyInfo.mutationMethod = DOMMutationMethods[propName];
	      }
	
	      DOMProperty.properties[propName] = propertyInfo;
	    }
	  }
	};
	
	/* eslint-disable max-len */
	var ATTRIBUTE_NAME_START_CHAR = ':A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD';
	/* eslint-enable max-len */
	
	/**
	 * DOMProperty exports lookup objects that can be used like functions:
	 *
	 *   > DOMProperty.isValid['id']
	 *   true
	 *   > DOMProperty.isValid['foobar']
	 *   undefined
	 *
	 * Although this may be confusing, it performs better in general.
	 *
	 * @see http://jsperf.com/key-exists
	 * @see http://jsperf.com/key-missing
	 */
	var DOMProperty = {
	
	  ID_ATTRIBUTE_NAME: 'data-reactid',
	  ROOT_ATTRIBUTE_NAME: 'data-reactroot',
	
	  ATTRIBUTE_NAME_START_CHAR: ATTRIBUTE_NAME_START_CHAR,
	  ATTRIBUTE_NAME_CHAR: ATTRIBUTE_NAME_START_CHAR + '\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040',
	
	  /**
	   * Map from property "standard name" to an object with info about how to set
	   * the property in the DOM. Each object contains:
	   *
	   * attributeName:
	   *   Used when rendering markup or with `*Attribute()`.
	   * attributeNamespace
	   * propertyName:
	   *   Used on DOM node instances. (This includes properties that mutate due to
	   *   external factors.)
	   * mutationMethod:
	   *   If non-null, used instead of the property or `setAttribute()` after
	   *   initial render.
	   * mustUseProperty:
	   *   Whether the property must be accessed and mutated as an object property.
	   * hasBooleanValue:
	   *   Whether the property should be removed when set to a falsey value.
	   * hasNumericValue:
	   *   Whether the property must be numeric or parse as a numeric and should be
	   *   removed when set to a falsey value.
	   * hasPositiveNumericValue:
	   *   Whether the property must be positive numeric or parse as a positive
	   *   numeric and should be removed when set to a falsey value.
	   * hasOverloadedBooleanValue:
	   *   Whether the property can be used as a flag as well as with a value.
	   *   Removed when strictly equal to false; present without a value when
	   *   strictly equal to true; present with a value otherwise.
	   */
	  properties: {},
	
	  /**
	   * Mapping from lowercase property names to the properly cased version, used
	   * to warn in the case of missing properties. Available only in __DEV__.
	   * @type {Object}
	   */
	  getPossibleStandardName:  false ? {} : null,
	
	  /**
	   * All of the isCustomAttribute() functions that have been injected.
	   */
	  _isCustomAttributeFunctions: [],
	
	  /**
	   * Checks whether a property name is a custom attribute.
	   * @method
	   */
	  isCustomAttribute: function (attributeName) {
	    for (var i = 0; i < DOMProperty._isCustomAttributeFunctions.length; i++) {
	      var isCustomAttributeFn = DOMProperty._isCustomAttributeFunctions[i];
	      if (isCustomAttributeFn(attributeName)) {
	        return true;
	      }
	    }
	    return false;
	  },
	
	  injection: DOMPropertyInjection
	};
	
	module.exports = DOMProperty;

/***/ },
/* 28 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactReconciler
	 */
	
	'use strict';
	
	var ReactRef = __webpack_require__(342);
	var ReactInstrumentation = __webpack_require__(11);
	
	var warning = __webpack_require__(4);
	
	/**
	 * Helper to call ReactRef.attachRefs with this composite component, split out
	 * to avoid allocations in the transaction mount-ready queue.
	 */
	function attachRefs() {
	  ReactRef.attachRefs(this, this._currentElement);
	}
	
	var ReactReconciler = {
	
	  /**
	   * Initializes the component, renders markup, and registers event listeners.
	   *
	   * @param {ReactComponent} internalInstance
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {?object} the containing host component instance
	   * @param {?object} info about the host container
	   * @return {?string} Rendered markup to be inserted into the DOM.
	   * @final
	   * @internal
	   */
	  mountComponent: function (internalInstance, transaction, hostParent, hostContainerInfo, context, parentDebugID // 0 in production and for roots
	  ) {
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onBeforeMountComponent(internalInstance._debugID, internalInstance._currentElement, parentDebugID);
	      }
	    }
	    var markup = internalInstance.mountComponent(transaction, hostParent, hostContainerInfo, context, parentDebugID);
	    if (internalInstance._currentElement && internalInstance._currentElement.ref != null) {
	      transaction.getReactMountReady().enqueue(attachRefs, internalInstance);
	    }
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onMountComponent(internalInstance._debugID);
	      }
	    }
	    return markup;
	  },
	
	  /**
	   * Returns a value that can be passed to
	   * ReactComponentEnvironment.replaceNodeWithMarkup.
	   */
	  getHostNode: function (internalInstance) {
	    return internalInstance.getHostNode();
	  },
	
	  /**
	   * Releases any resources allocated by `mountComponent`.
	   *
	   * @final
	   * @internal
	   */
	  unmountComponent: function (internalInstance, safely) {
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onBeforeUnmountComponent(internalInstance._debugID);
	      }
	    }
	    ReactRef.detachRefs(internalInstance, internalInstance._currentElement);
	    internalInstance.unmountComponent(safely);
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onUnmountComponent(internalInstance._debugID);
	      }
	    }
	  },
	
	  /**
	   * Update a component using a new element.
	   *
	   * @param {ReactComponent} internalInstance
	   * @param {ReactElement} nextElement
	   * @param {ReactReconcileTransaction} transaction
	   * @param {object} context
	   * @internal
	   */
	  receiveComponent: function (internalInstance, nextElement, transaction, context) {
	    var prevElement = internalInstance._currentElement;
	
	    if (nextElement === prevElement && context === internalInstance._context) {
	      // Since elements are immutable after the owner is rendered,
	      // we can do a cheap identity compare here to determine if this is a
	      // superfluous reconcile. It's possible for state to be mutable but such
	      // change should trigger an update of the owner which would recreate
	      // the element. We explicitly check for the existence of an owner since
	      // it's possible for an element created outside a composite to be
	      // deeply mutated and reused.
	
	      // TODO: Bailing out early is just a perf optimization right?
	      // TODO: Removing the return statement should affect correctness?
	      return;
	    }
	
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onBeforeUpdateComponent(internalInstance._debugID, nextElement);
	      }
	    }
	
	    var refsChanged = ReactRef.shouldUpdateRefs(prevElement, nextElement);
	
	    if (refsChanged) {
	      ReactRef.detachRefs(internalInstance, prevElement);
	    }
	
	    internalInstance.receiveComponent(nextElement, transaction, context);
	
	    if (refsChanged && internalInstance._currentElement && internalInstance._currentElement.ref != null) {
	      transaction.getReactMountReady().enqueue(attachRefs, internalInstance);
	    }
	
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onUpdateComponent(internalInstance._debugID);
	      }
	    }
	  },
	
	  /**
	   * Flush any dirty changes in a component.
	   *
	   * @param {ReactComponent} internalInstance
	   * @param {ReactReconcileTransaction} transaction
	   * @internal
	   */
	  performUpdateIfNecessary: function (internalInstance, transaction, updateBatchNumber) {
	    if (internalInstance._updateBatchNumber !== updateBatchNumber) {
	      // The component's enqueued batch number should always be the current
	      // batch or the following one.
	       false ? warning(internalInstance._updateBatchNumber == null || internalInstance._updateBatchNumber === updateBatchNumber + 1, 'performUpdateIfNecessary: Unexpected batch number (current %s, ' + 'pending %s)', updateBatchNumber, internalInstance._updateBatchNumber) : void 0;
	      return;
	    }
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onBeforeUpdateComponent(internalInstance._debugID, internalInstance._currentElement);
	      }
	    }
	    internalInstance.performUpdateIfNecessary(transaction);
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onUpdateComponent(internalInstance._debugID);
	      }
	    }
	  }
	
	};
	
	module.exports = ReactReconciler;

/***/ },
/* 29 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj; };
	
	var _propertyUtils = __webpack_require__(143);
	
	var RE_NUM = /[\-+]?(?:\d*\.|)\d+(?:[eE][\-+]?\d+|)/.source;
	
	var getComputedStyleX = void 0;
	
	function force(x, y) {
	  return x + y;
	}
	
	function css(el, name, v) {
	  var value = v;
	  if ((typeof name === 'undefined' ? 'undefined' : _typeof(name)) === 'object') {
	    for (var i in name) {
	      if (name.hasOwnProperty(i)) {
	        css(el, i, name[i]);
	      }
	    }
	    return undefined;
	  }
	  if (typeof value !== 'undefined') {
	    if (typeof value === 'number') {
	      value = value + 'px';
	    }
	    el.style[name] = value;
	    return undefined;
	  }
	  return getComputedStyleX(el, name);
	}
	
	function getClientPosition(elem) {
	  var box = void 0;
	  var x = void 0;
	  var y = void 0;
	  var doc = elem.ownerDocument;
	  var body = doc.body;
	  var docElem = doc && doc.documentElement;
	  // 根据 GBS 最新数据，A-Grade Browsers 都已支持 getBoundingClientRect 方法，不用再考虑传统的实现方式
	  box = elem.getBoundingClientRect();
	
	  // 注：jQuery 还考虑减去 docElem.clientLeft/clientTop
	  // 但测试发现，这样反而会导致当 html 和 body 有边距/边框样式时，获取的值不正确
	  // 此外，ie6 会忽略 html 的 margin 值，幸运地是没有谁会去设置 html 的 margin
	
	  x = box.left;
	  y = box.top;
	
	  // In IE, most of the time, 2 extra pixels are added to the top and left
	  // due to the implicit 2-pixel inset border.  In IE6/7 quirks mode and
	  // IE6 standards mode, this border can be overridden by setting the
	  // document element's border to zero -- thus, we cannot rely on the
	  // offset always being 2 pixels.
	
	  // In quirks mode, the offset can be determined by querying the body's
	  // clientLeft/clientTop, but in standards mode, it is found by querying
	  // the document element's clientLeft/clientTop.  Since we already called
	  // getClientBoundingRect we have already forced a reflow, so it is not
	  // too expensive just to query them all.
	
	  // ie 下应该减去窗口的边框吧，毕竟默认 absolute 都是相对窗口定位的
	  // 窗口边框标准是设 documentElement ,quirks 时设置 body
	  // 最好禁止在 body 和 html 上边框 ，但 ie < 9 html 默认有 2px ，减去
	  // 但是非 ie 不可能设置窗口边框，body html 也不是窗口 ,ie 可以通过 html,body 设置
	  // 标准 ie 下 docElem.clientTop 就是 border-top
	  // ie7 html 即窗口边框改变不了。永远为 2
	  // 但标准 firefox/chrome/ie9 下 docElem.clientTop 是窗口边框，即使设了 border-top 也为 0
	
	  x -= docElem.clientLeft || body.clientLeft || 0;
	  y -= docElem.clientTop || body.clientTop || 0;
	
	  return {
	    left: x,
	    top: y
	  };
	}
	
	function getScroll(w, top) {
	  var ret = w['page' + (top ? 'Y' : 'X') + 'Offset'];
	  var method = 'scroll' + (top ? 'Top' : 'Left');
	  if (typeof ret !== 'number') {
	    var d = w.document;
	    // ie6,7,8 standard mode
	    ret = d.documentElement[method];
	    if (typeof ret !== 'number') {
	      // quirks mode
	      ret = d.body[method];
	    }
	  }
	  return ret;
	}
	
	function getScrollLeft(w) {
	  return getScroll(w);
	}
	
	function getScrollTop(w) {
	  return getScroll(w, true);
	}
	
	function getOffset(el) {
	  var pos = getClientPosition(el);
	  var doc = el.ownerDocument;
	  var w = doc.defaultView || doc.parentWindow;
	  pos.left += getScrollLeft(w);
	  pos.top += getScrollTop(w);
	  return pos;
	}
	function _getComputedStyle(elem, name, cs) {
	  var computedStyle = cs;
	  var val = '';
	  var d = elem.ownerDocument;
	  computedStyle = computedStyle || d.defaultView.getComputedStyle(elem, null);
	
	  // https://github.com/kissyteam/kissy/issues/61
	  if (computedStyle) {
	    val = computedStyle.getPropertyValue(name) || computedStyle[name];
	  }
	
	  return val;
	}
	
	var _RE_NUM_NO_PX = new RegExp('^(' + RE_NUM + ')(?!px)[a-z%]+$', 'i');
	var RE_POS = /^(top|right|bottom|left)$/;
	var CURRENT_STYLE = 'currentStyle';
	var RUNTIME_STYLE = 'runtimeStyle';
	var LEFT = 'left';
	var PX = 'px';
	
	function _getComputedStyleIE(elem, name) {
	  // currentStyle maybe null
	  // http://msdn.microsoft.com/en-us/library/ms535231.aspx
	  var ret = elem[CURRENT_STYLE] && elem[CURRENT_STYLE][name];
	
	  // 当 width/height 设置为百分比时，通过 pixelLeft 方式转换的 width/height 值
	  // 一开始就处理了! CUSTOM_STYLE.height,CUSTOM_STYLE.width ,cssHook 解决@2011-08-19
	  // 在 ie 下不对，需要直接用 offset 方式
	  // borderWidth 等值也有问题，但考虑到 borderWidth 设为百分比的概率很小，这里就不考虑了
	
	  // From the awesome hack by Dean Edwards
	  // http://erik.eae.net/archives/2007/07/27/18.54.15/#comment-102291
	  // If we're not dealing with a regular pixel number
	  // but a number that has a weird ending, we need to convert it to pixels
	  // exclude left right for relativity
	  if (_RE_NUM_NO_PX.test(ret) && !RE_POS.test(name)) {
	    // Remember the original values
	    var style = elem.style;
	    var left = style[LEFT];
	    var rsLeft = elem[RUNTIME_STYLE][LEFT];
	
	    // prevent flashing of content
	    elem[RUNTIME_STYLE][LEFT] = elem[CURRENT_STYLE][LEFT];
	
	    // Put in the new values to get a computed value out
	    style[LEFT] = name === 'fontSize' ? '1em' : ret || 0;
	    ret = style.pixelLeft + PX;
	
	    // Revert the changed values
	    style[LEFT] = left;
	
	    elem[RUNTIME_STYLE][LEFT] = rsLeft;
	  }
	  return ret === '' ? 'auto' : ret;
	}
	
	if (typeof window !== 'undefined') {
	  getComputedStyleX = window.getComputedStyle ? _getComputedStyle : _getComputedStyleIE;
	}
	
	function getOffsetDirection(dir, option) {
	  if (dir === 'left') {
	    return option.useCssRight ? 'right' : dir;
	  }
	  return option.useCssBottom ? 'bottom' : dir;
	}
	
	function oppositeOffsetDirection(dir) {
	  if (dir === 'left') {
	    return 'right';
	  } else if (dir === 'right') {
	    return 'left';
	  } else if (dir === 'top') {
	    return 'bottom';
	  } else if (dir === 'bottom') {
	    return 'top';
	  }
	}
	
	// 设置 elem 相对 elem.ownerDocument 的坐标
	function setLeftTop(elem, offset, option) {
	  // set position first, in-case top/left are set even on static elem
	  if (css(elem, 'position') === 'static') {
	    elem.style.position = 'relative';
	  }
	  var presetH = -999;
	  var presetV = -999;
	  var horizontalProperty = getOffsetDirection('left', option);
	  var verticalProperty = getOffsetDirection('top', option);
	  var oppositeHorizontalProperty = oppositeOffsetDirection(horizontalProperty);
	  var oppositeVerticalProperty = oppositeOffsetDirection(verticalProperty);
	
	  if (horizontalProperty !== 'left') {
	    presetH = 999;
	  }
	
	  if (verticalProperty !== 'top') {
	    presetV = 999;
	  }
	  var originalTransition = '';
	  var originalOffset = getOffset(elem);
	  if ('left' in offset || 'top' in offset) {
	    originalTransition = (0, _propertyUtils.getTransitionProperty)(elem) || '';
	    (0, _propertyUtils.setTransitionProperty)(elem, 'none');
	  }
	  if ('left' in offset) {
	    elem.style[oppositeHorizontalProperty] = '';
	    elem.style[horizontalProperty] = presetH + 'px';
	  }
	  if ('top' in offset) {
	    elem.style[oppositeVerticalProperty] = '';
	    elem.style[verticalProperty] = presetV + 'px';
	  }
	  var old = getOffset(elem);
	  var originalStyle = {};
	  for (var key in offset) {
	    if (offset.hasOwnProperty(key)) {
	      var dir = getOffsetDirection(key, option);
	      var preset = key === 'left' ? presetH : presetV;
	      var off = originalOffset[key] - old[key];
	      if (dir === key) {
	        originalStyle[dir] = preset + off;
	      } else {
	        originalStyle[dir] = preset - off;
	      }
	    }
	  }
	  css(elem, originalStyle);
	  // force relayout
	  force(elem.offsetTop, elem.offsetLeft);
	  if ('left' in offset || 'top' in offset) {
	    (0, _propertyUtils.setTransitionProperty)(elem, originalTransition);
	  }
	  var ret = {};
	  for (var _key in offset) {
	    if (offset.hasOwnProperty(_key)) {
	      var _dir = getOffsetDirection(_key, option);
	      var _off = offset[_key] - originalOffset[_key];
	      if (_key === _dir) {
	        ret[_dir] = originalStyle[_dir] + _off;
	      } else {
	        ret[_dir] = originalStyle[_dir] - _off;
	      }
	    }
	  }
	  css(elem, ret);
	}
	
	function setTransform(elem, offset) {
	  var originalOffset = getOffset(elem);
	  var originalXY = (0, _propertyUtils.getTransformXY)(elem);
	  var resultXY = { x: originalXY.x, y: originalXY.y };
	  if ('left' in offset) {
	    resultXY.x = originalXY.x + offset.left - originalOffset.left;
	  }
	  if ('top' in offset) {
	    resultXY.y = originalXY.y + offset.top - originalOffset.top;
	  }
	  (0, _propertyUtils.setTransformXY)(elem, resultXY);
	}
	
	function setOffset(elem, offset, option) {
	  if (option.useCssRight || option.useCssBottom) {
	    setLeftTop(elem, offset, option);
	  } else if (option.useCssTransform && (0, _propertyUtils.getTransformName)() in document.body.style) {
	    setTransform(elem, offset, option);
	  } else {
	    setLeftTop(elem, offset, option);
	  }
	}
	
	function each(arr, fn) {
	  for (var i = 0; i < arr.length; i++) {
	    fn(arr[i]);
	  }
	}
	
	function isBorderBoxFn(elem) {
	  return getComputedStyleX(elem, 'boxSizing') === 'border-box';
	}
	
	var BOX_MODELS = ['margin', 'border', 'padding'];
	var CONTENT_INDEX = -1;
	var PADDING_INDEX = 2;
	var BORDER_INDEX = 1;
	var MARGIN_INDEX = 0;
	
	function swap(elem, options, callback) {
	  var old = {};
	  var style = elem.style;
	  var name = void 0;
	
	  // Remember the old values, and insert the new ones
	  for (name in options) {
	    if (options.hasOwnProperty(name)) {
	      old[name] = style[name];
	      style[name] = options[name];
	    }
	  }
	
	  callback.call(elem);
	
	  // Revert the old values
	  for (name in options) {
	    if (options.hasOwnProperty(name)) {
	      style[name] = old[name];
	    }
	  }
	}
	
	function getPBMWidth(elem, props, which) {
	  var value = 0;
	  var prop = void 0;
	  var j = void 0;
	  var i = void 0;
	  for (j = 0; j < props.length; j++) {
	    prop = props[j];
	    if (prop) {
	      for (i = 0; i < which.length; i++) {
	        var cssProp = void 0;
	        if (prop === 'border') {
	          cssProp = '' + prop + which[i] + 'Width';
	        } else {
	          cssProp = prop + which[i];
	        }
	        value += parseFloat(getComputedStyleX(elem, cssProp)) || 0;
	      }
	    }
	  }
	  return value;
	}
	
	/**
	 * A crude way of determining if an object is a window
	 * @member util
	 */
	function isWindow(obj) {
	  // must use == for ie8
	  /* eslint eqeqeq:0 */
	  return obj !== null && obj !== undefined && obj == obj.window;
	}
	
	var domUtils = {};
	
	each(['Width', 'Height'], function (name) {
	  domUtils['doc' + name] = function (refWin) {
	    var d = refWin.document;
	    return Math.max(
	    // firefox chrome documentElement.scrollHeight< body.scrollHeight
	    // ie standard mode : documentElement.scrollHeight> body.scrollHeight
	    d.documentElement['scroll' + name],
	    // quirks : documentElement.scrollHeight 最大等于可视窗口多一点？
	    d.body['scroll' + name], domUtils['viewport' + name](d));
	  };
	
	  domUtils['viewport' + name] = function (win) {
	    // pc browser includes scrollbar in window.innerWidth
	    var prop = 'client' + name;
	    var doc = win.document;
	    var body = doc.body;
	    var documentElement = doc.documentElement;
	    var documentElementProp = documentElement[prop];
	    // 标准模式取 documentElement
	    // backcompat 取 body
	    return doc.compatMode === 'CSS1Compat' && documentElementProp || body && body[prop] || documentElementProp;
	  };
	});
	
	/*
	 得到元素的大小信息
	 @param elem
	 @param name
	 @param {String} [extra]  'padding' : (css width) + padding
	 'border' : (css width) + padding + border
	 'margin' : (css width) + padding + border + margin
	 */
	function getWH(elem, name, ex) {
	  var extra = ex;
	  if (isWindow(elem)) {
	    return name === 'width' ? domUtils.viewportWidth(elem) : domUtils.viewportHeight(elem);
	  } else if (elem.nodeType === 9) {
	    return name === 'width' ? domUtils.docWidth(elem) : domUtils.docHeight(elem);
	  }
	  var which = name === 'width' ? ['Left', 'Right'] : ['Top', 'Bottom'];
	  var borderBoxValue = name === 'width' ? elem.offsetWidth : elem.offsetHeight;
	  var computedStyle = getComputedStyleX(elem);
	  var isBorderBox = isBorderBoxFn(elem, computedStyle);
	  var cssBoxValue = 0;
	  if (borderBoxValue === null || borderBoxValue === undefined || borderBoxValue <= 0) {
	    borderBoxValue = undefined;
	    // Fall back to computed then un computed css if necessary
	    cssBoxValue = getComputedStyleX(elem, name);
	    if (cssBoxValue === null || cssBoxValue === undefined || Number(cssBoxValue) < 0) {
	      cssBoxValue = elem.style[name] || 0;
	    }
	    // Normalize '', auto, and prepare for extra
	    cssBoxValue = parseFloat(cssBoxValue) || 0;
	  }
	  if (extra === undefined) {
	    extra = isBorderBox ? BORDER_INDEX : CONTENT_INDEX;
	  }
	  var borderBoxValueOrIsBorderBox = borderBoxValue !== undefined || isBorderBox;
	  var val = borderBoxValue || cssBoxValue;
	  if (extra === CONTENT_INDEX) {
	    if (borderBoxValueOrIsBorderBox) {
	      return val - getPBMWidth(elem, ['border', 'padding'], which, computedStyle);
	    }
	    return cssBoxValue;
	  } else if (borderBoxValueOrIsBorderBox) {
	    if (extra === BORDER_INDEX) {
	      return val;
	    }
	    return val + (extra === PADDING_INDEX ? -getPBMWidth(elem, ['border'], which, computedStyle) : getPBMWidth(elem, ['margin'], which, computedStyle));
	  }
	  return cssBoxValue + getPBMWidth(elem, BOX_MODELS.slice(extra), which, computedStyle);
	}
	
	var cssShow = {
	  position: 'absolute',
	  visibility: 'hidden',
	  display: 'block'
	};
	
	// fix #119 : https://github.com/kissyteam/kissy/issues/119
	function getWHIgnoreDisplay() {
	  for (var _len = arguments.length, args = Array(_len), _key2 = 0; _key2 < _len; _key2++) {
	    args[_key2] = arguments[_key2];
	  }
	
	  var val = void 0;
	  var elem = args[0];
	  // in case elem is window
	  // elem.offsetWidth === undefined
	  if (elem.offsetWidth !== 0) {
	    val = getWH.apply(undefined, args);
	  } else {
	    swap(elem, cssShow, function () {
	      val = getWH.apply(undefined, args);
	    });
	  }
	  return val;
	}
	
	each(['width', 'height'], function (name) {
	  var first = name.charAt(0).toUpperCase() + name.slice(1);
	  domUtils['outer' + first] = function (el, includeMargin) {
	    return el && getWHIgnoreDisplay(el, name, includeMargin ? MARGIN_INDEX : BORDER_INDEX);
	  };
	  var which = name === 'width' ? ['Left', 'Right'] : ['Top', 'Bottom'];
	
	  domUtils[name] = function (elem, v) {
	    var val = v;
	    if (val !== undefined) {
	      if (elem) {
	        var computedStyle = getComputedStyleX(elem);
	        var isBorderBox = isBorderBoxFn(elem);
	        if (isBorderBox) {
	          val += getPBMWidth(elem, ['padding', 'border'], which, computedStyle);
	        }
	        return css(elem, name, val);
	      }
	      return undefined;
	    }
	    return elem && getWHIgnoreDisplay(elem, name, CONTENT_INDEX);
	  };
	});
	
	function mix(to, from) {
	  for (var i in from) {
	    if (from.hasOwnProperty(i)) {
	      to[i] = from[i];
	    }
	  }
	  return to;
	}
	
	var utils = {
	  getWindow: function getWindow(node) {
	    if (node && node.document && node.setTimeout) {
	      return node;
	    }
	    var doc = node.ownerDocument || node;
	    return doc.defaultView || doc.parentWindow;
	  },
	  offset: function offset(el, value, option) {
	    if (typeof value !== 'undefined') {
	      setOffset(el, value, option || {});
	    } else {
	      return getOffset(el);
	    }
	  },
	
	  isWindow: isWindow,
	  each: each,
	  css: css,
	  clone: function clone(obj) {
	    var i = void 0;
	    var ret = {};
	    for (i in obj) {
	      if (obj.hasOwnProperty(i)) {
	        ret[i] = obj[i];
	      }
	    }
	    var overflow = obj.overflow;
	    if (overflow) {
	      for (i in obj) {
	        if (obj.hasOwnProperty(i)) {
	          ret.overflow[i] = obj.overflow[i];
	        }
	      }
	    }
	    return ret;
	  },
	
	  mix: mix,
	  getWindowScrollLeft: function getWindowScrollLeft(w) {
	    return getScrollLeft(w);
	  },
	  getWindowScrollTop: function getWindowScrollTop(w) {
	    return getScrollTop(w);
	  },
	  merge: function merge() {
	    var ret = {};
	
	    for (var _len2 = arguments.length, args = Array(_len2), _key3 = 0; _key3 < _len2; _key3++) {
	      args[_key3] = arguments[_key3];
	    }
	
	    for (var i = 0; i < args.length; i++) {
	      utils.mix(ret, args[i]);
	    }
	    return ret;
	  },
	
	  viewportWidth: 0,
	  viewportHeight: 0
	};
	
	mix(utils, domUtils);
	
	exports["default"] = utils;
	module.exports = exports['default'];

/***/ },
/* 30 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var emptyObject = {};
	
	if (false) {
	  Object.freeze(emptyObject);
	}
	
	module.exports = emptyObject;

/***/ },
/* 31 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.connect = exports.Provider = undefined;
	
	var _Provider = __webpack_require__(196);
	
	var _Provider2 = _interopRequireDefault(_Provider);
	
	var _connect = __webpack_require__(197);
	
	var _connect2 = _interopRequireDefault(_connect);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	exports.Provider = _Provider2["default"];
	exports.connect = _connect2["default"];

/***/ },
/* 32 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var InspectorCard = _react2.default.createClass({
	  displayName: 'InspectorCard',
	
	
	  getInitialState: function getInitialState() {
	    return {
	      open: this.props.open,
	      disabled: this.props.disabled,
	      buttonSelected: false
	    };
	  },
	
	  render: function render() {
	    var classNames = 'abl-inspector-card ' + (this.props.className || '');
	
	    if (this.state.open) {
	      classNames += ' abl-open';
	    }
	
	    return _react2.default.createElement(
	      'div',
	      { className: classNames },
	      _react2.default.createElement(
	        'div',
	        { className: 'abl-menubar', onClick: this.handleClick },
	        _react2.default.createElement(
	          'div',
	          { className: 'abl-menubar-label' },
	          this.props.header
	        ),
	        _react2.default.createElement('div', { className: 'abl-menubar-icon' })
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'abl-card-body' },
	        _react2.default.createElement(
	          'div',
	          { className: 'abl-card-content' },
	          this.props.children
	        )
	      )
	    );
	  },
	
	  handleButtonSelect: function handleButtonSelect(id, element, data, selected) {
	    if (!this.state.disabled) {
	      this.setState({ buttonSelected: selected });
	      if (this.props.onMenubarButtonSelect) {
	        this.props.onMenubarButtonSelect(id, element, data, selected);
	      }
	    }
	  },
	
	  handleClick: function handleClick() {
	    if (!this.state.disabled) {
	      this.setState({ open: !this.state.open });
	    }
	  }
	
	});
	
	exports.default = InspectorCard;

/***/ },
/* 33 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _entities_selector = __webpack_require__(17);
	
	var _entities_selector2 = _interopRequireDefault(_entities_selector);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var teachersSelector = (0, _entities_selector2.default)(function (state) {
	  return state.teachers;
	}, function (teacher, localState, associations) {
	  var displayName = void 0;
	  var initials = void 0;
	  if (teacher.first_name && teacher.last_name) {
	    displayName = teacher.first_name.substr(0, 1) + '. ' + teacher.last_name;
	    initials = '' + teacher.first_name.substr(0, 1) + teacher.last_name.substr(0, 1);
	  } else {
	    displayName = teacher.name;
	  }
	
	  return {
	    displayName: displayName,
	    initials: initials
	  };
	});
	
	exports.default = teachersSelector;

/***/ },
/* 34 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule EventPluginHub
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(3);
	
	var EventPluginRegistry = __webpack_require__(54);
	var EventPluginUtils = __webpack_require__(55);
	var ReactErrorUtils = __webpack_require__(61);
	
	var accumulateInto = __webpack_require__(119);
	var forEachAccumulated = __webpack_require__(121);
	var invariant = __webpack_require__(2);
	
	/**
	 * Internal store for event listeners
	 */
	var listenerBank = {};
	
	/**
	 * Internal queue of events that have accumulated their dispatches and are
	 * waiting to have their dispatches executed.
	 */
	var eventQueue = null;
	
	/**
	 * Dispatches an event and releases it back into the pool, unless persistent.
	 *
	 * @param {?object} event Synthetic event to be dispatched.
	 * @param {boolean} simulated If the event is simulated (changes exn behavior)
	 * @private
	 */
	var executeDispatchesAndRelease = function (event, simulated) {
	  if (event) {
	    EventPluginUtils.executeDispatchesInOrder(event, simulated);
	
	    if (!event.isPersistent()) {
	      event.constructor.release(event);
	    }
	  }
	};
	var executeDispatchesAndReleaseSimulated = function (e) {
	  return executeDispatchesAndRelease(e, true);
	};
	var executeDispatchesAndReleaseTopLevel = function (e) {
	  return executeDispatchesAndRelease(e, false);
	};
	
	var getDictionaryKey = function (inst) {
	  // Prevents V8 performance issue:
	  // https://github.com/facebook/react/pull/7232
	  return '.' + inst._rootNodeID;
	};
	
	/**
	 * This is a unified interface for event plugins to be installed and configured.
	 *
	 * Event plugins can implement the following properties:
	 *
	 *   `extractEvents` {function(string, DOMEventTarget, string, object): *}
	 *     Required. When a top-level event is fired, this method is expected to
	 *     extract synthetic events that will in turn be queued and dispatched.
	 *
	 *   `eventTypes` {object}
	 *     Optional, plugins that fire events must publish a mapping of registration
	 *     names that are used to register listeners. Values of this mapping must
	 *     be objects that contain `registrationName` or `phasedRegistrationNames`.
	 *
	 *   `executeDispatch` {function(object, function, string)}
	 *     Optional, allows plugins to override how an event gets dispatched. By
	 *     default, the listener is simply invoked.
	 *
	 * Each plugin that is injected into `EventsPluginHub` is immediately operable.
	 *
	 * @public
	 */
	var EventPluginHub = {
	
	  /**
	   * Methods for injecting dependencies.
	   */
	  injection: {
	
	    /**
	     * @param {array} InjectedEventPluginOrder
	     * @public
	     */
	    injectEventPluginOrder: EventPluginRegistry.injectEventPluginOrder,
	
	    /**
	     * @param {object} injectedNamesToPlugins Map from names to plugin modules.
	     */
	    injectEventPluginsByName: EventPluginRegistry.injectEventPluginsByName
	
	  },
	
	  /**
	   * Stores `listener` at `listenerBank[registrationName][key]`. Is idempotent.
	   *
	   * @param {object} inst The instance, which is the source of events.
	   * @param {string} registrationName Name of listener (e.g. `onClick`).
	   * @param {function} listener The callback to store.
	   */
	  putListener: function (inst, registrationName, listener) {
	    !(typeof listener === 'function') ?  false ? invariant(false, 'Expected %s listener to be a function, instead got type %s', registrationName, typeof listener) : _prodInvariant('94', registrationName, typeof listener) : void 0;
	
	    var key = getDictionaryKey(inst);
	    var bankForRegistrationName = listenerBank[registrationName] || (listenerBank[registrationName] = {});
	    bankForRegistrationName[key] = listener;
	
	    var PluginModule = EventPluginRegistry.registrationNameModules[registrationName];
	    if (PluginModule && PluginModule.didPutListener) {
	      PluginModule.didPutListener(inst, registrationName, listener);
	    }
	  },
	
	  /**
	   * @param {object} inst The instance, which is the source of events.
	   * @param {string} registrationName Name of listener (e.g. `onClick`).
	   * @return {?function} The stored callback.
	   */
	  getListener: function (inst, registrationName) {
	    var bankForRegistrationName = listenerBank[registrationName];
	    var key = getDictionaryKey(inst);
	    return bankForRegistrationName && bankForRegistrationName[key];
	  },
	
	  /**
	   * Deletes a listener from the registration bank.
	   *
	   * @param {object} inst The instance, which is the source of events.
	   * @param {string} registrationName Name of listener (e.g. `onClick`).
	   */
	  deleteListener: function (inst, registrationName) {
	    var PluginModule = EventPluginRegistry.registrationNameModules[registrationName];
	    if (PluginModule && PluginModule.willDeleteListener) {
	      PluginModule.willDeleteListener(inst, registrationName);
	    }
	
	    var bankForRegistrationName = listenerBank[registrationName];
	    // TODO: This should never be null -- when is it?
	    if (bankForRegistrationName) {
	      var key = getDictionaryKey(inst);
	      delete bankForRegistrationName[key];
	    }
	  },
	
	  /**
	   * Deletes all listeners for the DOM element with the supplied ID.
	   *
	   * @param {object} inst The instance, which is the source of events.
	   */
	  deleteAllListeners: function (inst) {
	    var key = getDictionaryKey(inst);
	    for (var registrationName in listenerBank) {
	      if (!listenerBank.hasOwnProperty(registrationName)) {
	        continue;
	      }
	
	      if (!listenerBank[registrationName][key]) {
	        continue;
	      }
	
	      var PluginModule = EventPluginRegistry.registrationNameModules[registrationName];
	      if (PluginModule && PluginModule.willDeleteListener) {
	        PluginModule.willDeleteListener(inst, registrationName);
	      }
	
	      delete listenerBank[registrationName][key];
	    }
	  },
	
	  /**
	   * Allows registered plugins an opportunity to extract events from top-level
	   * native browser events.
	   *
	   * @return {*} An accumulation of synthetic events.
	   * @internal
	   */
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    var events;
	    var plugins = EventPluginRegistry.plugins;
	    for (var i = 0; i < plugins.length; i++) {
	      // Not every plugin in the ordering may be loaded at runtime.
	      var possiblePlugin = plugins[i];
	      if (possiblePlugin) {
	        var extractedEvents = possiblePlugin.extractEvents(topLevelType, targetInst, nativeEvent, nativeEventTarget);
	        if (extractedEvents) {
	          events = accumulateInto(events, extractedEvents);
	        }
	      }
	    }
	    return events;
	  },
	
	  /**
	   * Enqueues a synthetic event that should be dispatched when
	   * `processEventQueue` is invoked.
	   *
	   * @param {*} events An accumulation of synthetic events.
	   * @internal
	   */
	  enqueueEvents: function (events) {
	    if (events) {
	      eventQueue = accumulateInto(eventQueue, events);
	    }
	  },
	
	  /**
	   * Dispatches all synthetic events on the event queue.
	   *
	   * @internal
	   */
	  processEventQueue: function (simulated) {
	    // Set `eventQueue` to null before processing it so that we can tell if more
	    // events get enqueued while processing.
	    var processingEventQueue = eventQueue;
	    eventQueue = null;
	    if (simulated) {
	      forEachAccumulated(processingEventQueue, executeDispatchesAndReleaseSimulated);
	    } else {
	      forEachAccumulated(processingEventQueue, executeDispatchesAndReleaseTopLevel);
	    }
	    !!eventQueue ?  false ? invariant(false, 'processEventQueue(): Additional events were enqueued while processing an event queue. Support for this has not yet been implemented.') : _prodInvariant('95') : void 0;
	    // This would be a good time to rethrow if any of the event handlers threw.
	    ReactErrorUtils.rethrowCaughtError();
	  },
	
	  /**
	   * These are needed for tests only. Do not use!
	   */
	  __purge: function () {
	    listenerBank = {};
	  },
	
	  __getListenerBank: function () {
	    return listenerBank;
	  }
	
	};
	
	module.exports = EventPluginHub;

/***/ },
/* 35 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule EventPropagators
	 */
	
	'use strict';
	
	var EventConstants = __webpack_require__(18);
	var EventPluginHub = __webpack_require__(34);
	var EventPluginUtils = __webpack_require__(55);
	
	var accumulateInto = __webpack_require__(119);
	var forEachAccumulated = __webpack_require__(121);
	var warning = __webpack_require__(4);
	
	var PropagationPhases = EventConstants.PropagationPhases;
	var getListener = EventPluginHub.getListener;
	
	/**
	 * Some event types have a notion of different registration names for different
	 * "phases" of propagation. This finds listeners by a given phase.
	 */
	function listenerAtPhase(inst, event, propagationPhase) {
	  var registrationName = event.dispatchConfig.phasedRegistrationNames[propagationPhase];
	  return getListener(inst, registrationName);
	}
	
	/**
	 * Tags a `SyntheticEvent` with dispatched listeners. Creating this function
	 * here, allows us to not have to bind or create functions for each event.
	 * Mutating the event's members allows us to not have to create a wrapping
	 * "dispatch" object that pairs the event with the listener.
	 */
	function accumulateDirectionalDispatches(inst, upwards, event) {
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(inst, 'Dispatching inst must not be null') : void 0;
	  }
	  var phase = upwards ? PropagationPhases.bubbled : PropagationPhases.captured;
	  var listener = listenerAtPhase(inst, event, phase);
	  if (listener) {
	    event._dispatchListeners = accumulateInto(event._dispatchListeners, listener);
	    event._dispatchInstances = accumulateInto(event._dispatchInstances, inst);
	  }
	}
	
	/**
	 * Collect dispatches (must be entirely collected before dispatching - see unit
	 * tests). Lazily allocate the array to conserve memory.  We must loop through
	 * each event and perform the traversal for each one. We cannot perform a
	 * single traversal for the entire collection of events because each event may
	 * have a different target.
	 */
	function accumulateTwoPhaseDispatchesSingle(event) {
	  if (event && event.dispatchConfig.phasedRegistrationNames) {
	    EventPluginUtils.traverseTwoPhase(event._targetInst, accumulateDirectionalDispatches, event);
	  }
	}
	
	/**
	 * Same as `accumulateTwoPhaseDispatchesSingle`, but skips over the targetID.
	 */
	function accumulateTwoPhaseDispatchesSingleSkipTarget(event) {
	  if (event && event.dispatchConfig.phasedRegistrationNames) {
	    var targetInst = event._targetInst;
	    var parentInst = targetInst ? EventPluginUtils.getParentInstance(targetInst) : null;
	    EventPluginUtils.traverseTwoPhase(parentInst, accumulateDirectionalDispatches, event);
	  }
	}
	
	/**
	 * Accumulates without regard to direction, does not look for phased
	 * registration names. Same as `accumulateDirectDispatchesSingle` but without
	 * requiring that the `dispatchMarker` be the same as the dispatched ID.
	 */
	function accumulateDispatches(inst, ignoredDirection, event) {
	  if (event && event.dispatchConfig.registrationName) {
	    var registrationName = event.dispatchConfig.registrationName;
	    var listener = getListener(inst, registrationName);
	    if (listener) {
	      event._dispatchListeners = accumulateInto(event._dispatchListeners, listener);
	      event._dispatchInstances = accumulateInto(event._dispatchInstances, inst);
	    }
	  }
	}
	
	/**
	 * Accumulates dispatches on an `SyntheticEvent`, but only for the
	 * `dispatchMarker`.
	 * @param {SyntheticEvent} event
	 */
	function accumulateDirectDispatchesSingle(event) {
	  if (event && event.dispatchConfig.registrationName) {
	    accumulateDispatches(event._targetInst, null, event);
	  }
	}
	
	function accumulateTwoPhaseDispatches(events) {
	  forEachAccumulated(events, accumulateTwoPhaseDispatchesSingle);
	}
	
	function accumulateTwoPhaseDispatchesSkipTarget(events) {
	  forEachAccumulated(events, accumulateTwoPhaseDispatchesSingleSkipTarget);
	}
	
	function accumulateEnterLeaveDispatches(leave, enter, from, to) {
	  EventPluginUtils.traverseEnterLeave(from, to, accumulateDispatches, leave, enter);
	}
	
	function accumulateDirectDispatches(events) {
	  forEachAccumulated(events, accumulateDirectDispatchesSingle);
	}
	
	/**
	 * A small set of propagation patterns, each of which will accept a small amount
	 * of information, and generate a set of "dispatch ready event objects" - which
	 * are sets of events that have already been annotated with a set of dispatched
	 * listener functions/ids. The API is designed this way to discourage these
	 * propagation strategies from actually executing the dispatches, since we
	 * always want to collect the entire set of dispatches before executing event a
	 * single one.
	 *
	 * @constructor EventPropagators
	 */
	var EventPropagators = {
	  accumulateTwoPhaseDispatches: accumulateTwoPhaseDispatches,
	  accumulateTwoPhaseDispatchesSkipTarget: accumulateTwoPhaseDispatchesSkipTarget,
	  accumulateDirectDispatches: accumulateDirectDispatches,
	  accumulateEnterLeaveDispatches: accumulateEnterLeaveDispatches
	};
	
	module.exports = EventPropagators;

/***/ },
/* 36 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactInstanceMap
	 */
	
	'use strict';
	
	/**
	 * `ReactInstanceMap` maintains a mapping from a public facing stateful
	 * instance (key) and the internal representation (value). This allows public
	 * methods to accept the user facing instance as an argument and map them back
	 * to internal methods.
	 */
	
	// TODO: Replace this with ES6: var ReactInstanceMap = new Map();
	
	var ReactInstanceMap = {
	
	  /**
	   * This API should be called `delete` but we'd have to make sure to always
	   * transform these to strings for IE support. When this transform is fully
	   * supported we can rename it.
	   */
	  remove: function (key) {
	    key._reactInternalInstance = undefined;
	  },
	
	  get: function (key) {
	    return key._reactInternalInstance;
	  },
	
	  has: function (key) {
	    return key._reactInternalInstance !== undefined;
	  },
	
	  set: function (key, value) {
	    key._reactInternalInstance = value;
	  }
	
	};
	
	module.exports = ReactInstanceMap;

/***/ },
/* 37 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule SyntheticUIEvent
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(19);
	
	var getEventTarget = __webpack_require__(70);
	
	/**
	 * @interface UIEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var UIEventInterface = {
	  view: function (event) {
	    if (event.view) {
	      return event.view;
	    }
	
	    var target = getEventTarget(event);
	    if (target.window === target) {
	      // target is a window object
	      return target;
	    }
	
	    var doc = target.ownerDocument;
	    // TODO: Figure out why `ownerDocument` is sometimes undefined in IE8.
	    if (doc) {
	      return doc.defaultView || doc.parentWindow;
	    } else {
	      return window;
	    }
	  },
	  detail: function (event) {
	    return event.detail || 0;
	  }
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticEvent}
	 */
	function SyntheticUIEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticUIEvent, UIEventInterface);
	
	module.exports = SyntheticUIEvent;

/***/ },
/* 38 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule Transaction
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(3);
	
	var invariant = __webpack_require__(2);
	
	/**
	 * `Transaction` creates a black box that is able to wrap any method such that
	 * certain invariants are maintained before and after the method is invoked
	 * (Even if an exception is thrown while invoking the wrapped method). Whoever
	 * instantiates a transaction can provide enforcers of the invariants at
	 * creation time. The `Transaction` class itself will supply one additional
	 * automatic invariant for you - the invariant that any transaction instance
	 * should not be run while it is already being run. You would typically create a
	 * single instance of a `Transaction` for reuse multiple times, that potentially
	 * is used to wrap several different methods. Wrappers are extremely simple -
	 * they only require implementing two methods.
	 *
	 * <pre>
	 *                       wrappers (injected at creation time)
	 *                                      +        +
	 *                                      |        |
	 *                    +-----------------|--------|--------------+
	 *                    |                 v        |              |
	 *                    |      +---------------+   |              |
	 *                    |   +--|    wrapper1   |---|----+         |
	 *                    |   |  +---------------+   v    |         |
	 *                    |   |          +-------------+  |         |
	 *                    |   |     +----|   wrapper2  |--------+   |
	 *                    |   |     |    +-------------+  |     |   |
	 *                    |   |     |                     |     |   |
	 *                    |   v     v                     v     v   | wrapper
	 *                    | +---+ +---+   +---------+   +---+ +---+ | invariants
	 * perform(anyMethod) | |   | |   |   |         |   |   | |   | | maintained
	 * +----------------->|-|---|-|---|-->|anyMethod|---|---|-|---|-|-------->
	 *                    | |   | |   |   |         |   |   | |   | |
	 *                    | |   | |   |   |         |   |   | |   | |
	 *                    | |   | |   |   |         |   |   | |   | |
	 *                    | +---+ +---+   +---------+   +---+ +---+ |
	 *                    |  initialize                    close    |
	 *                    +-----------------------------------------+
	 * </pre>
	 *
	 * Use cases:
	 * - Preserving the input selection ranges before/after reconciliation.
	 *   Restoring selection even in the event of an unexpected error.
	 * - Deactivating events while rearranging the DOM, preventing blurs/focuses,
	 *   while guaranteeing that afterwards, the event system is reactivated.
	 * - Flushing a queue of collected DOM mutations to the main UI thread after a
	 *   reconciliation takes place in a worker thread.
	 * - Invoking any collected `componentDidUpdate` callbacks after rendering new
	 *   content.
	 * - (Future use case): Wrapping particular flushes of the `ReactWorker` queue
	 *   to preserve the `scrollTop` (an automatic scroll aware DOM).
	 * - (Future use case): Layout calculations before and after DOM updates.
	 *
	 * Transactional plugin API:
	 * - A module that has an `initialize` method that returns any precomputation.
	 * - and a `close` method that accepts the precomputation. `close` is invoked
	 *   when the wrapped process is completed, or has failed.
	 *
	 * @param {Array<TransactionalWrapper>} transactionWrapper Wrapper modules
	 * that implement `initialize` and `close`.
	 * @return {Transaction} Single transaction for reuse in thread.
	 *
	 * @class Transaction
	 */
	var Mixin = {
	  /**
	   * Sets up this instance so that it is prepared for collecting metrics. Does
	   * so such that this setup method may be used on an instance that is already
	   * initialized, in a way that does not consume additional memory upon reuse.
	   * That can be useful if you decide to make your subclass of this mixin a
	   * "PooledClass".
	   */
	  reinitializeTransaction: function () {
	    this.transactionWrappers = this.getTransactionWrappers();
	    if (this.wrapperInitData) {
	      this.wrapperInitData.length = 0;
	    } else {
	      this.wrapperInitData = [];
	    }
	    this._isInTransaction = false;
	  },
	
	  _isInTransaction: false,
	
	  /**
	   * @abstract
	   * @return {Array<TransactionWrapper>} Array of transaction wrappers.
	   */
	  getTransactionWrappers: null,
	
	  isInTransaction: function () {
	    return !!this._isInTransaction;
	  },
	
	  /**
	   * Executes the function within a safety window. Use this for the top level
	   * methods that result in large amounts of computation/mutations that would
	   * need to be safety checked. The optional arguments helps prevent the need
	   * to bind in many cases.
	   *
	   * @param {function} method Member of scope to call.
	   * @param {Object} scope Scope to invoke from.
	   * @param {Object?=} a Argument to pass to the method.
	   * @param {Object?=} b Argument to pass to the method.
	   * @param {Object?=} c Argument to pass to the method.
	   * @param {Object?=} d Argument to pass to the method.
	   * @param {Object?=} e Argument to pass to the method.
	   * @param {Object?=} f Argument to pass to the method.
	   *
	   * @return {*} Return value from `method`.
	   */
	  perform: function (method, scope, a, b, c, d, e, f) {
	    !!this.isInTransaction() ?  false ? invariant(false, 'Transaction.perform(...): Cannot initialize a transaction when there is already an outstanding transaction.') : _prodInvariant('27') : void 0;
	    var errorThrown;
	    var ret;
	    try {
	      this._isInTransaction = true;
	      // Catching errors makes debugging more difficult, so we start with
	      // errorThrown set to true before setting it to false after calling
	      // close -- if it's still set to true in the finally block, it means
	      // one of these calls threw.
	      errorThrown = true;
	      this.initializeAll(0);
	      ret = method.call(scope, a, b, c, d, e, f);
	      errorThrown = false;
	    } finally {
	      try {
	        if (errorThrown) {
	          // If `method` throws, prefer to show that stack trace over any thrown
	          // by invoking `closeAll`.
	          try {
	            this.closeAll(0);
	          } catch (err) {}
	        } else {
	          // Since `method` didn't throw, we don't want to silence the exception
	          // here.
	          this.closeAll(0);
	        }
	      } finally {
	        this._isInTransaction = false;
	      }
	    }
	    return ret;
	  },
	
	  initializeAll: function (startIndex) {
	    var transactionWrappers = this.transactionWrappers;
	    for (var i = startIndex; i < transactionWrappers.length; i++) {
	      var wrapper = transactionWrappers[i];
	      try {
	        // Catching errors makes debugging more difficult, so we start with the
	        // OBSERVED_ERROR state before overwriting it with the real return value
	        // of initialize -- if it's still set to OBSERVED_ERROR in the finally
	        // block, it means wrapper.initialize threw.
	        this.wrapperInitData[i] = Transaction.OBSERVED_ERROR;
	        this.wrapperInitData[i] = wrapper.initialize ? wrapper.initialize.call(this) : null;
	      } finally {
	        if (this.wrapperInitData[i] === Transaction.OBSERVED_ERROR) {
	          // The initializer for wrapper i threw an error; initialize the
	          // remaining wrappers but silence any exceptions from them to ensure
	          // that the first error is the one to bubble up.
	          try {
	            this.initializeAll(i + 1);
	          } catch (err) {}
	        }
	      }
	    }
	  },
	
	  /**
	   * Invokes each of `this.transactionWrappers.close[i]` functions, passing into
	   * them the respective return values of `this.transactionWrappers.init[i]`
	   * (`close`rs that correspond to initializers that failed will not be
	   * invoked).
	   */
	  closeAll: function (startIndex) {
	    !this.isInTransaction() ?  false ? invariant(false, 'Transaction.closeAll(): Cannot close transaction when none are open.') : _prodInvariant('28') : void 0;
	    var transactionWrappers = this.transactionWrappers;
	    for (var i = startIndex; i < transactionWrappers.length; i++) {
	      var wrapper = transactionWrappers[i];
	      var initData = this.wrapperInitData[i];
	      var errorThrown;
	      try {
	        // Catching errors makes debugging more difficult, so we start with
	        // errorThrown set to true before setting it to false after calling
	        // close -- if it's still set to true in the finally block, it means
	        // wrapper.close threw.
	        errorThrown = true;
	        if (initData !== Transaction.OBSERVED_ERROR && wrapper.close) {
	          wrapper.close.call(this, initData);
	        }
	        errorThrown = false;
	      } finally {
	        if (errorThrown) {
	          // The closer for wrapper i threw an error; close the remaining
	          // wrappers but silence any exceptions from them to ensure that the
	          // first error is the one to bubble up.
	          try {
	            this.closeAll(i + 1);
	          } catch (e) {}
	        }
	      }
	    }
	    this.wrapperInitData.length = 0;
	  }
	};
	
	var Transaction = {
	
	  Mixin: Mixin,
	
	  /**
	   * Token to look for to determine if an error occurred.
	   */
	  OBSERVED_ERROR: {}
	
	};
	
	module.exports = Transaction;

/***/ },
/* 39 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var invariant = __webpack_require__(2);
	
	/**
	 * Constructs an enumeration with keys equal to their value.
	 *
	 * For example:
	 *
	 *   var COLORS = keyMirror({blue: null, red: null});
	 *   var myColor = COLORS.blue;
	 *   var isColorValid = !!COLORS[myColor];
	 *
	 * The last line could not be performed if the values of the generated enum were
	 * not equal to their keys.
	 *
	 *   Input:  {key1: val1, key2: val2}
	 *   Output: {key1: key1, key2: key2}
	 *
	 * @param {object} obj
	 * @return {object}
	 */
	var keyMirror = function keyMirror(obj) {
	  var ret = {};
	  var key;
	  !(obj instanceof Object && !Array.isArray(obj)) ?  false ? invariant(false, 'keyMirror(...): Argument must be an object.') : invariant(false) : void 0;
	  for (key in obj) {
	    if (!obj.hasOwnProperty(key)) {
	      continue;
	    }
	    ret[key] = key;
	  }
	  return ret;
	};
	
	module.exports = keyMirror;

/***/ },
/* 40 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _underscore = __webpack_require__(7);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _selectable = __webpack_require__(25);
	
	var _selectable2 = _interopRequireDefault(_selectable);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SelectableList = _react2.default.createClass({
	  displayName: 'SelectableList',
	
	
	  propTypes: {
	    tagName: _react2.default.PropTypes.string.isRequired,
	    className: _react2.default.PropTypes.string,
	    selectedClass: _react2.default.PropTypes.oneOfType([_react2.default.PropTypes.string, _react2.default.PropTypes.func]).isRequired,
	    itemTemplate: _react2.default.PropTypes.func.isRequired,
	    items: _react2.default.PropTypes.array.isRequired,
	    multiSelect: _react2.default.PropTypes.bool,
	    toggleSelect: _react2.default.PropTypes.bool,
	    onChange: _react2.default.PropTypes.func
	  },
	
	  getInitialState: function getInitialState() {
	    var lastSelected = void 0;
	    var selectedItems = {};
	    if (!this.props.toggleSelect && !this.props.multiSelect && this.props.items.length > 0) {
	
	      lastSelected = {
	        data: _underscore2.default.find(this.props.items, { selected: true }) || this.props.items[0],
	        selected: true
	      };
	      selectedItems[lastSelected.data.id] = true;
	    }
	    return {
	      lastSelected: lastSelected,
	      selectedItems: selectedItems
	    };
	  },
	
	  componentWillReceiveProps: function componentWillReceiveProps(props) {
	    var _this = this;
	
	    var hasChanges = _underscore2.default.some(props.items, function (item) {
	      return _this.state.selectedItems[item.id];
	    });
	    var selectedItems = void 0;
	
	    if (hasChanges) {
	      selectedItems = props.items.reduce(function (items, item) {
	        if (item.selected === true) {
	          items[item.id] = true;
	        }
	        return items;
	      }, {});
	      this.setState({ lastSelected: null, selectedItems: selectedItems });
	    }
	  },
	
	  render: function render() {
	    var items = this._renderItems(this.props.items);
	    return _react2.default.createElement(
	      this.props.tagName,
	      { className: this.props.className },
	      items
	    );
	  },
	
	  handleItemClick: function handleItemClick(selectable, data, selected) {
	    if (this.props.multiSelect) {
	      this._handleMultiSelectClick(selectable, data, selected);
	    } else {
	      this._handleSelectClick(selectable, data);
	    }
	  },
	
	  _handleMultiSelectClick: function _handleMultiSelectClick(selectable, data, selected) {
	    selected = selectable.toggleSelect();
	    this._updateState(data, selected);
	  },
	
	  _handleSelectClick: function _handleSelectClick(selectable, data) {
	    var lastSelected = this.state.lastSelected;
	    var selected = true;
	    var changeSelect = !lastSelected || lastSelected.data.id !== data.id;
	
	    if (this.props.toggleSelect || changeSelect) {
	      if (lastSelected) {
	        this.refs[lastSelected.data.id].unselect();
	      }
	
	      if (this.props.toggleSelect) {
	        selected = selectable.toggleSelect();
	      } else {
	        selectable.select();
	      }
	
	      this._updateState(data, selected);
	    }
	  },
	
	  _renderItems: function _renderItems(items) {
	    var _this2 = this;
	
	    return items.map(function (data, i) {
	      var newItem = _this2.props.itemTemplate(data, function (e) {
	        return _this2.handleItemClick(_this2.refs[data.id], data, _this2.refs[data.id].state.selected);
	      });
	      var selected = void 0;
	
	      if (data.selected !== undefined) {
	        selected = data.selected;
	      } else {
	        selected = _this2.state.selectedItems[data.id] === true;
	      }
	
	      return _react2.default.createElement(
	        _selectable2.default,
	        {
	          key: i,
	          ref: data.id,
	          id: data.id,
	          data: data,
	          selected: selected,
	          selectedClass: _this2.props.selectedClass,
	          overrideClick: true },
	        newItem
	      );
	    });
	  },
	
	  _updateState: function _updateState(data, selected) {
	    var lastSelected = this.state.lastSelected || {};
	    var currentSelected = {
	      data: data,
	      selected: selected
	    };
	
	    if (lastSelected.data !== currentSelected.data || lastSelected.selected !== currentSelected.selected) {
	
	      this.setState({ lastSelected: currentSelected });
	
	      if (this.props.onChange) {
	        this.props.onChange(lastSelected, currentSelected);
	      }
	    }
	  }
	
	});
	
	exports.default = SelectableList;

/***/ },
/* 41 */
/***/ function(module, exports) {

	// shim for using process in browser
	var process = module.exports = {};
	
	// cached from whatever global is present so that test runners that stub it
	// don't break things.  But we need to wrap it in a try catch in case it is
	// wrapped in strict mode code which doesn't define any globals.  It's inside a
	// function because try/catches deoptimize in certain engines.
	
	var cachedSetTimeout;
	var cachedClearTimeout;
	
	function defaultSetTimout() {
	    throw new Error('setTimeout has not been defined');
	}
	function defaultClearTimeout () {
	    throw new Error('clearTimeout has not been defined');
	}
	(function () {
	    try {
	        if (typeof setTimeout === 'function') {
	            cachedSetTimeout = setTimeout;
	        } else {
	            cachedSetTimeout = defaultSetTimout;
	        }
	    } catch (e) {
	        cachedSetTimeout = defaultSetTimout;
	    }
	    try {
	        if (typeof clearTimeout === 'function') {
	            cachedClearTimeout = clearTimeout;
	        } else {
	            cachedClearTimeout = defaultClearTimeout;
	        }
	    } catch (e) {
	        cachedClearTimeout = defaultClearTimeout;
	    }
	} ())
	function runTimeout(fun) {
	    if (cachedSetTimeout === setTimeout) {
	        //normal enviroments in sane situations
	        return setTimeout(fun, 0);
	    }
	    // if setTimeout wasn't available but was latter defined
	    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
	        cachedSetTimeout = setTimeout;
	        return setTimeout(fun, 0);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedSetTimeout(fun, 0);
	    } catch(e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
	            return cachedSetTimeout.call(null, fun, 0);
	        } catch(e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
	            return cachedSetTimeout.call(this, fun, 0);
	        }
	    }
	
	
	}
	function runClearTimeout(marker) {
	    if (cachedClearTimeout === clearTimeout) {
	        //normal enviroments in sane situations
	        return clearTimeout(marker);
	    }
	    // if clearTimeout wasn't available but was latter defined
	    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
	        cachedClearTimeout = clearTimeout;
	        return clearTimeout(marker);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedClearTimeout(marker);
	    } catch (e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
	            return cachedClearTimeout.call(null, marker);
	        } catch (e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
	            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
	            return cachedClearTimeout.call(this, marker);
	        }
	    }
	
	
	
	}
	var queue = [];
	var draining = false;
	var currentQueue;
	var queueIndex = -1;
	
	function cleanUpNextTick() {
	    if (!draining || !currentQueue) {
	        return;
	    }
	    draining = false;
	    if (currentQueue.length) {
	        queue = currentQueue.concat(queue);
	    } else {
	        queueIndex = -1;
	    }
	    if (queue.length) {
	        drainQueue();
	    }
	}
	
	function drainQueue() {
	    if (draining) {
	        return;
	    }
	    var timeout = runTimeout(cleanUpNextTick);
	    draining = true;
	
	    var len = queue.length;
	    while(len) {
	        currentQueue = queue;
	        queue = [];
	        while (++queueIndex < len) {
	            if (currentQueue) {
	                currentQueue[queueIndex].run();
	            }
	        }
	        queueIndex = -1;
	        len = queue.length;
	    }
	    currentQueue = null;
	    draining = false;
	    runClearTimeout(timeout);
	}
	
	process.nextTick = function (fun) {
	    var args = new Array(arguments.length - 1);
	    if (arguments.length > 1) {
	        for (var i = 1; i < arguments.length; i++) {
	            args[i - 1] = arguments[i];
	        }
	    }
	    queue.push(new Item(fun, args));
	    if (queue.length === 1 && !draining) {
	        runTimeout(drainQueue);
	    }
	};
	
	// v8 likes predictible objects
	function Item(fun, array) {
	    this.fun = fun;
	    this.array = array;
	}
	Item.prototype.run = function () {
	    this.fun.apply(null, this.array);
	};
	process.title = 'browser';
	process.browser = true;
	process.env = {};
	process.argv = [];
	process.version = ''; // empty string to avoid regexp issues
	process.versions = {};
	
	function noop() {}
	
	process.on = noop;
	process.addListener = noop;
	process.once = noop;
	process.off = noop;
	process.removeListener = noop;
	process.removeAllListeners = noop;
	process.emit = noop;
	
	process.binding = function (name) {
	    throw new Error('process.binding is not supported');
	};
	
	process.cwd = function () { return '/' };
	process.chdir = function (dir) {
	    throw new Error('process.chdir is not supported');
	};
	process.umask = function() { return 0; };


/***/ },
/* 42 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule DisabledInputUtils
	 */
	
	'use strict';
	
	var disableableMouseListenerNames = {
	  onClick: true,
	  onDoubleClick: true,
	  onMouseDown: true,
	  onMouseMove: true,
	  onMouseUp: true,
	
	  onClickCapture: true,
	  onDoubleClickCapture: true,
	  onMouseDownCapture: true,
	  onMouseMoveCapture: true,
	  onMouseUpCapture: true
	};
	
	/**
	 * Implements a host component that does not receive mouse events
	 * when `disabled` is set.
	 */
	var DisabledInputUtils = {
	  getHostProps: function (inst, props) {
	    if (!props.disabled) {
	      return props;
	    }
	
	    // Copy the props, except the mouse listeners
	    var hostProps = {};
	    for (var key in props) {
	      if (!disableableMouseListenerNames[key] && props.hasOwnProperty(key)) {
	        hostProps[key] = props[key];
	      }
	    }
	
	    return hostProps;
	  }
	};
	
	module.exports = DisabledInputUtils;

/***/ },
/* 43 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactBrowserEventEmitter
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(6);
	
	var EventConstants = __webpack_require__(18);
	var EventPluginRegistry = __webpack_require__(54);
	var ReactEventEmitterMixin = __webpack_require__(334);
	var ViewportMetrics = __webpack_require__(118);
	
	var getVendorPrefixedEventName = __webpack_require__(365);
	var isEventSupported = __webpack_require__(71);
	
	/**
	 * Summary of `ReactBrowserEventEmitter` event handling:
	 *
	 *  - Top-level delegation is used to trap most native browser events. This
	 *    may only occur in the main thread and is the responsibility of
	 *    ReactEventListener, which is injected and can therefore support pluggable
	 *    event sources. This is the only work that occurs in the main thread.
	 *
	 *  - We normalize and de-duplicate events to account for browser quirks. This
	 *    may be done in the worker thread.
	 *
	 *  - Forward these native events (with the associated top-level type used to
	 *    trap it) to `EventPluginHub`, which in turn will ask plugins if they want
	 *    to extract any synthetic events.
	 *
	 *  - The `EventPluginHub` will then process each event by annotating them with
	 *    "dispatches", a sequence of listeners and IDs that care about that event.
	 *
	 *  - The `EventPluginHub` then dispatches the events.
	 *
	 * Overview of React and the event system:
	 *
	 * +------------+    .
	 * |    DOM     |    .
	 * +------------+    .
	 *       |           .
	 *       v           .
	 * +------------+    .
	 * | ReactEvent |    .
	 * |  Listener  |    .
	 * +------------+    .                         +-----------+
	 *       |           .               +--------+|SimpleEvent|
	 *       |           .               |         |Plugin     |
	 * +-----|------+    .               v         +-----------+
	 * |     |      |    .    +--------------+                    +------------+
	 * |     +-----------.--->|EventPluginHub|                    |    Event   |
	 * |            |    .    |              |     +-----------+  | Propagators|
	 * | ReactEvent |    .    |              |     |TapEvent   |  |------------|
	 * |  Emitter   |    .    |              |<---+|Plugin     |  |other plugin|
	 * |            |    .    |              |     +-----------+  |  utilities |
	 * |     +-----------.--->|              |                    +------------+
	 * |     |      |    .    +--------------+
	 * +-----|------+    .                ^        +-----------+
	 *       |           .                |        |Enter/Leave|
	 *       +           .                +-------+|Plugin     |
	 * +-------------+   .                         +-----------+
	 * | application |   .
	 * |-------------|   .
	 * |             |   .
	 * |             |   .
	 * +-------------+   .
	 *                   .
	 *    React Core     .  General Purpose Event Plugin System
	 */
	
	var hasEventPageXY;
	var alreadyListeningTo = {};
	var isMonitoringScrollValue = false;
	var reactTopListenersCounter = 0;
	
	// For events like 'submit' which don't consistently bubble (which we trap at a
	// lower node than `document`), binding at `document` would cause duplicate
	// events so we don't include them here
	var topEventMapping = {
	  topAbort: 'abort',
	  topAnimationEnd: getVendorPrefixedEventName('animationend') || 'animationend',
	  topAnimationIteration: getVendorPrefixedEventName('animationiteration') || 'animationiteration',
	  topAnimationStart: getVendorPrefixedEventName('animationstart') || 'animationstart',
	  topBlur: 'blur',
	  topCanPlay: 'canplay',
	  topCanPlayThrough: 'canplaythrough',
	  topChange: 'change',
	  topClick: 'click',
	  topCompositionEnd: 'compositionend',
	  topCompositionStart: 'compositionstart',
	  topCompositionUpdate: 'compositionupdate',
	  topContextMenu: 'contextmenu',
	  topCopy: 'copy',
	  topCut: 'cut',
	  topDoubleClick: 'dblclick',
	  topDrag: 'drag',
	  topDragEnd: 'dragend',
	  topDragEnter: 'dragenter',
	  topDragExit: 'dragexit',
	  topDragLeave: 'dragleave',
	  topDragOver: 'dragover',
	  topDragStart: 'dragstart',
	  topDrop: 'drop',
	  topDurationChange: 'durationchange',
	  topEmptied: 'emptied',
	  topEncrypted: 'encrypted',
	  topEnded: 'ended',
	  topError: 'error',
	  topFocus: 'focus',
	  topInput: 'input',
	  topKeyDown: 'keydown',
	  topKeyPress: 'keypress',
	  topKeyUp: 'keyup',
	  topLoadedData: 'loadeddata',
	  topLoadedMetadata: 'loadedmetadata',
	  topLoadStart: 'loadstart',
	  topMouseDown: 'mousedown',
	  topMouseMove: 'mousemove',
	  topMouseOut: 'mouseout',
	  topMouseOver: 'mouseover',
	  topMouseUp: 'mouseup',
	  topPaste: 'paste',
	  topPause: 'pause',
	  topPlay: 'play',
	  topPlaying: 'playing',
	  topProgress: 'progress',
	  topRateChange: 'ratechange',
	  topScroll: 'scroll',
	  topSeeked: 'seeked',
	  topSeeking: 'seeking',
	  topSelectionChange: 'selectionchange',
	  topStalled: 'stalled',
	  topSuspend: 'suspend',
	  topTextInput: 'textInput',
	  topTimeUpdate: 'timeupdate',
	  topTouchCancel: 'touchcancel',
	  topTouchEnd: 'touchend',
	  topTouchMove: 'touchmove',
	  topTouchStart: 'touchstart',
	  topTransitionEnd: getVendorPrefixedEventName('transitionend') || 'transitionend',
	  topVolumeChange: 'volumechange',
	  topWaiting: 'waiting',
	  topWheel: 'wheel'
	};
	
	/**
	 * To ensure no conflicts with other potential React instances on the page
	 */
	var topListenersIDKey = '_reactListenersID' + String(Math.random()).slice(2);
	
	function getListeningForDocument(mountAt) {
	  // In IE8, `mountAt` is a host object and doesn't have `hasOwnProperty`
	  // directly.
	  if (!Object.prototype.hasOwnProperty.call(mountAt, topListenersIDKey)) {
	    mountAt[topListenersIDKey] = reactTopListenersCounter++;
	    alreadyListeningTo[mountAt[topListenersIDKey]] = {};
	  }
	  return alreadyListeningTo[mountAt[topListenersIDKey]];
	}
	
	/**
	 * `ReactBrowserEventEmitter` is used to attach top-level event listeners. For
	 * example:
	 *
	 *   EventPluginHub.putListener('myID', 'onClick', myFunction);
	 *
	 * This would allocate a "registration" of `('onClick', myFunction)` on 'myID'.
	 *
	 * @internal
	 */
	var ReactBrowserEventEmitter = _assign({}, ReactEventEmitterMixin, {
	
	  /**
	   * Injectable event backend
	   */
	  ReactEventListener: null,
	
	  injection: {
	    /**
	     * @param {object} ReactEventListener
	     */
	    injectReactEventListener: function (ReactEventListener) {
	      ReactEventListener.setHandleTopLevel(ReactBrowserEventEmitter.handleTopLevel);
	      ReactBrowserEventEmitter.ReactEventListener = ReactEventListener;
	    }
	  },
	
	  /**
	   * Sets whether or not any created callbacks should be enabled.
	   *
	   * @param {boolean} enabled True if callbacks should be enabled.
	   */
	  setEnabled: function (enabled) {
	    if (ReactBrowserEventEmitter.ReactEventListener) {
	      ReactBrowserEventEmitter.ReactEventListener.setEnabled(enabled);
	    }
	  },
	
	  /**
	   * @return {boolean} True if callbacks are enabled.
	   */
	  isEnabled: function () {
	    return !!(ReactBrowserEventEmitter.ReactEventListener && ReactBrowserEventEmitter.ReactEventListener.isEnabled());
	  },
	
	  /**
	   * We listen for bubbled touch events on the document object.
	   *
	   * Firefox v8.01 (and possibly others) exhibited strange behavior when
	   * mounting `onmousemove` events at some node that was not the document
	   * element. The symptoms were that if your mouse is not moving over something
	   * contained within that mount point (for example on the background) the
	   * top-level listeners for `onmousemove` won't be called. However, if you
	   * register the `mousemove` on the document object, then it will of course
	   * catch all `mousemove`s. This along with iOS quirks, justifies restricting
	   * top-level listeners to the document object only, at least for these
	   * movement types of events and possibly all events.
	   *
	   * @see http://www.quirksmode.org/blog/archives/2010/09/click_event_del.html
	   *
	   * Also, `keyup`/`keypress`/`keydown` do not bubble to the window on IE, but
	   * they bubble to document.
	   *
	   * @param {string} registrationName Name of listener (e.g. `onClick`).
	   * @param {object} contentDocumentHandle Document which owns the container
	   */
	  listenTo: function (registrationName, contentDocumentHandle) {
	    var mountAt = contentDocumentHandle;
	    var isListening = getListeningForDocument(mountAt);
	    var dependencies = EventPluginRegistry.registrationNameDependencies[registrationName];
	
	    var topLevelTypes = EventConstants.topLevelTypes;
	    for (var i = 0; i < dependencies.length; i++) {
	      var dependency = dependencies[i];
	      if (!(isListening.hasOwnProperty(dependency) && isListening[dependency])) {
	        if (dependency === topLevelTypes.topWheel) {
	          if (isEventSupported('wheel')) {
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(topLevelTypes.topWheel, 'wheel', mountAt);
	          } else if (isEventSupported('mousewheel')) {
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(topLevelTypes.topWheel, 'mousewheel', mountAt);
	          } else {
	            // Firefox needs to capture a different mouse scroll event.
	            // @see http://www.quirksmode.org/dom/events/tests/scroll.html
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(topLevelTypes.topWheel, 'DOMMouseScroll', mountAt);
	          }
	        } else if (dependency === topLevelTypes.topScroll) {
	
	          if (isEventSupported('scroll', true)) {
	            ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent(topLevelTypes.topScroll, 'scroll', mountAt);
	          } else {
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(topLevelTypes.topScroll, 'scroll', ReactBrowserEventEmitter.ReactEventListener.WINDOW_HANDLE);
	          }
	        } else if (dependency === topLevelTypes.topFocus || dependency === topLevelTypes.topBlur) {
	
	          if (isEventSupported('focus', true)) {
	            ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent(topLevelTypes.topFocus, 'focus', mountAt);
	            ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent(topLevelTypes.topBlur, 'blur', mountAt);
	          } else if (isEventSupported('focusin')) {
	            // IE has `focusin` and `focusout` events which bubble.
	            // @see http://www.quirksmode.org/blog/archives/2008/04/delegating_the.html
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(topLevelTypes.topFocus, 'focusin', mountAt);
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(topLevelTypes.topBlur, 'focusout', mountAt);
	          }
	
	          // to make sure blur and focus event listeners are only attached once
	          isListening[topLevelTypes.topBlur] = true;
	          isListening[topLevelTypes.topFocus] = true;
	        } else if (topEventMapping.hasOwnProperty(dependency)) {
	          ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(dependency, topEventMapping[dependency], mountAt);
	        }
	
	        isListening[dependency] = true;
	      }
	    }
	  },
	
	  trapBubbledEvent: function (topLevelType, handlerBaseName, handle) {
	    return ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(topLevelType, handlerBaseName, handle);
	  },
	
	  trapCapturedEvent: function (topLevelType, handlerBaseName, handle) {
	    return ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent(topLevelType, handlerBaseName, handle);
	  },
	
	  /**
	   * Listens to window scroll and resize events. We cache scroll values so that
	   * application code can access them without triggering reflows.
	   *
	   * ViewportMetrics is only used by SyntheticMouse/TouchEvent and only when
	   * pageX/pageY isn't supported (legacy browsers).
	   *
	   * NOTE: Scroll events do not bubble.
	   *
	   * @see http://www.quirksmode.org/dom/events/scroll.html
	   */
	  ensureScrollValueMonitoring: function () {
	    if (hasEventPageXY === undefined) {
	      hasEventPageXY = document.createEvent && 'pageX' in document.createEvent('MouseEvent');
	    }
	    if (!hasEventPageXY && !isMonitoringScrollValue) {
	      var refresh = ViewportMetrics.refreshScrollValues;
	      ReactBrowserEventEmitter.ReactEventListener.monitorScrollValue(refresh);
	      isMonitoringScrollValue = true;
	    }
	  }
	
	});
	
	module.exports = ReactBrowserEventEmitter;

/***/ },
/* 44 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule SyntheticMouseEvent
	 */
	
	'use strict';
	
	var SyntheticUIEvent = __webpack_require__(37);
	var ViewportMetrics = __webpack_require__(118);
	
	var getEventModifierState = __webpack_require__(69);
	
	/**
	 * @interface MouseEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var MouseEventInterface = {
	  screenX: null,
	  screenY: null,
	  clientX: null,
	  clientY: null,
	  ctrlKey: null,
	  shiftKey: null,
	  altKey: null,
	  metaKey: null,
	  getModifierState: getEventModifierState,
	  button: function (event) {
	    // Webkit, Firefox, IE9+
	    // which:  1 2 3
	    // button: 0 1 2 (standard)
	    var button = event.button;
	    if ('which' in event) {
	      return button;
	    }
	    // IE<9
	    // which:  undefined
	    // button: 0 0 0
	    // button: 1 4 2 (onmouseup)
	    return button === 2 ? 2 : button === 4 ? 1 : 0;
	  },
	  buttons: null,
	  relatedTarget: function (event) {
	    return event.relatedTarget || (event.fromElement === event.srcElement ? event.toElement : event.fromElement);
	  },
	  // "Proprietary" Interface.
	  pageX: function (event) {
	    return 'pageX' in event ? event.pageX : event.clientX + ViewportMetrics.currentScrollLeft;
	  },
	  pageY: function (event) {
	    return 'pageY' in event ? event.pageY : event.clientY + ViewportMetrics.currentScrollTop;
	  }
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticMouseEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticUIEvent.augmentClass(SyntheticMouseEvent, MouseEventInterface);
	
	module.exports = SyntheticMouseEvent;

/***/ },
/* 45 */
/***/ function(module, exports) {

	/**
	 * Copyright 2016-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * Based on the escape-html library, which is used under the MIT License below:
	 *
	 * Copyright (c) 2012-2013 TJ Holowaychuk
	 * Copyright (c) 2015 Andreas Lubbe
	 * Copyright (c) 2015 Tiancheng "Timothy" Gu
	 *
	 * Permission is hereby granted, free of charge, to any person obtaining
	 * a copy of this software and associated documentation files (the
	 * 'Software'), to deal in the Software without restriction, including
	 * without limitation the rights to use, copy, modify, merge, publish,
	 * distribute, sublicense, and/or sell copies of the Software, and to
	 * permit persons to whom the Software is furnished to do so, subject to
	 * the following conditions:
	 *
	 * The above copyright notice and this permission notice shall be
	 * included in all copies or substantial portions of the Software.
	 *
	 * THE SOFTWARE IS PROVIDED 'AS IS', WITHOUT WARRANTY OF ANY KIND,
	 * EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	 * MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.
	 * IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY
	 * CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
	 * TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE
	 * SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
	 *
	 * @providesModule escapeTextContentForBrowser
	 */
	
	'use strict';
	
	// code copied and modified from escape-html
	/**
	 * Module variables.
	 * @private
	 */
	
	var matchHtmlRegExp = /["'&<>]/;
	
	/**
	 * Escape special characters in the given string of html.
	 *
	 * @param  {string} string The string to escape for inserting into HTML
	 * @return {string}
	 * @public
	 */
	
	function escapeHtml(string) {
	  var str = '' + string;
	  var match = matchHtmlRegExp.exec(str);
	
	  if (!match) {
	    return str;
	  }
	
	  var escape;
	  var html = '';
	  var index = 0;
	  var lastIndex = 0;
	
	  for (index = match.index; index < str.length; index++) {
	    switch (str.charCodeAt(index)) {
	      case 34:
	        // "
	        escape = '&quot;';
	        break;
	      case 38:
	        // &
	        escape = '&amp;';
	        break;
	      case 39:
	        // '
	        escape = '&#x27;'; // modified from escape-html; used to be '&#39'
	        break;
	      case 60:
	        // <
	        escape = '&lt;';
	        break;
	      case 62:
	        // >
	        escape = '&gt;';
	        break;
	      default:
	        continue;
	    }
	
	    if (lastIndex !== index) {
	      html += str.substring(lastIndex, index);
	    }
	
	    lastIndex = index + 1;
	    html += escape;
	  }
	
	  return lastIndex !== index ? html + str.substring(lastIndex, index) : html;
	}
	// end code copied and modified from escape-html
	
	
	/**
	 * Escapes text to prevent scripting attacks.
	 *
	 * @param {*} text Text value to escape.
	 * @return {string} An escaped string.
	 */
	function escapeTextContentForBrowser(text) {
	  if (typeof text === 'boolean' || typeof text === 'number') {
	    // this shortcircuit helps perf for types that we know will never have
	    // special characters, especially given that this function is used often
	    // for numeric dom ids.
	    return '' + text;
	  }
	  return escapeHtml(text);
	}
	
	module.exports = escapeTextContentForBrowser;

/***/ },
/* 46 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule setInnerHTML
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(9);
	var DOMNamespaces = __webpack_require__(53);
	
	var WHITESPACE_TEST = /^[ \r\n\t\f]/;
	var NONVISIBLE_TEST = /<(!--|link|noscript|meta|script|style)[ \r\n\t\f\/>]/;
	
	var createMicrosoftUnsafeLocalFunction = __webpack_require__(67);
	
	// SVG temp container for IE lacking innerHTML
	var reusableSVGContainer;
	
	/**
	 * Set the innerHTML property of a node, ensuring that whitespace is preserved
	 * even in IE8.
	 *
	 * @param {DOMElement} node
	 * @param {string} html
	 * @internal
	 */
	var setInnerHTML = createMicrosoftUnsafeLocalFunction(function (node, html) {
	  // IE does not have innerHTML for SVG nodes, so instead we inject the
	  // new markup in a temp node and then move the child nodes across into
	  // the target node
	  if (node.namespaceURI === DOMNamespaces.svg && !('innerHTML' in node)) {
	    reusableSVGContainer = reusableSVGContainer || document.createElement('div');
	    reusableSVGContainer.innerHTML = '<svg>' + html + '</svg>';
	    var newNodes = reusableSVGContainer.firstChild.childNodes;
	    for (var i = 0; i < newNodes.length; i++) {
	      node.appendChild(newNodes[i]);
	    }
	  } else {
	    node.innerHTML = html;
	  }
	});
	
	if (ExecutionEnvironment.canUseDOM) {
	  // IE8: When updating a just created node with innerHTML only leading
	  // whitespace is removed. When updating an existing node with innerHTML
	  // whitespace in root TextNodes is also collapsed.
	  // @see quirksmode.org/bugreports/archives/2004/11/innerhtml_and_t.html
	
	  // Feature detection; only IE8 is known to behave improperly like this.
	  var testElement = document.createElement('div');
	  testElement.innerHTML = ' ';
	  if (testElement.innerHTML === '') {
	    setInnerHTML = function (node, html) {
	      // Magic theory: IE8 supposedly differentiates between added and updated
	      // nodes when processing innerHTML, innerHTML on updated nodes suffers
	      // from worse whitespace behavior. Re-adding a node like this triggers
	      // the initial and more favorable whitespace behavior.
	      // TODO: What to do on a detached node?
	      if (node.parentNode) {
	        node.parentNode.replaceChild(node, node);
	      }
	
	      // We also implement a workaround for non-visible tags disappearing into
	      // thin air on IE8, this only happens if there is no visible text
	      // in-front of the non-visible tags. Piggyback on the whitespace fix
	      // and simply check if any non-visible tags appear in the source.
	      if (WHITESPACE_TEST.test(html) || html[0] === '<' && NONVISIBLE_TEST.test(html)) {
	        // Recover leading whitespace by temporarily prepending any character.
	        // \uFEFF has the potential advantage of being zero-width/invisible.
	        // UglifyJS drops U+FEFF chars when parsing, so use String.fromCharCode
	        // in hopes that this is preserved even if "\uFEFF" is transformed to
	        // the actual Unicode character (by Babel, for example).
	        // https://github.com/mishoo/UglifyJS2/blob/v2.4.20/lib/parse.js#L216
	        node.innerHTML = String.fromCharCode(0xFEFF) + html;
	
	        // deleteData leaves an empty `TextNode` which offsets the index of all
	        // children. Definitely want to avoid this.
	        var textNode = node.firstChild;
	        if (textNode.data.length === 1) {
	          node.removeChild(textNode);
	        } else {
	          textNode.deleteData(0, 1);
	        }
	      } else {
	        node.innerHTML = html;
	      }
	    };
	  }
	  testElement = null;
	}
	
	module.exports = setInnerHTML;

/***/ },
/* 47 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks
	 * 
	 */
	
	/*eslint-disable no-self-compare */
	
	'use strict';
	
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	
	/**
	 * inlined Object.is polyfill to avoid requiring consumers ship their own
	 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
	 */
	function is(x, y) {
	  // SameValue algorithm
	  if (x === y) {
	    // Steps 1-5, 7-10
	    // Steps 6.b-6.e: +0 != -0
	    return x !== 0 || 1 / x === 1 / y;
	  } else {
	    // Step 6.a: NaN == NaN
	    return x !== x && y !== y;
	  }
	}
	
	/**
	 * Performs equality by iterating through keys on an object and returning false
	 * when any key has values which are not strictly equal between the arguments.
	 * Returns true when the values of all keys are strictly equal.
	 */
	function shallowEqual(objA, objB) {
	  if (is(objA, objB)) {
	    return true;
	  }
	
	  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
	    return false;
	  }
	
	  var keysA = Object.keys(objA);
	  var keysB = Object.keys(objB);
	
	  if (keysA.length !== keysB.length) {
	    return false;
	  }
	
	  // Test for A's keys different from B.
	  for (var i = 0; i < keysA.length; i++) {
	    if (!hasOwnProperty.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
	      return false;
	    }
	  }
	
	  return true;
	}
	
	module.exports = shallowEqual;

/***/ },
/* 48 */
/***/ function(module, exports, __webpack_require__) {

	var getPrototype = __webpack_require__(170),
	    isHostObject = __webpack_require__(171),
	    isObjectLike = __webpack_require__(173);
	
	/** `Object#toString` result references. */
	var objectTag = '[object Object]';
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to resolve the decompiled source of functions. */
	var funcToString = Function.prototype.toString;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/** Used to infer the `Object` constructor. */
	var objectCtorString = funcToString.call(Object);
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objectToString = objectProto.toString;
	
	/**
	 * Checks if `value` is a plain object, that is, an object created by the
	 * `Object` constructor or one with a `[[Prototype]]` of `null`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.8.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a plain object,
	 *  else `false`.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 * }
	 *
	 * _.isPlainObject(new Foo);
	 * // => false
	 *
	 * _.isPlainObject([1, 2, 3]);
	 * // => false
	 *
	 * _.isPlainObject({ 'x': 0, 'y': 0 });
	 * // => true
	 *
	 * _.isPlainObject(Object.create(null));
	 * // => true
	 */
	function isPlainObject(value) {
	  if (!isObjectLike(value) ||
	      objectToString.call(value) != objectTag || isHostObject(value)) {
	    return false;
	  }
	  var proto = getPrototype(value);
	  if (proto === null) {
	    return true;
	  }
	  var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
	  return (typeof Ctor == 'function' &&
	    Ctor instanceof Ctor && funcToString.call(Ctor) == objectCtorString);
	}
	
	module.exports = isPlainObject;


/***/ },
/* 49 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _app_actions = __webpack_require__(207);
	
	var _app_actions2 = _interopRequireDefault(_app_actions);
	
	var _auth_actions = __webpack_require__(208);
	
	var _auth_actions2 = _interopRequireDefault(_auth_actions);
	
	var _schedule_actions = __webpack_require__(215);
	
	var _schedule_actions2 = _interopRequireDefault(_schedule_actions);
	
	var _teacher_actions = __webpack_require__(219);
	
	var _teacher_actions2 = _interopRequireDefault(_teacher_actions);
	
	var _cohort_actions = __webpack_require__(209);
	
	var _cohort_actions2 = _interopRequireDefault(_cohort_actions);
	
	var _participant_actions = __webpack_require__(214);
	
	var _participant_actions2 = _interopRequireDefault(_participant_actions);
	
	var _meeting_actions = __webpack_require__(210);
	
	var _meeting_actions2 = _interopRequireDefault(_meeting_actions);
	
	var _schedule_viewer_actions = __webpack_require__(217);
	
	var _schedule_viewer_actions2 = _interopRequireDefault(_schedule_viewer_actions);
	
	var _schedule_controls_actions = __webpack_require__(216);
	
	var _schedule_controls_actions2 = _interopRequireDefault(_schedule_controls_actions);
	
	var _meeting_layer_actions = __webpack_require__(212);
	
	var _meeting_layer_actions2 = _interopRequireDefault(_meeting_layer_actions);
	
	var _meeting_label_actions = __webpack_require__(211);
	
	var _meeting_label_actions2 = _interopRequireDefault(_meeting_label_actions);
	
	var _student_cohort_actions = __webpack_require__(218);
	
	var _student_cohort_actions2 = _interopRequireDefault(_student_cohort_actions);
	
	var _modal_actions = __webpack_require__(213);
	
	var _modal_actions2 = _interopRequireDefault(_modal_actions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = Object.assign({}, _app_actions2.default, _auth_actions2.default, _schedule_actions2.default, _teacher_actions2.default, _cohort_actions2.default, _participant_actions2.default, _meeting_actions2.default, _schedule_viewer_actions2.default, _schedule_controls_actions2.default, _meeting_layer_actions2.default, _meeting_label_actions2.default, _student_cohort_actions2.default, _modal_actions2.default);

/***/ },
/* 50 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _entities_selector = __webpack_require__(17);
	
	var _entities_selector2 = _interopRequireDefault(_entities_selector);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var cohortsSelector = (0, _entities_selector2.default)(function (state) {
	  return state.cohorts;
	}, function (cohort, localState, associations) {
	  var first_name = cohort.first_name || cohort.id;
	  var last_name = cohort.last_name || '';
	  return { name: first_name + ' ' + last_name };
	});
	
	exports.default = cohortsSelector;

/***/ },
/* 51 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _underscore = __webpack_require__(7);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _reselect = __webpack_require__(15);
	
	var _entities_selector = __webpack_require__(17);
	
	var _entities_selector2 = _interopRequireDefault(_entities_selector);
	
	var _meetings_selector = __webpack_require__(282);
	
	var _meetings_selector2 = _interopRequireDefault(_meetings_selector);
	
	var _teachers_selector = __webpack_require__(33);
	
	var _teachers_selector2 = _interopRequireDefault(_teachers_selector);
	
	var _cohorts_selector = __webpack_require__(50);
	
	var _cohorts_selector2 = _interopRequireDefault(_cohorts_selector);
	
	var _meeting_layers_selector = __webpack_require__(99);
	
	var _meeting_layers_selector2 = _interopRequireDefault(_meeting_layers_selector);
	
	var _time = __webpack_require__(24);
	
	var _time2 = _interopRequireDefault(_time);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var formatDuration = function formatDuration(duration) {
		var hours = duration.hours > 0 ? Math.floor(duration.hours) : null;
		var minutes = duration.minutes > 59 ? Math.floor(duration.hours % 1 * 60) : duration.minutes;
		var str = '';
	
		if (hours && hours > 0) {
			if (hours === 1) {
				str += hours + ' hour ';
			} else {
				str += hours + ' hours ';
			}
		}
	
		if (minutes === 1) {
			str += minutes + ' minute';
		} else if (minutes > 1) {
			str += minutes + ' minutes';
		}
	
		return str;
	};
	
	var isScheduled = function isScheduled(scheduledMeeting, meeting) {
		return meeting && meeting.name !== 'Available';
	};
	
	var isSimilarToInspectedMeeting = function isSimilarToInspectedMeeting(scheduledMeeting, state) {
		if (!state.entities) return false;
	
		// we currently only inspect one meeting at a time
		var inspectedMeeting = state.entities[_underscore2.default.first(state.inspected)];
	
		if (inspectedMeeting && inspectedMeeting !== scheduledMeeting) {
			if (scheduledMeeting.name === inspectedMeeting.name && scheduledMeeting.start_time === inspectedMeeting.start_time && scheduledMeeting.end_time === inspectedMeeting.end_time && scheduledMeeting.teacher_ids === inspectedMeeting.teacher_ids && scheduledMeeting.cohort_ids === inspectedMeeting.cohort_ids) {
				return true;
			}
		}
		return false;
	};
	
	var scheduledMeetingsSelector = (0, _entities_selector2.default)(function (state) {
		return state.scheduledMeetings;
	}, function (scheduledMeeting, localState, _ref) {
		var teachers = _ref.teachers;
		var cohorts = _ref.cohorts;
		var meetings = _ref.meetings;
	
	
		var duration = _time2.default.duration(scheduledMeeting.start_time, scheduledMeeting.end_time);
		var meeting = scheduledMeeting.meeting_id ? meetings[scheduledMeeting.meeting_id] : null;
	
		return {
			name: scheduledMeeting.name ? scheduledMeeting.name : scheduledMeeting.meeting_id,
			scheduled: isScheduled(scheduledMeeting, meeting),
			duration: duration.minutes,
			associated_to_inspected: isSimilarToInspectedMeeting(scheduledMeeting, localState),
			durationString: formatDuration(duration),
			start_time_minutes: _time2.default.parse(scheduledMeeting.start_time).totalMinutes,
			end_time_minutes: _time2.default.parse(scheduledMeeting.end_time).totalMinutes,
			classNames: [scheduledMeeting.unavailable ? 'abl-unavailable' : null].concat(scheduledMeeting.classNames || []),
	
			// TODO: Need a better way to get associations
			teachers: _underscore2.default.compact(scheduledMeeting.teacher_ids.map(function (id) {
				return teachers[id];
			})),
			cohorts: _underscore2.default.compact(scheduledMeeting.cohort_ids.map(function (id) {
				return cohorts[id];
			})),
			meeting: meeting
		};
	}, (0, _reselect.createSelector)(function (state) {
		return _teachers_selector2.default.getAll(state);
	}, function (state) {
		return _cohorts_selector2.default.getAll(state);
	}, function (state) {
		return _meetings_selector2.default.getAll(state);
	}, function (state) {
		return _meeting_layers_selector2.default.getAll(state);
	}, function (teachers, cohorts, meetings, layers) {
		return {
			teachers: _underscore2.default.indexBy(teachers, 'id'),
			cohorts: _underscore2.default.indexBy(cohorts, 'id'),
			meetings: _underscore2.default.indexBy(meetings, 'id'),
			layers: layers
		};
	}));
	
	var isActive = function isActive(meeting, filterGroups) {
		return filterGroups.length > 0 && _underscore2.default.all(filterGroups, function (filterGroup) {
			if (typeof filterGroup === 'function') {
				filterGroup = { filters: [filterGroup] };
			}
			var join = filterGroup.join === 'any' ? 'any' : 'all';
			return _underscore2.default[join](filterGroup.filters, function (filter) {
				return filter(meeting);
			});
		});
	};
	
	var getActive = function getActive(state, filterGroups) {
		return scheduledMeetingsSelector.filter(state, function (meeting) {
			return isActive(meeting, filterGroups);
		});
	};
	
	scheduledMeetingsSelector.getActive = getActive;
	
	exports.default = scheduledMeetingsSelector;

/***/ },
/* 52 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule DOMChildrenOperations
	 */
	
	'use strict';
	
	var DOMLazyTree = __webpack_require__(26);
	var Danger = __webpack_require__(309);
	var ReactMultiChildUpdateTypes = __webpack_require__(114);
	var ReactDOMComponentTree = __webpack_require__(8);
	var ReactInstrumentation = __webpack_require__(11);
	
	var createMicrosoftUnsafeLocalFunction = __webpack_require__(67);
	var setInnerHTML = __webpack_require__(46);
	var setTextContent = __webpack_require__(127);
	
	function getNodeAfter(parentNode, node) {
	  // Special case for text components, which return [open, close] comments
	  // from getHostNode.
	  if (Array.isArray(node)) {
	    node = node[1];
	  }
	  return node ? node.nextSibling : parentNode.firstChild;
	}
	
	/**
	 * Inserts `childNode` as a child of `parentNode` at the `index`.
	 *
	 * @param {DOMElement} parentNode Parent node in which to insert.
	 * @param {DOMElement} childNode Child node to insert.
	 * @param {number} index Index at which to insert the child.
	 * @internal
	 */
	var insertChildAt = createMicrosoftUnsafeLocalFunction(function (parentNode, childNode, referenceNode) {
	  // We rely exclusively on `insertBefore(node, null)` instead of also using
	  // `appendChild(node)`. (Using `undefined` is not allowed by all browsers so
	  // we are careful to use `null`.)
	  parentNode.insertBefore(childNode, referenceNode);
	});
	
	function insertLazyTreeChildAt(parentNode, childTree, referenceNode) {
	  DOMLazyTree.insertTreeBefore(parentNode, childTree, referenceNode);
	}
	
	function moveChild(parentNode, childNode, referenceNode) {
	  if (Array.isArray(childNode)) {
	    moveDelimitedText(parentNode, childNode[0], childNode[1], referenceNode);
	  } else {
	    insertChildAt(parentNode, childNode, referenceNode);
	  }
	}
	
	function removeChild(parentNode, childNode) {
	  if (Array.isArray(childNode)) {
	    var closingComment = childNode[1];
	    childNode = childNode[0];
	    removeDelimitedText(parentNode, childNode, closingComment);
	    parentNode.removeChild(closingComment);
	  }
	  parentNode.removeChild(childNode);
	}
	
	function moveDelimitedText(parentNode, openingComment, closingComment, referenceNode) {
	  var node = openingComment;
	  while (true) {
	    var nextNode = node.nextSibling;
	    insertChildAt(parentNode, node, referenceNode);
	    if (node === closingComment) {
	      break;
	    }
	    node = nextNode;
	  }
	}
	
	function removeDelimitedText(parentNode, startNode, closingComment) {
	  while (true) {
	    var node = startNode.nextSibling;
	    if (node === closingComment) {
	      // The closing comment is removed by ReactMultiChild.
	      break;
	    } else {
	      parentNode.removeChild(node);
	    }
	  }
	}
	
	function replaceDelimitedText(openingComment, closingComment, stringText) {
	  var parentNode = openingComment.parentNode;
	  var nodeAfterComment = openingComment.nextSibling;
	  if (nodeAfterComment === closingComment) {
	    // There are no text nodes between the opening and closing comments; insert
	    // a new one if stringText isn't empty.
	    if (stringText) {
	      insertChildAt(parentNode, document.createTextNode(stringText), nodeAfterComment);
	    }
	  } else {
	    if (stringText) {
	      // Set the text content of the first node after the opening comment, and
	      // remove all following nodes up until the closing comment.
	      setTextContent(nodeAfterComment, stringText);
	      removeDelimitedText(parentNode, nodeAfterComment, closingComment);
	    } else {
	      removeDelimitedText(parentNode, openingComment, closingComment);
	    }
	  }
	
	  if (false) {
	    ReactInstrumentation.debugTool.onHostOperation(ReactDOMComponentTree.getInstanceFromNode(openingComment)._debugID, 'replace text', stringText);
	  }
	}
	
	var dangerouslyReplaceNodeWithMarkup = Danger.dangerouslyReplaceNodeWithMarkup;
	if (false) {
	  dangerouslyReplaceNodeWithMarkup = function (oldChild, markup, prevInstance) {
	    Danger.dangerouslyReplaceNodeWithMarkup(oldChild, markup);
	    if (prevInstance._debugID !== 0) {
	      ReactInstrumentation.debugTool.onHostOperation(prevInstance._debugID, 'replace with', markup.toString());
	    } else {
	      var nextInstance = ReactDOMComponentTree.getInstanceFromNode(markup.node);
	      if (nextInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onHostOperation(nextInstance._debugID, 'mount', markup.toString());
	      }
	    }
	  };
	}
	
	/**
	 * Operations for updating with DOM children.
	 */
	var DOMChildrenOperations = {
	
	  dangerouslyReplaceNodeWithMarkup: dangerouslyReplaceNodeWithMarkup,
	
	  replaceDelimitedText: replaceDelimitedText,
	
	  /**
	   * Updates a component's children by processing a series of updates. The
	   * update configurations are each expected to have a `parentNode` property.
	   *
	   * @param {array<object>} updates List of update configurations.
	   * @internal
	   */
	  processUpdates: function (parentNode, updates) {
	    if (false) {
	      var parentNodeDebugID = ReactDOMComponentTree.getInstanceFromNode(parentNode)._debugID;
	    }
	
	    for (var k = 0; k < updates.length; k++) {
	      var update = updates[k];
	      switch (update.type) {
	        case ReactMultiChildUpdateTypes.INSERT_MARKUP:
	          insertLazyTreeChildAt(parentNode, update.content, getNodeAfter(parentNode, update.afterNode));
	          if (false) {
	            ReactInstrumentation.debugTool.onHostOperation(parentNodeDebugID, 'insert child', { toIndex: update.toIndex, content: update.content.toString() });
	          }
	          break;
	        case ReactMultiChildUpdateTypes.MOVE_EXISTING:
	          moveChild(parentNode, update.fromNode, getNodeAfter(parentNode, update.afterNode));
	          if (false) {
	            ReactInstrumentation.debugTool.onHostOperation(parentNodeDebugID, 'move child', { fromIndex: update.fromIndex, toIndex: update.toIndex });
	          }
	          break;
	        case ReactMultiChildUpdateTypes.SET_MARKUP:
	          setInnerHTML(parentNode, update.content);
	          if (false) {
	            ReactInstrumentation.debugTool.onHostOperation(parentNodeDebugID, 'replace children', update.content.toString());
	          }
	          break;
	        case ReactMultiChildUpdateTypes.TEXT_CONTENT:
	          setTextContent(parentNode, update.content);
	          if (false) {
	            ReactInstrumentation.debugTool.onHostOperation(parentNodeDebugID, 'replace text', update.content.toString());
	          }
	          break;
	        case ReactMultiChildUpdateTypes.REMOVE_NODE:
	          removeChild(parentNode, update.fromNode);
	          if (false) {
	            ReactInstrumentation.debugTool.onHostOperation(parentNodeDebugID, 'remove child', { fromIndex: update.fromIndex });
	          }
	          break;
	      }
	    }
	  }
	
	};
	
	module.exports = DOMChildrenOperations;

/***/ },
/* 53 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule DOMNamespaces
	 */
	
	'use strict';
	
	var DOMNamespaces = {
	  html: 'http://www.w3.org/1999/xhtml',
	  mathml: 'http://www.w3.org/1998/Math/MathML',
	  svg: 'http://www.w3.org/2000/svg'
	};
	
	module.exports = DOMNamespaces;

/***/ },
/* 54 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule EventPluginRegistry
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(3);
	
	var invariant = __webpack_require__(2);
	
	/**
	 * Injectable ordering of event plugins.
	 */
	var EventPluginOrder = null;
	
	/**
	 * Injectable mapping from names to event plugin modules.
	 */
	var namesToPlugins = {};
	
	/**
	 * Recomputes the plugin list using the injected plugins and plugin ordering.
	 *
	 * @private
	 */
	function recomputePluginOrdering() {
	  if (!EventPluginOrder) {
	    // Wait until an `EventPluginOrder` is injected.
	    return;
	  }
	  for (var pluginName in namesToPlugins) {
	    var PluginModule = namesToPlugins[pluginName];
	    var pluginIndex = EventPluginOrder.indexOf(pluginName);
	    !(pluginIndex > -1) ?  false ? invariant(false, 'EventPluginRegistry: Cannot inject event plugins that do not exist in the plugin ordering, `%s`.', pluginName) : _prodInvariant('96', pluginName) : void 0;
	    if (EventPluginRegistry.plugins[pluginIndex]) {
	      continue;
	    }
	    !PluginModule.extractEvents ?  false ? invariant(false, 'EventPluginRegistry: Event plugins must implement an `extractEvents` method, but `%s` does not.', pluginName) : _prodInvariant('97', pluginName) : void 0;
	    EventPluginRegistry.plugins[pluginIndex] = PluginModule;
	    var publishedEvents = PluginModule.eventTypes;
	    for (var eventName in publishedEvents) {
	      !publishEventForPlugin(publishedEvents[eventName], PluginModule, eventName) ?  false ? invariant(false, 'EventPluginRegistry: Failed to publish event `%s` for plugin `%s`.', eventName, pluginName) : _prodInvariant('98', eventName, pluginName) : void 0;
	    }
	  }
	}
	
	/**
	 * Publishes an event so that it can be dispatched by the supplied plugin.
	 *
	 * @param {object} dispatchConfig Dispatch configuration for the event.
	 * @param {object} PluginModule Plugin publishing the event.
	 * @return {boolean} True if the event was successfully published.
	 * @private
	 */
	function publishEventForPlugin(dispatchConfig, PluginModule, eventName) {
	  !!EventPluginRegistry.eventNameDispatchConfigs.hasOwnProperty(eventName) ?  false ? invariant(false, 'EventPluginHub: More than one plugin attempted to publish the same event name, `%s`.', eventName) : _prodInvariant('99', eventName) : void 0;
	  EventPluginRegistry.eventNameDispatchConfigs[eventName] = dispatchConfig;
	
	  var phasedRegistrationNames = dispatchConfig.phasedRegistrationNames;
	  if (phasedRegistrationNames) {
	    for (var phaseName in phasedRegistrationNames) {
	      if (phasedRegistrationNames.hasOwnProperty(phaseName)) {
	        var phasedRegistrationName = phasedRegistrationNames[phaseName];
	        publishRegistrationName(phasedRegistrationName, PluginModule, eventName);
	      }
	    }
	    return true;
	  } else if (dispatchConfig.registrationName) {
	    publishRegistrationName(dispatchConfig.registrationName, PluginModule, eventName);
	    return true;
	  }
	  return false;
	}
	
	/**
	 * Publishes a registration name that is used to identify dispatched events and
	 * can be used with `EventPluginHub.putListener` to register listeners.
	 *
	 * @param {string} registrationName Registration name to add.
	 * @param {object} PluginModule Plugin publishing the event.
	 * @private
	 */
	function publishRegistrationName(registrationName, PluginModule, eventName) {
	  !!EventPluginRegistry.registrationNameModules[registrationName] ?  false ? invariant(false, 'EventPluginHub: More than one plugin attempted to publish the same registration name, `%s`.', registrationName) : _prodInvariant('100', registrationName) : void 0;
	  EventPluginRegistry.registrationNameModules[registrationName] = PluginModule;
	  EventPluginRegistry.registrationNameDependencies[registrationName] = PluginModule.eventTypes[eventName].dependencies;
	
	  if (false) {
	    var lowerCasedName = registrationName.toLowerCase();
	    EventPluginRegistry.possibleRegistrationNames[lowerCasedName] = registrationName;
	
	    if (registrationName === 'onDoubleClick') {
	      EventPluginRegistry.possibleRegistrationNames.ondblclick = registrationName;
	    }
	  }
	}
	
	/**
	 * Registers plugins so that they can extract and dispatch events.
	 *
	 * @see {EventPluginHub}
	 */
	var EventPluginRegistry = {
	
	  /**
	   * Ordered list of injected plugins.
	   */
	  plugins: [],
	
	  /**
	   * Mapping from event name to dispatch config
	   */
	  eventNameDispatchConfigs: {},
	
	  /**
	   * Mapping from registration name to plugin module
	   */
	  registrationNameModules: {},
	
	  /**
	   * Mapping from registration name to event name
	   */
	  registrationNameDependencies: {},
	
	  /**
	   * Mapping from lowercase registration names to the properly cased version,
	   * used to warn in the case of missing event handlers. Available
	   * only in __DEV__.
	   * @type {Object}
	   */
	  possibleRegistrationNames:  false ? {} : null,
	
	  /**
	   * Injects an ordering of plugins (by plugin name). This allows the ordering
	   * to be decoupled from injection of the actual plugins so that ordering is
	   * always deterministic regardless of packaging, on-the-fly injection, etc.
	   *
	   * @param {array} InjectedEventPluginOrder
	   * @internal
	   * @see {EventPluginHub.injection.injectEventPluginOrder}
	   */
	  injectEventPluginOrder: function (InjectedEventPluginOrder) {
	    !!EventPluginOrder ?  false ? invariant(false, 'EventPluginRegistry: Cannot inject event plugin ordering more than once. You are likely trying to load more than one copy of React.') : _prodInvariant('101') : void 0;
	    // Clone the ordering so it cannot be dynamically mutated.
	    EventPluginOrder = Array.prototype.slice.call(InjectedEventPluginOrder);
	    recomputePluginOrdering();
	  },
	
	  /**
	   * Injects plugins to be used by `EventPluginHub`. The plugin names must be
	   * in the ordering injected by `injectEventPluginOrder`.
	   *
	   * Plugins can be injected as part of page initialization or on-the-fly.
	   *
	   * @param {object} injectedNamesToPlugins Map from names to plugin modules.
	   * @internal
	   * @see {EventPluginHub.injection.injectEventPluginsByName}
	   */
	  injectEventPluginsByName: function (injectedNamesToPlugins) {
	    var isOrderingDirty = false;
	    for (var pluginName in injectedNamesToPlugins) {
	      if (!injectedNamesToPlugins.hasOwnProperty(pluginName)) {
	        continue;
	      }
	      var PluginModule = injectedNamesToPlugins[pluginName];
	      if (!namesToPlugins.hasOwnProperty(pluginName) || namesToPlugins[pluginName] !== PluginModule) {
	        !!namesToPlugins[pluginName] ?  false ? invariant(false, 'EventPluginRegistry: Cannot inject two different event plugins using the same name, `%s`.', pluginName) : _prodInvariant('102', pluginName) : void 0;
	        namesToPlugins[pluginName] = PluginModule;
	        isOrderingDirty = true;
	      }
	    }
	    if (isOrderingDirty) {
	      recomputePluginOrdering();
	    }
	  },
	
	  /**
	   * Looks up the plugin for the supplied event.
	   *
	   * @param {object} event A synthetic event.
	   * @return {?object} The plugin that created the supplied event.
	   * @internal
	   */
	  getPluginModuleForEvent: function (event) {
	    var dispatchConfig = event.dispatchConfig;
	    if (dispatchConfig.registrationName) {
	      return EventPluginRegistry.registrationNameModules[dispatchConfig.registrationName] || null;
	    }
	    for (var phase in dispatchConfig.phasedRegistrationNames) {
	      if (!dispatchConfig.phasedRegistrationNames.hasOwnProperty(phase)) {
	        continue;
	      }
	      var PluginModule = EventPluginRegistry.registrationNameModules[dispatchConfig.phasedRegistrationNames[phase]];
	      if (PluginModule) {
	        return PluginModule;
	      }
	    }
	    return null;
	  },
	
	  /**
	   * Exposed for unit testing.
	   * @private
	   */
	  _resetEventPlugins: function () {
	    EventPluginOrder = null;
	    for (var pluginName in namesToPlugins) {
	      if (namesToPlugins.hasOwnProperty(pluginName)) {
	        delete namesToPlugins[pluginName];
	      }
	    }
	    EventPluginRegistry.plugins.length = 0;
	
	    var eventNameDispatchConfigs = EventPluginRegistry.eventNameDispatchConfigs;
	    for (var eventName in eventNameDispatchConfigs) {
	      if (eventNameDispatchConfigs.hasOwnProperty(eventName)) {
	        delete eventNameDispatchConfigs[eventName];
	      }
	    }
	
	    var registrationNameModules = EventPluginRegistry.registrationNameModules;
	    for (var registrationName in registrationNameModules) {
	      if (registrationNameModules.hasOwnProperty(registrationName)) {
	        delete registrationNameModules[registrationName];
	      }
	    }
	
	    if (false) {
	      var possibleRegistrationNames = EventPluginRegistry.possibleRegistrationNames;
	      for (var lowerCasedName in possibleRegistrationNames) {
	        if (possibleRegistrationNames.hasOwnProperty(lowerCasedName)) {
	          delete possibleRegistrationNames[lowerCasedName];
	        }
	      }
	    }
	  }
	
	};
	
	module.exports = EventPluginRegistry;

/***/ },
/* 55 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule EventPluginUtils
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(3);
	
	var EventConstants = __webpack_require__(18);
	var ReactErrorUtils = __webpack_require__(61);
	
	var invariant = __webpack_require__(2);
	var warning = __webpack_require__(4);
	
	/**
	 * Injected dependencies:
	 */
	
	/**
	 * - `ComponentTree`: [required] Module that can convert between React instances
	 *   and actual node references.
	 */
	var ComponentTree;
	var TreeTraversal;
	var injection = {
	  injectComponentTree: function (Injected) {
	    ComponentTree = Injected;
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(Injected && Injected.getNodeFromInstance && Injected.getInstanceFromNode, 'EventPluginUtils.injection.injectComponentTree(...): Injected ' + 'module is missing getNodeFromInstance or getInstanceFromNode.') : void 0;
	    }
	  },
	  injectTreeTraversal: function (Injected) {
	    TreeTraversal = Injected;
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(Injected && Injected.isAncestor && Injected.getLowestCommonAncestor, 'EventPluginUtils.injection.injectTreeTraversal(...): Injected ' + 'module is missing isAncestor or getLowestCommonAncestor.') : void 0;
	    }
	  }
	};
	
	var topLevelTypes = EventConstants.topLevelTypes;
	
	function isEndish(topLevelType) {
	  return topLevelType === topLevelTypes.topMouseUp || topLevelType === topLevelTypes.topTouchEnd || topLevelType === topLevelTypes.topTouchCancel;
	}
	
	function isMoveish(topLevelType) {
	  return topLevelType === topLevelTypes.topMouseMove || topLevelType === topLevelTypes.topTouchMove;
	}
	function isStartish(topLevelType) {
	  return topLevelType === topLevelTypes.topMouseDown || topLevelType === topLevelTypes.topTouchStart;
	}
	
	var validateEventDispatches;
	if (false) {
	  validateEventDispatches = function (event) {
	    var dispatchListeners = event._dispatchListeners;
	    var dispatchInstances = event._dispatchInstances;
	
	    var listenersIsArr = Array.isArray(dispatchListeners);
	    var listenersLen = listenersIsArr ? dispatchListeners.length : dispatchListeners ? 1 : 0;
	
	    var instancesIsArr = Array.isArray(dispatchInstances);
	    var instancesLen = instancesIsArr ? dispatchInstances.length : dispatchInstances ? 1 : 0;
	
	    process.env.NODE_ENV !== 'production' ? warning(instancesIsArr === listenersIsArr && instancesLen === listenersLen, 'EventPluginUtils: Invalid `event`.') : void 0;
	  };
	}
	
	/**
	 * Dispatch the event to the listener.
	 * @param {SyntheticEvent} event SyntheticEvent to handle
	 * @param {boolean} simulated If the event is simulated (changes exn behavior)
	 * @param {function} listener Application-level callback
	 * @param {*} inst Internal component instance
	 */
	function executeDispatch(event, simulated, listener, inst) {
	  var type = event.type || 'unknown-event';
	  event.currentTarget = EventPluginUtils.getNodeFromInstance(inst);
	  if (simulated) {
	    ReactErrorUtils.invokeGuardedCallbackWithCatch(type, listener, event);
	  } else {
	    ReactErrorUtils.invokeGuardedCallback(type, listener, event);
	  }
	  event.currentTarget = null;
	}
	
	/**
	 * Standard/simple iteration through an event's collected dispatches.
	 */
	function executeDispatchesInOrder(event, simulated) {
	  var dispatchListeners = event._dispatchListeners;
	  var dispatchInstances = event._dispatchInstances;
	  if (false) {
	    validateEventDispatches(event);
	  }
	  if (Array.isArray(dispatchListeners)) {
	    for (var i = 0; i < dispatchListeners.length; i++) {
	      if (event.isPropagationStopped()) {
	        break;
	      }
	      // Listeners and Instances are two parallel arrays that are always in sync.
	      executeDispatch(event, simulated, dispatchListeners[i], dispatchInstances[i]);
	    }
	  } else if (dispatchListeners) {
	    executeDispatch(event, simulated, dispatchListeners, dispatchInstances);
	  }
	  event._dispatchListeners = null;
	  event._dispatchInstances = null;
	}
	
	/**
	 * Standard/simple iteration through an event's collected dispatches, but stops
	 * at the first dispatch execution returning true, and returns that id.
	 *
	 * @return {?string} id of the first dispatch execution who's listener returns
	 * true, or null if no listener returned true.
	 */
	function executeDispatchesInOrderStopAtTrueImpl(event) {
	  var dispatchListeners = event._dispatchListeners;
	  var dispatchInstances = event._dispatchInstances;
	  if (false) {
	    validateEventDispatches(event);
	  }
	  if (Array.isArray(dispatchListeners)) {
	    for (var i = 0; i < dispatchListeners.length; i++) {
	      if (event.isPropagationStopped()) {
	        break;
	      }
	      // Listeners and Instances are two parallel arrays that are always in sync.
	      if (dispatchListeners[i](event, dispatchInstances[i])) {
	        return dispatchInstances[i];
	      }
	    }
	  } else if (dispatchListeners) {
	    if (dispatchListeners(event, dispatchInstances)) {
	      return dispatchInstances;
	    }
	  }
	  return null;
	}
	
	/**
	 * @see executeDispatchesInOrderStopAtTrueImpl
	 */
	function executeDispatchesInOrderStopAtTrue(event) {
	  var ret = executeDispatchesInOrderStopAtTrueImpl(event);
	  event._dispatchInstances = null;
	  event._dispatchListeners = null;
	  return ret;
	}
	
	/**
	 * Execution of a "direct" dispatch - there must be at most one dispatch
	 * accumulated on the event or it is considered an error. It doesn't really make
	 * sense for an event with multiple dispatches (bubbled) to keep track of the
	 * return values at each dispatch execution, but it does tend to make sense when
	 * dealing with "direct" dispatches.
	 *
	 * @return {*} The return value of executing the single dispatch.
	 */
	function executeDirectDispatch(event) {
	  if (false) {
	    validateEventDispatches(event);
	  }
	  var dispatchListener = event._dispatchListeners;
	  var dispatchInstance = event._dispatchInstances;
	  !!Array.isArray(dispatchListener) ?  false ? invariant(false, 'executeDirectDispatch(...): Invalid `event`.') : _prodInvariant('103') : void 0;
	  event.currentTarget = dispatchListener ? EventPluginUtils.getNodeFromInstance(dispatchInstance) : null;
	  var res = dispatchListener ? dispatchListener(event) : null;
	  event.currentTarget = null;
	  event._dispatchListeners = null;
	  event._dispatchInstances = null;
	  return res;
	}
	
	/**
	 * @param {SyntheticEvent} event
	 * @return {boolean} True iff number of dispatches accumulated is greater than 0.
	 */
	function hasDispatches(event) {
	  return !!event._dispatchListeners;
	}
	
	/**
	 * General utilities that are useful in creating custom Event Plugins.
	 */
	var EventPluginUtils = {
	  isEndish: isEndish,
	  isMoveish: isMoveish,
	  isStartish: isStartish,
	
	  executeDirectDispatch: executeDirectDispatch,
	  executeDispatchesInOrder: executeDispatchesInOrder,
	  executeDispatchesInOrderStopAtTrue: executeDispatchesInOrderStopAtTrue,
	  hasDispatches: hasDispatches,
	
	  getInstanceFromNode: function (node) {
	    return ComponentTree.getInstanceFromNode(node);
	  },
	  getNodeFromInstance: function (node) {
	    return ComponentTree.getNodeFromInstance(node);
	  },
	  isAncestor: function (a, b) {
	    return TreeTraversal.isAncestor(a, b);
	  },
	  getLowestCommonAncestor: function (a, b) {
	    return TreeTraversal.getLowestCommonAncestor(a, b);
	  },
	  getParentInstance: function (inst) {
	    return TreeTraversal.getParentInstance(inst);
	  },
	  traverseTwoPhase: function (target, fn, arg) {
	    return TreeTraversal.traverseTwoPhase(target, fn, arg);
	  },
	  traverseEnterLeave: function (from, to, fn, argFrom, argTo) {
	    return TreeTraversal.traverseEnterLeave(from, to, fn, argFrom, argTo);
	  },
	
	  injection: injection
	};
	
	module.exports = EventPluginUtils;

/***/ },
/* 56 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule KeyEscapeUtils
	 * 
	 */
	
	'use strict';
	
	/**
	 * Escape and wrap key so it is safe to use as a reactid
	 *
	 * @param {string} key to be escaped.
	 * @return {string} the escaped key.
	 */
	
	function escape(key) {
	  var escapeRegex = /[=:]/g;
	  var escaperLookup = {
	    '=': '=0',
	    ':': '=2'
	  };
	  var escapedString = ('' + key).replace(escapeRegex, function (match) {
	    return escaperLookup[match];
	  });
	
	  return '$' + escapedString;
	}
	
	/**
	 * Unescape and unwrap key for human-readable display
	 *
	 * @param {string} key to unescape.
	 * @return {string} the unescaped key.
	 */
	function unescape(key) {
	  var unescapeRegex = /(=0|=2)/g;
	  var unescaperLookup = {
	    '=0': '=',
	    '=2': ':'
	  };
	  var keySubstring = key[0] === '.' && key[1] === '$' ? key.substring(2) : key.substring(1);
	
	  return ('' + keySubstring).replace(unescapeRegex, function (match) {
	    return unescaperLookup[match];
	  });
	}
	
	var KeyEscapeUtils = {
	  escape: escape,
	  unescape: unescape
	};
	
	module.exports = KeyEscapeUtils;

/***/ },
/* 57 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule LinkedValueUtils
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(3);
	
	var ReactPropTypes = __webpack_require__(116);
	var ReactPropTypeLocations = __webpack_require__(64);
	var ReactPropTypesSecret = __webpack_require__(65);
	
	var invariant = __webpack_require__(2);
	var warning = __webpack_require__(4);
	
	var hasReadOnlyValue = {
	  'button': true,
	  'checkbox': true,
	  'image': true,
	  'hidden': true,
	  'radio': true,
	  'reset': true,
	  'submit': true
	};
	
	function _assertSingleLink(inputProps) {
	  !(inputProps.checkedLink == null || inputProps.valueLink == null) ?  false ? invariant(false, 'Cannot provide a checkedLink and a valueLink. If you want to use checkedLink, you probably don\'t want to use valueLink and vice versa.') : _prodInvariant('87') : void 0;
	}
	function _assertValueLink(inputProps) {
	  _assertSingleLink(inputProps);
	  !(inputProps.value == null && inputProps.onChange == null) ?  false ? invariant(false, 'Cannot provide a valueLink and a value or onChange event. If you want to use value or onChange, you probably don\'t want to use valueLink.') : _prodInvariant('88') : void 0;
	}
	
	function _assertCheckedLink(inputProps) {
	  _assertSingleLink(inputProps);
	  !(inputProps.checked == null && inputProps.onChange == null) ?  false ? invariant(false, 'Cannot provide a checkedLink and a checked property or onChange event. If you want to use checked or onChange, you probably don\'t want to use checkedLink') : _prodInvariant('89') : void 0;
	}
	
	var propTypes = {
	  value: function (props, propName, componentName) {
	    if (!props[propName] || hasReadOnlyValue[props.type] || props.onChange || props.readOnly || props.disabled) {
	      return null;
	    }
	    return new Error('You provided a `value` prop to a form field without an ' + '`onChange` handler. This will render a read-only field. If ' + 'the field should be mutable use `defaultValue`. Otherwise, ' + 'set either `onChange` or `readOnly`.');
	  },
	  checked: function (props, propName, componentName) {
	    if (!props[propName] || props.onChange || props.readOnly || props.disabled) {
	      return null;
	    }
	    return new Error('You provided a `checked` prop to a form field without an ' + '`onChange` handler. This will render a read-only field. If ' + 'the field should be mutable use `defaultChecked`. Otherwise, ' + 'set either `onChange` or `readOnly`.');
	  },
	  onChange: ReactPropTypes.func
	};
	
	var loggedTypeFailures = {};
	function getDeclarationErrorAddendum(owner) {
	  if (owner) {
	    var name = owner.getName();
	    if (name) {
	      return ' Check the render method of `' + name + '`.';
	    }
	  }
	  return '';
	}
	
	/**
	 * Provide a linked `value` attribute for controlled forms. You should not use
	 * this outside of the ReactDOM controlled form components.
	 */
	var LinkedValueUtils = {
	  checkPropTypes: function (tagName, props, owner) {
	    for (var propName in propTypes) {
	      if (propTypes.hasOwnProperty(propName)) {
	        var error = propTypes[propName](props, propName, tagName, ReactPropTypeLocations.prop, null, ReactPropTypesSecret);
	      }
	      if (error instanceof Error && !(error.message in loggedTypeFailures)) {
	        // Only monitor this failure once because there tends to be a lot of the
	        // same error.
	        loggedTypeFailures[error.message] = true;
	
	        var addendum = getDeclarationErrorAddendum(owner);
	         false ? warning(false, 'Failed form propType: %s%s', error.message, addendum) : void 0;
	      }
	    }
	  },
	
	  /**
	   * @param {object} inputProps Props for form component
	   * @return {*} current value of the input either from value prop or link.
	   */
	  getValue: function (inputProps) {
	    if (inputProps.valueLink) {
	      _assertValueLink(inputProps);
	      return inputProps.valueLink.value;
	    }
	    return inputProps.value;
	  },
	
	  /**
	   * @param {object} inputProps Props for form component
	   * @return {*} current checked status of the input either from checked prop
	   *             or link.
	   */
	  getChecked: function (inputProps) {
	    if (inputProps.checkedLink) {
	      _assertCheckedLink(inputProps);
	      return inputProps.checkedLink.value;
	    }
	    return inputProps.checked;
	  },
	
	  /**
	   * @param {object} inputProps Props for form component
	   * @param {SyntheticEvent} event change event to handle
	   */
	  executeOnChange: function (inputProps, event) {
	    if (inputProps.valueLink) {
	      _assertValueLink(inputProps);
	      return inputProps.valueLink.requestChange(event.target.value);
	    } else if (inputProps.checkedLink) {
	      _assertCheckedLink(inputProps);
	      return inputProps.checkedLink.requestChange(event.target.checked);
	    } else if (inputProps.onChange) {
	      return inputProps.onChange.call(undefined, event);
	    }
	  }
	};
	
	module.exports = LinkedValueUtils;

/***/ },
/* 58 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactComponent
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(3);
	
	var ReactNoopUpdateQueue = __webpack_require__(62);
	
	var canDefineProperty = __webpack_require__(120);
	var emptyObject = __webpack_require__(30);
	var invariant = __webpack_require__(2);
	var warning = __webpack_require__(4);
	
	/**
	 * Base class helpers for the updating state of a component.
	 */
	function ReactComponent(props, context, updater) {
	  this.props = props;
	  this.context = context;
	  this.refs = emptyObject;
	  // We initialize the default updater but the real one gets injected by the
	  // renderer.
	  this.updater = updater || ReactNoopUpdateQueue;
	}
	
	ReactComponent.prototype.isReactComponent = {};
	
	/**
	 * Sets a subset of the state. Always use this to mutate
	 * state. You should treat `this.state` as immutable.
	 *
	 * There is no guarantee that `this.state` will be immediately updated, so
	 * accessing `this.state` after calling this method may return the old value.
	 *
	 * There is no guarantee that calls to `setState` will run synchronously,
	 * as they may eventually be batched together.  You can provide an optional
	 * callback that will be executed when the call to setState is actually
	 * completed.
	 *
	 * When a function is provided to setState, it will be called at some point in
	 * the future (not synchronously). It will be called with the up to date
	 * component arguments (state, props, context). These values can be different
	 * from this.* because your function may be called after receiveProps but before
	 * shouldComponentUpdate, and this new state, props, and context will not yet be
	 * assigned to this.
	 *
	 * @param {object|function} partialState Next partial state or function to
	 *        produce next partial state to be merged with current state.
	 * @param {?function} callback Called after state is updated.
	 * @final
	 * @protected
	 */
	ReactComponent.prototype.setState = function (partialState, callback) {
	  !(typeof partialState === 'object' || typeof partialState === 'function' || partialState == null) ?  false ? invariant(false, 'setState(...): takes an object of state variables to update or a function which returns an object of state variables.') : _prodInvariant('85') : void 0;
	  this.updater.enqueueSetState(this, partialState);
	  if (callback) {
	    this.updater.enqueueCallback(this, callback, 'setState');
	  }
	};
	
	/**
	 * Forces an update. This should only be invoked when it is known with
	 * certainty that we are **not** in a DOM transaction.
	 *
	 * You may want to call this when you know that some deeper aspect of the
	 * component's state has changed but `setState` was not called.
	 *
	 * This will not invoke `shouldComponentUpdate`, but it will invoke
	 * `componentWillUpdate` and `componentDidUpdate`.
	 *
	 * @param {?function} callback Called after update is complete.
	 * @final
	 * @protected
	 */
	ReactComponent.prototype.forceUpdate = function (callback) {
	  this.updater.enqueueForceUpdate(this);
	  if (callback) {
	    this.updater.enqueueCallback(this, callback, 'forceUpdate');
	  }
	};
	
	/**
	 * Deprecated APIs. These APIs used to exist on classic React classes but since
	 * we would like to deprecate them, we're not going to move them over to this
	 * modern base class. Instead, we define a getter that warns if it's accessed.
	 */
	if (false) {
	  var deprecatedAPIs = {
	    isMounted: ['isMounted', 'Instead, make sure to clean up subscriptions and pending requests in ' + 'componentWillUnmount to prevent memory leaks.'],
	    replaceState: ['replaceState', 'Refactor your code to use setState instead (see ' + 'https://github.com/facebook/react/issues/3236).']
	  };
	  var defineDeprecationWarning = function (methodName, info) {
	    if (canDefineProperty) {
	      Object.defineProperty(ReactComponent.prototype, methodName, {
	        get: function () {
	          process.env.NODE_ENV !== 'production' ? warning(false, '%s(...) is deprecated in plain JavaScript React classes. %s', info[0], info[1]) : void 0;
	          return undefined;
	        }
	      });
	    }
	  };
	  for (var fnName in deprecatedAPIs) {
	    if (deprecatedAPIs.hasOwnProperty(fnName)) {
	      defineDeprecationWarning(fnName, deprecatedAPIs[fnName]);
	    }
	  }
	}
	
	module.exports = ReactComponent;

/***/ },
/* 59 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactComponentEnvironment
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(3);
	
	var invariant = __webpack_require__(2);
	
	var injected = false;
	
	var ReactComponentEnvironment = {
	
	  /**
	   * Optionally injectable hook for swapping out mount images in the middle of
	   * the tree.
	   */
	  replaceNodeWithMarkup: null,
	
	  /**
	   * Optionally injectable hook for processing a queue of child updates. Will
	   * later move into MultiChildComponents.
	   */
	  processChildrenUpdates: null,
	
	  injection: {
	    injectEnvironment: function (environment) {
	      !!injected ?  false ? invariant(false, 'ReactCompositeComponent: injectEnvironment() can only be called once.') : _prodInvariant('104') : void 0;
	      ReactComponentEnvironment.replaceNodeWithMarkup = environment.replaceNodeWithMarkup;
	      ReactComponentEnvironment.processChildrenUpdates = environment.processChildrenUpdates;
	      injected = true;
	    }
	  }
	
	};
	
	module.exports = ReactComponentEnvironment;

/***/ },
/* 60 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2016-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactComponentTreeHook
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(3);
	
	var ReactCurrentOwner = __webpack_require__(23);
	
	var invariant = __webpack_require__(2);
	var warning = __webpack_require__(4);
	
	function isNative(fn) {
	  // Based on isNative() from Lodash
	  var funcToString = Function.prototype.toString;
	  var hasOwnProperty = Object.prototype.hasOwnProperty;
	  var reIsNative = RegExp('^' + funcToString
	  // Take an example native function source for comparison
	  .call(hasOwnProperty)
	  // Strip regex characters so we can use it for regex
	  .replace(/[\\^$.*+?()[\]{}|]/g, '\\$&')
	  // Remove hasOwnProperty from the template to make it generic
	  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');
	  try {
	    var source = funcToString.call(fn);
	    return reIsNative.test(source);
	  } catch (err) {
	    return false;
	  }
	}
	
	var canUseCollections =
	// Array.from
	typeof Array.from === 'function' &&
	// Map
	typeof Map === 'function' && isNative(Map) &&
	// Map.prototype.keys
	Map.prototype != null && typeof Map.prototype.keys === 'function' && isNative(Map.prototype.keys) &&
	// Set
	typeof Set === 'function' && isNative(Set) &&
	// Set.prototype.keys
	Set.prototype != null && typeof Set.prototype.keys === 'function' && isNative(Set.prototype.keys);
	
	var itemMap;
	var rootIDSet;
	
	var itemByKey;
	var rootByKey;
	
	if (canUseCollections) {
	  itemMap = new Map();
	  rootIDSet = new Set();
	} else {
	  itemByKey = {};
	  rootByKey = {};
	}
	
	var unmountedIDs = [];
	
	// Use non-numeric keys to prevent V8 performance issues:
	// https://github.com/facebook/react/pull/7232
	function getKeyFromID(id) {
	  return '.' + id;
	}
	function getIDFromKey(key) {
	  return parseInt(key.substr(1), 10);
	}
	
	function get(id) {
	  if (canUseCollections) {
	    return itemMap.get(id);
	  } else {
	    var key = getKeyFromID(id);
	    return itemByKey[key];
	  }
	}
	
	function remove(id) {
	  if (canUseCollections) {
	    itemMap['delete'](id);
	  } else {
	    var key = getKeyFromID(id);
	    delete itemByKey[key];
	  }
	}
	
	function create(id, element, parentID) {
	  var item = {
	    element: element,
	    parentID: parentID,
	    text: null,
	    childIDs: [],
	    isMounted: false,
	    updateCount: 0
	  };
	
	  if (canUseCollections) {
	    itemMap.set(id, item);
	  } else {
	    var key = getKeyFromID(id);
	    itemByKey[key] = item;
	  }
	}
	
	function addRoot(id) {
	  if (canUseCollections) {
	    rootIDSet.add(id);
	  } else {
	    var key = getKeyFromID(id);
	    rootByKey[key] = true;
	  }
	}
	
	function removeRoot(id) {
	  if (canUseCollections) {
	    rootIDSet['delete'](id);
	  } else {
	    var key = getKeyFromID(id);
	    delete rootByKey[key];
	  }
	}
	
	function getRegisteredIDs() {
	  if (canUseCollections) {
	    return Array.from(itemMap.keys());
	  } else {
	    return Object.keys(itemByKey).map(getIDFromKey);
	  }
	}
	
	function getRootIDs() {
	  if (canUseCollections) {
	    return Array.from(rootIDSet.keys());
	  } else {
	    return Object.keys(rootByKey).map(getIDFromKey);
	  }
	}
	
	function purgeDeep(id) {
	  var item = get(id);
	  if (item) {
	    var childIDs = item.childIDs;
	
	    remove(id);
	    childIDs.forEach(purgeDeep);
	  }
	}
	
	function describeComponentFrame(name, source, ownerName) {
	  return '\n    in ' + name + (source ? ' (at ' + source.fileName.replace(/^.*[\\\/]/, '') + ':' + source.lineNumber + ')' : ownerName ? ' (created by ' + ownerName + ')' : '');
	}
	
	function getDisplayName(element) {
	  if (element == null) {
	    return '#empty';
	  } else if (typeof element === 'string' || typeof element === 'number') {
	    return '#text';
	  } else if (typeof element.type === 'string') {
	    return element.type;
	  } else {
	    return element.type.displayName || element.type.name || 'Unknown';
	  }
	}
	
	function describeID(id) {
	  var name = ReactComponentTreeHook.getDisplayName(id);
	  var element = ReactComponentTreeHook.getElement(id);
	  var ownerID = ReactComponentTreeHook.getOwnerID(id);
	  var ownerName;
	  if (ownerID) {
	    ownerName = ReactComponentTreeHook.getDisplayName(ownerID);
	  }
	   false ? warning(element, 'ReactComponentTreeHook: Missing React element for debugID %s when ' + 'building stack', id) : void 0;
	  return describeComponentFrame(name, element && element._source, ownerName);
	}
	
	var ReactComponentTreeHook = {
	  onSetChildren: function (id, nextChildIDs) {
	    var item = get(id);
	    item.childIDs = nextChildIDs;
	
	    for (var i = 0; i < nextChildIDs.length; i++) {
	      var nextChildID = nextChildIDs[i];
	      var nextChild = get(nextChildID);
	      !nextChild ?  false ? invariant(false, 'Expected hook events to fire for the child before its parent includes it in onSetChildren().') : _prodInvariant('140') : void 0;
	      !(nextChild.childIDs != null || typeof nextChild.element !== 'object' || nextChild.element == null) ?  false ? invariant(false, 'Expected onSetChildren() to fire for a container child before its parent includes it in onSetChildren().') : _prodInvariant('141') : void 0;
	      !nextChild.isMounted ?  false ? invariant(false, 'Expected onMountComponent() to fire for the child before its parent includes it in onSetChildren().') : _prodInvariant('71') : void 0;
	      if (nextChild.parentID == null) {
	        nextChild.parentID = id;
	        // TODO: This shouldn't be necessary but mounting a new root during in
	        // componentWillMount currently causes not-yet-mounted components to
	        // be purged from our tree data so their parent ID is missing.
	      }
	      !(nextChild.parentID === id) ?  false ? invariant(false, 'Expected onBeforeMountComponent() parent and onSetChildren() to be consistent (%s has parents %s and %s).', nextChildID, nextChild.parentID, id) : _prodInvariant('142', nextChildID, nextChild.parentID, id) : void 0;
	    }
	  },
	  onBeforeMountComponent: function (id, element, parentID) {
	    create(id, element, parentID);
	  },
	  onBeforeUpdateComponent: function (id, element) {
	    var item = get(id);
	    if (!item || !item.isMounted) {
	      // We may end up here as a result of setState() in componentWillUnmount().
	      // In this case, ignore the element.
	      return;
	    }
	    item.element = element;
	  },
	  onMountComponent: function (id) {
	    var item = get(id);
	    item.isMounted = true;
	    var isRoot = item.parentID === 0;
	    if (isRoot) {
	      addRoot(id);
	    }
	  },
	  onUpdateComponent: function (id) {
	    var item = get(id);
	    if (!item || !item.isMounted) {
	      // We may end up here as a result of setState() in componentWillUnmount().
	      // In this case, ignore the element.
	      return;
	    }
	    item.updateCount++;
	  },
	  onUnmountComponent: function (id) {
	    var item = get(id);
	    if (item) {
	      // We need to check if it exists.
	      // `item` might not exist if it is inside an error boundary, and a sibling
	      // error boundary child threw while mounting. Then this instance never
	      // got a chance to mount, but it still gets an unmounting event during
	      // the error boundary cleanup.
	      item.isMounted = false;
	      var isRoot = item.parentID === 0;
	      if (isRoot) {
	        removeRoot(id);
	      }
	    }
	    unmountedIDs.push(id);
	  },
	  purgeUnmountedComponents: function () {
	    if (ReactComponentTreeHook._preventPurging) {
	      // Should only be used for testing.
	      return;
	    }
	
	    for (var i = 0; i < unmountedIDs.length; i++) {
	      var id = unmountedIDs[i];
	      purgeDeep(id);
	    }
	    unmountedIDs.length = 0;
	  },
	  isMounted: function (id) {
	    var item = get(id);
	    return item ? item.isMounted : false;
	  },
	  getCurrentStackAddendum: function (topElement) {
	    var info = '';
	    if (topElement) {
	      var type = topElement.type;
	      var name = typeof type === 'function' ? type.displayName || type.name : type;
	      var owner = topElement._owner;
	      info += describeComponentFrame(name || 'Unknown', topElement._source, owner && owner.getName());
	    }
	
	    var currentOwner = ReactCurrentOwner.current;
	    var id = currentOwner && currentOwner._debugID;
	
	    info += ReactComponentTreeHook.getStackAddendumByID(id);
	    return info;
	  },
	  getStackAddendumByID: function (id) {
	    var info = '';
	    while (id) {
	      info += describeID(id);
	      id = ReactComponentTreeHook.getParentID(id);
	    }
	    return info;
	  },
	  getChildIDs: function (id) {
	    var item = get(id);
	    return item ? item.childIDs : [];
	  },
	  getDisplayName: function (id) {
	    var element = ReactComponentTreeHook.getElement(id);
	    if (!element) {
	      return null;
	    }
	    return getDisplayName(element);
	  },
	  getElement: function (id) {
	    var item = get(id);
	    return item ? item.element : null;
	  },
	  getOwnerID: function (id) {
	    var element = ReactComponentTreeHook.getElement(id);
	    if (!element || !element._owner) {
	      return null;
	    }
	    return element._owner._debugID;
	  },
	  getParentID: function (id) {
	    var item = get(id);
	    return item ? item.parentID : null;
	  },
	  getSource: function (id) {
	    var item = get(id);
	    var element = item ? item.element : null;
	    var source = element != null ? element._source : null;
	    return source;
	  },
	  getText: function (id) {
	    var element = ReactComponentTreeHook.getElement(id);
	    if (typeof element === 'string') {
	      return element;
	    } else if (typeof element === 'number') {
	      return '' + element;
	    } else {
	      return null;
	    }
	  },
	  getUpdateCount: function (id) {
	    var item = get(id);
	    return item ? item.updateCount : 0;
	  },
	
	
	  getRegisteredIDs: getRegisteredIDs,
	
	  getRootIDs: getRootIDs
	};
	
	module.exports = ReactComponentTreeHook;

/***/ },
/* 61 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactErrorUtils
	 */
	
	'use strict';
	
	var caughtError = null;
	
	/**
	 * Call a function while guarding against errors that happens within it.
	 *
	 * @param {?String} name of the guard to use for logging or debugging
	 * @param {Function} func The function to invoke
	 * @param {*} a First argument
	 * @param {*} b Second argument
	 */
	function invokeGuardedCallback(name, func, a, b) {
	  try {
	    return func(a, b);
	  } catch (x) {
	    if (caughtError === null) {
	      caughtError = x;
	    }
	    return undefined;
	  }
	}
	
	var ReactErrorUtils = {
	  invokeGuardedCallback: invokeGuardedCallback,
	
	  /**
	   * Invoked by ReactTestUtils.Simulate so that any errors thrown by the event
	   * handler are sure to be rethrown by rethrowCaughtError.
	   */
	  invokeGuardedCallbackWithCatch: invokeGuardedCallback,
	
	  /**
	   * During execution of guarded functions we will capture the first error which
	   * we will rethrow to be handled by the top level error handler.
	   */
	  rethrowCaughtError: function () {
	    if (caughtError) {
	      var error = caughtError;
	      caughtError = null;
	      throw error;
	    }
	  }
	};
	
	if (false) {
	  /**
	   * To help development we can get better devtools integration by simulating a
	   * real browser event.
	   */
	  if (typeof window !== 'undefined' && typeof window.dispatchEvent === 'function' && typeof document !== 'undefined' && typeof document.createEvent === 'function') {
	    var fakeNode = document.createElement('react');
	    ReactErrorUtils.invokeGuardedCallback = function (name, func, a, b) {
	      var boundFunc = func.bind(null, a, b);
	      var evtType = 'react-' + name;
	      fakeNode.addEventListener(evtType, boundFunc, false);
	      var evt = document.createEvent('Event');
	      evt.initEvent(evtType, false, false);
	      fakeNode.dispatchEvent(evt);
	      fakeNode.removeEventListener(evtType, boundFunc, false);
	    };
	  }
	}
	
	module.exports = ReactErrorUtils;

/***/ },
/* 62 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactNoopUpdateQueue
	 */
	
	'use strict';
	
	var warning = __webpack_require__(4);
	
	function warnNoop(publicInstance, callerName) {
	  if (false) {
	    var constructor = publicInstance.constructor;
	    process.env.NODE_ENV !== 'production' ? warning(false, '%s(...): Can only update a mounted or mounting component. ' + 'This usually means you called %s() on an unmounted component. ' + 'This is a no-op. Please check the code for the %s component.', callerName, callerName, constructor && (constructor.displayName || constructor.name) || 'ReactClass') : void 0;
	  }
	}
	
	/**
	 * This is the abstract API for an update queue.
	 */
	var ReactNoopUpdateQueue = {
	
	  /**
	   * Checks whether or not this composite component is mounted.
	   * @param {ReactClass} publicInstance The instance we want to test.
	   * @return {boolean} True if mounted, false otherwise.
	   * @protected
	   * @final
	   */
	  isMounted: function (publicInstance) {
	    return false;
	  },
	
	  /**
	   * Enqueue a callback that will be executed after all the pending updates
	   * have processed.
	   *
	   * @param {ReactClass} publicInstance The instance to use as `this` context.
	   * @param {?function} callback Called after state is updated.
	   * @internal
	   */
	  enqueueCallback: function (publicInstance, callback) {},
	
	  /**
	   * Forces an update. This should only be invoked when it is known with
	   * certainty that we are **not** in a DOM transaction.
	   *
	   * You may want to call this when you know that some deeper aspect of the
	   * component's state has changed but `setState` was not called.
	   *
	   * This will not invoke `shouldComponentUpdate`, but it will invoke
	   * `componentWillUpdate` and `componentDidUpdate`.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @internal
	   */
	  enqueueForceUpdate: function (publicInstance) {
	    warnNoop(publicInstance, 'forceUpdate');
	  },
	
	  /**
	   * Replaces all of the state. Always use this or `setState` to mutate state.
	   * You should treat `this.state` as immutable.
	   *
	   * There is no guarantee that `this.state` will be immediately updated, so
	   * accessing `this.state` after calling this method may return the old value.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object} completeState Next state.
	   * @internal
	   */
	  enqueueReplaceState: function (publicInstance, completeState) {
	    warnNoop(publicInstance, 'replaceState');
	  },
	
	  /**
	   * Sets a subset of the state. This only exists because _pendingState is
	   * internal. This provides a merging strategy that is not available to deep
	   * properties which is confusing. TODO: Expose pendingState or don't use it
	   * during the merge.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object} partialState Next partial state to be merged with state.
	   * @internal
	   */
	  enqueueSetState: function (publicInstance, partialState) {
	    warnNoop(publicInstance, 'setState');
	  }
	};
	
	module.exports = ReactNoopUpdateQueue;

/***/ },
/* 63 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactPropTypeLocationNames
	 */
	
	'use strict';
	
	var ReactPropTypeLocationNames = {};
	
	if (false) {
	  ReactPropTypeLocationNames = {
	    prop: 'prop',
	    context: 'context',
	    childContext: 'child context'
	  };
	}
	
	module.exports = ReactPropTypeLocationNames;

/***/ },
/* 64 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactPropTypeLocations
	 */
	
	'use strict';
	
	var keyMirror = __webpack_require__(39);
	
	var ReactPropTypeLocations = keyMirror({
	  prop: null,
	  context: null,
	  childContext: null
	});
	
	module.exports = ReactPropTypeLocations;

/***/ },
/* 65 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactPropTypesSecret
	 */
	
	'use strict';
	
	var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
	
	module.exports = ReactPropTypesSecret;

/***/ },
/* 66 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactUpdateQueue
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(3);
	
	var ReactCurrentOwner = __webpack_require__(23);
	var ReactInstanceMap = __webpack_require__(36);
	var ReactInstrumentation = __webpack_require__(11);
	var ReactUpdates = __webpack_require__(14);
	
	var invariant = __webpack_require__(2);
	var warning = __webpack_require__(4);
	
	function enqueueUpdate(internalInstance) {
	  ReactUpdates.enqueueUpdate(internalInstance);
	}
	
	function formatUnexpectedArgument(arg) {
	  var type = typeof arg;
	  if (type !== 'object') {
	    return type;
	  }
	  var displayName = arg.constructor && arg.constructor.name || type;
	  var keys = Object.keys(arg);
	  if (keys.length > 0 && keys.length < 20) {
	    return displayName + ' (keys: ' + keys.join(', ') + ')';
	  }
	  return displayName;
	}
	
	function getInternalInstanceReadyForUpdate(publicInstance, callerName) {
	  var internalInstance = ReactInstanceMap.get(publicInstance);
	  if (!internalInstance) {
	    if (false) {
	      var ctor = publicInstance.constructor;
	      // Only warn when we have a callerName. Otherwise we should be silent.
	      // We're probably calling from enqueueCallback. We don't want to warn
	      // there because we already warned for the corresponding lifecycle method.
	      process.env.NODE_ENV !== 'production' ? warning(!callerName, '%s(...): Can only update a mounted or mounting component. ' + 'This usually means you called %s() on an unmounted component. ' + 'This is a no-op. Please check the code for the %s component.', callerName, callerName, ctor && (ctor.displayName || ctor.name) || 'ReactClass') : void 0;
	    }
	    return null;
	  }
	
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(ReactCurrentOwner.current == null, '%s(...): Cannot update during an existing state transition (such as ' + 'within `render` or another component\'s constructor). Render methods ' + 'should be a pure function of props and state; constructor ' + 'side-effects are an anti-pattern, but can be moved to ' + '`componentWillMount`.', callerName) : void 0;
	  }
	
	  return internalInstance;
	}
	
	/**
	 * ReactUpdateQueue allows for state updates to be scheduled into a later
	 * reconciliation step.
	 */
	var ReactUpdateQueue = {
	
	  /**
	   * Checks whether or not this composite component is mounted.
	   * @param {ReactClass} publicInstance The instance we want to test.
	   * @return {boolean} True if mounted, false otherwise.
	   * @protected
	   * @final
	   */
	  isMounted: function (publicInstance) {
	    if (false) {
	      var owner = ReactCurrentOwner.current;
	      if (owner !== null) {
	        process.env.NODE_ENV !== 'production' ? warning(owner._warnedAboutRefsInRender, '%s is accessing isMounted inside its render() function. ' + 'render() should be a pure function of props and state. It should ' + 'never access something that requires stale data from the previous ' + 'render, such as refs. Move this logic to componentDidMount and ' + 'componentDidUpdate instead.', owner.getName() || 'A component') : void 0;
	        owner._warnedAboutRefsInRender = true;
	      }
	    }
	    var internalInstance = ReactInstanceMap.get(publicInstance);
	    if (internalInstance) {
	      // During componentWillMount and render this will still be null but after
	      // that will always render to something. At least for now. So we can use
	      // this hack.
	      return !!internalInstance._renderedComponent;
	    } else {
	      return false;
	    }
	  },
	
	  /**
	   * Enqueue a callback that will be executed after all the pending updates
	   * have processed.
	   *
	   * @param {ReactClass} publicInstance The instance to use as `this` context.
	   * @param {?function} callback Called after state is updated.
	   * @param {string} callerName Name of the calling function in the public API.
	   * @internal
	   */
	  enqueueCallback: function (publicInstance, callback, callerName) {
	    ReactUpdateQueue.validateCallback(callback, callerName);
	    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance);
	
	    // Previously we would throw an error if we didn't have an internal
	    // instance. Since we want to make it a no-op instead, we mirror the same
	    // behavior we have in other enqueue* methods.
	    // We also need to ignore callbacks in componentWillMount. See
	    // enqueueUpdates.
	    if (!internalInstance) {
	      return null;
	    }
	
	    if (internalInstance._pendingCallbacks) {
	      internalInstance._pendingCallbacks.push(callback);
	    } else {
	      internalInstance._pendingCallbacks = [callback];
	    }
	    // TODO: The callback here is ignored when setState is called from
	    // componentWillMount. Either fix it or disallow doing so completely in
	    // favor of getInitialState. Alternatively, we can disallow
	    // componentWillMount during server-side rendering.
	    enqueueUpdate(internalInstance);
	  },
	
	  enqueueCallbackInternal: function (internalInstance, callback) {
	    if (internalInstance._pendingCallbacks) {
	      internalInstance._pendingCallbacks.push(callback);
	    } else {
	      internalInstance._pendingCallbacks = [callback];
	    }
	    enqueueUpdate(internalInstance);
	  },
	
	  /**
	   * Forces an update. This should only be invoked when it is known with
	   * certainty that we are **not** in a DOM transaction.
	   *
	   * You may want to call this when you know that some deeper aspect of the
	   * component's state has changed but `setState` was not called.
	   *
	   * This will not invoke `shouldComponentUpdate`, but it will invoke
	   * `componentWillUpdate` and `componentDidUpdate`.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @internal
	   */
	  enqueueForceUpdate: function (publicInstance) {
	    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance, 'forceUpdate');
	
	    if (!internalInstance) {
	      return;
	    }
	
	    internalInstance._pendingForceUpdate = true;
	
	    enqueueUpdate(internalInstance);
	  },
	
	  /**
	   * Replaces all of the state. Always use this or `setState` to mutate state.
	   * You should treat `this.state` as immutable.
	   *
	   * There is no guarantee that `this.state` will be immediately updated, so
	   * accessing `this.state` after calling this method may return the old value.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object} completeState Next state.
	   * @internal
	   */
	  enqueueReplaceState: function (publicInstance, completeState) {
	    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance, 'replaceState');
	
	    if (!internalInstance) {
	      return;
	    }
	
	    internalInstance._pendingStateQueue = [completeState];
	    internalInstance._pendingReplaceState = true;
	
	    enqueueUpdate(internalInstance);
	  },
	
	  /**
	   * Sets a subset of the state. This only exists because _pendingState is
	   * internal. This provides a merging strategy that is not available to deep
	   * properties which is confusing. TODO: Expose pendingState or don't use it
	   * during the merge.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object} partialState Next partial state to be merged with state.
	   * @internal
	   */
	  enqueueSetState: function (publicInstance, partialState) {
	    if (false) {
	      ReactInstrumentation.debugTool.onSetState();
	      process.env.NODE_ENV !== 'production' ? warning(partialState != null, 'setState(...): You passed an undefined or null state object; ' + 'instead, use forceUpdate().') : void 0;
	    }
	
	    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance, 'setState');
	
	    if (!internalInstance) {
	      return;
	    }
	
	    var queue = internalInstance._pendingStateQueue || (internalInstance._pendingStateQueue = []);
	    queue.push(partialState);
	
	    enqueueUpdate(internalInstance);
	  },
	
	  enqueueElementInternal: function (internalInstance, nextElement, nextContext) {
	    internalInstance._pendingElement = nextElement;
	    // TODO: introduce _pendingContext instead of setting it directly.
	    internalInstance._context = nextContext;
	    enqueueUpdate(internalInstance);
	  },
	
	  validateCallback: function (callback, callerName) {
	    !(!callback || typeof callback === 'function') ?  false ? invariant(false, '%s(...): Expected the last optional `callback` argument to be a function. Instead received: %s.', callerName, formatUnexpectedArgument(callback)) : _prodInvariant('122', callerName, formatUnexpectedArgument(callback)) : void 0;
	  }
	
	};
	
	module.exports = ReactUpdateQueue;

/***/ },
/* 67 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule createMicrosoftUnsafeLocalFunction
	 */
	
	/* globals MSApp */
	
	'use strict';
	
	/**
	 * Create a function which has 'unsafe' privileges (required by windows8 apps)
	 */
	
	var createMicrosoftUnsafeLocalFunction = function (func) {
	  if (typeof MSApp !== 'undefined' && MSApp.execUnsafeLocalFunction) {
	    return function (arg0, arg1, arg2, arg3) {
	      MSApp.execUnsafeLocalFunction(function () {
	        return func(arg0, arg1, arg2, arg3);
	      });
	    };
	  } else {
	    return func;
	  }
	};
	
	module.exports = createMicrosoftUnsafeLocalFunction;

/***/ },
/* 68 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule getEventCharCode
	 */
	
	'use strict';
	
	/**
	 * `charCode` represents the actual "character code" and is safe to use with
	 * `String.fromCharCode`. As such, only keys that correspond to printable
	 * characters produce a valid `charCode`, the only exception to this is Enter.
	 * The Tab-key is considered non-printable and does not have a `charCode`,
	 * presumably because it does not produce a tab-character in browsers.
	 *
	 * @param {object} nativeEvent Native browser event.
	 * @return {number} Normalized `charCode` property.
	 */
	
	function getEventCharCode(nativeEvent) {
	  var charCode;
	  var keyCode = nativeEvent.keyCode;
	
	  if ('charCode' in nativeEvent) {
	    charCode = nativeEvent.charCode;
	
	    // FF does not set `charCode` for the Enter-key, check against `keyCode`.
	    if (charCode === 0 && keyCode === 13) {
	      charCode = 13;
	    }
	  } else {
	    // IE8 does not implement `charCode`, but `keyCode` has the correct value.
	    charCode = keyCode;
	  }
	
	  // Some non-printable keys are reported in `charCode`/`keyCode`, discard them.
	  // Must not discard the (non-)printable Enter-key.
	  if (charCode >= 32 || charCode === 13) {
	    return charCode;
	  }
	
	  return 0;
	}
	
	module.exports = getEventCharCode;

/***/ },
/* 69 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule getEventModifierState
	 */
	
	'use strict';
	
	/**
	 * Translation from modifier key to the associated property in the event.
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/#keys-Modifiers
	 */
	
	var modifierKeyToProp = {
	  'Alt': 'altKey',
	  'Control': 'ctrlKey',
	  'Meta': 'metaKey',
	  'Shift': 'shiftKey'
	};
	
	// IE8 does not implement getModifierState so we simply map it to the only
	// modifier keys exposed by the event itself, does not support Lock-keys.
	// Currently, all major browsers except Chrome seems to support Lock-keys.
	function modifierStateGetter(keyArg) {
	  var syntheticEvent = this;
	  var nativeEvent = syntheticEvent.nativeEvent;
	  if (nativeEvent.getModifierState) {
	    return nativeEvent.getModifierState(keyArg);
	  }
	  var keyProp = modifierKeyToProp[keyArg];
	  return keyProp ? !!nativeEvent[keyProp] : false;
	}
	
	function getEventModifierState(nativeEvent) {
	  return modifierStateGetter;
	}
	
	module.exports = getEventModifierState;

/***/ },
/* 70 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule getEventTarget
	 */
	
	'use strict';
	
	/**
	 * Gets the target node from a native browser event by accounting for
	 * inconsistencies in browser DOM APIs.
	 *
	 * @param {object} nativeEvent Native browser event.
	 * @return {DOMEventTarget} Target node.
	 */
	
	function getEventTarget(nativeEvent) {
	  var target = nativeEvent.target || nativeEvent.srcElement || window;
	
	  // Normalize SVG <use> element events #4963
	  if (target.correspondingUseElement) {
	    target = target.correspondingUseElement;
	  }
	
	  // Safari may fire events on text nodes (Node.TEXT_NODE is 3).
	  // @see http://www.quirksmode.org/js/events_properties.html
	  return target.nodeType === 3 ? target.parentNode : target;
	}
	
	module.exports = getEventTarget;

/***/ },
/* 71 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule isEventSupported
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(9);
	
	var useHasFeature;
	if (ExecutionEnvironment.canUseDOM) {
	  useHasFeature = document.implementation && document.implementation.hasFeature &&
	  // always returns true in newer browsers as per the standard.
	  // @see http://dom.spec.whatwg.org/#dom-domimplementation-hasfeature
	  document.implementation.hasFeature('', '') !== true;
	}
	
	/**
	 * Checks if an event is supported in the current execution environment.
	 *
	 * NOTE: This will not work correctly for non-generic events such as `change`,
	 * `reset`, `load`, `error`, and `select`.
	 *
	 * Borrows from Modernizr.
	 *
	 * @param {string} eventNameSuffix Event name, e.g. "click".
	 * @param {?boolean} capture Check if the capture phase is supported.
	 * @return {boolean} True if the event is supported.
	 * @internal
	 * @license Modernizr 3.0.0pre (Custom Build) | MIT
	 */
	function isEventSupported(eventNameSuffix, capture) {
	  if (!ExecutionEnvironment.canUseDOM || capture && !('addEventListener' in document)) {
	    return false;
	  }
	
	  var eventName = 'on' + eventNameSuffix;
	  var isSupported = eventName in document;
	
	  if (!isSupported) {
	    var element = document.createElement('div');
	    element.setAttribute(eventName, 'return;');
	    isSupported = typeof element[eventName] === 'function';
	  }
	
	  if (!isSupported && useHasFeature && eventNameSuffix === 'wheel') {
	    // This is the only way to test support for the `wheel` event in IE9+.
	    isSupported = document.implementation.hasFeature('Events.wheel', '3.0');
	  }
	
	  return isSupported;
	}
	
	module.exports = isEventSupported;

/***/ },
/* 72 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule shouldUpdateReactComponent
	 */
	
	'use strict';
	
	/**
	 * Given a `prevElement` and `nextElement`, determines if the existing
	 * instance should be updated as opposed to being destroyed or replaced by a new
	 * instance. Both arguments are elements. This ensures that this logic can
	 * operate on stateless trees without any backing instance.
	 *
	 * @param {?object} prevElement
	 * @param {?object} nextElement
	 * @return {boolean} True if the existing instance should be updated.
	 * @protected
	 */
	
	function shouldUpdateReactComponent(prevElement, nextElement) {
	  var prevEmpty = prevElement === null || prevElement === false;
	  var nextEmpty = nextElement === null || nextElement === false;
	  if (prevEmpty || nextEmpty) {
	    return prevEmpty === nextEmpty;
	  }
	
	  var prevType = typeof prevElement;
	  var nextType = typeof nextElement;
	  if (prevType === 'string' || prevType === 'number') {
	    return nextType === 'string' || nextType === 'number';
	  } else {
	    return nextType === 'object' && prevElement.type === nextElement.type && prevElement.key === nextElement.key;
	  }
	}
	
	module.exports = shouldUpdateReactComponent;

/***/ },
/* 73 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule traverseAllChildren
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(3);
	
	var ReactCurrentOwner = __webpack_require__(23);
	var ReactElement = __webpack_require__(13);
	
	var getIteratorFn = __webpack_require__(123);
	var invariant = __webpack_require__(2);
	var KeyEscapeUtils = __webpack_require__(56);
	var warning = __webpack_require__(4);
	
	var SEPARATOR = '.';
	var SUBSEPARATOR = ':';
	
	/**
	 * TODO: Test that a single child and an array with one item have the same key
	 * pattern.
	 */
	
	var didWarnAboutMaps = false;
	
	/**
	 * Generate a key string that identifies a component within a set.
	 *
	 * @param {*} component A component that could contain a manual key.
	 * @param {number} index Index that is used if a manual key is not provided.
	 * @return {string}
	 */
	function getComponentKey(component, index) {
	  // Do some typechecking here since we call this blindly. We want to ensure
	  // that we don't block potential future ES APIs.
	  if (component && typeof component === 'object' && component.key != null) {
	    // Explicit key
	    return KeyEscapeUtils.escape(component.key);
	  }
	  // Implicit key determined by the index in the set
	  return index.toString(36);
	}
	
	/**
	 * @param {?*} children Children tree container.
	 * @param {!string} nameSoFar Name of the key path so far.
	 * @param {!function} callback Callback to invoke with each child found.
	 * @param {?*} traverseContext Used to pass information throughout the traversal
	 * process.
	 * @return {!number} The number of children in this subtree.
	 */
	function traverseAllChildrenImpl(children, nameSoFar, callback, traverseContext) {
	  var type = typeof children;
	
	  if (type === 'undefined' || type === 'boolean') {
	    // All of the above are perceived as null.
	    children = null;
	  }
	
	  if (children === null || type === 'string' || type === 'number' || ReactElement.isValidElement(children)) {
	    callback(traverseContext, children,
	    // If it's the only child, treat the name as if it was wrapped in an array
	    // so that it's consistent if the number of children grows.
	    nameSoFar === '' ? SEPARATOR + getComponentKey(children, 0) : nameSoFar);
	    return 1;
	  }
	
	  var child;
	  var nextName;
	  var subtreeCount = 0; // Count of children found in the current subtree.
	  var nextNamePrefix = nameSoFar === '' ? SEPARATOR : nameSoFar + SUBSEPARATOR;
	
	  if (Array.isArray(children)) {
	    for (var i = 0; i < children.length; i++) {
	      child = children[i];
	      nextName = nextNamePrefix + getComponentKey(child, i);
	      subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	    }
	  } else {
	    var iteratorFn = getIteratorFn(children);
	    if (iteratorFn) {
	      var iterator = iteratorFn.call(children);
	      var step;
	      if (iteratorFn !== children.entries) {
	        var ii = 0;
	        while (!(step = iterator.next()).done) {
	          child = step.value;
	          nextName = nextNamePrefix + getComponentKey(child, ii++);
	          subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	        }
	      } else {
	        if (false) {
	          var mapsAsChildrenAddendum = '';
	          if (ReactCurrentOwner.current) {
	            var mapsAsChildrenOwnerName = ReactCurrentOwner.current.getName();
	            if (mapsAsChildrenOwnerName) {
	              mapsAsChildrenAddendum = ' Check the render method of `' + mapsAsChildrenOwnerName + '`.';
	            }
	          }
	          process.env.NODE_ENV !== 'production' ? warning(didWarnAboutMaps, 'Using Maps as children is not yet fully supported. It is an ' + 'experimental feature that might be removed. Convert it to a ' + 'sequence / iterable of keyed ReactElements instead.%s', mapsAsChildrenAddendum) : void 0;
	          didWarnAboutMaps = true;
	        }
	        // Iterator will provide entry [k,v] tuples rather than values.
	        while (!(step = iterator.next()).done) {
	          var entry = step.value;
	          if (entry) {
	            child = entry[1];
	            nextName = nextNamePrefix + KeyEscapeUtils.escape(entry[0]) + SUBSEPARATOR + getComponentKey(child, 0);
	            subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	          }
	        }
	      }
	    } else if (type === 'object') {
	      var addendum = '';
	      if (false) {
	        addendum = ' If you meant to render a collection of children, use an array ' + 'instead or wrap the object using createFragment(object) from the ' + 'React add-ons.';
	        if (children._isReactElement) {
	          addendum = ' It looks like you\'re using an element created by a different ' + 'version of React. Make sure to use only one copy of React.';
	        }
	        if (ReactCurrentOwner.current) {
	          var name = ReactCurrentOwner.current.getName();
	          if (name) {
	            addendum += ' Check the render method of `' + name + '`.';
	          }
	        }
	      }
	      var childrenString = String(children);
	       true ?  false ? invariant(false, 'Objects are not valid as a React child (found: %s).%s', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : _prodInvariant('31', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : void 0;
	    }
	  }
	
	  return subtreeCount;
	}
	
	/**
	 * Traverses children that are typically specified as `props.children`, but
	 * might also be specified through attributes:
	 *
	 * - `traverseAllChildren(this.props.children, ...)`
	 * - `traverseAllChildren(this.props.leftPanelChildren, ...)`
	 *
	 * The `traverseContext` is an optional argument that is passed through the
	 * entire traversal. It can be used to store accumulations or anything else that
	 * the callback might find relevant.
	 *
	 * @param {?*} children Children tree object.
	 * @param {!function} callback To invoke upon traversing each child.
	 * @param {?*} traverseContext Context for traversal.
	 * @return {!number} The number of children in this subtree.
	 */
	function traverseAllChildren(children, callback, traverseContext) {
	  if (children == null) {
	    return 0;
	  }
	
	  return traverseAllChildrenImpl(children, '', callback, traverseContext);
	}
	
	module.exports = traverseAllChildren;

/***/ },
/* 74 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule validateDOMNesting
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(6);
	
	var emptyFunction = __webpack_require__(10);
	var warning = __webpack_require__(4);
	
	var validateDOMNesting = emptyFunction;
	
	if (false) {
	  // This validation code was written based on the HTML5 parsing spec:
	  // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-scope
	  //
	  // Note: this does not catch all invalid nesting, nor does it try to (as it's
	  // not clear what practical benefit doing so provides); instead, we warn only
	  // for cases where the parser will give a parse tree differing from what React
	  // intended. For example, <b><div></div></b> is invalid but we don't warn
	  // because it still parses correctly; we do warn for other cases like nested
	  // <p> tags where the beginning of the second element implicitly closes the
	  // first, causing a confusing mess.
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#special
	  var specialTags = ['address', 'applet', 'area', 'article', 'aside', 'base', 'basefont', 'bgsound', 'blockquote', 'body', 'br', 'button', 'caption', 'center', 'col', 'colgroup', 'dd', 'details', 'dir', 'div', 'dl', 'dt', 'embed', 'fieldset', 'figcaption', 'figure', 'footer', 'form', 'frame', 'frameset', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'head', 'header', 'hgroup', 'hr', 'html', 'iframe', 'img', 'input', 'isindex', 'li', 'link', 'listing', 'main', 'marquee', 'menu', 'menuitem', 'meta', 'nav', 'noembed', 'noframes', 'noscript', 'object', 'ol', 'p', 'param', 'plaintext', 'pre', 'script', 'section', 'select', 'source', 'style', 'summary', 'table', 'tbody', 'td', 'template', 'textarea', 'tfoot', 'th', 'thead', 'title', 'tr', 'track', 'ul', 'wbr', 'xmp'];
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-scope
	  var inScopeTags = ['applet', 'caption', 'html', 'table', 'td', 'th', 'marquee', 'object', 'template',
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#html-integration-point
	  // TODO: Distinguish by namespace here -- for <title>, including it here
	  // errs on the side of fewer warnings
	  'foreignObject', 'desc', 'title'];
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-button-scope
	  var buttonScopeTags = inScopeTags.concat(['button']);
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#generate-implied-end-tags
	  var impliedEndTags = ['dd', 'dt', 'li', 'option', 'optgroup', 'p', 'rp', 'rt'];
	
	  var emptyAncestorInfo = {
	    current: null,
	
	    formTag: null,
	    aTagInScope: null,
	    buttonTagInScope: null,
	    nobrTagInScope: null,
	    pTagInButtonScope: null,
	
	    listItemTagAutoclosing: null,
	    dlItemTagAutoclosing: null
	  };
	
	  var updatedAncestorInfo = function (oldInfo, tag, instance) {
	    var ancestorInfo = _assign({}, oldInfo || emptyAncestorInfo);
	    var info = { tag: tag, instance: instance };
	
	    if (inScopeTags.indexOf(tag) !== -1) {
	      ancestorInfo.aTagInScope = null;
	      ancestorInfo.buttonTagInScope = null;
	      ancestorInfo.nobrTagInScope = null;
	    }
	    if (buttonScopeTags.indexOf(tag) !== -1) {
	      ancestorInfo.pTagInButtonScope = null;
	    }
	
	    // See rules for 'li', 'dd', 'dt' start tags in
	    // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inbody
	    if (specialTags.indexOf(tag) !== -1 && tag !== 'address' && tag !== 'div' && tag !== 'p') {
	      ancestorInfo.listItemTagAutoclosing = null;
	      ancestorInfo.dlItemTagAutoclosing = null;
	    }
	
	    ancestorInfo.current = info;
	
	    if (tag === 'form') {
	      ancestorInfo.formTag = info;
	    }
	    if (tag === 'a') {
	      ancestorInfo.aTagInScope = info;
	    }
	    if (tag === 'button') {
	      ancestorInfo.buttonTagInScope = info;
	    }
	    if (tag === 'nobr') {
	      ancestorInfo.nobrTagInScope = info;
	    }
	    if (tag === 'p') {
	      ancestorInfo.pTagInButtonScope = info;
	    }
	    if (tag === 'li') {
	      ancestorInfo.listItemTagAutoclosing = info;
	    }
	    if (tag === 'dd' || tag === 'dt') {
	      ancestorInfo.dlItemTagAutoclosing = info;
	    }
	
	    return ancestorInfo;
	  };
	
	  /**
	   * Returns whether
	   */
	  var isTagValidWithParent = function (tag, parentTag) {
	    // First, let's check if we're in an unusual parsing mode...
	    switch (parentTag) {
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inselect
	      case 'select':
	        return tag === 'option' || tag === 'optgroup' || tag === '#text';
	      case 'optgroup':
	        return tag === 'option' || tag === '#text';
	      // Strictly speaking, seeing an <option> doesn't mean we're in a <select>
	      // but
	      case 'option':
	        return tag === '#text';
	
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intd
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-incaption
	      // No special behavior since these rules fall back to "in body" mode for
	      // all except special table nodes which cause bad parsing behavior anyway.
	
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intr
	      case 'tr':
	        return tag === 'th' || tag === 'td' || tag === 'style' || tag === 'script' || tag === 'template';
	
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intbody
	      case 'tbody':
	      case 'thead':
	      case 'tfoot':
	        return tag === 'tr' || tag === 'style' || tag === 'script' || tag === 'template';
	
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-incolgroup
	      case 'colgroup':
	        return tag === 'col' || tag === 'template';
	
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intable
	      case 'table':
	        return tag === 'caption' || tag === 'colgroup' || tag === 'tbody' || tag === 'tfoot' || tag === 'thead' || tag === 'style' || tag === 'script' || tag === 'template';
	
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inhead
	      case 'head':
	        return tag === 'base' || tag === 'basefont' || tag === 'bgsound' || tag === 'link' || tag === 'meta' || tag === 'title' || tag === 'noscript' || tag === 'noframes' || tag === 'style' || tag === 'script' || tag === 'template';
	
	      // https://html.spec.whatwg.org/multipage/semantics.html#the-html-element
	      case 'html':
	        return tag === 'head' || tag === 'body';
	      case '#document':
	        return tag === 'html';
	    }
	
	    // Probably in the "in body" parsing mode, so we outlaw only tag combos
	    // where the parsing rules cause implicit opens or closes to be added.
	    // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inbody
	    switch (tag) {
	      case 'h1':
	      case 'h2':
	      case 'h3':
	      case 'h4':
	      case 'h5':
	      case 'h6':
	        return parentTag !== 'h1' && parentTag !== 'h2' && parentTag !== 'h3' && parentTag !== 'h4' && parentTag !== 'h5' && parentTag !== 'h6';
	
	      case 'rp':
	      case 'rt':
	        return impliedEndTags.indexOf(parentTag) === -1;
	
	      case 'body':
	      case 'caption':
	      case 'col':
	      case 'colgroup':
	      case 'frame':
	      case 'head':
	      case 'html':
	      case 'tbody':
	      case 'td':
	      case 'tfoot':
	      case 'th':
	      case 'thead':
	      case 'tr':
	        // These tags are only valid with a few parents that have special child
	        // parsing rules -- if we're down here, then none of those matched and
	        // so we allow it only if we don't know what the parent is, as all other
	        // cases are invalid.
	        return parentTag == null;
	    }
	
	    return true;
	  };
	
	  /**
	   * Returns whether
	   */
	  var findInvalidAncestorForTag = function (tag, ancestorInfo) {
	    switch (tag) {
	      case 'address':
	      case 'article':
	      case 'aside':
	      case 'blockquote':
	      case 'center':
	      case 'details':
	      case 'dialog':
	      case 'dir':
	      case 'div':
	      case 'dl':
	      case 'fieldset':
	      case 'figcaption':
	      case 'figure':
	      case 'footer':
	      case 'header':
	      case 'hgroup':
	      case 'main':
	      case 'menu':
	      case 'nav':
	      case 'ol':
	      case 'p':
	      case 'section':
	      case 'summary':
	      case 'ul':
	
	      case 'pre':
	      case 'listing':
	
	      case 'table':
	
	      case 'hr':
	
	      case 'xmp':
	
	      case 'h1':
	      case 'h2':
	      case 'h3':
	      case 'h4':
	      case 'h5':
	      case 'h6':
	        return ancestorInfo.pTagInButtonScope;
	
	      case 'form':
	        return ancestorInfo.formTag || ancestorInfo.pTagInButtonScope;
	
	      case 'li':
	        return ancestorInfo.listItemTagAutoclosing;
	
	      case 'dd':
	      case 'dt':
	        return ancestorInfo.dlItemTagAutoclosing;
	
	      case 'button':
	        return ancestorInfo.buttonTagInScope;
	
	      case 'a':
	        // Spec says something about storing a list of markers, but it sounds
	        // equivalent to this check.
	        return ancestorInfo.aTagInScope;
	
	      case 'nobr':
	        return ancestorInfo.nobrTagInScope;
	    }
	
	    return null;
	  };
	
	  /**
	   * Given a ReactCompositeComponent instance, return a list of its recursive
	   * owners, starting at the root and ending with the instance itself.
	   */
	  var findOwnerStack = function (instance) {
	    if (!instance) {
	      return [];
	    }
	
	    var stack = [];
	    do {
	      stack.push(instance);
	    } while (instance = instance._currentElement._owner);
	    stack.reverse();
	    return stack;
	  };
	
	  var didWarn = {};
	
	  validateDOMNesting = function (childTag, childInstance, ancestorInfo) {
	    ancestorInfo = ancestorInfo || emptyAncestorInfo;
	    var parentInfo = ancestorInfo.current;
	    var parentTag = parentInfo && parentInfo.tag;
	
	    var invalidParent = isTagValidWithParent(childTag, parentTag) ? null : parentInfo;
	    var invalidAncestor = invalidParent ? null : findInvalidAncestorForTag(childTag, ancestorInfo);
	    var problematic = invalidParent || invalidAncestor;
	
	    if (problematic) {
	      var ancestorTag = problematic.tag;
	      var ancestorInstance = problematic.instance;
	
	      var childOwner = childInstance && childInstance._currentElement._owner;
	      var ancestorOwner = ancestorInstance && ancestorInstance._currentElement._owner;
	
	      var childOwners = findOwnerStack(childOwner);
	      var ancestorOwners = findOwnerStack(ancestorOwner);
	
	      var minStackLen = Math.min(childOwners.length, ancestorOwners.length);
	      var i;
	
	      var deepestCommon = -1;
	      for (i = 0; i < minStackLen; i++) {
	        if (childOwners[i] === ancestorOwners[i]) {
	          deepestCommon = i;
	        } else {
	          break;
	        }
	      }
	
	      var UNKNOWN = '(unknown)';
	      var childOwnerNames = childOwners.slice(deepestCommon + 1).map(function (inst) {
	        return inst.getName() || UNKNOWN;
	      });
	      var ancestorOwnerNames = ancestorOwners.slice(deepestCommon + 1).map(function (inst) {
	        return inst.getName() || UNKNOWN;
	      });
	      var ownerInfo = [].concat(
	      // If the parent and child instances have a common owner ancestor, start
	      // with that -- otherwise we just start with the parent's owners.
	      deepestCommon !== -1 ? childOwners[deepestCommon].getName() || UNKNOWN : [], ancestorOwnerNames, ancestorTag,
	      // If we're warning about an invalid (non-parent) ancestry, add '...'
	      invalidAncestor ? ['...'] : [], childOwnerNames, childTag).join(' > ');
	
	      var warnKey = !!invalidParent + '|' + childTag + '|' + ancestorTag + '|' + ownerInfo;
	      if (didWarn[warnKey]) {
	        return;
	      }
	      didWarn[warnKey] = true;
	
	      var tagDisplayName = childTag;
	      if (childTag !== '#text') {
	        tagDisplayName = '<' + childTag + '>';
	      }
	
	      if (invalidParent) {
	        var info = '';
	        if (ancestorTag === 'table' && childTag === 'tr') {
	          info += ' Add a <tbody> to your code to match the DOM tree generated by ' + 'the browser.';
	        }
	        process.env.NODE_ENV !== 'production' ? warning(false, 'validateDOMNesting(...): %s cannot appear as a child of <%s>. ' + 'See %s.%s', tagDisplayName, ancestorTag, ownerInfo, info) : void 0;
	      } else {
	        process.env.NODE_ENV !== 'production' ? warning(false, 'validateDOMNesting(...): %s cannot appear as a descendant of ' + '<%s>. See %s.', tagDisplayName, ancestorTag, ownerInfo) : void 0;
	      }
	    }
	  };
	
	  validateDOMNesting.updatedAncestorInfo = updatedAncestorInfo;
	
	  // For testing
	  validateDOMNesting.isTagValidInContext = function (tag, ancestorInfo) {
	    ancestorInfo = ancestorInfo || emptyAncestorInfo;
	    var parentInfo = ancestorInfo.current;
	    var parentTag = parentInfo && parentInfo.tag;
	    return isTagValidWithParent(tag, parentTag) && !findInvalidAncestorForTag(tag, ancestorInfo);
	  };
	}
	
	module.exports = validateDOMNesting;

/***/ },
/* 75 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.compose = exports.applyMiddleware = exports.bindActionCreators = exports.combineReducers = exports.createStore = undefined;
	
	var _createStore = __webpack_require__(129);
	
	var _createStore2 = _interopRequireDefault(_createStore);
	
	var _combineReducers = __webpack_require__(372);
	
	var _combineReducers2 = _interopRequireDefault(_combineReducers);
	
	var _bindActionCreators = __webpack_require__(371);
	
	var _bindActionCreators2 = _interopRequireDefault(_bindActionCreators);
	
	var _applyMiddleware = __webpack_require__(370);
	
	var _applyMiddleware2 = _interopRequireDefault(_applyMiddleware);
	
	var _compose = __webpack_require__(128);
	
	var _compose2 = _interopRequireDefault(_compose);
	
	var _warning = __webpack_require__(130);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	/*
	* This is a dummy function to check if the function name has been altered by minification.
	* If the function has been minified and NODE_ENV !== 'production', warn the user.
	*/
	function isCrushed() {}
	
	if (false) {
	  (0, _warning2['default'])('You are currently using minified code outside of NODE_ENV === \'production\'. ' + 'This means that you are running a slower development build of Redux. ' + 'You can use loose-envify (https://github.com/zertosh/loose-envify) for browserify ' + 'or DefinePlugin for webpack (http://stackoverflow.com/questions/30030031) ' + 'to ensure you have the correct code for your production build.');
	}
	
	exports.createStore = _createStore2['default'];
	exports.combineReducers = _combineReducers2['default'];
	exports.bindActionCreators = _bindActionCreators2['default'];
	exports.applyMiddleware = _applyMiddleware2['default'];
	exports.compose = _compose2['default'];

/***/ },
/* 76 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(global) {//     Backbone.js 1.3.3
	
	//     (c) 2010-2016 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	//     Backbone may be freely distributed under the MIT license.
	//     For all details and documentation:
	//     http://backbonejs.org
	
	(function(factory) {
	
	  // Establish the root object, `window` (`self`) in the browser, or `global` on the server.
	  // We use `self` instead of `window` for `WebWorker` support.
	  var root = (typeof self == 'object' && self.self === self && self) ||
	            (typeof global == 'object' && global.global === global && global);
	
	  // Set up Backbone appropriately for the environment. Start with AMD.
	  if (true) {
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(7), __webpack_require__(160), exports], __WEBPACK_AMD_DEFINE_RESULT__ = function(_, $, exports) {
	      // Export global even in AMD case in case this script is loaded with
	      // others that may still expect a global Backbone.
	      root.Backbone = factory(root, exports, _, $);
	    }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	
	  // Next for Node.js or CommonJS. jQuery may not be needed as a module.
	  } else if (typeof exports !== 'undefined') {
	    var _ = require('underscore'), $;
	    try { $ = require('jquery'); } catch (e) {}
	    factory(root, exports, _, $);
	
	  // Finally, as a browser global.
	  } else {
	    root.Backbone = factory(root, {}, root._, (root.jQuery || root.Zepto || root.ender || root.$));
	  }
	
	})(function(root, Backbone, _, $) {
	
	  // Initial Setup
	  // -------------
	
	  // Save the previous value of the `Backbone` variable, so that it can be
	  // restored later on, if `noConflict` is used.
	  var previousBackbone = root.Backbone;
	
	  // Create a local reference to a common array method we'll want to use later.
	  var slice = Array.prototype.slice;
	
	  // Current version of the library. Keep in sync with `package.json`.
	  Backbone.VERSION = '1.3.3';
	
	  // For Backbone's purposes, jQuery, Zepto, Ender, or My Library (kidding) owns
	  // the `$` variable.
	  Backbone.$ = $;
	
	  // Runs Backbone.js in *noConflict* mode, returning the `Backbone` variable
	  // to its previous owner. Returns a reference to this Backbone object.
	  Backbone.noConflict = function() {
	    root.Backbone = previousBackbone;
	    return this;
	  };
	
	  // Turn on `emulateHTTP` to support legacy HTTP servers. Setting this option
	  // will fake `"PATCH"`, `"PUT"` and `"DELETE"` requests via the `_method` parameter and
	  // set a `X-Http-Method-Override` header.
	  Backbone.emulateHTTP = false;
	
	  // Turn on `emulateJSON` to support legacy servers that can't deal with direct
	  // `application/json` requests ... this will encode the body as
	  // `application/x-www-form-urlencoded` instead and will send the model in a
	  // form param named `model`.
	  Backbone.emulateJSON = false;
	
	  // Proxy Backbone class methods to Underscore functions, wrapping the model's
	  // `attributes` object or collection's `models` array behind the scenes.
	  //
	  // collection.filter(function(model) { return model.get('age') > 10 });
	  // collection.each(this.addView);
	  //
	  // `Function#apply` can be slow so we use the method's arg count, if we know it.
	  var addMethod = function(length, method, attribute) {
	    switch (length) {
	      case 1: return function() {
	        return _[method](this[attribute]);
	      };
	      case 2: return function(value) {
	        return _[method](this[attribute], value);
	      };
	      case 3: return function(iteratee, context) {
	        return _[method](this[attribute], cb(iteratee, this), context);
	      };
	      case 4: return function(iteratee, defaultVal, context) {
	        return _[method](this[attribute], cb(iteratee, this), defaultVal, context);
	      };
	      default: return function() {
	        var args = slice.call(arguments);
	        args.unshift(this[attribute]);
	        return _[method].apply(_, args);
	      };
	    }
	  };
	  var addUnderscoreMethods = function(Class, methods, attribute) {
	    _.each(methods, function(length, method) {
	      if (_[method]) Class.prototype[method] = addMethod(length, method, attribute);
	    });
	  };
	
	  // Support `collection.sortBy('attr')` and `collection.findWhere({id: 1})`.
	  var cb = function(iteratee, instance) {
	    if (_.isFunction(iteratee)) return iteratee;
	    if (_.isObject(iteratee) && !instance._isModel(iteratee)) return modelMatcher(iteratee);
	    if (_.isString(iteratee)) return function(model) { return model.get(iteratee); };
	    return iteratee;
	  };
	  var modelMatcher = function(attrs) {
	    var matcher = _.matches(attrs);
	    return function(model) {
	      return matcher(model.attributes);
	    };
	  };
	
	  // Backbone.Events
	  // ---------------
	
	  // A module that can be mixed in to *any object* in order to provide it with
	  // a custom event channel. You may bind a callback to an event with `on` or
	  // remove with `off`; `trigger`-ing an event fires all callbacks in
	  // succession.
	  //
	  //     var object = {};
	  //     _.extend(object, Backbone.Events);
	  //     object.on('expand', function(){ alert('expanded'); });
	  //     object.trigger('expand');
	  //
	  var Events = Backbone.Events = {};
	
	  // Regular expression used to split event strings.
	  var eventSplitter = /\s+/;
	
	  // Iterates over the standard `event, callback` (as well as the fancy multiple
	  // space-separated events `"change blur", callback` and jQuery-style event
	  // maps `{event: callback}`).
	  var eventsApi = function(iteratee, events, name, callback, opts) {
	    var i = 0, names;
	    if (name && typeof name === 'object') {
	      // Handle event maps.
	      if (callback !== void 0 && 'context' in opts && opts.context === void 0) opts.context = callback;
	      for (names = _.keys(name); i < names.length ; i++) {
	        events = eventsApi(iteratee, events, names[i], name[names[i]], opts);
	      }
	    } else if (name && eventSplitter.test(name)) {
	      // Handle space-separated event names by delegating them individually.
	      for (names = name.split(eventSplitter); i < names.length; i++) {
	        events = iteratee(events, names[i], callback, opts);
	      }
	    } else {
	      // Finally, standard events.
	      events = iteratee(events, name, callback, opts);
	    }
	    return events;
	  };
	
	  // Bind an event to a `callback` function. Passing `"all"` will bind
	  // the callback to all events fired.
	  Events.on = function(name, callback, context) {
	    return internalOn(this, name, callback, context);
	  };
	
	  // Guard the `listening` argument from the public API.
	  var internalOn = function(obj, name, callback, context, listening) {
	    obj._events = eventsApi(onApi, obj._events || {}, name, callback, {
	      context: context,
	      ctx: obj,
	      listening: listening
	    });
	
	    if (listening) {
	      var listeners = obj._listeners || (obj._listeners = {});
	      listeners[listening.id] = listening;
	    }
	
	    return obj;
	  };
	
	  // Inversion-of-control versions of `on`. Tell *this* object to listen to
	  // an event in another object... keeping track of what it's listening to
	  // for easier unbinding later.
	  Events.listenTo = function(obj, name, callback) {
	    if (!obj) return this;
	    var id = obj._listenId || (obj._listenId = _.uniqueId('l'));
	    var listeningTo = this._listeningTo || (this._listeningTo = {});
	    var listening = listeningTo[id];
	
	    // This object is not listening to any other events on `obj` yet.
	    // Setup the necessary references to track the listening callbacks.
	    if (!listening) {
	      var thisId = this._listenId || (this._listenId = _.uniqueId('l'));
	      listening = listeningTo[id] = {obj: obj, objId: id, id: thisId, listeningTo: listeningTo, count: 0};
	    }
	
	    // Bind callbacks on obj, and keep track of them on listening.
	    internalOn(obj, name, callback, this, listening);
	    return this;
	  };
	
	  // The reducing API that adds a callback to the `events` object.
	  var onApi = function(events, name, callback, options) {
	    if (callback) {
	      var handlers = events[name] || (events[name] = []);
	      var context = options.context, ctx = options.ctx, listening = options.listening;
	      if (listening) listening.count++;
	
	      handlers.push({callback: callback, context: context, ctx: context || ctx, listening: listening});
	    }
	    return events;
	  };
	
	  // Remove one or many callbacks. If `context` is null, removes all
	  // callbacks with that function. If `callback` is null, removes all
	  // callbacks for the event. If `name` is null, removes all bound
	  // callbacks for all events.
	  Events.off = function(name, callback, context) {
	    if (!this._events) return this;
	    this._events = eventsApi(offApi, this._events, name, callback, {
	      context: context,
	      listeners: this._listeners
	    });
	    return this;
	  };
	
	  // Tell this object to stop listening to either specific events ... or
	  // to every object it's currently listening to.
	  Events.stopListening = function(obj, name, callback) {
	    var listeningTo = this._listeningTo;
	    if (!listeningTo) return this;
	
	    var ids = obj ? [obj._listenId] : _.keys(listeningTo);
	
	    for (var i = 0; i < ids.length; i++) {
	      var listening = listeningTo[ids[i]];
	
	      // If listening doesn't exist, this object is not currently
	      // listening to obj. Break out early.
	      if (!listening) break;
	
	      listening.obj.off(name, callback, this);
	    }
	
	    return this;
	  };
	
	  // The reducing API that removes a callback from the `events` object.
	  var offApi = function(events, name, callback, options) {
	    if (!events) return;
	
	    var i = 0, listening;
	    var context = options.context, listeners = options.listeners;
	
	    // Delete all events listeners and "drop" events.
	    if (!name && !callback && !context) {
	      var ids = _.keys(listeners);
	      for (; i < ids.length; i++) {
	        listening = listeners[ids[i]];
	        delete listeners[listening.id];
	        delete listening.listeningTo[listening.objId];
	      }
	      return;
	    }
	
	    var names = name ? [name] : _.keys(events);
	    for (; i < names.length; i++) {
	      name = names[i];
	      var handlers = events[name];
	
	      // Bail out if there are no events stored.
	      if (!handlers) break;
	
	      // Replace events if there are any remaining.  Otherwise, clean up.
	      var remaining = [];
	      for (var j = 0; j < handlers.length; j++) {
	        var handler = handlers[j];
	        if (
	          callback && callback !== handler.callback &&
	            callback !== handler.callback._callback ||
	              context && context !== handler.context
	        ) {
	          remaining.push(handler);
	        } else {
	          listening = handler.listening;
	          if (listening && --listening.count === 0) {
	            delete listeners[listening.id];
	            delete listening.listeningTo[listening.objId];
	          }
	        }
	      }
	
	      // Update tail event if the list has any events.  Otherwise, clean up.
	      if (remaining.length) {
	        events[name] = remaining;
	      } else {
	        delete events[name];
	      }
	    }
	    return events;
	  };
	
	  // Bind an event to only be triggered a single time. After the first time
	  // the callback is invoked, its listener will be removed. If multiple events
	  // are passed in using the space-separated syntax, the handler will fire
	  // once for each event, not once for a combination of all events.
	  Events.once = function(name, callback, context) {
	    // Map the event into a `{event: once}` object.
	    var events = eventsApi(onceMap, {}, name, callback, _.bind(this.off, this));
	    if (typeof name === 'string' && context == null) callback = void 0;
	    return this.on(events, callback, context);
	  };
	
	  // Inversion-of-control versions of `once`.
	  Events.listenToOnce = function(obj, name, callback) {
	    // Map the event into a `{event: once}` object.
	    var events = eventsApi(onceMap, {}, name, callback, _.bind(this.stopListening, this, obj));
	    return this.listenTo(obj, events);
	  };
	
	  // Reduces the event callbacks into a map of `{event: onceWrapper}`.
	  // `offer` unbinds the `onceWrapper` after it has been called.
	  var onceMap = function(map, name, callback, offer) {
	    if (callback) {
	      var once = map[name] = _.once(function() {
	        offer(name, once);
	        callback.apply(this, arguments);
	      });
	      once._callback = callback;
	    }
	    return map;
	  };
	
	  // Trigger one or many events, firing all bound callbacks. Callbacks are
	  // passed the same arguments as `trigger` is, apart from the event name
	  // (unless you're listening on `"all"`, which will cause your callback to
	  // receive the true name of the event as the first argument).
	  Events.trigger = function(name) {
	    if (!this._events) return this;
	
	    var length = Math.max(0, arguments.length - 1);
	    var args = Array(length);
	    for (var i = 0; i < length; i++) args[i] = arguments[i + 1];
	
	    eventsApi(triggerApi, this._events, name, void 0, args);
	    return this;
	  };
	
	  // Handles triggering the appropriate event callbacks.
	  var triggerApi = function(objEvents, name, callback, args) {
	    if (objEvents) {
	      var events = objEvents[name];
	      var allEvents = objEvents.all;
	      if (events && allEvents) allEvents = allEvents.slice();
	      if (events) triggerEvents(events, args);
	      if (allEvents) triggerEvents(allEvents, [name].concat(args));
	    }
	    return objEvents;
	  };
	
	  // A difficult-to-believe, but optimized internal dispatch function for
	  // triggering events. Tries to keep the usual cases speedy (most internal
	  // Backbone events have 3 arguments).
	  var triggerEvents = function(events, args) {
	    var ev, i = -1, l = events.length, a1 = args[0], a2 = args[1], a3 = args[2];
	    switch (args.length) {
	      case 0: while (++i < l) (ev = events[i]).callback.call(ev.ctx); return;
	      case 1: while (++i < l) (ev = events[i]).callback.call(ev.ctx, a1); return;
	      case 2: while (++i < l) (ev = events[i]).callback.call(ev.ctx, a1, a2); return;
	      case 3: while (++i < l) (ev = events[i]).callback.call(ev.ctx, a1, a2, a3); return;
	      default: while (++i < l) (ev = events[i]).callback.apply(ev.ctx, args); return;
	    }
	  };
	
	  // Aliases for backwards compatibility.
	  Events.bind   = Events.on;
	  Events.unbind = Events.off;
	
	  // Allow the `Backbone` object to serve as a global event bus, for folks who
	  // want global "pubsub" in a convenient place.
	  _.extend(Backbone, Events);
	
	  // Backbone.Model
	  // --------------
	
	  // Backbone **Models** are the basic data object in the framework --
	  // frequently representing a row in a table in a database on your server.
	  // A discrete chunk of data and a bunch of useful, related methods for
	  // performing computations and transformations on that data.
	
	  // Create a new model with the specified attributes. A client id (`cid`)
	  // is automatically generated and assigned for you.
	  var Model = Backbone.Model = function(attributes, options) {
	    var attrs = attributes || {};
	    options || (options = {});
	    this.cid = _.uniqueId(this.cidPrefix);
	    this.attributes = {};
	    if (options.collection) this.collection = options.collection;
	    if (options.parse) attrs = this.parse(attrs, options) || {};
	    var defaults = _.result(this, 'defaults');
	    attrs = _.defaults(_.extend({}, defaults, attrs), defaults);
	    this.set(attrs, options);
	    this.changed = {};
	    this.initialize.apply(this, arguments);
	  };
	
	  // Attach all inheritable methods to the Model prototype.
	  _.extend(Model.prototype, Events, {
	
	    // A hash of attributes whose current and previous value differ.
	    changed: null,
	
	    // The value returned during the last failed validation.
	    validationError: null,
	
	    // The default name for the JSON `id` attribute is `"id"`. MongoDB and
	    // CouchDB users may want to set this to `"_id"`.
	    idAttribute: 'id',
	
	    // The prefix is used to create the client id which is used to identify models locally.
	    // You may want to override this if you're experiencing name clashes with model ids.
	    cidPrefix: 'c',
	
	    // Initialize is an empty function by default. Override it with your own
	    // initialization logic.
	    initialize: function(){},
	
	    // Return a copy of the model's `attributes` object.
	    toJSON: function(options) {
	      return _.clone(this.attributes);
	    },
	
	    // Proxy `Backbone.sync` by default -- but override this if you need
	    // custom syncing semantics for *this* particular model.
	    sync: function() {
	      return Backbone.sync.apply(this, arguments);
	    },
	
	    // Get the value of an attribute.
	    get: function(attr) {
	      return this.attributes[attr];
	    },
	
	    // Get the HTML-escaped value of an attribute.
	    escape: function(attr) {
	      return _.escape(this.get(attr));
	    },
	
	    // Returns `true` if the attribute contains a value that is not null
	    // or undefined.
	    has: function(attr) {
	      return this.get(attr) != null;
	    },
	
	    // Special-cased proxy to underscore's `_.matches` method.
	    matches: function(attrs) {
	      return !!_.iteratee(attrs, this)(this.attributes);
	    },
	
	    // Set a hash of model attributes on the object, firing `"change"`. This is
	    // the core primitive operation of a model, updating the data and notifying
	    // anyone who needs to know about the change in state. The heart of the beast.
	    set: function(key, val, options) {
	      if (key == null) return this;
	
	      // Handle both `"key", value` and `{key: value}` -style arguments.
	      var attrs;
	      if (typeof key === 'object') {
	        attrs = key;
	        options = val;
	      } else {
	        (attrs = {})[key] = val;
	      }
	
	      options || (options = {});
	
	      // Run validation.
	      if (!this._validate(attrs, options)) return false;
	
	      // Extract attributes and options.
	      var unset      = options.unset;
	      var silent     = options.silent;
	      var changes    = [];
	      var changing   = this._changing;
	      this._changing = true;
	
	      if (!changing) {
	        this._previousAttributes = _.clone(this.attributes);
	        this.changed = {};
	      }
	
	      var current = this.attributes;
	      var changed = this.changed;
	      var prev    = this._previousAttributes;
	
	      // For each `set` attribute, update or delete the current value.
	      for (var attr in attrs) {
	        val = attrs[attr];
	        if (!_.isEqual(current[attr], val)) changes.push(attr);
	        if (!_.isEqual(prev[attr], val)) {
	          changed[attr] = val;
	        } else {
	          delete changed[attr];
	        }
	        unset ? delete current[attr] : current[attr] = val;
	      }
	
	      // Update the `id`.
	      if (this.idAttribute in attrs) this.id = this.get(this.idAttribute);
	
	      // Trigger all relevant attribute changes.
	      if (!silent) {
	        if (changes.length) this._pending = options;
	        for (var i = 0; i < changes.length; i++) {
	          this.trigger('change:' + changes[i], this, current[changes[i]], options);
	        }
	      }
	
	      // You might be wondering why there's a `while` loop here. Changes can
	      // be recursively nested within `"change"` events.
	      if (changing) return this;
	      if (!silent) {
	        while (this._pending) {
	          options = this._pending;
	          this._pending = false;
	          this.trigger('change', this, options);
	        }
	      }
	      this._pending = false;
	      this._changing = false;
	      return this;
	    },
	
	    // Remove an attribute from the model, firing `"change"`. `unset` is a noop
	    // if the attribute doesn't exist.
	    unset: function(attr, options) {
	      return this.set(attr, void 0, _.extend({}, options, {unset: true}));
	    },
	
	    // Clear all attributes on the model, firing `"change"`.
	    clear: function(options) {
	      var attrs = {};
	      for (var key in this.attributes) attrs[key] = void 0;
	      return this.set(attrs, _.extend({}, options, {unset: true}));
	    },
	
	    // Determine if the model has changed since the last `"change"` event.
	    // If you specify an attribute name, determine if that attribute has changed.
	    hasChanged: function(attr) {
	      if (attr == null) return !_.isEmpty(this.changed);
	      return _.has(this.changed, attr);
	    },
	
	    // Return an object containing all the attributes that have changed, or
	    // false if there are no changed attributes. Useful for determining what
	    // parts of a view need to be updated and/or what attributes need to be
	    // persisted to the server. Unset attributes will be set to undefined.
	    // You can also pass an attributes object to diff against the model,
	    // determining if there *would be* a change.
	    changedAttributes: function(diff) {
	      if (!diff) return this.hasChanged() ? _.clone(this.changed) : false;
	      var old = this._changing ? this._previousAttributes : this.attributes;
	      var changed = {};
	      for (var attr in diff) {
	        var val = diff[attr];
	        if (_.isEqual(old[attr], val)) continue;
	        changed[attr] = val;
	      }
	      return _.size(changed) ? changed : false;
	    },
	
	    // Get the previous value of an attribute, recorded at the time the last
	    // `"change"` event was fired.
	    previous: function(attr) {
	      if (attr == null || !this._previousAttributes) return null;
	      return this._previousAttributes[attr];
	    },
	
	    // Get all of the attributes of the model at the time of the previous
	    // `"change"` event.
	    previousAttributes: function() {
	      return _.clone(this._previousAttributes);
	    },
	
	    // Fetch the model from the server, merging the response with the model's
	    // local attributes. Any changed attributes will trigger a "change" event.
	    fetch: function(options) {
	      options = _.extend({parse: true}, options);
	      var model = this;
	      var success = options.success;
	      options.success = function(resp) {
	        var serverAttrs = options.parse ? model.parse(resp, options) : resp;
	        if (!model.set(serverAttrs, options)) return false;
	        if (success) success.call(options.context, model, resp, options);
	        model.trigger('sync', model, resp, options);
	      };
	      wrapError(this, options);
	      return this.sync('read', this, options);
	    },
	
	    // Set a hash of model attributes, and sync the model to the server.
	    // If the server returns an attributes hash that differs, the model's
	    // state will be `set` again.
	    save: function(key, val, options) {
	      // Handle both `"key", value` and `{key: value}` -style arguments.
	      var attrs;
	      if (key == null || typeof key === 'object') {
	        attrs = key;
	        options = val;
	      } else {
	        (attrs = {})[key] = val;
	      }
	
	      options = _.extend({validate: true, parse: true}, options);
	      var wait = options.wait;
	
	      // If we're not waiting and attributes exist, save acts as
	      // `set(attr).save(null, opts)` with validation. Otherwise, check if
	      // the model will be valid when the attributes, if any, are set.
	      if (attrs && !wait) {
	        if (!this.set(attrs, options)) return false;
	      } else if (!this._validate(attrs, options)) {
	        return false;
	      }
	
	      // After a successful server-side save, the client is (optionally)
	      // updated with the server-side state.
	      var model = this;
	      var success = options.success;
	      var attributes = this.attributes;
	      options.success = function(resp) {
	        // Ensure attributes are restored during synchronous saves.
	        model.attributes = attributes;
	        var serverAttrs = options.parse ? model.parse(resp, options) : resp;
	        if (wait) serverAttrs = _.extend({}, attrs, serverAttrs);
	        if (serverAttrs && !model.set(serverAttrs, options)) return false;
	        if (success) success.call(options.context, model, resp, options);
	        model.trigger('sync', model, resp, options);
	      };
	      wrapError(this, options);
	
	      // Set temporary attributes if `{wait: true}` to properly find new ids.
	      if (attrs && wait) this.attributes = _.extend({}, attributes, attrs);
	
	      var method = this.isNew() ? 'create' : (options.patch ? 'patch' : 'update');
	      if (method === 'patch' && !options.attrs) options.attrs = attrs;
	      var xhr = this.sync(method, this, options);
	
	      // Restore attributes.
	      this.attributes = attributes;
	
	      return xhr;
	    },
	
	    // Destroy this model on the server if it was already persisted.
	    // Optimistically removes the model from its collection, if it has one.
	    // If `wait: true` is passed, waits for the server to respond before removal.
	    destroy: function(options) {
	      options = options ? _.clone(options) : {};
	      var model = this;
	      var success = options.success;
	      var wait = options.wait;
	
	      var destroy = function() {
	        model.stopListening();
	        model.trigger('destroy', model, model.collection, options);
	      };
	
	      options.success = function(resp) {
	        if (wait) destroy();
	        if (success) success.call(options.context, model, resp, options);
	        if (!model.isNew()) model.trigger('sync', model, resp, options);
	      };
	
	      var xhr = false;
	      if (this.isNew()) {
	        _.defer(options.success);
	      } else {
	        wrapError(this, options);
	        xhr = this.sync('delete', this, options);
	      }
	      if (!wait) destroy();
	      return xhr;
	    },
	
	    // Default URL for the model's representation on the server -- if you're
	    // using Backbone's restful methods, override this to change the endpoint
	    // that will be called.
	    url: function() {
	      var base =
	        _.result(this, 'urlRoot') ||
	        _.result(this.collection, 'url') ||
	        urlError();
	      if (this.isNew()) return base;
	      var id = this.get(this.idAttribute);
	      return base.replace(/[^\/]$/, '$&/') + encodeURIComponent(id);
	    },
	
	    // **parse** converts a response into the hash of attributes to be `set` on
	    // the model. The default implementation is just to pass the response along.
	    parse: function(resp, options) {
	      return resp;
	    },
	
	    // Create a new model with identical attributes to this one.
	    clone: function() {
	      return new this.constructor(this.attributes);
	    },
	
	    // A model is new if it has never been saved to the server, and lacks an id.
	    isNew: function() {
	      return !this.has(this.idAttribute);
	    },
	
	    // Check if the model is currently in a valid state.
	    isValid: function(options) {
	      return this._validate({}, _.extend({}, options, {validate: true}));
	    },
	
	    // Run validation against the next complete set of model attributes,
	    // returning `true` if all is well. Otherwise, fire an `"invalid"` event.
	    _validate: function(attrs, options) {
	      if (!options.validate || !this.validate) return true;
	      attrs = _.extend({}, this.attributes, attrs);
	      var error = this.validationError = this.validate(attrs, options) || null;
	      if (!error) return true;
	      this.trigger('invalid', this, error, _.extend(options, {validationError: error}));
	      return false;
	    }
	
	  });
	
	  // Underscore methods that we want to implement on the Model, mapped to the
	  // number of arguments they take.
	  var modelMethods = {keys: 1, values: 1, pairs: 1, invert: 1, pick: 0,
	      omit: 0, chain: 1, isEmpty: 1};
	
	  // Mix in each Underscore method as a proxy to `Model#attributes`.
	  addUnderscoreMethods(Model, modelMethods, 'attributes');
	
	  // Backbone.Collection
	  // -------------------
	
	  // If models tend to represent a single row of data, a Backbone Collection is
	  // more analogous to a table full of data ... or a small slice or page of that
	  // table, or a collection of rows that belong together for a particular reason
	  // -- all of the messages in this particular folder, all of the documents
	  // belonging to this particular author, and so on. Collections maintain
	  // indexes of their models, both in order, and for lookup by `id`.
	
	  // Create a new **Collection**, perhaps to contain a specific type of `model`.
	  // If a `comparator` is specified, the Collection will maintain
	  // its models in sort order, as they're added and removed.
	  var Collection = Backbone.Collection = function(models, options) {
	    options || (options = {});
	    if (options.model) this.model = options.model;
	    if (options.comparator !== void 0) this.comparator = options.comparator;
	    this._reset();
	    this.initialize.apply(this, arguments);
	    if (models) this.reset(models, _.extend({silent: true}, options));
	  };
	
	  // Default options for `Collection#set`.
	  var setOptions = {add: true, remove: true, merge: true};
	  var addOptions = {add: true, remove: false};
	
	  // Splices `insert` into `array` at index `at`.
	  var splice = function(array, insert, at) {
	    at = Math.min(Math.max(at, 0), array.length);
	    var tail = Array(array.length - at);
	    var length = insert.length;
	    var i;
	    for (i = 0; i < tail.length; i++) tail[i] = array[i + at];
	    for (i = 0; i < length; i++) array[i + at] = insert[i];
	    for (i = 0; i < tail.length; i++) array[i + length + at] = tail[i];
	  };
	
	  // Define the Collection's inheritable methods.
	  _.extend(Collection.prototype, Events, {
	
	    // The default model for a collection is just a **Backbone.Model**.
	    // This should be overridden in most cases.
	    model: Model,
	
	    // Initialize is an empty function by default. Override it with your own
	    // initialization logic.
	    initialize: function(){},
	
	    // The JSON representation of a Collection is an array of the
	    // models' attributes.
	    toJSON: function(options) {
	      return this.map(function(model) { return model.toJSON(options); });
	    },
	
	    // Proxy `Backbone.sync` by default.
	    sync: function() {
	      return Backbone.sync.apply(this, arguments);
	    },
	
	    // Add a model, or list of models to the set. `models` may be Backbone
	    // Models or raw JavaScript objects to be converted to Models, or any
	    // combination of the two.
	    add: function(models, options) {
	      return this.set(models, _.extend({merge: false}, options, addOptions));
	    },
	
	    // Remove a model, or a list of models from the set.
	    remove: function(models, options) {
	      options = _.extend({}, options);
	      var singular = !_.isArray(models);
	      models = singular ? [models] : models.slice();
	      var removed = this._removeModels(models, options);
	      if (!options.silent && removed.length) {
	        options.changes = {added: [], merged: [], removed: removed};
	        this.trigger('update', this, options);
	      }
	      return singular ? removed[0] : removed;
	    },
	
	    // Update a collection by `set`-ing a new list of models, adding new ones,
	    // removing models that are no longer present, and merging models that
	    // already exist in the collection, as necessary. Similar to **Model#set**,
	    // the core operation for updating the data contained by the collection.
	    set: function(models, options) {
	      if (models == null) return;
	
	      options = _.extend({}, setOptions, options);
	      if (options.parse && !this._isModel(models)) {
	        models = this.parse(models, options) || [];
	      }
	
	      var singular = !_.isArray(models);
	      models = singular ? [models] : models.slice();
	
	      var at = options.at;
	      if (at != null) at = +at;
	      if (at > this.length) at = this.length;
	      if (at < 0) at += this.length + 1;
	
	      var set = [];
	      var toAdd = [];
	      var toMerge = [];
	      var toRemove = [];
	      var modelMap = {};
	
	      var add = options.add;
	      var merge = options.merge;
	      var remove = options.remove;
	
	      var sort = false;
	      var sortable = this.comparator && at == null && options.sort !== false;
	      var sortAttr = _.isString(this.comparator) ? this.comparator : null;
	
	      // Turn bare objects into model references, and prevent invalid models
	      // from being added.
	      var model, i;
	      for (i = 0; i < models.length; i++) {
	        model = models[i];
	
	        // If a duplicate is found, prevent it from being added and
	        // optionally merge it into the existing model.
	        var existing = this.get(model);
	        if (existing) {
	          if (merge && model !== existing) {
	            var attrs = this._isModel(model) ? model.attributes : model;
	            if (options.parse) attrs = existing.parse(attrs, options);
	            existing.set(attrs, options);
	            toMerge.push(existing);
	            if (sortable && !sort) sort = existing.hasChanged(sortAttr);
	          }
	          if (!modelMap[existing.cid]) {
	            modelMap[existing.cid] = true;
	            set.push(existing);
	          }
	          models[i] = existing;
	
	        // If this is a new, valid model, push it to the `toAdd` list.
	        } else if (add) {
	          model = models[i] = this._prepareModel(model, options);
	          if (model) {
	            toAdd.push(model);
	            this._addReference(model, options);
	            modelMap[model.cid] = true;
	            set.push(model);
	          }
	        }
	      }
	
	      // Remove stale models.
	      if (remove) {
	        for (i = 0; i < this.length; i++) {
	          model = this.models[i];
	          if (!modelMap[model.cid]) toRemove.push(model);
	        }
	        if (toRemove.length) this._removeModels(toRemove, options);
	      }
	
	      // See if sorting is needed, update `length` and splice in new models.
	      var orderChanged = false;
	      var replace = !sortable && add && remove;
	      if (set.length && replace) {
	        orderChanged = this.length !== set.length || _.some(this.models, function(m, index) {
	          return m !== set[index];
	        });
	        this.models.length = 0;
	        splice(this.models, set, 0);
	        this.length = this.models.length;
	      } else if (toAdd.length) {
	        if (sortable) sort = true;
	        splice(this.models, toAdd, at == null ? this.length : at);
	        this.length = this.models.length;
	      }
	
	      // Silently sort the collection if appropriate.
	      if (sort) this.sort({silent: true});
	
	      // Unless silenced, it's time to fire all appropriate add/sort/update events.
	      if (!options.silent) {
	        for (i = 0; i < toAdd.length; i++) {
	          if (at != null) options.index = at + i;
	          model = toAdd[i];
	          model.trigger('add', model, this, options);
	        }
	        if (sort || orderChanged) this.trigger('sort', this, options);
	        if (toAdd.length || toRemove.length || toMerge.length) {
	          options.changes = {
	            added: toAdd,
	            removed: toRemove,
	            merged: toMerge
	          };
	          this.trigger('update', this, options);
	        }
	      }
	
	      // Return the added (or merged) model (or models).
	      return singular ? models[0] : models;
	    },
	
	    // When you have more items than you want to add or remove individually,
	    // you can reset the entire set with a new list of models, without firing
	    // any granular `add` or `remove` events. Fires `reset` when finished.
	    // Useful for bulk operations and optimizations.
	    reset: function(models, options) {
	      options = options ? _.clone(options) : {};
	      for (var i = 0; i < this.models.length; i++) {
	        this._removeReference(this.models[i], options);
	      }
	      options.previousModels = this.models;
	      this._reset();
	      models = this.add(models, _.extend({silent: true}, options));
	      if (!options.silent) this.trigger('reset', this, options);
	      return models;
	    },
	
	    // Add a model to the end of the collection.
	    push: function(model, options) {
	      return this.add(model, _.extend({at: this.length}, options));
	    },
	
	    // Remove a model from the end of the collection.
	    pop: function(options) {
	      var model = this.at(this.length - 1);
	      return this.remove(model, options);
	    },
	
	    // Add a model to the beginning of the collection.
	    unshift: function(model, options) {
	      return this.add(model, _.extend({at: 0}, options));
	    },
	
	    // Remove a model from the beginning of the collection.
	    shift: function(options) {
	      var model = this.at(0);
	      return this.remove(model, options);
	    },
	
	    // Slice out a sub-array of models from the collection.
	    slice: function() {
	      return slice.apply(this.models, arguments);
	    },
	
	    // Get a model from the set by id, cid, model object with id or cid
	    // properties, or an attributes object that is transformed through modelId.
	    get: function(obj) {
	      if (obj == null) return void 0;
	      return this._byId[obj] ||
	        this._byId[this.modelId(obj.attributes || obj)] ||
	        obj.cid && this._byId[obj.cid];
	    },
	
	    // Returns `true` if the model is in the collection.
	    has: function(obj) {
	      return this.get(obj) != null;
	    },
	
	    // Get the model at the given index.
	    at: function(index) {
	      if (index < 0) index += this.length;
	      return this.models[index];
	    },
	
	    // Return models with matching attributes. Useful for simple cases of
	    // `filter`.
	    where: function(attrs, first) {
	      return this[first ? 'find' : 'filter'](attrs);
	    },
	
	    // Return the first model with matching attributes. Useful for simple cases
	    // of `find`.
	    findWhere: function(attrs) {
	      return this.where(attrs, true);
	    },
	
	    // Force the collection to re-sort itself. You don't need to call this under
	    // normal circumstances, as the set will maintain sort order as each item
	    // is added.
	    sort: function(options) {
	      var comparator = this.comparator;
	      if (!comparator) throw new Error('Cannot sort a set without a comparator');
	      options || (options = {});
	
	      var length = comparator.length;
	      if (_.isFunction(comparator)) comparator = _.bind(comparator, this);
	
	      // Run sort based on type of `comparator`.
	      if (length === 1 || _.isString(comparator)) {
	        this.models = this.sortBy(comparator);
	      } else {
	        this.models.sort(comparator);
	      }
	      if (!options.silent) this.trigger('sort', this, options);
	      return this;
	    },
	
	    // Pluck an attribute from each model in the collection.
	    pluck: function(attr) {
	      return this.map(attr + '');
	    },
	
	    // Fetch the default set of models for this collection, resetting the
	    // collection when they arrive. If `reset: true` is passed, the response
	    // data will be passed through the `reset` method instead of `set`.
	    fetch: function(options) {
	      options = _.extend({parse: true}, options);
	      var success = options.success;
	      var collection = this;
	      options.success = function(resp) {
	        var method = options.reset ? 'reset' : 'set';
	        collection[method](resp, options);
	        if (success) success.call(options.context, collection, resp, options);
	        collection.trigger('sync', collection, resp, options);
	      };
	      wrapError(this, options);
	      return this.sync('read', this, options);
	    },
	
	    // Create a new instance of a model in this collection. Add the model to the
	    // collection immediately, unless `wait: true` is passed, in which case we
	    // wait for the server to agree.
	    create: function(model, options) {
	      options = options ? _.clone(options) : {};
	      var wait = options.wait;
	      model = this._prepareModel(model, options);
	      if (!model) return false;
	      if (!wait) this.add(model, options);
	      var collection = this;
	      var success = options.success;
	      options.success = function(m, resp, callbackOpts) {
	        if (wait) collection.add(m, callbackOpts);
	        if (success) success.call(callbackOpts.context, m, resp, callbackOpts);
	      };
	      model.save(null, options);
	      return model;
	    },
	
	    // **parse** converts a response into a list of models to be added to the
	    // collection. The default implementation is just to pass it through.
	    parse: function(resp, options) {
	      return resp;
	    },
	
	    // Create a new collection with an identical list of models as this one.
	    clone: function() {
	      return new this.constructor(this.models, {
	        model: this.model,
	        comparator: this.comparator
	      });
	    },
	
	    // Define how to uniquely identify models in the collection.
	    modelId: function(attrs) {
	      return attrs[this.model.prototype.idAttribute || 'id'];
	    },
	
	    // Private method to reset all internal state. Called when the collection
	    // is first initialized or reset.
	    _reset: function() {
	      this.length = 0;
	      this.models = [];
	      this._byId  = {};
	    },
	
	    // Prepare a hash of attributes (or other model) to be added to this
	    // collection.
	    _prepareModel: function(attrs, options) {
	      if (this._isModel(attrs)) {
	        if (!attrs.collection) attrs.collection = this;
	        return attrs;
	      }
	      options = options ? _.clone(options) : {};
	      options.collection = this;
	      var model = new this.model(attrs, options);
	      if (!model.validationError) return model;
	      this.trigger('invalid', this, model.validationError, options);
	      return false;
	    },
	
	    // Internal method called by both remove and set.
	    _removeModels: function(models, options) {
	      var removed = [];
	      for (var i = 0; i < models.length; i++) {
	        var model = this.get(models[i]);
	        if (!model) continue;
	
	        var index = this.indexOf(model);
	        this.models.splice(index, 1);
	        this.length--;
	
	        // Remove references before triggering 'remove' event to prevent an
	        // infinite loop. #3693
	        delete this._byId[model.cid];
	        var id = this.modelId(model.attributes);
	        if (id != null) delete this._byId[id];
	
	        if (!options.silent) {
	          options.index = index;
	          model.trigger('remove', model, this, options);
	        }
	
	        removed.push(model);
	        this._removeReference(model, options);
	      }
	      return removed;
	    },
	
	    // Method for checking whether an object should be considered a model for
	    // the purposes of adding to the collection.
	    _isModel: function(model) {
	      return model instanceof Model;
	    },
	
	    // Internal method to create a model's ties to a collection.
	    _addReference: function(model, options) {
	      this._byId[model.cid] = model;
	      var id = this.modelId(model.attributes);
	      if (id != null) this._byId[id] = model;
	      model.on('all', this._onModelEvent, this);
	    },
	
	    // Internal method to sever a model's ties to a collection.
	    _removeReference: function(model, options) {
	      delete this._byId[model.cid];
	      var id = this.modelId(model.attributes);
	      if (id != null) delete this._byId[id];
	      if (this === model.collection) delete model.collection;
	      model.off('all', this._onModelEvent, this);
	    },
	
	    // Internal method called every time a model in the set fires an event.
	    // Sets need to update their indexes when models change ids. All other
	    // events simply proxy through. "add" and "remove" events that originate
	    // in other collections are ignored.
	    _onModelEvent: function(event, model, collection, options) {
	      if (model) {
	        if ((event === 'add' || event === 'remove') && collection !== this) return;
	        if (event === 'destroy') this.remove(model, options);
	        if (event === 'change') {
	          var prevId = this.modelId(model.previousAttributes());
	          var id = this.modelId(model.attributes);
	          if (prevId !== id) {
	            if (prevId != null) delete this._byId[prevId];
	            if (id != null) this._byId[id] = model;
	          }
	        }
	      }
	      this.trigger.apply(this, arguments);
	    }
	
	  });
	
	  // Underscore methods that we want to implement on the Collection.
	  // 90% of the core usefulness of Backbone Collections is actually implemented
	  // right here:
	  var collectionMethods = {forEach: 3, each: 3, map: 3, collect: 3, reduce: 0,
	      foldl: 0, inject: 0, reduceRight: 0, foldr: 0, find: 3, detect: 3, filter: 3,
	      select: 3, reject: 3, every: 3, all: 3, some: 3, any: 3, include: 3, includes: 3,
	      contains: 3, invoke: 0, max: 3, min: 3, toArray: 1, size: 1, first: 3,
	      head: 3, take: 3, initial: 3, rest: 3, tail: 3, drop: 3, last: 3,
	      without: 0, difference: 0, indexOf: 3, shuffle: 1, lastIndexOf: 3,
	      isEmpty: 1, chain: 1, sample: 3, partition: 3, groupBy: 3, countBy: 3,
	      sortBy: 3, indexBy: 3, findIndex: 3, findLastIndex: 3};
	
	  // Mix in each Underscore method as a proxy to `Collection#models`.
	  addUnderscoreMethods(Collection, collectionMethods, 'models');
	
	  // Backbone.View
	  // -------------
	
	  // Backbone Views are almost more convention than they are actual code. A View
	  // is simply a JavaScript object that represents a logical chunk of UI in the
	  // DOM. This might be a single item, an entire list, a sidebar or panel, or
	  // even the surrounding frame which wraps your whole app. Defining a chunk of
	  // UI as a **View** allows you to define your DOM events declaratively, without
	  // having to worry about render order ... and makes it easy for the view to
	  // react to specific changes in the state of your models.
	
	  // Creating a Backbone.View creates its initial element outside of the DOM,
	  // if an existing element is not provided...
	  var View = Backbone.View = function(options) {
	    this.cid = _.uniqueId('view');
	    _.extend(this, _.pick(options, viewOptions));
	    this._ensureElement();
	    this.initialize.apply(this, arguments);
	  };
	
	  // Cached regex to split keys for `delegate`.
	  var delegateEventSplitter = /^(\S+)\s*(.*)$/;
	
	  // List of view options to be set as properties.
	  var viewOptions = ['model', 'collection', 'el', 'id', 'attributes', 'className', 'tagName', 'events'];
	
	  // Set up all inheritable **Backbone.View** properties and methods.
	  _.extend(View.prototype, Events, {
	
	    // The default `tagName` of a View's element is `"div"`.
	    tagName: 'div',
	
	    // jQuery delegate for element lookup, scoped to DOM elements within the
	    // current view. This should be preferred to global lookups where possible.
	    $: function(selector) {
	      return this.$el.find(selector);
	    },
	
	    // Initialize is an empty function by default. Override it with your own
	    // initialization logic.
	    initialize: function(){},
	
	    // **render** is the core function that your view should override, in order
	    // to populate its element (`this.el`), with the appropriate HTML. The
	    // convention is for **render** to always return `this`.
	    render: function() {
	      return this;
	    },
	
	    // Remove this view by taking the element out of the DOM, and removing any
	    // applicable Backbone.Events listeners.
	    remove: function() {
	      this._removeElement();
	      this.stopListening();
	      return this;
	    },
	
	    // Remove this view's element from the document and all event listeners
	    // attached to it. Exposed for subclasses using an alternative DOM
	    // manipulation API.
	    _removeElement: function() {
	      this.$el.remove();
	    },
	
	    // Change the view's element (`this.el` property) and re-delegate the
	    // view's events on the new element.
	    setElement: function(element) {
	      this.undelegateEvents();
	      this._setElement(element);
	      this.delegateEvents();
	      return this;
	    },
	
	    // Creates the `this.el` and `this.$el` references for this view using the
	    // given `el`. `el` can be a CSS selector or an HTML string, a jQuery
	    // context or an element. Subclasses can override this to utilize an
	    // alternative DOM manipulation API and are only required to set the
	    // `this.el` property.
	    _setElement: function(el) {
	      this.$el = el instanceof Backbone.$ ? el : Backbone.$(el);
	      this.el = this.$el[0];
	    },
	
	    // Set callbacks, where `this.events` is a hash of
	    //
	    // *{"event selector": "callback"}*
	    //
	    //     {
	    //       'mousedown .title':  'edit',
	    //       'click .button':     'save',
	    //       'click .open':       function(e) { ... }
	    //     }
	    //
	    // pairs. Callbacks will be bound to the view, with `this` set properly.
	    // Uses event delegation for efficiency.
	    // Omitting the selector binds the event to `this.el`.
	    delegateEvents: function(events) {
	      events || (events = _.result(this, 'events'));
	      if (!events) return this;
	      this.undelegateEvents();
	      for (var key in events) {
	        var method = events[key];
	        if (!_.isFunction(method)) method = this[method];
	        if (!method) continue;
	        var match = key.match(delegateEventSplitter);
	        this.delegate(match[1], match[2], _.bind(method, this));
	      }
	      return this;
	    },
	
	    // Add a single event listener to the view's element (or a child element
	    // using `selector`). This only works for delegate-able events: not `focus`,
	    // `blur`, and not `change`, `submit`, and `reset` in Internet Explorer.
	    delegate: function(eventName, selector, listener) {
	      this.$el.on(eventName + '.delegateEvents' + this.cid, selector, listener);
	      return this;
	    },
	
	    // Clears all callbacks previously bound to the view by `delegateEvents`.
	    // You usually don't need to use this, but may wish to if you have multiple
	    // Backbone views attached to the same DOM element.
	    undelegateEvents: function() {
	      if (this.$el) this.$el.off('.delegateEvents' + this.cid);
	      return this;
	    },
	
	    // A finer-grained `undelegateEvents` for removing a single delegated event.
	    // `selector` and `listener` are both optional.
	    undelegate: function(eventName, selector, listener) {
	      this.$el.off(eventName + '.delegateEvents' + this.cid, selector, listener);
	      return this;
	    },
	
	    // Produces a DOM element to be assigned to your view. Exposed for
	    // subclasses using an alternative DOM manipulation API.
	    _createElement: function(tagName) {
	      return document.createElement(tagName);
	    },
	
	    // Ensure that the View has a DOM element to render into.
	    // If `this.el` is a string, pass it through `$()`, take the first
	    // matching element, and re-assign it to `el`. Otherwise, create
	    // an element from the `id`, `className` and `tagName` properties.
	    _ensureElement: function() {
	      if (!this.el) {
	        var attrs = _.extend({}, _.result(this, 'attributes'));
	        if (this.id) attrs.id = _.result(this, 'id');
	        if (this.className) attrs['class'] = _.result(this, 'className');
	        this.setElement(this._createElement(_.result(this, 'tagName')));
	        this._setAttributes(attrs);
	      } else {
	        this.setElement(_.result(this, 'el'));
	      }
	    },
	
	    // Set attributes from a hash on this view's element.  Exposed for
	    // subclasses using an alternative DOM manipulation API.
	    _setAttributes: function(attributes) {
	      this.$el.attr(attributes);
	    }
	
	  });
	
	  // Backbone.sync
	  // -------------
	
	  // Override this function to change the manner in which Backbone persists
	  // models to the server. You will be passed the type of request, and the
	  // model in question. By default, makes a RESTful Ajax request
	  // to the model's `url()`. Some possible customizations could be:
	  //
	  // * Use `setTimeout` to batch rapid-fire updates into a single request.
	  // * Send up the models as XML instead of JSON.
	  // * Persist models via WebSockets instead of Ajax.
	  //
	  // Turn on `Backbone.emulateHTTP` in order to send `PUT` and `DELETE` requests
	  // as `POST`, with a `_method` parameter containing the true HTTP method,
	  // as well as all requests with the body as `application/x-www-form-urlencoded`
	  // instead of `application/json` with the model in a param named `model`.
	  // Useful when interfacing with server-side languages like **PHP** that make
	  // it difficult to read the body of `PUT` requests.
	  Backbone.sync = function(method, model, options) {
	    var type = methodMap[method];
	
	    // Default options, unless specified.
	    _.defaults(options || (options = {}), {
	      emulateHTTP: Backbone.emulateHTTP,
	      emulateJSON: Backbone.emulateJSON
	    });
	
	    // Default JSON-request options.
	    var params = {type: type, dataType: 'json'};
	
	    // Ensure that we have a URL.
	    if (!options.url) {
	      params.url = _.result(model, 'url') || urlError();
	    }
	
	    // Ensure that we have the appropriate request data.
	    if (options.data == null && model && (method === 'create' || method === 'update' || method === 'patch')) {
	      params.contentType = 'application/json';
	      params.data = JSON.stringify(options.attrs || model.toJSON(options));
	    }
	
	    // For older servers, emulate JSON by encoding the request into an HTML-form.
	    if (options.emulateJSON) {
	      params.contentType = 'application/x-www-form-urlencoded';
	      params.data = params.data ? {model: params.data} : {};
	    }
	
	    // For older servers, emulate HTTP by mimicking the HTTP method with `_method`
	    // And an `X-HTTP-Method-Override` header.
	    if (options.emulateHTTP && (type === 'PUT' || type === 'DELETE' || type === 'PATCH')) {
	      params.type = 'POST';
	      if (options.emulateJSON) params.data._method = type;
	      var beforeSend = options.beforeSend;
	      options.beforeSend = function(xhr) {
	        xhr.setRequestHeader('X-HTTP-Method-Override', type);
	        if (beforeSend) return beforeSend.apply(this, arguments);
	      };
	    }
	
	    // Don't process data on a non-GET request.
	    if (params.type !== 'GET' && !options.emulateJSON) {
	      params.processData = false;
	    }
	
	    // Pass along `textStatus` and `errorThrown` from jQuery.
	    var error = options.error;
	    options.error = function(xhr, textStatus, errorThrown) {
	      options.textStatus = textStatus;
	      options.errorThrown = errorThrown;
	      if (error) error.call(options.context, xhr, textStatus, errorThrown);
	    };
	
	    // Make the request, allowing the user to override any Ajax options.
	    var xhr = options.xhr = Backbone.ajax(_.extend(params, options));
	    model.trigger('request', model, xhr, options);
	    return xhr;
	  };
	
	  // Map from CRUD to HTTP for our default `Backbone.sync` implementation.
	  var methodMap = {
	    'create': 'POST',
	    'update': 'PUT',
	    'patch': 'PATCH',
	    'delete': 'DELETE',
	    'read': 'GET'
	  };
	
	  // Set the default implementation of `Backbone.ajax` to proxy through to `$`.
	  // Override this if you'd like to use a different library.
	  Backbone.ajax = function() {
	    return Backbone.$.ajax.apply(Backbone.$, arguments);
	  };
	
	  // Backbone.Router
	  // ---------------
	
	  // Routers map faux-URLs to actions, and fire events when routes are
	  // matched. Creating a new one sets its `routes` hash, if not set statically.
	  var Router = Backbone.Router = function(options) {
	    options || (options = {});
	    if (options.routes) this.routes = options.routes;
	    this._bindRoutes();
	    this.initialize.apply(this, arguments);
	  };
	
	  // Cached regular expressions for matching named param parts and splatted
	  // parts of route strings.
	  var optionalParam = /\((.*?)\)/g;
	  var namedParam    = /(\(\?)?:\w+/g;
	  var splatParam    = /\*\w+/g;
	  var escapeRegExp  = /[\-{}\[\]+?.,\\\^$|#\s]/g;
	
	  // Set up all inheritable **Backbone.Router** properties and methods.
	  _.extend(Router.prototype, Events, {
	
	    // Initialize is an empty function by default. Override it with your own
	    // initialization logic.
	    initialize: function(){},
	
	    // Manually bind a single named route to a callback. For example:
	    //
	    //     this.route('search/:query/p:num', 'search', function(query, num) {
	    //       ...
	    //     });
	    //
	    route: function(route, name, callback) {
	      if (!_.isRegExp(route)) route = this._routeToRegExp(route);
	      if (_.isFunction(name)) {
	        callback = name;
	        name = '';
	      }
	      if (!callback) callback = this[name];
	      var router = this;
	      Backbone.history.route(route, function(fragment) {
	        var args = router._extractParameters(route, fragment);
	        if (router.execute(callback, args, name) !== false) {
	          router.trigger.apply(router, ['route:' + name].concat(args));
	          router.trigger('route', name, args);
	          Backbone.history.trigger('route', router, name, args);
	        }
	      });
	      return this;
	    },
	
	    // Execute a route handler with the provided parameters.  This is an
	    // excellent place to do pre-route setup or post-route cleanup.
	    execute: function(callback, args, name) {
	      if (callback) callback.apply(this, args);
	    },
	
	    // Simple proxy to `Backbone.history` to save a fragment into the history.
	    navigate: function(fragment, options) {
	      Backbone.history.navigate(fragment, options);
	      return this;
	    },
	
	    // Bind all defined routes to `Backbone.history`. We have to reverse the
	    // order of the routes here to support behavior where the most general
	    // routes can be defined at the bottom of the route map.
	    _bindRoutes: function() {
	      if (!this.routes) return;
	      this.routes = _.result(this, 'routes');
	      var route, routes = _.keys(this.routes);
	      while ((route = routes.pop()) != null) {
	        this.route(route, this.routes[route]);
	      }
	    },
	
	    // Convert a route string into a regular expression, suitable for matching
	    // against the current location hash.
	    _routeToRegExp: function(route) {
	      route = route.replace(escapeRegExp, '\\$&')
	                   .replace(optionalParam, '(?:$1)?')
	                   .replace(namedParam, function(match, optional) {
	                     return optional ? match : '([^/?]+)';
	                   })
	                   .replace(splatParam, '([^?]*?)');
	      return new RegExp('^' + route + '(?:\\?([\\s\\S]*))?$');
	    },
	
	    // Given a route, and a URL fragment that it matches, return the array of
	    // extracted decoded parameters. Empty or unmatched parameters will be
	    // treated as `null` to normalize cross-browser behavior.
	    _extractParameters: function(route, fragment) {
	      var params = route.exec(fragment).slice(1);
	      return _.map(params, function(param, i) {
	        // Don't decode the search params.
	        if (i === params.length - 1) return param || null;
	        return param ? decodeURIComponent(param) : null;
	      });
	    }
	
	  });
	
	  // Backbone.History
	  // ----------------
	
	  // Handles cross-browser history management, based on either
	  // [pushState](http://diveintohtml5.info/history.html) and real URLs, or
	  // [onhashchange](https://developer.mozilla.org/en-US/docs/DOM/window.onhashchange)
	  // and URL fragments. If the browser supports neither (old IE, natch),
	  // falls back to polling.
	  var History = Backbone.History = function() {
	    this.handlers = [];
	    this.checkUrl = _.bind(this.checkUrl, this);
	
	    // Ensure that `History` can be used outside of the browser.
	    if (typeof window !== 'undefined') {
	      this.location = window.location;
	      this.history = window.history;
	    }
	  };
	
	  // Cached regex for stripping a leading hash/slash and trailing space.
	  var routeStripper = /^[#\/]|\s+$/g;
	
	  // Cached regex for stripping leading and trailing slashes.
	  var rootStripper = /^\/+|\/+$/g;
	
	  // Cached regex for stripping urls of hash.
	  var pathStripper = /#.*$/;
	
	  // Has the history handling already been started?
	  History.started = false;
	
	  // Set up all inheritable **Backbone.History** properties and methods.
	  _.extend(History.prototype, Events, {
	
	    // The default interval to poll for hash changes, if necessary, is
	    // twenty times a second.
	    interval: 50,
	
	    // Are we at the app root?
	    atRoot: function() {
	      var path = this.location.pathname.replace(/[^\/]$/, '$&/');
	      return path === this.root && !this.getSearch();
	    },
	
	    // Does the pathname match the root?
	    matchRoot: function() {
	      var path = this.decodeFragment(this.location.pathname);
	      var rootPath = path.slice(0, this.root.length - 1) + '/';
	      return rootPath === this.root;
	    },
	
	    // Unicode characters in `location.pathname` are percent encoded so they're
	    // decoded for comparison. `%25` should not be decoded since it may be part
	    // of an encoded parameter.
	    decodeFragment: function(fragment) {
	      return decodeURI(fragment.replace(/%25/g, '%2525'));
	    },
	
	    // In IE6, the hash fragment and search params are incorrect if the
	    // fragment contains `?`.
	    getSearch: function() {
	      var match = this.location.href.replace(/#.*/, '').match(/\?.+/);
	      return match ? match[0] : '';
	    },
	
	    // Gets the true hash value. Cannot use location.hash directly due to bug
	    // in Firefox where location.hash will always be decoded.
	    getHash: function(window) {
	      var match = (window || this).location.href.match(/#(.*)$/);
	      return match ? match[1] : '';
	    },
	
	    // Get the pathname and search params, without the root.
	    getPath: function() {
	      var path = this.decodeFragment(
	        this.location.pathname + this.getSearch()
	      ).slice(this.root.length - 1);
	      return path.charAt(0) === '/' ? path.slice(1) : path;
	    },
	
	    // Get the cross-browser normalized URL fragment from the path or hash.
	    getFragment: function(fragment) {
	      if (fragment == null) {
	        if (this._usePushState || !this._wantsHashChange) {
	          fragment = this.getPath();
	        } else {
	          fragment = this.getHash();
	        }
	      }
	      return fragment.replace(routeStripper, '');
	    },
	
	    // Start the hash change handling, returning `true` if the current URL matches
	    // an existing route, and `false` otherwise.
	    start: function(options) {
	      if (History.started) throw new Error('Backbone.history has already been started');
	      History.started = true;
	
	      // Figure out the initial configuration. Do we need an iframe?
	      // Is pushState desired ... is it available?
	      this.options          = _.extend({root: '/'}, this.options, options);
	      this.root             = this.options.root;
	      this._wantsHashChange = this.options.hashChange !== false;
	      this._hasHashChange   = 'onhashchange' in window && (document.documentMode === void 0 || document.documentMode > 7);
	      this._useHashChange   = this._wantsHashChange && this._hasHashChange;
	      this._wantsPushState  = !!this.options.pushState;
	      this._hasPushState    = !!(this.history && this.history.pushState);
	      this._usePushState    = this._wantsPushState && this._hasPushState;
	      this.fragment         = this.getFragment();
	
	      // Normalize root to always include a leading and trailing slash.
	      this.root = ('/' + this.root + '/').replace(rootStripper, '/');
	
	      // Transition from hashChange to pushState or vice versa if both are
	      // requested.
	      if (this._wantsHashChange && this._wantsPushState) {
	
	        // If we've started off with a route from a `pushState`-enabled
	        // browser, but we're currently in a browser that doesn't support it...
	        if (!this._hasPushState && !this.atRoot()) {
	          var rootPath = this.root.slice(0, -1) || '/';
	          this.location.replace(rootPath + '#' + this.getPath());
	          // Return immediately as browser will do redirect to new url
	          return true;
	
	        // Or if we've started out with a hash-based route, but we're currently
	        // in a browser where it could be `pushState`-based instead...
	        } else if (this._hasPushState && this.atRoot()) {
	          this.navigate(this.getHash(), {replace: true});
	        }
	
	      }
	
	      // Proxy an iframe to handle location events if the browser doesn't
	      // support the `hashchange` event, HTML5 history, or the user wants
	      // `hashChange` but not `pushState`.
	      if (!this._hasHashChange && this._wantsHashChange && !this._usePushState) {
	        this.iframe = document.createElement('iframe');
	        this.iframe.src = 'javascript:0';
	        this.iframe.style.display = 'none';
	        this.iframe.tabIndex = -1;
	        var body = document.body;
	        // Using `appendChild` will throw on IE < 9 if the document is not ready.
	        var iWindow = body.insertBefore(this.iframe, body.firstChild).contentWindow;
	        iWindow.document.open();
	        iWindow.document.close();
	        iWindow.location.hash = '#' + this.fragment;
	      }
	
	      // Add a cross-platform `addEventListener` shim for older browsers.
	      var addEventListener = window.addEventListener || function(eventName, listener) {
	        return attachEvent('on' + eventName, listener);
	      };
	
	      // Depending on whether we're using pushState or hashes, and whether
	      // 'onhashchange' is supported, determine how we check the URL state.
	      if (this._usePushState) {
	        addEventListener('popstate', this.checkUrl, false);
	      } else if (this._useHashChange && !this.iframe) {
	        addEventListener('hashchange', this.checkUrl, false);
	      } else if (this._wantsHashChange) {
	        this._checkUrlInterval = setInterval(this.checkUrl, this.interval);
	      }
	
	      if (!this.options.silent) return this.loadUrl();
	    },
	
	    // Disable Backbone.history, perhaps temporarily. Not useful in a real app,
	    // but possibly useful for unit testing Routers.
	    stop: function() {
	      // Add a cross-platform `removeEventListener` shim for older browsers.
	      var removeEventListener = window.removeEventListener || function(eventName, listener) {
	        return detachEvent('on' + eventName, listener);
	      };
	
	      // Remove window listeners.
	      if (this._usePushState) {
	        removeEventListener('popstate', this.checkUrl, false);
	      } else if (this._useHashChange && !this.iframe) {
	        removeEventListener('hashchange', this.checkUrl, false);
	      }
	
	      // Clean up the iframe if necessary.
	      if (this.iframe) {
	        document.body.removeChild(this.iframe);
	        this.iframe = null;
	      }
	
	      // Some environments will throw when clearing an undefined interval.
	      if (this._checkUrlInterval) clearInterval(this._checkUrlInterval);
	      History.started = false;
	    },
	
	    // Add a route to be tested when the fragment changes. Routes added later
	    // may override previous routes.
	    route: function(route, callback) {
	      this.handlers.unshift({route: route, callback: callback});
	    },
	
	    // Checks the current URL to see if it has changed, and if it has,
	    // calls `loadUrl`, normalizing across the hidden iframe.
	    checkUrl: function(e) {
	      var current = this.getFragment();
	
	      // If the user pressed the back button, the iframe's hash will have
	      // changed and we should use that for comparison.
	      if (current === this.fragment && this.iframe) {
	        current = this.getHash(this.iframe.contentWindow);
	      }
	
	      if (current === this.fragment) return false;
	      if (this.iframe) this.navigate(current);
	      this.loadUrl();
	    },
	
	    // Attempt to load the current URL fragment. If a route succeeds with a
	    // match, returns `true`. If no defined routes matches the fragment,
	    // returns `false`.
	    loadUrl: function(fragment) {
	      // If the root doesn't match, no routes can match either.
	      if (!this.matchRoot()) return false;
	      fragment = this.fragment = this.getFragment(fragment);
	      return _.some(this.handlers, function(handler) {
	        if (handler.route.test(fragment)) {
	          handler.callback(fragment);
	          return true;
	        }
	      });
	    },
	
	    // Save a fragment into the hash history, or replace the URL state if the
	    // 'replace' option is passed. You are responsible for properly URL-encoding
	    // the fragment in advance.
	    //
	    // The options object can contain `trigger: true` if you wish to have the
	    // route callback be fired (not usually desirable), or `replace: true`, if
	    // you wish to modify the current URL without adding an entry to the history.
	    navigate: function(fragment, options) {
	      if (!History.started) return false;
	      if (!options || options === true) options = {trigger: !!options};
	
	      // Normalize the fragment.
	      fragment = this.getFragment(fragment || '');
	
	      // Don't include a trailing slash on the root.
	      var rootPath = this.root;
	      if (fragment === '' || fragment.charAt(0) === '?') {
	        rootPath = rootPath.slice(0, -1) || '/';
	      }
	      var url = rootPath + fragment;
	
	      // Strip the hash and decode for matching.
	      fragment = this.decodeFragment(fragment.replace(pathStripper, ''));
	
	      if (this.fragment === fragment) return;
	      this.fragment = fragment;
	
	      // If pushState is available, we use it to set the fragment as a real URL.
	      if (this._usePushState) {
	        this.history[options.replace ? 'replaceState' : 'pushState']({}, document.title, url);
	
	      // If hash changes haven't been explicitly disabled, update the hash
	      // fragment to store history.
	      } else if (this._wantsHashChange) {
	        this._updateHash(this.location, fragment, options.replace);
	        if (this.iframe && fragment !== this.getHash(this.iframe.contentWindow)) {
	          var iWindow = this.iframe.contentWindow;
	
	          // Opening and closing the iframe tricks IE7 and earlier to push a
	          // history entry on hash-tag change.  When replace is true, we don't
	          // want this.
	          if (!options.replace) {
	            iWindow.document.open();
	            iWindow.document.close();
	          }
	
	          this._updateHash(iWindow.location, fragment, options.replace);
	        }
	
	      // If you've told us that you explicitly don't want fallback hashchange-
	      // based history, then `navigate` becomes a page refresh.
	      } else {
	        return this.location.assign(url);
	      }
	      if (options.trigger) return this.loadUrl(fragment);
	    },
	
	    // Update the hash location, either replacing the current entry, or adding
	    // a new one to the browser history.
	    _updateHash: function(location, fragment, replace) {
	      if (replace) {
	        var href = location.href.replace(/(javascript:|#).*$/, '');
	        location.replace(href + '#' + fragment);
	      } else {
	        // Some browsers require that `hash` contains a leading #.
	        location.hash = '#' + fragment;
	      }
	    }
	
	  });
	
	  // Create the default Backbone.history.
	  Backbone.history = new History;
	
	  // Helpers
	  // -------
	
	  // Helper function to correctly set up the prototype chain for subclasses.
	  // Similar to `goog.inherits`, but uses a hash of prototype properties and
	  // class properties to be extended.
	  var extend = function(protoProps, staticProps) {
	    var parent = this;
	    var child;
	
	    // The constructor function for the new subclass is either defined by you
	    // (the "constructor" property in your `extend` definition), or defaulted
	    // by us to simply call the parent constructor.
	    if (protoProps && _.has(protoProps, 'constructor')) {
	      child = protoProps.constructor;
	    } else {
	      child = function(){ return parent.apply(this, arguments); };
	    }
	
	    // Add static properties to the constructor function, if supplied.
	    _.extend(child, parent, staticProps);
	
	    // Set the prototype chain to inherit from `parent`, without calling
	    // `parent`'s constructor function and add the prototype properties.
	    child.prototype = _.create(parent.prototype, protoProps);
	    child.prototype.constructor = child;
	
	    // Set a convenience property in case the parent's prototype is needed
	    // later.
	    child.__super__ = parent.prototype;
	
	    return child;
	  };
	
	  // Set up inheritance for the model, collection, router, view and history.
	  Model.extend = Collection.extend = Router.extend = View.extend = History.extend = extend;
	
	  // Throw an error when a URL is needed, and none is supplied.
	  var urlError = function() {
	    throw new Error('A "url" property or function must be specified');
	  };
	
	  // Wrap an optional error callback with a fallback error event.
	  var wrapError = function(model, options) {
	    var error = options.error;
	    options.error = function(resp) {
	      if (error) error.call(options.context, model, resp, options);
	      model.trigger('error', model, resp, options);
	    };
	  };
	
	  return Backbone;
	});
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 77 */
/***/ function(module, exports) {

	module.exports = function(arr, obj){
	  if (arr.indexOf) return arr.indexOf(obj);
	  for (var i = 0; i < arr.length; ++i) {
	    if (arr[i] === obj) return i;
	  }
	  return -1;
	};

/***/ },
/* 78 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _utils = __webpack_require__(29);
	
	var _utils2 = _interopRequireDefault(_utils);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	/**
	 * 得到会导致元素显示不全的祖先元素
	 */
	
	function getOffsetParent(element) {
	  // ie 这个也不是完全可行
	  /*
	   <div style="width: 50px;height: 100px;overflow: hidden">
	   <div style="width: 50px;height: 100px;position: relative;" id="d6">
	   元素 6 高 100px 宽 50px<br/>
	   </div>
	   </div>
	   */
	  // element.offsetParent does the right thing in ie7 and below. Return parent with layout!
	  //  In other browsers it only includes elements with position absolute, relative or
	  // fixed, not elements with overflow set to auto or scroll.
	  //        if (UA.ie && ieMode < 8) {
	  //            return element.offsetParent;
	  //        }
	  // 统一的 offsetParent 方法
	  var doc = element.ownerDocument;
	  var body = doc.body;
	  var parent = void 0;
	  var positionStyle = _utils2["default"].css(element, 'position');
	  var skipStatic = positionStyle === 'fixed' || positionStyle === 'absolute';
	
	  if (!skipStatic) {
	    return element.nodeName.toLowerCase() === 'html' ? null : element.parentNode;
	  }
	
	  for (parent = element.parentNode; parent && parent !== body; parent = parent.parentNode) {
	    positionStyle = _utils2["default"].css(parent, 'position');
	    if (positionStyle !== 'static') {
	      return parent;
	    }
	  }
	  return null;
	}
	
	exports["default"] = getOffsetParent;
	module.exports = exports['default'];

/***/ },
/* 79 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 *
	 * @typechecks
	 */
	
	var emptyFunction = __webpack_require__(10);
	
	/**
	 * Upstream version of event listener. Does not take into account specific
	 * nature of platform.
	 */
	var EventListener = {
	  /**
	   * Listen to DOM events during the bubble phase.
	   *
	   * @param {DOMEventTarget} target DOM element to register listener on.
	   * @param {string} eventType Event type, e.g. 'click' or 'mouseover'.
	   * @param {function} callback Callback function.
	   * @return {object} Object with a `remove` method.
	   */
	  listen: function listen(target, eventType, callback) {
	    if (target.addEventListener) {
	      target.addEventListener(eventType, callback, false);
	      return {
	        remove: function remove() {
	          target.removeEventListener(eventType, callback, false);
	        }
	      };
	    } else if (target.attachEvent) {
	      target.attachEvent('on' + eventType, callback);
	      return {
	        remove: function remove() {
	          target.detachEvent('on' + eventType, callback);
	        }
	      };
	    }
	  },
	
	  /**
	   * Listen to DOM events during the capture phase.
	   *
	   * @param {DOMEventTarget} target DOM element to register listener on.
	   * @param {string} eventType Event type, e.g. 'click' or 'mouseover'.
	   * @param {function} callback Callback function.
	   * @return {object} Object with a `remove` method.
	   */
	  capture: function capture(target, eventType, callback) {
	    if (target.addEventListener) {
	      target.addEventListener(eventType, callback, true);
	      return {
	        remove: function remove() {
	          target.removeEventListener(eventType, callback, true);
	        }
	      };
	    } else {
	      if (false) {
	        console.error('Attempted to listen to events during the capture phase on a ' + 'browser that does not support the capture phase. Your application ' + 'will not receive some events.');
	      }
	      return {
	        remove: emptyFunction
	      };
	    }
	  },
	
	  registerDefault: function registerDefault() {}
	};
	
	module.exports = EventListener;

/***/ },
/* 80 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	/**
	 * @param {DOMElement} node input/textarea to focus
	 */
	
	function focusNode(node) {
	  // IE8 can throw "Can't move focus to the control because it is invisible,
	  // not enabled, or of a type that does not accept the focus." for all kinds of
	  // reasons that are too expensive and fragile to test.
	  try {
	    node.focus();
	  } catch (e) {}
	}
	
	module.exports = focusNode;

/***/ },
/* 81 */
/***/ function(module, exports) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks
	 */
	
	/* eslint-disable fb-www/typeof-undefined */
	
	/**
	 * Same as document.activeElement but wraps in a try-catch block. In IE it is
	 * not safe to call document.activeElement if there is nothing focused.
	 *
	 * The activeElement will be null only if the document or document body is not
	 * yet defined.
	 */
	function getActiveElement() /*?DOMElement*/{
	  if (typeof document === 'undefined') {
	    return null;
	  }
	  try {
	    return document.activeElement || document.body;
	  } catch (e) {
	    return document.body;
	  }
	}
	
	module.exports = getActiveElement;

/***/ },
/* 82 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * lodash 3.1.2 (Custom Build) <https://lodash.com/>
	 * Build: `lodash modern modularize exports="npm" -o ./`
	 * Copyright 2012-2015 The Dojo Foundation <http://dojofoundation.org/>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 * Available under MIT license <https://lodash.com/license>
	 */
	var getNative = __webpack_require__(165),
	    isArguments = __webpack_require__(167),
	    isArray = __webpack_require__(168);
	
	/** Used to detect unsigned integer values. */
	var reIsUint = /^\d+$/;
	
	/** Used for native method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/* Native method references for those with the same name as other `lodash` methods. */
	var nativeKeys = getNative(Object, 'keys');
	
	/**
	 * Used as the [maximum length](http://ecma-international.org/ecma-262/6.0/#sec-number.max_safe_integer)
	 * of an array-like value.
	 */
	var MAX_SAFE_INTEGER = 9007199254740991;
	
	/**
	 * The base implementation of `_.property` without support for deep paths.
	 *
	 * @private
	 * @param {string} key The key of the property to get.
	 * @returns {Function} Returns the new function.
	 */
	function baseProperty(key) {
	  return function(object) {
	    return object == null ? undefined : object[key];
	  };
	}
	
	/**
	 * Gets the "length" property value of `object`.
	 *
	 * **Note:** This function is used to avoid a [JIT bug](https://bugs.webkit.org/show_bug.cgi?id=142792)
	 * that affects Safari on at least iOS 8.1-8.3 ARM64.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {*} Returns the "length" value.
	 */
	var getLength = baseProperty('length');
	
	/**
	 * Checks if `value` is array-like.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
	 */
	function isArrayLike(value) {
	  return value != null && isLength(getLength(value));
	}
	
	/**
	 * Checks if `value` is a valid array-like index.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
	 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
	 */
	function isIndex(value, length) {
	  value = (typeof value == 'number' || reIsUint.test(value)) ? +value : -1;
	  length = length == null ? MAX_SAFE_INTEGER : length;
	  return value > -1 && value % 1 == 0 && value < length;
	}
	
	/**
	 * Checks if `value` is a valid array-like length.
	 *
	 * **Note:** This function is based on [`ToLength`](http://ecma-international.org/ecma-262/6.0/#sec-tolength).
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
	 */
	function isLength(value) {
	  return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
	}
	
	/**
	 * A fallback implementation of `Object.keys` which creates an array of the
	 * own enumerable property names of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 */
	function shimKeys(object) {
	  var props = keysIn(object),
	      propsLength = props.length,
	      length = propsLength && object.length;
	
	  var allowIndexes = !!length && isLength(length) &&
	    (isArray(object) || isArguments(object));
	
	  var index = -1,
	      result = [];
	
	  while (++index < propsLength) {
	    var key = props[index];
	    if ((allowIndexes && isIndex(key, length)) || hasOwnProperty.call(object, key)) {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	/**
	 * Checks if `value` is the [language type](https://es5.github.io/#x8) of `Object`.
	 * (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(1);
	 * // => false
	 */
	function isObject(value) {
	  // Avoid a V8 JIT bug in Chrome 19-20.
	  // See https://code.google.com/p/v8/issues/detail?id=2291 for more details.
	  var type = typeof value;
	  return !!value && (type == 'object' || type == 'function');
	}
	
	/**
	 * Creates an array of the own enumerable property names of `object`.
	 *
	 * **Note:** Non-object values are coerced to objects. See the
	 * [ES spec](http://ecma-international.org/ecma-262/6.0/#sec-object.keys)
	 * for more details.
	 *
	 * @static
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.keys(new Foo);
	 * // => ['a', 'b'] (iteration order is not guaranteed)
	 *
	 * _.keys('hi');
	 * // => ['0', '1']
	 */
	var keys = !nativeKeys ? shimKeys : function(object) {
	  var Ctor = object == null ? undefined : object.constructor;
	  if ((typeof Ctor == 'function' && Ctor.prototype === object) ||
	      (typeof object != 'function' && isArrayLike(object))) {
	    return shimKeys(object);
	  }
	  return isObject(object) ? nativeKeys(object) : [];
	};
	
	/**
	 * Creates an array of the own and inherited enumerable property names of `object`.
	 *
	 * **Note:** Non-object values are coerced to objects.
	 *
	 * @static
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.keysIn(new Foo);
	 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
	 */
	function keysIn(object) {
	  if (object == null) {
	    return [];
	  }
	  if (!isObject(object)) {
	    object = Object(object);
	  }
	  var length = object.length;
	  length = (length && isLength(length) &&
	    (isArray(object) || isArguments(object)) && length) || 0;
	
	  var Ctor = object.constructor,
	      index = -1,
	      isProto = typeof Ctor == 'function' && Ctor.prototype === object,
	      result = Array(length),
	      skipIndexes = length > 0;
	
	  while (++index < length) {
	    result[index] = (index + '');
	  }
	  for (var key in object) {
	    if (!(skipIndexes && isIndex(key, length)) &&
	        !(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	module.exports = keys;


/***/ },
/* 83 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var util = {
	  isAppearSupported: function isAppearSupported(props) {
	    return props.transitionName && props.transitionAppear || props.animation.appear;
	  },
	  isEnterSupported: function isEnterSupported(props) {
	    return props.transitionName && props.transitionEnter || props.animation.enter;
	  },
	  isLeaveSupported: function isLeaveSupported(props) {
	    return props.transitionName && props.transitionLeave || props.animation.leave;
	  },
	  allowAppearCallback: function allowAppearCallback(props) {
	    return props.transitionAppear || props.animation.appear;
	  },
	  allowEnterCallback: function allowEnterCallback(props) {
	    return props.transitionEnter || props.animation.enter;
	  },
	  allowLeaveCallback: function allowLeaveCallback(props) {
	    return props.transitionLeave || props.animation.leave;
	  }
	};
	exports["default"] = util;
	module.exports = exports['default'];

/***/ },
/* 84 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = __webpack_require__(181);

/***/ },
/* 85 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var LazyRenderBox = _react2["default"].createClass({
	  displayName: 'LazyRenderBox',
	
	  propTypes: {
	    children: _react.PropTypes.any,
	    className: _react.PropTypes.string,
	    visible: _react.PropTypes.bool,
	    hiddenClassName: _react.PropTypes.string
	  },
	  shouldComponentUpdate: function shouldComponentUpdate(nextProps) {
	    return nextProps.hiddenClassName || nextProps.visible;
	  },
	  render: function render() {
	    var _props = this.props;
	    var hiddenClassName = _props.hiddenClassName;
	    var visible = _props.visible;
	
	    var props = _objectWithoutProperties(_props, ['hiddenClassName', 'visible']);
	
	    if (hiddenClassName || _react2["default"].Children.count(props.children) > 1) {
	      if (!visible && hiddenClassName) {
	        props.className += ' ' + hiddenClassName;
	      }
	      return _react2["default"].createElement('div', props);
	    }
	
	    return _react2["default"].Children.only(props.children);
	  }
	});
	
	exports["default"] = LazyRenderBox;
	module.exports = exports['default'];

/***/ },
/* 86 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = addEventListenerWrap;
	
	var _addDomEventListener = __webpack_require__(133);
	
	var _addDomEventListener2 = _interopRequireDefault(_addDomEventListener);
	
	var _reactDom = __webpack_require__(16);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function addEventListenerWrap(target, eventType, cb) {
	  /* eslint camelcase: 2 */
	  var callback = _reactDom2["default"].unstable_batchedUpdates ? function run(e) {
	    _reactDom2["default"].unstable_batchedUpdates(cb, e);
	  } : cb;
	  return (0, _addDomEventListener2["default"])(target, eventType, callback);
	}
	module.exports = exports['default'];

/***/ },
/* 87 */
/***/ function(module, exports) {

	/*!
	 * Adapted from jQuery UI core
	 *
	 * http://jqueryui.com
	 *
	 * Copyright 2014 jQuery Foundation and other contributors
	 * Released under the MIT license.
	 * http://jquery.org/license
	 *
	 * http://api.jqueryui.com/category/ui-core/
	 */
	
	function focusable(element, isTabIndexNotNaN) {
	  var nodeName = element.nodeName.toLowerCase();
	  return (/input|select|textarea|button|object/.test(nodeName) ?
	    !element.disabled :
	    "a" === nodeName ?
	      element.href || isTabIndexNotNaN :
	      isTabIndexNotNaN) && visible(element);
	}
	
	function hidden(el) {
	  return (el.offsetWidth <= 0 && el.offsetHeight <= 0) ||
	    el.style.display === 'none';
	}
	
	function visible(element) {
	  while (element) {
	    if (element === document.body) break;
	    if (hidden(element)) return false;
	    element = element.parentNode;
	  }
	  return true;
	}
	
	function tabbable(element) {
	  var tabIndex = element.getAttribute('tabindex');
	  if (tabIndex === null) tabIndex = undefined;
	  var isTabIndexNaN = isNaN(tabIndex);
	  return (isTabIndexNaN || tabIndex >= 0) && focusable(element, !isTabIndexNaN);
	}
	
	function findTabbableDescendants(element) {
	  return [].slice.call(element.querySelectorAll('*'), 0).filter(function(el) {
	    return tabbable(el);
	  });
	}
	
	module.exports = findTabbableDescendants;
	


/***/ },
/* 88 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * lodash 3.2.0 (Custom Build) <https://lodash.com/>
	 * Build: `lodash modern modularize exports="npm" -o ./`
	 * Copyright 2012-2015 The Dojo Foundation <http://dojofoundation.org/>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 * Available under MIT license <https://lodash.com/license>
	 */
	var baseAssign = __webpack_require__(161),
	    createAssigner = __webpack_require__(164),
	    keys = __webpack_require__(82);
	
	/**
	 * A specialized version of `_.assign` for customizing assigned values without
	 * support for argument juggling, multiple sources, and `this` binding `customizer`
	 * functions.
	 *
	 * @private
	 * @param {Object} object The destination object.
	 * @param {Object} source The source object.
	 * @param {Function} customizer The function to customize assigned values.
	 * @returns {Object} Returns `object`.
	 */
	function assignWith(object, source, customizer) {
	  var index = -1,
	      props = keys(source),
	      length = props.length;
	
	  while (++index < length) {
	    var key = props[index],
	        value = object[key],
	        result = customizer(value, source[key], key, object, source);
	
	    if ((result === result ? (result !== value) : (value === value)) ||
	        (value === undefined && !(key in object))) {
	      object[key] = result;
	    }
	  }
	  return object;
	}
	
	/**
	 * Assigns own enumerable properties of source object(s) to the destination
	 * object. Subsequent sources overwrite property assignments of previous sources.
	 * If `customizer` is provided it is invoked to produce the assigned values.
	 * The `customizer` is bound to `thisArg` and invoked with five arguments:
	 * (objectValue, sourceValue, key, object, source).
	 *
	 * **Note:** This method mutates `object` and is based on
	 * [`Object.assign`](https://people.mozilla.org/~jorendorff/es6-draft.html#sec-object.assign).
	 *
	 * @static
	 * @memberOf _
	 * @alias extend
	 * @category Object
	 * @param {Object} object The destination object.
	 * @param {...Object} [sources] The source objects.
	 * @param {Function} [customizer] The function to customize assigned values.
	 * @param {*} [thisArg] The `this` binding of `customizer`.
	 * @returns {Object} Returns `object`.
	 * @example
	 *
	 * _.assign({ 'user': 'barney' }, { 'age': 40 }, { 'user': 'fred' });
	 * // => { 'user': 'fred', 'age': 40 }
	 *
	 * // using a customizer callback
	 * var defaults = _.partialRight(_.assign, function(value, other) {
	 *   return _.isUndefined(value) ? other : value;
	 * });
	 *
	 * defaults({ 'user': 'barney' }, { 'age': 36 }, { 'user': 'fred' });
	 * // => { 'user': 'barney', 'age': 36 }
	 */
	var assign = createAssigner(function(object, source, customizer) {
	  return customizer
	    ? assignWith(object, source, customizer)
	    : baseAssign(object, source);
	});
	
	module.exports = assign;


/***/ },
/* 89 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	exports["default"] = _react.PropTypes.shape({
	  subscribe: _react.PropTypes.func.isRequired,
	  dispatch: _react.PropTypes.func.isRequired,
	  getState: _react.PropTypes.func.isRequired
	});

/***/ },
/* 90 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports["default"] = warning;
	/**
	 * Prints a warning in the console if it exists.
	 *
	 * @param {String} message The warning message.
	 * @returns {void}
	 */
	function warning(message) {
	  /* eslint-disable no-console */
	  if (typeof console !== 'undefined' && typeof console.error === 'function') {
	    console.error(message);
	  }
	  /* eslint-enable no-console */
	  try {
	    // This error was thrown as a convenience so that you can use this stack
	    // to find the callsite that caused this warning to fire.
	    throw new Error(message);
	    /* eslint-disable no-empty */
	  } catch (e) {}
	  /* eslint-enable no-empty */
	}

/***/ },
/* 91 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _underscore = __webpack_require__(7);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _abl = __webpack_require__(12);
	
	var _abl2 = _interopRequireDefault(_abl);
	
	var _time = __webpack_require__(24);
	
	var _time2 = _interopRequireDefault(_time);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	var GoogleSheetProcessor = _abl2.default.createClass({
		DAY_OF_WEEK_MAP: {
			"M": "Monday",
			"T": "Tuesday",
			"W": "Wednesday",
			"Th": "Thursday",
			"F": "Friday"
		},
	
		initialize: function initialize(result) {
			var version = arguments.length <= 1 || arguments[1] === undefined ? 1.0 : arguments[1];
	
			this.name = null;
			this.id = null;
			this.teachers = [];
			this.cohorts = [];
			this.meetings = [];
			this.scheduledMeetings = [];
			this.version = version;
			this._processData(result);
		},
	
		toJSON: function toJSON() {
			return {
				name: this.name,
				id: this.id,
				teachers: this.teachers,
				cohorts: this.cohorts,
				meetings: this.meetings,
				scheduledMeetings: this.scheduledMeetings
			};
		},
	
		_processData: function _processData(result) {
			switch (this.version) {
				case 1.0:
					this._processV1Data(result);
					break;
				case 2.0:
					this._processV2Data(result);
					break;
				default:
					console.log('Unrecognized sheet version!');
			}
		},
	
		_processV1Data: function _processV1Data(result) {
			if (result.sheets.length >= 3) {
				this.id = result.spreadsheetId;
				this.name = result.properties.title;
				this._processSchedules(this._selectSheet(result.sheets, 'School'), this.scheduledMeetings);
				this._createObjectsFromSheet(this._selectSheet(result.sheets, 'Teachers'), this.teachers, this._processTeacher);
				this._createObjectsFromSheet(this._selectSheet(result.sheets, 'Meetings'), this.meetings);
				this.cohorts = _underscore2.default.chain(this.scheduledMeetings).map(function (meeting) {
					return meeting.cohort_ids;
				}).flatten().uniq().compact().map(function (cohort_id) {
					return Object.assign({ id: cohort_id });
				}).value();
			}
		},
	
		_processV2Data: function _processV2Data(result) {
			if (result.sheets.length >= 3) {
				this.id = result.spreadsheetId;
				this.name = result.properties.title;
				this._processScheduledMeetings(this._selectSheet(result.sheets, 'School'), this.scheduledMeetings);
				this._createObjectsFromSheet(this._selectSheet(result.sheets, 'Staff'), this.teachers, this._processTeacher);
				this._createObjectsFromSheet(this._selectSheet(result.sheets, 'Cohorts'), this.cohorts, this._processCohort);
				this._createObjectsFromSheet(this._selectSheet(result.sheets, 'Meetings'), this.meetings);
			}
		},
	
		_selectSheet: function _selectSheet(sheetCollection, sheetName) {
			return _underscore2.default.find(sheetCollection, function (sheet) {
				return sheet.properties.title === sheetName;
			});
		},
	
		_scheduledMeetingsForParticipant: function _scheduledMeetingsForParticipant(participant, associationName) {
			return this.scheduledMeetings.filter(function (sm) {
				return sm[associationName].includes(participant.id);
			});
		},
	
		_sumOfScheduledMeetingMinutes: function _sumOfScheduledMeetingMinutes(scheduledMeetings) {
			var filter = arguments.length <= 1 || arguments[1] === undefined ? function (scheduledMeeting) {
				return scheduledMeeting;
			} : arguments[1];
	
			return scheduledMeetings.filter(filter).map(function (sm) {
				return sm.duration_minutes;
			}).reduce(function (prev, current, i, array) {
				return prev + current;
			});
		},
	
		_processTeacher: function _processTeacher(teacher) {
			if (!teacher.name) {
				teacher.name = [teacher.first_name, teacher.last_name].join(" ");
			}
	
			var scheduledMeetings = this._scheduledMeetingsForParticipant(teacher, 'teacher_ids');
	
			if (scheduledMeetings.length > 0) {
				teacher.scheduled_meeting_ids = scheduledMeetings.map(function (sm) {
					return sm.id;
				});
				teacher.total_minutes = this._sumOfScheduledMeetingMinutes(scheduledMeetings);
				teacher.scheduled_minutes = this._sumOfScheduledMeetingMinutes(scheduledMeetings, function (sm) {
					return sm.meeting_id !== null && sm.meeting_id !== 'Prep';
				});
				teacher.unscheduled_minutes = teacher.total_minutes - teacher.scheduled_minutes;
			}
	
			if (teacher.prep_teachers) {
				teacher.prep_teachers = teacher.prep_teachers.split(',');
			}
	
			if (teacher.release_teachers) {
				teacher.release_teachers = teacher.release_teachers.split(',');
			}
	
			if (teacher.unavailable) {
				teacher.unavailable = teacher.unavailable.split(',');
			}
		},
	
		_getFormattedValue: function _getFormattedValue(cellData) {
			if (cellData && cellData.formattedValue) {
				return cellData.formattedValue.trim();
			} else {
				return null;
			}
		},
	
		_processScheduledMeetings: function _processScheduledMeetings(sheet, collection) {
			var _this = this;
	
			if (!sheet) {
				console.log('Could not parse schedule data');
			}
	
			var rows = sheet.data[0].rowData;
			var columnIndexes = this._getColumnIndexes(rows[0]);
			rows.shift();
	
			var _iteratorNormalCompletion = true;
			var _didIteratorError = false;
			var _iteratorError = undefined;
	
			try {
				var _loop = function _loop() {
					var row = _step.value;
	
					if (row.values[0].formattedValue) {
						var startTime = _this._processTime(_this._getFormattedValue(row.values[columnIndexes.start_time]));
	
						var endTime = _this._processTime(_this._getFormattedValue(row.values[columnIndexes.end_time]));
	
						var durationMinutes = _time2.default.duration(startTime, endTime).minutes;
	
						var teacherIds = columnIndexes.teacher_id.reduce(function (ids, index) {
							ids = ids.concat(_this._parseParticipantList(_this._getFormattedValue(row.values[index])));
	
							return ids;
						}, []);
	
						var cohortIds = columnIndexes.section_id.reduce(function (ids, index) {
							ids = ids.concat(_this._parseParticipantList(_this._getFormattedValue(row.values[index])));
							return ids;
						}, []);
	
						var meetingName = _this._getFormattedValue(row.values[columnIndexes.name]);
	
						var meetingTypeId = _this._getFormattedValue(row.values[columnIndexes.meeting_type_id]);
	
						var daysOfWeek = _this._parseDaysOfWeekRanges(_this._getFormattedValue(row.values[columnIndexes.day_of_week]));
	
						var period = _this._getFormattedValue(row.values[columnIndexes.period]);
	
						var _iteratorNormalCompletion2 = true;
						var _didIteratorError2 = false;
						var _iteratorError2 = undefined;
	
						try {
							for (var _iterator2 = daysOfWeek[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
								var dayOfWeek = _step2.value;
	
								collection.push({
									id: collection.length + 1,
									day_of_week: dayOfWeek,
									days_of_week: daysOfWeek,
									start_time: startTime,
									end_time: endTime,
									duration_minutes: durationMinutes,
									teacher_ids: teacherIds,
									cohort_ids: cohortIds,
									name: meetingName,
									meeting_id: meetingTypeId,
									period: period
								});
							}
						} catch (err) {
							_didIteratorError2 = true;
							_iteratorError2 = err;
						} finally {
							try {
								if (!_iteratorNormalCompletion2 && _iterator2.return) {
									_iterator2.return();
								}
							} finally {
								if (_didIteratorError2) {
									throw _iteratorError2;
								}
							}
						}
					}
				};
	
				for (var _iterator = rows[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
					_loop();
				}
			} catch (err) {
				_didIteratorError = true;
				_iteratorError = err;
			} finally {
				try {
					if (!_iteratorNormalCompletion && _iterator.return) {
						_iterator.return();
					}
				} finally {
					if (_didIteratorError) {
						throw _iteratorError;
					}
				}
			}
	
			return collection;
		},
	
		_getColumnIndexes: function _getColumnIndexes(firstRow) {
			var columns = firstRow ? firstRow.values : [];
			return columns.reduce(function (columnNames, column, i) {
				if (column.formattedValue) {
					if (columnNames[column.formattedValue]) {
						if (!columnNames[column.formattedValue].length) {
							columnNames[column.formattedValue] = [columnNames[column.formattedValue]];
						}
						columnNames[column.formattedValue].push(i);
					} else {
						columnNames[column.formattedValue] = i;
					}
				}
				return columnNames;
			}, {});
		},
	
		_parseParticipantList: function _parseParticipantList(participantList) {
			if (!participantList) {
				return [];
			}
			return participantList.split(/,\s*/);
		},
	
		_parseDaysOfWeekRanges: function _parseDaysOfWeekRanges(daysRanges) {
			var _this2 = this;
	
			if (!daysRanges) return [];
			var ranges = daysRanges.split(/,\s*/);
			var dayCodes = _underscore2.default.flatten(_underscore2.default.map(ranges, function (range) {
				if (!range.includes('-')) return range;
				var rangeEnds = range.split('-');
				var allDayCodes = _underscore2.default.keys(_this2.DAY_OF_WEEK_MAP);
	
				return allDayCodes.slice(allDayCodes.indexOf(rangeEnds[0]), allDayCodes.indexOf(rangeEnds[1]) + 1);
			}));
			return _underscore2.default.map(dayCodes, function (dayCode) {
				return _this2.DAY_OF_WEEK_MAP[dayCode] ? _this2.DAY_OF_WEEK_MAP[dayCode] : dayCode;
			});
		},
	
		_getMeetingKey: function _getMeetingKey(scheduledMeeting) {
			return _underscore2.default.flatten([scheduledMeeting.day_of_week, scheduledMeeting.teacher_ids]).join('_');
		},
	
		_processSchedules: function _processSchedules(sheet, collection) {
			if (!sheet) {
				console.log('Could not parse schedule data');
			}
	
			var rows = sheet.data[0].rowData;
			var days = this._getDaysOfWeek(rows[0].values);
			var meetingsByKey = {};
			var processedMeetings = [];
	
			for (var i = 2; i < rows.length; i++) {
				if (rows[i].values[0].formattedValue) {
					var timeBlock = rows[i].values[0].formattedValue.split('-');
					var startTime = this._processTime(timeBlock[0]);
					var endTime = this._processTime(timeBlock[1]);
					var durationMinutes = _time2.default.duration(startTime, endTime).minutes;
					var teacherId = rows[i].values[1].formattedValue;
	
					for (var j = 2; j < rows[i].values.length; j += 2) {
						var meetingName = rows[i].values[j];
						var cohortId = rows[i].values[j + 1].formattedValue;
						if (cohortId === "0") cohortId = null;
	
						var dayOfWeek = days[j - 2];
	
						var scheduledMeeting = Object.assign({}, {
							id: processedMeetings.length + 1,
							day_of_week: dayOfWeek,
							days_of_week: [dayOfWeek],
							start_time: startTime,
							end_time: endTime,
							duration_minutes: durationMinutes,
							teacher_ids: _underscore2.default.compact([teacherId]),
							cohort_ids: _underscore2.default.compact([cohortId]),
							sheet_references: [{ row: i + 1, column: j + 1 }]
						}, this._processMeetingValue(meetingName));
	
						var key = this._getMeetingKey(scheduledMeeting);
						var meetingsForKey = meetingsByKey[key] = meetingsByKey[key] || [];
						var prevMeeting = _underscore2.default.last(meetingsForKey);
						if (prevMeeting && prevMeeting.meeting_id === scheduledMeeting.meeting_id && prevMeeting.cohort_ids.join("_") === scheduledMeeting.cohort_ids.join("_")) {
							prevMeeting.sheet_references.push(scheduledMeeting.sheet_references[0]);
							prevMeeting.end_time = scheduledMeeting.end_time;
						} else {
							meetingsForKey.push(scheduledMeeting);
							processedMeetings.push(scheduledMeeting);
						}
					}
				}
			}
	
			var groupedCollection = _underscore2.default.values(_underscore2.default.groupBy(processedMeetings, function (meeting) {
				if (meeting.cohort_ids.length === 0) {
					return meeting.id;
				}
				return _underscore2.default.flatten(_underscore2.default.values(_underscore2.default.pick(meeting, "day_of_week", "meeting_id", "start_time", "end_time", "cohort_ids"))).join("_");
			}));
	
			var compiledCollection = _underscore2.default.map(groupedCollection, function (meetings) {
				var newMeeting = void 0;
				if (meetings.length === 1) {
					newMeeting = _underscore2.default.first(meetings);
				} else {
					newMeeting = _underscore2.default.reduce(meetings, function (aggregateMeeting, componentMeeting) {
						aggregateMeeting.teacher_ids = aggregateMeeting.teacher_ids.concat(componentMeeting.teacher_ids);
						aggregateMeeting.sheet_references = aggregateMeeting.sheet_references.concat(componentMeeting.sheet_references);
						return aggregateMeeting;
					});
				}
				return newMeeting;
			});
	
			collection.push.apply(collection, _toConsumableArray(compiledCollection));
		},
	
		_getDaysOfWeek: function _getDaysOfWeek(values) {
			var days = [];
			var last = void 0;
			var value = void 0;
	
			// Need this because of merged cells
			for (var i = 2; i < values.length; i++) {
				value = values[i].formattedValue ? values[i].formattedValue : null;
				if (value && last !== value) {
					last = value;
				}
				days.push(last);
			}
			return days;
		},
	
		_processMeetingValue: function _processMeetingValue(value) {
			value = value && value.formattedValue ? value.formattedValue : null;
			var id = value === '0' || value === '--' ? null : value;
			return {
				meeting_id: id,
				name: id,
				unavailable: value === '0' || value === '--',
				earlyRelease: value === '--'
			};
		},
	
		_processTime: function _processTime(timeStr) {
			var str = timeStr.replace(/^\s*/, '').replace(/\s*$/, '');
			var hour = parseInt(str.split(':')[0], 10);
			if (hour === 12 || hour < 6) {
				str += 'pm';
			} else {
				str += 'am';
			}
			return str;
		},
	
		_createObjectsFromSheet: function _createObjectsFromSheet(sheet, collection, callback) {
			if (!sheet) {
				console.log('Could not parse sheet data');
			}
			var rows = sheet.data[0].rowData;
			var obj = void 0;
	
			callback = callback || function () {};
			for (var i = 1; i < rows.length; i++) {
				obj = {};
				for (var j = 0; j < rows[i].values.length; j++) {
					obj[rows[0].values[j].formattedValue] = _abl2.default.convertString(rows[i].values[j] ? rows[i].values[j].formattedValue : null);
				}
				callback.bind(this)(obj);
				collection.push(obj);
			}
			return collection;
		}
	
	});
	
	exports.default = GoogleSheetProcessor;

/***/ },
/* 92 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  files: [{
	    id: "3",
	    name: "Version 2 Test Schedule",
	    capabilities: { canEdit: true }
	  }]
	};

/***/ },
/* 93 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  files: [{
	    id: "2",
	    name: "Sanchez Fixture Schedule",
	    capabilities: { canEdit: true }
	  }]
	};

/***/ },
/* 94 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  files: [{
	    id: "1",
	    name: "Version 1 Test Schedule",
	    capabilities: { canEdit: true }
	  }]
	};

/***/ },
/* 95 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Editable = _react2.default.createClass({
	  displayName: 'Editable',
	
	
	  getInitialState: function getInitialState() {
	    return {
	      editing: false,
	      lastValue: this.props.value,
	      value: this.props.value
	    };
	  },
	
	  componentWillReceiveProps: function componentWillReceiveProps(props) {
	    if (this.state.value !== props.value) {
	      this._updateState(this.state.editing, props.value, true);
	    }
	  },
	
	  render: function render() {
	    var element = void 0;
	
	    if (this.state.editing) {
	      element = _react2.default.createElement('input', {
	        type: 'text',
	        autoFocus: true,
	        className: this.props.className,
	        value: this.state.value,
	        onChange: this.handleChange,
	        onBlur: this.handleBlur,
	        onKeyDown: this.handleKeyDown,
	        style: this._createStyle() });
	    } else {
	      element = _react2.default.createElement(
	        this.props.tagName,
	        {
	          className: this.props.className,
	          onClick: this.handleClick },
	        this.state.value || this.props.defaultText
	      );
	    }
	
	    return element;
	  },
	
	  handleClick: function handleClick(e) {
	    this._updateState(!this.state.editing, this.state.value);
	  },
	
	  handleBlur: function handleBlur(e) {
	    this._updateState(false, this.state.value);
	  },
	
	  handleChange: function handleChange(e) {
	    this._updateState(this.state.editing, e.target.value);
	  },
	
	  handleKeyDown: function handleKeyDown(e) {
	    if (e.which === 13) {
	      this._updateState(false, e.target.value);
	    }
	  },
	
	  _updateState: function _updateState(editing, value, silent) {
	    var lastValue = this.state.lastValue;
	
	    if (!silent && value && editing === false && lastValue !== value) {
	      lastValue = null;
	      if (this.props.onChange) {
	        this.props.onChange(this.state.lastValue, value, this.props.data);
	      }
	    }
	
	    this.setState({
	      editing: editing,
	      lastValue: lastValue,
	      value: value
	    });
	  },
	
	  _createStyle: function _createStyle() {
	    return {
	      padding: 0,
	      backgroundColor: 'transparent',
	      border: 0,
	      fontSize: 'inherit'
	    };
	  }
	
	});
	
	exports.default = Editable;

/***/ },
/* 96 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.default = LoadingIndicator;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function LoadingIndicator(props) {
		return _react2.default.createElement(
			"div",
			{ className: "abl-loading" },
			"Loading..."
		);
	};

/***/ },
/* 97 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.getCell = exports.getCellHeight = undefined;
	
	var _underscore = __webpack_require__(7);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var getParticipants = function getParticipants(id, type, scheduledMeeting) {
		var participants = {
			'teacher': scheduledMeeting.teachers || [],
			'cohort': scheduledMeeting.cohorts || []
		};
		var active = participants[type];
	
		if (participants.teacher.length === 0 && participants.cohort.length === 0) {
			participants = null;
		} else if (active) {
			participants[type] = _underscore2.default.reject(active, function (participant) {
				return participant.id === id;
			});
		};
	
		return participants;
	};
	
	var getCellHeight = exports.getCellHeight = function getCellHeight(cell) {
		return Math.floor(1.6 * cell.duration);
	};
	
	var getCell = exports.getCell = function getCell(_ref) {
		var column = _ref.column;
		var subColumns = _ref.subColumns;
		var scheduledMeeting = _ref.scheduledMeeting;
		var startTime = _ref.startTime;
		var endTime = _ref.endTime;
	
		var subColumn = subColumns[0] || {};
		var cell = {
			id: scheduledMeeting.id,
			column: column,
			subColumn: subColumn,
			subColumns: subColumns,
			scheduled: scheduledMeeting !== null ? scheduledMeeting.scheduled : false,
			scheduledMeeting: scheduledMeeting,
			startTime: startTime,
			endTime: endTime,
			duration: scheduledMeeting ? scheduledMeeting.duration : null,
			participants: getParticipants(subColumn.value, subColumn.type, scheduledMeeting)
		};
	
		cell.height = getCellHeight(cell);
		return cell;
	};

/***/ },
/* 98 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.default = {
		'sanchez_elementary': {
			name: 'Sanchez Elementary',
			terms: {
				'2016_2017': {
					id: '0B7M38pRihZntUThVLXlqdFdxdDQ',
					type: 'sheet',
					version: 1.0
				}
			}
		},
	
		'growth_schools': {
			name: 'Growth Schools',
			terms: {
				'2016_2017': {
					id: '0B7M38pRihZntdF9MY0dBMGV3REE',
					type: 'sheet',
					version: 1.0
				}
			}
		},
	
		'test_schedules': {
			name: 'Test Schedules',
			terms: {
				'2016_2017': {
					id: '0B7M38pRihZntVlgzV3dERVU0cG8',
					type: 'sheet',
					version: 1.0
				}
			}
		},
	
		'new_test': {
			name: 'New Test',
			terms: {
				'2016_2017': {
					id: '0B0WQeAm03_OZWDhCVDluLVNGRHM',
					type: 'sheet',
					version: 2.0
				}
			}
		},
	
		'slavens': {
			name: 'Slavens',
			terms: {
				'2016_2017': {
					id: '0B1nnQ3Qmp882OHREbnhFdU00R2M',
					type: 'sheet',
					version: 2.0
				}
			}
		},
	
		'demo': {
			name: 'Riverview Middle School',
			terms: {
				'2016_2017': {
					id: '0B7M38pRihZntU2ZLNTY2OFl3bDQ',
					type: 'sheet',
					version: 2.0
				},
				'period_example': {
					id: '0B7M38pRihZntMGx0RHNfVEQ4NlU',
					type: 'sheet',
					version: 2.0
				}
			}
		},
	
		'ccsc': {
			name: 'Community Charter School of Cambridge',
			terms: {
				'2016_2017': {
					id: '0B7M38pRihZntQm1kSDg5ZnlmYm8',
					type: 'sheet',
					version: 2.0
				}
			}
		},
	
		'bonsall': {
			name: 'Bonsall High School',
			terms: {
				'2016_2017': {
					id: '0B7M38pRihZntWDhHdG5LT2RNRGc',
					type: 'sheet',
					version: 2.0
				}
			}
		}
	};

/***/ },
/* 99 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _underscore = __webpack_require__(7);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _reselect = __webpack_require__(15);
	
	var _entities_selector = __webpack_require__(17);
	
	var _entities_selector2 = _interopRequireDefault(_entities_selector);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var add = (0, _reselect.createSelector)(function (layers, activeMeetings) {
	  return layers;
	}, function (layers, scheduledMeetings) {
	  return scheduledMeetings;
	}, function (layers, scheduledMeetings) {
	  if (layers.length === 0) {
	    return scheduledMeetings;
	  }
	
	  return scheduledMeetings.map(function (scheduledMeeting) {
	    layers.forEach(function (layer) {
	      var isMatch = _underscore2.default.every(Object.keys(layer.conditions), function (property) {
	        var isScheduledMeeting = property === 'scheduledMeeting';
	        return _underscore2.default.isMatch(isScheduledMeeting ? scheduledMeeting : scheduledMeeting[property], layer.conditions[property]);
	      });
	
	      if (isMatch) {
	        scheduledMeeting.classNames.push(layer.selectedClass);
	      }
	    });
	    return scheduledMeeting;
	  });
	});
	
	var meetingLayersSelector = (0, _entities_selector2.default)(function (state) {
	  return state.meetingLayers;
	});
	
	meetingLayersSelector.add = add;
	
	exports.default = meetingLayersSelector;

/***/ },
/* 100 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 101 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var asap = __webpack_require__(201);
	
	function noop() {}
	
	// States:
	//
	// 0 - pending
	// 1 - fulfilled with _value
	// 2 - rejected with _value
	// 3 - adopted the state of another promise, _value
	//
	// once the state is no longer pending (0) it is immutable
	
	// All `_` prefixed properties will be reduced to `_{random number}`
	// at build time to obfuscate them and discourage their use.
	// We don't use symbols or Object.defineProperty to fully hide them
	// because the performance isn't good enough.
	
	
	// to avoid using try/catch inside critical functions, we
	// extract them to here.
	var LAST_ERROR = null;
	var IS_ERROR = {};
	function getThen(obj) {
	  try {
	    return obj.then;
	  } catch (ex) {
	    LAST_ERROR = ex;
	    return IS_ERROR;
	  }
	}
	
	function tryCallOne(fn, a) {
	  try {
	    return fn(a);
	  } catch (ex) {
	    LAST_ERROR = ex;
	    return IS_ERROR;
	  }
	}
	function tryCallTwo(fn, a, b) {
	  try {
	    fn(a, b);
	  } catch (ex) {
	    LAST_ERROR = ex;
	    return IS_ERROR;
	  }
	}
	
	module.exports = Promise;
	
	function Promise(fn) {
	  if (typeof this !== 'object') {
	    throw new TypeError('Promises must be constructed via new');
	  }
	  if (typeof fn !== 'function') {
	    throw new TypeError('not a function');
	  }
	  this._45 = 0;
	  this._81 = 0;
	  this._65 = null;
	  this._54 = null;
	  if (fn === noop) return;
	  doResolve(fn, this);
	}
	Promise._10 = null;
	Promise._97 = null;
	Promise._61 = noop;
	
	Promise.prototype.then = function(onFulfilled, onRejected) {
	  if (this.constructor !== Promise) {
	    return safeThen(this, onFulfilled, onRejected);
	  }
	  var res = new Promise(noop);
	  handle(this, new Handler(onFulfilled, onRejected, res));
	  return res;
	};
	
	function safeThen(self, onFulfilled, onRejected) {
	  return new self.constructor(function (resolve, reject) {
	    var res = new Promise(noop);
	    res.then(resolve, reject);
	    handle(self, new Handler(onFulfilled, onRejected, res));
	  });
	};
	function handle(self, deferred) {
	  while (self._81 === 3) {
	    self = self._65;
	  }
	  if (Promise._10) {
	    Promise._10(self);
	  }
	  if (self._81 === 0) {
	    if (self._45 === 0) {
	      self._45 = 1;
	      self._54 = deferred;
	      return;
	    }
	    if (self._45 === 1) {
	      self._45 = 2;
	      self._54 = [self._54, deferred];
	      return;
	    }
	    self._54.push(deferred);
	    return;
	  }
	  handleResolved(self, deferred);
	}
	
	function handleResolved(self, deferred) {
	  asap(function() {
	    var cb = self._81 === 1 ? deferred.onFulfilled : deferred.onRejected;
	    if (cb === null) {
	      if (self._81 === 1) {
	        resolve(deferred.promise, self._65);
	      } else {
	        reject(deferred.promise, self._65);
	      }
	      return;
	    }
	    var ret = tryCallOne(cb, self._65);
	    if (ret === IS_ERROR) {
	      reject(deferred.promise, LAST_ERROR);
	    } else {
	      resolve(deferred.promise, ret);
	    }
	  });
	}
	function resolve(self, newValue) {
	  // Promise Resolution Procedure: https://github.com/promises-aplus/promises-spec#the-promise-resolution-procedure
	  if (newValue === self) {
	    return reject(
	      self,
	      new TypeError('A promise cannot be resolved with itself.')
	    );
	  }
	  if (
	    newValue &&
	    (typeof newValue === 'object' || typeof newValue === 'function')
	  ) {
	    var then = getThen(newValue);
	    if (then === IS_ERROR) {
	      return reject(self, LAST_ERROR);
	    }
	    if (
	      then === self.then &&
	      newValue instanceof Promise
	    ) {
	      self._81 = 3;
	      self._65 = newValue;
	      finale(self);
	      return;
	    } else if (typeof then === 'function') {
	      doResolve(then.bind(newValue), self);
	      return;
	    }
	  }
	  self._81 = 1;
	  self._65 = newValue;
	  finale(self);
	}
	
	function reject(self, newValue) {
	  self._81 = 2;
	  self._65 = newValue;
	  if (Promise._97) {
	    Promise._97(self, newValue);
	  }
	  finale(self);
	}
	function finale(self) {
	  if (self._45 === 1) {
	    handle(self, self._54);
	    self._54 = null;
	  }
	  if (self._45 === 2) {
	    for (var i = 0; i < self._54.length; i++) {
	      handle(self, self._54[i]);
	    }
	    self._54 = null;
	  }
	}
	
	function Handler(onFulfilled, onRejected, promise){
	  this.onFulfilled = typeof onFulfilled === 'function' ? onFulfilled : null;
	  this.onRejected = typeof onRejected === 'function' ? onRejected : null;
	  this.promise = promise;
	}
	
	/**
	 * Take a potentially misbehaving resolver function and make sure
	 * onFulfilled and onRejected are only called once.
	 *
	 * Makes no guarantees about asynchrony.
	 */
	function doResolve(fn, promise) {
	  var done = false;
	  var res = tryCallTwo(fn, function (value) {
	    if (done) return;
	    done = true;
	    resolve(promise, value);
	  }, function (reason) {
	    if (done) return;
	    done = true;
	    reject(promise, reason);
	  })
	  if (!done && res === IS_ERROR) {
	    done = true;
	    reject(promise, LAST_ERROR);
	  }
	}


/***/ },
/* 102 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule CSSProperty
	 */
	
	'use strict';
	
	/**
	 * CSS properties which accept numbers but are not in units of "px".
	 */
	
	var isUnitlessNumber = {
	  animationIterationCount: true,
	  borderImageOutset: true,
	  borderImageSlice: true,
	  borderImageWidth: true,
	  boxFlex: true,
	  boxFlexGroup: true,
	  boxOrdinalGroup: true,
	  columnCount: true,
	  flex: true,
	  flexGrow: true,
	  flexPositive: true,
	  flexShrink: true,
	  flexNegative: true,
	  flexOrder: true,
	  gridRow: true,
	  gridColumn: true,
	  fontWeight: true,
	  lineClamp: true,
	  lineHeight: true,
	  opacity: true,
	  order: true,
	  orphans: true,
	  tabSize: true,
	  widows: true,
	  zIndex: true,
	  zoom: true,
	
	  // SVG-related properties
	  fillOpacity: true,
	  floodOpacity: true,
	  stopOpacity: true,
	  strokeDasharray: true,
	  strokeDashoffset: true,
	  strokeMiterlimit: true,
	  strokeOpacity: true,
	  strokeWidth: true
	};
	
	/**
	 * @param {string} prefix vendor-specific prefix, eg: Webkit
	 * @param {string} key style name, eg: transitionDuration
	 * @return {string} style name prefixed with `prefix`, properly camelCased, eg:
	 * WebkitTransitionDuration
	 */
	function prefixKey(prefix, key) {
	  return prefix + key.charAt(0).toUpperCase() + key.substring(1);
	}
	
	/**
	 * Support style names that may come passed in prefixed by adding permutations
	 * of vendor prefixes.
	 */
	var prefixes = ['Webkit', 'ms', 'Moz', 'O'];
	
	// Using Object.keys here, or else the vanilla for-in loop makes IE8 go into an
	// infinite loop, because it iterates over the newly added props too.
	Object.keys(isUnitlessNumber).forEach(function (prop) {
	  prefixes.forEach(function (prefix) {
	    isUnitlessNumber[prefixKey(prefix, prop)] = isUnitlessNumber[prop];
	  });
	});
	
	/**
	 * Most style properties can be unset by doing .style[prop] = '' but IE8
	 * doesn't like doing that with shorthand properties so for the properties that
	 * IE8 breaks on, which are listed here, we instead unset each of the
	 * individual properties. See http://bugs.jquery.com/ticket/12385.
	 * The 4-value 'clock' properties like margin, padding, border-width seem to
	 * behave without any problems. Curiously, list-style works too without any
	 * special prodding.
	 */
	var shorthandPropertyExpansions = {
	  background: {
	    backgroundAttachment: true,
	    backgroundColor: true,
	    backgroundImage: true,
	    backgroundPositionX: true,
	    backgroundPositionY: true,
	    backgroundRepeat: true
	  },
	  backgroundPosition: {
	    backgroundPositionX: true,
	    backgroundPositionY: true
	  },
	  border: {
	    borderWidth: true,
	    borderStyle: true,
	    borderColor: true
	  },
	  borderBottom: {
	    borderBottomWidth: true,
	    borderBottomStyle: true,
	    borderBottomColor: true
	  },
	  borderLeft: {
	    borderLeftWidth: true,
	    borderLeftStyle: true,
	    borderLeftColor: true
	  },
	  borderRight: {
	    borderRightWidth: true,
	    borderRightStyle: true,
	    borderRightColor: true
	  },
	  borderTop: {
	    borderTopWidth: true,
	    borderTopStyle: true,
	    borderTopColor: true
	  },
	  font: {
	    fontStyle: true,
	    fontVariant: true,
	    fontWeight: true,
	    fontSize: true,
	    lineHeight: true,
	    fontFamily: true
	  },
	  outline: {
	    outlineWidth: true,
	    outlineStyle: true,
	    outlineColor: true
	  }
	};
	
	var CSSProperty = {
	  isUnitlessNumber: isUnitlessNumber,
	  shorthandPropertyExpansions: shorthandPropertyExpansions
	};
	
	module.exports = CSSProperty;

/***/ },
/* 103 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule CallbackQueue
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(3),
	    _assign = __webpack_require__(6);
	
	var PooledClass = __webpack_require__(22);
	
	var invariant = __webpack_require__(2);
	
	/**
	 * A specialized pseudo-event module to help keep track of components waiting to
	 * be notified when their DOM representations are available for use.
	 *
	 * This implements `PooledClass`, so you should never need to instantiate this.
	 * Instead, use `CallbackQueue.getPooled()`.
	 *
	 * @class ReactMountReady
	 * @implements PooledClass
	 * @internal
	 */
	function CallbackQueue() {
	  this._callbacks = null;
	  this._contexts = null;
	}
	
	_assign(CallbackQueue.prototype, {
	
	  /**
	   * Enqueues a callback to be invoked when `notifyAll` is invoked.
	   *
	   * @param {function} callback Invoked when `notifyAll` is invoked.
	   * @param {?object} context Context to call `callback` with.
	   * @internal
	   */
	  enqueue: function (callback, context) {
	    this._callbacks = this._callbacks || [];
	    this._contexts = this._contexts || [];
	    this._callbacks.push(callback);
	    this._contexts.push(context);
	  },
	
	  /**
	   * Invokes all enqueued callbacks and clears the queue. This is invoked after
	   * the DOM representation of a component has been created or updated.
	   *
	   * @internal
	   */
	  notifyAll: function () {
	    var callbacks = this._callbacks;
	    var contexts = this._contexts;
	    if (callbacks) {
	      !(callbacks.length === contexts.length) ?  false ? invariant(false, 'Mismatched list of contexts in callback queue') : _prodInvariant('24') : void 0;
	      this._callbacks = null;
	      this._contexts = null;
	      for (var i = 0; i < callbacks.length; i++) {
	        callbacks[i].call(contexts[i]);
	      }
	      callbacks.length = 0;
	      contexts.length = 0;
	    }
	  },
	
	  checkpoint: function () {
	    return this._callbacks ? this._callbacks.length : 0;
	  },
	
	  rollback: function (len) {
	    if (this._callbacks) {
	      this._callbacks.length = len;
	      this._contexts.length = len;
	    }
	  },
	
	  /**
	   * Resets the internal queue.
	   *
	   * @internal
	   */
	  reset: function () {
	    this._callbacks = null;
	    this._contexts = null;
	  },
	
	  /**
	   * `PooledClass` looks for this.
	   */
	  destructor: function () {
	    this.reset();
	  }
	
	});
	
	PooledClass.addPoolingTo(CallbackQueue);
	
	module.exports = CallbackQueue;

/***/ },
/* 104 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule DOMPropertyOperations
	 */
	
	'use strict';
	
	var DOMProperty = __webpack_require__(27);
	var ReactDOMComponentTree = __webpack_require__(8);
	var ReactInstrumentation = __webpack_require__(11);
	
	var quoteAttributeValueForBrowser = __webpack_require__(367);
	var warning = __webpack_require__(4);
	
	var VALID_ATTRIBUTE_NAME_REGEX = new RegExp('^[' + DOMProperty.ATTRIBUTE_NAME_START_CHAR + '][' + DOMProperty.ATTRIBUTE_NAME_CHAR + ']*$');
	var illegalAttributeNameCache = {};
	var validatedAttributeNameCache = {};
	
	function isAttributeNameSafe(attributeName) {
	  if (validatedAttributeNameCache.hasOwnProperty(attributeName)) {
	    return true;
	  }
	  if (illegalAttributeNameCache.hasOwnProperty(attributeName)) {
	    return false;
	  }
	  if (VALID_ATTRIBUTE_NAME_REGEX.test(attributeName)) {
	    validatedAttributeNameCache[attributeName] = true;
	    return true;
	  }
	  illegalAttributeNameCache[attributeName] = true;
	   false ? warning(false, 'Invalid attribute name: `%s`', attributeName) : void 0;
	  return false;
	}
	
	function shouldIgnoreValue(propertyInfo, value) {
	  return value == null || propertyInfo.hasBooleanValue && !value || propertyInfo.hasNumericValue && isNaN(value) || propertyInfo.hasPositiveNumericValue && value < 1 || propertyInfo.hasOverloadedBooleanValue && value === false;
	}
	
	/**
	 * Operations for dealing with DOM properties.
	 */
	var DOMPropertyOperations = {
	
	  /**
	   * Creates markup for the ID property.
	   *
	   * @param {string} id Unescaped ID.
	   * @return {string} Markup string.
	   */
	  createMarkupForID: function (id) {
	    return DOMProperty.ID_ATTRIBUTE_NAME + '=' + quoteAttributeValueForBrowser(id);
	  },
	
	  setAttributeForID: function (node, id) {
	    node.setAttribute(DOMProperty.ID_ATTRIBUTE_NAME, id);
	  },
	
	  createMarkupForRoot: function () {
	    return DOMProperty.ROOT_ATTRIBUTE_NAME + '=""';
	  },
	
	  setAttributeForRoot: function (node) {
	    node.setAttribute(DOMProperty.ROOT_ATTRIBUTE_NAME, '');
	  },
	
	  /**
	   * Creates markup for a property.
	   *
	   * @param {string} name
	   * @param {*} value
	   * @return {?string} Markup string, or null if the property was invalid.
	   */
	  createMarkupForProperty: function (name, value) {
	    var propertyInfo = DOMProperty.properties.hasOwnProperty(name) ? DOMProperty.properties[name] : null;
	    if (propertyInfo) {
	      if (shouldIgnoreValue(propertyInfo, value)) {
	        return '';
	      }
	      var attributeName = propertyInfo.attributeName;
	      if (propertyInfo.hasBooleanValue || propertyInfo.hasOverloadedBooleanValue && value === true) {
	        return attributeName + '=""';
	      }
	      return attributeName + '=' + quoteAttributeValueForBrowser(value);
	    } else if (DOMProperty.isCustomAttribute(name)) {
	      if (value == null) {
	        return '';
	      }
	      return name + '=' + quoteAttributeValueForBrowser(value);
	    }
	    return null;
	  },
	
	  /**
	   * Creates markup for a custom property.
	   *
	   * @param {string} name
	   * @param {*} value
	   * @return {string} Markup string, or empty string if the property was invalid.
	   */
	  createMarkupForCustomAttribute: function (name, value) {
	    if (!isAttributeNameSafe(name) || value == null) {
	      return '';
	    }
	    return name + '=' + quoteAttributeValueForBrowser(value);
	  },
	
	  /**
	   * Sets the value for a property on a node.
	   *
	   * @param {DOMElement} node
	   * @param {string} name
	   * @param {*} value
	   */
	  setValueForProperty: function (node, name, value) {
	    var propertyInfo = DOMProperty.properties.hasOwnProperty(name) ? DOMProperty.properties[name] : null;
	    if (propertyInfo) {
	      var mutationMethod = propertyInfo.mutationMethod;
	      if (mutationMethod) {
	        mutationMethod(node, value);
	      } else if (shouldIgnoreValue(propertyInfo, value)) {
	        this.deleteValueForProperty(node, name);
	        return;
	      } else if (propertyInfo.mustUseProperty) {
	        // Contrary to `setAttribute`, object properties are properly
	        // `toString`ed by IE8/9.
	        node[propertyInfo.propertyName] = value;
	      } else {
	        var attributeName = propertyInfo.attributeName;
	        var namespace = propertyInfo.attributeNamespace;
	        // `setAttribute` with objects becomes only `[object]` in IE8/9,
	        // ('' + value) makes it output the correct toString()-value.
	        if (namespace) {
	          node.setAttributeNS(namespace, attributeName, '' + value);
	        } else if (propertyInfo.hasBooleanValue || propertyInfo.hasOverloadedBooleanValue && value === true) {
	          node.setAttribute(attributeName, '');
	        } else {
	          node.setAttribute(attributeName, '' + value);
	        }
	      }
	    } else if (DOMProperty.isCustomAttribute(name)) {
	      DOMPropertyOperations.setValueForAttribute(node, name, value);
	      return;
	    }
	
	    if (false) {
	      var payload = {};
	      payload[name] = value;
	      ReactInstrumentation.debugTool.onHostOperation(ReactDOMComponentTree.getInstanceFromNode(node)._debugID, 'update attribute', payload);
	    }
	  },
	
	  setValueForAttribute: function (node, name, value) {
	    if (!isAttributeNameSafe(name)) {
	      return;
	    }
	    if (value == null) {
	      node.removeAttribute(name);
	    } else {
	      node.setAttribute(name, '' + value);
	    }
	
	    if (false) {
	      var payload = {};
	      payload[name] = value;
	      ReactInstrumentation.debugTool.onHostOperation(ReactDOMComponentTree.getInstanceFromNode(node)._debugID, 'update attribute', payload);
	    }
	  },
	
	  /**
	   * Deletes an attributes from a node.
	   *
	   * @param {DOMElement} node
	   * @param {string} name
	   */
	  deleteValueForAttribute: function (node, name) {
	    node.removeAttribute(name);
	    if (false) {
	      ReactInstrumentation.debugTool.onHostOperation(ReactDOMComponentTree.getInstanceFromNode(node)._debugID, 'remove attribute', name);
	    }
	  },
	
	  /**
	   * Deletes the value for a property on a node.
	   *
	   * @param {DOMElement} node
	   * @param {string} name
	   */
	  deleteValueForProperty: function (node, name) {
	    var propertyInfo = DOMProperty.properties.hasOwnProperty(name) ? DOMProperty.properties[name] : null;
	    if (propertyInfo) {
	      var mutationMethod = propertyInfo.mutationMethod;
	      if (mutationMethod) {
	        mutationMethod(node, undefined);
	      } else if (propertyInfo.mustUseProperty) {
	        var propName = propertyInfo.propertyName;
	        if (propertyInfo.hasBooleanValue) {
	          node[propName] = false;
	        } else {
	          node[propName] = '';
	        }
	      } else {
	        node.removeAttribute(propertyInfo.attributeName);
	      }
	    } else if (DOMProperty.isCustomAttribute(name)) {
	      node.removeAttribute(name);
	    }
	
	    if (false) {
	      ReactInstrumentation.debugTool.onHostOperation(ReactDOMComponentTree.getInstanceFromNode(node)._debugID, 'remove attribute', name);
	    }
	  }
	
	};
	
	module.exports = DOMPropertyOperations;

/***/ },
/* 105 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactChildren
	 */
	
	'use strict';
	
	var PooledClass = __webpack_require__(22);
	var ReactElement = __webpack_require__(13);
	
	var emptyFunction = __webpack_require__(10);
	var traverseAllChildren = __webpack_require__(73);
	
	var twoArgumentPooler = PooledClass.twoArgumentPooler;
	var fourArgumentPooler = PooledClass.fourArgumentPooler;
	
	var userProvidedKeyEscapeRegex = /\/+/g;
	function escapeUserProvidedKey(text) {
	  return ('' + text).replace(userProvidedKeyEscapeRegex, '$&/');
	}
	
	/**
	 * PooledClass representing the bookkeeping associated with performing a child
	 * traversal. Allows avoiding binding callbacks.
	 *
	 * @constructor ForEachBookKeeping
	 * @param {!function} forEachFunction Function to perform traversal with.
	 * @param {?*} forEachContext Context to perform context with.
	 */
	function ForEachBookKeeping(forEachFunction, forEachContext) {
	  this.func = forEachFunction;
	  this.context = forEachContext;
	  this.count = 0;
	}
	ForEachBookKeeping.prototype.destructor = function () {
	  this.func = null;
	  this.context = null;
	  this.count = 0;
	};
	PooledClass.addPoolingTo(ForEachBookKeeping, twoArgumentPooler);
	
	function forEachSingleChild(bookKeeping, child, name) {
	  var func = bookKeeping.func;
	  var context = bookKeeping.context;
	
	  func.call(context, child, bookKeeping.count++);
	}
	
	/**
	 * Iterates through children that are typically specified as `props.children`.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.foreach
	 *
	 * The provided forEachFunc(child, index) will be called for each
	 * leaf child.
	 *
	 * @param {?*} children Children tree container.
	 * @param {function(*, int)} forEachFunc
	 * @param {*} forEachContext Context for forEachContext.
	 */
	function forEachChildren(children, forEachFunc, forEachContext) {
	  if (children == null) {
	    return children;
	  }
	  var traverseContext = ForEachBookKeeping.getPooled(forEachFunc, forEachContext);
	  traverseAllChildren(children, forEachSingleChild, traverseContext);
	  ForEachBookKeeping.release(traverseContext);
	}
	
	/**
	 * PooledClass representing the bookkeeping associated with performing a child
	 * mapping. Allows avoiding binding callbacks.
	 *
	 * @constructor MapBookKeeping
	 * @param {!*} mapResult Object containing the ordered map of results.
	 * @param {!function} mapFunction Function to perform mapping with.
	 * @param {?*} mapContext Context to perform mapping with.
	 */
	function MapBookKeeping(mapResult, keyPrefix, mapFunction, mapContext) {
	  this.result = mapResult;
	  this.keyPrefix = keyPrefix;
	  this.func = mapFunction;
	  this.context = mapContext;
	  this.count = 0;
	}
	MapBookKeeping.prototype.destructor = function () {
	  this.result = null;
	  this.keyPrefix = null;
	  this.func = null;
	  this.context = null;
	  this.count = 0;
	};
	PooledClass.addPoolingTo(MapBookKeeping, fourArgumentPooler);
	
	function mapSingleChildIntoContext(bookKeeping, child, childKey) {
	  var result = bookKeeping.result;
	  var keyPrefix = bookKeeping.keyPrefix;
	  var func = bookKeeping.func;
	  var context = bookKeeping.context;
	
	
	  var mappedChild = func.call(context, child, bookKeeping.count++);
	  if (Array.isArray(mappedChild)) {
	    mapIntoWithKeyPrefixInternal(mappedChild, result, childKey, emptyFunction.thatReturnsArgument);
	  } else if (mappedChild != null) {
	    if (ReactElement.isValidElement(mappedChild)) {
	      mappedChild = ReactElement.cloneAndReplaceKey(mappedChild,
	      // Keep both the (mapped) and old keys if they differ, just as
	      // traverseAllChildren used to do for objects as children
	      keyPrefix + (mappedChild.key && (!child || child.key !== mappedChild.key) ? escapeUserProvidedKey(mappedChild.key) + '/' : '') + childKey);
	    }
	    result.push(mappedChild);
	  }
	}
	
	function mapIntoWithKeyPrefixInternal(children, array, prefix, func, context) {
	  var escapedPrefix = '';
	  if (prefix != null) {
	    escapedPrefix = escapeUserProvidedKey(prefix) + '/';
	  }
	  var traverseContext = MapBookKeeping.getPooled(array, escapedPrefix, func, context);
	  traverseAllChildren(children, mapSingleChildIntoContext, traverseContext);
	  MapBookKeeping.release(traverseContext);
	}
	
	/**
	 * Maps children that are typically specified as `props.children`.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.map
	 *
	 * The provided mapFunction(child, key, index) will be called for each
	 * leaf child.
	 *
	 * @param {?*} children Children tree container.
	 * @param {function(*, int)} func The map function.
	 * @param {*} context Context for mapFunction.
	 * @return {object} Object containing the ordered map of results.
	 */
	function mapChildren(children, func, context) {
	  if (children == null) {
	    return children;
	  }
	  var result = [];
	  mapIntoWithKeyPrefixInternal(children, result, null, func, context);
	  return result;
	}
	
	function forEachSingleChildDummy(traverseContext, child, name) {
	  return null;
	}
	
	/**
	 * Count the number of children that are typically specified as
	 * `props.children`.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.count
	 *
	 * @param {?*} children Children tree container.
	 * @return {number} The number of children.
	 */
	function countChildren(children, context) {
	  return traverseAllChildren(children, forEachSingleChildDummy, null);
	}
	
	/**
	 * Flatten a children object (typically specified as `props.children`) and
	 * return an array with appropriately re-keyed children.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.toarray
	 */
	function toArray(children) {
	  var result = [];
	  mapIntoWithKeyPrefixInternal(children, result, null, emptyFunction.thatReturnsArgument);
	  return result;
	}
	
	var ReactChildren = {
	  forEach: forEachChildren,
	  map: mapChildren,
	  mapIntoWithKeyPrefixInternal: mapIntoWithKeyPrefixInternal,
	  count: countChildren,
	  toArray: toArray
	};
	
	module.exports = ReactChildren;

/***/ },
/* 106 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactClass
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(3),
	    _assign = __webpack_require__(6);
	
	var ReactComponent = __webpack_require__(58);
	var ReactElement = __webpack_require__(13);
	var ReactPropTypeLocations = __webpack_require__(64);
	var ReactPropTypeLocationNames = __webpack_require__(63);
	var ReactNoopUpdateQueue = __webpack_require__(62);
	
	var emptyObject = __webpack_require__(30);
	var invariant = __webpack_require__(2);
	var keyMirror = __webpack_require__(39);
	var keyOf = __webpack_require__(20);
	var warning = __webpack_require__(4);
	
	var MIXINS_KEY = keyOf({ mixins: null });
	
	/**
	 * Policies that describe methods in `ReactClassInterface`.
	 */
	var SpecPolicy = keyMirror({
	  /**
	   * These methods may be defined only once by the class specification or mixin.
	   */
	  DEFINE_ONCE: null,
	  /**
	   * These methods may be defined by both the class specification and mixins.
	   * Subsequent definitions will be chained. These methods must return void.
	   */
	  DEFINE_MANY: null,
	  /**
	   * These methods are overriding the base class.
	   */
	  OVERRIDE_BASE: null,
	  /**
	   * These methods are similar to DEFINE_MANY, except we assume they return
	   * objects. We try to merge the keys of the return values of all the mixed in
	   * functions. If there is a key conflict we throw.
	   */
	  DEFINE_MANY_MERGED: null
	});
	
	var injectedMixins = [];
	
	/**
	 * Composite components are higher-level components that compose other composite
	 * or host components.
	 *
	 * To create a new type of `ReactClass`, pass a specification of
	 * your new class to `React.createClass`. The only requirement of your class
	 * specification is that you implement a `render` method.
	 *
	 *   var MyComponent = React.createClass({
	 *     render: function() {
	 *       return <div>Hello World</div>;
	 *     }
	 *   });
	 *
	 * The class specification supports a specific protocol of methods that have
	 * special meaning (e.g. `render`). See `ReactClassInterface` for
	 * more the comprehensive protocol. Any other properties and methods in the
	 * class specification will be available on the prototype.
	 *
	 * @interface ReactClassInterface
	 * @internal
	 */
	var ReactClassInterface = {
	
	  /**
	   * An array of Mixin objects to include when defining your component.
	   *
	   * @type {array}
	   * @optional
	   */
	  mixins: SpecPolicy.DEFINE_MANY,
	
	  /**
	   * An object containing properties and methods that should be defined on
	   * the component's constructor instead of its prototype (static methods).
	   *
	   * @type {object}
	   * @optional
	   */
	  statics: SpecPolicy.DEFINE_MANY,
	
	  /**
	   * Definition of prop types for this component.
	   *
	   * @type {object}
	   * @optional
	   */
	  propTypes: SpecPolicy.DEFINE_MANY,
	
	  /**
	   * Definition of context types for this component.
	   *
	   * @type {object}
	   * @optional
	   */
	  contextTypes: SpecPolicy.DEFINE_MANY,
	
	  /**
	   * Definition of context types this component sets for its children.
	   *
	   * @type {object}
	   * @optional
	   */
	  childContextTypes: SpecPolicy.DEFINE_MANY,
	
	  // ==== Definition methods ====
	
	  /**
	   * Invoked when the component is mounted. Values in the mapping will be set on
	   * `this.props` if that prop is not specified (i.e. using an `in` check).
	   *
	   * This method is invoked before `getInitialState` and therefore cannot rely
	   * on `this.state` or use `this.setState`.
	   *
	   * @return {object}
	   * @optional
	   */
	  getDefaultProps: SpecPolicy.DEFINE_MANY_MERGED,
	
	  /**
	   * Invoked once before the component is mounted. The return value will be used
	   * as the initial value of `this.state`.
	   *
	   *   getInitialState: function() {
	   *     return {
	   *       isOn: false,
	   *       fooBaz: new BazFoo()
	   *     }
	   *   }
	   *
	   * @return {object}
	   * @optional
	   */
	  getInitialState: SpecPolicy.DEFINE_MANY_MERGED,
	
	  /**
	   * @return {object}
	   * @optional
	   */
	  getChildContext: SpecPolicy.DEFINE_MANY_MERGED,
	
	  /**
	   * Uses props from `this.props` and state from `this.state` to render the
	   * structure of the component.
	   *
	   * No guarantees are made about when or how often this method is invoked, so
	   * it must not have side effects.
	   *
	   *   render: function() {
	   *     var name = this.props.name;
	   *     return <div>Hello, {name}!</div>;
	   *   }
	   *
	   * @return {ReactComponent}
	   * @nosideeffects
	   * @required
	   */
	  render: SpecPolicy.DEFINE_ONCE,
	
	  // ==== Delegate methods ====
	
	  /**
	   * Invoked when the component is initially created and about to be mounted.
	   * This may have side effects, but any external subscriptions or data created
	   * by this method must be cleaned up in `componentWillUnmount`.
	   *
	   * @optional
	   */
	  componentWillMount: SpecPolicy.DEFINE_MANY,
	
	  /**
	   * Invoked when the component has been mounted and has a DOM representation.
	   * However, there is no guarantee that the DOM node is in the document.
	   *
	   * Use this as an opportunity to operate on the DOM when the component has
	   * been mounted (initialized and rendered) for the first time.
	   *
	   * @param {DOMElement} rootNode DOM element representing the component.
	   * @optional
	   */
	  componentDidMount: SpecPolicy.DEFINE_MANY,
	
	  /**
	   * Invoked before the component receives new props.
	   *
	   * Use this as an opportunity to react to a prop transition by updating the
	   * state using `this.setState`. Current props are accessed via `this.props`.
	   *
	   *   componentWillReceiveProps: function(nextProps, nextContext) {
	   *     this.setState({
	   *       likesIncreasing: nextProps.likeCount > this.props.likeCount
	   *     });
	   *   }
	   *
	   * NOTE: There is no equivalent `componentWillReceiveState`. An incoming prop
	   * transition may cause a state change, but the opposite is not true. If you
	   * need it, you are probably looking for `componentWillUpdate`.
	   *
	   * @param {object} nextProps
	   * @optional
	   */
	  componentWillReceiveProps: SpecPolicy.DEFINE_MANY,
	
	  /**
	   * Invoked while deciding if the component should be updated as a result of
	   * receiving new props, state and/or context.
	   *
	   * Use this as an opportunity to `return false` when you're certain that the
	   * transition to the new props/state/context will not require a component
	   * update.
	   *
	   *   shouldComponentUpdate: function(nextProps, nextState, nextContext) {
	   *     return !equal(nextProps, this.props) ||
	   *       !equal(nextState, this.state) ||
	   *       !equal(nextContext, this.context);
	   *   }
	   *
	   * @param {object} nextProps
	   * @param {?object} nextState
	   * @param {?object} nextContext
	   * @return {boolean} True if the component should update.
	   * @optional
	   */
	  shouldComponentUpdate: SpecPolicy.DEFINE_ONCE,
	
	  /**
	   * Invoked when the component is about to update due to a transition from
	   * `this.props`, `this.state` and `this.context` to `nextProps`, `nextState`
	   * and `nextContext`.
	   *
	   * Use this as an opportunity to perform preparation before an update occurs.
	   *
	   * NOTE: You **cannot** use `this.setState()` in this method.
	   *
	   * @param {object} nextProps
	   * @param {?object} nextState
	   * @param {?object} nextContext
	   * @param {ReactReconcileTransaction} transaction
	   * @optional
	   */
	  componentWillUpdate: SpecPolicy.DEFINE_MANY,
	
	  /**
	   * Invoked when the component's DOM representation has been updated.
	   *
	   * Use this as an opportunity to operate on the DOM when the component has
	   * been updated.
	   *
	   * @param {object} prevProps
	   * @param {?object} prevState
	   * @param {?object} prevContext
	   * @param {DOMElement} rootNode DOM element representing the component.
	   * @optional
	   */
	  componentDidUpdate: SpecPolicy.DEFINE_MANY,
	
	  /**
	   * Invoked when the component is about to be removed from its parent and have
	   * its DOM representation destroyed.
	   *
	   * Use this as an opportunity to deallocate any external resources.
	   *
	   * NOTE: There is no `componentDidUnmount` since your component will have been
	   * destroyed by that point.
	   *
	   * @optional
	   */
	  componentWillUnmount: SpecPolicy.DEFINE_MANY,
	
	  // ==== Advanced methods ====
	
	  /**
	   * Updates the component's currently mounted DOM representation.
	   *
	   * By default, this implements React's rendering and reconciliation algorithm.
	   * Sophisticated clients may wish to override this.
	   *
	   * @param {ReactReconcileTransaction} transaction
	   * @internal
	   * @overridable
	   */
	  updateComponent: SpecPolicy.OVERRIDE_BASE
	
	};
	
	/**
	 * Mapping from class specification keys to special processing functions.
	 *
	 * Although these are declared like instance properties in the specification
	 * when defining classes using `React.createClass`, they are actually static
	 * and are accessible on the constructor instead of the prototype. Despite
	 * being static, they must be defined outside of the "statics" key under
	 * which all other static methods are defined.
	 */
	var RESERVED_SPEC_KEYS = {
	  displayName: function (Constructor, displayName) {
	    Constructor.displayName = displayName;
	  },
	  mixins: function (Constructor, mixins) {
	    if (mixins) {
	      for (var i = 0; i < mixins.length; i++) {
	        mixSpecIntoComponent(Constructor, mixins[i]);
	      }
	    }
	  },
	  childContextTypes: function (Constructor, childContextTypes) {
	    if (false) {
	      validateTypeDef(Constructor, childContextTypes, ReactPropTypeLocations.childContext);
	    }
	    Constructor.childContextTypes = _assign({}, Constructor.childContextTypes, childContextTypes);
	  },
	  contextTypes: function (Constructor, contextTypes) {
	    if (false) {
	      validateTypeDef(Constructor, contextTypes, ReactPropTypeLocations.context);
	    }
	    Constructor.contextTypes = _assign({}, Constructor.contextTypes, contextTypes);
	  },
	  /**
	   * Special case getDefaultProps which should move into statics but requires
	   * automatic merging.
	   */
	  getDefaultProps: function (Constructor, getDefaultProps) {
	    if (Constructor.getDefaultProps) {
	      Constructor.getDefaultProps = createMergedResultFunction(Constructor.getDefaultProps, getDefaultProps);
	    } else {
	      Constructor.getDefaultProps = getDefaultProps;
	    }
	  },
	  propTypes: function (Constructor, propTypes) {
	    if (false) {
	      validateTypeDef(Constructor, propTypes, ReactPropTypeLocations.prop);
	    }
	    Constructor.propTypes = _assign({}, Constructor.propTypes, propTypes);
	  },
	  statics: function (Constructor, statics) {
	    mixStaticSpecIntoComponent(Constructor, statics);
	  },
	  autobind: function () {} };
	
	// noop
	function validateTypeDef(Constructor, typeDef, location) {
	  for (var propName in typeDef) {
	    if (typeDef.hasOwnProperty(propName)) {
	      // use a warning instead of an invariant so components
	      // don't show up in prod but only in __DEV__
	       false ? warning(typeof typeDef[propName] === 'function', '%s: %s type `%s` is invalid; it must be a function, usually from ' + 'React.PropTypes.', Constructor.displayName || 'ReactClass', ReactPropTypeLocationNames[location], propName) : void 0;
	    }
	  }
	}
	
	function validateMethodOverride(isAlreadyDefined, name) {
	  var specPolicy = ReactClassInterface.hasOwnProperty(name) ? ReactClassInterface[name] : null;
	
	  // Disallow overriding of base class methods unless explicitly allowed.
	  if (ReactClassMixin.hasOwnProperty(name)) {
	    !(specPolicy === SpecPolicy.OVERRIDE_BASE) ?  false ? invariant(false, 'ReactClassInterface: You are attempting to override `%s` from your class specification. Ensure that your method names do not overlap with React methods.', name) : _prodInvariant('73', name) : void 0;
	  }
	
	  // Disallow defining methods more than once unless explicitly allowed.
	  if (isAlreadyDefined) {
	    !(specPolicy === SpecPolicy.DEFINE_MANY || specPolicy === SpecPolicy.DEFINE_MANY_MERGED) ?  false ? invariant(false, 'ReactClassInterface: You are attempting to define `%s` on your component more than once. This conflict may be due to a mixin.', name) : _prodInvariant('74', name) : void 0;
	  }
	}
	
	/**
	 * Mixin helper which handles policy validation and reserved
	 * specification keys when building React classes.
	 */
	function mixSpecIntoComponent(Constructor, spec) {
	  if (!spec) {
	    if (false) {
	      var typeofSpec = typeof spec;
	      var isMixinValid = typeofSpec === 'object' && spec !== null;
	
	      process.env.NODE_ENV !== 'production' ? warning(isMixinValid, '%s: You\'re attempting to include a mixin that is either null ' + 'or not an object. Check the mixins included by the component, ' + 'as well as any mixins they include themselves. ' + 'Expected object but got %s.', Constructor.displayName || 'ReactClass', spec === null ? null : typeofSpec) : void 0;
	    }
	
	    return;
	  }
	
	  !(typeof spec !== 'function') ?  false ? invariant(false, 'ReactClass: You\'re attempting to use a component class or function as a mixin. Instead, just use a regular object.') : _prodInvariant('75') : void 0;
	  !!ReactElement.isValidElement(spec) ?  false ? invariant(false, 'ReactClass: You\'re attempting to use a component as a mixin. Instead, just use a regular object.') : _prodInvariant('76') : void 0;
	
	  var proto = Constructor.prototype;
	  var autoBindPairs = proto.__reactAutoBindPairs;
	
	  // By handling mixins before any other properties, we ensure the same
	  // chaining order is applied to methods with DEFINE_MANY policy, whether
	  // mixins are listed before or after these methods in the spec.
	  if (spec.hasOwnProperty(MIXINS_KEY)) {
	    RESERVED_SPEC_KEYS.mixins(Constructor, spec.mixins);
	  }
	
	  for (var name in spec) {
	    if (!spec.hasOwnProperty(name)) {
	      continue;
	    }
	
	    if (name === MIXINS_KEY) {
	      // We have already handled mixins in a special case above.
	      continue;
	    }
	
	    var property = spec[name];
	    var isAlreadyDefined = proto.hasOwnProperty(name);
	    validateMethodOverride(isAlreadyDefined, name);
	
	    if (RESERVED_SPEC_KEYS.hasOwnProperty(name)) {
	      RESERVED_SPEC_KEYS[name](Constructor, property);
	    } else {
	      // Setup methods on prototype:
	      // The following member methods should not be automatically bound:
	      // 1. Expected ReactClass methods (in the "interface").
	      // 2. Overridden methods (that were mixed in).
	      var isReactClassMethod = ReactClassInterface.hasOwnProperty(name);
	      var isFunction = typeof property === 'function';
	      var shouldAutoBind = isFunction && !isReactClassMethod && !isAlreadyDefined && spec.autobind !== false;
	
	      if (shouldAutoBind) {
	        autoBindPairs.push(name, property);
	        proto[name] = property;
	      } else {
	        if (isAlreadyDefined) {
	          var specPolicy = ReactClassInterface[name];
	
	          // These cases should already be caught by validateMethodOverride.
	          !(isReactClassMethod && (specPolicy === SpecPolicy.DEFINE_MANY_MERGED || specPolicy === SpecPolicy.DEFINE_MANY)) ?  false ? invariant(false, 'ReactClass: Unexpected spec policy %s for key %s when mixing in component specs.', specPolicy, name) : _prodInvariant('77', specPolicy, name) : void 0;
	
	          // For methods which are defined more than once, call the existing
	          // methods before calling the new property, merging if appropriate.
	          if (specPolicy === SpecPolicy.DEFINE_MANY_MERGED) {
	            proto[name] = createMergedResultFunction(proto[name], property);
	          } else if (specPolicy === SpecPolicy.DEFINE_MANY) {
	            proto[name] = createChainedFunction(proto[name], property);
	          }
	        } else {
	          proto[name] = property;
	          if (false) {
	            // Add verbose displayName to the function, which helps when looking
	            // at profiling tools.
	            if (typeof property === 'function' && spec.displayName) {
	              proto[name].displayName = spec.displayName + '_' + name;
	            }
	          }
	        }
	      }
	    }
	  }
	}
	
	function mixStaticSpecIntoComponent(Constructor, statics) {
	  if (!statics) {
	    return;
	  }
	  for (var name in statics) {
	    var property = statics[name];
	    if (!statics.hasOwnProperty(name)) {
	      continue;
	    }
	
	    var isReserved = name in RESERVED_SPEC_KEYS;
	    !!isReserved ?  false ? invariant(false, 'ReactClass: You are attempting to define a reserved property, `%s`, that shouldn\'t be on the "statics" key. Define it as an instance property instead; it will still be accessible on the constructor.', name) : _prodInvariant('78', name) : void 0;
	
	    var isInherited = name in Constructor;
	    !!isInherited ?  false ? invariant(false, 'ReactClass: You are attempting to define `%s` on your component more than once. This conflict may be due to a mixin.', name) : _prodInvariant('79', name) : void 0;
	    Constructor[name] = property;
	  }
	}
	
	/**
	 * Merge two objects, but throw if both contain the same key.
	 *
	 * @param {object} one The first object, which is mutated.
	 * @param {object} two The second object
	 * @return {object} one after it has been mutated to contain everything in two.
	 */
	function mergeIntoWithNoDuplicateKeys(one, two) {
	  !(one && two && typeof one === 'object' && typeof two === 'object') ?  false ? invariant(false, 'mergeIntoWithNoDuplicateKeys(): Cannot merge non-objects.') : _prodInvariant('80') : void 0;
	
	  for (var key in two) {
	    if (two.hasOwnProperty(key)) {
	      !(one[key] === undefined) ?  false ? invariant(false, 'mergeIntoWithNoDuplicateKeys(): Tried to merge two objects with the same key: `%s`. This conflict may be due to a mixin; in particular, this may be caused by two getInitialState() or getDefaultProps() methods returning objects with clashing keys.', key) : _prodInvariant('81', key) : void 0;
	      one[key] = two[key];
	    }
	  }
	  return one;
	}
	
	/**
	 * Creates a function that invokes two functions and merges their return values.
	 *
	 * @param {function} one Function to invoke first.
	 * @param {function} two Function to invoke second.
	 * @return {function} Function that invokes the two argument functions.
	 * @private
	 */
	function createMergedResultFunction(one, two) {
	  return function mergedResult() {
	    var a = one.apply(this, arguments);
	    var b = two.apply(this, arguments);
	    if (a == null) {
	      return b;
	    } else if (b == null) {
	      return a;
	    }
	    var c = {};
	    mergeIntoWithNoDuplicateKeys(c, a);
	    mergeIntoWithNoDuplicateKeys(c, b);
	    return c;
	  };
	}
	
	/**
	 * Creates a function that invokes two functions and ignores their return vales.
	 *
	 * @param {function} one Function to invoke first.
	 * @param {function} two Function to invoke second.
	 * @return {function} Function that invokes the two argument functions.
	 * @private
	 */
	function createChainedFunction(one, two) {
	  return function chainedFunction() {
	    one.apply(this, arguments);
	    two.apply(this, arguments);
	  };
	}
	
	/**
	 * Binds a method to the component.
	 *
	 * @param {object} component Component whose method is going to be bound.
	 * @param {function} method Method to be bound.
	 * @return {function} The bound method.
	 */
	function bindAutoBindMethod(component, method) {
	  var boundMethod = method.bind(component);
	  if (false) {
	    boundMethod.__reactBoundContext = component;
	    boundMethod.__reactBoundMethod = method;
	    boundMethod.__reactBoundArguments = null;
	    var componentName = component.constructor.displayName;
	    var _bind = boundMethod.bind;
	    boundMethod.bind = function (newThis) {
	      for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	        args[_key - 1] = arguments[_key];
	      }
	
	      // User is trying to bind() an autobound method; we effectively will
	      // ignore the value of "this" that the user is trying to use, so
	      // let's warn.
	      if (newThis !== component && newThis !== null) {
	        process.env.NODE_ENV !== 'production' ? warning(false, 'bind(): React component methods may only be bound to the ' + 'component instance. See %s', componentName) : void 0;
	      } else if (!args.length) {
	        process.env.NODE_ENV !== 'production' ? warning(false, 'bind(): You are binding a component method to the component. ' + 'React does this for you automatically in a high-performance ' + 'way, so you can safely remove this call. See %s', componentName) : void 0;
	        return boundMethod;
	      }
	      var reboundMethod = _bind.apply(boundMethod, arguments);
	      reboundMethod.__reactBoundContext = component;
	      reboundMethod.__reactBoundMethod = method;
	      reboundMethod.__reactBoundArguments = args;
	      return reboundMethod;
	    };
	  }
	  return boundMethod;
	}
	
	/**
	 * Binds all auto-bound methods in a component.
	 *
	 * @param {object} component Component whose method is going to be bound.
	 */
	function bindAutoBindMethods(component) {
	  var pairs = component.__reactAutoBindPairs;
	  for (var i = 0; i < pairs.length; i += 2) {
	    var autoBindKey = pairs[i];
	    var method = pairs[i + 1];
	    component[autoBindKey] = bindAutoBindMethod(component, method);
	  }
	}
	
	/**
	 * Add more to the ReactClass base class. These are all legacy features and
	 * therefore not already part of the modern ReactComponent.
	 */
	var ReactClassMixin = {
	
	  /**
	   * TODO: This will be deprecated because state should always keep a consistent
	   * type signature and the only use case for this, is to avoid that.
	   */
	  replaceState: function (newState, callback) {
	    this.updater.enqueueReplaceState(this, newState);
	    if (callback) {
	      this.updater.enqueueCallback(this, callback, 'replaceState');
	    }
	  },
	
	  /**
	   * Checks whether or not this composite component is mounted.
	   * @return {boolean} True if mounted, false otherwise.
	   * @protected
	   * @final
	   */
	  isMounted: function () {
	    return this.updater.isMounted(this);
	  }
	};
	
	var ReactClassComponent = function () {};
	_assign(ReactClassComponent.prototype, ReactComponent.prototype, ReactClassMixin);
	
	/**
	 * Module for creating composite components.
	 *
	 * @class ReactClass
	 */
	var ReactClass = {
	
	  /**
	   * Creates a composite component class given a class specification.
	   * See https://facebook.github.io/react/docs/top-level-api.html#react.createclass
	   *
	   * @param {object} spec Class specification (which must define `render`).
	   * @return {function} Component constructor function.
	   * @public
	   */
	  createClass: function (spec) {
	    var Constructor = function (props, context, updater) {
	      // This constructor gets overridden by mocks. The argument is used
	      // by mocks to assert on what gets mounted.
	
	      if (false) {
	        process.env.NODE_ENV !== 'production' ? warning(this instanceof Constructor, 'Something is calling a React component directly. Use a factory or ' + 'JSX instead. See: https://fb.me/react-legacyfactory') : void 0;
	      }
	
	      // Wire up auto-binding
	      if (this.__reactAutoBindPairs.length) {
	        bindAutoBindMethods(this);
	      }
	
	      this.props = props;
	      this.context = context;
	      this.refs = emptyObject;
	      this.updater = updater || ReactNoopUpdateQueue;
	
	      this.state = null;
	
	      // ReactClasses doesn't have constructors. Instead, they use the
	      // getInitialState and componentWillMount methods for initialization.
	
	      var initialState = this.getInitialState ? this.getInitialState() : null;
	      if (false) {
	        // We allow auto-mocks to proceed as if they're returning null.
	        if (initialState === undefined && this.getInitialState._isMockFunction) {
	          // This is probably bad practice. Consider warning here and
	          // deprecating this convenience.
	          initialState = null;
	        }
	      }
	      !(typeof initialState === 'object' && !Array.isArray(initialState)) ?  false ? invariant(false, '%s.getInitialState(): must return an object or null', Constructor.displayName || 'ReactCompositeComponent') : _prodInvariant('82', Constructor.displayName || 'ReactCompositeComponent') : void 0;
	
	      this.state = initialState;
	    };
	    Constructor.prototype = new ReactClassComponent();
	    Constructor.prototype.constructor = Constructor;
	    Constructor.prototype.__reactAutoBindPairs = [];
	
	    injectedMixins.forEach(mixSpecIntoComponent.bind(null, Constructor));
	
	    mixSpecIntoComponent(Constructor, spec);
	
	    // Initialize the defaultProps property after all mixins have been merged.
	    if (Constructor.getDefaultProps) {
	      Constructor.defaultProps = Constructor.getDefaultProps();
	    }
	
	    if (false) {
	      // This is a tag to indicate that the use of these method names is ok,
	      // since it's used with createClass. If it's not, then it's likely a
	      // mistake so we'll warn you to use the static property, property
	      // initializer or constructor respectively.
	      if (Constructor.getDefaultProps) {
	        Constructor.getDefaultProps.isReactClassApproved = {};
	      }
	      if (Constructor.prototype.getInitialState) {
	        Constructor.prototype.getInitialState.isReactClassApproved = {};
	      }
	    }
	
	    !Constructor.prototype.render ?  false ? invariant(false, 'createClass(...): Class specification must implement a `render` method.') : _prodInvariant('83') : void 0;
	
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(!Constructor.prototype.componentShouldUpdate, '%s has a method called ' + 'componentShouldUpdate(). Did you mean shouldComponentUpdate()? ' + 'The name is phrased as a question because the function is ' + 'expected to return a value.', spec.displayName || 'A component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(!Constructor.prototype.componentWillRecieveProps, '%s has a method called ' + 'componentWillRecieveProps(). Did you mean componentWillReceiveProps()?', spec.displayName || 'A component') : void 0;
	    }
	
	    // Reduce time spent doing lookups by setting these on the prototype.
	    for (var methodName in ReactClassInterface) {
	      if (!Constructor.prototype[methodName]) {
	        Constructor.prototype[methodName] = null;
	      }
	    }
	
	    return Constructor;
	  },
	
	  injection: {
	    injectMixin: function (mixin) {
	      injectedMixins.push(mixin);
	    }
	  }
	
	};
	
	module.exports = ReactClass;

/***/ },
/* 107 */
/***/ function(module, exports) {

	/**
	 * Copyright 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDOMComponentFlags
	 */
	
	'use strict';
	
	var ReactDOMComponentFlags = {
	  hasCachedChildNodes: 1 << 0
	};
	
	module.exports = ReactDOMComponentFlags;

/***/ },
/* 108 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDOMSelect
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(6);
	
	var DisabledInputUtils = __webpack_require__(42);
	var LinkedValueUtils = __webpack_require__(57);
	var ReactDOMComponentTree = __webpack_require__(8);
	var ReactUpdates = __webpack_require__(14);
	
	var warning = __webpack_require__(4);
	
	var didWarnValueLink = false;
	var didWarnValueDefaultValue = false;
	
	function updateOptionsIfPendingUpdateAndMounted() {
	  if (this._rootNodeID && this._wrapperState.pendingUpdate) {
	    this._wrapperState.pendingUpdate = false;
	
	    var props = this._currentElement.props;
	    var value = LinkedValueUtils.getValue(props);
	
	    if (value != null) {
	      updateOptions(this, Boolean(props.multiple), value);
	    }
	  }
	}
	
	function getDeclarationErrorAddendum(owner) {
	  if (owner) {
	    var name = owner.getName();
	    if (name) {
	      return ' Check the render method of `' + name + '`.';
	    }
	  }
	  return '';
	}
	
	var valuePropNames = ['value', 'defaultValue'];
	
	/**
	 * Validation function for `value` and `defaultValue`.
	 * @private
	 */
	function checkSelectPropTypes(inst, props) {
	  var owner = inst._currentElement._owner;
	  LinkedValueUtils.checkPropTypes('select', props, owner);
	
	  if (props.valueLink !== undefined && !didWarnValueLink) {
	     false ? warning(false, '`valueLink` prop on `select` is deprecated; set `value` and `onChange` instead.') : void 0;
	    didWarnValueLink = true;
	  }
	
	  for (var i = 0; i < valuePropNames.length; i++) {
	    var propName = valuePropNames[i];
	    if (props[propName] == null) {
	      continue;
	    }
	    var isArray = Array.isArray(props[propName]);
	    if (props.multiple && !isArray) {
	       false ? warning(false, 'The `%s` prop supplied to <select> must be an array if ' + '`multiple` is true.%s', propName, getDeclarationErrorAddendum(owner)) : void 0;
	    } else if (!props.multiple && isArray) {
	       false ? warning(false, 'The `%s` prop supplied to <select> must be a scalar ' + 'value if `multiple` is false.%s', propName, getDeclarationErrorAddendum(owner)) : void 0;
	    }
	  }
	}
	
	/**
	 * @param {ReactDOMComponent} inst
	 * @param {boolean} multiple
	 * @param {*} propValue A stringable (with `multiple`, a list of stringables).
	 * @private
	 */
	function updateOptions(inst, multiple, propValue) {
	  var selectedValue, i;
	  var options = ReactDOMComponentTree.getNodeFromInstance(inst).options;
	
	  if (multiple) {
	    selectedValue = {};
	    for (i = 0; i < propValue.length; i++) {
	      selectedValue['' + propValue[i]] = true;
	    }
	    for (i = 0; i < options.length; i++) {
	      var selected = selectedValue.hasOwnProperty(options[i].value);
	      if (options[i].selected !== selected) {
	        options[i].selected = selected;
	      }
	    }
	  } else {
	    // Do not set `select.value` as exact behavior isn't consistent across all
	    // browsers for all cases.
	    selectedValue = '' + propValue;
	    for (i = 0; i < options.length; i++) {
	      if (options[i].value === selectedValue) {
	        options[i].selected = true;
	        return;
	      }
	    }
	    if (options.length) {
	      options[0].selected = true;
	    }
	  }
	}
	
	/**
	 * Implements a <select> host component that allows optionally setting the
	 * props `value` and `defaultValue`. If `multiple` is false, the prop must be a
	 * stringable. If `multiple` is true, the prop must be an array of stringables.
	 *
	 * If `value` is not supplied (or null/undefined), user actions that change the
	 * selected option will trigger updates to the rendered options.
	 *
	 * If it is supplied (and not null/undefined), the rendered options will not
	 * update in response to user actions. Instead, the `value` prop must change in
	 * order for the rendered options to update.
	 *
	 * If `defaultValue` is provided, any options with the supplied values will be
	 * selected.
	 */
	var ReactDOMSelect = {
	  getHostProps: function (inst, props) {
	    return _assign({}, DisabledInputUtils.getHostProps(inst, props), {
	      onChange: inst._wrapperState.onChange,
	      value: undefined
	    });
	  },
	
	  mountWrapper: function (inst, props) {
	    if (false) {
	      checkSelectPropTypes(inst, props);
	    }
	
	    var value = LinkedValueUtils.getValue(props);
	    inst._wrapperState = {
	      pendingUpdate: false,
	      initialValue: value != null ? value : props.defaultValue,
	      listeners: null,
	      onChange: _handleChange.bind(inst),
	      wasMultiple: Boolean(props.multiple)
	    };
	
	    if (props.value !== undefined && props.defaultValue !== undefined && !didWarnValueDefaultValue) {
	       false ? warning(false, 'Select elements must be either controlled or uncontrolled ' + '(specify either the value prop, or the defaultValue prop, but not ' + 'both). Decide between using a controlled or uncontrolled select ' + 'element and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components') : void 0;
	      didWarnValueDefaultValue = true;
	    }
	  },
	
	  getSelectValueContext: function (inst) {
	    // ReactDOMOption looks at this initial value so the initial generated
	    // markup has correct `selected` attributes
	    return inst._wrapperState.initialValue;
	  },
	
	  postUpdateWrapper: function (inst) {
	    var props = inst._currentElement.props;
	
	    // After the initial mount, we control selected-ness manually so don't pass
	    // this value down
	    inst._wrapperState.initialValue = undefined;
	
	    var wasMultiple = inst._wrapperState.wasMultiple;
	    inst._wrapperState.wasMultiple = Boolean(props.multiple);
	
	    var value = LinkedValueUtils.getValue(props);
	    if (value != null) {
	      inst._wrapperState.pendingUpdate = false;
	      updateOptions(inst, Boolean(props.multiple), value);
	    } else if (wasMultiple !== Boolean(props.multiple)) {
	      // For simplicity, reapply `defaultValue` if `multiple` is toggled.
	      if (props.defaultValue != null) {
	        updateOptions(inst, Boolean(props.multiple), props.defaultValue);
	      } else {
	        // Revert the select back to its default unselected state.
	        updateOptions(inst, Boolean(props.multiple), props.multiple ? [] : '');
	      }
	    }
	  }
	};
	
	function _handleChange(event) {
	  var props = this._currentElement.props;
	  var returnValue = LinkedValueUtils.executeOnChange(props, event);
	
	  if (this._rootNodeID) {
	    this._wrapperState.pendingUpdate = true;
	  }
	  ReactUpdates.asap(updateOptionsIfPendingUpdateAndMounted, this);
	  return returnValue;
	}
	
	module.exports = ReactDOMSelect;

/***/ },
/* 109 */
/***/ function(module, exports) {

	/**
	 * Copyright 2014-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactEmptyComponent
	 */
	
	'use strict';
	
	var emptyComponentFactory;
	
	var ReactEmptyComponentInjection = {
	  injectEmptyComponentFactory: function (factory) {
	    emptyComponentFactory = factory;
	  }
	};
	
	var ReactEmptyComponent = {
	  create: function (instantiate) {
	    return emptyComponentFactory(instantiate);
	  }
	};
	
	ReactEmptyComponent.injection = ReactEmptyComponentInjection;
	
	module.exports = ReactEmptyComponent;

/***/ },
/* 110 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactFeatureFlags
	 * 
	 */
	
	'use strict';
	
	var ReactFeatureFlags = {
	  // When true, call console.time() before and .timeEnd() after each top-level
	  // render (both initial renders and updates). Useful when looking at prod-mode
	  // timeline profiles in Chrome, for example.
	  logTopLevelRenders: false
	};
	
	module.exports = ReactFeatureFlags;

/***/ },
/* 111 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactHostComponent
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(3),
	    _assign = __webpack_require__(6);
	
	var invariant = __webpack_require__(2);
	
	var genericComponentClass = null;
	// This registry keeps track of wrapper classes around host tags.
	var tagToComponentClass = {};
	var textComponentClass = null;
	
	var ReactHostComponentInjection = {
	  // This accepts a class that receives the tag string. This is a catch all
	  // that can render any kind of tag.
	  injectGenericComponentClass: function (componentClass) {
	    genericComponentClass = componentClass;
	  },
	  // This accepts a text component class that takes the text string to be
	  // rendered as props.
	  injectTextComponentClass: function (componentClass) {
	    textComponentClass = componentClass;
	  },
	  // This accepts a keyed object with classes as values. Each key represents a
	  // tag. That particular tag will use this class instead of the generic one.
	  injectComponentClasses: function (componentClasses) {
	    _assign(tagToComponentClass, componentClasses);
	  }
	};
	
	/**
	 * Get a host internal component class for a specific tag.
	 *
	 * @param {ReactElement} element The element to create.
	 * @return {function} The internal class constructor function.
	 */
	function createInternalComponent(element) {
	  !genericComponentClass ?  false ? invariant(false, 'There is no registered component for the tag %s', element.type) : _prodInvariant('111', element.type) : void 0;
	  return new genericComponentClass(element);
	}
	
	/**
	 * @param {ReactText} text
	 * @return {ReactComponent}
	 */
	function createInstanceForText(text) {
	  return new textComponentClass(text);
	}
	
	/**
	 * @param {ReactComponent} component
	 * @return {boolean}
	 */
	function isTextComponent(component) {
	  return component instanceof textComponentClass;
	}
	
	var ReactHostComponent = {
	  createInternalComponent: createInternalComponent,
	  createInstanceForText: createInstanceForText,
	  isTextComponent: isTextComponent,
	  injection: ReactHostComponentInjection
	};
	
	module.exports = ReactHostComponent;

/***/ },
/* 112 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactInputSelection
	 */
	
	'use strict';
	
	var ReactDOMSelection = __webpack_require__(328);
	
	var containsNode = __webpack_require__(148);
	var focusNode = __webpack_require__(80);
	var getActiveElement = __webpack_require__(81);
	
	function isInDocument(node) {
	  return containsNode(document.documentElement, node);
	}
	
	/**
	 * @ReactInputSelection: React input selection module. Based on Selection.js,
	 * but modified to be suitable for react and has a couple of bug fixes (doesn't
	 * assume buttons have range selections allowed).
	 * Input selection module for React.
	 */
	var ReactInputSelection = {
	
	  hasSelectionCapabilities: function (elem) {
	    var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
	    return nodeName && (nodeName === 'input' && elem.type === 'text' || nodeName === 'textarea' || elem.contentEditable === 'true');
	  },
	
	  getSelectionInformation: function () {
	    var focusedElem = getActiveElement();
	    return {
	      focusedElem: focusedElem,
	      selectionRange: ReactInputSelection.hasSelectionCapabilities(focusedElem) ? ReactInputSelection.getSelection(focusedElem) : null
	    };
	  },
	
	  /**
	   * @restoreSelection: If any selection information was potentially lost,
	   * restore it. This is useful when performing operations that could remove dom
	   * nodes and place them back in, resulting in focus being lost.
	   */
	  restoreSelection: function (priorSelectionInformation) {
	    var curFocusedElem = getActiveElement();
	    var priorFocusedElem = priorSelectionInformation.focusedElem;
	    var priorSelectionRange = priorSelectionInformation.selectionRange;
	    if (curFocusedElem !== priorFocusedElem && isInDocument(priorFocusedElem)) {
	      if (ReactInputSelection.hasSelectionCapabilities(priorFocusedElem)) {
	        ReactInputSelection.setSelection(priorFocusedElem, priorSelectionRange);
	      }
	      focusNode(priorFocusedElem);
	    }
	  },
	
	  /**
	   * @getSelection: Gets the selection bounds of a focused textarea, input or
	   * contentEditable node.
	   * -@input: Look up selection bounds of this input
	   * -@return {start: selectionStart, end: selectionEnd}
	   */
	  getSelection: function (input) {
	    var selection;
	
	    if ('selectionStart' in input) {
	      // Modern browser with input or textarea.
	      selection = {
	        start: input.selectionStart,
	        end: input.selectionEnd
	      };
	    } else if (document.selection && input.nodeName && input.nodeName.toLowerCase() === 'input') {
	      // IE8 input.
	      var range = document.selection.createRange();
	      // There can only be one selection per document in IE, so it must
	      // be in our element.
	      if (range.parentElement() === input) {
	        selection = {
	          start: -range.moveStart('character', -input.value.length),
	          end: -range.moveEnd('character', -input.value.length)
	        };
	      }
	    } else {
	      // Content editable or old IE textarea.
	      selection = ReactDOMSelection.getOffsets(input);
	    }
	
	    return selection || { start: 0, end: 0 };
	  },
	
	  /**
	   * @setSelection: Sets the selection bounds of a textarea or input and focuses
	   * the input.
	   * -@input     Set selection bounds of this input or textarea
	   * -@offsets   Object of same form that is returned from get*
	   */
	  setSelection: function (input, offsets) {
	    var start = offsets.start;
	    var end = offsets.end;
	    if (end === undefined) {
	      end = start;
	    }
	
	    if ('selectionStart' in input) {
	      input.selectionStart = start;
	      input.selectionEnd = Math.min(end, input.value.length);
	    } else if (document.selection && input.nodeName && input.nodeName.toLowerCase() === 'input') {
	      var range = input.createTextRange();
	      range.collapse(true);
	      range.moveStart('character', start);
	      range.moveEnd('character', end - start);
	      range.select();
	    } else {
	      ReactDOMSelection.setOffsets(input, offsets);
	    }
	  }
	};
	
	module.exports = ReactInputSelection;

/***/ },
/* 113 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactMount
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(3);
	
	var DOMLazyTree = __webpack_require__(26);
	var DOMProperty = __webpack_require__(27);
	var ReactBrowserEventEmitter = __webpack_require__(43);
	var ReactCurrentOwner = __webpack_require__(23);
	var ReactDOMComponentTree = __webpack_require__(8);
	var ReactDOMContainerInfo = __webpack_require__(321);
	var ReactDOMFeatureFlags = __webpack_require__(324);
	var ReactElement = __webpack_require__(13);
	var ReactFeatureFlags = __webpack_require__(110);
	var ReactInstanceMap = __webpack_require__(36);
	var ReactInstrumentation = __webpack_require__(11);
	var ReactMarkupChecksum = __webpack_require__(337);
	var ReactReconciler = __webpack_require__(28);
	var ReactUpdateQueue = __webpack_require__(66);
	var ReactUpdates = __webpack_require__(14);
	
	var emptyObject = __webpack_require__(30);
	var instantiateReactComponent = __webpack_require__(125);
	var invariant = __webpack_require__(2);
	var setInnerHTML = __webpack_require__(46);
	var shouldUpdateReactComponent = __webpack_require__(72);
	var warning = __webpack_require__(4);
	
	var ATTR_NAME = DOMProperty.ID_ATTRIBUTE_NAME;
	var ROOT_ATTR_NAME = DOMProperty.ROOT_ATTRIBUTE_NAME;
	
	var ELEMENT_NODE_TYPE = 1;
	var DOC_NODE_TYPE = 9;
	var DOCUMENT_FRAGMENT_NODE_TYPE = 11;
	
	var instancesByReactRootID = {};
	
	/**
	 * Finds the index of the first character
	 * that's not common between the two given strings.
	 *
	 * @return {number} the index of the character where the strings diverge
	 */
	function firstDifferenceIndex(string1, string2) {
	  var minLen = Math.min(string1.length, string2.length);
	  for (var i = 0; i < minLen; i++) {
	    if (string1.charAt(i) !== string2.charAt(i)) {
	      return i;
	    }
	  }
	  return string1.length === string2.length ? -1 : minLen;
	}
	
	/**
	 * @param {DOMElement|DOMDocument} container DOM element that may contain
	 * a React component
	 * @return {?*} DOM element that may have the reactRoot ID, or null.
	 */
	function getReactRootElementInContainer(container) {
	  if (!container) {
	    return null;
	  }
	
	  if (container.nodeType === DOC_NODE_TYPE) {
	    return container.documentElement;
	  } else {
	    return container.firstChild;
	  }
	}
	
	function internalGetID(node) {
	  // If node is something like a window, document, or text node, none of
	  // which support attributes or a .getAttribute method, gracefully return
	  // the empty string, as if the attribute were missing.
	  return node.getAttribute && node.getAttribute(ATTR_NAME) || '';
	}
	
	/**
	 * Mounts this component and inserts it into the DOM.
	 *
	 * @param {ReactComponent} componentInstance The instance to mount.
	 * @param {DOMElement} container DOM element to mount into.
	 * @param {ReactReconcileTransaction} transaction
	 * @param {boolean} shouldReuseMarkup If true, do not insert markup
	 */
	function mountComponentIntoNode(wrapperInstance, container, transaction, shouldReuseMarkup, context) {
	  var markerName;
	  if (ReactFeatureFlags.logTopLevelRenders) {
	    var wrappedElement = wrapperInstance._currentElement.props;
	    var type = wrappedElement.type;
	    markerName = 'React mount: ' + (typeof type === 'string' ? type : type.displayName || type.name);
	    console.time(markerName);
	  }
	
	  var markup = ReactReconciler.mountComponent(wrapperInstance, transaction, null, ReactDOMContainerInfo(wrapperInstance, container), context, 0 /* parentDebugID */
	  );
	
	  if (markerName) {
	    console.timeEnd(markerName);
	  }
	
	  wrapperInstance._renderedComponent._topLevelWrapper = wrapperInstance;
	  ReactMount._mountImageIntoNode(markup, container, wrapperInstance, shouldReuseMarkup, transaction);
	}
	
	/**
	 * Batched mount.
	 *
	 * @param {ReactComponent} componentInstance The instance to mount.
	 * @param {DOMElement} container DOM element to mount into.
	 * @param {boolean} shouldReuseMarkup If true, do not insert markup
	 */
	function batchedMountComponentIntoNode(componentInstance, container, shouldReuseMarkup, context) {
	  var transaction = ReactUpdates.ReactReconcileTransaction.getPooled(
	  /* useCreateElement */
	  !shouldReuseMarkup && ReactDOMFeatureFlags.useCreateElement);
	  transaction.perform(mountComponentIntoNode, null, componentInstance, container, transaction, shouldReuseMarkup, context);
	  ReactUpdates.ReactReconcileTransaction.release(transaction);
	}
	
	/**
	 * Unmounts a component and removes it from the DOM.
	 *
	 * @param {ReactComponent} instance React component instance.
	 * @param {DOMElement} container DOM element to unmount from.
	 * @final
	 * @internal
	 * @see {ReactMount.unmountComponentAtNode}
	 */
	function unmountComponentFromNode(instance, container, safely) {
	  if (false) {
	    ReactInstrumentation.debugTool.onBeginFlush();
	  }
	  ReactReconciler.unmountComponent(instance, safely);
	  if (false) {
	    ReactInstrumentation.debugTool.onEndFlush();
	  }
	
	  if (container.nodeType === DOC_NODE_TYPE) {
	    container = container.documentElement;
	  }
	
	  // http://jsperf.com/emptying-a-node
	  while (container.lastChild) {
	    container.removeChild(container.lastChild);
	  }
	}
	
	/**
	 * True if the supplied DOM node has a direct React-rendered child that is
	 * not a React root element. Useful for warning in `render`,
	 * `unmountComponentAtNode`, etc.
	 *
	 * @param {?DOMElement} node The candidate DOM node.
	 * @return {boolean} True if the DOM element contains a direct child that was
	 * rendered by React but is not a root element.
	 * @internal
	 */
	function hasNonRootReactChild(container) {
	  var rootEl = getReactRootElementInContainer(container);
	  if (rootEl) {
	    var inst = ReactDOMComponentTree.getInstanceFromNode(rootEl);
	    return !!(inst && inst._hostParent);
	  }
	}
	
	/**
	 * True if the supplied DOM node is a React DOM element and
	 * it has been rendered by another copy of React.
	 *
	 * @param {?DOMElement} node The candidate DOM node.
	 * @return {boolean} True if the DOM has been rendered by another copy of React
	 * @internal
	 */
	function nodeIsRenderedByOtherInstance(container) {
	  var rootEl = getReactRootElementInContainer(container);
	  return !!(rootEl && isReactNode(rootEl) && !ReactDOMComponentTree.getInstanceFromNode(rootEl));
	}
	
	/**
	 * True if the supplied DOM node is a valid node element.
	 *
	 * @param {?DOMElement} node The candidate DOM node.
	 * @return {boolean} True if the DOM is a valid DOM node.
	 * @internal
	 */
	function isValidContainer(node) {
	  return !!(node && (node.nodeType === ELEMENT_NODE_TYPE || node.nodeType === DOC_NODE_TYPE || node.nodeType === DOCUMENT_FRAGMENT_NODE_TYPE));
	}
	
	/**
	 * True if the supplied DOM node is a valid React node element.
	 *
	 * @param {?DOMElement} node The candidate DOM node.
	 * @return {boolean} True if the DOM is a valid React DOM node.
	 * @internal
	 */
	function isReactNode(node) {
	  return isValidContainer(node) && (node.hasAttribute(ROOT_ATTR_NAME) || node.hasAttribute(ATTR_NAME));
	}
	
	function getHostRootInstanceInContainer(container) {
	  var rootEl = getReactRootElementInContainer(container);
	  var prevHostInstance = rootEl && ReactDOMComponentTree.getInstanceFromNode(rootEl);
	  return prevHostInstance && !prevHostInstance._hostParent ? prevHostInstance : null;
	}
	
	function getTopLevelWrapperInContainer(container) {
	  var root = getHostRootInstanceInContainer(container);
	  return root ? root._hostContainerInfo._topLevelWrapper : null;
	}
	
	/**
	 * Temporary (?) hack so that we can store all top-level pending updates on
	 * composites instead of having to worry about different types of components
	 * here.
	 */
	var topLevelRootCounter = 1;
	var TopLevelWrapper = function () {
	  this.rootID = topLevelRootCounter++;
	};
	TopLevelWrapper.prototype.isReactComponent = {};
	if (false) {
	  TopLevelWrapper.displayName = 'TopLevelWrapper';
	}
	TopLevelWrapper.prototype.render = function () {
	  // this.props is actually a ReactElement
	  return this.props;
	};
	
	/**
	 * Mounting is the process of initializing a React component by creating its
	 * representative DOM elements and inserting them into a supplied `container`.
	 * Any prior content inside `container` is destroyed in the process.
	 *
	 *   ReactMount.render(
	 *     component,
	 *     document.getElementById('container')
	 *   );
	 *
	 *   <div id="container">                   <-- Supplied `container`.
	 *     <div data-reactid=".3">              <-- Rendered reactRoot of React
	 *       // ...                                 component.
	 *     </div>
	 *   </div>
	 *
	 * Inside of `container`, the first element rendered is the "reactRoot".
	 */
	var ReactMount = {
	
	  TopLevelWrapper: TopLevelWrapper,
	
	  /**
	   * Used by devtools. The keys are not important.
	   */
	  _instancesByReactRootID: instancesByReactRootID,
	
	  /**
	   * This is a hook provided to support rendering React components while
	   * ensuring that the apparent scroll position of its `container` does not
	   * change.
	   *
	   * @param {DOMElement} container The `container` being rendered into.
	   * @param {function} renderCallback This must be called once to do the render.
	   */
	  scrollMonitor: function (container, renderCallback) {
	    renderCallback();
	  },
	
	  /**
	   * Take a component that's already mounted into the DOM and replace its props
	   * @param {ReactComponent} prevComponent component instance already in the DOM
	   * @param {ReactElement} nextElement component instance to render
	   * @param {DOMElement} container container to render into
	   * @param {?function} callback function triggered on completion
	   */
	  _updateRootComponent: function (prevComponent, nextElement, nextContext, container, callback) {
	    ReactMount.scrollMonitor(container, function () {
	      ReactUpdateQueue.enqueueElementInternal(prevComponent, nextElement, nextContext);
	      if (callback) {
	        ReactUpdateQueue.enqueueCallbackInternal(prevComponent, callback);
	      }
	    });
	
	    return prevComponent;
	  },
	
	  /**
	   * Render a new component into the DOM. Hooked by hooks!
	   *
	   * @param {ReactElement} nextElement element to render
	   * @param {DOMElement} container container to render into
	   * @param {boolean} shouldReuseMarkup if we should skip the markup insertion
	   * @return {ReactComponent} nextComponent
	   */
	  _renderNewRootComponent: function (nextElement, container, shouldReuseMarkup, context) {
	    // Various parts of our code (such as ReactCompositeComponent's
	    // _renderValidatedComponent) assume that calls to render aren't nested;
	    // verify that that's the case.
	     false ? warning(ReactCurrentOwner.current == null, '_renderNewRootComponent(): Render methods should be a pure function ' + 'of props and state; triggering nested component updates from ' + 'render is not allowed. If necessary, trigger nested updates in ' + 'componentDidUpdate. Check the render method of %s.', ReactCurrentOwner.current && ReactCurrentOwner.current.getName() || 'ReactCompositeComponent') : void 0;
	
	    !isValidContainer(container) ?  false ? invariant(false, '_registerComponent(...): Target container is not a DOM element.') : _prodInvariant('37') : void 0;
	
	    ReactBrowserEventEmitter.ensureScrollValueMonitoring();
	    var componentInstance = instantiateReactComponent(nextElement, false);
	
	    // The initial render is synchronous but any updates that happen during
	    // rendering, in componentWillMount or componentDidMount, will be batched
	    // according to the current batching strategy.
	
	    ReactUpdates.batchedUpdates(batchedMountComponentIntoNode, componentInstance, container, shouldReuseMarkup, context);
	
	    var wrapperID = componentInstance._instance.rootID;
	    instancesByReactRootID[wrapperID] = componentInstance;
	
	    return componentInstance;
	  },
	
	  /**
	   * Renders a React component into the DOM in the supplied `container`.
	   *
	   * If the React component was previously rendered into `container`, this will
	   * perform an update on it and only mutate the DOM as necessary to reflect the
	   * latest React component.
	   *
	   * @param {ReactComponent} parentComponent The conceptual parent of this render tree.
	   * @param {ReactElement} nextElement Component element to render.
	   * @param {DOMElement} container DOM element to render into.
	   * @param {?function} callback function triggered on completion
	   * @return {ReactComponent} Component instance rendered in `container`.
	   */
	  renderSubtreeIntoContainer: function (parentComponent, nextElement, container, callback) {
	    !(parentComponent != null && ReactInstanceMap.has(parentComponent)) ?  false ? invariant(false, 'parentComponent must be a valid React Component') : _prodInvariant('38') : void 0;
	    return ReactMount._renderSubtreeIntoContainer(parentComponent, nextElement, container, callback);
	  },
	
	  _renderSubtreeIntoContainer: function (parentComponent, nextElement, container, callback) {
	    ReactUpdateQueue.validateCallback(callback, 'ReactDOM.render');
	    !ReactElement.isValidElement(nextElement) ?  false ? invariant(false, 'ReactDOM.render(): Invalid component element.%s', typeof nextElement === 'string' ? ' Instead of passing a string like \'div\', pass ' + 'React.createElement(\'div\') or <div />.' : typeof nextElement === 'function' ? ' Instead of passing a class like Foo, pass ' + 'React.createElement(Foo) or <Foo />.' :
	    // Check if it quacks like an element
	    nextElement != null && nextElement.props !== undefined ? ' This may be caused by unintentionally loading two independent ' + 'copies of React.' : '') : _prodInvariant('39', typeof nextElement === 'string' ? ' Instead of passing a string like \'div\', pass ' + 'React.createElement(\'div\') or <div />.' : typeof nextElement === 'function' ? ' Instead of passing a class like Foo, pass ' + 'React.createElement(Foo) or <Foo />.' : nextElement != null && nextElement.props !== undefined ? ' This may be caused by unintentionally loading two independent ' + 'copies of React.' : '') : void 0;
	
	     false ? warning(!container || !container.tagName || container.tagName.toUpperCase() !== 'BODY', 'render(): Rendering components directly into document.body is ' + 'discouraged, since its children are often manipulated by third-party ' + 'scripts and browser extensions. This may lead to subtle ' + 'reconciliation issues. Try rendering into a container element created ' + 'for your app.') : void 0;
	
	    var nextWrappedElement = ReactElement(TopLevelWrapper, null, null, null, null, null, nextElement);
	
	    var nextContext;
	    if (parentComponent) {
	      var parentInst = ReactInstanceMap.get(parentComponent);
	      nextContext = parentInst._processChildContext(parentInst._context);
	    } else {
	      nextContext = emptyObject;
	    }
	
	    var prevComponent = getTopLevelWrapperInContainer(container);
	
	    if (prevComponent) {
	      var prevWrappedElement = prevComponent._currentElement;
	      var prevElement = prevWrappedElement.props;
	      if (shouldUpdateReactComponent(prevElement, nextElement)) {
	        var publicInst = prevComponent._renderedComponent.getPublicInstance();
	        var updatedCallback = callback && function () {
	          callback.call(publicInst);
	        };
	        ReactMount._updateRootComponent(prevComponent, nextWrappedElement, nextContext, container, updatedCallback);
	        return publicInst;
	      } else {
	        ReactMount.unmountComponentAtNode(container);
	      }
	    }
	
	    var reactRootElement = getReactRootElementInContainer(container);
	    var containerHasReactMarkup = reactRootElement && !!internalGetID(reactRootElement);
	    var containerHasNonRootReactChild = hasNonRootReactChild(container);
	
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(!containerHasNonRootReactChild, 'render(...): Replacing React-rendered children with a new root ' + 'component. If you intended to update the children of this node, ' + 'you should instead have the existing children update their state ' + 'and render the new components instead of calling ReactDOM.render.') : void 0;
	
	      if (!containerHasReactMarkup || reactRootElement.nextSibling) {
	        var rootElementSibling = reactRootElement;
	        while (rootElementSibling) {
	          if (internalGetID(rootElementSibling)) {
	            process.env.NODE_ENV !== 'production' ? warning(false, 'render(): Target node has markup rendered by React, but there ' + 'are unrelated nodes as well. This is most commonly caused by ' + 'white-space inserted around server-rendered markup.') : void 0;
	            break;
	          }
	          rootElementSibling = rootElementSibling.nextSibling;
	        }
	      }
	    }
	
	    var shouldReuseMarkup = containerHasReactMarkup && !prevComponent && !containerHasNonRootReactChild;
	    var component = ReactMount._renderNewRootComponent(nextWrappedElement, container, shouldReuseMarkup, nextContext)._renderedComponent.getPublicInstance();
	    if (callback) {
	      callback.call(component);
	    }
	    return component;
	  },
	
	  /**
	   * Renders a React component into the DOM in the supplied `container`.
	   * See https://facebook.github.io/react/docs/top-level-api.html#reactdom.render
	   *
	   * If the React component was previously rendered into `container`, this will
	   * perform an update on it and only mutate the DOM as necessary to reflect the
	   * latest React component.
	   *
	   * @param {ReactElement} nextElement Component element to render.
	   * @param {DOMElement} container DOM element to render into.
	   * @param {?function} callback function triggered on completion
	   * @return {ReactComponent} Component instance rendered in `container`.
	   */
	  render: function (nextElement, container, callback) {
	    return ReactMount._renderSubtreeIntoContainer(null, nextElement, container, callback);
	  },
	
	  /**
	   * Unmounts and destroys the React component rendered in the `container`.
	   * See https://facebook.github.io/react/docs/top-level-api.html#reactdom.unmountcomponentatnode
	   *
	   * @param {DOMElement} container DOM element containing a React component.
	   * @return {boolean} True if a component was found in and unmounted from
	   *                   `container`
	   */
	  unmountComponentAtNode: function (container) {
	    // Various parts of our code (such as ReactCompositeComponent's
	    // _renderValidatedComponent) assume that calls to render aren't nested;
	    // verify that that's the case. (Strictly speaking, unmounting won't cause a
	    // render but we still don't expect to be in a render call here.)
	     false ? warning(ReactCurrentOwner.current == null, 'unmountComponentAtNode(): Render methods should be a pure function ' + 'of props and state; triggering nested component updates from render ' + 'is not allowed. If necessary, trigger nested updates in ' + 'componentDidUpdate. Check the render method of %s.', ReactCurrentOwner.current && ReactCurrentOwner.current.getName() || 'ReactCompositeComponent') : void 0;
	
	    !isValidContainer(container) ?  false ? invariant(false, 'unmountComponentAtNode(...): Target container is not a DOM element.') : _prodInvariant('40') : void 0;
	
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(!nodeIsRenderedByOtherInstance(container), 'unmountComponentAtNode(): The node you\'re attempting to unmount ' + 'was rendered by another copy of React.') : void 0;
	    }
	
	    var prevComponent = getTopLevelWrapperInContainer(container);
	    if (!prevComponent) {
	      // Check if the node being unmounted was rendered by React, but isn't a
	      // root node.
	      var containerHasNonRootReactChild = hasNonRootReactChild(container);
	
	      // Check if the container itself is a React root node.
	      var isContainerReactRoot = container.nodeType === 1 && container.hasAttribute(ROOT_ATTR_NAME);
	
	      if (false) {
	        process.env.NODE_ENV !== 'production' ? warning(!containerHasNonRootReactChild, 'unmountComponentAtNode(): The node you\'re attempting to unmount ' + 'was rendered by React and is not a top-level container. %s', isContainerReactRoot ? 'You may have accidentally passed in a React root node instead ' + 'of its container.' : 'Instead, have the parent component update its state and ' + 'rerender in order to remove this component.') : void 0;
	      }
	
	      return false;
	    }
	    delete instancesByReactRootID[prevComponent._instance.rootID];
	    ReactUpdates.batchedUpdates(unmountComponentFromNode, prevComponent, container, false);
	    return true;
	  },
	
	  _mountImageIntoNode: function (markup, container, instance, shouldReuseMarkup, transaction) {
	    !isValidContainer(container) ?  false ? invariant(false, 'mountComponentIntoNode(...): Target container is not valid.') : _prodInvariant('41') : void 0;
	
	    if (shouldReuseMarkup) {
	      var rootElement = getReactRootElementInContainer(container);
	      if (ReactMarkupChecksum.canReuseMarkup(markup, rootElement)) {
	        ReactDOMComponentTree.precacheNode(instance, rootElement);
	        return;
	      } else {
	        var checksum = rootElement.getAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME);
	        rootElement.removeAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME);
	
	        var rootMarkup = rootElement.outerHTML;
	        rootElement.setAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME, checksum);
	
	        var normalizedMarkup = markup;
	        if (false) {
	          // because rootMarkup is retrieved from the DOM, various normalizations
	          // will have occurred which will not be present in `markup`. Here,
	          // insert markup into a <div> or <iframe> depending on the container
	          // type to perform the same normalizations before comparing.
	          var normalizer;
	          if (container.nodeType === ELEMENT_NODE_TYPE) {
	            normalizer = document.createElement('div');
	            normalizer.innerHTML = markup;
	            normalizedMarkup = normalizer.innerHTML;
	          } else {
	            normalizer = document.createElement('iframe');
	            document.body.appendChild(normalizer);
	            normalizer.contentDocument.write(markup);
	            normalizedMarkup = normalizer.contentDocument.documentElement.outerHTML;
	            document.body.removeChild(normalizer);
	          }
	        }
	
	        var diffIndex = firstDifferenceIndex(normalizedMarkup, rootMarkup);
	        var difference = ' (client) ' + normalizedMarkup.substring(diffIndex - 20, diffIndex + 20) + '\n (server) ' + rootMarkup.substring(diffIndex - 20, diffIndex + 20);
	
	        !(container.nodeType !== DOC_NODE_TYPE) ?  false ? invariant(false, 'You\'re trying to render a component to the document using server rendering but the checksum was invalid. This usually means you rendered a different component type or props on the client from the one on the server, or your render() methods are impure. React cannot handle this case due to cross-browser quirks by rendering at the document root. You should look for environment dependent code in your components and ensure the props are the same client and server side:\n%s', difference) : _prodInvariant('42', difference) : void 0;
	
	        if (false) {
	          process.env.NODE_ENV !== 'production' ? warning(false, 'React attempted to reuse markup in a container but the ' + 'checksum was invalid. This generally means that you are ' + 'using server rendering and the markup generated on the ' + 'server was not what the client was expecting. React injected ' + 'new markup to compensate which works but you have lost many ' + 'of the benefits of server rendering. Instead, figure out ' + 'why the markup being generated is different on the client ' + 'or server:\n%s', difference) : void 0;
	        }
	      }
	    }
	
	    !(container.nodeType !== DOC_NODE_TYPE) ?  false ? invariant(false, 'You\'re trying to render a component to the document but you didn\'t use server rendering. We can\'t do this without using server rendering due to cross-browser quirks. See ReactDOMServer.renderToString() for server rendering.') : _prodInvariant('43') : void 0;
	
	    if (transaction.useCreateElement) {
	      while (container.lastChild) {
	        container.removeChild(container.lastChild);
	      }
	      DOMLazyTree.insertTreeBefore(container, markup, null);
	    } else {
	      setInnerHTML(container, markup);
	      ReactDOMComponentTree.precacheNode(instance, container.firstChild);
	    }
	
	    if (false) {
	      var hostNode = ReactDOMComponentTree.getInstanceFromNode(container.firstChild);
	      if (hostNode._debugID !== 0) {
	        ReactInstrumentation.debugTool.onHostOperation(hostNode._debugID, 'mount', markup.toString());
	      }
	    }
	  }
	};
	
	module.exports = ReactMount;

/***/ },
/* 114 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactMultiChildUpdateTypes
	 */
	
	'use strict';
	
	var keyMirror = __webpack_require__(39);
	
	/**
	 * When a component's children are updated, a series of update configuration
	 * objects are created in order to batch and serialize the required changes.
	 *
	 * Enumerates all the possible types of update configurations.
	 *
	 * @internal
	 */
	var ReactMultiChildUpdateTypes = keyMirror({
	  INSERT_MARKUP: null,
	  MOVE_EXISTING: null,
	  REMOVE_NODE: null,
	  SET_MARKUP: null,
	  TEXT_CONTENT: null
	});
	
	module.exports = ReactMultiChildUpdateTypes;

/***/ },
/* 115 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactNodeTypes
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(3);
	
	var ReactElement = __webpack_require__(13);
	
	var invariant = __webpack_require__(2);
	
	var ReactNodeTypes = {
	  HOST: 0,
	  COMPOSITE: 1,
	  EMPTY: 2,
	
	  getType: function (node) {
	    if (node === null || node === false) {
	      return ReactNodeTypes.EMPTY;
	    } else if (ReactElement.isValidElement(node)) {
	      if (typeof node.type === 'function') {
	        return ReactNodeTypes.COMPOSITE;
	      } else {
	        return ReactNodeTypes.HOST;
	      }
	    }
	     true ?  false ? invariant(false, 'Unexpected node: %s', node) : _prodInvariant('26', node) : void 0;
	  }
	};
	
	module.exports = ReactNodeTypes;

/***/ },
/* 116 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactPropTypes
	 */
	
	'use strict';
	
	var ReactElement = __webpack_require__(13);
	var ReactPropTypeLocationNames = __webpack_require__(63);
	var ReactPropTypesSecret = __webpack_require__(65);
	
	var emptyFunction = __webpack_require__(10);
	var getIteratorFn = __webpack_require__(123);
	var warning = __webpack_require__(4);
	
	/**
	 * Collection of methods that allow declaration and validation of props that are
	 * supplied to React components. Example usage:
	 *
	 *   var Props = require('ReactPropTypes');
	 *   var MyArticle = React.createClass({
	 *     propTypes: {
	 *       // An optional string prop named "description".
	 *       description: Props.string,
	 *
	 *       // A required enum prop named "category".
	 *       category: Props.oneOf(['News','Photos']).isRequired,
	 *
	 *       // A prop named "dialog" that requires an instance of Dialog.
	 *       dialog: Props.instanceOf(Dialog).isRequired
	 *     },
	 *     render: function() { ... }
	 *   });
	 *
	 * A more formal specification of how these methods are used:
	 *
	 *   type := array|bool|func|object|number|string|oneOf([...])|instanceOf(...)
	 *   decl := ReactPropTypes.{type}(.isRequired)?
	 *
	 * Each and every declaration produces a function with the same signature. This
	 * allows the creation of custom validation functions. For example:
	 *
	 *  var MyLink = React.createClass({
	 *    propTypes: {
	 *      // An optional string or URI prop named "href".
	 *      href: function(props, propName, componentName) {
	 *        var propValue = props[propName];
	 *        if (propValue != null && typeof propValue !== 'string' &&
	 *            !(propValue instanceof URI)) {
	 *          return new Error(
	 *            'Expected a string or an URI for ' + propName + ' in ' +
	 *            componentName
	 *          );
	 *        }
	 *      }
	 *    },
	 *    render: function() {...}
	 *  });
	 *
	 * @internal
	 */
	
	var ANONYMOUS = '<<anonymous>>';
	
	var ReactPropTypes = {
	  array: createPrimitiveTypeChecker('array'),
	  bool: createPrimitiveTypeChecker('boolean'),
	  func: createPrimitiveTypeChecker('function'),
	  number: createPrimitiveTypeChecker('number'),
	  object: createPrimitiveTypeChecker('object'),
	  string: createPrimitiveTypeChecker('string'),
	  symbol: createPrimitiveTypeChecker('symbol'),
	
	  any: createAnyTypeChecker(),
	  arrayOf: createArrayOfTypeChecker,
	  element: createElementTypeChecker(),
	  instanceOf: createInstanceTypeChecker,
	  node: createNodeChecker(),
	  objectOf: createObjectOfTypeChecker,
	  oneOf: createEnumTypeChecker,
	  oneOfType: createUnionTypeChecker,
	  shape: createShapeTypeChecker
	};
	
	/**
	 * inlined Object.is polyfill to avoid requiring consumers ship their own
	 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
	 */
	/*eslint-disable no-self-compare*/
	function is(x, y) {
	  // SameValue algorithm
	  if (x === y) {
	    // Steps 1-5, 7-10
	    // Steps 6.b-6.e: +0 != -0
	    return x !== 0 || 1 / x === 1 / y;
	  } else {
	    // Step 6.a: NaN == NaN
	    return x !== x && y !== y;
	  }
	}
	/*eslint-enable no-self-compare*/
	
	/**
	 * We use an Error-like object for backward compatibility as people may call
	 * PropTypes directly and inspect their output. However we don't use real
	 * Errors anymore. We don't inspect their stack anyway, and creating them
	 * is prohibitively expensive if they are created too often, such as what
	 * happens in oneOfType() for any type before the one that matched.
	 */
	function PropTypeError(message) {
	  this.message = message;
	  this.stack = '';
	}
	// Make `instanceof Error` still work for returned errors.
	PropTypeError.prototype = Error.prototype;
	
	function createChainableTypeChecker(validate) {
	  if (false) {
	    var manualPropTypeCallCache = {};
	  }
	  function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
	    componentName = componentName || ANONYMOUS;
	    propFullName = propFullName || propName;
	    if (false) {
	      if (secret !== ReactPropTypesSecret && typeof console !== 'undefined') {
	        var cacheKey = componentName + ':' + propName;
	        if (!manualPropTypeCallCache[cacheKey]) {
	          process.env.NODE_ENV !== 'production' ? warning(false, 'You are manually calling a React.PropTypes validation ' + 'function for the `%s` prop on `%s`. This is deprecated ' + 'and will not work in the next major version. You may be ' + 'seeing this warning due to a third-party PropTypes library. ' + 'See https://fb.me/react-warning-dont-call-proptypes for details.', propFullName, componentName) : void 0;
	          manualPropTypeCallCache[cacheKey] = true;
	        }
	      }
	    }
	    if (props[propName] == null) {
	      var locationName = ReactPropTypeLocationNames[location];
	      if (isRequired) {
	        return new PropTypeError('Required ' + locationName + ' `' + propFullName + '` was not specified in ' + ('`' + componentName + '`.'));
	      }
	      return null;
	    } else {
	      return validate(props, propName, componentName, location, propFullName);
	    }
	  }
	
	  var chainedCheckType = checkType.bind(null, false);
	  chainedCheckType.isRequired = checkType.bind(null, true);
	
	  return chainedCheckType;
	}
	
	function createPrimitiveTypeChecker(expectedType) {
	  function validate(props, propName, componentName, location, propFullName, secret) {
	    var propValue = props[propName];
	    var propType = getPropType(propValue);
	    if (propType !== expectedType) {
	      var locationName = ReactPropTypeLocationNames[location];
	      // `propValue` being instance of, say, date/regexp, pass the 'object'
	      // check, but we can offer a more precise error message here rather than
	      // 'of type `object`'.
	      var preciseType = getPreciseType(propValue);
	
	      return new PropTypeError('Invalid ' + locationName + ' `' + propFullName + '` of type ' + ('`' + preciseType + '` supplied to `' + componentName + '`, expected ') + ('`' + expectedType + '`.'));
	    }
	    return null;
	  }
	  return createChainableTypeChecker(validate);
	}
	
	function createAnyTypeChecker() {
	  return createChainableTypeChecker(emptyFunction.thatReturns(null));
	}
	
	function createArrayOfTypeChecker(typeChecker) {
	  function validate(props, propName, componentName, location, propFullName) {
	    if (typeof typeChecker !== 'function') {
	      return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside arrayOf.');
	    }
	    var propValue = props[propName];
	    if (!Array.isArray(propValue)) {
	      var locationName = ReactPropTypeLocationNames[location];
	      var propType = getPropType(propValue);
	      return new PropTypeError('Invalid ' + locationName + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an array.'));
	    }
	    for (var i = 0; i < propValue.length; i++) {
	      var error = typeChecker(propValue, i, componentName, location, propFullName + '[' + i + ']', ReactPropTypesSecret);
	      if (error instanceof Error) {
	        return error;
	      }
	    }
	    return null;
	  }
	  return createChainableTypeChecker(validate);
	}
	
	function createElementTypeChecker() {
	  function validate(props, propName, componentName, location, propFullName) {
	    var propValue = props[propName];
	    if (!ReactElement.isValidElement(propValue)) {
	      var locationName = ReactPropTypeLocationNames[location];
	      var propType = getPropType(propValue);
	      return new PropTypeError('Invalid ' + locationName + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement.'));
	    }
	    return null;
	  }
	  return createChainableTypeChecker(validate);
	}
	
	function createInstanceTypeChecker(expectedClass) {
	  function validate(props, propName, componentName, location, propFullName) {
	    if (!(props[propName] instanceof expectedClass)) {
	      var locationName = ReactPropTypeLocationNames[location];
	      var expectedClassName = expectedClass.name || ANONYMOUS;
	      var actualClassName = getClassName(props[propName]);
	      return new PropTypeError('Invalid ' + locationName + ' `' + propFullName + '` of type ' + ('`' + actualClassName + '` supplied to `' + componentName + '`, expected ') + ('instance of `' + expectedClassName + '`.'));
	    }
	    return null;
	  }
	  return createChainableTypeChecker(validate);
	}
	
	function createEnumTypeChecker(expectedValues) {
	  if (!Array.isArray(expectedValues)) {
	     false ? warning(false, 'Invalid argument supplied to oneOf, expected an instance of array.') : void 0;
	    return emptyFunction.thatReturnsNull;
	  }
	
	  function validate(props, propName, componentName, location, propFullName) {
	    var propValue = props[propName];
	    for (var i = 0; i < expectedValues.length; i++) {
	      if (is(propValue, expectedValues[i])) {
	        return null;
	      }
	    }
	
	    var locationName = ReactPropTypeLocationNames[location];
	    var valuesString = JSON.stringify(expectedValues);
	    return new PropTypeError('Invalid ' + locationName + ' `' + propFullName + '` of value `' + propValue + '` ' + ('supplied to `' + componentName + '`, expected one of ' + valuesString + '.'));
	  }
	  return createChainableTypeChecker(validate);
	}
	
	function createObjectOfTypeChecker(typeChecker) {
	  function validate(props, propName, componentName, location, propFullName) {
	    if (typeof typeChecker !== 'function') {
	      return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside objectOf.');
	    }
	    var propValue = props[propName];
	    var propType = getPropType(propValue);
	    if (propType !== 'object') {
	      var locationName = ReactPropTypeLocationNames[location];
	      return new PropTypeError('Invalid ' + locationName + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an object.'));
	    }
	    for (var key in propValue) {
	      if (propValue.hasOwnProperty(key)) {
	        var error = typeChecker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
	        if (error instanceof Error) {
	          return error;
	        }
	      }
	    }
	    return null;
	  }
	  return createChainableTypeChecker(validate);
	}
	
	function createUnionTypeChecker(arrayOfTypeCheckers) {
	  if (!Array.isArray(arrayOfTypeCheckers)) {
	     false ? warning(false, 'Invalid argument supplied to oneOfType, expected an instance of array.') : void 0;
	    return emptyFunction.thatReturnsNull;
	  }
	
	  function validate(props, propName, componentName, location, propFullName) {
	    for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
	      var checker = arrayOfTypeCheckers[i];
	      if (checker(props, propName, componentName, location, propFullName, ReactPropTypesSecret) == null) {
	        return null;
	      }
	    }
	
	    var locationName = ReactPropTypeLocationNames[location];
	    return new PropTypeError('Invalid ' + locationName + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`.'));
	  }
	  return createChainableTypeChecker(validate);
	}
	
	function createNodeChecker() {
	  function validate(props, propName, componentName, location, propFullName) {
	    if (!isNode(props[propName])) {
	      var locationName = ReactPropTypeLocationNames[location];
	      return new PropTypeError('Invalid ' + locationName + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`, expected a ReactNode.'));
	    }
	    return null;
	  }
	  return createChainableTypeChecker(validate);
	}
	
	function createShapeTypeChecker(shapeTypes) {
	  function validate(props, propName, componentName, location, propFullName) {
	    var propValue = props[propName];
	    var propType = getPropType(propValue);
	    if (propType !== 'object') {
	      var locationName = ReactPropTypeLocationNames[location];
	      return new PropTypeError('Invalid ' + locationName + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
	    }
	    for (var key in shapeTypes) {
	      var checker = shapeTypes[key];
	      if (!checker) {
	        continue;
	      }
	      var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
	      if (error) {
	        return error;
	      }
	    }
	    return null;
	  }
	  return createChainableTypeChecker(validate);
	}
	
	function isNode(propValue) {
	  switch (typeof propValue) {
	    case 'number':
	    case 'string':
	    case 'undefined':
	      return true;
	    case 'boolean':
	      return !propValue;
	    case 'object':
	      if (Array.isArray(propValue)) {
	        return propValue.every(isNode);
	      }
	      if (propValue === null || ReactElement.isValidElement(propValue)) {
	        return true;
	      }
	
	      var iteratorFn = getIteratorFn(propValue);
	      if (iteratorFn) {
	        var iterator = iteratorFn.call(propValue);
	        var step;
	        if (iteratorFn !== propValue.entries) {
	          while (!(step = iterator.next()).done) {
	            if (!isNode(step.value)) {
	              return false;
	            }
	          }
	        } else {
	          // Iterator will provide entry [k,v] tuples rather than values.
	          while (!(step = iterator.next()).done) {
	            var entry = step.value;
	            if (entry) {
	              if (!isNode(entry[1])) {
	                return false;
	              }
	            }
	          }
	        }
	      } else {
	        return false;
	      }
	
	      return true;
	    default:
	      return false;
	  }
	}
	
	function isSymbol(propType, propValue) {
	  // Native Symbol.
	  if (propType === 'symbol') {
	    return true;
	  }
	
	  // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'
	  if (propValue['@@toStringTag'] === 'Symbol') {
	    return true;
	  }
	
	  // Fallback for non-spec compliant Symbols which are polyfilled.
	  if (typeof Symbol === 'function' && propValue instanceof Symbol) {
	    return true;
	  }
	
	  return false;
	}
	
	// Equivalent of `typeof` but with special handling for array and regexp.
	function getPropType(propValue) {
	  var propType = typeof propValue;
	  if (Array.isArray(propValue)) {
	    return 'array';
	  }
	  if (propValue instanceof RegExp) {
	    // Old webkits (at least until Android 4.0) return 'function' rather than
	    // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
	    // passes PropTypes.object.
	    return 'object';
	  }
	  if (isSymbol(propType, propValue)) {
	    return 'symbol';
	  }
	  return propType;
	}
	
	// This handles more types than `getPropType`. Only used for error messages.
	// See `createPrimitiveTypeChecker`.
	function getPreciseType(propValue) {
	  var propType = getPropType(propValue);
	  if (propType === 'object') {
	    if (propValue instanceof Date) {
	      return 'date';
	    } else if (propValue instanceof RegExp) {
	      return 'regexp';
	    }
	  }
	  return propType;
	}
	
	// Returns class name of the object, if any.
	function getClassName(propValue) {
	  if (!propValue.constructor || !propValue.constructor.name) {
	    return ANONYMOUS;
	  }
	  return propValue.constructor.name;
	}
	
	module.exports = ReactPropTypes;

/***/ },
/* 117 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactVersion
	 */
	
	'use strict';
	
	module.exports = '15.3.1';

/***/ },
/* 118 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ViewportMetrics
	 */
	
	'use strict';
	
	var ViewportMetrics = {
	
	  currentScrollLeft: 0,
	
	  currentScrollTop: 0,
	
	  refreshScrollValues: function (scrollPosition) {
	    ViewportMetrics.currentScrollLeft = scrollPosition.x;
	    ViewportMetrics.currentScrollTop = scrollPosition.y;
	  }
	
	};
	
	module.exports = ViewportMetrics;

/***/ },
/* 119 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule accumulateInto
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(3);
	
	var invariant = __webpack_require__(2);
	
	/**
	 * Accumulates items that must not be null or undefined into the first one. This
	 * is used to conserve memory by avoiding array allocations, and thus sacrifices
	 * API cleanness. Since `current` can be null before being passed in and not
	 * null after this function, make sure to assign it back to `current`:
	 *
	 * `a = accumulateInto(a, b);`
	 *
	 * This API should be sparingly used. Try `accumulate` for something cleaner.
	 *
	 * @return {*|array<*>} An accumulation of items.
	 */
	
	function accumulateInto(current, next) {
	  !(next != null) ?  false ? invariant(false, 'accumulateInto(...): Accumulated items must not be null or undefined.') : _prodInvariant('30') : void 0;
	
	  if (current == null) {
	    return next;
	  }
	
	  // Both are not empty. Warning: Never call x.concat(y) when you are not
	  // certain that x is an Array (x could be a string with concat method).
	  if (Array.isArray(current)) {
	    if (Array.isArray(next)) {
	      current.push.apply(current, next);
	      return current;
	    }
	    current.push(next);
	    return current;
	  }
	
	  if (Array.isArray(next)) {
	    // A bit too dangerous to mutate `next`.
	    return [current].concat(next);
	  }
	
	  return [current, next];
	}
	
	module.exports = accumulateInto;

/***/ },
/* 120 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule canDefineProperty
	 */
	
	'use strict';
	
	var canDefineProperty = false;
	if (false) {
	  try {
	    Object.defineProperty({}, 'x', { get: function () {} });
	    canDefineProperty = true;
	  } catch (x) {
	    // IE will fail on defineProperty
	  }
	}
	
	module.exports = canDefineProperty;

/***/ },
/* 121 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule forEachAccumulated
	 * 
	 */
	
	'use strict';
	
	/**
	 * @param {array} arr an "accumulation" of items which is either an Array or
	 * a single item. Useful when paired with the `accumulate` module. This is a
	 * simple utility that allows us to reason about a collection of items, but
	 * handling the case when there is exactly one item (and we do not need to
	 * allocate an array).
	 */
	
	function forEachAccumulated(arr, cb, scope) {
	  if (Array.isArray(arr)) {
	    arr.forEach(cb, scope);
	  } else if (arr) {
	    cb.call(scope, arr);
	  }
	}
	
	module.exports = forEachAccumulated;

/***/ },
/* 122 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule getHostComponentFromComposite
	 */
	
	'use strict';
	
	var ReactNodeTypes = __webpack_require__(115);
	
	function getHostComponentFromComposite(inst) {
	  var type;
	
	  while ((type = inst._renderedNodeType) === ReactNodeTypes.COMPOSITE) {
	    inst = inst._renderedComponent;
	  }
	
	  if (type === ReactNodeTypes.HOST) {
	    return inst._renderedComponent;
	  } else if (type === ReactNodeTypes.EMPTY) {
	    return null;
	  }
	}
	
	module.exports = getHostComponentFromComposite;

/***/ },
/* 123 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule getIteratorFn
	 * 
	 */
	
	'use strict';
	
	/* global Symbol */
	
	var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
	var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.
	
	/**
	 * Returns the iterator method function contained on the iterable object.
	 *
	 * Be sure to invoke the function with the iterable as context:
	 *
	 *     var iteratorFn = getIteratorFn(myIterable);
	 *     if (iteratorFn) {
	 *       var iterator = iteratorFn.call(myIterable);
	 *       ...
	 *     }
	 *
	 * @param {?object} maybeIterable
	 * @return {?function}
	 */
	function getIteratorFn(maybeIterable) {
	  var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
	  if (typeof iteratorFn === 'function') {
	    return iteratorFn;
	  }
	}
	
	module.exports = getIteratorFn;

/***/ },
/* 124 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule getTextContentAccessor
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(9);
	
	var contentKey = null;
	
	/**
	 * Gets the key used to access text content on a DOM node.
	 *
	 * @return {?string} Key used to access text content.
	 * @internal
	 */
	function getTextContentAccessor() {
	  if (!contentKey && ExecutionEnvironment.canUseDOM) {
	    // Prefer textContent to innerText because many browsers support both but
	    // SVG <text> elements don't support innerText even when <div> does.
	    contentKey = 'textContent' in document.documentElement ? 'textContent' : 'innerText';
	  }
	  return contentKey;
	}
	
	module.exports = getTextContentAccessor;

/***/ },
/* 125 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule instantiateReactComponent
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(3),
	    _assign = __webpack_require__(6);
	
	var ReactCompositeComponent = __webpack_require__(317);
	var ReactEmptyComponent = __webpack_require__(109);
	var ReactHostComponent = __webpack_require__(111);
	
	var invariant = __webpack_require__(2);
	var warning = __webpack_require__(4);
	
	// To avoid a cyclic dependency, we create the final class in this module
	var ReactCompositeComponentWrapper = function (element) {
	  this.construct(element);
	};
	_assign(ReactCompositeComponentWrapper.prototype, ReactCompositeComponent.Mixin, {
	  _instantiateReactComponent: instantiateReactComponent
	});
	
	function getDeclarationErrorAddendum(owner) {
	  if (owner) {
	    var name = owner.getName();
	    if (name) {
	      return ' Check the render method of `' + name + '`.';
	    }
	  }
	  return '';
	}
	
	/**
	 * Check if the type reference is a known internal type. I.e. not a user
	 * provided composite type.
	 *
	 * @param {function} type
	 * @return {boolean} Returns true if this is a valid internal type.
	 */
	function isInternalComponentType(type) {
	  return typeof type === 'function' && typeof type.prototype !== 'undefined' && typeof type.prototype.mountComponent === 'function' && typeof type.prototype.receiveComponent === 'function';
	}
	
	var nextDebugID = 1;
	
	/**
	 * Given a ReactNode, create an instance that will actually be mounted.
	 *
	 * @param {ReactNode} node
	 * @param {boolean} shouldHaveDebugID
	 * @return {object} A new instance of the element's constructor.
	 * @protected
	 */
	function instantiateReactComponent(node, shouldHaveDebugID) {
	  var instance;
	
	  if (node === null || node === false) {
	    instance = ReactEmptyComponent.create(instantiateReactComponent);
	  } else if (typeof node === 'object') {
	    var element = node;
	    !(element && (typeof element.type === 'function' || typeof element.type === 'string')) ?  false ? invariant(false, 'Element type is invalid: expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s', element.type == null ? element.type : typeof element.type, getDeclarationErrorAddendum(element._owner)) : _prodInvariant('130', element.type == null ? element.type : typeof element.type, getDeclarationErrorAddendum(element._owner)) : void 0;
	
	    // Special case string values
	    if (typeof element.type === 'string') {
	      instance = ReactHostComponent.createInternalComponent(element);
	    } else if (isInternalComponentType(element.type)) {
	      // This is temporarily available for custom components that are not string
	      // representations. I.e. ART. Once those are updated to use the string
	      // representation, we can drop this code path.
	      instance = new element.type(element);
	
	      // We renamed this. Allow the old name for compat. :(
	      if (!instance.getHostNode) {
	        instance.getHostNode = instance.getNativeNode;
	      }
	    } else {
	      instance = new ReactCompositeComponentWrapper(element);
	    }
	  } else if (typeof node === 'string' || typeof node === 'number') {
	    instance = ReactHostComponent.createInstanceForText(node);
	  } else {
	     true ?  false ? invariant(false, 'Encountered invalid React node of type %s', typeof node) : _prodInvariant('131', typeof node) : void 0;
	  }
	
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(typeof instance.mountComponent === 'function' && typeof instance.receiveComponent === 'function' && typeof instance.getHostNode === 'function' && typeof instance.unmountComponent === 'function', 'Only React Components can be mounted.') : void 0;
	  }
	
	  // These two fields are used by the DOM and ART diffing algorithms
	  // respectively. Instead of using expandos on components, we should be
	  // storing the state needed by the diffing algorithms elsewhere.
	  instance._mountIndex = 0;
	  instance._mountImage = null;
	
	  if (false) {
	    instance._debugID = shouldHaveDebugID ? nextDebugID++ : 0;
	  }
	
	  // Internal instances should fully constructed at this point, so they should
	  // not get any new fields added to them at this point.
	  if (false) {
	    if (Object.preventExtensions) {
	      Object.preventExtensions(instance);
	    }
	  }
	
	  return instance;
	}
	
	module.exports = instantiateReactComponent;

/***/ },
/* 126 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule isTextInputElement
	 * 
	 */
	
	'use strict';
	
	/**
	 * @see http://www.whatwg.org/specs/web-apps/current-work/multipage/the-input-element.html#input-type-attr-summary
	 */
	
	var supportedInputTypes = {
	  'color': true,
	  'date': true,
	  'datetime': true,
	  'datetime-local': true,
	  'email': true,
	  'month': true,
	  'number': true,
	  'password': true,
	  'range': true,
	  'search': true,
	  'tel': true,
	  'text': true,
	  'time': true,
	  'url': true,
	  'week': true
	};
	
	function isTextInputElement(elem) {
	  var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
	
	  if (nodeName === 'input') {
	    return !!supportedInputTypes[elem.type];
	  }
	
	  if (nodeName === 'textarea') {
	    return true;
	  }
	
	  return false;
	}
	
	module.exports = isTextInputElement;

/***/ },
/* 127 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule setTextContent
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(9);
	var escapeTextContentForBrowser = __webpack_require__(45);
	var setInnerHTML = __webpack_require__(46);
	
	/**
	 * Set the textContent property of a node, ensuring that whitespace is preserved
	 * even in IE8. innerText is a poor substitute for textContent and, among many
	 * issues, inserts <br> instead of the literal newline chars. innerHTML behaves
	 * as it should.
	 *
	 * @param {DOMElement} node
	 * @param {string} text
	 * @internal
	 */
	var setTextContent = function (node, text) {
	  if (text) {
	    var firstChild = node.firstChild;
	
	    if (firstChild && firstChild === node.lastChild && firstChild.nodeType === 3) {
	      firstChild.nodeValue = text;
	      return;
	    }
	  }
	  node.textContent = text;
	};
	
	if (ExecutionEnvironment.canUseDOM) {
	  if (!('textContent' in document.documentElement)) {
	    setTextContent = function (node, text) {
	      setInnerHTML(node, escapeTextContentForBrowser(text));
	    };
	  }
	}
	
	module.exports = setTextContent;

/***/ },
/* 128 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = compose;
	/**
	 * Composes single-argument functions from right to left. The rightmost
	 * function can take multiple arguments as it provides the signature for
	 * the resulting composite function.
	 *
	 * @param {...Function} funcs The functions to compose.
	 * @returns {Function} A function obtained by composing the argument functions
	 * from right to left. For example, compose(f, g, h) is identical to doing
	 * (...args) => f(g(h(...args))).
	 */
	
	function compose() {
	  for (var _len = arguments.length, funcs = Array(_len), _key = 0; _key < _len; _key++) {
	    funcs[_key] = arguments[_key];
	  }
	
	  if (funcs.length === 0) {
	    return function (arg) {
	      return arg;
	    };
	  }
	
	  if (funcs.length === 1) {
	    return funcs[0];
	  }
	
	  var last = funcs[funcs.length - 1];
	  var rest = funcs.slice(0, -1);
	  return function () {
	    return rest.reduceRight(function (composed, f) {
	      return f(composed);
	    }, last.apply(undefined, arguments));
	  };
	}

/***/ },
/* 129 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.ActionTypes = undefined;
	exports['default'] = createStore;
	
	var _isPlainObject = __webpack_require__(48);
	
	var _isPlainObject2 = _interopRequireDefault(_isPlainObject);
	
	var _symbolObservable = __webpack_require__(373);
	
	var _symbolObservable2 = _interopRequireDefault(_symbolObservable);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	/**
	 * These are private action types reserved by Redux.
	 * For any unknown actions, you must return the current state.
	 * If the current state is undefined, you must return the initial state.
	 * Do not reference these action types directly in your code.
	 */
	var ActionTypes = exports.ActionTypes = {
	  INIT: '@@redux/INIT'
	};
	
	/**
	 * Creates a Redux store that holds the state tree.
	 * The only way to change the data in the store is to call `dispatch()` on it.
	 *
	 * There should only be a single store in your app. To specify how different
	 * parts of the state tree respond to actions, you may combine several reducers
	 * into a single reducer function by using `combineReducers`.
	 *
	 * @param {Function} reducer A function that returns the next state tree, given
	 * the current state tree and the action to handle.
	 *
	 * @param {any} [preloadedState] The initial state. You may optionally specify it
	 * to hydrate the state from the server in universal apps, or to restore a
	 * previously serialized user session.
	 * If you use `combineReducers` to produce the root reducer function, this must be
	 * an object with the same shape as `combineReducers` keys.
	 *
	 * @param {Function} enhancer The store enhancer. You may optionally specify it
	 * to enhance the store with third-party capabilities such as middleware,
	 * time travel, persistence, etc. The only store enhancer that ships with Redux
	 * is `applyMiddleware()`.
	 *
	 * @returns {Store} A Redux store that lets you read the state, dispatch actions
	 * and subscribe to changes.
	 */
	function createStore(reducer, preloadedState, enhancer) {
	  var _ref2;
	
	  if (typeof preloadedState === 'function' && typeof enhancer === 'undefined') {
	    enhancer = preloadedState;
	    preloadedState = undefined;
	  }
	
	  if (typeof enhancer !== 'undefined') {
	    if (typeof enhancer !== 'function') {
	      throw new Error('Expected the enhancer to be a function.');
	    }
	
	    return enhancer(createStore)(reducer, preloadedState);
	  }
	
	  if (typeof reducer !== 'function') {
	    throw new Error('Expected the reducer to be a function.');
	  }
	
	  var currentReducer = reducer;
	  var currentState = preloadedState;
	  var currentListeners = [];
	  var nextListeners = currentListeners;
	  var isDispatching = false;
	
	  function ensureCanMutateNextListeners() {
	    if (nextListeners === currentListeners) {
	      nextListeners = currentListeners.slice();
	    }
	  }
	
	  /**
	   * Reads the state tree managed by the store.
	   *
	   * @returns {any} The current state tree of your application.
	   */
	  function getState() {
	    return currentState;
	  }
	
	  /**
	   * Adds a change listener. It will be called any time an action is dispatched,
	   * and some part of the state tree may potentially have changed. You may then
	   * call `getState()` to read the current state tree inside the callback.
	   *
	   * You may call `dispatch()` from a change listener, with the following
	   * caveats:
	   *
	   * 1. The subscriptions are snapshotted just before every `dispatch()` call.
	   * If you subscribe or unsubscribe while the listeners are being invoked, this
	   * will not have any effect on the `dispatch()` that is currently in progress.
	   * However, the next `dispatch()` call, whether nested or not, will use a more
	   * recent snapshot of the subscription list.
	   *
	   * 2. The listener should not expect to see all state changes, as the state
	   * might have been updated multiple times during a nested `dispatch()` before
	   * the listener is called. It is, however, guaranteed that all subscribers
	   * registered before the `dispatch()` started will be called with the latest
	   * state by the time it exits.
	   *
	   * @param {Function} listener A callback to be invoked on every dispatch.
	   * @returns {Function} A function to remove this change listener.
	   */
	  function subscribe(listener) {
	    if (typeof listener !== 'function') {
	      throw new Error('Expected listener to be a function.');
	    }
	
	    var isSubscribed = true;
	
	    ensureCanMutateNextListeners();
	    nextListeners.push(listener);
	
	    return function unsubscribe() {
	      if (!isSubscribed) {
	        return;
	      }
	
	      isSubscribed = false;
	
	      ensureCanMutateNextListeners();
	      var index = nextListeners.indexOf(listener);
	      nextListeners.splice(index, 1);
	    };
	  }
	
	  /**
	   * Dispatches an action. It is the only way to trigger a state change.
	   *
	   * The `reducer` function, used to create the store, will be called with the
	   * current state tree and the given `action`. Its return value will
	   * be considered the **next** state of the tree, and the change listeners
	   * will be notified.
	   *
	   * The base implementation only supports plain object actions. If you want to
	   * dispatch a Promise, an Observable, a thunk, or something else, you need to
	   * wrap your store creating function into the corresponding middleware. For
	   * example, see the documentation for the `redux-thunk` package. Even the
	   * middleware will eventually dispatch plain object actions using this method.
	   *
	   * @param {Object} action A plain object representing “what changed”. It is
	   * a good idea to keep actions serializable so you can record and replay user
	   * sessions, or use the time travelling `redux-devtools`. An action must have
	   * a `type` property which may not be `undefined`. It is a good idea to use
	   * string constants for action types.
	   *
	   * @returns {Object} For convenience, the same action object you dispatched.
	   *
	   * Note that, if you use a custom middleware, it may wrap `dispatch()` to
	   * return something else (for example, a Promise you can await).
	   */
	  function dispatch(action) {
	    if (!(0, _isPlainObject2['default'])(action)) {
	      throw new Error('Actions must be plain objects. ' + 'Use custom middleware for async actions.');
	    }
	
	    if (typeof action.type === 'undefined') {
	      throw new Error('Actions may not have an undefined "type" property. ' + 'Have you misspelled a constant?');
	    }
	
	    if (isDispatching) {
	      throw new Error('Reducers may not dispatch actions.');
	    }
	
	    try {
	      isDispatching = true;
	      currentState = currentReducer(currentState, action);
	    } finally {
	      isDispatching = false;
	    }
	
	    var listeners = currentListeners = nextListeners;
	    for (var i = 0; i < listeners.length; i++) {
	      listeners[i]();
	    }
	
	    return action;
	  }
	
	  /**
	   * Replaces the reducer currently used by the store to calculate the state.
	   *
	   * You might need this if your app implements code splitting and you want to
	   * load some of the reducers dynamically. You might also need this if you
	   * implement a hot reloading mechanism for Redux.
	   *
	   * @param {Function} nextReducer The reducer for the store to use instead.
	   * @returns {void}
	   */
	  function replaceReducer(nextReducer) {
	    if (typeof nextReducer !== 'function') {
	      throw new Error('Expected the nextReducer to be a function.');
	    }
	
	    currentReducer = nextReducer;
	    dispatch({ type: ActionTypes.INIT });
	  }
	
	  /**
	   * Interoperability point for observable/reactive libraries.
	   * @returns {observable} A minimal observable of state changes.
	   * For more information, see the observable proposal:
	   * https://github.com/zenparsing/es-observable
	   */
	  function observable() {
	    var _ref;
	
	    var outerSubscribe = subscribe;
	    return _ref = {
	      /**
	       * The minimal observable subscription method.
	       * @param {Object} observer Any object that can be used as an observer.
	       * The observer object should have a `next` method.
	       * @returns {subscription} An object with an `unsubscribe` method that can
	       * be used to unsubscribe the observable from the store, and prevent further
	       * emission of values from the observable.
	       */
	      subscribe: function subscribe(observer) {
	        if (typeof observer !== 'object') {
	          throw new TypeError('Expected the observer to be an object.');
	        }
	
	        function observeState() {
	          if (observer.next) {
	            observer.next(getState());
	          }
	        }
	
	        observeState();
	        var unsubscribe = outerSubscribe(observeState);
	        return { unsubscribe: unsubscribe };
	      }
	    }, _ref[_symbolObservable2['default']] = function () {
	      return this;
	    }, _ref;
	  }
	
	  // When a store is created, an "INIT" action is dispatched so that every
	  // reducer returns their initial state. This effectively populates
	  // the initial state tree.
	  dispatch({ type: ActionTypes.INIT });
	
	  return _ref2 = {
	    dispatch: dispatch,
	    subscribe: subscribe,
	    getState: getState,
	    replaceReducer: replaceReducer
	  }, _ref2[_symbolObservable2['default']] = observable, _ref2;
	}

/***/ },
/* 130 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports['default'] = warning;
	/**
	 * Prints a warning in the console if it exists.
	 *
	 * @param {String} message The warning message.
	 * @returns {void}
	 */
	function warning(message) {
	  /* eslint-disable no-console */
	  if (typeof console !== 'undefined' && typeof console.error === 'function') {
	    console.error(message);
	  }
	  /* eslint-enable no-console */
	  try {
	    // This error was thrown as a convenience so that if you enable
	    // "break on all exceptions" in your console,
	    // it would pause the execution at this line.
	    throw new Error(message);
	    /* eslint-disable no-empty */
	  } catch (e) {}
	  /* eslint-enable no-empty */
	}

/***/ },
/* 131 */
/***/ function(module, exports) {

	/**
	 * @ignore
	 * base event object for custom and dom event.
	 * @author yiminghe@gmail.com
	 */
	
	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	function returnFalse() {
	  return false;
	}
	
	function returnTrue() {
	  return true;
	}
	
	function EventBaseObject() {
	  this.timeStamp = Date.now();
	  this.target = undefined;
	  this.currentTarget = undefined;
	}
	
	EventBaseObject.prototype = {
	  isEventObject: 1,
	
	  constructor: EventBaseObject,
	
	  isDefaultPrevented: returnFalse,
	
	  isPropagationStopped: returnFalse,
	
	  isImmediatePropagationStopped: returnFalse,
	
	  preventDefault: function preventDefault() {
	    this.isDefaultPrevented = returnTrue;
	  },
	
	  stopPropagation: function stopPropagation() {
	    this.isPropagationStopped = returnTrue;
	  },
	
	  stopImmediatePropagation: function stopImmediatePropagation() {
	    this.isImmediatePropagationStopped = returnTrue;
	    // fixed 1.2
	    // call stopPropagation implicitly
	    this.stopPropagation();
	  },
	
	  halt: function halt(immediate) {
	    if (immediate) {
	      this.stopImmediatePropagation();
	    } else {
	      this.stopPropagation();
	    }
	    this.preventDefault();
	  }
	};
	
	exports["default"] = EventBaseObject;
	module.exports = exports["default"];

/***/ },
/* 132 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * @ignore
	 * event object for dom
	 * @author yiminghe@gmail.com
	 */
	
	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _EventBaseObject = __webpack_require__(131);
	
	var _EventBaseObject2 = _interopRequireDefault(_EventBaseObject);
	
	var _objectAssign = __webpack_require__(6);
	
	var _objectAssign2 = _interopRequireDefault(_objectAssign);
	
	var TRUE = true;
	var FALSE = false;
	var commonProps = ['altKey', 'bubbles', 'cancelable', 'ctrlKey', 'currentTarget', 'eventPhase', 'metaKey', 'shiftKey', 'target', 'timeStamp', 'view', 'type'];
	
	function isNullOrUndefined(w) {
	  return w === null || w === undefined;
	}
	
	var eventNormalizers = [{
	  reg: /^key/,
	  props: ['char', 'charCode', 'key', 'keyCode', 'which'],
	  fix: function fix(event, nativeEvent) {
	    if (isNullOrUndefined(event.which)) {
	      event.which = !isNullOrUndefined(nativeEvent.charCode) ? nativeEvent.charCode : nativeEvent.keyCode;
	    }
	
	    // add metaKey to non-Mac browsers (use ctrl for PC 's and Meta for Macs)
	    if (event.metaKey === undefined) {
	      event.metaKey = event.ctrlKey;
	    }
	  }
	}, {
	  reg: /^touch/,
	  props: ['touches', 'changedTouches', 'targetTouches']
	}, {
	  reg: /^hashchange$/,
	  props: ['newURL', 'oldURL']
	}, {
	  reg: /^gesturechange$/i,
	  props: ['rotation', 'scale']
	}, {
	  reg: /^(mousewheel|DOMMouseScroll)$/,
	  props: [],
	  fix: function fix(event, nativeEvent) {
	    var deltaX = undefined;
	    var deltaY = undefined;
	    var delta = undefined;
	    var wheelDelta = nativeEvent.wheelDelta;
	    var axis = nativeEvent.axis;
	    var wheelDeltaY = nativeEvent.wheelDeltaY;
	    var wheelDeltaX = nativeEvent.wheelDeltaX;
	    var detail = nativeEvent.detail;
	
	    // ie/webkit
	    if (wheelDelta) {
	      delta = wheelDelta / 120;
	    }
	
	    // gecko
	    if (detail) {
	      // press control e.detail == 1 else e.detail == 3
	      delta = 0 - (detail % 3 === 0 ? detail / 3 : detail);
	    }
	
	    // Gecko
	    if (axis !== undefined) {
	      if (axis === event.HORIZONTAL_AXIS) {
	        deltaY = 0;
	        deltaX = 0 - delta;
	      } else if (axis === event.VERTICAL_AXIS) {
	        deltaX = 0;
	        deltaY = delta;
	      }
	    }
	
	    // Webkit
	    if (wheelDeltaY !== undefined) {
	      deltaY = wheelDeltaY / 120;
	    }
	    if (wheelDeltaX !== undefined) {
	      deltaX = -1 * wheelDeltaX / 120;
	    }
	
	    // 默认 deltaY (ie)
	    if (!deltaX && !deltaY) {
	      deltaY = delta;
	    }
	
	    if (deltaX !== undefined) {
	      /**
	       * deltaX of mousewheel event
	       * @property deltaX
	       * @member Event.DomEvent.Object
	       */
	      event.deltaX = deltaX;
	    }
	
	    if (deltaY !== undefined) {
	      /**
	       * deltaY of mousewheel event
	       * @property deltaY
	       * @member Event.DomEvent.Object
	       */
	      event.deltaY = deltaY;
	    }
	
	    if (delta !== undefined) {
	      /**
	       * delta of mousewheel event
	       * @property delta
	       * @member Event.DomEvent.Object
	       */
	      event.delta = delta;
	    }
	  }
	}, {
	  reg: /^mouse|contextmenu|click|mspointer|(^DOMMouseScroll$)/i,
	  props: ['buttons', 'clientX', 'clientY', 'button', 'offsetX', 'relatedTarget', 'which', 'fromElement', 'toElement', 'offsetY', 'pageX', 'pageY', 'screenX', 'screenY'],
	  fix: function fix(event, nativeEvent) {
	    var eventDoc = undefined;
	    var doc = undefined;
	    var body = undefined;
	    var target = event.target;
	    var button = nativeEvent.button;
	
	    // Calculate pageX/Y if missing and clientX/Y available
	    if (target && isNullOrUndefined(event.pageX) && !isNullOrUndefined(nativeEvent.clientX)) {
	      eventDoc = target.ownerDocument || document;
	      doc = eventDoc.documentElement;
	      body = eventDoc.body;
	      event.pageX = nativeEvent.clientX + (doc && doc.scrollLeft || body && body.scrollLeft || 0) - (doc && doc.clientLeft || body && body.clientLeft || 0);
	      event.pageY = nativeEvent.clientY + (doc && doc.scrollTop || body && body.scrollTop || 0) - (doc && doc.clientTop || body && body.clientTop || 0);
	    }
	
	    // which for click: 1 === left; 2 === middle; 3 === right
	    // do not use button
	    if (!event.which && button !== undefined) {
	      if (button & 1) {
	        event.which = 1;
	      } else if (button & 2) {
	        event.which = 3;
	      } else if (button & 4) {
	        event.which = 2;
	      } else {
	        event.which = 0;
	      }
	    }
	
	    // add relatedTarget, if necessary
	    if (!event.relatedTarget && event.fromElement) {
	      event.relatedTarget = event.fromElement === target ? event.toElement : event.fromElement;
	    }
	
	    return event;
	  }
	}];
	
	function retTrue() {
	  return TRUE;
	}
	
	function retFalse() {
	  return FALSE;
	}
	
	function DomEventObject(nativeEvent) {
	  var type = nativeEvent.type;
	
	  var isNative = typeof nativeEvent.stopPropagation === 'function' || typeof nativeEvent.cancelBubble === 'boolean';
	
	  _EventBaseObject2['default'].call(this);
	
	  this.nativeEvent = nativeEvent;
	
	  // in case dom event has been mark as default prevented by lower dom node
	  var isDefaultPrevented = retFalse;
	  if ('defaultPrevented' in nativeEvent) {
	    isDefaultPrevented = nativeEvent.defaultPrevented ? retTrue : retFalse;
	  } else if ('getPreventDefault' in nativeEvent) {
	    // https://bugzilla.mozilla.org/show_bug.cgi?id=691151
	    isDefaultPrevented = nativeEvent.getPreventDefault() ? retTrue : retFalse;
	  } else if ('returnValue' in nativeEvent) {
	    isDefaultPrevented = nativeEvent.returnValue === FALSE ? retTrue : retFalse;
	  }
	
	  this.isDefaultPrevented = isDefaultPrevented;
	
	  var fixFns = [];
	  var fixFn = undefined;
	  var l = undefined;
	  var prop = undefined;
	  var props = commonProps.concat();
	
	  eventNormalizers.forEach(function (normalizer) {
	    if (type.match(normalizer.reg)) {
	      props = props.concat(normalizer.props);
	      if (normalizer.fix) {
	        fixFns.push(normalizer.fix);
	      }
	    }
	  });
	
	  l = props.length;
	
	  // clone properties of the original event object
	  while (l) {
	    prop = props[--l];
	    this[prop] = nativeEvent[prop];
	  }
	
	  // fix target property, if necessary
	  if (!this.target && isNative) {
	    this.target = nativeEvent.srcElement || document; // srcElement might not be defined either
	  }
	
	  // check if target is a text node (safari)
	  if (this.target && this.target.nodeType === 3) {
	    this.target = this.target.parentNode;
	  }
	
	  l = fixFns.length;
	
	  while (l) {
	    fixFn = fixFns[--l];
	    fixFn(this, nativeEvent);
	  }
	
	  this.timeStamp = nativeEvent.timeStamp || Date.now();
	}
	
	var EventBaseObjectProto = _EventBaseObject2['default'].prototype;
	
	(0, _objectAssign2['default'])(DomEventObject.prototype, EventBaseObjectProto, {
	  constructor: DomEventObject,
	
	  preventDefault: function preventDefault() {
	    var e = this.nativeEvent;
	
	    // if preventDefault exists run it on the original event
	    if (e.preventDefault) {
	      e.preventDefault();
	    } else {
	      // otherwise set the returnValue property of the original event to FALSE (IE)
	      e.returnValue = FALSE;
	    }
	
	    EventBaseObjectProto.preventDefault.call(this);
	  },
	
	  stopPropagation: function stopPropagation() {
	    var e = this.nativeEvent;
	
	    // if stopPropagation exists run it on the original event
	    if (e.stopPropagation) {
	      e.stopPropagation();
	    } else {
	      // otherwise set the cancelBubble property of the original event to TRUE (IE)
	      e.cancelBubble = TRUE;
	    }
	
	    EventBaseObjectProto.stopPropagation.call(this);
	  }
	});
	
	exports['default'] = DomEventObject;
	module.exports = exports['default'];

/***/ },
/* 133 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports['default'] = addEventListener;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _EventObject = __webpack_require__(132);
	
	var _EventObject2 = _interopRequireDefault(_EventObject);
	
	function addEventListener(target, eventType, callback) {
	  function wrapCallback(e) {
	    var ne = new _EventObject2['default'](e);
	    callback.call(target, ne);
	  }
	
	  if (target.addEventListener) {
	    target.addEventListener(eventType, wrapCallback, false);
	    return {
	      remove: function remove() {
	        target.removeEventListener(eventType, wrapCallback, false);
	      }
	    };
	  } else if (target.attachEvent) {
	    target.attachEvent('on' + eventType, wrapCallback);
	    return {
	      remove: function remove() {
	        target.detachEvent('on' + eventType, wrapCallback);
	      }
	    };
	  }
	}
	
	module.exports = exports['default'];

/***/ },
/* 134 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Module dependencies.
	 */
	
	try {
	  var index = __webpack_require__(77);
	} catch (err) {
	  var index = __webpack_require__(77);
	}
	
	/**
	 * Whitespace regexp.
	 */
	
	var re = /\s+/;
	
	/**
	 * toString reference.
	 */
	
	var toString = Object.prototype.toString;
	
	/**
	 * Wrap `el` in a `ClassList`.
	 *
	 * @param {Element} el
	 * @return {ClassList}
	 * @api public
	 */
	
	module.exports = function(el){
	  return new ClassList(el);
	};
	
	/**
	 * Initialize a new ClassList for `el`.
	 *
	 * @param {Element} el
	 * @api private
	 */
	
	function ClassList(el) {
	  if (!el || !el.nodeType) {
	    throw new Error('A DOM element reference is required');
	  }
	  this.el = el;
	  this.list = el.classList;
	}
	
	/**
	 * Add class `name` if not already present.
	 *
	 * @param {String} name
	 * @return {ClassList}
	 * @api public
	 */
	
	ClassList.prototype.add = function(name){
	  // classList
	  if (this.list) {
	    this.list.add(name);
	    return this;
	  }
	
	  // fallback
	  var arr = this.array();
	  var i = index(arr, name);
	  if (!~i) arr.push(name);
	  this.el.className = arr.join(' ');
	  return this;
	};
	
	/**
	 * Remove class `name` when present, or
	 * pass a regular expression to remove
	 * any which match.
	 *
	 * @param {String|RegExp} name
	 * @return {ClassList}
	 * @api public
	 */
	
	ClassList.prototype.remove = function(name){
	  if ('[object RegExp]' == toString.call(name)) {
	    return this.removeMatching(name);
	  }
	
	  // classList
	  if (this.list) {
	    this.list.remove(name);
	    return this;
	  }
	
	  // fallback
	  var arr = this.array();
	  var i = index(arr, name);
	  if (~i) arr.splice(i, 1);
	  this.el.className = arr.join(' ');
	  return this;
	};
	
	/**
	 * Remove all classes matching `re`.
	 *
	 * @param {RegExp} re
	 * @return {ClassList}
	 * @api private
	 */
	
	ClassList.prototype.removeMatching = function(re){
	  var arr = this.array();
	  for (var i = 0; i < arr.length; i++) {
	    if (re.test(arr[i])) {
	      this.remove(arr[i]);
	    }
	  }
	  return this;
	};
	
	/**
	 * Toggle class `name`, can force state via `force`.
	 *
	 * For browsers that support classList, but do not support `force` yet,
	 * the mistake will be detected and corrected.
	 *
	 * @param {String} name
	 * @param {Boolean} force
	 * @return {ClassList}
	 * @api public
	 */
	
	ClassList.prototype.toggle = function(name, force){
	  // classList
	  if (this.list) {
	    if ("undefined" !== typeof force) {
	      if (force !== this.list.toggle(name, force)) {
	        this.list.toggle(name); // toggle again to correct
	      }
	    } else {
	      this.list.toggle(name);
	    }
	    return this;
	  }
	
	  // fallback
	  if ("undefined" !== typeof force) {
	    if (!force) {
	      this.remove(name);
	    } else {
	      this.add(name);
	    }
	  } else {
	    if (this.has(name)) {
	      this.remove(name);
	    } else {
	      this.add(name);
	    }
	  }
	
	  return this;
	};
	
	/**
	 * Return an array of classes.
	 *
	 * @return {Array}
	 * @api public
	 */
	
	ClassList.prototype.array = function(){
	  var className = this.el.getAttribute('class') || '';
	  var str = className.replace(/^\s+|\s+$/g, '');
	  var arr = str.split(re);
	  if ('' === arr[0]) arr.shift();
	  return arr;
	};
	
	/**
	 * Check if class `name` is present.
	 *
	 * @param {String} name
	 * @return {ClassList}
	 * @api public
	 */
	
	ClassList.prototype.has =
	ClassList.prototype.contains = function(name){
	  return this.list
	    ? this.list.contains(name)
	    : !! ~index(this.array(), name);
	};


/***/ },
/* 135 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var EVENT_NAME_MAP = {
	  transitionend: {
	    transition: 'transitionend',
	    WebkitTransition: 'webkitTransitionEnd',
	    MozTransition: 'mozTransitionEnd',
	    OTransition: 'oTransitionEnd',
	    msTransition: 'MSTransitionEnd'
	  },
	
	  animationend: {
	    animation: 'animationend',
	    WebkitAnimation: 'webkitAnimationEnd',
	    MozAnimation: 'mozAnimationEnd',
	    OAnimation: 'oAnimationEnd',
	    msAnimation: 'MSAnimationEnd'
	  }
	};
	
	var endEvents = [];
	
	function detectEvents() {
	  var testEl = document.createElement('div');
	  var style = testEl.style;
	
	  if (!('AnimationEvent' in window)) {
	    delete EVENT_NAME_MAP.animationend.animation;
	  }
	
	  if (!('TransitionEvent' in window)) {
	    delete EVENT_NAME_MAP.transitionend.transition;
	  }
	
	  for (var baseEventName in EVENT_NAME_MAP) {
	    if (EVENT_NAME_MAP.hasOwnProperty(baseEventName)) {
	      var baseEvents = EVENT_NAME_MAP[baseEventName];
	      for (var styleName in baseEvents) {
	        if (styleName in style) {
	          endEvents.push(baseEvents[styleName]);
	          break;
	        }
	      }
	    }
	  }
	}
	
	if (typeof window !== 'undefined' && typeof document !== 'undefined') {
	  detectEvents();
	}
	
	function addEventListener(node, eventName, eventListener) {
	  node.addEventListener(eventName, eventListener, false);
	}
	
	function removeEventListener(node, eventName, eventListener) {
	  node.removeEventListener(eventName, eventListener, false);
	}
	
	var TransitionEvents = {
	  addEndEventListener: function addEndEventListener(node, eventListener) {
	    if (endEvents.length === 0) {
	      window.setTimeout(eventListener, 0);
	      return;
	    }
	    endEvents.forEach(function (endEvent) {
	      addEventListener(node, endEvent, eventListener);
	    });
	  },
	
	
	  endEvents: endEvents,
	
	  removeEndEventListener: function removeEndEventListener(node, eventListener) {
	    if (endEvents.length === 0) {
	      return;
	    }
	    endEvents.forEach(function (endEvent) {
	      removeEventListener(node, endEvent, eventListener);
	    });
	  }
	};
	
	exports["default"] = TransitionEvents;
	module.exports = exports['default'];

/***/ },
/* 136 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj; };
	
	var _Event = __webpack_require__(135);
	
	var _Event2 = _interopRequireDefault(_Event);
	
	var _componentClasses = __webpack_require__(134);
	
	var _componentClasses2 = _interopRequireDefault(_componentClasses);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	var isCssAnimationSupported = _Event2["default"].endEvents.length !== 0;
	
	
	var capitalPrefixes = ['Webkit', 'Moz', 'O',
	// ms is special .... !
	'ms'];
	var prefixes = ['-webkit-', '-moz-', '-o-', 'ms-', ''];
	
	function getStyleProperty(node, name) {
	  var style = window.getComputedStyle(node);
	
	  var ret = '';
	  for (var i = 0; i < prefixes.length; i++) {
	    ret = style.getPropertyValue(prefixes[i] + name);
	    if (ret) {
	      break;
	    }
	  }
	  return ret;
	}
	
	function fixBrowserByTimeout(node) {
	  if (isCssAnimationSupported) {
	    var transitionDelay = parseFloat(getStyleProperty(node, 'transition-delay')) || 0;
	    var transitionDuration = parseFloat(getStyleProperty(node, 'transition-duration')) || 0;
	    var animationDelay = parseFloat(getStyleProperty(node, 'animation-delay')) || 0;
	    var animationDuration = parseFloat(getStyleProperty(node, 'animation-duration')) || 0;
	    var time = Math.max(transitionDuration + transitionDelay, animationDuration + animationDelay);
	    // sometimes, browser bug
	    node.rcEndAnimTimeout = setTimeout(function () {
	      node.rcEndAnimTimeout = null;
	      if (node.rcEndListener) {
	        node.rcEndListener();
	      }
	    }, time * 1000 + 200);
	  }
	}
	
	function clearBrowserBugTimeout(node) {
	  if (node.rcEndAnimTimeout) {
	    clearTimeout(node.rcEndAnimTimeout);
	    node.rcEndAnimTimeout = null;
	  }
	}
	
	var cssAnimation = function cssAnimation(node, transitionName, endCallback) {
	  var nameIsObj = (typeof transitionName === 'undefined' ? 'undefined' : _typeof(transitionName)) === 'object';
	  var className = nameIsObj ? transitionName.name : transitionName;
	  var activeClassName = nameIsObj ? transitionName.active : transitionName + '-active';
	  var end = endCallback;
	  var start = void 0;
	  var active = void 0;
	  var nodeClasses = (0, _componentClasses2["default"])(node);
	
	  if (endCallback && Object.prototype.toString.call(endCallback) === '[object Object]') {
	    end = endCallback.end;
	    start = endCallback.start;
	    active = endCallback.active;
	  }
	
	  if (node.rcEndListener) {
	    node.rcEndListener();
	  }
	
	  node.rcEndListener = function (e) {
	    if (e && e.target !== node) {
	      return;
	    }
	
	    if (node.rcAnimTimeout) {
	      clearTimeout(node.rcAnimTimeout);
	      node.rcAnimTimeout = null;
	    }
	
	    clearBrowserBugTimeout(node);
	
	    nodeClasses.remove(className);
	    nodeClasses.remove(activeClassName);
	
	    _Event2["default"].removeEndEventListener(node, node.rcEndListener);
	    node.rcEndListener = null;
	
	    // Usually this optional end is used for informing an owner of
	    // a leave animation and telling it to remove the child.
	    if (end) {
	      end();
	    }
	  };
	
	  _Event2["default"].addEndEventListener(node, node.rcEndListener);
	
	  if (start) {
	    start();
	  }
	  nodeClasses.add(className);
	
	  node.rcAnimTimeout = setTimeout(function () {
	    node.rcAnimTimeout = null;
	    nodeClasses.add(activeClassName);
	    if (active) {
	      setTimeout(active, 0);
	    }
	    fixBrowserByTimeout(node);
	    // 30ms for firefox
	  }, 30);
	
	  return {
	    stop: function stop() {
	      if (node.rcEndListener) {
	        node.rcEndListener();
	      }
	    }
	  };
	};
	
	cssAnimation.style = function (node, style, callback) {
	  if (node.rcEndListener) {
	    node.rcEndListener();
	  }
	
	  node.rcEndListener = function (e) {
	    if (e && e.target !== node) {
	      return;
	    }
	
	    if (node.rcAnimTimeout) {
	      clearTimeout(node.rcAnimTimeout);
	      node.rcAnimTimeout = null;
	    }
	
	    clearBrowserBugTimeout(node);
	
	    _Event2["default"].removeEndEventListener(node, node.rcEndListener);
	    node.rcEndListener = null;
	
	    // Usually this optional callback is used for informing an owner of
	    // a leave animation and telling it to remove the child.
	    if (callback) {
	      callback();
	    }
	  };
	
	  _Event2["default"].addEndEventListener(node, node.rcEndListener);
	
	  node.rcAnimTimeout = setTimeout(function () {
	    for (var s in style) {
	      if (style.hasOwnProperty(s)) {
	        node.style[s] = style[s];
	      }
	    }
	    node.rcAnimTimeout = null;
	    fixBrowserByTimeout(node);
	  }, 0);
	};
	
	cssAnimation.setTransition = function (node, p, value) {
	  var property = p;
	  var v = value;
	  if (value === undefined) {
	    v = property;
	    property = '';
	  }
	  property = property || '';
	  capitalPrefixes.forEach(function (prefix) {
	    node.style[prefix + 'Transition' + property] = v;
	  });
	};
	
	cssAnimation.isCssAnimationSupported = isCssAnimationSupported;
	
	exports["default"] = cssAnimation;
	module.exports = exports['default'];

/***/ },
/* 137 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _utils = __webpack_require__(29);
	
	var _utils2 = _interopRequireDefault(_utils);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function adjustForViewport(elFuturePos, elRegion, visibleRect, overflow) {
	  var pos = _utils2["default"].clone(elFuturePos);
	  var size = {
	    width: elRegion.width,
	    height: elRegion.height
	  };
	
	  if (overflow.adjustX && pos.left < visibleRect.left) {
	    pos.left = visibleRect.left;
	  }
	
	  // Left edge inside and right edge outside viewport, try to resize it.
	  if (overflow.resizeWidth && pos.left >= visibleRect.left && pos.left + size.width > visibleRect.right) {
	    size.width -= pos.left + size.width - visibleRect.right;
	  }
	
	  // Right edge outside viewport, try to move it.
	  if (overflow.adjustX && pos.left + size.width > visibleRect.right) {
	    // 保证左边界和可视区域左边界对齐
	    pos.left = Math.max(visibleRect.right - size.width, visibleRect.left);
	  }
	
	  // Top edge outside viewport, try to move it.
	  if (overflow.adjustY && pos.top < visibleRect.top) {
	    pos.top = visibleRect.top;
	  }
	
	  // Top edge inside and bottom edge outside viewport, try to resize it.
	  if (overflow.resizeHeight && pos.top >= visibleRect.top && pos.top + size.height > visibleRect.bottom) {
	    size.height -= pos.top + size.height - visibleRect.bottom;
	  }
	
	  // Bottom edge outside viewport, try to move it.
	  if (overflow.adjustY && pos.top + size.height > visibleRect.bottom) {
	    // 保证上边界和可视区域上边界对齐
	    pos.top = Math.max(visibleRect.bottom - size.height, visibleRect.top);
	  }
	
	  return _utils2["default"].mix(pos, size);
	}
	
	exports["default"] = adjustForViewport;
	module.exports = exports['default'];

/***/ },
/* 138 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	/**
	 * 获取 node 上的 align 对齐点 相对于页面的坐标
	 */
	
	function getAlignOffset(region, align) {
	  var V = align.charAt(0);
	  var H = align.charAt(1);
	  var w = region.width;
	  var h = region.height;
	  var x = void 0;
	  var y = void 0;
	
	  x = region.left;
	  y = region.top;
	
	  if (V === 'c') {
	    y += h / 2;
	  } else if (V === 'b') {
	    y += h;
	  }
	
	  if (H === 'c') {
	    x += w / 2;
	  } else if (H === 'r') {
	    x += w;
	  }
	
	  return {
	    left: x,
	    top: y
	  };
	}
	
	exports["default"] = getAlignOffset;
	module.exports = exports['default'];

/***/ },
/* 139 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getAlignOffset = __webpack_require__(138);
	
	var _getAlignOffset2 = _interopRequireDefault(_getAlignOffset);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function getElFuturePos(elRegion, refNodeRegion, points, offset, targetOffset) {
	  var xy = void 0;
	  var diff = void 0;
	  var p1 = void 0;
	  var p2 = void 0;
	
	  xy = {
	    left: elRegion.left,
	    top: elRegion.top
	  };
	
	  p1 = (0, _getAlignOffset2["default"])(refNodeRegion, points[1]);
	  p2 = (0, _getAlignOffset2["default"])(elRegion, points[0]);
	
	  diff = [p2.left - p1.left, p2.top - p1.top];
	
	  return {
	    left: xy.left - diff[0] + offset[0] - targetOffset[0],
	    top: xy.top - diff[1] + offset[1] - targetOffset[1]
	  };
	}
	
	exports["default"] = getElFuturePos;
	module.exports = exports['default'];

/***/ },
/* 140 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _utils = __webpack_require__(29);
	
	var _utils2 = _interopRequireDefault(_utils);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function getRegion(node) {
	  var offset = void 0;
	  var w = void 0;
	  var h = void 0;
	  if (!_utils2["default"].isWindow(node) && node.nodeType !== 9) {
	    offset = _utils2["default"].offset(node);
	    w = _utils2["default"].outerWidth(node);
	    h = _utils2["default"].outerHeight(node);
	  } else {
	    var win = _utils2["default"].getWindow(node);
	    offset = {
	      left: _utils2["default"].getWindowScrollLeft(win),
	      top: _utils2["default"].getWindowScrollTop(win)
	    };
	    w = _utils2["default"].viewportWidth(win);
	    h = _utils2["default"].viewportHeight(win);
	  }
	  offset.width = w;
	  offset.height = h;
	  return offset;
	}
	
	exports["default"] = getRegion;
	module.exports = exports['default'];

/***/ },
/* 141 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _utils = __webpack_require__(29);
	
	var _utils2 = _interopRequireDefault(_utils);
	
	var _getOffsetParent = __webpack_require__(78);
	
	var _getOffsetParent2 = _interopRequireDefault(_getOffsetParent);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	/**
	 * 获得元素的显示部分的区域
	 */
	function getVisibleRectForElement(element) {
	  var visibleRect = {
	    left: 0,
	    right: Infinity,
	    top: 0,
	    bottom: Infinity
	  };
	  var el = (0, _getOffsetParent2["default"])(element);
	  var scrollX = void 0;
	  var scrollY = void 0;
	  var winSize = void 0;
	  var doc = element.ownerDocument;
	  var win = doc.defaultView || doc.parentWindow;
	  var body = doc.body;
	  var documentElement = doc.documentElement;
	
	  // Determine the size of the visible rect by climbing the dom accounting for
	  // all scrollable containers.
	  while (el) {
	    // clientWidth is zero for inline block elements in ie.
	    if ((navigator.userAgent.indexOf('MSIE') === -1 || el.clientWidth !== 0) &&
	    // body may have overflow set on it, yet we still get the entire
	    // viewport. In some browsers, el.offsetParent may be
	    // document.documentElement, so check for that too.
	    el !== body && el !== documentElement && _utils2["default"].css(el, 'overflow') !== 'visible') {
	      var pos = _utils2["default"].offset(el);
	      // add border
	      pos.left += el.clientLeft;
	      pos.top += el.clientTop;
	      visibleRect.top = Math.max(visibleRect.top, pos.top);
	      visibleRect.right = Math.min(visibleRect.right,
	      // consider area without scrollBar
	      pos.left + el.clientWidth);
	      visibleRect.bottom = Math.min(visibleRect.bottom, pos.top + el.clientHeight);
	      visibleRect.left = Math.max(visibleRect.left, pos.left);
	    } else if (el === body || el === documentElement) {
	      break;
	    }
	    el = (0, _getOffsetParent2["default"])(el);
	  }
	
	  // Clip by window's viewport.
	  scrollX = _utils2["default"].getWindowScrollLeft(win);
	  scrollY = _utils2["default"].getWindowScrollTop(win);
	  visibleRect.left = Math.max(visibleRect.left, scrollX);
	  visibleRect.top = Math.max(visibleRect.top, scrollY);
	  winSize = {
	    width: _utils2["default"].viewportWidth(win),
	    height: _utils2["default"].viewportHeight(win)
	  };
	  visibleRect.right = Math.min(visibleRect.right, scrollX + winSize.width);
	  visibleRect.bottom = Math.min(visibleRect.bottom, scrollY + winSize.height);
	  return visibleRect.top >= 0 && visibleRect.left >= 0 && visibleRect.bottom > visibleRect.top && visibleRect.right > visibleRect.left ? visibleRect : null;
	}
	
	exports["default"] = getVisibleRectForElement;
	module.exports = exports['default'];

/***/ },
/* 142 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _utils = __webpack_require__(29);
	
	var _utils2 = _interopRequireDefault(_utils);
	
	var _getOffsetParent = __webpack_require__(78);
	
	var _getOffsetParent2 = _interopRequireDefault(_getOffsetParent);
	
	var _getVisibleRectForElement = __webpack_require__(141);
	
	var _getVisibleRectForElement2 = _interopRequireDefault(_getVisibleRectForElement);
	
	var _adjustForViewport = __webpack_require__(137);
	
	var _adjustForViewport2 = _interopRequireDefault(_adjustForViewport);
	
	var _getRegion = __webpack_require__(140);
	
	var _getRegion2 = _interopRequireDefault(_getRegion);
	
	var _getElFuturePos = __webpack_require__(139);
	
	var _getElFuturePos2 = _interopRequireDefault(_getElFuturePos);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	// http://yiminghe.iteye.com/blog/1124720
	
	/**
	 * align dom node flexibly
	 * @author yiminghe@gmail.com
	 */
	
	function isFailX(elFuturePos, elRegion, visibleRect) {
	  return elFuturePos.left < visibleRect.left || elFuturePos.left + elRegion.width > visibleRect.right;
	}
	
	function isFailY(elFuturePos, elRegion, visibleRect) {
	  return elFuturePos.top < visibleRect.top || elFuturePos.top + elRegion.height > visibleRect.bottom;
	}
	
	function isCompleteFailX(elFuturePos, elRegion, visibleRect) {
	  return elFuturePos.left > visibleRect.right || elFuturePos.left + elRegion.width < visibleRect.left;
	}
	
	function isCompleteFailY(elFuturePos, elRegion, visibleRect) {
	  return elFuturePos.top > visibleRect.bottom || elFuturePos.top + elRegion.height < visibleRect.top;
	}
	
	function flip(points, reg, map) {
	  var ret = [];
	  _utils2["default"].each(points, function (p) {
	    ret.push(p.replace(reg, function (m) {
	      return map[m];
	    }));
	  });
	  return ret;
	}
	
	function flipOffset(offset, index) {
	  offset[index] = -offset[index];
	  return offset;
	}
	
	function convertOffset(str, offsetLen) {
	  var n = void 0;
	  if (/%$/.test(str)) {
	    n = parseInt(str.substring(0, str.length - 1), 10) / 100 * offsetLen;
	  } else {
	    n = parseInt(str, 10);
	  }
	  return n || 0;
	}
	
	function normalizeOffset(offset, el) {
	  offset[0] = convertOffset(offset[0], el.width);
	  offset[1] = convertOffset(offset[1], el.height);
	}
	
	function domAlign(el, refNode, align) {
	  var points = align.points;
	  var offset = align.offset || [0, 0];
	  var targetOffset = align.targetOffset || [0, 0];
	  var overflow = align.overflow;
	  var target = align.target || refNode;
	  var source = align.source || el;
	  offset = [].concat(offset);
	  targetOffset = [].concat(targetOffset);
	  overflow = overflow || {};
	  var newOverflowCfg = {};
	
	  var fail = 0;
	  // 当前节点可以被放置的显示区域
	  var visibleRect = (0, _getVisibleRectForElement2["default"])(source);
	  // 当前节点所占的区域, left/top/width/height
	  var elRegion = (0, _getRegion2["default"])(source);
	  // 参照节点所占的区域, left/top/width/height
	  var refNodeRegion = (0, _getRegion2["default"])(target);
	  // 将 offset 转换成数值，支持百分比
	  normalizeOffset(offset, elRegion);
	  normalizeOffset(targetOffset, refNodeRegion);
	  // 当前节点将要被放置的位置
	  var elFuturePos = (0, _getElFuturePos2["default"])(elRegion, refNodeRegion, points, offset, targetOffset);
	  // 当前节点将要所处的区域
	  var newElRegion = _utils2["default"].merge(elRegion, elFuturePos);
	
	  // 如果可视区域不能完全放置当前节点时允许调整
	  if (visibleRect && (overflow.adjustX || overflow.adjustY)) {
	    if (overflow.adjustX) {
	      // 如果横向不能放下
	      if (isFailX(elFuturePos, elRegion, visibleRect)) {
	        // 对齐位置反下
	        var newPoints = flip(points, /[lr]/ig, {
	          l: 'r',
	          r: 'l'
	        });
	        // 偏移量也反下
	        var newOffset = flipOffset(offset, 0);
	        var newTargetOffset = flipOffset(targetOffset, 0);
	        var newElFuturePos = (0, _getElFuturePos2["default"])(elRegion, refNodeRegion, newPoints, newOffset, newTargetOffset);
	        if (!isCompleteFailX(newElFuturePos, elRegion, visibleRect)) {
	          fail = 1;
	          points = newPoints;
	          offset = newOffset;
	          targetOffset = newTargetOffset;
	        }
	      }
	    }
	
	    if (overflow.adjustY) {
	      // 如果纵向不能放下
	      if (isFailY(elFuturePos, elRegion, visibleRect)) {
	        // 对齐位置反下
	        var _newPoints = flip(points, /[tb]/ig, {
	          t: 'b',
	          b: 't'
	        });
	        // 偏移量也反下
	        var _newOffset = flipOffset(offset, 1);
	        var _newTargetOffset = flipOffset(targetOffset, 1);
	        var _newElFuturePos = (0, _getElFuturePos2["default"])(elRegion, refNodeRegion, _newPoints, _newOffset, _newTargetOffset);
	        if (!isCompleteFailY(_newElFuturePos, elRegion, visibleRect)) {
	          fail = 1;
	          points = _newPoints;
	          offset = _newOffset;
	          targetOffset = _newTargetOffset;
	        }
	      }
	    }
	
	    // 如果失败，重新计算当前节点将要被放置的位置
	    if (fail) {
	      elFuturePos = (0, _getElFuturePos2["default"])(elRegion, refNodeRegion, points, offset, targetOffset);
	      _utils2["default"].mix(newElRegion, elFuturePos);
	    }
	
	    // 检查反下后的位置是否可以放下了
	    // 如果仍然放不下只有指定了可以调整当前方向才调整
	    newOverflowCfg.adjustX = overflow.adjustX && isFailX(elFuturePos, elRegion, visibleRect);
	
	    newOverflowCfg.adjustY = overflow.adjustY && isFailY(elFuturePos, elRegion, visibleRect);
	
	    // 确实要调整，甚至可能会调整高度宽度
	    if (newOverflowCfg.adjustX || newOverflowCfg.adjustY) {
	      newElRegion = (0, _adjustForViewport2["default"])(elFuturePos, elRegion, visibleRect, newOverflowCfg);
	    }
	  }
	
	  // need judge to in case set fixed with in css on height auto element
	  if (newElRegion.width !== elRegion.width) {
	    _utils2["default"].css(source, 'width', _utils2["default"].width(source) + newElRegion.width - elRegion.width);
	  }
	
	  if (newElRegion.height !== elRegion.height) {
	    _utils2["default"].css(source, 'height', _utils2["default"].height(source) + newElRegion.height - elRegion.height);
	  }
	
	  // https://github.com/kissyteam/kissy/issues/190
	  // 相对于屏幕位置没变，而 left/top 变了
	  // 例如 <div 'relative'><el absolute></div>
	  _utils2["default"].offset(source, {
	    left: newElRegion.left,
	    top: newElRegion.top
	  }, {
	    useCssRight: align.useCssRight,
	    useCssBottom: align.useCssBottom,
	    useCssTransform: align.useCssTransform
	  });
	
	  return {
	    points: points,
	    offset: offset,
	    targetOffset: targetOffset,
	    overflow: newOverflowCfg
	  };
	}
	
	domAlign.__getOffsetParent = _getOffsetParent2["default"];
	
	domAlign.__getVisibleRectForElement = _getVisibleRectForElement2["default"];
	
	exports["default"] = domAlign;
	/**
	 *  2012-04-26 yiminghe@gmail.com
	 *   - 优化智能对齐算法
	 *   - 慎用 resizeXX
	 *
	 *  2011-07-13 yiminghe@gmail.com note:
	 *   - 增加智能对齐，以及大小调整选项
	 **/
	
	module.exports = exports['default'];

/***/ },
/* 143 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getTransformName = getTransformName;
	exports.setTransitionProperty = setTransitionProperty;
	exports.getTransitionProperty = getTransitionProperty;
	exports.getTransformXY = getTransformXY;
	exports.setTransformXY = setTransformXY;
	var vendorPrefix = void 0;
	
	var jsCssMap = {
	  Webkit: '-webkit-',
	  Moz: '-moz-',
	  // IE did it wrong again ...
	  ms: '-ms-',
	  O: '-o-'
	};
	
	function getVendorPrefix() {
	  if (vendorPrefix !== undefined) {
	    return vendorPrefix;
	  }
	  vendorPrefix = '';
	  var style = document.createElement('p').style;
	  var testProp = 'Transform';
	  for (var key in jsCssMap) {
	    if (key + testProp in style) {
	      vendorPrefix = key;
	    }
	  }
	  return vendorPrefix;
	}
	
	function getTransitionName() {
	  return getVendorPrefix() ? getVendorPrefix() + 'TransitionProperty' : 'transitionProperty';
	}
	
	function getTransformName() {
	  return getVendorPrefix() ? getVendorPrefix() + 'Transform' : 'transform';
	}
	
	function setTransitionProperty(node, value) {
	  var name = getTransitionName();
	  if (name) {
	    node.style[name] = value;
	    if (name !== 'transitionProperty') {
	      node.style.transitionProperty = value;
	    }
	  }
	}
	
	function setTransform(node, value) {
	  var name = getTransformName();
	  if (name) {
	    node.style[name] = value;
	    if (name !== 'transform') {
	      node.style.transform = value;
	    }
	  }
	}
	
	function getTransitionProperty(node) {
	  return node.style.transitionProperty || node.style[getTransitionName()];
	}
	
	function getTransformXY(node) {
	  var style = window.getComputedStyle(node, null);
	  var transform = style.getPropertyValue('transform') || style.getPropertyValue(getTransformName());
	  if (transform && transform !== 'none') {
	    var matrix = transform.replace(/[^0-9\-.,]/g, '').split(',');
	    return { x: parseFloat(matrix[12] || matrix[4], 0), y: parseFloat(matrix[13] || matrix[5], 0) };
	  }
	  return {
	    x: 0,
	    y: 0
	  };
	}
	
	var matrix2d = /matrix\((.*)\)/;
	var matrix3d = /matrix3d\((.*)\)/;
	
	function setTransformXY(node, xy) {
	  var style = window.getComputedStyle(node, null);
	  var transform = style.getPropertyValue('transform') || style.getPropertyValue(getTransformName());
	  if (transform && transform !== 'none') {
	    var arr = void 0;
	    var match2d = transform.match(matrix2d);
	    if (match2d) {
	      match2d = match2d[1];
	      arr = match2d.split(',').map(function (item) {
	        return parseFloat(item, 10);
	      });
	      arr[4] = xy.x;
	      arr[5] = xy.y;
	      setTransform(node, 'matrix(' + arr.join(',') + ')');
	    } else {
	      var match3d = transform.match(matrix3d)[1];
	      arr = match3d.split(',').map(function (item) {
	        return parseFloat(item, 10);
	      });
	      arr[12] = xy.x;
	      arr[13] = xy.y;
	      setTransform(node, 'matrix3d(' + arr.join(',') + ')');
	    }
	  } else {
	    setTransform(node, 'translateX(' + xy.x + 'px) translateY(' + xy.y + 'px) translateZ(0)');
	  }
	}

/***/ },
/* 144 */
/***/ function(module, exports) {

	module.exports = function(opts) {
	  return new ElementClass(opts)
	}
	
	function indexOf(arr, prop) {
	  if (arr.indexOf) return arr.indexOf(prop)
	  for (var i = 0, len = arr.length; i < len; i++)
	    if (arr[i] === prop) return i
	  return -1
	}
	
	function ElementClass(opts) {
	  if (!(this instanceof ElementClass)) return new ElementClass(opts)
	  var self = this
	  if (!opts) opts = {}
	
	  // similar doing instanceof HTMLElement but works in IE8
	  if (opts.nodeType) opts = {el: opts}
	
	  this.opts = opts
	  this.el = opts.el || document.body
	  if (typeof this.el !== 'object') this.el = document.querySelector(this.el)
	}
	
	ElementClass.prototype.add = function(className) {
	  var el = this.el
	  if (!el) return
	  if (el.className === "") return el.className = className
	  var classes = el.className.split(' ')
	  if (indexOf(classes, className) > -1) return classes
	  classes.push(className)
	  el.className = classes.join(' ')
	  return classes
	}
	
	ElementClass.prototype.remove = function(className) {
	  var el = this.el
	  if (!el) return
	  if (el.className === "") return
	  var classes = el.className.split(' ')
	  var idx = indexOf(classes, className)
	  if (idx > -1) classes.splice(idx, 1)
	  el.className = classes.join(' ')
	  return classes
	}
	
	ElementClass.prototype.has = function(className) {
	  var el = this.el
	  if (!el) return
	  var classes = el.className.split(' ')
	  return indexOf(classes, className) > -1
	}
	
	ElementClass.prototype.toggle = function(className) {
	  var el = this.el
	  if (!el) return
	  if (this.has(className)) this.remove(className)
	  else this.add(className)
	}


/***/ },
/* 145 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/*!
	  Copyright (c) 2015 Jed Watson.
	  Based on code that is Copyright 2013-2015, Facebook, Inc.
	  All rights reserved.
	*/
	
	(function () {
		'use strict';
	
		var canUseDOM = !!(
			typeof window !== 'undefined' &&
			window.document &&
			window.document.createElement
		);
	
		var ExecutionEnvironment = {
	
			canUseDOM: canUseDOM,
	
			canUseWorkers: typeof Worker !== 'undefined',
	
			canUseEventListeners:
				canUseDOM && !!(window.addEventListener || window.attachEvent),
	
			canUseViewport: canUseDOM && !!window.screen
	
		};
	
		if (true) {
			!(__WEBPACK_AMD_DEFINE_RESULT__ = function () {
				return ExecutionEnvironment;
			}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else if (typeof module !== 'undefined' && module.exports) {
			module.exports = ExecutionEnvironment;
		} else {
			window.ExecutionEnvironment = ExecutionEnvironment;
		}
	
	}());


/***/ },
/* 146 */
/***/ function(module, exports) {

	"use strict";
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks
	 */
	
	var _hyphenPattern = /-(.)/g;
	
	/**
	 * Camelcases a hyphenated string, for example:
	 *
	 *   > camelize('background-color')
	 *   < "backgroundColor"
	 *
	 * @param {string} string
	 * @return {string}
	 */
	function camelize(string) {
	  return string.replace(_hyphenPattern, function (_, character) {
	    return character.toUpperCase();
	  });
	}
	
	module.exports = camelize;

/***/ },
/* 147 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks
	 */
	
	'use strict';
	
	var camelize = __webpack_require__(146);
	
	var msPattern = /^-ms-/;
	
	/**
	 * Camelcases a hyphenated CSS property name, for example:
	 *
	 *   > camelizeStyleName('background-color')
	 *   < "backgroundColor"
	 *   > camelizeStyleName('-moz-transition')
	 *   < "MozTransition"
	 *   > camelizeStyleName('-ms-transition')
	 *   < "msTransition"
	 *
	 * As Andi Smith suggests
	 * (http://www.andismith.com/blog/2012/02/modernizr-prefixed/), an `-ms` prefix
	 * is converted to lowercase `ms`.
	 *
	 * @param {string} string
	 * @return {string}
	 */
	function camelizeStyleName(string) {
	  return camelize(string.replace(msPattern, 'ms-'));
	}
	
	module.exports = camelizeStyleName;

/***/ },
/* 148 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	var isTextNode = __webpack_require__(156);
	
	/*eslint-disable no-bitwise */
	
	/**
	 * Checks if a given DOM node contains or is another DOM node.
	 */
	function containsNode(outerNode, innerNode) {
	  if (!outerNode || !innerNode) {
	    return false;
	  } else if (outerNode === innerNode) {
	    return true;
	  } else if (isTextNode(outerNode)) {
	    return false;
	  } else if (isTextNode(innerNode)) {
	    return containsNode(outerNode, innerNode.parentNode);
	  } else if ('contains' in outerNode) {
	    return outerNode.contains(innerNode);
	  } else if (outerNode.compareDocumentPosition) {
	    return !!(outerNode.compareDocumentPosition(innerNode) & 16);
	  } else {
	    return false;
	  }
	}
	
	module.exports = containsNode;

/***/ },
/* 149 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks
	 */
	
	var invariant = __webpack_require__(2);
	
	/**
	 * Convert array-like objects to arrays.
	 *
	 * This API assumes the caller knows the contents of the data type. For less
	 * well defined inputs use createArrayFromMixed.
	 *
	 * @param {object|function|filelist} obj
	 * @return {array}
	 */
	function toArray(obj) {
	  var length = obj.length;
	
	  // Some browsers builtin objects can report typeof 'function' (e.g. NodeList
	  // in old versions of Safari).
	  !(!Array.isArray(obj) && (typeof obj === 'object' || typeof obj === 'function')) ?  false ? invariant(false, 'toArray: Array-like object expected') : invariant(false) : void 0;
	
	  !(typeof length === 'number') ?  false ? invariant(false, 'toArray: Object needs a length property') : invariant(false) : void 0;
	
	  !(length === 0 || length - 1 in obj) ?  false ? invariant(false, 'toArray: Object should have keys for indices') : invariant(false) : void 0;
	
	  !(typeof obj.callee !== 'function') ?  false ? invariant(false, 'toArray: Object can\'t be `arguments`. Use rest params ' + '(function(...args) {}) or Array.from() instead.') : invariant(false) : void 0;
	
	  // Old IE doesn't give collections access to hasOwnProperty. Assume inputs
	  // without method will throw during the slice call and skip straight to the
	  // fallback.
	  if (obj.hasOwnProperty) {
	    try {
	      return Array.prototype.slice.call(obj);
	    } catch (e) {
	      // IE < 9 does not support Array#slice on collections objects
	    }
	  }
	
	  // Fall back to copying key by key. This assumes all keys have a value,
	  // so will not preserve sparsely populated inputs.
	  var ret = Array(length);
	  for (var ii = 0; ii < length; ii++) {
	    ret[ii] = obj[ii];
	  }
	  return ret;
	}
	
	/**
	 * Perform a heuristic test to determine if an object is "array-like".
	 *
	 *   A monk asked Joshu, a Zen master, "Has a dog Buddha nature?"
	 *   Joshu replied: "Mu."
	 *
	 * This function determines if its argument has "array nature": it returns
	 * true if the argument is an actual array, an `arguments' object, or an
	 * HTMLCollection (e.g. node.childNodes or node.getElementsByTagName()).
	 *
	 * It will return false for other array-like objects like Filelist.
	 *
	 * @param {*} obj
	 * @return {boolean}
	 */
	function hasArrayNature(obj) {
	  return (
	    // not null/false
	    !!obj && (
	    // arrays are objects, NodeLists are functions in Safari
	    typeof obj == 'object' || typeof obj == 'function') &&
	    // quacks like an array
	    'length' in obj &&
	    // not window
	    !('setInterval' in obj) &&
	    // no DOM node should be considered an array-like
	    // a 'select' element has 'length' and 'item' properties on IE8
	    typeof obj.nodeType != 'number' && (
	    // a real array
	    Array.isArray(obj) ||
	    // arguments
	    'callee' in obj ||
	    // HTMLCollection/NodeList
	    'item' in obj)
	  );
	}
	
	/**
	 * Ensure that the argument is an array by wrapping it in an array if it is not.
	 * Creates a copy of the argument if it is already an array.
	 *
	 * This is mostly useful idiomatically:
	 *
	 *   var createArrayFromMixed = require('createArrayFromMixed');
	 *
	 *   function takesOneOrMoreThings(things) {
	 *     things = createArrayFromMixed(things);
	 *     ...
	 *   }
	 *
	 * This allows you to treat `things' as an array, but accept scalars in the API.
	 *
	 * If you need to convert an array-like object, like `arguments`, into an array
	 * use toArray instead.
	 *
	 * @param {*} obj
	 * @return {array}
	 */
	function createArrayFromMixed(obj) {
	  if (!hasArrayNature(obj)) {
	    return [obj];
	  } else if (Array.isArray(obj)) {
	    return obj.slice();
	  } else {
	    return toArray(obj);
	  }
	}
	
	module.exports = createArrayFromMixed;

/***/ },
/* 150 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks
	 */
	
	/*eslint-disable fb-www/unsafe-html*/
	
	var ExecutionEnvironment = __webpack_require__(9);
	
	var createArrayFromMixed = __webpack_require__(149);
	var getMarkupWrap = __webpack_require__(151);
	var invariant = __webpack_require__(2);
	
	/**
	 * Dummy container used to render all markup.
	 */
	var dummyNode = ExecutionEnvironment.canUseDOM ? document.createElement('div') : null;
	
	/**
	 * Pattern used by `getNodeName`.
	 */
	var nodeNamePattern = /^\s*<(\w+)/;
	
	/**
	 * Extracts the `nodeName` of the first element in a string of markup.
	 *
	 * @param {string} markup String of markup.
	 * @return {?string} Node name of the supplied markup.
	 */
	function getNodeName(markup) {
	  var nodeNameMatch = markup.match(nodeNamePattern);
	  return nodeNameMatch && nodeNameMatch[1].toLowerCase();
	}
	
	/**
	 * Creates an array containing the nodes rendered from the supplied markup. The
	 * optionally supplied `handleScript` function will be invoked once for each
	 * <script> element that is rendered. If no `handleScript` function is supplied,
	 * an exception is thrown if any <script> elements are rendered.
	 *
	 * @param {string} markup A string of valid HTML markup.
	 * @param {?function} handleScript Invoked once for each rendered <script>.
	 * @return {array<DOMElement|DOMTextNode>} An array of rendered nodes.
	 */
	function createNodesFromMarkup(markup, handleScript) {
	  var node = dummyNode;
	  !!!dummyNode ?  false ? invariant(false, 'createNodesFromMarkup dummy not initialized') : invariant(false) : void 0;
	  var nodeName = getNodeName(markup);
	
	  var wrap = nodeName && getMarkupWrap(nodeName);
	  if (wrap) {
	    node.innerHTML = wrap[1] + markup + wrap[2];
	
	    var wrapDepth = wrap[0];
	    while (wrapDepth--) {
	      node = node.lastChild;
	    }
	  } else {
	    node.innerHTML = markup;
	  }
	
	  var scripts = node.getElementsByTagName('script');
	  if (scripts.length) {
	    !handleScript ?  false ? invariant(false, 'createNodesFromMarkup(...): Unexpected <script> element rendered.') : invariant(false) : void 0;
	    createArrayFromMixed(scripts).forEach(handleScript);
	  }
	
	  var nodes = Array.from(node.childNodes);
	  while (node.lastChild) {
	    node.removeChild(node.lastChild);
	  }
	  return nodes;
	}
	
	module.exports = createNodesFromMarkup;

/***/ },
/* 151 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	/*eslint-disable fb-www/unsafe-html */
	
	var ExecutionEnvironment = __webpack_require__(9);
	
	var invariant = __webpack_require__(2);
	
	/**
	 * Dummy container used to detect which wraps are necessary.
	 */
	var dummyNode = ExecutionEnvironment.canUseDOM ? document.createElement('div') : null;
	
	/**
	 * Some browsers cannot use `innerHTML` to render certain elements standalone,
	 * so we wrap them, render the wrapped nodes, then extract the desired node.
	 *
	 * In IE8, certain elements cannot render alone, so wrap all elements ('*').
	 */
	
	var shouldWrap = {};
	
	var selectWrap = [1, '<select multiple="true">', '</select>'];
	var tableWrap = [1, '<table>', '</table>'];
	var trWrap = [3, '<table><tbody><tr>', '</tr></tbody></table>'];
	
	var svgWrap = [1, '<svg xmlns="http://www.w3.org/2000/svg">', '</svg>'];
	
	var markupWrap = {
	  '*': [1, '?<div>', '</div>'],
	
	  'area': [1, '<map>', '</map>'],
	  'col': [2, '<table><tbody></tbody><colgroup>', '</colgroup></table>'],
	  'legend': [1, '<fieldset>', '</fieldset>'],
	  'param': [1, '<object>', '</object>'],
	  'tr': [2, '<table><tbody>', '</tbody></table>'],
	
	  'optgroup': selectWrap,
	  'option': selectWrap,
	
	  'caption': tableWrap,
	  'colgroup': tableWrap,
	  'tbody': tableWrap,
	  'tfoot': tableWrap,
	  'thead': tableWrap,
	
	  'td': trWrap,
	  'th': trWrap
	};
	
	// Initialize the SVG elements since we know they'll always need to be wrapped
	// consistently. If they are created inside a <div> they will be initialized in
	// the wrong namespace (and will not display).
	var svgElements = ['circle', 'clipPath', 'defs', 'ellipse', 'g', 'image', 'line', 'linearGradient', 'mask', 'path', 'pattern', 'polygon', 'polyline', 'radialGradient', 'rect', 'stop', 'text', 'tspan'];
	svgElements.forEach(function (nodeName) {
	  markupWrap[nodeName] = svgWrap;
	  shouldWrap[nodeName] = true;
	});
	
	/**
	 * Gets the markup wrap configuration for the supplied `nodeName`.
	 *
	 * NOTE: This lazily detects which wraps are necessary for the current browser.
	 *
	 * @param {string} nodeName Lowercase `nodeName`.
	 * @return {?array} Markup wrap configuration, if applicable.
	 */
	function getMarkupWrap(nodeName) {
	  !!!dummyNode ?  false ? invariant(false, 'Markup wrapping node not initialized') : invariant(false) : void 0;
	  if (!markupWrap.hasOwnProperty(nodeName)) {
	    nodeName = '*';
	  }
	  if (!shouldWrap.hasOwnProperty(nodeName)) {
	    if (nodeName === '*') {
	      dummyNode.innerHTML = '<link />';
	    } else {
	      dummyNode.innerHTML = '<' + nodeName + '></' + nodeName + '>';
	    }
	    shouldWrap[nodeName] = !dummyNode.firstChild;
	  }
	  return shouldWrap[nodeName] ? markupWrap[nodeName] : null;
	}
	
	module.exports = getMarkupWrap;

/***/ },
/* 152 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks
	 */
	
	'use strict';
	
	/**
	 * Gets the scroll position of the supplied element or window.
	 *
	 * The return values are unbounded, unlike `getScrollPosition`. This means they
	 * may be negative or exceed the element boundaries (which is possible using
	 * inertial scrolling).
	 *
	 * @param {DOMWindow|DOMElement} scrollable
	 * @return {object} Map with `x` and `y` keys.
	 */
	
	function getUnboundedScrollPosition(scrollable) {
	  if (scrollable === window) {
	    return {
	      x: window.pageXOffset || document.documentElement.scrollLeft,
	      y: window.pageYOffset || document.documentElement.scrollTop
	    };
	  }
	  return {
	    x: scrollable.scrollLeft,
	    y: scrollable.scrollTop
	  };
	}
	
	module.exports = getUnboundedScrollPosition;

/***/ },
/* 153 */
/***/ function(module, exports) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks
	 */
	
	var _uppercasePattern = /([A-Z])/g;
	
	/**
	 * Hyphenates a camelcased string, for example:
	 *
	 *   > hyphenate('backgroundColor')
	 *   < "background-color"
	 *
	 * For CSS style names, use `hyphenateStyleName` instead which works properly
	 * with all vendor prefixes, including `ms`.
	 *
	 * @param {string} string
	 * @return {string}
	 */
	function hyphenate(string) {
	  return string.replace(_uppercasePattern, '-$1').toLowerCase();
	}
	
	module.exports = hyphenate;

/***/ },
/* 154 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks
	 */
	
	'use strict';
	
	var hyphenate = __webpack_require__(153);
	
	var msPattern = /^ms-/;
	
	/**
	 * Hyphenates a camelcased CSS property name, for example:
	 *
	 *   > hyphenateStyleName('backgroundColor')
	 *   < "background-color"
	 *   > hyphenateStyleName('MozTransition')
	 *   < "-moz-transition"
	 *   > hyphenateStyleName('msTransition')
	 *   < "-ms-transition"
	 *
	 * As Modernizr suggests (http://modernizr.com/docs/#prefixed), an `ms` prefix
	 * is converted to `-ms-`.
	 *
	 * @param {string} string
	 * @return {string}
	 */
	function hyphenateStyleName(string) {
	  return hyphenate(string).replace(msPattern, '-ms-');
	}
	
	module.exports = hyphenateStyleName;

/***/ },
/* 155 */
/***/ function(module, exports) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks
	 */
	
	/**
	 * @param {*} object The object to check.
	 * @return {boolean} Whether or not the object is a DOM node.
	 */
	function isNode(object) {
	  return !!(object && (typeof Node === 'function' ? object instanceof Node : typeof object === 'object' && typeof object.nodeType === 'number' && typeof object.nodeName === 'string'));
	}
	
	module.exports = isNode;

/***/ },
/* 156 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks
	 */
	
	var isNode = __webpack_require__(155);
	
	/**
	 * @param {*} object The object to check.
	 * @return {boolean} Whether or not the object is a DOM text node.
	 */
	function isTextNode(object) {
	  return isNode(object) && object.nodeType == 3;
	}
	
	module.exports = isTextNode;

/***/ },
/* 157 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 * @typechecks static-only
	 */
	
	'use strict';
	
	/**
	 * Memoizes the return value of a function that accepts one string argument.
	 */
	
	function memoizeStringOnly(callback) {
	  var cache = {};
	  return function (string) {
	    if (!cache.hasOwnProperty(string)) {
	      cache[string] = callback.call(this, string);
	    }
	    return cache[string];
	  };
	}
	
	module.exports = memoizeStringOnly;

/***/ },
/* 158 */
/***/ function(module, exports) {

	/**
	 * Copyright 2015, Yahoo! Inc.
	 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
	 */
	'use strict';
	
	var REACT_STATICS = {
	    childContextTypes: true,
	    contextTypes: true,
	    defaultProps: true,
	    displayName: true,
	    getDefaultProps: true,
	    mixins: true,
	    propTypes: true,
	    type: true
	};
	
	var KNOWN_STATICS = {
	    name: true,
	    length: true,
	    prototype: true,
	    caller: true,
	    arguments: true,
	    arity: true
	};
	
	var isGetOwnPropertySymbolsAvailable = typeof Object.getOwnPropertySymbols === 'function';
	
	module.exports = function hoistNonReactStatics(targetComponent, sourceComponent, customStatics) {
	    if (typeof sourceComponent !== 'string') { // don't hoist over string (html) components
	        var keys = Object.getOwnPropertyNames(sourceComponent);
	
	        /* istanbul ignore else */
	        if (isGetOwnPropertySymbolsAvailable) {
	            keys = keys.concat(Object.getOwnPropertySymbols(sourceComponent));
	        }
	
	        for (var i = 0; i < keys.length; ++i) {
	            if (!REACT_STATICS[keys[i]] && !KNOWN_STATICS[keys[i]] && (!customStatics || !customStatics[keys[i]])) {
	                try {
	                    targetComponent[keys[i]] = sourceComponent[keys[i]];
	                } catch (error) {
	
	                }
	            }
	        }
	    }
	
	    return targetComponent;
	};


/***/ },
/* 159 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	'use strict';
	
	/**
	 * Use invariant() to assert state which your program assumes to be true.
	 *
	 * Provide sprintf-style format (only %s is supported) and arguments
	 * to provide information about what broke and what you were
	 * expecting.
	 *
	 * The invariant message will be stripped in production, but the invariant
	 * will remain to ensure logic does not differ in production.
	 */
	
	var invariant = function(condition, format, a, b, c, d, e, f) {
	  if (false) {
	    if (format === undefined) {
	      throw new Error('invariant requires an error message argument');
	    }
	  }
	
	  if (!condition) {
	    var error;
	    if (format === undefined) {
	      error = new Error(
	        'Minified exception occurred; use the non-minified dev environment ' +
	        'for the full error message and additional helpful warnings.'
	      );
	    } else {
	      var args = [a, b, c, d, e, f];
	      var argIndex = 0;
	      error = new Error(
	        format.replace(/%s/g, function() { return args[argIndex++]; })
	      );
	      error.name = 'Invariant Violation';
	    }
	
	    error.framesToPop = 1; // we don't care about invariant's own frame
	    throw error;
	  }
	};
	
	module.exports = invariant;


/***/ },
/* 160 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	 * jQuery JavaScript Library v1.12.4
	 * http://jquery.com/
	 *
	 * Includes Sizzle.js
	 * http://sizzlejs.com/
	 *
	 * Copyright jQuery Foundation and other contributors
	 * Released under the MIT license
	 * http://jquery.org/license
	 *
	 * Date: 2016-05-20T17:17Z
	 */
	
	(function( global, factory ) {
	
		if ( typeof module === "object" && typeof module.exports === "object" ) {
			// For CommonJS and CommonJS-like environments where a proper `window`
			// is present, execute the factory and get jQuery.
			// For environments that do not have a `window` with a `document`
			// (such as Node.js), expose a factory as module.exports.
			// This accentuates the need for the creation of a real `window`.
			// e.g. var jQuery = require("jquery")(window);
			// See ticket #14549 for more info.
			module.exports = global.document ?
				factory( global, true ) :
				function( w ) {
					if ( !w.document ) {
						throw new Error( "jQuery requires a window with a document" );
					}
					return factory( w );
				};
		} else {
			factory( global );
		}
	
	// Pass this if window is not defined yet
	}(typeof window !== "undefined" ? window : this, function( window, noGlobal ) {
	
	// Support: Firefox 18+
	// Can't be in strict mode, several libs including ASP.NET trace
	// the stack via arguments.caller.callee and Firefox dies if
	// you try to trace through "use strict" call chains. (#13335)
	//"use strict";
	var deletedIds = [];
	
	var document = window.document;
	
	var slice = deletedIds.slice;
	
	var concat = deletedIds.concat;
	
	var push = deletedIds.push;
	
	var indexOf = deletedIds.indexOf;
	
	var class2type = {};
	
	var toString = class2type.toString;
	
	var hasOwn = class2type.hasOwnProperty;
	
	var support = {};
	
	
	
	var
		version = "1.12.4",
	
		// Define a local copy of jQuery
		jQuery = function( selector, context ) {
	
			// The jQuery object is actually just the init constructor 'enhanced'
			// Need init if jQuery is called (just allow error to be thrown if not included)
			return new jQuery.fn.init( selector, context );
		},
	
		// Support: Android<4.1, IE<9
		// Make sure we trim BOM and NBSP
		rtrim = /^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g,
	
		// Matches dashed string for camelizing
		rmsPrefix = /^-ms-/,
		rdashAlpha = /-([\da-z])/gi,
	
		// Used by jQuery.camelCase as callback to replace()
		fcamelCase = function( all, letter ) {
			return letter.toUpperCase();
		};
	
	jQuery.fn = jQuery.prototype = {
	
		// The current version of jQuery being used
		jquery: version,
	
		constructor: jQuery,
	
		// Start with an empty selector
		selector: "",
	
		// The default length of a jQuery object is 0
		length: 0,
	
		toArray: function() {
			return slice.call( this );
		},
	
		// Get the Nth element in the matched element set OR
		// Get the whole matched element set as a clean array
		get: function( num ) {
			return num != null ?
	
				// Return just the one element from the set
				( num < 0 ? this[ num + this.length ] : this[ num ] ) :
	
				// Return all the elements in a clean array
				slice.call( this );
		},
	
		// Take an array of elements and push it onto the stack
		// (returning the new matched element set)
		pushStack: function( elems ) {
	
			// Build a new jQuery matched element set
			var ret = jQuery.merge( this.constructor(), elems );
	
			// Add the old object onto the stack (as a reference)
			ret.prevObject = this;
			ret.context = this.context;
	
			// Return the newly-formed element set
			return ret;
		},
	
		// Execute a callback for every element in the matched set.
		each: function( callback ) {
			return jQuery.each( this, callback );
		},
	
		map: function( callback ) {
			return this.pushStack( jQuery.map( this, function( elem, i ) {
				return callback.call( elem, i, elem );
			} ) );
		},
	
		slice: function() {
			return this.pushStack( slice.apply( this, arguments ) );
		},
	
		first: function() {
			return this.eq( 0 );
		},
	
		last: function() {
			return this.eq( -1 );
		},
	
		eq: function( i ) {
			var len = this.length,
				j = +i + ( i < 0 ? len : 0 );
			return this.pushStack( j >= 0 && j < len ? [ this[ j ] ] : [] );
		},
	
		end: function() {
			return this.prevObject || this.constructor();
		},
	
		// For internal use only.
		// Behaves like an Array's method, not like a jQuery method.
		push: push,
		sort: deletedIds.sort,
		splice: deletedIds.splice
	};
	
	jQuery.extend = jQuery.fn.extend = function() {
		var src, copyIsArray, copy, name, options, clone,
			target = arguments[ 0 ] || {},
			i = 1,
			length = arguments.length,
			deep = false;
	
		// Handle a deep copy situation
		if ( typeof target === "boolean" ) {
			deep = target;
	
			// skip the boolean and the target
			target = arguments[ i ] || {};
			i++;
		}
	
		// Handle case when target is a string or something (possible in deep copy)
		if ( typeof target !== "object" && !jQuery.isFunction( target ) ) {
			target = {};
		}
	
		// extend jQuery itself if only one argument is passed
		if ( i === length ) {
			target = this;
			i--;
		}
	
		for ( ; i < length; i++ ) {
	
			// Only deal with non-null/undefined values
			if ( ( options = arguments[ i ] ) != null ) {
	
				// Extend the base object
				for ( name in options ) {
					src = target[ name ];
					copy = options[ name ];
	
					// Prevent never-ending loop
					if ( target === copy ) {
						continue;
					}
	
					// Recurse if we're merging plain objects or arrays
					if ( deep && copy && ( jQuery.isPlainObject( copy ) ||
						( copyIsArray = jQuery.isArray( copy ) ) ) ) {
	
						if ( copyIsArray ) {
							copyIsArray = false;
							clone = src && jQuery.isArray( src ) ? src : [];
	
						} else {
							clone = src && jQuery.isPlainObject( src ) ? src : {};
						}
	
						// Never move original objects, clone them
						target[ name ] = jQuery.extend( deep, clone, copy );
	
					// Don't bring in undefined values
					} else if ( copy !== undefined ) {
						target[ name ] = copy;
					}
				}
			}
		}
	
		// Return the modified object
		return target;
	};
	
	jQuery.extend( {
	
		// Unique for each copy of jQuery on the page
		expando: "jQuery" + ( version + Math.random() ).replace( /\D/g, "" ),
	
		// Assume jQuery is ready without the ready module
		isReady: true,
	
		error: function( msg ) {
			throw new Error( msg );
		},
	
		noop: function() {},
	
		// See test/unit/core.js for details concerning isFunction.
		// Since version 1.3, DOM methods and functions like alert
		// aren't supported. They return false on IE (#2968).
		isFunction: function( obj ) {
			return jQuery.type( obj ) === "function";
		},
	
		isArray: Array.isArray || function( obj ) {
			return jQuery.type( obj ) === "array";
		},
	
		isWindow: function( obj ) {
			/* jshint eqeqeq: false */
			return obj != null && obj == obj.window;
		},
	
		isNumeric: function( obj ) {
	
			// parseFloat NaNs numeric-cast false positives (null|true|false|"")
			// ...but misinterprets leading-number strings, particularly hex literals ("0x...")
			// subtraction forces infinities to NaN
			// adding 1 corrects loss of precision from parseFloat (#15100)
			var realStringObj = obj && obj.toString();
			return !jQuery.isArray( obj ) && ( realStringObj - parseFloat( realStringObj ) + 1 ) >= 0;
		},
	
		isEmptyObject: function( obj ) {
			var name;
			for ( name in obj ) {
				return false;
			}
			return true;
		},
	
		isPlainObject: function( obj ) {
			var key;
	
			// Must be an Object.
			// Because of IE, we also have to check the presence of the constructor property.
			// Make sure that DOM nodes and window objects don't pass through, as well
			if ( !obj || jQuery.type( obj ) !== "object" || obj.nodeType || jQuery.isWindow( obj ) ) {
				return false;
			}
	
			try {
	
				// Not own constructor property must be Object
				if ( obj.constructor &&
					!hasOwn.call( obj, "constructor" ) &&
					!hasOwn.call( obj.constructor.prototype, "isPrototypeOf" ) ) {
					return false;
				}
			} catch ( e ) {
	
				// IE8,9 Will throw exceptions on certain host objects #9897
				return false;
			}
	
			// Support: IE<9
			// Handle iteration over inherited properties before own properties.
			if ( !support.ownFirst ) {
				for ( key in obj ) {
					return hasOwn.call( obj, key );
				}
			}
	
			// Own properties are enumerated firstly, so to speed up,
			// if last one is own, then all properties are own.
			for ( key in obj ) {}
	
			return key === undefined || hasOwn.call( obj, key );
		},
	
		type: function( obj ) {
			if ( obj == null ) {
				return obj + "";
			}
			return typeof obj === "object" || typeof obj === "function" ?
				class2type[ toString.call( obj ) ] || "object" :
				typeof obj;
		},
	
		// Workarounds based on findings by Jim Driscoll
		// http://weblogs.java.net/blog/driscoll/archive/2009/09/08/eval-javascript-global-context
		globalEval: function( data ) {
			if ( data && jQuery.trim( data ) ) {
	
				// We use execScript on Internet Explorer
				// We use an anonymous function so that context is window
				// rather than jQuery in Firefox
				( window.execScript || function( data ) {
					window[ "eval" ].call( window, data ); // jscs:ignore requireDotNotation
				} )( data );
			}
		},
	
		// Convert dashed to camelCase; used by the css and data modules
		// Microsoft forgot to hump their vendor prefix (#9572)
		camelCase: function( string ) {
			return string.replace( rmsPrefix, "ms-" ).replace( rdashAlpha, fcamelCase );
		},
	
		nodeName: function( elem, name ) {
			return elem.nodeName && elem.nodeName.toLowerCase() === name.toLowerCase();
		},
	
		each: function( obj, callback ) {
			var length, i = 0;
	
			if ( isArrayLike( obj ) ) {
				length = obj.length;
				for ( ; i < length; i++ ) {
					if ( callback.call( obj[ i ], i, obj[ i ] ) === false ) {
						break;
					}
				}
			} else {
				for ( i in obj ) {
					if ( callback.call( obj[ i ], i, obj[ i ] ) === false ) {
						break;
					}
				}
			}
	
			return obj;
		},
	
		// Support: Android<4.1, IE<9
		trim: function( text ) {
			return text == null ?
				"" :
				( text + "" ).replace( rtrim, "" );
		},
	
		// results is for internal usage only
		makeArray: function( arr, results ) {
			var ret = results || [];
	
			if ( arr != null ) {
				if ( isArrayLike( Object( arr ) ) ) {
					jQuery.merge( ret,
						typeof arr === "string" ?
						[ arr ] : arr
					);
				} else {
					push.call( ret, arr );
				}
			}
	
			return ret;
		},
	
		inArray: function( elem, arr, i ) {
			var len;
	
			if ( arr ) {
				if ( indexOf ) {
					return indexOf.call( arr, elem, i );
				}
	
				len = arr.length;
				i = i ? i < 0 ? Math.max( 0, len + i ) : i : 0;
	
				for ( ; i < len; i++ ) {
	
					// Skip accessing in sparse arrays
					if ( i in arr && arr[ i ] === elem ) {
						return i;
					}
				}
			}
	
			return -1;
		},
	
		merge: function( first, second ) {
			var len = +second.length,
				j = 0,
				i = first.length;
	
			while ( j < len ) {
				first[ i++ ] = second[ j++ ];
			}
	
			// Support: IE<9
			// Workaround casting of .length to NaN on otherwise arraylike objects (e.g., NodeLists)
			if ( len !== len ) {
				while ( second[ j ] !== undefined ) {
					first[ i++ ] = second[ j++ ];
				}
			}
	
			first.length = i;
	
			return first;
		},
	
		grep: function( elems, callback, invert ) {
			var callbackInverse,
				matches = [],
				i = 0,
				length = elems.length,
				callbackExpect = !invert;
	
			// Go through the array, only saving the items
			// that pass the validator function
			for ( ; i < length; i++ ) {
				callbackInverse = !callback( elems[ i ], i );
				if ( callbackInverse !== callbackExpect ) {
					matches.push( elems[ i ] );
				}
			}
	
			return matches;
		},
	
		// arg is for internal usage only
		map: function( elems, callback, arg ) {
			var length, value,
				i = 0,
				ret = [];
	
			// Go through the array, translating each of the items to their new values
			if ( isArrayLike( elems ) ) {
				length = elems.length;
				for ( ; i < length; i++ ) {
					value = callback( elems[ i ], i, arg );
	
					if ( value != null ) {
						ret.push( value );
					}
				}
	
			// Go through every key on the object,
			} else {
				for ( i in elems ) {
					value = callback( elems[ i ], i, arg );
	
					if ( value != null ) {
						ret.push( value );
					}
				}
			}
	
			// Flatten any nested arrays
			return concat.apply( [], ret );
		},
	
		// A global GUID counter for objects
		guid: 1,
	
		// Bind a function to a context, optionally partially applying any
		// arguments.
		proxy: function( fn, context ) {
			var args, proxy, tmp;
	
			if ( typeof context === "string" ) {
				tmp = fn[ context ];
				context = fn;
				fn = tmp;
			}
	
			// Quick check to determine if target is callable, in the spec
			// this throws a TypeError, but we will just return undefined.
			if ( !jQuery.isFunction( fn ) ) {
				return undefined;
			}
	
			// Simulated bind
			args = slice.call( arguments, 2 );
			proxy = function() {
				return fn.apply( context || this, args.concat( slice.call( arguments ) ) );
			};
	
			// Set the guid of unique handler to the same of original handler, so it can be removed
			proxy.guid = fn.guid = fn.guid || jQuery.guid++;
	
			return proxy;
		},
	
		now: function() {
			return +( new Date() );
		},
	
		// jQuery.support is not used in Core but other projects attach their
		// properties to it so it needs to exist.
		support: support
	} );
	
	// JSHint would error on this code due to the Symbol not being defined in ES5.
	// Defining this global in .jshintrc would create a danger of using the global
	// unguarded in another place, it seems safer to just disable JSHint for these
	// three lines.
	/* jshint ignore: start */
	if ( typeof Symbol === "function" ) {
		jQuery.fn[ Symbol.iterator ] = deletedIds[ Symbol.iterator ];
	}
	/* jshint ignore: end */
	
	// Populate the class2type map
	jQuery.each( "Boolean Number String Function Array Date RegExp Object Error Symbol".split( " " ),
	function( i, name ) {
		class2type[ "[object " + name + "]" ] = name.toLowerCase();
	} );
	
	function isArrayLike( obj ) {
	
		// Support: iOS 8.2 (not reproducible in simulator)
		// `in` check used to prevent JIT error (gh-2145)
		// hasOwn isn't used here due to false negatives
		// regarding Nodelist length in IE
		var length = !!obj && "length" in obj && obj.length,
			type = jQuery.type( obj );
	
		if ( type === "function" || jQuery.isWindow( obj ) ) {
			return false;
		}
	
		return type === "array" || length === 0 ||
			typeof length === "number" && length > 0 && ( length - 1 ) in obj;
	}
	var Sizzle =
	/*!
	 * Sizzle CSS Selector Engine v2.2.1
	 * http://sizzlejs.com/
	 *
	 * Copyright jQuery Foundation and other contributors
	 * Released under the MIT license
	 * http://jquery.org/license
	 *
	 * Date: 2015-10-17
	 */
	(function( window ) {
	
	var i,
		support,
		Expr,
		getText,
		isXML,
		tokenize,
		compile,
		select,
		outermostContext,
		sortInput,
		hasDuplicate,
	
		// Local document vars
		setDocument,
		document,
		docElem,
		documentIsHTML,
		rbuggyQSA,
		rbuggyMatches,
		matches,
		contains,
	
		// Instance-specific data
		expando = "sizzle" + 1 * new Date(),
		preferredDoc = window.document,
		dirruns = 0,
		done = 0,
		classCache = createCache(),
		tokenCache = createCache(),
		compilerCache = createCache(),
		sortOrder = function( a, b ) {
			if ( a === b ) {
				hasDuplicate = true;
			}
			return 0;
		},
	
		// General-purpose constants
		MAX_NEGATIVE = 1 << 31,
	
		// Instance methods
		hasOwn = ({}).hasOwnProperty,
		arr = [],
		pop = arr.pop,
		push_native = arr.push,
		push = arr.push,
		slice = arr.slice,
		// Use a stripped-down indexOf as it's faster than native
		// http://jsperf.com/thor-indexof-vs-for/5
		indexOf = function( list, elem ) {
			var i = 0,
				len = list.length;
			for ( ; i < len; i++ ) {
				if ( list[i] === elem ) {
					return i;
				}
			}
			return -1;
		},
	
		booleans = "checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|ismap|loop|multiple|open|readonly|required|scoped",
	
		// Regular expressions
	
		// http://www.w3.org/TR/css3-selectors/#whitespace
		whitespace = "[\\x20\\t\\r\\n\\f]",
	
		// http://www.w3.org/TR/CSS21/syndata.html#value-def-identifier
		identifier = "(?:\\\\.|[\\w-]|[^\\x00-\\xa0])+",
	
		// Attribute selectors: http://www.w3.org/TR/selectors/#attribute-selectors
		attributes = "\\[" + whitespace + "*(" + identifier + ")(?:" + whitespace +
			// Operator (capture 2)
			"*([*^$|!~]?=)" + whitespace +
			// "Attribute values must be CSS identifiers [capture 5] or strings [capture 3 or capture 4]"
			"*(?:'((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\"|(" + identifier + "))|)" + whitespace +
			"*\\]",
	
		pseudos = ":(" + identifier + ")(?:\\((" +
			// To reduce the number of selectors needing tokenize in the preFilter, prefer arguments:
			// 1. quoted (capture 3; capture 4 or capture 5)
			"('((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\")|" +
			// 2. simple (capture 6)
			"((?:\\\\.|[^\\\\()[\\]]|" + attributes + ")*)|" +
			// 3. anything else (capture 2)
			".*" +
			")\\)|)",
	
		// Leading and non-escaped trailing whitespace, capturing some non-whitespace characters preceding the latter
		rwhitespace = new RegExp( whitespace + "+", "g" ),
		rtrim = new RegExp( "^" + whitespace + "+|((?:^|[^\\\\])(?:\\\\.)*)" + whitespace + "+$", "g" ),
	
		rcomma = new RegExp( "^" + whitespace + "*," + whitespace + "*" ),
		rcombinators = new RegExp( "^" + whitespace + "*([>+~]|" + whitespace + ")" + whitespace + "*" ),
	
		rattributeQuotes = new RegExp( "=" + whitespace + "*([^\\]'\"]*?)" + whitespace + "*\\]", "g" ),
	
		rpseudo = new RegExp( pseudos ),
		ridentifier = new RegExp( "^" + identifier + "$" ),
	
		matchExpr = {
			"ID": new RegExp( "^#(" + identifier + ")" ),
			"CLASS": new RegExp( "^\\.(" + identifier + ")" ),
			"TAG": new RegExp( "^(" + identifier + "|[*])" ),
			"ATTR": new RegExp( "^" + attributes ),
			"PSEUDO": new RegExp( "^" + pseudos ),
			"CHILD": new RegExp( "^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\(" + whitespace +
				"*(even|odd|(([+-]|)(\\d*)n|)" + whitespace + "*(?:([+-]|)" + whitespace +
				"*(\\d+)|))" + whitespace + "*\\)|)", "i" ),
			"bool": new RegExp( "^(?:" + booleans + ")$", "i" ),
			// For use in libraries implementing .is()
			// We use this for POS matching in `select`
			"needsContext": new RegExp( "^" + whitespace + "*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\(" +
				whitespace + "*((?:-\\d)?\\d*)" + whitespace + "*\\)|)(?=[^-]|$)", "i" )
		},
	
		rinputs = /^(?:input|select|textarea|button)$/i,
		rheader = /^h\d$/i,
	
		rnative = /^[^{]+\{\s*\[native \w/,
	
		// Easily-parseable/retrievable ID or TAG or CLASS selectors
		rquickExpr = /^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/,
	
		rsibling = /[+~]/,
		rescape = /'|\\/g,
	
		// CSS escapes http://www.w3.org/TR/CSS21/syndata.html#escaped-characters
		runescape = new RegExp( "\\\\([\\da-f]{1,6}" + whitespace + "?|(" + whitespace + ")|.)", "ig" ),
		funescape = function( _, escaped, escapedWhitespace ) {
			var high = "0x" + escaped - 0x10000;
			// NaN means non-codepoint
			// Support: Firefox<24
			// Workaround erroneous numeric interpretation of +"0x"
			return high !== high || escapedWhitespace ?
				escaped :
				high < 0 ?
					// BMP codepoint
					String.fromCharCode( high + 0x10000 ) :
					// Supplemental Plane codepoint (surrogate pair)
					String.fromCharCode( high >> 10 | 0xD800, high & 0x3FF | 0xDC00 );
		},
	
		// Used for iframes
		// See setDocument()
		// Removing the function wrapper causes a "Permission Denied"
		// error in IE
		unloadHandler = function() {
			setDocument();
		};
	
	// Optimize for push.apply( _, NodeList )
	try {
		push.apply(
			(arr = slice.call( preferredDoc.childNodes )),
			preferredDoc.childNodes
		);
		// Support: Android<4.0
		// Detect silently failing push.apply
		arr[ preferredDoc.childNodes.length ].nodeType;
	} catch ( e ) {
		push = { apply: arr.length ?
	
			// Leverage slice if possible
			function( target, els ) {
				push_native.apply( target, slice.call(els) );
			} :
	
			// Support: IE<9
			// Otherwise append directly
			function( target, els ) {
				var j = target.length,
					i = 0;
				// Can't trust NodeList.length
				while ( (target[j++] = els[i++]) ) {}
				target.length = j - 1;
			}
		};
	}
	
	function Sizzle( selector, context, results, seed ) {
		var m, i, elem, nid, nidselect, match, groups, newSelector,
			newContext = context && context.ownerDocument,
	
			// nodeType defaults to 9, since context defaults to document
			nodeType = context ? context.nodeType : 9;
	
		results = results || [];
	
		// Return early from calls with invalid selector or context
		if ( typeof selector !== "string" || !selector ||
			nodeType !== 1 && nodeType !== 9 && nodeType !== 11 ) {
	
			return results;
		}
	
		// Try to shortcut find operations (as opposed to filters) in HTML documents
		if ( !seed ) {
	
			if ( ( context ? context.ownerDocument || context : preferredDoc ) !== document ) {
				setDocument( context );
			}
			context = context || document;
	
			if ( documentIsHTML ) {
	
				// If the selector is sufficiently simple, try using a "get*By*" DOM method
				// (excepting DocumentFragment context, where the methods don't exist)
				if ( nodeType !== 11 && (match = rquickExpr.exec( selector )) ) {
	
					// ID selector
					if ( (m = match[1]) ) {
	
						// Document context
						if ( nodeType === 9 ) {
							if ( (elem = context.getElementById( m )) ) {
	
								// Support: IE, Opera, Webkit
								// TODO: identify versions
								// getElementById can match elements by name instead of ID
								if ( elem.id === m ) {
									results.push( elem );
									return results;
								}
							} else {
								return results;
							}
	
						// Element context
						} else {
	
							// Support: IE, Opera, Webkit
							// TODO: identify versions
							// getElementById can match elements by name instead of ID
							if ( newContext && (elem = newContext.getElementById( m )) &&
								contains( context, elem ) &&
								elem.id === m ) {
	
								results.push( elem );
								return results;
							}
						}
	
					// Type selector
					} else if ( match[2] ) {
						push.apply( results, context.getElementsByTagName( selector ) );
						return results;
	
					// Class selector
					} else if ( (m = match[3]) && support.getElementsByClassName &&
						context.getElementsByClassName ) {
	
						push.apply( results, context.getElementsByClassName( m ) );
						return results;
					}
				}
	
				// Take advantage of querySelectorAll
				if ( support.qsa &&
					!compilerCache[ selector + " " ] &&
					(!rbuggyQSA || !rbuggyQSA.test( selector )) ) {
	
					if ( nodeType !== 1 ) {
						newContext = context;
						newSelector = selector;
	
					// qSA looks outside Element context, which is not what we want
					// Thanks to Andrew Dupont for this workaround technique
					// Support: IE <=8
					// Exclude object elements
					} else if ( context.nodeName.toLowerCase() !== "object" ) {
	
						// Capture the context ID, setting it first if necessary
						if ( (nid = context.getAttribute( "id" )) ) {
							nid = nid.replace( rescape, "\\$&" );
						} else {
							context.setAttribute( "id", (nid = expando) );
						}
	
						// Prefix every selector in the list
						groups = tokenize( selector );
						i = groups.length;
						nidselect = ridentifier.test( nid ) ? "#" + nid : "[id='" + nid + "']";
						while ( i-- ) {
							groups[i] = nidselect + " " + toSelector( groups[i] );
						}
						newSelector = groups.join( "," );
	
						// Expand context for sibling selectors
						newContext = rsibling.test( selector ) && testContext( context.parentNode ) ||
							context;
					}
	
					if ( newSelector ) {
						try {
							push.apply( results,
								newContext.querySelectorAll( newSelector )
							);
							return results;
						} catch ( qsaError ) {
						} finally {
							if ( nid === expando ) {
								context.removeAttribute( "id" );
							}
						}
					}
				}
			}
		}
	
		// All others
		return select( selector.replace( rtrim, "$1" ), context, results, seed );
	}
	
	/**
	 * Create key-value caches of limited size
	 * @returns {function(string, object)} Returns the Object data after storing it on itself with
	 *	property name the (space-suffixed) string and (if the cache is larger than Expr.cacheLength)
	 *	deleting the oldest entry
	 */
	function createCache() {
		var keys = [];
	
		function cache( key, value ) {
			// Use (key + " ") to avoid collision with native prototype properties (see Issue #157)
			if ( keys.push( key + " " ) > Expr.cacheLength ) {
				// Only keep the most recent entries
				delete cache[ keys.shift() ];
			}
			return (cache[ key + " " ] = value);
		}
		return cache;
	}
	
	/**
	 * Mark a function for special use by Sizzle
	 * @param {Function} fn The function to mark
	 */
	function markFunction( fn ) {
		fn[ expando ] = true;
		return fn;
	}
	
	/**
	 * Support testing using an element
	 * @param {Function} fn Passed the created div and expects a boolean result
	 */
	function assert( fn ) {
		var div = document.createElement("div");
	
		try {
			return !!fn( div );
		} catch (e) {
			return false;
		} finally {
			// Remove from its parent by default
			if ( div.parentNode ) {
				div.parentNode.removeChild( div );
			}
			// release memory in IE
			div = null;
		}
	}
	
	/**
	 * Adds the same handler for all of the specified attrs
	 * @param {String} attrs Pipe-separated list of attributes
	 * @param {Function} handler The method that will be applied
	 */
	function addHandle( attrs, handler ) {
		var arr = attrs.split("|"),
			i = arr.length;
	
		while ( i-- ) {
			Expr.attrHandle[ arr[i] ] = handler;
		}
	}
	
	/**
	 * Checks document order of two siblings
	 * @param {Element} a
	 * @param {Element} b
	 * @returns {Number} Returns less than 0 if a precedes b, greater than 0 if a follows b
	 */
	function siblingCheck( a, b ) {
		var cur = b && a,
			diff = cur && a.nodeType === 1 && b.nodeType === 1 &&
				( ~b.sourceIndex || MAX_NEGATIVE ) -
				( ~a.sourceIndex || MAX_NEGATIVE );
	
		// Use IE sourceIndex if available on both nodes
		if ( diff ) {
			return diff;
		}
	
		// Check if b follows a
		if ( cur ) {
			while ( (cur = cur.nextSibling) ) {
				if ( cur === b ) {
					return -1;
				}
			}
		}
	
		return a ? 1 : -1;
	}
	
	/**
	 * Returns a function to use in pseudos for input types
	 * @param {String} type
	 */
	function createInputPseudo( type ) {
		return function( elem ) {
			var name = elem.nodeName.toLowerCase();
			return name === "input" && elem.type === type;
		};
	}
	
	/**
	 * Returns a function to use in pseudos for buttons
	 * @param {String} type
	 */
	function createButtonPseudo( type ) {
		return function( elem ) {
			var name = elem.nodeName.toLowerCase();
			return (name === "input" || name === "button") && elem.type === type;
		};
	}
	
	/**
	 * Returns a function to use in pseudos for positionals
	 * @param {Function} fn
	 */
	function createPositionalPseudo( fn ) {
		return markFunction(function( argument ) {
			argument = +argument;
			return markFunction(function( seed, matches ) {
				var j,
					matchIndexes = fn( [], seed.length, argument ),
					i = matchIndexes.length;
	
				// Match elements found at the specified indexes
				while ( i-- ) {
					if ( seed[ (j = matchIndexes[i]) ] ) {
						seed[j] = !(matches[j] = seed[j]);
					}
				}
			});
		});
	}
	
	/**
	 * Checks a node for validity as a Sizzle context
	 * @param {Element|Object=} context
	 * @returns {Element|Object|Boolean} The input node if acceptable, otherwise a falsy value
	 */
	function testContext( context ) {
		return context && typeof context.getElementsByTagName !== "undefined" && context;
	}
	
	// Expose support vars for convenience
	support = Sizzle.support = {};
	
	/**
	 * Detects XML nodes
	 * @param {Element|Object} elem An element or a document
	 * @returns {Boolean} True iff elem is a non-HTML XML node
	 */
	isXML = Sizzle.isXML = function( elem ) {
		// documentElement is verified for cases where it doesn't yet exist
		// (such as loading iframes in IE - #4833)
		var documentElement = elem && (elem.ownerDocument || elem).documentElement;
		return documentElement ? documentElement.nodeName !== "HTML" : false;
	};
	
	/**
	 * Sets document-related variables once based on the current document
	 * @param {Element|Object} [doc] An element or document object to use to set the document
	 * @returns {Object} Returns the current document
	 */
	setDocument = Sizzle.setDocument = function( node ) {
		var hasCompare, parent,
			doc = node ? node.ownerDocument || node : preferredDoc;
	
		// Return early if doc is invalid or already selected
		if ( doc === document || doc.nodeType !== 9 || !doc.documentElement ) {
			return document;
		}
	
		// Update global variables
		document = doc;
		docElem = document.documentElement;
		documentIsHTML = !isXML( document );
	
		// Support: IE 9-11, Edge
		// Accessing iframe documents after unload throws "permission denied" errors (jQuery #13936)
		if ( (parent = document.defaultView) && parent.top !== parent ) {
			// Support: IE 11
			if ( parent.addEventListener ) {
				parent.addEventListener( "unload", unloadHandler, false );
	
			// Support: IE 9 - 10 only
			} else if ( parent.attachEvent ) {
				parent.attachEvent( "onunload", unloadHandler );
			}
		}
	
		/* Attributes
		---------------------------------------------------------------------- */
	
		// Support: IE<8
		// Verify that getAttribute really returns attributes and not properties
		// (excepting IE8 booleans)
		support.attributes = assert(function( div ) {
			div.className = "i";
			return !div.getAttribute("className");
		});
	
		/* getElement(s)By*
		---------------------------------------------------------------------- */
	
		// Check if getElementsByTagName("*") returns only elements
		support.getElementsByTagName = assert(function( div ) {
			div.appendChild( document.createComment("") );
			return !div.getElementsByTagName("*").length;
		});
	
		// Support: IE<9
		support.getElementsByClassName = rnative.test( document.getElementsByClassName );
	
		// Support: IE<10
		// Check if getElementById returns elements by name
		// The broken getElementById methods don't pick up programatically-set names,
		// so use a roundabout getElementsByName test
		support.getById = assert(function( div ) {
			docElem.appendChild( div ).id = expando;
			return !document.getElementsByName || !document.getElementsByName( expando ).length;
		});
	
		// ID find and filter
		if ( support.getById ) {
			Expr.find["ID"] = function( id, context ) {
				if ( typeof context.getElementById !== "undefined" && documentIsHTML ) {
					var m = context.getElementById( id );
					return m ? [ m ] : [];
				}
			};
			Expr.filter["ID"] = function( id ) {
				var attrId = id.replace( runescape, funescape );
				return function( elem ) {
					return elem.getAttribute("id") === attrId;
				};
			};
		} else {
			// Support: IE6/7
			// getElementById is not reliable as a find shortcut
			delete Expr.find["ID"];
	
			Expr.filter["ID"] =  function( id ) {
				var attrId = id.replace( runescape, funescape );
				return function( elem ) {
					var node = typeof elem.getAttributeNode !== "undefined" &&
						elem.getAttributeNode("id");
					return node && node.value === attrId;
				};
			};
		}
	
		// Tag
		Expr.find["TAG"] = support.getElementsByTagName ?
			function( tag, context ) {
				if ( typeof context.getElementsByTagName !== "undefined" ) {
					return context.getElementsByTagName( tag );
	
				// DocumentFragment nodes don't have gEBTN
				} else if ( support.qsa ) {
					return context.querySelectorAll( tag );
				}
			} :
	
			function( tag, context ) {
				var elem,
					tmp = [],
					i = 0,
					// By happy coincidence, a (broken) gEBTN appears on DocumentFragment nodes too
					results = context.getElementsByTagName( tag );
	
				// Filter out possible comments
				if ( tag === "*" ) {
					while ( (elem = results[i++]) ) {
						if ( elem.nodeType === 1 ) {
							tmp.push( elem );
						}
					}
	
					return tmp;
				}
				return results;
			};
	
		// Class
		Expr.find["CLASS"] = support.getElementsByClassName && function( className, context ) {
			if ( typeof context.getElementsByClassName !== "undefined" && documentIsHTML ) {
				return context.getElementsByClassName( className );
			}
		};
	
		/* QSA/matchesSelector
		---------------------------------------------------------------------- */
	
		// QSA and matchesSelector support
	
		// matchesSelector(:active) reports false when true (IE9/Opera 11.5)
		rbuggyMatches = [];
	
		// qSa(:focus) reports false when true (Chrome 21)
		// We allow this because of a bug in IE8/9 that throws an error
		// whenever `document.activeElement` is accessed on an iframe
		// So, we allow :focus to pass through QSA all the time to avoid the IE error
		// See http://bugs.jquery.com/ticket/13378
		rbuggyQSA = [];
	
		if ( (support.qsa = rnative.test( document.querySelectorAll )) ) {
			// Build QSA regex
			// Regex strategy adopted from Diego Perini
			assert(function( div ) {
				// Select is set to empty string on purpose
				// This is to test IE's treatment of not explicitly
				// setting a boolean content attribute,
				// since its presence should be enough
				// http://bugs.jquery.com/ticket/12359
				docElem.appendChild( div ).innerHTML = "<a id='" + expando + "'></a>" +
					"<select id='" + expando + "-\r\\' msallowcapture=''>" +
					"<option selected=''></option></select>";
	
				// Support: IE8, Opera 11-12.16
				// Nothing should be selected when empty strings follow ^= or $= or *=
				// The test attribute must be unknown in Opera but "safe" for WinRT
				// http://msdn.microsoft.com/en-us/library/ie/hh465388.aspx#attribute_section
				if ( div.querySelectorAll("[msallowcapture^='']").length ) {
					rbuggyQSA.push( "[*^$]=" + whitespace + "*(?:''|\"\")" );
				}
	
				// Support: IE8
				// Boolean attributes and "value" are not treated correctly
				if ( !div.querySelectorAll("[selected]").length ) {
					rbuggyQSA.push( "\\[" + whitespace + "*(?:value|" + booleans + ")" );
				}
	
				// Support: Chrome<29, Android<4.4, Safari<7.0+, iOS<7.0+, PhantomJS<1.9.8+
				if ( !div.querySelectorAll( "[id~=" + expando + "-]" ).length ) {
					rbuggyQSA.push("~=");
				}
	
				// Webkit/Opera - :checked should return selected option elements
				// http://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
				// IE8 throws error here and will not see later tests
				if ( !div.querySelectorAll(":checked").length ) {
					rbuggyQSA.push(":checked");
				}
	
				// Support: Safari 8+, iOS 8+
				// https://bugs.webkit.org/show_bug.cgi?id=136851
				// In-page `selector#id sibing-combinator selector` fails
				if ( !div.querySelectorAll( "a#" + expando + "+*" ).length ) {
					rbuggyQSA.push(".#.+[+~]");
				}
			});
	
			assert(function( div ) {
				// Support: Windows 8 Native Apps
				// The type and name attributes are restricted during .innerHTML assignment
				var input = document.createElement("input");
				input.setAttribute( "type", "hidden" );
				div.appendChild( input ).setAttribute( "name", "D" );
	
				// Support: IE8
				// Enforce case-sensitivity of name attribute
				if ( div.querySelectorAll("[name=d]").length ) {
					rbuggyQSA.push( "name" + whitespace + "*[*^$|!~]?=" );
				}
	
				// FF 3.5 - :enabled/:disabled and hidden elements (hidden elements are still enabled)
				// IE8 throws error here and will not see later tests
				if ( !div.querySelectorAll(":enabled").length ) {
					rbuggyQSA.push( ":enabled", ":disabled" );
				}
	
				// Opera 10-11 does not throw on post-comma invalid pseudos
				div.querySelectorAll("*,:x");
				rbuggyQSA.push(",.*:");
			});
		}
	
		if ( (support.matchesSelector = rnative.test( (matches = docElem.matches ||
			docElem.webkitMatchesSelector ||
			docElem.mozMatchesSelector ||
			docElem.oMatchesSelector ||
			docElem.msMatchesSelector) )) ) {
	
			assert(function( div ) {
				// Check to see if it's possible to do matchesSelector
				// on a disconnected node (IE 9)
				support.disconnectedMatch = matches.call( div, "div" );
	
				// This should fail with an exception
				// Gecko does not error, returns false instead
				matches.call( div, "[s!='']:x" );
				rbuggyMatches.push( "!=", pseudos );
			});
		}
	
		rbuggyQSA = rbuggyQSA.length && new RegExp( rbuggyQSA.join("|") );
		rbuggyMatches = rbuggyMatches.length && new RegExp( rbuggyMatches.join("|") );
	
		/* Contains
		---------------------------------------------------------------------- */
		hasCompare = rnative.test( docElem.compareDocumentPosition );
	
		// Element contains another
		// Purposefully self-exclusive
		// As in, an element does not contain itself
		contains = hasCompare || rnative.test( docElem.contains ) ?
			function( a, b ) {
				var adown = a.nodeType === 9 ? a.documentElement : a,
					bup = b && b.parentNode;
				return a === bup || !!( bup && bup.nodeType === 1 && (
					adown.contains ?
						adown.contains( bup ) :
						a.compareDocumentPosition && a.compareDocumentPosition( bup ) & 16
				));
			} :
			function( a, b ) {
				if ( b ) {
					while ( (b = b.parentNode) ) {
						if ( b === a ) {
							return true;
						}
					}
				}
				return false;
			};
	
		/* Sorting
		---------------------------------------------------------------------- */
	
		// Document order sorting
		sortOrder = hasCompare ?
		function( a, b ) {
	
			// Flag for duplicate removal
			if ( a === b ) {
				hasDuplicate = true;
				return 0;
			}
	
			// Sort on method existence if only one input has compareDocumentPosition
			var compare = !a.compareDocumentPosition - !b.compareDocumentPosition;
			if ( compare ) {
				return compare;
			}
	
			// Calculate position if both inputs belong to the same document
			compare = ( a.ownerDocument || a ) === ( b.ownerDocument || b ) ?
				a.compareDocumentPosition( b ) :
	
				// Otherwise we know they are disconnected
				1;
	
			// Disconnected nodes
			if ( compare & 1 ||
				(!support.sortDetached && b.compareDocumentPosition( a ) === compare) ) {
	
				// Choose the first element that is related to our preferred document
				if ( a === document || a.ownerDocument === preferredDoc && contains(preferredDoc, a) ) {
					return -1;
				}
				if ( b === document || b.ownerDocument === preferredDoc && contains(preferredDoc, b) ) {
					return 1;
				}
	
				// Maintain original order
				return sortInput ?
					( indexOf( sortInput, a ) - indexOf( sortInput, b ) ) :
					0;
			}
	
			return compare & 4 ? -1 : 1;
		} :
		function( a, b ) {
			// Exit early if the nodes are identical
			if ( a === b ) {
				hasDuplicate = true;
				return 0;
			}
	
			var cur,
				i = 0,
				aup = a.parentNode,
				bup = b.parentNode,
				ap = [ a ],
				bp = [ b ];
	
			// Parentless nodes are either documents or disconnected
			if ( !aup || !bup ) {
				return a === document ? -1 :
					b === document ? 1 :
					aup ? -1 :
					bup ? 1 :
					sortInput ?
					( indexOf( sortInput, a ) - indexOf( sortInput, b ) ) :
					0;
	
			// If the nodes are siblings, we can do a quick check
			} else if ( aup === bup ) {
				return siblingCheck( a, b );
			}
	
			// Otherwise we need full lists of their ancestors for comparison
			cur = a;
			while ( (cur = cur.parentNode) ) {
				ap.unshift( cur );
			}
			cur = b;
			while ( (cur = cur.parentNode) ) {
				bp.unshift( cur );
			}
	
			// Walk down the tree looking for a discrepancy
			while ( ap[i] === bp[i] ) {
				i++;
			}
	
			return i ?
				// Do a sibling check if the nodes have a common ancestor
				siblingCheck( ap[i], bp[i] ) :
	
				// Otherwise nodes in our document sort first
				ap[i] === preferredDoc ? -1 :
				bp[i] === preferredDoc ? 1 :
				0;
		};
	
		return document;
	};
	
	Sizzle.matches = function( expr, elements ) {
		return Sizzle( expr, null, null, elements );
	};
	
	Sizzle.matchesSelector = function( elem, expr ) {
		// Set document vars if needed
		if ( ( elem.ownerDocument || elem ) !== document ) {
			setDocument( elem );
		}
	
		// Make sure that attribute selectors are quoted
		expr = expr.replace( rattributeQuotes, "='$1']" );
	
		if ( support.matchesSelector && documentIsHTML &&
			!compilerCache[ expr + " " ] &&
			( !rbuggyMatches || !rbuggyMatches.test( expr ) ) &&
			( !rbuggyQSA     || !rbuggyQSA.test( expr ) ) ) {
	
			try {
				var ret = matches.call( elem, expr );
	
				// IE 9's matchesSelector returns false on disconnected nodes
				if ( ret || support.disconnectedMatch ||
						// As well, disconnected nodes are said to be in a document
						// fragment in IE 9
						elem.document && elem.document.nodeType !== 11 ) {
					return ret;
				}
			} catch (e) {}
		}
	
		return Sizzle( expr, document, null, [ elem ] ).length > 0;
	};
	
	Sizzle.contains = function( context, elem ) {
		// Set document vars if needed
		if ( ( context.ownerDocument || context ) !== document ) {
			setDocument( context );
		}
		return contains( context, elem );
	};
	
	Sizzle.attr = function( elem, name ) {
		// Set document vars if needed
		if ( ( elem.ownerDocument || elem ) !== document ) {
			setDocument( elem );
		}
	
		var fn = Expr.attrHandle[ name.toLowerCase() ],
			// Don't get fooled by Object.prototype properties (jQuery #13807)
			val = fn && hasOwn.call( Expr.attrHandle, name.toLowerCase() ) ?
				fn( elem, name, !documentIsHTML ) :
				undefined;
	
		return val !== undefined ?
			val :
			support.attributes || !documentIsHTML ?
				elem.getAttribute( name ) :
				(val = elem.getAttributeNode(name)) && val.specified ?
					val.value :
					null;
	};
	
	Sizzle.error = function( msg ) {
		throw new Error( "Syntax error, unrecognized expression: " + msg );
	};
	
	/**
	 * Document sorting and removing duplicates
	 * @param {ArrayLike} results
	 */
	Sizzle.uniqueSort = function( results ) {
		var elem,
			duplicates = [],
			j = 0,
			i = 0;
	
		// Unless we *know* we can detect duplicates, assume their presence
		hasDuplicate = !support.detectDuplicates;
		sortInput = !support.sortStable && results.slice( 0 );
		results.sort( sortOrder );
	
		if ( hasDuplicate ) {
			while ( (elem = results[i++]) ) {
				if ( elem === results[ i ] ) {
					j = duplicates.push( i );
				}
			}
			while ( j-- ) {
				results.splice( duplicates[ j ], 1 );
			}
		}
	
		// Clear input after sorting to release objects
		// See https://github.com/jquery/sizzle/pull/225
		sortInput = null;
	
		return results;
	};
	
	/**
	 * Utility function for retrieving the text value of an array of DOM nodes
	 * @param {Array|Element} elem
	 */
	getText = Sizzle.getText = function( elem ) {
		var node,
			ret = "",
			i = 0,
			nodeType = elem.nodeType;
	
		if ( !nodeType ) {
			// If no nodeType, this is expected to be an array
			while ( (node = elem[i++]) ) {
				// Do not traverse comment nodes
				ret += getText( node );
			}
		} else if ( nodeType === 1 || nodeType === 9 || nodeType === 11 ) {
			// Use textContent for elements
			// innerText usage removed for consistency of new lines (jQuery #11153)
			if ( typeof elem.textContent === "string" ) {
				return elem.textContent;
			} else {
				// Traverse its children
				for ( elem = elem.firstChild; elem; elem = elem.nextSibling ) {
					ret += getText( elem );
				}
			}
		} else if ( nodeType === 3 || nodeType === 4 ) {
			return elem.nodeValue;
		}
		// Do not include comment or processing instruction nodes
	
		return ret;
	};
	
	Expr = Sizzle.selectors = {
	
		// Can be adjusted by the user
		cacheLength: 50,
	
		createPseudo: markFunction,
	
		match: matchExpr,
	
		attrHandle: {},
	
		find: {},
	
		relative: {
			">": { dir: "parentNode", first: true },
			" ": { dir: "parentNode" },
			"+": { dir: "previousSibling", first: true },
			"~": { dir: "previousSibling" }
		},
	
		preFilter: {
			"ATTR": function( match ) {
				match[1] = match[1].replace( runescape, funescape );
	
				// Move the given value to match[3] whether quoted or unquoted
				match[3] = ( match[3] || match[4] || match[5] || "" ).replace( runescape, funescape );
	
				if ( match[2] === "~=" ) {
					match[3] = " " + match[3] + " ";
				}
	
				return match.slice( 0, 4 );
			},
	
			"CHILD": function( match ) {
				/* matches from matchExpr["CHILD"]
					1 type (only|nth|...)
					2 what (child|of-type)
					3 argument (even|odd|\d*|\d*n([+-]\d+)?|...)
					4 xn-component of xn+y argument ([+-]?\d*n|)
					5 sign of xn-component
					6 x of xn-component
					7 sign of y-component
					8 y of y-component
				*/
				match[1] = match[1].toLowerCase();
	
				if ( match[1].slice( 0, 3 ) === "nth" ) {
					// nth-* requires argument
					if ( !match[3] ) {
						Sizzle.error( match[0] );
					}
	
					// numeric x and y parameters for Expr.filter.CHILD
					// remember that false/true cast respectively to 0/1
					match[4] = +( match[4] ? match[5] + (match[6] || 1) : 2 * ( match[3] === "even" || match[3] === "odd" ) );
					match[5] = +( ( match[7] + match[8] ) || match[3] === "odd" );
	
				// other types prohibit arguments
				} else if ( match[3] ) {
					Sizzle.error( match[0] );
				}
	
				return match;
			},
	
			"PSEUDO": function( match ) {
				var excess,
					unquoted = !match[6] && match[2];
	
				if ( matchExpr["CHILD"].test( match[0] ) ) {
					return null;
				}
	
				// Accept quoted arguments as-is
				if ( match[3] ) {
					match[2] = match[4] || match[5] || "";
	
				// Strip excess characters from unquoted arguments
				} else if ( unquoted && rpseudo.test( unquoted ) &&
					// Get excess from tokenize (recursively)
					(excess = tokenize( unquoted, true )) &&
					// advance to the next closing parenthesis
					(excess = unquoted.indexOf( ")", unquoted.length - excess ) - unquoted.length) ) {
	
					// excess is a negative index
					match[0] = match[0].slice( 0, excess );
					match[2] = unquoted.slice( 0, excess );
				}
	
				// Return only captures needed by the pseudo filter method (type and argument)
				return match.slice( 0, 3 );
			}
		},
	
		filter: {
	
			"TAG": function( nodeNameSelector ) {
				var nodeName = nodeNameSelector.replace( runescape, funescape ).toLowerCase();
				return nodeNameSelector === "*" ?
					function() { return true; } :
					function( elem ) {
						return elem.nodeName && elem.nodeName.toLowerCase() === nodeName;
					};
			},
	
			"CLASS": function( className ) {
				var pattern = classCache[ className + " " ];
	
				return pattern ||
					(pattern = new RegExp( "(^|" + whitespace + ")" + className + "(" + whitespace + "|$)" )) &&
					classCache( className, function( elem ) {
						return pattern.test( typeof elem.className === "string" && elem.className || typeof elem.getAttribute !== "undefined" && elem.getAttribute("class") || "" );
					});
			},
	
			"ATTR": function( name, operator, check ) {
				return function( elem ) {
					var result = Sizzle.attr( elem, name );
	
					if ( result == null ) {
						return operator === "!=";
					}
					if ( !operator ) {
						return true;
					}
	
					result += "";
	
					return operator === "=" ? result === check :
						operator === "!=" ? result !== check :
						operator === "^=" ? check && result.indexOf( check ) === 0 :
						operator === "*=" ? check && result.indexOf( check ) > -1 :
						operator === "$=" ? check && result.slice( -check.length ) === check :
						operator === "~=" ? ( " " + result.replace( rwhitespace, " " ) + " " ).indexOf( check ) > -1 :
						operator === "|=" ? result === check || result.slice( 0, check.length + 1 ) === check + "-" :
						false;
				};
			},
	
			"CHILD": function( type, what, argument, first, last ) {
				var simple = type.slice( 0, 3 ) !== "nth",
					forward = type.slice( -4 ) !== "last",
					ofType = what === "of-type";
	
				return first === 1 && last === 0 ?
	
					// Shortcut for :nth-*(n)
					function( elem ) {
						return !!elem.parentNode;
					} :
	
					function( elem, context, xml ) {
						var cache, uniqueCache, outerCache, node, nodeIndex, start,
							dir = simple !== forward ? "nextSibling" : "previousSibling",
							parent = elem.parentNode,
							name = ofType && elem.nodeName.toLowerCase(),
							useCache = !xml && !ofType,
							diff = false;
	
						if ( parent ) {
	
							// :(first|last|only)-(child|of-type)
							if ( simple ) {
								while ( dir ) {
									node = elem;
									while ( (node = node[ dir ]) ) {
										if ( ofType ?
											node.nodeName.toLowerCase() === name :
											node.nodeType === 1 ) {
	
											return false;
										}
									}
									// Reverse direction for :only-* (if we haven't yet done so)
									start = dir = type === "only" && !start && "nextSibling";
								}
								return true;
							}
	
							start = [ forward ? parent.firstChild : parent.lastChild ];
	
							// non-xml :nth-child(...) stores cache data on `parent`
							if ( forward && useCache ) {
	
								// Seek `elem` from a previously-cached index
	
								// ...in a gzip-friendly way
								node = parent;
								outerCache = node[ expando ] || (node[ expando ] = {});
	
								// Support: IE <9 only
								// Defend against cloned attroperties (jQuery gh-1709)
								uniqueCache = outerCache[ node.uniqueID ] ||
									(outerCache[ node.uniqueID ] = {});
	
								cache = uniqueCache[ type ] || [];
								nodeIndex = cache[ 0 ] === dirruns && cache[ 1 ];
								diff = nodeIndex && cache[ 2 ];
								node = nodeIndex && parent.childNodes[ nodeIndex ];
	
								while ( (node = ++nodeIndex && node && node[ dir ] ||
	
									// Fallback to seeking `elem` from the start
									(diff = nodeIndex = 0) || start.pop()) ) {
	
									// When found, cache indexes on `parent` and break
									if ( node.nodeType === 1 && ++diff && node === elem ) {
										uniqueCache[ type ] = [ dirruns, nodeIndex, diff ];
										break;
									}
								}
	
							} else {
								// Use previously-cached element index if available
								if ( useCache ) {
									// ...in a gzip-friendly way
									node = elem;
									outerCache = node[ expando ] || (node[ expando ] = {});
	
									// Support: IE <9 only
									// Defend against cloned attroperties (jQuery gh-1709)
									uniqueCache = outerCache[ node.uniqueID ] ||
										(outerCache[ node.uniqueID ] = {});
	
									cache = uniqueCache[ type ] || [];
									nodeIndex = cache[ 0 ] === dirruns && cache[ 1 ];
									diff = nodeIndex;
								}
	
								// xml :nth-child(...)
								// or :nth-last-child(...) or :nth(-last)?-of-type(...)
								if ( diff === false ) {
									// Use the same loop as above to seek `elem` from the start
									while ( (node = ++nodeIndex && node && node[ dir ] ||
										(diff = nodeIndex = 0) || start.pop()) ) {
	
										if ( ( ofType ?
											node.nodeName.toLowerCase() === name :
											node.nodeType === 1 ) &&
											++diff ) {
	
											// Cache the index of each encountered element
											if ( useCache ) {
												outerCache = node[ expando ] || (node[ expando ] = {});
	
												// Support: IE <9 only
												// Defend against cloned attroperties (jQuery gh-1709)
												uniqueCache = outerCache[ node.uniqueID ] ||
													(outerCache[ node.uniqueID ] = {});
	
												uniqueCache[ type ] = [ dirruns, diff ];
											}
	
											if ( node === elem ) {
												break;
											}
										}
									}
								}
							}
	
							// Incorporate the offset, then check against cycle size
							diff -= last;
							return diff === first || ( diff % first === 0 && diff / first >= 0 );
						}
					};
			},
	
			"PSEUDO": function( pseudo, argument ) {
				// pseudo-class names are case-insensitive
				// http://www.w3.org/TR/selectors/#pseudo-classes
				// Prioritize by case sensitivity in case custom pseudos are added with uppercase letters
				// Remember that setFilters inherits from pseudos
				var args,
					fn = Expr.pseudos[ pseudo ] || Expr.setFilters[ pseudo.toLowerCase() ] ||
						Sizzle.error( "unsupported pseudo: " + pseudo );
	
				// The user may use createPseudo to indicate that
				// arguments are needed to create the filter function
				// just as Sizzle does
				if ( fn[ expando ] ) {
					return fn( argument );
				}
	
				// But maintain support for old signatures
				if ( fn.length > 1 ) {
					args = [ pseudo, pseudo, "", argument ];
					return Expr.setFilters.hasOwnProperty( pseudo.toLowerCase() ) ?
						markFunction(function( seed, matches ) {
							var idx,
								matched = fn( seed, argument ),
								i = matched.length;
							while ( i-- ) {
								idx = indexOf( seed, matched[i] );
								seed[ idx ] = !( matches[ idx ] = matched[i] );
							}
						}) :
						function( elem ) {
							return fn( elem, 0, args );
						};
				}
	
				return fn;
			}
		},
	
		pseudos: {
			// Potentially complex pseudos
			"not": markFunction(function( selector ) {
				// Trim the selector passed to compile
				// to avoid treating leading and trailing
				// spaces as combinators
				var input = [],
					results = [],
					matcher = compile( selector.replace( rtrim, "$1" ) );
	
				return matcher[ expando ] ?
					markFunction(function( seed, matches, context, xml ) {
						var elem,
							unmatched = matcher( seed, null, xml, [] ),
							i = seed.length;
	
						// Match elements unmatched by `matcher`
						while ( i-- ) {
							if ( (elem = unmatched[i]) ) {
								seed[i] = !(matches[i] = elem);
							}
						}
					}) :
					function( elem, context, xml ) {
						input[0] = elem;
						matcher( input, null, xml, results );
						// Don't keep the element (issue #299)
						input[0] = null;
						return !results.pop();
					};
			}),
	
			"has": markFunction(function( selector ) {
				return function( elem ) {
					return Sizzle( selector, elem ).length > 0;
				};
			}),
	
			"contains": markFunction(function( text ) {
				text = text.replace( runescape, funescape );
				return function( elem ) {
					return ( elem.textContent || elem.innerText || getText( elem ) ).indexOf( text ) > -1;
				};
			}),
	
			// "Whether an element is represented by a :lang() selector
			// is based solely on the element's language value
			// being equal to the identifier C,
			// or beginning with the identifier C immediately followed by "-".
			// The matching of C against the element's language value is performed case-insensitively.
			// The identifier C does not have to be a valid language name."
			// http://www.w3.org/TR/selectors/#lang-pseudo
			"lang": markFunction( function( lang ) {
				// lang value must be a valid identifier
				if ( !ridentifier.test(lang || "") ) {
					Sizzle.error( "unsupported lang: " + lang );
				}
				lang = lang.replace( runescape, funescape ).toLowerCase();
				return function( elem ) {
					var elemLang;
					do {
						if ( (elemLang = documentIsHTML ?
							elem.lang :
							elem.getAttribute("xml:lang") || elem.getAttribute("lang")) ) {
	
							elemLang = elemLang.toLowerCase();
							return elemLang === lang || elemLang.indexOf( lang + "-" ) === 0;
						}
					} while ( (elem = elem.parentNode) && elem.nodeType === 1 );
					return false;
				};
			}),
	
			// Miscellaneous
			"target": function( elem ) {
				var hash = window.location && window.location.hash;
				return hash && hash.slice( 1 ) === elem.id;
			},
	
			"root": function( elem ) {
				return elem === docElem;
			},
	
			"focus": function( elem ) {
				return elem === document.activeElement && (!document.hasFocus || document.hasFocus()) && !!(elem.type || elem.href || ~elem.tabIndex);
			},
	
			// Boolean properties
			"enabled": function( elem ) {
				return elem.disabled === false;
			},
	
			"disabled": function( elem ) {
				return elem.disabled === true;
			},
	
			"checked": function( elem ) {
				// In CSS3, :checked should return both checked and selected elements
				// http://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
				var nodeName = elem.nodeName.toLowerCase();
				return (nodeName === "input" && !!elem.checked) || (nodeName === "option" && !!elem.selected);
			},
	
			"selected": function( elem ) {
				// Accessing this property makes selected-by-default
				// options in Safari work properly
				if ( elem.parentNode ) {
					elem.parentNode.selectedIndex;
				}
	
				return elem.selected === true;
			},
	
			// Contents
			"empty": function( elem ) {
				// http://www.w3.org/TR/selectors/#empty-pseudo
				// :empty is negated by element (1) or content nodes (text: 3; cdata: 4; entity ref: 5),
				//   but not by others (comment: 8; processing instruction: 7; etc.)
				// nodeType < 6 works because attributes (2) do not appear as children
				for ( elem = elem.firstChild; elem; elem = elem.nextSibling ) {
					if ( elem.nodeType < 6 ) {
						return false;
					}
				}
				return true;
			},
	
			"parent": function( elem ) {
				return !Expr.pseudos["empty"]( elem );
			},
	
			// Element/input types
			"header": function( elem ) {
				return rheader.test( elem.nodeName );
			},
	
			"input": function( elem ) {
				return rinputs.test( elem.nodeName );
			},
	
			"button": function( elem ) {
				var name = elem.nodeName.toLowerCase();
				return name === "input" && elem.type === "button" || name === "button";
			},
	
			"text": function( elem ) {
				var attr;
				return elem.nodeName.toLowerCase() === "input" &&
					elem.type === "text" &&
	
					// Support: IE<8
					// New HTML5 attribute values (e.g., "search") appear with elem.type === "text"
					( (attr = elem.getAttribute("type")) == null || attr.toLowerCase() === "text" );
			},
	
			// Position-in-collection
			"first": createPositionalPseudo(function() {
				return [ 0 ];
			}),
	
			"last": createPositionalPseudo(function( matchIndexes, length ) {
				return [ length - 1 ];
			}),
	
			"eq": createPositionalPseudo(function( matchIndexes, length, argument ) {
				return [ argument < 0 ? argument + length : argument ];
			}),
	
			"even": createPositionalPseudo(function( matchIndexes, length ) {
				var i = 0;
				for ( ; i < length; i += 2 ) {
					matchIndexes.push( i );
				}
				return matchIndexes;
			}),
	
			"odd": createPositionalPseudo(function( matchIndexes, length ) {
				var i = 1;
				for ( ; i < length; i += 2 ) {
					matchIndexes.push( i );
				}
				return matchIndexes;
			}),
	
			"lt": createPositionalPseudo(function( matchIndexes, length, argument ) {
				var i = argument < 0 ? argument + length : argument;
				for ( ; --i >= 0; ) {
					matchIndexes.push( i );
				}
				return matchIndexes;
			}),
	
			"gt": createPositionalPseudo(function( matchIndexes, length, argument ) {
				var i = argument < 0 ? argument + length : argument;
				for ( ; ++i < length; ) {
					matchIndexes.push( i );
				}
				return matchIndexes;
			})
		}
	};
	
	Expr.pseudos["nth"] = Expr.pseudos["eq"];
	
	// Add button/input type pseudos
	for ( i in { radio: true, checkbox: true, file: true, password: true, image: true } ) {
		Expr.pseudos[ i ] = createInputPseudo( i );
	}
	for ( i in { submit: true, reset: true } ) {
		Expr.pseudos[ i ] = createButtonPseudo( i );
	}
	
	// Easy API for creating new setFilters
	function setFilters() {}
	setFilters.prototype = Expr.filters = Expr.pseudos;
	Expr.setFilters = new setFilters();
	
	tokenize = Sizzle.tokenize = function( selector, parseOnly ) {
		var matched, match, tokens, type,
			soFar, groups, preFilters,
			cached = tokenCache[ selector + " " ];
	
		if ( cached ) {
			return parseOnly ? 0 : cached.slice( 0 );
		}
	
		soFar = selector;
		groups = [];
		preFilters = Expr.preFilter;
	
		while ( soFar ) {
	
			// Comma and first run
			if ( !matched || (match = rcomma.exec( soFar )) ) {
				if ( match ) {
					// Don't consume trailing commas as valid
					soFar = soFar.slice( match[0].length ) || soFar;
				}
				groups.push( (tokens = []) );
			}
	
			matched = false;
	
			// Combinators
			if ( (match = rcombinators.exec( soFar )) ) {
				matched = match.shift();
				tokens.push({
					value: matched,
					// Cast descendant combinators to space
					type: match[0].replace( rtrim, " " )
				});
				soFar = soFar.slice( matched.length );
			}
	
			// Filters
			for ( type in Expr.filter ) {
				if ( (match = matchExpr[ type ].exec( soFar )) && (!preFilters[ type ] ||
					(match = preFilters[ type ]( match ))) ) {
					matched = match.shift();
					tokens.push({
						value: matched,
						type: type,
						matches: match
					});
					soFar = soFar.slice( matched.length );
				}
			}
	
			if ( !matched ) {
				break;
			}
		}
	
		// Return the length of the invalid excess
		// if we're just parsing
		// Otherwise, throw an error or return tokens
		return parseOnly ?
			soFar.length :
			soFar ?
				Sizzle.error( selector ) :
				// Cache the tokens
				tokenCache( selector, groups ).slice( 0 );
	};
	
	function toSelector( tokens ) {
		var i = 0,
			len = tokens.length,
			selector = "";
		for ( ; i < len; i++ ) {
			selector += tokens[i].value;
		}
		return selector;
	}
	
	function addCombinator( matcher, combinator, base ) {
		var dir = combinator.dir,
			checkNonElements = base && dir === "parentNode",
			doneName = done++;
	
		return combinator.first ?
			// Check against closest ancestor/preceding element
			function( elem, context, xml ) {
				while ( (elem = elem[ dir ]) ) {
					if ( elem.nodeType === 1 || checkNonElements ) {
						return matcher( elem, context, xml );
					}
				}
			} :
	
			// Check against all ancestor/preceding elements
			function( elem, context, xml ) {
				var oldCache, uniqueCache, outerCache,
					newCache = [ dirruns, doneName ];
	
				// We can't set arbitrary data on XML nodes, so they don't benefit from combinator caching
				if ( xml ) {
					while ( (elem = elem[ dir ]) ) {
						if ( elem.nodeType === 1 || checkNonElements ) {
							if ( matcher( elem, context, xml ) ) {
								return true;
							}
						}
					}
				} else {
					while ( (elem = elem[ dir ]) ) {
						if ( elem.nodeType === 1 || checkNonElements ) {
							outerCache = elem[ expando ] || (elem[ expando ] = {});
	
							// Support: IE <9 only
							// Defend against cloned attroperties (jQuery gh-1709)
							uniqueCache = outerCache[ elem.uniqueID ] || (outerCache[ elem.uniqueID ] = {});
	
							if ( (oldCache = uniqueCache[ dir ]) &&
								oldCache[ 0 ] === dirruns && oldCache[ 1 ] === doneName ) {
	
								// Assign to newCache so results back-propagate to previous elements
								return (newCache[ 2 ] = oldCache[ 2 ]);
							} else {
								// Reuse newcache so results back-propagate to previous elements
								uniqueCache[ dir ] = newCache;
	
								// A match means we're done; a fail means we have to keep checking
								if ( (newCache[ 2 ] = matcher( elem, context, xml )) ) {
									return true;
								}
							}
						}
					}
				}
			};
	}
	
	function elementMatcher( matchers ) {
		return matchers.length > 1 ?
			function( elem, context, xml ) {
				var i = matchers.length;
				while ( i-- ) {
					if ( !matchers[i]( elem, context, xml ) ) {
						return false;
					}
				}
				return true;
			} :
			matchers[0];
	}
	
	function multipleContexts( selector, contexts, results ) {
		var i = 0,
			len = contexts.length;
		for ( ; i < len; i++ ) {
			Sizzle( selector, contexts[i], results );
		}
		return results;
	}
	
	function condense( unmatched, map, filter, context, xml ) {
		var elem,
			newUnmatched = [],
			i = 0,
			len = unmatched.length,
			mapped = map != null;
	
		for ( ; i < len; i++ ) {
			if ( (elem = unmatched[i]) ) {
				if ( !filter || filter( elem, context, xml ) ) {
					newUnmatched.push( elem );
					if ( mapped ) {
						map.push( i );
					}
				}
			}
		}
	
		return newUnmatched;
	}
	
	function setMatcher( preFilter, selector, matcher, postFilter, postFinder, postSelector ) {
		if ( postFilter && !postFilter[ expando ] ) {
			postFilter = setMatcher( postFilter );
		}
		if ( postFinder && !postFinder[ expando ] ) {
			postFinder = setMatcher( postFinder, postSelector );
		}
		return markFunction(function( seed, results, context, xml ) {
			var temp, i, elem,
				preMap = [],
				postMap = [],
				preexisting = results.length,
	
				// Get initial elements from seed or context
				elems = seed || multipleContexts( selector || "*", context.nodeType ? [ context ] : context, [] ),
	
				// Prefilter to get matcher input, preserving a map for seed-results synchronization
				matcherIn = preFilter && ( seed || !selector ) ?
					condense( elems, preMap, preFilter, context, xml ) :
					elems,
	
				matcherOut = matcher ?
					// If we have a postFinder, or filtered seed, or non-seed postFilter or preexisting results,
					postFinder || ( seed ? preFilter : preexisting || postFilter ) ?
	
						// ...intermediate processing is necessary
						[] :
	
						// ...otherwise use results directly
						results :
					matcherIn;
	
			// Find primary matches
			if ( matcher ) {
				matcher( matcherIn, matcherOut, context, xml );
			}
	
			// Apply postFilter
			if ( postFilter ) {
				temp = condense( matcherOut, postMap );
				postFilter( temp, [], context, xml );
	
				// Un-match failing elements by moving them back to matcherIn
				i = temp.length;
				while ( i-- ) {
					if ( (elem = temp[i]) ) {
						matcherOut[ postMap[i] ] = !(matcherIn[ postMap[i] ] = elem);
					}
				}
			}
	
			if ( seed ) {
				if ( postFinder || preFilter ) {
					if ( postFinder ) {
						// Get the final matcherOut by condensing this intermediate into postFinder contexts
						temp = [];
						i = matcherOut.length;
						while ( i-- ) {
							if ( (elem = matcherOut[i]) ) {
								// Restore matcherIn since elem is not yet a final match
								temp.push( (matcherIn[i] = elem) );
							}
						}
						postFinder( null, (matcherOut = []), temp, xml );
					}
	
					// Move matched elements from seed to results to keep them synchronized
					i = matcherOut.length;
					while ( i-- ) {
						if ( (elem = matcherOut[i]) &&
							(temp = postFinder ? indexOf( seed, elem ) : preMap[i]) > -1 ) {
	
							seed[temp] = !(results[temp] = elem);
						}
					}
				}
	
			// Add elements to results, through postFinder if defined
			} else {
				matcherOut = condense(
					matcherOut === results ?
						matcherOut.splice( preexisting, matcherOut.length ) :
						matcherOut
				);
				if ( postFinder ) {
					postFinder( null, results, matcherOut, xml );
				} else {
					push.apply( results, matcherOut );
				}
			}
		});
	}
	
	function matcherFromTokens( tokens ) {
		var checkContext, matcher, j,
			len = tokens.length,
			leadingRelative = Expr.relative[ tokens[0].type ],
			implicitRelative = leadingRelative || Expr.relative[" "],
			i = leadingRelative ? 1 : 0,
	
			// The foundational matcher ensures that elements are reachable from top-level context(s)
			matchContext = addCombinator( function( elem ) {
				return elem === checkContext;
			}, implicitRelative, true ),
			matchAnyContext = addCombinator( function( elem ) {
				return indexOf( checkContext, elem ) > -1;
			}, implicitRelative, true ),
			matchers = [ function( elem, context, xml ) {
				var ret = ( !leadingRelative && ( xml || context !== outermostContext ) ) || (
					(checkContext = context).nodeType ?
						matchContext( elem, context, xml ) :
						matchAnyContext( elem, context, xml ) );
				// Avoid hanging onto element (issue #299)
				checkContext = null;
				return ret;
			} ];
	
		for ( ; i < len; i++ ) {
			if ( (matcher = Expr.relative[ tokens[i].type ]) ) {
				matchers = [ addCombinator(elementMatcher( matchers ), matcher) ];
			} else {
				matcher = Expr.filter[ tokens[i].type ].apply( null, tokens[i].matches );
	
				// Return special upon seeing a positional matcher
				if ( matcher[ expando ] ) {
					// Find the next relative operator (if any) for proper handling
					j = ++i;
					for ( ; j < len; j++ ) {
						if ( Expr.relative[ tokens[j].type ] ) {
							break;
						}
					}
					return setMatcher(
						i > 1 && elementMatcher( matchers ),
						i > 1 && toSelector(
							// If the preceding token was a descendant combinator, insert an implicit any-element `*`
							tokens.slice( 0, i - 1 ).concat({ value: tokens[ i - 2 ].type === " " ? "*" : "" })
						).replace( rtrim, "$1" ),
						matcher,
						i < j && matcherFromTokens( tokens.slice( i, j ) ),
						j < len && matcherFromTokens( (tokens = tokens.slice( j )) ),
						j < len && toSelector( tokens )
					);
				}
				matchers.push( matcher );
			}
		}
	
		return elementMatcher( matchers );
	}
	
	function matcherFromGroupMatchers( elementMatchers, setMatchers ) {
		var bySet = setMatchers.length > 0,
			byElement = elementMatchers.length > 0,
			superMatcher = function( seed, context, xml, results, outermost ) {
				var elem, j, matcher,
					matchedCount = 0,
					i = "0",
					unmatched = seed && [],
					setMatched = [],
					contextBackup = outermostContext,
					// We must always have either seed elements or outermost context
					elems = seed || byElement && Expr.find["TAG"]( "*", outermost ),
					// Use integer dirruns iff this is the outermost matcher
					dirrunsUnique = (dirruns += contextBackup == null ? 1 : Math.random() || 0.1),
					len = elems.length;
	
				if ( outermost ) {
					outermostContext = context === document || context || outermost;
				}
	
				// Add elements passing elementMatchers directly to results
				// Support: IE<9, Safari
				// Tolerate NodeList properties (IE: "length"; Safari: <number>) matching elements by id
				for ( ; i !== len && (elem = elems[i]) != null; i++ ) {
					if ( byElement && elem ) {
						j = 0;
						if ( !context && elem.ownerDocument !== document ) {
							setDocument( elem );
							xml = !documentIsHTML;
						}
						while ( (matcher = elementMatchers[j++]) ) {
							if ( matcher( elem, context || document, xml) ) {
								results.push( elem );
								break;
							}
						}
						if ( outermost ) {
							dirruns = dirrunsUnique;
						}
					}
	
					// Track unmatched elements for set filters
					if ( bySet ) {
						// They will have gone through all possible matchers
						if ( (elem = !matcher && elem) ) {
							matchedCount--;
						}
	
						// Lengthen the array for every element, matched or not
						if ( seed ) {
							unmatched.push( elem );
						}
					}
				}
	
				// `i` is now the count of elements visited above, and adding it to `matchedCount`
				// makes the latter nonnegative.
				matchedCount += i;
	
				// Apply set filters to unmatched elements
				// NOTE: This can be skipped if there are no unmatched elements (i.e., `matchedCount`
				// equals `i`), unless we didn't visit _any_ elements in the above loop because we have
				// no element matchers and no seed.
				// Incrementing an initially-string "0" `i` allows `i` to remain a string only in that
				// case, which will result in a "00" `matchedCount` that differs from `i` but is also
				// numerically zero.
				if ( bySet && i !== matchedCount ) {
					j = 0;
					while ( (matcher = setMatchers[j++]) ) {
						matcher( unmatched, setMatched, context, xml );
					}
	
					if ( seed ) {
						// Reintegrate element matches to eliminate the need for sorting
						if ( matchedCount > 0 ) {
							while ( i-- ) {
								if ( !(unmatched[i] || setMatched[i]) ) {
									setMatched[i] = pop.call( results );
								}
							}
						}
	
						// Discard index placeholder values to get only actual matches
						setMatched = condense( setMatched );
					}
	
					// Add matches to results
					push.apply( results, setMatched );
	
					// Seedless set matches succeeding multiple successful matchers stipulate sorting
					if ( outermost && !seed && setMatched.length > 0 &&
						( matchedCount + setMatchers.length ) > 1 ) {
	
						Sizzle.uniqueSort( results );
					}
				}
	
				// Override manipulation of globals by nested matchers
				if ( outermost ) {
					dirruns = dirrunsUnique;
					outermostContext = contextBackup;
				}
	
				return unmatched;
			};
	
		return bySet ?
			markFunction( superMatcher ) :
			superMatcher;
	}
	
	compile = Sizzle.compile = function( selector, match /* Internal Use Only */ ) {
		var i,
			setMatchers = [],
			elementMatchers = [],
			cached = compilerCache[ selector + " " ];
	
		if ( !cached ) {
			// Generate a function of recursive functions that can be used to check each element
			if ( !match ) {
				match = tokenize( selector );
			}
			i = match.length;
			while ( i-- ) {
				cached = matcherFromTokens( match[i] );
				if ( cached[ expando ] ) {
					setMatchers.push( cached );
				} else {
					elementMatchers.push( cached );
				}
			}
	
			// Cache the compiled function
			cached = compilerCache( selector, matcherFromGroupMatchers( elementMatchers, setMatchers ) );
	
			// Save selector and tokenization
			cached.selector = selector;
		}
		return cached;
	};
	
	/**
	 * A low-level selection function that works with Sizzle's compiled
	 *  selector functions
	 * @param {String|Function} selector A selector or a pre-compiled
	 *  selector function built with Sizzle.compile
	 * @param {Element} context
	 * @param {Array} [results]
	 * @param {Array} [seed] A set of elements to match against
	 */
	select = Sizzle.select = function( selector, context, results, seed ) {
		var i, tokens, token, type, find,
			compiled = typeof selector === "function" && selector,
			match = !seed && tokenize( (selector = compiled.selector || selector) );
	
		results = results || [];
	
		// Try to minimize operations if there is only one selector in the list and no seed
		// (the latter of which guarantees us context)
		if ( match.length === 1 ) {
	
			// Reduce context if the leading compound selector is an ID
			tokens = match[0] = match[0].slice( 0 );
			if ( tokens.length > 2 && (token = tokens[0]).type === "ID" &&
					support.getById && context.nodeType === 9 && documentIsHTML &&
					Expr.relative[ tokens[1].type ] ) {
	
				context = ( Expr.find["ID"]( token.matches[0].replace(runescape, funescape), context ) || [] )[0];
				if ( !context ) {
					return results;
	
				// Precompiled matchers will still verify ancestry, so step up a level
				} else if ( compiled ) {
					context = context.parentNode;
				}
	
				selector = selector.slice( tokens.shift().value.length );
			}
	
			// Fetch a seed set for right-to-left matching
			i = matchExpr["needsContext"].test( selector ) ? 0 : tokens.length;
			while ( i-- ) {
				token = tokens[i];
	
				// Abort if we hit a combinator
				if ( Expr.relative[ (type = token.type) ] ) {
					break;
				}
				if ( (find = Expr.find[ type ]) ) {
					// Search, expanding context for leading sibling combinators
					if ( (seed = find(
						token.matches[0].replace( runescape, funescape ),
						rsibling.test( tokens[0].type ) && testContext( context.parentNode ) || context
					)) ) {
	
						// If seed is empty or no tokens remain, we can return early
						tokens.splice( i, 1 );
						selector = seed.length && toSelector( tokens );
						if ( !selector ) {
							push.apply( results, seed );
							return results;
						}
	
						break;
					}
				}
			}
		}
	
		// Compile and execute a filtering function if one is not provided
		// Provide `match` to avoid retokenization if we modified the selector above
		( compiled || compile( selector, match ) )(
			seed,
			context,
			!documentIsHTML,
			results,
			!context || rsibling.test( selector ) && testContext( context.parentNode ) || context
		);
		return results;
	};
	
	// One-time assignments
	
	// Sort stability
	support.sortStable = expando.split("").sort( sortOrder ).join("") === expando;
	
	// Support: Chrome 14-35+
	// Always assume duplicates if they aren't passed to the comparison function
	support.detectDuplicates = !!hasDuplicate;
	
	// Initialize against the default document
	setDocument();
	
	// Support: Webkit<537.32 - Safari 6.0.3/Chrome 25 (fixed in Chrome 27)
	// Detached nodes confoundingly follow *each other*
	support.sortDetached = assert(function( div1 ) {
		// Should return 1, but returns 4 (following)
		return div1.compareDocumentPosition( document.createElement("div") ) & 1;
	});
	
	// Support: IE<8
	// Prevent attribute/property "interpolation"
	// http://msdn.microsoft.com/en-us/library/ms536429%28VS.85%29.aspx
	if ( !assert(function( div ) {
		div.innerHTML = "<a href='#'></a>";
		return div.firstChild.getAttribute("href") === "#" ;
	}) ) {
		addHandle( "type|href|height|width", function( elem, name, isXML ) {
			if ( !isXML ) {
				return elem.getAttribute( name, name.toLowerCase() === "type" ? 1 : 2 );
			}
		});
	}
	
	// Support: IE<9
	// Use defaultValue in place of getAttribute("value")
	if ( !support.attributes || !assert(function( div ) {
		div.innerHTML = "<input/>";
		div.firstChild.setAttribute( "value", "" );
		return div.firstChild.getAttribute( "value" ) === "";
	}) ) {
		addHandle( "value", function( elem, name, isXML ) {
			if ( !isXML && elem.nodeName.toLowerCase() === "input" ) {
				return elem.defaultValue;
			}
		});
	}
	
	// Support: IE<9
	// Use getAttributeNode to fetch booleans when getAttribute lies
	if ( !assert(function( div ) {
		return div.getAttribute("disabled") == null;
	}) ) {
		addHandle( booleans, function( elem, name, isXML ) {
			var val;
			if ( !isXML ) {
				return elem[ name ] === true ? name.toLowerCase() :
						(val = elem.getAttributeNode( name )) && val.specified ?
						val.value :
					null;
			}
		});
	}
	
	return Sizzle;
	
	})( window );
	
	
	
	jQuery.find = Sizzle;
	jQuery.expr = Sizzle.selectors;
	jQuery.expr[ ":" ] = jQuery.expr.pseudos;
	jQuery.uniqueSort = jQuery.unique = Sizzle.uniqueSort;
	jQuery.text = Sizzle.getText;
	jQuery.isXMLDoc = Sizzle.isXML;
	jQuery.contains = Sizzle.contains;
	
	
	
	var dir = function( elem, dir, until ) {
		var matched = [],
			truncate = until !== undefined;
	
		while ( ( elem = elem[ dir ] ) && elem.nodeType !== 9 ) {
			if ( elem.nodeType === 1 ) {
				if ( truncate && jQuery( elem ).is( until ) ) {
					break;
				}
				matched.push( elem );
			}
		}
		return matched;
	};
	
	
	var siblings = function( n, elem ) {
		var matched = [];
	
		for ( ; n; n = n.nextSibling ) {
			if ( n.nodeType === 1 && n !== elem ) {
				matched.push( n );
			}
		}
	
		return matched;
	};
	
	
	var rneedsContext = jQuery.expr.match.needsContext;
	
	var rsingleTag = ( /^<([\w-]+)\s*\/?>(?:<\/\1>|)$/ );
	
	
	
	var risSimple = /^.[^:#\[\.,]*$/;
	
	// Implement the identical functionality for filter and not
	function winnow( elements, qualifier, not ) {
		if ( jQuery.isFunction( qualifier ) ) {
			return jQuery.grep( elements, function( elem, i ) {
				/* jshint -W018 */
				return !!qualifier.call( elem, i, elem ) !== not;
			} );
	
		}
	
		if ( qualifier.nodeType ) {
			return jQuery.grep( elements, function( elem ) {
				return ( elem === qualifier ) !== not;
			} );
	
		}
	
		if ( typeof qualifier === "string" ) {
			if ( risSimple.test( qualifier ) ) {
				return jQuery.filter( qualifier, elements, not );
			}
	
			qualifier = jQuery.filter( qualifier, elements );
		}
	
		return jQuery.grep( elements, function( elem ) {
			return ( jQuery.inArray( elem, qualifier ) > -1 ) !== not;
		} );
	}
	
	jQuery.filter = function( expr, elems, not ) {
		var elem = elems[ 0 ];
	
		if ( not ) {
			expr = ":not(" + expr + ")";
		}
	
		return elems.length === 1 && elem.nodeType === 1 ?
			jQuery.find.matchesSelector( elem, expr ) ? [ elem ] : [] :
			jQuery.find.matches( expr, jQuery.grep( elems, function( elem ) {
				return elem.nodeType === 1;
			} ) );
	};
	
	jQuery.fn.extend( {
		find: function( selector ) {
			var i,
				ret = [],
				self = this,
				len = self.length;
	
			if ( typeof selector !== "string" ) {
				return this.pushStack( jQuery( selector ).filter( function() {
					for ( i = 0; i < len; i++ ) {
						if ( jQuery.contains( self[ i ], this ) ) {
							return true;
						}
					}
				} ) );
			}
	
			for ( i = 0; i < len; i++ ) {
				jQuery.find( selector, self[ i ], ret );
			}
	
			// Needed because $( selector, context ) becomes $( context ).find( selector )
			ret = this.pushStack( len > 1 ? jQuery.unique( ret ) : ret );
			ret.selector = this.selector ? this.selector + " " + selector : selector;
			return ret;
		},
		filter: function( selector ) {
			return this.pushStack( winnow( this, selector || [], false ) );
		},
		not: function( selector ) {
			return this.pushStack( winnow( this, selector || [], true ) );
		},
		is: function( selector ) {
			return !!winnow(
				this,
	
				// If this is a positional/relative selector, check membership in the returned set
				// so $("p:first").is("p:last") won't return true for a doc with two "p".
				typeof selector === "string" && rneedsContext.test( selector ) ?
					jQuery( selector ) :
					selector || [],
				false
			).length;
		}
	} );
	
	
	// Initialize a jQuery object
	
	
	// A central reference to the root jQuery(document)
	var rootjQuery,
	
		// A simple way to check for HTML strings
		// Prioritize #id over <tag> to avoid XSS via location.hash (#9521)
		// Strict HTML recognition (#11290: must start with <)
		rquickExpr = /^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]*))$/,
	
		init = jQuery.fn.init = function( selector, context, root ) {
			var match, elem;
	
			// HANDLE: $(""), $(null), $(undefined), $(false)
			if ( !selector ) {
				return this;
			}
	
			// init accepts an alternate rootjQuery
			// so migrate can support jQuery.sub (gh-2101)
			root = root || rootjQuery;
	
			// Handle HTML strings
			if ( typeof selector === "string" ) {
				if ( selector.charAt( 0 ) === "<" &&
					selector.charAt( selector.length - 1 ) === ">" &&
					selector.length >= 3 ) {
	
					// Assume that strings that start and end with <> are HTML and skip the regex check
					match = [ null, selector, null ];
	
				} else {
					match = rquickExpr.exec( selector );
				}
	
				// Match html or make sure no context is specified for #id
				if ( match && ( match[ 1 ] || !context ) ) {
	
					// HANDLE: $(html) -> $(array)
					if ( match[ 1 ] ) {
						context = context instanceof jQuery ? context[ 0 ] : context;
	
						// scripts is true for back-compat
						// Intentionally let the error be thrown if parseHTML is not present
						jQuery.merge( this, jQuery.parseHTML(
							match[ 1 ],
							context && context.nodeType ? context.ownerDocument || context : document,
							true
						) );
	
						// HANDLE: $(html, props)
						if ( rsingleTag.test( match[ 1 ] ) && jQuery.isPlainObject( context ) ) {
							for ( match in context ) {
	
								// Properties of context are called as methods if possible
								if ( jQuery.isFunction( this[ match ] ) ) {
									this[ match ]( context[ match ] );
	
								// ...and otherwise set as attributes
								} else {
									this.attr( match, context[ match ] );
								}
							}
						}
	
						return this;
	
					// HANDLE: $(#id)
					} else {
						elem = document.getElementById( match[ 2 ] );
	
						// Check parentNode to catch when Blackberry 4.6 returns
						// nodes that are no longer in the document #6963
						if ( elem && elem.parentNode ) {
	
							// Handle the case where IE and Opera return items
							// by name instead of ID
							if ( elem.id !== match[ 2 ] ) {
								return rootjQuery.find( selector );
							}
	
							// Otherwise, we inject the element directly into the jQuery object
							this.length = 1;
							this[ 0 ] = elem;
						}
	
						this.context = document;
						this.selector = selector;
						return this;
					}
	
				// HANDLE: $(expr, $(...))
				} else if ( !context || context.jquery ) {
					return ( context || root ).find( selector );
	
				// HANDLE: $(expr, context)
				// (which is just equivalent to: $(context).find(expr)
				} else {
					return this.constructor( context ).find( selector );
				}
	
			// HANDLE: $(DOMElement)
			} else if ( selector.nodeType ) {
				this.context = this[ 0 ] = selector;
				this.length = 1;
				return this;
	
			// HANDLE: $(function)
			// Shortcut for document ready
			} else if ( jQuery.isFunction( selector ) ) {
				return typeof root.ready !== "undefined" ?
					root.ready( selector ) :
	
					// Execute immediately if ready is not present
					selector( jQuery );
			}
	
			if ( selector.selector !== undefined ) {
				this.selector = selector.selector;
				this.context = selector.context;
			}
	
			return jQuery.makeArray( selector, this );
		};
	
	// Give the init function the jQuery prototype for later instantiation
	init.prototype = jQuery.fn;
	
	// Initialize central reference
	rootjQuery = jQuery( document );
	
	
	var rparentsprev = /^(?:parents|prev(?:Until|All))/,
	
		// methods guaranteed to produce a unique set when starting from a unique set
		guaranteedUnique = {
			children: true,
			contents: true,
			next: true,
			prev: true
		};
	
	jQuery.fn.extend( {
		has: function( target ) {
			var i,
				targets = jQuery( target, this ),
				len = targets.length;
	
			return this.filter( function() {
				for ( i = 0; i < len; i++ ) {
					if ( jQuery.contains( this, targets[ i ] ) ) {
						return true;
					}
				}
			} );
		},
	
		closest: function( selectors, context ) {
			var cur,
				i = 0,
				l = this.length,
				matched = [],
				pos = rneedsContext.test( selectors ) || typeof selectors !== "string" ?
					jQuery( selectors, context || this.context ) :
					0;
	
			for ( ; i < l; i++ ) {
				for ( cur = this[ i ]; cur && cur !== context; cur = cur.parentNode ) {
	
					// Always skip document fragments
					if ( cur.nodeType < 11 && ( pos ?
						pos.index( cur ) > -1 :
	
						// Don't pass non-elements to Sizzle
						cur.nodeType === 1 &&
							jQuery.find.matchesSelector( cur, selectors ) ) ) {
	
						matched.push( cur );
						break;
					}
				}
			}
	
			return this.pushStack( matched.length > 1 ? jQuery.uniqueSort( matched ) : matched );
		},
	
		// Determine the position of an element within
		// the matched set of elements
		index: function( elem ) {
	
			// No argument, return index in parent
			if ( !elem ) {
				return ( this[ 0 ] && this[ 0 ].parentNode ) ? this.first().prevAll().length : -1;
			}
	
			// index in selector
			if ( typeof elem === "string" ) {
				return jQuery.inArray( this[ 0 ], jQuery( elem ) );
			}
	
			// Locate the position of the desired element
			return jQuery.inArray(
	
				// If it receives a jQuery object, the first element is used
				elem.jquery ? elem[ 0 ] : elem, this );
		},
	
		add: function( selector, context ) {
			return this.pushStack(
				jQuery.uniqueSort(
					jQuery.merge( this.get(), jQuery( selector, context ) )
				)
			);
		},
	
		addBack: function( selector ) {
			return this.add( selector == null ?
				this.prevObject : this.prevObject.filter( selector )
			);
		}
	} );
	
	function sibling( cur, dir ) {
		do {
			cur = cur[ dir ];
		} while ( cur && cur.nodeType !== 1 );
	
		return cur;
	}
	
	jQuery.each( {
		parent: function( elem ) {
			var parent = elem.parentNode;
			return parent && parent.nodeType !== 11 ? parent : null;
		},
		parents: function( elem ) {
			return dir( elem, "parentNode" );
		},
		parentsUntil: function( elem, i, until ) {
			return dir( elem, "parentNode", until );
		},
		next: function( elem ) {
			return sibling( elem, "nextSibling" );
		},
		prev: function( elem ) {
			return sibling( elem, "previousSibling" );
		},
		nextAll: function( elem ) {
			return dir( elem, "nextSibling" );
		},
		prevAll: function( elem ) {
			return dir( elem, "previousSibling" );
		},
		nextUntil: function( elem, i, until ) {
			return dir( elem, "nextSibling", until );
		},
		prevUntil: function( elem, i, until ) {
			return dir( elem, "previousSibling", until );
		},
		siblings: function( elem ) {
			return siblings( ( elem.parentNode || {} ).firstChild, elem );
		},
		children: function( elem ) {
			return siblings( elem.firstChild );
		},
		contents: function( elem ) {
			return jQuery.nodeName( elem, "iframe" ) ?
				elem.contentDocument || elem.contentWindow.document :
				jQuery.merge( [], elem.childNodes );
		}
	}, function( name, fn ) {
		jQuery.fn[ name ] = function( until, selector ) {
			var ret = jQuery.map( this, fn, until );
	
			if ( name.slice( -5 ) !== "Until" ) {
				selector = until;
			}
	
			if ( selector && typeof selector === "string" ) {
				ret = jQuery.filter( selector, ret );
			}
	
			if ( this.length > 1 ) {
	
				// Remove duplicates
				if ( !guaranteedUnique[ name ] ) {
					ret = jQuery.uniqueSort( ret );
				}
	
				// Reverse order for parents* and prev-derivatives
				if ( rparentsprev.test( name ) ) {
					ret = ret.reverse();
				}
			}
	
			return this.pushStack( ret );
		};
	} );
	var rnotwhite = ( /\S+/g );
	
	
	
	// Convert String-formatted options into Object-formatted ones
	function createOptions( options ) {
		var object = {};
		jQuery.each( options.match( rnotwhite ) || [], function( _, flag ) {
			object[ flag ] = true;
		} );
		return object;
	}
	
	/*
	 * Create a callback list using the following parameters:
	 *
	 *	options: an optional list of space-separated options that will change how
	 *			the callback list behaves or a more traditional option object
	 *
	 * By default a callback list will act like an event callback list and can be
	 * "fired" multiple times.
	 *
	 * Possible options:
	 *
	 *	once:			will ensure the callback list can only be fired once (like a Deferred)
	 *
	 *	memory:			will keep track of previous values and will call any callback added
	 *					after the list has been fired right away with the latest "memorized"
	 *					values (like a Deferred)
	 *
	 *	unique:			will ensure a callback can only be added once (no duplicate in the list)
	 *
	 *	stopOnFalse:	interrupt callings when a callback returns false
	 *
	 */
	jQuery.Callbacks = function( options ) {
	
		// Convert options from String-formatted to Object-formatted if needed
		// (we check in cache first)
		options = typeof options === "string" ?
			createOptions( options ) :
			jQuery.extend( {}, options );
	
		var // Flag to know if list is currently firing
			firing,
	
			// Last fire value for non-forgettable lists
			memory,
	
			// Flag to know if list was already fired
			fired,
	
			// Flag to prevent firing
			locked,
	
			// Actual callback list
			list = [],
	
			// Queue of execution data for repeatable lists
			queue = [],
	
			// Index of currently firing callback (modified by add/remove as needed)
			firingIndex = -1,
	
			// Fire callbacks
			fire = function() {
	
				// Enforce single-firing
				locked = options.once;
	
				// Execute callbacks for all pending executions,
				// respecting firingIndex overrides and runtime changes
				fired = firing = true;
				for ( ; queue.length; firingIndex = -1 ) {
					memory = queue.shift();
					while ( ++firingIndex < list.length ) {
	
						// Run callback and check for early termination
						if ( list[ firingIndex ].apply( memory[ 0 ], memory[ 1 ] ) === false &&
							options.stopOnFalse ) {
	
							// Jump to end and forget the data so .add doesn't re-fire
							firingIndex = list.length;
							memory = false;
						}
					}
				}
	
				// Forget the data if we're done with it
				if ( !options.memory ) {
					memory = false;
				}
	
				firing = false;
	
				// Clean up if we're done firing for good
				if ( locked ) {
	
					// Keep an empty list if we have data for future add calls
					if ( memory ) {
						list = [];
	
					// Otherwise, this object is spent
					} else {
						list = "";
					}
				}
			},
	
			// Actual Callbacks object
			self = {
	
				// Add a callback or a collection of callbacks to the list
				add: function() {
					if ( list ) {
	
						// If we have memory from a past run, we should fire after adding
						if ( memory && !firing ) {
							firingIndex = list.length - 1;
							queue.push( memory );
						}
	
						( function add( args ) {
							jQuery.each( args, function( _, arg ) {
								if ( jQuery.isFunction( arg ) ) {
									if ( !options.unique || !self.has( arg ) ) {
										list.push( arg );
									}
								} else if ( arg && arg.length && jQuery.type( arg ) !== "string" ) {
	
									// Inspect recursively
									add( arg );
								}
							} );
						} )( arguments );
	
						if ( memory && !firing ) {
							fire();
						}
					}
					return this;
				},
	
				// Remove a callback from the list
				remove: function() {
					jQuery.each( arguments, function( _, arg ) {
						var index;
						while ( ( index = jQuery.inArray( arg, list, index ) ) > -1 ) {
							list.splice( index, 1 );
	
							// Handle firing indexes
							if ( index <= firingIndex ) {
								firingIndex--;
							}
						}
					} );
					return this;
				},
	
				// Check if a given callback is in the list.
				// If no argument is given, return whether or not list has callbacks attached.
				has: function( fn ) {
					return fn ?
						jQuery.inArray( fn, list ) > -1 :
						list.length > 0;
				},
	
				// Remove all callbacks from the list
				empty: function() {
					if ( list ) {
						list = [];
					}
					return this;
				},
	
				// Disable .fire and .add
				// Abort any current/pending executions
				// Clear all callbacks and values
				disable: function() {
					locked = queue = [];
					list = memory = "";
					return this;
				},
				disabled: function() {
					return !list;
				},
	
				// Disable .fire
				// Also disable .add unless we have memory (since it would have no effect)
				// Abort any pending executions
				lock: function() {
					locked = true;
					if ( !memory ) {
						self.disable();
					}
					return this;
				},
				locked: function() {
					return !!locked;
				},
	
				// Call all callbacks with the given context and arguments
				fireWith: function( context, args ) {
					if ( !locked ) {
						args = args || [];
						args = [ context, args.slice ? args.slice() : args ];
						queue.push( args );
						if ( !firing ) {
							fire();
						}
					}
					return this;
				},
	
				// Call all the callbacks with the given arguments
				fire: function() {
					self.fireWith( this, arguments );
					return this;
				},
	
				// To know if the callbacks have already been called at least once
				fired: function() {
					return !!fired;
				}
			};
	
		return self;
	};
	
	
	jQuery.extend( {
	
		Deferred: function( func ) {
			var tuples = [
	
					// action, add listener, listener list, final state
					[ "resolve", "done", jQuery.Callbacks( "once memory" ), "resolved" ],
					[ "reject", "fail", jQuery.Callbacks( "once memory" ), "rejected" ],
					[ "notify", "progress", jQuery.Callbacks( "memory" ) ]
				],
				state = "pending",
				promise = {
					state: function() {
						return state;
					},
					always: function() {
						deferred.done( arguments ).fail( arguments );
						return this;
					},
					then: function( /* fnDone, fnFail, fnProgress */ ) {
						var fns = arguments;
						return jQuery.Deferred( function( newDefer ) {
							jQuery.each( tuples, function( i, tuple ) {
								var fn = jQuery.isFunction( fns[ i ] ) && fns[ i ];
	
								// deferred[ done | fail | progress ] for forwarding actions to newDefer
								deferred[ tuple[ 1 ] ]( function() {
									var returned = fn && fn.apply( this, arguments );
									if ( returned && jQuery.isFunction( returned.promise ) ) {
										returned.promise()
											.progress( newDefer.notify )
											.done( newDefer.resolve )
											.fail( newDefer.reject );
									} else {
										newDefer[ tuple[ 0 ] + "With" ](
											this === promise ? newDefer.promise() : this,
											fn ? [ returned ] : arguments
										);
									}
								} );
							} );
							fns = null;
						} ).promise();
					},
	
					// Get a promise for this deferred
					// If obj is provided, the promise aspect is added to the object
					promise: function( obj ) {
						return obj != null ? jQuery.extend( obj, promise ) : promise;
					}
				},
				deferred = {};
	
			// Keep pipe for back-compat
			promise.pipe = promise.then;
	
			// Add list-specific methods
			jQuery.each( tuples, function( i, tuple ) {
				var list = tuple[ 2 ],
					stateString = tuple[ 3 ];
	
				// promise[ done | fail | progress ] = list.add
				promise[ tuple[ 1 ] ] = list.add;
	
				// Handle state
				if ( stateString ) {
					list.add( function() {
	
						// state = [ resolved | rejected ]
						state = stateString;
	
					// [ reject_list | resolve_list ].disable; progress_list.lock
					}, tuples[ i ^ 1 ][ 2 ].disable, tuples[ 2 ][ 2 ].lock );
				}
	
				// deferred[ resolve | reject | notify ]
				deferred[ tuple[ 0 ] ] = function() {
					deferred[ tuple[ 0 ] + "With" ]( this === deferred ? promise : this, arguments );
					return this;
				};
				deferred[ tuple[ 0 ] + "With" ] = list.fireWith;
			} );
	
			// Make the deferred a promise
			promise.promise( deferred );
	
			// Call given func if any
			if ( func ) {
				func.call( deferred, deferred );
			}
	
			// All done!
			return deferred;
		},
	
		// Deferred helper
		when: function( subordinate /* , ..., subordinateN */ ) {
			var i = 0,
				resolveValues = slice.call( arguments ),
				length = resolveValues.length,
	
				// the count of uncompleted subordinates
				remaining = length !== 1 ||
					( subordinate && jQuery.isFunction( subordinate.promise ) ) ? length : 0,
	
				// the master Deferred.
				// If resolveValues consist of only a single Deferred, just use that.
				deferred = remaining === 1 ? subordinate : jQuery.Deferred(),
	
				// Update function for both resolve and progress values
				updateFunc = function( i, contexts, values ) {
					return function( value ) {
						contexts[ i ] = this;
						values[ i ] = arguments.length > 1 ? slice.call( arguments ) : value;
						if ( values === progressValues ) {
							deferred.notifyWith( contexts, values );
	
						} else if ( !( --remaining ) ) {
							deferred.resolveWith( contexts, values );
						}
					};
				},
	
				progressValues, progressContexts, resolveContexts;
	
			// add listeners to Deferred subordinates; treat others as resolved
			if ( length > 1 ) {
				progressValues = new Array( length );
				progressContexts = new Array( length );
				resolveContexts = new Array( length );
				for ( ; i < length; i++ ) {
					if ( resolveValues[ i ] && jQuery.isFunction( resolveValues[ i ].promise ) ) {
						resolveValues[ i ].promise()
							.progress( updateFunc( i, progressContexts, progressValues ) )
							.done( updateFunc( i, resolveContexts, resolveValues ) )
							.fail( deferred.reject );
					} else {
						--remaining;
					}
				}
			}
	
			// if we're not waiting on anything, resolve the master
			if ( !remaining ) {
				deferred.resolveWith( resolveContexts, resolveValues );
			}
	
			return deferred.promise();
		}
	} );
	
	
	// The deferred used on DOM ready
	var readyList;
	
	jQuery.fn.ready = function( fn ) {
	
		// Add the callback
		jQuery.ready.promise().done( fn );
	
		return this;
	};
	
	jQuery.extend( {
	
		// Is the DOM ready to be used? Set to true once it occurs.
		isReady: false,
	
		// A counter to track how many items to wait for before
		// the ready event fires. See #6781
		readyWait: 1,
	
		// Hold (or release) the ready event
		holdReady: function( hold ) {
			if ( hold ) {
				jQuery.readyWait++;
			} else {
				jQuery.ready( true );
			}
		},
	
		// Handle when the DOM is ready
		ready: function( wait ) {
	
			// Abort if there are pending holds or we're already ready
			if ( wait === true ? --jQuery.readyWait : jQuery.isReady ) {
				return;
			}
	
			// Remember that the DOM is ready
			jQuery.isReady = true;
	
			// If a normal DOM Ready event fired, decrement, and wait if need be
			if ( wait !== true && --jQuery.readyWait > 0 ) {
				return;
			}
	
			// If there are functions bound, to execute
			readyList.resolveWith( document, [ jQuery ] );
	
			// Trigger any bound ready events
			if ( jQuery.fn.triggerHandler ) {
				jQuery( document ).triggerHandler( "ready" );
				jQuery( document ).off( "ready" );
			}
		}
	} );
	
	/**
	 * Clean-up method for dom ready events
	 */
	function detach() {
		if ( document.addEventListener ) {
			document.removeEventListener( "DOMContentLoaded", completed );
			window.removeEventListener( "load", completed );
	
		} else {
			document.detachEvent( "onreadystatechange", completed );
			window.detachEvent( "onload", completed );
		}
	}
	
	/**
	 * The ready event handler and self cleanup method
	 */
	function completed() {
	
		// readyState === "complete" is good enough for us to call the dom ready in oldIE
		if ( document.addEventListener ||
			window.event.type === "load" ||
			document.readyState === "complete" ) {
	
			detach();
			jQuery.ready();
		}
	}
	
	jQuery.ready.promise = function( obj ) {
		if ( !readyList ) {
	
			readyList = jQuery.Deferred();
	
			// Catch cases where $(document).ready() is called
			// after the browser event has already occurred.
			// Support: IE6-10
			// Older IE sometimes signals "interactive" too soon
			if ( document.readyState === "complete" ||
				( document.readyState !== "loading" && !document.documentElement.doScroll ) ) {
	
				// Handle it asynchronously to allow scripts the opportunity to delay ready
				window.setTimeout( jQuery.ready );
	
			// Standards-based browsers support DOMContentLoaded
			} else if ( document.addEventListener ) {
	
				// Use the handy event callback
				document.addEventListener( "DOMContentLoaded", completed );
	
				// A fallback to window.onload, that will always work
				window.addEventListener( "load", completed );
	
			// If IE event model is used
			} else {
	
				// Ensure firing before onload, maybe late but safe also for iframes
				document.attachEvent( "onreadystatechange", completed );
	
				// A fallback to window.onload, that will always work
				window.attachEvent( "onload", completed );
	
				// If IE and not a frame
				// continually check to see if the document is ready
				var top = false;
	
				try {
					top = window.frameElement == null && document.documentElement;
				} catch ( e ) {}
	
				if ( top && top.doScroll ) {
					( function doScrollCheck() {
						if ( !jQuery.isReady ) {
	
							try {
	
								// Use the trick by Diego Perini
								// http://javascript.nwbox.com/IEContentLoaded/
								top.doScroll( "left" );
							} catch ( e ) {
								return window.setTimeout( doScrollCheck, 50 );
							}
	
							// detach all dom ready events
							detach();
	
							// and execute any waiting functions
							jQuery.ready();
						}
					} )();
				}
			}
		}
		return readyList.promise( obj );
	};
	
	// Kick off the DOM ready check even if the user does not
	jQuery.ready.promise();
	
	
	
	
	// Support: IE<9
	// Iteration over object's inherited properties before its own
	var i;
	for ( i in jQuery( support ) ) {
		break;
	}
	support.ownFirst = i === "0";
	
	// Note: most support tests are defined in their respective modules.
	// false until the test is run
	support.inlineBlockNeedsLayout = false;
	
	// Execute ASAP in case we need to set body.style.zoom
	jQuery( function() {
	
		// Minified: var a,b,c,d
		var val, div, body, container;
	
		body = document.getElementsByTagName( "body" )[ 0 ];
		if ( !body || !body.style ) {
	
			// Return for frameset docs that don't have a body
			return;
		}
	
		// Setup
		div = document.createElement( "div" );
		container = document.createElement( "div" );
		container.style.cssText = "position:absolute;border:0;width:0;height:0;top:0;left:-9999px";
		body.appendChild( container ).appendChild( div );
	
		if ( typeof div.style.zoom !== "undefined" ) {
	
			// Support: IE<8
			// Check if natively block-level elements act like inline-block
			// elements when setting their display to 'inline' and giving
			// them layout
			div.style.cssText = "display:inline;margin:0;border:0;padding:1px;width:1px;zoom:1";
	
			support.inlineBlockNeedsLayout = val = div.offsetWidth === 3;
			if ( val ) {
	
				// Prevent IE 6 from affecting layout for positioned elements #11048
				// Prevent IE from shrinking the body in IE 7 mode #12869
				// Support: IE<8
				body.style.zoom = 1;
			}
		}
	
		body.removeChild( container );
	} );
	
	
	( function() {
		var div = document.createElement( "div" );
	
		// Support: IE<9
		support.deleteExpando = true;
		try {
			delete div.test;
		} catch ( e ) {
			support.deleteExpando = false;
		}
	
		// Null elements to avoid leaks in IE.
		div = null;
	} )();
	var acceptData = function( elem ) {
		var noData = jQuery.noData[ ( elem.nodeName + " " ).toLowerCase() ],
			nodeType = +elem.nodeType || 1;
	
		// Do not set data on non-element DOM nodes because it will not be cleared (#8335).
		return nodeType !== 1 && nodeType !== 9 ?
			false :
	
			// Nodes accept data unless otherwise specified; rejection can be conditional
			!noData || noData !== true && elem.getAttribute( "classid" ) === noData;
	};
	
	
	
	
	var rbrace = /^(?:\{[\w\W]*\}|\[[\w\W]*\])$/,
		rmultiDash = /([A-Z])/g;
	
	function dataAttr( elem, key, data ) {
	
		// If nothing was found internally, try to fetch any
		// data from the HTML5 data-* attribute
		if ( data === undefined && elem.nodeType === 1 ) {
	
			var name = "data-" + key.replace( rmultiDash, "-$1" ).toLowerCase();
	
			data = elem.getAttribute( name );
	
			if ( typeof data === "string" ) {
				try {
					data = data === "true" ? true :
						data === "false" ? false :
						data === "null" ? null :
	
						// Only convert to a number if it doesn't change the string
						+data + "" === data ? +data :
						rbrace.test( data ) ? jQuery.parseJSON( data ) :
						data;
				} catch ( e ) {}
	
				// Make sure we set the data so it isn't changed later
				jQuery.data( elem, key, data );
	
			} else {
				data = undefined;
			}
		}
	
		return data;
	}
	
	// checks a cache object for emptiness
	function isEmptyDataObject( obj ) {
		var name;
		for ( name in obj ) {
	
			// if the public data object is empty, the private is still empty
			if ( name === "data" && jQuery.isEmptyObject( obj[ name ] ) ) {
				continue;
			}
			if ( name !== "toJSON" ) {
				return false;
			}
		}
	
		return true;
	}
	
	function internalData( elem, name, data, pvt /* Internal Use Only */ ) {
		if ( !acceptData( elem ) ) {
			return;
		}
	
		var ret, thisCache,
			internalKey = jQuery.expando,
	
			// We have to handle DOM nodes and JS objects differently because IE6-7
			// can't GC object references properly across the DOM-JS boundary
			isNode = elem.nodeType,
	
			// Only DOM nodes need the global jQuery cache; JS object data is
			// attached directly to the object so GC can occur automatically
			cache = isNode ? jQuery.cache : elem,
	
			// Only defining an ID for JS objects if its cache already exists allows
			// the code to shortcut on the same path as a DOM node with no cache
			id = isNode ? elem[ internalKey ] : elem[ internalKey ] && internalKey;
	
		// Avoid doing any more work than we need to when trying to get data on an
		// object that has no data at all
		if ( ( !id || !cache[ id ] || ( !pvt && !cache[ id ].data ) ) &&
			data === undefined && typeof name === "string" ) {
			return;
		}
	
		if ( !id ) {
	
			// Only DOM nodes need a new unique ID for each element since their data
			// ends up in the global cache
			if ( isNode ) {
				id = elem[ internalKey ] = deletedIds.pop() || jQuery.guid++;
			} else {
				id = internalKey;
			}
		}
	
		if ( !cache[ id ] ) {
	
			// Avoid exposing jQuery metadata on plain JS objects when the object
			// is serialized using JSON.stringify
			cache[ id ] = isNode ? {} : { toJSON: jQuery.noop };
		}
	
		// An object can be passed to jQuery.data instead of a key/value pair; this gets
		// shallow copied over onto the existing cache
		if ( typeof name === "object" || typeof name === "function" ) {
			if ( pvt ) {
				cache[ id ] = jQuery.extend( cache[ id ], name );
			} else {
				cache[ id ].data = jQuery.extend( cache[ id ].data, name );
			}
		}
	
		thisCache = cache[ id ];
	
		// jQuery data() is stored in a separate object inside the object's internal data
		// cache in order to avoid key collisions between internal data and user-defined
		// data.
		if ( !pvt ) {
			if ( !thisCache.data ) {
				thisCache.data = {};
			}
	
			thisCache = thisCache.data;
		}
	
		if ( data !== undefined ) {
			thisCache[ jQuery.camelCase( name ) ] = data;
		}
	
		// Check for both converted-to-camel and non-converted data property names
		// If a data property was specified
		if ( typeof name === "string" ) {
	
			// First Try to find as-is property data
			ret = thisCache[ name ];
	
			// Test for null|undefined property data
			if ( ret == null ) {
	
				// Try to find the camelCased property
				ret = thisCache[ jQuery.camelCase( name ) ];
			}
		} else {
			ret = thisCache;
		}
	
		return ret;
	}
	
	function internalRemoveData( elem, name, pvt ) {
		if ( !acceptData( elem ) ) {
			return;
		}
	
		var thisCache, i,
			isNode = elem.nodeType,
	
			// See jQuery.data for more information
			cache = isNode ? jQuery.cache : elem,
			id = isNode ? elem[ jQuery.expando ] : jQuery.expando;
	
		// If there is already no cache entry for this object, there is no
		// purpose in continuing
		if ( !cache[ id ] ) {
			return;
		}
	
		if ( name ) {
	
			thisCache = pvt ? cache[ id ] : cache[ id ].data;
	
			if ( thisCache ) {
	
				// Support array or space separated string names for data keys
				if ( !jQuery.isArray( name ) ) {
	
					// try the string as a key before any manipulation
					if ( name in thisCache ) {
						name = [ name ];
					} else {
	
						// split the camel cased version by spaces unless a key with the spaces exists
						name = jQuery.camelCase( name );
						if ( name in thisCache ) {
							name = [ name ];
						} else {
							name = name.split( " " );
						}
					}
				} else {
	
					// If "name" is an array of keys...
					// When data is initially created, via ("key", "val") signature,
					// keys will be converted to camelCase.
					// Since there is no way to tell _how_ a key was added, remove
					// both plain key and camelCase key. #12786
					// This will only penalize the array argument path.
					name = name.concat( jQuery.map( name, jQuery.camelCase ) );
				}
	
				i = name.length;
				while ( i-- ) {
					delete thisCache[ name[ i ] ];
				}
	
				// If there is no data left in the cache, we want to continue
				// and let the cache object itself get destroyed
				if ( pvt ? !isEmptyDataObject( thisCache ) : !jQuery.isEmptyObject( thisCache ) ) {
					return;
				}
			}
		}
	
		// See jQuery.data for more information
		if ( !pvt ) {
			delete cache[ id ].data;
	
			// Don't destroy the parent cache unless the internal data object
			// had been the only thing left in it
			if ( !isEmptyDataObject( cache[ id ] ) ) {
				return;
			}
		}
	
		// Destroy the cache
		if ( isNode ) {
			jQuery.cleanData( [ elem ], true );
	
		// Use delete when supported for expandos or `cache` is not a window per isWindow (#10080)
		/* jshint eqeqeq: false */
		} else if ( support.deleteExpando || cache != cache.window ) {
			/* jshint eqeqeq: true */
			delete cache[ id ];
	
		// When all else fails, undefined
		} else {
			cache[ id ] = undefined;
		}
	}
	
	jQuery.extend( {
		cache: {},
	
		// The following elements (space-suffixed to avoid Object.prototype collisions)
		// throw uncatchable exceptions if you attempt to set expando properties
		noData: {
			"applet ": true,
			"embed ": true,
	
			// ...but Flash objects (which have this classid) *can* handle expandos
			"object ": "clsid:D27CDB6E-AE6D-11cf-96B8-444553540000"
		},
	
		hasData: function( elem ) {
			elem = elem.nodeType ? jQuery.cache[ elem[ jQuery.expando ] ] : elem[ jQuery.expando ];
			return !!elem && !isEmptyDataObject( elem );
		},
	
		data: function( elem, name, data ) {
			return internalData( elem, name, data );
		},
	
		removeData: function( elem, name ) {
			return internalRemoveData( elem, name );
		},
	
		// For internal use only.
		_data: function( elem, name, data ) {
			return internalData( elem, name, data, true );
		},
	
		_removeData: function( elem, name ) {
			return internalRemoveData( elem, name, true );
		}
	} );
	
	jQuery.fn.extend( {
		data: function( key, value ) {
			var i, name, data,
				elem = this[ 0 ],
				attrs = elem && elem.attributes;
	
			// Special expections of .data basically thwart jQuery.access,
			// so implement the relevant behavior ourselves
	
			// Gets all values
			if ( key === undefined ) {
				if ( this.length ) {
					data = jQuery.data( elem );
	
					if ( elem.nodeType === 1 && !jQuery._data( elem, "parsedAttrs" ) ) {
						i = attrs.length;
						while ( i-- ) {
	
							// Support: IE11+
							// The attrs elements can be null (#14894)
							if ( attrs[ i ] ) {
								name = attrs[ i ].name;
								if ( name.indexOf( "data-" ) === 0 ) {
									name = jQuery.camelCase( name.slice( 5 ) );
									dataAttr( elem, name, data[ name ] );
								}
							}
						}
						jQuery._data( elem, "parsedAttrs", true );
					}
				}
	
				return data;
			}
	
			// Sets multiple values
			if ( typeof key === "object" ) {
				return this.each( function() {
					jQuery.data( this, key );
				} );
			}
	
			return arguments.length > 1 ?
	
				// Sets one value
				this.each( function() {
					jQuery.data( this, key, value );
				} ) :
	
				// Gets one value
				// Try to fetch any internally stored data first
				elem ? dataAttr( elem, key, jQuery.data( elem, key ) ) : undefined;
		},
	
		removeData: function( key ) {
			return this.each( function() {
				jQuery.removeData( this, key );
			} );
		}
	} );
	
	
	jQuery.extend( {
		queue: function( elem, type, data ) {
			var queue;
	
			if ( elem ) {
				type = ( type || "fx" ) + "queue";
				queue = jQuery._data( elem, type );
	
				// Speed up dequeue by getting out quickly if this is just a lookup
				if ( data ) {
					if ( !queue || jQuery.isArray( data ) ) {
						queue = jQuery._data( elem, type, jQuery.makeArray( data ) );
					} else {
						queue.push( data );
					}
				}
				return queue || [];
			}
		},
	
		dequeue: function( elem, type ) {
			type = type || "fx";
	
			var queue = jQuery.queue( elem, type ),
				startLength = queue.length,
				fn = queue.shift(),
				hooks = jQuery._queueHooks( elem, type ),
				next = function() {
					jQuery.dequeue( elem, type );
				};
	
			// If the fx queue is dequeued, always remove the progress sentinel
			if ( fn === "inprogress" ) {
				fn = queue.shift();
				startLength--;
			}
	
			if ( fn ) {
	
				// Add a progress sentinel to prevent the fx queue from being
				// automatically dequeued
				if ( type === "fx" ) {
					queue.unshift( "inprogress" );
				}
	
				// clear up the last queue stop function
				delete hooks.stop;
				fn.call( elem, next, hooks );
			}
	
			if ( !startLength && hooks ) {
				hooks.empty.fire();
			}
		},
	
		// not intended for public consumption - generates a queueHooks object,
		// or returns the current one
		_queueHooks: function( elem, type ) {
			var key = type + "queueHooks";
			return jQuery._data( elem, key ) || jQuery._data( elem, key, {
				empty: jQuery.Callbacks( "once memory" ).add( function() {
					jQuery._removeData( elem, type + "queue" );
					jQuery._removeData( elem, key );
				} )
			} );
		}
	} );
	
	jQuery.fn.extend( {
		queue: function( type, data ) {
			var setter = 2;
	
			if ( typeof type !== "string" ) {
				data = type;
				type = "fx";
				setter--;
			}
	
			if ( arguments.length < setter ) {
				return jQuery.queue( this[ 0 ], type );
			}
	
			return data === undefined ?
				this :
				this.each( function() {
					var queue = jQuery.queue( this, type, data );
	
					// ensure a hooks for this queue
					jQuery._queueHooks( this, type );
	
					if ( type === "fx" && queue[ 0 ] !== "inprogress" ) {
						jQuery.dequeue( this, type );
					}
				} );
		},
		dequeue: function( type ) {
			return this.each( function() {
				jQuery.dequeue( this, type );
			} );
		},
		clearQueue: function( type ) {
			return this.queue( type || "fx", [] );
		},
	
		// Get a promise resolved when queues of a certain type
		// are emptied (fx is the type by default)
		promise: function( type, obj ) {
			var tmp,
				count = 1,
				defer = jQuery.Deferred(),
				elements = this,
				i = this.length,
				resolve = function() {
					if ( !( --count ) ) {
						defer.resolveWith( elements, [ elements ] );
					}
				};
	
			if ( typeof type !== "string" ) {
				obj = type;
				type = undefined;
			}
			type = type || "fx";
	
			while ( i-- ) {
				tmp = jQuery._data( elements[ i ], type + "queueHooks" );
				if ( tmp && tmp.empty ) {
					count++;
					tmp.empty.add( resolve );
				}
			}
			resolve();
			return defer.promise( obj );
		}
	} );
	
	
	( function() {
		var shrinkWrapBlocksVal;
	
		support.shrinkWrapBlocks = function() {
			if ( shrinkWrapBlocksVal != null ) {
				return shrinkWrapBlocksVal;
			}
	
			// Will be changed later if needed.
			shrinkWrapBlocksVal = false;
	
			// Minified: var b,c,d
			var div, body, container;
	
			body = document.getElementsByTagName( "body" )[ 0 ];
			if ( !body || !body.style ) {
	
				// Test fired too early or in an unsupported environment, exit.
				return;
			}
	
			// Setup
			div = document.createElement( "div" );
			container = document.createElement( "div" );
			container.style.cssText = "position:absolute;border:0;width:0;height:0;top:0;left:-9999px";
			body.appendChild( container ).appendChild( div );
	
			// Support: IE6
			// Check if elements with layout shrink-wrap their children
			if ( typeof div.style.zoom !== "undefined" ) {
	
				// Reset CSS: box-sizing; display; margin; border
				div.style.cssText =
	
					// Support: Firefox<29, Android 2.3
					// Vendor-prefix box-sizing
					"-webkit-box-sizing:content-box;-moz-box-sizing:content-box;" +
					"box-sizing:content-box;display:block;margin:0;border:0;" +
					"padding:1px;width:1px;zoom:1";
				div.appendChild( document.createElement( "div" ) ).style.width = "5px";
				shrinkWrapBlocksVal = div.offsetWidth !== 3;
			}
	
			body.removeChild( container );
	
			return shrinkWrapBlocksVal;
		};
	
	} )();
	var pnum = ( /[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/ ).source;
	
	var rcssNum = new RegExp( "^(?:([+-])=|)(" + pnum + ")([a-z%]*)$", "i" );
	
	
	var cssExpand = [ "Top", "Right", "Bottom", "Left" ];
	
	var isHidden = function( elem, el ) {
	
			// isHidden might be called from jQuery#filter function;
			// in that case, element will be second argument
			elem = el || elem;
			return jQuery.css( elem, "display" ) === "none" ||
				!jQuery.contains( elem.ownerDocument, elem );
		};
	
	
	
	function adjustCSS( elem, prop, valueParts, tween ) {
		var adjusted,
			scale = 1,
			maxIterations = 20,
			currentValue = tween ?
				function() { return tween.cur(); } :
				function() { return jQuery.css( elem, prop, "" ); },
			initial = currentValue(),
			unit = valueParts && valueParts[ 3 ] || ( jQuery.cssNumber[ prop ] ? "" : "px" ),
	
			// Starting value computation is required for potential unit mismatches
			initialInUnit = ( jQuery.cssNumber[ prop ] || unit !== "px" && +initial ) &&
				rcssNum.exec( jQuery.css( elem, prop ) );
	
		if ( initialInUnit && initialInUnit[ 3 ] !== unit ) {
	
			// Trust units reported by jQuery.css
			unit = unit || initialInUnit[ 3 ];
	
			// Make sure we update the tween properties later on
			valueParts = valueParts || [];
	
			// Iteratively approximate from a nonzero starting point
			initialInUnit = +initial || 1;
	
			do {
	
				// If previous iteration zeroed out, double until we get *something*.
				// Use string for doubling so we don't accidentally see scale as unchanged below
				scale = scale || ".5";
	
				// Adjust and apply
				initialInUnit = initialInUnit / scale;
				jQuery.style( elem, prop, initialInUnit + unit );
	
			// Update scale, tolerating zero or NaN from tween.cur()
			// Break the loop if scale is unchanged or perfect, or if we've just had enough.
			} while (
				scale !== ( scale = currentValue() / initial ) && scale !== 1 && --maxIterations
			);
		}
	
		if ( valueParts ) {
			initialInUnit = +initialInUnit || +initial || 0;
	
			// Apply relative offset (+=/-=) if specified
			adjusted = valueParts[ 1 ] ?
				initialInUnit + ( valueParts[ 1 ] + 1 ) * valueParts[ 2 ] :
				+valueParts[ 2 ];
			if ( tween ) {
				tween.unit = unit;
				tween.start = initialInUnit;
				tween.end = adjusted;
			}
		}
		return adjusted;
	}
	
	
	// Multifunctional method to get and set values of a collection
	// The value/s can optionally be executed if it's a function
	var access = function( elems, fn, key, value, chainable, emptyGet, raw ) {
		var i = 0,
			length = elems.length,
			bulk = key == null;
	
		// Sets many values
		if ( jQuery.type( key ) === "object" ) {
			chainable = true;
			for ( i in key ) {
				access( elems, fn, i, key[ i ], true, emptyGet, raw );
			}
	
		// Sets one value
		} else if ( value !== undefined ) {
			chainable = true;
	
			if ( !jQuery.isFunction( value ) ) {
				raw = true;
			}
	
			if ( bulk ) {
	
				// Bulk operations run against the entire set
				if ( raw ) {
					fn.call( elems, value );
					fn = null;
	
				// ...except when executing function values
				} else {
					bulk = fn;
					fn = function( elem, key, value ) {
						return bulk.call( jQuery( elem ), value );
					};
				}
			}
	
			if ( fn ) {
				for ( ; i < length; i++ ) {
					fn(
						elems[ i ],
						key,
						raw ? value : value.call( elems[ i ], i, fn( elems[ i ], key ) )
					);
				}
			}
		}
	
		return chainable ?
			elems :
	
			// Gets
			bulk ?
				fn.call( elems ) :
				length ? fn( elems[ 0 ], key ) : emptyGet;
	};
	var rcheckableType = ( /^(?:checkbox|radio)$/i );
	
	var rtagName = ( /<([\w:-]+)/ );
	
	var rscriptType = ( /^$|\/(?:java|ecma)script/i );
	
	var rleadingWhitespace = ( /^\s+/ );
	
	var nodeNames = "abbr|article|aside|audio|bdi|canvas|data|datalist|" +
			"details|dialog|figcaption|figure|footer|header|hgroup|main|" +
			"mark|meter|nav|output|picture|progress|section|summary|template|time|video";
	
	
	
	function createSafeFragment( document ) {
		var list = nodeNames.split( "|" ),
			safeFrag = document.createDocumentFragment();
	
		if ( safeFrag.createElement ) {
			while ( list.length ) {
				safeFrag.createElement(
					list.pop()
				);
			}
		}
		return safeFrag;
	}
	
	
	( function() {
		var div = document.createElement( "div" ),
			fragment = document.createDocumentFragment(),
			input = document.createElement( "input" );
	
		// Setup
		div.innerHTML = "  <link/><table></table><a href='/a'>a</a><input type='checkbox'/>";
	
		// IE strips leading whitespace when .innerHTML is used
		support.leadingWhitespace = div.firstChild.nodeType === 3;
	
		// Make sure that tbody elements aren't automatically inserted
		// IE will insert them into empty tables
		support.tbody = !div.getElementsByTagName( "tbody" ).length;
	
		// Make sure that link elements get serialized correctly by innerHTML
		// This requires a wrapper element in IE
		support.htmlSerialize = !!div.getElementsByTagName( "link" ).length;
	
		// Makes sure cloning an html5 element does not cause problems
		// Where outerHTML is undefined, this still works
		support.html5Clone =
			document.createElement( "nav" ).cloneNode( true ).outerHTML !== "<:nav></:nav>";
	
		// Check if a disconnected checkbox will retain its checked
		// value of true after appended to the DOM (IE6/7)
		input.type = "checkbox";
		input.checked = true;
		fragment.appendChild( input );
		support.appendChecked = input.checked;
	
		// Make sure textarea (and checkbox) defaultValue is properly cloned
		// Support: IE6-IE11+
		div.innerHTML = "<textarea>x</textarea>";
		support.noCloneChecked = !!div.cloneNode( true ).lastChild.defaultValue;
	
		// #11217 - WebKit loses check when the name is after the checked attribute
		fragment.appendChild( div );
	
		// Support: Windows Web Apps (WWA)
		// `name` and `type` must use .setAttribute for WWA (#14901)
		input = document.createElement( "input" );
		input.setAttribute( "type", "radio" );
		input.setAttribute( "checked", "checked" );
		input.setAttribute( "name", "t" );
	
		div.appendChild( input );
	
		// Support: Safari 5.1, iOS 5.1, Android 4.x, Android 2.3
		// old WebKit doesn't clone checked state correctly in fragments
		support.checkClone = div.cloneNode( true ).cloneNode( true ).lastChild.checked;
	
		// Support: IE<9
		// Cloned elements keep attachEvent handlers, we use addEventListener on IE9+
		support.noCloneEvent = !!div.addEventListener;
	
		// Support: IE<9
		// Since attributes and properties are the same in IE,
		// cleanData must set properties to undefined rather than use removeAttribute
		div[ jQuery.expando ] = 1;
		support.attributes = !div.getAttribute( jQuery.expando );
	} )();
	
	
	// We have to close these tags to support XHTML (#13200)
	var wrapMap = {
		option: [ 1, "<select multiple='multiple'>", "</select>" ],
		legend: [ 1, "<fieldset>", "</fieldset>" ],
		area: [ 1, "<map>", "</map>" ],
	
		// Support: IE8
		param: [ 1, "<object>", "</object>" ],
		thead: [ 1, "<table>", "</table>" ],
		tr: [ 2, "<table><tbody>", "</tbody></table>" ],
		col: [ 2, "<table><tbody></tbody><colgroup>", "</colgroup></table>" ],
		td: [ 3, "<table><tbody><tr>", "</tr></tbody></table>" ],
	
		// IE6-8 can't serialize link, script, style, or any html5 (NoScope) tags,
		// unless wrapped in a div with non-breaking characters in front of it.
		_default: support.htmlSerialize ? [ 0, "", "" ] : [ 1, "X<div>", "</div>" ]
	};
	
	// Support: IE8-IE9
	wrapMap.optgroup = wrapMap.option;
	
	wrapMap.tbody = wrapMap.tfoot = wrapMap.colgroup = wrapMap.caption = wrapMap.thead;
	wrapMap.th = wrapMap.td;
	
	
	function getAll( context, tag ) {
		var elems, elem,
			i = 0,
			found = typeof context.getElementsByTagName !== "undefined" ?
				context.getElementsByTagName( tag || "*" ) :
				typeof context.querySelectorAll !== "undefined" ?
					context.querySelectorAll( tag || "*" ) :
					undefined;
	
		if ( !found ) {
			for ( found = [], elems = context.childNodes || context;
				( elem = elems[ i ] ) != null;
				i++
			) {
				if ( !tag || jQuery.nodeName( elem, tag ) ) {
					found.push( elem );
				} else {
					jQuery.merge( found, getAll( elem, tag ) );
				}
			}
		}
	
		return tag === undefined || tag && jQuery.nodeName( context, tag ) ?
			jQuery.merge( [ context ], found ) :
			found;
	}
	
	
	// Mark scripts as having already been evaluated
	function setGlobalEval( elems, refElements ) {
		var elem,
			i = 0;
		for ( ; ( elem = elems[ i ] ) != null; i++ ) {
			jQuery._data(
				elem,
				"globalEval",
				!refElements || jQuery._data( refElements[ i ], "globalEval" )
			);
		}
	}
	
	
	var rhtml = /<|&#?\w+;/,
		rtbody = /<tbody/i;
	
	function fixDefaultChecked( elem ) {
		if ( rcheckableType.test( elem.type ) ) {
			elem.defaultChecked = elem.checked;
		}
	}
	
	function buildFragment( elems, context, scripts, selection, ignored ) {
		var j, elem, contains,
			tmp, tag, tbody, wrap,
			l = elems.length,
	
			// Ensure a safe fragment
			safe = createSafeFragment( context ),
	
			nodes = [],
			i = 0;
	
		for ( ; i < l; i++ ) {
			elem = elems[ i ];
	
			if ( elem || elem === 0 ) {
	
				// Add nodes directly
				if ( jQuery.type( elem ) === "object" ) {
					jQuery.merge( nodes, elem.nodeType ? [ elem ] : elem );
	
				// Convert non-html into a text node
				} else if ( !rhtml.test( elem ) ) {
					nodes.push( context.createTextNode( elem ) );
	
				// Convert html into DOM nodes
				} else {
					tmp = tmp || safe.appendChild( context.createElement( "div" ) );
	
					// Deserialize a standard representation
					tag = ( rtagName.exec( elem ) || [ "", "" ] )[ 1 ].toLowerCase();
					wrap = wrapMap[ tag ] || wrapMap._default;
	
					tmp.innerHTML = wrap[ 1 ] + jQuery.htmlPrefilter( elem ) + wrap[ 2 ];
	
					// Descend through wrappers to the right content
					j = wrap[ 0 ];
					while ( j-- ) {
						tmp = tmp.lastChild;
					}
	
					// Manually add leading whitespace removed by IE
					if ( !support.leadingWhitespace && rleadingWhitespace.test( elem ) ) {
						nodes.push( context.createTextNode( rleadingWhitespace.exec( elem )[ 0 ] ) );
					}
	
					// Remove IE's autoinserted <tbody> from table fragments
					if ( !support.tbody ) {
	
						// String was a <table>, *may* have spurious <tbody>
						elem = tag === "table" && !rtbody.test( elem ) ?
							tmp.firstChild :
	
							// String was a bare <thead> or <tfoot>
							wrap[ 1 ] === "<table>" && !rtbody.test( elem ) ?
								tmp :
								0;
	
						j = elem && elem.childNodes.length;
						while ( j-- ) {
							if ( jQuery.nodeName( ( tbody = elem.childNodes[ j ] ), "tbody" ) &&
								!tbody.childNodes.length ) {
	
								elem.removeChild( tbody );
							}
						}
					}
	
					jQuery.merge( nodes, tmp.childNodes );
	
					// Fix #12392 for WebKit and IE > 9
					tmp.textContent = "";
	
					// Fix #12392 for oldIE
					while ( tmp.firstChild ) {
						tmp.removeChild( tmp.firstChild );
					}
	
					// Remember the top-level container for proper cleanup
					tmp = safe.lastChild;
				}
			}
		}
	
		// Fix #11356: Clear elements from fragment
		if ( tmp ) {
			safe.removeChild( tmp );
		}
	
		// Reset defaultChecked for any radios and checkboxes
		// about to be appended to the DOM in IE 6/7 (#8060)
		if ( !support.appendChecked ) {
			jQuery.grep( getAll( nodes, "input" ), fixDefaultChecked );
		}
	
		i = 0;
		while ( ( elem = nodes[ i++ ] ) ) {
	
			// Skip elements already in the context collection (trac-4087)
			if ( selection && jQuery.inArray( elem, selection ) > -1 ) {
				if ( ignored ) {
					ignored.push( elem );
				}
	
				continue;
			}
	
			contains = jQuery.contains( elem.ownerDocument, elem );
	
			// Append to fragment
			tmp = getAll( safe.appendChild( elem ), "script" );
	
			// Preserve script evaluation history
			if ( contains ) {
				setGlobalEval( tmp );
			}
	
			// Capture executables
			if ( scripts ) {
				j = 0;
				while ( ( elem = tmp[ j++ ] ) ) {
					if ( rscriptType.test( elem.type || "" ) ) {
						scripts.push( elem );
					}
				}
			}
		}
	
		tmp = null;
	
		return safe;
	}
	
	
	( function() {
		var i, eventName,
			div = document.createElement( "div" );
	
		// Support: IE<9 (lack submit/change bubble), Firefox (lack focus(in | out) events)
		for ( i in { submit: true, change: true, focusin: true } ) {
			eventName = "on" + i;
	
			if ( !( support[ i ] = eventName in window ) ) {
	
				// Beware of CSP restrictions (https://developer.mozilla.org/en/Security/CSP)
				div.setAttribute( eventName, "t" );
				support[ i ] = div.attributes[ eventName ].expando === false;
			}
		}
	
		// Null elements to avoid leaks in IE.
		div = null;
	} )();
	
	
	var rformElems = /^(?:input|select|textarea)$/i,
		rkeyEvent = /^key/,
		rmouseEvent = /^(?:mouse|pointer|contextmenu|drag|drop)|click/,
		rfocusMorph = /^(?:focusinfocus|focusoutblur)$/,
		rtypenamespace = /^([^.]*)(?:\.(.+)|)/;
	
	function returnTrue() {
		return true;
	}
	
	function returnFalse() {
		return false;
	}
	
	// Support: IE9
	// See #13393 for more info
	function safeActiveElement() {
		try {
			return document.activeElement;
		} catch ( err ) { }
	}
	
	function on( elem, types, selector, data, fn, one ) {
		var origFn, type;
	
		// Types can be a map of types/handlers
		if ( typeof types === "object" ) {
	
			// ( types-Object, selector, data )
			if ( typeof selector !== "string" ) {
	
				// ( types-Object, data )
				data = data || selector;
				selector = undefined;
			}
			for ( type in types ) {
				on( elem, type, selector, data, types[ type ], one );
			}
			return elem;
		}
	
		if ( data == null && fn == null ) {
	
			// ( types, fn )
			fn = selector;
			data = selector = undefined;
		} else if ( fn == null ) {
			if ( typeof selector === "string" ) {
	
				// ( types, selector, fn )
				fn = data;
				data = undefined;
			} else {
	
				// ( types, data, fn )
				fn = data;
				data = selector;
				selector = undefined;
			}
		}
		if ( fn === false ) {
			fn = returnFalse;
		} else if ( !fn ) {
			return elem;
		}
	
		if ( one === 1 ) {
			origFn = fn;
			fn = function( event ) {
	
				// Can use an empty set, since event contains the info
				jQuery().off( event );
				return origFn.apply( this, arguments );
			};
	
			// Use same guid so caller can remove using origFn
			fn.guid = origFn.guid || ( origFn.guid = jQuery.guid++ );
		}
		return elem.each( function() {
			jQuery.event.add( this, types, fn, data, selector );
		} );
	}
	
	/*
	 * Helper functions for managing events -- not part of the public interface.
	 * Props to Dean Edwards' addEvent library for many of the ideas.
	 */
	jQuery.event = {
	
		global: {},
	
		add: function( elem, types, handler, data, selector ) {
			var tmp, events, t, handleObjIn,
				special, eventHandle, handleObj,
				handlers, type, namespaces, origType,
				elemData = jQuery._data( elem );
	
			// Don't attach events to noData or text/comment nodes (but allow plain objects)
			if ( !elemData ) {
				return;
			}
	
			// Caller can pass in an object of custom data in lieu of the handler
			if ( handler.handler ) {
				handleObjIn = handler;
				handler = handleObjIn.handler;
				selector = handleObjIn.selector;
			}
	
			// Make sure that the handler has a unique ID, used to find/remove it later
			if ( !handler.guid ) {
				handler.guid = jQuery.guid++;
			}
	
			// Init the element's event structure and main handler, if this is the first
			if ( !( events = elemData.events ) ) {
				events = elemData.events = {};
			}
			if ( !( eventHandle = elemData.handle ) ) {
				eventHandle = elemData.handle = function( e ) {
	
					// Discard the second event of a jQuery.event.trigger() and
					// when an event is called after a page has unloaded
					return typeof jQuery !== "undefined" &&
						( !e || jQuery.event.triggered !== e.type ) ?
						jQuery.event.dispatch.apply( eventHandle.elem, arguments ) :
						undefined;
				};
	
				// Add elem as a property of the handle fn to prevent a memory leak
				// with IE non-native events
				eventHandle.elem = elem;
			}
	
			// Handle multiple events separated by a space
			types = ( types || "" ).match( rnotwhite ) || [ "" ];
			t = types.length;
			while ( t-- ) {
				tmp = rtypenamespace.exec( types[ t ] ) || [];
				type = origType = tmp[ 1 ];
				namespaces = ( tmp[ 2 ] || "" ).split( "." ).sort();
	
				// There *must* be a type, no attaching namespace-only handlers
				if ( !type ) {
					continue;
				}
	
				// If event changes its type, use the special event handlers for the changed type
				special = jQuery.event.special[ type ] || {};
	
				// If selector defined, determine special event api type, otherwise given type
				type = ( selector ? special.delegateType : special.bindType ) || type;
	
				// Update special based on newly reset type
				special = jQuery.event.special[ type ] || {};
	
				// handleObj is passed to all event handlers
				handleObj = jQuery.extend( {
					type: type,
					origType: origType,
					data: data,
					handler: handler,
					guid: handler.guid,
					selector: selector,
					needsContext: selector && jQuery.expr.match.needsContext.test( selector ),
					namespace: namespaces.join( "." )
				}, handleObjIn );
	
				// Init the event handler queue if we're the first
				if ( !( handlers = events[ type ] ) ) {
					handlers = events[ type ] = [];
					handlers.delegateCount = 0;
	
					// Only use addEventListener/attachEvent if the special events handler returns false
					if ( !special.setup ||
						special.setup.call( elem, data, namespaces, eventHandle ) === false ) {
	
						// Bind the global event handler to the element
						if ( elem.addEventListener ) {
							elem.addEventListener( type, eventHandle, false );
	
						} else if ( elem.attachEvent ) {
							elem.attachEvent( "on" + type, eventHandle );
						}
					}
				}
	
				if ( special.add ) {
					special.add.call( elem, handleObj );
	
					if ( !handleObj.handler.guid ) {
						handleObj.handler.guid = handler.guid;
					}
				}
	
				// Add to the element's handler list, delegates in front
				if ( selector ) {
					handlers.splice( handlers.delegateCount++, 0, handleObj );
				} else {
					handlers.push( handleObj );
				}
	
				// Keep track of which events have ever been used, for event optimization
				jQuery.event.global[ type ] = true;
			}
	
			// Nullify elem to prevent memory leaks in IE
			elem = null;
		},
	
		// Detach an event or set of events from an element
		remove: function( elem, types, handler, selector, mappedTypes ) {
			var j, handleObj, tmp,
				origCount, t, events,
				special, handlers, type,
				namespaces, origType,
				elemData = jQuery.hasData( elem ) && jQuery._data( elem );
	
			if ( !elemData || !( events = elemData.events ) ) {
				return;
			}
	
			// Once for each type.namespace in types; type may be omitted
			types = ( types || "" ).match( rnotwhite ) || [ "" ];
			t = types.length;
			while ( t-- ) {
				tmp = rtypenamespace.exec( types[ t ] ) || [];
				type = origType = tmp[ 1 ];
				namespaces = ( tmp[ 2 ] || "" ).split( "." ).sort();
	
				// Unbind all events (on this namespace, if provided) for the element
				if ( !type ) {
					for ( type in events ) {
						jQuery.event.remove( elem, type + types[ t ], handler, selector, true );
					}
					continue;
				}
	
				special = jQuery.event.special[ type ] || {};
				type = ( selector ? special.delegateType : special.bindType ) || type;
				handlers = events[ type ] || [];
				tmp = tmp[ 2 ] &&
					new RegExp( "(^|\\.)" + namespaces.join( "\\.(?:.*\\.|)" ) + "(\\.|$)" );
	
				// Remove matching events
				origCount = j = handlers.length;
				while ( j-- ) {
					handleObj = handlers[ j ];
	
					if ( ( mappedTypes || origType === handleObj.origType ) &&
						( !handler || handler.guid === handleObj.guid ) &&
						( !tmp || tmp.test( handleObj.namespace ) ) &&
						( !selector || selector === handleObj.selector ||
							selector === "**" && handleObj.selector ) ) {
						handlers.splice( j, 1 );
	
						if ( handleObj.selector ) {
							handlers.delegateCount--;
						}
						if ( special.remove ) {
							special.remove.call( elem, handleObj );
						}
					}
				}
	
				// Remove generic event handler if we removed something and no more handlers exist
				// (avoids potential for endless recursion during removal of special event handlers)
				if ( origCount && !handlers.length ) {
					if ( !special.teardown ||
						special.teardown.call( elem, namespaces, elemData.handle ) === false ) {
	
						jQuery.removeEvent( elem, type, elemData.handle );
					}
	
					delete events[ type ];
				}
			}
	
			// Remove the expando if it's no longer used
			if ( jQuery.isEmptyObject( events ) ) {
				delete elemData.handle;
	
				// removeData also checks for emptiness and clears the expando if empty
				// so use it instead of delete
				jQuery._removeData( elem, "events" );
			}
		},
	
		trigger: function( event, data, elem, onlyHandlers ) {
			var handle, ontype, cur,
				bubbleType, special, tmp, i,
				eventPath = [ elem || document ],
				type = hasOwn.call( event, "type" ) ? event.type : event,
				namespaces = hasOwn.call( event, "namespace" ) ? event.namespace.split( "." ) : [];
	
			cur = tmp = elem = elem || document;
	
			// Don't do events on text and comment nodes
			if ( elem.nodeType === 3 || elem.nodeType === 8 ) {
				return;
			}
	
			// focus/blur morphs to focusin/out; ensure we're not firing them right now
			if ( rfocusMorph.test( type + jQuery.event.triggered ) ) {
				return;
			}
	
			if ( type.indexOf( "." ) > -1 ) {
	
				// Namespaced trigger; create a regexp to match event type in handle()
				namespaces = type.split( "." );
				type = namespaces.shift();
				namespaces.sort();
			}
			ontype = type.indexOf( ":" ) < 0 && "on" + type;
	
			// Caller can pass in a jQuery.Event object, Object, or just an event type string
			event = event[ jQuery.expando ] ?
				event :
				new jQuery.Event( type, typeof event === "object" && event );
	
			// Trigger bitmask: & 1 for native handlers; & 2 for jQuery (always true)
			event.isTrigger = onlyHandlers ? 2 : 3;
			event.namespace = namespaces.join( "." );
			event.rnamespace = event.namespace ?
				new RegExp( "(^|\\.)" + namespaces.join( "\\.(?:.*\\.|)" ) + "(\\.|$)" ) :
				null;
	
			// Clean up the event in case it is being reused
			event.result = undefined;
			if ( !event.target ) {
				event.target = elem;
			}
	
			// Clone any incoming data and prepend the event, creating the handler arg list
			data = data == null ?
				[ event ] :
				jQuery.makeArray( data, [ event ] );
	
			// Allow special events to draw outside the lines
			special = jQuery.event.special[ type ] || {};
			if ( !onlyHandlers && special.trigger && special.trigger.apply( elem, data ) === false ) {
				return;
			}
	
			// Determine event propagation path in advance, per W3C events spec (#9951)
			// Bubble up to document, then to window; watch for a global ownerDocument var (#9724)
			if ( !onlyHandlers && !special.noBubble && !jQuery.isWindow( elem ) ) {
	
				bubbleType = special.delegateType || type;
				if ( !rfocusMorph.test( bubbleType + type ) ) {
					cur = cur.parentNode;
				}
				for ( ; cur; cur = cur.parentNode ) {
					eventPath.push( cur );
					tmp = cur;
				}
	
				// Only add window if we got to document (e.g., not plain obj or detached DOM)
				if ( tmp === ( elem.ownerDocument || document ) ) {
					eventPath.push( tmp.defaultView || tmp.parentWindow || window );
				}
			}
	
			// Fire handlers on the event path
			i = 0;
			while ( ( cur = eventPath[ i++ ] ) && !event.isPropagationStopped() ) {
	
				event.type = i > 1 ?
					bubbleType :
					special.bindType || type;
	
				// jQuery handler
				handle = ( jQuery._data( cur, "events" ) || {} )[ event.type ] &&
					jQuery._data( cur, "handle" );
	
				if ( handle ) {
					handle.apply( cur, data );
				}
	
				// Native handler
				handle = ontype && cur[ ontype ];
				if ( handle && handle.apply && acceptData( cur ) ) {
					event.result = handle.apply( cur, data );
					if ( event.result === false ) {
						event.preventDefault();
					}
				}
			}
			event.type = type;
	
			// If nobody prevented the default action, do it now
			if ( !onlyHandlers && !event.isDefaultPrevented() ) {
	
				if (
					( !special._default ||
					 special._default.apply( eventPath.pop(), data ) === false
					) && acceptData( elem )
				) {
	
					// Call a native DOM method on the target with the same name name as the event.
					// Can't use an .isFunction() check here because IE6/7 fails that test.
					// Don't do default actions on window, that's where global variables be (#6170)
					if ( ontype && elem[ type ] && !jQuery.isWindow( elem ) ) {
	
						// Don't re-trigger an onFOO event when we call its FOO() method
						tmp = elem[ ontype ];
	
						if ( tmp ) {
							elem[ ontype ] = null;
						}
	
						// Prevent re-triggering of the same event, since we already bubbled it above
						jQuery.event.triggered = type;
						try {
							elem[ type ]();
						} catch ( e ) {
	
							// IE<9 dies on focus/blur to hidden element (#1486,#12518)
							// only reproducible on winXP IE8 native, not IE9 in IE8 mode
						}
						jQuery.event.triggered = undefined;
	
						if ( tmp ) {
							elem[ ontype ] = tmp;
						}
					}
				}
			}
	
			return event.result;
		},
	
		dispatch: function( event ) {
	
			// Make a writable jQuery.Event from the native event object
			event = jQuery.event.fix( event );
	
			var i, j, ret, matched, handleObj,
				handlerQueue = [],
				args = slice.call( arguments ),
				handlers = ( jQuery._data( this, "events" ) || {} )[ event.type ] || [],
				special = jQuery.event.special[ event.type ] || {};
	
			// Use the fix-ed jQuery.Event rather than the (read-only) native event
			args[ 0 ] = event;
			event.delegateTarget = this;
	
			// Call the preDispatch hook for the mapped type, and let it bail if desired
			if ( special.preDispatch && special.preDispatch.call( this, event ) === false ) {
				return;
			}
	
			// Determine handlers
			handlerQueue = jQuery.event.handlers.call( this, event, handlers );
	
			// Run delegates first; they may want to stop propagation beneath us
			i = 0;
			while ( ( matched = handlerQueue[ i++ ] ) && !event.isPropagationStopped() ) {
				event.currentTarget = matched.elem;
	
				j = 0;
				while ( ( handleObj = matched.handlers[ j++ ] ) &&
					!event.isImmediatePropagationStopped() ) {
	
					// Triggered event must either 1) have no namespace, or 2) have namespace(s)
					// a subset or equal to those in the bound event (both can have no namespace).
					if ( !event.rnamespace || event.rnamespace.test( handleObj.namespace ) ) {
	
						event.handleObj = handleObj;
						event.data = handleObj.data;
	
						ret = ( ( jQuery.event.special[ handleObj.origType ] || {} ).handle ||
							handleObj.handler ).apply( matched.elem, args );
	
						if ( ret !== undefined ) {
							if ( ( event.result = ret ) === false ) {
								event.preventDefault();
								event.stopPropagation();
							}
						}
					}
				}
			}
	
			// Call the postDispatch hook for the mapped type
			if ( special.postDispatch ) {
				special.postDispatch.call( this, event );
			}
	
			return event.result;
		},
	
		handlers: function( event, handlers ) {
			var i, matches, sel, handleObj,
				handlerQueue = [],
				delegateCount = handlers.delegateCount,
				cur = event.target;
	
			// Support (at least): Chrome, IE9
			// Find delegate handlers
			// Black-hole SVG <use> instance trees (#13180)
			//
			// Support: Firefox<=42+
			// Avoid non-left-click in FF but don't block IE radio events (#3861, gh-2343)
			if ( delegateCount && cur.nodeType &&
				( event.type !== "click" || isNaN( event.button ) || event.button < 1 ) ) {
	
				/* jshint eqeqeq: false */
				for ( ; cur != this; cur = cur.parentNode || this ) {
					/* jshint eqeqeq: true */
	
					// Don't check non-elements (#13208)
					// Don't process clicks on disabled elements (#6911, #8165, #11382, #11764)
					if ( cur.nodeType === 1 && ( cur.disabled !== true || event.type !== "click" ) ) {
						matches = [];
						for ( i = 0; i < delegateCount; i++ ) {
							handleObj = handlers[ i ];
	
							// Don't conflict with Object.prototype properties (#13203)
							sel = handleObj.selector + " ";
	
							if ( matches[ sel ] === undefined ) {
								matches[ sel ] = handleObj.needsContext ?
									jQuery( sel, this ).index( cur ) > -1 :
									jQuery.find( sel, this, null, [ cur ] ).length;
							}
							if ( matches[ sel ] ) {
								matches.push( handleObj );
							}
						}
						if ( matches.length ) {
							handlerQueue.push( { elem: cur, handlers: matches } );
						}
					}
				}
			}
	
			// Add the remaining (directly-bound) handlers
			if ( delegateCount < handlers.length ) {
				handlerQueue.push( { elem: this, handlers: handlers.slice( delegateCount ) } );
			}
	
			return handlerQueue;
		},
	
		fix: function( event ) {
			if ( event[ jQuery.expando ] ) {
				return event;
			}
	
			// Create a writable copy of the event object and normalize some properties
			var i, prop, copy,
				type = event.type,
				originalEvent = event,
				fixHook = this.fixHooks[ type ];
	
			if ( !fixHook ) {
				this.fixHooks[ type ] = fixHook =
					rmouseEvent.test( type ) ? this.mouseHooks :
					rkeyEvent.test( type ) ? this.keyHooks :
					{};
			}
			copy = fixHook.props ? this.props.concat( fixHook.props ) : this.props;
	
			event = new jQuery.Event( originalEvent );
	
			i = copy.length;
			while ( i-- ) {
				prop = copy[ i ];
				event[ prop ] = originalEvent[ prop ];
			}
	
			// Support: IE<9
			// Fix target property (#1925)
			if ( !event.target ) {
				event.target = originalEvent.srcElement || document;
			}
	
			// Support: Safari 6-8+
			// Target should not be a text node (#504, #13143)
			if ( event.target.nodeType === 3 ) {
				event.target = event.target.parentNode;
			}
	
			// Support: IE<9
			// For mouse/key events, metaKey==false if it's undefined (#3368, #11328)
			event.metaKey = !!event.metaKey;
	
			return fixHook.filter ? fixHook.filter( event, originalEvent ) : event;
		},
	
		// Includes some event props shared by KeyEvent and MouseEvent
		props: ( "altKey bubbles cancelable ctrlKey currentTarget detail eventPhase " +
			"metaKey relatedTarget shiftKey target timeStamp view which" ).split( " " ),
	
		fixHooks: {},
	
		keyHooks: {
			props: "char charCode key keyCode".split( " " ),
			filter: function( event, original ) {
	
				// Add which for key events
				if ( event.which == null ) {
					event.which = original.charCode != null ? original.charCode : original.keyCode;
				}
	
				return event;
			}
		},
	
		mouseHooks: {
			props: ( "button buttons clientX clientY fromElement offsetX offsetY " +
				"pageX pageY screenX screenY toElement" ).split( " " ),
			filter: function( event, original ) {
				var body, eventDoc, doc,
					button = original.button,
					fromElement = original.fromElement;
	
				// Calculate pageX/Y if missing and clientX/Y available
				if ( event.pageX == null && original.clientX != null ) {
					eventDoc = event.target.ownerDocument || document;
					doc = eventDoc.documentElement;
					body = eventDoc.body;
	
					event.pageX = original.clientX +
						( doc && doc.scrollLeft || body && body.scrollLeft || 0 ) -
						( doc && doc.clientLeft || body && body.clientLeft || 0 );
					event.pageY = original.clientY +
						( doc && doc.scrollTop  || body && body.scrollTop  || 0 ) -
						( doc && doc.clientTop  || body && body.clientTop  || 0 );
				}
	
				// Add relatedTarget, if necessary
				if ( !event.relatedTarget && fromElement ) {
					event.relatedTarget = fromElement === event.target ?
						original.toElement :
						fromElement;
				}
	
				// Add which for click: 1 === left; 2 === middle; 3 === right
				// Note: button is not normalized, so don't use it
				if ( !event.which && button !== undefined ) {
					event.which = ( button & 1 ? 1 : ( button & 2 ? 3 : ( button & 4 ? 2 : 0 ) ) );
				}
	
				return event;
			}
		},
	
		special: {
			load: {
	
				// Prevent triggered image.load events from bubbling to window.load
				noBubble: true
			},
			focus: {
	
				// Fire native event if possible so blur/focus sequence is correct
				trigger: function() {
					if ( this !== safeActiveElement() && this.focus ) {
						try {
							this.focus();
							return false;
						} catch ( e ) {
	
							// Support: IE<9
							// If we error on focus to hidden element (#1486, #12518),
							// let .trigger() run the handlers
						}
					}
				},
				delegateType: "focusin"
			},
			blur: {
				trigger: function() {
					if ( this === safeActiveElement() && this.blur ) {
						this.blur();
						return false;
					}
				},
				delegateType: "focusout"
			},
			click: {
	
				// For checkbox, fire native event so checked state will be right
				trigger: function() {
					if ( jQuery.nodeName( this, "input" ) && this.type === "checkbox" && this.click ) {
						this.click();
						return false;
					}
				},
	
				// For cross-browser consistency, don't fire native .click() on links
				_default: function( event ) {
					return jQuery.nodeName( event.target, "a" );
				}
			},
	
			beforeunload: {
				postDispatch: function( event ) {
	
					// Support: Firefox 20+
					// Firefox doesn't alert if the returnValue field is not set.
					if ( event.result !== undefined && event.originalEvent ) {
						event.originalEvent.returnValue = event.result;
					}
				}
			}
		},
	
		// Piggyback on a donor event to simulate a different one
		simulate: function( type, elem, event ) {
			var e = jQuery.extend(
				new jQuery.Event(),
				event,
				{
					type: type,
					isSimulated: true
	
					// Previously, `originalEvent: {}` was set here, so stopPropagation call
					// would not be triggered on donor event, since in our own
					// jQuery.event.stopPropagation function we had a check for existence of
					// originalEvent.stopPropagation method, so, consequently it would be a noop.
					//
					// Guard for simulated events was moved to jQuery.event.stopPropagation function
					// since `originalEvent` should point to the original event for the
					// constancy with other events and for more focused logic
				}
			);
	
			jQuery.event.trigger( e, null, elem );
	
			if ( e.isDefaultPrevented() ) {
				event.preventDefault();
			}
		}
	};
	
	jQuery.removeEvent = document.removeEventListener ?
		function( elem, type, handle ) {
	
			// This "if" is needed for plain objects
			if ( elem.removeEventListener ) {
				elem.removeEventListener( type, handle );
			}
		} :
		function( elem, type, handle ) {
			var name = "on" + type;
	
			if ( elem.detachEvent ) {
	
				// #8545, #7054, preventing memory leaks for custom events in IE6-8
				// detachEvent needed property on element, by name of that event,
				// to properly expose it to GC
				if ( typeof elem[ name ] === "undefined" ) {
					elem[ name ] = null;
				}
	
				elem.detachEvent( name, handle );
			}
		};
	
	jQuery.Event = function( src, props ) {
	
		// Allow instantiation without the 'new' keyword
		if ( !( this instanceof jQuery.Event ) ) {
			return new jQuery.Event( src, props );
		}
	
		// Event object
		if ( src && src.type ) {
			this.originalEvent = src;
			this.type = src.type;
	
			// Events bubbling up the document may have been marked as prevented
			// by a handler lower down the tree; reflect the correct value.
			this.isDefaultPrevented = src.defaultPrevented ||
					src.defaultPrevented === undefined &&
	
					// Support: IE < 9, Android < 4.0
					src.returnValue === false ?
				returnTrue :
				returnFalse;
	
		// Event type
		} else {
			this.type = src;
		}
	
		// Put explicitly provided properties onto the event object
		if ( props ) {
			jQuery.extend( this, props );
		}
	
		// Create a timestamp if incoming event doesn't have one
		this.timeStamp = src && src.timeStamp || jQuery.now();
	
		// Mark it as fixed
		this[ jQuery.expando ] = true;
	};
	
	// jQuery.Event is based on DOM3 Events as specified by the ECMAScript Language Binding
	// http://www.w3.org/TR/2003/WD-DOM-Level-3-Events-20030331/ecma-script-binding.html
	jQuery.Event.prototype = {
		constructor: jQuery.Event,
		isDefaultPrevented: returnFalse,
		isPropagationStopped: returnFalse,
		isImmediatePropagationStopped: returnFalse,
	
		preventDefault: function() {
			var e = this.originalEvent;
	
			this.isDefaultPrevented = returnTrue;
			if ( !e ) {
				return;
			}
	
			// If preventDefault exists, run it on the original event
			if ( e.preventDefault ) {
				e.preventDefault();
	
			// Support: IE
			// Otherwise set the returnValue property of the original event to false
			} else {
				e.returnValue = false;
			}
		},
		stopPropagation: function() {
			var e = this.originalEvent;
	
			this.isPropagationStopped = returnTrue;
	
			if ( !e || this.isSimulated ) {
				return;
			}
	
			// If stopPropagation exists, run it on the original event
			if ( e.stopPropagation ) {
				e.stopPropagation();
			}
	
			// Support: IE
			// Set the cancelBubble property of the original event to true
			e.cancelBubble = true;
		},
		stopImmediatePropagation: function() {
			var e = this.originalEvent;
	
			this.isImmediatePropagationStopped = returnTrue;
	
			if ( e && e.stopImmediatePropagation ) {
				e.stopImmediatePropagation();
			}
	
			this.stopPropagation();
		}
	};
	
	// Create mouseenter/leave events using mouseover/out and event-time checks
	// so that event delegation works in jQuery.
	// Do the same for pointerenter/pointerleave and pointerover/pointerout
	//
	// Support: Safari 7 only
	// Safari sends mouseenter too often; see:
	// https://code.google.com/p/chromium/issues/detail?id=470258
	// for the description of the bug (it existed in older Chrome versions as well).
	jQuery.each( {
		mouseenter: "mouseover",
		mouseleave: "mouseout",
		pointerenter: "pointerover",
		pointerleave: "pointerout"
	}, function( orig, fix ) {
		jQuery.event.special[ orig ] = {
			delegateType: fix,
			bindType: fix,
	
			handle: function( event ) {
				var ret,
					target = this,
					related = event.relatedTarget,
					handleObj = event.handleObj;
	
				// For mouseenter/leave call the handler if related is outside the target.
				// NB: No relatedTarget if the mouse left/entered the browser window
				if ( !related || ( related !== target && !jQuery.contains( target, related ) ) ) {
					event.type = handleObj.origType;
					ret = handleObj.handler.apply( this, arguments );
					event.type = fix;
				}
				return ret;
			}
		};
	} );
	
	// IE submit delegation
	if ( !support.submit ) {
	
		jQuery.event.special.submit = {
			setup: function() {
	
				// Only need this for delegated form submit events
				if ( jQuery.nodeName( this, "form" ) ) {
					return false;
				}
	
				// Lazy-add a submit handler when a descendant form may potentially be submitted
				jQuery.event.add( this, "click._submit keypress._submit", function( e ) {
	
					// Node name check avoids a VML-related crash in IE (#9807)
					var elem = e.target,
						form = jQuery.nodeName( elem, "input" ) || jQuery.nodeName( elem, "button" ) ?
	
							// Support: IE <=8
							// We use jQuery.prop instead of elem.form
							// to allow fixing the IE8 delegated submit issue (gh-2332)
							// by 3rd party polyfills/workarounds.
							jQuery.prop( elem, "form" ) :
							undefined;
	
					if ( form && !jQuery._data( form, "submit" ) ) {
						jQuery.event.add( form, "submit._submit", function( event ) {
							event._submitBubble = true;
						} );
						jQuery._data( form, "submit", true );
					}
				} );
	
				// return undefined since we don't need an event listener
			},
	
			postDispatch: function( event ) {
	
				// If form was submitted by the user, bubble the event up the tree
				if ( event._submitBubble ) {
					delete event._submitBubble;
					if ( this.parentNode && !event.isTrigger ) {
						jQuery.event.simulate( "submit", this.parentNode, event );
					}
				}
			},
	
			teardown: function() {
	
				// Only need this for delegated form submit events
				if ( jQuery.nodeName( this, "form" ) ) {
					return false;
				}
	
				// Remove delegated handlers; cleanData eventually reaps submit handlers attached above
				jQuery.event.remove( this, "._submit" );
			}
		};
	}
	
	// IE change delegation and checkbox/radio fix
	if ( !support.change ) {
	
		jQuery.event.special.change = {
	
			setup: function() {
	
				if ( rformElems.test( this.nodeName ) ) {
	
					// IE doesn't fire change on a check/radio until blur; trigger it on click
					// after a propertychange. Eat the blur-change in special.change.handle.
					// This still fires onchange a second time for check/radio after blur.
					if ( this.type === "checkbox" || this.type === "radio" ) {
						jQuery.event.add( this, "propertychange._change", function( event ) {
							if ( event.originalEvent.propertyName === "checked" ) {
								this._justChanged = true;
							}
						} );
						jQuery.event.add( this, "click._change", function( event ) {
							if ( this._justChanged && !event.isTrigger ) {
								this._justChanged = false;
							}
	
							// Allow triggered, simulated change events (#11500)
							jQuery.event.simulate( "change", this, event );
						} );
					}
					return false;
				}
	
				// Delegated event; lazy-add a change handler on descendant inputs
				jQuery.event.add( this, "beforeactivate._change", function( e ) {
					var elem = e.target;
	
					if ( rformElems.test( elem.nodeName ) && !jQuery._data( elem, "change" ) ) {
						jQuery.event.add( elem, "change._change", function( event ) {
							if ( this.parentNode && !event.isSimulated && !event.isTrigger ) {
								jQuery.event.simulate( "change", this.parentNode, event );
							}
						} );
						jQuery._data( elem, "change", true );
					}
				} );
			},
	
			handle: function( event ) {
				var elem = event.target;
	
				// Swallow native change events from checkbox/radio, we already triggered them above
				if ( this !== elem || event.isSimulated || event.isTrigger ||
					( elem.type !== "radio" && elem.type !== "checkbox" ) ) {
	
					return event.handleObj.handler.apply( this, arguments );
				}
			},
	
			teardown: function() {
				jQuery.event.remove( this, "._change" );
	
				return !rformElems.test( this.nodeName );
			}
		};
	}
	
	// Support: Firefox
	// Firefox doesn't have focus(in | out) events
	// Related ticket - https://bugzilla.mozilla.org/show_bug.cgi?id=687787
	//
	// Support: Chrome, Safari
	// focus(in | out) events fire after focus & blur events,
	// which is spec violation - http://www.w3.org/TR/DOM-Level-3-Events/#events-focusevent-event-order
	// Related ticket - https://code.google.com/p/chromium/issues/detail?id=449857
	if ( !support.focusin ) {
		jQuery.each( { focus: "focusin", blur: "focusout" }, function( orig, fix ) {
	
			// Attach a single capturing handler on the document while someone wants focusin/focusout
			var handler = function( event ) {
				jQuery.event.simulate( fix, event.target, jQuery.event.fix( event ) );
			};
	
			jQuery.event.special[ fix ] = {
				setup: function() {
					var doc = this.ownerDocument || this,
						attaches = jQuery._data( doc, fix );
	
					if ( !attaches ) {
						doc.addEventListener( orig, handler, true );
					}
					jQuery._data( doc, fix, ( attaches || 0 ) + 1 );
				},
				teardown: function() {
					var doc = this.ownerDocument || this,
						attaches = jQuery._data( doc, fix ) - 1;
	
					if ( !attaches ) {
						doc.removeEventListener( orig, handler, true );
						jQuery._removeData( doc, fix );
					} else {
						jQuery._data( doc, fix, attaches );
					}
				}
			};
		} );
	}
	
	jQuery.fn.extend( {
	
		on: function( types, selector, data, fn ) {
			return on( this, types, selector, data, fn );
		},
		one: function( types, selector, data, fn ) {
			return on( this, types, selector, data, fn, 1 );
		},
		off: function( types, selector, fn ) {
			var handleObj, type;
			if ( types && types.preventDefault && types.handleObj ) {
	
				// ( event )  dispatched jQuery.Event
				handleObj = types.handleObj;
				jQuery( types.delegateTarget ).off(
					handleObj.namespace ?
						handleObj.origType + "." + handleObj.namespace :
						handleObj.origType,
					handleObj.selector,
					handleObj.handler
				);
				return this;
			}
			if ( typeof types === "object" ) {
	
				// ( types-object [, selector] )
				for ( type in types ) {
					this.off( type, selector, types[ type ] );
				}
				return this;
			}
			if ( selector === false || typeof selector === "function" ) {
	
				// ( types [, fn] )
				fn = selector;
				selector = undefined;
			}
			if ( fn === false ) {
				fn = returnFalse;
			}
			return this.each( function() {
				jQuery.event.remove( this, types, fn, selector );
			} );
		},
	
		trigger: function( type, data ) {
			return this.each( function() {
				jQuery.event.trigger( type, data, this );
			} );
		},
		triggerHandler: function( type, data ) {
			var elem = this[ 0 ];
			if ( elem ) {
				return jQuery.event.trigger( type, data, elem, true );
			}
		}
	} );
	
	
	var rinlinejQuery = / jQuery\d+="(?:null|\d+)"/g,
		rnoshimcache = new RegExp( "<(?:" + nodeNames + ")[\\s/>]", "i" ),
		rxhtmlTag = /<(?!area|br|col|embed|hr|img|input|link|meta|param)(([\w:-]+)[^>]*)\/>/gi,
	
		// Support: IE 10-11, Edge 10240+
		// In IE/Edge using regex groups here causes severe slowdowns.
		// See https://connect.microsoft.com/IE/feedback/details/1736512/
		rnoInnerhtml = /<script|<style|<link/i,
	
		// checked="checked" or checked
		rchecked = /checked\s*(?:[^=]|=\s*.checked.)/i,
		rscriptTypeMasked = /^true\/(.*)/,
		rcleanScript = /^\s*<!(?:\[CDATA\[|--)|(?:\]\]|--)>\s*$/g,
		safeFragment = createSafeFragment( document ),
		fragmentDiv = safeFragment.appendChild( document.createElement( "div" ) );
	
	// Support: IE<8
	// Manipulating tables requires a tbody
	function manipulationTarget( elem, content ) {
		return jQuery.nodeName( elem, "table" ) &&
			jQuery.nodeName( content.nodeType !== 11 ? content : content.firstChild, "tr" ) ?
	
			elem.getElementsByTagName( "tbody" )[ 0 ] ||
				elem.appendChild( elem.ownerDocument.createElement( "tbody" ) ) :
			elem;
	}
	
	// Replace/restore the type attribute of script elements for safe DOM manipulation
	function disableScript( elem ) {
		elem.type = ( jQuery.find.attr( elem, "type" ) !== null ) + "/" + elem.type;
		return elem;
	}
	function restoreScript( elem ) {
		var match = rscriptTypeMasked.exec( elem.type );
		if ( match ) {
			elem.type = match[ 1 ];
		} else {
			elem.removeAttribute( "type" );
		}
		return elem;
	}
	
	function cloneCopyEvent( src, dest ) {
		if ( dest.nodeType !== 1 || !jQuery.hasData( src ) ) {
			return;
		}
	
		var type, i, l,
			oldData = jQuery._data( src ),
			curData = jQuery._data( dest, oldData ),
			events = oldData.events;
	
		if ( events ) {
			delete curData.handle;
			curData.events = {};
	
			for ( type in events ) {
				for ( i = 0, l = events[ type ].length; i < l; i++ ) {
					jQuery.event.add( dest, type, events[ type ][ i ] );
				}
			}
		}
	
		// make the cloned public data object a copy from the original
		if ( curData.data ) {
			curData.data = jQuery.extend( {}, curData.data );
		}
	}
	
	function fixCloneNodeIssues( src, dest ) {
		var nodeName, e, data;
	
		// We do not need to do anything for non-Elements
		if ( dest.nodeType !== 1 ) {
			return;
		}
	
		nodeName = dest.nodeName.toLowerCase();
	
		// IE6-8 copies events bound via attachEvent when using cloneNode.
		if ( !support.noCloneEvent && dest[ jQuery.expando ] ) {
			data = jQuery._data( dest );
	
			for ( e in data.events ) {
				jQuery.removeEvent( dest, e, data.handle );
			}
	
			// Event data gets referenced instead of copied if the expando gets copied too
			dest.removeAttribute( jQuery.expando );
		}
	
		// IE blanks contents when cloning scripts, and tries to evaluate newly-set text
		if ( nodeName === "script" && dest.text !== src.text ) {
			disableScript( dest ).text = src.text;
			restoreScript( dest );
	
		// IE6-10 improperly clones children of object elements using classid.
		// IE10 throws NoModificationAllowedError if parent is null, #12132.
		} else if ( nodeName === "object" ) {
			if ( dest.parentNode ) {
				dest.outerHTML = src.outerHTML;
			}
	
			// This path appears unavoidable for IE9. When cloning an object
			// element in IE9, the outerHTML strategy above is not sufficient.
			// If the src has innerHTML and the destination does not,
			// copy the src.innerHTML into the dest.innerHTML. #10324
			if ( support.html5Clone && ( src.innerHTML && !jQuery.trim( dest.innerHTML ) ) ) {
				dest.innerHTML = src.innerHTML;
			}
	
		} else if ( nodeName === "input" && rcheckableType.test( src.type ) ) {
	
			// IE6-8 fails to persist the checked state of a cloned checkbox
			// or radio button. Worse, IE6-7 fail to give the cloned element
			// a checked appearance if the defaultChecked value isn't also set
	
			dest.defaultChecked = dest.checked = src.checked;
	
			// IE6-7 get confused and end up setting the value of a cloned
			// checkbox/radio button to an empty string instead of "on"
			if ( dest.value !== src.value ) {
				dest.value = src.value;
			}
	
		// IE6-8 fails to return the selected option to the default selected
		// state when cloning options
		} else if ( nodeName === "option" ) {
			dest.defaultSelected = dest.selected = src.defaultSelected;
	
		// IE6-8 fails to set the defaultValue to the correct value when
		// cloning other types of input fields
		} else if ( nodeName === "input" || nodeName === "textarea" ) {
			dest.defaultValue = src.defaultValue;
		}
	}
	
	function domManip( collection, args, callback, ignored ) {
	
		// Flatten any nested arrays
		args = concat.apply( [], args );
	
		var first, node, hasScripts,
			scripts, doc, fragment,
			i = 0,
			l = collection.length,
			iNoClone = l - 1,
			value = args[ 0 ],
			isFunction = jQuery.isFunction( value );
	
		// We can't cloneNode fragments that contain checked, in WebKit
		if ( isFunction ||
				( l > 1 && typeof value === "string" &&
					!support.checkClone && rchecked.test( value ) ) ) {
			return collection.each( function( index ) {
				var self = collection.eq( index );
				if ( isFunction ) {
					args[ 0 ] = value.call( this, index, self.html() );
				}
				domManip( self, args, callback, ignored );
			} );
		}
	
		if ( l ) {
			fragment = buildFragment( args, collection[ 0 ].ownerDocument, false, collection, ignored );
			first = fragment.firstChild;
	
			if ( fragment.childNodes.length === 1 ) {
				fragment = first;
			}
	
			// Require either new content or an interest in ignored elements to invoke the callback
			if ( first || ignored ) {
				scripts = jQuery.map( getAll( fragment, "script" ), disableScript );
				hasScripts = scripts.length;
	
				// Use the original fragment for the last item
				// instead of the first because it can end up
				// being emptied incorrectly in certain situations (#8070).
				for ( ; i < l; i++ ) {
					node = fragment;
	
					if ( i !== iNoClone ) {
						node = jQuery.clone( node, true, true );
	
						// Keep references to cloned scripts for later restoration
						if ( hasScripts ) {
	
							// Support: Android<4.1, PhantomJS<2
							// push.apply(_, arraylike) throws on ancient WebKit
							jQuery.merge( scripts, getAll( node, "script" ) );
						}
					}
	
					callback.call( collection[ i ], node, i );
				}
	
				if ( hasScripts ) {
					doc = scripts[ scripts.length - 1 ].ownerDocument;
	
					// Reenable scripts
					jQuery.map( scripts, restoreScript );
	
					// Evaluate executable scripts on first document insertion
					for ( i = 0; i < hasScripts; i++ ) {
						node = scripts[ i ];
						if ( rscriptType.test( node.type || "" ) &&
							!jQuery._data( node, "globalEval" ) &&
							jQuery.contains( doc, node ) ) {
	
							if ( node.src ) {
	
								// Optional AJAX dependency, but won't run scripts if not present
								if ( jQuery._evalUrl ) {
									jQuery._evalUrl( node.src );
								}
							} else {
								jQuery.globalEval(
									( node.text || node.textContent || node.innerHTML || "" )
										.replace( rcleanScript, "" )
								);
							}
						}
					}
				}
	
				// Fix #11809: Avoid leaking memory
				fragment = first = null;
			}
		}
	
		return collection;
	}
	
	function remove( elem, selector, keepData ) {
		var node,
			elems = selector ? jQuery.filter( selector, elem ) : elem,
			i = 0;
	
		for ( ; ( node = elems[ i ] ) != null; i++ ) {
	
			if ( !keepData && node.nodeType === 1 ) {
				jQuery.cleanData( getAll( node ) );
			}
	
			if ( node.parentNode ) {
				if ( keepData && jQuery.contains( node.ownerDocument, node ) ) {
					setGlobalEval( getAll( node, "script" ) );
				}
				node.parentNode.removeChild( node );
			}
		}
	
		return elem;
	}
	
	jQuery.extend( {
		htmlPrefilter: function( html ) {
			return html.replace( rxhtmlTag, "<$1></$2>" );
		},
	
		clone: function( elem, dataAndEvents, deepDataAndEvents ) {
			var destElements, node, clone, i, srcElements,
				inPage = jQuery.contains( elem.ownerDocument, elem );
	
			if ( support.html5Clone || jQuery.isXMLDoc( elem ) ||
				!rnoshimcache.test( "<" + elem.nodeName + ">" ) ) {
	
				clone = elem.cloneNode( true );
	
			// IE<=8 does not properly clone detached, unknown element nodes
			} else {
				fragmentDiv.innerHTML = elem.outerHTML;
				fragmentDiv.removeChild( clone = fragmentDiv.firstChild );
			}
	
			if ( ( !support.noCloneEvent || !support.noCloneChecked ) &&
					( elem.nodeType === 1 || elem.nodeType === 11 ) && !jQuery.isXMLDoc( elem ) ) {
	
				// We eschew Sizzle here for performance reasons: http://jsperf.com/getall-vs-sizzle/2
				destElements = getAll( clone );
				srcElements = getAll( elem );
	
				// Fix all IE cloning issues
				for ( i = 0; ( node = srcElements[ i ] ) != null; ++i ) {
	
					// Ensure that the destination node is not null; Fixes #9587
					if ( destElements[ i ] ) {
						fixCloneNodeIssues( node, destElements[ i ] );
					}
				}
			}
	
			// Copy the events from the original to the clone
			if ( dataAndEvents ) {
				if ( deepDataAndEvents ) {
					srcElements = srcElements || getAll( elem );
					destElements = destElements || getAll( clone );
	
					for ( i = 0; ( node = srcElements[ i ] ) != null; i++ ) {
						cloneCopyEvent( node, destElements[ i ] );
					}
				} else {
					cloneCopyEvent( elem, clone );
				}
			}
	
			// Preserve script evaluation history
			destElements = getAll( clone, "script" );
			if ( destElements.length > 0 ) {
				setGlobalEval( destElements, !inPage && getAll( elem, "script" ) );
			}
	
			destElements = srcElements = node = null;
	
			// Return the cloned set
			return clone;
		},
	
		cleanData: function( elems, /* internal */ forceAcceptData ) {
			var elem, type, id, data,
				i = 0,
				internalKey = jQuery.expando,
				cache = jQuery.cache,
				attributes = support.attributes,
				special = jQuery.event.special;
	
			for ( ; ( elem = elems[ i ] ) != null; i++ ) {
				if ( forceAcceptData || acceptData( elem ) ) {
	
					id = elem[ internalKey ];
					data = id && cache[ id ];
	
					if ( data ) {
						if ( data.events ) {
							for ( type in data.events ) {
								if ( special[ type ] ) {
									jQuery.event.remove( elem, type );
	
								// This is a shortcut to avoid jQuery.event.remove's overhead
								} else {
									jQuery.removeEvent( elem, type, data.handle );
								}
							}
						}
	
						// Remove cache only if it was not already removed by jQuery.event.remove
						if ( cache[ id ] ) {
	
							delete cache[ id ];
	
							// Support: IE<9
							// IE does not allow us to delete expando properties from nodes
							// IE creates expando attributes along with the property
							// IE does not have a removeAttribute function on Document nodes
							if ( !attributes && typeof elem.removeAttribute !== "undefined" ) {
								elem.removeAttribute( internalKey );
	
							// Webkit & Blink performance suffers when deleting properties
							// from DOM nodes, so set to undefined instead
							// https://code.google.com/p/chromium/issues/detail?id=378607
							} else {
								elem[ internalKey ] = undefined;
							}
	
							deletedIds.push( id );
						}
					}
				}
			}
		}
	} );
	
	jQuery.fn.extend( {
	
		// Keep domManip exposed until 3.0 (gh-2225)
		domManip: domManip,
	
		detach: function( selector ) {
			return remove( this, selector, true );
		},
	
		remove: function( selector ) {
			return remove( this, selector );
		},
	
		text: function( value ) {
			return access( this, function( value ) {
				return value === undefined ?
					jQuery.text( this ) :
					this.empty().append(
						( this[ 0 ] && this[ 0 ].ownerDocument || document ).createTextNode( value )
					);
			}, null, value, arguments.length );
		},
	
		append: function() {
			return domManip( this, arguments, function( elem ) {
				if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
					var target = manipulationTarget( this, elem );
					target.appendChild( elem );
				}
			} );
		},
	
		prepend: function() {
			return domManip( this, arguments, function( elem ) {
				if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
					var target = manipulationTarget( this, elem );
					target.insertBefore( elem, target.firstChild );
				}
			} );
		},
	
		before: function() {
			return domManip( this, arguments, function( elem ) {
				if ( this.parentNode ) {
					this.parentNode.insertBefore( elem, this );
				}
			} );
		},
	
		after: function() {
			return domManip( this, arguments, function( elem ) {
				if ( this.parentNode ) {
					this.parentNode.insertBefore( elem, this.nextSibling );
				}
			} );
		},
	
		empty: function() {
			var elem,
				i = 0;
	
			for ( ; ( elem = this[ i ] ) != null; i++ ) {
	
				// Remove element nodes and prevent memory leaks
				if ( elem.nodeType === 1 ) {
					jQuery.cleanData( getAll( elem, false ) );
				}
	
				// Remove any remaining nodes
				while ( elem.firstChild ) {
					elem.removeChild( elem.firstChild );
				}
	
				// If this is a select, ensure that it displays empty (#12336)
				// Support: IE<9
				if ( elem.options && jQuery.nodeName( elem, "select" ) ) {
					elem.options.length = 0;
				}
			}
	
			return this;
		},
	
		clone: function( dataAndEvents, deepDataAndEvents ) {
			dataAndEvents = dataAndEvents == null ? false : dataAndEvents;
			deepDataAndEvents = deepDataAndEvents == null ? dataAndEvents : deepDataAndEvents;
	
			return this.map( function() {
				return jQuery.clone( this, dataAndEvents, deepDataAndEvents );
			} );
		},
	
		html: function( value ) {
			return access( this, function( value ) {
				var elem = this[ 0 ] || {},
					i = 0,
					l = this.length;
	
				if ( value === undefined ) {
					return elem.nodeType === 1 ?
						elem.innerHTML.replace( rinlinejQuery, "" ) :
						undefined;
				}
	
				// See if we can take a shortcut and just use innerHTML
				if ( typeof value === "string" && !rnoInnerhtml.test( value ) &&
					( support.htmlSerialize || !rnoshimcache.test( value )  ) &&
					( support.leadingWhitespace || !rleadingWhitespace.test( value ) ) &&
					!wrapMap[ ( rtagName.exec( value ) || [ "", "" ] )[ 1 ].toLowerCase() ] ) {
	
					value = jQuery.htmlPrefilter( value );
	
					try {
						for ( ; i < l; i++ ) {
	
							// Remove element nodes and prevent memory leaks
							elem = this[ i ] || {};
							if ( elem.nodeType === 1 ) {
								jQuery.cleanData( getAll( elem, false ) );
								elem.innerHTML = value;
							}
						}
	
						elem = 0;
	
					// If using innerHTML throws an exception, use the fallback method
					} catch ( e ) {}
				}
	
				if ( elem ) {
					this.empty().append( value );
				}
			}, null, value, arguments.length );
		},
	
		replaceWith: function() {
			var ignored = [];
	
			// Make the changes, replacing each non-ignored context element with the new content
			return domManip( this, arguments, function( elem ) {
				var parent = this.parentNode;
	
				if ( jQuery.inArray( this, ignored ) < 0 ) {
					jQuery.cleanData( getAll( this ) );
					if ( parent ) {
						parent.replaceChild( elem, this );
					}
				}
	
			// Force callback invocation
			}, ignored );
		}
	} );
	
	jQuery.each( {
		appendTo: "append",
		prependTo: "prepend",
		insertBefore: "before",
		insertAfter: "after",
		replaceAll: "replaceWith"
	}, function( name, original ) {
		jQuery.fn[ name ] = function( selector ) {
			var elems,
				i = 0,
				ret = [],
				insert = jQuery( selector ),
				last = insert.length - 1;
	
			for ( ; i <= last; i++ ) {
				elems = i === last ? this : this.clone( true );
				jQuery( insert[ i ] )[ original ]( elems );
	
				// Modern browsers can apply jQuery collections as arrays, but oldIE needs a .get()
				push.apply( ret, elems.get() );
			}
	
			return this.pushStack( ret );
		};
	} );
	
	
	var iframe,
		elemdisplay = {
	
			// Support: Firefox
			// We have to pre-define these values for FF (#10227)
			HTML: "block",
			BODY: "block"
		};
	
	/**
	 * Retrieve the actual display of a element
	 * @param {String} name nodeName of the element
	 * @param {Object} doc Document object
	 */
	
	// Called only from within defaultDisplay
	function actualDisplay( name, doc ) {
		var elem = jQuery( doc.createElement( name ) ).appendTo( doc.body ),
	
			display = jQuery.css( elem[ 0 ], "display" );
	
		// We don't have any data stored on the element,
		// so use "detach" method as fast way to get rid of the element
		elem.detach();
	
		return display;
	}
	
	/**
	 * Try to determine the default display value of an element
	 * @param {String} nodeName
	 */
	function defaultDisplay( nodeName ) {
		var doc = document,
			display = elemdisplay[ nodeName ];
	
		if ( !display ) {
			display = actualDisplay( nodeName, doc );
	
			// If the simple way fails, read from inside an iframe
			if ( display === "none" || !display ) {
	
				// Use the already-created iframe if possible
				iframe = ( iframe || jQuery( "<iframe frameborder='0' width='0' height='0'/>" ) )
					.appendTo( doc.documentElement );
	
				// Always write a new HTML skeleton so Webkit and Firefox don't choke on reuse
				doc = ( iframe[ 0 ].contentWindow || iframe[ 0 ].contentDocument ).document;
	
				// Support: IE
				doc.write();
				doc.close();
	
				display = actualDisplay( nodeName, doc );
				iframe.detach();
			}
	
			// Store the correct default display
			elemdisplay[ nodeName ] = display;
		}
	
		return display;
	}
	var rmargin = ( /^margin/ );
	
	var rnumnonpx = new RegExp( "^(" + pnum + ")(?!px)[a-z%]+$", "i" );
	
	var swap = function( elem, options, callback, args ) {
		var ret, name,
			old = {};
	
		// Remember the old values, and insert the new ones
		for ( name in options ) {
			old[ name ] = elem.style[ name ];
			elem.style[ name ] = options[ name ];
		}
	
		ret = callback.apply( elem, args || [] );
	
		// Revert the old values
		for ( name in options ) {
			elem.style[ name ] = old[ name ];
		}
	
		return ret;
	};
	
	
	var documentElement = document.documentElement;
	
	
	
	( function() {
		var pixelPositionVal, pixelMarginRightVal, boxSizingReliableVal,
			reliableHiddenOffsetsVal, reliableMarginRightVal, reliableMarginLeftVal,
			container = document.createElement( "div" ),
			div = document.createElement( "div" );
	
		// Finish early in limited (non-browser) environments
		if ( !div.style ) {
			return;
		}
	
		div.style.cssText = "float:left;opacity:.5";
	
		// Support: IE<9
		// Make sure that element opacity exists (as opposed to filter)
		support.opacity = div.style.opacity === "0.5";
	
		// Verify style float existence
		// (IE uses styleFloat instead of cssFloat)
		support.cssFloat = !!div.style.cssFloat;
	
		div.style.backgroundClip = "content-box";
		div.cloneNode( true ).style.backgroundClip = "";
		support.clearCloneStyle = div.style.backgroundClip === "content-box";
	
		container = document.createElement( "div" );
		container.style.cssText = "border:0;width:8px;height:0;top:0;left:-9999px;" +
			"padding:0;margin-top:1px;position:absolute";
		div.innerHTML = "";
		container.appendChild( div );
	
		// Support: Firefox<29, Android 2.3
		// Vendor-prefix box-sizing
		support.boxSizing = div.style.boxSizing === "" || div.style.MozBoxSizing === "" ||
			div.style.WebkitBoxSizing === "";
	
		jQuery.extend( support, {
			reliableHiddenOffsets: function() {
				if ( pixelPositionVal == null ) {
					computeStyleTests();
				}
				return reliableHiddenOffsetsVal;
			},
	
			boxSizingReliable: function() {
	
				// We're checking for pixelPositionVal here instead of boxSizingReliableVal
				// since that compresses better and they're computed together anyway.
				if ( pixelPositionVal == null ) {
					computeStyleTests();
				}
				return boxSizingReliableVal;
			},
	
			pixelMarginRight: function() {
	
				// Support: Android 4.0-4.3
				if ( pixelPositionVal == null ) {
					computeStyleTests();
				}
				return pixelMarginRightVal;
			},
	
			pixelPosition: function() {
				if ( pixelPositionVal == null ) {
					computeStyleTests();
				}
				return pixelPositionVal;
			},
	
			reliableMarginRight: function() {
	
				// Support: Android 2.3
				if ( pixelPositionVal == null ) {
					computeStyleTests();
				}
				return reliableMarginRightVal;
			},
	
			reliableMarginLeft: function() {
	
				// Support: IE <=8 only, Android 4.0 - 4.3 only, Firefox <=3 - 37
				if ( pixelPositionVal == null ) {
					computeStyleTests();
				}
				return reliableMarginLeftVal;
			}
		} );
	
		function computeStyleTests() {
			var contents, divStyle,
				documentElement = document.documentElement;
	
			// Setup
			documentElement.appendChild( container );
	
			div.style.cssText =
	
				// Support: Android 2.3
				// Vendor-prefix box-sizing
				"-webkit-box-sizing:border-box;box-sizing:border-box;" +
				"position:relative;display:block;" +
				"margin:auto;border:1px;padding:1px;" +
				"top:1%;width:50%";
	
			// Support: IE<9
			// Assume reasonable values in the absence of getComputedStyle
			pixelPositionVal = boxSizingReliableVal = reliableMarginLeftVal = false;
			pixelMarginRightVal = reliableMarginRightVal = true;
	
			// Check for getComputedStyle so that this code is not run in IE<9.
			if ( window.getComputedStyle ) {
				divStyle = window.getComputedStyle( div );
				pixelPositionVal = ( divStyle || {} ).top !== "1%";
				reliableMarginLeftVal = ( divStyle || {} ).marginLeft === "2px";
				boxSizingReliableVal = ( divStyle || { width: "4px" } ).width === "4px";
	
				// Support: Android 4.0 - 4.3 only
				// Some styles come back with percentage values, even though they shouldn't
				div.style.marginRight = "50%";
				pixelMarginRightVal = ( divStyle || { marginRight: "4px" } ).marginRight === "4px";
	
				// Support: Android 2.3 only
				// Div with explicit width and no margin-right incorrectly
				// gets computed margin-right based on width of container (#3333)
				// WebKit Bug 13343 - getComputedStyle returns wrong value for margin-right
				contents = div.appendChild( document.createElement( "div" ) );
	
				// Reset CSS: box-sizing; display; margin; border; padding
				contents.style.cssText = div.style.cssText =
	
					// Support: Android 2.3
					// Vendor-prefix box-sizing
					"-webkit-box-sizing:content-box;-moz-box-sizing:content-box;" +
					"box-sizing:content-box;display:block;margin:0;border:0;padding:0";
				contents.style.marginRight = contents.style.width = "0";
				div.style.width = "1px";
	
				reliableMarginRightVal =
					!parseFloat( ( window.getComputedStyle( contents ) || {} ).marginRight );
	
				div.removeChild( contents );
			}
	
			// Support: IE6-8
			// First check that getClientRects works as expected
			// Check if table cells still have offsetWidth/Height when they are set
			// to display:none and there are still other visible table cells in a
			// table row; if so, offsetWidth/Height are not reliable for use when
			// determining if an element has been hidden directly using
			// display:none (it is still safe to use offsets if a parent element is
			// hidden; don safety goggles and see bug #4512 for more information).
			div.style.display = "none";
			reliableHiddenOffsetsVal = div.getClientRects().length === 0;
			if ( reliableHiddenOffsetsVal ) {
				div.style.display = "";
				div.innerHTML = "<table><tr><td></td><td>t</td></tr></table>";
				div.childNodes[ 0 ].style.borderCollapse = "separate";
				contents = div.getElementsByTagName( "td" );
				contents[ 0 ].style.cssText = "margin:0;border:0;padding:0;display:none";
				reliableHiddenOffsetsVal = contents[ 0 ].offsetHeight === 0;
				if ( reliableHiddenOffsetsVal ) {
					contents[ 0 ].style.display = "";
					contents[ 1 ].style.display = "none";
					reliableHiddenOffsetsVal = contents[ 0 ].offsetHeight === 0;
				}
			}
	
			// Teardown
			documentElement.removeChild( container );
		}
	
	} )();
	
	
	var getStyles, curCSS,
		rposition = /^(top|right|bottom|left)$/;
	
	if ( window.getComputedStyle ) {
		getStyles = function( elem ) {
	
			// Support: IE<=11+, Firefox<=30+ (#15098, #14150)
			// IE throws on elements created in popups
			// FF meanwhile throws on frame elements through "defaultView.getComputedStyle"
			var view = elem.ownerDocument.defaultView;
	
			if ( !view || !view.opener ) {
				view = window;
			}
	
			return view.getComputedStyle( elem );
		};
	
		curCSS = function( elem, name, computed ) {
			var width, minWidth, maxWidth, ret,
				style = elem.style;
	
			computed = computed || getStyles( elem );
	
			// getPropertyValue is only needed for .css('filter') in IE9, see #12537
			ret = computed ? computed.getPropertyValue( name ) || computed[ name ] : undefined;
	
			// Support: Opera 12.1x only
			// Fall back to style even without computed
			// computed is undefined for elems on document fragments
			if ( ( ret === "" || ret === undefined ) && !jQuery.contains( elem.ownerDocument, elem ) ) {
				ret = jQuery.style( elem, name );
			}
	
			if ( computed ) {
	
				// A tribute to the "awesome hack by Dean Edwards"
				// Chrome < 17 and Safari 5.0 uses "computed value"
				// instead of "used value" for margin-right
				// Safari 5.1.7 (at least) returns percentage for a larger set of values,
				// but width seems to be reliably pixels
				// this is against the CSSOM draft spec:
				// http://dev.w3.org/csswg/cssom/#resolved-values
				if ( !support.pixelMarginRight() && rnumnonpx.test( ret ) && rmargin.test( name ) ) {
	
					// Remember the original values
					width = style.width;
					minWidth = style.minWidth;
					maxWidth = style.maxWidth;
	
					// Put in the new values to get a computed value out
					style.minWidth = style.maxWidth = style.width = ret;
					ret = computed.width;
	
					// Revert the changed values
					style.width = width;
					style.minWidth = minWidth;
					style.maxWidth = maxWidth;
				}
			}
	
			// Support: IE
			// IE returns zIndex value as an integer.
			return ret === undefined ?
				ret :
				ret + "";
		};
	} else if ( documentElement.currentStyle ) {
		getStyles = function( elem ) {
			return elem.currentStyle;
		};
	
		curCSS = function( elem, name, computed ) {
			var left, rs, rsLeft, ret,
				style = elem.style;
	
			computed = computed || getStyles( elem );
			ret = computed ? computed[ name ] : undefined;
	
			// Avoid setting ret to empty string here
			// so we don't default to auto
			if ( ret == null && style && style[ name ] ) {
				ret = style[ name ];
			}
	
			// From the awesome hack by Dean Edwards
			// http://erik.eae.net/archives/2007/07/27/18.54.15/#comment-102291
	
			// If we're not dealing with a regular pixel number
			// but a number that has a weird ending, we need to convert it to pixels
			// but not position css attributes, as those are
			// proportional to the parent element instead
			// and we can't measure the parent instead because it
			// might trigger a "stacking dolls" problem
			if ( rnumnonpx.test( ret ) && !rposition.test( name ) ) {
	
				// Remember the original values
				left = style.left;
				rs = elem.runtimeStyle;
				rsLeft = rs && rs.left;
	
				// Put in the new values to get a computed value out
				if ( rsLeft ) {
					rs.left = elem.currentStyle.left;
				}
				style.left = name === "fontSize" ? "1em" : ret;
				ret = style.pixelLeft + "px";
	
				// Revert the changed values
				style.left = left;
				if ( rsLeft ) {
					rs.left = rsLeft;
				}
			}
	
			// Support: IE
			// IE returns zIndex value as an integer.
			return ret === undefined ?
				ret :
				ret + "" || "auto";
		};
	}
	
	
	
	
	function addGetHookIf( conditionFn, hookFn ) {
	
		// Define the hook, we'll check on the first run if it's really needed.
		return {
			get: function() {
				if ( conditionFn() ) {
	
					// Hook not needed (or it's not possible to use it due
					// to missing dependency), remove it.
					delete this.get;
					return;
				}
	
				// Hook needed; redefine it so that the support test is not executed again.
				return ( this.get = hookFn ).apply( this, arguments );
			}
		};
	}
	
	
	var
	
			ralpha = /alpha\([^)]*\)/i,
		ropacity = /opacity\s*=\s*([^)]*)/i,
	
		// swappable if display is none or starts with table except
		// "table", "table-cell", or "table-caption"
		// see here for display values:
		// https://developer.mozilla.org/en-US/docs/CSS/display
		rdisplayswap = /^(none|table(?!-c[ea]).+)/,
		rnumsplit = new RegExp( "^(" + pnum + ")(.*)$", "i" ),
	
		cssShow = { position: "absolute", visibility: "hidden", display: "block" },
		cssNormalTransform = {
			letterSpacing: "0",
			fontWeight: "400"
		},
	
		cssPrefixes = [ "Webkit", "O", "Moz", "ms" ],
		emptyStyle = document.createElement( "div" ).style;
	
	
	// return a css property mapped to a potentially vendor prefixed property
	function vendorPropName( name ) {
	
		// shortcut for names that are not vendor prefixed
		if ( name in emptyStyle ) {
			return name;
		}
	
		// check for vendor prefixed names
		var capName = name.charAt( 0 ).toUpperCase() + name.slice( 1 ),
			i = cssPrefixes.length;
	
		while ( i-- ) {
			name = cssPrefixes[ i ] + capName;
			if ( name in emptyStyle ) {
				return name;
			}
		}
	}
	
	function showHide( elements, show ) {
		var display, elem, hidden,
			values = [],
			index = 0,
			length = elements.length;
	
		for ( ; index < length; index++ ) {
			elem = elements[ index ];
			if ( !elem.style ) {
				continue;
			}
	
			values[ index ] = jQuery._data( elem, "olddisplay" );
			display = elem.style.display;
			if ( show ) {
	
				// Reset the inline display of this element to learn if it is
				// being hidden by cascaded rules or not
				if ( !values[ index ] && display === "none" ) {
					elem.style.display = "";
				}
	
				// Set elements which have been overridden with display: none
				// in a stylesheet to whatever the default browser style is
				// for such an element
				if ( elem.style.display === "" && isHidden( elem ) ) {
					values[ index ] =
						jQuery._data( elem, "olddisplay", defaultDisplay( elem.nodeName ) );
				}
			} else {
				hidden = isHidden( elem );
	
				if ( display && display !== "none" || !hidden ) {
					jQuery._data(
						elem,
						"olddisplay",
						hidden ? display : jQuery.css( elem, "display" )
					);
				}
			}
		}
	
		// Set the display of most of the elements in a second loop
		// to avoid the constant reflow
		for ( index = 0; index < length; index++ ) {
			elem = elements[ index ];
			if ( !elem.style ) {
				continue;
			}
			if ( !show || elem.style.display === "none" || elem.style.display === "" ) {
				elem.style.display = show ? values[ index ] || "" : "none";
			}
		}
	
		return elements;
	}
	
	function setPositiveNumber( elem, value, subtract ) {
		var matches = rnumsplit.exec( value );
		return matches ?
	
			// Guard against undefined "subtract", e.g., when used as in cssHooks
			Math.max( 0, matches[ 1 ] - ( subtract || 0 ) ) + ( matches[ 2 ] || "px" ) :
			value;
	}
	
	function augmentWidthOrHeight( elem, name, extra, isBorderBox, styles ) {
		var i = extra === ( isBorderBox ? "border" : "content" ) ?
	
			// If we already have the right measurement, avoid augmentation
			4 :
	
			// Otherwise initialize for horizontal or vertical properties
			name === "width" ? 1 : 0,
	
			val = 0;
	
		for ( ; i < 4; i += 2 ) {
	
			// both box models exclude margin, so add it if we want it
			if ( extra === "margin" ) {
				val += jQuery.css( elem, extra + cssExpand[ i ], true, styles );
			}
	
			if ( isBorderBox ) {
	
				// border-box includes padding, so remove it if we want content
				if ( extra === "content" ) {
					val -= jQuery.css( elem, "padding" + cssExpand[ i ], true, styles );
				}
	
				// at this point, extra isn't border nor margin, so remove border
				if ( extra !== "margin" ) {
					val -= jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );
				}
			} else {
	
				// at this point, extra isn't content, so add padding
				val += jQuery.css( elem, "padding" + cssExpand[ i ], true, styles );
	
				// at this point, extra isn't content nor padding, so add border
				if ( extra !== "padding" ) {
					val += jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );
				}
			}
		}
	
		return val;
	}
	
	function getWidthOrHeight( elem, name, extra ) {
	
		// Start with offset property, which is equivalent to the border-box value
		var valueIsBorderBox = true,
			val = name === "width" ? elem.offsetWidth : elem.offsetHeight,
			styles = getStyles( elem ),
			isBorderBox = support.boxSizing &&
				jQuery.css( elem, "boxSizing", false, styles ) === "border-box";
	
		// some non-html elements return undefined for offsetWidth, so check for null/undefined
		// svg - https://bugzilla.mozilla.org/show_bug.cgi?id=649285
		// MathML - https://bugzilla.mozilla.org/show_bug.cgi?id=491668
		if ( val <= 0 || val == null ) {
	
			// Fall back to computed then uncomputed css if necessary
			val = curCSS( elem, name, styles );
			if ( val < 0 || val == null ) {
				val = elem.style[ name ];
			}
	
			// Computed unit is not pixels. Stop here and return.
			if ( rnumnonpx.test( val ) ) {
				return val;
			}
	
			// we need the check for style in case a browser which returns unreliable values
			// for getComputedStyle silently falls back to the reliable elem.style
			valueIsBorderBox = isBorderBox &&
				( support.boxSizingReliable() || val === elem.style[ name ] );
	
			// Normalize "", auto, and prepare for extra
			val = parseFloat( val ) || 0;
		}
	
		// use the active box-sizing model to add/subtract irrelevant styles
		return ( val +
			augmentWidthOrHeight(
				elem,
				name,
				extra || ( isBorderBox ? "border" : "content" ),
				valueIsBorderBox,
				styles
			)
		) + "px";
	}
	
	jQuery.extend( {
	
		// Add in style property hooks for overriding the default
		// behavior of getting and setting a style property
		cssHooks: {
			opacity: {
				get: function( elem, computed ) {
					if ( computed ) {
	
						// We should always get a number back from opacity
						var ret = curCSS( elem, "opacity" );
						return ret === "" ? "1" : ret;
					}
				}
			}
		},
	
		// Don't automatically add "px" to these possibly-unitless properties
		cssNumber: {
			"animationIterationCount": true,
			"columnCount": true,
			"fillOpacity": true,
			"flexGrow": true,
			"flexShrink": true,
			"fontWeight": true,
			"lineHeight": true,
			"opacity": true,
			"order": true,
			"orphans": true,
			"widows": true,
			"zIndex": true,
			"zoom": true
		},
	
		// Add in properties whose names you wish to fix before
		// setting or getting the value
		cssProps: {
	
			// normalize float css property
			"float": support.cssFloat ? "cssFloat" : "styleFloat"
		},
	
		// Get and set the style property on a DOM Node
		style: function( elem, name, value, extra ) {
	
			// Don't set styles on text and comment nodes
			if ( !elem || elem.nodeType === 3 || elem.nodeType === 8 || !elem.style ) {
				return;
			}
	
			// Make sure that we're working with the right name
			var ret, type, hooks,
				origName = jQuery.camelCase( name ),
				style = elem.style;
	
			name = jQuery.cssProps[ origName ] ||
				( jQuery.cssProps[ origName ] = vendorPropName( origName ) || origName );
	
			// gets hook for the prefixed version
			// followed by the unprefixed version
			hooks = jQuery.cssHooks[ name ] || jQuery.cssHooks[ origName ];
	
			// Check if we're setting a value
			if ( value !== undefined ) {
				type = typeof value;
	
				// Convert "+=" or "-=" to relative numbers (#7345)
				if ( type === "string" && ( ret = rcssNum.exec( value ) ) && ret[ 1 ] ) {
					value = adjustCSS( elem, name, ret );
	
					// Fixes bug #9237
					type = "number";
				}
	
				// Make sure that null and NaN values aren't set. See: #7116
				if ( value == null || value !== value ) {
					return;
				}
	
				// If a number was passed in, add the unit (except for certain CSS properties)
				if ( type === "number" ) {
					value += ret && ret[ 3 ] || ( jQuery.cssNumber[ origName ] ? "" : "px" );
				}
	
				// Fixes #8908, it can be done more correctly by specifing setters in cssHooks,
				// but it would mean to define eight
				// (for every problematic property) identical functions
				if ( !support.clearCloneStyle && value === "" && name.indexOf( "background" ) === 0 ) {
					style[ name ] = "inherit";
				}
	
				// If a hook was provided, use that value, otherwise just set the specified value
				if ( !hooks || !( "set" in hooks ) ||
					( value = hooks.set( elem, value, extra ) ) !== undefined ) {
	
					// Support: IE
					// Swallow errors from 'invalid' CSS values (#5509)
					try {
						style[ name ] = value;
					} catch ( e ) {}
				}
	
			} else {
	
				// If a hook was provided get the non-computed value from there
				if ( hooks && "get" in hooks &&
					( ret = hooks.get( elem, false, extra ) ) !== undefined ) {
	
					return ret;
				}
	
				// Otherwise just get the value from the style object
				return style[ name ];
			}
		},
	
		css: function( elem, name, extra, styles ) {
			var num, val, hooks,
				origName = jQuery.camelCase( name );
	
			// Make sure that we're working with the right name
			name = jQuery.cssProps[ origName ] ||
				( jQuery.cssProps[ origName ] = vendorPropName( origName ) || origName );
	
			// gets hook for the prefixed version
			// followed by the unprefixed version
			hooks = jQuery.cssHooks[ name ] || jQuery.cssHooks[ origName ];
	
			// If a hook was provided get the computed value from there
			if ( hooks && "get" in hooks ) {
				val = hooks.get( elem, true, extra );
			}
	
			// Otherwise, if a way to get the computed value exists, use that
			if ( val === undefined ) {
				val = curCSS( elem, name, styles );
			}
	
			//convert "normal" to computed value
			if ( val === "normal" && name in cssNormalTransform ) {
				val = cssNormalTransform[ name ];
			}
	
			// Return, converting to number if forced or a qualifier was provided and val looks numeric
			if ( extra === "" || extra ) {
				num = parseFloat( val );
				return extra === true || isFinite( num ) ? num || 0 : val;
			}
			return val;
		}
	} );
	
	jQuery.each( [ "height", "width" ], function( i, name ) {
		jQuery.cssHooks[ name ] = {
			get: function( elem, computed, extra ) {
				if ( computed ) {
	
					// certain elements can have dimension info if we invisibly show them
					// however, it must have a current display style that would benefit from this
					return rdisplayswap.test( jQuery.css( elem, "display" ) ) &&
						elem.offsetWidth === 0 ?
							swap( elem, cssShow, function() {
								return getWidthOrHeight( elem, name, extra );
							} ) :
							getWidthOrHeight( elem, name, extra );
				}
			},
	
			set: function( elem, value, extra ) {
				var styles = extra && getStyles( elem );
				return setPositiveNumber( elem, value, extra ?
					augmentWidthOrHeight(
						elem,
						name,
						extra,
						support.boxSizing &&
							jQuery.css( elem, "boxSizing", false, styles ) === "border-box",
						styles
					) : 0
				);
			}
		};
	} );
	
	if ( !support.opacity ) {
		jQuery.cssHooks.opacity = {
			get: function( elem, computed ) {
	
				// IE uses filters for opacity
				return ropacity.test( ( computed && elem.currentStyle ?
					elem.currentStyle.filter :
					elem.style.filter ) || "" ) ?
						( 0.01 * parseFloat( RegExp.$1 ) ) + "" :
						computed ? "1" : "";
			},
	
			set: function( elem, value ) {
				var style = elem.style,
					currentStyle = elem.currentStyle,
					opacity = jQuery.isNumeric( value ) ? "alpha(opacity=" + value * 100 + ")" : "",
					filter = currentStyle && currentStyle.filter || style.filter || "";
	
				// IE has trouble with opacity if it does not have layout
				// Force it by setting the zoom level
				style.zoom = 1;
	
				// if setting opacity to 1, and no other filters exist -
				// attempt to remove filter attribute #6652
				// if value === "", then remove inline opacity #12685
				if ( ( value >= 1 || value === "" ) &&
						jQuery.trim( filter.replace( ralpha, "" ) ) === "" &&
						style.removeAttribute ) {
	
					// Setting style.filter to null, "" & " " still leave "filter:" in the cssText
					// if "filter:" is present at all, clearType is disabled, we want to avoid this
					// style.removeAttribute is IE Only, but so apparently is this code path...
					style.removeAttribute( "filter" );
	
					// if there is no filter style applied in a css rule
					// or unset inline opacity, we are done
					if ( value === "" || currentStyle && !currentStyle.filter ) {
						return;
					}
				}
	
				// otherwise, set new filter values
				style.filter = ralpha.test( filter ) ?
					filter.replace( ralpha, opacity ) :
					filter + " " + opacity;
			}
		};
	}
	
	jQuery.cssHooks.marginRight = addGetHookIf( support.reliableMarginRight,
		function( elem, computed ) {
			if ( computed ) {
				return swap( elem, { "display": "inline-block" },
					curCSS, [ elem, "marginRight" ] );
			}
		}
	);
	
	jQuery.cssHooks.marginLeft = addGetHookIf( support.reliableMarginLeft,
		function( elem, computed ) {
			if ( computed ) {
				return (
					parseFloat( curCSS( elem, "marginLeft" ) ) ||
	
					// Support: IE<=11+
					// Running getBoundingClientRect on a disconnected node in IE throws an error
					// Support: IE8 only
					// getClientRects() errors on disconnected elems
					( jQuery.contains( elem.ownerDocument, elem ) ?
						elem.getBoundingClientRect().left -
							swap( elem, { marginLeft: 0 }, function() {
								return elem.getBoundingClientRect().left;
							} ) :
						0
					)
				) + "px";
			}
		}
	);
	
	// These hooks are used by animate to expand properties
	jQuery.each( {
		margin: "",
		padding: "",
		border: "Width"
	}, function( prefix, suffix ) {
		jQuery.cssHooks[ prefix + suffix ] = {
			expand: function( value ) {
				var i = 0,
					expanded = {},
	
					// assumes a single number if not a string
					parts = typeof value === "string" ? value.split( " " ) : [ value ];
	
				for ( ; i < 4; i++ ) {
					expanded[ prefix + cssExpand[ i ] + suffix ] =
						parts[ i ] || parts[ i - 2 ] || parts[ 0 ];
				}
	
				return expanded;
			}
		};
	
		if ( !rmargin.test( prefix ) ) {
			jQuery.cssHooks[ prefix + suffix ].set = setPositiveNumber;
		}
	} );
	
	jQuery.fn.extend( {
		css: function( name, value ) {
			return access( this, function( elem, name, value ) {
				var styles, len,
					map = {},
					i = 0;
	
				if ( jQuery.isArray( name ) ) {
					styles = getStyles( elem );
					len = name.length;
	
					for ( ; i < len; i++ ) {
						map[ name[ i ] ] = jQuery.css( elem, name[ i ], false, styles );
					}
	
					return map;
				}
	
				return value !== undefined ?
					jQuery.style( elem, name, value ) :
					jQuery.css( elem, name );
			}, name, value, arguments.length > 1 );
		},
		show: function() {
			return showHide( this, true );
		},
		hide: function() {
			return showHide( this );
		},
		toggle: function( state ) {
			if ( typeof state === "boolean" ) {
				return state ? this.show() : this.hide();
			}
	
			return this.each( function() {
				if ( isHidden( this ) ) {
					jQuery( this ).show();
				} else {
					jQuery( this ).hide();
				}
			} );
		}
	} );
	
	
	function Tween( elem, options, prop, end, easing ) {
		return new Tween.prototype.init( elem, options, prop, end, easing );
	}
	jQuery.Tween = Tween;
	
	Tween.prototype = {
		constructor: Tween,
		init: function( elem, options, prop, end, easing, unit ) {
			this.elem = elem;
			this.prop = prop;
			this.easing = easing || jQuery.easing._default;
			this.options = options;
			this.start = this.now = this.cur();
			this.end = end;
			this.unit = unit || ( jQuery.cssNumber[ prop ] ? "" : "px" );
		},
		cur: function() {
			var hooks = Tween.propHooks[ this.prop ];
	
			return hooks && hooks.get ?
				hooks.get( this ) :
				Tween.propHooks._default.get( this );
		},
		run: function( percent ) {
			var eased,
				hooks = Tween.propHooks[ this.prop ];
	
			if ( this.options.duration ) {
				this.pos = eased = jQuery.easing[ this.easing ](
					percent, this.options.duration * percent, 0, 1, this.options.duration
				);
			} else {
				this.pos = eased = percent;
			}
			this.now = ( this.end - this.start ) * eased + this.start;
	
			if ( this.options.step ) {
				this.options.step.call( this.elem, this.now, this );
			}
	
			if ( hooks && hooks.set ) {
				hooks.set( this );
			} else {
				Tween.propHooks._default.set( this );
			}
			return this;
		}
	};
	
	Tween.prototype.init.prototype = Tween.prototype;
	
	Tween.propHooks = {
		_default: {
			get: function( tween ) {
				var result;
	
				// Use a property on the element directly when it is not a DOM element,
				// or when there is no matching style property that exists.
				if ( tween.elem.nodeType !== 1 ||
					tween.elem[ tween.prop ] != null && tween.elem.style[ tween.prop ] == null ) {
					return tween.elem[ tween.prop ];
				}
	
				// passing an empty string as a 3rd parameter to .css will automatically
				// attempt a parseFloat and fallback to a string if the parse fails
				// so, simple values such as "10px" are parsed to Float.
				// complex values such as "rotate(1rad)" are returned as is.
				result = jQuery.css( tween.elem, tween.prop, "" );
	
				// Empty strings, null, undefined and "auto" are converted to 0.
				return !result || result === "auto" ? 0 : result;
			},
			set: function( tween ) {
	
				// use step hook for back compat - use cssHook if its there - use .style if its
				// available and use plain properties where available
				if ( jQuery.fx.step[ tween.prop ] ) {
					jQuery.fx.step[ tween.prop ]( tween );
				} else if ( tween.elem.nodeType === 1 &&
					( tween.elem.style[ jQuery.cssProps[ tween.prop ] ] != null ||
						jQuery.cssHooks[ tween.prop ] ) ) {
					jQuery.style( tween.elem, tween.prop, tween.now + tween.unit );
				} else {
					tween.elem[ tween.prop ] = tween.now;
				}
			}
		}
	};
	
	// Support: IE <=9
	// Panic based approach to setting things on disconnected nodes
	
	Tween.propHooks.scrollTop = Tween.propHooks.scrollLeft = {
		set: function( tween ) {
			if ( tween.elem.nodeType && tween.elem.parentNode ) {
				tween.elem[ tween.prop ] = tween.now;
			}
		}
	};
	
	jQuery.easing = {
		linear: function( p ) {
			return p;
		},
		swing: function( p ) {
			return 0.5 - Math.cos( p * Math.PI ) / 2;
		},
		_default: "swing"
	};
	
	jQuery.fx = Tween.prototype.init;
	
	// Back Compat <1.8 extension point
	jQuery.fx.step = {};
	
	
	
	
	var
		fxNow, timerId,
		rfxtypes = /^(?:toggle|show|hide)$/,
		rrun = /queueHooks$/;
	
	// Animations created synchronously will run synchronously
	function createFxNow() {
		window.setTimeout( function() {
			fxNow = undefined;
		} );
		return ( fxNow = jQuery.now() );
	}
	
	// Generate parameters to create a standard animation
	function genFx( type, includeWidth ) {
		var which,
			attrs = { height: type },
			i = 0;
	
		// if we include width, step value is 1 to do all cssExpand values,
		// if we don't include width, step value is 2 to skip over Left and Right
		includeWidth = includeWidth ? 1 : 0;
		for ( ; i < 4 ; i += 2 - includeWidth ) {
			which = cssExpand[ i ];
			attrs[ "margin" + which ] = attrs[ "padding" + which ] = type;
		}
	
		if ( includeWidth ) {
			attrs.opacity = attrs.width = type;
		}
	
		return attrs;
	}
	
	function createTween( value, prop, animation ) {
		var tween,
			collection = ( Animation.tweeners[ prop ] || [] ).concat( Animation.tweeners[ "*" ] ),
			index = 0,
			length = collection.length;
		for ( ; index < length; index++ ) {
			if ( ( tween = collection[ index ].call( animation, prop, value ) ) ) {
	
				// we're done with this property
				return tween;
			}
		}
	}
	
	function defaultPrefilter( elem, props, opts ) {
		/* jshint validthis: true */
		var prop, value, toggle, tween, hooks, oldfire, display, checkDisplay,
			anim = this,
			orig = {},
			style = elem.style,
			hidden = elem.nodeType && isHidden( elem ),
			dataShow = jQuery._data( elem, "fxshow" );
	
		// handle queue: false promises
		if ( !opts.queue ) {
			hooks = jQuery._queueHooks( elem, "fx" );
			if ( hooks.unqueued == null ) {
				hooks.unqueued = 0;
				oldfire = hooks.empty.fire;
				hooks.empty.fire = function() {
					if ( !hooks.unqueued ) {
						oldfire();
					}
				};
			}
			hooks.unqueued++;
	
			anim.always( function() {
	
				// doing this makes sure that the complete handler will be called
				// before this completes
				anim.always( function() {
					hooks.unqueued--;
					if ( !jQuery.queue( elem, "fx" ).length ) {
						hooks.empty.fire();
					}
				} );
			} );
		}
	
		// height/width overflow pass
		if ( elem.nodeType === 1 && ( "height" in props || "width" in props ) ) {
	
			// Make sure that nothing sneaks out
			// Record all 3 overflow attributes because IE does not
			// change the overflow attribute when overflowX and
			// overflowY are set to the same value
			opts.overflow = [ style.overflow, style.overflowX, style.overflowY ];
	
			// Set display property to inline-block for height/width
			// animations on inline elements that are having width/height animated
			display = jQuery.css( elem, "display" );
	
			// Test default display if display is currently "none"
			checkDisplay = display === "none" ?
				jQuery._data( elem, "olddisplay" ) || defaultDisplay( elem.nodeName ) : display;
	
			if ( checkDisplay === "inline" && jQuery.css( elem, "float" ) === "none" ) {
	
				// inline-level elements accept inline-block;
				// block-level elements need to be inline with layout
				if ( !support.inlineBlockNeedsLayout || defaultDisplay( elem.nodeName ) === "inline" ) {
					style.display = "inline-block";
				} else {
					style.zoom = 1;
				}
			}
		}
	
		if ( opts.overflow ) {
			style.overflow = "hidden";
			if ( !support.shrinkWrapBlocks() ) {
				anim.always( function() {
					style.overflow = opts.overflow[ 0 ];
					style.overflowX = opts.overflow[ 1 ];
					style.overflowY = opts.overflow[ 2 ];
				} );
			}
		}
	
		// show/hide pass
		for ( prop in props ) {
			value = props[ prop ];
			if ( rfxtypes.exec( value ) ) {
				delete props[ prop ];
				toggle = toggle || value === "toggle";
				if ( value === ( hidden ? "hide" : "show" ) ) {
	
					// If there is dataShow left over from a stopped hide or show
					// and we are going to proceed with show, we should pretend to be hidden
					if ( value === "show" && dataShow && dataShow[ prop ] !== undefined ) {
						hidden = true;
					} else {
						continue;
					}
				}
				orig[ prop ] = dataShow && dataShow[ prop ] || jQuery.style( elem, prop );
	
			// Any non-fx value stops us from restoring the original display value
			} else {
				display = undefined;
			}
		}
	
		if ( !jQuery.isEmptyObject( orig ) ) {
			if ( dataShow ) {
				if ( "hidden" in dataShow ) {
					hidden = dataShow.hidden;
				}
			} else {
				dataShow = jQuery._data( elem, "fxshow", {} );
			}
	
			// store state if its toggle - enables .stop().toggle() to "reverse"
			if ( toggle ) {
				dataShow.hidden = !hidden;
			}
			if ( hidden ) {
				jQuery( elem ).show();
			} else {
				anim.done( function() {
					jQuery( elem ).hide();
				} );
			}
			anim.done( function() {
				var prop;
				jQuery._removeData( elem, "fxshow" );
				for ( prop in orig ) {
					jQuery.style( elem, prop, orig[ prop ] );
				}
			} );
			for ( prop in orig ) {
				tween = createTween( hidden ? dataShow[ prop ] : 0, prop, anim );
	
				if ( !( prop in dataShow ) ) {
					dataShow[ prop ] = tween.start;
					if ( hidden ) {
						tween.end = tween.start;
						tween.start = prop === "width" || prop === "height" ? 1 : 0;
					}
				}
			}
	
		// If this is a noop like .hide().hide(), restore an overwritten display value
		} else if ( ( display === "none" ? defaultDisplay( elem.nodeName ) : display ) === "inline" ) {
			style.display = display;
		}
	}
	
	function propFilter( props, specialEasing ) {
		var index, name, easing, value, hooks;
	
		// camelCase, specialEasing and expand cssHook pass
		for ( index in props ) {
			name = jQuery.camelCase( index );
			easing = specialEasing[ name ];
			value = props[ index ];
			if ( jQuery.isArray( value ) ) {
				easing = value[ 1 ];
				value = props[ index ] = value[ 0 ];
			}
	
			if ( index !== name ) {
				props[ name ] = value;
				delete props[ index ];
			}
	
			hooks = jQuery.cssHooks[ name ];
			if ( hooks && "expand" in hooks ) {
				value = hooks.expand( value );
				delete props[ name ];
	
				// not quite $.extend, this wont overwrite keys already present.
				// also - reusing 'index' from above because we have the correct "name"
				for ( index in value ) {
					if ( !( index in props ) ) {
						props[ index ] = value[ index ];
						specialEasing[ index ] = easing;
					}
				}
			} else {
				specialEasing[ name ] = easing;
			}
		}
	}
	
	function Animation( elem, properties, options ) {
		var result,
			stopped,
			index = 0,
			length = Animation.prefilters.length,
			deferred = jQuery.Deferred().always( function() {
	
				// don't match elem in the :animated selector
				delete tick.elem;
			} ),
			tick = function() {
				if ( stopped ) {
					return false;
				}
				var currentTime = fxNow || createFxNow(),
					remaining = Math.max( 0, animation.startTime + animation.duration - currentTime ),
	
					// Support: Android 2.3
					// Archaic crash bug won't allow us to use `1 - ( 0.5 || 0 )` (#12497)
					temp = remaining / animation.duration || 0,
					percent = 1 - temp,
					index = 0,
					length = animation.tweens.length;
	
				for ( ; index < length ; index++ ) {
					animation.tweens[ index ].run( percent );
				}
	
				deferred.notifyWith( elem, [ animation, percent, remaining ] );
	
				if ( percent < 1 && length ) {
					return remaining;
				} else {
					deferred.resolveWith( elem, [ animation ] );
					return false;
				}
			},
			animation = deferred.promise( {
				elem: elem,
				props: jQuery.extend( {}, properties ),
				opts: jQuery.extend( true, {
					specialEasing: {},
					easing: jQuery.easing._default
				}, options ),
				originalProperties: properties,
				originalOptions: options,
				startTime: fxNow || createFxNow(),
				duration: options.duration,
				tweens: [],
				createTween: function( prop, end ) {
					var tween = jQuery.Tween( elem, animation.opts, prop, end,
							animation.opts.specialEasing[ prop ] || animation.opts.easing );
					animation.tweens.push( tween );
					return tween;
				},
				stop: function( gotoEnd ) {
					var index = 0,
	
						// if we are going to the end, we want to run all the tweens
						// otherwise we skip this part
						length = gotoEnd ? animation.tweens.length : 0;
					if ( stopped ) {
						return this;
					}
					stopped = true;
					for ( ; index < length ; index++ ) {
						animation.tweens[ index ].run( 1 );
					}
	
					// resolve when we played the last frame
					// otherwise, reject
					if ( gotoEnd ) {
						deferred.notifyWith( elem, [ animation, 1, 0 ] );
						deferred.resolveWith( elem, [ animation, gotoEnd ] );
					} else {
						deferred.rejectWith( elem, [ animation, gotoEnd ] );
					}
					return this;
				}
			} ),
			props = animation.props;
	
		propFilter( props, animation.opts.specialEasing );
	
		for ( ; index < length ; index++ ) {
			result = Animation.prefilters[ index ].call( animation, elem, props, animation.opts );
			if ( result ) {
				if ( jQuery.isFunction( result.stop ) ) {
					jQuery._queueHooks( animation.elem, animation.opts.queue ).stop =
						jQuery.proxy( result.stop, result );
				}
				return result;
			}
		}
	
		jQuery.map( props, createTween, animation );
	
		if ( jQuery.isFunction( animation.opts.start ) ) {
			animation.opts.start.call( elem, animation );
		}
	
		jQuery.fx.timer(
			jQuery.extend( tick, {
				elem: elem,
				anim: animation,
				queue: animation.opts.queue
			} )
		);
	
		// attach callbacks from options
		return animation.progress( animation.opts.progress )
			.done( animation.opts.done, animation.opts.complete )
			.fail( animation.opts.fail )
			.always( animation.opts.always );
	}
	
	jQuery.Animation = jQuery.extend( Animation, {
	
		tweeners: {
			"*": [ function( prop, value ) {
				var tween = this.createTween( prop, value );
				adjustCSS( tween.elem, prop, rcssNum.exec( value ), tween );
				return tween;
			} ]
		},
	
		tweener: function( props, callback ) {
			if ( jQuery.isFunction( props ) ) {
				callback = props;
				props = [ "*" ];
			} else {
				props = props.match( rnotwhite );
			}
	
			var prop,
				index = 0,
				length = props.length;
	
			for ( ; index < length ; index++ ) {
				prop = props[ index ];
				Animation.tweeners[ prop ] = Animation.tweeners[ prop ] || [];
				Animation.tweeners[ prop ].unshift( callback );
			}
		},
	
		prefilters: [ defaultPrefilter ],
	
		prefilter: function( callback, prepend ) {
			if ( prepend ) {
				Animation.prefilters.unshift( callback );
			} else {
				Animation.prefilters.push( callback );
			}
		}
	} );
	
	jQuery.speed = function( speed, easing, fn ) {
		var opt = speed && typeof speed === "object" ? jQuery.extend( {}, speed ) : {
			complete: fn || !fn && easing ||
				jQuery.isFunction( speed ) && speed,
			duration: speed,
			easing: fn && easing || easing && !jQuery.isFunction( easing ) && easing
		};
	
		opt.duration = jQuery.fx.off ? 0 : typeof opt.duration === "number" ? opt.duration :
			opt.duration in jQuery.fx.speeds ?
				jQuery.fx.speeds[ opt.duration ] : jQuery.fx.speeds._default;
	
		// normalize opt.queue - true/undefined/null -> "fx"
		if ( opt.queue == null || opt.queue === true ) {
			opt.queue = "fx";
		}
	
		// Queueing
		opt.old = opt.complete;
	
		opt.complete = function() {
			if ( jQuery.isFunction( opt.old ) ) {
				opt.old.call( this );
			}
	
			if ( opt.queue ) {
				jQuery.dequeue( this, opt.queue );
			}
		};
	
		return opt;
	};
	
	jQuery.fn.extend( {
		fadeTo: function( speed, to, easing, callback ) {
	
			// show any hidden elements after setting opacity to 0
			return this.filter( isHidden ).css( "opacity", 0 ).show()
	
				// animate to the value specified
				.end().animate( { opacity: to }, speed, easing, callback );
		},
		animate: function( prop, speed, easing, callback ) {
			var empty = jQuery.isEmptyObject( prop ),
				optall = jQuery.speed( speed, easing, callback ),
				doAnimation = function() {
	
					// Operate on a copy of prop so per-property easing won't be lost
					var anim = Animation( this, jQuery.extend( {}, prop ), optall );
	
					// Empty animations, or finishing resolves immediately
					if ( empty || jQuery._data( this, "finish" ) ) {
						anim.stop( true );
					}
				};
				doAnimation.finish = doAnimation;
	
			return empty || optall.queue === false ?
				this.each( doAnimation ) :
				this.queue( optall.queue, doAnimation );
		},
		stop: function( type, clearQueue, gotoEnd ) {
			var stopQueue = function( hooks ) {
				var stop = hooks.stop;
				delete hooks.stop;
				stop( gotoEnd );
			};
	
			if ( typeof type !== "string" ) {
				gotoEnd = clearQueue;
				clearQueue = type;
				type = undefined;
			}
			if ( clearQueue && type !== false ) {
				this.queue( type || "fx", [] );
			}
	
			return this.each( function() {
				var dequeue = true,
					index = type != null && type + "queueHooks",
					timers = jQuery.timers,
					data = jQuery._data( this );
	
				if ( index ) {
					if ( data[ index ] && data[ index ].stop ) {
						stopQueue( data[ index ] );
					}
				} else {
					for ( index in data ) {
						if ( data[ index ] && data[ index ].stop && rrun.test( index ) ) {
							stopQueue( data[ index ] );
						}
					}
				}
	
				for ( index = timers.length; index--; ) {
					if ( timers[ index ].elem === this &&
						( type == null || timers[ index ].queue === type ) ) {
	
						timers[ index ].anim.stop( gotoEnd );
						dequeue = false;
						timers.splice( index, 1 );
					}
				}
	
				// start the next in the queue if the last step wasn't forced
				// timers currently will call their complete callbacks, which will dequeue
				// but only if they were gotoEnd
				if ( dequeue || !gotoEnd ) {
					jQuery.dequeue( this, type );
				}
			} );
		},
		finish: function( type ) {
			if ( type !== false ) {
				type = type || "fx";
			}
			return this.each( function() {
				var index,
					data = jQuery._data( this ),
					queue = data[ type + "queue" ],
					hooks = data[ type + "queueHooks" ],
					timers = jQuery.timers,
					length = queue ? queue.length : 0;
	
				// enable finishing flag on private data
				data.finish = true;
	
				// empty the queue first
				jQuery.queue( this, type, [] );
	
				if ( hooks && hooks.stop ) {
					hooks.stop.call( this, true );
				}
	
				// look for any active animations, and finish them
				for ( index = timers.length; index--; ) {
					if ( timers[ index ].elem === this && timers[ index ].queue === type ) {
						timers[ index ].anim.stop( true );
						timers.splice( index, 1 );
					}
				}
	
				// look for any animations in the old queue and finish them
				for ( index = 0; index < length; index++ ) {
					if ( queue[ index ] && queue[ index ].finish ) {
						queue[ index ].finish.call( this );
					}
				}
	
				// turn off finishing flag
				delete data.finish;
			} );
		}
	} );
	
	jQuery.each( [ "toggle", "show", "hide" ], function( i, name ) {
		var cssFn = jQuery.fn[ name ];
		jQuery.fn[ name ] = function( speed, easing, callback ) {
			return speed == null || typeof speed === "boolean" ?
				cssFn.apply( this, arguments ) :
				this.animate( genFx( name, true ), speed, easing, callback );
		};
	} );
	
	// Generate shortcuts for custom animations
	jQuery.each( {
		slideDown: genFx( "show" ),
		slideUp: genFx( "hide" ),
		slideToggle: genFx( "toggle" ),
		fadeIn: { opacity: "show" },
		fadeOut: { opacity: "hide" },
		fadeToggle: { opacity: "toggle" }
	}, function( name, props ) {
		jQuery.fn[ name ] = function( speed, easing, callback ) {
			return this.animate( props, speed, easing, callback );
		};
	} );
	
	jQuery.timers = [];
	jQuery.fx.tick = function() {
		var timer,
			timers = jQuery.timers,
			i = 0;
	
		fxNow = jQuery.now();
	
		for ( ; i < timers.length; i++ ) {
			timer = timers[ i ];
	
			// Checks the timer has not already been removed
			if ( !timer() && timers[ i ] === timer ) {
				timers.splice( i--, 1 );
			}
		}
	
		if ( !timers.length ) {
			jQuery.fx.stop();
		}
		fxNow = undefined;
	};
	
	jQuery.fx.timer = function( timer ) {
		jQuery.timers.push( timer );
		if ( timer() ) {
			jQuery.fx.start();
		} else {
			jQuery.timers.pop();
		}
	};
	
	jQuery.fx.interval = 13;
	
	jQuery.fx.start = function() {
		if ( !timerId ) {
			timerId = window.setInterval( jQuery.fx.tick, jQuery.fx.interval );
		}
	};
	
	jQuery.fx.stop = function() {
		window.clearInterval( timerId );
		timerId = null;
	};
	
	jQuery.fx.speeds = {
		slow: 600,
		fast: 200,
	
		// Default speed
		_default: 400
	};
	
	
	// Based off of the plugin by Clint Helfers, with permission.
	// http://web.archive.org/web/20100324014747/http://blindsignals.com/index.php/2009/07/jquery-delay/
	jQuery.fn.delay = function( time, type ) {
		time = jQuery.fx ? jQuery.fx.speeds[ time ] || time : time;
		type = type || "fx";
	
		return this.queue( type, function( next, hooks ) {
			var timeout = window.setTimeout( next, time );
			hooks.stop = function() {
				window.clearTimeout( timeout );
			};
		} );
	};
	
	
	( function() {
		var a,
			input = document.createElement( "input" ),
			div = document.createElement( "div" ),
			select = document.createElement( "select" ),
			opt = select.appendChild( document.createElement( "option" ) );
	
		// Setup
		div = document.createElement( "div" );
		div.setAttribute( "className", "t" );
		div.innerHTML = "  <link/><table></table><a href='/a'>a</a><input type='checkbox'/>";
		a = div.getElementsByTagName( "a" )[ 0 ];
	
		// Support: Windows Web Apps (WWA)
		// `type` must use .setAttribute for WWA (#14901)
		input.setAttribute( "type", "checkbox" );
		div.appendChild( input );
	
		a = div.getElementsByTagName( "a" )[ 0 ];
	
		// First batch of tests.
		a.style.cssText = "top:1px";
	
		// Test setAttribute on camelCase class.
		// If it works, we need attrFixes when doing get/setAttribute (ie6/7)
		support.getSetAttribute = div.className !== "t";
	
		// Get the style information from getAttribute
		// (IE uses .cssText instead)
		support.style = /top/.test( a.getAttribute( "style" ) );
	
		// Make sure that URLs aren't manipulated
		// (IE normalizes it by default)
		support.hrefNormalized = a.getAttribute( "href" ) === "/a";
	
		// Check the default checkbox/radio value ("" on WebKit; "on" elsewhere)
		support.checkOn = !!input.value;
	
		// Make sure that a selected-by-default option has a working selected property.
		// (WebKit defaults to false instead of true, IE too, if it's in an optgroup)
		support.optSelected = opt.selected;
	
		// Tests for enctype support on a form (#6743)
		support.enctype = !!document.createElement( "form" ).enctype;
	
		// Make sure that the options inside disabled selects aren't marked as disabled
		// (WebKit marks them as disabled)
		select.disabled = true;
		support.optDisabled = !opt.disabled;
	
		// Support: IE8 only
		// Check if we can trust getAttribute("value")
		input = document.createElement( "input" );
		input.setAttribute( "value", "" );
		support.input = input.getAttribute( "value" ) === "";
	
		// Check if an input maintains its value after becoming a radio
		input.value = "t";
		input.setAttribute( "type", "radio" );
		support.radioValue = input.value === "t";
	} )();
	
	
	var rreturn = /\r/g,
		rspaces = /[\x20\t\r\n\f]+/g;
	
	jQuery.fn.extend( {
		val: function( value ) {
			var hooks, ret, isFunction,
				elem = this[ 0 ];
	
			if ( !arguments.length ) {
				if ( elem ) {
					hooks = jQuery.valHooks[ elem.type ] ||
						jQuery.valHooks[ elem.nodeName.toLowerCase() ];
	
					if (
						hooks &&
						"get" in hooks &&
						( ret = hooks.get( elem, "value" ) ) !== undefined
					) {
						return ret;
					}
	
					ret = elem.value;
	
					return typeof ret === "string" ?
	
						// handle most common string cases
						ret.replace( rreturn, "" ) :
	
						// handle cases where value is null/undef or number
						ret == null ? "" : ret;
				}
	
				return;
			}
	
			isFunction = jQuery.isFunction( value );
	
			return this.each( function( i ) {
				var val;
	
				if ( this.nodeType !== 1 ) {
					return;
				}
	
				if ( isFunction ) {
					val = value.call( this, i, jQuery( this ).val() );
				} else {
					val = value;
				}
	
				// Treat null/undefined as ""; convert numbers to string
				if ( val == null ) {
					val = "";
				} else if ( typeof val === "number" ) {
					val += "";
				} else if ( jQuery.isArray( val ) ) {
					val = jQuery.map( val, function( value ) {
						return value == null ? "" : value + "";
					} );
				}
	
				hooks = jQuery.valHooks[ this.type ] || jQuery.valHooks[ this.nodeName.toLowerCase() ];
	
				// If set returns undefined, fall back to normal setting
				if ( !hooks || !( "set" in hooks ) || hooks.set( this, val, "value" ) === undefined ) {
					this.value = val;
				}
			} );
		}
	} );
	
	jQuery.extend( {
		valHooks: {
			option: {
				get: function( elem ) {
					var val = jQuery.find.attr( elem, "value" );
					return val != null ?
						val :
	
						// Support: IE10-11+
						// option.text throws exceptions (#14686, #14858)
						// Strip and collapse whitespace
						// https://html.spec.whatwg.org/#strip-and-collapse-whitespace
						jQuery.trim( jQuery.text( elem ) ).replace( rspaces, " " );
				}
			},
			select: {
				get: function( elem ) {
					var value, option,
						options = elem.options,
						index = elem.selectedIndex,
						one = elem.type === "select-one" || index < 0,
						values = one ? null : [],
						max = one ? index + 1 : options.length,
						i = index < 0 ?
							max :
							one ? index : 0;
	
					// Loop through all the selected options
					for ( ; i < max; i++ ) {
						option = options[ i ];
	
						// oldIE doesn't update selected after form reset (#2551)
						if ( ( option.selected || i === index ) &&
	
								// Don't return options that are disabled or in a disabled optgroup
								( support.optDisabled ?
									!option.disabled :
									option.getAttribute( "disabled" ) === null ) &&
								( !option.parentNode.disabled ||
									!jQuery.nodeName( option.parentNode, "optgroup" ) ) ) {
	
							// Get the specific value for the option
							value = jQuery( option ).val();
	
							// We don't need an array for one selects
							if ( one ) {
								return value;
							}
	
							// Multi-Selects return an array
							values.push( value );
						}
					}
	
					return values;
				},
	
				set: function( elem, value ) {
					var optionSet, option,
						options = elem.options,
						values = jQuery.makeArray( value ),
						i = options.length;
	
					while ( i-- ) {
						option = options[ i ];
	
						if ( jQuery.inArray( jQuery.valHooks.option.get( option ), values ) > -1 ) {
	
							// Support: IE6
							// When new option element is added to select box we need to
							// force reflow of newly added node in order to workaround delay
							// of initialization properties
							try {
								option.selected = optionSet = true;
	
							} catch ( _ ) {
	
								// Will be executed only in IE6
								option.scrollHeight;
							}
	
						} else {
							option.selected = false;
						}
					}
	
					// Force browsers to behave consistently when non-matching value is set
					if ( !optionSet ) {
						elem.selectedIndex = -1;
					}
	
					return options;
				}
			}
		}
	} );
	
	// Radios and checkboxes getter/setter
	jQuery.each( [ "radio", "checkbox" ], function() {
		jQuery.valHooks[ this ] = {
			set: function( elem, value ) {
				if ( jQuery.isArray( value ) ) {
					return ( elem.checked = jQuery.inArray( jQuery( elem ).val(), value ) > -1 );
				}
			}
		};
		if ( !support.checkOn ) {
			jQuery.valHooks[ this ].get = function( elem ) {
				return elem.getAttribute( "value" ) === null ? "on" : elem.value;
			};
		}
	} );
	
	
	
	
	var nodeHook, boolHook,
		attrHandle = jQuery.expr.attrHandle,
		ruseDefault = /^(?:checked|selected)$/i,
		getSetAttribute = support.getSetAttribute,
		getSetInput = support.input;
	
	jQuery.fn.extend( {
		attr: function( name, value ) {
			return access( this, jQuery.attr, name, value, arguments.length > 1 );
		},
	
		removeAttr: function( name ) {
			return this.each( function() {
				jQuery.removeAttr( this, name );
			} );
		}
	} );
	
	jQuery.extend( {
		attr: function( elem, name, value ) {
			var ret, hooks,
				nType = elem.nodeType;
	
			// Don't get/set attributes on text, comment and attribute nodes
			if ( nType === 3 || nType === 8 || nType === 2 ) {
				return;
			}
	
			// Fallback to prop when attributes are not supported
			if ( typeof elem.getAttribute === "undefined" ) {
				return jQuery.prop( elem, name, value );
			}
	
			// All attributes are lowercase
			// Grab necessary hook if one is defined
			if ( nType !== 1 || !jQuery.isXMLDoc( elem ) ) {
				name = name.toLowerCase();
				hooks = jQuery.attrHooks[ name ] ||
					( jQuery.expr.match.bool.test( name ) ? boolHook : nodeHook );
			}
	
			if ( value !== undefined ) {
				if ( value === null ) {
					jQuery.removeAttr( elem, name );
					return;
				}
	
				if ( hooks && "set" in hooks &&
					( ret = hooks.set( elem, value, name ) ) !== undefined ) {
					return ret;
				}
	
				elem.setAttribute( name, value + "" );
				return value;
			}
	
			if ( hooks && "get" in hooks && ( ret = hooks.get( elem, name ) ) !== null ) {
				return ret;
			}
	
			ret = jQuery.find.attr( elem, name );
	
			// Non-existent attributes return null, we normalize to undefined
			return ret == null ? undefined : ret;
		},
	
		attrHooks: {
			type: {
				set: function( elem, value ) {
					if ( !support.radioValue && value === "radio" &&
						jQuery.nodeName( elem, "input" ) ) {
	
						// Setting the type on a radio button after the value resets the value in IE8-9
						// Reset value to default in case type is set after value during creation
						var val = elem.value;
						elem.setAttribute( "type", value );
						if ( val ) {
							elem.value = val;
						}
						return value;
					}
				}
			}
		},
	
		removeAttr: function( elem, value ) {
			var name, propName,
				i = 0,
				attrNames = value && value.match( rnotwhite );
	
			if ( attrNames && elem.nodeType === 1 ) {
				while ( ( name = attrNames[ i++ ] ) ) {
					propName = jQuery.propFix[ name ] || name;
	
					// Boolean attributes get special treatment (#10870)
					if ( jQuery.expr.match.bool.test( name ) ) {
	
						// Set corresponding property to false
						if ( getSetInput && getSetAttribute || !ruseDefault.test( name ) ) {
							elem[ propName ] = false;
	
						// Support: IE<9
						// Also clear defaultChecked/defaultSelected (if appropriate)
						} else {
							elem[ jQuery.camelCase( "default-" + name ) ] =
								elem[ propName ] = false;
						}
	
					// See #9699 for explanation of this approach (setting first, then removal)
					} else {
						jQuery.attr( elem, name, "" );
					}
	
					elem.removeAttribute( getSetAttribute ? name : propName );
				}
			}
		}
	} );
	
	// Hooks for boolean attributes
	boolHook = {
		set: function( elem, value, name ) {
			if ( value === false ) {
	
				// Remove boolean attributes when set to false
				jQuery.removeAttr( elem, name );
			} else if ( getSetInput && getSetAttribute || !ruseDefault.test( name ) ) {
	
				// IE<8 needs the *property* name
				elem.setAttribute( !getSetAttribute && jQuery.propFix[ name ] || name, name );
	
			} else {
	
				// Support: IE<9
				// Use defaultChecked and defaultSelected for oldIE
				elem[ jQuery.camelCase( "default-" + name ) ] = elem[ name ] = true;
			}
			return name;
		}
	};
	
	jQuery.each( jQuery.expr.match.bool.source.match( /\w+/g ), function( i, name ) {
		var getter = attrHandle[ name ] || jQuery.find.attr;
	
		if ( getSetInput && getSetAttribute || !ruseDefault.test( name ) ) {
			attrHandle[ name ] = function( elem, name, isXML ) {
				var ret, handle;
				if ( !isXML ) {
	
					// Avoid an infinite loop by temporarily removing this function from the getter
					handle = attrHandle[ name ];
					attrHandle[ name ] = ret;
					ret = getter( elem, name, isXML ) != null ?
						name.toLowerCase() :
						null;
					attrHandle[ name ] = handle;
				}
				return ret;
			};
		} else {
			attrHandle[ name ] = function( elem, name, isXML ) {
				if ( !isXML ) {
					return elem[ jQuery.camelCase( "default-" + name ) ] ?
						name.toLowerCase() :
						null;
				}
			};
		}
	} );
	
	// fix oldIE attroperties
	if ( !getSetInput || !getSetAttribute ) {
		jQuery.attrHooks.value = {
			set: function( elem, value, name ) {
				if ( jQuery.nodeName( elem, "input" ) ) {
	
					// Does not return so that setAttribute is also used
					elem.defaultValue = value;
				} else {
	
					// Use nodeHook if defined (#1954); otherwise setAttribute is fine
					return nodeHook && nodeHook.set( elem, value, name );
				}
			}
		};
	}
	
	// IE6/7 do not support getting/setting some attributes with get/setAttribute
	if ( !getSetAttribute ) {
	
		// Use this for any attribute in IE6/7
		// This fixes almost every IE6/7 issue
		nodeHook = {
			set: function( elem, value, name ) {
	
				// Set the existing or create a new attribute node
				var ret = elem.getAttributeNode( name );
				if ( !ret ) {
					elem.setAttributeNode(
						( ret = elem.ownerDocument.createAttribute( name ) )
					);
				}
	
				ret.value = value += "";
	
				// Break association with cloned elements by also using setAttribute (#9646)
				if ( name === "value" || value === elem.getAttribute( name ) ) {
					return value;
				}
			}
		};
	
		// Some attributes are constructed with empty-string values when not defined
		attrHandle.id = attrHandle.name = attrHandle.coords =
			function( elem, name, isXML ) {
				var ret;
				if ( !isXML ) {
					return ( ret = elem.getAttributeNode( name ) ) && ret.value !== "" ?
						ret.value :
						null;
				}
			};
	
		// Fixing value retrieval on a button requires this module
		jQuery.valHooks.button = {
			get: function( elem, name ) {
				var ret = elem.getAttributeNode( name );
				if ( ret && ret.specified ) {
					return ret.value;
				}
			},
			set: nodeHook.set
		};
	
		// Set contenteditable to false on removals(#10429)
		// Setting to empty string throws an error as an invalid value
		jQuery.attrHooks.contenteditable = {
			set: function( elem, value, name ) {
				nodeHook.set( elem, value === "" ? false : value, name );
			}
		};
	
		// Set width and height to auto instead of 0 on empty string( Bug #8150 )
		// This is for removals
		jQuery.each( [ "width", "height" ], function( i, name ) {
			jQuery.attrHooks[ name ] = {
				set: function( elem, value ) {
					if ( value === "" ) {
						elem.setAttribute( name, "auto" );
						return value;
					}
				}
			};
		} );
	}
	
	if ( !support.style ) {
		jQuery.attrHooks.style = {
			get: function( elem ) {
	
				// Return undefined in the case of empty string
				// Note: IE uppercases css property names, but if we were to .toLowerCase()
				// .cssText, that would destroy case sensitivity in URL's, like in "background"
				return elem.style.cssText || undefined;
			},
			set: function( elem, value ) {
				return ( elem.style.cssText = value + "" );
			}
		};
	}
	
	
	
	
	var rfocusable = /^(?:input|select|textarea|button|object)$/i,
		rclickable = /^(?:a|area)$/i;
	
	jQuery.fn.extend( {
		prop: function( name, value ) {
			return access( this, jQuery.prop, name, value, arguments.length > 1 );
		},
	
		removeProp: function( name ) {
			name = jQuery.propFix[ name ] || name;
			return this.each( function() {
	
				// try/catch handles cases where IE balks (such as removing a property on window)
				try {
					this[ name ] = undefined;
					delete this[ name ];
				} catch ( e ) {}
			} );
		}
	} );
	
	jQuery.extend( {
		prop: function( elem, name, value ) {
			var ret, hooks,
				nType = elem.nodeType;
	
			// Don't get/set properties on text, comment and attribute nodes
			if ( nType === 3 || nType === 8 || nType === 2 ) {
				return;
			}
	
			if ( nType !== 1 || !jQuery.isXMLDoc( elem ) ) {
	
				// Fix name and attach hooks
				name = jQuery.propFix[ name ] || name;
				hooks = jQuery.propHooks[ name ];
			}
	
			if ( value !== undefined ) {
				if ( hooks && "set" in hooks &&
					( ret = hooks.set( elem, value, name ) ) !== undefined ) {
					return ret;
				}
	
				return ( elem[ name ] = value );
			}
	
			if ( hooks && "get" in hooks && ( ret = hooks.get( elem, name ) ) !== null ) {
				return ret;
			}
	
			return elem[ name ];
		},
	
		propHooks: {
			tabIndex: {
				get: function( elem ) {
	
					// elem.tabIndex doesn't always return the
					// correct value when it hasn't been explicitly set
					// http://fluidproject.org/blog/2008/01/09/getting-setting-and-removing-tabindex-values-with-javascript/
					// Use proper attribute retrieval(#12072)
					var tabindex = jQuery.find.attr( elem, "tabindex" );
	
					return tabindex ?
						parseInt( tabindex, 10 ) :
						rfocusable.test( elem.nodeName ) ||
							rclickable.test( elem.nodeName ) && elem.href ?
								0 :
								-1;
				}
			}
		},
	
		propFix: {
			"for": "htmlFor",
			"class": "className"
		}
	} );
	
	// Some attributes require a special call on IE
	// http://msdn.microsoft.com/en-us/library/ms536429%28VS.85%29.aspx
	if ( !support.hrefNormalized ) {
	
		// href/src property should get the full normalized URL (#10299/#12915)
		jQuery.each( [ "href", "src" ], function( i, name ) {
			jQuery.propHooks[ name ] = {
				get: function( elem ) {
					return elem.getAttribute( name, 4 );
				}
			};
		} );
	}
	
	// Support: Safari, IE9+
	// Accessing the selectedIndex property
	// forces the browser to respect setting selected
	// on the option
	// The getter ensures a default option is selected
	// when in an optgroup
	if ( !support.optSelected ) {
		jQuery.propHooks.selected = {
			get: function( elem ) {
				var parent = elem.parentNode;
	
				if ( parent ) {
					parent.selectedIndex;
	
					// Make sure that it also works with optgroups, see #5701
					if ( parent.parentNode ) {
						parent.parentNode.selectedIndex;
					}
				}
				return null;
			},
			set: function( elem ) {
				var parent = elem.parentNode;
				if ( parent ) {
					parent.selectedIndex;
	
					if ( parent.parentNode ) {
						parent.parentNode.selectedIndex;
					}
				}
			}
		};
	}
	
	jQuery.each( [
		"tabIndex",
		"readOnly",
		"maxLength",
		"cellSpacing",
		"cellPadding",
		"rowSpan",
		"colSpan",
		"useMap",
		"frameBorder",
		"contentEditable"
	], function() {
		jQuery.propFix[ this.toLowerCase() ] = this;
	} );
	
	// IE6/7 call enctype encoding
	if ( !support.enctype ) {
		jQuery.propFix.enctype = "encoding";
	}
	
	
	
	
	var rclass = /[\t\r\n\f]/g;
	
	function getClass( elem ) {
		return jQuery.attr( elem, "class" ) || "";
	}
	
	jQuery.fn.extend( {
		addClass: function( value ) {
			var classes, elem, cur, curValue, clazz, j, finalValue,
				i = 0;
	
			if ( jQuery.isFunction( value ) ) {
				return this.each( function( j ) {
					jQuery( this ).addClass( value.call( this, j, getClass( this ) ) );
				} );
			}
	
			if ( typeof value === "string" && value ) {
				classes = value.match( rnotwhite ) || [];
	
				while ( ( elem = this[ i++ ] ) ) {
					curValue = getClass( elem );
					cur = elem.nodeType === 1 &&
						( " " + curValue + " " ).replace( rclass, " " );
	
					if ( cur ) {
						j = 0;
						while ( ( clazz = classes[ j++ ] ) ) {
							if ( cur.indexOf( " " + clazz + " " ) < 0 ) {
								cur += clazz + " ";
							}
						}
	
						// only assign if different to avoid unneeded rendering.
						finalValue = jQuery.trim( cur );
						if ( curValue !== finalValue ) {
							jQuery.attr( elem, "class", finalValue );
						}
					}
				}
			}
	
			return this;
		},
	
		removeClass: function( value ) {
			var classes, elem, cur, curValue, clazz, j, finalValue,
				i = 0;
	
			if ( jQuery.isFunction( value ) ) {
				return this.each( function( j ) {
					jQuery( this ).removeClass( value.call( this, j, getClass( this ) ) );
				} );
			}
	
			if ( !arguments.length ) {
				return this.attr( "class", "" );
			}
	
			if ( typeof value === "string" && value ) {
				classes = value.match( rnotwhite ) || [];
	
				while ( ( elem = this[ i++ ] ) ) {
					curValue = getClass( elem );
	
					// This expression is here for better compressibility (see addClass)
					cur = elem.nodeType === 1 &&
						( " " + curValue + " " ).replace( rclass, " " );
	
					if ( cur ) {
						j = 0;
						while ( ( clazz = classes[ j++ ] ) ) {
	
							// Remove *all* instances
							while ( cur.indexOf( " " + clazz + " " ) > -1 ) {
								cur = cur.replace( " " + clazz + " ", " " );
							}
						}
	
						// Only assign if different to avoid unneeded rendering.
						finalValue = jQuery.trim( cur );
						if ( curValue !== finalValue ) {
							jQuery.attr( elem, "class", finalValue );
						}
					}
				}
			}
	
			return this;
		},
	
		toggleClass: function( value, stateVal ) {
			var type = typeof value;
	
			if ( typeof stateVal === "boolean" && type === "string" ) {
				return stateVal ? this.addClass( value ) : this.removeClass( value );
			}
	
			if ( jQuery.isFunction( value ) ) {
				return this.each( function( i ) {
					jQuery( this ).toggleClass(
						value.call( this, i, getClass( this ), stateVal ),
						stateVal
					);
				} );
			}
	
			return this.each( function() {
				var className, i, self, classNames;
	
				if ( type === "string" ) {
	
					// Toggle individual class names
					i = 0;
					self = jQuery( this );
					classNames = value.match( rnotwhite ) || [];
	
					while ( ( className = classNames[ i++ ] ) ) {
	
						// Check each className given, space separated list
						if ( self.hasClass( className ) ) {
							self.removeClass( className );
						} else {
							self.addClass( className );
						}
					}
	
				// Toggle whole class name
				} else if ( value === undefined || type === "boolean" ) {
					className = getClass( this );
					if ( className ) {
	
						// store className if set
						jQuery._data( this, "__className__", className );
					}
	
					// If the element has a class name or if we're passed "false",
					// then remove the whole classname (if there was one, the above saved it).
					// Otherwise bring back whatever was previously saved (if anything),
					// falling back to the empty string if nothing was stored.
					jQuery.attr( this, "class",
						className || value === false ?
						"" :
						jQuery._data( this, "__className__" ) || ""
					);
				}
			} );
		},
	
		hasClass: function( selector ) {
			var className, elem,
				i = 0;
	
			className = " " + selector + " ";
			while ( ( elem = this[ i++ ] ) ) {
				if ( elem.nodeType === 1 &&
					( " " + getClass( elem ) + " " ).replace( rclass, " " )
						.indexOf( className ) > -1
				) {
					return true;
				}
			}
	
			return false;
		}
	} );
	
	
	
	
	// Return jQuery for attributes-only inclusion
	
	
	jQuery.each( ( "blur focus focusin focusout load resize scroll unload click dblclick " +
		"mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave " +
		"change select submit keydown keypress keyup error contextmenu" ).split( " " ),
		function( i, name ) {
	
		// Handle event binding
		jQuery.fn[ name ] = function( data, fn ) {
			return arguments.length > 0 ?
				this.on( name, null, data, fn ) :
				this.trigger( name );
		};
	} );
	
	jQuery.fn.extend( {
		hover: function( fnOver, fnOut ) {
			return this.mouseenter( fnOver ).mouseleave( fnOut || fnOver );
		}
	} );
	
	
	var location = window.location;
	
	var nonce = jQuery.now();
	
	var rquery = ( /\?/ );
	
	
	
	var rvalidtokens = /(,)|(\[|{)|(}|])|"(?:[^"\\\r\n]|\\["\\\/bfnrt]|\\u[\da-fA-F]{4})*"\s*:?|true|false|null|-?(?!0\d)\d+(?:\.\d+|)(?:[eE][+-]?\d+|)/g;
	
	jQuery.parseJSON = function( data ) {
	
		// Attempt to parse using the native JSON parser first
		if ( window.JSON && window.JSON.parse ) {
	
			// Support: Android 2.3
			// Workaround failure to string-cast null input
			return window.JSON.parse( data + "" );
		}
	
		var requireNonComma,
			depth = null,
			str = jQuery.trim( data + "" );
	
		// Guard against invalid (and possibly dangerous) input by ensuring that nothing remains
		// after removing valid tokens
		return str && !jQuery.trim( str.replace( rvalidtokens, function( token, comma, open, close ) {
	
			// Force termination if we see a misplaced comma
			if ( requireNonComma && comma ) {
				depth = 0;
			}
	
			// Perform no more replacements after returning to outermost depth
			if ( depth === 0 ) {
				return token;
			}
	
			// Commas must not follow "[", "{", or ","
			requireNonComma = open || comma;
	
			// Determine new depth
			// array/object open ("[" or "{"): depth += true - false (increment)
			// array/object close ("]" or "}"): depth += false - true (decrement)
			// other cases ("," or primitive): depth += true - true (numeric cast)
			depth += !close - !open;
	
			// Remove this token
			return "";
		} ) ) ?
			( Function( "return " + str ) )() :
			jQuery.error( "Invalid JSON: " + data );
	};
	
	
	// Cross-browser xml parsing
	jQuery.parseXML = function( data ) {
		var xml, tmp;
		if ( !data || typeof data !== "string" ) {
			return null;
		}
		try {
			if ( window.DOMParser ) { // Standard
				tmp = new window.DOMParser();
				xml = tmp.parseFromString( data, "text/xml" );
			} else { // IE
				xml = new window.ActiveXObject( "Microsoft.XMLDOM" );
				xml.async = "false";
				xml.loadXML( data );
			}
		} catch ( e ) {
			xml = undefined;
		}
		if ( !xml || !xml.documentElement || xml.getElementsByTagName( "parsererror" ).length ) {
			jQuery.error( "Invalid XML: " + data );
		}
		return xml;
	};
	
	
	var
		rhash = /#.*$/,
		rts = /([?&])_=[^&]*/,
	
		// IE leaves an \r character at EOL
		rheaders = /^(.*?):[ \t]*([^\r\n]*)\r?$/mg,
	
		// #7653, #8125, #8152: local protocol detection
		rlocalProtocol = /^(?:about|app|app-storage|.+-extension|file|res|widget):$/,
		rnoContent = /^(?:GET|HEAD)$/,
		rprotocol = /^\/\//,
		rurl = /^([\w.+-]+:)(?:\/\/(?:[^\/?#]*@|)([^\/?#:]*)(?::(\d+)|)|)/,
	
		/* Prefilters
		 * 1) They are useful to introduce custom dataTypes (see ajax/jsonp.js for an example)
		 * 2) These are called:
		 *    - BEFORE asking for a transport
		 *    - AFTER param serialization (s.data is a string if s.processData is true)
		 * 3) key is the dataType
		 * 4) the catchall symbol "*" can be used
		 * 5) execution will start with transport dataType and THEN continue down to "*" if needed
		 */
		prefilters = {},
	
		/* Transports bindings
		 * 1) key is the dataType
		 * 2) the catchall symbol "*" can be used
		 * 3) selection will start with transport dataType and THEN go to "*" if needed
		 */
		transports = {},
	
		// Avoid comment-prolog char sequence (#10098); must appease lint and evade compression
		allTypes = "*/".concat( "*" ),
	
		// Document location
		ajaxLocation = location.href,
	
		// Segment location into parts
		ajaxLocParts = rurl.exec( ajaxLocation.toLowerCase() ) || [];
	
	// Base "constructor" for jQuery.ajaxPrefilter and jQuery.ajaxTransport
	function addToPrefiltersOrTransports( structure ) {
	
		// dataTypeExpression is optional and defaults to "*"
		return function( dataTypeExpression, func ) {
	
			if ( typeof dataTypeExpression !== "string" ) {
				func = dataTypeExpression;
				dataTypeExpression = "*";
			}
	
			var dataType,
				i = 0,
				dataTypes = dataTypeExpression.toLowerCase().match( rnotwhite ) || [];
	
			if ( jQuery.isFunction( func ) ) {
	
				// For each dataType in the dataTypeExpression
				while ( ( dataType = dataTypes[ i++ ] ) ) {
	
					// Prepend if requested
					if ( dataType.charAt( 0 ) === "+" ) {
						dataType = dataType.slice( 1 ) || "*";
						( structure[ dataType ] = structure[ dataType ] || [] ).unshift( func );
	
					// Otherwise append
					} else {
						( structure[ dataType ] = structure[ dataType ] || [] ).push( func );
					}
				}
			}
		};
	}
	
	// Base inspection function for prefilters and transports
	function inspectPrefiltersOrTransports( structure, options, originalOptions, jqXHR ) {
	
		var inspected = {},
			seekingTransport = ( structure === transports );
	
		function inspect( dataType ) {
			var selected;
			inspected[ dataType ] = true;
			jQuery.each( structure[ dataType ] || [], function( _, prefilterOrFactory ) {
				var dataTypeOrTransport = prefilterOrFactory( options, originalOptions, jqXHR );
				if ( typeof dataTypeOrTransport === "string" &&
					!seekingTransport && !inspected[ dataTypeOrTransport ] ) {
	
					options.dataTypes.unshift( dataTypeOrTransport );
					inspect( dataTypeOrTransport );
					return false;
				} else if ( seekingTransport ) {
					return !( selected = dataTypeOrTransport );
				}
			} );
			return selected;
		}
	
		return inspect( options.dataTypes[ 0 ] ) || !inspected[ "*" ] && inspect( "*" );
	}
	
	// A special extend for ajax options
	// that takes "flat" options (not to be deep extended)
	// Fixes #9887
	function ajaxExtend( target, src ) {
		var deep, key,
			flatOptions = jQuery.ajaxSettings.flatOptions || {};
	
		for ( key in src ) {
			if ( src[ key ] !== undefined ) {
				( flatOptions[ key ] ? target : ( deep || ( deep = {} ) ) )[ key ] = src[ key ];
			}
		}
		if ( deep ) {
			jQuery.extend( true, target, deep );
		}
	
		return target;
	}
	
	/* Handles responses to an ajax request:
	 * - finds the right dataType (mediates between content-type and expected dataType)
	 * - returns the corresponding response
	 */
	function ajaxHandleResponses( s, jqXHR, responses ) {
		var firstDataType, ct, finalDataType, type,
			contents = s.contents,
			dataTypes = s.dataTypes;
	
		// Remove auto dataType and get content-type in the process
		while ( dataTypes[ 0 ] === "*" ) {
			dataTypes.shift();
			if ( ct === undefined ) {
				ct = s.mimeType || jqXHR.getResponseHeader( "Content-Type" );
			}
		}
	
		// Check if we're dealing with a known content-type
		if ( ct ) {
			for ( type in contents ) {
				if ( contents[ type ] && contents[ type ].test( ct ) ) {
					dataTypes.unshift( type );
					break;
				}
			}
		}
	
		// Check to see if we have a response for the expected dataType
		if ( dataTypes[ 0 ] in responses ) {
			finalDataType = dataTypes[ 0 ];
		} else {
	
			// Try convertible dataTypes
			for ( type in responses ) {
				if ( !dataTypes[ 0 ] || s.converters[ type + " " + dataTypes[ 0 ] ] ) {
					finalDataType = type;
					break;
				}
				if ( !firstDataType ) {
					firstDataType = type;
				}
			}
	
			// Or just use first one
			finalDataType = finalDataType || firstDataType;
		}
	
		// If we found a dataType
		// We add the dataType to the list if needed
		// and return the corresponding response
		if ( finalDataType ) {
			if ( finalDataType !== dataTypes[ 0 ] ) {
				dataTypes.unshift( finalDataType );
			}
			return responses[ finalDataType ];
		}
	}
	
	/* Chain conversions given the request and the original response
	 * Also sets the responseXXX fields on the jqXHR instance
	 */
	function ajaxConvert( s, response, jqXHR, isSuccess ) {
		var conv2, current, conv, tmp, prev,
			converters = {},
	
			// Work with a copy of dataTypes in case we need to modify it for conversion
			dataTypes = s.dataTypes.slice();
	
		// Create converters map with lowercased keys
		if ( dataTypes[ 1 ] ) {
			for ( conv in s.converters ) {
				converters[ conv.toLowerCase() ] = s.converters[ conv ];
			}
		}
	
		current = dataTypes.shift();
	
		// Convert to each sequential dataType
		while ( current ) {
	
			if ( s.responseFields[ current ] ) {
				jqXHR[ s.responseFields[ current ] ] = response;
			}
	
			// Apply the dataFilter if provided
			if ( !prev && isSuccess && s.dataFilter ) {
				response = s.dataFilter( response, s.dataType );
			}
	
			prev = current;
			current = dataTypes.shift();
	
			if ( current ) {
	
				// There's only work to do if current dataType is non-auto
				if ( current === "*" ) {
	
					current = prev;
	
				// Convert response if prev dataType is non-auto and differs from current
				} else if ( prev !== "*" && prev !== current ) {
	
					// Seek a direct converter
					conv = converters[ prev + " " + current ] || converters[ "* " + current ];
	
					// If none found, seek a pair
					if ( !conv ) {
						for ( conv2 in converters ) {
	
							// If conv2 outputs current
							tmp = conv2.split( " " );
							if ( tmp[ 1 ] === current ) {
	
								// If prev can be converted to accepted input
								conv = converters[ prev + " " + tmp[ 0 ] ] ||
									converters[ "* " + tmp[ 0 ] ];
								if ( conv ) {
	
									// Condense equivalence converters
									if ( conv === true ) {
										conv = converters[ conv2 ];
	
									// Otherwise, insert the intermediate dataType
									} else if ( converters[ conv2 ] !== true ) {
										current = tmp[ 0 ];
										dataTypes.unshift( tmp[ 1 ] );
									}
									break;
								}
							}
						}
					}
	
					// Apply converter (if not an equivalence)
					if ( conv !== true ) {
	
						// Unless errors are allowed to bubble, catch and return them
						if ( conv && s[ "throws" ] ) { // jscs:ignore requireDotNotation
							response = conv( response );
						} else {
							try {
								response = conv( response );
							} catch ( e ) {
								return {
									state: "parsererror",
									error: conv ? e : "No conversion from " + prev + " to " + current
								};
							}
						}
					}
				}
			}
		}
	
		return { state: "success", data: response };
	}
	
	jQuery.extend( {
	
		// Counter for holding the number of active queries
		active: 0,
	
		// Last-Modified header cache for next request
		lastModified: {},
		etag: {},
	
		ajaxSettings: {
			url: ajaxLocation,
			type: "GET",
			isLocal: rlocalProtocol.test( ajaxLocParts[ 1 ] ),
			global: true,
			processData: true,
			async: true,
			contentType: "application/x-www-form-urlencoded; charset=UTF-8",
			/*
			timeout: 0,
			data: null,
			dataType: null,
			username: null,
			password: null,
			cache: null,
			throws: false,
			traditional: false,
			headers: {},
			*/
	
			accepts: {
				"*": allTypes,
				text: "text/plain",
				html: "text/html",
				xml: "application/xml, text/xml",
				json: "application/json, text/javascript"
			},
	
			contents: {
				xml: /\bxml\b/,
				html: /\bhtml/,
				json: /\bjson\b/
			},
	
			responseFields: {
				xml: "responseXML",
				text: "responseText",
				json: "responseJSON"
			},
	
			// Data converters
			// Keys separate source (or catchall "*") and destination types with a single space
			converters: {
	
				// Convert anything to text
				"* text": String,
	
				// Text to html (true = no transformation)
				"text html": true,
	
				// Evaluate text as a json expression
				"text json": jQuery.parseJSON,
	
				// Parse text as xml
				"text xml": jQuery.parseXML
			},
	
			// For options that shouldn't be deep extended:
			// you can add your own custom options here if
			// and when you create one that shouldn't be
			// deep extended (see ajaxExtend)
			flatOptions: {
				url: true,
				context: true
			}
		},
	
		// Creates a full fledged settings object into target
		// with both ajaxSettings and settings fields.
		// If target is omitted, writes into ajaxSettings.
		ajaxSetup: function( target, settings ) {
			return settings ?
	
				// Building a settings object
				ajaxExtend( ajaxExtend( target, jQuery.ajaxSettings ), settings ) :
	
				// Extending ajaxSettings
				ajaxExtend( jQuery.ajaxSettings, target );
		},
	
		ajaxPrefilter: addToPrefiltersOrTransports( prefilters ),
		ajaxTransport: addToPrefiltersOrTransports( transports ),
	
		// Main method
		ajax: function( url, options ) {
	
			// If url is an object, simulate pre-1.5 signature
			if ( typeof url === "object" ) {
				options = url;
				url = undefined;
			}
	
			// Force options to be an object
			options = options || {};
	
			var
	
				// Cross-domain detection vars
				parts,
	
				// Loop variable
				i,
	
				// URL without anti-cache param
				cacheURL,
	
				// Response headers as string
				responseHeadersString,
	
				// timeout handle
				timeoutTimer,
	
				// To know if global events are to be dispatched
				fireGlobals,
	
				transport,
	
				// Response headers
				responseHeaders,
	
				// Create the final options object
				s = jQuery.ajaxSetup( {}, options ),
	
				// Callbacks context
				callbackContext = s.context || s,
	
				// Context for global events is callbackContext if it is a DOM node or jQuery collection
				globalEventContext = s.context &&
					( callbackContext.nodeType || callbackContext.jquery ) ?
						jQuery( callbackContext ) :
						jQuery.event,
	
				// Deferreds
				deferred = jQuery.Deferred(),
				completeDeferred = jQuery.Callbacks( "once memory" ),
	
				// Status-dependent callbacks
				statusCode = s.statusCode || {},
	
				// Headers (they are sent all at once)
				requestHeaders = {},
				requestHeadersNames = {},
	
				// The jqXHR state
				state = 0,
	
				// Default abort message
				strAbort = "canceled",
	
				// Fake xhr
				jqXHR = {
					readyState: 0,
	
					// Builds headers hashtable if needed
					getResponseHeader: function( key ) {
						var match;
						if ( state === 2 ) {
							if ( !responseHeaders ) {
								responseHeaders = {};
								while ( ( match = rheaders.exec( responseHeadersString ) ) ) {
									responseHeaders[ match[ 1 ].toLowerCase() ] = match[ 2 ];
								}
							}
							match = responseHeaders[ key.toLowerCase() ];
						}
						return match == null ? null : match;
					},
	
					// Raw string
					getAllResponseHeaders: function() {
						return state === 2 ? responseHeadersString : null;
					},
	
					// Caches the header
					setRequestHeader: function( name, value ) {
						var lname = name.toLowerCase();
						if ( !state ) {
							name = requestHeadersNames[ lname ] = requestHeadersNames[ lname ] || name;
							requestHeaders[ name ] = value;
						}
						return this;
					},
	
					// Overrides response content-type header
					overrideMimeType: function( type ) {
						if ( !state ) {
							s.mimeType = type;
						}
						return this;
					},
	
					// Status-dependent callbacks
					statusCode: function( map ) {
						var code;
						if ( map ) {
							if ( state < 2 ) {
								for ( code in map ) {
	
									// Lazy-add the new callback in a way that preserves old ones
									statusCode[ code ] = [ statusCode[ code ], map[ code ] ];
								}
							} else {
	
								// Execute the appropriate callbacks
								jqXHR.always( map[ jqXHR.status ] );
							}
						}
						return this;
					},
	
					// Cancel the request
					abort: function( statusText ) {
						var finalText = statusText || strAbort;
						if ( transport ) {
							transport.abort( finalText );
						}
						done( 0, finalText );
						return this;
					}
				};
	
			// Attach deferreds
			deferred.promise( jqXHR ).complete = completeDeferred.add;
			jqXHR.success = jqXHR.done;
			jqXHR.error = jqXHR.fail;
	
			// Remove hash character (#7531: and string promotion)
			// Add protocol if not provided (#5866: IE7 issue with protocol-less urls)
			// Handle falsy url in the settings object (#10093: consistency with old signature)
			// We also use the url parameter if available
			s.url = ( ( url || s.url || ajaxLocation ) + "" )
				.replace( rhash, "" )
				.replace( rprotocol, ajaxLocParts[ 1 ] + "//" );
	
			// Alias method option to type as per ticket #12004
			s.type = options.method || options.type || s.method || s.type;
	
			// Extract dataTypes list
			s.dataTypes = jQuery.trim( s.dataType || "*" ).toLowerCase().match( rnotwhite ) || [ "" ];
	
			// A cross-domain request is in order when we have a protocol:host:port mismatch
			if ( s.crossDomain == null ) {
				parts = rurl.exec( s.url.toLowerCase() );
				s.crossDomain = !!( parts &&
					( parts[ 1 ] !== ajaxLocParts[ 1 ] || parts[ 2 ] !== ajaxLocParts[ 2 ] ||
						( parts[ 3 ] || ( parts[ 1 ] === "http:" ? "80" : "443" ) ) !==
							( ajaxLocParts[ 3 ] || ( ajaxLocParts[ 1 ] === "http:" ? "80" : "443" ) ) )
				);
			}
	
			// Convert data if not already a string
			if ( s.data && s.processData && typeof s.data !== "string" ) {
				s.data = jQuery.param( s.data, s.traditional );
			}
	
			// Apply prefilters
			inspectPrefiltersOrTransports( prefilters, s, options, jqXHR );
	
			// If request was aborted inside a prefilter, stop there
			if ( state === 2 ) {
				return jqXHR;
			}
	
			// We can fire global events as of now if asked to
			// Don't fire events if jQuery.event is undefined in an AMD-usage scenario (#15118)
			fireGlobals = jQuery.event && s.global;
	
			// Watch for a new set of requests
			if ( fireGlobals && jQuery.active++ === 0 ) {
				jQuery.event.trigger( "ajaxStart" );
			}
	
			// Uppercase the type
			s.type = s.type.toUpperCase();
	
			// Determine if request has content
			s.hasContent = !rnoContent.test( s.type );
	
			// Save the URL in case we're toying with the If-Modified-Since
			// and/or If-None-Match header later on
			cacheURL = s.url;
	
			// More options handling for requests with no content
			if ( !s.hasContent ) {
	
				// If data is available, append data to url
				if ( s.data ) {
					cacheURL = ( s.url += ( rquery.test( cacheURL ) ? "&" : "?" ) + s.data );
	
					// #9682: remove data so that it's not used in an eventual retry
					delete s.data;
				}
	
				// Add anti-cache in url if needed
				if ( s.cache === false ) {
					s.url = rts.test( cacheURL ) ?
	
						// If there is already a '_' parameter, set its value
						cacheURL.replace( rts, "$1_=" + nonce++ ) :
	
						// Otherwise add one to the end
						cacheURL + ( rquery.test( cacheURL ) ? "&" : "?" ) + "_=" + nonce++;
				}
			}
	
			// Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
			if ( s.ifModified ) {
				if ( jQuery.lastModified[ cacheURL ] ) {
					jqXHR.setRequestHeader( "If-Modified-Since", jQuery.lastModified[ cacheURL ] );
				}
				if ( jQuery.etag[ cacheURL ] ) {
					jqXHR.setRequestHeader( "If-None-Match", jQuery.etag[ cacheURL ] );
				}
			}
	
			// Set the correct header, if data is being sent
			if ( s.data && s.hasContent && s.contentType !== false || options.contentType ) {
				jqXHR.setRequestHeader( "Content-Type", s.contentType );
			}
	
			// Set the Accepts header for the server, depending on the dataType
			jqXHR.setRequestHeader(
				"Accept",
				s.dataTypes[ 0 ] && s.accepts[ s.dataTypes[ 0 ] ] ?
					s.accepts[ s.dataTypes[ 0 ] ] +
						( s.dataTypes[ 0 ] !== "*" ? ", " + allTypes + "; q=0.01" : "" ) :
					s.accepts[ "*" ]
			);
	
			// Check for headers option
			for ( i in s.headers ) {
				jqXHR.setRequestHeader( i, s.headers[ i ] );
			}
	
			// Allow custom headers/mimetypes and early abort
			if ( s.beforeSend &&
				( s.beforeSend.call( callbackContext, jqXHR, s ) === false || state === 2 ) ) {
	
				// Abort if not done already and return
				return jqXHR.abort();
			}
	
			// aborting is no longer a cancellation
			strAbort = "abort";
	
			// Install callbacks on deferreds
			for ( i in { success: 1, error: 1, complete: 1 } ) {
				jqXHR[ i ]( s[ i ] );
			}
	
			// Get transport
			transport = inspectPrefiltersOrTransports( transports, s, options, jqXHR );
	
			// If no transport, we auto-abort
			if ( !transport ) {
				done( -1, "No Transport" );
			} else {
				jqXHR.readyState = 1;
	
				// Send global event
				if ( fireGlobals ) {
					globalEventContext.trigger( "ajaxSend", [ jqXHR, s ] );
				}
	
				// If request was aborted inside ajaxSend, stop there
				if ( state === 2 ) {
					return jqXHR;
				}
	
				// Timeout
				if ( s.async && s.timeout > 0 ) {
					timeoutTimer = window.setTimeout( function() {
						jqXHR.abort( "timeout" );
					}, s.timeout );
				}
	
				try {
					state = 1;
					transport.send( requestHeaders, done );
				} catch ( e ) {
	
					// Propagate exception as error if not done
					if ( state < 2 ) {
						done( -1, e );
	
					// Simply rethrow otherwise
					} else {
						throw e;
					}
				}
			}
	
			// Callback for when everything is done
			function done( status, nativeStatusText, responses, headers ) {
				var isSuccess, success, error, response, modified,
					statusText = nativeStatusText;
	
				// Called once
				if ( state === 2 ) {
					return;
				}
	
				// State is "done" now
				state = 2;
	
				// Clear timeout if it exists
				if ( timeoutTimer ) {
					window.clearTimeout( timeoutTimer );
				}
	
				// Dereference transport for early garbage collection
				// (no matter how long the jqXHR object will be used)
				transport = undefined;
	
				// Cache response headers
				responseHeadersString = headers || "";
	
				// Set readyState
				jqXHR.readyState = status > 0 ? 4 : 0;
	
				// Determine if successful
				isSuccess = status >= 200 && status < 300 || status === 304;
	
				// Get response data
				if ( responses ) {
					response = ajaxHandleResponses( s, jqXHR, responses );
				}
	
				// Convert no matter what (that way responseXXX fields are always set)
				response = ajaxConvert( s, response, jqXHR, isSuccess );
	
				// If successful, handle type chaining
				if ( isSuccess ) {
	
					// Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
					if ( s.ifModified ) {
						modified = jqXHR.getResponseHeader( "Last-Modified" );
						if ( modified ) {
							jQuery.lastModified[ cacheURL ] = modified;
						}
						modified = jqXHR.getResponseHeader( "etag" );
						if ( modified ) {
							jQuery.etag[ cacheURL ] = modified;
						}
					}
	
					// if no content
					if ( status === 204 || s.type === "HEAD" ) {
						statusText = "nocontent";
	
					// if not modified
					} else if ( status === 304 ) {
						statusText = "notmodified";
	
					// If we have data, let's convert it
					} else {
						statusText = response.state;
						success = response.data;
						error = response.error;
						isSuccess = !error;
					}
				} else {
	
					// We extract error from statusText
					// then normalize statusText and status for non-aborts
					error = statusText;
					if ( status || !statusText ) {
						statusText = "error";
						if ( status < 0 ) {
							status = 0;
						}
					}
				}
	
				// Set data for the fake xhr object
				jqXHR.status = status;
				jqXHR.statusText = ( nativeStatusText || statusText ) + "";
	
				// Success/Error
				if ( isSuccess ) {
					deferred.resolveWith( callbackContext, [ success, statusText, jqXHR ] );
				} else {
					deferred.rejectWith( callbackContext, [ jqXHR, statusText, error ] );
				}
	
				// Status-dependent callbacks
				jqXHR.statusCode( statusCode );
				statusCode = undefined;
	
				if ( fireGlobals ) {
					globalEventContext.trigger( isSuccess ? "ajaxSuccess" : "ajaxError",
						[ jqXHR, s, isSuccess ? success : error ] );
				}
	
				// Complete
				completeDeferred.fireWith( callbackContext, [ jqXHR, statusText ] );
	
				if ( fireGlobals ) {
					globalEventContext.trigger( "ajaxComplete", [ jqXHR, s ] );
	
					// Handle the global AJAX counter
					if ( !( --jQuery.active ) ) {
						jQuery.event.trigger( "ajaxStop" );
					}
				}
			}
	
			return jqXHR;
		},
	
		getJSON: function( url, data, callback ) {
			return jQuery.get( url, data, callback, "json" );
		},
	
		getScript: function( url, callback ) {
			return jQuery.get( url, undefined, callback, "script" );
		}
	} );
	
	jQuery.each( [ "get", "post" ], function( i, method ) {
		jQuery[ method ] = function( url, data, callback, type ) {
	
			// shift arguments if data argument was omitted
			if ( jQuery.isFunction( data ) ) {
				type = type || callback;
				callback = data;
				data = undefined;
			}
	
			// The url can be an options object (which then must have .url)
			return jQuery.ajax( jQuery.extend( {
				url: url,
				type: method,
				dataType: type,
				data: data,
				success: callback
			}, jQuery.isPlainObject( url ) && url ) );
		};
	} );
	
	
	jQuery._evalUrl = function( url ) {
		return jQuery.ajax( {
			url: url,
	
			// Make this explicit, since user can override this through ajaxSetup (#11264)
			type: "GET",
			dataType: "script",
			cache: true,
			async: false,
			global: false,
			"throws": true
		} );
	};
	
	
	jQuery.fn.extend( {
		wrapAll: function( html ) {
			if ( jQuery.isFunction( html ) ) {
				return this.each( function( i ) {
					jQuery( this ).wrapAll( html.call( this, i ) );
				} );
			}
	
			if ( this[ 0 ] ) {
	
				// The elements to wrap the target around
				var wrap = jQuery( html, this[ 0 ].ownerDocument ).eq( 0 ).clone( true );
	
				if ( this[ 0 ].parentNode ) {
					wrap.insertBefore( this[ 0 ] );
				}
	
				wrap.map( function() {
					var elem = this;
	
					while ( elem.firstChild && elem.firstChild.nodeType === 1 ) {
						elem = elem.firstChild;
					}
	
					return elem;
				} ).append( this );
			}
	
			return this;
		},
	
		wrapInner: function( html ) {
			if ( jQuery.isFunction( html ) ) {
				return this.each( function( i ) {
					jQuery( this ).wrapInner( html.call( this, i ) );
				} );
			}
	
			return this.each( function() {
				var self = jQuery( this ),
					contents = self.contents();
	
				if ( contents.length ) {
					contents.wrapAll( html );
	
				} else {
					self.append( html );
				}
			} );
		},
	
		wrap: function( html ) {
			var isFunction = jQuery.isFunction( html );
	
			return this.each( function( i ) {
				jQuery( this ).wrapAll( isFunction ? html.call( this, i ) : html );
			} );
		},
	
		unwrap: function() {
			return this.parent().each( function() {
				if ( !jQuery.nodeName( this, "body" ) ) {
					jQuery( this ).replaceWith( this.childNodes );
				}
			} ).end();
		}
	} );
	
	
	function getDisplay( elem ) {
		return elem.style && elem.style.display || jQuery.css( elem, "display" );
	}
	
	function filterHidden( elem ) {
	
		// Disconnected elements are considered hidden
		if ( !jQuery.contains( elem.ownerDocument || document, elem ) ) {
			return true;
		}
		while ( elem && elem.nodeType === 1 ) {
			if ( getDisplay( elem ) === "none" || elem.type === "hidden" ) {
				return true;
			}
			elem = elem.parentNode;
		}
		return false;
	}
	
	jQuery.expr.filters.hidden = function( elem ) {
	
		// Support: Opera <= 12.12
		// Opera reports offsetWidths and offsetHeights less than zero on some elements
		return support.reliableHiddenOffsets() ?
			( elem.offsetWidth <= 0 && elem.offsetHeight <= 0 &&
				!elem.getClientRects().length ) :
				filterHidden( elem );
	};
	
	jQuery.expr.filters.visible = function( elem ) {
		return !jQuery.expr.filters.hidden( elem );
	};
	
	
	
	
	var r20 = /%20/g,
		rbracket = /\[\]$/,
		rCRLF = /\r?\n/g,
		rsubmitterTypes = /^(?:submit|button|image|reset|file)$/i,
		rsubmittable = /^(?:input|select|textarea|keygen)/i;
	
	function buildParams( prefix, obj, traditional, add ) {
		var name;
	
		if ( jQuery.isArray( obj ) ) {
	
			// Serialize array item.
			jQuery.each( obj, function( i, v ) {
				if ( traditional || rbracket.test( prefix ) ) {
	
					// Treat each array item as a scalar.
					add( prefix, v );
	
				} else {
	
					// Item is non-scalar (array or object), encode its numeric index.
					buildParams(
						prefix + "[" + ( typeof v === "object" && v != null ? i : "" ) + "]",
						v,
						traditional,
						add
					);
				}
			} );
	
		} else if ( !traditional && jQuery.type( obj ) === "object" ) {
	
			// Serialize object item.
			for ( name in obj ) {
				buildParams( prefix + "[" + name + "]", obj[ name ], traditional, add );
			}
	
		} else {
	
			// Serialize scalar item.
			add( prefix, obj );
		}
	}
	
	// Serialize an array of form elements or a set of
	// key/values into a query string
	jQuery.param = function( a, traditional ) {
		var prefix,
			s = [],
			add = function( key, value ) {
	
				// If value is a function, invoke it and return its value
				value = jQuery.isFunction( value ) ? value() : ( value == null ? "" : value );
				s[ s.length ] = encodeURIComponent( key ) + "=" + encodeURIComponent( value );
			};
	
		// Set traditional to true for jQuery <= 1.3.2 behavior.
		if ( traditional === undefined ) {
			traditional = jQuery.ajaxSettings && jQuery.ajaxSettings.traditional;
		}
	
		// If an array was passed in, assume that it is an array of form elements.
		if ( jQuery.isArray( a ) || ( a.jquery && !jQuery.isPlainObject( a ) ) ) {
	
			// Serialize the form elements
			jQuery.each( a, function() {
				add( this.name, this.value );
			} );
	
		} else {
	
			// If traditional, encode the "old" way (the way 1.3.2 or older
			// did it), otherwise encode params recursively.
			for ( prefix in a ) {
				buildParams( prefix, a[ prefix ], traditional, add );
			}
		}
	
		// Return the resulting serialization
		return s.join( "&" ).replace( r20, "+" );
	};
	
	jQuery.fn.extend( {
		serialize: function() {
			return jQuery.param( this.serializeArray() );
		},
		serializeArray: function() {
			return this.map( function() {
	
				// Can add propHook for "elements" to filter or add form elements
				var elements = jQuery.prop( this, "elements" );
				return elements ? jQuery.makeArray( elements ) : this;
			} )
			.filter( function() {
				var type = this.type;
	
				// Use .is(":disabled") so that fieldset[disabled] works
				return this.name && !jQuery( this ).is( ":disabled" ) &&
					rsubmittable.test( this.nodeName ) && !rsubmitterTypes.test( type ) &&
					( this.checked || !rcheckableType.test( type ) );
			} )
			.map( function( i, elem ) {
				var val = jQuery( this ).val();
	
				return val == null ?
					null :
					jQuery.isArray( val ) ?
						jQuery.map( val, function( val ) {
							return { name: elem.name, value: val.replace( rCRLF, "\r\n" ) };
						} ) :
						{ name: elem.name, value: val.replace( rCRLF, "\r\n" ) };
			} ).get();
		}
	} );
	
	
	// Create the request object
	// (This is still attached to ajaxSettings for backward compatibility)
	jQuery.ajaxSettings.xhr = window.ActiveXObject !== undefined ?
	
		// Support: IE6-IE8
		function() {
	
			// XHR cannot access local files, always use ActiveX for that case
			if ( this.isLocal ) {
				return createActiveXHR();
			}
	
			// Support: IE 9-11
			// IE seems to error on cross-domain PATCH requests when ActiveX XHR
			// is used. In IE 9+ always use the native XHR.
			// Note: this condition won't catch Edge as it doesn't define
			// document.documentMode but it also doesn't support ActiveX so it won't
			// reach this code.
			if ( document.documentMode > 8 ) {
				return createStandardXHR();
			}
	
			// Support: IE<9
			// oldIE XHR does not support non-RFC2616 methods (#13240)
			// See http://msdn.microsoft.com/en-us/library/ie/ms536648(v=vs.85).aspx
			// and http://www.w3.org/Protocols/rfc2616/rfc2616-sec9.html#sec9
			// Although this check for six methods instead of eight
			// since IE also does not support "trace" and "connect"
			return /^(get|post|head|put|delete|options)$/i.test( this.type ) &&
				createStandardXHR() || createActiveXHR();
		} :
	
		// For all other browsers, use the standard XMLHttpRequest object
		createStandardXHR;
	
	var xhrId = 0,
		xhrCallbacks = {},
		xhrSupported = jQuery.ajaxSettings.xhr();
	
	// Support: IE<10
	// Open requests must be manually aborted on unload (#5280)
	// See https://support.microsoft.com/kb/2856746 for more info
	if ( window.attachEvent ) {
		window.attachEvent( "onunload", function() {
			for ( var key in xhrCallbacks ) {
				xhrCallbacks[ key ]( undefined, true );
			}
		} );
	}
	
	// Determine support properties
	support.cors = !!xhrSupported && ( "withCredentials" in xhrSupported );
	xhrSupported = support.ajax = !!xhrSupported;
	
	// Create transport if the browser can provide an xhr
	if ( xhrSupported ) {
	
		jQuery.ajaxTransport( function( options ) {
	
			// Cross domain only allowed if supported through XMLHttpRequest
			if ( !options.crossDomain || support.cors ) {
	
				var callback;
	
				return {
					send: function( headers, complete ) {
						var i,
							xhr = options.xhr(),
							id = ++xhrId;
	
						// Open the socket
						xhr.open(
							options.type,
							options.url,
							options.async,
							options.username,
							options.password
						);
	
						// Apply custom fields if provided
						if ( options.xhrFields ) {
							for ( i in options.xhrFields ) {
								xhr[ i ] = options.xhrFields[ i ];
							}
						}
	
						// Override mime type if needed
						if ( options.mimeType && xhr.overrideMimeType ) {
							xhr.overrideMimeType( options.mimeType );
						}
	
						// X-Requested-With header
						// For cross-domain requests, seeing as conditions for a preflight are
						// akin to a jigsaw puzzle, we simply never set it to be sure.
						// (it can always be set on a per-request basis or even using ajaxSetup)
						// For same-domain requests, won't change header if already provided.
						if ( !options.crossDomain && !headers[ "X-Requested-With" ] ) {
							headers[ "X-Requested-With" ] = "XMLHttpRequest";
						}
	
						// Set headers
						for ( i in headers ) {
	
							// Support: IE<9
							// IE's ActiveXObject throws a 'Type Mismatch' exception when setting
							// request header to a null-value.
							//
							// To keep consistent with other XHR implementations, cast the value
							// to string and ignore `undefined`.
							if ( headers[ i ] !== undefined ) {
								xhr.setRequestHeader( i, headers[ i ] + "" );
							}
						}
	
						// Do send the request
						// This may raise an exception which is actually
						// handled in jQuery.ajax (so no try/catch here)
						xhr.send( ( options.hasContent && options.data ) || null );
	
						// Listener
						callback = function( _, isAbort ) {
							var status, statusText, responses;
	
							// Was never called and is aborted or complete
							if ( callback && ( isAbort || xhr.readyState === 4 ) ) {
	
								// Clean up
								delete xhrCallbacks[ id ];
								callback = undefined;
								xhr.onreadystatechange = jQuery.noop;
	
								// Abort manually if needed
								if ( isAbort ) {
									if ( xhr.readyState !== 4 ) {
										xhr.abort();
									}
								} else {
									responses = {};
									status = xhr.status;
	
									// Support: IE<10
									// Accessing binary-data responseText throws an exception
									// (#11426)
									if ( typeof xhr.responseText === "string" ) {
										responses.text = xhr.responseText;
									}
	
									// Firefox throws an exception when accessing
									// statusText for faulty cross-domain requests
									try {
										statusText = xhr.statusText;
									} catch ( e ) {
	
										// We normalize with Webkit giving an empty statusText
										statusText = "";
									}
	
									// Filter status for non standard behaviors
	
									// If the request is local and we have data: assume a success
									// (success with no data won't get notified, that's the best we
									// can do given current implementations)
									if ( !status && options.isLocal && !options.crossDomain ) {
										status = responses.text ? 200 : 404;
	
									// IE - #1450: sometimes returns 1223 when it should be 204
									} else if ( status === 1223 ) {
										status = 204;
									}
								}
							}
	
							// Call complete if needed
							if ( responses ) {
								complete( status, statusText, responses, xhr.getAllResponseHeaders() );
							}
						};
	
						// Do send the request
						// `xhr.send` may raise an exception, but it will be
						// handled in jQuery.ajax (so no try/catch here)
						if ( !options.async ) {
	
							// If we're in sync mode we fire the callback
							callback();
						} else if ( xhr.readyState === 4 ) {
	
							// (IE6 & IE7) if it's in cache and has been
							// retrieved directly we need to fire the callback
							window.setTimeout( callback );
						} else {
	
							// Register the callback, but delay it in case `xhr.send` throws
							// Add to the list of active xhr callbacks
							xhr.onreadystatechange = xhrCallbacks[ id ] = callback;
						}
					},
	
					abort: function() {
						if ( callback ) {
							callback( undefined, true );
						}
					}
				};
			}
		} );
	}
	
	// Functions to create xhrs
	function createStandardXHR() {
		try {
			return new window.XMLHttpRequest();
		} catch ( e ) {}
	}
	
	function createActiveXHR() {
		try {
			return new window.ActiveXObject( "Microsoft.XMLHTTP" );
		} catch ( e ) {}
	}
	
	
	
	
	// Install script dataType
	jQuery.ajaxSetup( {
		accepts: {
			script: "text/javascript, application/javascript, " +
				"application/ecmascript, application/x-ecmascript"
		},
		contents: {
			script: /\b(?:java|ecma)script\b/
		},
		converters: {
			"text script": function( text ) {
				jQuery.globalEval( text );
				return text;
			}
		}
	} );
	
	// Handle cache's special case and global
	jQuery.ajaxPrefilter( "script", function( s ) {
		if ( s.cache === undefined ) {
			s.cache = false;
		}
		if ( s.crossDomain ) {
			s.type = "GET";
			s.global = false;
		}
	} );
	
	// Bind script tag hack transport
	jQuery.ajaxTransport( "script", function( s ) {
	
		// This transport only deals with cross domain requests
		if ( s.crossDomain ) {
	
			var script,
				head = document.head || jQuery( "head" )[ 0 ] || document.documentElement;
	
			return {
	
				send: function( _, callback ) {
	
					script = document.createElement( "script" );
	
					script.async = true;
	
					if ( s.scriptCharset ) {
						script.charset = s.scriptCharset;
					}
	
					script.src = s.url;
	
					// Attach handlers for all browsers
					script.onload = script.onreadystatechange = function( _, isAbort ) {
	
						if ( isAbort || !script.readyState || /loaded|complete/.test( script.readyState ) ) {
	
							// Handle memory leak in IE
							script.onload = script.onreadystatechange = null;
	
							// Remove the script
							if ( script.parentNode ) {
								script.parentNode.removeChild( script );
							}
	
							// Dereference the script
							script = null;
	
							// Callback if not abort
							if ( !isAbort ) {
								callback( 200, "success" );
							}
						}
					};
	
					// Circumvent IE6 bugs with base elements (#2709 and #4378) by prepending
					// Use native DOM manipulation to avoid our domManip AJAX trickery
					head.insertBefore( script, head.firstChild );
				},
	
				abort: function() {
					if ( script ) {
						script.onload( undefined, true );
					}
				}
			};
		}
	} );
	
	
	
	
	var oldCallbacks = [],
		rjsonp = /(=)\?(?=&|$)|\?\?/;
	
	// Default jsonp settings
	jQuery.ajaxSetup( {
		jsonp: "callback",
		jsonpCallback: function() {
			var callback = oldCallbacks.pop() || ( jQuery.expando + "_" + ( nonce++ ) );
			this[ callback ] = true;
			return callback;
		}
	} );
	
	// Detect, normalize options and install callbacks for jsonp requests
	jQuery.ajaxPrefilter( "json jsonp", function( s, originalSettings, jqXHR ) {
	
		var callbackName, overwritten, responseContainer,
			jsonProp = s.jsonp !== false && ( rjsonp.test( s.url ) ?
				"url" :
				typeof s.data === "string" &&
					( s.contentType || "" )
						.indexOf( "application/x-www-form-urlencoded" ) === 0 &&
					rjsonp.test( s.data ) && "data"
			);
	
		// Handle iff the expected data type is "jsonp" or we have a parameter to set
		if ( jsonProp || s.dataTypes[ 0 ] === "jsonp" ) {
	
			// Get callback name, remembering preexisting value associated with it
			callbackName = s.jsonpCallback = jQuery.isFunction( s.jsonpCallback ) ?
				s.jsonpCallback() :
				s.jsonpCallback;
	
			// Insert callback into url or form data
			if ( jsonProp ) {
				s[ jsonProp ] = s[ jsonProp ].replace( rjsonp, "$1" + callbackName );
			} else if ( s.jsonp !== false ) {
				s.url += ( rquery.test( s.url ) ? "&" : "?" ) + s.jsonp + "=" + callbackName;
			}
	
			// Use data converter to retrieve json after script execution
			s.converters[ "script json" ] = function() {
				if ( !responseContainer ) {
					jQuery.error( callbackName + " was not called" );
				}
				return responseContainer[ 0 ];
			};
	
			// force json dataType
			s.dataTypes[ 0 ] = "json";
	
			// Install callback
			overwritten = window[ callbackName ];
			window[ callbackName ] = function() {
				responseContainer = arguments;
			};
	
			// Clean-up function (fires after converters)
			jqXHR.always( function() {
	
				// If previous value didn't exist - remove it
				if ( overwritten === undefined ) {
					jQuery( window ).removeProp( callbackName );
	
				// Otherwise restore preexisting value
				} else {
					window[ callbackName ] = overwritten;
				}
	
				// Save back as free
				if ( s[ callbackName ] ) {
	
					// make sure that re-using the options doesn't screw things around
					s.jsonpCallback = originalSettings.jsonpCallback;
	
					// save the callback name for future use
					oldCallbacks.push( callbackName );
				}
	
				// Call if it was a function and we have a response
				if ( responseContainer && jQuery.isFunction( overwritten ) ) {
					overwritten( responseContainer[ 0 ] );
				}
	
				responseContainer = overwritten = undefined;
			} );
	
			// Delegate to script
			return "script";
		}
	} );
	
	
	
	
	// data: string of html
	// context (optional): If specified, the fragment will be created in this context,
	// defaults to document
	// keepScripts (optional): If true, will include scripts passed in the html string
	jQuery.parseHTML = function( data, context, keepScripts ) {
		if ( !data || typeof data !== "string" ) {
			return null;
		}
		if ( typeof context === "boolean" ) {
			keepScripts = context;
			context = false;
		}
		context = context || document;
	
		var parsed = rsingleTag.exec( data ),
			scripts = !keepScripts && [];
	
		// Single tag
		if ( parsed ) {
			return [ context.createElement( parsed[ 1 ] ) ];
		}
	
		parsed = buildFragment( [ data ], context, scripts );
	
		if ( scripts && scripts.length ) {
			jQuery( scripts ).remove();
		}
	
		return jQuery.merge( [], parsed.childNodes );
	};
	
	
	// Keep a copy of the old load method
	var _load = jQuery.fn.load;
	
	/**
	 * Load a url into a page
	 */
	jQuery.fn.load = function( url, params, callback ) {
		if ( typeof url !== "string" && _load ) {
			return _load.apply( this, arguments );
		}
	
		var selector, type, response,
			self = this,
			off = url.indexOf( " " );
	
		if ( off > -1 ) {
			selector = jQuery.trim( url.slice( off, url.length ) );
			url = url.slice( 0, off );
		}
	
		// If it's a function
		if ( jQuery.isFunction( params ) ) {
	
			// We assume that it's the callback
			callback = params;
			params = undefined;
	
		// Otherwise, build a param string
		} else if ( params && typeof params === "object" ) {
			type = "POST";
		}
	
		// If we have elements to modify, make the request
		if ( self.length > 0 ) {
			jQuery.ajax( {
				url: url,
	
				// If "type" variable is undefined, then "GET" method will be used.
				// Make value of this field explicit since
				// user can override it through ajaxSetup method
				type: type || "GET",
				dataType: "html",
				data: params
			} ).done( function( responseText ) {
	
				// Save response for use in complete callback
				response = arguments;
	
				self.html( selector ?
	
					// If a selector was specified, locate the right elements in a dummy div
					// Exclude scripts to avoid IE 'Permission Denied' errors
					jQuery( "<div>" ).append( jQuery.parseHTML( responseText ) ).find( selector ) :
	
					// Otherwise use the full result
					responseText );
	
			// If the request succeeds, this function gets "data", "status", "jqXHR"
			// but they are ignored because response was set above.
			// If it fails, this function gets "jqXHR", "status", "error"
			} ).always( callback && function( jqXHR, status ) {
				self.each( function() {
					callback.apply( this, response || [ jqXHR.responseText, status, jqXHR ] );
				} );
			} );
		}
	
		return this;
	};
	
	
	
	
	// Attach a bunch of functions for handling common AJAX events
	jQuery.each( [
		"ajaxStart",
		"ajaxStop",
		"ajaxComplete",
		"ajaxError",
		"ajaxSuccess",
		"ajaxSend"
	], function( i, type ) {
		jQuery.fn[ type ] = function( fn ) {
			return this.on( type, fn );
		};
	} );
	
	
	
	
	jQuery.expr.filters.animated = function( elem ) {
		return jQuery.grep( jQuery.timers, function( fn ) {
			return elem === fn.elem;
		} ).length;
	};
	
	
	
	
	
	/**
	 * Gets a window from an element
	 */
	function getWindow( elem ) {
		return jQuery.isWindow( elem ) ?
			elem :
			elem.nodeType === 9 ?
				elem.defaultView || elem.parentWindow :
				false;
	}
	
	jQuery.offset = {
		setOffset: function( elem, options, i ) {
			var curPosition, curLeft, curCSSTop, curTop, curOffset, curCSSLeft, calculatePosition,
				position = jQuery.css( elem, "position" ),
				curElem = jQuery( elem ),
				props = {};
	
			// set position first, in-case top/left are set even on static elem
			if ( position === "static" ) {
				elem.style.position = "relative";
			}
	
			curOffset = curElem.offset();
			curCSSTop = jQuery.css( elem, "top" );
			curCSSLeft = jQuery.css( elem, "left" );
			calculatePosition = ( position === "absolute" || position === "fixed" ) &&
				jQuery.inArray( "auto", [ curCSSTop, curCSSLeft ] ) > -1;
	
			// need to be able to calculate position if either top or left
			// is auto and position is either absolute or fixed
			if ( calculatePosition ) {
				curPosition = curElem.position();
				curTop = curPosition.top;
				curLeft = curPosition.left;
			} else {
				curTop = parseFloat( curCSSTop ) || 0;
				curLeft = parseFloat( curCSSLeft ) || 0;
			}
	
			if ( jQuery.isFunction( options ) ) {
	
				// Use jQuery.extend here to allow modification of coordinates argument (gh-1848)
				options = options.call( elem, i, jQuery.extend( {}, curOffset ) );
			}
	
			if ( options.top != null ) {
				props.top = ( options.top - curOffset.top ) + curTop;
			}
			if ( options.left != null ) {
				props.left = ( options.left - curOffset.left ) + curLeft;
			}
	
			if ( "using" in options ) {
				options.using.call( elem, props );
			} else {
				curElem.css( props );
			}
		}
	};
	
	jQuery.fn.extend( {
		offset: function( options ) {
			if ( arguments.length ) {
				return options === undefined ?
					this :
					this.each( function( i ) {
						jQuery.offset.setOffset( this, options, i );
					} );
			}
	
			var docElem, win,
				box = { top: 0, left: 0 },
				elem = this[ 0 ],
				doc = elem && elem.ownerDocument;
	
			if ( !doc ) {
				return;
			}
	
			docElem = doc.documentElement;
	
			// Make sure it's not a disconnected DOM node
			if ( !jQuery.contains( docElem, elem ) ) {
				return box;
			}
	
			// If we don't have gBCR, just use 0,0 rather than error
			// BlackBerry 5, iOS 3 (original iPhone)
			if ( typeof elem.getBoundingClientRect !== "undefined" ) {
				box = elem.getBoundingClientRect();
			}
			win = getWindow( doc );
			return {
				top: box.top  + ( win.pageYOffset || docElem.scrollTop )  - ( docElem.clientTop  || 0 ),
				left: box.left + ( win.pageXOffset || docElem.scrollLeft ) - ( docElem.clientLeft || 0 )
			};
		},
	
		position: function() {
			if ( !this[ 0 ] ) {
				return;
			}
	
			var offsetParent, offset,
				parentOffset = { top: 0, left: 0 },
				elem = this[ 0 ];
	
			// Fixed elements are offset from window (parentOffset = {top:0, left: 0},
			// because it is its only offset parent
			if ( jQuery.css( elem, "position" ) === "fixed" ) {
	
				// we assume that getBoundingClientRect is available when computed position is fixed
				offset = elem.getBoundingClientRect();
			} else {
	
				// Get *real* offsetParent
				offsetParent = this.offsetParent();
	
				// Get correct offsets
				offset = this.offset();
				if ( !jQuery.nodeName( offsetParent[ 0 ], "html" ) ) {
					parentOffset = offsetParent.offset();
				}
	
				// Add offsetParent borders
				parentOffset.top  += jQuery.css( offsetParent[ 0 ], "borderTopWidth", true );
				parentOffset.left += jQuery.css( offsetParent[ 0 ], "borderLeftWidth", true );
			}
	
			// Subtract parent offsets and element margins
			// note: when an element has margin: auto the offsetLeft and marginLeft
			// are the same in Safari causing offset.left to incorrectly be 0
			return {
				top:  offset.top  - parentOffset.top - jQuery.css( elem, "marginTop", true ),
				left: offset.left - parentOffset.left - jQuery.css( elem, "marginLeft", true )
			};
		},
	
		offsetParent: function() {
			return this.map( function() {
				var offsetParent = this.offsetParent;
	
				while ( offsetParent && ( !jQuery.nodeName( offsetParent, "html" ) &&
					jQuery.css( offsetParent, "position" ) === "static" ) ) {
					offsetParent = offsetParent.offsetParent;
				}
				return offsetParent || documentElement;
			} );
		}
	} );
	
	// Create scrollLeft and scrollTop methods
	jQuery.each( { scrollLeft: "pageXOffset", scrollTop: "pageYOffset" }, function( method, prop ) {
		var top = /Y/.test( prop );
	
		jQuery.fn[ method ] = function( val ) {
			return access( this, function( elem, method, val ) {
				var win = getWindow( elem );
	
				if ( val === undefined ) {
					return win ? ( prop in win ) ? win[ prop ] :
						win.document.documentElement[ method ] :
						elem[ method ];
				}
	
				if ( win ) {
					win.scrollTo(
						!top ? val : jQuery( win ).scrollLeft(),
						top ? val : jQuery( win ).scrollTop()
					);
	
				} else {
					elem[ method ] = val;
				}
			}, method, val, arguments.length, null );
		};
	} );
	
	// Support: Safari<7-8+, Chrome<37-44+
	// Add the top/left cssHooks using jQuery.fn.position
	// Webkit bug: https://bugs.webkit.org/show_bug.cgi?id=29084
	// getComputedStyle returns percent when specified for top/left/bottom/right
	// rather than make the css module depend on the offset module, we just check for it here
	jQuery.each( [ "top", "left" ], function( i, prop ) {
		jQuery.cssHooks[ prop ] = addGetHookIf( support.pixelPosition,
			function( elem, computed ) {
				if ( computed ) {
					computed = curCSS( elem, prop );
	
					// if curCSS returns percentage, fallback to offset
					return rnumnonpx.test( computed ) ?
						jQuery( elem ).position()[ prop ] + "px" :
						computed;
				}
			}
		);
	} );
	
	
	// Create innerHeight, innerWidth, height, width, outerHeight and outerWidth methods
	jQuery.each( { Height: "height", Width: "width" }, function( name, type ) {
		jQuery.each( { padding: "inner" + name, content: type, "": "outer" + name },
		function( defaultExtra, funcName ) {
	
			// margin is only for outerHeight, outerWidth
			jQuery.fn[ funcName ] = function( margin, value ) {
				var chainable = arguments.length && ( defaultExtra || typeof margin !== "boolean" ),
					extra = defaultExtra || ( margin === true || value === true ? "margin" : "border" );
	
				return access( this, function( elem, type, value ) {
					var doc;
	
					if ( jQuery.isWindow( elem ) ) {
	
						// As of 5/8/2012 this will yield incorrect results for Mobile Safari, but there
						// isn't a whole lot we can do. See pull request at this URL for discussion:
						// https://github.com/jquery/jquery/pull/764
						return elem.document.documentElement[ "client" + name ];
					}
	
					// Get document width or height
					if ( elem.nodeType === 9 ) {
						doc = elem.documentElement;
	
						// Either scroll[Width/Height] or offset[Width/Height] or client[Width/Height],
						// whichever is greatest
						// unfortunately, this causes bug #3838 in IE6/8 only,
						// but there is currently no good, small way to fix it.
						return Math.max(
							elem.body[ "scroll" + name ], doc[ "scroll" + name ],
							elem.body[ "offset" + name ], doc[ "offset" + name ],
							doc[ "client" + name ]
						);
					}
	
					return value === undefined ?
	
						// Get width or height on the element, requesting but not forcing parseFloat
						jQuery.css( elem, type, extra ) :
	
						// Set width or height on the element
						jQuery.style( elem, type, value, extra );
				}, type, chainable ? margin : undefined, chainable, null );
			};
		} );
	} );
	
	
	jQuery.fn.extend( {
	
		bind: function( types, data, fn ) {
			return this.on( types, null, data, fn );
		},
		unbind: function( types, fn ) {
			return this.off( types, null, fn );
		},
	
		delegate: function( selector, types, data, fn ) {
			return this.on( types, selector, data, fn );
		},
		undelegate: function( selector, types, fn ) {
	
			// ( namespace ) or ( selector, types [, fn] )
			return arguments.length === 1 ?
				this.off( selector, "**" ) :
				this.off( types, selector || "**", fn );
		}
	} );
	
	// The number of elements contained in the matched element set
	jQuery.fn.size = function() {
		return this.length;
	};
	
	jQuery.fn.andSelf = jQuery.fn.addBack;
	
	
	
	
	// Register as a named AMD module, since jQuery can be concatenated with other
	// files that may use define, but not via a proper concatenation script that
	// understands anonymous AMD modules. A named AMD is safest and most robust
	// way to register. Lowercase jquery is used because AMD module names are
	// derived from file names, and jQuery is normally delivered in a lowercase
	// file name. Do this after creating the global so that if an AMD module wants
	// to call noConflict to hide this version of jQuery, it will work.
	
	// Note that for maximum portability, libraries that are not jQuery should
	// declare themselves as anonymous modules, and avoid setting a global if an
	// AMD loader is present. jQuery is a special case. For more information, see
	// https://github.com/jrburke/requirejs/wiki/Updating-existing-libraries#wiki-anon
	
	if ( true ) {
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function() {
			return jQuery;
		}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	}
	
	
	
	var
	
		// Map over jQuery in case of overwrite
		_jQuery = window.jQuery,
	
		// Map over the $ in case of overwrite
		_$ = window.$;
	
	jQuery.noConflict = function( deep ) {
		if ( window.$ === jQuery ) {
			window.$ = _$;
		}
	
		if ( deep && window.jQuery === jQuery ) {
			window.jQuery = _jQuery;
		}
	
		return jQuery;
	};
	
	// Expose jQuery and $ identifiers, even in
	// AMD (#7102#comment:10, https://github.com/jquery/jquery/pull/557)
	// and CommonJS for browser emulators (#13566)
	if ( !noGlobal ) {
		window.jQuery = window.$ = jQuery;
	}
	
	return jQuery;
	}));


/***/ },
/* 161 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * lodash 3.2.0 (Custom Build) <https://lodash.com/>
	 * Build: `lodash modern modularize exports="npm" -o ./`
	 * Copyright 2012-2015 The Dojo Foundation <http://dojofoundation.org/>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 * Available under MIT license <https://lodash.com/license>
	 */
	var baseCopy = __webpack_require__(162),
	    keys = __webpack_require__(82);
	
	/**
	 * The base implementation of `_.assign` without support for argument juggling,
	 * multiple sources, and `customizer` functions.
	 *
	 * @private
	 * @param {Object} object The destination object.
	 * @param {Object} source The source object.
	 * @returns {Object} Returns `object`.
	 */
	function baseAssign(object, source) {
	  return source == null
	    ? object
	    : baseCopy(source, keys(source), object);
	}
	
	module.exports = baseAssign;


/***/ },
/* 162 */
/***/ function(module, exports) {

	/**
	 * lodash 3.0.1 (Custom Build) <https://lodash.com/>
	 * Build: `lodash modern modularize exports="npm" -o ./`
	 * Copyright 2012-2015 The Dojo Foundation <http://dojofoundation.org/>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 * Available under MIT license <https://lodash.com/license>
	 */
	
	/**
	 * Copies properties of `source` to `object`.
	 *
	 * @private
	 * @param {Object} source The object to copy properties from.
	 * @param {Array} props The property names to copy.
	 * @param {Object} [object={}] The object to copy properties to.
	 * @returns {Object} Returns `object`.
	 */
	function baseCopy(source, props, object) {
	  object || (object = {});
	
	  var index = -1,
	      length = props.length;
	
	  while (++index < length) {
	    var key = props[index];
	    object[key] = source[key];
	  }
	  return object;
	}
	
	module.exports = baseCopy;


/***/ },
/* 163 */
/***/ function(module, exports) {

	/**
	 * lodash 3.0.1 (Custom Build) <https://lodash.com/>
	 * Build: `lodash modern modularize exports="npm" -o ./`
	 * Copyright 2012-2015 The Dojo Foundation <http://dojofoundation.org/>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 * Available under MIT license <https://lodash.com/license>
	 */
	
	/**
	 * A specialized version of `baseCallback` which only supports `this` binding
	 * and specifying the number of arguments to provide to `func`.
	 *
	 * @private
	 * @param {Function} func The function to bind.
	 * @param {*} thisArg The `this` binding of `func`.
	 * @param {number} [argCount] The number of arguments to provide to `func`.
	 * @returns {Function} Returns the callback.
	 */
	function bindCallback(func, thisArg, argCount) {
	  if (typeof func != 'function') {
	    return identity;
	  }
	  if (thisArg === undefined) {
	    return func;
	  }
	  switch (argCount) {
	    case 1: return function(value) {
	      return func.call(thisArg, value);
	    };
	    case 3: return function(value, index, collection) {
	      return func.call(thisArg, value, index, collection);
	    };
	    case 4: return function(accumulator, value, index, collection) {
	      return func.call(thisArg, accumulator, value, index, collection);
	    };
	    case 5: return function(value, other, key, object, source) {
	      return func.call(thisArg, value, other, key, object, source);
	    };
	  }
	  return function() {
	    return func.apply(thisArg, arguments);
	  };
	}
	
	/**
	 * This method returns the first argument provided to it.
	 *
	 * @static
	 * @memberOf _
	 * @category Utility
	 * @param {*} value Any value.
	 * @returns {*} Returns `value`.
	 * @example
	 *
	 * var object = { 'user': 'fred' };
	 *
	 * _.identity(object) === object;
	 * // => true
	 */
	function identity(value) {
	  return value;
	}
	
	module.exports = bindCallback;


/***/ },
/* 164 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * lodash 3.1.1 (Custom Build) <https://lodash.com/>
	 * Build: `lodash modern modularize exports="npm" -o ./`
	 * Copyright 2012-2015 The Dojo Foundation <http://dojofoundation.org/>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 * Available under MIT license <https://lodash.com/license>
	 */
	var bindCallback = __webpack_require__(163),
	    isIterateeCall = __webpack_require__(166),
	    restParam = __webpack_require__(169);
	
	/**
	 * Creates a function that assigns properties of source object(s) to a given
	 * destination object.
	 *
	 * **Note:** This function is used to create `_.assign`, `_.defaults`, and `_.merge`.
	 *
	 * @private
	 * @param {Function} assigner The function to assign values.
	 * @returns {Function} Returns the new assigner function.
	 */
	function createAssigner(assigner) {
	  return restParam(function(object, sources) {
	    var index = -1,
	        length = object == null ? 0 : sources.length,
	        customizer = length > 2 ? sources[length - 2] : undefined,
	        guard = length > 2 ? sources[2] : undefined,
	        thisArg = length > 1 ? sources[length - 1] : undefined;
	
	    if (typeof customizer == 'function') {
	      customizer = bindCallback(customizer, thisArg, 5);
	      length -= 2;
	    } else {
	      customizer = typeof thisArg == 'function' ? thisArg : undefined;
	      length -= (customizer ? 1 : 0);
	    }
	    if (guard && isIterateeCall(sources[0], sources[1], guard)) {
	      customizer = length < 3 ? undefined : customizer;
	      length = 1;
	    }
	    while (++index < length) {
	      var source = sources[index];
	      if (source) {
	        assigner(object, source, customizer);
	      }
	    }
	    return object;
	  });
	}
	
	module.exports = createAssigner;


/***/ },
/* 165 */
/***/ function(module, exports) {

	/**
	 * lodash 3.9.1 (Custom Build) <https://lodash.com/>
	 * Build: `lodash modern modularize exports="npm" -o ./`
	 * Copyright 2012-2015 The Dojo Foundation <http://dojofoundation.org/>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 * Available under MIT license <https://lodash.com/license>
	 */
	
	/** `Object#toString` result references. */
	var funcTag = '[object Function]';
	
	/** Used to detect host constructors (Safari > 5). */
	var reIsHostCtor = /^\[object .+?Constructor\]$/;
	
	/**
	 * Checks if `value` is object-like.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 */
	function isObjectLike(value) {
	  return !!value && typeof value == 'object';
	}
	
	/** Used for native method references. */
	var objectProto = Object.prototype;
	
	/** Used to resolve the decompiled source of functions. */
	var fnToString = Function.prototype.toString;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Used to resolve the [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objToString = objectProto.toString;
	
	/** Used to detect if a method is native. */
	var reIsNative = RegExp('^' +
	  fnToString.call(hasOwnProperty).replace(/[\\^$.*+?()[\]{}|]/g, '\\$&')
	  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
	);
	
	/**
	 * Gets the native function at `key` of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {string} key The key of the method to get.
	 * @returns {*} Returns the function if it's native, else `undefined`.
	 */
	function getNative(object, key) {
	  var value = object == null ? undefined : object[key];
	  return isNative(value) ? value : undefined;
	}
	
	/**
	 * Checks if `value` is classified as a `Function` object.
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
	 * @example
	 *
	 * _.isFunction(_);
	 * // => true
	 *
	 * _.isFunction(/abc/);
	 * // => false
	 */
	function isFunction(value) {
	  // The use of `Object#toString` avoids issues with the `typeof` operator
	  // in older versions of Chrome and Safari which return 'function' for regexes
	  // and Safari 8 equivalents which return 'object' for typed array constructors.
	  return isObject(value) && objToString.call(value) == funcTag;
	}
	
	/**
	 * Checks if `value` is the [language type](https://es5.github.io/#x8) of `Object`.
	 * (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(1);
	 * // => false
	 */
	function isObject(value) {
	  // Avoid a V8 JIT bug in Chrome 19-20.
	  // See https://code.google.com/p/v8/issues/detail?id=2291 for more details.
	  var type = typeof value;
	  return !!value && (type == 'object' || type == 'function');
	}
	
	/**
	 * Checks if `value` is a native function.
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a native function, else `false`.
	 * @example
	 *
	 * _.isNative(Array.prototype.push);
	 * // => true
	 *
	 * _.isNative(_);
	 * // => false
	 */
	function isNative(value) {
	  if (value == null) {
	    return false;
	  }
	  if (isFunction(value)) {
	    return reIsNative.test(fnToString.call(value));
	  }
	  return isObjectLike(value) && reIsHostCtor.test(value);
	}
	
	module.exports = getNative;


/***/ },
/* 166 */
/***/ function(module, exports) {

	/**
	 * lodash 3.0.9 (Custom Build) <https://lodash.com/>
	 * Build: `lodash modern modularize exports="npm" -o ./`
	 * Copyright 2012-2015 The Dojo Foundation <http://dojofoundation.org/>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 * Available under MIT license <https://lodash.com/license>
	 */
	
	/** Used to detect unsigned integer values. */
	var reIsUint = /^\d+$/;
	
	/**
	 * Used as the [maximum length](https://people.mozilla.org/~jorendorff/es6-draft.html#sec-number.max_safe_integer)
	 * of an array-like value.
	 */
	var MAX_SAFE_INTEGER = 9007199254740991;
	
	/**
	 * The base implementation of `_.property` without support for deep paths.
	 *
	 * @private
	 * @param {string} key The key of the property to get.
	 * @returns {Function} Returns the new function.
	 */
	function baseProperty(key) {
	  return function(object) {
	    return object == null ? undefined : object[key];
	  };
	}
	
	/**
	 * Gets the "length" property value of `object`.
	 *
	 * **Note:** This function is used to avoid a [JIT bug](https://bugs.webkit.org/show_bug.cgi?id=142792)
	 * that affects Safari on at least iOS 8.1-8.3 ARM64.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {*} Returns the "length" value.
	 */
	var getLength = baseProperty('length');
	
	/**
	 * Checks if `value` is array-like.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
	 */
	function isArrayLike(value) {
	  return value != null && isLength(getLength(value));
	}
	
	/**
	 * Checks if `value` is a valid array-like index.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
	 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
	 */
	function isIndex(value, length) {
	  value = (typeof value == 'number' || reIsUint.test(value)) ? +value : -1;
	  length = length == null ? MAX_SAFE_INTEGER : length;
	  return value > -1 && value % 1 == 0 && value < length;
	}
	
	/**
	 * Checks if the provided arguments are from an iteratee call.
	 *
	 * @private
	 * @param {*} value The potential iteratee value argument.
	 * @param {*} index The potential iteratee index or key argument.
	 * @param {*} object The potential iteratee object argument.
	 * @returns {boolean} Returns `true` if the arguments are from an iteratee call, else `false`.
	 */
	function isIterateeCall(value, index, object) {
	  if (!isObject(object)) {
	    return false;
	  }
	  var type = typeof index;
	  if (type == 'number'
	      ? (isArrayLike(object) && isIndex(index, object.length))
	      : (type == 'string' && index in object)) {
	    var other = object[index];
	    return value === value ? (value === other) : (other !== other);
	  }
	  return false;
	}
	
	/**
	 * Checks if `value` is a valid array-like length.
	 *
	 * **Note:** This function is based on [`ToLength`](https://people.mozilla.org/~jorendorff/es6-draft.html#sec-tolength).
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
	 */
	function isLength(value) {
	  return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
	}
	
	/**
	 * Checks if `value` is the [language type](https://es5.github.io/#x8) of `Object`.
	 * (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(1);
	 * // => false
	 */
	function isObject(value) {
	  // Avoid a V8 JIT bug in Chrome 19-20.
	  // See https://code.google.com/p/v8/issues/detail?id=2291 for more details.
	  var type = typeof value;
	  return !!value && (type == 'object' || type == 'function');
	}
	
	module.exports = isIterateeCall;


/***/ },
/* 167 */
/***/ function(module, exports) {

	/**
	 * lodash (Custom Build) <https://lodash.com/>
	 * Build: `lodash modularize exports="npm" -o ./`
	 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
	 * Released under MIT license <https://lodash.com/license>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 */
	
	/** Used as references for various `Number` constants. */
	var MAX_SAFE_INTEGER = 9007199254740991;
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]',
	    funcTag = '[object Function]',
	    genTag = '[object GeneratorFunction]';
	
	/**
	 * The base implementation of `_.property` without support for deep paths.
	 *
	 * @private
	 * @param {string} key The key of the property to get.
	 * @returns {Function} Returns the new accessor function.
	 */
	function baseProperty(key) {
	  return function(object) {
	    return object == null ? undefined : object[key];
	  };
	}
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objectToString = objectProto.toString;
	
	/** Built-in value references. */
	var propertyIsEnumerable = objectProto.propertyIsEnumerable;
	
	/**
	 * Gets the "length" property value of `object`.
	 *
	 * **Note:** This function is used to avoid a
	 * [JIT bug](https://bugs.webkit.org/show_bug.cgi?id=142792) that affects
	 * Safari on at least iOS 8.1-8.3 ARM64.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {*} Returns the "length" value.
	 */
	var getLength = baseProperty('length');
	
	/**
	 * Checks if `value` is likely an `arguments` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	 *  else `false`.
	 * @example
	 *
	 * _.isArguments(function() { return arguments; }());
	 * // => true
	 *
	 * _.isArguments([1, 2, 3]);
	 * // => false
	 */
	function isArguments(value) {
	  // Safari 8.1 incorrectly makes `arguments.callee` enumerable in strict mode.
	  return isArrayLikeObject(value) && hasOwnProperty.call(value, 'callee') &&
	    (!propertyIsEnumerable.call(value, 'callee') || objectToString.call(value) == argsTag);
	}
	
	/**
	 * Checks if `value` is array-like. A value is considered array-like if it's
	 * not a function and has a `value.length` that's an integer greater than or
	 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
	 * @example
	 *
	 * _.isArrayLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isArrayLike(document.body.children);
	 * // => true
	 *
	 * _.isArrayLike('abc');
	 * // => true
	 *
	 * _.isArrayLike(_.noop);
	 * // => false
	 */
	function isArrayLike(value) {
	  return value != null && isLength(getLength(value)) && !isFunction(value);
	}
	
	/**
	 * This method is like `_.isArrayLike` except that it also checks if `value`
	 * is an object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an array-like object,
	 *  else `false`.
	 * @example
	 *
	 * _.isArrayLikeObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isArrayLikeObject(document.body.children);
	 * // => true
	 *
	 * _.isArrayLikeObject('abc');
	 * // => false
	 *
	 * _.isArrayLikeObject(_.noop);
	 * // => false
	 */
	function isArrayLikeObject(value) {
	  return isObjectLike(value) && isArrayLike(value);
	}
	
	/**
	 * Checks if `value` is classified as a `Function` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
	 * @example
	 *
	 * _.isFunction(_);
	 * // => true
	 *
	 * _.isFunction(/abc/);
	 * // => false
	 */
	function isFunction(value) {
	  // The use of `Object#toString` avoids issues with the `typeof` operator
	  // in Safari 8 which returns 'object' for typed array and weak map constructors,
	  // and PhantomJS 1.9 which returns 'function' for `NodeList` instances.
	  var tag = isObject(value) ? objectToString.call(value) : '';
	  return tag == funcTag || tag == genTag;
	}
	
	/**
	 * Checks if `value` is a valid array-like length.
	 *
	 * **Note:** This function is loosely based on
	 * [`ToLength`](http://ecma-international.org/ecma-262/6.0/#sec-tolength).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a valid length,
	 *  else `false`.
	 * @example
	 *
	 * _.isLength(3);
	 * // => true
	 *
	 * _.isLength(Number.MIN_VALUE);
	 * // => false
	 *
	 * _.isLength(Infinity);
	 * // => false
	 *
	 * _.isLength('3');
	 * // => false
	 */
	function isLength(value) {
	  return typeof value == 'number' &&
	    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
	}
	
	/**
	 * Checks if `value` is the
	 * [language type](http://www.ecma-international.org/ecma-262/6.0/#sec-ecmascript-language-types)
	 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(_.noop);
	 * // => true
	 *
	 * _.isObject(null);
	 * // => false
	 */
	function isObject(value) {
	  var type = typeof value;
	  return !!value && (type == 'object' || type == 'function');
	}
	
	/**
	 * Checks if `value` is object-like. A value is object-like if it's not `null`
	 * and has a `typeof` result of "object".
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 * @example
	 *
	 * _.isObjectLike({});
	 * // => true
	 *
	 * _.isObjectLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isObjectLike(_.noop);
	 * // => false
	 *
	 * _.isObjectLike(null);
	 * // => false
	 */
	function isObjectLike(value) {
	  return !!value && typeof value == 'object';
	}
	
	module.exports = isArguments;


/***/ },
/* 168 */
/***/ function(module, exports) {

	/**
	 * lodash 3.0.4 (Custom Build) <https://lodash.com/>
	 * Build: `lodash modern modularize exports="npm" -o ./`
	 * Copyright 2012-2015 The Dojo Foundation <http://dojofoundation.org/>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 * Available under MIT license <https://lodash.com/license>
	 */
	
	/** `Object#toString` result references. */
	var arrayTag = '[object Array]',
	    funcTag = '[object Function]';
	
	/** Used to detect host constructors (Safari > 5). */
	var reIsHostCtor = /^\[object .+?Constructor\]$/;
	
	/**
	 * Checks if `value` is object-like.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 */
	function isObjectLike(value) {
	  return !!value && typeof value == 'object';
	}
	
	/** Used for native method references. */
	var objectProto = Object.prototype;
	
	/** Used to resolve the decompiled source of functions. */
	var fnToString = Function.prototype.toString;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Used to resolve the [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objToString = objectProto.toString;
	
	/** Used to detect if a method is native. */
	var reIsNative = RegExp('^' +
	  fnToString.call(hasOwnProperty).replace(/[\\^$.*+?()[\]{}|]/g, '\\$&')
	  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
	);
	
	/* Native method references for those with the same name as other `lodash` methods. */
	var nativeIsArray = getNative(Array, 'isArray');
	
	/**
	 * Used as the [maximum length](http://ecma-international.org/ecma-262/6.0/#sec-number.max_safe_integer)
	 * of an array-like value.
	 */
	var MAX_SAFE_INTEGER = 9007199254740991;
	
	/**
	 * Gets the native function at `key` of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {string} key The key of the method to get.
	 * @returns {*} Returns the function if it's native, else `undefined`.
	 */
	function getNative(object, key) {
	  var value = object == null ? undefined : object[key];
	  return isNative(value) ? value : undefined;
	}
	
	/**
	 * Checks if `value` is a valid array-like length.
	 *
	 * **Note:** This function is based on [`ToLength`](http://ecma-international.org/ecma-262/6.0/#sec-tolength).
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
	 */
	function isLength(value) {
	  return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
	}
	
	/**
	 * Checks if `value` is classified as an `Array` object.
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
	 * @example
	 *
	 * _.isArray([1, 2, 3]);
	 * // => true
	 *
	 * _.isArray(function() { return arguments; }());
	 * // => false
	 */
	var isArray = nativeIsArray || function(value) {
	  return isObjectLike(value) && isLength(value.length) && objToString.call(value) == arrayTag;
	};
	
	/**
	 * Checks if `value` is classified as a `Function` object.
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
	 * @example
	 *
	 * _.isFunction(_);
	 * // => true
	 *
	 * _.isFunction(/abc/);
	 * // => false
	 */
	function isFunction(value) {
	  // The use of `Object#toString` avoids issues with the `typeof` operator
	  // in older versions of Chrome and Safari which return 'function' for regexes
	  // and Safari 8 equivalents which return 'object' for typed array constructors.
	  return isObject(value) && objToString.call(value) == funcTag;
	}
	
	/**
	 * Checks if `value` is the [language type](https://es5.github.io/#x8) of `Object`.
	 * (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(1);
	 * // => false
	 */
	function isObject(value) {
	  // Avoid a V8 JIT bug in Chrome 19-20.
	  // See https://code.google.com/p/v8/issues/detail?id=2291 for more details.
	  var type = typeof value;
	  return !!value && (type == 'object' || type == 'function');
	}
	
	/**
	 * Checks if `value` is a native function.
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a native function, else `false`.
	 * @example
	 *
	 * _.isNative(Array.prototype.push);
	 * // => true
	 *
	 * _.isNative(_);
	 * // => false
	 */
	function isNative(value) {
	  if (value == null) {
	    return false;
	  }
	  if (isFunction(value)) {
	    return reIsNative.test(fnToString.call(value));
	  }
	  return isObjectLike(value) && reIsHostCtor.test(value);
	}
	
	module.exports = isArray;


/***/ },
/* 169 */
/***/ function(module, exports) {

	/**
	 * lodash 3.6.1 (Custom Build) <https://lodash.com/>
	 * Build: `lodash modern modularize exports="npm" -o ./`
	 * Copyright 2012-2015 The Dojo Foundation <http://dojofoundation.org/>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 * Available under MIT license <https://lodash.com/license>
	 */
	
	/** Used as the `TypeError` message for "Functions" methods. */
	var FUNC_ERROR_TEXT = 'Expected a function';
	
	/* Native method references for those with the same name as other `lodash` methods. */
	var nativeMax = Math.max;
	
	/**
	 * Creates a function that invokes `func` with the `this` binding of the
	 * created function and arguments from `start` and beyond provided as an array.
	 *
	 * **Note:** This method is based on the [rest parameter](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Functions/rest_parameters).
	 *
	 * @static
	 * @memberOf _
	 * @category Function
	 * @param {Function} func The function to apply a rest parameter to.
	 * @param {number} [start=func.length-1] The start position of the rest parameter.
	 * @returns {Function} Returns the new function.
	 * @example
	 *
	 * var say = _.restParam(function(what, names) {
	 *   return what + ' ' + _.initial(names).join(', ') +
	 *     (_.size(names) > 1 ? ', & ' : '') + _.last(names);
	 * });
	 *
	 * say('hello', 'fred', 'barney', 'pebbles');
	 * // => 'hello fred, barney, & pebbles'
	 */
	function restParam(func, start) {
	  if (typeof func != 'function') {
	    throw new TypeError(FUNC_ERROR_TEXT);
	  }
	  start = nativeMax(start === undefined ? (func.length - 1) : (+start || 0), 0);
	  return function() {
	    var args = arguments,
	        index = -1,
	        length = nativeMax(args.length - start, 0),
	        rest = Array(length);
	
	    while (++index < length) {
	      rest[index] = args[start + index];
	    }
	    switch (start) {
	      case 0: return func.call(this, rest);
	      case 1: return func.call(this, args[0], rest);
	      case 2: return func.call(this, args[0], args[1], rest);
	    }
	    var otherArgs = Array(start + 1);
	    index = -1;
	    while (++index < start) {
	      otherArgs[index] = args[index];
	    }
	    otherArgs[start] = rest;
	    return func.apply(this, otherArgs);
	  };
	}
	
	module.exports = restParam;


/***/ },
/* 170 */
/***/ function(module, exports, __webpack_require__) {

	var overArg = __webpack_require__(172);
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeGetPrototype = Object.getPrototypeOf;
	
	/**
	 * Gets the `[[Prototype]]` of `value`.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {null|Object} Returns the `[[Prototype]]`.
	 */
	var getPrototype = overArg(nativeGetPrototype, Object);
	
	module.exports = getPrototype;


/***/ },
/* 171 */
/***/ function(module, exports) {

	/**
	 * Checks if `value` is a host object in IE < 9.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a host object, else `false`.
	 */
	function isHostObject(value) {
	  // Many host objects are `Object` objects that can coerce to strings
	  // despite having improperly defined `toString` methods.
	  var result = false;
	  if (value != null && typeof value.toString != 'function') {
	    try {
	      result = !!(value + '');
	    } catch (e) {}
	  }
	  return result;
	}
	
	module.exports = isHostObject;


/***/ },
/* 172 */
/***/ function(module, exports) {

	/**
	 * Creates a function that invokes `func` with its first argument transformed.
	 *
	 * @private
	 * @param {Function} func The function to wrap.
	 * @param {Function} transform The argument transform.
	 * @returns {Function} Returns the new function.
	 */
	function overArg(func, transform) {
	  return function(arg) {
	    return func(transform(arg));
	  };
	}
	
	module.exports = overArg;


/***/ },
/* 173 */
/***/ function(module, exports) {

	/**
	 * Checks if `value` is object-like. A value is object-like if it's not `null`
	 * and has a `typeof` result of "object".
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 * @example
	 *
	 * _.isObjectLike({});
	 * // => true
	 *
	 * _.isObjectLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isObjectLike(_.noop);
	 * // => false
	 *
	 * _.isObjectLike(null);
	 * // => false
	 */
	function isObjectLike(value) {
	  return !!value && typeof value == 'object';
	}
	
	module.exports = isObjectLike;


/***/ },
/* 174 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(16);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _domAlign = __webpack_require__(142);
	
	var _domAlign2 = _interopRequireDefault(_domAlign);
	
	var _addEventListener = __webpack_require__(86);
	
	var _addEventListener2 = _interopRequireDefault(_addEventListener);
	
	var _isWindow = __webpack_require__(176);
	
	var _isWindow2 = _interopRequireDefault(_isWindow);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function buffer(fn, ms) {
	  var timer = void 0;
	
	  function clear() {
	    if (timer) {
	      clearTimeout(timer);
	      timer = null;
	    }
	  }
	
	  function bufferFn() {
	    clear();
	    timer = setTimeout(fn, ms);
	  }
	
	  bufferFn.clear = clear;
	
	  return bufferFn;
	}
	
	var Align = _react2["default"].createClass({
	  displayName: 'Align',
	
	  propTypes: {
	    childrenProps: _react.PropTypes.object,
	    align: _react.PropTypes.object.isRequired,
	    target: _react.PropTypes.func,
	    onAlign: _react.PropTypes.func,
	    monitorBufferTime: _react.PropTypes.number,
	    monitorWindowResize: _react.PropTypes.bool,
	    disabled: _react.PropTypes.bool,
	    children: _react.PropTypes.any
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      target: function target() {
	        return window;
	      },
	      onAlign: function onAlign() {},
	
	      monitorBufferTime: 50,
	      monitorWindowResize: false,
	      disabled: false
	    };
	  },
	  componentDidMount: function componentDidMount() {
	    var props = this.props;
	    // if parent ref not attached .... use document.getElementById
	    this.forceAlign();
	    if (!props.disabled && props.monitorWindowResize) {
	      this.startMonitorWindowResize();
	    }
	  },
	  componentDidUpdate: function componentDidUpdate(prevProps) {
	    var reAlign = false;
	    var props = this.props;
	
	    if (!props.disabled) {
	      if (prevProps.disabled || prevProps.align !== props.align) {
	        reAlign = true;
	      } else {
	        var lastTarget = prevProps.target();
	        var currentTarget = props.target();
	        if ((0, _isWindow2["default"])(lastTarget) && (0, _isWindow2["default"])(currentTarget)) {
	          reAlign = false;
	        } else if (lastTarget !== currentTarget) {
	          reAlign = true;
	        }
	      }
	    }
	
	    if (reAlign) {
	      this.forceAlign();
	    }
	
	    if (props.monitorWindowResize && !props.disabled) {
	      this.startMonitorWindowResize();
	    } else {
	      this.stopMonitorWindowResize();
	    }
	  },
	  componentWillUnmount: function componentWillUnmount() {
	    this.stopMonitorWindowResize();
	  },
	  startMonitorWindowResize: function startMonitorWindowResize() {
	    if (!this.resizeHandler) {
	      this.bufferMonitor = buffer(this.forceAlign, this.props.monitorBufferTime);
	      this.resizeHandler = (0, _addEventListener2["default"])(window, 'resize', this.bufferMonitor);
	    }
	  },
	  stopMonitorWindowResize: function stopMonitorWindowResize() {
	    if (this.resizeHandler) {
	      this.bufferMonitor.clear();
	      this.resizeHandler.remove();
	      this.resizeHandler = null;
	    }
	  },
	  forceAlign: function forceAlign() {
	    var props = this.props;
	    if (!props.disabled) {
	      var source = _reactDom2["default"].findDOMNode(this);
	      props.onAlign(source, (0, _domAlign2["default"])(source, props.target(), props.align));
	    }
	  },
	  render: function render() {
	    var _props = this.props;
	    var childrenProps = _props.childrenProps;
	    var children = _props.children;
	
	    var child = _react2["default"].Children.only(children);
	    if (childrenProps) {
	      var newProps = {};
	      for (var prop in childrenProps) {
	        if (childrenProps.hasOwnProperty(prop)) {
	          newProps[prop] = this.props[childrenProps[prop]];
	        }
	      }
	      return _react2["default"].cloneElement(child, newProps);
	    }
	    return child;
	  }
	});
	
	exports["default"] = Align;
	module.exports = exports['default'];

/***/ },
/* 175 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Align = __webpack_require__(174);
	
	var _Align2 = _interopRequireDefault(_Align);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	exports["default"] = _Align2["default"]; // export this package's api
	
	module.exports = exports['default'];

/***/ },
/* 176 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = isWindow;
	function isWindow(obj) {
	  /* eslint no-eq-null: 0 */
	  /* eslint eqeqeq: 0 */
	  return obj != null && obj == obj.window;
	}
	module.exports = exports['default'];

/***/ },
/* 177 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ChildrenUtils = __webpack_require__(179);
	
	var _AnimateChild = __webpack_require__(178);
	
	var _AnimateChild2 = _interopRequireDefault(_AnimateChild);
	
	var _util = __webpack_require__(83);
	
	var _util2 = _interopRequireDefault(_util);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var defaultKey = 'rc_animate_' + Date.now();
	
	
	function getChildrenFromProps(props) {
	  var children = props.children;
	  if (_react2["default"].isValidElement(children)) {
	    if (!children.key) {
	      return _react2["default"].cloneElement(children, {
	        key: defaultKey
	      });
	    }
	  }
	  return children;
	}
	
	function noop() {}
	
	var Animate = _react2["default"].createClass({
	  displayName: 'Animate',
	
	  propTypes: {
	    component: _react2["default"].PropTypes.any,
	    animation: _react2["default"].PropTypes.object,
	    transitionName: _react2["default"].PropTypes.oneOfType([_react2["default"].PropTypes.string, _react2["default"].PropTypes.object]),
	    transitionEnter: _react2["default"].PropTypes.bool,
	    transitionAppear: _react2["default"].PropTypes.bool,
	    exclusive: _react2["default"].PropTypes.bool,
	    transitionLeave: _react2["default"].PropTypes.bool,
	    onEnd: _react2["default"].PropTypes.func,
	    onEnter: _react2["default"].PropTypes.func,
	    onLeave: _react2["default"].PropTypes.func,
	    onAppear: _react2["default"].PropTypes.func,
	    showProp: _react2["default"].PropTypes.string
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      animation: {},
	      component: 'span',
	      transitionEnter: true,
	      transitionLeave: true,
	      transitionAppear: false,
	      onEnd: noop,
	      onEnter: noop,
	      onLeave: noop,
	      onAppear: noop
	    };
	  },
	  getInitialState: function getInitialState() {
	    this.currentlyAnimatingKeys = {};
	    this.keysToEnter = [];
	    this.keysToLeave = [];
	    return {
	      children: (0, _ChildrenUtils.toArrayChildren)(getChildrenFromProps(this.props))
	    };
	  },
	  componentDidMount: function componentDidMount() {
	    var _this = this;
	
	    var showProp = this.props.showProp;
	    var children = this.state.children;
	    if (showProp) {
	      children = children.filter(function (child) {
	        return !!child.props[showProp];
	      });
	    }
	    children.forEach(function (child) {
	      if (child) {
	        _this.performAppear(child.key);
	      }
	    });
	  },
	  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
	    var _this2 = this;
	
	    this.nextProps = nextProps;
	    var nextChildren = (0, _ChildrenUtils.toArrayChildren)(getChildrenFromProps(nextProps));
	    var props = this.props;
	    // exclusive needs immediate response
	    if (props.exclusive) {
	      Object.keys(this.currentlyAnimatingKeys).forEach(function (key) {
	        _this2.stop(key);
	      });
	    }
	    var showProp = props.showProp;
	    var currentlyAnimatingKeys = this.currentlyAnimatingKeys;
	    // last props children if exclusive
	    var currentChildren = props.exclusive ? (0, _ChildrenUtils.toArrayChildren)(getChildrenFromProps(props)) : this.state.children;
	    // in case destroy in showProp mode
	    var newChildren = [];
	    if (showProp) {
	      currentChildren.forEach(function (currentChild) {
	        var nextChild = currentChild && (0, _ChildrenUtils.findChildInChildrenByKey)(nextChildren, currentChild.key);
	        var newChild = void 0;
	        if ((!nextChild || !nextChild.props[showProp]) && currentChild.props[showProp]) {
	          newChild = _react2["default"].cloneElement(nextChild || currentChild, _defineProperty({}, showProp, true));
	        } else {
	          newChild = nextChild;
	        }
	        if (newChild) {
	          newChildren.push(newChild);
	        }
	      });
	      nextChildren.forEach(function (nextChild) {
	        if (!nextChild || !(0, _ChildrenUtils.findChildInChildrenByKey)(currentChildren, nextChild.key)) {
	          newChildren.push(nextChild);
	        }
	      });
	    } else {
	      newChildren = (0, _ChildrenUtils.mergeChildren)(currentChildren, nextChildren);
	    }
	
	    // need render to avoid update
	    this.setState({
	      children: newChildren
	    });
	
	    nextChildren.forEach(function (child) {
	      var key = child && child.key;
	      if (child && currentlyAnimatingKeys[key]) {
	        return;
	      }
	      var hasPrev = child && (0, _ChildrenUtils.findChildInChildrenByKey)(currentChildren, key);
	      if (showProp) {
	        var showInNext = child.props[showProp];
	        if (hasPrev) {
	          var showInNow = (0, _ChildrenUtils.findShownChildInChildrenByKey)(currentChildren, key, showProp);
	          if (!showInNow && showInNext) {
	            _this2.keysToEnter.push(key);
	          }
	        } else if (showInNext) {
	          _this2.keysToEnter.push(key);
	        }
	      } else if (!hasPrev) {
	        _this2.keysToEnter.push(key);
	      }
	    });
	
	    currentChildren.forEach(function (child) {
	      var key = child && child.key;
	      if (child && currentlyAnimatingKeys[key]) {
	        return;
	      }
	      var hasNext = child && (0, _ChildrenUtils.findChildInChildrenByKey)(nextChildren, key);
	      if (showProp) {
	        var showInNow = child.props[showProp];
	        if (hasNext) {
	          var showInNext = (0, _ChildrenUtils.findShownChildInChildrenByKey)(nextChildren, key, showProp);
	          if (!showInNext && showInNow) {
	            _this2.keysToLeave.push(key);
	          }
	        } else if (showInNow) {
	          _this2.keysToLeave.push(key);
	        }
	      } else if (!hasNext) {
	        _this2.keysToLeave.push(key);
	      }
	    });
	  },
	  componentDidUpdate: function componentDidUpdate() {
	    var keysToEnter = this.keysToEnter;
	    this.keysToEnter = [];
	    keysToEnter.forEach(this.performEnter);
	    var keysToLeave = this.keysToLeave;
	    this.keysToLeave = [];
	    keysToLeave.forEach(this.performLeave);
	  },
	  performEnter: function performEnter(key) {
	    // may already remove by exclusive
	    if (this.refs[key]) {
	      this.currentlyAnimatingKeys[key] = true;
	      this.refs[key].componentWillEnter(this.handleDoneAdding.bind(this, key, 'enter'));
	    }
	  },
	  performAppear: function performAppear(key) {
	    if (this.refs[key]) {
	      this.currentlyAnimatingKeys[key] = true;
	      this.refs[key].componentWillAppear(this.handleDoneAdding.bind(this, key, 'appear'));
	    }
	  },
	  handleDoneAdding: function handleDoneAdding(key, type) {
	    var props = this.props;
	    delete this.currentlyAnimatingKeys[key];
	    // if update on exclusive mode, skip check
	    if (props.exclusive && props !== this.nextProps) {
	      return;
	    }
	    var currentChildren = (0, _ChildrenUtils.toArrayChildren)(getChildrenFromProps(props));
	    if (!this.isValidChildByKey(currentChildren, key)) {
	      // exclusive will not need this
	      this.performLeave(key);
	    } else {
	      if (type === 'appear') {
	        if (_util2["default"].allowAppearCallback(props)) {
	          props.onAppear(key);
	          props.onEnd(key, true);
	        }
	      } else {
	        if (_util2["default"].allowEnterCallback(props)) {
	          props.onEnter(key);
	          props.onEnd(key, true);
	        }
	      }
	    }
	  },
	  performLeave: function performLeave(key) {
	    // may already remove by exclusive
	    if (this.refs[key]) {
	      this.currentlyAnimatingKeys[key] = true;
	      this.refs[key].componentWillLeave(this.handleDoneLeaving.bind(this, key));
	    }
	  },
	  handleDoneLeaving: function handleDoneLeaving(key) {
	    var props = this.props;
	    delete this.currentlyAnimatingKeys[key];
	    // if update on exclusive mode, skip check
	    if (props.exclusive && props !== this.nextProps) {
	      return;
	    }
	    var currentChildren = (0, _ChildrenUtils.toArrayChildren)(getChildrenFromProps(props));
	    // in case state change is too fast
	    if (this.isValidChildByKey(currentChildren, key)) {
	      this.performEnter(key);
	    } else {
	      var end = function end() {
	        if (_util2["default"].allowLeaveCallback(props)) {
	          props.onLeave(key);
	          props.onEnd(key, false);
	        }
	      };
	      /* eslint react/no-is-mounted:0 */
	      if (this.isMounted() && !(0, _ChildrenUtils.isSameChildren)(this.state.children, currentChildren, props.showProp)) {
	        this.setState({
	          children: currentChildren
	        }, end);
	      } else {
	        end();
	      }
	    }
	  },
	  isValidChildByKey: function isValidChildByKey(currentChildren, key) {
	    var showProp = this.props.showProp;
	    if (showProp) {
	      return (0, _ChildrenUtils.findShownChildInChildrenByKey)(currentChildren, key, showProp);
	    }
	    return (0, _ChildrenUtils.findChildInChildrenByKey)(currentChildren, key);
	  },
	  stop: function stop(key) {
	    delete this.currentlyAnimatingKeys[key];
	    var component = this.refs[key];
	    if (component) {
	      component.stop();
	    }
	  },
	  render: function render() {
	    var props = this.props;
	    this.nextProps = props;
	    var stateChildren = this.state.children;
	    var children = null;
	    if (stateChildren) {
	      children = stateChildren.map(function (child) {
	        if (child === null || child === undefined) {
	          return child;
	        }
	        if (!child.key) {
	          throw new Error('must set key for <rc-animate> children');
	        }
	        return _react2["default"].createElement(
	          _AnimateChild2["default"],
	          {
	            key: child.key,
	            ref: child.key,
	            animation: props.animation,
	            transitionName: props.transitionName,
	            transitionEnter: props.transitionEnter,
	            transitionAppear: props.transitionAppear,
	            transitionLeave: props.transitionLeave
	          },
	          child
	        );
	      });
	    }
	    var Component = props.component;
	    if (Component) {
	      var passedProps = props;
	      if (typeof Component === 'string') {
	        passedProps = {
	          className: props.className,
	          style: props.style
	        };
	      }
	      return _react2["default"].createElement(
	        Component,
	        passedProps,
	        children
	      );
	    }
	    return children[0] || null;
	  }
	});
	
	exports["default"] = Animate;
	module.exports = exports['default'];

/***/ },
/* 178 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(16);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _cssAnimation = __webpack_require__(136);
	
	var _cssAnimation2 = _interopRequireDefault(_cssAnimation);
	
	var _util = __webpack_require__(83);
	
	var _util2 = _interopRequireDefault(_util);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	var transitionMap = {
	  enter: 'transitionEnter',
	  appear: 'transitionAppear',
	  leave: 'transitionLeave'
	};
	
	var AnimateChild = _react2["default"].createClass({
	  displayName: 'AnimateChild',
	
	  propTypes: {
	    children: _react2["default"].PropTypes.any
	  },
	
	  componentWillUnmount: function componentWillUnmount() {
	    this.stop();
	  },
	  componentWillEnter: function componentWillEnter(done) {
	    if (_util2["default"].isEnterSupported(this.props)) {
	      this.transition('enter', done);
	    } else {
	      done();
	    }
	  },
	  componentWillAppear: function componentWillAppear(done) {
	    if (_util2["default"].isAppearSupported(this.props)) {
	      this.transition('appear', done);
	    } else {
	      done();
	    }
	  },
	  componentWillLeave: function componentWillLeave(done) {
	    if (_util2["default"].isLeaveSupported(this.props)) {
	      this.transition('leave', done);
	    } else {
	      // always sync, do not interupt with react component life cycle
	      // update hidden -> animate hidden ->
	      // didUpdate -> animate leave -> unmount (if animate is none)
	      done();
	    }
	  },
	  transition: function transition(animationType, finishCallback) {
	    var _this = this;
	
	    var node = _reactDom2["default"].findDOMNode(this);
	    var props = this.props;
	    var transitionName = props.transitionName;
	    var nameIsObj = (typeof transitionName === 'undefined' ? 'undefined' : _typeof(transitionName)) === 'object';
	    this.stop();
	    var end = function end() {
	      _this.stopper = null;
	      finishCallback();
	    };
	    if ((_cssAnimation.isCssAnimationSupported || !props.animation[animationType]) && transitionName && props[transitionMap[animationType]]) {
	      var name = nameIsObj ? transitionName[animationType] : transitionName + '-' + animationType;
	      var activeName = name + '-active';
	      if (nameIsObj && transitionName[animationType + 'Active']) {
	        activeName = transitionName[animationType + 'Active'];
	      }
	      this.stopper = (0, _cssAnimation2["default"])(node, {
	        name: name,
	        active: activeName
	      }, end);
	    } else {
	      this.stopper = props.animation[animationType](node, end);
	    }
	  },
	  stop: function stop() {
	    var stopper = this.stopper;
	    if (stopper) {
	      this.stopper = null;
	      stopper.stop();
	    }
	  },
	  render: function render() {
	    return this.props.children;
	  }
	});
	
	exports["default"] = AnimateChild;
	module.exports = exports['default'];

/***/ },
/* 179 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.toArrayChildren = toArrayChildren;
	exports.findChildInChildrenByKey = findChildInChildrenByKey;
	exports.findShownChildInChildrenByKey = findShownChildInChildrenByKey;
	exports.findHiddenChildInChildrenByKey = findHiddenChildInChildrenByKey;
	exports.isSameChildren = isSameChildren;
	exports.mergeChildren = mergeChildren;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function toArrayChildren(children) {
	  var ret = [];
	  _react2["default"].Children.forEach(children, function (child) {
	    ret.push(child);
	  });
	  return ret;
	}
	
	function findChildInChildrenByKey(children, key) {
	  var ret = null;
	  if (children) {
	    children.forEach(function (child) {
	      if (ret) {
	        return;
	      }
	      if (child && child.key === key) {
	        ret = child;
	      }
	    });
	  }
	  return ret;
	}
	
	function findShownChildInChildrenByKey(children, key, showProp) {
	  var ret = null;
	  if (children) {
	    children.forEach(function (child) {
	      if (child && child.key === key && child.props[showProp]) {
	        if (ret) {
	          throw new Error('two child with same key for <rc-animate> children');
	        }
	        ret = child;
	      }
	    });
	  }
	  return ret;
	}
	
	function findHiddenChildInChildrenByKey(children, key, showProp) {
	  var found = 0;
	  if (children) {
	    children.forEach(function (child) {
	      if (found) {
	        return;
	      }
	      found = child && child.key === key && !child.props[showProp];
	    });
	  }
	  return found;
	}
	
	function isSameChildren(c1, c2, showProp) {
	  var same = c1.length === c2.length;
	  if (same) {
	    c1.forEach(function (child, index) {
	      var child2 = c2[index];
	      if (child && child2) {
	        if (child && !child2 || !child && child2) {
	          same = false;
	        } else if (child.key !== child2.key) {
	          same = false;
	        } else if (showProp && child.props[showProp] !== child2.props[showProp]) {
	          same = false;
	        }
	      }
	    });
	  }
	  return same;
	}
	
	function mergeChildren(prev, next) {
	  var ret = [];
	
	  // For each key of `next`, the list of keys to insert before that key in
	  // the combined list
	  var nextChildrenPending = {};
	  var pendingChildren = [];
	  prev.forEach(function (child) {
	    if (child && findChildInChildrenByKey(next, child.key)) {
	      if (pendingChildren.length) {
	        nextChildrenPending[child.key] = pendingChildren;
	        pendingChildren = [];
	      }
	    } else {
	      pendingChildren.push(child);
	    }
	  });
	
	  next.forEach(function (child) {
	    if (child && nextChildrenPending.hasOwnProperty(child.key)) {
	      ret = ret.concat(nextChildrenPending[child.key]);
	    }
	    ret.push(child);
	  });
	
	  ret = ret.concat(pendingChildren);
	
	  return ret;
	}

/***/ },
/* 180 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	// export this package's api
	module.exports = __webpack_require__(177);

/***/ },
/* 181 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _placements = __webpack_require__(182);
	
	var _rcTrigger = __webpack_require__(186);
	
	var _rcTrigger2 = _interopRequireDefault(_rcTrigger);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var Tooltip = _react2["default"].createClass({
	  displayName: 'Tooltip',
	
	  propTypes: {
	    trigger: _react.PropTypes.any,
	    children: _react.PropTypes.any,
	    defaultVisible: _react.PropTypes.bool,
	    visible: _react.PropTypes.bool,
	    placement: _react.PropTypes.string,
	    transitionName: _react.PropTypes.string,
	    animation: _react.PropTypes.any,
	    onVisibleChange: _react.PropTypes.func,
	    afterVisibleChange: _react.PropTypes.func,
	    overlay: _react.PropTypes.oneOfType([_react2["default"].PropTypes.node, _react2["default"].PropTypes.func]).isRequired,
	    overlayStyle: _react.PropTypes.object,
	    overlayClassName: _react.PropTypes.string,
	    prefixCls: _react.PropTypes.string,
	    mouseEnterDelay: _react.PropTypes.number,
	    mouseLeaveDelay: _react.PropTypes.number,
	    getTooltipContainer: _react.PropTypes.func,
	    destroyTooltipOnHide: _react.PropTypes.bool,
	    align: _react.PropTypes.object,
	    arrowContent: _react.PropTypes.any
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      prefixCls: 'rc-tooltip',
	      mouseEnterDelay: 0,
	      destroyTooltipOnHide: false,
	      mouseLeaveDelay: 0.1,
	      align: {},
	      placement: 'right',
	      trigger: ['hover'],
	      arrowContent: null
	    };
	  },
	  getPopupElement: function getPopupElement() {
	    var _props = this.props;
	    var arrowContent = _props.arrowContent;
	    var overlay = _props.overlay;
	    var prefixCls = _props.prefixCls;
	
	    return [_react2["default"].createElement(
	      'div',
	      { className: prefixCls + '-arrow', key: 'arrow' },
	      arrowContent
	    ), _react2["default"].createElement(
	      'div',
	      { className: prefixCls + '-inner', key: 'content' },
	      typeof overlay === 'function' ? overlay() : overlay
	    )];
	  },
	  getPopupDomNode: function getPopupDomNode() {
	    return this.refs.trigger.getPopupDomNode();
	  },
	  render: function render() {
	    var _props2 = this.props;
	    var overlayClassName = _props2.overlayClassName;
	    var trigger = _props2.trigger;
	    var mouseEnterDelay = _props2.mouseEnterDelay;
	    var mouseLeaveDelay = _props2.mouseLeaveDelay;
	    var overlayStyle = _props2.overlayStyle;
	    var prefixCls = _props2.prefixCls;
	    var children = _props2.children;
	    var onVisibleChange = _props2.onVisibleChange;
	    var transitionName = _props2.transitionName;
	    var animation = _props2.animation;
	    var placement = _props2.placement;
	    var align = _props2.align;
	    var destroyTooltipOnHide = _props2.destroyTooltipOnHide;
	    var defaultVisible = _props2.defaultVisible;
	    var getTooltipContainer = _props2.getTooltipContainer;
	
	    var restProps = _objectWithoutProperties(_props2, ['overlayClassName', 'trigger', 'mouseEnterDelay', 'mouseLeaveDelay', 'overlayStyle', 'prefixCls', 'children', 'onVisibleChange', 'transitionName', 'animation', 'placement', 'align', 'destroyTooltipOnHide', 'defaultVisible', 'getTooltipContainer']);
	
	    var extraProps = _extends({}, restProps);
	    if ('visible' in this.props) {
	      extraProps.popupVisible = this.props.visible;
	    }
	    return _react2["default"].createElement(
	      _rcTrigger2["default"],
	      _extends({
	        popupClassName: overlayClassName,
	        ref: 'trigger',
	        prefixCls: prefixCls,
	        popup: this.getPopupElement,
	        action: trigger,
	        builtinPlacements: _placements.placements,
	        popupPlacement: placement,
	        popupAlign: align,
	        getPopupContainer: getTooltipContainer,
	        onPopupVisibleChange: onVisibleChange,
	        popupTransitionName: transitionName,
	        popupAnimation: animation,
	        defaultPopupVisible: defaultVisible,
	        destroyPopupOnHide: destroyTooltipOnHide,
	        mouseLeaveDelay: mouseLeaveDelay,
	        popupStyle: overlayStyle,
	        mouseEnterDelay: mouseEnterDelay
	      }, extraProps),
	      children
	    );
	  }
	});
	
	exports["default"] = Tooltip;
	module.exports = exports['default'];

/***/ },
/* 182 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var autoAdjustOverflow = {
	  adjustX: 1,
	  adjustY: 1
	};
	
	var targetOffset = [0, 0];
	
	var placements = exports.placements = {
	  left: {
	    points: ['cr', 'cl'],
	    overflow: autoAdjustOverflow,
	    offset: [-4, 0],
	    targetOffset: targetOffset
	  },
	  right: {
	    points: ['cl', 'cr'],
	    overflow: autoAdjustOverflow,
	    offset: [4, 0],
	    targetOffset: targetOffset
	  },
	  top: {
	    points: ['bc', 'tc'],
	    overflow: autoAdjustOverflow,
	    offset: [0, -4],
	    targetOffset: targetOffset
	  },
	  bottom: {
	    points: ['tc', 'bc'],
	    overflow: autoAdjustOverflow,
	    offset: [0, 4],
	    targetOffset: targetOffset
	  },
	  topLeft: {
	    points: ['bl', 'tl'],
	    overflow: autoAdjustOverflow,
	    offset: [0, -4],
	    targetOffset: targetOffset
	  },
	  leftTop: {
	    points: ['tr', 'tl'],
	    overflow: autoAdjustOverflow,
	    offset: [-4, 0],
	    targetOffset: targetOffset
	  },
	  topRight: {
	    points: ['br', 'tr'],
	    overflow: autoAdjustOverflow,
	    offset: [0, -4],
	    targetOffset: targetOffset
	  },
	  rightTop: {
	    points: ['tl', 'tr'],
	    overflow: autoAdjustOverflow,
	    offset: [4, 0],
	    targetOffset: targetOffset
	  },
	  bottomRight: {
	    points: ['tr', 'br'],
	    overflow: autoAdjustOverflow,
	    offset: [0, 4],
	    targetOffset: targetOffset
	  },
	  rightBottom: {
	    points: ['bl', 'br'],
	    overflow: autoAdjustOverflow,
	    offset: [4, 0],
	    targetOffset: targetOffset
	  },
	  bottomLeft: {
	    points: ['tl', 'bl'],
	    overflow: autoAdjustOverflow,
	    offset: [0, 4],
	    targetOffset: targetOffset
	  },
	  leftBottom: {
	    points: ['br', 'bl'],
	    overflow: autoAdjustOverflow,
	    offset: [-4, 0],
	    targetOffset: targetOffset
	  }
	};
	
	exports["default"] = placements;

/***/ },
/* 183 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(16);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _rcAlign = __webpack_require__(175);
	
	var _rcAlign2 = _interopRequireDefault(_rcAlign);
	
	var _rcAnimate = __webpack_require__(180);
	
	var _rcAnimate2 = _interopRequireDefault(_rcAnimate);
	
	var _PopupInner = __webpack_require__(184);
	
	var _PopupInner2 = _interopRequireDefault(_PopupInner);
	
	var _LazyRenderBox = __webpack_require__(85);
	
	var _LazyRenderBox2 = _interopRequireDefault(_LazyRenderBox);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	var Popup = _react2["default"].createClass({
	  displayName: 'Popup',
	
	  propTypes: {
	    visible: _react.PropTypes.bool,
	    style: _react.PropTypes.object,
	    getClassNameFromAlign: _react.PropTypes.func,
	    onAlign: _react.PropTypes.func,
	    getRootDomNode: _react.PropTypes.func,
	    onMouseEnter: _react.PropTypes.func,
	    align: _react.PropTypes.any,
	    destroyPopupOnHide: _react.PropTypes.bool,
	    className: _react.PropTypes.string,
	    prefixCls: _react.PropTypes.string,
	    onMouseLeave: _react.PropTypes.func
	  },
	
	  componentDidMount: function componentDidMount() {
	    this.rootNode = this.getPopupDomNode();
	  },
	  onAlign: function onAlign(popupDomNode, align) {
	    var props = this.props;
	    var alignClassName = props.getClassNameFromAlign(props.align);
	    var currentAlignClassName = props.getClassNameFromAlign(align);
	    if (alignClassName !== currentAlignClassName) {
	      this.currentAlignClassName = currentAlignClassName;
	      popupDomNode.className = this.getClassName(currentAlignClassName);
	    }
	    props.onAlign(popupDomNode, align);
	  },
	  getPopupDomNode: function getPopupDomNode() {
	    return _reactDom2["default"].findDOMNode(this.refs.popup);
	  },
	  getTarget: function getTarget() {
	    return this.props.getRootDomNode();
	  },
	  getMaskTransitionName: function getMaskTransitionName() {
	    var props = this.props;
	    var transitionName = props.maskTransitionName;
	    var animation = props.maskAnimation;
	    if (!transitionName && animation) {
	      transitionName = props.prefixCls + '-' + animation;
	    }
	    return transitionName;
	  },
	  getTransitionName: function getTransitionName() {
	    var props = this.props;
	    var transitionName = props.transitionName;
	    if (!transitionName && props.animation) {
	      transitionName = props.prefixCls + '-' + props.animation;
	    }
	    return transitionName;
	  },
	  getClassName: function getClassName(currentAlignClassName) {
	    return this.props.prefixCls + ' ' + this.props.className + ' ' + currentAlignClassName;
	  },
	  getPopupElement: function getPopupElement() {
	    var props = this.props;
	    var align = props.align;
	    var style = props.style;
	    var visible = props.visible;
	    var prefixCls = props.prefixCls;
	    var destroyPopupOnHide = props.destroyPopupOnHide;
	
	    var className = this.getClassName(this.currentAlignClassName || props.getClassNameFromAlign(align));
	    var hiddenClassName = prefixCls + '-hidden';
	    if (!visible) {
	      this.currentAlignClassName = null;
	    }
	    var newStyle = _extends({}, style, this.getZIndexStyle());
	    var popupInnerProps = {
	      className: className,
	      prefixCls: prefixCls,
	      ref: 'popup',
	      onMouseEnter: props.onMouseEnter,
	      onMouseLeave: props.onMouseLeave,
	      style: newStyle
	    };
	    if (destroyPopupOnHide) {
	      return _react2["default"].createElement(
	        _rcAnimate2["default"],
	        {
	          component: '',
	          exclusive: true,
	          transitionAppear: true,
	          transitionName: this.getTransitionName()
	        },
	        visible ? _react2["default"].createElement(
	          _rcAlign2["default"],
	          {
	            target: this.getTarget,
	            key: 'popup',
	            ref: this.saveAlign,
	            monitorWindowResize: true,
	            align: align,
	            onAlign: this.onAlign
	          },
	          _react2["default"].createElement(
	            _PopupInner2["default"],
	            _extends({
	              visible: true
	            }, popupInnerProps),
	            props.children
	          )
	        ) : null
	      );
	    }
	    return _react2["default"].createElement(
	      _rcAnimate2["default"],
	      {
	        component: '',
	        exclusive: true,
	        transitionAppear: true,
	        transitionName: this.getTransitionName(),
	        showProp: 'xVisible'
	      },
	      _react2["default"].createElement(
	        _rcAlign2["default"],
	        {
	          target: this.getTarget,
	          key: 'popup',
	          ref: this.saveAlign,
	          monitorWindowResize: true,
	          xVisible: visible,
	          childrenProps: { visible: 'xVisible' },
	          disabled: !visible,
	          align: align,
	          onAlign: this.onAlign
	        },
	        _react2["default"].createElement(
	          _PopupInner2["default"],
	          _extends({
	            hiddenClassName: hiddenClassName
	          }, popupInnerProps),
	          props.children
	        )
	      )
	    );
	  },
	  getZIndexStyle: function getZIndexStyle() {
	    var style = {};
	    var props = this.props;
	    if (props.zIndex !== undefined) {
	      style.zIndex = props.zIndex;
	    }
	    return style;
	  },
	  getMaskElement: function getMaskElement() {
	    var props = this.props;
	    var maskElement = void 0;
	    if (props.mask) {
	      var maskTransition = this.getMaskTransitionName();
	      maskElement = _react2["default"].createElement(_LazyRenderBox2["default"], {
	        style: this.getZIndexStyle(),
	        key: 'mask',
	        className: props.prefixCls + '-mask',
	        hiddenClassName: props.prefixCls + '-mask-hidden',
	        visible: props.visible
	      });
	      if (maskTransition) {
	        maskElement = _react2["default"].createElement(
	          _rcAnimate2["default"],
	          {
	            key: 'mask',
	            showProp: 'visible',
	            transitionAppear: true,
	            component: '',
	            transitionName: maskTransition
	          },
	          maskElement
	        );
	      }
	    }
	    return maskElement;
	  },
	  saveAlign: function saveAlign(align) {
	    this.alignInstance = align;
	  },
	  render: function render() {
	    return _react2["default"].createElement(
	      'div',
	      null,
	      this.getMaskElement(),
	      this.getPopupElement()
	    );
	  }
	});
	
	exports["default"] = Popup;
	module.exports = exports['default'];

/***/ },
/* 184 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _LazyRenderBox = __webpack_require__(85);
	
	var _LazyRenderBox2 = _interopRequireDefault(_LazyRenderBox);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	var PopupInner = _react2["default"].createClass({
	  displayName: 'PopupInner',
	
	  propTypes: {
	    hiddenClassName: _react.PropTypes.string,
	    className: _react.PropTypes.string,
	    prefixCls: _react.PropTypes.string,
	    onMouseEnter: _react.PropTypes.func,
	    onMouseLeave: _react.PropTypes.func,
	    children: _react.PropTypes.any
	  },
	  render: function render() {
	    var props = this.props;
	    var className = props.className;
	    if (!props.visible) {
	      className += ' ' + props.hiddenClassName;
	    }
	    return _react2["default"].createElement(
	      'div',
	      {
	        className: className,
	        onMouseEnter: props.onMouseEnter,
	        onMouseLeave: props.onMouseLeave,
	        style: props.style
	      },
	      _react2["default"].createElement(
	        _LazyRenderBox2["default"],
	        { className: props.prefixCls + '-content', visible: props.visible },
	        props.children
	      )
	    );
	  }
	});
	
	exports["default"] = PopupInner;
	module.exports = exports['default'];

/***/ },
/* 185 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(16);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _contains = __webpack_require__(188);
	
	var _contains2 = _interopRequireDefault(_contains);
	
	var _addEventListener = __webpack_require__(86);
	
	var _addEventListener2 = _interopRequireDefault(_addEventListener);
	
	var _Popup = __webpack_require__(183);
	
	var _Popup2 = _interopRequireDefault(_Popup);
	
	var _utils = __webpack_require__(187);
	
	var _getContainerRenderMixin = __webpack_require__(189);
	
	var _getContainerRenderMixin2 = _interopRequireDefault(_getContainerRenderMixin);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function noop() {}
	
	function returnEmptyString() {
	  return '';
	}
	
	var ALL_HANDLERS = ['onClick', 'onMouseDown', 'onTouchStart', 'onMouseEnter', 'onMouseLeave', 'onFocus', 'onBlur'];
	
	var Trigger = _react2["default"].createClass({
	  displayName: 'Trigger',
	
	  propTypes: {
	    children: _react.PropTypes.any,
	    action: _react.PropTypes.oneOfType([_react.PropTypes.string, _react.PropTypes.arrayOf(_react.PropTypes.string)]),
	    showAction: _react.PropTypes.any,
	    hideAction: _react.PropTypes.any,
	    getPopupClassNameFromAlign: _react.PropTypes.any,
	    onPopupVisibleChange: _react.PropTypes.func,
	    afterPopupVisibleChange: _react.PropTypes.func,
	    popup: _react.PropTypes.oneOfType([_react.PropTypes.node, _react.PropTypes.func]).isRequired,
	    popupStyle: _react.PropTypes.object,
	    prefixCls: _react.PropTypes.string,
	    popupClassName: _react.PropTypes.string,
	    popupPlacement: _react.PropTypes.string,
	    builtinPlacements: _react.PropTypes.object,
	    popupTransitionName: _react.PropTypes.string,
	    popupAnimation: _react.PropTypes.any,
	    mouseEnterDelay: _react.PropTypes.number,
	    mouseLeaveDelay: _react.PropTypes.number,
	    zIndex: _react.PropTypes.number,
	    focusDelay: _react.PropTypes.number,
	    blurDelay: _react.PropTypes.number,
	    getPopupContainer: _react.PropTypes.func,
	    destroyPopupOnHide: _react.PropTypes.bool,
	    mask: _react.PropTypes.bool,
	    onPopupAlign: _react.PropTypes.func,
	    popupAlign: _react.PropTypes.object,
	    popupVisible: _react.PropTypes.bool,
	    maskTransitionName: _react.PropTypes.string,
	    maskAnimation: _react.PropTypes.string
	  },
	
	  mixins: [(0, _getContainerRenderMixin2["default"])({
	    autoMount: false,
	
	    isVisible: function isVisible(instance) {
	      return instance.state.popupVisible;
	    },
	    getContainer: function getContainer(instance) {
	      var popupContainer = document.createElement('div');
	      var mountNode = instance.props.getPopupContainer ? instance.props.getPopupContainer((0, _reactDom.findDOMNode)(instance)) : document.body;
	      mountNode.appendChild(popupContainer);
	      return popupContainer;
	    },
	    getComponent: function getComponent(instance) {
	      var props = instance.props;
	      var state = instance.state;
	
	      var mouseProps = {};
	      if (instance.isMouseEnterToShow()) {
	        mouseProps.onMouseEnter = instance.onPopupMouseEnter;
	      }
	      if (instance.isMouseLeaveToHide()) {
	        mouseProps.onMouseLeave = instance.onPopupMouseLeave;
	      }
	      return _react2["default"].createElement(
	        _Popup2["default"],
	        _extends({
	          prefixCls: props.prefixCls,
	          destroyPopupOnHide: props.destroyPopupOnHide,
	          visible: state.popupVisible,
	          className: props.popupClassName,
	          action: props.action,
	          align: instance.getPopupAlign(),
	          onAlign: props.onPopupAlign,
	          animation: props.popupAnimation,
	          getClassNameFromAlign: instance.getPopupClassNameFromAlign
	        }, mouseProps, {
	          getRootDomNode: instance.getRootDomNode,
	          style: props.popupStyle,
	          mask: props.mask,
	          zIndex: props.zIndex,
	          transitionName: props.popupTransitionName,
	          maskAnimation: props.maskAnimation,
	          maskTransitionName: props.maskTransitionName
	        }),
	        typeof props.popup === 'function' ? props.popup() : props.popup
	      );
	    }
	  })],
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      prefixCls: 'rc-trigger-popup',
	      getPopupClassNameFromAlign: returnEmptyString,
	      onPopupVisibleChange: noop,
	      afterPopupVisibleChange: noop,
	      onPopupAlign: noop,
	      popupClassName: '',
	      mouseEnterDelay: 0,
	      mouseLeaveDelay: 0.1,
	      focusDelay: 0,
	      blurDelay: 0.15,
	      popupStyle: {},
	      destroyPopupOnHide: false,
	      popupAlign: {},
	      defaultPopupVisible: false,
	      mask: false,
	      action: [],
	      showAction: [],
	      hideAction: []
	    };
	  },
	  getInitialState: function getInitialState() {
	    var props = this.props;
	    var popupVisible = void 0;
	    if ('popupVisible' in props) {
	      popupVisible = !!props.popupVisible;
	    } else {
	      popupVisible = !!props.defaultPopupVisible;
	    }
	    return {
	      popupVisible: popupVisible
	    };
	  },
	  componentWillMount: function componentWillMount() {
	    var _this = this;
	
	    ALL_HANDLERS.forEach(function (h) {
	      _this['fire' + h] = function (e) {
	        _this.fireEvents(h, e);
	      };
	    });
	  },
	  componentDidMount: function componentDidMount() {
	    this.componentDidUpdate({}, {
	      popupVisible: this.state.popupVisible
	    });
	  },
	  componentWillReceiveProps: function componentWillReceiveProps(_ref) {
	    var popupVisible = _ref.popupVisible;
	
	    if (popupVisible !== undefined) {
	      this.setState({
	        popupVisible: popupVisible
	      });
	    }
	  },
	  componentDidUpdate: function componentDidUpdate(_, prevState) {
	    var props = this.props;
	    var state = this.state;
	    this.renderComponent(null, function () {
	      if (prevState.popupVisible !== state.popupVisible) {
	        props.afterPopupVisibleChange(state.popupVisible);
	      }
	    });
	    if (this.isClickToHide()) {
	      if (state.popupVisible) {
	        if (!this.clickOutsideHandler) {
	          this.clickOutsideHandler = (0, _addEventListener2["default"])(document, 'mousedown', this.onDocumentClick);
	          this.touchOutsideHandler = (0, _addEventListener2["default"])(document, 'touchstart', this.onDocumentClick);
	        }
	        return;
	      }
	    }
	    if (this.clickOutsideHandler) {
	      this.clickOutsideHandler.remove();
	      this.touchOutsideHandler.remove();
	      this.clickOutsideHandler = null;
	      this.touchOutsideHandler = null;
	    }
	  },
	  componentWillUnmount: function componentWillUnmount() {
	    this.clearDelayTimer();
	    if (this.clickOutsideHandler) {
	      this.clickOutsideHandler.remove();
	      this.touchOutsideHandler.remove();
	      this.clickOutsideHandler = null;
	      this.touchOutsideHandler = null;
	    }
	  },
	  onMouseEnter: function onMouseEnter(e) {
	    this.fireEvents('onMouseEnter', e);
	    this.delaySetPopupVisible(true, this.props.mouseEnterDelay);
	  },
	  onMouseLeave: function onMouseLeave(e) {
	    this.fireEvents('onMouseLeave', e);
	    this.delaySetPopupVisible(false, this.props.mouseLeaveDelay);
	  },
	  onPopupMouseEnter: function onPopupMouseEnter() {
	    this.clearDelayTimer();
	  },
	  onPopupMouseLeave: function onPopupMouseLeave(e) {
	    // https://github.com/react-component/trigger/pull/13
	    // react bug?
	    if (e.relatedTarget && !e.relatedTarget.setTimeout && this._component && (0, _contains2["default"])(this._component.getPopupDomNode(), e.relatedTarget)) {
	      return;
	    }
	    this.delaySetPopupVisible(false, this.props.mouseLeaveDelay);
	  },
	  onFocus: function onFocus(e) {
	    this.fireEvents('onFocus', e);
	    // incase focusin and focusout
	    this.clearDelayTimer();
	    if (this.isFocusToShow()) {
	      this.focusTime = Date.now();
	      this.delaySetPopupVisible(true, this.props.focusDelay);
	    }
	  },
	  onMouseDown: function onMouseDown(e) {
	    this.fireEvents('onMouseDown', e);
	    this.preClickTime = Date.now();
	  },
	  onTouchStart: function onTouchStart(e) {
	    this.fireEvents('onTouchStart', e);
	    this.preTouchTime = Date.now();
	  },
	  onBlur: function onBlur(e) {
	    this.fireEvents('onBlur', e);
	    this.clearDelayTimer();
	    if (this.isBlurToHide()) {
	      this.delaySetPopupVisible(false, this.props.blurDelay);
	    }
	  },
	  onClick: function onClick(event) {
	    this.fireEvents('onClick', event);
	    // focus will trigger click
	    if (this.focusTime) {
	      var preTime = void 0;
	      if (this.preClickTime && this.preTouchTime) {
	        preTime = Math.min(this.preClickTime, this.preTouchTime);
	      } else if (this.preClickTime) {
	        preTime = this.preClickTime;
	      } else if (this.preTouchTime) {
	        preTime = this.preTouchTime;
	      }
	      if (Math.abs(preTime - this.focusTime) < 20) {
	        return;
	      }
	      this.focusTime = 0;
	    }
	    this.preClickTime = 0;
	    this.preTouchTime = 0;
	    event.preventDefault();
	    var nextVisible = !this.state.popupVisible;
	    if (this.isClickToHide() && !nextVisible || nextVisible && this.isClickToShow()) {
	      this.setPopupVisible(!this.state.popupVisible);
	    }
	  },
	  onDocumentClick: function onDocumentClick(event) {
	    var target = event.target;
	    var root = (0, _reactDom.findDOMNode)(this);
	    var popupNode = this.getPopupDomNode();
	    if (!(0, _contains2["default"])(root, target) && !(0, _contains2["default"])(popupNode, target)) {
	      this.setPopupVisible(false);
	    }
	  },
	  getPopupDomNode: function getPopupDomNode() {
	    // for test
	    if (this._component) {
	      return this._component.isMounted() ? this._component.getPopupDomNode() : null;
	    }
	    return null;
	  },
	  getRootDomNode: function getRootDomNode() {
	    return _reactDom2["default"].findDOMNode(this);
	  },
	  getPopupClassNameFromAlign: function getPopupClassNameFromAlign(align) {
	    var className = [];
	    var props = this.props;
	    var popupPlacement = props.popupPlacement;
	    var builtinPlacements = props.builtinPlacements;
	    var prefixCls = props.prefixCls;
	
	    if (popupPlacement && builtinPlacements) {
	      className.push((0, _utils.getPopupClassNameFromAlign)(builtinPlacements, prefixCls, align));
	    }
	    if (props.getPopupClassNameFromAlign) {
	      className.push(props.getPopupClassNameFromAlign(align));
	    }
	    return className.join(' ');
	  },
	  getPopupAlign: function getPopupAlign() {
	    var props = this.props;
	    var popupPlacement = props.popupPlacement;
	    var popupAlign = props.popupAlign;
	    var builtinPlacements = props.builtinPlacements;
	
	    if (popupPlacement && builtinPlacements) {
	      return (0, _utils.getAlignFromPlacement)(builtinPlacements, popupPlacement, popupAlign);
	    }
	    return popupAlign;
	  },
	  setPopupVisible: function setPopupVisible(popupVisible) {
	    this.clearDelayTimer();
	    if (this.state.popupVisible !== popupVisible) {
	      if (!('popupVisible' in this.props)) {
	        this.setState({
	          popupVisible: popupVisible
	        });
	      }
	      this.props.onPopupVisibleChange(popupVisible);
	    }
	  },
	  delaySetPopupVisible: function delaySetPopupVisible(visible, delayS) {
	    var _this2 = this;
	
	    var delay = delayS * 1000;
	    this.clearDelayTimer();
	    if (delay) {
	      this.delayTimer = setTimeout(function () {
	        _this2.setPopupVisible(visible);
	        _this2.clearDelayTimer();
	      }, delay);
	    } else {
	      this.setPopupVisible(visible);
	    }
	  },
	  clearDelayTimer: function clearDelayTimer() {
	    if (this.delayTimer) {
	      clearTimeout(this.delayTimer);
	      this.delayTimer = null;
	    }
	  },
	  createTwoChains: function createTwoChains(event) {
	    var childPros = this.props.children.props;
	    var props = this.props;
	    if (childPros[event] && props[event]) {
	      return this['fire' + event];
	    }
	    return childPros[event] || props[event];
	  },
	  isClickToShow: function isClickToShow() {
	    var _props = this.props;
	    var action = _props.action;
	    var showAction = _props.showAction;
	
	    return action.indexOf('click') !== -1 || showAction.indexOf('click') !== -1;
	  },
	  isClickToHide: function isClickToHide() {
	    var _props2 = this.props;
	    var action = _props2.action;
	    var hideAction = _props2.hideAction;
	
	    return action.indexOf('click') !== -1 || hideAction.indexOf('click') !== -1;
	  },
	  isMouseEnterToShow: function isMouseEnterToShow() {
	    var _props3 = this.props;
	    var action = _props3.action;
	    var showAction = _props3.showAction;
	
	    return action.indexOf('hover') !== -1 || showAction.indexOf('mouseEnter') !== -1;
	  },
	  isMouseLeaveToHide: function isMouseLeaveToHide() {
	    var _props4 = this.props;
	    var action = _props4.action;
	    var hideAction = _props4.hideAction;
	
	    return action.indexOf('hover') !== -1 || hideAction.indexOf('mouseLeave') !== -1;
	  },
	  isFocusToShow: function isFocusToShow() {
	    var _props5 = this.props;
	    var action = _props5.action;
	    var showAction = _props5.showAction;
	
	    return action.indexOf('focus') !== -1 || showAction.indexOf('focus') !== -1;
	  },
	  isBlurToHide: function isBlurToHide() {
	    var _props6 = this.props;
	    var action = _props6.action;
	    var hideAction = _props6.hideAction;
	
	    return action.indexOf('focus') !== -1 || hideAction.indexOf('blur') !== -1;
	  },
	  forcePopupAlign: function forcePopupAlign() {
	    if (this.state.popupVisible && this.popupInstance && this.popupInstance.alignInstance) {
	      this.popupInstance.alignInstance.forceAlign();
	    }
	  },
	  fireEvents: function fireEvents(type, e) {
	    var childCallback = this.props.children.props[type];
	    if (childCallback) {
	      childCallback(e);
	    }
	    var callback = this.props[type];
	    if (callback) {
	      callback(e);
	    }
	  },
	  render: function render() {
	    var props = this.props;
	    var children = props.children;
	    var child = _react2["default"].Children.only(children);
	    var newChildProps = {};
	
	    if (this.isClickToHide() || this.isClickToShow()) {
	      newChildProps.onClick = this.onClick;
	      newChildProps.onMouseDown = this.onMouseDown;
	      newChildProps.onTouchStart = this.onTouchStart;
	    } else {
	      newChildProps.onClick = this.createTwoChains('onClick');
	      newChildProps.onMouseDown = this.createTwoChains('onMouseDown');
	      newChildProps.onTouchStart = this.createTwoChains('onTouchStart');
	    }
	    if (this.isMouseEnterToShow()) {
	      newChildProps.onMouseEnter = this.onMouseEnter;
	    } else {
	      newChildProps.onMouseEnter = this.createTwoChains('onMouseEnter');
	    }
	    if (this.isMouseLeaveToHide()) {
	      newChildProps.onMouseLeave = this.onMouseLeave;
	    } else {
	      newChildProps.onMouseLeave = this.createTwoChains('onMouseLeave');
	    }
	    if (this.isFocusToShow() || this.isBlurToHide()) {
	      newChildProps.onFocus = this.onFocus;
	      newChildProps.onBlur = this.onBlur;
	    } else {
	      newChildProps.onFocus = this.createTwoChains('onFocus');
	      newChildProps.onBlur = this.createTwoChains('onBlur');
	    }
	
	    return _react2["default"].cloneElement(child, newChildProps);
	  }
	});
	
	exports["default"] = Trigger;
	module.exports = exports['default'];

/***/ },
/* 186 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = __webpack_require__(185);

/***/ },
/* 187 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.getAlignFromPlacement = getAlignFromPlacement;
	exports.getPopupClassNameFromAlign = getPopupClassNameFromAlign;
	function isPointsEq(a1, a2) {
	  return a1[0] === a2[0] && a1[1] === a2[1];
	}
	
	function getAlignFromPlacement(builtinPlacements, placementStr, align) {
	  var baseAlign = builtinPlacements[placementStr] || {};
	  return _extends({}, baseAlign, align);
	}
	
	function getPopupClassNameFromAlign(builtinPlacements, prefixCls, align) {
	  var points = align.points;
	  for (var placement in builtinPlacements) {
	    if (builtinPlacements.hasOwnProperty(placement)) {
	      if (isPointsEq(builtinPlacements[placement].points, points)) {
	        return prefixCls + '-placement-' + placement;
	      }
	    }
	  }
	  return '';
	}

/***/ },
/* 188 */
/***/ function(module, exports) {

	"use strict";
	
	module.exports = function contains(root, n) {
	  var node = n;
	  while (node) {
	    if (node === root) {
	      return true;
	    }
	    node = node.parentNode;
	  }
	
	  return false;
	};

/***/ },
/* 189 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports["default"] = getContainerRenderMixin;
	
	var _reactDom = __webpack_require__(16);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function defaultGetContainer() {
	  var container = document.createElement('div');
	  document.body.appendChild(container);
	  return container;
	}
	
	function getContainerRenderMixin(config) {
	  var _config$autoMount = config.autoMount;
	  var autoMount = _config$autoMount === undefined ? true : _config$autoMount;
	  var _config$autoDestroy = config.autoDestroy;
	  var autoDestroy = _config$autoDestroy === undefined ? true : _config$autoDestroy;
	  var isVisible = config.isVisible;
	  var getComponent = config.getComponent;
	  var _config$getContainer = config.getContainer;
	  var getContainer = _config$getContainer === undefined ? defaultGetContainer : _config$getContainer;
	
	
	  var mixin = void 0;
	
	  function _renderComponent(instance, componentArg, ready) {
	    if (!isVisible || instance._component || isVisible(instance)) {
	      if (!instance._container) {
	        instance._container = getContainer(instance);
	      }
	      _reactDom2["default"].unstable_renderSubtreeIntoContainer(instance, getComponent(instance, componentArg), instance._container, function callback() {
	        instance._component = this;
	        if (ready) {
	          ready.call(this);
	        }
	      });
	    }
	  }
	
	  if (autoMount) {
	    mixin = _extends({}, mixin, {
	      componentDidMount: function componentDidMount() {
	        _renderComponent(this);
	      },
	      componentDidUpdate: function componentDidUpdate() {
	        _renderComponent(this);
	      }
	    });
	  }
	
	  if (!autoMount || !autoDestroy) {
	    mixin = _extends({}, mixin, {
	      renderComponent: function renderComponent(componentArg, ready) {
	        _renderComponent(this, componentArg, ready);
	      }
	    });
	  }
	
	  function _removeContainer(instance) {
	    if (instance._container) {
	      var container = instance._container;
	      _reactDom2["default"].unmountComponentAtNode(container);
	      container.parentNode.removeChild(container);
	      instance._container = null;
	    }
	  }
	
	  if (autoDestroy) {
	    mixin = _extends({}, mixin, {
	      componentWillUnmount: function componentWillUnmount() {
	        _removeContainer(this);
	      }
	    });
	  } else {
	    mixin = _extends({}, mixin, {
	      removeContainer: function removeContainer() {
	        _removeContainer(this);
	      }
	    });
	  }
	
	  return mixin;
	}
	module.exports = exports['default'];

/***/ },
/* 190 */
/***/ function(module, exports, __webpack_require__) {

	var React = __webpack_require__(1);
	var ReactDOM = __webpack_require__(16);
	var ExecutionEnvironment = __webpack_require__(145);
	var ModalPortal = React.createFactory(__webpack_require__(191));
	var ariaAppHider = __webpack_require__(192);
	var elementClass = __webpack_require__(144);
	var renderSubtreeIntoContainer = __webpack_require__(16).unstable_renderSubtreeIntoContainer;
	var Assign = __webpack_require__(88);
	
	var SafeHTMLElement = ExecutionEnvironment.canUseDOM ? window.HTMLElement : {};
	var AppElement = ExecutionEnvironment.canUseDOM ? document.body : {appendChild: function() {}};
	
	var Modal = React.createClass({
	
	  displayName: 'Modal',
	  statics: {
	    setAppElement: function(element) {
	        AppElement = ariaAppHider.setElement(element);
	    },
	    injectCSS: function() {
	      "production" !== ("production")
	        && console.warn('React-Modal: injectCSS has been deprecated ' +
	                        'and no longer has any effect. It will be removed in a later version');
	    }
	  },
	
	  propTypes: {
	    isOpen: React.PropTypes.bool.isRequired,
	    style: React.PropTypes.shape({
	      content: React.PropTypes.object,
	      overlay: React.PropTypes.object
	    }),
	    appElement: React.PropTypes.instanceOf(SafeHTMLElement),
	    onAfterOpen: React.PropTypes.func,
	    onRequestClose: React.PropTypes.func,
	    closeTimeoutMS: React.PropTypes.number,
	    ariaHideApp: React.PropTypes.bool,
	    shouldCloseOnOverlayClick: React.PropTypes.bool
	  },
	
	  getDefaultProps: function () {
	    return {
	      isOpen: false,
	      ariaHideApp: true,
	      closeTimeoutMS: 0,
	      shouldCloseOnOverlayClick: true
	    };
	  },
	
	  componentDidMount: function() {
	    this.node = document.createElement('div');
	    this.node.className = 'ReactModalPortal';
	    document.body.appendChild(this.node);
	    this.renderPortal(this.props);
	  },
	
	  componentWillReceiveProps: function(newProps) {
	    this.renderPortal(newProps);
	  },
	
	  componentWillUnmount: function() {
	    ReactDOM.unmountComponentAtNode(this.node);
	    document.body.removeChild(this.node);
	    elementClass(document.body).remove('ReactModal__Body--open');
	  },
	
	  renderPortal: function(props) {
	    if (props.isOpen) {
	      elementClass(document.body).add('ReactModal__Body--open');
	    } else {
	      elementClass(document.body).remove('ReactModal__Body--open');
	    }
	
	    if (props.ariaHideApp) {
	      ariaAppHider.toggle(props.isOpen, props.appElement);
	    }
	
	    this.portal = renderSubtreeIntoContainer(this, ModalPortal(Assign({}, props, {defaultStyles: Modal.defaultStyles})), this.node);
	  },
	
	  render: function () {
	    return React.DOM.noscript();
	  }
	});
	
	Modal.defaultStyles = {
	  overlay: {
	    position        : 'fixed',
	    top             : 0,
	    left            : 0,
	    right           : 0,
	    bottom          : 0,
	    backgroundColor : 'rgba(255, 255, 255, 0.75)'
	  },
	  content: {
	    position                : 'absolute',
	    top                     : '40px',
	    left                    : '40px',
	    right                   : '40px',
	    bottom                  : '40px',
	    border                  : '1px solid #ccc',
	    background              : '#fff',
	    overflow                : 'auto',
	    WebkitOverflowScrolling : 'touch',
	    borderRadius            : '4px',
	    outline                 : 'none',
	    padding                 : '20px'
	  }
	}
	
	module.exports = Modal


/***/ },
/* 191 */
/***/ function(module, exports, __webpack_require__) {

	var React = __webpack_require__(1);
	var div = React.DOM.div;
	var focusManager = __webpack_require__(193);
	var scopeTab = __webpack_require__(194);
	var Assign = __webpack_require__(88);
	
	// so that our CSS is statically analyzable
	var CLASS_NAMES = {
	  overlay: {
	    base: 'ReactModal__Overlay',
	    afterOpen: 'ReactModal__Overlay--after-open',
	    beforeClose: 'ReactModal__Overlay--before-close'
	  },
	  content: {
	    base: 'ReactModal__Content',
	    afterOpen: 'ReactModal__Content--after-open',
	    beforeClose: 'ReactModal__Content--before-close'
	  }
	};
	
	var ModalPortal = module.exports = React.createClass({
	
	  displayName: 'ModalPortal',
	
	  getDefaultProps: function() {
	    return {
	      style: {
	        overlay: {},
	        content: {}
	      }
	    };
	  },
	
	  getInitialState: function() {
	    return {
	      afterOpen: false,
	      beforeClose: false
	    };
	  },
	
	  componentDidMount: function() {
	    // Focus needs to be set when mounting and already open
	    if (this.props.isOpen) {
	      this.setFocusAfterRender(true);
	      this.open();
	    }
	  },
	
	  componentWillUnmount: function() {
	    clearTimeout(this.closeTimer);
	  },
	
	  componentWillReceiveProps: function(newProps) {
	    // Focus only needs to be set once when the modal is being opened
	    if (!this.props.isOpen && newProps.isOpen) {
	      this.setFocusAfterRender(true);
	      this.open();
	    } else if (this.props.isOpen && !newProps.isOpen) {
	      this.close();
	    }
	  },
	
	  componentDidUpdate: function () {
	    if (this.focusAfterRender) {
	      this.focusContent();
	      this.setFocusAfterRender(false);
	    }
	  },
	
	  setFocusAfterRender: function (focus) {
	    this.focusAfterRender = focus;
	  },
	
	  open: function() {
	    if (this.state.afterOpen && this.state.beforeClose) {
	      clearTimeout(this.closeTimer);
	      this.setState({ beforeClose: false });
	    } else {
	      focusManager.setupScopedFocus(this.node);
	      focusManager.markForFocusLater();
	      this.setState({isOpen: true}, function() {
	        this.setState({afterOpen: true});
	
	        if (this.props.isOpen && this.props.onAfterOpen) {
	          this.props.onAfterOpen();
	        }
	      }.bind(this));
	    }
	  },
	
	  close: function() {
	    if (!this.ownerHandlesClose())
	      return;
	    if (this.props.closeTimeoutMS > 0)
	      this.closeWithTimeout();
	    else
	      this.closeWithoutTimeout();
	  },
	
	  focusContent: function() {
	    this.refs.content.focus();
	  },
	
	  closeWithTimeout: function() {
	    this.setState({beforeClose: true}, function() {
	      this.closeTimer = setTimeout(this.closeWithoutTimeout, this.props.closeTimeoutMS);
	    }.bind(this));
	  },
	
	  closeWithoutTimeout: function() {
	    this.setState({
	      beforeClose: false,
	      isOpen: false,
	      afterOpen: false,
	    }, this.afterClose);
	  },
	
	  afterClose: function() {
	    focusManager.returnFocus();
	    focusManager.teardownScopedFocus();
	  },
	
	  handleKeyDown: function(event) {
	    if (event.keyCode == 9 /*tab*/) scopeTab(this.refs.content, event);
	    if (event.keyCode == 27 /*esc*/) {
	      event.preventDefault();
	      this.requestClose(event);
	    }
	  },
	
	  handleOverlayClick: function(event) {
	    var node = event.target
	
	    while (node) {
	      if (node === this.refs.content) return
	      node = node.parentNode
	    }
	
	    if (this.props.shouldCloseOnOverlayClick) {
	      if (this.ownerHandlesClose())
	        this.requestClose(event);
	      else
	        this.focusContent();
	    }
	  },
	
	  requestClose: function(event) {
	    if (this.ownerHandlesClose())
	      this.props.onRequestClose(event);
	  },
	
	  ownerHandlesClose: function() {
	    return this.props.onRequestClose;
	  },
	
	  shouldBeClosed: function() {
	    return !this.props.isOpen && !this.state.beforeClose;
	  },
	
	  buildClassName: function(which, additional) {
	    var className = CLASS_NAMES[which].base;
	    if (this.state.afterOpen)
	      className += ' '+CLASS_NAMES[which].afterOpen;
	    if (this.state.beforeClose)
	      className += ' '+CLASS_NAMES[which].beforeClose;
	    return additional ? className + ' ' + additional : className;
	  },
	
	  render: function() {
	    var contentStyles = (this.props.className) ? {} : this.props.defaultStyles.content;
	    var overlayStyles = (this.props.overlayClassName) ? {} : this.props.defaultStyles.overlay;
	
	    return this.shouldBeClosed() ? div() : (
	      div({
	        ref: "overlay",
	        className: this.buildClassName('overlay', this.props.overlayClassName),
	        style: Assign({}, overlayStyles, this.props.style.overlay || {}),
	        onClick: this.handleOverlayClick
	      },
	        div({
	          ref: "content",
	          style: Assign({}, contentStyles, this.props.style.content || {}),
	          className: this.buildClassName('content', this.props.className),
	          tabIndex: "-1",
	          onKeyDown: this.handleKeyDown
	        },
	          this.props.children
	        )
	      )
	    );
	  }
	});


/***/ },
/* 192 */
/***/ function(module, exports) {

	var _element = typeof document !== 'undefined' ? document.body : null;
	
	function setElement(element) {
	  if (typeof element === 'string') {
	    var el = document.querySelectorAll(element);
	    element = 'length' in el ? el[0] : el;
	  }
	  _element = element || _element;
	  return _element;
	}
	
	function hide(appElement) {
	  validateElement(appElement);
	  (appElement || _element).setAttribute('aria-hidden', 'true');
	}
	
	function show(appElement) {
	  validateElement(appElement);
	  (appElement || _element).removeAttribute('aria-hidden');
	}
	
	function toggle(shouldHide, appElement) {
	  if (shouldHide)
	    hide(appElement);
	  else
	    show(appElement);
	}
	
	function validateElement(appElement) {
	  if (!appElement && !_element)
	    throw new Error('react-modal: You must set an element with `Modal.setAppElement(el)` to make this accessible');
	}
	
	function resetForTesting() {
	  _element = document.body;
	}
	
	exports.toggle = toggle;
	exports.setElement = setElement;
	exports.show = show;
	exports.hide = hide;
	exports.resetForTesting = resetForTesting;


/***/ },
/* 193 */
/***/ function(module, exports, __webpack_require__) {

	var findTabbable = __webpack_require__(87);
	var modalElement = null;
	var focusLaterElement = null;
	var needToFocus = false;
	
	function handleBlur(event) {
	  needToFocus = true;
	}
	
	function handleFocus(event) {
	  if (needToFocus) {
	    needToFocus = false;
	    if (!modalElement) {
	      return;
	    }
	    // need to see how jQuery shims document.on('focusin') so we don't need the
	    // setTimeout, firefox doesn't support focusin, if it did, we could focus
	    // the element outside of a setTimeout. Side-effect of this implementation 
	    // is that the document.body gets focus, and then we focus our element right 
	    // after, seems fine.
	    setTimeout(function() {
	      if (modalElement.contains(document.activeElement))
	        return;
	      var el = (findTabbable(modalElement)[0] || modalElement);
	      el.focus();
	    }, 0);
	  }
	}
	
	exports.markForFocusLater = function() {
	  focusLaterElement = document.activeElement;
	};
	
	exports.returnFocus = function() {
	  try {
	    focusLaterElement.focus();
	  }
	  catch (e) {
	    console.warn('You tried to return focus to '+focusLaterElement+' but it is not in the DOM anymore');
	  }
	  focusLaterElement = null;
	};
	
	exports.setupScopedFocus = function(element) {
	  modalElement = element;
	
	  if (window.addEventListener) {
	    window.addEventListener('blur', handleBlur, false);
	    document.addEventListener('focus', handleFocus, true);
	  } else {
	    window.attachEvent('onBlur', handleBlur);
	    document.attachEvent('onFocus', handleFocus);
	  }
	};
	
	exports.teardownScopedFocus = function() {
	  modalElement = null;
	
	  if (window.addEventListener) {
	    window.removeEventListener('blur', handleBlur);
	    document.removeEventListener('focus', handleFocus);
	  } else {
	    window.detachEvent('onBlur', handleBlur);
	    document.detachEvent('onFocus', handleFocus);
	  }
	};
	
	


/***/ },
/* 194 */
/***/ function(module, exports, __webpack_require__) {

	var findTabbable = __webpack_require__(87);
	
	module.exports = function(node, event) {
	  var tabbable = findTabbable(node);
	  if (!tabbable.length) {
	      event.preventDefault();
	      return;
	  }
	  var finalTabbable = tabbable[event.shiftKey ? 0 : tabbable.length - 1];
	  var leavingFinalTabbable = (
	    finalTabbable === document.activeElement ||
	    // handle immediate shift+tab after opening with mouse
	    node === document.activeElement
	  );
	  if (!leavingFinalTabbable) return;
	  event.preventDefault();
	  var target = tabbable[event.shiftKey ? tabbable.length - 1 : 0];
	  target.focus();
	};


/***/ },
/* 195 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(190);
	


/***/ },
/* 196 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports["default"] = undefined;
	
	var _react = __webpack_require__(1);
	
	var _storeShape = __webpack_require__(89);
	
	var _storeShape2 = _interopRequireDefault(_storeShape);
	
	var _warning = __webpack_require__(90);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var didWarnAboutReceivingStore = false;
	function warnAboutReceivingStore() {
	  if (didWarnAboutReceivingStore) {
	    return;
	  }
	  didWarnAboutReceivingStore = true;
	
	  (0, _warning2["default"])('<Provider> does not support changing `store` on the fly. ' + 'It is most likely that you see this error because you updated to ' + 'Redux 2.x and React Redux 2.x which no longer hot reload reducers ' + 'automatically. See https://github.com/reactjs/react-redux/releases/' + 'tag/v2.0.0 for the migration instructions.');
	}
	
	var Provider = function (_Component) {
	  _inherits(Provider, _Component);
	
	  Provider.prototype.getChildContext = function getChildContext() {
	    return { store: this.store };
	  };
	
	  function Provider(props, context) {
	    _classCallCheck(this, Provider);
	
	    var _this = _possibleConstructorReturn(this, _Component.call(this, props, context));
	
	    _this.store = props.store;
	    return _this;
	  }
	
	  Provider.prototype.render = function render() {
	    var children = this.props.children;
	
	    return _react.Children.only(children);
	  };
	
	  return Provider;
	}(_react.Component);
	
	exports["default"] = Provider;
	
	if (false) {
	  Provider.prototype.componentWillReceiveProps = function (nextProps) {
	    var store = this.store;
	    var nextStore = nextProps.store;
	
	    if (store !== nextStore) {
	      warnAboutReceivingStore();
	    }
	  };
	}
	
	Provider.propTypes = {
	  store: _storeShape2["default"].isRequired,
	  children: _react.PropTypes.element.isRequired
	};
	Provider.childContextTypes = {
	  store: _storeShape2["default"].isRequired
	};

/***/ },
/* 197 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.__esModule = true;
	exports["default"] = connect;
	
	var _react = __webpack_require__(1);
	
	var _storeShape = __webpack_require__(89);
	
	var _storeShape2 = _interopRequireDefault(_storeShape);
	
	var _shallowEqual = __webpack_require__(198);
	
	var _shallowEqual2 = _interopRequireDefault(_shallowEqual);
	
	var _wrapActionCreators = __webpack_require__(199);
	
	var _wrapActionCreators2 = _interopRequireDefault(_wrapActionCreators);
	
	var _warning = __webpack_require__(90);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _isPlainObject = __webpack_require__(48);
	
	var _isPlainObject2 = _interopRequireDefault(_isPlainObject);
	
	var _hoistNonReactStatics = __webpack_require__(158);
	
	var _hoistNonReactStatics2 = _interopRequireDefault(_hoistNonReactStatics);
	
	var _invariant = __webpack_require__(159);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var defaultMapStateToProps = function defaultMapStateToProps(state) {
	  return {};
	}; // eslint-disable-line no-unused-vars
	var defaultMapDispatchToProps = function defaultMapDispatchToProps(dispatch) {
	  return { dispatch: dispatch };
	};
	var defaultMergeProps = function defaultMergeProps(stateProps, dispatchProps, parentProps) {
	  return _extends({}, parentProps, stateProps, dispatchProps);
	};
	
	function getDisplayName(WrappedComponent) {
	  return WrappedComponent.displayName || WrappedComponent.name || 'Component';
	}
	
	var errorObject = { value: null };
	function tryCatch(fn, ctx) {
	  try {
	    return fn.apply(ctx);
	  } catch (e) {
	    errorObject.value = e;
	    return errorObject;
	  }
	}
	
	// Helps track hot reloading.
	var nextVersion = 0;
	
	function connect(mapStateToProps, mapDispatchToProps, mergeProps) {
	  var options = arguments.length <= 3 || arguments[3] === undefined ? {} : arguments[3];
	
	  var shouldSubscribe = Boolean(mapStateToProps);
	  var mapState = mapStateToProps || defaultMapStateToProps;
	
	  var mapDispatch = undefined;
	  if (typeof mapDispatchToProps === 'function') {
	    mapDispatch = mapDispatchToProps;
	  } else if (!mapDispatchToProps) {
	    mapDispatch = defaultMapDispatchToProps;
	  } else {
	    mapDispatch = (0, _wrapActionCreators2["default"])(mapDispatchToProps);
	  }
	
	  var finalMergeProps = mergeProps || defaultMergeProps;
	  var _options$pure = options.pure;
	  var pure = _options$pure === undefined ? true : _options$pure;
	  var _options$withRef = options.withRef;
	  var withRef = _options$withRef === undefined ? false : _options$withRef;
	
	  var checkMergedEquals = pure && finalMergeProps !== defaultMergeProps;
	
	  // Helps track hot reloading.
	  var version = nextVersion++;
	
	  return function wrapWithConnect(WrappedComponent) {
	    var connectDisplayName = 'Connect(' + getDisplayName(WrappedComponent) + ')';
	
	    function checkStateShape(props, methodName) {
	      if (!(0, _isPlainObject2["default"])(props)) {
	        (0, _warning2["default"])(methodName + '() in ' + connectDisplayName + ' must return a plain object. ' + ('Instead received ' + props + '.'));
	      }
	    }
	
	    function computeMergedProps(stateProps, dispatchProps, parentProps) {
	      var mergedProps = finalMergeProps(stateProps, dispatchProps, parentProps);
	      if (false) {
	        checkStateShape(mergedProps, 'mergeProps');
	      }
	      return mergedProps;
	    }
	
	    var Connect = function (_Component) {
	      _inherits(Connect, _Component);
	
	      Connect.prototype.shouldComponentUpdate = function shouldComponentUpdate() {
	        return !pure || this.haveOwnPropsChanged || this.hasStoreStateChanged;
	      };
	
	      function Connect(props, context) {
	        _classCallCheck(this, Connect);
	
	        var _this = _possibleConstructorReturn(this, _Component.call(this, props, context));
	
	        _this.version = version;
	        _this.store = props.store || context.store;
	
	        (0, _invariant2["default"])(_this.store, 'Could not find "store" in either the context or ' + ('props of "' + connectDisplayName + '". ') + 'Either wrap the root component in a <Provider>, ' + ('or explicitly pass "store" as a prop to "' + connectDisplayName + '".'));
	
	        var storeState = _this.store.getState();
	        _this.state = { storeState: storeState };
	        _this.clearCache();
	        return _this;
	      }
	
	      Connect.prototype.computeStateProps = function computeStateProps(store, props) {
	        if (!this.finalMapStateToProps) {
	          return this.configureFinalMapState(store, props);
	        }
	
	        var state = store.getState();
	        var stateProps = this.doStatePropsDependOnOwnProps ? this.finalMapStateToProps(state, props) : this.finalMapStateToProps(state);
	
	        if (false) {
	          checkStateShape(stateProps, 'mapStateToProps');
	        }
	        return stateProps;
	      };
	
	      Connect.prototype.configureFinalMapState = function configureFinalMapState(store, props) {
	        var mappedState = mapState(store.getState(), props);
	        var isFactory = typeof mappedState === 'function';
	
	        this.finalMapStateToProps = isFactory ? mappedState : mapState;
	        this.doStatePropsDependOnOwnProps = this.finalMapStateToProps.length !== 1;
	
	        if (isFactory) {
	          return this.computeStateProps(store, props);
	        }
	
	        if (false) {
	          checkStateShape(mappedState, 'mapStateToProps');
	        }
	        return mappedState;
	      };
	
	      Connect.prototype.computeDispatchProps = function computeDispatchProps(store, props) {
	        if (!this.finalMapDispatchToProps) {
	          return this.configureFinalMapDispatch(store, props);
	        }
	
	        var dispatch = store.dispatch;
	
	        var dispatchProps = this.doDispatchPropsDependOnOwnProps ? this.finalMapDispatchToProps(dispatch, props) : this.finalMapDispatchToProps(dispatch);
	
	        if (false) {
	          checkStateShape(dispatchProps, 'mapDispatchToProps');
	        }
	        return dispatchProps;
	      };
	
	      Connect.prototype.configureFinalMapDispatch = function configureFinalMapDispatch(store, props) {
	        var mappedDispatch = mapDispatch(store.dispatch, props);
	        var isFactory = typeof mappedDispatch === 'function';
	
	        this.finalMapDispatchToProps = isFactory ? mappedDispatch : mapDispatch;
	        this.doDispatchPropsDependOnOwnProps = this.finalMapDispatchToProps.length !== 1;
	
	        if (isFactory) {
	          return this.computeDispatchProps(store, props);
	        }
	
	        if (false) {
	          checkStateShape(mappedDispatch, 'mapDispatchToProps');
	        }
	        return mappedDispatch;
	      };
	
	      Connect.prototype.updateStatePropsIfNeeded = function updateStatePropsIfNeeded() {
	        var nextStateProps = this.computeStateProps(this.store, this.props);
	        if (this.stateProps && (0, _shallowEqual2["default"])(nextStateProps, this.stateProps)) {
	          return false;
	        }
	
	        this.stateProps = nextStateProps;
	        return true;
	      };
	
	      Connect.prototype.updateDispatchPropsIfNeeded = function updateDispatchPropsIfNeeded() {
	        var nextDispatchProps = this.computeDispatchProps(this.store, this.props);
	        if (this.dispatchProps && (0, _shallowEqual2["default"])(nextDispatchProps, this.dispatchProps)) {
	          return false;
	        }
	
	        this.dispatchProps = nextDispatchProps;
	        return true;
	      };
	
	      Connect.prototype.updateMergedPropsIfNeeded = function updateMergedPropsIfNeeded() {
	        var nextMergedProps = computeMergedProps(this.stateProps, this.dispatchProps, this.props);
	        if (this.mergedProps && checkMergedEquals && (0, _shallowEqual2["default"])(nextMergedProps, this.mergedProps)) {
	          return false;
	        }
	
	        this.mergedProps = nextMergedProps;
	        return true;
	      };
	
	      Connect.prototype.isSubscribed = function isSubscribed() {
	        return typeof this.unsubscribe === 'function';
	      };
	
	      Connect.prototype.trySubscribe = function trySubscribe() {
	        if (shouldSubscribe && !this.unsubscribe) {
	          this.unsubscribe = this.store.subscribe(this.handleChange.bind(this));
	          this.handleChange();
	        }
	      };
	
	      Connect.prototype.tryUnsubscribe = function tryUnsubscribe() {
	        if (this.unsubscribe) {
	          this.unsubscribe();
	          this.unsubscribe = null;
	        }
	      };
	
	      Connect.prototype.componentDidMount = function componentDidMount() {
	        this.trySubscribe();
	      };
	
	      Connect.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	        if (!pure || !(0, _shallowEqual2["default"])(nextProps, this.props)) {
	          this.haveOwnPropsChanged = true;
	        }
	      };
	
	      Connect.prototype.componentWillUnmount = function componentWillUnmount() {
	        this.tryUnsubscribe();
	        this.clearCache();
	      };
	
	      Connect.prototype.clearCache = function clearCache() {
	        this.dispatchProps = null;
	        this.stateProps = null;
	        this.mergedProps = null;
	        this.haveOwnPropsChanged = true;
	        this.hasStoreStateChanged = true;
	        this.haveStatePropsBeenPrecalculated = false;
	        this.statePropsPrecalculationError = null;
	        this.renderedElement = null;
	        this.finalMapDispatchToProps = null;
	        this.finalMapStateToProps = null;
	      };
	
	      Connect.prototype.handleChange = function handleChange() {
	        if (!this.unsubscribe) {
	          return;
	        }
	
	        var storeState = this.store.getState();
	        var prevStoreState = this.state.storeState;
	        if (pure && prevStoreState === storeState) {
	          return;
	        }
	
	        if (pure && !this.doStatePropsDependOnOwnProps) {
	          var haveStatePropsChanged = tryCatch(this.updateStatePropsIfNeeded, this);
	          if (!haveStatePropsChanged) {
	            return;
	          }
	          if (haveStatePropsChanged === errorObject) {
	            this.statePropsPrecalculationError = errorObject.value;
	          }
	          this.haveStatePropsBeenPrecalculated = true;
	        }
	
	        this.hasStoreStateChanged = true;
	        this.setState({ storeState: storeState });
	      };
	
	      Connect.prototype.getWrappedInstance = function getWrappedInstance() {
	        (0, _invariant2["default"])(withRef, 'To access the wrapped instance, you need to specify ' + '{ withRef: true } as the fourth argument of the connect() call.');
	
	        return this.refs.wrappedInstance;
	      };
	
	      Connect.prototype.render = function render() {
	        var haveOwnPropsChanged = this.haveOwnPropsChanged;
	        var hasStoreStateChanged = this.hasStoreStateChanged;
	        var haveStatePropsBeenPrecalculated = this.haveStatePropsBeenPrecalculated;
	        var statePropsPrecalculationError = this.statePropsPrecalculationError;
	        var renderedElement = this.renderedElement;
	
	        this.haveOwnPropsChanged = false;
	        this.hasStoreStateChanged = false;
	        this.haveStatePropsBeenPrecalculated = false;
	        this.statePropsPrecalculationError = null;
	
	        if (statePropsPrecalculationError) {
	          throw statePropsPrecalculationError;
	        }
	
	        var shouldUpdateStateProps = true;
	        var shouldUpdateDispatchProps = true;
	        if (pure && renderedElement) {
	          shouldUpdateStateProps = hasStoreStateChanged || haveOwnPropsChanged && this.doStatePropsDependOnOwnProps;
	          shouldUpdateDispatchProps = haveOwnPropsChanged && this.doDispatchPropsDependOnOwnProps;
	        }
	
	        var haveStatePropsChanged = false;
	        var haveDispatchPropsChanged = false;
	        if (haveStatePropsBeenPrecalculated) {
	          haveStatePropsChanged = true;
	        } else if (shouldUpdateStateProps) {
	          haveStatePropsChanged = this.updateStatePropsIfNeeded();
	        }
	        if (shouldUpdateDispatchProps) {
	          haveDispatchPropsChanged = this.updateDispatchPropsIfNeeded();
	        }
	
	        var haveMergedPropsChanged = true;
	        if (haveStatePropsChanged || haveDispatchPropsChanged || haveOwnPropsChanged) {
	          haveMergedPropsChanged = this.updateMergedPropsIfNeeded();
	        } else {
	          haveMergedPropsChanged = false;
	        }
	
	        if (!haveMergedPropsChanged && renderedElement) {
	          return renderedElement;
	        }
	
	        if (withRef) {
	          this.renderedElement = (0, _react.createElement)(WrappedComponent, _extends({}, this.mergedProps, {
	            ref: 'wrappedInstance'
	          }));
	        } else {
	          this.renderedElement = (0, _react.createElement)(WrappedComponent, this.mergedProps);
	        }
	
	        return this.renderedElement;
	      };
	
	      return Connect;
	    }(_react.Component);
	
	    Connect.displayName = connectDisplayName;
	    Connect.WrappedComponent = WrappedComponent;
	    Connect.contextTypes = {
	      store: _storeShape2["default"]
	    };
	    Connect.propTypes = {
	      store: _storeShape2["default"]
	    };
	
	    if (false) {
	      Connect.prototype.componentWillUpdate = function componentWillUpdate() {
	        if (this.version === version) {
	          return;
	        }
	
	        // We are hot reloading!
	        this.version = version;
	        this.trySubscribe();
	        this.clearCache();
	      };
	    }
	
	    return (0, _hoistNonReactStatics2["default"])(Connect, WrappedComponent);
	  };
	}

/***/ },
/* 198 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = shallowEqual;
	function shallowEqual(objA, objB) {
	  if (objA === objB) {
	    return true;
	  }
	
	  var keysA = Object.keys(objA);
	  var keysB = Object.keys(objB);
	
	  if (keysA.length !== keysB.length) {
	    return false;
	  }
	
	  // Test for A's keys different from B.
	  var hasOwn = Object.prototype.hasOwnProperty;
	  for (var i = 0; i < keysA.length; i++) {
	    if (!hasOwn.call(objB, keysA[i]) || objA[keysA[i]] !== objB[keysA[i]]) {
	      return false;
	    }
	  }
	
	  return true;
	}

/***/ },
/* 199 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports["default"] = wrapActionCreators;
	
	var _redux = __webpack_require__(75);
	
	function wrapActionCreators(actionCreators) {
	  return function (dispatch) {
	    return (0, _redux.bindActionCreators)(actionCreators, dispatch);
	  };
	}

/***/ },
/* 200 */
/***/ function(module, exports, __webpack_require__) {

	// @remove-on-eject-begin
	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	// @remove-on-eject-end
	
	if (typeof Promise === 'undefined') {
	  // Rejection tracking prevents a common issue where React gets into an
	  // inconsistent state due to an error, but it gets swallowed by a Promise,
	  // and the user has no idea what causes React's erratic future behavior.
	  __webpack_require__(303).enable();
	  window.Promise = __webpack_require__(302);
	}
	
	// fetch() polyfill for making API calls.
	__webpack_require__(304);
	
	// Object.assign() is commonly used with React.
	// It will use the native implementation if it's present and isn't buggy.
	Object.assign = __webpack_require__(301);


/***/ },
/* 201 */
/***/ function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {"use strict";
	
	// Use the fastest means possible to execute a task in its own turn, with
	// priority over other events including IO, animation, reflow, and redraw
	// events in browsers.
	//
	// An exception thrown by a task will permanently interrupt the processing of
	// subsequent tasks. The higher level `asap` function ensures that if an
	// exception is thrown by a task, that the task queue will continue flushing as
	// soon as possible, but if you use `rawAsap` directly, you are responsible to
	// either ensure that no exceptions are thrown from your task, or to manually
	// call `rawAsap.requestFlush` if an exception is thrown.
	module.exports = rawAsap;
	function rawAsap(task) {
	    if (!queue.length) {
	        requestFlush();
	        flushing = true;
	    }
	    // Equivalent to push, but avoids a function call.
	    queue[queue.length] = task;
	}
	
	var queue = [];
	// Once a flush has been requested, no further calls to `requestFlush` are
	// necessary until the next `flush` completes.
	var flushing = false;
	// `requestFlush` is an implementation-specific method that attempts to kick
	// off a `flush` event as quickly as possible. `flush` will attempt to exhaust
	// the event queue before yielding to the browser's own event loop.
	var requestFlush;
	// The position of the next task to execute in the task queue. This is
	// preserved between calls to `flush` so that it can be resumed if
	// a task throws an exception.
	var index = 0;
	// If a task schedules additional tasks recursively, the task queue can grow
	// unbounded. To prevent memory exhaustion, the task queue will periodically
	// truncate already-completed tasks.
	var capacity = 1024;
	
	// The flush function processes all tasks that have been scheduled with
	// `rawAsap` unless and until one of those tasks throws an exception.
	// If a task throws an exception, `flush` ensures that its state will remain
	// consistent and will resume where it left off when called again.
	// However, `flush` does not make any arrangements to be called again if an
	// exception is thrown.
	function flush() {
	    while (index < queue.length) {
	        var currentIndex = index;
	        // Advance the index before calling the task. This ensures that we will
	        // begin flushing on the next task the task throws an error.
	        index = index + 1;
	        queue[currentIndex].call();
	        // Prevent leaking memory for long chains of recursive calls to `asap`.
	        // If we call `asap` within tasks scheduled by `asap`, the queue will
	        // grow, but to avoid an O(n) walk for every task we execute, we don't
	        // shift tasks off the queue after they have been executed.
	        // Instead, we periodically shift 1024 tasks off the queue.
	        if (index > capacity) {
	            // Manually shift all values starting at the index back to the
	            // beginning of the queue.
	            for (var scan = 0, newLength = queue.length - index; scan < newLength; scan++) {
	                queue[scan] = queue[scan + index];
	            }
	            queue.length -= index;
	            index = 0;
	        }
	    }
	    queue.length = 0;
	    index = 0;
	    flushing = false;
	}
	
	// `requestFlush` is implemented using a strategy based on data collected from
	// every available SauceLabs Selenium web driver worker at time of writing.
	// https://docs.google.com/spreadsheets/d/1mG-5UYGup5qxGdEMWkhP6BWCz053NUb2E1QoUTU16uA/edit#gid=783724593
	
	// Safari 6 and 6.1 for desktop, iPad, and iPhone are the only browsers that
	// have WebKitMutationObserver but not un-prefixed MutationObserver.
	// Must use `global` instead of `window` to work in both frames and web
	// workers. `global` is a provision of Browserify, Mr, Mrs, or Mop.
	var BrowserMutationObserver = global.MutationObserver || global.WebKitMutationObserver;
	
	// MutationObservers are desirable because they have high priority and work
	// reliably everywhere they are implemented.
	// They are implemented in all modern browsers.
	//
	// - Android 4-4.3
	// - Chrome 26-34
	// - Firefox 14-29
	// - Internet Explorer 11
	// - iPad Safari 6-7.1
	// - iPhone Safari 7-7.1
	// - Safari 6-7
	if (typeof BrowserMutationObserver === "function") {
	    requestFlush = makeRequestCallFromMutationObserver(flush);
	
	// MessageChannels are desirable because they give direct access to the HTML
	// task queue, are implemented in Internet Explorer 10, Safari 5.0-1, and Opera
	// 11-12, and in web workers in many engines.
	// Although message channels yield to any queued rendering and IO tasks, they
	// would be better than imposing the 4ms delay of timers.
	// However, they do not work reliably in Internet Explorer or Safari.
	
	// Internet Explorer 10 is the only browser that has setImmediate but does
	// not have MutationObservers.
	// Although setImmediate yields to the browser's renderer, it would be
	// preferrable to falling back to setTimeout since it does not have
	// the minimum 4ms penalty.
	// Unfortunately there appears to be a bug in Internet Explorer 10 Mobile (and
	// Desktop to a lesser extent) that renders both setImmediate and
	// MessageChannel useless for the purposes of ASAP.
	// https://github.com/kriskowal/q/issues/396
	
	// Timers are implemented universally.
	// We fall back to timers in workers in most engines, and in foreground
	// contexts in the following browsers.
	// However, note that even this simple case requires nuances to operate in a
	// broad spectrum of browsers.
	//
	// - Firefox 3-13
	// - Internet Explorer 6-9
	// - iPad Safari 4.3
	// - Lynx 2.8.7
	} else {
	    requestFlush = makeRequestCallFromTimer(flush);
	}
	
	// `requestFlush` requests that the high priority event queue be flushed as
	// soon as possible.
	// This is useful to prevent an error thrown in a task from stalling the event
	// queue if the exception handled by Node.js’s
	// `process.on("uncaughtException")` or by a domain.
	rawAsap.requestFlush = requestFlush;
	
	// To request a high priority event, we induce a mutation observer by toggling
	// the text of a text node between "1" and "-1".
	function makeRequestCallFromMutationObserver(callback) {
	    var toggle = 1;
	    var observer = new BrowserMutationObserver(callback);
	    var node = document.createTextNode("");
	    observer.observe(node, {characterData: true});
	    return function requestCall() {
	        toggle = -toggle;
	        node.data = toggle;
	    };
	}
	
	// The message channel technique was discovered by Malte Ubl and was the
	// original foundation for this library.
	// http://www.nonblocking.io/2011/06/windownexttick.html
	
	// Safari 6.0.5 (at least) intermittently fails to create message ports on a
	// page's first load. Thankfully, this version of Safari supports
	// MutationObservers, so we don't need to fall back in that case.
	
	// function makeRequestCallFromMessageChannel(callback) {
	//     var channel = new MessageChannel();
	//     channel.port1.onmessage = callback;
	//     return function requestCall() {
	//         channel.port2.postMessage(0);
	//     };
	// }
	
	// For reasons explained above, we are also unable to use `setImmediate`
	// under any circumstances.
	// Even if we were, there is another bug in Internet Explorer 10.
	// It is not sufficient to assign `setImmediate` to `requestFlush` because
	// `setImmediate` must be called *by name* and therefore must be wrapped in a
	// closure.
	// Never forget.
	
	// function makeRequestCallFromSetImmediate(callback) {
	//     return function requestCall() {
	//         setImmediate(callback);
	//     };
	// }
	
	// Safari 6.0 has a problem where timers will get lost while the user is
	// scrolling. This problem does not impact ASAP because Safari 6.0 supports
	// mutation observers, so that implementation is used instead.
	// However, if we ever elect to use timers in Safari, the prevalent work-around
	// is to add a scroll event listener that calls for a flush.
	
	// `setTimeout` does not call the passed callback if the delay is less than
	// approximately 7 in web workers in Firefox 8 through 18, and sometimes not
	// even then.
	
	function makeRequestCallFromTimer(callback) {
	    return function requestCall() {
	        // We dispatch a timeout with a specified delay of 0 for engines that
	        // can reliably accommodate that request. This will usually be snapped
	        // to a 4 milisecond delay, but once we're flushing, there's no delay
	        // between events.
	        var timeoutHandle = setTimeout(handleTimer, 0);
	        // However, since this timer gets frequently dropped in Firefox
	        // workers, we enlist an interval handle that will try to fire
	        // an event 20 times per second until it succeeds.
	        var intervalHandle = setInterval(handleTimer, 50);
	
	        function handleTimer() {
	            // Whichever timer succeeds will cancel both timers and
	            // execute the callback.
	            clearTimeout(timeoutHandle);
	            clearInterval(intervalHandle);
	            callback();
	        }
	    };
	}
	
	// This is for `asap.js` only.
	// Its name will be periodically randomized to break any code that depends on
	// its existence.
	rawAsap.makeRequestCallFromTimer = makeRequestCallFromTimer;
	
	// ASAP was originally a nextTick shim included in Q. This was factored out
	// into this ASAP package. It was later adapted to RSVP which made further
	// amendments. These decisions, particularly to marginalize MessageChannel and
	// to capture the MutationObserver implementation in a closure, were integrated
	// back into ASAP proper.
	// https://github.com/tildeio/rsvp.js/blob/cddf7232546a9cf858524b75cde6f9edf72620a7/lib/rsvp/asap.js
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 202 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	/* CREATE FILE NAMED config.dev.js */
	var fixtures = __webpack_require__(224);
	
	exports.default = {
	  debug: true,
	  defaultUrl: 'school/test_schedules/schedules/2016_2017',
	  fixtures: fixtures,
	  use_fixtures: false,
	  feature_flags: {
	    cohort_selection: true,
	    core_vs_noncore_layers: true
	  },
	  reduxDevTools: window.devToolsExtension
	};

/***/ },
/* 203 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	/* global process */
	var devMode = process && ("production") === 'development';
	var config = {};
	
	try {
	  config = __webpack_require__(devMode ? 202 : 204);
	} catch (e) {
	  console.warn('Please create a file named src/config/config.dev.js');
	}
	
	exports.default = Object.assign({
	  defaultUrl: 'school/demo/schedules/2016_2017',
	  feature_flags: {
	    cohort_selection: true,
	    core_vs_noncore_layers: false
	  }
	}, config);
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(41)))

/***/ },
/* 204 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {};

/***/ },
/* 205 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.StudentIcon = exports.ExportIcon = exports.LayersIcon = exports.SelectIcon = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SelectIcon = exports.SelectIcon = function SelectIcon(props) {
	  return _react2.default.createElement(
	    "svg",
	    { width: "25", height: "25", title: props.title, viewBox: "-1 -1 18 26", xmlns: "http://www.w3.org/2000/svg" },
	    _react2.default.createElement("path", { d: "M1.174 0a1.17 1.17 0 0 0-1.17 1.17L0 18.977a1.171 1.171 0 0 0 1.644 1.07l3.922-1.737 2.21 4.992a1.17 1.17 0 0 0 1.545.596l1.604-.71 1.604-.71a1.17 1.17 0 0 0 .596-1.544l-2.21-4.993 3.922-1.736a1.171 1.171 0 0 0 .313-1.936L1.96.303A1.173 1.173 0 0 0 1.175 0z", stroke: "#ffffff", fill: "none" })
	  );
	};
	
	var LayersIcon = exports.LayersIcon = function LayersIcon(props) {
	  return _react2.default.createElement(
	    "svg",
	    { width: "25", height: "25", title: props.title, viewBox: "2 0 33 33", xmlns: "http://www.w3.org/2000/svg" },
	    _react2.default.createElement("path", { d: "M29.09 12.65L35 9.24 19 0 3 9.238l5.91 3.412L3 16.062l5.91 3.412L3 22.886l16 9.239 16-9.239-5.91-3.412L35 16.062l-5.91-3.412zM19 1.743L31.98 9.24 19 16.734 6.02 9.238 19 1.743zm-8.581 11.78L19 18.476l8.581-4.955 4.4 2.54L19 23.558 6.02 16.062l4.399-2.54zm21.562 9.363L19 30.381 6.02 22.886l4.399-2.54L19 25.3l8.581-4.955 4.4 2.54z", fill: "#ffffff", fillRule: "evenodd" })
	  );
	};
	
	var ExportIcon = exports.ExportIcon = function ExportIcon(props) {
	  return _react2.default.createElement(
	    "svg",
	    { width: "25", height: "25", title: props.title, viewBox: "107 2 20 23", xmlns: "http://www.w3.org/2000/svg" },
	    _react2.default.createElement("path", { d: "M117.013 19.523V3.472l4.298 4.493.519-.542L116.642 2l-5.187 5.422.519.543 4.297-4.493v16.05h.742zm8.529-14.806l.001 17.416-.001 1.125h-17.8V4.717h-.741L107 22.133l.001 1.867h19.283V4.717h-.742z", fill: "#E1E1E1", fillRule: "evenodd" })
	  );
	};
	
	var StudentIcon = exports.StudentIcon = function StudentIcon(props) {
	  return _react2.default.createElement(
	    "svg",
	    { width: "12", height: "27", viewBox: "334 504 12 27", xmlns: "http://www.w3.org/2000/svg" },
	    _react2.default.createElement("path", { d: "M337.347 529.833c0 .724.396 1.086 1.19 1.086.795 0 1.192-.362 1.192-1.086v-9.781h1.222v9.782c0 .723.399 1.086 1.193 1.086s1.193-.363 1.193-1.086V513.17h.58v6.002c0 .38.147.656.438.828.29.173.589.173.902 0 .31-.172.464-.448.464-.828v-6.468c0-.69-.264-1.224-.785-1.604-.523-.38-1.25-.57-2.18-.57h-4.771c-.892 0-1.618.173-2.18.518-.562.345-.844.88-.844 1.605v6.882c0 .31.155.534.466.672.31.138.61.138.9 0 .29-.138.438-.362.438-.672v-6.365h.583v16.663h-.001zm.087-22.876c0 .604.242 1.121.726 1.552.486.431 1.067.648 1.744.648.681 0 1.26-.217 1.748-.648.484-.43.726-.957.726-1.578 0-.586-.242-1.096-.726-1.526-.487-.431-1.066-.648-1.748-.648-.677 0-1.258.217-1.744.648-.484.43-.726.948-.726 1.552z", fill: "#D8D8D8", fillRule: "evenodd" })
	  );
	};

/***/ },
/* 206 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _abl = __webpack_require__(12);
	
	var _abl2 = _interopRequireDefault(_abl);
	
	var _router = __webpack_require__(275);
	
	var _router2 = _interopRequireDefault(_router);
	
	__webpack_require__(289);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_abl2.default.setRouter(new _router2.default());

/***/ },
/* 207 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _index = __webpack_require__(5);
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AppActions = {
	
		hideOpenTrays: function hideOpenTrays() {
			return {
				type: _index2.default.HIDE_OPEN_TRAYS,
				payload: {}
			};
		}
	
	};
	
	exports.default = AppActions;

/***/ },
/* 208 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _index = __webpack_require__(5);
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AuthActions = {
	
		requestAuthentication: function requestAuthentication() {
			return function (dispatch, getState, clients) {
				dispatch({
					type: _index2.default.REQUEST_AUTHENTICATION,
					payload: {}
				});
	
				clients.auth.onAuthChange(function (authenticated) {
					dispatch(this.requestAuthenticationSuccess(authenticated));
				}.bind(this));
			}.bind(this);
		},
	
		requestAuthenticationSuccess: function requestAuthenticationSuccess(authenticated) {
			return {
				type: _index2.default.REQUEST_AUTHENTICATION_SUCCESS,
				payload: {
					initialized: true,
					authenticated: authenticated
				}
			};
		},
	
		requestAuthenticationFail: function requestAuthenticationFail(err) {
			return {
				type: _index2.default.REQUEST_AUTHENTICATION_FAIL,
				payload: {
					error: err
				}
			};
		},
	
		requestSignIn: function requestSignIn() {
			return function (dispatch, getState, clients) {
				dispatch({
					type: _index2.default.REQUEST_SIGN_IN,
					payload: {}
				}, true);
	
				clients.auth.signIn();
			};
		}
	};
	
	exports.default = AuthActions;

/***/ },
/* 209 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _index = __webpack_require__(5);
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CohortActions = {
	  requestCohortsSuccess: function requestCohortsSuccess(participants) {
	    return {
	      type: _index2.default.REQUEST_COHORTS_SUCCESS,
	      payload: {
	        participants: participants
	      }
	    };
	  },
	
	  requestCohortsFail: function requestCohortsFail() {
	    return {
	      type: _index2.default.REQUEST_COHORTS_FAIL,
	      payload: {}
	    };
	  },
	
	  selectCohort: function selectCohort(id, selected) {
	    return {
	      type: _index2.default.SELECT_COHORT,
	      payload: {
	        id: id,
	        selected: selected
	      }
	    };
	  },
	  unSelectCohorts: function unSelectCohorts() {
	    return {
	      type: _index2.default.UNSELECT_COHORTS,
	      payload: {}
	    };
	  }
	};
	
	exports.default = CohortActions;

/***/ },
/* 210 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _index = __webpack_require__(5);
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MeetingActions = {
		requestMeetingsSuccess: function requestMeetingsSuccess(meetings) {
			return {
				type: _index2.default.REQUEST_MEETINGS_SUCCESS,
				payload: {
					meetings: meetings
				}
			};
		},
	
		requestScheduledMeetingsSuccess: function requestScheduledMeetingsSuccess(scheduledMeetings) {
			return function (publish, clients) {
				publish({
					type: _index2.default.REQUEST_SCHEDULED_MEETINGS_SUCCESS,
					payload: {
						scheduledMeetings: scheduledMeetings
					}
				});
			};
		},
	
		changeMeetingNames: function changeMeetingNames(selectedMeetings, meeting_id, params) {
			return function (publish, clients) {
				var cells = [];
				var values = [];
				publish({
					type: _index2.default.CHANGE_SCHEDULED_MEETING_NAMES,
					payload: {
						ids: selectedMeetings.map(function (meeting) {
							return meeting.id;
						}),
						meeting_id: meeting_id
					}
				});
	
				selectedMeetings.forEach(function (meeting) {
					cells = cells.concat(meeting.sheet_references);
					values.push(meeting_id);
				});
	
				// Not actually persisting updates right now, but uncomment
				// the following line to see what would be updated in the 
				// spreadsheet if we were:
				// console.log("Updating Spreadsheet", cells, values);
			};
		},
	
		updateMeetingSuccess: function updateMeetingSuccess(response) {
			console.log(response);
		},
	
		updateMeetingFail: function updateMeetingFail(err) {
			console.log(err);
		}
	};
	
	exports.default = MeetingActions;

/***/ },
/* 211 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _index = __webpack_require__(5);
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MeetingLabelActions = {
	
	  selectMeetingLabel: function selectMeetingLabel(id, selected) {
	    return {
	      type: _index2.default.SELECT_MEETING_LABEL,
	      payload: {
	        id: id,
	        selected: selected
	      }
	    };
	  }
	
	};
	
	exports.default = MeetingLabelActions;

/***/ },
/* 212 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _index = __webpack_require__(5);
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MeetingLayerActions = {
	
	  selectMeetingLayer: function selectMeetingLayer(id, selected) {
	    return {
	      type: _index2.default.SELECT_MEETING_LAYER,
	      payload: {
	        id: id,
	        selected: selected
	      }
	    };
	  }
	
	};
	
	exports.default = MeetingLayerActions;

/***/ },
/* 213 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _index = __webpack_require__(5);
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ModalActions = {
	
	  showModal: function showModal(isOpen) {
	    return {
	      type: _index2.default.SHOW_MODAL,
	      payload: {
	        isOpen: isOpen
	      }
	    };
	  }
	
	};
	
	exports.default = ModalActions;

/***/ },
/* 214 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _index = __webpack_require__(5);
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ParticipantActions = {
	  selectParticipantGroup: function selectParticipantGroup(type, group, selected) {
	    return {
	      type: _index2.default.SELECT_PARTICIPANTS_GROUP,
	      payload: {
	        type: type,
	        group: group,
	        selected: selected
	      }
	    };
	  }
	};
	
	exports.default = ParticipantActions;

/***/ },
/* 215 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _index = __webpack_require__(5);
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ScheduleActions = {
		selectSchool: function selectSchool(data) {
			return {
				type: _index2.default.SELECT_SCHOOL,
				payload: {
					school: data.school,
					term: data.term
				}
			};
		},
	
		requestSchedules: function requestSchedules(data) {
			var _this = this;
	
			return function (dispatch, getState, clients) {
	
				dispatch(_this.selectSchool(data));
				dispatch({
					type: _index2.default.REQUEST_SCHEDULES,
					payload: data
				});
	
				return clients.schedule.getList({
					school: data.school,
					term: data.term
				}).then(function (schedules) {
					dispatch(_this.requestSchedulesSuccess(schedules));
					dispatch(_this.requestSchedule({
						school: data.school,
						term: data.term,
						scheduleId: !data.scheduleId && schedules[0] ? schedules[0].id : data.scheduleId
					}));
				}, function (err) {
					dispatch(_this.requestSchedulesFail(err));
				});
			};
		},
	
		requestSchedulesSuccess: function requestSchedulesSuccess(schedules) {
			return {
				type: _index2.default.REQUEST_SCHEDULES_SUCCESS,
				payload: {
					schedules: schedules
				}
			};
		},
	
		requestSchedulesFail: function requestSchedulesFail(err) {
			console.log(err);
			return {
				type: _index2.default.REQUEST_SCHEDULE_FAIL,
				payload: {}
			};
		},
	
		changeSchedule: function changeSchedule(id) {
			return {
				type: _index2.default.CHANGE_SCHEDULE,
				payload: {
					id: id
				}
			};
		},
	
		requestSchedule: function requestSchedule(data) {
			var _this2 = this;
	
			return function (dispatch, getState, clients) {
				dispatch({
					type: _index2.default.REQUEST_SCHEDULE,
					payload: {}
				});
	
				return clients.schedule.get({
					school: data.school,
					term: data.term,
					scheduleId: data.scheduleId
				}).then(function (schedule) {
					dispatch(_this2.requestScheduleSuccess(schedule));
				}, function (err) {
					dispatch(_this2.requestScheduleFail(err));
				});
			};
		},
	
		requestScheduleSuccess: function requestScheduleSuccess(schedule) {
			var _this3 = this;
	
			return function (dispatch, getState, clients) {
				dispatch(_this3.requestTeachersSuccess(schedule.teachers));
				dispatch(_this3.requestCohortsSuccess(schedule.cohorts));
				dispatch(_this3.requestMeetingsSuccess(schedule.meetings));
				dispatch(_this3.requestScheduledMeetingsSuccess(schedule.scheduledMeetings));
				return dispatch({
					type: _index2.default.REQUEST_SCHEDULE_SUCCESS,
					payload: {
						schedule: schedule
					}
				});
			};
		},
	
		requestScheduleFail: function requestScheduleFail(err) {
			console.log(err);
			return {
				type: _index2.default.REQUEST_SCHEDULE_FAIL,
				payload: {}
			};
		}
	};
	
	exports.default = ScheduleActions;

/***/ },
/* 216 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _index = __webpack_require__(5);
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ScheduleControlsActions = {
		selectControlsMenuItem: function selectControlsMenuItem(id, selected) {
			return {
				type: _index2.default.SELECT_CONTROLS_MENU_ITEM,
				payload: {
					id: id,
					selected: selected
				}
			};
		},
	
		selectLayersMenuItem: function selectLayersMenuItem(selected) {
			return {
				type: _index2.default.SELECT_LAYERS_MENU_ITEM,
				payload: {
					selected: selected
				}
			};
		}
	};
	
	exports.default = ScheduleControlsActions;

/***/ },
/* 217 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _index = __webpack_require__(5);
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ScheduleViewerActions = {
	
		selectViewerCell: function selectViewerCell(id, scheduledMeetingId, selected) {
			return {
				type: _index2.default.SELECT_VIEWER_CELL,
				payload: {
					id: id,
					scheduledMeetingId: scheduledMeetingId,
					selected: selected
				}
			};
		},
	
		selectViewerColumn: function selectViewerColumn(index, name, value, selected) {
			return {
				type: _index2.default.SELECT_VIEWER_COLUMN,
				payload: {
					index: index,
					name: name,
					value: value,
					selected: selected
				}
			};
		},
	
		selectViewerSubColumn: function selectViewerSubColumn(index, name, value, selected) {
			return {
				type: _index2.default.SELECT_VIEWER_SUBCOLUMN,
				payload: {
					index: index,
					name: name,
					value: value,
					selected: selected
				}
			};
		},
	
		hideViewerColumn: function hideViewerColumn(index, name, value) {
			return {
				type: _index2.default.HIDE_VIEWER_COLUMN,
				payload: {
					index: index,
					name: name,
					value: value
				}
			};
		},
	
		unHideViewerColumns: function unHideViewerColumns() {
			return {
				type: _index2.default.UNHIDE_VIEWER_COLUMNS,
				payload: {}
			};
		}
	};
	
	exports.default = ScheduleViewerActions;

/***/ },
/* 218 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _index = __webpack_require__(5);
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var StudentCohortActions = {
	  changeStudentCohortFilter: function changeStudentCohortFilter(id, selected) {
	    return {
	      type: _index2.default.CHANGE_STUDENT_COHORT_FILTER,
	      payload: {
	        id: id,
	        selected: selected
	      }
	    };
	  }
	};
	
	exports.default = StudentCohortActions;

/***/ },
/* 219 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _index = __webpack_require__(5);
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TeacherActions = {
		requestTeachersSuccess: function requestTeachersSuccess(participants) {
			return {
				type: _index2.default.REQUEST_TEACHERS_SUCCESS,
				payload: {
					participants: participants
				}
			};
		},
	
		requestTeachersFail: function requestTeachersFail() {
			return {
				type: _index2.default.REQUEST_TEACHERS_FAIL,
				payload: {}
			};
		},
	
		selectTeacher: function selectTeacher(id, selected) {
			return {
				type: _index2.default.SELECT_TEACHER,
				payload: {
					id: id,
					selected: selected
				}
			};
		},
	
		selectTeachers: function selectTeachers(ids, selected, group_id) {
			return {
				type: _index2.default.SELECT_TEACHERS,
				payload: {
					ids: ids,
					selected: selected
				}
			};
		},
	
		unSelectTeachers: function unSelectTeachers() {
			return {
				type: _index2.default.UNSELECT_TEACHERS,
				payload: {}
			};
		}
	};
	
	exports.default = TeacherActions;

/***/ },
/* 220 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _abl = __webpack_require__(12);
	
	var _abl2 = _interopRequireDefault(_abl);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AuthAPI = _abl2.default.createClass({
	
		initialize: function initialize(props) {
			this.requestor = props.requestor || {};
		},
	
		onAuthChange: function onAuthChange(callback) {
			return this.requestor.authenticate(callback);
		},
	
		signIn: function signIn() {
			return this.requestor.signIn();
		}
	
	});
	
	exports.default = AuthAPI;

/***/ },
/* 221 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _abl = __webpack_require__(12);
	
	var _abl2 = _interopRequireDefault(_abl);
	
	var _google_api = __webpack_require__(222);
	
	var _google_api2 = _interopRequireDefault(_google_api);
	
	var _auth_api = __webpack_require__(220);
	
	var _auth_api2 = _interopRequireDefault(_auth_api);
	
	var _schedule_api = __webpack_require__(226);
	
	var _schedule_api2 = _interopRequireDefault(_schedule_api);
	
	var _mock_api = __webpack_require__(225);
	
	var _mock_api2 = _interopRequireDefault(_mock_api);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var requestor = _abl2.default.config.use_fixtures ? new _mock_api2.default() : new _google_api2.default();
	
	var clients = {
	  auth: new _auth_api2.default({ requestor: requestor }),
	  schedule: new _schedule_api2.default({ requestor: requestor })
	};
	
	exports.default = clients;

/***/ },
/* 222 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _abl = __webpack_require__(12);
	
	var _abl2 = _interopRequireDefault(_abl);
	
	var _google_sheet_processor = __webpack_require__(91);
	
	var _google_sheet_processor2 = _interopRequireDefault(_google_sheet_processor);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var GoogleAPI = _abl2.default.createClass({
	  initialize: function initialize(props) {
	    var _this = this;
	
	    props = props || {};
	    this.apiKey = props.apiKey || 'AIzaSyDZx1er56QwGTn7KB-E-QQRxvHE832jCII';
	    this.clientId = props.clientId || '55358074609-tlve91j1j6eje2j7vjdr77a8hthl226m.apps.googleusercontent.com';
	    this.scopes = props.scopes || ['https://www.googleapis.com/auth/spreadsheets', 'https://www.googleapis.com/auth/drive.metadata.readonly'];
	    this.sheetsUrl = props.sheetsUrl || 'https://sheets.googleapis.com/$discovery/rest?version=v4';
	    this.driveUrl = props.driveUrl || 'https://www.googleapis.com/auth/drive.readonly';
	    this.authenticated = false;
	    this.clientCount = this.scopes.length;
	    this.initialized = false;
	    this.authCallbacks = [];
	    this.gapi = this.gapi || window['gapi'];
	    this.gapi.load('client:auth2', function () {
	      return _this._initClient();
	    });
	  },
	
	  authenticate: function authenticate(callback) {
	    this.authCallbacks.push(callback);
	    if (this.initialized) {
	      callback(this.authenticated);
	    }
	  },
	
	  signIn: function signIn() {
	    this.gapi.auth2.getAuthInstance().signIn();
	  },
	
	  getFiles: function getFiles(props) {
	    return this.gapi.client.drive.files.list({
	      'pageSize': 20,
	      'corpus': 'user',
	      'spaces': 'drive',
	      'q': "'" + props.term + "' in parents and mimeType != 'application/vnd.google-apps.folder' and trashed = false",
	      'orderyBy': 'createdTime',
	      'fields': "nextPageToken, files(id, name, capabilities(canEdit))"
	    });
	  },
	
	  getSheet: function getSheet(props) {
	    return this.gapi.client.sheets.spreadsheets.get({
	      spreadsheetId: props.spreadsheetId,
	      ranges: props.ranges,
	      fields: 'spreadsheetId,properties.title,sheets(properties,data.rowData.values(formattedValue,effectiveFormat(backgroundColor)))'
	    }).then(function (response) {
	      var processor = new _google_sheet_processor2.default(response.result, props.version);
	      return processor.toJSON();
	    }, function (err) {
	      return err;
	    });
	  },
	
	  updateSheet: function updateSheet(props) {
	    return this.gapi.client.sheets.spreadsheets.values.update({
	      spreadsheetId: props.spreadsheetId,
	      range: props.range,
	      valueInputOption: 'USER_ENTERED',
	      majorDimension: 'COLUMNS',
	      values: [[props.value]]
	    });
	  },
	
	  batchUpdateSheet: function batchUpdateSheet(props) {
	    return this.gapi.client.sheets.spreadsheets.values.batchUpdate({
	      spreadsheetId: props.spreadsheetId,
	      valueInputOption: 'USER_ENTERED',
	      data: props.data
	    });
	  },
	
	  _initClient: function _initClient() {
	    var _this2 = this;
	
	    this.gapi.auth2.init({
	      client_id: this.clientId,
	      scope: this.scopes.join(' ') }).then(function () {
	      var auth2 = _this2.gapi.auth2.getAuthInstance();
	      auth2.isSignedIn.listen(_this2._handleAuthChange.bind(_this2));
	      _this2._initDrive(auth2);
	      _this2._initSheets(auth2);
	    });
	  },
	
	  _initSheets: function _initSheets(auth2) {
	    var _this3 = this;
	
	    this.gapi.client.load(this.sheetsUrl).then(function () {
	      _this3.authenticated = auth2.isSignedIn.get();
	      _this3._setInitialized();
	    });
	  },
	
	  _initDrive: function _initDrive(auth2) {
	    var _this4 = this;
	
	    this.gapi.client.load('drive', 'v3', function () {
	      _this4._setInitialized();
	    });
	  },
	
	  _handleAuthChange: function _handleAuthChange(isAuthenticated) {
	    this.authenticated = isAuthenticated;
	    for (var i = 0; i < this.authCallbacks.length; i++) {
	      this.authCallbacks[i](isAuthenticated);
	    }
	  },
	
	  _setInitialized: function _setInitialized() {
	    this.clientCount--;
	    if (this.clientCount === 0) {
	      this.initialized = true;
	      this._handleAuthChange(this.authenticated);
	    }
	  }
	});
	
	exports.default = GoogleAPI;

/***/ },
/* 223 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = processUnscheduledMeetings;
	
	var _underscore = __webpack_require__(7);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _time = __webpack_require__(24);
	
	var _time2 = _interopRequireDefault(_time);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var sortMeetings = function sortMeetings(scheduledMeetings) {
	  return _underscore2.default.sortBy(scheduledMeetings, function (scheduledMeeting) {
	    return _time2.default.parse(scheduledMeeting.start_time).totalMinutes;
	  });
	};
	
	var getParticipants = function getParticipants(scheduledMeeting) {
	  return [].concat(scheduledMeeting.teacher_ids.map(function (id) {
	    return { type: 'teacher', id: id };
	  }), scheduledMeeting.cohort_ids.map(function (id) {
	    return { type: 'cohort', id: id };
	  }));
	};
	
	var isUnscheduled = function isUnscheduled(lastMeeting, currentMeeting) {
	  return lastMeeting && _time2.default.parse(lastMeeting.end_time).totalMinutes < _time2.default.parse(currentMeeting.start_time).totalMinutes;
	};
	
	var createUnscheduledMeeting = function createUnscheduledMeeting(id, participant, lastMeeting, scheduledMeeting, day_of_week) {
	  return Object.assign({}, lastMeeting, {
	    // TODO: Need a generic id and name for this meeting
	    id: id,
	    name: 'Available',
	    meeting_id: 'Available',
	    teacher_ids: participant.type === 'teacher' ? [participant.id] : [],
	    cohort_ids: participant.type === 'cohort' ? [participant.id] : [],
	    start_time: lastMeeting.end_time,
	    end_time: scheduledMeeting.start_time,
	    duration_minutes: _time2.default.duration(lastMeeting.end_time, scheduledMeeting.start_time).minutes,
	    day_of_week: day_of_week,
	    days_of_week: [day_of_week]
	  });
	};
	
	var getUnscheduledByDay = function getUnscheduledByDay(day, lastMeeting, scheduledMeeting, participant, id) {
	  var unscheduled = void 0;
	
	  if (isUnscheduled(lastMeeting, scheduledMeeting)) {
	    unscheduled = createUnscheduledMeeting(id, participant, lastMeeting, scheduledMeeting, day);
	  }
	
	  return unscheduled;
	};
	
	function processUnscheduledMeetings(scheduledMeetings) {
	  var newScheduledMeetings = [];
	  var lastMeeting = void 0;
	  var unscheduled = void 0;
	  var idCount = scheduledMeetings.length;
	
	  scheduledMeetings = sortMeetings(scheduledMeetings);
	  scheduledMeetings = _underscore2.default.reject(scheduledMeetings, function (m) {
	    return ['Social Studies'].includes(m.meeting_id);
	  });
	
	  scheduledMeetings.reduce(function (groups, scheduledMeeting) {
	    var participants = getParticipants(scheduledMeeting);
	
	    participants.forEach(function (participant) {
	      var id = [participant.type, participant.id].join('_');
	      groups[id] = groups[id] || {};
	
	      scheduledMeeting.days_of_week.forEach(function (day) {
	        lastMeeting = groups[id][day];
	        unscheduled = getUnscheduledByDay(day, lastMeeting, scheduledMeeting, participant, idCount + 1);
	
	        if (unscheduled) {
	          idCount++;
	          newScheduledMeetings.push(unscheduled);
	        }
	        groups[id][day] = scheduledMeeting;
	      });
	    });
	    newScheduledMeetings.push(scheduledMeeting);
	    return groups;
	  }, {});
	
	  return newScheduledMeetings;
	};

/***/ },
/* 224 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  getTermFolder: function getTermFolder(id) {
	    return __webpack_require__(377)("./" + id);
	  },
	  getFixtureSheet: function getFixtureSheet(id) {
	    return __webpack_require__(376)("./" + id + ".json");
	  }
	};

/***/ },
/* 225 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _abl = __webpack_require__(12);
	
	var _abl2 = _interopRequireDefault(_abl);
	
	var _google_sheet_processor = __webpack_require__(91);
	
	var _google_sheet_processor2 = _interopRequireDefault(_google_sheet_processor);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var fixtures = _abl2.default.config.fixtures;
	
	var MockAPI = _abl2.default.createClass({
	  initialize: function initialize() {
	    this.authenticated = true;
	    this.initialized = true;
	  },
	
	  authenticate: function authenticate(callback) {
	    if (this.initialized) {
	      callback(this.authenticated);
	    }
	  },
	
	  getFiles: function getFiles(props) {
	    var term = props.term;
	    return new Promise(function (resolve, reject) {
	      return resolve({ result: fixtures.getTermFolder(term) });
	    });
	  },
	
	  getSheet: function getSheet(props) {
	    return new Promise(function (resolve, reject) {
	      var processor = new _google_sheet_processor2.default(fixtures.getFixtureSheet(props.spreadsheetId), props.version);
	      return resolve(processor.toJSON());
	    });
	  },
	
	  updateSheet: function updateSheet(props) {
	    return new Promise(function (resolve, reject) {
	      return reject(new Error("not implemented in mock API yet"));
	    });
	  },
	
	  batchUpdateSheet: function batchUpdateSheet(props) {
	    return new Promise(function (resolve, reject) {
	      return reject(new Error("not implemented in mock API yet"));
	    });
	  }
	});
	
	exports.default = MockAPI;

/***/ },
/* 226 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _abl = __webpack_require__(12);
	
	var _abl2 = _interopRequireDefault(_abl);
	
	var _schools = __webpack_require__(98);
	
	var _schools2 = _interopRequireDefault(_schools);
	
	var _process_unscheduled_meetings = __webpack_require__(223);
	
	var _process_unscheduled_meetings2 = _interopRequireDefault(_process_unscheduled_meetings);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ScheduleAPI = _abl2.default.createClass({
	
		initialize: function initialize(props) {
			this.requestor = props.requestor || {};
		},
	
		getList: function getList(props) {
			var _this = this;
	
			var promise = new Promise(function (resolve, reject) {
				var scheduleInfo = _this._getScheduleInfo(props.school, props.term);
	
				if (scheduleInfo && scheduleInfo.type === 'sheet') {
					_this.requestor.getFiles({
						term: scheduleInfo.id
					}).then(function (response) {
						resolve(response.result.files);
					}, function (err) {
						reject(err);
					});
				} else {
					reject({ message: 'Could not find schedule' });
				}
			});
	
			return promise;
		},
	
		get: function get(props) {
			var _this2 = this;
	
			var promise = new Promise(function (resolve, reject) {
				var scheduleInfo = _this2._getScheduleInfo(props.school, props.term, props.scheduleId);
				if (scheduleInfo && scheduleInfo.type === 'sheet') {
					var ranges = scheduleInfo.version === 1.0 ? ['School', 'Teachers', 'Meetings'] : ['School', 'Staff', 'Cohorts', 'Meetings'];
					_this2.requestor.getSheet({
						spreadsheetId: props.scheduleId,
						version: scheduleInfo.version,
						ranges: ranges,
						majorDimension: 'ROWS'
					}).then(function (response) {
	
						response.scheduledMeetings = (0, _process_unscheduled_meetings2.default)(response.scheduledMeetings);
	
						resolve(response);
					}, function (err) {
						reject(err);
					});
				} else {
					reject({ message: 'Could not find schedule' });
				}
			});
	
			return promise;
		},
	
		_getScheduleInfo: function _getScheduleInfo(school, term) {
			var info = void 0;
			if (_schools2.default[school] && _schools2.default[school].terms[term]) {
				info = _schools2.default[school].terms[term];
			}
			return info;
		},
	
		_getColumnName: function _getColumnName(column) {
			var name = '';
			var startCode = 'A'.charCodeAt(0);
			var remainder = void 0;
	
			while (column > 0) {
				remainder = (column - 1) % 26;
				name = String.fromCharCode(startCode + remainder) + name;
				column = parseInt((column - remainder) / 26, 10);
			}
	
			return name;
		}
	});
	
	exports.default = ScheduleAPI;

/***/ },
/* 227 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
			value: true
	});
	exports.default = AuthView;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function AuthView(props) {
			return _react2.default.createElement(
					"div",
					{ className: "abl-auth-container", id: "abl-auth-view" },
					_react2.default.createElement(
							"h3",
							null,
							"Sign in to Google to access your schedule"
					),
					_react2.default.createElement(
							"button",
							{ id: "abl-authorize-button", onClick: props.onClick },
							"Sign In"
					)
			);
	};

/***/ },
/* 228 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SelectDropdown = _react2.default.createClass({
	  displayName: 'SelectDropdown',
	
	
	  render: function render() {
	    var data = this._getList(this.props.items);
	    return _react2.default.createElement(
	      'div',
	      { className: this.props.className },
	      _react2.default.createElement(
	        'h2',
	        null,
	        data.selected.name
	      ),
	      _react2.default.createElement(
	        'ul',
	        null,
	        data.unselected
	      )
	    );
	  },
	
	  _getList: function _getList(items) {
	    var selected = {};
	    var unselected = [];
	    for (var i = 0; i < items.length; i++) {
	      if (items[i].selected) {
	        selected = items[i];
	      } else {
	        unselected.push(_react2.default.createElement(
	          'li',
	          { key: i },
	          items[i].name
	        ));
	      }
	    }
	    return {
	      selected: selected,
	      unselected: unselected
	    };
	  }
	
	});
	
	exports.default = SelectDropdown;

/***/ },
/* 229 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = ErrorView;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function ErrorView(props) {
	  return _react2.default.createElement(
	    "div",
	    { className: "abl-error-view" },
	    _react2.default.createElement("img", { className: "abl-error-image", src: __webpack_require__(293),
	      alt: "Sorry, there was an error" }),
	    _react2.default.createElement(
	      "div",
	      { className: "abl-error-message-container" },
	      _react2.default.createElement(
	        "h4",
	        null,
	        "Sorry, something went wrong."
	      ),
	      _react2.default.createElement(
	        "div",
	        { className: "abl-error-signature" },
	        "Sincerely, ",
	        _react2.default.createElement("br", null),
	        _react2.default.createElement("br", null),
	        "Team Abl"
	      )
	    )
	  );
	};

/***/ },
/* 230 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactModal = __webpack_require__(195);
	
	var _reactModal2 = _interopRequireDefault(_reactModal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Modal = _react2.default.createClass({
	  displayName: 'Modal',
	
	
	  getInitialState: function getInitialState() {
	    return {
	      style: {
	        display: null
	      },
	      shareStyle: {
	        display: 'none'
	      }
	    };
	  },
	
	  componentWillReceiveProps: function componentWillReceiveProps() {
	    this.setState(this.getInitialState());
	  },
	
	  render: function render() {
	    return _react2.default.createElement(
	      _reactModal2.default,
	      {
	        overlayClassName: 'abl-modal',
	        className: 'abl-modal-content',
	        isOpen: this.props.isOpen,
	        onRequestClose: this.props.onClose
	      },
	      _react2.default.createElement(
	        'div',
	        { className: 'abl-share-export-modal' },
	        _react2.default.createElement(
	          'div',
	          { style: this.state.style },
	          _react2.default.createElement('img', {
	            src: __webpack_require__(291),
	            width: '562',
	            height: '360',
	            alt: 'Share and Export' }),
	          _react2.default.createElement('span', { onClick: this.handleShareClick, className: 'abl-share-btn' })
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'abl-share-modal', style: this.state.shareStyle },
	          _react2.default.createElement('img', {
	            src: __webpack_require__(292),
	            width: '642',
	            height: '350',
	            alt: 'Share' })
	        ),
	        _react2.default.createElement('span', { onClick: this.props.onClose, className: 'abl-close-btn' })
	      )
	    );
	  },
	
	  handleShareClick: function handleShareClick() {
	    this.setState({
	      style: { display: 'none' },
	      shareStyle: { display: 'block' }
	    });
	  }
	
	});
	
	exports.default = Modal;

/***/ },
/* 231 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = CellParticipantList;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Participants = function Participants(props) {
	  var items = props.items.map(function (participant, i) {
	    var name = participant.displayName || participant.name || participant.id;
	
	    return _react2.default.createElement(
	      "li",
	      { key: i, title: participant.name },
	      _react2.default.createElement(
	        "span",
	        null,
	        name
	      )
	    );
	  });
	
	  return _react2.default.createElement(
	    "ul",
	    { className: props.className },
	    items
	  );
	};
	
	function CellParticipantList(props) {
	  var element = null;
	
	  if (props.participants) {
	    element = _react2.default.createElement(
	      "div",
	      { className: "abl-meeting-participants" },
	      _react2.default.createElement(Participants, {
	        className: "abl-participants-list abl-meeting-teacher",
	        items: props.participants.teacher }),
	      _react2.default.createElement(Participants, {
	        className: "abl-participants-list abl-meeting-cohort",
	        items: props.participants.cohort })
	    );
	  }
	
	  return element;
	};

/***/ },
/* 232 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = ColumnHeaders;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _selectable = __webpack_require__(25);
	
	var _selectable2 = _interopRequireDefault(_selectable);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function ColumnHeaders(props) {
	  var headers = props.columns.map(function (column, i) {
	    return _react2.default.createElement(
	      'td',
	      { key: i, className: 'abl-col-header ' + column.className, colSpan: column.subColumns.items.length },
	      _react2.default.createElement(
	        _selectable2.default,
	        {
	          id: column.name,
	          data: column,
	          selected: column.selected,
	          overrideClick: true,
	          onChange: props.onColumnClick,
	          selectedClass: 'abl-selected' },
	        _react2.default.createElement(
	          'div',
	          { className: 'abl-cell', title: column.name },
	          column.name
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'abl-close-button', onClick: props.onColumnCloseClick.bind(null, column) },
	        'X'
	      )
	    );
	  });
	
	  return _react2.default.createElement(
	    'tr',
	    null,
	    headers
	  );
	};

/***/ },
/* 233 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = ControlsMenu;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _controls_menu_list = __webpack_require__(234);
	
	var _controls_menu_list2 = _interopRequireDefault(_controls_menu_list);
	
	var _participant_group_list = __webpack_require__(238);
	
	var _participant_group_list2 = _interopRequireDefault(_participant_group_list);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function ControlsMenu(props) {
	
	  return _react2.default.createElement(
	    'div',
	    { className: 'abl-nav-menu', onMouseDown: props.onMouseDown, onClick: props.onClick },
	    _react2.default.createElement(
	      _controls_menu_list2.default,
	      {
	        items: props.menuItems,
	        onChange: props.onMenuItemChange,
	        onClearAllClick: props.onMenuClearAllClick },
	      _react2.default.createElement(_participant_group_list2.default, {
	        id: 'teachers',
	        items: props.teacherGroups,
	        onChange: props.onTeacherSelect,
	        onSelectAll: props.onParticipantGroupSelect.bind(null, 'teacher')
	      }),
	      _react2.default.createElement(_participant_group_list2.default, {
	        id: 'cohorts',
	        style: { display: 'none' },
	        items: props.cohortGroups,
	        onChange: props.onCohortSelect,
	        onSelectAll: props.onParticipantGroupSelect.bind(null, 'cohort')
	      })
	    )
	  );
	};

/***/ },
/* 234 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _selectable_list = __webpack_require__(40);
	
	var _selectable_list2 = _interopRequireDefault(_selectable_list);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ControlsMenuList = _react2.default.createClass({
	  displayName: 'ControlsMenuList',
	
	
	  render: function render() {
	    return _react2.default.createElement(_selectable_list2.default, {
	      tagName: 'ul',
	      className: 'abl-nav-menu-list',
	      selectedClass: 'abl-selected',
	      items: this.props.items,
	      itemTemplate: this._itemTemplate,
	      onChange: this.props.onChange,
	      toggleSelect: true });
	  },
	
	  _itemTemplate: function _itemTemplate(item, handleClick) {
	    return _react2.default.createElement(
	      'li',
	      null,
	      _react2.default.createElement(
	        'a',
	        { onClick: handleClick, title: item.name },
	        _react2.default.createElement('img', { src: item.imgSrc, height: item.height, width: item.width, alt: item.name }),
	        item.name,
	        _react2.default.createElement('span', null)
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'abl-tray' },
	        _react2.default.createElement(
	          'a',
	          {
	            className: 'abl-controls-menu-clear-all',
	            onClick: this.props.onClearAllClick.bind(null, item.id) },
	          'Clear All'
	        ),
	        this._renderTray(item)
	      )
	    );
	  },
	
	  _renderTray: function _renderTray(item) {
	    var tray = null;
	    _react2.default.Children.forEach(this.props.children, function (child) {
	      if (child.props.id === item.id) {
	        tray = child;
	      }
	    });
	
	    return tray;
	  }
	
	});
	
	exports.default = ControlsMenuList;

/***/ },
/* 235 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = LayersMenu;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _meeting_layers_list = __webpack_require__(237);
	
	var _meeting_layers_list2 = _interopRequireDefault(_meeting_layers_list);
	
	var _meeting_labels_list = __webpack_require__(236);
	
	var _meeting_labels_list2 = _interopRequireDefault(_meeting_labels_list);
	
	var _selectable = __webpack_require__(25);
	
	var _selectable2 = _interopRequireDefault(_selectable);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function LayersMenu(props) {
	  return _react2.default.createElement(
	    _selectable2.default,
	    {
	      selectedClass: 'abl-selected',
	      id: 'layers',
	      selected: props.selected,
	      clickTargetClassName: 'abl-layers-menu-title',
	      onChange: props.onMenuItemChange },
	    _react2.default.createElement(
	      'div',
	      {
	        className: 'abl-layers-menu',
	        onMouseDown: props.onMouseDown,
	        onClick: props.onClick },
	      _react2.default.createElement(
	        'h4',
	        { className: 'abl-layers-menu-title' },
	        _react2.default.createElement(
	          'span',
	          null,
	          'Layers'
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'abl-tray' },
	        _react2.default.createElement(
	          'div',
	          { className: 'abl-layers-group' },
	          _react2.default.createElement(
	            'h5',
	            null,
	            'Highlights'
	          ),
	          _react2.default.createElement(_meeting_layers_list2.default, {
	            items: props.highlights,
	            onChange: props.onLayerChange
	          })
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'abl-layers-group' },
	          _react2.default.createElement(
	            'h5',
	            null,
	            'Labels'
	          ),
	          _react2.default.createElement(_meeting_labels_list2.default, {
	            items: props.labels,
	            onChange: props.onLabelChange
	          })
	        )
	      )
	    )
	  );
	};

/***/ },
/* 236 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = MeetingLabelsList;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function MeetingLabelsList(props) {
	  var items = props.items.map(function (item, i) {
	    return _react2.default.createElement(
	      "li",
	      { key: i },
	      _react2.default.createElement("input", {
	        type: "checkbox",
	        checked: item.selected,
	        onClick: props.onChange.bind(null, item) }),
	      " ",
	      item.name
	    );
	  });
	
	  return _react2.default.createElement(
	    "ul",
	    { className: "abl-labels-list" },
	    items
	  );
	};

/***/ },
/* 237 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = MeetingLayersList;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _selectable_list = __webpack_require__(40);
	
	var _selectable_list2 = _interopRequireDefault(_selectable_list);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MeetingLayersListItem = function MeetingLayersListItem(item, handleClick) {
	  return _react2.default.createElement(
	    'li',
	    { className: 'abl-border ' + item.className, onClick: handleClick },
	    item.name
	  );
	};
	
	function MeetingLayersList(props) {
	  return _react2.default.createElement(_selectable_list2.default, {
	    tagName: 'ul',
	    className: 'abl-layers-list',
	    selectedClass: function selectedClass(item) {
	      return item.selectedClass;
	    },
	    items: props.items,
	    onChange: props.onChange,
	    multiSelect: true,
	    itemTemplate: MeetingLayersListItem });
	};

/***/ },
/* 238 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _selectable_list = __webpack_require__(40);
	
	var _selectable_list2 = _interopRequireDefault(_selectable_list);
	
	var _selectable = __webpack_require__(25);
	
	var _selectable2 = _interopRequireDefault(_selectable);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ParticipantGroupList = _react2.default.createClass({
		displayName: 'ParticipantGroupList',
	
	
		render: function render() {
			var _this = this;
	
			var groups = this.props.items.map(function (group, i) {
				return _this._renderGroup(group, i);
			});
			return _react2.default.createElement(
				'div',
				{ className: 'abl-teachers-list' },
				groups
			);
		},
	
		_renderGroup: function _renderGroup(group, i) {
			var key = 'group_' + i;
			return _react2.default.createElement(
				'div',
				{ key: key },
				_react2.default.createElement(
					_selectable2.default,
					{
						id: group.id,
						ref: group.id,
						data: group,
						selected: group.selected,
						onChange: this.props.onSelectAll,
						selectedClass: 'abl-selected' },
					_react2.default.createElement(
						'h4',
						null,
						_react2.default.createElement(
							'a',
							null,
							group.name
						)
					)
				),
				_react2.default.createElement(_selectable_list2.default, {
					tagName: 'ul',
					selectedClass: 'abl-selected',
					items: group.items,
					itemTemplate: this._listItemTemplate,
					onChange: this.props.onChange,
					multiSelect: true })
			);
		},
	
		_listItemTemplate: function _listItemTemplate(item, handleClick) {
			return _react2.default.createElement(
				'li',
				{ onClick: handleClick },
				_react2.default.createElement(
					'a',
					null,
					_react2.default.createElement(
						'span',
						null,
						item.name
					)
				)
			);
		}
	
	});
	
	exports.default = ParticipantGroupList;

/***/ },
/* 239 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = RowHeaders;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function RowHeaders(props) {
	  var rows = props.items.map(function (item, i) {
	    return _react2.default.createElement(
	      "div",
	      { key: i, className: "abl-row", "data-duration": item.duration, style: { height: item.height } },
	      _react2.default.createElement(
	        "div",
	        { className: "abl-cell" },
	        item.name
	      )
	    );
	  });
	
	  return _react2.default.createElement(
	    "div",
	    { className: "abl-row-headers" },
	    rows
	  );
	};

/***/ },
/* 240 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = SubColumnHeaders;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _selectable = __webpack_require__(25);
	
	var _selectable2 = _interopRequireDefault(_selectable);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function SubColumnHeaders(props) {
	  var headers = props.columns.map(function (column, i) {
	    return column.subColumns.items.map(function (subColumn, i) {
	      return _react2.default.createElement(
	        'td',
	        { className: 'abl-col ' + subColumn.className, key: i },
	        _react2.default.createElement(
	          'div',
	          { className: 'abl-sub-col' },
	          _react2.default.createElement(
	            _selectable2.default,
	            {
	              id: subColumn.id,
	              data: subColumn,
	              overrideClick: true,
	              onChange: props.onSubColumnClick,
	              selected: subColumn.selected,
	              selectedClass: 'abl-selected' },
	            _react2.default.createElement(
	              'h4',
	              { title: subColumn.displayName, className: 'abl-subcolumn-' + subColumn.type + ' abl-vertical' },
	              _react2.default.createElement('span', { className: 'abl-subcolumn-icon', title: subColumn.type }),
	              subColumn.displayName
	            )
	          )
	        )
	      );
	    });
	  });
	
	  return _react2.default.createElement(
	    'tr',
	    null,
	    headers
	  );
	};

/***/ },
/* 241 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _row_headers = __webpack_require__(239);
	
	var _row_headers2 = _interopRequireDefault(_row_headers);
	
	var _column_headers = __webpack_require__(232);
	
	var _column_headers2 = _interopRequireDefault(_column_headers);
	
	var _subcolumn_headers = __webpack_require__(240);
	
	var _subcolumn_headers2 = _interopRequireDefault(_subcolumn_headers);
	
	var _cell_participant_list = __webpack_require__(231);
	
	var _cell_participant_list2 = _interopRequireDefault(_cell_participant_list);
	
	var _selectable = __webpack_require__(25);
	
	var _selectable2 = _interopRequireDefault(_selectable);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ViewerTable = _react2.default.createClass({
	  displayName: 'ViewerTable',
	
	
	  render: function render() {
	    var rows = this._getRows(this.props.columns);
	
	    return _react2.default.createElement(
	      'div',
	      { style: { display: this.props.display }, className: 'abl-viewer-table' },
	      _react2.default.createElement(
	        'div',
	        {
	          className: 'abl-unhide-columns-button',
	          onClick: this.props.onUnhideColumnsClick,
	          style: { display: this.props.unHideColumnsButtonDisplay }
	        },
	        'Show All'
	      ),
	      _react2.default.createElement(
	        'div',
	        { ref: 'columnHeaders', className: 'abl-horizontal-scrollable' },
	        _react2.default.createElement('div', { className: 'abl-row-header-spacer' }),
	        _react2.default.createElement(
	          'table',
	          { className: 'abl-table abl-col-headers' },
	          _react2.default.createElement(
	            'tbody',
	            null,
	            _react2.default.createElement(_column_headers2.default, _extends({ columns: this.props.columns }, this.props)),
	            _react2.default.createElement(_subcolumn_headers2.default, _extends({ columns: this.props.columns }, this.props))
	          )
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'abl-vertical-scrollable' },
	        _react2.default.createElement(_row_headers2.default, {
	          display: this.props.rowHeadersDisplay,
	          items: this.props.rowHeaders }),
	        _react2.default.createElement(
	          'div',
	          { onScroll: this.handleScroll, className: 'abl-horizontal-scrollable' },
	          _react2.default.createElement(
	            'table',
	            { className: 'abl-table' },
	            _react2.default.createElement(
	              'tbody',
	              null,
	              rows
	            )
	          )
	        )
	      )
	    );
	  },
	
	  handleScroll: function handleScroll(e) {
	    this.refs.columnHeaders.scrollLeft = e.target.scrollLeft;
	  },
	
	  _getRows: function _getRows(columns) {
	    var _this = this;
	
	    var rows = columns.map(function (column, i) {
	      return _this._getSubColumns(column.subColumns);
	    });
	
	    return _react2.default.createElement(
	      'tr',
	      null,
	      rows
	    );
	  },
	
	  _getSubColumns: function _getSubColumns(subColumns) {
	    var _this2 = this;
	
	    return subColumns.items.map(function (subColumn, i) {
	      var cells = _this2._getCells(subColumn.rows);
	
	      return _react2.default.createElement(
	        'td',
	        { className: 'abl-col ' + subColumn.className, key: i + 1 },
	        _react2.default.createElement(
	          'div',
	          { className: 'abl-sub-col' },
	          cells
	        )
	      );
	    });
	  },
	
	  _getMeetingClassNames: function _getMeetingClassNames(scheduledMeeting) {
	    var classNames = [];
	    if (scheduledMeeting.associated_to_inspected) {
	      classNames.push('abl-associated');
	    }
	    return classNames;
	  },
	
	
	  _getCells: function _getCells(cells) {
	    var _this3 = this;
	
	    cells = cells || [];
	    return cells.map(function (cell, i) {
	      return _react2.default.createElement(
	        _selectable2.default,
	        {
	          key: i,
	          id: cell.id,
	          data: cell,
	          overrideClick: true,
	          selected: cell.scheduledMeeting.inspected,
	          selectedClass: 'abl-selected',
	          className: _this3._getMeetingClassNames(cell.scheduledMeeting).join(' ') },
	        _react2.default.createElement(
	          'div',
	          {
	            className: 'abl-row',
	            'data-duration': cell.duration,
	            style: { height: cell.height },
	            'data-start-time': cell.scheduledMeeting.start_time,
	            onClick: _this3.handleCellClick
	          },
	          _react2.default.createElement(
	            'div',
	            {
	              className: 'abl-cell ' + cell.scheduledMeeting.classNames.join(' '),
	              'data-meeting-id': cell.scheduledMeeting.id,
	              'data-cell-id': cell.id,
	              'data-scheduled': cell.scheduledMeeting.scheduled,
	              tabIndex: '0' },
	            _react2.default.createElement(
	              'div',
	              { className: 'abl-meeting-name', title: cell.scheduledMeeting.name },
	              cell.scheduledMeeting.name
	            ),
	            _react2.default.createElement(_cell_participant_list2.default, {
	              participants: cell.participants })
	          )
	        )
	      );
	    });
	  },
	
	  handleCellClick: function handleCellClick(selectable) {
	    var selected = selectable.toggleSelect();
	
	    if (this.lastSelected && this.lastSelected.isMounted()) {
	      this.lastSelected.unselect();
	    }
	
	    this.props.onCellChange(selectable.props.id, selectable, selectable.props.data, selected);
	
	    this.lastSelected = selectable;
	  }
	
	});
	
	exports.default = ViewerTable;

/***/ },
/* 242 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = Agenda;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _inspector_card = __webpack_require__(32);
	
	var _inspector_card2 = _interopRequireDefault(_inspector_card);
	
	var _editable = __webpack_require__(95);
	
	var _editable2 = _interopRequireDefault(_editable);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function Agenda(props) {
	  return _react2.default.createElement(
	    _inspector_card2.default,
	    _extends({ header: 'Agenda' }, props, { className: 'abl-agenda-card' }),
	    _react2.default.createElement(
	      'table',
	      { className: 'abl-agenda-table' },
	      _react2.default.createElement(
	        'thead',
	        null,
	        _react2.default.createElement(
	          'tr',
	          null,
	          _react2.default.createElement(
	            'th',
	            null,
	            'Name'
	          ),
	          _react2.default.createElement(
	            'th',
	            null,
	            'Start'
	          ),
	          _react2.default.createElement(
	            'th',
	            null,
	            'End'
	          )
	        )
	      ),
	      _react2.default.createElement(
	        'tbody',
	        null,
	        _react2.default.createElement(
	          'tr',
	          null,
	          _react2.default.createElement(
	            'td',
	            null,
	            _react2.default.createElement(_editable2.default, {
	              tagName: 'span',
	              className: 'abl-editable-label',
	              defaultText: 'Untitled',
	              value: 'Do Now' })
	          ),
	          _react2.default.createElement(
	            'td',
	            null,
	            _react2.default.createElement(_editable2.default, {
	              tagName: 'span',
	              className: 'abl-editable-label',
	              defaultText: 'Untitled',
	              value: '9:30' })
	          ),
	          _react2.default.createElement(
	            'td',
	            null,
	            _react2.default.createElement(_editable2.default, {
	              tagName: 'span',
	              className: 'abl-editable-label',
	              defaultText: 'Untitled',
	              value: '10:00' })
	          )
	        ),
	        _react2.default.createElement(
	          'tr',
	          null,
	          _react2.default.createElement(
	            'td',
	            null,
	            _react2.default.createElement(_editable2.default, {
	              tagName: 'span',
	              className: 'abl-editable-label',
	              defaultText: 'Untitled',
	              value: 'Word Work' })
	          ),
	          _react2.default.createElement(
	            'td',
	            null,
	            _react2.default.createElement(_editable2.default, {
	              tagName: 'span',
	              className: 'abl-editable-label',
	              defaultText: 'Untitled',
	              value: '10:00' })
	          ),
	          _react2.default.createElement(
	            'td',
	            null,
	            _react2.default.createElement(_editable2.default, {
	              tagName: 'span',
	              className: 'abl-editable-label',
	              defaultText: 'Untitled',
	              value: '10:30' })
	          )
	        ),
	        _react2.default.createElement(
	          'tr',
	          null,
	          _react2.default.createElement(
	            'td',
	            null,
	            _react2.default.createElement(_editable2.default, {
	              tagName: 'span',
	              className: 'abl-editable-label',
	              defaultText: 'Untitled',
	              value: 'Read Aloud' })
	          ),
	          _react2.default.createElement(
	            'td',
	            null,
	            _react2.default.createElement(_editable2.default, {
	              tagName: 'span',
	              className: 'abl-editable-label',
	              defaultText: 'Untitled',
	              value: '10:30' })
	          ),
	          _react2.default.createElement(
	            'td',
	            null,
	            _react2.default.createElement(_editable2.default, {
	              tagName: 'span',
	              className: 'abl-editable-label',
	              defaultText: 'Untitled',
	              value: '11:00' })
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'abl-agenda-invite' },
	      _react2.default.createElement(
	        'a',
	        null,
	        'Invite Team Member to Edit'
	      )
	    )
	  );
	};

/***/ },
/* 243 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = Facilities;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _inspector_card = __webpack_require__(32);
	
	var _inspector_card2 = _interopRequireDefault(_inspector_card);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function Facilities(props) {
	  return _react2.default.createElement(
	    _inspector_card2.default,
	    _extends({ header: 'Facilities' }, props),
	    _react2.default.createElement(
	      'div',
	      { className: 'abl-inspector-group abl-facilities-card' },
	      _react2.default.createElement(
	        'div',
	        { className: 'abl-label-group' },
	        _react2.default.createElement(
	          'label',
	          null,
	          'Room #'
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'abl-label-content' },
	          '119'
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'abl-label-group' },
	        _react2.default.createElement(
	          'label',
	          null,
	          'Capacity'
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'abl-label-content' },
	          '30'
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'abl-label-group' },
	        _react2.default.createElement(
	          'label',
	          null,
	          'Type'
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'abl-label-content' },
	          'Lab, Cafeteria, Small Group, etc'
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'abl-label-group' },
	        _react2.default.createElement(
	          'label',
	          null,
	          'Used by'
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'abl-label-content' },
	          _react2.default.createElement(
	            'ul',
	            null,
	            _react2.default.createElement(
	              'li',
	              null,
	              'A. Filsinger'
	            ),
	            _react2.default.createElement(
	              'li',
	              null,
	              'C. Walsh'
	            )
	          )
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'abl-label-group' },
	        _react2.default.createElement(
	          'label',
	          null,
	          'Materials'
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'abl-label-content' },
	          _react2.default.createElement(
	            'ul',
	            null,
	            _react2.default.createElement(
	              'li',
	              null,
	              'Projector'
	            ),
	            _react2.default.createElement(
	              'li',
	              null,
	              'Lab tables'
	            )
	          )
	        )
	      )
	    )
	  );
	};

/***/ },
/* 244 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _meeting_summary = __webpack_require__(245);
	
	var _meeting_summary2 = _interopRequireDefault(_meeting_summary);
	
	var _staff_availability_card = __webpack_require__(246);
	
	var _staff_availability_card2 = _interopRequireDefault(_staff_availability_card);
	
	var _student_cohorts = __webpack_require__(250);
	
	var _student_cohorts2 = _interopRequireDefault(_student_cohorts);
	
	var _facilities = __webpack_require__(243);
	
	var _facilities2 = _interopRequireDefault(_facilities);
	
	var _agenda = __webpack_require__(242);
	
	var _agenda2 = _interopRequireDefault(_agenda);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var InspectorCardList = _react2.default.createClass({
	  displayName: 'InspectorCardList',
	
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      cardsById: {
	        summary: function summary(card, props) {
	          return _react2.default.createElement(_meeting_summary2.default, _extends({}, card, { onChange: props.onMeetingChange }));
	        },
	        staff_availability: function staff_availability(card, props) {
	          return _react2.default.createElement(_staff_availability_card2.default, card);
	        },
	        students: function students(card, props) {
	          return _react2.default.createElement(_student_cohorts2.default, _extends({}, card, { onFilterChange: props.onStudentFilterChange }));
	        },
	        facilities: function facilities(card, props) {
	          return _react2.default.createElement(_facilities2.default, card);
	        },
	        agenda: function agenda(card, props) {
	          return _react2.default.createElement(_agenda2.default, card);
	        }
	      }
	    };
	  },
	
	  render: function render() {
	    var element = this._defaultContent();
	    var cards = void 0;
	
	    if (this.props.render) {
	      cards = this._getCardComponents(this.props.items);
	      element = _react2.default.createElement(
	        'ul',
	        { className: 'abl-inspector-card-list' },
	        cards
	      );
	    }
	
	    return element;
	  },
	
	  _getCardComponents: function _getCardComponents(cards) {
	    var _this = this;
	
	    return cards.reduce(function (components, card) {
	
	      var component = _this.props.cardsById[card.id](card, _this.props);
	      if (!component) {
	        throw new Error({ message: 'Could not find card: ' + card.id });
	      }
	
	      components.push(_react2.default.createElement(
	        'li',
	        { key: components.length },
	        component
	      ));
	
	      return components;
	    }, []);
	  },
	
	  _defaultContent: function _defaultContent() {
	    return _react2.default.createElement(
	      'div',
	      { className: 'abl-default-message' },
	      _react2.default.createElement(
	        'h4',
	        null,
	        'Nothing selected.'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        'Select a time block to see more.'
	      )
	    );
	  }
	
	});
	
	exports.default = InspectorCardList;

/***/ },
/* 245 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = MeetingSummary;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _editable = __webpack_require__(95);
	
	var _editable2 = _interopRequireDefault(_editable);
	
	var _inspector_card = __webpack_require__(32);
	
	var _inspector_card2 = _interopRequireDefault(_inspector_card);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var cohortSummary = function cohortSummary(props) {
	  return _react2.default.createElement(
	    'div',
	    { className: 'abl-label-group' },
	    _react2.default.createElement(
	      'label',
	      null,
	      'Cohorts'
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'abl-label-content' },
	      _react2.default.createElement(
	        'ul',
	        { className: 'abl-participant-list' },
	        props.meetingDetails.cohorts.map(function (cohort, i) {
	          return _react2.default.createElement(
	            'li',
	            { key: i },
	            cohort.id
	          );
	        })
	      )
	    )
	  );
	};
	
	function MeetingSummary(props) {
	
	  return _react2.default.createElement(
	    _inspector_card2.default,
	    _extends({ header: 'Summary' }, props),
	    _react2.default.createElement(
	      'div',
	      { className: 'abl-inspector-group abl-meeting-details' },
	      _react2.default.createElement(
	        'div',
	        { className: 'abl-label-group' },
	        _react2.default.createElement(
	          'label',
	          null,
	          'Name'
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'abl-label-content abl-editable abl-form-field' },
	          _react2.default.createElement(_editable2.default, {
	            onChange: props.onChange,
	            tagName: 'span',
	            className: 'abl-editable-label',
	            defaultText: 'Untitled',
	            data: props.meetings,
	            value: props.meetingDetails.name })
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'abl-label-group' },
	        _react2.default.createElement(
	          'label',
	          null,
	          'Staff'
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'abl-label-content' },
	          _react2.default.createElement(
	            'ul',
	            { className: 'abl-participant-list' },
	            props.meetingDetails.teachers.map(function (teacher, i) {
	              return _react2.default.createElement(
	                'li',
	                { key: i },
	                teacher.name
	              );
	            })
	          )
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'abl-inspector-group-2-col' },
	        _react2.default.createElement(
	          'div',
	          { className: 'abl-label-group' },
	          _react2.default.createElement(
	            'label',
	            null,
	            'Start'
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'abl-label-content abl-form-field' },
	            props.meetingDetails.start_time
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'abl-label-group' },
	          _react2.default.createElement(
	            'label',
	            null,
	            'Stop'
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'abl-label-content abl-form-field' },
	            props.meetingDetails.end_time
	          )
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'abl-label-group' },
	        _react2.default.createElement(
	          'label',
	          null,
	          'Duration'
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'abl-label-content' },
	          props.meetingDetails.durationString
	        )
	      ),
	      cohortSummary(props)
	    )
	  );
	};

/***/ },
/* 246 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = StaffAvailability;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _inspector_card = __webpack_require__(32);
	
	var _inspector_card2 = _interopRequireDefault(_inspector_card);
	
	var _rcTooltip = __webpack_require__(84);
	
	var _rcTooltip2 = _interopRequireDefault(_rcTooltip);
	
	__webpack_require__(100);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var availabilityString = function availabilityString(availability) {
	  if (availability === 'partial') {
	    return "Partially Available";
	  } else {
	    return "Fully Available";
	  }
	};
	
	var teacherTooltip = function teacherTooltip(teacher) {
	  return _react2.default.createElement(
	    'div',
	    { className: 'abl-staff-details' },
	    _react2.default.createElement(
	      'table',
	      { className: 'abl-staff-details-table' },
	      _react2.default.createElement(
	        'tbody',
	        null,
	        _react2.default.createElement(
	          'tr',
	          null,
	          _react2.default.createElement(
	            'th',
	            null,
	            'Name:'
	          ),
	          _react2.default.createElement(
	            'td',
	            null,
	            teacher.name
	          )
	        ),
	        _react2.default.createElement(
	          'tr',
	          null,
	          _react2.default.createElement(
	            'th',
	            null,
	            'FTE:'
	          ),
	          _react2.default.createElement(
	            'td',
	            null,
	            '.75'
	          )
	        ),
	        _react2.default.createElement(
	          'tr',
	          null,
	          _react2.default.createElement(
	            'th',
	            null,
	            'Content Preps:'
	          ),
	          _react2.default.createElement(
	            'td',
	            null,
	            '3'
	          )
	        ),
	        _react2.default.createElement(
	          'tr',
	          null,
	          _react2.default.createElement(
	            'th',
	            null,
	            'Availability:'
	          ),
	          _react2.default.createElement(
	            'td',
	            null,
	            '50%'
	          )
	        )
	      )
	    )
	  );
	};
	
	function StaffAvailability(props) {
	  var teachers = props.teachers.map(function (teacher, i) {
	    return _react2.default.createElement(
	      'li',
	      { key: i },
	      _react2.default.createElement(
	        'div',
	        { className: 'abl-staff-member' },
	        _react2.default.createElement(
	          _rcTooltip2.default,
	          { placement: 'left', mouseEnterDelay: 0.8, overlay: _react2.default.createElement(
	              'span',
	              null,
	              availabilityString(teacher.availability)
	            ) },
	          _react2.default.createElement('i', { className: 'fa fa-circle availability-indicator availability-indicator-' + teacher.availability })
	        ),
	        _react2.default.createElement(
	          _rcTooltip2.default,
	          { placement: 'bottom', mouseEnterDelay: 0.8, overlay: teacherTooltip(teacher) },
	          _react2.default.createElement(
	            'span',
	            { className: 'abl-staff-name' },
	            teacher.displayName
	          )
	        ),
	        _react2.default.createElement(
	          'span',
	          { className: 'abl-staff-assign' },
	          _react2.default.createElement(
	            _rcTooltip2.default,
	            { placement: 'left', mouseEnterDelay: 0.8, overlay: _react2.default.createElement(
	                'span',
	                null,
	                'Assign'
	              ) },
	            _react2.default.createElement('i', { className: 'fa fa-plus-circle' })
	          )
	        )
	      )
	    );
	  });
	
	  return _react2.default.createElement(
	    _inspector_card2.default,
	    _extends({ header: 'Staff Availability' }, props),
	    _react2.default.createElement(
	      'div',
	      { className: 'abl-inspector-group' },
	      _react2.default.createElement(
	        'ul',
	        { className: 'abl-available-staff-list' },
	        teachers
	      )
	    )
	  );
	};

/***/ },
/* 247 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = StudentCohortDetails;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function StudentCohortDetails(props) {
	  return _react2.default.createElement(
	    "div",
	    { className: "abl-inspector-group abl-student-cohort-details" },
	    _react2.default.createElement(
	      "div",
	      { className: "abl-student-capacity" },
	      props.capacity
	    ),
	    _react2.default.createElement(
	      "div",
	      { className: "abl-cohort-demagraphics" },
	      _react2.default.createElement(
	        "label",
	        null,
	        "Gender"
	      ),
	      _react2.default.createElement(
	        "div",
	        { className: "abl-label-content" },
	        "F (14)"
	      ),
	      _react2.default.createElement(
	        "div",
	        { className: "abl-label-content" },
	        "M (10)"
	      )
	    ),
	    _react2.default.createElement(
	      "div",
	      { className: "abl-cohort-demagraphics" },
	      _react2.default.createElement(
	        "label",
	        null,
	        "Grades"
	      ),
	      _react2.default.createElement(
	        "div",
	        { className: "abl-label-content" },
	        "9th (10)"
	      ),
	      _react2.default.createElement(
	        "div",
	        { className: "abl-label-content" },
	        "10th (4)"
	      )
	    )
	  );
	};

/***/ },
/* 248 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = StudentCohortFilters;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _selectable_list = __webpack_require__(40);
	
	var _selectable_list2 = _interopRequireDefault(_selectable_list);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var StudentCohortFilter = function StudentCohortFilter(props, handleClick) {
	  return _react2.default.createElement(
	    'li',
	    { key: props.id, onClick: handleClick, title: props.name },
	    props.name
	  );
	};
	
	function StudentCohortFilters(props) {
	  return _react2.default.createElement(_selectable_list2.default, {
	    tagName: 'ul',
	    className: 'abl-student-cohorts-highlights-list',
	    selectedClass: function selectedClass(highlight) {
	      return highlight.selectedClass;
	    },
	    items: props.items,
	    onChange: props.onChange,
	    toggleSelect: true,
	    itemTemplate: StudentCohortFilter });
	};

/***/ },
/* 249 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = StudentCohortIconList;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _inspector_icons = __webpack_require__(205);
	
	var _rcTooltip = __webpack_require__(84);
	
	var _rcTooltip2 = _interopRequireDefault(_rcTooltip);
	
	__webpack_require__(100);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function StudentCohortIconList(props) {
	  return _react2.default.createElement(
	    'ul',
	    { className: 'abl-student-cohorts-list ' + props.ratio },
	    props.items.map(function (student, i) {
	      return _react2.default.createElement(
	        'li',
	        { key: i, className: student.className },
	        _react2.default.createElement(
	          _rcTooltip2.default,
	          {
	            trigger: student.triggers,
	            placement: 'top',
	            mouseEnterDelay: 0.25,
	            mouseLeaveDelay: 0.05,
	            overlay: student.name,
	            align: { offset: [0, -10] } },
	          _react2.default.createElement(
	            'span',
	            null,
	            _react2.default.createElement(_inspector_icons.StudentIcon, null)
	          )
	        )
	      );
	    })
	  );
	};

/***/ },
/* 250 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = StudentCohorts;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _inspector_card = __webpack_require__(32);
	
	var _inspector_card2 = _interopRequireDefault(_inspector_card);
	
	var _student_cohort_icon_list = __webpack_require__(249);
	
	var _student_cohort_icon_list2 = _interopRequireDefault(_student_cohort_icon_list);
	
	var _student_cohort_details = __webpack_require__(247);
	
	var _student_cohort_details2 = _interopRequireDefault(_student_cohort_details);
	
	var _student_cohort_filters = __webpack_require__(248);
	
	var _student_cohort_filters2 = _interopRequireDefault(_student_cohort_filters);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function StudentCohorts(props) {
	  return _react2.default.createElement(
	    _inspector_card2.default,
	    _extends({ header: 'Students' }, props, { className: 'abl-student-cohorts' }),
	    _react2.default.createElement(_student_cohort_details2.default, props),
	    _react2.default.createElement(_student_cohort_icon_list2.default, { items: props.filteredStudents, ratio: props.studentRatio }),
	    _react2.default.createElement(_student_cohort_filters2.default, { items: props.filters, onChange: props.onFilterChange })
	  );
	};

/***/ },
/* 251 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.AppContainer = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(31);
	
	var _auth = __webpack_require__(227);
	
	var _auth2 = _interopRequireDefault(_auth);
	
	var _index = __webpack_require__(49);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _loading_indicator = __webpack_require__(96);
	
	var _loading_indicator2 = _interopRequireDefault(_loading_indicator);
	
	var _app_selector = __webpack_require__(276);
	
	var _app_selector2 = _interopRequireDefault(_app_selector);
	
	var _modal = __webpack_require__(230);
	
	var _modal2 = _interopRequireDefault(_modal);
	
	var _error = __webpack_require__(229);
	
	var _error2 = _interopRequireDefault(_error);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var mapStateToProps = function mapStateToProps(state) {
	  return (0, _app_selector2.default)(state);
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	  return {
	    handleMount: function handleMount() {
	      return dispatch(_index2.default.requestAuthentication());
	    },
	    handleSignIn: function handleSignIn() {
	      return dispatch(_index2.default.requestSignIn());
	    },
	    handleModalClose: function handleModalClose() {
	      return dispatch(_index2.default.showModal(false));
	    }
	  };
	};
	
	var AppContainer = exports.AppContainer = _react2.default.createClass({
	  displayName: 'AppContainer',
	
	
	  componentDidMount: function componentDidMount() {
	    this.props.handleMount();
	  },
	
	  render: function render() {
	    if (!this.props.hasErrors) {
	      if (this.props.renderLoadingIndicator) {
	        return _react2.default.createElement(_loading_indicator2.default, null);
	      }
	      if (this.props.renderAuthView) {
	        return _react2.default.createElement(_auth2.default, { onClick: this.props.handleSignIn });
	      } else if (this.props.renderScheduleView) {
	        return _react2.default.createElement(
	          'div',
	          { className: 'abl-app-container' },
	          this.props.children,
	          _react2.default.createElement(_modal2.default, { onClose: this.props.handleModalClose, isOpen: this.props.modalIsOpen })
	        );
	      } else {
	        return null;
	      }
	    } else {
	      return _react2.default.createElement(_error2.default, null);
	    }
	  }
	});
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(AppContainer);

/***/ },
/* 252 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ScheduleHeaderContainer = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(31);
	
	var _schools = __webpack_require__(98);
	
	var _schools2 = _interopRequireDefault(_schools);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var mapStateToProps = function mapStateToProps(state) {
	  var school = _schools2.default[state.schedules.school] || {};
	  return {
	    schedules: state.schedules,
	    schoolName: school.name
	  };
	};
	
	var ScheduleHeaderContainer = exports.ScheduleHeaderContainer = _react2.default.createClass({
	  displayName: 'ScheduleHeaderContainer',
	
	
	  render: function render() {
	
	    if (!this.props.schedules.loading) {
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'abl-schedule-builder-container' },
	        _react2.default.createElement(
	          'div',
	          { className: 'abl-navbar' },
	          _react2.default.createElement(
	            'a',
	            { href: '#', className: 'abl-home', title: 'Home' },
	            _react2.default.createElement('span', null),
	            _react2.default.createElement('span', null),
	            _react2.default.createElement('span', null)
	          ),
	          _react2.default.createElement('img', { className: 'abl-logo', src: __webpack_require__(295), width: '38', height: '38', alt: 'Abl Schools', title: 'Abl Schools' }),
	          _react2.default.createElement(
	            'div',
	            { className: 'abl-school-name' },
	            this.props.schoolName
	          ),
	          _react2.default.createElement('img', {
	            className: 'abl-current-user-avatar',
	            src: __webpack_require__(290),
	            alt: 'Ann Marin',
	            width: '24',
	            height: '24' })
	        )
	      );
	    } else {
	      return null;
	    }
	  }
	
	});
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps)(ScheduleHeaderContainer);

/***/ },
/* 253 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ScheduleInspectorContainer = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(31);
	
	var _inspector_card_list = __webpack_require__(244);
	
	var _inspector_card_list2 = _interopRequireDefault(_inspector_card_list);
	
	var _index = __webpack_require__(49);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _inspector_selector = __webpack_require__(280);
	
	var _inspector_selector2 = _interopRequireDefault(_inspector_selector);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var mapStateToProps = function mapStateToProps(state) {
	  return (0, _inspector_selector2.default)(state);
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	  return {
	    handleMeetingChange: function handleMeetingChange(previous, currentValue, selectedMeetings) {
	      dispatch(_index2.default.changeMeetingNames(selectedMeetings, currentValue, Object.assign({}, undefined.props.data, { scheduleId: undefined.state.schedules.selected[0] })));
	    },
	    handleStudentFilterChange: function handleStudentFilterChange(previous, current) {
	      dispatch(_index2.default.changeStudentCohortFilter(current.data.id, current.selected));
	    }
	  };
	};
	
	var ScheduleInspectorContainer = exports.ScheduleInspectorContainer = _react2.default.createClass({
	  displayName: 'ScheduleInspectorContainer',
	
	
	  render: function render() {
	    var element = null;
	    if (!this.props.schedules.loading) {
	      element = _react2.default.createElement(
	        'div',
	        { className: 'abl-schedule-inspector-container' },
	        _react2.default.createElement(
	          'div',
	          { className: 'abl-inspector-content' },
	          _react2.default.createElement(_inspector_card_list2.default, {
	            id: 'select',
	            render: this.props.showCards,
	            items: this.props.cards,
	            onMeetingChange: this.props.handleMeetingChange,
	            onStudentFilterChange: this.props.handleStudentFilterChange
	          })
	        )
	      );
	    }
	
	    return element;
	  }
	
	});
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(ScheduleInspectorContainer);

/***/ },
/* 254 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ScheduleViewerContainer = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(31);
	
	var _viewer_table = __webpack_require__(241);
	
	var _viewer_table2 = _interopRequireDefault(_viewer_table);
	
	var _loading_indicator = __webpack_require__(96);
	
	var _loading_indicator2 = _interopRequireDefault(_loading_indicator);
	
	var _controls_menu = __webpack_require__(233);
	
	var _controls_menu2 = _interopRequireDefault(_controls_menu);
	
	var _layers_menu = __webpack_require__(235);
	
	var _layers_menu2 = _interopRequireDefault(_layers_menu);
	
	var _select_dropdown = __webpack_require__(228);
	
	var _select_dropdown2 = _interopRequireDefault(_select_dropdown);
	
	var _index = __webpack_require__(49);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _viewer_selector = __webpack_require__(288);
	
	var _viewer_selector2 = _interopRequireDefault(_viewer_selector);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var mapStateToProps = function mapStateToProps(state) {
	  return (0, _viewer_selector2.default)(state);
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch, props) {
	  return {
	    dispatch: dispatch,
	    handleMount: function handleMount() {
	      dispatch(_index2.default.requestSchedules(props.data));
	    },
	
	    handleScheduleChange: function handleScheduleChange(previous, current) {
	      dispatch(_index2.default.changeSchedule(current.data.id));
	    },
	
	    handleViewerLayoutChange: function handleViewerLayoutChange(previous, current) {
	      dispatch(_index2.default.selectViewerLayout(current.data.id));
	    },
	
	    handleCellChange: function handleCellChange(id, element, cell, selected) {
	      dispatch(_index2.default.selectViewerCell(id, cell.scheduledMeeting.id, selected));
	    },
	
	    handleColumnClick: function handleColumnClick(id, element, column, selected) {
	      dispatch(_index2.default.selectViewerColumn(column.index, column.name, column.value, selected));
	    },
	
	    handleSubColumnClick: function handleSubColumnClick(id, element, subColumn, selected) {
	      // disable this event for now - we don't support subcolumn
	      // selection in the inspector.
	
	      // dispatch(actions.selectViewerSubColumn(
	      //   subColumn.column.index,
	      //   subColumn.name,
	      //   subColumn.value,
	      //   selected
	      // ));
	    },
	
	    handleColumnCloseClick: function handleColumnCloseClick(column) {
	      dispatch(_index2.default.hideViewerColumn(column.index, column.name, column.value));
	    },
	
	    handleUnhideColumnsClick: function handleUnhideColumnsClick(column) {
	      dispatch(_index2.default.unHideViewerColumns());
	    },
	
	    handleControlsMenuItemChange: function handleControlsMenuItemChange(previous, current) {
	      dispatch(_index2.default.selectControlsMenuItem(current.data.id, current.selected));
	    },
	
	    handleTeacherSelect: function handleTeacherSelect(previous, current) {
	      dispatch(_index2.default.selectTeacher(current.data.id, current.selected));
	    },
	
	    handleCohortSelect: function handleCohortSelect(previous, current) {
	      dispatch(_index2.default.selectCohort(current.data.id, current.selected));
	    },
	
	    handleParticipantGroupSelect: function handleParticipantGroupSelect(type, id, element, group, selected) {
	      dispatch(_index2.default.selectParticipantGroup(type, group, selected));
	    },
	
	    handleLayersMenuItemChange: function handleLayersMenuItemChange(id, element, group, selected) {
	      dispatch(_index2.default.selectLayersMenuItem(selected));
	    },
	
	    handleLayerChange: function handleLayerChange(previous, current) {
	      dispatch(_index2.default.selectMeetingLayer(current.data.id, current.selected));
	    },
	
	    handleLabelChange: function handleLabelChange(item, e) {
	      dispatch(_index2.default.selectMeetingLabel(item.id, e.target.checked));
	    },
	
	    handleMenuClearAllClick: function handleMenuClearAllClick(id) {
	      if (id === 'teachers') {
	        dispatch(_index2.default.unSelectTeachers());
	      } else if (id === 'cohorts') {
	        dispatch(_index2.default.unSelectCohorts());
	      }
	    },
	
	    handleShareClick: function handleShareClick() {
	      dispatch(_index2.default.showModal(true));
	    }
	  };
	};
	
	var ScheduleViewerContainer = exports.ScheduleViewerContainer = _react2.default.createClass({
	  displayName: 'ScheduleViewerContainer',
	
	
	  componentDidMount: function componentDidMount() {
	    this.props.handleMount();
	  },
	
	  componentWillUnmount: function componentWillUnmount() {
	    document.body.removeEventListener('click', this.handleDocumentClick);
	  },
	
	  handleDocumentClick: function handleDocumentClick(e) {
	    if (!this._isClickedInside) {
	      this.props.dispatch(_index2.default.hideOpenTrays());
	      document.body.removeEventListener('click', this.handleDocumentClick);
	    }
	  },
	
	  handleMenuMouseDown: function handleMenuMouseDown() {
	    this._isClickedInside = true;
	    document.body.addEventListener('click', this.handleDocumentClick);
	  },
	
	  handleMenuMouseUp: function handleMenuMouseUp(e) {
	    this._isClickedInside = false;
	  },
	
	  render: function render() {
	    if (this.props.loading) {
	      return _react2.default.createElement(_loading_indicator2.default, null);
	    } else {
	      return _react2.default.createElement(
	        'div',
	        { className: 'abl-schedule-container' },
	        _react2.default.createElement(
	          'div',
	          { className: 'abl-schedule-viewer-grid ' + this.props.className },
	          _react2.default.createElement(
	            'div',
	            { className: 'abl-schedule-controls' },
	            _react2.default.createElement(
	              'div',
	              { className: 'abl-schedule-controls-left' },
	              _react2.default.createElement(_controls_menu2.default, _extends({}, this.props.controls, {
	                onMenuItemChange: this.props.handleControlsMenuItemChange,
	                onDocumentClick: this.handleDocumentClick,
	                onTeacherSelect: this.props.handleTeacherSelect,
	                onCohortSelect: this.props.handleCohortSelect,
	                onParticipantGroupSelect: this.props.handleParticipantGroupSelect,
	                onMenuClearAllClick: this.props.handleMenuClearAllClick,
	                onMouseDown: this.handleMenuMouseDown,
	                onClick: this.handleMenuMouseUp
	              }))
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'abl-schedule-controls-middle' },
	              _react2.default.createElement(_select_dropdown2.default, {
	                className: 'abl-schedule-list',
	                onChange: this.props.handleScheduleChange,
	                items: this.props.schedules })
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'abl-schedule-controls-right' },
	              _react2.default.createElement(_layers_menu2.default, _extends({}, this.props.layers, {
	                onMenuItemChange: this.props.handleLayersMenuItemChange,
	                onLayerChange: this.props.handleLayerChange,
	                onLabelChange: this.props.handleLabelChange,
	                onDocumentClick: this.handleDocumentClick,
	                onMouseDown: this.handleMenuMouseDown,
	                onClick: this.handleMenuMouseUp })),
	              _react2.default.createElement('img', {
	                className: 'abl-share-menu',
	                onClick: this.props.handleShareClick,
	                src: __webpack_require__(294),
	                alt: 'Share',
	                width: '16',
	                height: '20'
	              })
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'abl-schedule-content' },
	            _react2.default.createElement(_viewer_table2.default, _extends({
	              onCellChange: this.props.handleCellChange,
	              onColumnClick: this.props.handleColumnClick,
	              onSubColumnClick: this.props.handleSubColumnClick,
	              onColumnCloseClick: this.props.handleColumnCloseClick,
	              onUnhideColumnsClick: this.props.handleUnhideColumnsClick
	            }, this.props.table))
	          )
	        )
	      );
	    }
	  }
	});
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(ScheduleViewerContainer);

/***/ },
/* 255 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = ["Ubaldo Carroll", "Maegan Murazik", "Shane Corwin", "Joanie Osinski", "Bobbie Schinner", "Krystal Ullrich", "Eryn Auer", "Jadyn Rowe", "Brandyn Swaniawski", "Maiya Franecki", "Cesar Pacocha", "Jaycee Hamill", "Vergie Zieme", "Sandrine Wisoky", "Faye Steuber", "Chloe Mayer", "Belle Gaylord", "Lulu Murphy", "Dave Strosin", "Viva Wisozk", "Ophelia Quigley", "Chelsie Marquardt", "Zoila Rippin", "Garland Wolf", "Margaret Sporer", "Frederick Jaskolski", "Jasper Breitenberg", "Yesenia Schultz", "Mateo Mertz", "Holly Brekke", "Esteban Schinner", "Mariam Stroman", "Ivory Nolan", "Cortney Schmitt", "Russell Homenick", "Eleanora Ondricka", "Erika Okuneva", "Janae Johnston", "Jamar Lakin", "Finn Crist", "Herta Schiller", "Jose Cummings", "Stanley Stokes", "Don Emmerich", "Elijah McGlynn", "Kathryn Mertz", "Mariano Blanda", "Casandra Thiel", "Felicita Hammes", "Arthur Conn", "Mona Crona", "Desmond Deckow", "Kailyn Considine", "Braulio Krajcik", "Alex Reinger", "Laura Volkman", "Patsy Lowe", "Jamaal Pouros", "Davonte Nienow", "Franco Sauer", "Mortimer Ortiz", "Mylene Hilpert", "Nadia Mosciski", "Krystal Rau", "Enoch Nader", "Merle Kovacek", "Paris Bahringer", "Elinore Schneider", "Max Schneider", "Roberto Rohan", "Delphia Fahey", "Stefanie Tromp", "Lisa Ritchie", "Sean White", "Alexzander Sanford", "Prudence Stark", "Idella Stoltenberg", "Ramiro Hermann", "Melissa Lockman", "Lionel Kreiger", "Lukas O'Keefe", "Carolanne Pouros", "Ozella Donnelly", "Ilene Bartoletti", "Trace Koss", "Katherine Casper", "Grace Jakubowski", "Cullen Zulauf", "Buster Smith", "Prince Dibbert", "Eugene Kirlin", "Rodger Pollich", "Samantha Hoeger", "Annette Tremblay", "Kay Spencer", "Carroll Maggio", "Bruce Gorczany", "Wayne Kuvalis", "Gordon Fay", "Carson Lesch"];

/***/ },
/* 256 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.default = column;
	function column(columns, name, columnProperty) {
		if (!columns.entities[name]) {
			columns.entities[name] = {
				name: name,
				value: name,
				property: columnProperty,
				subColumns: { items: [], entities: {} },
				index: columns.items.length
			};
			columns.items.push(columns.entities[name]);
		}
	
		return columns.entities[name];
	};

/***/ },
/* 257 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.default = createTableData;
	
	var _underscore = __webpack_require__(7);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _row_headers = __webpack_require__(258);
	
	var _row_headers2 = _interopRequireDefault(_row_headers);
	
	var _column = __webpack_require__(256);
	
	var _column2 = _interopRequireDefault(_column);
	
	var _sub_column = __webpack_require__(260);
	
	var _sub_column2 = _interopRequireDefault(_sub_column);
	
	var _cell = __webpack_require__(97);
	
	var _time = __webpack_require__(24);
	
	var _time2 = _interopRequireDefault(_time);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var addData = function addData(table, subColumn, cell) {
		subColumn.rows.push(cell);
		if (!table.subColumns.entities[subColumn.id]) {
			table.subColumns.entities[subColumn.id] = subColumn;
			table.subColumns.items.push(subColumn);
		}
		if (!table.cells.entities[cell.id]) {
			table.cells.entities[cell.id] = cell;
			table.cells.items.push(cell);
		}
	};
	
	var createCellData = function createCellData(table, meeting, props) {
		var columnProperty = props.columnProperty;
		var startTime = props.startTime;
		var endTime = props.endTime;
	
		var columnName = meeting[columnProperty];
		var column = (0, _column2.default)(table.columns, columnName, columnProperty);
		var subColumns = _underscore2.default.compact(_underscore2.default.map(props.subColumnFilters, function (subColumnFilter) {
			if (subColumnFilter.filter(meeting)) {
				return (0, _sub_column2.default)(column, subColumnFilter.type, subColumnFilter.name, subColumnFilter.attribute);
			}
		}));
		return (0, _cell.getCell)({
			startTime: startTime,
			endTime: endTime,
			column: column,
			subColumns: subColumns,
			scheduledMeeting: meeting
		});
	};
	
	var tableProps = function tableProps(scheduledMeetings, props) {
		return {
			rowHeaders: (0, _row_headers2.default)(props, scheduledMeetings),
			columns: { items: [], entities: {} },
			subColumns: { items: [], entities: {} },
			cells: { items: [], entities: {} },
			scheduledMeetings: [].concat(scheduledMeetings)
		};
	};
	
	function createTableData(props) {
		var scheduledMeetings = _underscore2.default.sortBy(props.scheduledMeetings, function (scheduledMeeting) {
			return _time2.default.parse(scheduledMeeting.start_time).totalMinutes;
		});
	
		var tableData = tableProps(scheduledMeetings, props);
	
		scheduledMeetings.forEach(function (scheduledMeeting) {
			var cellData = createCellData(tableData, scheduledMeeting, props);
			cellData.subColumns.forEach(function (subColumn) {
				addData(tableData, subColumn, cellData);
			});
		});
	
		return tableData;
	};

/***/ },
/* 258 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.default = rowHeaders;
	
	var _underscore = __webpack_require__(7);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _cell = __webpack_require__(97);
	
	var _time = __webpack_require__(24);
	
	var _time2 = _interopRequireDefault(_time);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var usePeriods = function usePeriods(scheduledMeetings) {
		return scheduledMeetings.length > 0 && scheduledMeetings[0].period !== undefined && scheduledMeetings[0].period !== null;
	};
	
	var createHeaderCell = function createHeaderCell(index, name, duration) {
		var cell = {
			index: index,
			name: name,
			duration: duration
		};
	
		cell.height = (0, _cell.getCellHeight)(cell);
	
		return cell;
	};
	
	var getPeriodLabels = function getPeriodLabels(scheduledMeetings) {
		return scheduledMeetings.reduce(function (periods, scheduledMeeting) {
			var period = scheduledMeeting.period;
	
			if (!periods.entities[period]) {
				periods.entities[period] = true;
				periods.items.push(createHeaderCell(period, 'PER \n ' + period, scheduledMeeting.duration));
			}
			return periods;
		}, { items: [], entities: {} });
	};
	
	var getTimeLabels = function getTimeLabels(_ref) {
		var timeInterval = _ref.timeInterval;
		var startTime = _ref.startTime;
		var endTime = _ref.endTime;
	
		var headers = [];
		var name = void 0;
	
		startTime = _time2.default.parse(startTime);
		endTime = _time2.default.parse(endTime);
		name = _time2.default.new(startTime.hour, startTime.minutes).value.replace(/\s*am|pm/, '');
		headers.push(createHeaderCell(startTime.hour, name, 60 - startTime.minutes));
	
		for (var hour = startTime.hour + 1; hour <= endTime.hour; hour++) {
	
			for (var minutes = 0; minutes < 60; minutes += timeInterval) {
				if (hour === endTime.hour && minutes > endTime.minutes) {
					break;
				}
				name = _time2.default.new(hour, minutes).value.replace(/\s*am|pm/, '');
				headers.push(createHeaderCell(hour, name, timeInterval));
			}
		}
	
		return headers;
	};
	
	function rowHeaders(props, scheduledMeetings) {
		if (usePeriods(scheduledMeetings)) {
			return _underscore2.default.sortBy(getPeriodLabels(scheduledMeetings).items, function (item) {
				return item.period;
			});
		} else {
			return getTimeLabels(props);
		}
	};

/***/ },
/* 259 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _abl = __webpack_require__(12);
	
	var _abl2 = _interopRequireDefault(_abl);
	
	var _create_table_data = __webpack_require__(257);
	
	var _create_table_data2 = _interopRequireDefault(_create_table_data);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ScheduleTable = _abl2.default.createClass({
		initialize: function initialize(props) {
			this.startTime = props.startTime;
			this.endTime = props.endTime;
			this.scheduledMeetings = props.scheduledMeetings;
			this.timeInterval = props.timeInterval;
			this.columnProperty = props.columnProperty;
			this.subColumnFilters = props.subColumnFilters;
			this.createUnscheduledMeeting = props.createUnscheduledMeeting;
			var tableData = {
				items: [],
				columns: { items: [], entities: {} },
				rowHeaders: [],
				cells: { items: [], entities: {} }
			};
	
			if (this.startTime && this.endTime) {
				tableData = (0, _create_table_data2.default)(this);
			}
	
			this.items = tableData.items;
			this._columns = tableData.columns;
			this._rowHeaders = tableData.rowHeaders;
			this._rows = tableData.rows;
			this._cells = tableData.cells;
		},
	
		rowHeaders: function rowHeaders() {
			return this._rowHeaders;
		},
	
		columns: function columns() {
			return this._columns.items;
		},
	
		column: function column(name) {
			return this._columns.entities[name];
		},
	
		cells: function cells() {
			return this._cells.items;
		},
	
		cell: function cell(id) {
			return this._cells.entities[id];
		}
	});
	
	exports.default = ScheduleTable;

/***/ },
/* 260 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.default = subColumn;
	function subColumn(column, type, attributeValue, subColumnProperty) {
		var id = type + '_' + attributeValue;
		var name = void 0;
	
		if (!column.subColumns.entities[id]) {
			name = attributeValue;
			column.subColumns.entities[id] = {
				id: id,
				index: column.subColumns.items.length,
				name: name === 'null' ? null : name,
				value: name === 'null' ? null : name,
				column: column,
				property: subColumnProperty,
				type: type,
				rows: []
			};
	
			column.subColumns.items.push(column.subColumns.entities[id]);
		}
	
		return column.subColumns.entities[id];
	};

/***/ },
/* 261 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.default = appStatus;
	
	var _index = __webpack_require__(5);
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function appStatus(state, action) {
		var newState = state || _index2.default.APP_STATUS.INITIALIZING;
	
		switch (action.type) {
			case _index2.default.REQUEST_AUTHENTICATION:
				newState = _index2.default.APP_STATUS.AUTHENTICATING;
				break;
			case _index2.default.REQUEST_AUTHENTICATION_FAIL:
			case _index2.default.REQUEST_AUTHENTICATION_SUCCESS:
				if (action.payload.authenticated) {
					newState = _index2.default.APP_STATUS.READY;
				} else {
					newState = _index2.default.APP_STATUS.UNAUTHENTICATED;
				}
				break;
			default:
		}
		return newState;
	};

/***/ },
/* 262 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.default = authenticated;
	
	var _index = __webpack_require__(5);
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function authenticated() {
		var state = arguments.length <= 0 || arguments[0] === undefined ? false : arguments[0];
		var action = arguments[1];
	
		var newState = state;
	
		switch (action.type) {
			case _index2.default.REQUEST_AUTHENTICATION_FAIL:
				newState = false;
				break;
			case _index2.default.REQUEST_AUTHENTICATION_SUCCESS:
				newState = action.payload.authenticated;
				break;
			default:
		}
		return newState;
	};

/***/ },
/* 263 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = errors;
	
	var _index = __webpack_require__(5);
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var defaultState = [];
	
	function errors() {
	  var state = arguments.length <= 0 || arguments[0] === undefined ? defaultState : arguments[0];
	  var action = arguments[1];
	
	  var newState = state;
	
	  switch (action.type) {
	    case _index2.default.REQUEST_AUTHENTICATION_FAIL:
	    case _index2.default.REQUEST_SCHEDULES_FAIL:
	    case _index2.default.REQUEST_SCHEDULE_FAIL:
	      newState = [action.payload];
	      break;
	    default:
	  }
	  return newState;
	};

/***/ },
/* 264 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _redux = __webpack_require__(75);
	
	var _app_status_reducer = __webpack_require__(261);
	
	var _app_status_reducer2 = _interopRequireDefault(_app_status_reducer);
	
	var _authenticated_reducer = __webpack_require__(262);
	
	var _authenticated_reducer2 = _interopRequireDefault(_authenticated_reducer);
	
	var _schedules_reducer = __webpack_require__(273);
	
	var _schedules_reducer2 = _interopRequireDefault(_schedules_reducer);
	
	var _participants_reducer = __webpack_require__(269);
	
	var _participants_reducer2 = _interopRequireDefault(_participants_reducer);
	
	var _meetings_reducer = __webpack_require__(267);
	
	var _meetings_reducer2 = _interopRequireDefault(_meetings_reducer);
	
	var _meeting_layers_reducer = __webpack_require__(266);
	
	var _meeting_layers_reducer2 = _interopRequireDefault(_meeting_layers_reducer);
	
	var _meeting_labels_reducer = __webpack_require__(265);
	
	var _meeting_labels_reducer2 = _interopRequireDefault(_meeting_labels_reducer);
	
	var _student_cohort_filters_reducer = __webpack_require__(274);
	
	var _student_cohort_filters_reducer2 = _interopRequireDefault(_student_cohort_filters_reducer);
	
	var _scheduled_meetings_reducer = __webpack_require__(272);
	
	var _scheduled_meetings_reducer2 = _interopRequireDefault(_scheduled_meetings_reducer);
	
	var _schedule_controls_reducer = __webpack_require__(270);
	
	var _schedule_controls_reducer2 = _interopRequireDefault(_schedule_controls_reducer);
	
	var _schedule_viewer_reducer = __webpack_require__(271);
	
	var _schedule_viewer_reducer2 = _interopRequireDefault(_schedule_viewer_reducer);
	
	var _modal_reducer = __webpack_require__(268);
	
	var _modal_reducer2 = _interopRequireDefault(_modal_reducer);
	
	var _errors_reducer = __webpack_require__(263);
	
	var _errors_reducer2 = _interopRequireDefault(_errors_reducer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _redux.combineReducers)({
		appStatus: _app_status_reducer2.default,
		authenticated: _authenticated_reducer2.default,
		schedules: _schedules_reducer2.default,
		teachers: (0, _participants_reducer2.default)('teacher'),
		cohorts: (0, _participants_reducer2.default)('cohort'),
		meetings: _meetings_reducer2.default,
		meetingLayers: _meeting_layers_reducer2.default,
		meetingLabels: _meeting_labels_reducer2.default,
		studentCohortFilters: _student_cohort_filters_reducer2.default,
		scheduledMeetings: _scheduled_meetings_reducer2.default,
		controls: _schedule_controls_reducer2.default,
		viewer: _schedule_viewer_reducer2.default,
		modal: _modal_reducer2.default,
		errors: _errors_reducer2.default
	});

/***/ },
/* 265 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = meetingLabels;
	
	var _underscore = __webpack_require__(7);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _index = __webpack_require__(5);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _normalize = __webpack_require__(21);
	
	var _normalize2 = _interopRequireDefault(_normalize);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var defaultState = (0, _normalize2.default)({ selected: [] }, [{
	  id: 'teacher',
	  name: 'Staff'
	}, {
	  id: 'cohort',
	  name: 'Student Cohorts'
	}, {
	  id: 'facilities',
	  name: 'Facilities'
	}, {
	  id: 'time',
	  name: 'Time'
	}]);
	
	function meetingLabels() {
	  var state = arguments.length <= 0 || arguments[0] === undefined ? defaultState : arguments[0];
	  var action = arguments[1];
	
	  var newState = state;
	
	  switch (action.type) {
	    case _index2.default.SELECT_MEETING_LABEL:
	      newState = Object.assign({}, newState);
	      if (action.payload.selected) {
	        newState.selected = newState.selected.concat(action.payload.id);
	      } else {
	        newState.selected = _underscore2.default.without(newState.selected, action.payload.id);
	      }
	      break;
	    default:
	  }
	  return newState;
	};

/***/ },
/* 266 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = meetingLayersReducer;
	
	var _abl = __webpack_require__(12);
	
	var _abl2 = _interopRequireDefault(_abl);
	
	var _underscore = __webpack_require__(7);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _index = __webpack_require__(5);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _normalize = __webpack_require__(21);
	
	var _normalize2 = _interopRequireDefault(_normalize);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var instructionalLayers = _abl2.default.config.feature_flags.core_vs_noncore_layers ? [{
	  id: 'core_instructional',
	  name: 'Instructional (Core)',
	  className: 'abl-layers-core-instructional-border',
	  selectedClass: 'abl-layers-core-instructional',
	  conditions: {
	    meeting: { instructional: true, core: true }
	  }
	}, {
	  id: 'non_core_instructional',
	  name: 'Instructional (Non-Core)',
	  className: 'abl-layers-non-core-instructional-border',
	  selectedClass: 'abl-layers-non-core-instructional',
	  conditions: {
	    meeting: { instructional: true, core: false }
	  }
	}] : [{
	  id: 'instructional',
	  name: 'Instructional',
	  className: 'abl-layers-instructional-border',
	  selectedClass: 'abl-layers-instructional',
	  conditions: {
	    meeting: { instructional: true }
	  }
	}];
	
	var defaultState = (0, _normalize2.default)({
	  selected: ['available', 'non-instructional']
	}, instructionalLayers.concat([{
	  id: 'prep',
	  name: 'Prep/Plan',
	  className: 'abl-layers-prep-border',
	  selectedClass: 'abl-layers-prep',
	  conditions: {
	    meeting: { type: 'Prep' }
	  }
	}, {
	  id: 'duty',
	  name: 'Duty',
	  className: 'abl-layers-duty-border',
	  selectedClass: 'abl-layers-duty',
	  conditions: {
	    meeting: { type: 'Duty' }
	  }
	}, {
	  id: 'available',
	  name: 'Available',
	  className: 'abl-layers-available-border',
	  selectedClass: 'abl-layers-available',
	  conditions: {
	    scheduledMeeting: { scheduled: false }
	  }
	}, {
	  id: 'non-instructional',
	  name: 'Non-Instructional',
	  className: 'abl-layers-noninstructional-border',
	  selectedClass: 'abl-layers-noninstructional',
	  conditions: {
	    meeting: { noninstructional: true },
	    scheduledMeeting: { scheduled: true }
	  }
	}]));
	
	function meetingLayersReducer() {
	  var state = arguments.length <= 0 || arguments[0] === undefined ? defaultState : arguments[0];
	  var action = arguments[1];
	
	  var newState = state;
	
	  switch (action.type) {
	    case _index2.default.SELECT_MEETING_LAYER:
	      newState = Object.assign({}, newState);
	      if (action.payload.selected) {
	        newState.selected = newState.selected.concat(action.payload.id);
	      } else {
	        newState.selected = _underscore2.default.without(newState.selected, action.payload.id);
	      }
	      break;
	    default:
	  }
	  return newState;
	};

/***/ },
/* 267 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.default = meetingsReducer;
	
	var _index = __webpack_require__(5);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _normalize = __webpack_require__(21);
	
	var _normalize2 = _interopRequireDefault(_normalize);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var defaultState = (0, _normalize2.default)();
	
	function meetingsReducer() {
		var state = arguments.length <= 0 || arguments[0] === undefined ? defaultState : arguments[0];
		var action = arguments[1];
	
		var newState = state;
	
		switch (action.type) {
			case _index2.default.REQUEST_MEETINGS_SUCCESS:
				newState = (0, _normalize2.default)(state, action.payload.meetings);
				break;
			default:
		}
		return newState;
	};

/***/ },
/* 268 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = modalReducer;
	
	var _index = __webpack_require__(5);
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var defaultState = {
	  isOpen: false
	};
	
	function modalReducer() {
	  var state = arguments.length <= 0 || arguments[0] === undefined ? defaultState : arguments[0];
	  var action = arguments[1];
	
	  var newState = state;
	
	  switch (action.type) {
	    case _index2.default.SHOW_MODAL:
	      newState = Object.assign({}, newState, {
	        isOpen: action.payload.isOpen
	      });
	      break;
	    default:
	  }
	  return newState;
	};

/***/ },
/* 269 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.default = forParticipant;
	
	var _underscore = __webpack_require__(7);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _index = __webpack_require__(5);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _normalize = __webpack_require__(21);
	
	var _normalize2 = _interopRequireDefault(_normalize);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var selectParticipants = function selectParticipants(newState, propName, selected, ids) {
		newState = Object.assign({}, newState);
		if (selected) {
			newState[propName] = _underscore2.default.uniq(newState[propName].concat(ids));
		} else {
			newState[propName] = _underscore2.default.without.apply(_underscore2.default, [newState[propName]].concat(ids));
		}
	
		return newState;
	};
	
	var unSelectParticipants = function unSelectParticipants(newState, action) {
		newState = Object.assign({}, newState);
		newState.selected = [];
		newState.selectedGroups = [];
		return newState;
	};
	
	var selectParticipantsGroup = function selectParticipantsGroup(participantName, newState, action) {
	
		if (participantName !== action.payload.type) {
			return newState;
		}
	
		var group = action.payload.group;
		var ids = group.items.map(function (item) {
			return item.id;
		});
		var selected = action.payload.selected;
	
		newState = Object.assign({}, newState);
	
		if (selected) {
			newState.selectedGroups = newState.selectedGroups.concat([group.id]);
		} else {
			newState.selectedGroups = _underscore2.default.without(newState.selectedGroups, group.id);
		}
	
		return selectParticipants(newState, 'selected', selected, ids);
	};
	
	var participantsReducer = function participantsReducer(participantName) {
		return function (state, action) {
			var participantConstantName = participantName.toUpperCase();
	
			var newState = state || (0, _normalize2.default)({
				selectedGroups: [],
				selected: [],
				inspected: []
			});
	
			switch (action.type) {
				case _index2.default['REQUEST_' + participantConstantName + 'S_SUCCESS']:
					newState = (0, _normalize2.default)(state, action.payload.participants);
					break;
	
				case _index2.default['SELECT_' + participantConstantName]:
					newState = selectParticipants(newState, 'selected', action.payload.selected, [action.payload.id]);
					break;
	
				case _index2.default['SELECT_' + participantConstantName + 'S']:
					newState = selectParticipants(newState, 'selected', action.payload.selected, action.payload.ids);
					break;
	
				case _index2.default.SELECT_PARTICIPANTS_GROUP:
					newState = selectParticipantsGroup(participantName, newState, action);
					break;
	
				case _index2.default['UNSELECT_' + participantConstantName + 'S']:
					newState = unSelectParticipants(newState, action);
					break;
	
				case _index2.default.SELECT_VIEWER_SUBCOLUMN:
					newState = selectParticipants(newState, 'inspected', action.payload.selected, [action.payload.value]);
					break;
	
				default:
			}
			return newState;
		};
	};
	
	function forParticipant(participantName) {
		return participantsReducer(participantName);
	};

/***/ },
/* 270 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.default = scheduleControlsReducer;
	
	var _index = __webpack_require__(5);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _normalize = __webpack_require__(21);
	
	var _normalize2 = _interopRequireDefault(_normalize);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var defaultState = (0, _normalize2.default)({ layersMenuOpen: false }, [{ id: 'teachers', name: 'Staff', imgSrc: __webpack_require__(297), height: 16, width: 16 }, { id: 'cohorts', name: 'Students', imgSrc: __webpack_require__(296), height: 16, width: 19 }]);
	
	function scheduleControlsReducer() {
		var state = arguments.length <= 0 || arguments[0] === undefined ? defaultState : arguments[0];
		var action = arguments[1];
	
		var newState = state;
	
		var menuItem = void 0;
	
		switch (action.type) {
			case _index2.default.SELECT_LAYERS_MENU_ITEM:
				newState = Object.assign({}, newState, {
					layersMenuOpen: action.payload.selected
				});
				break;
			case _index2.default.SELECT_CONTROLS_MENU_ITEM:
				menuItem = action.payload.selected ? [action.payload.id] : [];
				newState = Object.assign({}, newState, {
					selected: menuItem
				});
				break;
			case _index2.default.HIDE_OPEN_TRAYS:
				newState = Object.assign({}, newState, {
					selected: [],
					layersMenuOpen: false
				});
				break;
	
			default:
		}
		return newState;
	};

/***/ },
/* 271 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.default = scheduleViewerReducer;
	
	var _underscore = __webpack_require__(7);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _index = __webpack_require__(5);
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var defaultState = {
		selectedColumns: [],
		selectedSubColumns: [],
		hiddenColumns: [],
		timeInterval: 30,
		columnProperty: 'day_of_week',
		subColumnProperty: 'teacher_ids'
	};
	
	function scheduleViewerReducer() {
		var state = arguments.length <= 0 || arguments[0] === undefined ? defaultState : arguments[0];
		var action = arguments[1];
	
		var newState = state;
	
		switch (action.type) {
			case _index2.default.SELECT_VIEWER_COLUMN:
				newState = Object.assign({}, newState);
				if (action.payload.selected) {
					newState.selectedColumns = newState.selectedColumns.concat([action.payload.name]);
				} else {
					newState.selectedColumns = _underscore2.default.without(newState.selectedColumns, action.payload.name);
				}
				break;
	
			case _index2.default.HIDE_VIEWER_COLUMN:
				newState = Object.assign({}, newState);
				newState.hiddenColumns = newState.hiddenColumns.concat([action.payload.name]);
				break;
	
			case _index2.default.UNHIDE_VIEWER_COLUMNS:
				newState = Object.assign({}, newState);
				newState.hiddenColumns = [];
				break;
	
			case _index2.default.SELECT_VIEWER_SUBCOLUMN:
				newState = Object.assign({}, newState);
				if (action.payload.selected) {
					newState.selectedSubColumns = newState.selectedSubColumns.concat([{
						index: action.payload.index,
						name: action.payload.name
					}]);
				} else {
					newState.selectedSubColumns = _underscore2.default.reject(newState.selectedSubColumns, function (column) {
						return column.index === action.payload.index && column.name === action.payload.name;
					});
				}
				break;
			default:
		}
		return newState;
	};

/***/ },
/* 272 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.references = undefined;
	exports.default = scheduledMeetingsReducer;
	
	var _underscore = __webpack_require__(7);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _index = __webpack_require__(5);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _normalize = __webpack_require__(21);
	
	var _normalize2 = _interopRequireDefault(_normalize);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var references = exports.references = [{ reference: 'meeting_id', association: 'meeting', source: 'meetings' }, { reference: 'teacher_ids', association: 'teachers', source: 'teachers' }, { reference: 'cohort_ids', association: 'cohorts', source: 'cohorts' }];
	
	var defaultState = (0, _normalize2.default)({ selected: [], inspected: [] }, null, references);
	
	function scheduledMeetingsReducer() {
		var state = arguments.length <= 0 || arguments[0] === undefined ? defaultState : arguments[0];
		var action = arguments[1];
	
		var newState = state;
		var ids = void 0;
	
		(function () {
			switch (action.type) {
				case _index2.default.REQUEST_SCHEDULED_MEETINGS_SUCCESS:
					newState = (0, _normalize2.default)(state, action.payload.scheduledMeetings);
					break;
	
				case _index2.default.SELECT_VIEWER_CELL:
					newState = Object.assign({}, newState);
					if (action.payload.selected) {
						newState.inspected = [action.payload.scheduledMeetingId.toString()];
					} else {
						newState.inspected = _underscore2.default.without(newState.inspected, action.payload.scheduledMeetingId.toString());
					}
					break;
	
				case _index2.default.SELECT_TEACHER:
				case _index2.default.SELECT_TEACHERS:
				case _index2.default.SELECT_PARTICIPANTS_GROUP:
					if (!action.payload.selected) {
						newState = Object.assign({}, newState, { inspected: [] });
					}
					break;
	
				case _index2.default.UNSELECT_TEACHERS:
				case _index2.default.UNSELECT_COHORTS:
					newState = Object.assign({}, newState, { inspected: [] });
					break;
	
				case _index2.default.CHANGE_SCHEDULED_MEETING_NAMES:
					var meeting_id = action.payload.meeting_id;
					ids = action.payload.ids;
					newState = Object.assign({}, newState);
					newState.entities = Object.assign({}, newState.entities);
	
					ids.reduce(function (entities, id) {
						entities[id] = Object.assign({}, newState.entities[id], { name: meeting_id, meeting_id: meeting_id });
						return entities;
					}, newState.entities);
	
					break;
	
				default:
			}
		})();
	
		return newState;
	};

/***/ },
/* 273 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.default = schedulesReducer;
	
	var _index = __webpack_require__(5);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _normalize = __webpack_require__(21);
	
	var _normalize2 = _interopRequireDefault(_normalize);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var defaultState = (0, _normalize2.default)({
		loading: true,
		school: null,
		term: null,
		schedule: null,
		selected: []
	});
	
	function schedulesReducer() {
		var state = arguments.length <= 0 || arguments[0] === undefined ? defaultState : arguments[0];
		var action = arguments[1];
	
		var newState = state;
	
		switch (action.type) {
			case _index2.default.REQUEST_SCHEDULES:
	
				newState = Object.assign({}, newState, {
					school: action.payload.school,
					term: action.payload.term
				});
				break;
	
			case _index2.default.REQUEST_SCHEDULES_SUCCESS:
				newState = (0, _normalize2.default)(state, action.payload.schedules);
				break;
	
			case _index2.default.REQUEST_SCHEDULE_SUCCESS:
				newState = Object.assign({}, newState, {
					schedule: action.payload.schedule.id,
					selected: [action.payload.schedule.id],
					loading: false
				});
				break;
			default:
		}
	
		if (!newState.schedule && newState.items.length > 0) {
			newState.schedule = newState.items[0];
		}
		return newState;
	};

/***/ },
/* 274 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = studentCohortsFiltersReducer;
	
	var _index = __webpack_require__(5);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _normalize = __webpack_require__(21);
	
	var _normalize2 = _interopRequireDefault(_normalize);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var defaultState = (0, _normalize2.default)({ selected: ['all'] }, [{
	  id: 'reading_intervention',
	  name: 'Reading Intervention',
	  selectedClass: 'abl-student-cohorts-reading-intervention',
	  students: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10]
	}, {
	  id: 'ell',
	  name: 'ELL',
	  selectedClass: 'abl-student-cohorts-ell',
	  students: [10, 11, 12, 13, 14]
	}, {
	  id: 'iep_special_ed',
	  name: 'IEP / Special Ed',
	  selectedClass: 'abl-student-cohorts-iep',
	  students: [21, 22, 23, 24]
	}, {
	  id: 'math_intervention',
	  name: 'Math Intervention',
	  selectedClass: 'abl-student-cohorts-math-intervention',
	  students: [15, 16, 17, 18, 19, 20]
	}]);
	
	function studentCohortsFiltersReducer() {
	  var state = arguments.length <= 0 || arguments[0] === undefined ? defaultState : arguments[0];
	  var action = arguments[1];
	
	  var newState = state;
	
	  switch (action.type) {
	    case _index2.default.CHANGE_STUDENT_COHORT_FILTER:
	      if (action.payload.selected) {
	        newState = Object.assign({}, newState, {
	          selected: [action.payload.id]
	        });
	      } else {
	        newState = Object.assign({}, newState, {
	          selected: []
	        });
	      }
	      break;
	    case _index2.default.SELECT_VIEWER_CELL:
	      newState = Object.assign({}, newState, {
	        selected: []
	      });
	      break;
	    default:
	  }
	
	  return newState;
	};

/***/ },
/* 275 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _abl = __webpack_require__(12);
	
	var _abl2 = _interopRequireDefault(_abl);
	
	var _backbone = __webpack_require__(76);
	
	var _backbone2 = _interopRequireDefault(_backbone);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(16);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _reduxThunk = __webpack_require__(369);
	
	var _reduxThunk2 = _interopRequireDefault(_reduxThunk);
	
	var _redux = __webpack_require__(75);
	
	var _reactRedux = __webpack_require__(31);
	
	var _index = __webpack_require__(264);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _clients = __webpack_require__(221);
	
	var _clients2 = _interopRequireDefault(_clients);
	
	var _app_container = __webpack_require__(251);
	
	var _app_container2 = _interopRequireDefault(_app_container);
	
	var _schedule_viewer_container = __webpack_require__(254);
	
	var _schedule_viewer_container2 = _interopRequireDefault(_schedule_viewer_container);
	
	var _schedule_header_container = __webpack_require__(252);
	
	var _schedule_header_container2 = _interopRequireDefault(_schedule_header_container);
	
	var _schedule_inspector_container = __webpack_require__(253);
	
	var _schedule_inspector_container2 = _interopRequireDefault(_schedule_inspector_container);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Router = _backbone2.default.Router.extend({
	
	  routes: {
	    '': 'index',
	    'school/:school/schedules/:term(/:scheduleId)': 'schedule',
	    '*404': '404'
	  },
	
	  initialize: function initialize() {},
	
	  index: function index() {
	    var defaultUrl = _abl2.default.config.defaultUrl;
	    if (defaultUrl) {
	      this.navigate(defaultUrl, {
	        trigger: true,
	        replace: true
	      });
	    }
	  },
	
	  404: function _() {
	    console.log('404 page');
	  },
	
	  schedule: function schedule(school, term, scheduleId) {
	    var store = (0, _redux.createStore)(_index2.default, {}, (0, _redux.compose)((0, _redux.applyMiddleware)(_reduxThunk2.default.withExtraArgument(_clients2.default)), _abl2.default.config.reduxDevTools ? _abl2.default.config.reduxDevTools() : function (f) {
	      return f;
	    }));
	
	    var data = {
	      school: school,
	      term: term,
	      scheduleId: scheduleId
	    };
	
	    _reactDom2.default.render(_react2.default.createElement(
	      _reactRedux.Provider,
	      { store: store },
	      _react2.default.createElement(
	        _app_container2.default,
	        { data: data },
	        _react2.default.createElement(
	          'div',
	          { className: 'abl-schedule-app' },
	          _react2.default.createElement(_schedule_header_container2.default, { data: data }),
	          _react2.default.createElement(_schedule_inspector_container2.default, { data: data }),
	          _react2.default.createElement(_schedule_viewer_container2.default, { data: data })
	        )
	      )
	    ), document.getElementsByClassName('abl-bdy')[0]);
	  }
	});
	
	exports.default = Router;

/***/ },
/* 276 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = appSelector;
	
	var _index = __webpack_require__(5);
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var renderLoadingIndicator = function renderLoadingIndicator(state) {
	  return state.appStatus !== _index2.default.APP_STATUS.UNAUTHENTICATED && state.appStatus !== _index2.default.APP_STATUS.READY;
	};
	
	var renderAuthView = function renderAuthView(state) {
	  return state.appStatus === _index2.default.APP_STATUS.UNAUTHENTICATED;
	};
	
	var renderScheduleView = function renderScheduleView(state) {
	  return state.appStatus === _index2.default.APP_STATUS.READY;
	};
	
	function appSelector(state) {
	
	  return {
	    renderLoadingIndicator: renderLoadingIndicator(state),
	    renderAuthView: renderAuthView(state),
	    renderScheduleView: renderScheduleView(state),
	    hasErrors: state.errors.length > 0,
	    modalIsOpen: state.modal.isOpen
	  };
	};

/***/ },
/* 277 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _underscore = __webpack_require__(7);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _reselect = __webpack_require__(15);
	
	var _scheduled_meetings_selector = __webpack_require__(51);
	
	var _scheduled_meetings_selector2 = _interopRequireDefault(_scheduled_meetings_selector);
	
	var _teachers_selector = __webpack_require__(33);
	
	var _teachers_selector2 = _interopRequireDefault(_teachers_selector);
	
	var _time = __webpack_require__(24);
	
	var _time2 = _interopRequireDefault(_time);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _meetingsDoNotIntersect = function _meetingsDoNotIntersect(inspectedMeeting, teacherScheduledMeeting) {
	  return teacherScheduledMeeting.day_of_week !== inspectedMeeting.day_of_week || _time2.default.parse(teacherScheduledMeeting.end_time).totalMinutes <= _time2.default.parse(inspectedMeeting.start_time).totalMinutes || _time2.default.parse(teacherScheduledMeeting.start_time).totalMinutes >= _time2.default.parse(inspectedMeeting.end_time).totalMinutes;
	};
	
	var _scheduledMeetingsForTeacher = function _scheduledMeetingsForTeacher(teacher, state) {
	  return _underscore2.default.chain(teacher.scheduled_meeting_ids).map(function (id) {
	    return state.scheduledMeetings.entities[id];
	  }).select(function (scheduledMeeting) {
	    return scheduledMeeting && scheduledMeeting.meeting_id && scheduledMeeting.name !== 'Available';
	  }).value();
	};
	
	var availableStaffSelector = (0, _reselect.createSelector)(function (state) {
	  return state;
	}, function (state) {
	  return _scheduled_meetings_selector2.default.getInspected(state);
	}, function (state, scheduledMeetings) {
	  var availableStaff = _underscore2.default.chain(_teachers_selector2.default.getAll(state)).select(function (teacher) {
	    var teacherScheduledMeetings = _scheduledMeetingsForTeacher(teacher, state);
	    return _underscore2.default.all(scheduledMeetings, function (inspectedMeeting) {
	      return _underscore2.default.all(teacherScheduledMeetings, function (teacherScheduledMeeting) {
	        return _meetingsDoNotIntersect(inspectedMeeting, teacherScheduledMeeting);
	      });
	    });
	  }).map(function (teacher) {
	    return Object.assign(teacher, { availability: "full" });
	  }).value();
	
	  // temporary hack to demonstrate partial availability display
	  // (we're not calculating partial availability yet)
	  if (availableStaff.length > 0) {
	    availableStaff[availableStaff.length - 1].availability = "partial";
	  }
	
	  return availableStaff;
	});
	
	exports.default = availableStaffSelector;

/***/ },
/* 278 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _underscore = __webpack_require__(7);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _reselect = __webpack_require__(15);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var subColumnDisplayName = function subColumnDisplayName(teachersById, cohortsById, subColumn) {
	  var name = subColumn.name;
	  var participant = void 0;
	  if (subColumn.type === 'teacher') {
	    participant = teachersById[subColumn.value];
	  } else if (subColumn.type === 'cohort') {
	    participant = cohortsById[subColumn.value];
	  }
	
	  name = participant ? participant.displayName || participant.name : name;
	
	  return name;
	};
	
	var columnSelector = (0, _reselect.createSelector)(function (viewerState, columns, selectedTeachers, selectedCohorts) {
	  return viewerState;
	}, function (viewerState, columns, selectedTeachers, selectedCohorts) {
	  return columns;
	}, function (viewerState, columns, selectedTeachers, selectedCohorts) {
	  return selectedTeachers;
	}, function (viewerState, columns, selectedTeachers, selectedCohorts) {
	  return selectedCohorts;
	}, function (viewerState, columns, selectedTeachers, selectedCohorts) {
	
	  var getKey = function getKey(index, name) {
	    return index + '_' + name;
	  };
	  var teachersById = _underscore2.default.indexBy(selectedTeachers, 'id');
	  var cohortsById = _underscore2.default.indexBy(selectedCohorts, 'id');
	
	  var subColumns = _underscore2.default.groupBy(viewerState.selectedSubColumns, function (subColumn) {
	    return getKey(subColumn.index, subColumn.name);
	  });
	
	  return columns.reduce(function (newColumns, column) {
	    var count = 0;
	    column.selected = _underscore2.default.contains(viewerState.selectedColumns, column.name);
	    column.hidden = _underscore2.default.contains(viewerState.hiddenColumns, column.name);
	    column.className = 'abl-col-border';
	
	    if (!column.hidden) {
	      column.subColumns.items.forEach(function (subColumn) {
	        var key = getKey(subColumn.column.index, subColumn.name);
	        var isBorder = count > 0 && (count + 1) % column.subColumns.items.length === 0;
	
	        subColumn.selected = subColumns[key] !== undefined;
	        subColumn.displayName = subColumnDisplayName(teachersById, cohortsById, subColumn);
	        subColumn.iconName = subColumn.type.substr(0, 1);
	        subColumn.className = isBorder ? column.className : '';
	        count++;
	      });
	      newColumns.push(column);
	    }
	
	    return newColumns;
	  }, []);
	});
	
	exports.default = columnSelector;

/***/ },
/* 279 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = inspectorCards;
	var meetingDetails = function meetingDetails(selectedMeetings) {
	  var details = void 0;
	  if (selectedMeetings.length >= 1) {
	    details = Object.assign({}, selectedMeetings[0], {
	      start_time: selectedMeetings[0].start_time.replace(/am|pm/, ''),
	      end_time: selectedMeetings[0].end_time.replace(/am|pm/, '')
	    });
	  } else {
	    details = {
	      meeting_id: '',
	      cohorts: [],
	      teachers: [],
	      meeting: { name: '-' },
	      day_of_week: '-',
	      start_time: '-',
	      end_time: '-',
	      durationString: '-'
	    };
	  }
	  return details;
	};
	
	var getDefaultCards = function getDefaultCards(meetings, available_staff, studentCohort) {
	  return [{
	    id: 'summary',
	    meetingDetails: meetingDetails(meetings),
	    meetings: meetings
	  }, { id: 'agenda' }, Object.assign({
	    id: 'students'
	  }, studentCohort), {
	    id: 'staff_availability',
	    teachers: available_staff
	  }, { id: 'facilities' }];
	};
	
	function inspectorCards(_ref) {
	  var meetings = _ref.meetings;
	  var teachers = _ref.teachers;
	  var days = _ref.days;
	  var available_staff = _ref.available_staff;
	  var studentCohort = _ref.studentCohort;
	
	  var cards = getDefaultCards(meetings, available_staff, studentCohort);
	  cards.forEach(function (card) {
	    card.open = true;
	  });
	  return cards;
	};

/***/ },
/* 280 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _underscore = __webpack_require__(7);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _reselect = __webpack_require__(15);
	
	var _scheduled_meetings_selector = __webpack_require__(51);
	
	var _scheduled_meetings_selector2 = _interopRequireDefault(_scheduled_meetings_selector);
	
	var _teachers_selector = __webpack_require__(33);
	
	var _teachers_selector2 = _interopRequireDefault(_teachers_selector);
	
	var _available_staff_selector = __webpack_require__(277);
	
	var _available_staff_selector2 = _interopRequireDefault(_available_staff_selector);
	
	var _student_cohort_card_selector = __webpack_require__(286);
	
	var _student_cohort_card_selector2 = _interopRequireDefault(_student_cohort_card_selector);
	
	var _inspector_cards = __webpack_require__(279);
	
	var _inspector_cards2 = _interopRequireDefault(_inspector_cards);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var inspectorSelector = (0, _reselect.createSelector)(function (state) {
	  return _scheduled_meetings_selector2.default.getInspected(state);
	}, function (state) {
	  return _teachers_selector2.default.getInspected(state);
	}, function (state) {
	  return (0, _available_staff_selector2.default)(state);
	}, function (state) {
	  return (0, _student_cohort_card_selector2.default)(state);
	}, function (state) {
	  return state.schedules;
	}, function (inspectedMeetings, inspectedTeachers, availableStaff, studentCohort, schedules) {
	  var cardsData = {
	    meetings: inspectedMeetings,
	    teachers: _underscore2.default.uniq(inspectedTeachers),
	    available_staff: _underscore2.default.uniq(availableStaff),
	    studentCohort: studentCohort
	  };
	
	  return {
	    schedules: schedules,
	    cards: (0, _inspector_cards2.default)(cardsData),
	    showCards: cardsData.meetings.length > 0 || cardsData.teachers.length > 0
	  };
	});
	
	exports.default = inspectorSelector;

/***/ },
/* 281 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _entities_selector = __webpack_require__(17);
	
	var _entities_selector2 = _interopRequireDefault(_entities_selector);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var meetingLabelsSelector = (0, _entities_selector2.default)(function (state) {
	  return state.meetingLabels;
	});
	
	exports.default = meetingLabelsSelector;

/***/ },
/* 282 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _entities_selector = __webpack_require__(17);
	
	var _entities_selector2 = _interopRequireDefault(_entities_selector);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var meetingsSelector = (0, _entities_selector2.default)(function (state) {
	  return state.meetings;
	}, function (meeting, localState, associations) {
	  return {
	    noninstructional: !meeting.instructional && meeting.name !== 'Prep'
	  };
	});
	
	exports.default = meetingsSelector;

/***/ },
/* 283 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _underscore = __webpack_require__(7);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _reselect = __webpack_require__(15);
	
	var _entities_selector = __webpack_require__(17);
	
	var _entities_selector2 = _interopRequireDefault(_entities_selector);
	
	var _teachers_selector = __webpack_require__(33);
	
	var _teachers_selector2 = _interopRequireDefault(_teachers_selector);
	
	var _cohorts_selector = __webpack_require__(50);
	
	var _cohorts_selector2 = _interopRequireDefault(_cohorts_selector);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var getParticipantGroups = (0, _reselect.createSelector)(function (state, selector) {
		return selector.getAll(state);
	}, function (state, selector) {
		return selector.getState(state).selectedGroups;
	}, function (participants, selectedGroups) {
	
		var groupsHash = {};
		return participants.reduce(function (groups, participant) {
			var group = groupsHash[participant.group];
	
			if (!group) {
				group = groupsHash[participant.group] = {
					id: participant.group_id || -1,
					name: participant.group,
					selected: _underscore2.default.contains(selectedGroups, participant.group_id),
					items: []
				};
				groups.push(group);
			}
	
			group.items.push(participant);
			return groups;
		}, []);
	});
	
	var menuItemsSelector = (0, _entities_selector2.default)(function (state) {
		return state.controls;
	});
	
	var navMenuSelector = (0, _reselect.createSelector)(function (state) {
		return menuItemsSelector.getAll(state);
	}, function (state) {
		return getParticipantGroups(state, _teachers_selector2.default);
	}, function (state) {
		return getParticipantGroups(state, _cohorts_selector2.default);
	}, function (menuItems, teacherGroups, cohortGroups) {
		return {
			menuItems: menuItems,
			teacherGroups: teacherGroups,
			cohortGroups: cohortGroups
		};
	});
	
	exports.default = navMenuSelector;

/***/ },
/* 284 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _entities_selector = __webpack_require__(17);
	
	var _entities_selector2 = _interopRequireDefault(_entities_selector);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var schedulesSelector = (0, _entities_selector2.default)(function (state) {
	  return state.schedules;
	});
	
	exports.default = schedulesSelector;

/***/ },
/* 285 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj; };
	
	var _underscore = __webpack_require__(7);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var addSelected = function addSelected(entity, prop, selected) {
		var selectedProp = {};
	
		if (selected !== undefined && selected !== null) {
			if (selected.length !== undefined) {
				selectedProp[prop] = _underscore2.default.contains(selected, entity.id.toString());
			} else if (typeof selected === 'boolean') {
				selectedProp[prop] = selected;
			} else if ((typeof selected === 'undefined' ? 'undefined' : _typeof(selected)) === 'object') {
				selectedProp[prop] = entity === selected;
			} else {
				selectedProp[prop] = entity.id === selected;
			}
		}
	
		return selectedProp;
	};
	
	exports.default = addSelected;

/***/ },
/* 286 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _reselect = __webpack_require__(15);
	
	var _student_cohort_filters_selector = __webpack_require__(287);
	
	var _student_cohort_filters_selector2 = _interopRequireDefault(_student_cohort_filters_selector);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var studentRatios = {
	  safe: 'abl-student-ratio-safe',
	  nearLimit: 'abl-student-ratio-near-limit',
	  aboveLimit: 'abl-student-ratio-above-limit'
	};
	
	var studentCohortCardSelector = (0, _reselect.createSelector)(function (state) {
	  return state;
	}, function (state) {
	  return _student_cohort_filters_selector2.default.getFilter(state);
	}, function (state) {
	  return _student_cohort_filters_selector2.default.getAll(state);
	}, function (state) {
	  return _student_cohort_filters_selector2.default.filterStudents(state);
	}, function (state, filter, filters, filteredStudents) {
	  var capacity = 24;
	
	  return {
	    capacity: capacity + ' Students',
	    studentRatio: studentRatios.nearLimit,
	    filterClassName: filter ? filter.selectedClass : null,
	    filteredStudents: filteredStudents,
	    filters: filters
	  };
	});
	
	exports.default = studentCohortCardSelector;

/***/ },
/* 287 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _underscore = __webpack_require__(7);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _reselect = __webpack_require__(15);
	
	var _entities_selector = __webpack_require__(17);
	
	var _entities_selector2 = _interopRequireDefault(_entities_selector);
	
	var _fake_names = __webpack_require__(255);
	
	var _fake_names2 = _interopRequireDefault(_fake_names);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var stateSelector = function stateSelector(state) {
	  return state.studentCohortFilters;
	};
	
	var studentCohortFiltersSelector = (0, _entities_selector2.default)(stateSelector);
	
	var getFilter = function getFilter(state) {
	  return studentCohortFiltersSelector.getSelected(state)[0];
	};
	
	var getClassName = function getClassName(student, index, capacity, filter) {
	  var classNames = [];
	
	  if (index > capacity) {
	    classNames.push('abl-student-unscheduled');
	  }
	  if (filter && filter.students && filter.students.includes(student)) {
	    classNames.push(filter.selectedClass);
	  }
	
	  return classNames.join(' ');
	};
	
	var filterStudents = (0, _reselect.createSelector)(function (state) {
	  return getFilter(state);
	}, function (state) {
	  return Array.from(Array(30).keys());
	}, function (state) {
	  return 24;
	}, function (filter, students, capacity) {
	
	  var filterStudents = filter ? filter.students : [];
	
	  return _underscore2.default.chain(students).sortBy(function (student) {
	    return filterStudents.includes(student) ? 0 : 1;
	  }).map(function (student, i) {
	    return {
	      name: _fake_names2.default[student],
	      className: getClassName(student, i, capacity, filter),
	      triggers: i <= capacity ? ['hover'] : []
	    };
	  }).value();
	});
	
	studentCohortFiltersSelector.getFilter = getFilter;
	studentCohortFiltersSelector.filterStudents = filterStudents;
	
	exports.default = studentCohortFiltersSelector;

/***/ },
/* 288 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _underscore = __webpack_require__(7);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _reselect = __webpack_require__(15);
	
	var _schedules_selector = __webpack_require__(284);
	
	var _schedules_selector2 = _interopRequireDefault(_schedules_selector);
	
	var _scheduled_meetings_selector = __webpack_require__(51);
	
	var _scheduled_meetings_selector2 = _interopRequireDefault(_scheduled_meetings_selector);
	
	var _teachers_selector = __webpack_require__(33);
	
	var _teachers_selector2 = _interopRequireDefault(_teachers_selector);
	
	var _cohorts_selector = __webpack_require__(50);
	
	var _cohorts_selector2 = _interopRequireDefault(_cohorts_selector);
	
	var _nav_menu_selector = __webpack_require__(283);
	
	var _nav_menu_selector2 = _interopRequireDefault(_nav_menu_selector);
	
	var _meeting_layers_selector = __webpack_require__(99);
	
	var _meeting_layers_selector2 = _interopRequireDefault(_meeting_layers_selector);
	
	var _meeting_labels_selector = __webpack_require__(281);
	
	var _meeting_labels_selector2 = _interopRequireDefault(_meeting_labels_selector);
	
	var _column_selector = __webpack_require__(278);
	
	var _column_selector2 = _interopRequireDefault(_column_selector);
	
	var _schedule_table = __webpack_require__(259);
	
	var _schedule_table2 = _interopRequireDefault(_schedule_table);
	
	var _time = __webpack_require__(24);
	
	var _time2 = _interopRequireDefault(_time);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var classNames = function classNames(meetingLabels, columnCount, subColumnCount) {
	  return meetingLabels.reduce(function (names, label) {
	    if (label.selected) {
	      names.push('abl-meeting-label-' + label.id);
	    }
	    return names;
	  }, ['abl-subcols-' + columnCount * subColumnCount]);
	};
	
	var startTime = (0, _reselect.createSelector)(function (scheduledMeetings) {
	  return scheduledMeetings;
	}, function (scheduledMeetings) {
	  var meeting = _underscore2.default.min(scheduledMeetings, function (item) {
	    return _time2.default.parse(item.start_time).totalMinutes;
	  });
	  return meeting.start_time;
	});
	
	var endTime = (0, _reselect.createSelector)(function (scheduledMeetings) {
	  return scheduledMeetings;
	}, function (scheduledMeetings) {
	  var meeting = _underscore2.default.max(scheduledMeetings, function (item) {
	    return _time2.default.parse(item.end_time).totalMinutes;
	  });
	  return meeting.end_time;
	});
	
	var subColumnCount = function subColumnCount(columns) {
	  return columns.reduce(function (count, column) {
	    count = Math.max(count, column.subColumns.items.length);
	    return count;
	  }, 0);
	};
	
	var teachersFilter = function teachersFilter(selectedTeacherIds) {
	  return function (scheduledMeeting) {
	    return _underscore2.default.intersection(selectedTeacherIds, scheduledMeeting.teacher_ids).length > 0;
	  };
	};
	
	var cohortsFilter = function cohortsFilter(selectedCohortIds) {
	  return function (scheduledMeeting) {
	    return _underscore2.default.intersection(selectedCohortIds, scheduledMeeting.cohort_ids).length > 0;
	  };
	};
	
	var scheduleFilterGroups = function scheduleFilterGroups(_ref) {
	  var type = _ref.type;
	  var attribute = _ref.attribute;
	  var values = _ref.values;
	  return _underscore2.default.map(values, function (value) {
	    return { type: type, attribute: attribute, name: '' + value, filter: function filter(meeting) {
	        return (meeting[attribute] || []).includes(value);
	      } };
	  });
	};
	
	var getSubColumnFilters = (0, _reselect.createSelector)(function (state) {
	  return _teachers_selector2.default.getSelected(state);
	}, function (state) {
	  return _cohorts_selector2.default.getSelected(state);
	}, function (selectedTeachers, selectedCohorts) {
	  var selectedTeacherIds = _underscore2.default.pluck(selectedTeachers, "id");
	  var selectedCohortIds = _underscore2.default.pluck(selectedCohorts, "id");
	
	  return _underscore2.default.flatten([scheduleFilterGroups({ type: 'teacher', attribute: 'teacher_ids', values: selectedTeacherIds }), scheduleFilterGroups({ type: 'cohort', attribute: 'cohort_ids', values: selectedCohortIds })]);
	});
	
	var getScheduleFilters = (0, _reselect.createSelector)(function (state) {
	  return _teachers_selector2.default.getSelected(state);
	}, function (state) {
	  return _cohorts_selector2.default.getSelected(state);
	}, function (selectedTeachers, selectedCohorts) {
	  var selectedTeacherIds = _underscore2.default.pluck(selectedTeachers, "id");
	  var selectedCohortIds = _underscore2.default.pluck(selectedCohorts, "id");
	
	  return [{
	    join: 'any',
	    filters: [teachersFilter(selectedTeacherIds), cohortsFilter(selectedCohortIds)]
	  }];
	});
	
	var getViewerTable = (0, _reselect.createSelector)(function (state) {
	  return state.viewer;
	}, function (state) {
	  return _scheduled_meetings_selector2.default.getAll(state);
	}, function (state) {
	  return _scheduled_meetings_selector2.default.getActive(state, getScheduleFilters(state));
	}, function (state) {
	  return getSubColumnFilters(state);
	}, function (state) {
	  return _teachers_selector2.default.getSelected(state);
	}, function (state) {
	  return _cohorts_selector2.default.getSelected(state);
	}, function (viewerState, scheduledMeetings, activeMeetings, subColumnFilters, selectedTeachers, selectedCohorts) {
	  var props = viewerState;
	  var table = new _schedule_table2.default(Object.assign({
	    scheduledMeetings: activeMeetings,
	    subColumnFilters: subColumnFilters,
	    startTime: startTime(scheduledMeetings),
	    endTime: endTime(scheduledMeetings)
	  }, props));
	
	  var columns = (0, _column_selector2.default)(viewerState, table.columns(), selectedTeachers, selectedCohorts);
	
	  return {
	    table: table,
	    columns: columns
	  };
	});
	
	var getLayers = (0, _reselect.createSelector)(function (state) {
	  return state.controls.layersMenuOpen;
	}, function (state) {
	  return _meeting_layers_selector2.default.getAll(state);
	}, function (state) {
	  return _meeting_labels_selector2.default.getAll(state);
	}, function (layersMenuOpen, highlights, labels) {
	  return {
	    selected: layersMenuOpen,
	    highlights: highlights,
	    labels: labels
	  };
	});
	
	var viewerSelector = (0, _reselect.createSelector)(function (state) {
	  return state.schedules.loading;
	}, function (state) {
	  return _schedules_selector2.default.getAll(state);
	}, function (state) {
	  return getViewerTable(state);
	}, function (state) {
	  return getLayers(state);
	}, function (state) {
	  return (0, _nav_menu_selector2.default)(state);
	}, function (state) {
	  return state.viewer;
	}, function (state) {
	  return _meeting_labels_selector2.default.getSelected(state);
	}, function (state) {
	  return _meeting_layers_selector2.default.getSelected(state);
	}, function (loading, schedules, _ref2, layers, scheduleControls, viewerState, meetingLabels, meetingLayers) {
	  var table = _ref2.table;
	  var columns = _ref2.columns;
	
	
	  var props = {
	    loading: loading,
	    schedules: schedules,
	    table: {
	      columnCount: columns.length,
	      subColumnCount: subColumnCount(columns),
	      rowHeaders: table.rowHeaders(),
	      rowHeadersDisplay: table.rowHeaders().length === 0 ? 'none' : null,
	      columns: columns,
	      display: table.columns().length === 0 ? 'none' : null,
	      unHideColumnsButtonDisplay: viewerState.hiddenColumns.length === 0 ? 'none' : null
	    },
	    controls: scheduleControls,
	    layers: layers
	  };
	
	  _meeting_layers_selector2.default.add(meetingLayers, table.scheduledMeetings);
	
	  props.className = classNames(meetingLabels, props.table.columnCount, props.table.subColumnCount).join(' ');
	
	  return props;
	});
	
	exports.default = viewerSelector;

/***/ },
/* 289 */
100,
/* 290 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/current_user_avatar_fpo.3ee673dd.png";

/***/ },
/* 291 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/share_and_export_fpo.09ba1d99.png";

/***/ },
/* 292 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/share_modal_fpo.dcfa5f1b.png";

/***/ },
/* 293 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/error_image.2641f3d5.svg";

/***/ },
/* 294 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/export_icon.ec663481.svg";

/***/ },
/* 295 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/logo.2ac40bbb.svg";

/***/ },
/* 296 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/nav_menu_students.fe5d0d00.svg";

/***/ },
/* 297 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/nav_menu_teachers.e24f674d.svg";

/***/ },
/* 298 */
/***/ function(module, exports) {

	module.exports = {
		"spreadsheetId": "1",
		"properties": {
			"title": "Version 1 Test Schedule"
		},
		"sheets": [
			{
				"properties": {
					"sheetId": 293666632,
					"title": "School",
					"index": 0,
					"sheetType": "GRID",
					"gridProperties": {
						"rowCount": 502,
						"columnCount": 12,
						"frozenRowCount": 1,
						"frozenColumnCount": 1
					}
				},
				"data": [
					{
						"rowData": [
							{
								"values": [
									{},
									{},
									{
										"formattedValue": "Monday"
									},
									{},
									{
										"formattedValue": "Tuesday"
									},
									{},
									{
										"formattedValue": "Wednesday"
									},
									{},
									{
										"formattedValue": "Thursday"
									},
									{},
									{
										"formattedValue": "Friday"
									},
									{}
								]
							},
							{
								"values": [
									{},
									{
										"formattedValue": "teacher_id"
									},
									{
										"formattedValue": "meeting_id"
									},
									{
										"formattedValue": "section_id"
									},
									{
										"formattedValue": "meeting_id"
									},
									{
										"formattedValue": "section_id"
									},
									{
										"formattedValue": "meeting_id"
									},
									{
										"formattedValue": "section_id"
									},
									{
										"formattedValue": "meeting_id"
									},
									{
										"formattedValue": "section_id"
									},
									{
										"formattedValue": "meeting_id"
									},
									{
										"formattedValue": "section_id"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "7:45-8:00"
									},
									{
										"formattedValue": "KA"
									},
									{
										"formattedValue": "ELD"
									},
									{
										"formattedValue": "KA"
									},
									{
										"formattedValue": "Intake"
									},
									{
										"formattedValue": "KA"
									},
									{
										"formattedValue": "Intake"
									},
									{
										"formattedValue": "KA"
									},
									{
										"formattedValue": "Intake"
									},
									{
										"formattedValue": "KA"
									},
									{
										"formattedValue": "Intake"
									},
									{
										"formattedValue": "KA"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "8:00-8:15"
									},
									{
										"formattedValue": "KA"
									},
									{
										"formattedValue": "ELD"
									},
									{
										"formattedValue": "KA"
									},
									{
										"formattedValue": "ELD"
									},
									{
										"formattedValue": "KA"
									},
									{
										"formattedValue": "ELD"
									},
									{
										"formattedValue": "KA"
									},
									{
										"formattedValue": "ELD"
									},
									{
										"formattedValue": "KA"
									},
									{
										"formattedValue": "ELD"
									},
									{
										"formattedValue": "KA"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "8:15-8:30"
									},
									{
										"formattedValue": "KA"
									},
									{
										"formattedValue": "ELD"
									},
									{
										"formattedValue": "KA"
									},
									{
										"formattedValue": "ELD"
									},
									{
										"formattedValue": "KA"
									},
									{
										"formattedValue": "ELD"
									},
									{
										"formattedValue": "KA"
									},
									{
										"formattedValue": "ELD"
									},
									{
										"formattedValue": "KA"
									},
									{
										"formattedValue": "ELD"
									},
									{
										"formattedValue": "KA"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "8:30 - 8:45"
									},
									{
										"formattedValue": "KA"
									},
									{
										"formattedValue": "PE"
									},
									{
										"formattedValue": "KA"
									},
									{
										"formattedValue": "PE"
									},
									{
										"formattedValue": "KA"
									},
									{
										"formattedValue": "PE"
									},
									{
										"formattedValue": "KA"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "KA"
									},
									{
										"formattedValue": "PE"
									},
									{
										"formattedValue": "KA"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "8:45-9:00"
									},
									{
										"formattedValue": "KA"
									},
									{
										"formattedValue": "PE"
									},
									{
										"formattedValue": "KA"
									},
									{
										"formattedValue": "PE"
									},
									{
										"formattedValue": "KA"
									},
									{
										"formattedValue": "PE"
									},
									{
										"formattedValue": "KA"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "KA"
									},
									{
										"formattedValue": "PE"
									},
									{
										"formattedValue": "KA"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "9:00-9:15"
									},
									{
										"formattedValue": "KA"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "KA"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "KA"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "KA"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "KA"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "KA"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "9:15 - 9:30"
									},
									{
										"formattedValue": "KA"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "KA"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "KA"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "KA"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "KA"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "KA"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "9:30-9:45"
									},
									{
										"formattedValue": "KA"
									},
									{
										"formattedValue": "Rec"
									},
									{
										"formattedValue": "KA"
									},
									{
										"formattedValue": "Rec"
									},
									{
										"formattedValue": "KA"
									},
									{
										"formattedValue": "Rec"
									},
									{
										"formattedValue": "KA"
									},
									{
										"formattedValue": "Rec"
									},
									{
										"formattedValue": "KA"
									},
									{
										"formattedValue": "Rec"
									},
									{
										"formattedValue": "KA"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "9:45-10:00"
									},
									{
										"formattedValue": "KA"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "KA"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "KA"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "KA"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "KA"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "KA"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "10:00 - 10:15"
									},
									{
										"formattedValue": "KA"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "KA"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "KA"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "KA"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "KA"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "KA"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "10:15 - 10:30"
									},
									{
										"formattedValue": "KA"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "KA"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "KA"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "KA"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "KA"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "KA"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "10:30 - 10:45"
									},
									{
										"formattedValue": "KA"
									},
									{
										"formattedValue": "PWG"
									},
									{
										"formattedValue": "KA"
									},
									{
										"formattedValue": "COTEACH"
									},
									{
										"formattedValue": "KA"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "KA"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "KA"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "KA"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "10:45 - 11:00"
									},
									{
										"formattedValue": "KA"
									},
									{
										"formattedValue": "PWG"
									},
									{
										"formattedValue": "KA"
									},
									{
										"formattedValue": "COTEACH"
									},
									{
										"formattedValue": "KA"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "KA"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "KA"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "KA"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "11:00 - 11:15"
									},
									{
										"formattedValue": "KA"
									},
									{
										"formattedValue": "Lunch"
									},
									{
										"formattedValue": "KA"
									},
									{
										"formattedValue": "Lunch"
									},
									{
										"formattedValue": "KA"
									},
									{
										"formattedValue": "Lunch"
									},
									{
										"formattedValue": "KA"
									},
									{
										"formattedValue": "Lunch"
									},
									{
										"formattedValue": "KA"
									},
									{
										"formattedValue": "Lunch"
									},
									{
										"formattedValue": "KA"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "11:15 - 11:30"
									},
									{
										"formattedValue": "KA"
									},
									{
										"formattedValue": "Lunch"
									},
									{
										"formattedValue": "KA"
									},
									{
										"formattedValue": "Lunch"
									},
									{
										"formattedValue": "KA"
									},
									{
										"formattedValue": "Lunch"
									},
									{
										"formattedValue": "KA"
									},
									{
										"formattedValue": "Lunch"
									},
									{
										"formattedValue": "KA"
									},
									{
										"formattedValue": "Lunch"
									},
									{
										"formattedValue": "KA"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "11:30 - 11:45"
									},
									{
										"formattedValue": "KA"
									},
									{
										"formattedValue": "Lunch"
									},
									{
										"formattedValue": "KA"
									},
									{
										"formattedValue": "Lunch"
									},
									{
										"formattedValue": "KA"
									},
									{
										"formattedValue": "Lunch"
									},
									{
										"formattedValue": "KA"
									},
									{
										"formattedValue": "Lunch"
									},
									{
										"formattedValue": "KA"
									},
									{
										"formattedValue": "Lunch"
									},
									{
										"formattedValue": "KA"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "11:45 - 12:00"
									},
									{
										"formattedValue": "KA"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "KA"
									},
									{
										"formattedValue": "COTEACH"
									},
									{
										"formattedValue": "KA"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "KA"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "KA"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "KA"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "12:00 - 12:15"
									},
									{
										"formattedValue": "KA"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "KA"
									},
									{
										"formattedValue": "COTEACH"
									},
									{
										"formattedValue": "KA"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "KA"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "KA"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "KA"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "12:15 - 12:30"
									},
									{
										"formattedValue": "KA"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "KA"
									},
									{
										"formattedValue": "Prep"
									},
									{},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "KA"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "KA"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "KA"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "12:30-12:45"
									},
									{
										"formattedValue": "KA"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "KA"
									},
									{
										"formattedValue": "Prep"
									},
									{},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "KA"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "KA"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "KA"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "12:45-1:00"
									},
									{
										"formattedValue": "KA"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "KA"
									},
									{
										"formattedValue": "Prep"
									},
									{},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "KA"
									},
									{
										"formattedValue": "PD"
									},
									{
										"formattedValue": "KA"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "KA"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "1:00 - 1:15"
									},
									{
										"formattedValue": "KA"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "KA"
									},
									{
										"formattedValue": "Prep"
									},
									{},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "KA"
									},
									{
										"formattedValue": "PD"
									},
									{
										"formattedValue": "KA"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "KA"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "1:15 - 1:30"
									},
									{
										"formattedValue": "KA"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "KA"
									},
									{
										"formattedValue": "Prep"
									},
									{},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "KA"
									},
									{
										"formattedValue": "PD"
									},
									{
										"formattedValue": "KA"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "KA"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "1:30 - 1:45"
									},
									{
										"formattedValue": "KA"
									},
									{
										"formattedValue": "Prep"
									},
									{},
									{
										"formattedValue": "Prep"
									},
									{},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "KA"
									},
									{
										"formattedValue": "PD"
									},
									{
										"formattedValue": "KA"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "KA"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "1:45-2:00"
									},
									{
										"formattedValue": "KA"
									},
									{
										"formattedValue": "Prep"
									},
									{},
									{
										"formattedValue": "Prep"
									},
									{},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "KA"
									},
									{
										"formattedValue": "PD"
									},
									{
										"formattedValue": "KA"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "KA"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "7:45-8:00"
									},
									{
										"formattedValue": "KB"
									},
									{
										"formattedValue": "Intake"
									},
									{
										"formattedValue": "KB"
									},
									{
										"formattedValue": "Intake"
									},
									{
										"formattedValue": "KB"
									},
									{
										"formattedValue": "Intake"
									},
									{
										"formattedValue": "KB"
									},
									{
										"formattedValue": "Intake"
									},
									{
										"formattedValue": "KB"
									},
									{
										"formattedValue": "Intake"
									},
									{
										"formattedValue": "KB"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "8:00-8:15"
									},
									{
										"formattedValue": "KB"
									},
									{
										"formattedValue": "ELD"
									},
									{
										"formattedValue": "KB"
									},
									{
										"formattedValue": "ELD"
									},
									{
										"formattedValue": "KB"
									},
									{
										"formattedValue": "ELD"
									},
									{
										"formattedValue": "KB"
									},
									{
										"formattedValue": "ELD"
									},
									{
										"formattedValue": "KB"
									},
									{
										"formattedValue": "ELD"
									},
									{
										"formattedValue": "KB"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "8:15-8:30"
									},
									{
										"formattedValue": "KB"
									},
									{
										"formattedValue": "ELD"
									},
									{
										"formattedValue": "KB"
									},
									{
										"formattedValue": "ELD"
									},
									{
										"formattedValue": "KB"
									},
									{
										"formattedValue": "ELD"
									},
									{
										"formattedValue": "KB"
									},
									{
										"formattedValue": "ELD"
									},
									{
										"formattedValue": "KB"
									},
									{
										"formattedValue": "ELD"
									},
									{
										"formattedValue": "KB"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "8:30 - 8:45"
									},
									{
										"formattedValue": "KB"
									},
									{
										"formattedValue": "PE"
									},
									{
										"formattedValue": "KB"
									},
									{
										"formattedValue": "PE"
									},
									{
										"formattedValue": "KB"
									},
									{
										"formattedValue": "PE"
									},
									{
										"formattedValue": "KB"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "KB"
									},
									{
										"formattedValue": "PE"
									},
									{
										"formattedValue": "KB"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "8:45-9:00"
									},
									{
										"formattedValue": "KB"
									},
									{
										"formattedValue": "PE"
									},
									{
										"formattedValue": "KB"
									},
									{
										"formattedValue": "PE"
									},
									{
										"formattedValue": "KB"
									},
									{
										"formattedValue": "PE"
									},
									{
										"formattedValue": "KB"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "KB"
									},
									{
										"formattedValue": "PE"
									},
									{
										"formattedValue": "KB"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "9:00-9:15"
									},
									{
										"formattedValue": "KB"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "KB"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "KB"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "KB"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "KB"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "KB"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "9:15 - 9:30"
									},
									{
										"formattedValue": "KB"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "KB"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "KB"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "KB"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "KB"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "KB"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "9:30-9:45"
									},
									{
										"formattedValue": "KB"
									},
									{
										"formattedValue": "Rec"
									},
									{
										"formattedValue": "KB"
									},
									{
										"formattedValue": "Rec"
									},
									{
										"formattedValue": "KB"
									},
									{
										"formattedValue": "Rec"
									},
									{
										"formattedValue": "KB"
									},
									{
										"formattedValue": "Rec"
									},
									{
										"formattedValue": "KB"
									},
									{
										"formattedValue": "Rec"
									},
									{
										"formattedValue": "KB"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "9:45-10:00"
									},
									{
										"formattedValue": "KB"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "KB"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "KB"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "KB"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "KB"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "KB"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "10:00 - 10:15"
									},
									{
										"formattedValue": "KB"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "KB"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "KB"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "KB"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "KB"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "KB"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "10:15 - 10:30"
									},
									{
										"formattedValue": "KB"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "KB"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "KB"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "KB"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "KB"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "KB"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "10:30 - 10:45"
									},
									{
										"formattedValue": "KB"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "KB"
									},
									{
										"formattedValue": "COTEACH"
									},
									{
										"formattedValue": "KB"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "KB"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "KB"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "KB"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "10:45 - 11:00"
									},
									{
										"formattedValue": "KB"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "KB"
									},
									{
										"formattedValue": "COTEACH"
									},
									{
										"formattedValue": "KB"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "KB"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "KB"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "KB"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "11:00 - 11:15"
									},
									{
										"formattedValue": "KB"
									},
									{
										"formattedValue": "Lunch"
									},
									{},
									{
										"formattedValue": "Lunch"
									},
									{
										"formattedValue": "KB"
									},
									{},
									{
										"formattedValue": "KB"
									},
									{},
									{
										"formattedValue": "KB"
									},
									{},
									{
										"formattedValue": "KB"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "11:15 - 11:30"
									},
									{
										"formattedValue": "KB"
									},
									{
										"formattedValue": "Lunch"
									},
									{},
									{
										"formattedValue": "Lunch"
									},
									{
										"formattedValue": "KB"
									},
									{},
									{
										"formattedValue": "KB"
									},
									{},
									{
										"formattedValue": "KB"
									},
									{},
									{
										"formattedValue": "KB"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "11:30 - 11:45"
									},
									{
										"formattedValue": "KB"
									},
									{
										"formattedValue": "Lunch"
									},
									{},
									{
										"formattedValue": "Lunch"
									},
									{
										"formattedValue": "KB"
									},
									{},
									{
										"formattedValue": "KB"
									},
									{},
									{
										"formattedValue": "KB"
									},
									{},
									{
										"formattedValue": "KB"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "11:45 - 12:00"
									},
									{
										"formattedValue": "KB"
									},
									{
										"formattedValue": "Prep"
									},
									{},
									{
										"formattedValue": "COTEACH"
									},
									{
										"formattedValue": "KB"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "KB"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "KB"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "KB"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "12:00 - 12:15"
									},
									{
										"formattedValue": "KB"
									},
									{
										"formattedValue": "Prep"
									},
									{},
									{
										"formattedValue": "COTEACH"
									},
									{
										"formattedValue": "KB"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "KB"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "KB"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "KB"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "12:15 - 12:30"
									},
									{
										"formattedValue": "KB"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "KB"
									},
									{
										"formattedValue": "Prep"
									},
									{},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "KB"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "KB"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "KB"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "12:30-12:45"
									},
									{
										"formattedValue": "KB"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "KB"
									},
									{
										"formattedValue": "Prep"
									},
									{},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "KB"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "KB"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "KB"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "12:45-1:00"
									},
									{
										"formattedValue": "KB"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "KB"
									},
									{
										"formattedValue": "Prep"
									},
									{},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "KB"
									},
									{
										"formattedValue": "PD"
									},
									{
										"formattedValue": "KB"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "KB"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "1:00 - 1:15"
									},
									{
										"formattedValue": "KB"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "KB"
									},
									{
										"formattedValue": "Prep"
									},
									{},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "KB"
									},
									{
										"formattedValue": "PD"
									},
									{
										"formattedValue": "KB"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "KB"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "1:15 - 1:30"
									},
									{
										"formattedValue": "KB"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "KB"
									},
									{
										"formattedValue": "Prep"
									},
									{},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "KB"
									},
									{
										"formattedValue": "PD"
									},
									{
										"formattedValue": "KB"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "KB"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "1:30 - 1:45"
									},
									{
										"formattedValue": "KB"
									},
									{
										"formattedValue": "PWG"
									},
									{
										"formattedValue": "KB"
									},
									{
										"formattedValue": "Prep"
									},
									{},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "KB"
									},
									{
										"formattedValue": "PD"
									},
									{
										"formattedValue": "KB"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "KB"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "1:45-2:00"
									},
									{
										"formattedValue": "KB"
									},
									{
										"formattedValue": "PWG"
									},
									{
										"formattedValue": "KB"
									},
									{
										"formattedValue": "Prep"
									},
									{},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "KB"
									},
									{
										"formattedValue": "PD"
									},
									{
										"formattedValue": "KB"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "KB"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "7:45-8:00"
									},
									{
										"formattedValue": "KC"
									},
									{
										"formattedValue": "Intake"
									},
									{
										"formattedValue": "KC"
									},
									{
										"formattedValue": "Intake"
									},
									{
										"formattedValue": "KC"
									},
									{
										"formattedValue": "Intake"
									},
									{
										"formattedValue": "KC"
									},
									{
										"formattedValue": "Intake"
									},
									{
										"formattedValue": "KC"
									},
									{
										"formattedValue": "Intake"
									},
									{
										"formattedValue": "KC"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "8:00-8:15"
									},
									{
										"formattedValue": "KC"
									},
									{
										"formattedValue": "ELD"
									},
									{
										"formattedValue": "KC"
									},
									{
										"formattedValue": "ELD"
									},
									{
										"formattedValue": "KC"
									},
									{
										"formattedValue": "ELD"
									},
									{
										"formattedValue": "KC"
									},
									{
										"formattedValue": "ELD"
									},
									{
										"formattedValue": "KC"
									},
									{
										"formattedValue": "ELD"
									},
									{
										"formattedValue": "KC"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "8:15-8:30"
									},
									{
										"formattedValue": "KC"
									},
									{
										"formattedValue": "ELD"
									},
									{
										"formattedValue": "KC"
									},
									{
										"formattedValue": "ELD"
									},
									{
										"formattedValue": "KC"
									},
									{
										"formattedValue": "ELD"
									},
									{
										"formattedValue": "KC"
									},
									{
										"formattedValue": "ELD"
									},
									{
										"formattedValue": "KC"
									},
									{
										"formattedValue": "ELD"
									},
									{
										"formattedValue": "KC"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "8:30 - 8:45"
									},
									{
										"formattedValue": "KC"
									},
									{
										"formattedValue": "PE"
									},
									{
										"formattedValue": "KC"
									},
									{
										"formattedValue": "PE"
									},
									{
										"formattedValue": "KC"
									},
									{
										"formattedValue": "PE"
									},
									{
										"formattedValue": "KC"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "KC"
									},
									{
										"formattedValue": "PE"
									},
									{
										"formattedValue": "KC"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "8:45-9:00"
									},
									{
										"formattedValue": "KC"
									},
									{
										"formattedValue": "PE"
									},
									{
										"formattedValue": "KC"
									},
									{
										"formattedValue": "PE"
									},
									{
										"formattedValue": "KC"
									},
									{
										"formattedValue": "PE"
									},
									{
										"formattedValue": "KC"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "KC"
									},
									{
										"formattedValue": "PE"
									},
									{
										"formattedValue": "KC"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "9:00-9:15"
									},
									{
										"formattedValue": "KC"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "KC"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "KC"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "KC"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "KC"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "KC"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "9:15 - 9:30"
									},
									{
										"formattedValue": "KC"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "KC"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "KC"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "KC"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "KC"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "KC"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "9:30-9:45"
									},
									{
										"formattedValue": "KC"
									},
									{
										"formattedValue": "Rec"
									},
									{
										"formattedValue": "KC"
									},
									{
										"formattedValue": "Rec"
									},
									{
										"formattedValue": "KC"
									},
									{
										"formattedValue": "Rec"
									},
									{
										"formattedValue": "KC"
									},
									{
										"formattedValue": "Rec"
									},
									{
										"formattedValue": "KC"
									},
									{
										"formattedValue": "Rec"
									},
									{
										"formattedValue": "KC"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "9:45-10:00"
									},
									{
										"formattedValue": "KC"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "KC"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "KC"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "KC"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "KC"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "KC"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "10:00 - 10:15"
									},
									{
										"formattedValue": "KC"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "KC"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "KC"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "KC"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "KC"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "KC"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "10:15 - 10:30"
									},
									{
										"formattedValue": "KC"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "KC"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "KC"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "KC"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "KC"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "KC"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "10:30 - 10:45"
									},
									{
										"formattedValue": "KC"
									},
									{
										"formattedValue": "Prep"
									},
									{},
									{
										"formattedValue": "COTEACH"
									},
									{
										"formattedValue": "KC"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "KC"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "KC"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "KC"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "10:45 - 11:00"
									},
									{
										"formattedValue": "KC"
									},
									{
										"formattedValue": "Prep"
									},
									{},
									{
										"formattedValue": "COTEACH"
									},
									{
										"formattedValue": "KC"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "KC"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "KC"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "KC"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "11:00 - 11:15"
									},
									{
										"formattedValue": "KC"
									},
									{
										"formattedValue": "Lunch"
									},
									{},
									{
										"formattedValue": "Lunch"
									},
									{},
									{
										"formattedValue": "Lunch"
									},
									{},
									{
										"formattedValue": "Lunch"
									},
									{},
									{
										"formattedValue": "Lunch"
									},
									{}
								]
							},
							{
								"values": [
									{
										"formattedValue": "11:15 - 11:30"
									},
									{
										"formattedValue": "KC"
									},
									{
										"formattedValue": "Lunch"
									},
									{},
									{
										"formattedValue": "Lunch"
									},
									{},
									{
										"formattedValue": "Lunch"
									},
									{},
									{
										"formattedValue": "Lunch"
									},
									{},
									{
										"formattedValue": "Lunch"
									},
									{}
								]
							},
							{
								"values": [
									{
										"formattedValue": "11:30 - 11:45"
									},
									{
										"formattedValue": "KC"
									},
									{
										"formattedValue": "Lunch"
									},
									{},
									{
										"formattedValue": "Lunch"
									},
									{},
									{
										"formattedValue": "Lunch"
									},
									{},
									{
										"formattedValue": "Lunch"
									},
									{},
									{
										"formattedValue": "Lunch"
									},
									{}
								]
							},
							{
								"values": [
									{
										"formattedValue": "11:45 - 12:00"
									},
									{
										"formattedValue": "KC"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "KC"
									},
									{
										"formattedValue": "COTEACH"
									},
									{
										"formattedValue": "KC"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "KC"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "KC"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "KC"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "12:00 - 12:15"
									},
									{
										"formattedValue": "KC"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "KC"
									},
									{
										"formattedValue": "COTEACH"
									},
									{
										"formattedValue": "KC"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "KC"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "KC"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "KC"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "12:15 - 12:30"
									},
									{
										"formattedValue": "KC"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "KC"
									},
									{
										"formattedValue": "Prep"
									},
									{},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "KC"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "KC"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "KC"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "12:30-12:45"
									},
									{
										"formattedValue": "KC"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "KC"
									},
									{
										"formattedValue": "Prep"
									},
									{},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "KC"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "KC"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "KC"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "12:45-1:00"
									},
									{
										"formattedValue": "KC"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "KC"
									},
									{
										"formattedValue": "Prep"
									},
									{},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "KC"
									},
									{
										"formattedValue": "PD"
									},
									{
										"formattedValue": "KC"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "KC"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "1:00 - 1:15"
									},
									{
										"formattedValue": "KC"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "KC"
									},
									{
										"formattedValue": "Prep"
									},
									{},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "KC"
									},
									{
										"formattedValue": "PD"
									},
									{
										"formattedValue": "KC"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "KC"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "1:15 - 1:30"
									},
									{
										"formattedValue": "KC"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "KC"
									},
									{
										"formattedValue": "Prep"
									},
									{},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "KC"
									},
									{
										"formattedValue": "PD"
									},
									{
										"formattedValue": "KC"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "KC"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "1:30 - 1:45"
									},
									{
										"formattedValue": "KC"
									},
									{
										"formattedValue": "PWG"
									},
									{
										"formattedValue": "KC"
									},
									{
										"formattedValue": "Prep"
									},
									{},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "KC"
									},
									{
										"formattedValue": "PD"
									},
									{
										"formattedValue": "KC"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "KC"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "1:45-2:00"
									},
									{
										"formattedValue": "KC"
									},
									{
										"formattedValue": "PWG"
									},
									{
										"formattedValue": "KC"
									},
									{
										"formattedValue": "Prep"
									},
									{},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "KC"
									},
									{
										"formattedValue": "PD"
									},
									{
										"formattedValue": "KC"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "KC"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "7:45-8:00"
									},
									{
										"formattedValue": "1A"
									},
									{
										"formattedValue": "Intake"
									},
									{
										"formattedValue": "1A"
									},
									{
										"formattedValue": "Intake"
									},
									{
										"formattedValue": "1A"
									},
									{
										"formattedValue": "Intake"
									},
									{
										"formattedValue": "1A"
									},
									{
										"formattedValue": "Intake"
									},
									{
										"formattedValue": "1A"
									},
									{
										"formattedValue": "Intake"
									},
									{
										"formattedValue": "1A"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "8:00-8:15"
									},
									{
										"formattedValue": "1A"
									},
									{
										"formattedValue": "ELD"
									},
									{
										"formattedValue": "1A"
									},
									{
										"formattedValue": "ELD"
									},
									{
										"formattedValue": "1A"
									},
									{
										"formattedValue": "ELD"
									},
									{
										"formattedValue": "1A"
									},
									{
										"formattedValue": "ELD"
									},
									{
										"formattedValue": "1A"
									},
									{
										"formattedValue": "ELD"
									},
									{
										"formattedValue": "1A"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "8:15-8:30"
									},
									{
										"formattedValue": "1A"
									},
									{
										"formattedValue": "ELD"
									},
									{
										"formattedValue": "1A"
									},
									{
										"formattedValue": "ELD"
									},
									{
										"formattedValue": "1A"
									},
									{
										"formattedValue": "ELD"
									},
									{
										"formattedValue": "1A"
									},
									{
										"formattedValue": "ELD"
									},
									{
										"formattedValue": "1A"
									},
									{
										"formattedValue": "ELD"
									},
									{
										"formattedValue": "1A"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "8:30 - 8:45"
									},
									{
										"formattedValue": "1A"
									},
									{
										"formattedValue": "Prep"
									},
									{},
									{
										"formattedValue": "Prep"
									},
									{
										"formattedValue": "1A"
									},
									{
										"formattedValue": "COTEACH"
									},
									{
										"formattedValue": "1A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "1A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "1A"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "8:45-9:00"
									},
									{
										"formattedValue": "1A"
									},
									{
										"formattedValue": "Prep"
									},
									{},
									{
										"formattedValue": "Prep"
									},
									{},
									{
										"formattedValue": "COTEACH"
									},
									{
										"formattedValue": "1A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "1A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "1A"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "9:00-9:15"
									},
									{
										"formattedValue": "1A"
									},
									{
										"formattedValue": "PWG"
									},
									{
										"formattedValue": "1A"
									},
									{
										"formattedValue": "Prep"
									},
									{},
									{
										"formattedValue": "COTEACh"
									},
									{
										"formattedValue": "1A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "1A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "1A"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "9:15 - 9:30"
									},
									{
										"formattedValue": "1A"
									},
									{
										"formattedValue": "PWG"
									},
									{
										"formattedValue": "1A"
									},
									{
										"formattedValue": "Prep"
									},
									{},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "1A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "1A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "1A"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "9:30-9:45"
									},
									{
										"formattedValue": "1A"
									},
									{
										"formattedValue": "Rec"
									},
									{
										"formattedValue": "1A"
									},
									{
										"formattedValue": "Prep"
									},
									{},
									{
										"formattedValue": "Rec"
									},
									{
										"formattedValue": "1A"
									},
									{
										"formattedValue": "Rec"
									},
									{
										"formattedValue": "1A"
									},
									{
										"formattedValue": "Rec"
									},
									{
										"formattedValue": "1A"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "9:45-10:00"
									},
									{
										"formattedValue": "1A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "1A"
									},
									{
										"formattedValue": "Prep"
									},
									{},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "1A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "1A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "1A"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "10:00 - 10:15"
									},
									{
										"formattedValue": "1A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "1A"
									},
									{
										"formattedValue": "Prep"
									},
									{},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "1A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "1A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "1A"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "10:15 - 10:30"
									},
									{
										"formattedValue": "1A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "1A"
									},
									{
										"formattedValue": "Prep"
									},
									{},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "1A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "1A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "1A"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "10:30 - 10:45"
									},
									{
										"formattedValue": "1A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "1A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "1A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "1A"
									},
									{
										"formattedValue": "Coteach"
									},
									{
										"formattedValue": "1A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "1A"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "10:45 - 11:00"
									},
									{
										"formattedValue": "1A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "1A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "1A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "1A"
									},
									{
										"formattedValue": "Coteach"
									},
									{
										"formattedValue": "1A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "1A"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "11:00 - 11:15"
									},
									{
										"formattedValue": "1A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "1A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "1A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "1A"
									},
									{
										"formattedValue": "Coteach"
									},
									{
										"formattedValue": "1A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "1A"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "11:15 - 11:30"
									},
									{
										"formattedValue": "1A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "1A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "1A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "1A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "1A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "1A"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "11:30 - 11:45"
									},
									{
										"formattedValue": "1A"
									},
									{
										"formattedValue": "Lunch"
									},
									{},
									{
										"formattedValue": "Lunch"
									},
									{},
									{
										"formattedValue": "Lunch"
									},
									{},
									{
										"formattedValue": "Lunch"
									},
									{},
									{
										"formattedValue": "Lunch"
									},
									{}
								]
							},
							{
								"values": [
									{
										"formattedValue": "11:45 - 12:00"
									},
									{
										"formattedValue": "1A"
									},
									{
										"formattedValue": "Lunch"
									},
									{},
									{
										"formattedValue": "Lunch"
									},
									{},
									{
										"formattedValue": "Lunch"
									},
									{},
									{
										"formattedValue": "Lunch"
									},
									{},
									{
										"formattedValue": "Lunch"
									},
									{}
								]
							},
							{
								"values": [
									{
										"formattedValue": "12:00 - 12:15"
									},
									{
										"formattedValue": "1A"
									},
									{
										"formattedValue": "Lunch"
									},
									{},
									{
										"formattedValue": "Lunch"
									},
									{},
									{
										"formattedValue": "Lunch"
									},
									{},
									{
										"formattedValue": "Lunch"
									},
									{},
									{
										"formattedValue": "Lunch"
									},
									{}
								]
							},
							{
								"values": [
									{
										"formattedValue": "12:15 - 12:30"
									},
									{
										"formattedValue": "1A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "1A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "1A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "1A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "1A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "1A"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "12:30-12:45"
									},
									{
										"formattedValue": "1A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "1A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "1A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "1A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "1A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "1A"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "12:45-1:00"
									},
									{
										"formattedValue": "1A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "1A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "1A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "1A"
									},
									{
										"formattedValue": "PD"
									},
									{
										"formattedValue": "1A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "1A"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "1:00 - 1:15"
									},
									{
										"formattedValue": "1A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "1A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "1A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "1A"
									},
									{
										"formattedValue": "PD"
									},
									{
										"formattedValue": "1A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "1A"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "1:15 - 1:30"
									},
									{
										"formattedValue": "1A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "1A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "1A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "1A"
									},
									{
										"formattedValue": "PD"
									},
									{
										"formattedValue": "1A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "1A"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "1:30 - 1:45"
									},
									{
										"formattedValue": "1A"
									},
									{
										"formattedValue": "PE"
									},
									{
										"formattedValue": "1A"
									},
									{
										"formattedValue": "PE"
									},
									{
										"formattedValue": "1A"
									},
									{
										"formattedValue": "PE"
									},
									{
										"formattedValue": "1A"
									},
									{
										"formattedValue": "PD"
									},
									{
										"formattedValue": "1A"
									},
									{
										"formattedValue": "PE"
									},
									{
										"formattedValue": "1A"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "1:45-2:00"
									},
									{
										"formattedValue": "1A"
									},
									{
										"formattedValue": "PE"
									},
									{
										"formattedValue": "1A"
									},
									{
										"formattedValue": "PE"
									},
									{
										"formattedValue": "1A"
									},
									{
										"formattedValue": "PE"
									},
									{
										"formattedValue": "1A"
									},
									{
										"formattedValue": "PD"
									},
									{
										"formattedValue": "1A"
									},
									{
										"formattedValue": "PE"
									},
									{
										"formattedValue": "1A"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "7:45-8:00"
									},
									{
										"formattedValue": "1B"
									},
									{
										"formattedValue": "Intake"
									},
									{
										"formattedValue": "1B"
									},
									{
										"formattedValue": "Intake"
									},
									{
										"formattedValue": "1B"
									},
									{
										"formattedValue": "Intake"
									},
									{
										"formattedValue": "1B"
									},
									{
										"formattedValue": "Intake"
									},
									{
										"formattedValue": "1B"
									},
									{
										"formattedValue": "Intake"
									},
									{
										"formattedValue": "1B"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "8:00-8:15"
									},
									{
										"formattedValue": "1B"
									},
									{
										"formattedValue": "ELD"
									},
									{
										"formattedValue": "1B"
									},
									{
										"formattedValue": "ELD"
									},
									{
										"formattedValue": "1B"
									},
									{
										"formattedValue": "ELD"
									},
									{
										"formattedValue": "1B"
									},
									{
										"formattedValue": "ELD"
									},
									{
										"formattedValue": "1B"
									},
									{
										"formattedValue": "ELD"
									},
									{
										"formattedValue": "1B"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "8:15-8:30"
									},
									{
										"formattedValue": "1B"
									},
									{
										"formattedValue": "ELD"
									},
									{
										"formattedValue": "1B"
									},
									{
										"formattedValue": "ELD"
									},
									{
										"formattedValue": "1B"
									},
									{
										"formattedValue": "ELD"
									},
									{
										"formattedValue": "1B"
									},
									{
										"formattedValue": "ELD"
									},
									{
										"formattedValue": "1B"
									},
									{
										"formattedValue": "ELD"
									},
									{
										"formattedValue": "1B"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "8:30 - 8:45"
									},
									{
										"formattedValue": "1B"
									},
									{
										"formattedValue": "PWG"
									},
									{
										"formattedValue": "1B"
									},
									{
										"formattedValue": "Prep"
									},
									{},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "1B"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "1B"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "1B"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "8:45-9:00"
									},
									{
										"formattedValue": "1B"
									},
									{
										"formattedValue": "PWG"
									},
									{
										"formattedValue": "1B"
									},
									{
										"formattedValue": "Prep"
									},
									{},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "1B"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "1B"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "1B"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "9:00-9:15"
									},
									{
										"formattedValue": "1B"
									},
									{
										"formattedValue": "Prep"
									},
									{},
									{
										"formattedValue": "Prep"
									},
									{},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "1B"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "1B"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "1B"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "9:15 - 9:30"
									},
									{
										"formattedValue": "1B"
									},
									{
										"formattedValue": "Prep"
									},
									{},
									{
										"formattedValue": "Prep"
									},
									{},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "1B"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "1B"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "1B"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "9:30-9:45"
									},
									{
										"formattedValue": "1B"
									},
									{
										"formattedValue": "Rec"
									},
									{
										"formattedValue": "1B"
									},
									{
										"formattedValue": "Prep"
									},
									{},
									{
										"formattedValue": "Rec"
									},
									{
										"formattedValue": "1B"
									},
									{
										"formattedValue": "Rec"
									},
									{
										"formattedValue": "1B"
									},
									{
										"formattedValue": "Rec"
									},
									{
										"formattedValue": "1B"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "9:45-10:00"
									},
									{
										"formattedValue": "1B"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "1B"
									},
									{
										"formattedValue": "Prep"
									},
									{},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "1B"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "1B"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "1B"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "10:00 - 10:15"
									},
									{
										"formattedValue": "1B"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "1B"
									},
									{
										"formattedValue": "Prep"
									},
									{},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "1B"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "1B"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "1B"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "10:15 - 10:30"
									},
									{
										"formattedValue": "1B"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "1B"
									},
									{
										"formattedValue": "Prep"
									},
									{},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "1B"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "1B"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "1B"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "10:30 - 10:45"
									},
									{
										"formattedValue": "1B"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "1B"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "1B"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "1B"
									},
									{
										"formattedValue": "Coteach"
									},
									{
										"formattedValue": "1B"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "1B"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "10:45 - 11:00"
									},
									{
										"formattedValue": "1B"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "1B"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "1B"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "1B"
									},
									{
										"formattedValue": "Coteach"
									},
									{
										"formattedValue": "1B"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "1B"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "11:00 - 11:15"
									},
									{
										"formattedValue": "1B"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "1B"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "1B"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "1B"
									},
									{
										"formattedValue": "Coteach"
									},
									{
										"formattedValue": "1B"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "1B"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "11:15 - 11:30"
									},
									{
										"formattedValue": "1B"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "1B"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "1B"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "1B"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "1B"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "1B"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "11:30 - 11:45"
									},
									{
										"formattedValue": "1B"
									},
									{
										"formattedValue": "Lunch"
									},
									{},
									{
										"formattedValue": "Lunch"
									},
									{},
									{
										"formattedValue": "Lunch"
									},
									{},
									{
										"formattedValue": "Lunch"
									},
									{},
									{
										"formattedValue": "Lunch"
									},
									{}
								]
							},
							{
								"values": [
									{
										"formattedValue": "11:45 - 12:00"
									},
									{
										"formattedValue": "1B"
									},
									{
										"formattedValue": "Lunch"
									},
									{},
									{
										"formattedValue": "Lunch"
									},
									{},
									{
										"formattedValue": "Lunch"
									},
									{},
									{
										"formattedValue": "Lunch"
									},
									{},
									{
										"formattedValue": "Lunch"
									},
									{}
								]
							},
							{
								"values": [
									{
										"formattedValue": "12:00 - 12:15"
									},
									{
										"formattedValue": "1B"
									},
									{
										"formattedValue": "Lunch"
									},
									{},
									{
										"formattedValue": "Lunch"
									},
									{},
									{
										"formattedValue": "Lunch"
									},
									{},
									{
										"formattedValue": "Lunch"
									},
									{},
									{
										"formattedValue": "Lunch"
									},
									{}
								]
							},
							{
								"values": [
									{
										"formattedValue": "12:15 - 12:30"
									},
									{
										"formattedValue": "1B"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "1B"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "1B"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "1B"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "1B"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "1B"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "12:30-12:45"
									},
									{
										"formattedValue": "1B"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "1B"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "1B"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "1B"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "1B"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "1B"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "12:45-1:00"
									},
									{
										"formattedValue": "1B"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "1B"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "1B"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "1B"
									},
									{
										"formattedValue": "PD"
									},
									{
										"formattedValue": "1B"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "1B"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "1:00 - 1:15"
									},
									{
										"formattedValue": "1B"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "1B"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "1B"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "1B"
									},
									{
										"formattedValue": "PD"
									},
									{
										"formattedValue": "1B"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "1B"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "1:15 - 1:30"
									},
									{
										"formattedValue": "1B"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "1B"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "1B"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "1B"
									},
									{
										"formattedValue": "PD"
									},
									{
										"formattedValue": "1B"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "1B"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "1:30 - 1:45"
									},
									{
										"formattedValue": "1B"
									},
									{
										"formattedValue": "PE"
									},
									{
										"formattedValue": "1B"
									},
									{
										"formattedValue": "PE"
									},
									{
										"formattedValue": "1B"
									},
									{
										"formattedValue": "PE"
									},
									{
										"formattedValue": "1B"
									},
									{
										"formattedValue": "PD"
									},
									{
										"formattedValue": "1B"
									},
									{
										"formattedValue": "PE"
									},
									{
										"formattedValue": "1B"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "1:45-2:00"
									},
									{
										"formattedValue": "1B"
									},
									{
										"formattedValue": "PE"
									},
									{
										"formattedValue": "1B"
									},
									{
										"formattedValue": "PE"
									},
									{
										"formattedValue": "1B"
									},
									{
										"formattedValue": "PE"
									},
									{
										"formattedValue": "1B"
									},
									{
										"formattedValue": "PD"
									},
									{
										"formattedValue": "1B"
									},
									{
										"formattedValue": "PE"
									},
									{
										"formattedValue": "1B"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "7:45-8:00"
									},
									{
										"formattedValue": "1C"
									},
									{
										"formattedValue": "Intake"
									},
									{
										"formattedValue": "1C"
									},
									{
										"formattedValue": "Intake"
									},
									{
										"formattedValue": "1C"
									},
									{
										"formattedValue": "Intake"
									},
									{
										"formattedValue": "1C"
									},
									{
										"formattedValue": "Intake"
									},
									{
										"formattedValue": "1C"
									},
									{
										"formattedValue": "Intake"
									},
									{
										"formattedValue": "1C"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "8:00-8:15"
									},
									{
										"formattedValue": "1C"
									},
									{
										"formattedValue": "ELD"
									},
									{
										"formattedValue": "1C"
									},
									{
										"formattedValue": "ELD"
									},
									{
										"formattedValue": "1C"
									},
									{
										"formattedValue": "ELD"
									},
									{
										"formattedValue": "1C"
									},
									{
										"formattedValue": "ELD"
									},
									{
										"formattedValue": "1C"
									},
									{
										"formattedValue": "ELD"
									},
									{
										"formattedValue": "1C"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "8:15-8:30"
									},
									{
										"formattedValue": "1C"
									},
									{
										"formattedValue": "ELD"
									},
									{
										"formattedValue": "1C"
									},
									{
										"formattedValue": "ELD"
									},
									{
										"formattedValue": "1C"
									},
									{
										"formattedValue": "ELD"
									},
									{
										"formattedValue": "1C"
									},
									{
										"formattedValue": "ELD"
									},
									{
										"formattedValue": "1C"
									},
									{
										"formattedValue": "ELD"
									},
									{
										"formattedValue": "1C"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "8:30 - 8:45"
									},
									{
										"formattedValue": "1C"
									},
									{
										"formattedValue": "PWG"
									},
									{
										"formattedValue": "1C"
									},
									{
										"formattedValue": "Prep"
									},
									{},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "1C"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "1C"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "1C"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "8:45-9:00"
									},
									{
										"formattedValue": "1C"
									},
									{
										"formattedValue": "PWG"
									},
									{
										"formattedValue": "1C"
									},
									{
										"formattedValue": "Prep"
									},
									{},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "1C"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "1C"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "1C"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "9:00-9:15"
									},
									{
										"formattedValue": "1C"
									},
									{
										"formattedValue": "PWG"
									},
									{
										"formattedValue": "1C"
									},
									{
										"formattedValue": "Prep"
									},
									{},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "1C"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "1C"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "1C"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "9:15 - 9:30"
									},
									{
										"formattedValue": "1C"
									},
									{
										"formattedValue": "PWG"
									},
									{
										"formattedValue": "1C"
									},
									{
										"formattedValue": "Prep"
									},
									{},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "1C"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "1C"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "1C"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "9:30-9:45"
									},
									{
										"formattedValue": "1C"
									},
									{
										"formattedValue": "Rec"
									},
									{
										"formattedValue": "1C"
									},
									{
										"formattedValue": "Prep"
									},
									{},
									{
										"formattedValue": "Rec"
									},
									{
										"formattedValue": "1C"
									},
									{
										"formattedValue": "Rec"
									},
									{
										"formattedValue": "1C"
									},
									{
										"formattedValue": "Rec"
									},
									{
										"formattedValue": "1C"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "9:45-10:00"
									},
									{
										"formattedValue": "1C"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "1C"
									},
									{
										"formattedValue": "Prep"
									},
									{},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "1C"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "1C"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "1C"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "10:00 - 10:15"
									},
									{
										"formattedValue": "1C"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "1C"
									},
									{
										"formattedValue": "Prep"
									},
									{},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "1C"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "1C"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "1C"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "10:15 - 10:30"
									},
									{
										"formattedValue": "1C"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "1C"
									},
									{
										"formattedValue": "Prep"
									},
									{},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "1C"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "1C"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "1C"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "10:30 - 10:45"
									},
									{
										"formattedValue": "1C"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "1C"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "1C"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "1C"
									},
									{
										"formattedValue": "Coteach"
									},
									{
										"formattedValue": "1C"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "1C"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "10:45 - 11:00"
									},
									{
										"formattedValue": "1C"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "1C"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "1C"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "1C"
									},
									{
										"formattedValue": "Coteach"
									},
									{
										"formattedValue": "1C"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "1C"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "11:00 - 11:15"
									},
									{
										"formattedValue": "1C"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "1C"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "1C"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "1C"
									},
									{
										"formattedValue": "Coteach"
									},
									{
										"formattedValue": "1C"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "1C"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "11:15 - 11:30"
									},
									{
										"formattedValue": "1C"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "1C"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "1C"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "1C"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "1C"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "1C"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "11:30 - 11:45"
									},
									{
										"formattedValue": "1C"
									},
									{
										"formattedValue": "Lunch"
									},
									{},
									{
										"formattedValue": "Lunch"
									},
									{},
									{
										"formattedValue": "Lunch"
									},
									{},
									{
										"formattedValue": "Lunch"
									},
									{},
									{
										"formattedValue": "Lunch"
									},
									{}
								]
							},
							{
								"values": [
									{
										"formattedValue": "11:45 - 12:00"
									},
									{
										"formattedValue": "1C"
									},
									{
										"formattedValue": "Lunch"
									},
									{},
									{
										"formattedValue": "Lunch"
									},
									{},
									{
										"formattedValue": "Lunch"
									},
									{},
									{
										"formattedValue": "Lunch"
									},
									{},
									{
										"formattedValue": "Lunch"
									},
									{}
								]
							},
							{
								"values": [
									{
										"formattedValue": "12:00 - 12:15"
									},
									{
										"formattedValue": "1C"
									},
									{
										"formattedValue": "Lunch"
									},
									{},
									{
										"formattedValue": "Lunch"
									},
									{},
									{
										"formattedValue": "Lunch"
									},
									{},
									{
										"formattedValue": "Lunch"
									},
									{},
									{
										"formattedValue": "Lunch"
									},
									{}
								]
							},
							{
								"values": [
									{
										"formattedValue": "12:15 - 12:30"
									},
									{
										"formattedValue": "1C"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "1C"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "1C"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "1C"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "1C"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "1C"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "12:30-12:45"
									},
									{
										"formattedValue": "1C"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "1C"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "1C"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "1C"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "1C"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "1C"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "12:45-1:00"
									},
									{
										"formattedValue": "1C"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "1C"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "1C"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "1C"
									},
									{
										"formattedValue": "PD"
									},
									{
										"formattedValue": "1C"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "1C"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "1:00 - 1:15"
									},
									{
										"formattedValue": "1C"
									},
									{
										"formattedValue": "Prep"
									},
									{},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "1C"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "1C"
									},
									{
										"formattedValue": "PD"
									},
									{
										"formattedValue": "1C"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "1C"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "1:15 - 1:30"
									},
									{
										"formattedValue": "1C"
									},
									{
										"formattedValue": "Prep"
									},
									{},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "1C"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "1C"
									},
									{
										"formattedValue": "PD"
									},
									{
										"formattedValue": "1C"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "1C"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "1:30 - 1:45"
									},
									{
										"formattedValue": "1C"
									},
									{
										"formattedValue": "PE"
									},
									{
										"formattedValue": "1C"
									},
									{
										"formattedValue": "PE"
									},
									{
										"formattedValue": "1C"
									},
									{
										"formattedValue": "PE"
									},
									{
										"formattedValue": "1C"
									},
									{
										"formattedValue": "PD"
									},
									{
										"formattedValue": "1C"
									},
									{
										"formattedValue": "PE"
									},
									{
										"formattedValue": "1C"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "1:45-2:00"
									},
									{
										"formattedValue": "1C"
									},
									{
										"formattedValue": "PE"
									},
									{
										"formattedValue": "1C"
									},
									{
										"formattedValue": "PE"
									},
									{
										"formattedValue": "1C"
									},
									{
										"formattedValue": "PE"
									},
									{
										"formattedValue": "1C"
									},
									{
										"formattedValue": "PD"
									},
									{
										"formattedValue": "1C"
									},
									{
										"formattedValue": "PE"
									},
									{
										"formattedValue": "1C"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "7:45-8:00"
									},
									{
										"formattedValue": "2A"
									},
									{
										"formattedValue": "Intake"
									},
									{
										"formattedValue": "2A"
									},
									{
										"formattedValue": "Intake"
									},
									{
										"formattedValue": "2A"
									},
									{
										"formattedValue": "Intake"
									},
									{
										"formattedValue": "2A"
									},
									{
										"formattedValue": "Intake"
									},
									{
										"formattedValue": "2A"
									},
									{
										"formattedValue": "Intake"
									},
									{
										"formattedValue": "2A"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "8:00-8:15"
									},
									{
										"formattedValue": "2A"
									},
									{
										"formattedValue": "ELD"
									},
									{
										"formattedValue": "2A"
									},
									{
										"formattedValue": "ELD"
									},
									{
										"formattedValue": "2A"
									},
									{
										"formattedValue": "ELD"
									},
									{
										"formattedValue": "2A"
									},
									{
										"formattedValue": "ELD"
									},
									{
										"formattedValue": "2A"
									},
									{
										"formattedValue": "ELD"
									},
									{
										"formattedValue": "2A"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "8:15-8:30"
									},
									{
										"formattedValue": "2A"
									},
									{
										"formattedValue": "ELD"
									},
									{
										"formattedValue": "2A"
									},
									{
										"formattedValue": "ELD"
									},
									{
										"formattedValue": "2A"
									},
									{
										"formattedValue": "ELD"
									},
									{
										"formattedValue": "2A"
									},
									{
										"formattedValue": "ELD"
									},
									{
										"formattedValue": "2A"
									},
									{
										"formattedValue": "ELD"
									},
									{
										"formattedValue": "2A"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "8:30 - 8:45"
									},
									{
										"formattedValue": "2A"
									},
									{
										"formattedValue": "Ins"
									},
									{},
									{
										"formattedValue": "PWG"
									},
									{
										"formattedValue": "2A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "2A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "2A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "2A"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "8:45-9:00"
									},
									{
										"formattedValue": "2A"
									},
									{
										"formattedValue": "Ins"
									},
									{},
									{
										"formattedValue": "PWG"
									},
									{
										"formattedValue": "2A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "2A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "2A"
									},
									{
										"formattedValue": "PE"
									},
									{
										"formattedValue": "2A"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "9:00-9:15"
									},
									{
										"formattedValue": "2A"
									},
									{
										"formattedValue": "PE"
									},
									{
										"formattedValue": "2A"
									},
									{
										"formattedValue": "PE"
									},
									{
										"formattedValue": "2A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "2A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "2A"
									},
									{
										"formattedValue": "PE"
									},
									{
										"formattedValue": "2A"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "9:15 - 9:30"
									},
									{
										"formattedValue": "2A"
									},
									{
										"formattedValue": "PE"
									},
									{
										"formattedValue": "2A"
									},
									{
										"formattedValue": "PE"
									},
									{
										"formattedValue": "2A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "2A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "2A"
									},
									{
										"formattedValue": "PE"
									},
									{
										"formattedValue": "2A"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "9:30-9:45"
									},
									{
										"formattedValue": "2A"
									},
									{
										"formattedValue": "Rec"
									},
									{
										"formattedValue": "2A"
									},
									{
										"formattedValue": "Rec"
									},
									{
										"formattedValue": "2A"
									},
									{
										"formattedValue": "Rec"
									},
									{
										"formattedValue": "2A"
									},
									{
										"formattedValue": "Rec"
									},
									{
										"formattedValue": "2A"
									},
									{
										"formattedValue": "Rec"
									},
									{
										"formattedValue": "2A"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "9:45-10:00"
									},
									{
										"formattedValue": "2A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "2A"
									},
									{
										"formattedValue": "Prep"
									},
									{},
									{
										"formattedValue": "COTEACH"
									},
									{
										"formattedValue": "2A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "2A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "2A"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "10:00 - 10:15"
									},
									{
										"formattedValue": "2A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "2A"
									},
									{
										"formattedValue": "Prep"
									},
									{},
									{
										"formattedValue": "COTEACH"
									},
									{
										"formattedValue": "2A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "2A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "2A"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "10:15 - 10:30"
									},
									{
										"formattedValue": "2A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "2A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "2A"
									},
									{
										"formattedValue": "COTEACH"
									},
									{
										"formattedValue": "2A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "2A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "2A"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "10:30 - 10:45"
									},
									{
										"formattedValue": "2A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "2A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "2A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "2A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "2A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "2A"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "10:45 - 11:00"
									},
									{
										"formattedValue": "2A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "2A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "2A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "2A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "2A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "2A"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "11:00 - 11:15"
									},
									{
										"formattedValue": "2A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "2A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "2A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "2A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "2A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "2A"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "11:15 - 11:30"
									},
									{
										"formattedValue": "2A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "2A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "2A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "2A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "2A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "2A"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "11:30 - 11:45"
									},
									{
										"formattedValue": "2A"
									},
									{
										"formattedValue": "Lunch"
									},
									{},
									{
										"formattedValue": "Lunch"
									},
									{},
									{
										"formattedValue": "Lunch"
									},
									{},
									{
										"formattedValue": "Lunch"
									},
									{},
									{
										"formattedValue": "Lunch"
									},
									{}
								]
							},
							{
								"values": [
									{
										"formattedValue": "11:45 - 12:00"
									},
									{
										"formattedValue": "2A"
									},
									{
										"formattedValue": "Lunch"
									},
									{},
									{
										"formattedValue": "Lunch"
									},
									{},
									{
										"formattedValue": "Lunch"
									},
									{},
									{
										"formattedValue": "Lunch"
									},
									{},
									{
										"formattedValue": "Lunch"
									},
									{}
								]
							},
							{
								"values": [
									{
										"formattedValue": "12:00 - 12:15"
									},
									{
										"formattedValue": "2A"
									},
									{
										"formattedValue": "Lunch"
									},
									{},
									{
										"formattedValue": "Lunch"
									},
									{},
									{
										"formattedValue": "Lunch"
									},
									{},
									{
										"formattedValue": "Lunch"
									},
									{},
									{
										"formattedValue": "Lunch"
									},
									{}
								]
							},
							{
								"values": [
									{
										"formattedValue": "12:15 - 12:30"
									},
									{
										"formattedValue": "2A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "2A"
									},
									{
										"formattedValue": "Prep"
									},
									{},
									{
										"formattedValue": "Prep"
									},
									{
										"formattedValue": "2A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "2A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "2A"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "12:30-12:45"
									},
									{
										"formattedValue": "2A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "2A"
									},
									{
										"formattedValue": "Prep"
									},
									{},
									{
										"formattedValue": "Prep"
									},
									{
										"formattedValue": "2A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "2A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "2A"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "12:45-1:00"
									},
									{
										"formattedValue": "2A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "2A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "2A"
									},
									{
										"formattedValue": "Prep"
									},
									{
										"formattedValue": "2A"
									},
									{
										"formattedValue": "PD"
									},
									{
										"formattedValue": "2A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "2A"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "1:00 - 1:15"
									},
									{
										"formattedValue": "2A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "2A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "2A"
									},
									{
										"formattedValue": "Prep"
									},
									{
										"formattedValue": "2A"
									},
									{
										"formattedValue": "PD"
									},
									{
										"formattedValue": "2A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "2A"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "1:15 - 1:30"
									},
									{
										"formattedValue": "2A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "2A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "2A"
									},
									{
										"formattedValue": "Prep"
									},
									{
										"formattedValue": "2A"
									},
									{
										"formattedValue": "PD"
									},
									{
										"formattedValue": "2A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "2A"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "1:30 - 1:45"
									},
									{
										"formattedValue": "2A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "2A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "2A"
									},
									{
										"formattedValue": "Prep"
									},
									{
										"formattedValue": "2A"
									},
									{
										"formattedValue": "PD"
									},
									{
										"formattedValue": "2A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "2A"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "1:45-2:00"
									},
									{
										"formattedValue": "2A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "2A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "2A"
									},
									{
										"formattedValue": "Prep"
									},
									{
										"formattedValue": "2A"
									},
									{
										"formattedValue": "PD"
									},
									{
										"formattedValue": "2A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "2A"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "7:45-8:00"
									},
									{
										"formattedValue": "2B"
									},
									{
										"formattedValue": "Intake"
									},
									{
										"formattedValue": "2B"
									},
									{
										"formattedValue": "Intake"
									},
									{
										"formattedValue": "2B"
									},
									{
										"formattedValue": "Intake"
									},
									{
										"formattedValue": "2B"
									},
									{
										"formattedValue": "Intake"
									},
									{
										"formattedValue": "2B"
									},
									{
										"formattedValue": "Intake"
									},
									{
										"formattedValue": "2B"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "8:00-8:15"
									},
									{
										"formattedValue": "2B"
									},
									{
										"formattedValue": "ELD"
									},
									{
										"formattedValue": "2B"
									},
									{
										"formattedValue": "ELD"
									},
									{
										"formattedValue": "2B"
									},
									{
										"formattedValue": "ELD"
									},
									{
										"formattedValue": "2B"
									},
									{
										"formattedValue": "ELD"
									},
									{
										"formattedValue": "2B"
									},
									{
										"formattedValue": "ELD"
									},
									{
										"formattedValue": "2B"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "8:15-8:30"
									},
									{
										"formattedValue": "2B"
									},
									{
										"formattedValue": "ELD"
									},
									{
										"formattedValue": "2B"
									},
									{
										"formattedValue": "ELD"
									},
									{
										"formattedValue": "2B"
									},
									{
										"formattedValue": "ELD"
									},
									{
										"formattedValue": "2B"
									},
									{
										"formattedValue": "ELD"
									},
									{
										"formattedValue": "2B"
									},
									{
										"formattedValue": "ELD"
									},
									{
										"formattedValue": "2B"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "8:30 - 8:45"
									},
									{
										"formattedValue": "2B"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "2B"
									},
									{
										"formattedValue": "PWG"
									},
									{
										"formattedValue": "2B"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "2B"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "2B"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "2B"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "8:45-9:00"
									},
									{
										"formattedValue": "2B"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "2B"
									},
									{
										"formattedValue": "PWG"
									},
									{
										"formattedValue": "2B"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "2B"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "2B"
									},
									{
										"formattedValue": "PE"
									},
									{
										"formattedValue": "2B"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "9:00-9:15"
									},
									{
										"formattedValue": "2B"
									},
									{
										"formattedValue": "PE"
									},
									{
										"formattedValue": "2B"
									},
									{
										"formattedValue": "PE"
									},
									{
										"formattedValue": "2B"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "2B"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "2B"
									},
									{
										"formattedValue": "PE"
									},
									{
										"formattedValue": "2B"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "9:15 - 9:30"
									},
									{
										"formattedValue": "2B"
									},
									{
										"formattedValue": "PE"
									},
									{
										"formattedValue": "2B"
									},
									{
										"formattedValue": "PE"
									},
									{
										"formattedValue": "2B"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "2B"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "2B"
									},
									{
										"formattedValue": "PE"
									},
									{
										"formattedValue": "2B"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "9:30-9:45"
									},
									{
										"formattedValue": "2B"
									},
									{
										"formattedValue": "Rec"
									},
									{
										"formattedValue": "2B"
									},
									{
										"formattedValue": "Rec"
									},
									{
										"formattedValue": "2B"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "2B"
									},
									{
										"formattedValue": "Rec"
									},
									{
										"formattedValue": "2B"
									},
									{
										"formattedValue": "Rec"
									},
									{
										"formattedValue": "2B"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "9:45-10:00"
									},
									{
										"formattedValue": "2B"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "2B"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "2B"
									},
									{
										"formattedValue": "COTEACH"
									},
									{
										"formattedValue": "2B"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "2B"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "2B"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "10:00 - 10:15"
									},
									{
										"formattedValue": "2B"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "2B"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "2B"
									},
									{
										"formattedValue": "COTEACH"
									},
									{
										"formattedValue": "2B"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "2B"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "2B"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "10:15 - 10:30"
									},
									{
										"formattedValue": "2B"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "2B"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "2B"
									},
									{
										"formattedValue": "COTEACH"
									},
									{
										"formattedValue": "2B"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "2B"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "2B"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "10:30 - 10:45"
									},
									{
										"formattedValue": "2B"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "2B"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "2B"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "2B"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "2B"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "2B"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "10:45 - 11:00"
									},
									{
										"formattedValue": "2B"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "2B"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "2B"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "2B"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "2B"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "2B"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "11:00 - 11:15"
									},
									{
										"formattedValue": "2B"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "2B"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "2B"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "2B"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "2B"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "2B"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "11:15 - 11:30"
									},
									{
										"formattedValue": "2B"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "2B"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "2B"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "2B"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "2B"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "2B"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "11:30 - 11:45"
									},
									{
										"formattedValue": "2B"
									},
									{
										"formattedValue": "Lunch"
									},
									{},
									{
										"formattedValue": "Lunch"
									},
									{},
									{
										"formattedValue": "Lunch"
									},
									{},
									{
										"formattedValue": "Lunch"
									},
									{},
									{
										"formattedValue": "Lunch"
									},
									{}
								]
							},
							{
								"values": [
									{
										"formattedValue": "11:45 - 12:00"
									},
									{
										"formattedValue": "2B"
									},
									{
										"formattedValue": "Lunch"
									},
									{},
									{
										"formattedValue": "Lunch"
									},
									{},
									{
										"formattedValue": "Lunch"
									},
									{},
									{
										"formattedValue": "Lunch"
									},
									{},
									{
										"formattedValue": "Lunch"
									},
									{}
								]
							},
							{
								"values": [
									{
										"formattedValue": "12:00 - 12:15"
									},
									{
										"formattedValue": "2B"
									},
									{
										"formattedValue": "Lunch"
									},
									{},
									{
										"formattedValue": "Lunch"
									},
									{},
									{
										"formattedValue": "Lunch"
									},
									{},
									{
										"formattedValue": "Lunch"
									},
									{},
									{
										"formattedValue": "Lunch"
									},
									{}
								]
							},
							{
								"values": [
									{
										"formattedValue": "12:15 - 12:30"
									},
									{
										"formattedValue": "2B"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "2B"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "2B"
									},
									{
										"formattedValue": "Prep"
									},
									{},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "2B"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "2B"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "12:30-12:45"
									},
									{
										"formattedValue": "2B"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "2B"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "2B"
									},
									{
										"formattedValue": "Prep"
									},
									{},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "2B"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "2B"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "12:45-1:00"
									},
									{
										"formattedValue": "2B"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "2B"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "2B"
									},
									{
										"formattedValue": "Prep"
									},
									{},
									{
										"formattedValue": "PD"
									},
									{
										"formattedValue": "2B"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "2B"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "1:00 - 1:15"
									},
									{
										"formattedValue": "2B"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "2B"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "2B"
									},
									{
										"formattedValue": "Prep"
									},
									{},
									{
										"formattedValue": "PD"
									},
									{
										"formattedValue": "2B"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "2B"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "1:15 - 1:30"
									},
									{
										"formattedValue": "2B"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "2B"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "2B"
									},
									{
										"formattedValue": "Prep"
									},
									{},
									{
										"formattedValue": "PD"
									},
									{
										"formattedValue": "2B"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "2B"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "1:30 - 1:45"
									},
									{
										"formattedValue": "2B"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "2B"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "2B"
									},
									{
										"formattedValue": "Prep"
									},
									{},
									{
										"formattedValue": "PD"
									},
									{
										"formattedValue": "2B"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "2B"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "1:45-2:00"
									},
									{
										"formattedValue": "2B"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "2B"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "2B"
									},
									{
										"formattedValue": "Prep"
									},
									{},
									{
										"formattedValue": "PD"
									},
									{
										"formattedValue": "2B"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "2B"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "7:45-8:00"
									},
									{
										"formattedValue": "3A"
									},
									{
										"formattedValue": "Intake"
									},
									{
										"formattedValue": "3A"
									},
									{
										"formattedValue": "Intake"
									},
									{
										"formattedValue": "3A"
									},
									{
										"formattedValue": "Intake"
									},
									{
										"formattedValue": "3A"
									},
									{
										"formattedValue": "Intake"
									},
									{
										"formattedValue": "3A"
									},
									{
										"formattedValue": "Intake"
									},
									{
										"formattedValue": "3A"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "8:00-8:15"
									},
									{
										"formattedValue": "3A"
									},
									{
										"formattedValue": "ELD"
									},
									{
										"formattedValue": "3A"
									},
									{
										"formattedValue": "ELD"
									},
									{
										"formattedValue": "3A"
									},
									{
										"formattedValue": "ELD"
									},
									{
										"formattedValue": "3A"
									},
									{
										"formattedValue": "ELD"
									},
									{
										"formattedValue": "3A"
									},
									{
										"formattedValue": "ELD"
									},
									{
										"formattedValue": "3A"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "8:15-8:30"
									},
									{
										"formattedValue": "3A"
									},
									{
										"formattedValue": "ELD"
									},
									{
										"formattedValue": "3A"
									},
									{
										"formattedValue": "ELD"
									},
									{
										"formattedValue": "3A"
									},
									{
										"formattedValue": "ELD"
									},
									{
										"formattedValue": "3A"
									},
									{
										"formattedValue": "ELD"
									},
									{
										"formattedValue": "3A"
									},
									{
										"formattedValue": "ELD"
									},
									{
										"formattedValue": "3A"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "8:30 - 8:45"
									},
									{
										"formattedValue": "3A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "3A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "3A"
									},
									{
										"formattedValue": "Prep"
									},
									{
										"formattedValue": "3A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "3A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "3A"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "8:45-9:00"
									},
									{
										"formattedValue": "3A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "3A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "3A"
									},
									{
										"formattedValue": "Prep"
									},
									{
										"formattedValue": "3A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "3A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "3A"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "9:00-9:15"
									},
									{
										"formattedValue": "3A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "3A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "3A"
									},
									{
										"formattedValue": "Prep"
									},
									{
										"formattedValue": "3A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "3A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "3A"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "9:15 - 9:30"
									},
									{
										"formattedValue": "3A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "3A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "3A"
									},
									{
										"formattedValue": "Prep"
									},
									{
										"formattedValue": "3A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "3A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "3A"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "9:30-9:45"
									},
									{
										"formattedValue": "3A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "3A"
									},
									{
										"formattedValue": "VAPA"
									},
									{},
									{
										"formattedValue": "Prep"
									},
									{
										"formattedValue": "3A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "3A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "3A"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "9:45-10:00"
									},
									{
										"formattedValue": "3A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "3A"
									},
									{
										"formattedValue": "VAPA"
									},
									{},
									{
										"formattedValue": "Prep"
									},
									{
										"formattedValue": "3A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "3A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "3A"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "10:00 - 10:15"
									},
									{
										"formattedValue": "3A"
									},
									{
										"formattedValue": "Rec"
									},
									{
										"formattedValue": "3A"
									},
									{
										"formattedValue": "Rec"
									},
									{
										"formattedValue": "3A"
									},
									{
										"formattedValue": "Rec"
									},
									{
										"formattedValue": "3A"
									},
									{
										"formattedValue": "Rec"
									},
									{
										"formattedValue": "3A"
									},
									{
										"formattedValue": "Rec"
									},
									{
										"formattedValue": "3A"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "10:15 - 10:30"
									},
									{
										"formattedValue": "3A"
									},
									{
										"formattedValue": "PE"
									},
									{
										"formattedValue": "3A"
									},
									{
										"formattedValue": "PE"
									},
									{
										"formattedValue": "3A"
									},
									{
										"formattedValue": "Prep"
									},
									{
										"formattedValue": "3A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "3A"
									},
									{
										"formattedValue": "PE"
									},
									{
										"formattedValue": "3A"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "10:30 - 10:45"
									},
									{
										"formattedValue": "3A"
									},
									{
										"formattedValue": "PE"
									},
									{
										"formattedValue": "3A"
									},
									{
										"formattedValue": "PE"
									},
									{
										"formattedValue": "3A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "3A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "3A"
									},
									{
										"formattedValue": "PE"
									},
									{
										"formattedValue": "3A"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "10:45 - 11:00"
									},
									{
										"formattedValue": "3A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "3A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "3A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "3A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "3A"
									},
									{
										"formattedValue": "PE"
									},
									{
										"formattedValue": "3A"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "11:00 - 11:15"
									},
									{
										"formattedValue": "3A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "3A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "3A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "3A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "3A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "3A"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "11:15 - 11:30"
									},
									{
										"formattedValue": "3A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "3A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "3A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "3A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "3A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "3A"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "11:30 - 11:45"
									},
									{
										"formattedValue": "3A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "3A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "3A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "3A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "3A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "3A"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "11:45 - 12:00"
									},
									{
										"formattedValue": "3A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "3A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "3A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "3A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "3A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "3A"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "12:00 - 12:15"
									},
									{
										"formattedValue": "3A"
									},
									{
										"formattedValue": "Lunch"
									},
									{},
									{
										"formattedValue": "Lunch"
									},
									{},
									{
										"formattedValue": "Lunch"
									},
									{},
									{
										"formattedValue": "Lunch"
									},
									{},
									{
										"formattedValue": "Lunch"
									},
									{}
								]
							},
							{
								"values": [
									{
										"formattedValue": "12:15 - 12:30"
									},
									{
										"formattedValue": "3A"
									},
									{
										"formattedValue": "Lunch"
									},
									{},
									{
										"formattedValue": "Lunch"
									},
									{},
									{
										"formattedValue": "Lunch"
									},
									{},
									{
										"formattedValue": "Lunch"
									},
									{},
									{
										"formattedValue": "Lunch"
									},
									{}
								]
							},
							{
								"values": [
									{
										"formattedValue": "12:30-12:45"
									},
									{
										"formattedValue": "3A"
									},
									{
										"formattedValue": "Lunch"
									},
									{},
									{
										"formattedValue": "Lunch"
									},
									{},
									{
										"formattedValue": "Lunch"
									},
									{},
									{
										"formattedValue": "Lunch"
									},
									{},
									{
										"formattedValue": "Lunch"
									},
									{}
								]
							},
							{
								"values": [
									{
										"formattedValue": "12:45-1:00"
									},
									{
										"formattedValue": "3A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "3A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "3A"
									},
									{
										"formattedValue": "COTEACH"
									},
									{
										"formattedValue": "3A"
									},
									{
										"formattedValue": "PD"
									},
									{
										"formattedValue": "3A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "3A"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "1:00 - 1:15"
									},
									{
										"formattedValue": "3A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "3A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "3A"
									},
									{
										"formattedValue": "COTEACH"
									},
									{
										"formattedValue": "3A"
									},
									{
										"formattedValue": "PD"
									},
									{
										"formattedValue": "3A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "3A"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "1:15 - 1:30"
									},
									{
										"formattedValue": "3A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "3A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "3A"
									},
									{
										"formattedValue": "COTEACH"
									},
									{
										"formattedValue": "3A"
									},
									{
										"formattedValue": "PD"
									},
									{
										"formattedValue": "3A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "3A"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "1:30 - 1:45"
									},
									{
										"formattedValue": "3A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "3A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "3A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "3A"
									},
									{
										"formattedValue": "PD"
									},
									{
										"formattedValue": "3A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "3A"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "1:45-2:00"
									},
									{
										"formattedValue": "3A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "3A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "3A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "3A"
									},
									{
										"formattedValue": "PD"
									},
									{
										"formattedValue": "3A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "3A"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "7:45-8:00"
									},
									{
										"formattedValue": "3B"
									},
									{
										"formattedValue": "Intake"
									},
									{
										"formattedValue": "3B"
									},
									{
										"formattedValue": "Intake"
									},
									{
										"formattedValue": "3B"
									},
									{
										"formattedValue": "Intake"
									},
									{
										"formattedValue": "3B"
									},
									{
										"formattedValue": "Intake"
									},
									{
										"formattedValue": "3B"
									},
									{
										"formattedValue": "Intake"
									},
									{
										"formattedValue": "3B"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "8:00-8:15"
									},
									{
										"formattedValue": "3B"
									},
									{
										"formattedValue": "ELD"
									},
									{
										"formattedValue": "3B"
									},
									{
										"formattedValue": "ELD"
									},
									{
										"formattedValue": "3B"
									},
									{
										"formattedValue": "ELD"
									},
									{
										"formattedValue": "3B"
									},
									{
										"formattedValue": "ELD"
									},
									{
										"formattedValue": "3B"
									},
									{
										"formattedValue": "ELD"
									},
									{
										"formattedValue": "3B"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "8:15-8:30"
									},
									{
										"formattedValue": "3B"
									},
									{
										"formattedValue": "ELD"
									},
									{
										"formattedValue": "3B"
									},
									{
										"formattedValue": "ELD"
									},
									{
										"formattedValue": "3B"
									},
									{
										"formattedValue": "ELD"
									},
									{
										"formattedValue": "3B"
									},
									{
										"formattedValue": "ELD"
									},
									{
										"formattedValue": "3B"
									},
									{
										"formattedValue": "ELD"
									},
									{
										"formattedValue": "3B"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "8:30 - 8:45"
									},
									{
										"formattedValue": "3B"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "3B"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "3B"
									},
									{
										"formattedValue": "Prep"
									},
									{
										"formattedValue": "3B"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "3B"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "3B"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "8:45-9:00"
									},
									{
										"formattedValue": "3B"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "3B"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "3B"
									},
									{
										"formattedValue": "Prep"
									},
									{
										"formattedValue": "3B"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "3B"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "3B"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "9:00-9:15"
									},
									{
										"formattedValue": "3B"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "3B"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "3B"
									},
									{
										"formattedValue": "Prep"
									},
									{
										"formattedValue": "3B"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "3B"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "3B"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "9:15 - 9:30"
									},
									{
										"formattedValue": "3B"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "3B"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "3B"
									},
									{
										"formattedValue": "Prep"
									},
									{
										"formattedValue": "3B"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "3B"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "3B"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "9:30-9:45"
									},
									{
										"formattedValue": "3B"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "3B"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "3B"
									},
									{
										"formattedValue": "Prep"
									},
									{
										"formattedValue": "3B"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "3B"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "3B"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "9:45-10:00"
									},
									{
										"formattedValue": "3B"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "3B"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "3B"
									},
									{
										"formattedValue": "Prep"
									},
									{
										"formattedValue": "3B"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "3B"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "3B"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "10:00 - 10:15"
									},
									{
										"formattedValue": "3B"
									},
									{
										"formattedValue": "Rec"
									},
									{
										"formattedValue": "3B"
									},
									{
										"formattedValue": "Rec"
									},
									{
										"formattedValue": "3B"
									},
									{
										"formattedValue": "Rec"
									},
									{
										"formattedValue": "3B"
									},
									{
										"formattedValue": "Rec"
									},
									{
										"formattedValue": "3B"
									},
									{
										"formattedValue": "Rec"
									},
									{
										"formattedValue": "3B"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "10:15 - 10:30"
									},
									{
										"formattedValue": "3B"
									},
									{
										"formattedValue": "PE"
									},
									{
										"formattedValue": "3B"
									},
									{
										"formattedValue": "PE"
									},
									{
										"formattedValue": "3B"
									},
									{
										"formattedValue": "Prep"
									},
									{
										"formattedValue": "3B"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "3B"
									},
									{
										"formattedValue": "PE"
									},
									{
										"formattedValue": "3B"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "10:30 - 10:45"
									},
									{
										"formattedValue": "3B"
									},
									{
										"formattedValue": "PE"
									},
									{
										"formattedValue": "3B"
									},
									{
										"formattedValue": "PE"
									},
									{
										"formattedValue": "3B"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "3B"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "3B"
									},
									{
										"formattedValue": "PE"
									},
									{
										"formattedValue": "3B"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "10:45 - 11:00"
									},
									{
										"formattedValue": "3B"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "3B"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "3B"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "3B"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "3B"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "3B"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "11:00 - 11:15"
									},
									{
										"formattedValue": "3B"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "3B"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "3B"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "3B"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "3B"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "3B"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "11:15 - 11:30"
									},
									{
										"formattedValue": "3B"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "3B"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "3B"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "3B"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "3B"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "3B"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "11:30 - 11:45"
									},
									{
										"formattedValue": "3B"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "3B"
									},
									{
										"formattedValue": "VAPA"
									},
									{},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "3B"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "3B"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "3B"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "11:45 - 12:00"
									},
									{
										"formattedValue": "3B"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "3B"
									},
									{
										"formattedValue": "VAPA"
									},
									{},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "3B"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "3B"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "3B"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "12:00-12:15"
									},
									{
										"formattedValue": "3B"
									},
									{
										"formattedValue": "Lunch"
									},
									{},
									{
										"formattedValue": "Lunch"
									},
									{},
									{
										"formattedValue": "Lunch"
									},
									{},
									{
										"formattedValue": "Lunch"
									},
									{},
									{
										"formattedValue": "Lunch"
									},
									{}
								]
							},
							{
								"values": [
									{
										"formattedValue": "12:15-12:30"
									},
									{
										"formattedValue": "3B"
									},
									{
										"formattedValue": "Lunch"
									},
									{},
									{
										"formattedValue": "Lunch"
									},
									{},
									{
										"formattedValue": "Lunch"
									},
									{},
									{
										"formattedValue": "Lunch"
									},
									{},
									{
										"formattedValue": "Lunch"
									},
									{}
								]
							},
							{
								"values": [
									{
										"formattedValue": "12:30-12:45"
									},
									{
										"formattedValue": "3B"
									},
									{
										"formattedValue": "Lunch"
									},
									{},
									{
										"formattedValue": "Lunch"
									},
									{},
									{
										"formattedValue": "Lunch"
									},
									{},
									{
										"formattedValue": "Lunch"
									},
									{},
									{
										"formattedValue": "Lunch"
									},
									{}
								]
							},
							{
								"values": [
									{
										"formattedValue": "12:45-1:00"
									},
									{
										"formattedValue": "3B"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "3B"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "3B"
									},
									{
										"formattedValue": "COTEACH"
									},
									{
										"formattedValue": "3B"
									},
									{
										"formattedValue": "PD"
									},
									{
										"formattedValue": "3B"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "3B"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "1:00 - 1:15"
									},
									{
										"formattedValue": "3B"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "3B"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "3B"
									},
									{
										"formattedValue": "COTEACH"
									},
									{
										"formattedValue": "3B"
									},
									{
										"formattedValue": "PD"
									},
									{
										"formattedValue": "3B"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "3B"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "1:15 - 1:30"
									},
									{
										"formattedValue": "3B"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "3B"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "3B"
									},
									{
										"formattedValue": "COTEACH"
									},
									{
										"formattedValue": "3B"
									},
									{
										"formattedValue": "PD"
									},
									{
										"formattedValue": "3B"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "3B"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "1:30 - 1:45"
									},
									{
										"formattedValue": "3B"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "3B"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "3B"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "3B"
									},
									{
										"formattedValue": "PD"
									},
									{
										"formattedValue": "3B"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "3B"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "1:45-2:00"
									},
									{
										"formattedValue": "3B"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "3B"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "3B"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "3B"
									},
									{
										"formattedValue": "PD"
									},
									{
										"formattedValue": "3B"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "3B"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "7:45-8:00"
									},
									{
										"formattedValue": "4A"
									},
									{
										"formattedValue": "Intake"
									},
									{
										"formattedValue": "4A"
									},
									{
										"formattedValue": "Intake"
									},
									{
										"formattedValue": "4A"
									},
									{
										"formattedValue": "Intake"
									},
									{
										"formattedValue": "4A"
									},
									{
										"formattedValue": "Intake"
									},
									{
										"formattedValue": "4A"
									},
									{
										"formattedValue": "Intake"
									},
									{
										"formattedValue": "4A"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "8:00-8:15"
									},
									{
										"formattedValue": "4A"
									},
									{
										"formattedValue": "ELD"
									},
									{
										"formattedValue": "4A"
									},
									{
										"formattedValue": "ELD"
									},
									{
										"formattedValue": "4A"
									},
									{
										"formattedValue": "ELD"
									},
									{
										"formattedValue": "4A"
									},
									{
										"formattedValue": "ELD"
									},
									{
										"formattedValue": "4A"
									},
									{
										"formattedValue": "ELD"
									},
									{
										"formattedValue": "4A"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "8:15-8:30"
									},
									{
										"formattedValue": "4A"
									},
									{
										"formattedValue": "ELD"
									},
									{
										"formattedValue": "4A"
									},
									{
										"formattedValue": "ELD"
									},
									{
										"formattedValue": "4A"
									},
									{
										"formattedValue": "ELD"
									},
									{
										"formattedValue": "4A"
									},
									{
										"formattedValue": "ELD"
									},
									{
										"formattedValue": "4A"
									},
									{
										"formattedValue": "ELD"
									},
									{
										"formattedValue": "4A"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "8:30 - 8:45"
									},
									{
										"formattedValue": "4A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "4A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "4A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "4A"
									},
									{
										"formattedValue": "Prep"
									},
									{},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "4A"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "8:45-9:00"
									},
									{
										"formattedValue": "4A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "4A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "4A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "4A"
									},
									{
										"formattedValue": "Prep"
									},
									{},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "4A"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "9:00-9:15"
									},
									{
										"formattedValue": "4A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "4A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "4A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "4A"
									},
									{
										"formattedValue": "Prep"
									},
									{},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "4A"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "9:15 - 9:30"
									},
									{
										"formattedValue": "4A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "4A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "4A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "4A"
									},
									{
										"formattedValue": "Prep"
									},
									{},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "4A"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "9:30-9:45"
									},
									{
										"formattedValue": "4A"
									},
									{
										"formattedValue": "Prep"
									},
									{},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "4A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "4A"
									},
									{
										"formattedValue": "Prep"
									},
									{},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "4A"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "9:45-10:00"
									},
									{
										"formattedValue": "4A"
									},
									{
										"formattedValue": "Prep"
									},
									{},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "4A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "4A"
									},
									{
										"formattedValue": "Prep"
									},
									{},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "4A"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "10:00 - 10:15"
									},
									{
										"formattedValue": "4A"
									},
									{
										"formattedValue": "Rec"
									},
									{
										"formattedValue": "4A"
									},
									{
										"formattedValue": "Rec"
									},
									{
										"formattedValue": "4A"
									},
									{
										"formattedValue": "Rec"
									},
									{
										"formattedValue": "4A"
									},
									{
										"formattedValue": "Prep"
									},
									{},
									{
										"formattedValue": "Rec"
									},
									{
										"formattedValue": "4A"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "10:15 - 10:30"
									},
									{
										"formattedValue": "4A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "4A"
									},
									{
										"formattedValue": "PWG"
									},
									{
										"formattedValue": "4A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "4A"
									},
									{
										"formattedValue": "Prep"
									},
									{},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "4A"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "10:30 - 10:45"
									},
									{
										"formattedValue": "4A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "4A"
									},
									{
										"formattedValue": "PWG"
									},
									{
										"formattedValue": "4A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "4A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "4A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "4A"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "10:45 - 11:00"
									},
									{
										"formattedValue": "4A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "4A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "4A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "4A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "4A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "4A"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "11:00 - 11:15"
									},
									{
										"formattedValue": "4A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "4A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "4A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "4A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "4A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "4A"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "11:15 - 11:30"
									},
									{
										"formattedValue": "4A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "4A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "4A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "4A"
									},
									{
										"formattedValue": "Coteach"
									},
									{
										"formattedValue": "4A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "4A"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "11:30 - 11:45"
									},
									{
										"formattedValue": "4A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "4A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "4A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "4A"
									},
									{
										"formattedValue": "Coteach"
									},
									{
										"formattedValue": "4A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "4A"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "11:45 - 12:00"
									},
									{
										"formattedValue": "4A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "4A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "4A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "4A"
									},
									{
										"formattedValue": "Coteach"
									},
									{
										"formattedValue": "4A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "4A"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "12:00 - 12:15"
									},
									{
										"formattedValue": "4A"
									},
									{
										"formattedValue": "Lunch"
									},
									{},
									{
										"formattedValue": "Lunch"
									},
									{},
									{
										"formattedValue": "Lunch"
									},
									{},
									{
										"formattedValue": "Lunch"
									},
									{},
									{
										"formattedValue": "Lunch"
									},
									{}
								]
							},
							{
								"values": [
									{
										"formattedValue": "12:15 - 12:30"
									},
									{
										"formattedValue": "4A"
									},
									{
										"formattedValue": "Lunch"
									},
									{},
									{
										"formattedValue": "Lunch"
									},
									{},
									{
										"formattedValue": "Lunch"
									},
									{},
									{
										"formattedValue": "Lunch"
									},
									{},
									{
										"formattedValue": "Lunch"
									},
									{}
								]
							},
							{
								"values": [
									{
										"formattedValue": "12:30-12:45"
									},
									{
										"formattedValue": "4A"
									},
									{
										"formattedValue": "Lunch"
									},
									{},
									{
										"formattedValue": "Lunch"
									},
									{},
									{
										"formattedValue": "Lunch"
									},
									{},
									{
										"formattedValue": "Lunch"
									},
									{},
									{
										"formattedValue": "Lunch"
									},
									{}
								]
							},
							{
								"values": [
									{
										"formattedValue": "12:45-1:00"
									},
									{
										"formattedValue": "4A"
									},
									{
										"formattedValue": "PE"
									},
									{
										"formattedValue": "4A"
									},
									{
										"formattedValue": "PE"
									},
									{
										"formattedValue": "4A"
									},
									{
										"formattedValue": "PE"
									},
									{
										"formattedValue": "4A"
									},
									{
										"formattedValue": "PD"
									},
									{
										"formattedValue": "4A"
									},
									{
										"formattedValue": "PE"
									},
									{
										"formattedValue": "4A"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "1:00 - 1:15"
									},
									{
										"formattedValue": "4A"
									},
									{
										"formattedValue": "PE"
									},
									{
										"formattedValue": "4A"
									},
									{
										"formattedValue": "PE"
									},
									{
										"formattedValue": "4A"
									},
									{
										"formattedValue": "PE"
									},
									{
										"formattedValue": "4A"
									},
									{
										"formattedValue": "PD"
									},
									{
										"formattedValue": "4A"
									},
									{
										"formattedValue": "PE"
									},
									{
										"formattedValue": "4A"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "1:15 - 1:30"
									},
									{
										"formattedValue": "4A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "4A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "4A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "4A"
									},
									{
										"formattedValue": "PD"
									},
									{
										"formattedValue": "4A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "4A"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "1:30 - 1:45"
									},
									{
										"formattedValue": "4A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "4A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "4A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "4A"
									},
									{
										"formattedValue": "PD"
									},
									{
										"formattedValue": "4A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "4A"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "1:45-2:00"
									},
									{
										"formattedValue": "4A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "4A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "4A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "4A"
									},
									{
										"formattedValue": "PD"
									},
									{
										"formattedValue": "4A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "4A"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "7:45-8:00"
									},
									{
										"formattedValue": "4B"
									},
									{
										"formattedValue": "Intake"
									},
									{
										"formattedValue": "4B"
									},
									{
										"formattedValue": "Intake"
									},
									{
										"formattedValue": "4B"
									},
									{
										"formattedValue": "Intake"
									},
									{
										"formattedValue": "4B"
									},
									{
										"formattedValue": "Intake"
									},
									{
										"formattedValue": "4B"
									},
									{
										"formattedValue": "Intake"
									},
									{
										"formattedValue": "4B"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "8:00-8:15"
									},
									{
										"formattedValue": "4B"
									},
									{
										"formattedValue": "ELD"
									},
									{
										"formattedValue": "4B"
									},
									{
										"formattedValue": "ELD"
									},
									{
										"formattedValue": "4B"
									},
									{
										"formattedValue": "ELD"
									},
									{
										"formattedValue": "4B"
									},
									{
										"formattedValue": "ELD"
									},
									{
										"formattedValue": "4B"
									},
									{
										"formattedValue": "ELD"
									},
									{
										"formattedValue": "4B"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "8:15-8:30"
									},
									{
										"formattedValue": "4B"
									},
									{
										"formattedValue": "ELD"
									},
									{
										"formattedValue": "4B"
									},
									{
										"formattedValue": "ELD"
									},
									{
										"formattedValue": "4B"
									},
									{
										"formattedValue": "ELD"
									},
									{
										"formattedValue": "4B"
									},
									{
										"formattedValue": "ELD"
									},
									{
										"formattedValue": "4B"
									},
									{
										"formattedValue": "ELD"
									},
									{
										"formattedValue": "4B"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "8:30 - 8:45"
									},
									{
										"formattedValue": "4B"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "4B"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "4B"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "4B"
									},
									{
										"formattedValue": "Prep"
									},
									{},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "4B"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "8:45-9:00"
									},
									{
										"formattedValue": "4B"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "4B"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "4B"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "4B"
									},
									{
										"formattedValue": "Prep"
									},
									{},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "4B"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "9:00-9:15"
									},
									{
										"formattedValue": "4B"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "4B"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "4B"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "4B"
									},
									{
										"formattedValue": "Prep"
									},
									{},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "4B"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "9:15 - 9:30"
									},
									{
										"formattedValue": "4B"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "4B"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "4B"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "4B"
									},
									{
										"formattedValue": "Prep"
									},
									{},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "4B"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "9:30-9:45"
									},
									{
										"formattedValue": "4B"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "4B"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "4B"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "4B"
									},
									{
										"formattedValue": "Prep"
									},
									{},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "4B"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "9:45-10:00"
									},
									{
										"formattedValue": "4B"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "4B"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "4B"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "4B"
									},
									{
										"formattedValue": "Prep"
									},
									{},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "4B"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "10:00 - 10:15"
									},
									{
										"formattedValue": "4B"
									},
									{
										"formattedValue": "Rec"
									},
									{
										"formattedValue": "4B"
									},
									{
										"formattedValue": "Rec"
									},
									{
										"formattedValue": "4B"
									},
									{
										"formattedValue": "Rec"
									},
									{
										"formattedValue": "4B"
									},
									{
										"formattedValue": "Prep"
									},
									{},
									{
										"formattedValue": "Rec"
									},
									{
										"formattedValue": "4B"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "10:15 - 10:30"
									},
									{
										"formattedValue": "4B"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "4B"
									},
									{
										"formattedValue": "PWG"
									},
									{
										"formattedValue": "4B"
									},
									{
										"formattedValue": "PWG"
									},
									{
										"formattedValue": "4B"
									},
									{
										"formattedValue": "Prep"
									},
									{},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "4B"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "10:30 - 10:45"
									},
									{
										"formattedValue": "4B"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "4B"
									},
									{
										"formattedValue": "PWG"
									},
									{
										"formattedValue": "4B"
									},
									{
										"formattedValue": "PWG"
									},
									{
										"formattedValue": "4B"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "4B"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "4B"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "10:45 - 11:00"
									},
									{
										"formattedValue": "4B"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "4B"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "4B"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "4B"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "4B"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "4B"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "11:00 - 11:15"
									},
									{
										"formattedValue": "4B"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "4B"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "4B"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "4B"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "4B"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "4B"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "11:15 - 11:30"
									},
									{
										"formattedValue": "4B"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "4B"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "4B"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "4B"
									},
									{
										"formattedValue": "COTEACH"
									},
									{
										"formattedValue": "4B"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "4B"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "11:30 - 11:45"
									},
									{
										"formattedValue": "4B"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "4B"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "4B"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "4B"
									},
									{
										"formattedValue": "COTEACH"
									},
									{
										"formattedValue": "4B"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "4B"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "11:45 - 12:00"
									},
									{
										"formattedValue": "4B"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "4B"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "4B"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "4B"
									},
									{
										"formattedValue": "COTEACH"
									},
									{
										"formattedValue": "4B"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "4B"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "12:00 - 12:15"
									},
									{
										"formattedValue": "4B"
									},
									{
										"formattedValue": "Lunch"
									},
									{},
									{
										"formattedValue": "Lunch"
									},
									{},
									{
										"formattedValue": "Lunch"
									},
									{},
									{
										"formattedValue": "Lunch"
									},
									{},
									{
										"formattedValue": "Lunch"
									},
									{}
								]
							},
							{
								"values": [
									{
										"formattedValue": "12:15 - 12:30"
									},
									{
										"formattedValue": "4B"
									},
									{
										"formattedValue": "Lunch"
									},
									{},
									{
										"formattedValue": "Lunch"
									},
									{},
									{
										"formattedValue": "Lunch"
									},
									{},
									{
										"formattedValue": "Lunch"
									},
									{},
									{
										"formattedValue": "Lunch"
									},
									{}
								]
							},
							{
								"values": [
									{
										"formattedValue": "12:30-12:45"
									},
									{
										"formattedValue": "4B"
									},
									{
										"formattedValue": "Lunch"
									},
									{},
									{
										"formattedValue": "Lunch"
									},
									{},
									{
										"formattedValue": "Lunch"
									},
									{},
									{
										"formattedValue": "Lunch"
									},
									{},
									{
										"formattedValue": "Lunch"
									},
									{}
								]
							},
							{
								"values": [
									{
										"formattedValue": "12:45-1:00"
									},
									{
										"formattedValue": "4B"
									},
									{
										"formattedValue": "PE"
									},
									{
										"formattedValue": "4B"
									},
									{
										"formattedValue": "Prep"
									},
									{},
									{
										"formattedValue": "PE"
									},
									{
										"formattedValue": "4B"
									},
									{
										"formattedValue": "PD"
									},
									{
										"formattedValue": "4B"
									},
									{
										"formattedValue": "PE"
									},
									{
										"formattedValue": "4B"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "1:00 - 1:15"
									},
									{
										"formattedValue": "4B"
									},
									{
										"formattedValue": "PE"
									},
									{
										"formattedValue": "4B"
									},
									{
										"formattedValue": "Prep"
									},
									{},
									{
										"formattedValue": "PE"
									},
									{
										"formattedValue": "4B"
									},
									{
										"formattedValue": "PD"
									},
									{
										"formattedValue": "4B"
									},
									{
										"formattedValue": "PE"
									},
									{
										"formattedValue": "4B"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "1:15 - 1:30"
									},
									{
										"formattedValue": "4B"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "4B"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "4B"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "4B"
									},
									{
										"formattedValue": "PD"
									},
									{
										"formattedValue": "4B"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "4B"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "1:30 - 1:45"
									},
									{
										"formattedValue": "4B"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "4B"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "4B"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "4B"
									},
									{
										"formattedValue": "PD"
									},
									{
										"formattedValue": "4B"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "4B"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "1:45-2:00"
									},
									{
										"formattedValue": "4B"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "4B"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "4B"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "4B"
									},
									{
										"formattedValue": "PD"
									},
									{
										"formattedValue": "4B"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "4B"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "7:45-8:00"
									},
									{
										"formattedValue": "5A"
									},
									{
										"formattedValue": "Intake"
									},
									{
										"formattedValue": "5A"
									},
									{
										"formattedValue": "Intake"
									},
									{
										"formattedValue": "5A"
									},
									{
										"formattedValue": "Intake"
									},
									{
										"formattedValue": "5A"
									},
									{
										"formattedValue": "Intake"
									},
									{
										"formattedValue": "5A"
									},
									{
										"formattedValue": "Intake"
									},
									{
										"formattedValue": "5A"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "8:00-8:15"
									},
									{
										"formattedValue": "5A"
									},
									{
										"formattedValue": "ELD"
									},
									{
										"formattedValue": "5A"
									},
									{
										"formattedValue": "ELD"
									},
									{
										"formattedValue": "5A"
									},
									{
										"formattedValue": "ELD"
									},
									{
										"formattedValue": "5A"
									},
									{
										"formattedValue": "ELD"
									},
									{
										"formattedValue": "5A"
									},
									{
										"formattedValue": "ELD"
									},
									{
										"formattedValue": "5A"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "8:15-8:30"
									},
									{
										"formattedValue": "5A"
									},
									{
										"formattedValue": "ELD"
									},
									{
										"formattedValue": "5A"
									},
									{
										"formattedValue": "ELD"
									},
									{
										"formattedValue": "5A"
									},
									{
										"formattedValue": "ELD"
									},
									{
										"formattedValue": "5A"
									},
									{
										"formattedValue": "ELD"
									},
									{
										"formattedValue": "5A"
									},
									{
										"formattedValue": "ELD"
									},
									{
										"formattedValue": "5A"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "8:30 - 8:45"
									},
									{
										"formattedValue": "5A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "5A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "5A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "5A"
									},
									{
										"formattedValue": "Prep"
									},
									{},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "5A"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "8:45-9:00"
									},
									{
										"formattedValue": "5A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "5A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "5A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "5A"
									},
									{
										"formattedValue": "Prep"
									},
									{},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "5A"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "9:00-9:15"
									},
									{
										"formattedValue": "5A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "5A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "5A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "5A"
									},
									{
										"formattedValue": "Prep"
									},
									{},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "5A"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "9:15 - 9:30"
									},
									{
										"formattedValue": "5A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "5A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "5A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "5A"
									},
									{
										"formattedValue": "Prep"
									},
									{},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "5A"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "9:30-9:45"
									},
									{
										"formattedValue": "5A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "5A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "5A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "5A"
									},
									{
										"formattedValue": "Prep"
									},
									{},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "5A"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "9:45-10:00"
									},
									{
										"formattedValue": "5A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "5A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "5A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "5A"
									},
									{
										"formattedValue": "Prep"
									},
									{},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "5A"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "10:00 - 10:15"
									},
									{
										"formattedValue": "5A"
									},
									{
										"formattedValue": "Rec"
									},
									{
										"formattedValue": "5A"
									},
									{
										"formattedValue": "Rec"
									},
									{
										"formattedValue": "5A"
									},
									{
										"formattedValue": "Rec"
									},
									{
										"formattedValue": "5A"
									},
									{
										"formattedValue": "Prep"
									},
									{},
									{
										"formattedValue": "Rec"
									},
									{
										"formattedValue": "5A"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "10:15 - 10:30"
									},
									{
										"formattedValue": "5A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "5A"
									},
									{
										"formattedValue": "Prep"
									},
									{},
									{
										"formattedValue": "PWG"
									},
									{
										"formattedValue": "5A"
									},
									{
										"formattedValue": "Prep"
									},
									{},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "5A"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "10:30 - 10:45"
									},
									{
										"formattedValue": "5A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "5A"
									},
									{
										"formattedValue": "Prep"
									},
									{},
									{
										"formattedValue": "PWG"
									},
									{
										"formattedValue": "5A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "5A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "5A"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "10:45 - 11:00"
									},
									{
										"formattedValue": "5A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "5A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "5A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "5A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "5A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "5A"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "11:00 - 11:15"
									},
									{
										"formattedValue": "5A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "5A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "5A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "5A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "5A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "5A"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "11:15 - 11:30"
									},
									{
										"formattedValue": "5A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "5A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "5A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "5A"
									},
									{
										"formattedValue": "COTEACH"
									},
									{
										"formattedValue": "5A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "5A"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "11:30 - 11:45"
									},
									{
										"formattedValue": "5A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "5A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "5A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "5A"
									},
									{
										"formattedValue": "COTEACH"
									},
									{
										"formattedValue": "5A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "5A"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "11:45 - 12:00"
									},
									{
										"formattedValue": "5A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "5A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "5A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "5A"
									},
									{
										"formattedValue": "COTEACH"
									},
									{
										"formattedValue": "5A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "5A"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "12:00 - 12:15"
									},
									{
										"formattedValue": "5A"
									},
									{
										"formattedValue": "Lunch"
									},
									{},
									{
										"formattedValue": "Lunch"
									},
									{},
									{
										"formattedValue": "Lunch"
									},
									{},
									{
										"formattedValue": "Lunch"
									},
									{},
									{
										"formattedValue": "Lunch"
									},
									{}
								]
							},
							{
								"values": [
									{
										"formattedValue": "12:15 - 12:30"
									},
									{
										"formattedValue": "5A"
									},
									{
										"formattedValue": "Lunch"
									},
									{},
									{
										"formattedValue": "Lunch"
									},
									{},
									{
										"formattedValue": "Lunch"
									},
									{},
									{
										"formattedValue": "Lunch"
									},
									{},
									{
										"formattedValue": "Lunch"
									},
									{}
								]
							},
							{
								"values": [
									{
										"formattedValue": "12:30-12:45"
									},
									{
										"formattedValue": "5A"
									},
									{
										"formattedValue": "Lunch"
									},
									{},
									{
										"formattedValue": "Lunch"
									},
									{},
									{
										"formattedValue": "Lunch"
									},
									{},
									{
										"formattedValue": "Lunch"
									},
									{},
									{
										"formattedValue": "Lunch"
									},
									{}
								]
							},
							{
								"values": [
									{
										"formattedValue": "12:45-1:00"
									},
									{
										"formattedValue": "5A"
									},
									{
										"formattedValue": "PE"
									},
									{
										"formattedValue": "5A"
									},
									{
										"formattedValue": "PE"
									},
									{
										"formattedValue": "5A"
									},
									{
										"formattedValue": "PE"
									},
									{
										"formattedValue": "5A"
									},
									{
										"formattedValue": "PD"
									},
									{
										"formattedValue": "5A"
									},
									{
										"formattedValue": "PE"
									},
									{
										"formattedValue": "5A"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "1:00 - 1:15"
									},
									{
										"formattedValue": "5A"
									},
									{
										"formattedValue": "PE"
									},
									{
										"formattedValue": "5A"
									},
									{
										"formattedValue": "PE"
									},
									{
										"formattedValue": "5A"
									},
									{
										"formattedValue": "PE"
									},
									{
										"formattedValue": "5A"
									},
									{
										"formattedValue": "PD"
									},
									{
										"formattedValue": "5A"
									},
									{
										"formattedValue": "PE"
									},
									{
										"formattedValue": "5A"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "1:15 - 1:30"
									},
									{
										"formattedValue": "5A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "5A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "5A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "5A"
									},
									{
										"formattedValue": "PD"
									},
									{
										"formattedValue": "5A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "5A"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "1:30 - 1:45"
									},
									{
										"formattedValue": "5A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "5A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "5A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "5A"
									},
									{
										"formattedValue": "PD"
									},
									{
										"formattedValue": "5A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "5A"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "1:45-2:00"
									},
									{
										"formattedValue": "5A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "5A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "5A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "5A"
									},
									{
										"formattedValue": "PD"
									},
									{
										"formattedValue": "5A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "5A"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "7:45-8:00"
									},
									{
										"formattedValue": "PE"
									},
									{
										"formattedValue": "Duty"
									},
									{},
									{
										"formattedValue": "Duty"
									},
									{},
									{
										"formattedValue": "Duty"
									},
									{},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "8:00-8:15"
									},
									{
										"formattedValue": "PE"
									},
									{
										"formattedValue": "Prep"
									},
									{},
									{
										"formattedValue": "Prep"
									},
									{},
									{
										"formattedValue": "Prep"
									},
									{},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "8:15-8:30"
									},
									{
										"formattedValue": "PE"
									},
									{
										"formattedValue": "Prep"
									},
									{},
									{
										"formattedValue": "Prep"
									},
									{},
									{
										"formattedValue": "Prep"
									},
									{},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "8:30 - 8:45"
									},
									{
										"formattedValue": "PE"
									},
									{
										"formattedValue": "PE KA"
									},
									{
										"formattedValue": "KA"
									},
									{
										"formattedValue": "PE KB"
									},
									{
										"formattedValue": "KB"
									},
									{
										"formattedValue": "PE KC"
									},
									{
										"formattedValue": "KC"
									},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "8:45-9:00"
									},
									{
										"formattedValue": "PE"
									},
									{
										"formattedValue": "PE KA"
									},
									{
										"formattedValue": "KA"
									},
									{
										"formattedValue": "PE KB"
									},
									{
										"formattedValue": "KB"
									},
									{
										"formattedValue": "PE KC"
									},
									{
										"formattedValue": "KC"
									},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "9:00-9:15"
									},
									{
										"formattedValue": "PE"
									},
									{
										"formattedValue": "PE 2A"
									},
									{
										"formattedValue": "2A"
									},
									{
										"formattedValue": "PE 2B"
									},
									{
										"formattedValue": "2B"
									},
									{
										"formattedValue": "Prep"
									},
									{},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "9:15 - 9:30"
									},
									{
										"formattedValue": "PE"
									},
									{
										"formattedValue": "PE 2A"
									},
									{
										"formattedValue": "2A"
									},
									{
										"formattedValue": "PE 2B"
									},
									{
										"formattedValue": "2B"
									},
									{
										"formattedValue": "Prep"
									},
									{},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "9:30-9:45"
									},
									{
										"formattedValue": "PE"
									},
									{
										"formattedValue": "Duty"
									},
									{},
									{
										"formattedValue": "Duty"
									},
									{},
									{
										"formattedValue": "Duty"
									},
									{},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "9:45-10:00"
									},
									{
										"formattedValue": "PE"
									},
									{
										"formattedValue": "Prep"
									},
									{},
									{
										"formattedValue": "Prep"
									},
									{},
									{
										"formattedValue": "Prep"
									},
									{},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "10:00 - 10:15"
									},
									{
										"formattedValue": "PE"
									},
									{
										"formattedValue": "Duty"
									},
									{},
									{
										"formattedValue": "Duty"
									},
									{},
									{
										"formattedValue": "Duty"
									},
									{},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "10:15 - 10:30"
									},
									{
										"formattedValue": "PE"
									},
									{
										"formattedValue": "PE 3A"
									},
									{
										"formattedValue": "3A"
									},
									{
										"formattedValue": "PE 3B"
									},
									{
										"formattedValue": "3B"
									},
									{
										"formattedValue": "PE 3A"
									},
									{
										"formattedValue": "3A"
									},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "10:30 - 10:45"
									},
									{
										"formattedValue": "PE"
									},
									{
										"formattedValue": "PE 3A"
									},
									{
										"formattedValue": "3A"
									},
									{
										"formattedValue": "PE 3B"
									},
									{
										"formattedValue": "3B"
									},
									{
										"formattedValue": "PE 3A"
									},
									{
										"formattedValue": "3A"
									},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "10:45 - 11:00"
									},
									{
										"formattedValue": "PE"
									},
									{
										"formattedValue": "Lunch"
									},
									{},
									{
										"formattedValue": "Lunch"
									},
									{},
									{
										"formattedValue": "Lunch"
									},
									{},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "11:00 - 11:15"
									},
									{
										"formattedValue": "PE"
									},
									{
										"formattedValue": "Lunch"
									},
									{},
									{
										"formattedValue": "Lunch"
									},
									{},
									{
										"formattedValue": "Lunch"
									},
									{},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "11:15 - 11:30"
									},
									{
										"formattedValue": "PE"
									},
									{
										"formattedValue": "Duty"
									},
									{},
									{
										"formattedValue": "Duty"
									},
									{},
									{
										"formattedValue": "Duty"
									},
									{},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "11:30 - 11:45"
									},
									{
										"formattedValue": "PE"
									},
									{
										"formattedValue": "Duty"
									},
									{},
									{
										"formattedValue": "Duty"
									},
									{},
									{
										"formattedValue": "Duty"
									},
									{},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "11:45 - 12:00"
									},
									{
										"formattedValue": "PE"
									},
									{
										"formattedValue": "Duty"
									},
									{},
									{
										"formattedValue": "Duty"
									},
									{},
									{
										"formattedValue": "Duty"
									},
									{},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "12:00 - 12:15"
									},
									{
										"formattedValue": "PE"
									},
									{
										"formattedValue": "Duty"
									},
									{},
									{
										"formattedValue": "Duty"
									},
									{},
									{
										"formattedValue": "Duty"
									},
									{},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "12:15 - 12:30"
									},
									{
										"formattedValue": "PE"
									},
									{
										"formattedValue": "Duty"
									},
									{},
									{
										"formattedValue": "Duty"
									},
									{},
									{
										"formattedValue": "Duty"
									},
									{},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "12:30-12:45"
									},
									{
										"formattedValue": "PE"
									},
									{
										"formattedValue": "Duty"
									},
									{},
									{
										"formattedValue": "Duty"
									},
									{},
									{
										"formattedValue": "Duty"
									},
									{},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "12:45-1:00"
									},
									{
										"formattedValue": "PE"
									},
									{
										"formattedValue": "PE 4A"
									},
									{
										"formattedValue": "4A"
									},
									{
										"formattedValue": "PE 4B"
									},
									{
										"formattedValue": "4B"
									},
									{
										"formattedValue": "PE 5A"
									},
									{
										"formattedValue": "5A"
									},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "1:00 - 1:15"
									},
									{
										"formattedValue": "PE"
									},
									{
										"formattedValue": "PE 4A"
									},
									{
										"formattedValue": "4A"
									},
									{
										"formattedValue": "PE 4B"
									},
									{
										"formattedValue": "4B"
									},
									{
										"formattedValue": "PE 5A"
									},
									{
										"formattedValue": "5A"
									},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "1:15 - 1:30"
									},
									{
										"formattedValue": "PE"
									},
									{
										"formattedValue": " "
									},
									{},
									{
										"formattedValue": "Prep"
									},
									{},
									{
										"formattedValue": "Prep"
									},
									{},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "1:30 - 1:45"
									},
									{
										"formattedValue": "PE"
									},
									{
										"formattedValue": "PE 1A"
									},
									{
										"formattedValue": "1A"
									},
									{
										"formattedValue": "PE 1B"
									},
									{
										"formattedValue": "1B"
									},
									{
										"formattedValue": "PE 1C"
									},
									{
										"formattedValue": "1C"
									},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "1:45-2:00"
									},
									{
										"formattedValue": "PE"
									},
									{
										"formattedValue": "PE 1A"
									},
									{
										"formattedValue": "1A"
									},
									{
										"formattedValue": "PE 1B"
									},
									{
										"formattedValue": "1B"
									},
									{
										"formattedValue": "PE 1C"
									},
									{
										"formattedValue": "1C"
									},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "7:45-8:00"
									},
									{
										"formattedValue": "V"
									},
									{
										"formattedValue": "Prep"
									},
									{},
									{
										"formattedValue": "Prep"
									},
									{},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "8:00-8:15"
									},
									{
										"formattedValue": "V"
									},
									{
										"formattedValue": "Prep"
									},
									{},
									{
										"formattedValue": "Prep"
									},
									{},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "8:15-8:30"
									},
									{
										"formattedValue": "V"
									},
									{
										"formattedValue": "Prep"
									},
									{},
									{
										"formattedValue": "Prep"
									},
									{},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "8:30 - 8:45"
									},
									{
										"formattedValue": "V"
									},
									{
										"formattedValue": "VAPA 1A"
									},
									{
										"formattedValue": "1A"
									},
									{
										"formattedValue": "VAPA 2B"
									},
									{
										"formattedValue": "2B"
									},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "8:45-9:00"
									},
									{
										"formattedValue": "V"
									},
									{
										"formattedValue": "VAPA 1A"
									},
									{
										"formattedValue": "1A"
									},
									{
										"formattedValue": "VAPA 2B"
									},
									{
										"formattedValue": "2B"
									},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "9:00-9:15"
									},
									{
										"formattedValue": "V"
									},
									{
										"formattedValue": "VAPA 1B"
									},
									{
										"formattedValue": "1B"
									},
									{
										"formattedValue": "Prep"
									},
									{},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "9:15 - 9:30"
									},
									{
										"formattedValue": "V"
									},
									{
										"formattedValue": "VAPA 1B"
									},
									{
										"formattedValue": "1B"
									},
									{
										"formattedValue": "Prep"
									},
									{},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "9:30-9:45"
									},
									{
										"formattedValue": "V"
									},
									{
										"formattedValue": "VAPA 4A"
									},
									{
										"formattedValue": "4A"
									},
									{
										"formattedValue": "VAPA 3A"
									},
									{
										"formattedValue": "3A"
									},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "9:45-10:00"
									},
									{
										"formattedValue": "V"
									},
									{
										"formattedValue": "VAPA 4A"
									},
									{
										"formattedValue": "4A"
									},
									{
										"formattedValue": "VAPA 3A"
									},
									{
										"formattedValue": "3A"
									},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "10:00 - 10:15"
									},
									{
										"formattedValue": "V"
									},
									{
										"formattedValue": "Prep"
									},
									{},
									{
										"formattedValue": "Prep"
									},
									{},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "10:15 - 10:30"
									},
									{
										"formattedValue": "V"
									},
									{
										"formattedValue": "Prep"
									},
									{},
									{
										"formattedValue": "VAPA 5A"
									},
									{
										"formattedValue": "5A"
									},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "10:30 - 10:45"
									},
									{
										"formattedValue": "V"
									},
									{
										"formattedValue": "VAPA KC"
									},
									{
										"formattedValue": "KC"
									},
									{
										"formattedValue": "VAPA 5A"
									},
									{
										"formattedValue": "5A"
									},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "10:45 - 11:00"
									},
									{
										"formattedValue": "V"
									},
									{
										"formattedValue": "VAPA KC"
									},
									{
										"formattedValue": "KC"
									},
									{
										"formattedValue": "Lunch"
									},
									{},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "11:00 - 11:15"
									},
									{
										"formattedValue": "V"
									},
									{
										"formattedValue": "Lunch"
									},
									{},
									{
										"formattedValue": "Lunch"
									},
									{},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "11:15 - 11:30"
									},
									{
										"formattedValue": "V"
									},
									{
										"formattedValue": "Lunch"
									},
									{},
									{
										"formattedValue": "Lunch"
									},
									{},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "11:30 - 11:45"
									},
									{
										"formattedValue": "V"
									},
									{
										"formattedValue": "Lunch"
									},
									{},
									{
										"formattedValue": "VAPA 3B"
									},
									{
										"formattedValue": "3B"
									},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "11:45 - 12:00"
									},
									{
										"formattedValue": "V"
									},
									{
										"formattedValue": "VAPA KB"
									},
									{
										"formattedValue": "KB"
									},
									{
										"formattedValue": "VAPA 3B"
									},
									{
										"formattedValue": "3B"
									},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "12:00 - 12:15"
									},
									{
										"formattedValue": "V"
									},
									{
										"formattedValue": "VAPA KB"
									},
									{
										"formattedValue": "KB"
									},
									{
										"formattedValue": "prep"
									},
									{},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "12:15 - 12:30"
									},
									{
										"formattedValue": "V"
									},
									{
										"formattedValue": "Prep"
									},
									{
										"formattedValue": "3A"
									},
									{
										"formattedValue": "VAPA 2A"
									},
									{
										"formattedValue": "2A"
									},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "12:30-12:45"
									},
									{
										"formattedValue": "V"
									},
									{
										"formattedValue": "Prep"
									},
									{
										"formattedValue": "3A"
									},
									{
										"formattedValue": "VAPA 2A"
									},
									{
										"formattedValue": "2A"
									},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "12:45-1:00"
									},
									{
										"formattedValue": "V"
									},
									{
										"formattedValue": "Prep"
									},
									{},
									{
										"formattedValue": "VAPA 4B"
									},
									{
										"formattedValue": "4B"
									},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "1:00 - 1:15"
									},
									{
										"formattedValue": "V"
									},
									{
										"formattedValue": "VAPA 1C"
									},
									{
										"formattedValue": "1C"
									},
									{
										"formattedValue": "VAPA 4B"
									},
									{
										"formattedValue": "4B"
									},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "1:15 - 1:30"
									},
									{
										"formattedValue": "V"
									},
									{
										"formattedValue": "VAPA 1C"
									},
									{
										"formattedValue": "1C"
									},
									{
										"formattedValue": "Prep"
									},
									{},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "1:30 - 1:45"
									},
									{
										"formattedValue": "V"
									},
									{
										"formattedValue": "VAPA KA"
									},
									{
										"formattedValue": "KA"
									},
									{
										"formattedValue": "Prep"
									},
									{},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "1:45-2:00"
									},
									{
										"formattedValue": "V"
									},
									{
										"formattedValue": "VAPA KA"
									},
									{
										"formattedValue": "KA"
									},
									{
										"formattedValue": "Prep"
									},
									{},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "7:45-8:00"
									},
									{
										"formattedValue": "Sci"
									},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "Duty"
									},
									{},
									{
										"formattedValue": "Duty"
									},
									{},
									{
										"formattedValue": "Duty"
									},
									{},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "8:00-8:15"
									},
									{
										"formattedValue": "Sci"
									},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "Prep"
									},
									{},
									{
										"formattedValue": "Prep"
									},
									{},
									{
										"formattedValue": "Prep"
									},
									{},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "8:15-8:30"
									},
									{
										"formattedValue": "Sci"
									},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "Prep"
									},
									{},
									{
										"formattedValue": "Prep"
									},
									{},
									{
										"formattedValue": "Prep"
									},
									{},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "8:30 - 8:45"
									},
									{
										"formattedValue": "Sci"
									},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "Specials 1C"
									},
									{
										"formattedValue": "1C"
									},
									{
										"formattedValue": "Specials 2B"
									},
									{
										"formattedValue": "2B"
									},
									{
										"formattedValue": "Specials 5A"
									},
									{
										"formattedValue": "5A"
									},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "8:45-9:00"
									},
									{
										"formattedValue": "Sci"
									},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "Specials 1C"
									},
									{
										"formattedValue": "1C"
									},
									{
										"formattedValue": "Specials 2B"
									},
									{
										"formattedValue": "2B"
									},
									{
										"formattedValue": "Specials 5A"
									},
									{
										"formattedValue": "5A"
									},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "9:00-9:15"
									},
									{
										"formattedValue": "Sci"
									},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "Specials 1C"
									},
									{
										"formattedValue": "1C"
									},
									{
										"formattedValue": "Specials 2B"
									},
									{
										"formattedValue": "2B"
									},
									{
										"formattedValue": "Specials 5A"
									},
									{
										"formattedValue": "5A"
									},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "9:15 - 9:30"
									},
									{
										"formattedValue": "Sci"
									},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "Specials 1C"
									},
									{
										"formattedValue": "1C"
									},
									{
										"formattedValue": "Specials 2B"
									},
									{
										"formattedValue": "2B"
									},
									{
										"formattedValue": "Specials 5A"
									},
									{
										"formattedValue": "5A"
									},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "9:30-9:45"
									},
									{
										"formattedValue": "Sci"
									},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "Rec"
									},
									{},
									{
										"formattedValue": "Rec"
									},
									{},
									{
										"formattedValue": "Specials 5A"
									},
									{
										"formattedValue": "5A"
									},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "9:45-10:00"
									},
									{
										"formattedValue": "Sci"
									},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "Specials 1C"
									},
									{
										"formattedValue": "1C"
									},
									{
										"formattedValue": "Specials 2A"
									},
									{
										"formattedValue": "2A"
									},
									{
										"formattedValue": "Specials 5A"
									},
									{
										"formattedValue": "5A"
									},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "10:00 - 10:15"
									},
									{
										"formattedValue": "Sci"
									},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "Specials 1C"
									},
									{
										"formattedValue": "1C"
									},
									{
										"formattedValue": "Specials 2A"
									},
									{
										"formattedValue": "2A"
									},
									{
										"formattedValue": "Rec"
									},
									{},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "10:15 - 10:30"
									},
									{
										"formattedValue": "Sci"
									},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "Specials 1C"
									},
									{
										"formattedValue": "1C"
									},
									{
										"formattedValue": "Specials 2A"
									},
									{
										"formattedValue": "2A"
									},
									{
										"formattedValue": "Specials 5A"
									},
									{
										"formattedValue": "5A"
									},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "10:30 - 10:45"
									},
									{
										"formattedValue": "Sci"
									},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "COTEACH KC"
									},
									{
										"formattedValue": "KC"
									},
									{
										"formattedValue": "Prep"
									},
									{},
									{
										"formattedValue": "COTEACH 1C"
									},
									{
										"formattedValue": "1C"
									},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "10:45 - 11:00"
									},
									{
										"formattedValue": "Sci"
									},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "COTEACH KC"
									},
									{
										"formattedValue": "KC"
									},
									{
										"formattedValue": "COTEACH 3A"
									},
									{
										"formattedValue": "3A"
									},
									{
										"formattedValue": "COTEACH 1C"
									},
									{
										"formattedValue": "1C"
									},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "11:00 - 11:15"
									},
									{
										"formattedValue": "Sci"
									},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "Lunch"
									},
									{},
									{
										"formattedValue": "COTEACH 3A"
									},
									{
										"formattedValue": "3A"
									},
									{
										"formattedValue": "COTEACH 1C"
									},
									{
										"formattedValue": "1C"
									},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "11:15 - 11:30"
									},
									{
										"formattedValue": "Sci"
									},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "Lunch"
									},
									{},
									{
										"formattedValue": "COTEACH 3A"
									},
									{
										"formattedValue": "3A"
									},
									{
										"formattedValue": "COTEACH 5A"
									},
									{
										"formattedValue": "5A"
									},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "11:30 - 11:45"
									},
									{
										"formattedValue": "Sci"
									},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "Lunch"
									},
									{},
									{
										"formattedValue": "Lunch"
									},
									{},
									{
										"formattedValue": "COTEACH 5A"
									},
									{
										"formattedValue": "5A"
									},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "11:45 - 12:00"
									},
									{
										"formattedValue": "Sci"
									},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "COTEACH KC"
									},
									{
										"formattedValue": "KC"
									},
									{
										"formattedValue": "Lunch"
									},
									{},
									{
										"formattedValue": "COTEACH 5A"
									},
									{
										"formattedValue": "5A"
									},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "12:00 - 12:15"
									},
									{
										"formattedValue": "Sci"
									},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "COTEACH KC"
									},
									{
										"formattedValue": "KC"
									},
									{
										"formattedValue": "Lunch"
									},
									{},
									{
										"formattedValue": "Lunch"
									},
									{},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "12:15 - 12:30"
									},
									{
										"formattedValue": "Sci"
									},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "Specials KC"
									},
									{
										"formattedValue": "KC"
									},
									{
										"formattedValue": "COTEACH 2B"
									},
									{
										"formattedValue": "2B"
									},
									{
										"formattedValue": "Lunch"
									},
									{},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "12:30-12:45"
									},
									{
										"formattedValue": "Sci"
									},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "Specials KC"
									},
									{
										"formattedValue": "KC"
									},
									{
										"formattedValue": "COTEACH 2B"
									},
									{
										"formattedValue": "2B"
									},
									{
										"formattedValue": "Lunch"
									},
									{},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "12:45-1:00"
									},
									{
										"formattedValue": "Sci"
									},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "Specials KC"
									},
									{
										"formattedValue": "KC"
									},
									{
										"formattedValue": "COTEACH 2B"
									},
									{
										"formattedValue": "2B"
									},
									{
										"formattedValue": "PD"
									},
									{},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "1:00 - 1:15"
									},
									{
										"formattedValue": "Sci"
									},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "Specials KC"
									},
									{
										"formattedValue": "KC"
									},
									{
										"formattedValue": "Specials 3A"
									},
									{
										"formattedValue": "3A"
									},
									{
										"formattedValue": "PD"
									},
									{},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "1:15 - 1:30"
									},
									{
										"formattedValue": "Sci"
									},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "Specials KC"
									},
									{
										"formattedValue": "KC"
									},
									{
										"formattedValue": "Specials 3A"
									},
									{
										"formattedValue": "3A"
									},
									{
										"formattedValue": "PD"
									},
									{},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "1:30 - 1:45"
									},
									{
										"formattedValue": "Sci"
									},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "Specials KC"
									},
									{
										"formattedValue": "KC"
									},
									{
										"formattedValue": "Specials 3B"
									},
									{
										"formattedValue": "3B"
									},
									{
										"formattedValue": "PD"
									},
									{},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "1:45-2:00"
									},
									{
										"formattedValue": "Sci"
									},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "Specials KC"
									},
									{
										"formattedValue": "KC"
									},
									{
										"formattedValue": "Specials 3B"
									},
									{
										"formattedValue": "3B"
									},
									{
										"formattedValue": "PD"
									},
									{},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "7:45-8:00"
									},
									{
										"formattedValue": "PW"
									},
									{
										"formattedValue": "Duty"
									},
									{},
									{
										"formattedValue": "Duty"
									},
									{},
									{
										"formattedValue": "Duty"
									},
									{},
									{
										"formattedValue": "Duty"
									},
									{},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "8:00-8:15"
									},
									{
										"formattedValue": "PW"
									},
									{
										"formattedValue": "Prep"
									},
									{},
									{
										"formattedValue": "Prep"
									},
									{},
									{
										"formattedValue": "Prep"
									},
									{},
									{
										"formattedValue": "Prep"
									},
									{},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "8:15-8:30"
									},
									{
										"formattedValue": "PW"
									},
									{
										"formattedValue": "Prep"
									},
									{},
									{
										"formattedValue": "Prep"
									},
									{},
									{
										"formattedValue": "Prep"
									},
									{},
									{
										"formattedValue": "Prep"
									},
									{},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "8:30 - 8:45"
									},
									{
										"formattedValue": "PW"
									},
									{
										"formattedValue": "PW 1C"
									},
									{
										"formattedValue": "1C"
									},
									{
										"formattedValue": "PW 2A"
									},
									{
										"formattedValue": "2A"
									},
									{
										"formattedValue": "Prep"
									},
									{},
									{
										"formattedValue": "Prep"
									},
									{},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "8:45-9:00"
									},
									{
										"formattedValue": "PW"
									},
									{
										"formattedValue": "PW 1C"
									},
									{
										"formattedValue": "1C"
									},
									{
										"formattedValue": "PW 2A"
									},
									{
										"formattedValue": "2A"
									},
									{
										"formattedValue": "Prep"
									},
									{},
									{
										"formattedValue": "Prep"
									},
									{},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "9:00-9:15"
									},
									{
										"formattedValue": "PW"
									},
									{
										"formattedValue": "PW 1A"
									},
									{
										"formattedValue": "1A"
									},
									{
										"formattedValue": "Prep"
									},
									{},
									{
										"formattedValue": "Prep"
									},
									{},
									{
										"formattedValue": "Prep"
									},
									{},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "9:15 - 9:30"
									},
									{
										"formattedValue": "PW"
									},
									{
										"formattedValue": "PW 1A"
									},
									{
										"formattedValue": "1A"
									},
									{
										"formattedValue": "Prep"
									},
									{},
									{
										"formattedValue": "Prep"
									},
									{},
									{
										"formattedValue": "Prep"
									},
									{},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "9:30-9:45"
									},
									{
										"formattedValue": "PW"
									},
									{
										"formattedValue": "Rec"
									},
									{},
									{
										"formattedValue": "Rec"
									},
									{},
									{
										"formattedValue": "Rec"
									},
									{},
									{
										"formattedValue": "Rec"
									},
									{},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "9:45-10:00"
									},
									{
										"formattedValue": "PW"
									},
									{
										"formattedValue": "Break"
									},
									{},
									{
										"formattedValue": "Break"
									},
									{},
									{
										"formattedValue": "Break"
									},
									{},
									{
										"formattedValue": "Break"
									},
									{},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "10:00 - 10:15"
									},
									{
										"formattedValue": "PW"
									},
									{
										"formattedValue": "Rec"
									},
									{},
									{
										"formattedValue": "Rec"
									},
									{},
									{
										"formattedValue": "Rec"
									},
									{},
									{
										"formattedValue": "Rec"
									},
									{},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "10:15 - 10:30"
									},
									{
										"formattedValue": "PW"
									},
									{
										"formattedValue": "Prep"
									},
									{},
									{
										"formattedValue": "PW 4A"
									},
									{
										"formattedValue": "4A"
									},
									{
										"formattedValue": "PW 5A"
									},
									{
										"formattedValue": "5A"
									},
									{
										"formattedValue": "Prep"
									},
									{},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "10:30 - 10:45"
									},
									{
										"formattedValue": "PW"
									},
									{
										"formattedValue": "PW KA"
									},
									{
										"formattedValue": "KA"
									},
									{
										"formattedValue": "PW 4A"
									},
									{
										"formattedValue": "4A"
									},
									{
										"formattedValue": "PW 5A"
									},
									{
										"formattedValue": "5A"
									},
									{
										"formattedValue": "Prep"
									},
									{},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "10:45 - 11:00"
									},
									{
										"formattedValue": "PW"
									},
									{
										"formattedValue": "PW KA"
									},
									{
										"formattedValue": "KA"
									},
									{
										"formattedValue": "Prep"
									},
									{},
									{
										"formattedValue": "Prep"
									},
									{},
									{
										"formattedValue": "Prep"
									},
									{},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "11:00 - 11:15"
									},
									{
										"formattedValue": "PW"
									},
									{
										"formattedValue": "Duty"
									},
									{},
									{
										"formattedValue": "Duty"
									},
									{},
									{
										"formattedValue": "Duty"
									},
									{},
									{
										"formattedValue": "Duty"
									},
									{},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "11:15 - 11:30"
									},
									{
										"formattedValue": "PW"
									},
									{
										"formattedValue": "Duty"
									},
									{},
									{
										"formattedValue": "Duty"
									},
									{},
									{
										"formattedValue": "Duty"
									},
									{},
									{
										"formattedValue": "Duty"
									},
									{},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "11:30 - 11:45"
									},
									{
										"formattedValue": "PW"
									},
									{
										"formattedValue": "Duty"
									},
									{},
									{
										"formattedValue": "Duty"
									},
									{},
									{
										"formattedValue": "Duty"
									},
									{},
									{
										"formattedValue": "Duty"
									},
									{},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "11:45 - 12:00"
									},
									{
										"formattedValue": "PW"
									},
									{
										"formattedValue": "Duty"
									},
									{},
									{
										"formattedValue": "Duty"
									},
									{},
									{
										"formattedValue": "Duty"
									},
									{},
									{
										"formattedValue": "Duty"
									},
									{},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "12:00 - 12:15"
									},
									{
										"formattedValue": "PW"
									},
									{
										"formattedValue": "Duty"
									},
									{},
									{
										"formattedValue": "Duty"
									},
									{},
									{
										"formattedValue": "Duty"
									},
									{},
									{
										"formattedValue": "Duty"
									},
									{},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "12:15 - 12:30"
									},
									{
										"formattedValue": "PW"
									},
									{
										"formattedValue": "Prep"
									},
									{},
									{
										"formattedValue": "Prep"
									},
									{},
									{
										"formattedValue": "Duty"
									},
									{},
									{
										"formattedValue": "Duty"
									},
									{},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "12:30-12:45"
									},
									{
										"formattedValue": "PW"
									},
									{
										"formattedValue": "Prep"
									},
									{},
									{
										"formattedValue": "Prep"
									},
									{},
									{
										"formattedValue": "Duty"
									},
									{},
									{
										"formattedValue": "Duty"
									},
									{},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "12:45-1:00"
									},
									{
										"formattedValue": "PW"
									},
									{
										"formattedValue": "Lunch"
									},
									{},
									{
										"formattedValue": "Lunch"
									},
									{},
									{
										"formattedValue": "Lunch"
									},
									{},
									{
										"formattedValue": "Lunch"
									},
									{},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "1:00 - 1:15"
									},
									{
										"formattedValue": "PW"
									},
									{
										"formattedValue": "Lunch"
									},
									{},
									{
										"formattedValue": "Lunch"
									},
									{},
									{
										"formattedValue": "Lunch"
									},
									{},
									{
										"formattedValue": "Lunch"
									},
									{},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "1:15 - 1:30"
									},
									{
										"formattedValue": "PW"
									},
									{
										"formattedValue": "Lunch"
									},
									{},
									{
										"formattedValue": "Lunch"
									},
									{},
									{
										"formattedValue": "Lunch"
									},
									{},
									{
										"formattedValue": "Lunch"
									},
									{},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "1:30 - 1:45"
									},
									{
										"formattedValue": "PW"
									},
									{
										"formattedValue": "PW KC"
									},
									{
										"formattedValue": "KC"
									},
									{
										"formattedValue": "PW 3A"
									},
									{
										"formattedValue": "3A"
									},
									{
										"formattedValue": "Lunch"
									},
									{},
									{
										"formattedValue": "Lunch"
									},
									{},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "1:45-2:00"
									},
									{
										"formattedValue": "PW"
									},
									{
										"formattedValue": "PW KC"
									},
									{
										"formattedValue": "KC"
									},
									{
										"formattedValue": "PW 3A"
									},
									{
										"formattedValue": "3A"
									},
									{
										"formattedValue": "Duty"
									},
									{},
									{
										"formattedValue": "PD"
									},
									{},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "7:45-8:00"
									},
									{
										"formattedValue": "Tech"
									},
									{
										"formattedValue": "Duty"
									},
									{},
									{
										"formattedValue": "Duty"
									},
									{},
									{
										"formattedValue": "Duty"
									},
									{},
									{
										"formattedValue": "Duty"
									},
									{},
									{
										"formattedValue": "Duty"
									},
									{}
								]
							},
							{
								"values": [
									{
										"formattedValue": "8:00-8:15"
									},
									{
										"formattedValue": "Tech"
									},
									{
										"formattedValue": "Prep"
									},
									{},
									{
										"formattedValue": "Prep"
									},
									{},
									{
										"formattedValue": "Prep"
									},
									{},
									{
										"formattedValue": "Prep"
									},
									{},
									{
										"formattedValue": "Prep"
									},
									{}
								]
							},
							{
								"values": [
									{
										"formattedValue": "8:15-8:30"
									},
									{
										"formattedValue": "Tech"
									},
									{
										"formattedValue": "Prep"
									},
									{},
									{
										"formattedValue": "Prep"
									},
									{},
									{
										"formattedValue": "Prep"
									},
									{},
									{
										"formattedValue": "Prep"
									},
									{},
									{
										"formattedValue": "Prep"
									},
									{}
								]
							},
							{
								"values": [
									{
										"formattedValue": "8:30 - 8:45"
									},
									{
										"formattedValue": "Tech"
									},
									{
										"formattedValue": "Prep"
									},
									{},
									{
										"formattedValue": "Specials 1B"
									},
									{
										"formattedValue": "1B"
									},
									{
										"formattedValue": "Specials 2B"
									},
									{
										"formattedValue": "2B"
									},
									{
										"formattedValue": "Specials 4B"
									},
									{
										"formattedValue": "4B"
									},
									{
										"formattedValue": "Prep"
									},
									{}
								]
							},
							{
								"values": [
									{
										"formattedValue": "8:45-9:00"
									},
									{
										"formattedValue": "Tech"
									},
									{
										"formattedValue": "Prep"
									},
									{},
									{
										"formattedValue": "Specials 1B"
									},
									{
										"formattedValue": "1B"
									},
									{
										"formattedValue": "Specials 2B"
									},
									{
										"formattedValue": "2B"
									},
									{
										"formattedValue": "Specials 4B"
									},
									{
										"formattedValue": "4B"
									},
									{
										"formattedValue": "Prep"
									},
									{}
								]
							},
							{
								"values": [
									{
										"formattedValue": "9:00-9:15"
									},
									{
										"formattedValue": "Tech"
									},
									{
										"formattedValue": "Prep"
									},
									{},
									{
										"formattedValue": "Specials 1B"
									},
									{
										"formattedValue": "1B"
									},
									{
										"formattedValue": "Specials 2B"
									},
									{
										"formattedValue": "2B"
									},
									{
										"formattedValue": "Specials 4B"
									},
									{
										"formattedValue": "4B"
									},
									{
										"formattedValue": "Prep"
									},
									{}
								]
							},
							{
								"values": [
									{
										"formattedValue": "9:15 - 9:30"
									},
									{
										"formattedValue": "Tech"
									},
									{
										"formattedValue": "Prep"
									},
									{},
									{
										"formattedValue": "Specials 1B"
									},
									{
										"formattedValue": "1B"
									},
									{
										"formattedValue": "Specials 2B"
									},
									{
										"formattedValue": "2B"
									},
									{
										"formattedValue": "Specials 4B"
									},
									{
										"formattedValue": "4B"
									},
									{
										"formattedValue": "Prep"
									},
									{}
								]
							},
							{
								"values": [
									{
										"formattedValue": "9:30-9:45"
									},
									{
										"formattedValue": "Tech"
									},
									{
										"formattedValue": "Prep"
									},
									{},
									{
										"formattedValue": "Rec"
									},
									{},
									{
										"formattedValue": "Rec"
									},
									{},
									{
										"formattedValue": "Specials 4B"
									},
									{
										"formattedValue": "4B"
									},
									{
										"formattedValue": "Prep"
									},
									{}
								]
							},
							{
								"values": [
									{
										"formattedValue": "9:45-10:00"
									},
									{
										"formattedValue": "Tech"
									},
									{
										"formattedValue": "Prep"
									},
									{},
									{
										"formattedValue": "Specials 1B"
									},
									{
										"formattedValue": "1B"
									},
									{
										"formattedValue": "Specials 2B"
									},
									{
										"formattedValue": "2B"
									},
									{
										"formattedValue": "Specials 4B"
									},
									{
										"formattedValue": "4B"
									},
									{
										"formattedValue": "Prep"
									},
									{}
								]
							},
							{
								"values": [
									{
										"formattedValue": "10:00 - 10:15"
									},
									{
										"formattedValue": "Tech"
									},
									{
										"formattedValue": "Prep"
									},
									{},
									{
										"formattedValue": "Specials 1B"
									},
									{
										"formattedValue": "1B"
									},
									{
										"formattedValue": "Specials 2B"
									},
									{
										"formattedValue": "2B"
									},
									{
										"formattedValue": "Rec"
									},
									{},
									{
										"formattedValue": "Prep"
									},
									{}
								]
							},
							{
								"values": [
									{
										"formattedValue": "10:15 - 10:30"
									},
									{
										"formattedValue": "Tech"
									},
									{
										"formattedValue": "Prep"
									},
									{},
									{
										"formattedValue": "Specials 1B"
									},
									{
										"formattedValue": "1B"
									},
									{
										"formattedValue": "Specials 2B"
									},
									{
										"formattedValue": "2B"
									},
									{
										"formattedValue": "Specials 4B"
									},
									{
										"formattedValue": "4B"
									},
									{
										"formattedValue": "Prep"
									},
									{}
								]
							},
							{
								"values": [
									{
										"formattedValue": "10:30 - 10:45"
									},
									{
										"formattedValue": "Tech"
									},
									{
										"formattedValue": "Prep"
									},
									{},
									{
										"formattedValue": "COTEACH KB"
									},
									{
										"formattedValue": "KB"
									},
									{
										"formattedValue": "prep"
									},
									{},
									{
										"formattedValue": "COTEACH 1B"
									},
									{
										"formattedValue": "1B"
									},
									{
										"formattedValue": "Prep"
									},
									{}
								]
							},
							{
								"values": [
									{
										"formattedValue": "10:45 - 11:00"
									},
									{
										"formattedValue": "Tech"
									},
									{
										"formattedValue": "Prep"
									},
									{},
									{
										"formattedValue": "COTEACH KB"
									},
									{
										"formattedValue": "KB"
									},
									{
										"formattedValue": "COTEACH 3B"
									},
									{
										"formattedValue": "3B"
									},
									{
										"formattedValue": "COTEACH 1B"
									},
									{
										"formattedValue": "1B"
									},
									{
										"formattedValue": "Prep"
									},
									{}
								]
							},
							{
								"values": [
									{
										"formattedValue": "11:00 - 11:15"
									},
									{
										"formattedValue": "Tech"
									},
									{
										"formattedValue": "Lunch"
									},
									{},
									{
										"formattedValue": "Lunch"
									},
									{},
									{
										"formattedValue": "COTEACH 3B"
									},
									{
										"formattedValue": "3B"
									},
									{
										"formattedValue": "COTEACH 1B"
									},
									{
										"formattedValue": "1B"
									},
									{
										"formattedValue": "Lunch"
									},
									{}
								]
							},
							{
								"values": [
									{
										"formattedValue": "11:15 - 11:30"
									},
									{
										"formattedValue": "Tech"
									},
									{
										"formattedValue": "Lunch"
									},
									{},
									{
										"formattedValue": "Lunch"
									},
									{},
									{
										"formattedValue": "COTEACH 3B"
									},
									{
										"formattedValue": "3B"
									},
									{
										"formattedValue": "COTEACH 1B"
									},
									{
										"formattedValue": "4B"
									},
									{
										"formattedValue": "Lunch"
									},
									{}
								]
							},
							{
								"values": [
									{
										"formattedValue": "11:30 - 11:45"
									},
									{
										"formattedValue": "Tech"
									},
									{
										"formattedValue": "Lunch"
									},
									{},
									{
										"formattedValue": "Lunch"
									},
									{},
									{
										"formattedValue": "Lunch"
									},
									{},
									{
										"formattedValue": "COTEACH 1B"
									},
									{
										"formattedValue": "4B"
									},
									{
										"formattedValue": "Lunch"
									},
									{}
								]
							},
							{
								"values": [
									{
										"formattedValue": "11:45 - 12:00"
									},
									{
										"formattedValue": "Tech"
									},
									{
										"formattedValue": "Prep"
									},
									{},
									{
										"formattedValue": "COTEACH KB"
									},
									{
										"formattedValue": "KB"
									},
									{
										"formattedValue": "Lunch"
									},
									{},
									{
										"formattedValue": "COTEACH 1B"
									},
									{
										"formattedValue": "4B"
									},
									{
										"formattedValue": "Prep"
									},
									{}
								]
							},
							{
								"values": [
									{
										"formattedValue": "12:00 - 12:15"
									},
									{
										"formattedValue": "Tech"
									},
									{
										"formattedValue": "Prep"
									},
									{},
									{
										"formattedValue": "COTEACH KB"
									},
									{
										"formattedValue": "KB"
									},
									{
										"formattedValue": "Lunch"
									},
									{},
									{
										"formattedValue": "Lunch"
									},
									{},
									{
										"formattedValue": "Prep"
									},
									{}
								]
							},
							{
								"values": [
									{
										"formattedValue": "12:15 - 12:30"
									},
									{
										"formattedValue": "Tech"
									},
									{
										"formattedValue": "Prep"
									},
									{},
									{
										"formattedValue": "COTEACH KB"
									},
									{
										"formattedValue": "KB"
									},
									{
										"formattedValue": "Specials 3B"
									},
									{
										"formattedValue": "3B"
									},
									{
										"formattedValue": "Lunch"
									},
									{},
									{
										"formattedValue": "Prep"
									},
									{}
								]
							},
							{
								"values": [
									{
										"formattedValue": "12:30-12:45"
									},
									{
										"formattedValue": "Tech"
									},
									{
										"formattedValue": "Prep"
									},
									{},
									{
										"formattedValue": "COTEACH KB"
									},
									{
										"formattedValue": "KB"
									},
									{
										"formattedValue": "Specials 3B"
									},
									{
										"formattedValue": "3B"
									},
									{
										"formattedValue": "Lunch"
									},
									{},
									{
										"formattedValue": "Prep"
									},
									{}
								]
							},
							{
								"values": [
									{
										"formattedValue": "12:45-1:00"
									},
									{
										"formattedValue": "Tech"
									},
									{
										"formattedValue": "Prep"
									},
									{},
									{
										"formattedValue": "COTEACH KB"
									},
									{
										"formattedValue": "KB"
									},
									{
										"formattedValue": "Specials 3B"
									},
									{
										"formattedValue": "3B"
									},
									{
										"formattedValue": "PD"
									},
									{},
									{
										"formattedValue": "Prep"
									},
									{}
								]
							},
							{
								"values": [
									{
										"formattedValue": "1:00 - 1:15"
									},
									{
										"formattedValue": "Tech"
									},
									{
										"formattedValue": "Prep"
									},
									{},
									{
										"formattedValue": "COTEACH KB"
									},
									{
										"formattedValue": "KB"
									},
									{
										"formattedValue": "Specials 3B"
									},
									{
										"formattedValue": "3B"
									},
									{
										"formattedValue": "PD"
									},
									{},
									{
										"formattedValue": "Prep"
									},
									{}
								]
							},
							{
								"values": [
									{
										"formattedValue": "1:15 - 1:30"
									},
									{
										"formattedValue": "Tech"
									},
									{
										"formattedValue": "Prep"
									},
									{},
									{
										"formattedValue": "COTEACH KB"
									},
									{
										"formattedValue": "KB"
									},
									{
										"formattedValue": "Specials 3B"
									},
									{
										"formattedValue": "3B"
									},
									{
										"formattedValue": "PD"
									},
									{},
									{
										"formattedValue": "Prep"
									},
									{}
								]
							},
							{
								"values": [
									{
										"formattedValue": "1:30 - 1:45"
									},
									{
										"formattedValue": "Tech"
									},
									{
										"formattedValue": "Prep"
									},
									{},
									{
										"formattedValue": "COTEACH KB"
									},
									{
										"formattedValue": "KB"
									},
									{
										"formattedValue": "Specials 3B"
									},
									{
										"formattedValue": "3B"
									},
									{
										"formattedValue": "PD"
									},
									{},
									{
										"formattedValue": "Prep"
									},
									{}
								]
							},
							{
								"values": [
									{
										"formattedValue": "1:45-2:00"
									},
									{
										"formattedValue": "Tech"
									},
									{
										"formattedValue": "Prep"
									},
									{},
									{
										"formattedValue": "COTEACH KB"
									},
									{
										"formattedValue": "KB"
									},
									{
										"formattedValue": "Specials 3B"
									},
									{
										"formattedValue": "3B"
									},
									{
										"formattedValue": "PD"
									},
									{},
									{
										"formattedValue": "Prep"
									},
									{}
								]
							},
							{
								"values": [
									{
										"formattedValue": "7:45-8:00"
									},
									{
										"formattedValue": "Lib"
									},
									{
										"formattedValue": "Duty"
									},
									{},
									{
										"formattedValue": "Duty"
									},
									{},
									{
										"formattedValue": "Duty"
									},
									{},
									{
										"formattedValue": "Duty"
									},
									{},
									{
										"formattedValue": "Duty"
									},
									{}
								]
							},
							{
								"values": [
									{
										"formattedValue": "8:00-8:15"
									},
									{
										"formattedValue": "Lib"
									},
									{
										"formattedValue": "Prep"
									},
									{},
									{
										"formattedValue": "Prep"
									},
									{},
									{
										"formattedValue": "Prep"
									},
									{},
									{
										"formattedValue": "Prep"
									},
									{},
									{
										"formattedValue": "Prep"
									},
									{}
								]
							},
							{
								"values": [
									{
										"formattedValue": "8:15-8:30"
									},
									{
										"formattedValue": "Lib"
									},
									{
										"formattedValue": "Prep"
									},
									{},
									{
										"formattedValue": "Prep"
									},
									{},
									{
										"formattedValue": "Prep"
									},
									{},
									{
										"formattedValue": "Prep"
									},
									{},
									{
										"formattedValue": "Prep"
									},
									{}
								]
							},
							{
								"values": [
									{
										"formattedValue": "8:30 - 8:45"
									},
									{
										"formattedValue": "Lib"
									},
									{
										"formattedValue": "Prep"
									},
									{},
									{
										"formattedValue": "Specials 1A"
									},
									{
										"formattedValue": "1A"
									},
									{
										"formattedValue": "Specials 2A"
									},
									{
										"formattedValue": "2A"
									},
									{
										"formattedValue": "Specials 4A"
									},
									{
										"formattedValue": "4A"
									},
									{
										"formattedValue": "Prep"
									},
									{}
								]
							},
							{
								"values": [
									{
										"formattedValue": "8:45-9:00"
									},
									{
										"formattedValue": "Lib"
									},
									{
										"formattedValue": "Prep"
									},
									{},
									{
										"formattedValue": "Specials 1A"
									},
									{
										"formattedValue": "1A"
									},
									{
										"formattedValue": "Specials 2A"
									},
									{
										"formattedValue": "2A"
									},
									{
										"formattedValue": "Specials 4A"
									},
									{
										"formattedValue": "4A"
									},
									{
										"formattedValue": "Prep"
									},
									{}
								]
							},
							{
								"values": [
									{
										"formattedValue": "9:00-9:15"
									},
									{
										"formattedValue": "Lib"
									},
									{
										"formattedValue": "Prep"
									},
									{},
									{
										"formattedValue": "Specials 1A"
									},
									{
										"formattedValue": "1A"
									},
									{
										"formattedValue": "Specials 2A"
									},
									{
										"formattedValue": "2A"
									},
									{
										"formattedValue": "Specials 4A"
									},
									{
										"formattedValue": "4A"
									},
									{
										"formattedValue": "Prep"
									},
									{}
								]
							},
							{
								"values": [
									{
										"formattedValue": "9:15 - 9:30"
									},
									{
										"formattedValue": "Lib"
									},
									{
										"formattedValue": "Prep"
									},
									{},
									{
										"formattedValue": "Specials 1A"
									},
									{
										"formattedValue": "1A"
									},
									{
										"formattedValue": "Specials 2A"
									},
									{
										"formattedValue": "2A"
									},
									{
										"formattedValue": "Specials 4A"
									},
									{
										"formattedValue": "4A"
									},
									{
										"formattedValue": "Prep"
									},
									{}
								]
							},
							{
								"values": [
									{
										"formattedValue": "9:30-9:45"
									},
									{
										"formattedValue": "Lib"
									},
									{
										"formattedValue": "Prep"
									},
									{},
									{
										"formattedValue": "Rec"
									},
									{},
									{
										"formattedValue": "Rec"
									},
									{},
									{
										"formattedValue": "Specials 4A"
									},
									{
										"formattedValue": "4A"
									},
									{
										"formattedValue": "Prep"
									},
									{}
								]
							},
							{
								"values": [
									{
										"formattedValue": "9:45-10:00"
									},
									{
										"formattedValue": "Lib"
									},
									{
										"formattedValue": "Prep"
									},
									{},
									{
										"formattedValue": "Specials 1A"
									},
									{
										"formattedValue": "1A"
									},
									{
										"formattedValue": "Specials 2A"
									},
									{
										"formattedValue": "2A"
									},
									{
										"formattedValue": "Specials 4A"
									},
									{
										"formattedValue": "4A"
									},
									{
										"formattedValue": "Prep"
									},
									{}
								]
							},
							{
								"values": [
									{
										"formattedValue": "10:00 - 10:15"
									},
									{
										"formattedValue": "Lib"
									},
									{
										"formattedValue": "Prep"
									},
									{},
									{
										"formattedValue": "Specials 1A"
									},
									{
										"formattedValue": "1A"
									},
									{
										"formattedValue": "Specials 2A"
									},
									{
										"formattedValue": "2A"
									},
									{
										"formattedValue": "Rec"
									},
									{},
									{
										"formattedValue": "Prep"
									},
									{}
								]
							},
							{
								"values": [
									{
										"formattedValue": "10:15 - 10:30"
									},
									{
										"formattedValue": "Lib"
									},
									{
										"formattedValue": "Prep"
									},
									{},
									{
										"formattedValue": "Specials 1A"
									},
									{
										"formattedValue": "1A"
									},
									{
										"formattedValue": "Specials 2A"
									},
									{
										"formattedValue": "2A"
									},
									{
										"formattedValue": "Specials 4A"
									},
									{
										"formattedValue": "4A"
									},
									{
										"formattedValue": "Prep"
									},
									{}
								]
							},
							{
								"values": [
									{
										"formattedValue": "10:30 - 10:45"
									},
									{
										"formattedValue": "Lib"
									},
									{
										"formattedValue": "Prep"
									},
									{},
									{
										"formattedValue": "COTEACH KA"
									},
									{
										"formattedValue": "KA"
									},
									{
										"formattedValue": "Prep"
									},
									{},
									{
										"formattedValue": "COTEACH 1A"
									},
									{
										"formattedValue": "1A"
									},
									{
										"formattedValue": "Prep"
									},
									{}
								]
							},
							{
								"values": [
									{
										"formattedValue": "10:45 - 11:00"
									},
									{
										"formattedValue": "Lib"
									},
									{
										"formattedValue": "Prep"
									},
									{},
									{
										"formattedValue": "COTEACH KA"
									},
									{
										"formattedValue": "KA"
									},
									{
										"formattedValue": "COTEACH 3A"
									},
									{
										"formattedValue": "3A"
									},
									{
										"formattedValue": "COTEACH 1A"
									},
									{
										"formattedValue": "1A"
									},
									{
										"formattedValue": "Prep"
									},
									{}
								]
							},
							{
								"values": [
									{
										"formattedValue": "11:00 - 11:15"
									},
									{
										"formattedValue": "Lib"
									},
									{
										"formattedValue": "Lunch"
									},
									{},
									{
										"formattedValue": "Lunch"
									},
									{},
									{
										"formattedValue": "COTEACH 3A"
									},
									{
										"formattedValue": "3A"
									},
									{
										"formattedValue": "COTEACH 1A"
									},
									{
										"formattedValue": "1A"
									},
									{
										"formattedValue": "Prep"
									},
									{}
								]
							},
							{
								"values": [
									{
										"formattedValue": "11:15 - 11:30"
									},
									{
										"formattedValue": "Lib"
									},
									{
										"formattedValue": "Lunch"
									},
									{},
									{
										"formattedValue": "Lunch"
									},
									{},
									{
										"formattedValue": "COTEACH 3A"
									},
									{
										"formattedValue": "3A"
									},
									{
										"formattedValue": "COTEACH 1A"
									},
									{
										"formattedValue": "4A"
									},
									{
										"formattedValue": "Lunch"
									},
									{}
								]
							},
							{
								"values": [
									{
										"formattedValue": "11:30 - 11:45"
									},
									{
										"formattedValue": "Lib"
									},
									{
										"formattedValue": "Lunch"
									},
									{},
									{
										"formattedValue": "Lunch"
									},
									{},
									{
										"formattedValue": "Lunch"
									},
									{},
									{
										"formattedValue": "COTEACH 1A"
									},
									{
										"formattedValue": "4A"
									},
									{
										"formattedValue": "Lunch"
									},
									{}
								]
							},
							{
								"values": [
									{
										"formattedValue": "11:45 - 12:00"
									},
									{
										"formattedValue": "Lib"
									},
									{
										"formattedValue": "Prep"
									},
									{},
									{
										"formattedValue": "COTEACH KA"
									},
									{
										"formattedValue": "KA"
									},
									{
										"formattedValue": "Lunch"
									},
									{},
									{
										"formattedValue": "COTEACH 1A"
									},
									{
										"formattedValue": "4A"
									},
									{
										"formattedValue": "Lunch"
									},
									{}
								]
							},
							{
								"values": [
									{
										"formattedValue": "12:00 - 12:15"
									},
									{
										"formattedValue": "Lib"
									},
									{
										"formattedValue": "Prep"
									},
									{},
									{
										"formattedValue": "COTEACH KA"
									},
									{
										"formattedValue": "KA"
									},
									{
										"formattedValue": "Lunch"
									},
									{},
									{
										"formattedValue": "Lunch"
									},
									{},
									{
										"formattedValue": "Prep"
									},
									{}
								]
							},
							{
								"values": [
									{
										"formattedValue": "12:15 - 12:30"
									},
									{
										"formattedValue": "Lib"
									},
									{
										"formattedValue": "Prep"
									},
									{},
									{
										"formattedValue": "Specials KA"
									},
									{
										"formattedValue": "KA"
									},
									{
										"formattedValue": "Specials 3A"
									},
									{
										"formattedValue": "3A"
									},
									{
										"formattedValue": "Lunch"
									},
									{},
									{
										"formattedValue": "Prep"
									},
									{}
								]
							},
							{
								"values": [
									{
										"formattedValue": "12:30-12:45"
									},
									{
										"formattedValue": "Lib"
									},
									{
										"formattedValue": "Prep"
									},
									{},
									{
										"formattedValue": "Specials KA"
									},
									{
										"formattedValue": "KA"
									},
									{
										"formattedValue": "Specials 3A"
									},
									{
										"formattedValue": "3A"
									},
									{
										"formattedValue": "Lunch"
									},
									{},
									{
										"formattedValue": "Prep"
									},
									{}
								]
							},
							{
								"values": [
									{
										"formattedValue": "12:45-1:00"
									},
									{
										"formattedValue": "Lib"
									},
									{
										"formattedValue": "Prep"
									},
									{},
									{
										"formattedValue": "Specials KA"
									},
									{
										"formattedValue": "KA"
									},
									{
										"formattedValue": "Specials 3A"
									},
									{
										"formattedValue": "3A"
									},
									{
										"formattedValue": "PD"
									},
									{},
									{
										"formattedValue": "Prep"
									},
									{}
								]
							},
							{
								"values": [
									{
										"formattedValue": "1:00 - 1:15"
									},
									{
										"formattedValue": "Lib"
									},
									{
										"formattedValue": "Prep"
									},
									{},
									{
										"formattedValue": "Specials KA"
									},
									{
										"formattedValue": "KA"
									},
									{
										"formattedValue": "COTEACH 2A"
									},
									{
										"formattedValue": "2A"
									},
									{
										"formattedValue": "PD"
									},
									{},
									{
										"formattedValue": "Prep"
									},
									{}
								]
							},
							{
								"values": [
									{
										"formattedValue": "1:15 - 1:30"
									},
									{
										"formattedValue": "Lib"
									},
									{
										"formattedValue": "Prep"
									},
									{},
									{
										"formattedValue": "Specials KA"
									},
									{
										"formattedValue": "KA"
									},
									{
										"formattedValue": "COTEACH 2A"
									},
									{
										"formattedValue": "2A"
									},
									{
										"formattedValue": "PD"
									},
									{},
									{
										"formattedValue": "Prep"
									},
									{}
								]
							},
							{
								"values": [
									{
										"formattedValue": "1:30 - 1:45"
									},
									{
										"formattedValue": "Lib"
									},
									{
										"formattedValue": "Prep"
									},
									{},
									{
										"formattedValue": "Specials KA"
									},
									{
										"formattedValue": "KA"
									},
									{
										"formattedValue": "COTEACH 2A"
									},
									{
										"formattedValue": "2A"
									},
									{
										"formattedValue": "PD"
									},
									{},
									{
										"formattedValue": "Prep"
									},
									{}
								]
							},
							{
								"values": [
									{
										"formattedValue": "1:45-2:00"
									},
									{
										"formattedValue": "Lib"
									},
									{
										"formattedValue": "Prep"
									},
									{},
									{
										"formattedValue": "Specials KA"
									},
									{
										"formattedValue": "KA"
									},
									{
										"formattedValue": "COTEACH 2A"
									},
									{
										"formattedValue": "2A"
									},
									{
										"formattedValue": "PD"
									},
									{},
									{
										"formattedValue": "Prep"
									},
									{}
								]
							},
							{
								"values": [
									{
										"formattedValue": "7:45-8:00"
									},
									{
										"formattedValue": "G"
									},
									{
										"formattedValue": "Duty"
									},
									{},
									{
										"formattedValue": "Duty"
									},
									{},
									{
										"formattedValue": "Duty"
									},
									{},
									{
										"formattedValue": "Duty"
									},
									{},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "8:00-8:15"
									},
									{
										"formattedValue": "G"
									},
									{
										"formattedValue": "Prep"
									},
									{},
									{
										"formattedValue": "Prep"
									},
									{},
									{
										"formattedValue": "Prep"
									},
									{},
									{
										"formattedValue": "Prep"
									},
									{},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "8:15-8:30"
									},
									{
										"formattedValue": "G"
									},
									{
										"formattedValue": "Prep"
									},
									{},
									{
										"formattedValue": "Prep"
									},
									{},
									{
										"formattedValue": "Prep"
									},
									{},
									{
										"formattedValue": "Prep"
									},
									{},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "8:30 - 8:45"
									},
									{
										"formattedValue": "G"
									},
									{
										"formattedValue": "G 1B"
									},
									{
										"formattedValue": "1B"
									},
									{
										"formattedValue": "G 2A"
									},
									{
										"formattedValue": "2A"
									},
									{
										"formattedValue": "Prep"
									},
									{},
									{
										"formattedValue": "Prep"
									},
									{},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "8:45-9:00"
									},
									{
										"formattedValue": "G"
									},
									{
										"formattedValue": "G 1B"
									},
									{
										"formattedValue": "1B"
									},
									{
										"formattedValue": "G 2A"
									},
									{
										"formattedValue": "2A"
									},
									{
										"formattedValue": "Prep"
									},
									{},
									{
										"formattedValue": "Prep"
									},
									{},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "9:00-9:15"
									},
									{
										"formattedValue": "G"
									},
									{
										"formattedValue": "prep"
									},
									{},
									{
										"formattedValue": "Prep"
									},
									{},
									{
										"formattedValue": "Prep"
									},
									{},
									{
										"formattedValue": "Prep"
									},
									{},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "9:15 - 9:30"
									},
									{
										"formattedValue": "G"
									},
									{
										"formattedValue": "prep"
									},
									{},
									{
										"formattedValue": "Prep"
									},
									{},
									{
										"formattedValue": "Prep"
									},
									{},
									{
										"formattedValue": "Prep"
									},
									{},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "9:30-9:45"
									},
									{
										"formattedValue": "G"
									},
									{
										"formattedValue": "Rec"
									},
									{},
									{
										"formattedValue": "Rec"
									},
									{},
									{
										"formattedValue": "Rec"
									},
									{},
									{
										"formattedValue": "Rec"
									},
									{},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "9:45-10:00"
									},
									{
										"formattedValue": "G"
									},
									{
										"formattedValue": "Break"
									},
									{},
									{
										"formattedValue": "Break"
									},
									{},
									{
										"formattedValue": "Break"
									},
									{},
									{
										"formattedValue": "Break"
									},
									{},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "10:00 - 10:15"
									},
									{
										"formattedValue": "G"
									},
									{
										"formattedValue": "Rec"
									},
									{},
									{
										"formattedValue": "Rec"
									},
									{},
									{
										"formattedValue": "Rec"
									},
									{},
									{
										"formattedValue": "Rec"
									},
									{},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "10:15 - 10:30"
									},
									{
										"formattedValue": "G"
									},
									{
										"formattedValue": "Prep"
									},
									{},
									{
										"formattedValue": "G 4B"
									},
									{
										"formattedValue": "4B"
									},
									{
										"formattedValue": "G 5A"
									},
									{
										"formattedValue": "5A"
									},
									{
										"formattedValue": "Prep"
									},
									{},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "10:30 - 10:45"
									},
									{
										"formattedValue": "G"
									},
									{
										"formattedValue": "G KA"
									},
									{
										"formattedValue": "KA"
									},
									{
										"formattedValue": "G 4B"
									},
									{
										"formattedValue": "4B"
									},
									{
										"formattedValue": "G 5A"
									},
									{
										"formattedValue": "5A"
									},
									{
										"formattedValue": "Prep"
									},
									{},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "10:45 - 11:00"
									},
									{
										"formattedValue": "G"
									},
									{
										"formattedValue": "G KA"
									},
									{
										"formattedValue": "KA"
									},
									{
										"formattedValue": "Prep"
									},
									{},
									{
										"formattedValue": "Prep"
									},
									{},
									{
										"formattedValue": "Prep"
									},
									{},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "11:00 - 11:15"
									},
									{
										"formattedValue": "G"
									},
									{
										"formattedValue": "Duty"
									},
									{},
									{
										"formattedValue": "Duty"
									},
									{},
									{
										"formattedValue": "Duty"
									},
									{},
									{
										"formattedValue": "Duty"
									},
									{},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "11:15 - 11:30"
									},
									{
										"formattedValue": "G"
									},
									{
										"formattedValue": "Duty"
									},
									{},
									{
										"formattedValue": "Duty"
									},
									{},
									{
										"formattedValue": "Duty"
									},
									{},
									{
										"formattedValue": "Duty"
									},
									{},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "11:30 - 11:45"
									},
									{
										"formattedValue": "G"
									},
									{
										"formattedValue": "Duty"
									},
									{},
									{
										"formattedValue": "Duty"
									},
									{},
									{
										"formattedValue": "Duty"
									},
									{},
									{
										"formattedValue": "Duty"
									},
									{},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "11:45 - 12:00"
									},
									{
										"formattedValue": "G"
									},
									{
										"formattedValue": "Duty"
									},
									{},
									{
										"formattedValue": "Duty"
									},
									{},
									{
										"formattedValue": "Duty"
									},
									{},
									{
										"formattedValue": "Duty"
									},
									{},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "12:00 - 12:15"
									},
									{
										"formattedValue": "G"
									},
									{
										"formattedValue": "Duty"
									},
									{},
									{
										"formattedValue": "Duty"
									},
									{},
									{
										"formattedValue": "Duty"
									},
									{},
									{
										"formattedValue": "Duty"
									},
									{},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "12:15 - 12:30"
									},
									{
										"formattedValue": "G"
									},
									{
										"formattedValue": "Prep"
									},
									{},
									{
										"formattedValue": "prep"
									},
									{},
									{
										"formattedValue": "Duty"
									},
									{},
									{
										"formattedValue": "Duty"
									},
									{},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "12:30-12:45"
									},
									{
										"formattedValue": "G"
									},
									{
										"formattedValue": "Prep"
									},
									{},
									{
										"formattedValue": "prep"
									},
									{},
									{
										"formattedValue": "Duty"
									},
									{},
									{
										"formattedValue": "Duty"
									},
									{},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "12:45-1:00"
									},
									{
										"formattedValue": "G"
									},
									{
										"formattedValue": "Lunch"
									},
									{},
									{
										"formattedValue": "Lunch"
									},
									{},
									{
										"formattedValue": "Lunch"
									},
									{},
									{
										"formattedValue": "Lunch"
									},
									{},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "1:00 - 1:15"
									},
									{
										"formattedValue": "G"
									},
									{
										"formattedValue": "Lunch"
									},
									{},
									{
										"formattedValue": "Lunch"
									},
									{},
									{
										"formattedValue": "Lunch"
									},
									{},
									{
										"formattedValue": "Lunch"
									},
									{},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "1:15 - 1:30"
									},
									{
										"formattedValue": "G"
									},
									{
										"formattedValue": "Lunch"
									},
									{},
									{
										"formattedValue": "Lunch"
									},
									{},
									{
										"formattedValue": "Lunch"
									},
									{},
									{
										"formattedValue": "Lunch"
									},
									{},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "1:30 - 1:45"
									},
									{
										"formattedValue": "G"
									},
									{
										"formattedValue": "G KB"
									},
									{
										"formattedValue": "KB"
									},
									{
										"formattedValue": "G 3B"
									},
									{
										"formattedValue": "3B"
									},
									{
										"formattedValue": "Lunch"
									},
									{},
									{
										"formattedValue": "Lunch"
									},
									{},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "1:45-2:00"
									},
									{
										"formattedValue": "G"
									},
									{
										"formattedValue": "G KB"
									},
									{
										"formattedValue": "KB"
									},
									{
										"formattedValue": "G 3B"
									},
									{
										"formattedValue": "3B"
									},
									{
										"formattedValue": "Duty"
									},
									{},
									{
										"formattedValue": "PD"
									},
									{},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									}
								]
							}
						]
					}
				]
			},
			{
				"properties": {
					"sheetId": 1558634518,
					"title": "Teachers",
					"index": 1,
					"sheetType": "GRID",
					"gridProperties": {
						"rowCount": 1000,
						"columnCount": 27
					}
				},
				"data": [
					{
						"rowData": [
							{
								"values": [
									{
										"formattedValue": "id"
									},
									{
										"formattedValue": "name"
									},
									{
										"formattedValue": "group"
									},
									{
										"formattedValue": "group_id"
									},
									{
										"formattedValue": "tags"
									},
									{
										"formattedValue": "fte"
									},
									{
										"formattedValue": "prep_teachers"
									},
									{
										"formattedValue": "release_teachers"
									},
									{
										"formattedValue": "unavailable"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "KA"
									},
									{
										"formattedValue": "Kinder A"
									},
									{
										"formattedValue": "Classroom"
									},
									{
										"formattedValue": "1"
									},
									{
										"formattedValue": "Kindergarten"
									},
									{
										"formattedValue": "TRUE"
									},
									{
										"formattedValue": "KA,KB,KC"
									},
									{
										"formattedValue": "V,Sci,Tech,Lib"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "PE"
									},
									{
										"formattedValue": "PE"
									},
									{
										"formattedValue": "Specials"
									},
									{
										"formattedValue": "3"
									},
									{},
									{
										"formattedValue": "FALSE"
									},
									{},
									{},
									{
										"formattedValue": "Thursday"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "KB"
									},
									{
										"formattedValue": "Kinder B"
									},
									{
										"formattedValue": "Classroom"
									},
									{
										"formattedValue": "1"
									},
									{
										"formattedValue": "Kindergarten"
									},
									{
										"formattedValue": "TRUE"
									},
									{
										"formattedValue": "KA,KB,KC"
									},
									{
										"formattedValue": "V,Sci,Tech,Lib"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "KC"
									},
									{
										"formattedValue": "Kinder C"
									},
									{
										"formattedValue": "Classroom"
									},
									{
										"formattedValue": "1"
									},
									{
										"formattedValue": "Kindergarten"
									},
									{
										"formattedValue": "TRUE"
									},
									{
										"formattedValue": "KA,KB,KC"
									},
									{
										"formattedValue": "V,Sci,Tech,Lib"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "1A"
									},
									{
										"formattedValue": "1st A"
									},
									{
										"formattedValue": "Classroom"
									},
									{
										"formattedValue": "1"
									},
									{
										"formattedValue": "1st grade"
									},
									{
										"formattedValue": "TRUE"
									},
									{
										"formattedValue": "1A,1B,1C"
									},
									{
										"formattedValue": "V,Sci,Tech,Lib"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "V"
									},
									{
										"formattedValue": "VAPA"
									},
									{
										"formattedValue": "Specials"
									},
									{
										"formattedValue": "3"
									},
									{},
									{
										"formattedValue": "FALSE"
									},
									{},
									{},
									{
										"formattedValue": "Wednesday,Thursday,Friday"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "Sci"
									},
									{
										"formattedValue": "Science"
									},
									{
										"formattedValue": "Enrichment"
									},
									{
										"formattedValue": "2"
									},
									{},
									{
										"formattedValue": "TRUE"
									},
									{},
									{},
									{
										"formattedValue": "Monday,Friday"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "1B"
									},
									{
										"formattedValue": "1st B"
									},
									{
										"formattedValue": "Classroom"
									},
									{
										"formattedValue": "1"
									},
									{
										"formattedValue": "1st grade"
									},
									{
										"formattedValue": "TRUE"
									},
									{
										"formattedValue": "1A,1B,1C"
									},
									{
										"formattedValue": "V,Sci,Tech,Lib"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "G"
									},
									{
										"formattedValue": "Garden"
									},
									{
										"formattedValue": "Specials"
									},
									{
										"formattedValue": "3"
									},
									{},
									{
										"formattedValue": "FALSE"
									},
									{},
									{},
									{
										"formattedValue": "Friday"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "PW"
									},
									{
										"formattedValue": "Playworks"
									},
									{
										"formattedValue": "Specials"
									},
									{
										"formattedValue": "3"
									},
									{},
									{
										"formattedValue": "FALSE"
									},
									{},
									{},
									{
										"formattedValue": "Friday"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "Tech"
									},
									{
										"formattedValue": "Technology"
									},
									{
										"formattedValue": "Enrichment"
									},
									{
										"formattedValue": "2"
									},
									{},
									{
										"formattedValue": "TRUE"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "1C"
									},
									{
										"formattedValue": "1st C"
									},
									{
										"formattedValue": "Classroom"
									},
									{
										"formattedValue": "1"
									},
									{
										"formattedValue": "1st grade"
									},
									{
										"formattedValue": "TRUE"
									},
									{
										"formattedValue": "1A,1B,1C"
									},
									{
										"formattedValue": "V,Sci,Tech,Lib"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "Lib"
									},
									{
										"formattedValue": "Library"
									},
									{
										"formattedValue": "Enrichment"
									},
									{
										"formattedValue": "2"
									},
									{},
									{
										"formattedValue": "TRUE"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "2A"
									},
									{
										"formattedValue": "2nd A"
									},
									{
										"formattedValue": "Classroom"
									},
									{
										"formattedValue": "1"
									},
									{
										"formattedValue": "2nd grade"
									},
									{
										"formattedValue": "TRUE"
									},
									{
										"formattedValue": "2A,2B"
									},
									{
										"formattedValue": "V,Sci,Tech,Lib"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "2B"
									},
									{
										"formattedValue": "2nd B"
									},
									{
										"formattedValue": "Classroom"
									},
									{
										"formattedValue": "1"
									},
									{
										"formattedValue": "2nd grade"
									},
									{
										"formattedValue": "TRUE"
									},
									{
										"formattedValue": "2A,2B"
									},
									{
										"formattedValue": "V,Sci,Tech,Lib"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "3A"
									},
									{
										"formattedValue": "3rd A"
									},
									{
										"formattedValue": "Classroom"
									},
									{
										"formattedValue": "1"
									},
									{
										"formattedValue": "3rd grade"
									},
									{
										"formattedValue": "TRUE"
									},
									{
										"formattedValue": "3A,3B"
									},
									{
										"formattedValue": "V,Sci,Tech,Lib"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "3B"
									},
									{
										"formattedValue": "3rd B"
									},
									{
										"formattedValue": "Classroom"
									},
									{
										"formattedValue": "1"
									},
									{
										"formattedValue": "3rd grade"
									},
									{
										"formattedValue": "TRUE"
									},
									{
										"formattedValue": "3A,3B"
									},
									{
										"formattedValue": "V,Sci,Tech,Lib"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "4A"
									},
									{
										"formattedValue": "4th A"
									},
									{
										"formattedValue": "Classroom"
									},
									{
										"formattedValue": "1"
									},
									{
										"formattedValue": "4th grade"
									},
									{
										"formattedValue": "TRUE"
									},
									{
										"formattedValue": "4A,4B,5A"
									},
									{
										"formattedValue": "V,Sci,Tech,Lib"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "4B"
									},
									{
										"formattedValue": "4th B"
									},
									{
										"formattedValue": "Classroom"
									},
									{
										"formattedValue": "1"
									},
									{
										"formattedValue": "4th grade"
									},
									{
										"formattedValue": "TRUE"
									},
									{
										"formattedValue": "4A,4B,5A"
									},
									{
										"formattedValue": "V,Sci,Tech,Lib"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "5A"
									},
									{
										"formattedValue": "5th A"
									},
									{
										"formattedValue": "Classroom"
									},
									{
										"formattedValue": "1"
									},
									{
										"formattedValue": "4th grade"
									},
									{
										"formattedValue": "TRUE"
									},
									{
										"formattedValue": "4A,4B,5A"
									},
									{
										"formattedValue": "V,Sci,Tech,Lib"
									}
								]
							}
						]
					}
				]
			},
			{
				"properties": {
					"sheetId": 1120187879,
					"title": "Meetings",
					"index": 2,
					"sheetType": "GRID",
					"gridProperties": {
						"rowCount": 997,
						"columnCount": 26
					}
				},
				"data": [
					{
						"rowData": [
							{
								"values": [
									{
										"formattedValue": "id"
									},
									{
										"formattedValue": "name"
									},
									{
										"formattedValue": "type"
									},
									{
										"formattedValue": "core"
									},
									{
										"formattedValue": "instructional"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "PWG"
									},
									{
										"formattedValue": "Playworks/Garden"
									},
									{
										"formattedValue": "Instructional"
									},
									{
										"formattedValue": "FALSE"
									},
									{
										"formattedValue": "TRUE"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "Intake"
									},
									{
										"formattedValue": "Intake"
									},
									{
										"formattedValue": "Instructional"
									},
									{
										"formattedValue": "FALSE"
									},
									{
										"formattedValue": "FALSE"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "ELD"
									},
									{
										"formattedValue": "ELD"
									},
									{
										"formattedValue": "Instructional"
									},
									{
										"formattedValue": "FALSE"
									},
									{
										"formattedValue": "TRUE"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "PE"
									},
									{
										"formattedValue": "PE"
									},
									{
										"formattedValue": "Instructional"
									},
									{
										"formattedValue": "FALSE"
									},
									{
										"formattedValue": "FALSE"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "Instructional"
									},
									{
										"formattedValue": "TRUE"
									},
									{
										"formattedValue": "TRUE"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "Rec"
									},
									{
										"formattedValue": "Recess"
									},
									{
										"formattedValue": "Break"
									},
									{},
									{
										"formattedValue": "FALSE"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "PW"
									},
									{
										"formattedValue": "Playworks"
									},
									{
										"formattedValue": "Instructional"
									},
									{
										"formattedValue": "FALSE"
									},
									{
										"formattedValue": "TRUE"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "G"
									},
									{
										"formattedValue": "Garden"
									},
									{
										"formattedValue": "Instructional"
									},
									{
										"formattedValue": "FALSE"
									},
									{
										"formattedValue": "TRUE"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "Lunch"
									},
									{
										"formattedValue": "Lunch"
									},
									{
										"formattedValue": "Break"
									},
									{},
									{
										"formattedValue": "FALSE"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "VAPA"
									},
									{
										"formattedValue": "VAPA"
									},
									{
										"formattedValue": "Instructional"
									},
									{
										"formattedValue": "FALSE"
									},
									{
										"formattedValue": "FALSE"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "COTEACH"
									},
									{
										"formattedValue": "COTEACH"
									},
									{
										"formattedValue": "Blended"
									},
									{
										"formattedValue": "FALSE"
									},
									{
										"formattedValue": "FALSE"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "Specials"
									},
									{
										"formattedValue": "Specials"
									},
									{
										"formattedValue": "Prep"
									},
									{
										"formattedValue": "FALSE"
									},
									{
										"formattedValue": "FALSE"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "Duty"
									},
									{
										"formattedValue": "Duty"
									},
									{
										"formattedValue": "Duty"
									},
									{},
									{
										"formattedValue": "FALSE"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "Prep"
									},
									{
										"formattedValue": "Prep"
									},
									{
										"formattedValue": "Prep"
									},
									{},
									{
										"formattedValue": "FALSE"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "PD"
									},
									{
										"formattedValue": "PD"
									},
									{
										"formattedValue": "PD"
									},
									{
										"formattedValue": "FALSE"
									},
									{
										"formattedValue": "FALSE"
									}
								]
							}
						]
					}
				]
			}
		]
	};

/***/ },
/* 299 */
/***/ function(module, exports) {

	module.exports = {
		"spreadsheetId": "2",
		"properties": {
			"title": "Sanchez Fixture Schedule"
		},
		"sheets": [
			{
				"properties": {
					"sheetId": 293666632,
					"title": "School",
					"index": 0,
					"sheetType": "GRID",
					"gridProperties": {
						"rowCount": 502,
						"columnCount": 12,
						"frozenRowCount": 1,
						"frozenColumnCount": 1
					}
				},
				"data": [
					{
						"rowData": [
							{
								"values": [
									{},
									{},
									{
										"formattedValue": "Monday"
									},
									{},
									{
										"formattedValue": "Tuesday"
									},
									{},
									{
										"formattedValue": "Wednesday"
									},
									{},
									{
										"formattedValue": "Thursday"
									},
									{},
									{
										"formattedValue": "Friday"
									},
									{}
								]
							},
							{
								"values": [
									{},
									{
										"formattedValue": "teacher_id"
									},
									{
										"formattedValue": "meeting_id"
									},
									{
										"formattedValue": "section_id"
									},
									{
										"formattedValue": "meeting_id"
									},
									{
										"formattedValue": "section_id"
									},
									{
										"formattedValue": "meeting_id"
									},
									{
										"formattedValue": "section_id"
									},
									{
										"formattedValue": "meeting_id"
									},
									{
										"formattedValue": "section_id"
									},
									{
										"formattedValue": "meeting_id"
									},
									{
										"formattedValue": "section_id"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "7:45-8:00"
									},
									{
										"formattedValue": "KA"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "KA"
									},
									{
										"formattedValue": "Intake"
									},
									{
										"formattedValue": "KA"
									},
									{
										"formattedValue": "Intake"
									},
									{
										"formattedValue": "KA"
									},
									{
										"formattedValue": "Intake"
									},
									{
										"formattedValue": "KA"
									},
									{
										"formattedValue": "Intake"
									},
									{
										"formattedValue": "KA"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "8:00-8:15"
									},
									{
										"formattedValue": "KA"
									},
									{
										"formattedValue": "ELD"
									},
									{
										"formattedValue": "KA"
									},
									{
										"formattedValue": "ELD"
									},
									{
										"formattedValue": "KA"
									},
									{
										"formattedValue": "ELD"
									},
									{
										"formattedValue": "KA"
									},
									{
										"formattedValue": "ELD"
									},
									{
										"formattedValue": "KA"
									},
									{
										"formattedValue": "ELD"
									},
									{
										"formattedValue": "KA"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "8:15-8:30"
									},
									{
										"formattedValue": "KA"
									},
									{
										"formattedValue": "ELD"
									},
									{
										"formattedValue": "KA"
									},
									{
										"formattedValue": "ELD"
									},
									{
										"formattedValue": "KA"
									},
									{
										"formattedValue": "ELD"
									},
									{
										"formattedValue": "KA"
									},
									{
										"formattedValue": "ELD"
									},
									{
										"formattedValue": "KA"
									},
									{
										"formattedValue": "ELD"
									},
									{
										"formattedValue": "KA"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "8:30 - 8:45"
									},
									{
										"formattedValue": "KA"
									},
									{
										"formattedValue": "PE"
									},
									{
										"formattedValue": "KA"
									},
									{
										"formattedValue": "PE"
									},
									{
										"formattedValue": "KA"
									},
									{
										"formattedValue": "PE"
									},
									{
										"formattedValue": "KA"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "KA"
									},
									{
										"formattedValue": "PE"
									},
									{
										"formattedValue": "KA"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "8:45-9:00"
									},
									{
										"formattedValue": "KA"
									},
									{
										"formattedValue": "PE"
									},
									{
										"formattedValue": "KA"
									},
									{
										"formattedValue": "PE"
									},
									{
										"formattedValue": "KA"
									},
									{
										"formattedValue": "PE"
									},
									{
										"formattedValue": "KA"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "KA"
									},
									{
										"formattedValue": "PE"
									},
									{
										"formattedValue": "KA"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "9:00-9:15"
									},
									{
										"formattedValue": "KA"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "KA"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "KA"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "KA"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "KA"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "KA"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "9:15 - 9:30"
									},
									{
										"formattedValue": "KA"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "KA"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "KA"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "KA"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "KA"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "KA"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "9:30-9:45"
									},
									{
										"formattedValue": "KA"
									},
									{
										"formattedValue": "Rec"
									},
									{
										"formattedValue": "KA"
									},
									{
										"formattedValue": "Rec"
									},
									{
										"formattedValue": "KA"
									},
									{
										"formattedValue": "Rec"
									},
									{
										"formattedValue": "KA"
									},
									{
										"formattedValue": "Rec"
									},
									{
										"formattedValue": "KA"
									},
									{
										"formattedValue": "Rec"
									},
									{
										"formattedValue": "KA"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "9:45-10:00"
									},
									{
										"formattedValue": "KA"
									},
									{
										"formattedValue": "Prep"
									},
									{
										"formattedValue": "KA"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "KA"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "KA"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "KA"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "KA"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "10:00 - 10:15"
									},
									{
										"formattedValue": "KA"
									},
									{
										"formattedValue": "Prep"
									},
									{
										"formattedValue": "KA"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "KA"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "KA"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "KA"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "KA"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "10:15 - 10:30"
									},
									{
										"formattedValue": "KA"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "KA"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "KA"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "KA"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "KA"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "KA"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "10:30 - 10:45"
									},
									{
										"formattedValue": "KA"
									},
									{
										"formattedValue": "PWG"
									},
									{
										"formattedValue": "KA"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "KA"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "KA"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "KA"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "KA"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "10:45 - 11:00"
									},
									{
										"formattedValue": "KA"
									},
									{
										"formattedValue": "PWG"
									},
									{
										"formattedValue": "KA"
									},
									{
										"formattedValue": "COTEACH"
									},
									{
										"formattedValue": "KA"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "KA"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "KA"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "KA"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "11:00 - 11:15"
									},
									{
										"formattedValue": "KA"
									},
									{
										"formattedValue": "Lunch"
									},
									{
										"formattedValue": "KA"
									},
									{
										"formattedValue": "Lunch"
									},
									{
										"formattedValue": "KA"
									},
									{
										"formattedValue": "Lunch"
									},
									{
										"formattedValue": "KA"
									},
									{
										"formattedValue": "Lunch"
									},
									{
										"formattedValue": "KA"
									},
									{
										"formattedValue": "Lunch"
									},
									{
										"formattedValue": "KA"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "11:15 - 11:30"
									},
									{
										"formattedValue": "KA"
									},
									{
										"formattedValue": "Lunch"
									},
									{
										"formattedValue": "KA"
									},
									{
										"formattedValue": "Lunch"
									},
									{
										"formattedValue": "KA"
									},
									{
										"formattedValue": "Lunch"
									},
									{
										"formattedValue": "KA"
									},
									{
										"formattedValue": "Lunch"
									},
									{
										"formattedValue": "KA"
									},
									{
										"formattedValue": "Lunch"
									},
									{
										"formattedValue": "KA"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "11:30 - 11:45"
									},
									{
										"formattedValue": "KA"
									},
									{
										"formattedValue": "Lunch"
									},
									{
										"formattedValue": "KA"
									},
									{
										"formattedValue": "Lunch"
									},
									{
										"formattedValue": "KA"
									},
									{
										"formattedValue": "Lunch"
									},
									{
										"formattedValue": "KA"
									},
									{
										"formattedValue": "Lunch"
									},
									{
										"formattedValue": "KA"
									},
									{
										"formattedValue": "Lunch"
									},
									{
										"formattedValue": "KA"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "11:45 - 12:00"
									},
									{
										"formattedValue": "KA"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "KA"
									},
									{
										"formattedValue": "COTEACH"
									},
									{
										"formattedValue": "KA"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "KA"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "KA"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "KA"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "12:00 - 12:15"
									},
									{
										"formattedValue": "KA"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "KA"
									},
									{
										"formattedValue": "COTEACH"
									},
									{
										"formattedValue": "KA"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "KA"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "KA"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "KA"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "12:15 - 12:30"
									},
									{
										"formattedValue": "KA"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "KA"
									},
									{
										"formattedValue": "Prep"
									},
									{},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "KA"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "KA"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "KA"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "12:30-12:45"
									},
									{
										"formattedValue": "KA"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "KA"
									},
									{
										"formattedValue": "Prep"
									},
									{},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "KA"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "KA"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "KA"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "12:45-1:00"
									},
									{
										"formattedValue": "KA"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "KA"
									},
									{
										"formattedValue": "Prep"
									},
									{},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "KA"
									},
									{
										"formattedValue": "PD"
									},
									{
										"formattedValue": "KA"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "KA"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "1:00 - 1:15"
									},
									{
										"formattedValue": "KA"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "KA"
									},
									{
										"formattedValue": "Prep"
									},
									{},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "KA"
									},
									{
										"formattedValue": "PD"
									},
									{
										"formattedValue": "KA"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "KA"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "1:15 - 1:30"
									},
									{
										"formattedValue": "KA"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "KA"
									},
									{
										"formattedValue": "Prep"
									},
									{},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "KA"
									},
									{
										"formattedValue": "PD"
									},
									{
										"formattedValue": "KA"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "KA"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "1:30 - 1:45"
									},
									{
										"formattedValue": "KA"
									},
									{
										"formattedValue": "Prep"
									},
									{},
									{
										"formattedValue": "Prep"
									},
									{},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "KA"
									},
									{
										"formattedValue": "PD"
									},
									{
										"formattedValue": "KA"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "KA"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "1:45-2:00"
									},
									{
										"formattedValue": "KA"
									},
									{
										"formattedValue": "Prep"
									},
									{},
									{
										"formattedValue": "Prep"
									},
									{},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "KA"
									},
									{
										"formattedValue": "PD"
									},
									{
										"formattedValue": "KA"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "KA"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "7:45-8:00"
									},
									{
										"formattedValue": "KB"
									},
									{
										"formattedValue": "Intake"
									},
									{
										"formattedValue": "KB"
									},
									{
										"formattedValue": "Intake"
									},
									{
										"formattedValue": "KB"
									},
									{
										"formattedValue": "Intake"
									},
									{
										"formattedValue": "KB"
									},
									{
										"formattedValue": "Intake"
									},
									{
										"formattedValue": "KB"
									},
									{
										"formattedValue": "Intake"
									},
									{
										"formattedValue": "KB"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "8:00-8:15"
									},
									{
										"formattedValue": "KB"
									},
									{
										"formattedValue": "ELD"
									},
									{
										"formattedValue": "KB"
									},
									{
										"formattedValue": "ELD"
									},
									{
										"formattedValue": "KB"
									},
									{
										"formattedValue": "ELD"
									},
									{
										"formattedValue": "KB"
									},
									{
										"formattedValue": "ELD"
									},
									{
										"formattedValue": "KB"
									},
									{
										"formattedValue": "ELD"
									},
									{
										"formattedValue": "KB"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "8:15-8:30"
									},
									{
										"formattedValue": "KB"
									},
									{
										"formattedValue": "ELD"
									},
									{
										"formattedValue": "KB"
									},
									{
										"formattedValue": "ELD"
									},
									{
										"formattedValue": "KB"
									},
									{
										"formattedValue": "ELD"
									},
									{
										"formattedValue": "KB"
									},
									{
										"formattedValue": "ELD"
									},
									{
										"formattedValue": "KB"
									},
									{
										"formattedValue": "ELD"
									},
									{
										"formattedValue": "KB"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "8:30 - 8:45"
									},
									{
										"formattedValue": "KB"
									},
									{
										"formattedValue": "PE"
									},
									{
										"formattedValue": "KB"
									},
									{
										"formattedValue": "PE"
									},
									{
										"formattedValue": "KB"
									},
									{
										"formattedValue": "PE"
									},
									{
										"formattedValue": "KB"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "KB"
									},
									{
										"formattedValue": "PE"
									},
									{
										"formattedValue": "KB"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "8:45-9:00"
									},
									{
										"formattedValue": "KB"
									},
									{
										"formattedValue": "PE"
									},
									{
										"formattedValue": "KB"
									},
									{
										"formattedValue": "PE"
									},
									{
										"formattedValue": "KB"
									},
									{
										"formattedValue": "PE"
									},
									{
										"formattedValue": "KB"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "KB"
									},
									{
										"formattedValue": "PE"
									},
									{
										"formattedValue": "KB"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "9:00-9:15"
									},
									{
										"formattedValue": "KB"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "KB"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "KB"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "KB"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "KB"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "KB"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "9:15 - 9:30"
									},
									{
										"formattedValue": "KB"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "KB"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "KB"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "KB"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "KB"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "KB"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "9:30-9:45"
									},
									{
										"formattedValue": "KB"
									},
									{
										"formattedValue": "Rec"
									},
									{
										"formattedValue": "KB"
									},
									{
										"formattedValue": "Rec"
									},
									{
										"formattedValue": "KB"
									},
									{
										"formattedValue": "Rec"
									},
									{
										"formattedValue": "KB"
									},
									{
										"formattedValue": "Rec"
									},
									{
										"formattedValue": "KB"
									},
									{
										"formattedValue": "Rec"
									},
									{
										"formattedValue": "KB"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "9:45-10:00"
									},
									{
										"formattedValue": "KB"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "KB"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "KB"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "KB"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "KB"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "KB"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "10:00 - 10:15"
									},
									{
										"formattedValue": "KB"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "KB"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "KB"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "KB"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "KB"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "KB"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "10:15 - 10:30"
									},
									{
										"formattedValue": "KB"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "KB"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "KB"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "KB"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "KB"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "KB"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "10:30 - 10:45"
									},
									{
										"formattedValue": "KB"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "KB"
									},
									{
										"formattedValue": "COTEACH"
									},
									{
										"formattedValue": "KB"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "KB"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "KB"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "KB"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "10:45 - 11:00"
									},
									{
										"formattedValue": "KB"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "KB"
									},
									{
										"formattedValue": "COTEACH"
									},
									{
										"formattedValue": "KB"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "KB"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "KB"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "KB"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "11:00 - 11:15"
									},
									{
										"formattedValue": "KB"
									},
									{
										"formattedValue": "Lunch"
									},
									{},
									{
										"formattedValue": "Lunch"
									},
									{
										"formattedValue": "KB"
									},
									{},
									{
										"formattedValue": "KB"
									},
									{},
									{
										"formattedValue": "KB"
									},
									{},
									{
										"formattedValue": "KB"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "11:15 - 11:30"
									},
									{
										"formattedValue": "KB"
									},
									{
										"formattedValue": "Lunch"
									},
									{},
									{
										"formattedValue": "Lunch"
									},
									{
										"formattedValue": "KB"
									},
									{},
									{
										"formattedValue": "KB"
									},
									{},
									{
										"formattedValue": "KB"
									},
									{},
									{
										"formattedValue": "KB"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "11:30 - 11:45"
									},
									{
										"formattedValue": "KB"
									},
									{
										"formattedValue": "Lunch"
									},
									{},
									{
										"formattedValue": "Lunch"
									},
									{
										"formattedValue": "KB"
									},
									{},
									{
										"formattedValue": "KB"
									},
									{},
									{
										"formattedValue": "KB"
									},
									{},
									{
										"formattedValue": "KB"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "11:45 - 12:00"
									},
									{
										"formattedValue": "KB"
									},
									{
										"formattedValue": "Prep"
									},
									{},
									{
										"formattedValue": "COTEACH"
									},
									{
										"formattedValue": "KB"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "KB"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "KB"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "KB"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "12:00 - 12:15"
									},
									{
										"formattedValue": "KB"
									},
									{
										"formattedValue": "Prep"
									},
									{},
									{
										"formattedValue": "COTEACH"
									},
									{
										"formattedValue": "KB"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "KB"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "KB"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "KB"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "12:15 - 12:30"
									},
									{
										"formattedValue": "KB"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "KB"
									},
									{
										"formattedValue": "Prep"
									},
									{},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "KB"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "KB"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "KB"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "12:30-12:45"
									},
									{
										"formattedValue": "KB"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "KB"
									},
									{
										"formattedValue": "Prep"
									},
									{},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "KB"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "KB"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "KB"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "12:45-1:00"
									},
									{
										"formattedValue": "KB"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "KB"
									},
									{
										"formattedValue": "Prep"
									},
									{},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "KB"
									},
									{
										"formattedValue": "PD"
									},
									{
										"formattedValue": "KB"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "KB"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "1:00 - 1:15"
									},
									{
										"formattedValue": "KB"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "KB"
									},
									{
										"formattedValue": "Prep"
									},
									{},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "KB"
									},
									{
										"formattedValue": "PD"
									},
									{
										"formattedValue": "KB"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "KB"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "1:15 - 1:30"
									},
									{
										"formattedValue": "KB"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "KB"
									},
									{
										"formattedValue": "Prep"
									},
									{},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "KB"
									},
									{
										"formattedValue": "PD"
									},
									{
										"formattedValue": "KB"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "KB"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "1:30 - 1:45"
									},
									{
										"formattedValue": "KB"
									},
									{
										"formattedValue": "PWG"
									},
									{
										"formattedValue": "KB"
									},
									{
										"formattedValue": "Prep"
									},
									{},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "KB"
									},
									{
										"formattedValue": "PD"
									},
									{
										"formattedValue": "KB"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "KB"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "1:45-2:00"
									},
									{
										"formattedValue": "KB"
									},
									{
										"formattedValue": "PWG"
									},
									{
										"formattedValue": "KB"
									},
									{
										"formattedValue": "Prep"
									},
									{},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "KB"
									},
									{
										"formattedValue": "PD"
									},
									{
										"formattedValue": "KB"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "KB"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "7:45-8:00"
									},
									{
										"formattedValue": "KC"
									},
									{
										"formattedValue": "Intake"
									},
									{
										"formattedValue": "KC"
									},
									{
										"formattedValue": "Intake"
									},
									{
										"formattedValue": "KC"
									},
									{
										"formattedValue": "Intake"
									},
									{
										"formattedValue": "KC"
									},
									{
										"formattedValue": "Intake"
									},
									{
										"formattedValue": "KC"
									},
									{
										"formattedValue": "Intake"
									},
									{
										"formattedValue": "KC"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "8:00-8:15"
									},
									{
										"formattedValue": "KC"
									},
									{
										"formattedValue": "ELD"
									},
									{
										"formattedValue": "KC"
									},
									{
										"formattedValue": "ELD"
									},
									{
										"formattedValue": "KC"
									},
									{
										"formattedValue": "ELD"
									},
									{
										"formattedValue": "KC"
									},
									{
										"formattedValue": "ELD"
									},
									{
										"formattedValue": "KC"
									},
									{
										"formattedValue": "ELD"
									},
									{
										"formattedValue": "KC"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "8:15-8:30"
									},
									{
										"formattedValue": "KC"
									},
									{
										"formattedValue": "ELD"
									},
									{
										"formattedValue": "KC"
									},
									{
										"formattedValue": "ELD"
									},
									{
										"formattedValue": "KC"
									},
									{
										"formattedValue": "ELD"
									},
									{
										"formattedValue": "KC"
									},
									{
										"formattedValue": "ELD"
									},
									{
										"formattedValue": "KC"
									},
									{
										"formattedValue": "ELD"
									},
									{
										"formattedValue": "KC"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "8:30 - 8:45"
									},
									{
										"formattedValue": "KC"
									},
									{
										"formattedValue": "PE"
									},
									{
										"formattedValue": "KC"
									},
									{
										"formattedValue": "PE"
									},
									{
										"formattedValue": "KC"
									},
									{
										"formattedValue": "PE"
									},
									{
										"formattedValue": "KC"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "KC"
									},
									{
										"formattedValue": "PE"
									},
									{
										"formattedValue": "KC"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "8:45-9:00"
									},
									{
										"formattedValue": "KC"
									},
									{
										"formattedValue": "PE"
									},
									{
										"formattedValue": "KC"
									},
									{
										"formattedValue": "PE"
									},
									{
										"formattedValue": "KC"
									},
									{
										"formattedValue": "PE"
									},
									{
										"formattedValue": "KC"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "KC"
									},
									{
										"formattedValue": "PE"
									},
									{
										"formattedValue": "KC"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "9:00-9:15"
									},
									{
										"formattedValue": "KC"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "KC"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "KC"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "KC"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "KC"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "KC"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "9:15 - 9:30"
									},
									{
										"formattedValue": "KC"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "KC"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "KC"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "KC"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "KC"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "KC"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "9:30-9:45"
									},
									{
										"formattedValue": "KC"
									},
									{
										"formattedValue": "Rec"
									},
									{
										"formattedValue": "KC"
									},
									{
										"formattedValue": "Rec"
									},
									{
										"formattedValue": "KC"
									},
									{
										"formattedValue": "Rec"
									},
									{
										"formattedValue": "KC"
									},
									{
										"formattedValue": "Rec"
									},
									{
										"formattedValue": "KC"
									},
									{
										"formattedValue": "Rec"
									},
									{
										"formattedValue": "KC"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "9:45-10:00"
									},
									{
										"formattedValue": "KC"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "KC"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "KC"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "KC"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "KC"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "KC"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "10:00 - 10:15"
									},
									{
										"formattedValue": "KC"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "KC"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "KC"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "KC"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "KC"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "KC"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "10:15 - 10:30"
									},
									{
										"formattedValue": "KC"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "KC"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "KC"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "KC"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "KC"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "KC"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "10:30 - 10:45"
									},
									{
										"formattedValue": "KC"
									},
									{
										"formattedValue": "Prep"
									},
									{},
									{
										"formattedValue": "COTEACH"
									},
									{
										"formattedValue": "KC"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "KC"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "KC"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "KC"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "10:45 - 11:00"
									},
									{
										"formattedValue": "KC"
									},
									{
										"formattedValue": "Prep"
									},
									{},
									{
										"formattedValue": "COTEACH"
									},
									{
										"formattedValue": "KC"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "KC"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "KC"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "KC"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "11:00 - 11:15"
									},
									{
										"formattedValue": "KC"
									},
									{
										"formattedValue": "Lunch"
									},
									{},
									{
										"formattedValue": "Lunch"
									},
									{},
									{
										"formattedValue": "Lunch"
									},
									{},
									{
										"formattedValue": "Lunch"
									},
									{},
									{
										"formattedValue": "Lunch"
									},
									{}
								]
							},
							{
								"values": [
									{
										"formattedValue": "11:15 - 11:30"
									},
									{
										"formattedValue": "KC"
									},
									{
										"formattedValue": "Lunch"
									},
									{},
									{
										"formattedValue": "Lunch"
									},
									{},
									{
										"formattedValue": "Lunch"
									},
									{},
									{
										"formattedValue": "Lunch"
									},
									{},
									{
										"formattedValue": "Lunch"
									},
									{}
								]
							},
							{
								"values": [
									{
										"formattedValue": "11:30 - 11:45"
									},
									{
										"formattedValue": "KC"
									},
									{
										"formattedValue": "Lunch"
									},
									{},
									{
										"formattedValue": "Lunch"
									},
									{},
									{
										"formattedValue": "Lunch"
									},
									{},
									{
										"formattedValue": "Lunch"
									},
									{},
									{
										"formattedValue": "Lunch"
									},
									{}
								]
							},
							{
								"values": [
									{
										"formattedValue": "11:45 - 12:00"
									},
									{
										"formattedValue": "KC"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "KC"
									},
									{
										"formattedValue": "COTEACH"
									},
									{
										"formattedValue": "KC"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "KC"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "KC"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "KC"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "12:00 - 12:15"
									},
									{
										"formattedValue": "KC"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "KC"
									},
									{
										"formattedValue": "COTEACH"
									},
									{
										"formattedValue": "KC"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "KC"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "KC"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "KC"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "12:15 - 12:30"
									},
									{
										"formattedValue": "KC"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "KC"
									},
									{
										"formattedValue": "Prep"
									},
									{},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "KC"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "KC"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "KC"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "12:30-12:45"
									},
									{
										"formattedValue": "KC"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "KC"
									},
									{
										"formattedValue": "Prep"
									},
									{},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "KC"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "KC"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "KC"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "12:45-1:00"
									},
									{
										"formattedValue": "KC"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "KC"
									},
									{
										"formattedValue": "Prep"
									},
									{},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "KC"
									},
									{
										"formattedValue": "PD"
									},
									{
										"formattedValue": "KC"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "KC"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "1:00 - 1:15"
									},
									{
										"formattedValue": "KC"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "KC"
									},
									{
										"formattedValue": "Prep"
									},
									{},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "KC"
									},
									{
										"formattedValue": "PD"
									},
									{
										"formattedValue": "KC"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "KC"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "1:15 - 1:30"
									},
									{
										"formattedValue": "KC"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "KC"
									},
									{
										"formattedValue": "Prep"
									},
									{},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "KC"
									},
									{
										"formattedValue": "PD"
									},
									{
										"formattedValue": "KC"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "KC"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "1:30 - 1:45"
									},
									{
										"formattedValue": "KC"
									},
									{
										"formattedValue": "PWG"
									},
									{
										"formattedValue": "KC"
									},
									{
										"formattedValue": "Prep"
									},
									{},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "KC"
									},
									{
										"formattedValue": "PD"
									},
									{
										"formattedValue": "KC"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "KC"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "1:45-2:00"
									},
									{
										"formattedValue": "KC"
									},
									{
										"formattedValue": "PWG"
									},
									{
										"formattedValue": "KC"
									},
									{
										"formattedValue": "Prep"
									},
									{},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "KC"
									},
									{
										"formattedValue": "PD"
									},
									{
										"formattedValue": "KC"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "KC"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "7:45-8:00"
									},
									{
										"formattedValue": "1A"
									},
									{
										"formattedValue": "Intake"
									},
									{
										"formattedValue": "1A"
									},
									{
										"formattedValue": "Intake"
									},
									{
										"formattedValue": "1A"
									},
									{
										"formattedValue": "Intake"
									},
									{
										"formattedValue": "1A"
									},
									{
										"formattedValue": "Intake"
									},
									{
										"formattedValue": "1A"
									},
									{
										"formattedValue": "Intake"
									},
									{
										"formattedValue": "1A"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "8:00-8:15"
									},
									{
										"formattedValue": "1A"
									},
									{
										"formattedValue": "ELD"
									},
									{
										"formattedValue": "1A"
									},
									{
										"formattedValue": "ELD"
									},
									{
										"formattedValue": "1A"
									},
									{
										"formattedValue": "ELD"
									},
									{
										"formattedValue": "1A"
									},
									{
										"formattedValue": "ELD"
									},
									{
										"formattedValue": "1A"
									},
									{
										"formattedValue": "ELD"
									},
									{
										"formattedValue": "1A"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "8:15-8:30"
									},
									{
										"formattedValue": "1A"
									},
									{
										"formattedValue": "ELD"
									},
									{
										"formattedValue": "1A"
									},
									{
										"formattedValue": "ELD"
									},
									{
										"formattedValue": "1A"
									},
									{
										"formattedValue": "ELD"
									},
									{
										"formattedValue": "1A"
									},
									{
										"formattedValue": "ELD"
									},
									{
										"formattedValue": "1A"
									},
									{
										"formattedValue": "ELD"
									},
									{
										"formattedValue": "1A"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "8:30 - 8:45"
									},
									{
										"formattedValue": "1A"
									},
									{
										"formattedValue": "Prep"
									},
									{},
									{
										"formattedValue": "Prep"
									},
									{
										"formattedValue": "1A"
									},
									{
										"formattedValue": "COTEACH"
									},
									{
										"formattedValue": "1A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "1A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "1A"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "8:45-9:00"
									},
									{
										"formattedValue": "1A"
									},
									{
										"formattedValue": "Prep"
									},
									{},
									{
										"formattedValue": "Prep"
									},
									{},
									{
										"formattedValue": "COTEACH"
									},
									{
										"formattedValue": "1A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "1A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "1A"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "9:00-9:15"
									},
									{
										"formattedValue": "1A"
									},
									{
										"formattedValue": "PWG"
									},
									{
										"formattedValue": "1A"
									},
									{
										"formattedValue": "Prep"
									},
									{},
									{
										"formattedValue": "COTEACh"
									},
									{
										"formattedValue": "1A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "1A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "1A"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "9:15 - 9:30"
									},
									{
										"formattedValue": "1A"
									},
									{
										"formattedValue": "PWG"
									},
									{
										"formattedValue": "1A"
									},
									{
										"formattedValue": "Prep"
									},
									{},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "1A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "1A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "1A"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "9:30-9:45"
									},
									{
										"formattedValue": "1A"
									},
									{
										"formattedValue": "Rec"
									},
									{
										"formattedValue": "1A"
									},
									{
										"formattedValue": "Prep"
									},
									{},
									{
										"formattedValue": "Rec"
									},
									{
										"formattedValue": "1A"
									},
									{
										"formattedValue": "Rec"
									},
									{
										"formattedValue": "1A"
									},
									{
										"formattedValue": "Rec"
									},
									{
										"formattedValue": "1A"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "9:45-10:00"
									},
									{
										"formattedValue": "1A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "1A"
									},
									{
										"formattedValue": "Prep"
									},
									{},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "1A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "1A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "1A"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "10:00 - 10:15"
									},
									{
										"formattedValue": "1A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "1A"
									},
									{
										"formattedValue": "Prep"
									},
									{},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "1A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "1A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "1A"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "10:15 - 10:30"
									},
									{
										"formattedValue": "1A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "1A"
									},
									{
										"formattedValue": "Prep"
									},
									{},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "1A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "1A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "1A"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "10:30 - 10:45"
									},
									{
										"formattedValue": "1A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "1A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "1A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "1A"
									},
									{
										"formattedValue": "Coteach"
									},
									{
										"formattedValue": "1A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "1A"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "10:45 - 11:00"
									},
									{
										"formattedValue": "1A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "1A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "1A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "1A"
									},
									{
										"formattedValue": "Coteach"
									},
									{
										"formattedValue": "1A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "1A"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "11:00 - 11:15"
									},
									{
										"formattedValue": "1A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "1A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "1A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "1A"
									},
									{
										"formattedValue": "Coteach"
									},
									{
										"formattedValue": "1A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "1A"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "11:15 - 11:30"
									},
									{
										"formattedValue": "1A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "1A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "1A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "1A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "1A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "1A"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "11:30 - 11:45"
									},
									{
										"formattedValue": "1A"
									},
									{
										"formattedValue": "Lunch"
									},
									{},
									{
										"formattedValue": "Lunch"
									},
									{},
									{
										"formattedValue": "Lunch"
									},
									{},
									{
										"formattedValue": "Lunch"
									},
									{},
									{
										"formattedValue": "Lunch"
									},
									{}
								]
							},
							{
								"values": [
									{
										"formattedValue": "11:45 - 12:00"
									},
									{
										"formattedValue": "1A"
									},
									{
										"formattedValue": "Lunch"
									},
									{},
									{
										"formattedValue": "Lunch"
									},
									{},
									{
										"formattedValue": "Lunch"
									},
									{},
									{
										"formattedValue": "Lunch"
									},
									{},
									{
										"formattedValue": "Lunch"
									},
									{}
								]
							},
							{
								"values": [
									{
										"formattedValue": "12:00 - 12:15"
									},
									{
										"formattedValue": "1A"
									},
									{
										"formattedValue": "Lunch"
									},
									{},
									{
										"formattedValue": "Lunch"
									},
									{},
									{
										"formattedValue": "Lunch"
									},
									{},
									{
										"formattedValue": "Lunch"
									},
									{},
									{
										"formattedValue": "Lunch"
									},
									{}
								]
							},
							{
								"values": [
									{
										"formattedValue": "12:15 - 12:30"
									},
									{
										"formattedValue": "1A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "1A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "1A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "1A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "1A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "1A"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "12:30-12:45"
									},
									{
										"formattedValue": "1A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "1A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "1A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "1A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "1A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "1A"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "12:45-1:00"
									},
									{
										"formattedValue": "1A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "1A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "1A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "1A"
									},
									{
										"formattedValue": "PD"
									},
									{
										"formattedValue": "1A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "1A"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "1:00 - 1:15"
									},
									{
										"formattedValue": "1A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "1A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "1A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "1A"
									},
									{
										"formattedValue": "PD"
									},
									{
										"formattedValue": "1A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "1A"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "1:15 - 1:30"
									},
									{
										"formattedValue": "1A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "1A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "1A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "1A"
									},
									{
										"formattedValue": "PD"
									},
									{
										"formattedValue": "1A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "1A"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "1:30 - 1:45"
									},
									{
										"formattedValue": "1A"
									},
									{
										"formattedValue": "PE"
									},
									{
										"formattedValue": "1A"
									},
									{
										"formattedValue": "PE"
									},
									{
										"formattedValue": "1A"
									},
									{
										"formattedValue": "PE"
									},
									{
										"formattedValue": "1A"
									},
									{
										"formattedValue": "PD"
									},
									{
										"formattedValue": "1A"
									},
									{
										"formattedValue": "PE"
									},
									{
										"formattedValue": "1A"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "1:45-2:00"
									},
									{
										"formattedValue": "1A"
									},
									{
										"formattedValue": "PE"
									},
									{
										"formattedValue": "1A"
									},
									{
										"formattedValue": "PE"
									},
									{
										"formattedValue": "1A"
									},
									{
										"formattedValue": "PE"
									},
									{
										"formattedValue": "1A"
									},
									{
										"formattedValue": "PD"
									},
									{
										"formattedValue": "1A"
									},
									{
										"formattedValue": "PE"
									},
									{
										"formattedValue": "1A"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "7:45-8:00"
									},
									{
										"formattedValue": "1B"
									},
									{
										"formattedValue": "Intake"
									},
									{
										"formattedValue": "1B"
									},
									{
										"formattedValue": "Intake"
									},
									{
										"formattedValue": "1B"
									},
									{
										"formattedValue": "Intake"
									},
									{
										"formattedValue": "1B"
									},
									{
										"formattedValue": "Intake"
									},
									{
										"formattedValue": "1B"
									},
									{
										"formattedValue": "Intake"
									},
									{
										"formattedValue": "1B"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "8:00-8:15"
									},
									{
										"formattedValue": "1B"
									},
									{
										"formattedValue": "ELD"
									},
									{
										"formattedValue": "1B"
									},
									{
										"formattedValue": "ELD"
									},
									{
										"formattedValue": "1B"
									},
									{
										"formattedValue": "ELD"
									},
									{
										"formattedValue": "1B"
									},
									{
										"formattedValue": "ELD"
									},
									{
										"formattedValue": "1B"
									},
									{
										"formattedValue": "ELD"
									},
									{
										"formattedValue": "1B"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "8:15-8:30"
									},
									{
										"formattedValue": "1B"
									},
									{
										"formattedValue": "ELD"
									},
									{
										"formattedValue": "1B"
									},
									{
										"formattedValue": "ELD"
									},
									{
										"formattedValue": "1B"
									},
									{
										"formattedValue": "ELD"
									},
									{
										"formattedValue": "1B"
									},
									{
										"formattedValue": "ELD"
									},
									{
										"formattedValue": "1B"
									},
									{
										"formattedValue": "ELD"
									},
									{
										"formattedValue": "1B"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "8:30 - 8:45"
									},
									{
										"formattedValue": "1B"
									},
									{
										"formattedValue": "PWG"
									},
									{
										"formattedValue": "1B"
									},
									{
										"formattedValue": "Prep"
									},
									{},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "1B"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "1B"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "1B"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "8:45-9:00"
									},
									{
										"formattedValue": "1B"
									},
									{
										"formattedValue": "PWG"
									},
									{
										"formattedValue": "1B"
									},
									{
										"formattedValue": "Prep"
									},
									{},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "1B"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "1B"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "1B"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "9:00-9:15"
									},
									{
										"formattedValue": "1B"
									},
									{
										"formattedValue": "Prep"
									},
									{},
									{
										"formattedValue": "Prep"
									},
									{},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "1B"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "1B"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "1B"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "9:15 - 9:30"
									},
									{
										"formattedValue": "1B"
									},
									{
										"formattedValue": "Prep"
									},
									{},
									{
										"formattedValue": "Prep"
									},
									{},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "1B"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "1B"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "1B"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "9:30-9:45"
									},
									{
										"formattedValue": "1B"
									},
									{
										"formattedValue": "Rec"
									},
									{
										"formattedValue": "1B"
									},
									{
										"formattedValue": "Prep"
									},
									{},
									{
										"formattedValue": "Rec"
									},
									{
										"formattedValue": "1B"
									},
									{
										"formattedValue": "Rec"
									},
									{
										"formattedValue": "1B"
									},
									{
										"formattedValue": "Rec"
									},
									{
										"formattedValue": "1B"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "9:45-10:00"
									},
									{
										"formattedValue": "1B"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "1B"
									},
									{
										"formattedValue": "Prep"
									},
									{},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "1B"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "1B"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "1B"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "10:00 - 10:15"
									},
									{
										"formattedValue": "1B"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "1B"
									},
									{
										"formattedValue": "Prep"
									},
									{},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "1B"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "1B"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "1B"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "10:15 - 10:30"
									},
									{
										"formattedValue": "1B"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "1B"
									},
									{
										"formattedValue": "Prep"
									},
									{},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "1B"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "1B"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "1B"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "10:30 - 10:45"
									},
									{
										"formattedValue": "1B"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "1B"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "1B"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "1B"
									},
									{
										"formattedValue": "Coteach"
									},
									{
										"formattedValue": "1B"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "1B"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "10:45 - 11:00"
									},
									{
										"formattedValue": "1B"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "1B"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "1B"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "1B"
									},
									{
										"formattedValue": "Coteach"
									},
									{
										"formattedValue": "1B"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "1B"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "11:00 - 11:15"
									},
									{
										"formattedValue": "1B"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "1B"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "1B"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "1B"
									},
									{
										"formattedValue": "Coteach"
									},
									{
										"formattedValue": "1B"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "1B"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "11:15 - 11:30"
									},
									{
										"formattedValue": "1B"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "1B"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "1B"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "1B"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "1B"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "1B"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "11:30 - 11:45"
									},
									{
										"formattedValue": "1B"
									},
									{
										"formattedValue": "Lunch"
									},
									{},
									{
										"formattedValue": "Lunch"
									},
									{},
									{
										"formattedValue": "Lunch"
									},
									{},
									{
										"formattedValue": "Lunch"
									},
									{},
									{
										"formattedValue": "Lunch"
									},
									{}
								]
							},
							{
								"values": [
									{
										"formattedValue": "11:45 - 12:00"
									},
									{
										"formattedValue": "1B"
									},
									{
										"formattedValue": "Lunch"
									},
									{},
									{
										"formattedValue": "Lunch"
									},
									{},
									{
										"formattedValue": "Lunch"
									},
									{},
									{
										"formattedValue": "Lunch"
									},
									{},
									{
										"formattedValue": "Lunch"
									},
									{}
								]
							},
							{
								"values": [
									{
										"formattedValue": "12:00 - 12:15"
									},
									{
										"formattedValue": "1B"
									},
									{
										"formattedValue": "Lunch"
									},
									{},
									{
										"formattedValue": "Lunch"
									},
									{},
									{
										"formattedValue": "Lunch"
									},
									{},
									{
										"formattedValue": "Lunch"
									},
									{},
									{
										"formattedValue": "Lunch"
									},
									{}
								]
							},
							{
								"values": [
									{
										"formattedValue": "12:15 - 12:30"
									},
									{
										"formattedValue": "1B"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "1B"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "1B"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "1B"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "1B"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "1B"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "12:30-12:45"
									},
									{
										"formattedValue": "1B"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "1B"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "1B"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "1B"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "1B"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "1B"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "12:45-1:00"
									},
									{
										"formattedValue": "1B"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "1B"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "1B"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "1B"
									},
									{
										"formattedValue": "PD"
									},
									{
										"formattedValue": "1B"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "1B"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "1:00 - 1:15"
									},
									{
										"formattedValue": "1B"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "1B"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "1B"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "1B"
									},
									{
										"formattedValue": "PD"
									},
									{
										"formattedValue": "1B"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "1B"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "1:15 - 1:30"
									},
									{
										"formattedValue": "1B"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "1B"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "1B"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "1B"
									},
									{
										"formattedValue": "PD"
									},
									{
										"formattedValue": "1B"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "1B"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "1:30 - 1:45"
									},
									{
										"formattedValue": "1B"
									},
									{
										"formattedValue": "PE"
									},
									{
										"formattedValue": "1B"
									},
									{
										"formattedValue": "PE"
									},
									{
										"formattedValue": "1B"
									},
									{
										"formattedValue": "PE"
									},
									{
										"formattedValue": "1B"
									},
									{
										"formattedValue": "PD"
									},
									{
										"formattedValue": "1B"
									},
									{
										"formattedValue": "PE"
									},
									{
										"formattedValue": "1B"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "1:45-2:00"
									},
									{
										"formattedValue": "1B"
									},
									{
										"formattedValue": "PE"
									},
									{
										"formattedValue": "1B"
									},
									{
										"formattedValue": "PE"
									},
									{
										"formattedValue": "1B"
									},
									{
										"formattedValue": "PE"
									},
									{
										"formattedValue": "1B"
									},
									{
										"formattedValue": "PD"
									},
									{
										"formattedValue": "1B"
									},
									{
										"formattedValue": "PE"
									},
									{
										"formattedValue": "1B"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "7:45-8:00"
									},
									{
										"formattedValue": "1C"
									},
									{
										"formattedValue": "Intake"
									},
									{
										"formattedValue": "1C"
									},
									{
										"formattedValue": "Intake"
									},
									{
										"formattedValue": "1C"
									},
									{
										"formattedValue": "Intake"
									},
									{
										"formattedValue": "1C"
									},
									{
										"formattedValue": "Intake"
									},
									{
										"formattedValue": "1C"
									},
									{
										"formattedValue": "Intake"
									},
									{
										"formattedValue": "1C"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "8:00-8:15"
									},
									{
										"formattedValue": "1C"
									},
									{
										"formattedValue": "ELD"
									},
									{
										"formattedValue": "1C"
									},
									{
										"formattedValue": "ELD"
									},
									{
										"formattedValue": "1C"
									},
									{
										"formattedValue": "ELD"
									},
									{
										"formattedValue": "1C"
									},
									{
										"formattedValue": "ELD"
									},
									{
										"formattedValue": "1C"
									},
									{
										"formattedValue": "ELD"
									},
									{
										"formattedValue": "1C"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "8:15-8:30"
									},
									{
										"formattedValue": "1C"
									},
									{
										"formattedValue": "ELD"
									},
									{
										"formattedValue": "1C"
									},
									{
										"formattedValue": "ELD"
									},
									{
										"formattedValue": "1C"
									},
									{
										"formattedValue": "ELD"
									},
									{
										"formattedValue": "1C"
									},
									{
										"formattedValue": "ELD"
									},
									{
										"formattedValue": "1C"
									},
									{
										"formattedValue": "ELD"
									},
									{
										"formattedValue": "1C"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "8:30 - 8:45"
									},
									{
										"formattedValue": "1C"
									},
									{
										"formattedValue": "PWG"
									},
									{
										"formattedValue": "1C"
									},
									{
										"formattedValue": "Prep"
									},
									{},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "1C"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "1C"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "1C"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "8:45-9:00"
									},
									{
										"formattedValue": "1C"
									},
									{
										"formattedValue": "PWG"
									},
									{
										"formattedValue": "1C"
									},
									{
										"formattedValue": "Prep"
									},
									{},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "1C"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "1C"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "1C"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "9:00-9:15"
									},
									{
										"formattedValue": "1C"
									},
									{
										"formattedValue": "PWG"
									},
									{
										"formattedValue": "1C"
									},
									{
										"formattedValue": "Prep"
									},
									{},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "1C"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "1C"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "1C"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "9:15 - 9:30"
									},
									{
										"formattedValue": "1C"
									},
									{
										"formattedValue": "PWG"
									},
									{
										"formattedValue": "1C"
									},
									{
										"formattedValue": "Prep"
									},
									{},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "1C"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "1C"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "1C"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "9:30-9:45"
									},
									{
										"formattedValue": "1C"
									},
									{
										"formattedValue": "Rec"
									},
									{
										"formattedValue": "1C"
									},
									{
										"formattedValue": "Prep"
									},
									{},
									{
										"formattedValue": "Rec"
									},
									{
										"formattedValue": "1C"
									},
									{
										"formattedValue": "Rec"
									},
									{
										"formattedValue": "1C"
									},
									{
										"formattedValue": "Rec"
									},
									{
										"formattedValue": "1C"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "9:45-10:00"
									},
									{
										"formattedValue": "1C"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "1C"
									},
									{
										"formattedValue": "Prep"
									},
									{},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "1C"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "1C"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "1C"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "10:00 - 10:15"
									},
									{
										"formattedValue": "1C"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "1C"
									},
									{
										"formattedValue": "Prep"
									},
									{},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "1C"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "1C"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "1C"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "10:15 - 10:30"
									},
									{
										"formattedValue": "1C"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "1C"
									},
									{
										"formattedValue": "Prep"
									},
									{},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "1C"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "1C"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "1C"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "10:30 - 10:45"
									},
									{
										"formattedValue": "1C"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "1C"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "1C"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "1C"
									},
									{
										"formattedValue": "Coteach"
									},
									{
										"formattedValue": "1C"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "1C"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "10:45 - 11:00"
									},
									{
										"formattedValue": "1C"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "1C"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "1C"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "1C"
									},
									{
										"formattedValue": "Coteach"
									},
									{
										"formattedValue": "1C"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "1C"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "11:00 - 11:15"
									},
									{
										"formattedValue": "1C"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "1C"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "1C"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "1C"
									},
									{
										"formattedValue": "Coteach"
									},
									{
										"formattedValue": "1C"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "1C"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "11:15 - 11:30"
									},
									{
										"formattedValue": "1C"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "1C"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "1C"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "1C"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "1C"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "1C"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "11:30 - 11:45"
									},
									{
										"formattedValue": "1C"
									},
									{
										"formattedValue": "Lunch"
									},
									{},
									{
										"formattedValue": "Lunch"
									},
									{},
									{
										"formattedValue": "Lunch"
									},
									{},
									{
										"formattedValue": "Lunch"
									},
									{},
									{
										"formattedValue": "Lunch"
									},
									{}
								]
							},
							{
								"values": [
									{
										"formattedValue": "11:45 - 12:00"
									},
									{
										"formattedValue": "1C"
									},
									{
										"formattedValue": "Lunch"
									},
									{},
									{
										"formattedValue": "Lunch"
									},
									{},
									{
										"formattedValue": "Lunch"
									},
									{},
									{
										"formattedValue": "Lunch"
									},
									{},
									{
										"formattedValue": "Lunch"
									},
									{}
								]
							},
							{
								"values": [
									{
										"formattedValue": "12:00 - 12:15"
									},
									{
										"formattedValue": "1C"
									},
									{
										"formattedValue": "Lunch"
									},
									{},
									{
										"formattedValue": "Lunch"
									},
									{},
									{
										"formattedValue": "Lunch"
									},
									{},
									{
										"formattedValue": "Lunch"
									},
									{},
									{
										"formattedValue": "Lunch"
									},
									{}
								]
							},
							{
								"values": [
									{
										"formattedValue": "12:15 - 12:30"
									},
									{
										"formattedValue": "1C"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "1C"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "1C"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "1C"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "1C"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "1C"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "12:30-12:45"
									},
									{
										"formattedValue": "1C"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "1C"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "1C"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "1C"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "1C"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "1C"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "12:45-1:00"
									},
									{
										"formattedValue": "1C"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "1C"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "1C"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "1C"
									},
									{
										"formattedValue": "PD"
									},
									{
										"formattedValue": "1C"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "1C"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "1:00 - 1:15"
									},
									{
										"formattedValue": "1C"
									},
									{
										"formattedValue": "Prep"
									},
									{},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "1C"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "1C"
									},
									{
										"formattedValue": "PD"
									},
									{
										"formattedValue": "1C"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "1C"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "1:15 - 1:30"
									},
									{
										"formattedValue": "1C"
									},
									{
										"formattedValue": "Prep"
									},
									{},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "1C"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "1C"
									},
									{
										"formattedValue": "PD"
									},
									{
										"formattedValue": "1C"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "1C"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "1:30 - 1:45"
									},
									{
										"formattedValue": "1C"
									},
									{
										"formattedValue": "PE"
									},
									{
										"formattedValue": "1C"
									},
									{
										"formattedValue": "PE"
									},
									{
										"formattedValue": "1C"
									},
									{
										"formattedValue": "PE"
									},
									{
										"formattedValue": "1C"
									},
									{
										"formattedValue": "PD"
									},
									{
										"formattedValue": "1C"
									},
									{
										"formattedValue": "PE"
									},
									{
										"formattedValue": "1C"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "1:45-2:00"
									},
									{
										"formattedValue": "1C"
									},
									{
										"formattedValue": "PE"
									},
									{
										"formattedValue": "1C"
									},
									{
										"formattedValue": "PE"
									},
									{
										"formattedValue": "1C"
									},
									{
										"formattedValue": "PE"
									},
									{
										"formattedValue": "1C"
									},
									{
										"formattedValue": "PD"
									},
									{
										"formattedValue": "1C"
									},
									{
										"formattedValue": "PE"
									},
									{
										"formattedValue": "1C"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "7:45-8:00"
									},
									{
										"formattedValue": "2A"
									},
									{
										"formattedValue": "Intake"
									},
									{
										"formattedValue": "2A"
									},
									{
										"formattedValue": "Intake"
									},
									{
										"formattedValue": "2A"
									},
									{
										"formattedValue": "Intake"
									},
									{
										"formattedValue": "2A"
									},
									{
										"formattedValue": "Intake"
									},
									{
										"formattedValue": "2A"
									},
									{
										"formattedValue": "Intake"
									},
									{
										"formattedValue": "2A"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "8:00-8:15"
									},
									{
										"formattedValue": "2A"
									},
									{
										"formattedValue": "ELD"
									},
									{
										"formattedValue": "2A"
									},
									{
										"formattedValue": "ELD"
									},
									{
										"formattedValue": "2A"
									},
									{
										"formattedValue": "ELD"
									},
									{
										"formattedValue": "2A"
									},
									{
										"formattedValue": "ELD"
									},
									{
										"formattedValue": "2A"
									},
									{
										"formattedValue": "ELD"
									},
									{
										"formattedValue": "2A"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "8:15-8:30"
									},
									{
										"formattedValue": "2A"
									},
									{
										"formattedValue": "ELD"
									},
									{
										"formattedValue": "2A"
									},
									{
										"formattedValue": "ELD"
									},
									{
										"formattedValue": "2A"
									},
									{
										"formattedValue": "ELD"
									},
									{
										"formattedValue": "2A"
									},
									{
										"formattedValue": "ELD"
									},
									{
										"formattedValue": "2A"
									},
									{
										"formattedValue": "ELD"
									},
									{
										"formattedValue": "2A"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "8:30 - 8:45"
									},
									{
										"formattedValue": "2A"
									},
									{
										"formattedValue": "Ins"
									},
									{},
									{
										"formattedValue": "PWG"
									},
									{
										"formattedValue": "2A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "2A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "2A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "2A"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "8:45-9:00"
									},
									{
										"formattedValue": "2A"
									},
									{
										"formattedValue": "Ins"
									},
									{},
									{
										"formattedValue": "PWG"
									},
									{
										"formattedValue": "2A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "2A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "2A"
									},
									{
										"formattedValue": "PE"
									},
									{
										"formattedValue": "2A"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "9:00-9:15"
									},
									{
										"formattedValue": "2A"
									},
									{
										"formattedValue": "PE"
									},
									{
										"formattedValue": "2A"
									},
									{
										"formattedValue": "PE"
									},
									{
										"formattedValue": "2A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "2A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "2A"
									},
									{
										"formattedValue": "PE"
									},
									{
										"formattedValue": "2A"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "9:15 - 9:30"
									},
									{
										"formattedValue": "2A"
									},
									{
										"formattedValue": "PE"
									},
									{
										"formattedValue": "2A"
									},
									{
										"formattedValue": "PE"
									},
									{
										"formattedValue": "2A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "2A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "2A"
									},
									{
										"formattedValue": "PE"
									},
									{
										"formattedValue": "2A"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "9:30-9:45"
									},
									{
										"formattedValue": "2A"
									},
									{
										"formattedValue": "Rec"
									},
									{
										"formattedValue": "2A"
									},
									{
										"formattedValue": "Rec"
									},
									{
										"formattedValue": "2A"
									},
									{
										"formattedValue": "Rec"
									},
									{
										"formattedValue": "2A"
									},
									{
										"formattedValue": "Rec"
									},
									{
										"formattedValue": "2A"
									},
									{
										"formattedValue": "Rec"
									},
									{
										"formattedValue": "2A"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "9:45-10:00"
									},
									{
										"formattedValue": "2A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "2A"
									},
									{
										"formattedValue": "Prep"
									},
									{},
									{
										"formattedValue": "COTEACH"
									},
									{
										"formattedValue": "2A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "2A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "2A"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "10:00 - 10:15"
									},
									{
										"formattedValue": "2A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "2A"
									},
									{
										"formattedValue": "Prep"
									},
									{},
									{
										"formattedValue": "COTEACH"
									},
									{
										"formattedValue": "2A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "2A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "2A"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "10:15 - 10:30"
									},
									{
										"formattedValue": "2A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "2A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "2A"
									},
									{
										"formattedValue": "COTEACH"
									},
									{
										"formattedValue": "2A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "2A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "2A"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "10:30 - 10:45"
									},
									{
										"formattedValue": "2A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "2A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "2A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "2A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "2A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "2A"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "10:45 - 11:00"
									},
									{
										"formattedValue": "2A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "2A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "2A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "2A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "2A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "2A"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "11:00 - 11:15"
									},
									{
										"formattedValue": "2A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "2A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "2A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "2A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "2A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "2A"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "11:15 - 11:30"
									},
									{
										"formattedValue": "2A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "2A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "2A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "2A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "2A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "2A"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "11:30 - 11:45"
									},
									{
										"formattedValue": "2A"
									},
									{
										"formattedValue": "Lunch"
									},
									{},
									{
										"formattedValue": "Lunch"
									},
									{},
									{
										"formattedValue": "Lunch"
									},
									{},
									{
										"formattedValue": "Lunch"
									},
									{},
									{
										"formattedValue": "Lunch"
									},
									{}
								]
							},
							{
								"values": [
									{
										"formattedValue": "11:45 - 12:00"
									},
									{
										"formattedValue": "2A"
									},
									{
										"formattedValue": "Lunch"
									},
									{},
									{
										"formattedValue": "Lunch"
									},
									{},
									{
										"formattedValue": "Lunch"
									},
									{},
									{
										"formattedValue": "Lunch"
									},
									{},
									{
										"formattedValue": "Lunch"
									},
									{}
								]
							},
							{
								"values": [
									{
										"formattedValue": "12:00 - 12:15"
									},
									{
										"formattedValue": "2A"
									},
									{
										"formattedValue": "Lunch"
									},
									{},
									{
										"formattedValue": "Lunch"
									},
									{},
									{
										"formattedValue": "Lunch"
									},
									{},
									{
										"formattedValue": "Lunch"
									},
									{},
									{
										"formattedValue": "Lunch"
									},
									{}
								]
							},
							{
								"values": [
									{
										"formattedValue": "12:15 - 12:30"
									},
									{
										"formattedValue": "2A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "2A"
									},
									{
										"formattedValue": "Ins"
									},
									{},
									{
										"formattedValue": "Prep"
									},
									{
										"formattedValue": "2A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "2A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "2A"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "12:30-12:45"
									},
									{
										"formattedValue": "2A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "2A"
									},
									{
										"formattedValue": "Ins"
									},
									{},
									{
										"formattedValue": "Prep"
									},
									{
										"formattedValue": "2A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "2A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "2A"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "12:45-1:00"
									},
									{
										"formattedValue": "2A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "2A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "2A"
									},
									{
										"formattedValue": "Prep"
									},
									{
										"formattedValue": "2A"
									},
									{
										"formattedValue": "PD"
									},
									{
										"formattedValue": "2A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "2A"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "1:00 - 1:15"
									},
									{
										"formattedValue": "2A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "2A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "2A"
									},
									{
										"formattedValue": "Prep"
									},
									{
										"formattedValue": "2A"
									},
									{
										"formattedValue": "PD"
									},
									{
										"formattedValue": "2A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "2A"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "1:15 - 1:30"
									},
									{
										"formattedValue": "2A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "2A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "2A"
									},
									{
										"formattedValue": "Prep"
									},
									{
										"formattedValue": "2A"
									},
									{
										"formattedValue": "PD"
									},
									{
										"formattedValue": "2A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "2A"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "1:30 - 1:45"
									},
									{
										"formattedValue": "2A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "2A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "2A"
									},
									{
										"formattedValue": "Prep"
									},
									{
										"formattedValue": "2A"
									},
									{
										"formattedValue": "PD"
									},
									{
										"formattedValue": "2A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "2A"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "1:45-2:00"
									},
									{
										"formattedValue": "2A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "2A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "2A"
									},
									{
										"formattedValue": "Prep"
									},
									{
										"formattedValue": "2A"
									},
									{
										"formattedValue": "PD"
									},
									{
										"formattedValue": "2A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "2A"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "7:45-8:00"
									},
									{
										"formattedValue": "2B"
									},
									{
										"formattedValue": "Intake"
									},
									{
										"formattedValue": "2B"
									},
									{
										"formattedValue": "Intake"
									},
									{
										"formattedValue": "2B"
									},
									{
										"formattedValue": "Intake"
									},
									{
										"formattedValue": "2B"
									},
									{
										"formattedValue": "Intake"
									},
									{
										"formattedValue": "2B"
									},
									{
										"formattedValue": "Intake"
									},
									{
										"formattedValue": "2B"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "8:00-8:15"
									},
									{
										"formattedValue": "2B"
									},
									{
										"formattedValue": "ELD"
									},
									{
										"formattedValue": "2B"
									},
									{
										"formattedValue": "ELD"
									},
									{
										"formattedValue": "2B"
									},
									{
										"formattedValue": "ELD"
									},
									{
										"formattedValue": "2B"
									},
									{
										"formattedValue": "ELD"
									},
									{
										"formattedValue": "2B"
									},
									{
										"formattedValue": "ELD"
									},
									{
										"formattedValue": "2B"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "8:15-8:30"
									},
									{
										"formattedValue": "2B"
									},
									{
										"formattedValue": "ELD"
									},
									{
										"formattedValue": "2B"
									},
									{
										"formattedValue": "ELD"
									},
									{
										"formattedValue": "2B"
									},
									{
										"formattedValue": "ELD"
									},
									{
										"formattedValue": "2B"
									},
									{
										"formattedValue": "ELD"
									},
									{
										"formattedValue": "2B"
									},
									{
										"formattedValue": "ELD"
									},
									{
										"formattedValue": "2B"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "8:30 - 8:45"
									},
									{
										"formattedValue": "2B"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "2B"
									},
									{
										"formattedValue": "PWG"
									},
									{
										"formattedValue": "2B"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "2B"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "2B"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "2B"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "8:45-9:00"
									},
									{
										"formattedValue": "2B"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "2B"
									},
									{
										"formattedValue": "PWG"
									},
									{
										"formattedValue": "2B"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "2B"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "2B"
									},
									{
										"formattedValue": "PE"
									},
									{
										"formattedValue": "2B"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "9:00-9:15"
									},
									{
										"formattedValue": "2B"
									},
									{
										"formattedValue": "PE"
									},
									{
										"formattedValue": "2B"
									},
									{
										"formattedValue": "PE"
									},
									{
										"formattedValue": "2B"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "2B"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "2B"
									},
									{
										"formattedValue": "PE"
									},
									{
										"formattedValue": "2B"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "9:15 - 9:30"
									},
									{
										"formattedValue": "2B"
									},
									{
										"formattedValue": "PE"
									},
									{
										"formattedValue": "2B"
									},
									{
										"formattedValue": "PE"
									},
									{
										"formattedValue": "2B"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "2B"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "2B"
									},
									{
										"formattedValue": "PE"
									},
									{
										"formattedValue": "2B"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "9:30-9:45"
									},
									{
										"formattedValue": "2B"
									},
									{
										"formattedValue": "Rec"
									},
									{
										"formattedValue": "2B"
									},
									{
										"formattedValue": "Rec"
									},
									{
										"formattedValue": "2B"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "2B"
									},
									{
										"formattedValue": "Rec"
									},
									{
										"formattedValue": "2B"
									},
									{
										"formattedValue": "Rec"
									},
									{
										"formattedValue": "2B"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "9:45-10:00"
									},
									{
										"formattedValue": "2B"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "2B"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "2B"
									},
									{
										"formattedValue": "COTEACH"
									},
									{
										"formattedValue": "2B"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "2B"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "2B"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "10:00 - 10:15"
									},
									{
										"formattedValue": "2B"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "2B"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "2B"
									},
									{
										"formattedValue": "COTEACH"
									},
									{
										"formattedValue": "2B"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "2B"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "2B"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "10:15 - 10:30"
									},
									{
										"formattedValue": "2B"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "2B"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "2B"
									},
									{
										"formattedValue": "COTEACH"
									},
									{
										"formattedValue": "2B"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "2B"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "2B"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "10:30 - 10:45"
									},
									{
										"formattedValue": "2B"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "2B"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "2B"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "2B"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "2B"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "2B"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "10:45 - 11:00"
									},
									{
										"formattedValue": "2B"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "2B"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "2B"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "2B"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "2B"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "2B"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "11:00 - 11:15"
									},
									{
										"formattedValue": "2B"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "2B"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "2B"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "2B"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "2B"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "2B"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "11:15 - 11:30"
									},
									{
										"formattedValue": "2B"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "2B"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "2B"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "2B"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "2B"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "2B"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "11:30 - 11:45"
									},
									{
										"formattedValue": "2B"
									},
									{
										"formattedValue": "Lunch"
									},
									{},
									{
										"formattedValue": "Lunch"
									},
									{},
									{
										"formattedValue": "Lunch"
									},
									{},
									{
										"formattedValue": "Lunch"
									},
									{},
									{
										"formattedValue": "Lunch"
									},
									{}
								]
							},
							{
								"values": [
									{
										"formattedValue": "11:45 - 12:00"
									},
									{
										"formattedValue": "2B"
									},
									{
										"formattedValue": "Lunch"
									},
									{},
									{
										"formattedValue": "Lunch"
									},
									{},
									{
										"formattedValue": "Lunch"
									},
									{},
									{
										"formattedValue": "Lunch"
									},
									{},
									{
										"formattedValue": "Lunch"
									},
									{}
								]
							},
							{
								"values": [
									{
										"formattedValue": "12:00 - 12:15"
									},
									{
										"formattedValue": "2B"
									},
									{
										"formattedValue": "Lunch"
									},
									{},
									{
										"formattedValue": "Lunch"
									},
									{},
									{
										"formattedValue": "Lunch"
									},
									{},
									{
										"formattedValue": "Lunch"
									},
									{},
									{
										"formattedValue": "Lunch"
									},
									{}
								]
							},
							{
								"values": [
									{
										"formattedValue": "12:15 - 12:30"
									},
									{
										"formattedValue": "2B"
									},
									{
										"formattedValue": "Prep"
									},
									{
										"formattedValue": "2B"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "2B"
									},
									{
										"formattedValue": "Prep"
									},
									{},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "2B"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "2B"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "12:30-12:45"
									},
									{
										"formattedValue": "2B"
									},
									{
										"formattedValue": "Prep"
									},
									{
										"formattedValue": "2B"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "2B"
									},
									{
										"formattedValue": "Prep"
									},
									{},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "2B"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "2B"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "12:45-1:00"
									},
									{
										"formattedValue": "2B"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "2B"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "2B"
									},
									{
										"formattedValue": "Prep"
									},
									{},
									{
										"formattedValue": "PD"
									},
									{
										"formattedValue": "2B"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "2B"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "1:00 - 1:15"
									},
									{
										"formattedValue": "2B"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "2B"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "2B"
									},
									{
										"formattedValue": "Prep"
									},
									{},
									{
										"formattedValue": "PD"
									},
									{
										"formattedValue": "2B"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "2B"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "1:15 - 1:30"
									},
									{
										"formattedValue": "2B"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "2B"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "2B"
									},
									{
										"formattedValue": "Prep"
									},
									{},
									{
										"formattedValue": "PD"
									},
									{
										"formattedValue": "2B"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "2B"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "1:30 - 1:45"
									},
									{
										"formattedValue": "2B"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "2B"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "2B"
									},
									{
										"formattedValue": "Prep"
									},
									{},
									{
										"formattedValue": "PD"
									},
									{
										"formattedValue": "2B"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "2B"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "1:45-2:00"
									},
									{
										"formattedValue": "2B"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "2B"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "2B"
									},
									{
										"formattedValue": "Prep"
									},
									{},
									{
										"formattedValue": "PD"
									},
									{
										"formattedValue": "2B"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "2B"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "7:45-8:00"
									},
									{
										"formattedValue": "3A"
									},
									{
										"formattedValue": "Intake"
									},
									{
										"formattedValue": "3A"
									},
									{
										"formattedValue": "Intake"
									},
									{
										"formattedValue": "3A"
									},
									{
										"formattedValue": "Intake"
									},
									{
										"formattedValue": "3A"
									},
									{
										"formattedValue": "Intake"
									},
									{
										"formattedValue": "3A"
									},
									{
										"formattedValue": "Intake"
									},
									{
										"formattedValue": "3A"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "8:00-8:15"
									},
									{
										"formattedValue": "3A"
									},
									{
										"formattedValue": "ELD"
									},
									{
										"formattedValue": "3A"
									},
									{
										"formattedValue": "ELD"
									},
									{
										"formattedValue": "3A"
									},
									{
										"formattedValue": "ELD"
									},
									{
										"formattedValue": "3A"
									},
									{
										"formattedValue": "ELD"
									},
									{
										"formattedValue": "3A"
									},
									{
										"formattedValue": "ELD"
									},
									{
										"formattedValue": "3A"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "8:15-8:30"
									},
									{
										"formattedValue": "3A"
									},
									{
										"formattedValue": "ELD"
									},
									{
										"formattedValue": "3A"
									},
									{
										"formattedValue": "ELD"
									},
									{
										"formattedValue": "3A"
									},
									{
										"formattedValue": "ELD"
									},
									{
										"formattedValue": "3A"
									},
									{
										"formattedValue": "ELD"
									},
									{
										"formattedValue": "3A"
									},
									{
										"formattedValue": "ELD"
									},
									{
										"formattedValue": "3A"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "8:30 - 8:45"
									},
									{
										"formattedValue": "3A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "3A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "3A"
									},
									{
										"formattedValue": "Prep"
									},
									{
										"formattedValue": "3A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "3A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "3A"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "8:45-9:00"
									},
									{
										"formattedValue": "3A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "3A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "3A"
									},
									{
										"formattedValue": "Prep"
									},
									{
										"formattedValue": "3A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "3A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "3A"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "9:00-9:15"
									},
									{
										"formattedValue": "3A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "3A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "3A"
									},
									{
										"formattedValue": "Prep"
									},
									{
										"formattedValue": "3A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "3A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "3A"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "9:15 - 9:30"
									},
									{
										"formattedValue": "3A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "3A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "3A"
									},
									{
										"formattedValue": "Prep"
									},
									{
										"formattedValue": "3A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "3A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "3A"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "9:30-9:45"
									},
									{
										"formattedValue": "3A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "3A"
									},
									{
										"formattedValue": "VAPA"
									},
									{},
									{
										"formattedValue": "Prep"
									},
									{
										"formattedValue": "3A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "3A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "3A"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "9:45-10:00"
									},
									{
										"formattedValue": "3A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "3A"
									},
									{
										"formattedValue": "VAPA"
									},
									{},
									{
										"formattedValue": "Prep"
									},
									{
										"formattedValue": "3A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "3A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "3A"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "10:00 - 10:15"
									},
									{
										"formattedValue": "3A"
									},
									{
										"formattedValue": "Rec"
									},
									{
										"formattedValue": "3A"
									},
									{
										"formattedValue": "Rec"
									},
									{
										"formattedValue": "3A"
									},
									{
										"formattedValue": "Rec"
									},
									{
										"formattedValue": "3A"
									},
									{
										"formattedValue": "Rec"
									},
									{
										"formattedValue": "3A"
									},
									{
										"formattedValue": "Rec"
									},
									{
										"formattedValue": "3A"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "10:15 - 10:30"
									},
									{
										"formattedValue": "3A"
									},
									{
										"formattedValue": "PE"
									},
									{
										"formattedValue": "3A"
									},
									{
										"formattedValue": "PE"
									},
									{
										"formattedValue": "3A"
									},
									{
										"formattedValue": "Prep"
									},
									{
										"formattedValue": "3A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "3A"
									},
									{
										"formattedValue": "PE"
									},
									{
										"formattedValue": "3A"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "10:30 - 10:45"
									},
									{
										"formattedValue": "3A"
									},
									{
										"formattedValue": "PE"
									},
									{
										"formattedValue": "3A"
									},
									{
										"formattedValue": "PE"
									},
									{
										"formattedValue": "3A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "3A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "3A"
									},
									{
										"formattedValue": "PE"
									},
									{
										"formattedValue": "3A"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "10:45 - 11:00"
									},
									{
										"formattedValue": "3A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "3A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "3A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "3A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "3A"
									},
									{
										"formattedValue": "PE"
									},
									{
										"formattedValue": "3A"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "11:00 - 11:15"
									},
									{
										"formattedValue": "3A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "3A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "3A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "3A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "3A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "3A"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "11:15 - 11:30"
									},
									{
										"formattedValue": "3A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "3A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "3A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "3A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "3A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "3A"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "11:30 - 11:45"
									},
									{
										"formattedValue": "3A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "3A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "3A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "3A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "3A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "3A"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "11:45 - 12:00"
									},
									{
										"formattedValue": "3A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "3A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "3A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "3A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "3A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "3A"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "12:00 - 12:15"
									},
									{
										"formattedValue": "3A"
									},
									{
										"formattedValue": "Lunch"
									},
									{},
									{
										"formattedValue": "Lunch"
									},
									{},
									{
										"formattedValue": "Lunch"
									},
									{},
									{
										"formattedValue": "Lunch"
									},
									{},
									{
										"formattedValue": "Lunch"
									},
									{}
								]
							},
							{
								"values": [
									{
										"formattedValue": "12:15 - 12:30"
									},
									{
										"formattedValue": "3A"
									},
									{
										"formattedValue": "Lunch"
									},
									{},
									{
										"formattedValue": "Lunch"
									},
									{},
									{
										"formattedValue": "Lunch"
									},
									{},
									{
										"formattedValue": "Lunch"
									},
									{},
									{
										"formattedValue": "Lunch"
									},
									{}
								]
							},
							{
								"values": [
									{
										"formattedValue": "12:30-12:45"
									},
									{
										"formattedValue": "3A"
									},
									{
										"formattedValue": "Lunch"
									},
									{},
									{
										"formattedValue": "Lunch"
									},
									{},
									{
										"formattedValue": "Lunch"
									},
									{},
									{
										"formattedValue": "Lunch"
									},
									{},
									{
										"formattedValue": "Lunch"
									},
									{}
								]
							},
							{
								"values": [
									{
										"formattedValue": "12:45-1:00"
									},
									{
										"formattedValue": "3A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "3A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "3A"
									},
									{
										"formattedValue": "COTEACH"
									},
									{
										"formattedValue": "3A"
									},
									{
										"formattedValue": "PD"
									},
									{
										"formattedValue": "3A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "3A"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "1:00 - 1:15"
									},
									{
										"formattedValue": "3A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "3A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "3A"
									},
									{
										"formattedValue": "COTEACH"
									},
									{
										"formattedValue": "3A"
									},
									{
										"formattedValue": "PD"
									},
									{
										"formattedValue": "3A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "3A"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "1:15 - 1:30"
									},
									{
										"formattedValue": "3A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "3A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "3A"
									},
									{
										"formattedValue": "COTEACH"
									},
									{
										"formattedValue": "3A"
									},
									{
										"formattedValue": "PD"
									},
									{
										"formattedValue": "3A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "3A"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "1:30 - 1:45"
									},
									{
										"formattedValue": "3A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "3A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "3A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "3A"
									},
									{
										"formattedValue": "PD"
									},
									{
										"formattedValue": "3A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "3A"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "1:45-2:00"
									},
									{
										"formattedValue": "3A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "3A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "3A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "3A"
									},
									{
										"formattedValue": "PD"
									},
									{
										"formattedValue": "3A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "3A"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "7:45-8:00"
									},
									{
										"formattedValue": "3B"
									},
									{
										"formattedValue": "Intake"
									},
									{
										"formattedValue": "3B"
									},
									{
										"formattedValue": "Intake"
									},
									{
										"formattedValue": "3B"
									},
									{
										"formattedValue": "Intake"
									},
									{
										"formattedValue": "3B"
									},
									{
										"formattedValue": "Intake"
									},
									{
										"formattedValue": "3B"
									},
									{
										"formattedValue": "Intake"
									},
									{
										"formattedValue": "3B"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "8:00-8:15"
									},
									{
										"formattedValue": "3B"
									},
									{
										"formattedValue": "ELD"
									},
									{
										"formattedValue": "3B"
									},
									{
										"formattedValue": "ELD"
									},
									{
										"formattedValue": "3B"
									},
									{
										"formattedValue": "ELD"
									},
									{
										"formattedValue": "3B"
									},
									{
										"formattedValue": "ELD"
									},
									{
										"formattedValue": "3B"
									},
									{
										"formattedValue": "ELD"
									},
									{
										"formattedValue": "3B"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "8:15-8:30"
									},
									{
										"formattedValue": "3B"
									},
									{
										"formattedValue": "ELD"
									},
									{
										"formattedValue": "3B"
									},
									{
										"formattedValue": "ELD"
									},
									{
										"formattedValue": "3B"
									},
									{
										"formattedValue": "ELD"
									},
									{
										"formattedValue": "3B"
									},
									{
										"formattedValue": "ELD"
									},
									{
										"formattedValue": "3B"
									},
									{
										"formattedValue": "ELD"
									},
									{
										"formattedValue": "3B"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "8:30 - 8:45"
									},
									{
										"formattedValue": "3B"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "3B"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "3B"
									},
									{
										"formattedValue": "Prep"
									},
									{
										"formattedValue": "3B"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "3B"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "3B"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "8:45-9:00"
									},
									{
										"formattedValue": "3B"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "3B"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "3B"
									},
									{
										"formattedValue": "Prep"
									},
									{
										"formattedValue": "3B"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "3B"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "3B"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "9:00-9:15"
									},
									{
										"formattedValue": "3B"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "3B"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "3B"
									},
									{
										"formattedValue": "Prep"
									},
									{
										"formattedValue": "3B"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "3B"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "3B"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "9:15 - 9:30"
									},
									{
										"formattedValue": "3B"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "3B"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "3B"
									},
									{
										"formattedValue": "Prep"
									},
									{
										"formattedValue": "3B"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "3B"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "3B"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "9:30-9:45"
									},
									{
										"formattedValue": "3B"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "3B"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "3B"
									},
									{
										"formattedValue": "Prep"
									},
									{
										"formattedValue": "3B"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "3B"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "3B"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "9:45-10:00"
									},
									{
										"formattedValue": "3B"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "3B"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "3B"
									},
									{
										"formattedValue": "Prep"
									},
									{
										"formattedValue": "3B"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "3B"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "3B"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "10:00 - 10:15"
									},
									{
										"formattedValue": "3B"
									},
									{
										"formattedValue": "Rec"
									},
									{
										"formattedValue": "3B"
									},
									{
										"formattedValue": "Rec"
									},
									{
										"formattedValue": "3B"
									},
									{
										"formattedValue": "Rec"
									},
									{
										"formattedValue": "3B"
									},
									{
										"formattedValue": "Rec"
									},
									{
										"formattedValue": "3B"
									},
									{
										"formattedValue": "Rec"
									},
									{
										"formattedValue": "3B"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "10:15 - 10:30"
									},
									{
										"formattedValue": "3B"
									},
									{
										"formattedValue": "PE"
									},
									{
										"formattedValue": "3B"
									},
									{
										"formattedValue": "PE"
									},
									{
										"formattedValue": "3B"
									},
									{
										"formattedValue": "Prep"
									},
									{
										"formattedValue": "3B"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "3B"
									},
									{
										"formattedValue": "PE"
									},
									{
										"formattedValue": "3B"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "10:30 - 10:45"
									},
									{
										"formattedValue": "3B"
									},
									{
										"formattedValue": "PE"
									},
									{
										"formattedValue": "3B"
									},
									{
										"formattedValue": "PE"
									},
									{
										"formattedValue": "3B"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "3B"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "3B"
									},
									{
										"formattedValue": "PE"
									},
									{
										"formattedValue": "3B"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "10:45 - 11:00"
									},
									{
										"formattedValue": "3B"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "3B"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "3B"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "3B"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "3B"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "3B"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "11:00 - 11:15"
									},
									{
										"formattedValue": "3B"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "3B"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "3B"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "3B"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "3B"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "3B"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "11:15 - 11:30"
									},
									{
										"formattedValue": "3B"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "3B"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "3B"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "3B"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "3B"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "3B"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "11:30 - 11:45"
									},
									{
										"formattedValue": "3B"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "3B"
									},
									{
										"formattedValue": "VAPA"
									},
									{},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "3B"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "3B"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "3B"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "11:45 - 12:00"
									},
									{
										"formattedValue": "3B"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "3B"
									},
									{
										"formattedValue": "VAPA"
									},
									{},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "3B"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "3B"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "3B"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "12:00-12:15"
									},
									{
										"formattedValue": "3B"
									},
									{
										"formattedValue": "Lunch"
									},
									{},
									{
										"formattedValue": "Lunch"
									},
									{},
									{
										"formattedValue": "Lunch"
									},
									{},
									{
										"formattedValue": "Lunch"
									},
									{},
									{
										"formattedValue": "Lunch"
									},
									{}
								]
							},
							{
								"values": [
									{
										"formattedValue": "12:15-12:30"
									},
									{
										"formattedValue": "3B"
									},
									{
										"formattedValue": "Lunch"
									},
									{},
									{
										"formattedValue": "Lunch"
									},
									{},
									{
										"formattedValue": "Lunch"
									},
									{},
									{
										"formattedValue": "Lunch"
									},
									{},
									{
										"formattedValue": "Lunch"
									},
									{}
								]
							},
							{
								"values": [
									{
										"formattedValue": "12:30-12:45"
									},
									{
										"formattedValue": "3B"
									},
									{
										"formattedValue": "Lunch"
									},
									{},
									{
										"formattedValue": "Lunch"
									},
									{},
									{
										"formattedValue": "Lunch"
									},
									{},
									{
										"formattedValue": "Lunch"
									},
									{},
									{
										"formattedValue": "Lunch"
									},
									{}
								]
							},
							{
								"values": [
									{
										"formattedValue": "12:45-1:00"
									},
									{
										"formattedValue": "3B"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "3B"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "3B"
									},
									{
										"formattedValue": "COTEACH"
									},
									{
										"formattedValue": "3B"
									},
									{
										"formattedValue": "PD"
									},
									{
										"formattedValue": "3B"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "3B"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "1:00 - 1:15"
									},
									{
										"formattedValue": "3B"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "3B"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "3B"
									},
									{
										"formattedValue": "COTEACH"
									},
									{
										"formattedValue": "3B"
									},
									{
										"formattedValue": "PD"
									},
									{
										"formattedValue": "3B"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "3B"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "1:15 - 1:30"
									},
									{
										"formattedValue": "3B"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "3B"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "3B"
									},
									{
										"formattedValue": "COTEACH"
									},
									{
										"formattedValue": "3B"
									},
									{
										"formattedValue": "PD"
									},
									{
										"formattedValue": "3B"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "3B"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "1:30 - 1:45"
									},
									{
										"formattedValue": "3B"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "3B"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "3B"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "3B"
									},
									{
										"formattedValue": "PD"
									},
									{
										"formattedValue": "3B"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "3B"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "1:45-2:00"
									},
									{
										"formattedValue": "3B"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "3B"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "3B"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "3B"
									},
									{
										"formattedValue": "PD"
									},
									{
										"formattedValue": "3B"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "3B"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "7:45-8:00"
									},
									{
										"formattedValue": "4A"
									},
									{
										"formattedValue": "Intake"
									},
									{
										"formattedValue": "4A"
									},
									{
										"formattedValue": "Intake"
									},
									{
										"formattedValue": "4A"
									},
									{
										"formattedValue": "Intake"
									},
									{
										"formattedValue": "4A"
									},
									{
										"formattedValue": "Intake"
									},
									{
										"formattedValue": "4A"
									},
									{
										"formattedValue": "Intake"
									},
									{
										"formattedValue": "4A"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "8:00-8:15"
									},
									{
										"formattedValue": "4A"
									},
									{
										"formattedValue": "ELD"
									},
									{
										"formattedValue": "4A"
									},
									{
										"formattedValue": "ELD"
									},
									{
										"formattedValue": "4A"
									},
									{
										"formattedValue": "ELD"
									},
									{
										"formattedValue": "4A"
									},
									{
										"formattedValue": "ELD"
									},
									{
										"formattedValue": "4A"
									},
									{
										"formattedValue": "ELD"
									},
									{
										"formattedValue": "4A"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "8:15-8:30"
									},
									{
										"formattedValue": "4A"
									},
									{
										"formattedValue": "ELD"
									},
									{
										"formattedValue": "4A"
									},
									{
										"formattedValue": "ELD"
									},
									{
										"formattedValue": "4A"
									},
									{
										"formattedValue": "ELD"
									},
									{
										"formattedValue": "4A"
									},
									{
										"formattedValue": "ELD"
									},
									{
										"formattedValue": "4A"
									},
									{
										"formattedValue": "ELD"
									},
									{
										"formattedValue": "4A"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "8:30 - 8:45"
									},
									{
										"formattedValue": "4A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "4A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "4A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "4A"
									},
									{
										"formattedValue": "Prep"
									},
									{},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "4A"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "8:45-9:00"
									},
									{
										"formattedValue": "4A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "4A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "4A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "4A"
									},
									{
										"formattedValue": "Prep"
									},
									{},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "4A"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "9:00-9:15"
									},
									{
										"formattedValue": "4A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "4A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "4A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "4A"
									},
									{
										"formattedValue": "Prep"
									},
									{},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "4A"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "9:15 - 9:30"
									},
									{
										"formattedValue": "4A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "4A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "4A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "4A"
									},
									{
										"formattedValue": "Prep"
									},
									{},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "4A"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "9:30-9:45"
									},
									{
										"formattedValue": "4A"
									},
									{
										"formattedValue": "Prep"
									},
									{},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "4A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "4A"
									},
									{
										"formattedValue": "Prep"
									},
									{},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "4A"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "9:45-10:00"
									},
									{
										"formattedValue": "4A"
									},
									{
										"formattedValue": "Prep"
									},
									{},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "4A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "4A"
									},
									{
										"formattedValue": "Prep"
									},
									{},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "4A"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "10:00 - 10:15"
									},
									{
										"formattedValue": "4A"
									},
									{
										"formattedValue": "Rec"
									},
									{
										"formattedValue": "4A"
									},
									{
										"formattedValue": "Rec"
									},
									{
										"formattedValue": "4A"
									},
									{
										"formattedValue": "Rec"
									},
									{
										"formattedValue": "4A"
									},
									{
										"formattedValue": "Prep"
									},
									{},
									{
										"formattedValue": "Rec"
									},
									{
										"formattedValue": "4A"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "10:15 - 10:30"
									},
									{
										"formattedValue": "4A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "4A"
									},
									{
										"formattedValue": "PWG"
									},
									{
										"formattedValue": "4A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "4A"
									},
									{
										"formattedValue": "Prep"
									},
									{},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "4A"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "10:30 - 10:45"
									},
									{
										"formattedValue": "4A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "4A"
									},
									{
										"formattedValue": "PWG"
									},
									{
										"formattedValue": "4A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "4A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "4A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "4A"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "10:45 - 11:00"
									},
									{
										"formattedValue": "4A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "4A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "4A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "4A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "4A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "4A"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "11:00 - 11:15"
									},
									{
										"formattedValue": "4A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "4A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "4A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "4A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "4A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "4A"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "11:15 - 11:30"
									},
									{
										"formattedValue": "4A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "4A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "4A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "4A"
									},
									{
										"formattedValue": "Coteach"
									},
									{
										"formattedValue": "4A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "4A"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "11:30 - 11:45"
									},
									{
										"formattedValue": "4A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "4A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "4A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "4A"
									},
									{
										"formattedValue": "Coteach"
									},
									{
										"formattedValue": "4A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "4A"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "11:45 - 12:00"
									},
									{
										"formattedValue": "4A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "4A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "4A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "4A"
									},
									{
										"formattedValue": "Coteach"
									},
									{
										"formattedValue": "4A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "4A"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "12:00 - 12:15"
									},
									{
										"formattedValue": "4A"
									},
									{
										"formattedValue": "Lunch"
									},
									{},
									{
										"formattedValue": "Lunch"
									},
									{},
									{
										"formattedValue": "Lunch"
									},
									{},
									{
										"formattedValue": "Lunch"
									},
									{},
									{
										"formattedValue": "Lunch"
									},
									{}
								]
							},
							{
								"values": [
									{
										"formattedValue": "12:15 - 12:30"
									},
									{
										"formattedValue": "4A"
									},
									{
										"formattedValue": "Lunch"
									},
									{},
									{
										"formattedValue": "Lunch"
									},
									{},
									{
										"formattedValue": "Lunch"
									},
									{},
									{
										"formattedValue": "Lunch"
									},
									{},
									{
										"formattedValue": "Lunch"
									},
									{}
								]
							},
							{
								"values": [
									{
										"formattedValue": "12:30-12:45"
									},
									{
										"formattedValue": "4A"
									},
									{
										"formattedValue": "Lunch"
									},
									{},
									{
										"formattedValue": "Lunch"
									},
									{},
									{
										"formattedValue": "Lunch"
									},
									{},
									{
										"formattedValue": "Lunch"
									},
									{},
									{
										"formattedValue": "Lunch"
									},
									{}
								]
							},
							{
								"values": [
									{
										"formattedValue": "12:45-1:00"
									},
									{
										"formattedValue": "4A"
									},
									{
										"formattedValue": "PE"
									},
									{
										"formattedValue": "4A"
									},
									{
										"formattedValue": "PE"
									},
									{
										"formattedValue": "4A"
									},
									{
										"formattedValue": "PE"
									},
									{
										"formattedValue": "4A"
									},
									{
										"formattedValue": "PD"
									},
									{
										"formattedValue": "4A"
									},
									{
										"formattedValue": "PE"
									},
									{
										"formattedValue": "4A"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "1:00 - 1:15"
									},
									{
										"formattedValue": "4A"
									},
									{
										"formattedValue": "PE"
									},
									{
										"formattedValue": "4A"
									},
									{
										"formattedValue": "PE"
									},
									{
										"formattedValue": "4A"
									},
									{
										"formattedValue": "PE"
									},
									{
										"formattedValue": "4A"
									},
									{
										"formattedValue": "PD"
									},
									{
										"formattedValue": "4A"
									},
									{
										"formattedValue": "PE"
									},
									{
										"formattedValue": "4A"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "1:15 - 1:30"
									},
									{
										"formattedValue": "4A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "4A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "4A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "4A"
									},
									{
										"formattedValue": "PD"
									},
									{
										"formattedValue": "4A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "4A"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "1:30 - 1:45"
									},
									{
										"formattedValue": "4A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "4A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "4A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "4A"
									},
									{
										"formattedValue": "PD"
									},
									{
										"formattedValue": "4A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "4A"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "1:45-2:00"
									},
									{
										"formattedValue": "4A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "4A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "4A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "4A"
									},
									{
										"formattedValue": "PD"
									},
									{
										"formattedValue": "4A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "4A"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "7:45-8:00"
									},
									{
										"formattedValue": "4B"
									},
									{
										"formattedValue": "Intake"
									},
									{
										"formattedValue": "4B"
									},
									{
										"formattedValue": "Intake"
									},
									{
										"formattedValue": "4B"
									},
									{
										"formattedValue": "Intake"
									},
									{
										"formattedValue": "4B"
									},
									{
										"formattedValue": "Intake"
									},
									{
										"formattedValue": "4B"
									},
									{
										"formattedValue": "Intake"
									},
									{
										"formattedValue": "4B"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "8:00-8:15"
									},
									{
										"formattedValue": "4B"
									},
									{
										"formattedValue": "ELD"
									},
									{
										"formattedValue": "4B"
									},
									{
										"formattedValue": "ELD"
									},
									{
										"formattedValue": "4B"
									},
									{
										"formattedValue": "ELD"
									},
									{
										"formattedValue": "4B"
									},
									{
										"formattedValue": "ELD"
									},
									{
										"formattedValue": "4B"
									},
									{
										"formattedValue": "ELD"
									},
									{
										"formattedValue": "4B"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "8:15-8:30"
									},
									{
										"formattedValue": "4B"
									},
									{
										"formattedValue": "ELD"
									},
									{
										"formattedValue": "4B"
									},
									{
										"formattedValue": "ELD"
									},
									{
										"formattedValue": "4B"
									},
									{
										"formattedValue": "ELD"
									},
									{
										"formattedValue": "4B"
									},
									{
										"formattedValue": "ELD"
									},
									{
										"formattedValue": "4B"
									},
									{
										"formattedValue": "ELD"
									},
									{
										"formattedValue": "4B"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "8:30 - 8:45"
									},
									{
										"formattedValue": "4B"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "4B"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "4B"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "4B"
									},
									{
										"formattedValue": "Prep"
									},
									{},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "4B"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "8:45-9:00"
									},
									{
										"formattedValue": "4B"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "4B"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "4B"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "4B"
									},
									{
										"formattedValue": "Prep"
									},
									{},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "4B"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "9:00-9:15"
									},
									{
										"formattedValue": "4B"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "4B"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "4B"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "4B"
									},
									{
										"formattedValue": "Prep"
									},
									{},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "4B"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "9:15 - 9:30"
									},
									{
										"formattedValue": "4B"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "4B"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "4B"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "4B"
									},
									{
										"formattedValue": "Prep"
									},
									{},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "4B"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "9:30-9:45"
									},
									{
										"formattedValue": "4B"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "4B"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "4B"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "4B"
									},
									{
										"formattedValue": "Prep"
									},
									{},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "4B"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "9:45-10:00"
									},
									{
										"formattedValue": "4B"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "4B"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "4B"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "4B"
									},
									{
										"formattedValue": "Prep"
									},
									{},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "4B"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "10:00 - 10:15"
									},
									{
										"formattedValue": "4B"
									},
									{
										"formattedValue": "Rec"
									},
									{
										"formattedValue": "4B"
									},
									{
										"formattedValue": "Rec"
									},
									{
										"formattedValue": "4B"
									},
									{
										"formattedValue": "Rec"
									},
									{
										"formattedValue": "4B"
									},
									{
										"formattedValue": "Prep"
									},
									{},
									{
										"formattedValue": "Rec"
									},
									{
										"formattedValue": "4B"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "10:15 - 10:30"
									},
									{
										"formattedValue": "4B"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "4B"
									},
									{
										"formattedValue": "PWG"
									},
									{
										"formattedValue": "4B"
									},
									{
										"formattedValue": "PWG"
									},
									{
										"formattedValue": "4B"
									},
									{
										"formattedValue": "Prep"
									},
									{},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "4B"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "10:30 - 10:45"
									},
									{
										"formattedValue": "4B"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "4B"
									},
									{
										"formattedValue": "PWG"
									},
									{
										"formattedValue": "4B"
									},
									{
										"formattedValue": "PWG"
									},
									{
										"formattedValue": "4B"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "4B"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "4B"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "10:45 - 11:00"
									},
									{
										"formattedValue": "4B"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "4B"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "4B"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "4B"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "4B"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "4B"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "11:00 - 11:15"
									},
									{
										"formattedValue": "4B"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "4B"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "4B"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "4B"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "4B"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "4B"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "11:15 - 11:30"
									},
									{
										"formattedValue": "4B"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "4B"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "4B"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "4B"
									},
									{
										"formattedValue": "COTEACH"
									},
									{
										"formattedValue": "4B"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "4B"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "11:30 - 11:45"
									},
									{
										"formattedValue": "4B"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "4B"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "4B"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "4B"
									},
									{
										"formattedValue": "COTEACH"
									},
									{
										"formattedValue": "4B"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "4B"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "11:45 - 12:00"
									},
									{
										"formattedValue": "4B"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "4B"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "4B"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "4B"
									},
									{
										"formattedValue": "COTEACH"
									},
									{
										"formattedValue": "4B"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "4B"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "12:00 - 12:15"
									},
									{
										"formattedValue": "4B"
									},
									{
										"formattedValue": "Lunch"
									},
									{},
									{
										"formattedValue": "Lunch"
									},
									{},
									{
										"formattedValue": "Lunch"
									},
									{},
									{
										"formattedValue": "Lunch"
									},
									{},
									{
										"formattedValue": "Lunch"
									},
									{}
								]
							},
							{
								"values": [
									{
										"formattedValue": "12:15 - 12:30"
									},
									{
										"formattedValue": "4B"
									},
									{
										"formattedValue": "Lunch"
									},
									{},
									{
										"formattedValue": "Lunch"
									},
									{},
									{
										"formattedValue": "Lunch"
									},
									{},
									{
										"formattedValue": "Lunch"
									},
									{},
									{
										"formattedValue": "Lunch"
									},
									{}
								]
							},
							{
								"values": [
									{
										"formattedValue": "12:30-12:45"
									},
									{
										"formattedValue": "4B"
									},
									{
										"formattedValue": "Lunch"
									},
									{},
									{
										"formattedValue": "Lunch"
									},
									{},
									{
										"formattedValue": "Lunch"
									},
									{},
									{
										"formattedValue": "Lunch"
									},
									{},
									{
										"formattedValue": "Lunch"
									},
									{}
								]
							},
							{
								"values": [
									{
										"formattedValue": "12:45-1:00"
									},
									{
										"formattedValue": "4B"
									},
									{
										"formattedValue": "PE"
									},
									{
										"formattedValue": "4B"
									},
									{
										"formattedValue": "Prep"
									},
									{},
									{
										"formattedValue": "PE"
									},
									{
										"formattedValue": "4B"
									},
									{
										"formattedValue": "PD"
									},
									{
										"formattedValue": "4B"
									},
									{
										"formattedValue": "PE"
									},
									{
										"formattedValue": "4B"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "1:00 - 1:15"
									},
									{
										"formattedValue": "4B"
									},
									{
										"formattedValue": "PE"
									},
									{
										"formattedValue": "4B"
									},
									{
										"formattedValue": "Prep"
									},
									{},
									{
										"formattedValue": "PE"
									},
									{
										"formattedValue": "4B"
									},
									{
										"formattedValue": "PD"
									},
									{
										"formattedValue": "4B"
									},
									{
										"formattedValue": "PE"
									},
									{
										"formattedValue": "4B"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "1:15 - 1:30"
									},
									{
										"formattedValue": "4B"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "4B"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "4B"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "4B"
									},
									{
										"formattedValue": "PD"
									},
									{
										"formattedValue": "4B"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "4B"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "1:30 - 1:45"
									},
									{
										"formattedValue": "4B"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "4B"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "4B"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "4B"
									},
									{
										"formattedValue": "PD"
									},
									{
										"formattedValue": "4B"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "4B"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "1:45-2:00"
									},
									{
										"formattedValue": "4B"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "4B"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "4B"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "4B"
									},
									{
										"formattedValue": "PD"
									},
									{
										"formattedValue": "4B"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "4B"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "7:45-8:00"
									},
									{
										"formattedValue": "5A"
									},
									{
										"formattedValue": "Intake"
									},
									{
										"formattedValue": "5A"
									},
									{
										"formattedValue": "Intake"
									},
									{
										"formattedValue": "5A"
									},
									{
										"formattedValue": "Intake"
									},
									{
										"formattedValue": "5A"
									},
									{
										"formattedValue": "Intake"
									},
									{
										"formattedValue": "5A"
									},
									{
										"formattedValue": "Intake"
									},
									{
										"formattedValue": "5A"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "8:00-8:15"
									},
									{
										"formattedValue": "5A"
									},
									{
										"formattedValue": "ELD"
									},
									{
										"formattedValue": "5A"
									},
									{
										"formattedValue": "ELD"
									},
									{
										"formattedValue": "5A"
									},
									{
										"formattedValue": "ELD"
									},
									{
										"formattedValue": "5A"
									},
									{
										"formattedValue": "ELD"
									},
									{
										"formattedValue": "5A"
									},
									{
										"formattedValue": "ELD"
									},
									{
										"formattedValue": "5A"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "8:15-8:30"
									},
									{
										"formattedValue": "5A"
									},
									{
										"formattedValue": "ELD"
									},
									{
										"formattedValue": "5A"
									},
									{
										"formattedValue": "ELD"
									},
									{
										"formattedValue": "5A"
									},
									{
										"formattedValue": "ELD"
									},
									{
										"formattedValue": "5A"
									},
									{
										"formattedValue": "ELD"
									},
									{
										"formattedValue": "5A"
									},
									{
										"formattedValue": "ELD"
									},
									{
										"formattedValue": "5A"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "8:30 - 8:45"
									},
									{
										"formattedValue": "5A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "5A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "5A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "5A"
									},
									{
										"formattedValue": "Prep"
									},
									{},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "5A"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "8:45-9:00"
									},
									{
										"formattedValue": "5A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "5A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "5A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "5A"
									},
									{
										"formattedValue": "Prep"
									},
									{},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "5A"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "9:00-9:15"
									},
									{
										"formattedValue": "5A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "5A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "5A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "5A"
									},
									{
										"formattedValue": "Prep"
									},
									{},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "5A"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "9:15 - 9:30"
									},
									{
										"formattedValue": "5A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "5A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "5A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "5A"
									},
									{
										"formattedValue": "Prep"
									},
									{},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "5A"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "9:30-9:45"
									},
									{
										"formattedValue": "5A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "5A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "5A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "5A"
									},
									{
										"formattedValue": "Prep"
									},
									{},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "5A"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "9:45-10:00"
									},
									{
										"formattedValue": "5A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "5A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "5A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "5A"
									},
									{
										"formattedValue": "Prep"
									},
									{},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "5A"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "10:00 - 10:15"
									},
									{
										"formattedValue": "5A"
									},
									{
										"formattedValue": "Rec"
									},
									{
										"formattedValue": "5A"
									},
									{
										"formattedValue": "Rec"
									},
									{
										"formattedValue": "5A"
									},
									{
										"formattedValue": "Rec"
									},
									{
										"formattedValue": "5A"
									},
									{
										"formattedValue": "Prep"
									},
									{},
									{
										"formattedValue": "Rec"
									},
									{
										"formattedValue": "5A"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "10:15 - 10:30"
									},
									{
										"formattedValue": "5A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "5A"
									},
									{
										"formattedValue": "Prep"
									},
									{},
									{
										"formattedValue": "PWG"
									},
									{
										"formattedValue": "5A"
									},
									{
										"formattedValue": "Prep"
									},
									{},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "5A"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "10:30 - 10:45"
									},
									{
										"formattedValue": "5A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "5A"
									},
									{
										"formattedValue": "Prep"
									},
									{},
									{
										"formattedValue": "PWG"
									},
									{
										"formattedValue": "5A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "5A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "5A"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "10:45 - 11:00"
									},
									{
										"formattedValue": "5A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "5A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "5A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "5A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "5A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "5A"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "11:00 - 11:15"
									},
									{
										"formattedValue": "5A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "5A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "5A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "5A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "5A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "5A"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "11:15 - 11:30"
									},
									{
										"formattedValue": "5A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "5A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "5A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "5A"
									},
									{
										"formattedValue": "COTEACH"
									},
									{
										"formattedValue": "5A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "5A"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "11:30 - 11:45"
									},
									{
										"formattedValue": "5A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "5A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "5A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "5A"
									},
									{
										"formattedValue": "COTEACH"
									},
									{
										"formattedValue": "5A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "5A"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "11:45 - 12:00"
									},
									{
										"formattedValue": "5A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "5A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "5A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "5A"
									},
									{
										"formattedValue": "COTEACH"
									},
									{
										"formattedValue": "5A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "5A"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "12:00 - 12:15"
									},
									{
										"formattedValue": "5A"
									},
									{
										"formattedValue": "Lunch"
									},
									{},
									{
										"formattedValue": "Lunch"
									},
									{},
									{
										"formattedValue": "Lunch"
									},
									{},
									{
										"formattedValue": "Lunch"
									},
									{},
									{
										"formattedValue": "Lunch"
									},
									{}
								]
							},
							{
								"values": [
									{
										"formattedValue": "12:15 - 12:30"
									},
									{
										"formattedValue": "5A"
									},
									{
										"formattedValue": "Lunch"
									},
									{},
									{
										"formattedValue": "Lunch"
									},
									{},
									{
										"formattedValue": "Lunch"
									},
									{},
									{
										"formattedValue": "Lunch"
									},
									{},
									{
										"formattedValue": "Lunch"
									},
									{}
								]
							},
							{
								"values": [
									{
										"formattedValue": "12:30-12:45"
									},
									{
										"formattedValue": "5A"
									},
									{
										"formattedValue": "Lunch"
									},
									{},
									{
										"formattedValue": "Lunch"
									},
									{},
									{
										"formattedValue": "Lunch"
									},
									{},
									{
										"formattedValue": "Lunch"
									},
									{},
									{
										"formattedValue": "Lunch"
									},
									{}
								]
							},
							{
								"values": [
									{
										"formattedValue": "12:45-1:00"
									},
									{
										"formattedValue": "5A"
									},
									{
										"formattedValue": "PE"
									},
									{
										"formattedValue": "5A"
									},
									{
										"formattedValue": "PE"
									},
									{
										"formattedValue": "5A"
									},
									{
										"formattedValue": "PE"
									},
									{
										"formattedValue": "5A"
									},
									{
										"formattedValue": "PD"
									},
									{
										"formattedValue": "5A"
									},
									{
										"formattedValue": "PE"
									},
									{
										"formattedValue": "5A"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "1:00 - 1:15"
									},
									{
										"formattedValue": "5A"
									},
									{
										"formattedValue": "PE"
									},
									{
										"formattedValue": "5A"
									},
									{
										"formattedValue": "PE"
									},
									{
										"formattedValue": "5A"
									},
									{
										"formattedValue": "PE"
									},
									{
										"formattedValue": "5A"
									},
									{
										"formattedValue": "PD"
									},
									{
										"formattedValue": "5A"
									},
									{
										"formattedValue": "PE"
									},
									{
										"formattedValue": "5A"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "1:15 - 1:30"
									},
									{
										"formattedValue": "5A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "5A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "5A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "5A"
									},
									{
										"formattedValue": "PD"
									},
									{
										"formattedValue": "5A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "5A"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "1:30 - 1:45"
									},
									{
										"formattedValue": "5A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "5A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "5A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "5A"
									},
									{
										"formattedValue": "PD"
									},
									{
										"formattedValue": "5A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "5A"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "1:45-2:00"
									},
									{
										"formattedValue": "5A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "5A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "5A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "5A"
									},
									{
										"formattedValue": "PD"
									},
									{
										"formattedValue": "5A"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "5A"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "7:45-8:00"
									},
									{
										"formattedValue": "PE"
									},
									{
										"formattedValue": "Duty"
									},
									{},
									{
										"formattedValue": "Duty"
									},
									{},
									{
										"formattedValue": "Duty"
									},
									{},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "8:00-8:15"
									},
									{
										"formattedValue": "PE"
									},
									{
										"formattedValue": "Prep"
									},
									{},
									{
										"formattedValue": "Prep"
									},
									{},
									{
										"formattedValue": "Prep"
									},
									{},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "8:15-8:30"
									},
									{
										"formattedValue": "PE"
									},
									{
										"formattedValue": "Prep"
									},
									{},
									{
										"formattedValue": "Prep"
									},
									{},
									{
										"formattedValue": "Prep"
									},
									{},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "8:30 - 8:45"
									},
									{
										"formattedValue": "PE"
									},
									{
										"formattedValue": "PE KA"
									},
									{
										"formattedValue": "KA"
									},
									{
										"formattedValue": "PE KB"
									},
									{
										"formattedValue": "KB"
									},
									{
										"formattedValue": "PE KC"
									},
									{
										"formattedValue": "KC"
									},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "8:45-9:00"
									},
									{
										"formattedValue": "PE"
									},
									{
										"formattedValue": "PE KA"
									},
									{
										"formattedValue": "KA"
									},
									{
										"formattedValue": "PE KB"
									},
									{
										"formattedValue": "KB"
									},
									{
										"formattedValue": "PE KC"
									},
									{
										"formattedValue": "KC"
									},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "9:00-9:15"
									},
									{
										"formattedValue": "PE"
									},
									{
										"formattedValue": "PE 2A"
									},
									{
										"formattedValue": "2A"
									},
									{
										"formattedValue": "PE 2B"
									},
									{
										"formattedValue": "2B"
									},
									{
										"formattedValue": "Prep"
									},
									{},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "9:15 - 9:30"
									},
									{
										"formattedValue": "PE"
									},
									{
										"formattedValue": "PE 2A"
									},
									{
										"formattedValue": "2A"
									},
									{
										"formattedValue": "PE 2B"
									},
									{
										"formattedValue": "2B"
									},
									{
										"formattedValue": "Prep"
									},
									{},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "9:30-9:45"
									},
									{
										"formattedValue": "PE"
									},
									{
										"formattedValue": "Duty"
									},
									{},
									{
										"formattedValue": "Duty"
									},
									{},
									{
										"formattedValue": "Duty"
									},
									{},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "9:45-10:00"
									},
									{
										"formattedValue": "PE"
									},
									{
										"formattedValue": "Prep"
									},
									{},
									{
										"formattedValue": "Prep"
									},
									{},
									{
										"formattedValue": "Prep"
									},
									{},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "10:00 - 10:15"
									},
									{
										"formattedValue": "PE"
									},
									{
										"formattedValue": "Duty"
									},
									{},
									{
										"formattedValue": "Duty"
									},
									{},
									{
										"formattedValue": "Duty"
									},
									{},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "10:15 - 10:30"
									},
									{
										"formattedValue": "PE"
									},
									{
										"formattedValue": "PE 3A"
									},
									{
										"formattedValue": "3A"
									},
									{
										"formattedValue": "PE 3B"
									},
									{
										"formattedValue": "3B"
									},
									{
										"formattedValue": "PE 3A"
									},
									{
										"formattedValue": "3A"
									},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "10:30 - 10:45"
									},
									{
										"formattedValue": "PE"
									},
									{
										"formattedValue": "PE 3A"
									},
									{
										"formattedValue": "3A"
									},
									{
										"formattedValue": "PE 3B"
									},
									{
										"formattedValue": "3B"
									},
									{
										"formattedValue": "PE 3A"
									},
									{
										"formattedValue": "3A"
									},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "10:45 - 11:00"
									},
									{
										"formattedValue": "PE"
									},
									{
										"formattedValue": "Lunch"
									},
									{},
									{
										"formattedValue": "Lunch"
									},
									{},
									{
										"formattedValue": "Lunch"
									},
									{},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "11:00 - 11:15"
									},
									{
										"formattedValue": "PE"
									},
									{
										"formattedValue": "Lunch"
									},
									{},
									{
										"formattedValue": "Lunch"
									},
									{},
									{
										"formattedValue": "Lunch"
									},
									{},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "11:15 - 11:30"
									},
									{
										"formattedValue": "PE"
									},
									{
										"formattedValue": "Duty"
									},
									{},
									{
										"formattedValue": "Duty"
									},
									{},
									{
										"formattedValue": "Duty"
									},
									{},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "11:30 - 11:45"
									},
									{
										"formattedValue": "PE"
									},
									{
										"formattedValue": "Duty"
									},
									{},
									{
										"formattedValue": "Duty"
									},
									{},
									{
										"formattedValue": "Duty"
									},
									{},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "11:45 - 12:00"
									},
									{
										"formattedValue": "PE"
									},
									{
										"formattedValue": "Duty"
									},
									{},
									{
										"formattedValue": "Duty"
									},
									{},
									{
										"formattedValue": "Duty"
									},
									{},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "12:00 - 12:15"
									},
									{
										"formattedValue": "PE"
									},
									{
										"formattedValue": "Duty"
									},
									{},
									{
										"formattedValue": "Duty"
									},
									{},
									{
										"formattedValue": "Duty"
									},
									{},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "12:15 - 12:30"
									},
									{
										"formattedValue": "PE"
									},
									{
										"formattedValue": "Duty"
									},
									{},
									{
										"formattedValue": "Duty"
									},
									{},
									{
										"formattedValue": "Duty"
									},
									{},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "12:30-12:45"
									},
									{
										"formattedValue": "PE"
									},
									{
										"formattedValue": "Duty"
									},
									{},
									{
										"formattedValue": "Duty"
									},
									{},
									{
										"formattedValue": "Duty"
									},
									{},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "12:45-1:00"
									},
									{
										"formattedValue": "PE"
									},
									{
										"formattedValue": "PE 4A"
									},
									{
										"formattedValue": "4A"
									},
									{
										"formattedValue": "PE 4B"
									},
									{
										"formattedValue": "4B"
									},
									{
										"formattedValue": "PE 5A"
									},
									{
										"formattedValue": "5A"
									},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "1:00 - 1:15"
									},
									{
										"formattedValue": "PE"
									},
									{
										"formattedValue": "PE 4A"
									},
									{
										"formattedValue": "4A"
									},
									{
										"formattedValue": "PE 4B"
									},
									{
										"formattedValue": "4B"
									},
									{
										"formattedValue": "PE 5A"
									},
									{
										"formattedValue": "5A"
									},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "1:15 - 1:30"
									},
									{
										"formattedValue": "PE"
									},
									{
										"formattedValue": " "
									},
									{},
									{
										"formattedValue": "Prep"
									},
									{},
									{
										"formattedValue": "Prep"
									},
									{},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "1:30 - 1:45"
									},
									{
										"formattedValue": "PE"
									},
									{
										"formattedValue": "PE 1A"
									},
									{
										"formattedValue": "1A"
									},
									{
										"formattedValue": "PE 1B"
									},
									{
										"formattedValue": "1B"
									},
									{
										"formattedValue": "PE 1C"
									},
									{
										"formattedValue": "1C"
									},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "1:45-2:00"
									},
									{
										"formattedValue": "PE"
									},
									{
										"formattedValue": "PE 1A"
									},
									{
										"formattedValue": "1A"
									},
									{
										"formattedValue": "PE 1B"
									},
									{
										"formattedValue": "1B"
									},
									{
										"formattedValue": "PE 1C"
									},
									{
										"formattedValue": "1C"
									},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "7:45-8:00"
									},
									{
										"formattedValue": "V"
									},
									{
										"formattedValue": "Prep"
									},
									{},
									{
										"formattedValue": "Prep"
									},
									{},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "8:00-8:15"
									},
									{
										"formattedValue": "V"
									},
									{
										"formattedValue": "Prep"
									},
									{},
									{
										"formattedValue": "Prep"
									},
									{},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "8:15-8:30"
									},
									{
										"formattedValue": "V"
									},
									{
										"formattedValue": "Prep"
									},
									{},
									{
										"formattedValue": "Prep"
									},
									{},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "8:30 - 8:45"
									},
									{
										"formattedValue": "V"
									},
									{
										"formattedValue": "VAPA 1A"
									},
									{
										"formattedValue": "1A"
									},
									{
										"formattedValue": "VAPA 2B"
									},
									{
										"formattedValue": "2B"
									},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "8:45-9:00"
									},
									{
										"formattedValue": "V"
									},
									{
										"formattedValue": "VAPA 1A"
									},
									{
										"formattedValue": "1A"
									},
									{
										"formattedValue": "VAPA 2B"
									},
									{
										"formattedValue": "2B"
									},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "9:00-9:15"
									},
									{
										"formattedValue": "V"
									},
									{
										"formattedValue": "VAPA 1B"
									},
									{
										"formattedValue": "1B"
									},
									{
										"formattedValue": "VAPA 2B"
									},
									{},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "9:15 - 9:30"
									},
									{
										"formattedValue": "V"
									},
									{
										"formattedValue": "VAPA 1B"
									},
									{
										"formattedValue": "1B"
									},
									{
										"formattedValue": "Prep"
									},
									{},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "9:30-9:45"
									},
									{
										"formattedValue": "V"
									},
									{
										"formattedValue": "VAPA 4A"
									},
									{
										"formattedValue": "4A"
									},
									{
										"formattedValue": "VAPA 3A"
									},
									{
										"formattedValue": "3A"
									},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "9:45-10:00"
									},
									{
										"formattedValue": "V"
									},
									{
										"formattedValue": "VAPA 4A"
									},
									{
										"formattedValue": "4A"
									},
									{
										"formattedValue": "VAPA 3A"
									},
									{
										"formattedValue": "3A"
									},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "10:00 - 10:15"
									},
									{
										"formattedValue": "V"
									},
									{
										"formattedValue": "Prep"
									},
									{},
									{
										"formattedValue": "VAPA 3A"
									},
									{},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "10:15 - 10:30"
									},
									{
										"formattedValue": "V"
									},
									{
										"formattedValue": "VAPA KC"
									},
									{},
									{
										"formattedValue": "VAPA 5A"
									},
									{
										"formattedValue": "5A"
									},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "10:30 - 10:45"
									},
									{
										"formattedValue": "V"
									},
									{
										"formattedValue": "VAPA KC"
									},
									{
										"formattedValue": "KC"
									},
									{
										"formattedValue": "VAPA 5A"
									},
									{
										"formattedValue": "5A"
									},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "10:45 - 11:00"
									},
									{
										"formattedValue": "V"
									},
									{
										"formattedValue": "VAPA KC"
									},
									{
										"formattedValue": "KC"
									},
									{
										"formattedValue": "VAPA 5A"
									},
									{},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "11:00 - 11:15"
									},
									{
										"formattedValue": "V"
									},
									{
										"formattedValue": "Lunch"
									},
									{},
									{
										"formattedValue": "Lunch"
									},
									{},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "11:15 - 11:30"
									},
									{
										"formattedValue": "V"
									},
									{
										"formattedValue": "Lunch"
									},
									{},
									{
										"formattedValue": "Lunch"
									},
									{},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "11:30 - 11:45"
									},
									{
										"formattedValue": "V"
									},
									{
										"formattedValue": "Lunch"
									},
									{},
									{
										"formattedValue": "VAPA 3B"
									},
									{
										"formattedValue": "3B"
									},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "11:45 - 12:00"
									},
									{
										"formattedValue": "V"
									},
									{
										"formattedValue": "VAPA KB"
									},
									{
										"formattedValue": "KB"
									},
									{
										"formattedValue": "VAPA 3B"
									},
									{
										"formattedValue": "3B"
									},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "12:00 - 12:15"
									},
									{
										"formattedValue": "V"
									},
									{
										"formattedValue": "VAPA KB"
									},
									{
										"formattedValue": "KB"
									},
									{
										"formattedValue": "VAPA 3B/VAPA 2A"
									},
									{},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "12:15 - 12:30"
									},
									{
										"formattedValue": "V"
									},
									{
										"formattedValue": "Prep"
									},
									{
										"formattedValue": "3A"
									},
									{
										"formattedValue": "VAPA 2A"
									},
									{
										"formattedValue": "2A"
									},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "12:30-12:45"
									},
									{
										"formattedValue": "V"
									},
									{
										"formattedValue": "Prep"
									},
									{
										"formattedValue": "3A"
									},
									{
										"formattedValue": "VAPA 2A"
									},
									{
										"formattedValue": "2A"
									},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "12:45-1:00"
									},
									{
										"formattedValue": "V"
									},
									{
										"formattedValue": "Prep"
									},
									{},
									{
										"formattedValue": "VAPA 4B"
									},
									{
										"formattedValue": "4B"
									},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "1:00 - 1:15"
									},
									{
										"formattedValue": "V"
									},
									{
										"formattedValue": "VAPA 1C"
									},
									{
										"formattedValue": "1C"
									},
									{
										"formattedValue": "VAPA 4B"
									},
									{
										"formattedValue": "4B"
									},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "1:15 - 1:30"
									},
									{
										"formattedValue": "V"
									},
									{
										"formattedValue": "VAPA 1C"
									},
									{
										"formattedValue": "1C"
									},
									{
										"formattedValue": "VAPA 4B"
									},
									{},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "1:30 - 1:45"
									},
									{
										"formattedValue": "V"
									},
									{
										"formattedValue": "VAPA KA"
									},
									{
										"formattedValue": "KA"
									},
									{
										"formattedValue": "Prep"
									},
									{},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "1:45-2:00"
									},
									{
										"formattedValue": "V"
									},
									{
										"formattedValue": "VAPA KA"
									},
									{
										"formattedValue": "KA"
									},
									{
										"formattedValue": "Prep"
									},
									{},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "7:45-8:00"
									},
									{
										"formattedValue": "Sci"
									},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "Duty"
									},
									{},
									{
										"formattedValue": "Duty"
									},
									{},
									{
										"formattedValue": "Duty"
									},
									{},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "8:00-8:15"
									},
									{
										"formattedValue": "Sci"
									},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "Prep"
									},
									{},
									{
										"formattedValue": "Prep"
									},
									{},
									{
										"formattedValue": "Prep"
									},
									{},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "8:15-8:30"
									},
									{
										"formattedValue": "Sci"
									},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "Prep"
									},
									{},
									{
										"formattedValue": "Prep"
									},
									{},
									{
										"formattedValue": "Prep"
									},
									{},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "8:30 - 8:45"
									},
									{
										"formattedValue": "Sci"
									},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "Specials 1C"
									},
									{
										"formattedValue": "1C"
									},
									{
										"formattedValue": "Specials 2B"
									},
									{
										"formattedValue": "2B"
									},
									{
										"formattedValue": "Specials 5A"
									},
									{
										"formattedValue": "5A"
									},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "8:45-9:00"
									},
									{
										"formattedValue": "Sci"
									},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "Specials 1C"
									},
									{
										"formattedValue": "1C"
									},
									{
										"formattedValue": "Specials 2B"
									},
									{
										"formattedValue": "2B"
									},
									{
										"formattedValue": "Specials 5A"
									},
									{
										"formattedValue": "5A"
									},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "9:00-9:15"
									},
									{
										"formattedValue": "Sci"
									},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "Specials 1C"
									},
									{
										"formattedValue": "1C"
									},
									{
										"formattedValue": "Specials 2B"
									},
									{
										"formattedValue": "2B"
									},
									{
										"formattedValue": "Specials 5A"
									},
									{
										"formattedValue": "5A"
									},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "9:15 - 9:30"
									},
									{
										"formattedValue": "Sci"
									},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "Specials 1C"
									},
									{
										"formattedValue": "1C"
									},
									{
										"formattedValue": "Specials 2B"
									},
									{
										"formattedValue": "2B"
									},
									{
										"formattedValue": "Specials 5A"
									},
									{
										"formattedValue": "5A"
									},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "9:30-9:45"
									},
									{
										"formattedValue": "Sci"
									},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "Rec"
									},
									{},
									{
										"formattedValue": "Rec"
									},
									{},
									{
										"formattedValue": "Specials 5A"
									},
									{
										"formattedValue": "5A"
									},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "9:45-10:00"
									},
									{
										"formattedValue": "Sci"
									},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "Specials 1C"
									},
									{
										"formattedValue": "1C"
									},
									{
										"formattedValue": "Specials 2A"
									},
									{
										"formattedValue": "2A"
									},
									{
										"formattedValue": "Specials 5A"
									},
									{
										"formattedValue": "5A"
									},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "10:00 - 10:15"
									},
									{
										"formattedValue": "Sci"
									},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "Specials 1C"
									},
									{
										"formattedValue": "1C"
									},
									{
										"formattedValue": "Specials 2A"
									},
									{
										"formattedValue": "2A"
									},
									{
										"formattedValue": "Rec"
									},
									{},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "10:15 - 10:30"
									},
									{
										"formattedValue": "Sci"
									},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "Specials 1C"
									},
									{
										"formattedValue": "1C"
									},
									{
										"formattedValue": "Specials 2A"
									},
									{
										"formattedValue": "2A"
									},
									{
										"formattedValue": "Specials 5A"
									},
									{
										"formattedValue": "5A"
									},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "10:30 - 10:45"
									},
									{
										"formattedValue": "Sci"
									},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "COTEACH KC"
									},
									{
										"formattedValue": "KC"
									},
									{
										"formattedValue": "Prep"
									},
									{},
									{
										"formattedValue": "COTEACH 1C"
									},
									{
										"formattedValue": "1C"
									},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "10:45 - 11:00"
									},
									{
										"formattedValue": "Sci"
									},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "COTEACH KC"
									},
									{
										"formattedValue": "KC"
									},
									{
										"formattedValue": "COTEACH 3A"
									},
									{
										"formattedValue": "3A"
									},
									{
										"formattedValue": "COTEACH 1C"
									},
									{
										"formattedValue": "1C"
									},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "11:00 - 11:15"
									},
									{
										"formattedValue": "Sci"
									},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "Lunch"
									},
									{},
									{
										"formattedValue": "COTEACH 3A"
									},
									{
										"formattedValue": "3A"
									},
									{
										"formattedValue": "COTEACH 1C"
									},
									{
										"formattedValue": "1C"
									},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "11:15 - 11:30"
									},
									{
										"formattedValue": "Sci"
									},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "Lunch"
									},
									{},
									{
										"formattedValue": "COTEACH 3A"
									},
									{
										"formattedValue": "3A"
									},
									{
										"formattedValue": "COTEACH 5A"
									},
									{
										"formattedValue": "5A"
									},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "11:30 - 11:45"
									},
									{
										"formattedValue": "Sci"
									},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "Lunch"
									},
									{},
									{
										"formattedValue": "Lunch"
									},
									{},
									{
										"formattedValue": "COTEACH 5A"
									},
									{
										"formattedValue": "5A"
									},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "11:45 - 12:00"
									},
									{
										"formattedValue": "Sci"
									},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "COTEACH KC"
									},
									{
										"formattedValue": "KC"
									},
									{
										"formattedValue": "Lunch"
									},
									{},
									{
										"formattedValue": "COTEACH 5A"
									},
									{
										"formattedValue": "5A"
									},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "12:00 - 12:15"
									},
									{
										"formattedValue": "Sci"
									},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "COTEACH KC"
									},
									{
										"formattedValue": "KC"
									},
									{
										"formattedValue": "Lunch"
									},
									{},
									{
										"formattedValue": "Lunch"
									},
									{},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "12:15 - 12:30"
									},
									{
										"formattedValue": "Sci"
									},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "Specials KC"
									},
									{
										"formattedValue": "KC"
									},
									{
										"formattedValue": "COTEACH 2B"
									},
									{
										"formattedValue": "2B"
									},
									{
										"formattedValue": "Lunch"
									},
									{},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "12:30-12:45"
									},
									{
										"formattedValue": "Sci"
									},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "Specials KC"
									},
									{
										"formattedValue": "KC"
									},
									{
										"formattedValue": "COTEACH 2B"
									},
									{
										"formattedValue": "2B"
									},
									{
										"formattedValue": "Lunch"
									},
									{},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "12:45-1:00"
									},
									{
										"formattedValue": "Sci"
									},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "Specials KC"
									},
									{
										"formattedValue": "KC"
									},
									{
										"formattedValue": "COTEACH 2B"
									},
									{
										"formattedValue": "2B"
									},
									{
										"formattedValue": "PD"
									},
									{},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "1:00 - 1:15"
									},
									{
										"formattedValue": "Sci"
									},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "Specials KC"
									},
									{
										"formattedValue": "KC"
									},
									{
										"formattedValue": "Specials 3A"
									},
									{
										"formattedValue": "3A"
									},
									{
										"formattedValue": "PD"
									},
									{},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "1:15 - 1:30"
									},
									{
										"formattedValue": "Sci"
									},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "Specials KC"
									},
									{
										"formattedValue": "KC"
									},
									{
										"formattedValue": "Specials 3A"
									},
									{
										"formattedValue": "3A"
									},
									{
										"formattedValue": "PD"
									},
									{},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "1:30 - 1:45"
									},
									{
										"formattedValue": "Sci"
									},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "Specials KC"
									},
									{
										"formattedValue": "KC"
									},
									{
										"formattedValue": "Specials 3B"
									},
									{
										"formattedValue": "3B"
									},
									{
										"formattedValue": "PD"
									},
									{},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "1:45-2:00"
									},
									{
										"formattedValue": "Sci"
									},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "Specials KC"
									},
									{
										"formattedValue": "KC"
									},
									{
										"formattedValue": "Specials 3B"
									},
									{
										"formattedValue": "3B"
									},
									{
										"formattedValue": "PD"
									},
									{},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "7:45-8:00"
									},
									{
										"formattedValue": "PW"
									},
									{
										"formattedValue": "Duty"
									},
									{},
									{
										"formattedValue": "Duty"
									},
									{},
									{
										"formattedValue": "Duty"
									},
									{},
									{
										"formattedValue": "Duty"
									},
									{},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "8:00-8:15"
									},
									{
										"formattedValue": "PW"
									},
									{
										"formattedValue": "Prep"
									},
									{},
									{
										"formattedValue": "Prep"
									},
									{},
									{
										"formattedValue": "Prep"
									},
									{},
									{
										"formattedValue": "Prep"
									},
									{},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "8:15-8:30"
									},
									{
										"formattedValue": "PW"
									},
									{
										"formattedValue": "Prep"
									},
									{},
									{
										"formattedValue": "Prep"
									},
									{},
									{
										"formattedValue": "Prep"
									},
									{},
									{
										"formattedValue": "Prep"
									},
									{},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "8:30 - 8:45"
									},
									{
										"formattedValue": "PW"
									},
									{
										"formattedValue": "PW 1C"
									},
									{
										"formattedValue": "1C"
									},
									{
										"formattedValue": "PW 2A"
									},
									{
										"formattedValue": "2A"
									},
									{
										"formattedValue": "Prep"
									},
									{},
									{
										"formattedValue": "Prep"
									},
									{},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "8:45-9:00"
									},
									{
										"formattedValue": "PW"
									},
									{
										"formattedValue": "PW 1C"
									},
									{
										"formattedValue": "1C"
									},
									{
										"formattedValue": "PW 2A"
									},
									{
										"formattedValue": "2A"
									},
									{
										"formattedValue": "Prep"
									},
									{},
									{
										"formattedValue": "Prep"
									},
									{},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "9:00-9:15"
									},
									{
										"formattedValue": "PW"
									},
									{
										"formattedValue": "PW 1A"
									},
									{
										"formattedValue": "1A"
									},
									{
										"formattedValue": "Prep"
									},
									{},
									{
										"formattedValue": "Prep"
									},
									{},
									{
										"formattedValue": "Prep"
									},
									{},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "9:15 - 9:30"
									},
									{
										"formattedValue": "PW"
									},
									{
										"formattedValue": "PW 1A"
									},
									{
										"formattedValue": "1A"
									},
									{
										"formattedValue": "Prep"
									},
									{},
									{
										"formattedValue": "Prep"
									},
									{},
									{
										"formattedValue": "Prep"
									},
									{},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "9:30-9:45"
									},
									{
										"formattedValue": "PW"
									},
									{
										"formattedValue": "Rec"
									},
									{},
									{
										"formattedValue": "Rec"
									},
									{},
									{
										"formattedValue": "Rec"
									},
									{},
									{
										"formattedValue": "Rec"
									},
									{},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "9:45-10:00"
									},
									{
										"formattedValue": "PW"
									},
									{
										"formattedValue": "Break"
									},
									{},
									{
										"formattedValue": "Break"
									},
									{},
									{
										"formattedValue": "Break"
									},
									{},
									{
										"formattedValue": "Break"
									},
									{},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "10:00 - 10:15"
									},
									{
										"formattedValue": "PW"
									},
									{
										"formattedValue": "Rec"
									},
									{},
									{
										"formattedValue": "Rec"
									},
									{},
									{
										"formattedValue": "Rec"
									},
									{},
									{
										"formattedValue": "Rec"
									},
									{},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "10:15 - 10:30"
									},
									{
										"formattedValue": "PW"
									},
									{
										"formattedValue": "Prep"
									},
									{},
									{
										"formattedValue": "PW 4A"
									},
									{
										"formattedValue": "4A"
									},
									{
										"formattedValue": "PW 5A"
									},
									{
										"formattedValue": "5A"
									},
									{
										"formattedValue": "Prep"
									},
									{},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "10:30 - 10:45"
									},
									{
										"formattedValue": "PW"
									},
									{
										"formattedValue": "PW KA"
									},
									{
										"formattedValue": "KA"
									},
									{
										"formattedValue": "PW 4A"
									},
									{
										"formattedValue": "4A"
									},
									{
										"formattedValue": "PW 5A"
									},
									{
										"formattedValue": "5A"
									},
									{
										"formattedValue": "Prep"
									},
									{},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "10:45 - 11:00"
									},
									{
										"formattedValue": "PW"
									},
									{
										"formattedValue": "PW KA"
									},
									{
										"formattedValue": "KA"
									},
									{
										"formattedValue": "Prep"
									},
									{},
									{
										"formattedValue": "Prep"
									},
									{},
									{
										"formattedValue": "Prep"
									},
									{},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "11:00 - 11:15"
									},
									{
										"formattedValue": "PW"
									},
									{
										"formattedValue": "Duty"
									},
									{},
									{
										"formattedValue": "Duty"
									},
									{},
									{
										"formattedValue": "Duty"
									},
									{},
									{
										"formattedValue": "Duty"
									},
									{},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "11:15 - 11:30"
									},
									{
										"formattedValue": "PW"
									},
									{
										"formattedValue": "Duty"
									},
									{},
									{
										"formattedValue": "Duty"
									},
									{},
									{
										"formattedValue": "Duty"
									},
									{},
									{
										"formattedValue": "Duty"
									},
									{},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "11:30 - 11:45"
									},
									{
										"formattedValue": "PW"
									},
									{
										"formattedValue": "Duty"
									},
									{},
									{
										"formattedValue": "Duty"
									},
									{},
									{
										"formattedValue": "Duty"
									},
									{},
									{
										"formattedValue": "Duty"
									},
									{},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "11:45 - 12:00"
									},
									{
										"formattedValue": "PW"
									},
									{
										"formattedValue": "Duty"
									},
									{},
									{
										"formattedValue": "Duty"
									},
									{},
									{
										"formattedValue": "Duty"
									},
									{},
									{
										"formattedValue": "Duty"
									},
									{},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "12:00 - 12:15"
									},
									{
										"formattedValue": "PW"
									},
									{
										"formattedValue": "Duty"
									},
									{},
									{
										"formattedValue": "Duty"
									},
									{},
									{
										"formattedValue": "Duty"
									},
									{},
									{
										"formattedValue": "Duty"
									},
									{},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "12:15 - 12:30"
									},
									{
										"formattedValue": "PW"
									},
									{
										"formattedValue": "Prep"
									},
									{},
									{
										"formattedValue": "Prep"
									},
									{},
									{
										"formattedValue": "Duty"
									},
									{},
									{
										"formattedValue": "Duty"
									},
									{},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "12:30-12:45"
									},
									{
										"formattedValue": "PW"
									},
									{
										"formattedValue": "Prep"
									},
									{},
									{
										"formattedValue": "Prep"
									},
									{},
									{
										"formattedValue": "Duty"
									},
									{},
									{
										"formattedValue": "Duty"
									},
									{},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "12:45-1:00"
									},
									{
										"formattedValue": "PW"
									},
									{
										"formattedValue": "Lunch"
									},
									{},
									{
										"formattedValue": "Lunch"
									},
									{},
									{
										"formattedValue": "Lunch"
									},
									{},
									{
										"formattedValue": "Lunch"
									},
									{},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "1:00 - 1:15"
									},
									{
										"formattedValue": "PW"
									},
									{
										"formattedValue": "Lunch"
									},
									{},
									{
										"formattedValue": "Lunch"
									},
									{},
									{
										"formattedValue": "Lunch"
									},
									{},
									{
										"formattedValue": "Lunch"
									},
									{},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "1:15 - 1:30"
									},
									{
										"formattedValue": "PW"
									},
									{
										"formattedValue": "Lunch"
									},
									{},
									{
										"formattedValue": "Lunch"
									},
									{},
									{
										"formattedValue": "Lunch"
									},
									{},
									{
										"formattedValue": "Lunch"
									},
									{},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "1:30 - 1:45"
									},
									{
										"formattedValue": "PW"
									},
									{
										"formattedValue": "PW KC"
									},
									{
										"formattedValue": "KC"
									},
									{
										"formattedValue": "PW 3A"
									},
									{
										"formattedValue": "3A"
									},
									{
										"formattedValue": "Lunch"
									},
									{},
									{
										"formattedValue": "Lunch"
									},
									{},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "1:45-2:00"
									},
									{
										"formattedValue": "PW"
									},
									{
										"formattedValue": "PW KC"
									},
									{
										"formattedValue": "KC"
									},
									{
										"formattedValue": "PW 3A"
									},
									{
										"formattedValue": "3A"
									},
									{
										"formattedValue": "Duty"
									},
									{},
									{
										"formattedValue": "PD"
									},
									{},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "7:45-8:00"
									},
									{
										"formattedValue": "Tech"
									},
									{
										"formattedValue": "Duty"
									},
									{},
									{
										"formattedValue": "Duty"
									},
									{},
									{
										"formattedValue": "Duty"
									},
									{},
									{
										"formattedValue": "Duty"
									},
									{},
									{
										"formattedValue": "Duty"
									},
									{}
								]
							},
							{
								"values": [
									{
										"formattedValue": "8:00-8:15"
									},
									{
										"formattedValue": "Tech"
									},
									{
										"formattedValue": "Prep"
									},
									{},
									{
										"formattedValue": "Prep"
									},
									{},
									{
										"formattedValue": "Prep"
									},
									{},
									{
										"formattedValue": "Prep"
									},
									{},
									{
										"formattedValue": "Prep"
									},
									{}
								]
							},
							{
								"values": [
									{
										"formattedValue": "8:15-8:30"
									},
									{
										"formattedValue": "Tech"
									},
									{
										"formattedValue": "Prep"
									},
									{},
									{
										"formattedValue": "Prep"
									},
									{},
									{
										"formattedValue": "Prep"
									},
									{},
									{
										"formattedValue": "Prep"
									},
									{},
									{
										"formattedValue": "Prep"
									},
									{}
								]
							},
							{
								"values": [
									{
										"formattedValue": "8:30 - 8:45"
									},
									{
										"formattedValue": "Tech"
									},
									{
										"formattedValue": "Prep"
									},
									{},
									{
										"formattedValue": "Specials 1B"
									},
									{
										"formattedValue": "1B"
									},
									{
										"formattedValue": "Specials 2B"
									},
									{
										"formattedValue": "2B"
									},
									{
										"formattedValue": "Specials 4B"
									},
									{
										"formattedValue": "4B"
									},
									{
										"formattedValue": "Prep"
									},
									{}
								]
							},
							{
								"values": [
									{
										"formattedValue": "8:45-9:00"
									},
									{
										"formattedValue": "Tech"
									},
									{
										"formattedValue": "Prep"
									},
									{},
									{
										"formattedValue": "Specials 1B"
									},
									{
										"formattedValue": "1B"
									},
									{
										"formattedValue": "Specials 2B"
									},
									{
										"formattedValue": "2B"
									},
									{
										"formattedValue": "Specials 4B"
									},
									{
										"formattedValue": "4B"
									},
									{
										"formattedValue": "Prep"
									},
									{}
								]
							},
							{
								"values": [
									{
										"formattedValue": "9:00-9:15"
									},
									{
										"formattedValue": "Tech"
									},
									{
										"formattedValue": "Prep"
									},
									{},
									{
										"formattedValue": "Specials 1B"
									},
									{
										"formattedValue": "1B"
									},
									{
										"formattedValue": "Specials 2B"
									},
									{
										"formattedValue": "2B"
									},
									{
										"formattedValue": "Specials 4B"
									},
									{
										"formattedValue": "4B"
									},
									{
										"formattedValue": "Prep"
									},
									{}
								]
							},
							{
								"values": [
									{
										"formattedValue": "9:15 - 9:30"
									},
									{
										"formattedValue": "Tech"
									},
									{
										"formattedValue": "Prep"
									},
									{},
									{
										"formattedValue": "Specials 1B"
									},
									{
										"formattedValue": "1B"
									},
									{
										"formattedValue": "Specials 2B"
									},
									{
										"formattedValue": "2B"
									},
									{
										"formattedValue": "Specials 4B"
									},
									{
										"formattedValue": "4B"
									},
									{
										"formattedValue": "Prep"
									},
									{}
								]
							},
							{
								"values": [
									{
										"formattedValue": "9:30-9:45"
									},
									{
										"formattedValue": "Tech"
									},
									{
										"formattedValue": "Prep"
									},
									{},
									{
										"formattedValue": "Rec"
									},
									{},
									{
										"formattedValue": "Rec"
									},
									{},
									{
										"formattedValue": "Specials 4B"
									},
									{
										"formattedValue": "4B"
									},
									{
										"formattedValue": "Prep"
									},
									{}
								]
							},
							{
								"values": [
									{
										"formattedValue": "9:45-10:00"
									},
									{
										"formattedValue": "Tech"
									},
									{
										"formattedValue": "Prep"
									},
									{},
									{
										"formattedValue": "Specials 1B"
									},
									{
										"formattedValue": "1B"
									},
									{
										"formattedValue": "Specials 2B"
									},
									{
										"formattedValue": "2B"
									},
									{
										"formattedValue": "Specials 4B"
									},
									{
										"formattedValue": "4B"
									},
									{
										"formattedValue": "Prep"
									},
									{}
								]
							},
							{
								"values": [
									{
										"formattedValue": "10:00 - 10:15"
									},
									{
										"formattedValue": "Tech"
									},
									{
										"formattedValue": "Prep"
									},
									{},
									{
										"formattedValue": "Specials 1B"
									},
									{
										"formattedValue": "1B"
									},
									{
										"formattedValue": "Specials 2B"
									},
									{
										"formattedValue": "2B"
									},
									{
										"formattedValue": "Rec"
									},
									{},
									{
										"formattedValue": "Prep"
									},
									{}
								]
							},
							{
								"values": [
									{
										"formattedValue": "10:15 - 10:30"
									},
									{
										"formattedValue": "Tech"
									},
									{
										"formattedValue": "Prep"
									},
									{},
									{
										"formattedValue": "Specials 1B"
									},
									{
										"formattedValue": "1B"
									},
									{
										"formattedValue": "Specials 2B"
									},
									{
										"formattedValue": "2B"
									},
									{
										"formattedValue": "Specials 4B"
									},
									{
										"formattedValue": "4B"
									},
									{
										"formattedValue": "Prep"
									},
									{}
								]
							},
							{
								"values": [
									{
										"formattedValue": "10:30 - 10:45"
									},
									{
										"formattedValue": "Tech"
									},
									{
										"formattedValue": "Prep"
									},
									{},
									{
										"formattedValue": "COTEACH KB"
									},
									{
										"formattedValue": "KB"
									},
									{
										"formattedValue": "prep"
									},
									{},
									{
										"formattedValue": "COTEACH 1B"
									},
									{
										"formattedValue": "1B"
									},
									{
										"formattedValue": "Prep"
									},
									{}
								]
							},
							{
								"values": [
									{
										"formattedValue": "10:45 - 11:00"
									},
									{
										"formattedValue": "Tech"
									},
									{
										"formattedValue": "Prep"
									},
									{},
									{
										"formattedValue": "COTEACH KB"
									},
									{
										"formattedValue": "KB"
									},
									{
										"formattedValue": "COTEACH 3B"
									},
									{
										"formattedValue": "3B"
									},
									{
										"formattedValue": "COTEACH 1B"
									},
									{
										"formattedValue": "1B"
									},
									{
										"formattedValue": "Prep"
									},
									{}
								]
							},
							{
								"values": [
									{
										"formattedValue": "11:00 - 11:15"
									},
									{
										"formattedValue": "Tech"
									},
									{
										"formattedValue": "Lunch"
									},
									{},
									{
										"formattedValue": "Lunch"
									},
									{},
									{
										"formattedValue": "COTEACH 3B"
									},
									{
										"formattedValue": "3B"
									},
									{
										"formattedValue": "COTEACH 1B"
									},
									{
										"formattedValue": "1B"
									},
									{
										"formattedValue": "Lunch"
									},
									{}
								]
							},
							{
								"values": [
									{
										"formattedValue": "11:15 - 11:30"
									},
									{
										"formattedValue": "Tech"
									},
									{
										"formattedValue": "Lunch"
									},
									{},
									{
										"formattedValue": "Lunch"
									},
									{},
									{
										"formattedValue": "COTEACH 3B"
									},
									{
										"formattedValue": "3B"
									},
									{
										"formattedValue": "COTEACH 1B"
									},
									{
										"formattedValue": "4B"
									},
									{
										"formattedValue": "Lunch"
									},
									{}
								]
							},
							{
								"values": [
									{
										"formattedValue": "11:30 - 11:45"
									},
									{
										"formattedValue": "Tech"
									},
									{
										"formattedValue": "Lunch"
									},
									{},
									{
										"formattedValue": "Lunch"
									},
									{},
									{
										"formattedValue": "Lunch"
									},
									{},
									{
										"formattedValue": "COTEACH 1B"
									},
									{
										"formattedValue": "4B"
									},
									{
										"formattedValue": "Lunch"
									},
									{}
								]
							},
							{
								"values": [
									{
										"formattedValue": "11:45 - 12:00"
									},
									{
										"formattedValue": "Tech"
									},
									{
										"formattedValue": "Prep"
									},
									{},
									{
										"formattedValue": "COTEACH KB"
									},
									{
										"formattedValue": "KB"
									},
									{
										"formattedValue": "Lunch"
									},
									{},
									{
										"formattedValue": "COTEACH 1B"
									},
									{
										"formattedValue": "4B"
									},
									{
										"formattedValue": "Prep"
									},
									{}
								]
							},
							{
								"values": [
									{
										"formattedValue": "12:00 - 12:15"
									},
									{
										"formattedValue": "Tech"
									},
									{
										"formattedValue": "Prep"
									},
									{},
									{
										"formattedValue": "COTEACH KB"
									},
									{
										"formattedValue": "KB"
									},
									{
										"formattedValue": "Lunch"
									},
									{},
									{
										"formattedValue": "Lunch"
									},
									{},
									{
										"formattedValue": "Prep"
									},
									{}
								]
							},
							{
								"values": [
									{
										"formattedValue": "12:15 - 12:30"
									},
									{
										"formattedValue": "Tech"
									},
									{
										"formattedValue": "Prep"
									},
									{},
									{
										"formattedValue": "COTEACH KB"
									},
									{
										"formattedValue": "KB"
									},
									{
										"formattedValue": "Specials 3B"
									},
									{
										"formattedValue": "3B"
									},
									{
										"formattedValue": "Lunch"
									},
									{},
									{
										"formattedValue": "Prep"
									},
									{}
								]
							},
							{
								"values": [
									{
										"formattedValue": "12:30-12:45"
									},
									{
										"formattedValue": "Tech"
									},
									{
										"formattedValue": "Prep"
									},
									{},
									{
										"formattedValue": "COTEACH KB"
									},
									{
										"formattedValue": "KB"
									},
									{
										"formattedValue": "Specials 3B"
									},
									{
										"formattedValue": "3B"
									},
									{
										"formattedValue": "Lunch"
									},
									{},
									{
										"formattedValue": "Prep"
									},
									{}
								]
							},
							{
								"values": [
									{
										"formattedValue": "12:45-1:00"
									},
									{
										"formattedValue": "Tech"
									},
									{
										"formattedValue": "Prep"
									},
									{},
									{
										"formattedValue": "COTEACH KB"
									},
									{
										"formattedValue": "KB"
									},
									{
										"formattedValue": "Specials 3B"
									},
									{
										"formattedValue": "3B"
									},
									{
										"formattedValue": "PD"
									},
									{},
									{
										"formattedValue": "Prep"
									},
									{}
								]
							},
							{
								"values": [
									{
										"formattedValue": "1:00 - 1:15"
									},
									{
										"formattedValue": "Tech"
									},
									{
										"formattedValue": "Prep"
									},
									{},
									{
										"formattedValue": "COTEACH KB"
									},
									{
										"formattedValue": "KB"
									},
									{
										"formattedValue": "Specials 3B"
									},
									{
										"formattedValue": "3B"
									},
									{
										"formattedValue": "PD"
									},
									{},
									{
										"formattedValue": "Prep"
									},
									{}
								]
							},
							{
								"values": [
									{
										"formattedValue": "1:15 - 1:30"
									},
									{
										"formattedValue": "Tech"
									},
									{
										"formattedValue": "Prep"
									},
									{},
									{
										"formattedValue": "COTEACH KB"
									},
									{
										"formattedValue": "KB"
									},
									{
										"formattedValue": "Specials 3B"
									},
									{
										"formattedValue": "3B"
									},
									{
										"formattedValue": "PD"
									},
									{},
									{
										"formattedValue": "Prep"
									},
									{}
								]
							},
							{
								"values": [
									{
										"formattedValue": "1:30 - 1:45"
									},
									{
										"formattedValue": "Tech"
									},
									{
										"formattedValue": "Prep"
									},
									{},
									{
										"formattedValue": "COTEACH KB"
									},
									{
										"formattedValue": "KB"
									},
									{
										"formattedValue": "Specials 3B"
									},
									{
										"formattedValue": "3B"
									},
									{
										"formattedValue": "PD"
									},
									{},
									{
										"formattedValue": "Prep"
									},
									{}
								]
							},
							{
								"values": [
									{
										"formattedValue": "1:45-2:00"
									},
									{
										"formattedValue": "Tech"
									},
									{
										"formattedValue": "Prep"
									},
									{},
									{
										"formattedValue": "COTEACH KB"
									},
									{
										"formattedValue": "KB"
									},
									{
										"formattedValue": "Specials 3B"
									},
									{
										"formattedValue": "3B"
									},
									{
										"formattedValue": "PD"
									},
									{},
									{
										"formattedValue": "Prep"
									},
									{}
								]
							},
							{
								"values": [
									{
										"formattedValue": "7:45-8:00"
									},
									{
										"formattedValue": "Lib"
									},
									{
										"formattedValue": "Duty"
									},
									{},
									{
										"formattedValue": "Duty"
									},
									{},
									{
										"formattedValue": "Duty"
									},
									{},
									{
										"formattedValue": "Duty"
									},
									{},
									{
										"formattedValue": "Duty"
									},
									{}
								]
							},
							{
								"values": [
									{
										"formattedValue": "8:00-8:15"
									},
									{
										"formattedValue": "Lib"
									},
									{
										"formattedValue": "Prep"
									},
									{},
									{
										"formattedValue": "Prep"
									},
									{},
									{
										"formattedValue": "Prep"
									},
									{},
									{
										"formattedValue": "Prep"
									},
									{},
									{
										"formattedValue": "Prep"
									},
									{}
								]
							},
							{
								"values": [
									{
										"formattedValue": "8:15-8:30"
									},
									{
										"formattedValue": "Lib"
									},
									{
										"formattedValue": "Prep"
									},
									{},
									{
										"formattedValue": "Prep"
									},
									{},
									{
										"formattedValue": "Prep"
									},
									{},
									{
										"formattedValue": "Prep"
									},
									{},
									{
										"formattedValue": "Prep"
									},
									{}
								]
							},
							{
								"values": [
									{
										"formattedValue": "8:30 - 8:45"
									},
									{
										"formattedValue": "Lib"
									},
									{
										"formattedValue": "Prep"
									},
									{},
									{
										"formattedValue": "Specials 1A"
									},
									{
										"formattedValue": "1A"
									},
									{
										"formattedValue": "Specials 2A"
									},
									{
										"formattedValue": "2A"
									},
									{
										"formattedValue": "Specials 4A"
									},
									{
										"formattedValue": "4A"
									},
									{
										"formattedValue": "Prep"
									},
									{}
								]
							},
							{
								"values": [
									{
										"formattedValue": "8:45-9:00"
									},
									{
										"formattedValue": "Lib"
									},
									{
										"formattedValue": "Prep"
									},
									{},
									{
										"formattedValue": "Specials 1A"
									},
									{
										"formattedValue": "1A"
									},
									{
										"formattedValue": "Specials 2A"
									},
									{
										"formattedValue": "2A"
									},
									{
										"formattedValue": "Specials 4A"
									},
									{
										"formattedValue": "4A"
									},
									{
										"formattedValue": "Prep"
									},
									{}
								]
							},
							{
								"values": [
									{
										"formattedValue": "9:00-9:15"
									},
									{
										"formattedValue": "Lib"
									},
									{
										"formattedValue": "Prep"
									},
									{},
									{
										"formattedValue": "Specials 1A"
									},
									{
										"formattedValue": "1A"
									},
									{
										"formattedValue": "Specials 2A"
									},
									{
										"formattedValue": "2A"
									},
									{
										"formattedValue": "Specials 4A"
									},
									{
										"formattedValue": "4A"
									},
									{
										"formattedValue": "Prep"
									},
									{}
								]
							},
							{
								"values": [
									{
										"formattedValue": "9:15 - 9:30"
									},
									{
										"formattedValue": "Lib"
									},
									{
										"formattedValue": "Prep"
									},
									{},
									{
										"formattedValue": "Specials 1A"
									},
									{
										"formattedValue": "1A"
									},
									{
										"formattedValue": "Specials 2A"
									},
									{
										"formattedValue": "2A"
									},
									{
										"formattedValue": "Specials 4A"
									},
									{
										"formattedValue": "4A"
									},
									{
										"formattedValue": "Prep"
									},
									{}
								]
							},
							{
								"values": [
									{
										"formattedValue": "9:30-9:45"
									},
									{
										"formattedValue": "Lib"
									},
									{
										"formattedValue": "Prep"
									},
									{},
									{
										"formattedValue": "Rec"
									},
									{},
									{
										"formattedValue": "Rec"
									},
									{},
									{
										"formattedValue": "Specials 4A"
									},
									{
										"formattedValue": "4A"
									},
									{
										"formattedValue": "Prep"
									},
									{}
								]
							},
							{
								"values": [
									{
										"formattedValue": "9:45-10:00"
									},
									{
										"formattedValue": "Lib"
									},
									{
										"formattedValue": "Prep"
									},
									{},
									{
										"formattedValue": "Specials 1A"
									},
									{
										"formattedValue": "1A"
									},
									{
										"formattedValue": "Specials 2A"
									},
									{
										"formattedValue": "2A"
									},
									{
										"formattedValue": "Specials 4A"
									},
									{
										"formattedValue": "4A"
									},
									{
										"formattedValue": "Prep"
									},
									{}
								]
							},
							{
								"values": [
									{
										"formattedValue": "10:00 - 10:15"
									},
									{
										"formattedValue": "Lib"
									},
									{
										"formattedValue": "Prep"
									},
									{},
									{
										"formattedValue": "Specials 1A"
									},
									{
										"formattedValue": "1A"
									},
									{
										"formattedValue": "Specials 2A"
									},
									{
										"formattedValue": "2A"
									},
									{
										"formattedValue": "Rec"
									},
									{},
									{
										"formattedValue": "Prep"
									},
									{}
								]
							},
							{
								"values": [
									{
										"formattedValue": "10:15 - 10:30"
									},
									{
										"formattedValue": "Lib"
									},
									{
										"formattedValue": "Prep"
									},
									{},
									{
										"formattedValue": "Specials 1A"
									},
									{
										"formattedValue": "1A"
									},
									{
										"formattedValue": "Specials 2A"
									},
									{
										"formattedValue": "2A"
									},
									{
										"formattedValue": "Specials 4A"
									},
									{
										"formattedValue": "4A"
									},
									{
										"formattedValue": "Prep"
									},
									{}
								]
							},
							{
								"values": [
									{
										"formattedValue": "10:30 - 10:45"
									},
									{
										"formattedValue": "Lib"
									},
									{
										"formattedValue": "Prep"
									},
									{},
									{
										"formattedValue": "COTEACH KA"
									},
									{
										"formattedValue": "KA"
									},
									{
										"formattedValue": "Prep"
									},
									{},
									{
										"formattedValue": "COTEACH 1A"
									},
									{
										"formattedValue": "1A"
									},
									{
										"formattedValue": "Prep"
									},
									{}
								]
							},
							{
								"values": [
									{
										"formattedValue": "10:45 - 11:00"
									},
									{
										"formattedValue": "Lib"
									},
									{
										"formattedValue": "Prep"
									},
									{},
									{
										"formattedValue": "COTEACH KA"
									},
									{
										"formattedValue": "KA"
									},
									{
										"formattedValue": "COTEACH 3A"
									},
									{
										"formattedValue": "3A"
									},
									{
										"formattedValue": "COTEACH 1A"
									},
									{
										"formattedValue": "1A"
									},
									{
										"formattedValue": "Prep"
									},
									{}
								]
							},
							{
								"values": [
									{
										"formattedValue": "11:00 - 11:15"
									},
									{
										"formattedValue": "Lib"
									},
									{
										"formattedValue": "Lunch"
									},
									{},
									{
										"formattedValue": "Lunch"
									},
									{},
									{
										"formattedValue": "COTEACH 3A"
									},
									{
										"formattedValue": "3A"
									},
									{
										"formattedValue": "COTEACH 1A"
									},
									{
										"formattedValue": "1A"
									},
									{
										"formattedValue": "Prep"
									},
									{}
								]
							},
							{
								"values": [
									{
										"formattedValue": "11:15 - 11:30"
									},
									{
										"formattedValue": "Lib"
									},
									{
										"formattedValue": "Lunch"
									},
									{},
									{
										"formattedValue": "Lunch"
									},
									{},
									{
										"formattedValue": "COTEACH 3A"
									},
									{
										"formattedValue": "3A"
									},
									{
										"formattedValue": "COTEACH 1A"
									},
									{
										"formattedValue": "4A"
									},
									{
										"formattedValue": "Lunch"
									},
									{}
								]
							},
							{
								"values": [
									{
										"formattedValue": "11:30 - 11:45"
									},
									{
										"formattedValue": "Lib"
									},
									{
										"formattedValue": "Lunch"
									},
									{},
									{
										"formattedValue": "Lunch"
									},
									{},
									{
										"formattedValue": "Lunch"
									},
									{},
									{
										"formattedValue": "COTEACH 1A"
									},
									{
										"formattedValue": "4A"
									},
									{
										"formattedValue": "Lunch"
									},
									{}
								]
							},
							{
								"values": [
									{
										"formattedValue": "11:45 - 12:00"
									},
									{
										"formattedValue": "Lib"
									},
									{
										"formattedValue": "Prep"
									},
									{},
									{
										"formattedValue": "COTEACH KA"
									},
									{
										"formattedValue": "KA"
									},
									{
										"formattedValue": "Lunch"
									},
									{},
									{
										"formattedValue": "COTEACH 1A"
									},
									{
										"formattedValue": "4A"
									},
									{
										"formattedValue": "Lunch"
									},
									{}
								]
							},
							{
								"values": [
									{
										"formattedValue": "12:00 - 12:15"
									},
									{
										"formattedValue": "Lib"
									},
									{
										"formattedValue": "Prep"
									},
									{},
									{
										"formattedValue": "COTEACH KA"
									},
									{
										"formattedValue": "KA"
									},
									{
										"formattedValue": "Lunch"
									},
									{},
									{
										"formattedValue": "Lunch"
									},
									{},
									{
										"formattedValue": "Prep"
									},
									{}
								]
							},
							{
								"values": [
									{
										"formattedValue": "12:15 - 12:30"
									},
									{
										"formattedValue": "Lib"
									},
									{
										"formattedValue": "Prep"
									},
									{},
									{
										"formattedValue": "Specials KA"
									},
									{
										"formattedValue": "KA"
									},
									{
										"formattedValue": "Specials 3A"
									},
									{
										"formattedValue": "3A"
									},
									{
										"formattedValue": "Lunch"
									},
									{},
									{
										"formattedValue": "Prep"
									},
									{}
								]
							},
							{
								"values": [
									{
										"formattedValue": "12:30-12:45"
									},
									{
										"formattedValue": "Lib"
									},
									{
										"formattedValue": "Prep"
									},
									{},
									{
										"formattedValue": "Specials KA"
									},
									{
										"formattedValue": "KA"
									},
									{
										"formattedValue": "Specials 3A"
									},
									{
										"formattedValue": "3A"
									},
									{
										"formattedValue": "Lunch"
									},
									{},
									{
										"formattedValue": "Prep"
									},
									{}
								]
							},
							{
								"values": [
									{
										"formattedValue": "12:45-1:00"
									},
									{
										"formattedValue": "Lib"
									},
									{
										"formattedValue": "Prep"
									},
									{},
									{
										"formattedValue": "Specials KA"
									},
									{
										"formattedValue": "KA"
									},
									{
										"formattedValue": "Specials 3A"
									},
									{
										"formattedValue": "3A"
									},
									{
										"formattedValue": "PD"
									},
									{},
									{
										"formattedValue": "Prep"
									},
									{}
								]
							},
							{
								"values": [
									{
										"formattedValue": "1:00 - 1:15"
									},
									{
										"formattedValue": "Lib"
									},
									{
										"formattedValue": "Prep"
									},
									{},
									{
										"formattedValue": "Specials KA"
									},
									{
										"formattedValue": "KA"
									},
									{
										"formattedValue": "COTEACH 2A"
									},
									{
										"formattedValue": "2A"
									},
									{
										"formattedValue": "PD"
									},
									{},
									{
										"formattedValue": "Prep"
									},
									{}
								]
							},
							{
								"values": [
									{
										"formattedValue": "1:15 - 1:30"
									},
									{
										"formattedValue": "Lib"
									},
									{
										"formattedValue": "Prep"
									},
									{},
									{
										"formattedValue": "Specials KA"
									},
									{
										"formattedValue": "KA"
									},
									{
										"formattedValue": "COTEACH 2A"
									},
									{
										"formattedValue": "2A"
									},
									{
										"formattedValue": "PD"
									},
									{},
									{
										"formattedValue": "Prep"
									},
									{}
								]
							},
							{
								"values": [
									{
										"formattedValue": "1:30 - 1:45"
									},
									{
										"formattedValue": "Lib"
									},
									{
										"formattedValue": "Prep"
									},
									{},
									{
										"formattedValue": "Specials KA"
									},
									{
										"formattedValue": "KA"
									},
									{
										"formattedValue": "COTEACH 2A"
									},
									{
										"formattedValue": "2A"
									},
									{
										"formattedValue": "PD"
									},
									{},
									{
										"formattedValue": "Prep"
									},
									{}
								]
							},
							{
								"values": [
									{
										"formattedValue": "1:45-2:00"
									},
									{
										"formattedValue": "Lib"
									},
									{
										"formattedValue": "Prep"
									},
									{},
									{
										"formattedValue": "Specials KA"
									},
									{
										"formattedValue": "KA"
									},
									{
										"formattedValue": "COTEACH 2A"
									},
									{
										"formattedValue": "2A"
									},
									{
										"formattedValue": "PD"
									},
									{},
									{
										"formattedValue": "Prep"
									},
									{}
								]
							},
							{
								"values": [
									{
										"formattedValue": "7:45-8:00"
									},
									{
										"formattedValue": "G"
									},
									{
										"formattedValue": "Duty"
									},
									{},
									{
										"formattedValue": "Duty"
									},
									{},
									{
										"formattedValue": "Duty"
									},
									{},
									{
										"formattedValue": "Duty"
									},
									{},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "8:00-8:15"
									},
									{
										"formattedValue": "G"
									},
									{
										"formattedValue": "Prep"
									},
									{},
									{
										"formattedValue": "Prep"
									},
									{},
									{
										"formattedValue": "Prep"
									},
									{},
									{
										"formattedValue": "Prep"
									},
									{},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "8:15-8:30"
									},
									{
										"formattedValue": "G"
									},
									{
										"formattedValue": "Prep"
									},
									{},
									{
										"formattedValue": "Prep"
									},
									{},
									{
										"formattedValue": "Prep"
									},
									{},
									{
										"formattedValue": "Prep"
									},
									{},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "8:30 - 8:45"
									},
									{
										"formattedValue": "G"
									},
									{
										"formattedValue": "G 1B"
									},
									{
										"formattedValue": "1B"
									},
									{
										"formattedValue": "G 2A"
									},
									{
										"formattedValue": "2A"
									},
									{
										"formattedValue": "Prep"
									},
									{},
									{
										"formattedValue": "Prep"
									},
									{},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "8:45-9:00"
									},
									{
										"formattedValue": "G"
									},
									{
										"formattedValue": "G 1B"
									},
									{
										"formattedValue": "1B"
									},
									{
										"formattedValue": "G 2A"
									},
									{
										"formattedValue": "2A"
									},
									{
										"formattedValue": "Prep"
									},
									{},
									{
										"formattedValue": "Prep"
									},
									{},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "9:00-9:15"
									},
									{
										"formattedValue": "G"
									},
									{
										"formattedValue": "prep"
									},
									{},
									{
										"formattedValue": "Prep"
									},
									{},
									{
										"formattedValue": "Prep"
									},
									{},
									{
										"formattedValue": "Prep"
									},
									{},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "9:15 - 9:30"
									},
									{
										"formattedValue": "G"
									},
									{
										"formattedValue": "prep"
									},
									{},
									{
										"formattedValue": "Prep"
									},
									{},
									{
										"formattedValue": "Prep"
									},
									{},
									{
										"formattedValue": "Prep"
									},
									{},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "9:30-9:45"
									},
									{
										"formattedValue": "G"
									},
									{
										"formattedValue": "Rec"
									},
									{},
									{
										"formattedValue": "Rec"
									},
									{},
									{
										"formattedValue": "Rec"
									},
									{},
									{
										"formattedValue": "Rec"
									},
									{},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "9:45-10:00"
									},
									{
										"formattedValue": "G"
									},
									{
										"formattedValue": "Break"
									},
									{},
									{
										"formattedValue": "Break"
									},
									{},
									{
										"formattedValue": "Break"
									},
									{},
									{
										"formattedValue": "Break"
									},
									{},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "10:00 - 10:15"
									},
									{
										"formattedValue": "G"
									},
									{
										"formattedValue": "Rec"
									},
									{},
									{
										"formattedValue": "Rec"
									},
									{},
									{
										"formattedValue": "Rec"
									},
									{},
									{
										"formattedValue": "Rec"
									},
									{},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "10:15 - 10:30"
									},
									{
										"formattedValue": "G"
									},
									{
										"formattedValue": "Prep"
									},
									{},
									{
										"formattedValue": "G 4B"
									},
									{
										"formattedValue": "4B"
									},
									{
										"formattedValue": "G 5A"
									},
									{
										"formattedValue": "5A"
									},
									{
										"formattedValue": "Prep"
									},
									{},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "10:30 - 10:45"
									},
									{
										"formattedValue": "G"
									},
									{
										"formattedValue": "G KA"
									},
									{
										"formattedValue": "KA"
									},
									{
										"formattedValue": "G 4B"
									},
									{
										"formattedValue": "4B"
									},
									{
										"formattedValue": "G 5A"
									},
									{
										"formattedValue": "5A"
									},
									{
										"formattedValue": "Prep"
									},
									{},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "10:45 - 11:00"
									},
									{
										"formattedValue": "G"
									},
									{
										"formattedValue": "G KA"
									},
									{
										"formattedValue": "KA"
									},
									{
										"formattedValue": "Prep"
									},
									{},
									{
										"formattedValue": "Prep"
									},
									{},
									{
										"formattedValue": "Prep"
									},
									{},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "11:00 - 11:15"
									},
									{
										"formattedValue": "G"
									},
									{
										"formattedValue": "Duty"
									},
									{},
									{
										"formattedValue": "Duty"
									},
									{},
									{
										"formattedValue": "Duty"
									},
									{},
									{
										"formattedValue": "Duty"
									},
									{},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "11:15 - 11:30"
									},
									{
										"formattedValue": "G"
									},
									{
										"formattedValue": "Duty"
									},
									{},
									{
										"formattedValue": "Duty"
									},
									{},
									{
										"formattedValue": "Duty"
									},
									{},
									{
										"formattedValue": "Duty"
									},
									{},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "11:30 - 11:45"
									},
									{
										"formattedValue": "G"
									},
									{
										"formattedValue": "Duty"
									},
									{},
									{
										"formattedValue": "Duty"
									},
									{},
									{
										"formattedValue": "Duty"
									},
									{},
									{
										"formattedValue": "Duty"
									},
									{},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "11:45 - 12:00"
									},
									{
										"formattedValue": "G"
									},
									{
										"formattedValue": "Duty"
									},
									{},
									{
										"formattedValue": "Duty"
									},
									{},
									{
										"formattedValue": "Duty"
									},
									{},
									{
										"formattedValue": "Duty"
									},
									{},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "12:00 - 12:15"
									},
									{
										"formattedValue": "G"
									},
									{
										"formattedValue": "Duty"
									},
									{},
									{
										"formattedValue": "Duty"
									},
									{},
									{
										"formattedValue": "Duty"
									},
									{},
									{
										"formattedValue": "Duty"
									},
									{},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "12:15 - 12:30"
									},
									{
										"formattedValue": "G"
									},
									{
										"formattedValue": "Prep"
									},
									{},
									{
										"formattedValue": "prep"
									},
									{},
									{
										"formattedValue": "Duty"
									},
									{},
									{
										"formattedValue": "Duty"
									},
									{},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "12:30-12:45"
									},
									{
										"formattedValue": "G"
									},
									{
										"formattedValue": "Prep"
									},
									{},
									{
										"formattedValue": "prep"
									},
									{},
									{
										"formattedValue": "Duty"
									},
									{},
									{
										"formattedValue": "Duty"
									},
									{},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "12:45-1:00"
									},
									{
										"formattedValue": "G"
									},
									{
										"formattedValue": "Lunch"
									},
									{},
									{
										"formattedValue": "Lunch"
									},
									{},
									{
										"formattedValue": "Lunch"
									},
									{},
									{
										"formattedValue": "Lunch"
									},
									{},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "1:00 - 1:15"
									},
									{
										"formattedValue": "G"
									},
									{
										"formattedValue": "Lunch"
									},
									{},
									{
										"formattedValue": "Lunch"
									},
									{},
									{
										"formattedValue": "Lunch"
									},
									{},
									{
										"formattedValue": "Lunch"
									},
									{},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "1:15 - 1:30"
									},
									{
										"formattedValue": "G"
									},
									{
										"formattedValue": "Lunch"
									},
									{},
									{
										"formattedValue": "Lunch"
									},
									{},
									{
										"formattedValue": "Lunch"
									},
									{},
									{
										"formattedValue": "Lunch"
									},
									{},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "1:30 - 1:45"
									},
									{
										"formattedValue": "G"
									},
									{
										"formattedValue": "G KB"
									},
									{
										"formattedValue": "KB"
									},
									{
										"formattedValue": "G 3B"
									},
									{
										"formattedValue": "3B"
									},
									{
										"formattedValue": "Lunch"
									},
									{},
									{
										"formattedValue": "Lunch"
									},
									{},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "1:45-2:00"
									},
									{
										"formattedValue": "G"
									},
									{
										"formattedValue": "G KB"
									},
									{
										"formattedValue": "KB"
									},
									{
										"formattedValue": "G 3B"
									},
									{
										"formattedValue": "3B"
									},
									{
										"formattedValue": "Duty"
									},
									{},
									{
										"formattedValue": "PD"
									},
									{},
									{
										"formattedValue": "0"
									},
									{
										"formattedValue": "0"
									}
								]
							}
						]
					}
				]
			},
			{
				"properties": {
					"sheetId": 1558634518,
					"title": "Teachers",
					"index": 1,
					"sheetType": "GRID",
					"gridProperties": {
						"rowCount": 1000,
						"columnCount": 27
					}
				},
				"data": [
					{
						"rowData": [
							{
								"values": [
									{
										"formattedValue": "id"
									},
									{
										"formattedValue": "name"
									},
									{
										"formattedValue": "group"
									},
									{
										"formattedValue": "group_id"
									},
									{
										"formattedValue": "tags"
									},
									{
										"formattedValue": "fte"
									},
									{
										"formattedValue": "prep_teachers"
									},
									{
										"formattedValue": "release_teachers"
									},
									{
										"formattedValue": "unavailable"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "KA"
									},
									{
										"formattedValue": "Kinder A"
									},
									{
										"formattedValue": "Classroom"
									},
									{
										"formattedValue": "1"
									},
									{
										"formattedValue": "Kindergarten"
									},
									{
										"formattedValue": "TRUE"
									},
									{
										"formattedValue": "KA,KB,KC"
									},
									{
										"formattedValue": "V,Sci,Tech,Lib"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "PE"
									},
									{
										"formattedValue": "PE"
									},
									{
										"formattedValue": "Specials"
									},
									{
										"formattedValue": "3"
									},
									{},
									{
										"formattedValue": "FALSE"
									},
									{},
									{},
									{
										"formattedValue": "Thursday"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "KB"
									},
									{
										"formattedValue": "Kinder B"
									},
									{
										"formattedValue": "Classroom"
									},
									{
										"formattedValue": "1"
									},
									{
										"formattedValue": "Kindergarten"
									},
									{
										"formattedValue": "TRUE"
									},
									{
										"formattedValue": "KA,KB,KC"
									},
									{
										"formattedValue": "V,Sci,Tech,Lib"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "KC"
									},
									{
										"formattedValue": "Kinder C"
									},
									{
										"formattedValue": "Classroom"
									},
									{
										"formattedValue": "1"
									},
									{
										"formattedValue": "Kindergarten"
									},
									{
										"formattedValue": "TRUE"
									},
									{
										"formattedValue": "KA,KB,KC"
									},
									{
										"formattedValue": "V,Sci,Tech,Lib"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "1A"
									},
									{
										"formattedValue": "1st A"
									},
									{
										"formattedValue": "Classroom"
									},
									{
										"formattedValue": "1"
									},
									{
										"formattedValue": "1st grade"
									},
									{
										"formattedValue": "TRUE"
									},
									{
										"formattedValue": "1A,1B,1C"
									},
									{
										"formattedValue": "V,Sci,Tech,Lib"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "V"
									},
									{
										"formattedValue": "VAPA"
									},
									{
										"formattedValue": "Specials"
									},
									{
										"formattedValue": "3"
									},
									{},
									{
										"formattedValue": "FALSE"
									},
									{},
									{},
									{
										"formattedValue": "Wednesday,Thursday,Friday"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "Sci"
									},
									{
										"formattedValue": "Science"
									},
									{
										"formattedValue": "Enrichment"
									},
									{
										"formattedValue": "2"
									},
									{},
									{
										"formattedValue": "TRUE"
									},
									{},
									{},
									{
										"formattedValue": "Monday,Friday"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "1B"
									},
									{
										"formattedValue": "1st B"
									},
									{
										"formattedValue": "Classroom"
									},
									{
										"formattedValue": "1"
									},
									{
										"formattedValue": "1st grade"
									},
									{
										"formattedValue": "TRUE"
									},
									{
										"formattedValue": "1A,1B,1C"
									},
									{
										"formattedValue": "V,Sci,Tech,Lib"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "G"
									},
									{
										"formattedValue": "Garden"
									},
									{
										"formattedValue": "Specials"
									},
									{
										"formattedValue": "3"
									},
									{},
									{
										"formattedValue": "FALSE"
									},
									{},
									{},
									{
										"formattedValue": "Friday"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "PW"
									},
									{
										"formattedValue": "Playworks"
									},
									{
										"formattedValue": "Specials"
									},
									{
										"formattedValue": "3"
									},
									{},
									{
										"formattedValue": "FALSE"
									},
									{},
									{},
									{
										"formattedValue": "Friday"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "Tech"
									},
									{
										"formattedValue": "Technology"
									},
									{
										"formattedValue": "Enrichment"
									},
									{
										"formattedValue": "2"
									},
									{},
									{
										"formattedValue": "TRUE"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "1C"
									},
									{
										"formattedValue": "1st C"
									},
									{
										"formattedValue": "Classroom"
									},
									{
										"formattedValue": "1"
									},
									{
										"formattedValue": "1st grade"
									},
									{
										"formattedValue": "TRUE"
									},
									{
										"formattedValue": "1A,1B,1C"
									},
									{
										"formattedValue": "V,Sci,Tech,Lib"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "Lib"
									},
									{
										"formattedValue": "Library"
									},
									{
										"formattedValue": "Enrichment"
									},
									{
										"formattedValue": "2"
									},
									{},
									{
										"formattedValue": "TRUE"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "2A"
									},
									{
										"formattedValue": "2nd A"
									},
									{
										"formattedValue": "Classroom"
									},
									{
										"formattedValue": "1"
									},
									{
										"formattedValue": "2nd grade"
									},
									{
										"formattedValue": "TRUE"
									},
									{
										"formattedValue": "2A,2B"
									},
									{
										"formattedValue": "V,Sci,Tech,Lib"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "2B"
									},
									{
										"formattedValue": "2nd B"
									},
									{
										"formattedValue": "Classroom"
									},
									{
										"formattedValue": "1"
									},
									{
										"formattedValue": "2nd grade"
									},
									{
										"formattedValue": "TRUE"
									},
									{
										"formattedValue": "2A,2B"
									},
									{
										"formattedValue": "V,Sci,Tech,Lib"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "3A"
									},
									{
										"formattedValue": "3rd A"
									},
									{
										"formattedValue": "Classroom"
									},
									{
										"formattedValue": "1"
									},
									{
										"formattedValue": "3rd grade"
									},
									{
										"formattedValue": "TRUE"
									},
									{
										"formattedValue": "3A,3B"
									},
									{
										"formattedValue": "V,Sci,Tech,Lib"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "3B"
									},
									{
										"formattedValue": "3rd B"
									},
									{
										"formattedValue": "Classroom"
									},
									{
										"formattedValue": "1"
									},
									{
										"formattedValue": "3rd grade"
									},
									{
										"formattedValue": "TRUE"
									},
									{
										"formattedValue": "3A,3B"
									},
									{
										"formattedValue": "V,Sci,Tech,Lib"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "4A"
									},
									{
										"formattedValue": "4th A"
									},
									{
										"formattedValue": "Classroom"
									},
									{
										"formattedValue": "1"
									},
									{
										"formattedValue": "4th grade"
									},
									{
										"formattedValue": "TRUE"
									},
									{
										"formattedValue": "4A,4B,5A"
									},
									{
										"formattedValue": "V,Sci,Tech,Lib"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "4B"
									},
									{
										"formattedValue": "4th B"
									},
									{
										"formattedValue": "Classroom"
									},
									{
										"formattedValue": "1"
									},
									{
										"formattedValue": "4th grade"
									},
									{
										"formattedValue": "TRUE"
									},
									{
										"formattedValue": "4A,4B,5A"
									},
									{
										"formattedValue": "V,Sci,Tech,Lib"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "5A"
									},
									{
										"formattedValue": "5th A"
									},
									{
										"formattedValue": "Classroom"
									},
									{
										"formattedValue": "1"
									},
									{
										"formattedValue": "4th grade"
									},
									{
										"formattedValue": "TRUE"
									},
									{
										"formattedValue": "4A,4B,5A"
									},
									{
										"formattedValue": "V,Sci,Tech,Lib"
									}
								]
							}
						]
					}
				]
			},
			{
				"properties": {
					"sheetId": 1120187879,
					"title": "Meetings",
					"index": 2,
					"sheetType": "GRID",
					"gridProperties": {
						"rowCount": 997,
						"columnCount": 26
					}
				},
				"data": [
					{
						"rowData": [
							{
								"values": [
									{
										"formattedValue": "id"
									},
									{
										"formattedValue": "name"
									},
									{
										"formattedValue": "type"
									},
									{
										"formattedValue": "core"
									},
									{
										"formattedValue": "instructional"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "Intake"
									},
									{
										"formattedValue": "Intake"
									},
									{
										"formattedValue": "Instructional"
									},
									{
										"formattedValue": "FALSE"
									},
									{
										"formattedValue": "FALSE"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "ELD"
									},
									{
										"formattedValue": "ELD"
									},
									{
										"formattedValue": "Instructional"
									},
									{
										"formattedValue": "FALSE"
									},
									{
										"formattedValue": "TRUE"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "PE"
									},
									{
										"formattedValue": "PE"
									},
									{
										"formattedValue": "Instructional"
									},
									{
										"formattedValue": "FALSE"
									},
									{
										"formattedValue": "FALSE"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "Instructional"
									},
									{
										"formattedValue": "TRUE"
									},
									{
										"formattedValue": "TRUE"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "Rec"
									},
									{
										"formattedValue": "Recess"
									},
									{
										"formattedValue": "Break"
									},
									{},
									{
										"formattedValue": "FALSE"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "PW"
									},
									{
										"formattedValue": "Playworks"
									},
									{
										"formattedValue": "Instructional"
									},
									{
										"formattedValue": "FALSE"
									},
									{
										"formattedValue": "TRUE"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "G"
									},
									{
										"formattedValue": "Garden"
									},
									{
										"formattedValue": "Instructional"
									},
									{
										"formattedValue": "FALSE"
									},
									{
										"formattedValue": "TRUE"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "Lunch"
									},
									{
										"formattedValue": "Lunch"
									},
									{
										"formattedValue": "Break"
									},
									{},
									{
										"formattedValue": "FALSE"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "VAPA"
									},
									{
										"formattedValue": "VAPA"
									},
									{
										"formattedValue": "Instructional"
									},
									{
										"formattedValue": "FALSE"
									},
									{
										"formattedValue": "FALSE"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "COTEACH"
									},
									{
										"formattedValue": "COTEACH"
									},
									{
										"formattedValue": "Blended"
									},
									{
										"formattedValue": "FALSE"
									},
									{
										"formattedValue": "FALSE"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "Specials"
									},
									{
										"formattedValue": "Specials"
									},
									{
										"formattedValue": "Prep"
									},
									{
										"formattedValue": "FALSE"
									},
									{
										"formattedValue": "FALSE"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "Duty"
									},
									{
										"formattedValue": "Duty"
									},
									{
										"formattedValue": "Duty"
									},
									{},
									{
										"formattedValue": "FALSE"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "Prep"
									},
									{
										"formattedValue": "Prep"
									},
									{
										"formattedValue": "Prep"
									},
									{},
									{
										"formattedValue": "FALSE"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "PD"
									},
									{
										"formattedValue": "PD"
									},
									{
										"formattedValue": "PD"
									},
									{
										"formattedValue": "FALSE"
									},
									{
										"formattedValue": "FALSE"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "PWG"
									},
									{
										"formattedValue": "Playworks/Garden"
									},
									{
										"formattedValue": "Instructional"
									},
									{
										"formattedValue": "FALSE"
									},
									{
										"formattedValue": "TRUE"
									}
								]
							}
						]
					}
				]
			}
		]
	};

/***/ },
/* 300 */
/***/ function(module, exports) {

	module.exports = {
		"spreadsheetId": "3",
		"properties": {
			"title": "Version 2 Test Schedule"
		},
		"sheets": [
			{
				"properties": {
					"sheetId": 293666632,
					"title": "School",
					"index": 0,
					"sheetType": "GRID",
					"gridProperties": {
						"rowCount": 290,
						"columnCount": 12,
						"frozenRowCount": 1
					}
				},
				"data": [
					{
						"rowData": [
							{
								"values": [
									{
										"formattedValue": "name"
									},
									{
										"formattedValue": "meeting_type_id"
									},
									{
										"formattedValue": "start_time"
									},
									{
										"formattedValue": "end_time"
									},
									{
										"formattedValue": "day_of_week"
									},
									{
										"formattedValue": "teacher_id"
									},
									{
										"formattedValue": "teacher_id"
									},
									{
										"formattedValue": "section_id"
									},
									{
										"formattedValue": "section_id"
									},
									{},
									{},
									{}
								]
							},
							{
								"values": [
									{
										"formattedValue": "Dance"
									},
									{
										"formattedValue": "Specials"
									},
									{
										"formattedValue": "12:10"
									},
									{
										"formattedValue": "12:40"
									},
									{
										"formattedValue": "W"
									},
									{
										"formattedValue": "Dance, 1A"
									},
									{},
									{
										"formattedValue": "1A"
									},
									{},
									{},
									{},
									{}
								]
							},
							{
								"values": [
									{
										"formattedValue": "PE"
									},
									{
										"formattedValue": "PE"
									},
									{
										"formattedValue": "12:10"
									},
									{
										"formattedValue": "12:40"
									},
									{
										"formattedValue": "M, T,Th,F"
									},
									{
										"formattedValue": "PE"
									},
									{},
									{
										"formattedValue": "1A"
									},
									{},
									{},
									{},
									{}
								]
							},
							{
								"values": [
									{
										"formattedValue": "Math"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "1:00"
									},
									{
										"formattedValue": "2:00"
									},
									{
										"formattedValue": "M-F"
									},
									{
										"formattedValue": "1B"
									},
									{},
									{
										"formattedValue": "1A"
									},
									{},
									{},
									{},
									{}
								]
							},
							{
								"values": [
									{
										"formattedValue": "Math Corner"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "12:40"
									},
									{
										"formattedValue": "1:00"
									},
									{
										"formattedValue": "M-F"
									},
									{
										"formattedValue": "1B"
									},
									{},
									{
										"formattedValue": "1A"
									},
									{},
									{},
									{},
									{}
								]
							},
							{
								"values": [
									{
										"formattedValue": "RW"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "9:30"
									},
									{
										"formattedValue": "10:30"
									},
									{
										"formattedValue": "M-F"
									},
									{
										"formattedValue": "1A"
									},
									{},
									{
										"formattedValue": "1A"
									},
									{},
									{},
									{},
									{}
								]
							},
							{
								"values": [
									{
										"formattedValue": "Science"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "2:00"
									},
									{
										"formattedValue": "2:30"
									},
									{
										"formattedValue": "M-F"
									},
									{
										"formattedValue": "1B"
									},
									{},
									{
										"formattedValue": "1A"
									},
									{},
									{},
									{},
									{}
								]
							},
							{
								"values": [
									{
										"formattedValue": "Specials"
									},
									{
										"formattedValue": "Specials"
									},
									{
										"formattedValue": "8:50"
									},
									{
										"formattedValue": "9:30"
									},
									{
										"formattedValue": "M-F"
									},
									{
										"formattedValue": "Ranting"
									},
									{},
									{
										"formattedValue": "1A"
									},
									{},
									{},
									{},
									{}
								]
							},
							{
								"values": [
									{
										"formattedValue": "SS"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "2:30"
									},
									{
										"formattedValue": "3:00"
									},
									{
										"formattedValue": "M-F"
									},
									{
										"formattedValue": "1B"
									},
									{},
									{
										"formattedValue": "1A"
									},
									{},
									{},
									{},
									{}
								]
							},
							{
								"values": [
									{
										"formattedValue": "SS"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "8:00"
									},
									{
										"formattedValue": "8:50"
									},
									{
										"formattedValue": "M-F"
									},
									{
										"formattedValue": "1A"
									},
									{},
									{
										"formattedValue": "1A"
									},
									{},
									{},
									{},
									{}
								]
							},
							{
								"values": [
									{
										"formattedValue": "WW"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "10:30"
									},
									{
										"formattedValue": "11:30"
									},
									{
										"formattedValue": "M-F"
									},
									{
										"formattedValue": "1A"
									},
									{},
									{
										"formattedValue": "1A"
									},
									{},
									{},
									{},
									{}
								]
							},
							{
								"values": [
									{
										"formattedValue": "Lunch 2"
									},
									{
										"formattedValue": "Lunch"
									},
									{
										"formattedValue": "11:30"
									},
									{
										"formattedValue": "12:10"
									},
									{
										"formattedValue": "M-F"
									},
									{},
									{},
									{
										"formattedValue": "1A, 1B, 1C"
									},
									{},
									{},
									{},
									{}
								]
							},
							{
								"values": [
									{
										"formattedValue": "Recess"
									},
									{
										"formattedValue": "Recess"
									},
									{
										"formattedValue": "11:10"
									},
									{
										"formattedValue": "11:30"
									},
									{
										"formattedValue": "M-F"
									},
									{
										"formattedValue": "1A, 1B"
									},
									{},
									{
										"formattedValue": "1A, 1B, 1C"
									},
									{},
									{},
									{},
									{}
								]
							},
							{
								"values": [
									{
										"formattedValue": "Dance"
									},
									{
										"formattedValue": "Specials"
									},
									{
										"formattedValue": "12:10"
									},
									{
										"formattedValue": "12:40"
									},
									{
										"formattedValue": "T"
									},
									{
										"formattedValue": "Dance, 1B"
									},
									{},
									{
										"formattedValue": "1B"
									},
									{},
									{},
									{},
									{}
								]
							},
							{
								"values": [
									{
										"formattedValue": "PE"
									},
									{
										"formattedValue": "PE"
									},
									{
										"formattedValue": "12:10"
									},
									{
										"formattedValue": "12:40"
									},
									{
										"formattedValue": "M,W,Th,F"
									},
									{
										"formattedValue": "PE"
									},
									{},
									{
										"formattedValue": "1B"
									},
									{},
									{},
									{},
									{}
								]
							},
							{
								"values": [
									{
										"formattedValue": "Math"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "10:30"
									},
									{
										"formattedValue": "11:30"
									},
									{
										"formattedValue": "M-F"
									},
									{
										"formattedValue": "1B"
									},
									{},
									{
										"formattedValue": "1B"
									},
									{},
									{},
									{},
									{}
								]
							},
							{
								"values": [
									{
										"formattedValue": "Math Corner"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "9:30"
									},
									{
										"formattedValue": "10:30"
									},
									{
										"formattedValue": "M-F"
									},
									{
										"formattedValue": "1B"
									},
									{},
									{
										"formattedValue": "1B"
									},
									{},
									{},
									{},
									{}
								]
							},
							{
								"values": [
									{
										"formattedValue": "RW"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "1:00"
									},
									{
										"formattedValue": "2:00"
									},
									{
										"formattedValue": "M-F"
									},
									{
										"formattedValue": "1A"
									},
									{},
									{
										"formattedValue": "1B"
									},
									{},
									{},
									{},
									{}
								]
							},
							{
								"values": [
									{
										"formattedValue": "Science"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "8:00"
									},
									{
										"formattedValue": "8:50"
									},
									{
										"formattedValue": "M-F"
									},
									{
										"formattedValue": "1B"
									},
									{},
									{
										"formattedValue": "1B"
									},
									{},
									{},
									{},
									{}
								]
							},
							{
								"values": [
									{
										"formattedValue": "Specials"
									},
									{
										"formattedValue": "Specials"
									},
									{
										"formattedValue": "8:50"
									},
									{
										"formattedValue": "9:30"
									},
									{
										"formattedValue": "M-F"
									},
									{
										"formattedValue": "Quilting"
									},
									{},
									{
										"formattedValue": "1B"
									},
									{},
									{},
									{},
									{}
								]
							},
							{
								"values": [
									{
										"formattedValue": "SS"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "12:40"
									},
									{
										"formattedValue": "1:00"
									},
									{
										"formattedValue": "M-F"
									},
									{
										"formattedValue": "1A"
									},
									{},
									{
										"formattedValue": "1B"
									},
									{},
									{},
									{},
									{}
								]
							},
							{
								"values": [
									{
										"formattedValue": "WW"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "2:00"
									},
									{
										"formattedValue": "3:00"
									},
									{
										"formattedValue": "M-F"
									},
									{
										"formattedValue": "1A"
									},
									{},
									{
										"formattedValue": "1B"
									},
									{},
									{},
									{},
									{}
								]
							},
							{
								"values": [
									{
										"formattedValue": "Dance"
									},
									{
										"formattedValue": "Specials"
									},
									{
										"formattedValue": "12:10"
									},
									{
										"formattedValue": "12:40"
									},
									{
										"formattedValue": "Th"
									},
									{
										"formattedValue": "Dance, 1C"
									},
									{},
									{
										"formattedValue": "1C"
									},
									{},
									{},
									{},
									{}
								]
							},
							{
								"values": [
									{
										"formattedValue": "PE"
									},
									{
										"formattedValue": "PE"
									},
									{
										"formattedValue": "12:10"
									},
									{
										"formattedValue": "12:40"
									},
									{
										"formattedValue": "M,T,W,F"
									},
									{
										"formattedValue": "PE"
									},
									{},
									{
										"formattedValue": "1C"
									},
									{},
									{},
									{},
									{}
								]
							},
							{
								"values": [
									{
										"formattedValue": "Math"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "1:00"
									},
									{
										"formattedValue": "2:00"
									},
									{
										"formattedValue": "M-F"
									},
									{
										"formattedValue": "1C"
									},
									{},
									{
										"formattedValue": "1C"
									},
									{},
									{},
									{},
									{}
								]
							},
							{
								"values": [
									{
										"formattedValue": "Math Corner"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "12:40"
									},
									{
										"formattedValue": "1:00"
									},
									{
										"formattedValue": "M-F"
									},
									{
										"formattedValue": "1C"
									},
									{},
									{
										"formattedValue": "1C"
									},
									{},
									{},
									{},
									{}
								]
							},
							{
								"values": [
									{
										"formattedValue": "RW"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "10:30"
									},
									{
										"formattedValue": "11:30"
									},
									{
										"formattedValue": "M-F"
									},
									{
										"formattedValue": "1C"
									},
									{},
									{
										"formattedValue": "1C"
									},
									{},
									{},
									{},
									{}
								]
							},
							{
								"values": [
									{
										"formattedValue": "Science"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "8:00"
									},
									{
										"formattedValue": "8:50"
									},
									{
										"formattedValue": "M-F"
									},
									{
										"formattedValue": "1C"
									},
									{},
									{
										"formattedValue": "1C"
									},
									{},
									{},
									{},
									{}
								]
							},
							{
								"values": [
									{
										"formattedValue": "Specials"
									},
									{
										"formattedValue": "Specials"
									},
									{
										"formattedValue": "8:50"
									},
									{
										"formattedValue": "9:30"
									},
									{
										"formattedValue": "M-F"
									},
									{
										"formattedValue": "Pyrotechnics"
									},
									{},
									{
										"formattedValue": "1C"
									},
									{},
									{},
									{},
									{}
								]
							},
							{
								"values": [
									{
										"formattedValue": "SS"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "9:30"
									},
									{
										"formattedValue": "10:30"
									},
									{
										"formattedValue": "M-F"
									},
									{
										"formattedValue": "1C"
									},
									{},
									{
										"formattedValue": "1C"
									},
									{},
									{},
									{},
									{}
								]
							},
							{
								"values": [
									{
										"formattedValue": "WW"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "2:00"
									},
									{
										"formattedValue": "3:00"
									},
									{
										"formattedValue": "M-F"
									},
									{
										"formattedValue": "1C"
									},
									{},
									{
										"formattedValue": "1C"
									},
									{},
									{},
									{},
									{}
								]
							},
							{
								"values": [
									{
										"formattedValue": "Dance"
									},
									{
										"formattedValue": "Specials"
									},
									{
										"formattedValue": "1:30"
									},
									{
										"formattedValue": "2:00"
									},
									{
										"formattedValue": "W"
									},
									{
										"formattedValue": "Dance, KA"
									},
									{},
									{
										"formattedValue": "KA"
									},
									{},
									{},
									{},
									{}
								]
							},
							{
								"values": [
									{
										"formattedValue": "PE"
									},
									{
										"formattedValue": "PE"
									},
									{
										"formattedValue": "1:30"
									},
									{
										"formattedValue": "2:00"
									},
									{
										"formattedValue": "M, T,Th,F"
									},
									{
										"formattedValue": "PE"
									},
									{},
									{
										"formattedValue": "KA"
									},
									{},
									{},
									{},
									{}
								]
							},
							{
								"values": [
									{
										"formattedValue": "Math"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "8:30"
									},
									{
										"formattedValue": "9:40"
									},
									{
										"formattedValue": "M-F"
									},
									{
										"formattedValue": "KA"
									},
									{},
									{
										"formattedValue": "KA"
									},
									{},
									{},
									{},
									{}
								]
							},
							{
								"values": [
									{
										"formattedValue": "Math Corner"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "8:00"
									},
									{
										"formattedValue": "8:30"
									},
									{
										"formattedValue": "M-F"
									},
									{
										"formattedValue": "KA"
									},
									{},
									{
										"formattedValue": "KA"
									},
									{},
									{},
									{},
									{}
								]
							},
							{
								"values": [
									{
										"formattedValue": "RW"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "9:40"
									},
									{
										"formattedValue": "10:15"
									},
									{
										"formattedValue": "M-F"
									},
									{
										"formattedValue": "KA"
									},
									{},
									{
										"formattedValue": "KA"
									},
									{},
									{},
									{},
									{}
								]
							},
							{
								"values": [
									{
										"formattedValue": "RW"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "10:15"
									},
									{
										"formattedValue": "10:50"
									},
									{
										"formattedValue": "M-F"
									},
									{
										"formattedValue": "KA"
									},
									{},
									{
										"formattedValue": "KA"
									},
									{},
									{},
									{},
									{}
								]
							},
							{
								"values": [
									{
										"formattedValue": "Science"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "12:10"
									},
									{
										"formattedValue": "1:10"
									},
									{
										"formattedValue": "M-F"
									},
									{
										"formattedValue": "KA"
									},
									{},
									{
										"formattedValue": "KA"
									},
									{},
									{},
									{},
									{}
								]
							},
							{
								"values": [
									{
										"formattedValue": "SS"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "1:10"
									},
									{
										"formattedValue": "1:30"
									},
									{
										"formattedValue": "M-F"
									},
									{
										"formattedValue": "KA"
									},
									{},
									{
										"formattedValue": "KA"
									},
									{},
									{},
									{},
									{}
								]
							},
							{
								"values": [
									{
										"formattedValue": "WW"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "2:00"
									},
									{
										"formattedValue": "3:00"
									},
									{
										"formattedValue": "M-F"
									},
									{
										"formattedValue": "KA"
									},
									{},
									{
										"formattedValue": "KA"
									},
									{},
									{},
									{},
									{}
								]
							},
							{
								"values": [
									{
										"formattedValue": "Lunch 1"
									},
									{
										"formattedValue": "Lunch"
									},
									{
										"formattedValue": "12:10"
									},
									{
										"formattedValue": "12:50"
									},
									{
										"formattedValue": "M-F"
									},
									{},
									{},
									{
										"formattedValue": "KA, KB, KC"
									},
									{},
									{},
									{},
									{}
								]
							},
							{
								"values": [
									{
										"formattedValue": "Recess"
									},
									{
										"formattedValue": "Recess"
									},
									{
										"formattedValue": "11:50"
									},
									{
										"formattedValue": "12:10"
									},
									{
										"formattedValue": "M-F"
									},
									{
										"formattedValue": "KA, KB"
									},
									{},
									{
										"formattedValue": "KA, KB, KC"
									},
									{},
									{},
									{},
									{}
								]
							},
							{
								"values": [
									{
										"formattedValue": "Dance"
									},
									{
										"formattedValue": "Specials"
									},
									{
										"formattedValue": "1:30"
									},
									{
										"formattedValue": "2:00"
									},
									{
										"formattedValue": "T"
									},
									{
										"formattedValue": "Dance, KB"
									},
									{},
									{
										"formattedValue": "KB"
									},
									{},
									{},
									{},
									{}
								]
							},
							{
								"values": [
									{
										"formattedValue": "PE"
									},
									{
										"formattedValue": "PE"
									},
									{
										"formattedValue": "1:30"
									},
									{
										"formattedValue": "2:00"
									},
									{
										"formattedValue": "M,W,Th,F"
									},
									{
										"formattedValue": "PE"
									},
									{},
									{
										"formattedValue": "KB"
									},
									{},
									{},
									{},
									{}
								]
							},
							{
								"values": [
									{
										"formattedValue": "Math"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "8:30"
									},
									{
										"formattedValue": "9:40"
									},
									{
										"formattedValue": "M-F"
									},
									{
										"formattedValue": "KB"
									},
									{},
									{
										"formattedValue": "KB"
									},
									{},
									{},
									{},
									{}
								]
							},
							{
								"values": [
									{
										"formattedValue": "Math Corner"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "8:00"
									},
									{
										"formattedValue": "8:30"
									},
									{
										"formattedValue": "M-F"
									},
									{
										"formattedValue": "KB"
									},
									{},
									{
										"formattedValue": "KB"
									},
									{},
									{},
									{},
									{}
								]
							},
							{
								"values": [
									{
										"formattedValue": "RW"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "9:40"
									},
									{
										"formattedValue": "10:15"
									},
									{
										"formattedValue": "M-F"
									},
									{
										"formattedValue": "KB"
									},
									{},
									{
										"formattedValue": "KB"
									},
									{},
									{},
									{},
									{}
								]
							},
							{
								"values": [
									{
										"formattedValue": "RW"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "10:50"
									},
									{
										"formattedValue": "11:30"
									},
									{
										"formattedValue": "M-F"
									},
									{
										"formattedValue": "KB"
									},
									{},
									{
										"formattedValue": "KB"
									},
									{},
									{},
									{},
									{}
								]
							},
							{
								"values": [
									{
										"formattedValue": "Science"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "12:10"
									},
									{
										"formattedValue": "1:10"
									},
									{
										"formattedValue": "M-F"
									},
									{
										"formattedValue": "KB"
									},
									{},
									{
										"formattedValue": "KB"
									},
									{},
									{},
									{},
									{}
								]
							},
							{
								"values": [
									{
										"formattedValue": "SS"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "1:10"
									},
									{
										"formattedValue": "1:30"
									},
									{
										"formattedValue": "M-F"
									},
									{
										"formattedValue": "KB"
									},
									{},
									{
										"formattedValue": "KB"
									},
									{},
									{},
									{},
									{}
								]
							},
							{
								"values": [
									{
										"formattedValue": "WW"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "2:00"
									},
									{
										"formattedValue": "3:00"
									},
									{
										"formattedValue": "M-F"
									},
									{
										"formattedValue": "KB"
									},
									{},
									{
										"formattedValue": "KB"
									},
									{},
									{},
									{},
									{}
								]
							},
							{
								"values": [
									{
										"formattedValue": "Dance"
									},
									{
										"formattedValue": "Specials"
									},
									{
										"formattedValue": "1:30"
									},
									{
										"formattedValue": "2:00"
									},
									{
										"formattedValue": "Th"
									},
									{
										"formattedValue": "Dance, KC"
									},
									{},
									{
										"formattedValue": "KC"
									},
									{},
									{},
									{},
									{}
								]
							},
							{
								"values": [
									{
										"formattedValue": "PE"
									},
									{
										"formattedValue": "PE"
									},
									{
										"formattedValue": "1:30"
									},
									{
										"formattedValue": "2:00"
									},
									{
										"formattedValue": "M,T,W,F"
									},
									{
										"formattedValue": "PE"
									},
									{},
									{
										"formattedValue": "KC"
									},
									{},
									{},
									{},
									{}
								]
							},
							{
								"values": [
									{
										"formattedValue": "Math"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "8:30"
									},
									{
										"formattedValue": "9:40"
									},
									{
										"formattedValue": "M-F"
									},
									{
										"formattedValue": "KC"
									},
									{},
									{
										"formattedValue": "KC"
									},
									{},
									{},
									{},
									{}
								]
							},
							{
								"values": [
									{
										"formattedValue": "Math Corner"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "8:00"
									},
									{
										"formattedValue": "8:30"
									},
									{
										"formattedValue": "M-F"
									},
									{
										"formattedValue": "KC"
									},
									{},
									{
										"formattedValue": "KC"
									},
									{},
									{},
									{},
									{}
								]
							},
							{
								"values": [
									{
										"formattedValue": "RW"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "10:15"
									},
									{
										"formattedValue": "10:50"
									},
									{
										"formattedValue": "M-F"
									},
									{
										"formattedValue": "KC"
									},
									{},
									{
										"formattedValue": "KC"
									},
									{},
									{},
									{},
									{}
								]
							},
							{
								"values": [
									{
										"formattedValue": "RW"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "10:50"
									},
									{
										"formattedValue": "11:30"
									},
									{
										"formattedValue": "M-F"
									},
									{
										"formattedValue": "KC"
									},
									{},
									{
										"formattedValue": "KC"
									},
									{},
									{},
									{},
									{}
								]
							},
							{
								"values": [
									{
										"formattedValue": "Science"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "12:10"
									},
									{
										"formattedValue": "1:10"
									},
									{
										"formattedValue": "M-F"
									},
									{
										"formattedValue": "KC"
									},
									{},
									{
										"formattedValue": "KC"
									},
									{},
									{},
									{},
									{}
								]
							},
							{
								"values": [
									{
										"formattedValue": "SS"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "1:10"
									},
									{
										"formattedValue": "1:30"
									},
									{
										"formattedValue": "M-F"
									},
									{
										"formattedValue": "KC"
									},
									{},
									{
										"formattedValue": "KC"
									},
									{},
									{},
									{},
									{}
								]
							},
							{
								"values": [
									{
										"formattedValue": "WW"
									},
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "2:00"
									},
									{
										"formattedValue": "3:00"
									},
									{
										"formattedValue": "M-F"
									},
									{
										"formattedValue": "KC"
									},
									{},
									{
										"formattedValue": "KC"
									},
									{},
									{},
									{},
									{}
								]
							}
						]
					}
				]
			},
			{
				"properties": {
					"sheetId": 1558634518,
					"title": "Staff",
					"index": 1,
					"sheetType": "GRID",
					"gridProperties": {
						"rowCount": 935,
						"columnCount": 29
					}
				},
				"data": [
					{
						"rowData": [
							{
								"values": [
									{
										"formattedValue": "id"
									},
									{
										"formattedValue": "last_name"
									},
									{
										"formattedValue": "first_name"
									},
									{
										"formattedValue": "role"
									},
									{
										"formattedValue": "group"
									},
									{
										"formattedValue": "group_id"
									},
									{
										"formattedValue": "tags"
									},
									{
										"formattedValue": "fte"
									},
									{
										"formattedValue": "prep_teachers"
									},
									{
										"formattedValue": "release_teachers"
									},
									{
										"formattedValue": "unavailable"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "KA"
									},
									{
										"formattedValue": "Alexander"
									},
									{
										"formattedValue": "Abe"
									},
									{
										"formattedValue": "KA"
									},
									{
										"formattedValue": "Classroom"
									},
									{
										"formattedValue": "1"
									},
									{},
									{
										"formattedValue": "TRUE"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "KB"
									},
									{
										"formattedValue": "Buttons"
									},
									{
										"formattedValue": "Bran"
									},
									{
										"formattedValue": "KB"
									},
									{
										"formattedValue": "Classroom"
									},
									{
										"formattedValue": "1"
									},
									{},
									{
										"formattedValue": "TRUE"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "KC"
									},
									{
										"formattedValue": "Calmface"
									},
									{
										"formattedValue": "Carter"
									},
									{
										"formattedValue": "KC"
									},
									{
										"formattedValue": "Classroom"
									},
									{
										"formattedValue": "1"
									},
									{},
									{
										"formattedValue": "TRUE"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "1A"
									},
									{
										"formattedValue": "Dustwhisper"
									},
									{
										"formattedValue": "Deanna"
									},
									{
										"formattedValue": "1A"
									},
									{
										"formattedValue": "Classroom"
									},
									{
										"formattedValue": "1"
									},
									{},
									{
										"formattedValue": "TRUE"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "1B"
									},
									{
										"formattedValue": "Eddings"
									},
									{
										"formattedValue": "Ernora"
									},
									{
										"formattedValue": "1B"
									},
									{
										"formattedValue": "Classroom"
									},
									{
										"formattedValue": "1"
									},
									{},
									{
										"formattedValue": "TRUE"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "1C"
									},
									{
										"formattedValue": "Fastcharge"
									},
									{
										"formattedValue": "Fron"
									},
									{
										"formattedValue": "1C"
									},
									{
										"formattedValue": "Classroom"
									},
									{
										"formattedValue": "1"
									},
									{},
									{
										"formattedValue": "TRUE"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "Ranting"
									},
									{
										"formattedValue": "Heckchance"
									},
									{
										"formattedValue": "Holda"
									},
									{
										"formattedValue": "Ranting"
									},
									{
										"formattedValue": "Specials"
									},
									{
										"formattedValue": "2"
									},
									{},
									{
										"formattedValue": "FALSE"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "Quilting"
									},
									{
										"formattedValue": "Idlebrain"
									},
									{
										"formattedValue": "Ice"
									},
									{
										"formattedValue": "Quilting"
									},
									{
										"formattedValue": "Specials"
									},
									{
										"formattedValue": "2"
									},
									{
										"formattedValue": "Coach"
									},
									{
										"formattedValue": "FALSE"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "Pyrotechnics"
									},
									{
										"formattedValue": "Johnpepto"
									},
									{
										"formattedValue": "Jarga"
									},
									{
										"formattedValue": "Pyrotechnics"
									},
									{
										"formattedValue": "Specials"
									},
									{
										"formattedValue": "2"
									},
									{},
									{
										"formattedValue": "FALSE"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "Dance"
									},
									{
										"formattedValue": "Kidsquisher"
									},
									{
										"formattedValue": "Kitten"
									},
									{
										"formattedValue": "Dance"
									},
									{
										"formattedValue": "Specials"
									},
									{
										"formattedValue": "2"
									},
									{},
									{
										"formattedValue": "TRUE"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "PE"
									},
									{
										"formattedValue": "Lamp"
									},
									{
										"formattedValue": "Lauren"
									},
									{
										"formattedValue": "PE"
									},
									{
										"formattedValue": "Specials"
									},
									{
										"formattedValue": "2"
									},
									{},
									{
										"formattedValue": "TRUE"
									}
								]
							}
						]
					}
				]
			},
			{
				"properties": {
					"sheetId": 214155908,
					"title": "Cohorts",
					"index": 2,
					"sheetType": "GRID",
					"gridProperties": {
						"rowCount": 973,
						"columnCount": 27
					}
				},
				"data": [
					{
						"rowData": [
							{
								"values": [
									{
										"formattedValue": "id"
									},
									{
										"formattedValue": "name"
									},
									{
										"formattedValue": "group"
									},
									{
										"formattedValue": "group_id"
									},
									{
										"formattedValue": "tags"
									},
									{
										"formattedValue": "Size"
									},
									{
										"formattedValue": "%ELL"
									},
									{
										"formattedValue": "%ISE"
									},
									{
										"formattedValue": "%FRL"
									},
									{
										"formattedValue": "%Female"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "KA"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "KB"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "KC"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "1A"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "1B"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "1C"
									}
								]
							}
						]
					}
				]
			},
			{
				"properties": {
					"sheetId": 1120187879,
					"title": "Meetings",
					"index": 3,
					"sheetType": "GRID",
					"gridProperties": {
						"rowCount": 988,
						"columnCount": 26
					}
				},
				"data": [
					{
						"rowData": [
							{
								"values": [
									{
										"formattedValue": "id"
									},
									{
										"formattedValue": "name"
									},
									{
										"formattedValue": "type"
									},
									{
										"formattedValue": "core"
									},
									{
										"formattedValue": "instructional"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "PE"
									},
									{
										"formattedValue": "PE"
									},
									{
										"formattedValue": "Instructional"
									},
									{
										"formattedValue": "FALSE"
									},
									{
										"formattedValue": "FALSE"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "Ins"
									},
									{
										"formattedValue": "Instructional"
									},
									{
										"formattedValue": "Instructional"
									},
									{
										"formattedValue": "TRUE"
									},
									{
										"formattedValue": "TRUE"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "Recess"
									},
									{
										"formattedValue": "Recess"
									},
									{
										"formattedValue": "Break"
									},
									{},
									{
										"formattedValue": "FALSE"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "Lunch"
									},
									{
										"formattedValue": "Lunch"
									},
									{
										"formattedValue": "Break"
									},
									{},
									{
										"formattedValue": "FALSE"
									}
								]
							},
							{
								"values": [
									{
										"formattedValue": "Specials"
									},
									{
										"formattedValue": "Specials"
									},
									{
										"formattedValue": "Prep"
									},
									{
										"formattedValue": "FALSE"
									},
									{
										"formattedValue": "FALSE"
									}
								]
							}
						]
					}
				]
			}
		]
	};

/***/ },
/* 301 */
6,
/* 302 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	//This file contains the ES6 extensions to the core Promises/A+ API
	
	var Promise = __webpack_require__(101);
	
	module.exports = Promise;
	
	/* Static Functions */
	
	var TRUE = valuePromise(true);
	var FALSE = valuePromise(false);
	var NULL = valuePromise(null);
	var UNDEFINED = valuePromise(undefined);
	var ZERO = valuePromise(0);
	var EMPTYSTRING = valuePromise('');
	
	function valuePromise(value) {
	  var p = new Promise(Promise._61);
	  p._81 = 1;
	  p._65 = value;
	  return p;
	}
	Promise.resolve = function (value) {
	  if (value instanceof Promise) return value;
	
	  if (value === null) return NULL;
	  if (value === undefined) return UNDEFINED;
	  if (value === true) return TRUE;
	  if (value === false) return FALSE;
	  if (value === 0) return ZERO;
	  if (value === '') return EMPTYSTRING;
	
	  if (typeof value === 'object' || typeof value === 'function') {
	    try {
	      var then = value.then;
	      if (typeof then === 'function') {
	        return new Promise(then.bind(value));
	      }
	    } catch (ex) {
	      return new Promise(function (resolve, reject) {
	        reject(ex);
	      });
	    }
	  }
	  return valuePromise(value);
	};
	
	Promise.all = function (arr) {
	  var args = Array.prototype.slice.call(arr);
	
	  return new Promise(function (resolve, reject) {
	    if (args.length === 0) return resolve([]);
	    var remaining = args.length;
	    function res(i, val) {
	      if (val && (typeof val === 'object' || typeof val === 'function')) {
	        if (val instanceof Promise && val.then === Promise.prototype.then) {
	          while (val._81 === 3) {
	            val = val._65;
	          }
	          if (val._81 === 1) return res(i, val._65);
	          if (val._81 === 2) reject(val._65);
	          val.then(function (val) {
	            res(i, val);
	          }, reject);
	          return;
	        } else {
	          var then = val.then;
	          if (typeof then === 'function') {
	            var p = new Promise(then.bind(val));
	            p.then(function (val) {
	              res(i, val);
	            }, reject);
	            return;
	          }
	        }
	      }
	      args[i] = val;
	      if (--remaining === 0) {
	        resolve(args);
	      }
	    }
	    for (var i = 0; i < args.length; i++) {
	      res(i, args[i]);
	    }
	  });
	};
	
	Promise.reject = function (value) {
	  return new Promise(function (resolve, reject) {
	    reject(value);
	  });
	};
	
	Promise.race = function (values) {
	  return new Promise(function (resolve, reject) {
	    values.forEach(function(value){
	      Promise.resolve(value).then(resolve, reject);
	    });
	  });
	};
	
	/* Prototype Methods */
	
	Promise.prototype['catch'] = function (onRejected) {
	  return this.then(null, onRejected);
	};


/***/ },
/* 303 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var Promise = __webpack_require__(101);
	
	var DEFAULT_WHITELIST = [
	  ReferenceError,
	  TypeError,
	  RangeError
	];
	
	var enabled = false;
	exports.disable = disable;
	function disable() {
	  enabled = false;
	  Promise._10 = null;
	  Promise._97 = null;
	}
	
	exports.enable = enable;
	function enable(options) {
	  options = options || {};
	  if (enabled) disable();
	  enabled = true;
	  var id = 0;
	  var displayId = 0;
	  var rejections = {};
	  Promise._10 = function (promise) {
	    if (
	      promise._81 === 2 && // IS REJECTED
	      rejections[promise._72]
	    ) {
	      if (rejections[promise._72].logged) {
	        onHandled(promise._72);
	      } else {
	        clearTimeout(rejections[promise._72].timeout);
	      }
	      delete rejections[promise._72];
	    }
	  };
	  Promise._97 = function (promise, err) {
	    if (promise._45 === 0) { // not yet handled
	      promise._72 = id++;
	      rejections[promise._72] = {
	        displayId: null,
	        error: err,
	        timeout: setTimeout(
	          onUnhandled.bind(null, promise._72),
	          // For reference errors and type errors, this almost always
	          // means the programmer made a mistake, so log them after just
	          // 100ms
	          // otherwise, wait 2 seconds to see if they get handled
	          matchWhitelist(err, DEFAULT_WHITELIST)
	            ? 100
	            : 2000
	        ),
	        logged: false
	      };
	    }
	  };
	  function onUnhandled(id) {
	    if (
	      options.allRejections ||
	      matchWhitelist(
	        rejections[id].error,
	        options.whitelist || DEFAULT_WHITELIST
	      )
	    ) {
	      rejections[id].displayId = displayId++;
	      if (options.onUnhandled) {
	        rejections[id].logged = true;
	        options.onUnhandled(
	          rejections[id].displayId,
	          rejections[id].error
	        );
	      } else {
	        rejections[id].logged = true;
	        logError(
	          rejections[id].displayId,
	          rejections[id].error
	        );
	      }
	    }
	  }
	  function onHandled(id) {
	    if (rejections[id].logged) {
	      if (options.onHandled) {
	        options.onHandled(rejections[id].displayId, rejections[id].error);
	      } else if (!rejections[id].onUnhandled) {
	        console.warn(
	          'Promise Rejection Handled (id: ' + rejections[id].displayId + '):'
	        );
	        console.warn(
	          '  This means you can ignore any previous messages of the form "Possible Unhandled Promise Rejection" with id ' +
	          rejections[id].displayId + '.'
	        );
	      }
	    }
	  }
	}
	
	function logError(id, error) {
	  console.warn('Possible Unhandled Promise Rejection (id: ' + id + '):');
	  var errStr = (error && (error.stack || error)) + '';
	  errStr.split('\n').forEach(function (line) {
	    console.warn('  ' + line);
	  });
	}
	
	function matchWhitelist(error, list) {
	  return list.some(function (cls) {
	    return error instanceof cls;
	  });
	}

/***/ },
/* 304 */
/***/ function(module, exports) {

	(function(self) {
	  'use strict';
	
	  if (self.fetch) {
	    return
	  }
	
	  var support = {
	    searchParams: 'URLSearchParams' in self,
	    iterable: 'Symbol' in self && 'iterator' in Symbol,
	    blob: 'FileReader' in self && 'Blob' in self && (function() {
	      try {
	        new Blob()
	        return true
	      } catch(e) {
	        return false
	      }
	    })(),
	    formData: 'FormData' in self,
	    arrayBuffer: 'ArrayBuffer' in self
	  }
	
	  function normalizeName(name) {
	    if (typeof name !== 'string') {
	      name = String(name)
	    }
	    if (/[^a-z0-9\-#$%&'*+.\^_`|~]/i.test(name)) {
	      throw new TypeError('Invalid character in header field name')
	    }
	    return name.toLowerCase()
	  }
	
	  function normalizeValue(value) {
	    if (typeof value !== 'string') {
	      value = String(value)
	    }
	    return value
	  }
	
	  // Build a destructive iterator for the value list
	  function iteratorFor(items) {
	    var iterator = {
	      next: function() {
	        var value = items.shift()
	        return {done: value === undefined, value: value}
	      }
	    }
	
	    if (support.iterable) {
	      iterator[Symbol.iterator] = function() {
	        return iterator
	      }
	    }
	
	    return iterator
	  }
	
	  function Headers(headers) {
	    this.map = {}
	
	    if (headers instanceof Headers) {
	      headers.forEach(function(value, name) {
	        this.append(name, value)
	      }, this)
	
	    } else if (headers) {
	      Object.getOwnPropertyNames(headers).forEach(function(name) {
	        this.append(name, headers[name])
	      }, this)
	    }
	  }
	
	  Headers.prototype.append = function(name, value) {
	    name = normalizeName(name)
	    value = normalizeValue(value)
	    var list = this.map[name]
	    if (!list) {
	      list = []
	      this.map[name] = list
	    }
	    list.push(value)
	  }
	
	  Headers.prototype['delete'] = function(name) {
	    delete this.map[normalizeName(name)]
	  }
	
	  Headers.prototype.get = function(name) {
	    var values = this.map[normalizeName(name)]
	    return values ? values[0] : null
	  }
	
	  Headers.prototype.getAll = function(name) {
	    return this.map[normalizeName(name)] || []
	  }
	
	  Headers.prototype.has = function(name) {
	    return this.map.hasOwnProperty(normalizeName(name))
	  }
	
	  Headers.prototype.set = function(name, value) {
	    this.map[normalizeName(name)] = [normalizeValue(value)]
	  }
	
	  Headers.prototype.forEach = function(callback, thisArg) {
	    Object.getOwnPropertyNames(this.map).forEach(function(name) {
	      this.map[name].forEach(function(value) {
	        callback.call(thisArg, value, name, this)
	      }, this)
	    }, this)
	  }
	
	  Headers.prototype.keys = function() {
	    var items = []
	    this.forEach(function(value, name) { items.push(name) })
	    return iteratorFor(items)
	  }
	
	  Headers.prototype.values = function() {
	    var items = []
	    this.forEach(function(value) { items.push(value) })
	    return iteratorFor(items)
	  }
	
	  Headers.prototype.entries = function() {
	    var items = []
	    this.forEach(function(value, name) { items.push([name, value]) })
	    return iteratorFor(items)
	  }
	
	  if (support.iterable) {
	    Headers.prototype[Symbol.iterator] = Headers.prototype.entries
	  }
	
	  function consumed(body) {
	    if (body.bodyUsed) {
	      return Promise.reject(new TypeError('Already read'))
	    }
	    body.bodyUsed = true
	  }
	
	  function fileReaderReady(reader) {
	    return new Promise(function(resolve, reject) {
	      reader.onload = function() {
	        resolve(reader.result)
	      }
	      reader.onerror = function() {
	        reject(reader.error)
	      }
	    })
	  }
	
	  function readBlobAsArrayBuffer(blob) {
	    var reader = new FileReader()
	    reader.readAsArrayBuffer(blob)
	    return fileReaderReady(reader)
	  }
	
	  function readBlobAsText(blob) {
	    var reader = new FileReader()
	    reader.readAsText(blob)
	    return fileReaderReady(reader)
	  }
	
	  function Body() {
	    this.bodyUsed = false
	
	    this._initBody = function(body) {
	      this._bodyInit = body
	      if (typeof body === 'string') {
	        this._bodyText = body
	      } else if (support.blob && Blob.prototype.isPrototypeOf(body)) {
	        this._bodyBlob = body
	      } else if (support.formData && FormData.prototype.isPrototypeOf(body)) {
	        this._bodyFormData = body
	      } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
	        this._bodyText = body.toString()
	      } else if (!body) {
	        this._bodyText = ''
	      } else if (support.arrayBuffer && ArrayBuffer.prototype.isPrototypeOf(body)) {
	        // Only support ArrayBuffers for POST method.
	        // Receiving ArrayBuffers happens via Blobs, instead.
	      } else {
	        throw new Error('unsupported BodyInit type')
	      }
	
	      if (!this.headers.get('content-type')) {
	        if (typeof body === 'string') {
	          this.headers.set('content-type', 'text/plain;charset=UTF-8')
	        } else if (this._bodyBlob && this._bodyBlob.type) {
	          this.headers.set('content-type', this._bodyBlob.type)
	        } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
	          this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8')
	        }
	      }
	    }
	
	    if (support.blob) {
	      this.blob = function() {
	        var rejected = consumed(this)
	        if (rejected) {
	          return rejected
	        }
	
	        if (this._bodyBlob) {
	          return Promise.resolve(this._bodyBlob)
	        } else if (this._bodyFormData) {
	          throw new Error('could not read FormData body as blob')
	        } else {
	          return Promise.resolve(new Blob([this._bodyText]))
	        }
	      }
	
	      this.arrayBuffer = function() {
	        return this.blob().then(readBlobAsArrayBuffer)
	      }
	
	      this.text = function() {
	        var rejected = consumed(this)
	        if (rejected) {
	          return rejected
	        }
	
	        if (this._bodyBlob) {
	          return readBlobAsText(this._bodyBlob)
	        } else if (this._bodyFormData) {
	          throw new Error('could not read FormData body as text')
	        } else {
	          return Promise.resolve(this._bodyText)
	        }
	      }
	    } else {
	      this.text = function() {
	        var rejected = consumed(this)
	        return rejected ? rejected : Promise.resolve(this._bodyText)
	      }
	    }
	
	    if (support.formData) {
	      this.formData = function() {
	        return this.text().then(decode)
	      }
	    }
	
	    this.json = function() {
	      return this.text().then(JSON.parse)
	    }
	
	    return this
	  }
	
	  // HTTP methods whose capitalization should be normalized
	  var methods = ['DELETE', 'GET', 'HEAD', 'OPTIONS', 'POST', 'PUT']
	
	  function normalizeMethod(method) {
	    var upcased = method.toUpperCase()
	    return (methods.indexOf(upcased) > -1) ? upcased : method
	  }
	
	  function Request(input, options) {
	    options = options || {}
	    var body = options.body
	    if (Request.prototype.isPrototypeOf(input)) {
	      if (input.bodyUsed) {
	        throw new TypeError('Already read')
	      }
	      this.url = input.url
	      this.credentials = input.credentials
	      if (!options.headers) {
	        this.headers = new Headers(input.headers)
	      }
	      this.method = input.method
	      this.mode = input.mode
	      if (!body) {
	        body = input._bodyInit
	        input.bodyUsed = true
	      }
	    } else {
	      this.url = input
	    }
	
	    this.credentials = options.credentials || this.credentials || 'omit'
	    if (options.headers || !this.headers) {
	      this.headers = new Headers(options.headers)
	    }
	    this.method = normalizeMethod(options.method || this.method || 'GET')
	    this.mode = options.mode || this.mode || null
	    this.referrer = null
	
	    if ((this.method === 'GET' || this.method === 'HEAD') && body) {
	      throw new TypeError('Body not allowed for GET or HEAD requests')
	    }
	    this._initBody(body)
	  }
	
	  Request.prototype.clone = function() {
	    return new Request(this)
	  }
	
	  function decode(body) {
	    var form = new FormData()
	    body.trim().split('&').forEach(function(bytes) {
	      if (bytes) {
	        var split = bytes.split('=')
	        var name = split.shift().replace(/\+/g, ' ')
	        var value = split.join('=').replace(/\+/g, ' ')
	        form.append(decodeURIComponent(name), decodeURIComponent(value))
	      }
	    })
	    return form
	  }
	
	  function headers(xhr) {
	    var head = new Headers()
	    var pairs = (xhr.getAllResponseHeaders() || '').trim().split('\n')
	    pairs.forEach(function(header) {
	      var split = header.trim().split(':')
	      var key = split.shift().trim()
	      var value = split.join(':').trim()
	      head.append(key, value)
	    })
	    return head
	  }
	
	  Body.call(Request.prototype)
	
	  function Response(bodyInit, options) {
	    if (!options) {
	      options = {}
	    }
	
	    this.type = 'default'
	    this.status = options.status
	    this.ok = this.status >= 200 && this.status < 300
	    this.statusText = options.statusText
	    this.headers = options.headers instanceof Headers ? options.headers : new Headers(options.headers)
	    this.url = options.url || ''
	    this._initBody(bodyInit)
	  }
	
	  Body.call(Response.prototype)
	
	  Response.prototype.clone = function() {
	    return new Response(this._bodyInit, {
	      status: this.status,
	      statusText: this.statusText,
	      headers: new Headers(this.headers),
	      url: this.url
	    })
	  }
	
	  Response.error = function() {
	    var response = new Response(null, {status: 0, statusText: ''})
	    response.type = 'error'
	    return response
	  }
	
	  var redirectStatuses = [301, 302, 303, 307, 308]
	
	  Response.redirect = function(url, status) {
	    if (redirectStatuses.indexOf(status) === -1) {
	      throw new RangeError('Invalid status code')
	    }
	
	    return new Response(null, {status: status, headers: {location: url}})
	  }
	
	  self.Headers = Headers
	  self.Request = Request
	  self.Response = Response
	
	  self.fetch = function(input, init) {
	    return new Promise(function(resolve, reject) {
	      var request
	      if (Request.prototype.isPrototypeOf(input) && !init) {
	        request = input
	      } else {
	        request = new Request(input, init)
	      }
	
	      var xhr = new XMLHttpRequest()
	
	      function responseURL() {
	        if ('responseURL' in xhr) {
	          return xhr.responseURL
	        }
	
	        // Avoid security warnings on getResponseHeader when not allowed by CORS
	        if (/^X-Request-URL:/m.test(xhr.getAllResponseHeaders())) {
	          return xhr.getResponseHeader('X-Request-URL')
	        }
	
	        return
	      }
	
	      xhr.onload = function() {
	        var options = {
	          status: xhr.status,
	          statusText: xhr.statusText,
	          headers: headers(xhr),
	          url: responseURL()
	        }
	        var body = 'response' in xhr ? xhr.response : xhr.responseText
	        resolve(new Response(body, options))
	      }
	
	      xhr.onerror = function() {
	        reject(new TypeError('Network request failed'))
	      }
	
	      xhr.ontimeout = function() {
	        reject(new TypeError('Network request failed'))
	      }
	
	      xhr.open(request.method, request.url, true)
	
	      if (request.credentials === 'include') {
	        xhr.withCredentials = true
	      }
	
	      if ('responseType' in xhr && support.blob) {
	        xhr.responseType = 'blob'
	      }
	
	      request.headers.forEach(function(value, name) {
	        xhr.setRequestHeader(name, value)
	      })
	
	      xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit)
	    })
	  }
	  self.fetch.polyfill = true
	})(typeof self !== 'undefined' ? self : this);


/***/ },
/* 305 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule AutoFocusUtils
	 */
	
	'use strict';
	
	var ReactDOMComponentTree = __webpack_require__(8);
	
	var focusNode = __webpack_require__(80);
	
	var AutoFocusUtils = {
	  focusDOMComponent: function () {
	    focusNode(ReactDOMComponentTree.getNodeFromInstance(this));
	  }
	};
	
	module.exports = AutoFocusUtils;

/***/ },
/* 306 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule BeforeInputEventPlugin
	 */
	
	'use strict';
	
	var EventConstants = __webpack_require__(18);
	var EventPropagators = __webpack_require__(35);
	var ExecutionEnvironment = __webpack_require__(9);
	var FallbackCompositionState = __webpack_require__(312);
	var SyntheticCompositionEvent = __webpack_require__(350);
	var SyntheticInputEvent = __webpack_require__(353);
	
	var keyOf = __webpack_require__(20);
	
	var END_KEYCODES = [9, 13, 27, 32]; // Tab, Return, Esc, Space
	var START_KEYCODE = 229;
	
	var canUseCompositionEvent = ExecutionEnvironment.canUseDOM && 'CompositionEvent' in window;
	
	var documentMode = null;
	if (ExecutionEnvironment.canUseDOM && 'documentMode' in document) {
	  documentMode = document.documentMode;
	}
	
	// Webkit offers a very useful `textInput` event that can be used to
	// directly represent `beforeInput`. The IE `textinput` event is not as
	// useful, so we don't use it.
	var canUseTextInputEvent = ExecutionEnvironment.canUseDOM && 'TextEvent' in window && !documentMode && !isPresto();
	
	// In IE9+, we have access to composition events, but the data supplied
	// by the native compositionend event may be incorrect. Japanese ideographic
	// spaces, for instance (\u3000) are not recorded correctly.
	var useFallbackCompositionData = ExecutionEnvironment.canUseDOM && (!canUseCompositionEvent || documentMode && documentMode > 8 && documentMode <= 11);
	
	/**
	 * Opera <= 12 includes TextEvent in window, but does not fire
	 * text input events. Rely on keypress instead.
	 */
	function isPresto() {
	  var opera = window.opera;
	  return typeof opera === 'object' && typeof opera.version === 'function' && parseInt(opera.version(), 10) <= 12;
	}
	
	var SPACEBAR_CODE = 32;
	var SPACEBAR_CHAR = String.fromCharCode(SPACEBAR_CODE);
	
	var topLevelTypes = EventConstants.topLevelTypes;
	
	// Events and their corresponding property names.
	var eventTypes = {
	  beforeInput: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onBeforeInput: null }),
	      captured: keyOf({ onBeforeInputCapture: null })
	    },
	    dependencies: [topLevelTypes.topCompositionEnd, topLevelTypes.topKeyPress, topLevelTypes.topTextInput, topLevelTypes.topPaste]
	  },
	  compositionEnd: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onCompositionEnd: null }),
	      captured: keyOf({ onCompositionEndCapture: null })
	    },
	    dependencies: [topLevelTypes.topBlur, topLevelTypes.topCompositionEnd, topLevelTypes.topKeyDown, topLevelTypes.topKeyPress, topLevelTypes.topKeyUp, topLevelTypes.topMouseDown]
	  },
	  compositionStart: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onCompositionStart: null }),
	      captured: keyOf({ onCompositionStartCapture: null })
	    },
	    dependencies: [topLevelTypes.topBlur, topLevelTypes.topCompositionStart, topLevelTypes.topKeyDown, topLevelTypes.topKeyPress, topLevelTypes.topKeyUp, topLevelTypes.topMouseDown]
	  },
	  compositionUpdate: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onCompositionUpdate: null }),
	      captured: keyOf({ onCompositionUpdateCapture: null })
	    },
	    dependencies: [topLevelTypes.topBlur, topLevelTypes.topCompositionUpdate, topLevelTypes.topKeyDown, topLevelTypes.topKeyPress, topLevelTypes.topKeyUp, topLevelTypes.topMouseDown]
	  }
	};
	
	// Track whether we've ever handled a keypress on the space key.
	var hasSpaceKeypress = false;
	
	/**
	 * Return whether a native keypress event is assumed to be a command.
	 * This is required because Firefox fires `keypress` events for key commands
	 * (cut, copy, select-all, etc.) even though no character is inserted.
	 */
	function isKeypressCommand(nativeEvent) {
	  return (nativeEvent.ctrlKey || nativeEvent.altKey || nativeEvent.metaKey) &&
	  // ctrlKey && altKey is equivalent to AltGr, and is not a command.
	  !(nativeEvent.ctrlKey && nativeEvent.altKey);
	}
	
	/**
	 * Translate native top level events into event types.
	 *
	 * @param {string} topLevelType
	 * @return {object}
	 */
	function getCompositionEventType(topLevelType) {
	  switch (topLevelType) {
	    case topLevelTypes.topCompositionStart:
	      return eventTypes.compositionStart;
	    case topLevelTypes.topCompositionEnd:
	      return eventTypes.compositionEnd;
	    case topLevelTypes.topCompositionUpdate:
	      return eventTypes.compositionUpdate;
	  }
	}
	
	/**
	 * Does our fallback best-guess model think this event signifies that
	 * composition has begun?
	 *
	 * @param {string} topLevelType
	 * @param {object} nativeEvent
	 * @return {boolean}
	 */
	function isFallbackCompositionStart(topLevelType, nativeEvent) {
	  return topLevelType === topLevelTypes.topKeyDown && nativeEvent.keyCode === START_KEYCODE;
	}
	
	/**
	 * Does our fallback mode think that this event is the end of composition?
	 *
	 * @param {string} topLevelType
	 * @param {object} nativeEvent
	 * @return {boolean}
	 */
	function isFallbackCompositionEnd(topLevelType, nativeEvent) {
	  switch (topLevelType) {
	    case topLevelTypes.topKeyUp:
	      // Command keys insert or clear IME input.
	      return END_KEYCODES.indexOf(nativeEvent.keyCode) !== -1;
	    case topLevelTypes.topKeyDown:
	      // Expect IME keyCode on each keydown. If we get any other
	      // code we must have exited earlier.
	      return nativeEvent.keyCode !== START_KEYCODE;
	    case topLevelTypes.topKeyPress:
	    case topLevelTypes.topMouseDown:
	    case topLevelTypes.topBlur:
	      // Events are not possible without cancelling IME.
	      return true;
	    default:
	      return false;
	  }
	}
	
	/**
	 * Google Input Tools provides composition data via a CustomEvent,
	 * with the `data` property populated in the `detail` object. If this
	 * is available on the event object, use it. If not, this is a plain
	 * composition event and we have nothing special to extract.
	 *
	 * @param {object} nativeEvent
	 * @return {?string}
	 */
	function getDataFromCustomEvent(nativeEvent) {
	  var detail = nativeEvent.detail;
	  if (typeof detail === 'object' && 'data' in detail) {
	    return detail.data;
	  }
	  return null;
	}
	
	// Track the current IME composition fallback object, if any.
	var currentComposition = null;
	
	/**
	 * @return {?object} A SyntheticCompositionEvent.
	 */
	function extractCompositionEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	  var eventType;
	  var fallbackData;
	
	  if (canUseCompositionEvent) {
	    eventType = getCompositionEventType(topLevelType);
	  } else if (!currentComposition) {
	    if (isFallbackCompositionStart(topLevelType, nativeEvent)) {
	      eventType = eventTypes.compositionStart;
	    }
	  } else if (isFallbackCompositionEnd(topLevelType, nativeEvent)) {
	    eventType = eventTypes.compositionEnd;
	  }
	
	  if (!eventType) {
	    return null;
	  }
	
	  if (useFallbackCompositionData) {
	    // The current composition is stored statically and must not be
	    // overwritten while composition continues.
	    if (!currentComposition && eventType === eventTypes.compositionStart) {
	      currentComposition = FallbackCompositionState.getPooled(nativeEventTarget);
	    } else if (eventType === eventTypes.compositionEnd) {
	      if (currentComposition) {
	        fallbackData = currentComposition.getData();
	      }
	    }
	  }
	
	  var event = SyntheticCompositionEvent.getPooled(eventType, targetInst, nativeEvent, nativeEventTarget);
	
	  if (fallbackData) {
	    // Inject data generated from fallback path into the synthetic event.
	    // This matches the property of native CompositionEventInterface.
	    event.data = fallbackData;
	  } else {
	    var customData = getDataFromCustomEvent(nativeEvent);
	    if (customData !== null) {
	      event.data = customData;
	    }
	  }
	
	  EventPropagators.accumulateTwoPhaseDispatches(event);
	  return event;
	}
	
	/**
	 * @param {string} topLevelType Record from `EventConstants`.
	 * @param {object} nativeEvent Native browser event.
	 * @return {?string} The string corresponding to this `beforeInput` event.
	 */
	function getNativeBeforeInputChars(topLevelType, nativeEvent) {
	  switch (topLevelType) {
	    case topLevelTypes.topCompositionEnd:
	      return getDataFromCustomEvent(nativeEvent);
	    case topLevelTypes.topKeyPress:
	      /**
	       * If native `textInput` events are available, our goal is to make
	       * use of them. However, there is a special case: the spacebar key.
	       * In Webkit, preventing default on a spacebar `textInput` event
	       * cancels character insertion, but it *also* causes the browser
	       * to fall back to its default spacebar behavior of scrolling the
	       * page.
	       *
	       * Tracking at:
	       * https://code.google.com/p/chromium/issues/detail?id=355103
	       *
	       * To avoid this issue, use the keypress event as if no `textInput`
	       * event is available.
	       */
	      var which = nativeEvent.which;
	      if (which !== SPACEBAR_CODE) {
	        return null;
	      }
	
	      hasSpaceKeypress = true;
	      return SPACEBAR_CHAR;
	
	    case topLevelTypes.topTextInput:
	      // Record the characters to be added to the DOM.
	      var chars = nativeEvent.data;
	
	      // If it's a spacebar character, assume that we have already handled
	      // it at the keypress level and bail immediately. Android Chrome
	      // doesn't give us keycodes, so we need to blacklist it.
	      if (chars === SPACEBAR_CHAR && hasSpaceKeypress) {
	        return null;
	      }
	
	      return chars;
	
	    default:
	      // For other native event types, do nothing.
	      return null;
	  }
	}
	
	/**
	 * For browsers that do not provide the `textInput` event, extract the
	 * appropriate string to use for SyntheticInputEvent.
	 *
	 * @param {string} topLevelType Record from `EventConstants`.
	 * @param {object} nativeEvent Native browser event.
	 * @return {?string} The fallback string for this `beforeInput` event.
	 */
	function getFallbackBeforeInputChars(topLevelType, nativeEvent) {
	  // If we are currently composing (IME) and using a fallback to do so,
	  // try to extract the composed characters from the fallback object.
	  if (currentComposition) {
	    if (topLevelType === topLevelTypes.topCompositionEnd || isFallbackCompositionEnd(topLevelType, nativeEvent)) {
	      var chars = currentComposition.getData();
	      FallbackCompositionState.release(currentComposition);
	      currentComposition = null;
	      return chars;
	    }
	    return null;
	  }
	
	  switch (topLevelType) {
	    case topLevelTypes.topPaste:
	      // If a paste event occurs after a keypress, throw out the input
	      // chars. Paste events should not lead to BeforeInput events.
	      return null;
	    case topLevelTypes.topKeyPress:
	      /**
	       * As of v27, Firefox may fire keypress events even when no character
	       * will be inserted. A few possibilities:
	       *
	       * - `which` is `0`. Arrow keys, Esc key, etc.
	       *
	       * - `which` is the pressed key code, but no char is available.
	       *   Ex: 'AltGr + d` in Polish. There is no modified character for
	       *   this key combination and no character is inserted into the
	       *   document, but FF fires the keypress for char code `100` anyway.
	       *   No `input` event will occur.
	       *
	       * - `which` is the pressed key code, but a command combination is
	       *   being used. Ex: `Cmd+C`. No character is inserted, and no
	       *   `input` event will occur.
	       */
	      if (nativeEvent.which && !isKeypressCommand(nativeEvent)) {
	        return String.fromCharCode(nativeEvent.which);
	      }
	      return null;
	    case topLevelTypes.topCompositionEnd:
	      return useFallbackCompositionData ? null : nativeEvent.data;
	    default:
	      return null;
	  }
	}
	
	/**
	 * Extract a SyntheticInputEvent for `beforeInput`, based on either native
	 * `textInput` or fallback behavior.
	 *
	 * @return {?object} A SyntheticInputEvent.
	 */
	function extractBeforeInputEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	  var chars;
	
	  if (canUseTextInputEvent) {
	    chars = getNativeBeforeInputChars(topLevelType, nativeEvent);
	  } else {
	    chars = getFallbackBeforeInputChars(topLevelType, nativeEvent);
	  }
	
	  // If no characters are being inserted, no BeforeInput event should
	  // be fired.
	  if (!chars) {
	    return null;
	  }
	
	  var event = SyntheticInputEvent.getPooled(eventTypes.beforeInput, targetInst, nativeEvent, nativeEventTarget);
	
	  event.data = chars;
	  EventPropagators.accumulateTwoPhaseDispatches(event);
	  return event;
	}
	
	/**
	 * Create an `onBeforeInput` event to match
	 * http://www.w3.org/TR/2013/WD-DOM-Level-3-Events-20131105/#events-inputevents.
	 *
	 * This event plugin is based on the native `textInput` event
	 * available in Chrome, Safari, Opera, and IE. This event fires after
	 * `onKeyPress` and `onCompositionEnd`, but before `onInput`.
	 *
	 * `beforeInput` is spec'd but not implemented in any browsers, and
	 * the `input` event does not provide any useful information about what has
	 * actually been added, contrary to the spec. Thus, `textInput` is the best
	 * available event to identify the characters that have actually been inserted
	 * into the target node.
	 *
	 * This plugin is also responsible for emitting `composition` events, thus
	 * allowing us to share composition fallback code for both `beforeInput` and
	 * `composition` event types.
	 */
	var BeforeInputEventPlugin = {
	
	  eventTypes: eventTypes,
	
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    return [extractCompositionEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget), extractBeforeInputEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget)];
	  }
	};
	
	module.exports = BeforeInputEventPlugin;

/***/ },
/* 307 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule CSSPropertyOperations
	 */
	
	'use strict';
	
	var CSSProperty = __webpack_require__(102);
	var ExecutionEnvironment = __webpack_require__(9);
	var ReactInstrumentation = __webpack_require__(11);
	
	var camelizeStyleName = __webpack_require__(147);
	var dangerousStyleValue = __webpack_require__(360);
	var hyphenateStyleName = __webpack_require__(154);
	var memoizeStringOnly = __webpack_require__(157);
	var warning = __webpack_require__(4);
	
	var processStyleName = memoizeStringOnly(function (styleName) {
	  return hyphenateStyleName(styleName);
	});
	
	var hasShorthandPropertyBug = false;
	var styleFloatAccessor = 'cssFloat';
	if (ExecutionEnvironment.canUseDOM) {
	  var tempStyle = document.createElement('div').style;
	  try {
	    // IE8 throws "Invalid argument." if resetting shorthand style properties.
	    tempStyle.font = '';
	  } catch (e) {
	    hasShorthandPropertyBug = true;
	  }
	  // IE8 only supports accessing cssFloat (standard) as styleFloat
	  if (document.documentElement.style.cssFloat === undefined) {
	    styleFloatAccessor = 'styleFloat';
	  }
	}
	
	if (false) {
	  // 'msTransform' is correct, but the other prefixes should be capitalized
	  var badVendoredStyleNamePattern = /^(?:webkit|moz|o)[A-Z]/;
	
	  // style values shouldn't contain a semicolon
	  var badStyleValueWithSemicolonPattern = /;\s*$/;
	
	  var warnedStyleNames = {};
	  var warnedStyleValues = {};
	  var warnedForNaNValue = false;
	
	  var warnHyphenatedStyleName = function (name, owner) {
	    if (warnedStyleNames.hasOwnProperty(name) && warnedStyleNames[name]) {
	      return;
	    }
	
	    warnedStyleNames[name] = true;
	    process.env.NODE_ENV !== 'production' ? warning(false, 'Unsupported style property %s. Did you mean %s?%s', name, camelizeStyleName(name), checkRenderMessage(owner)) : void 0;
	  };
	
	  var warnBadVendoredStyleName = function (name, owner) {
	    if (warnedStyleNames.hasOwnProperty(name) && warnedStyleNames[name]) {
	      return;
	    }
	
	    warnedStyleNames[name] = true;
	    process.env.NODE_ENV !== 'production' ? warning(false, 'Unsupported vendor-prefixed style property %s. Did you mean %s?%s', name, name.charAt(0).toUpperCase() + name.slice(1), checkRenderMessage(owner)) : void 0;
	  };
	
	  var warnStyleValueWithSemicolon = function (name, value, owner) {
	    if (warnedStyleValues.hasOwnProperty(value) && warnedStyleValues[value]) {
	      return;
	    }
	
	    warnedStyleValues[value] = true;
	    process.env.NODE_ENV !== 'production' ? warning(false, 'Style property values shouldn\'t contain a semicolon.%s ' + 'Try "%s: %s" instead.', checkRenderMessage(owner), name, value.replace(badStyleValueWithSemicolonPattern, '')) : void 0;
	  };
	
	  var warnStyleValueIsNaN = function (name, value, owner) {
	    if (warnedForNaNValue) {
	      return;
	    }
	
	    warnedForNaNValue = true;
	    process.env.NODE_ENV !== 'production' ? warning(false, '`NaN` is an invalid value for the `%s` css style property.%s', name, checkRenderMessage(owner)) : void 0;
	  };
	
	  var checkRenderMessage = function (owner) {
	    if (owner) {
	      var name = owner.getName();
	      if (name) {
	        return ' Check the render method of `' + name + '`.';
	      }
	    }
	    return '';
	  };
	
	  /**
	   * @param {string} name
	   * @param {*} value
	   * @param {ReactDOMComponent} component
	   */
	  var warnValidStyle = function (name, value, component) {
	    var owner;
	    if (component) {
	      owner = component._currentElement._owner;
	    }
	    if (name.indexOf('-') > -1) {
	      warnHyphenatedStyleName(name, owner);
	    } else if (badVendoredStyleNamePattern.test(name)) {
	      warnBadVendoredStyleName(name, owner);
	    } else if (badStyleValueWithSemicolonPattern.test(value)) {
	      warnStyleValueWithSemicolon(name, value, owner);
	    }
	
	    if (typeof value === 'number' && isNaN(value)) {
	      warnStyleValueIsNaN(name, value, owner);
	    }
	  };
	}
	
	/**
	 * Operations for dealing with CSS properties.
	 */
	var CSSPropertyOperations = {
	
	  /**
	   * Serializes a mapping of style properties for use as inline styles:
	   *
	   *   > createMarkupForStyles({width: '200px', height: 0})
	   *   "width:200px;height:0;"
	   *
	   * Undefined values are ignored so that declarative programming is easier.
	   * The result should be HTML-escaped before insertion into the DOM.
	   *
	   * @param {object} styles
	   * @param {ReactDOMComponent} component
	   * @return {?string}
	   */
	  createMarkupForStyles: function (styles, component) {
	    var serialized = '';
	    for (var styleName in styles) {
	      if (!styles.hasOwnProperty(styleName)) {
	        continue;
	      }
	      var styleValue = styles[styleName];
	      if (false) {
	        warnValidStyle(styleName, styleValue, component);
	      }
	      if (styleValue != null) {
	        serialized += processStyleName(styleName) + ':';
	        serialized += dangerousStyleValue(styleName, styleValue, component) + ';';
	      }
	    }
	    return serialized || null;
	  },
	
	  /**
	   * Sets the value for multiple styles on a node.  If a value is specified as
	   * '' (empty string), the corresponding style property will be unset.
	   *
	   * @param {DOMElement} node
	   * @param {object} styles
	   * @param {ReactDOMComponent} component
	   */
	  setValueForStyles: function (node, styles, component) {
	    if (false) {
	      ReactInstrumentation.debugTool.onHostOperation(component._debugID, 'update styles', styles);
	    }
	
	    var style = node.style;
	    for (var styleName in styles) {
	      if (!styles.hasOwnProperty(styleName)) {
	        continue;
	      }
	      if (false) {
	        warnValidStyle(styleName, styles[styleName], component);
	      }
	      var styleValue = dangerousStyleValue(styleName, styles[styleName], component);
	      if (styleName === 'float' || styleName === 'cssFloat') {
	        styleName = styleFloatAccessor;
	      }
	      if (styleValue) {
	        style[styleName] = styleValue;
	      } else {
	        var expansion = hasShorthandPropertyBug && CSSProperty.shorthandPropertyExpansions[styleName];
	        if (expansion) {
	          // Shorthand property that IE8 won't like unsetting, so unset each
	          // component to placate it
	          for (var individualStyleName in expansion) {
	            style[individualStyleName] = '';
	          }
	        } else {
	          style[styleName] = '';
	        }
	      }
	    }
	  }
	
	};
	
	module.exports = CSSPropertyOperations;

/***/ },
/* 308 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ChangeEventPlugin
	 */
	
	'use strict';
	
	var EventConstants = __webpack_require__(18);
	var EventPluginHub = __webpack_require__(34);
	var EventPropagators = __webpack_require__(35);
	var ExecutionEnvironment = __webpack_require__(9);
	var ReactDOMComponentTree = __webpack_require__(8);
	var ReactUpdates = __webpack_require__(14);
	var SyntheticEvent = __webpack_require__(19);
	
	var getEventTarget = __webpack_require__(70);
	var isEventSupported = __webpack_require__(71);
	var isTextInputElement = __webpack_require__(126);
	var keyOf = __webpack_require__(20);
	
	var topLevelTypes = EventConstants.topLevelTypes;
	
	var eventTypes = {
	  change: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onChange: null }),
	      captured: keyOf({ onChangeCapture: null })
	    },
	    dependencies: [topLevelTypes.topBlur, topLevelTypes.topChange, topLevelTypes.topClick, topLevelTypes.topFocus, topLevelTypes.topInput, topLevelTypes.topKeyDown, topLevelTypes.topKeyUp, topLevelTypes.topSelectionChange]
	  }
	};
	
	/**
	 * For IE shims
	 */
	var activeElement = null;
	var activeElementInst = null;
	var activeElementValue = null;
	var activeElementValueProp = null;
	
	/**
	 * SECTION: handle `change` event
	 */
	function shouldUseChangeEvent(elem) {
	  var nodeName = elem.nodeName && elem.nodeName.toLowerCase();
	  return nodeName === 'select' || nodeName === 'input' && elem.type === 'file';
	}
	
	var doesChangeEventBubble = false;
	if (ExecutionEnvironment.canUseDOM) {
	  // See `handleChange` comment below
	  doesChangeEventBubble = isEventSupported('change') && (!('documentMode' in document) || document.documentMode > 8);
	}
	
	function manualDispatchChangeEvent(nativeEvent) {
	  var event = SyntheticEvent.getPooled(eventTypes.change, activeElementInst, nativeEvent, getEventTarget(nativeEvent));
	  EventPropagators.accumulateTwoPhaseDispatches(event);
	
	  // If change and propertychange bubbled, we'd just bind to it like all the
	  // other events and have it go through ReactBrowserEventEmitter. Since it
	  // doesn't, we manually listen for the events and so we have to enqueue and
	  // process the abstract event manually.
	  //
	  // Batching is necessary here in order to ensure that all event handlers run
	  // before the next rerender (including event handlers attached to ancestor
	  // elements instead of directly on the input). Without this, controlled
	  // components don't work properly in conjunction with event bubbling because
	  // the component is rerendered and the value reverted before all the event
	  // handlers can run. See https://github.com/facebook/react/issues/708.
	  ReactUpdates.batchedUpdates(runEventInBatch, event);
	}
	
	function runEventInBatch(event) {
	  EventPluginHub.enqueueEvents(event);
	  EventPluginHub.processEventQueue(false);
	}
	
	function startWatchingForChangeEventIE8(target, targetInst) {
	  activeElement = target;
	  activeElementInst = targetInst;
	  activeElement.attachEvent('onchange', manualDispatchChangeEvent);
	}
	
	function stopWatchingForChangeEventIE8() {
	  if (!activeElement) {
	    return;
	  }
	  activeElement.detachEvent('onchange', manualDispatchChangeEvent);
	  activeElement = null;
	  activeElementInst = null;
	}
	
	function getTargetInstForChangeEvent(topLevelType, targetInst) {
	  if (topLevelType === topLevelTypes.topChange) {
	    return targetInst;
	  }
	}
	function handleEventsForChangeEventIE8(topLevelType, target, targetInst) {
	  if (topLevelType === topLevelTypes.topFocus) {
	    // stopWatching() should be a noop here but we call it just in case we
	    // missed a blur event somehow.
	    stopWatchingForChangeEventIE8();
	    startWatchingForChangeEventIE8(target, targetInst);
	  } else if (topLevelType === topLevelTypes.topBlur) {
	    stopWatchingForChangeEventIE8();
	  }
	}
	
	/**
	 * SECTION: handle `input` event
	 */
	var isInputEventSupported = false;
	if (ExecutionEnvironment.canUseDOM) {
	  // IE9 claims to support the input event but fails to trigger it when
	  // deleting text, so we ignore its input events.
	  // IE10+ fire input events to often, such when a placeholder
	  // changes or when an input with a placeholder is focused.
	  isInputEventSupported = isEventSupported('input') && (!('documentMode' in document) || document.documentMode > 11);
	}
	
	/**
	 * (For IE <=11) Replacement getter/setter for the `value` property that gets
	 * set on the active element.
	 */
	var newValueProp = {
	  get: function () {
	    return activeElementValueProp.get.call(this);
	  },
	  set: function (val) {
	    // Cast to a string so we can do equality checks.
	    activeElementValue = '' + val;
	    activeElementValueProp.set.call(this, val);
	  }
	};
	
	/**
	 * (For IE <=11) Starts tracking propertychange events on the passed-in element
	 * and override the value property so that we can distinguish user events from
	 * value changes in JS.
	 */
	function startWatchingForValueChange(target, targetInst) {
	  activeElement = target;
	  activeElementInst = targetInst;
	  activeElementValue = target.value;
	  activeElementValueProp = Object.getOwnPropertyDescriptor(target.constructor.prototype, 'value');
	
	  // Not guarded in a canDefineProperty check: IE8 supports defineProperty only
	  // on DOM elements
	  Object.defineProperty(activeElement, 'value', newValueProp);
	  if (activeElement.attachEvent) {
	    activeElement.attachEvent('onpropertychange', handlePropertyChange);
	  } else {
	    activeElement.addEventListener('propertychange', handlePropertyChange, false);
	  }
	}
	
	/**
	 * (For IE <=11) Removes the event listeners from the currently-tracked element,
	 * if any exists.
	 */
	function stopWatchingForValueChange() {
	  if (!activeElement) {
	    return;
	  }
	
	  // delete restores the original property definition
	  delete activeElement.value;
	
	  if (activeElement.detachEvent) {
	    activeElement.detachEvent('onpropertychange', handlePropertyChange);
	  } else {
	    activeElement.removeEventListener('propertychange', handlePropertyChange, false);
	  }
	
	  activeElement = null;
	  activeElementInst = null;
	  activeElementValue = null;
	  activeElementValueProp = null;
	}
	
	/**
	 * (For IE <=11) Handles a propertychange event, sending a `change` event if
	 * the value of the active element has changed.
	 */
	function handlePropertyChange(nativeEvent) {
	  if (nativeEvent.propertyName !== 'value') {
	    return;
	  }
	  var value = nativeEvent.srcElement.value;
	  if (value === activeElementValue) {
	    return;
	  }
	  activeElementValue = value;
	
	  manualDispatchChangeEvent(nativeEvent);
	}
	
	/**
	 * If a `change` event should be fired, returns the target's ID.
	 */
	function getTargetInstForInputEvent(topLevelType, targetInst) {
	  if (topLevelType === topLevelTypes.topInput) {
	    // In modern browsers (i.e., not IE8 or IE9), the input event is exactly
	    // what we want so fall through here and trigger an abstract event
	    return targetInst;
	  }
	}
	
	function handleEventsForInputEventIE(topLevelType, target, targetInst) {
	  if (topLevelType === topLevelTypes.topFocus) {
	    // In IE8, we can capture almost all .value changes by adding a
	    // propertychange handler and looking for events with propertyName
	    // equal to 'value'
	    // In IE9-11, propertychange fires for most input events but is buggy and
	    // doesn't fire when text is deleted, but conveniently, selectionchange
	    // appears to fire in all of the remaining cases so we catch those and
	    // forward the event if the value has changed
	    // In either case, we don't want to call the event handler if the value
	    // is changed from JS so we redefine a setter for `.value` that updates
	    // our activeElementValue variable, allowing us to ignore those changes
	    //
	    // stopWatching() should be a noop here but we call it just in case we
	    // missed a blur event somehow.
	    stopWatchingForValueChange();
	    startWatchingForValueChange(target, targetInst);
	  } else if (topLevelType === topLevelTypes.topBlur) {
	    stopWatchingForValueChange();
	  }
	}
	
	// For IE8 and IE9.
	function getTargetInstForInputEventIE(topLevelType, targetInst) {
	  if (topLevelType === topLevelTypes.topSelectionChange || topLevelType === topLevelTypes.topKeyUp || topLevelType === topLevelTypes.topKeyDown) {
	    // On the selectionchange event, the target is just document which isn't
	    // helpful for us so just check activeElement instead.
	    //
	    // 99% of the time, keydown and keyup aren't necessary. IE8 fails to fire
	    // propertychange on the first input event after setting `value` from a
	    // script and fires only keydown, keypress, keyup. Catching keyup usually
	    // gets it and catching keydown lets us fire an event for the first
	    // keystroke if user does a key repeat (it'll be a little delayed: right
	    // before the second keystroke). Other input methods (e.g., paste) seem to
	    // fire selectionchange normally.
	    if (activeElement && activeElement.value !== activeElementValue) {
	      activeElementValue = activeElement.value;
	      return activeElementInst;
	    }
	  }
	}
	
	/**
	 * SECTION: handle `click` event
	 */
	function shouldUseClickEvent(elem) {
	  // Use the `click` event to detect changes to checkbox and radio inputs.
	  // This approach works across all browsers, whereas `change` does not fire
	  // until `blur` in IE8.
	  return elem.nodeName && elem.nodeName.toLowerCase() === 'input' && (elem.type === 'checkbox' || elem.type === 'radio');
	}
	
	function getTargetInstForClickEvent(topLevelType, targetInst) {
	  if (topLevelType === topLevelTypes.topClick) {
	    return targetInst;
	  }
	}
	
	/**
	 * This plugin creates an `onChange` event that normalizes change events
	 * across form elements. This event fires at a time when it's possible to
	 * change the element's value without seeing a flicker.
	 *
	 * Supported elements are:
	 * - input (see `isTextInputElement`)
	 * - textarea
	 * - select
	 */
	var ChangeEventPlugin = {
	
	  eventTypes: eventTypes,
	
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    var targetNode = targetInst ? ReactDOMComponentTree.getNodeFromInstance(targetInst) : window;
	
	    var getTargetInstFunc, handleEventFunc;
	    if (shouldUseChangeEvent(targetNode)) {
	      if (doesChangeEventBubble) {
	        getTargetInstFunc = getTargetInstForChangeEvent;
	      } else {
	        handleEventFunc = handleEventsForChangeEventIE8;
	      }
	    } else if (isTextInputElement(targetNode)) {
	      if (isInputEventSupported) {
	        getTargetInstFunc = getTargetInstForInputEvent;
	      } else {
	        getTargetInstFunc = getTargetInstForInputEventIE;
	        handleEventFunc = handleEventsForInputEventIE;
	      }
	    } else if (shouldUseClickEvent(targetNode)) {
	      getTargetInstFunc = getTargetInstForClickEvent;
	    }
	
	    if (getTargetInstFunc) {
	      var inst = getTargetInstFunc(topLevelType, targetInst);
	      if (inst) {
	        var event = SyntheticEvent.getPooled(eventTypes.change, inst, nativeEvent, nativeEventTarget);
	        event.type = 'change';
	        EventPropagators.accumulateTwoPhaseDispatches(event);
	        return event;
	      }
	    }
	
	    if (handleEventFunc) {
	      handleEventFunc(topLevelType, targetNode, targetInst);
	    }
	  }
	
	};
	
	module.exports = ChangeEventPlugin;

/***/ },
/* 309 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule Danger
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(3);
	
	var DOMLazyTree = __webpack_require__(26);
	var ExecutionEnvironment = __webpack_require__(9);
	
	var createNodesFromMarkup = __webpack_require__(150);
	var emptyFunction = __webpack_require__(10);
	var invariant = __webpack_require__(2);
	
	var Danger = {
	
	  /**
	   * Replaces a node with a string of markup at its current position within its
	   * parent. The markup must render into a single root node.
	   *
	   * @param {DOMElement} oldChild Child node to replace.
	   * @param {string} markup Markup to render in place of the child node.
	   * @internal
	   */
	  dangerouslyReplaceNodeWithMarkup: function (oldChild, markup) {
	    !ExecutionEnvironment.canUseDOM ?  false ? invariant(false, 'dangerouslyReplaceNodeWithMarkup(...): Cannot render markup in a worker thread. Make sure `window` and `document` are available globally before requiring React when unit testing or use ReactDOMServer.renderToString() for server rendering.') : _prodInvariant('56') : void 0;
	    !markup ?  false ? invariant(false, 'dangerouslyReplaceNodeWithMarkup(...): Missing markup.') : _prodInvariant('57') : void 0;
	    !(oldChild.nodeName !== 'HTML') ?  false ? invariant(false, 'dangerouslyReplaceNodeWithMarkup(...): Cannot replace markup of the <html> node. This is because browser quirks make this unreliable and/or slow. If you want to render to the root you must use server rendering. See ReactDOMServer.renderToString().') : _prodInvariant('58') : void 0;
	
	    if (typeof markup === 'string') {
	      var newChild = createNodesFromMarkup(markup, emptyFunction)[0];
	      oldChild.parentNode.replaceChild(newChild, oldChild);
	    } else {
	      DOMLazyTree.replaceChildWithTree(oldChild, markup);
	    }
	  }
	
	};
	
	module.exports = Danger;

/***/ },
/* 310 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule DefaultEventPluginOrder
	 */
	
	'use strict';
	
	var keyOf = __webpack_require__(20);
	
	/**
	 * Module that is injectable into `EventPluginHub`, that specifies a
	 * deterministic ordering of `EventPlugin`s. A convenient way to reason about
	 * plugins, without having to package every one of them. This is better than
	 * having plugins be ordered in the same order that they are injected because
	 * that ordering would be influenced by the packaging order.
	 * `ResponderEventPlugin` must occur before `SimpleEventPlugin` so that
	 * preventing default on events is convenient in `SimpleEventPlugin` handlers.
	 */
	var DefaultEventPluginOrder = [keyOf({ ResponderEventPlugin: null }), keyOf({ SimpleEventPlugin: null }), keyOf({ TapEventPlugin: null }), keyOf({ EnterLeaveEventPlugin: null }), keyOf({ ChangeEventPlugin: null }), keyOf({ SelectEventPlugin: null }), keyOf({ BeforeInputEventPlugin: null })];
	
	module.exports = DefaultEventPluginOrder;

/***/ },
/* 311 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule EnterLeaveEventPlugin
	 */
	
	'use strict';
	
	var EventConstants = __webpack_require__(18);
	var EventPropagators = __webpack_require__(35);
	var ReactDOMComponentTree = __webpack_require__(8);
	var SyntheticMouseEvent = __webpack_require__(44);
	
	var keyOf = __webpack_require__(20);
	
	var topLevelTypes = EventConstants.topLevelTypes;
	
	var eventTypes = {
	  mouseEnter: {
	    registrationName: keyOf({ onMouseEnter: null }),
	    dependencies: [topLevelTypes.topMouseOut, topLevelTypes.topMouseOver]
	  },
	  mouseLeave: {
	    registrationName: keyOf({ onMouseLeave: null }),
	    dependencies: [topLevelTypes.topMouseOut, topLevelTypes.topMouseOver]
	  }
	};
	
	var EnterLeaveEventPlugin = {
	
	  eventTypes: eventTypes,
	
	  /**
	   * For almost every interaction we care about, there will be both a top-level
	   * `mouseover` and `mouseout` event that occurs. Only use `mouseout` so that
	   * we do not extract duplicate events. However, moving the mouse into the
	   * browser from outside will not fire a `mouseout` event. In this case, we use
	   * the `mouseover` top-level event.
	   */
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    if (topLevelType === topLevelTypes.topMouseOver && (nativeEvent.relatedTarget || nativeEvent.fromElement)) {
	      return null;
	    }
	    if (topLevelType !== topLevelTypes.topMouseOut && topLevelType !== topLevelTypes.topMouseOver) {
	      // Must not be a mouse in or mouse out - ignoring.
	      return null;
	    }
	
	    var win;
	    if (nativeEventTarget.window === nativeEventTarget) {
	      // `nativeEventTarget` is probably a window object.
	      win = nativeEventTarget;
	    } else {
	      // TODO: Figure out why `ownerDocument` is sometimes undefined in IE8.
	      var doc = nativeEventTarget.ownerDocument;
	      if (doc) {
	        win = doc.defaultView || doc.parentWindow;
	      } else {
	        win = window;
	      }
	    }
	
	    var from;
	    var to;
	    if (topLevelType === topLevelTypes.topMouseOut) {
	      from = targetInst;
	      var related = nativeEvent.relatedTarget || nativeEvent.toElement;
	      to = related ? ReactDOMComponentTree.getClosestInstanceFromNode(related) : null;
	    } else {
	      // Moving to a node from outside the window.
	      from = null;
	      to = targetInst;
	    }
	
	    if (from === to) {
	      // Nothing pertains to our managed components.
	      return null;
	    }
	
	    var fromNode = from == null ? win : ReactDOMComponentTree.getNodeFromInstance(from);
	    var toNode = to == null ? win : ReactDOMComponentTree.getNodeFromInstance(to);
	
	    var leave = SyntheticMouseEvent.getPooled(eventTypes.mouseLeave, from, nativeEvent, nativeEventTarget);
	    leave.type = 'mouseleave';
	    leave.target = fromNode;
	    leave.relatedTarget = toNode;
	
	    var enter = SyntheticMouseEvent.getPooled(eventTypes.mouseEnter, to, nativeEvent, nativeEventTarget);
	    enter.type = 'mouseenter';
	    enter.target = toNode;
	    enter.relatedTarget = fromNode;
	
	    EventPropagators.accumulateEnterLeaveDispatches(leave, enter, from, to);
	
	    return [leave, enter];
	  }
	
	};
	
	module.exports = EnterLeaveEventPlugin;

/***/ },
/* 312 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule FallbackCompositionState
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(6);
	
	var PooledClass = __webpack_require__(22);
	
	var getTextContentAccessor = __webpack_require__(124);
	
	/**
	 * This helper class stores information about text content of a target node,
	 * allowing comparison of content before and after a given event.
	 *
	 * Identify the node where selection currently begins, then observe
	 * both its text content and its current position in the DOM. Since the
	 * browser may natively replace the target node during composition, we can
	 * use its position to find its replacement.
	 *
	 * @param {DOMEventTarget} root
	 */
	function FallbackCompositionState(root) {
	  this._root = root;
	  this._startText = this.getText();
	  this._fallbackText = null;
	}
	
	_assign(FallbackCompositionState.prototype, {
	  destructor: function () {
	    this._root = null;
	    this._startText = null;
	    this._fallbackText = null;
	  },
	
	  /**
	   * Get current text of input.
	   *
	   * @return {string}
	   */
	  getText: function () {
	    if ('value' in this._root) {
	      return this._root.value;
	    }
	    return this._root[getTextContentAccessor()];
	  },
	
	  /**
	   * Determine the differing substring between the initially stored
	   * text content and the current content.
	   *
	   * @return {string}
	   */
	  getData: function () {
	    if (this._fallbackText) {
	      return this._fallbackText;
	    }
	
	    var start;
	    var startValue = this._startText;
	    var startLength = startValue.length;
	    var end;
	    var endValue = this.getText();
	    var endLength = endValue.length;
	
	    for (start = 0; start < startLength; start++) {
	      if (startValue[start] !== endValue[start]) {
	        break;
	      }
	    }
	
	    var minEnd = startLength - start;
	    for (end = 1; end <= minEnd; end++) {
	      if (startValue[startLength - end] !== endValue[endLength - end]) {
	        break;
	      }
	    }
	
	    var sliceTail = end > 1 ? 1 - end : undefined;
	    this._fallbackText = endValue.slice(start, sliceTail);
	    return this._fallbackText;
	  }
	});
	
	PooledClass.addPoolingTo(FallbackCompositionState);
	
	module.exports = FallbackCompositionState;

/***/ },
/* 313 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule HTMLDOMPropertyConfig
	 */
	
	'use strict';
	
	var DOMProperty = __webpack_require__(27);
	
	var MUST_USE_PROPERTY = DOMProperty.injection.MUST_USE_PROPERTY;
	var HAS_BOOLEAN_VALUE = DOMProperty.injection.HAS_BOOLEAN_VALUE;
	var HAS_NUMERIC_VALUE = DOMProperty.injection.HAS_NUMERIC_VALUE;
	var HAS_POSITIVE_NUMERIC_VALUE = DOMProperty.injection.HAS_POSITIVE_NUMERIC_VALUE;
	var HAS_OVERLOADED_BOOLEAN_VALUE = DOMProperty.injection.HAS_OVERLOADED_BOOLEAN_VALUE;
	
	var HTMLDOMPropertyConfig = {
	  isCustomAttribute: RegExp.prototype.test.bind(new RegExp('^(data|aria)-[' + DOMProperty.ATTRIBUTE_NAME_CHAR + ']*$')),
	  Properties: {
	    /**
	     * Standard Properties
	     */
	    accept: 0,
	    acceptCharset: 0,
	    accessKey: 0,
	    action: 0,
	    allowFullScreen: HAS_BOOLEAN_VALUE,
	    allowTransparency: 0,
	    alt: 0,
	    async: HAS_BOOLEAN_VALUE,
	    autoComplete: 0,
	    // autoFocus is polyfilled/normalized by AutoFocusUtils
	    // autoFocus: HAS_BOOLEAN_VALUE,
	    autoPlay: HAS_BOOLEAN_VALUE,
	    capture: HAS_BOOLEAN_VALUE,
	    cellPadding: 0,
	    cellSpacing: 0,
	    charSet: 0,
	    challenge: 0,
	    checked: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
	    cite: 0,
	    classID: 0,
	    className: 0,
	    cols: HAS_POSITIVE_NUMERIC_VALUE,
	    colSpan: 0,
	    content: 0,
	    contentEditable: 0,
	    contextMenu: 0,
	    controls: HAS_BOOLEAN_VALUE,
	    coords: 0,
	    crossOrigin: 0,
	    data: 0, // For `<object />` acts as `src`.
	    dateTime: 0,
	    'default': HAS_BOOLEAN_VALUE,
	    defer: HAS_BOOLEAN_VALUE,
	    dir: 0,
	    disabled: HAS_BOOLEAN_VALUE,
	    download: HAS_OVERLOADED_BOOLEAN_VALUE,
	    draggable: 0,
	    encType: 0,
	    form: 0,
	    formAction: 0,
	    formEncType: 0,
	    formMethod: 0,
	    formNoValidate: HAS_BOOLEAN_VALUE,
	    formTarget: 0,
	    frameBorder: 0,
	    headers: 0,
	    height: 0,
	    hidden: HAS_BOOLEAN_VALUE,
	    high: 0,
	    href: 0,
	    hrefLang: 0,
	    htmlFor: 0,
	    httpEquiv: 0,
	    icon: 0,
	    id: 0,
	    inputMode: 0,
	    integrity: 0,
	    is: 0,
	    keyParams: 0,
	    keyType: 0,
	    kind: 0,
	    label: 0,
	    lang: 0,
	    list: 0,
	    loop: HAS_BOOLEAN_VALUE,
	    low: 0,
	    manifest: 0,
	    marginHeight: 0,
	    marginWidth: 0,
	    max: 0,
	    maxLength: 0,
	    media: 0,
	    mediaGroup: 0,
	    method: 0,
	    min: 0,
	    minLength: 0,
	    // Caution; `option.selected` is not updated if `select.multiple` is
	    // disabled with `removeAttribute`.
	    multiple: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
	    muted: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
	    name: 0,
	    nonce: 0,
	    noValidate: HAS_BOOLEAN_VALUE,
	    open: HAS_BOOLEAN_VALUE,
	    optimum: 0,
	    pattern: 0,
	    placeholder: 0,
	    poster: 0,
	    preload: 0,
	    profile: 0,
	    radioGroup: 0,
	    readOnly: HAS_BOOLEAN_VALUE,
	    referrerPolicy: 0,
	    rel: 0,
	    required: HAS_BOOLEAN_VALUE,
	    reversed: HAS_BOOLEAN_VALUE,
	    role: 0,
	    rows: HAS_POSITIVE_NUMERIC_VALUE,
	    rowSpan: HAS_NUMERIC_VALUE,
	    sandbox: 0,
	    scope: 0,
	    scoped: HAS_BOOLEAN_VALUE,
	    scrolling: 0,
	    seamless: HAS_BOOLEAN_VALUE,
	    selected: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
	    shape: 0,
	    size: HAS_POSITIVE_NUMERIC_VALUE,
	    sizes: 0,
	    span: HAS_POSITIVE_NUMERIC_VALUE,
	    spellCheck: 0,
	    src: 0,
	    srcDoc: 0,
	    srcLang: 0,
	    srcSet: 0,
	    start: HAS_NUMERIC_VALUE,
	    step: 0,
	    style: 0,
	    summary: 0,
	    tabIndex: 0,
	    target: 0,
	    title: 0,
	    // Setting .type throws on non-<input> tags
	    type: 0,
	    useMap: 0,
	    value: 0,
	    width: 0,
	    wmode: 0,
	    wrap: 0,
	
	    /**
	     * RDFa Properties
	     */
	    about: 0,
	    datatype: 0,
	    inlist: 0,
	    prefix: 0,
	    // property is also supported for OpenGraph in meta tags.
	    property: 0,
	    resource: 0,
	    'typeof': 0,
	    vocab: 0,
	
	    /**
	     * Non-standard Properties
	     */
	    // autoCapitalize and autoCorrect are supported in Mobile Safari for
	    // keyboard hints.
	    autoCapitalize: 0,
	    autoCorrect: 0,
	    // autoSave allows WebKit/Blink to persist values of input fields on page reloads
	    autoSave: 0,
	    // color is for Safari mask-icon link
	    color: 0,
	    // itemProp, itemScope, itemType are for
	    // Microdata support. See http://schema.org/docs/gs.html
	    itemProp: 0,
	    itemScope: HAS_BOOLEAN_VALUE,
	    itemType: 0,
	    // itemID and itemRef are for Microdata support as well but
	    // only specified in the WHATWG spec document. See
	    // https://html.spec.whatwg.org/multipage/microdata.html#microdata-dom-api
	    itemID: 0,
	    itemRef: 0,
	    // results show looking glass icon and recent searches on input
	    // search fields in WebKit/Blink
	    results: 0,
	    // IE-only attribute that specifies security restrictions on an iframe
	    // as an alternative to the sandbox attribute on IE<10
	    security: 0,
	    // IE-only attribute that controls focus behavior
	    unselectable: 0
	  },
	  DOMAttributeNames: {
	    acceptCharset: 'accept-charset',
	    className: 'class',
	    htmlFor: 'for',
	    httpEquiv: 'http-equiv'
	  },
	  DOMPropertyNames: {}
	};
	
	module.exports = HTMLDOMPropertyConfig;

/***/ },
/* 314 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule React
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(6);
	
	var ReactChildren = __webpack_require__(105);
	var ReactComponent = __webpack_require__(58);
	var ReactPureComponent = __webpack_require__(340);
	var ReactClass = __webpack_require__(106);
	var ReactDOMFactories = __webpack_require__(323);
	var ReactElement = __webpack_require__(13);
	var ReactPropTypes = __webpack_require__(116);
	var ReactVersion = __webpack_require__(117);
	
	var onlyChild = __webpack_require__(366);
	var warning = __webpack_require__(4);
	
	var createElement = ReactElement.createElement;
	var createFactory = ReactElement.createFactory;
	var cloneElement = ReactElement.cloneElement;
	
	if (false) {
	  var ReactElementValidator = require('./ReactElementValidator');
	  createElement = ReactElementValidator.createElement;
	  createFactory = ReactElementValidator.createFactory;
	  cloneElement = ReactElementValidator.cloneElement;
	}
	
	var __spread = _assign;
	
	if (false) {
	  var warned = false;
	  __spread = function () {
	    process.env.NODE_ENV !== 'production' ? warning(warned, 'React.__spread is deprecated and should not be used. Use ' + 'Object.assign directly or another helper function with similar ' + 'semantics. You may be seeing this warning due to your compiler. ' + 'See https://fb.me/react-spread-deprecation for more details.') : void 0;
	    warned = true;
	    return _assign.apply(null, arguments);
	  };
	}
	
	var React = {
	
	  // Modern
	
	  Children: {
	    map: ReactChildren.map,
	    forEach: ReactChildren.forEach,
	    count: ReactChildren.count,
	    toArray: ReactChildren.toArray,
	    only: onlyChild
	  },
	
	  Component: ReactComponent,
	  PureComponent: ReactPureComponent,
	
	  createElement: createElement,
	  cloneElement: cloneElement,
	  isValidElement: ReactElement.isValidElement,
	
	  // Classic
	
	  PropTypes: ReactPropTypes,
	  createClass: ReactClass.createClass,
	  createFactory: createFactory,
	  createMixin: function (mixin) {
	    // Currently a noop. Will be used to validate and trace mixins.
	    return mixin;
	  },
	
	  // This looks DOM specific but these are actually isomorphic helpers
	  // since they are just generating DOM strings.
	  DOM: ReactDOMFactories,
	
	  version: ReactVersion,
	
	  // Deprecated hook for JSX spread, don't use this for anything.
	  __spread: __spread
	};
	
	module.exports = React;

/***/ },
/* 315 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {/**
	 * Copyright 2014-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactChildReconciler
	 */
	
	'use strict';
	
	var ReactReconciler = __webpack_require__(28);
	
	var instantiateReactComponent = __webpack_require__(125);
	var KeyEscapeUtils = __webpack_require__(56);
	var shouldUpdateReactComponent = __webpack_require__(72);
	var traverseAllChildren = __webpack_require__(73);
	var warning = __webpack_require__(4);
	
	var ReactComponentTreeHook;
	
	if (typeof process !== 'undefined' && process.env && ("production") === 'test') {
	  // Temporary hack.
	  // Inline requires don't work well with Jest:
	  // https://github.com/facebook/react/issues/7240
	  // Remove the inline requires when we don't need them anymore:
	  // https://github.com/facebook/react/pull/7178
	  ReactComponentTreeHook = __webpack_require__(60);
	}
	
	function instantiateChild(childInstances, child, name, selfDebugID) {
	  // We found a component instance.
	  var keyUnique = childInstances[name] === undefined;
	  if (false) {
	    if (!ReactComponentTreeHook) {
	      ReactComponentTreeHook = require('./ReactComponentTreeHook');
	    }
	    if (!keyUnique) {
	      process.env.NODE_ENV !== 'production' ? warning(false, 'flattenChildren(...): Encountered two children with the same key, ' + '`%s`. Child keys must be unique; when two children share a key, only ' + 'the first child will be used.%s', KeyEscapeUtils.unescape(name), ReactComponentTreeHook.getStackAddendumByID(selfDebugID)) : void 0;
	    }
	  }
	  if (child != null && keyUnique) {
	    childInstances[name] = instantiateReactComponent(child, true);
	  }
	}
	
	/**
	 * ReactChildReconciler provides helpers for initializing or updating a set of
	 * children. Its output is suitable for passing it onto ReactMultiChild which
	 * does diffed reordering and insertion.
	 */
	var ReactChildReconciler = {
	  /**
	   * Generates a "mount image" for each of the supplied children. In the case
	   * of `ReactDOMComponent`, a mount image is a string of markup.
	   *
	   * @param {?object} nestedChildNodes Nested child maps.
	   * @return {?object} A set of child instances.
	   * @internal
	   */
	  instantiateChildren: function (nestedChildNodes, transaction, context, selfDebugID // 0 in production and for roots
	  ) {
	    if (nestedChildNodes == null) {
	      return null;
	    }
	    var childInstances = {};
	
	    if (false) {
	      traverseAllChildren(nestedChildNodes, function (childInsts, child, name) {
	        return instantiateChild(childInsts, child, name, selfDebugID);
	      }, childInstances);
	    } else {
	      traverseAllChildren(nestedChildNodes, instantiateChild, childInstances);
	    }
	    return childInstances;
	  },
	
	  /**
	   * Updates the rendered children and returns a new set of children.
	   *
	   * @param {?object} prevChildren Previously initialized set of children.
	   * @param {?object} nextChildren Flat child element maps.
	   * @param {ReactReconcileTransaction} transaction
	   * @param {object} context
	   * @return {?object} A new set of child instances.
	   * @internal
	   */
	  updateChildren: function (prevChildren, nextChildren, mountImages, removedNodes, transaction, hostParent, hostContainerInfo, context, selfDebugID // 0 in production and for roots
	  ) {
	    // We currently don't have a way to track moves here but if we use iterators
	    // instead of for..in we can zip the iterators and check if an item has
	    // moved.
	    // TODO: If nothing has changed, return the prevChildren object so that we
	    // can quickly bailout if nothing has changed.
	    if (!nextChildren && !prevChildren) {
	      return;
	    }
	    var name;
	    var prevChild;
	    for (name in nextChildren) {
	      if (!nextChildren.hasOwnProperty(name)) {
	        continue;
	      }
	      prevChild = prevChildren && prevChildren[name];
	      var prevElement = prevChild && prevChild._currentElement;
	      var nextElement = nextChildren[name];
	      if (prevChild != null && shouldUpdateReactComponent(prevElement, nextElement)) {
	        ReactReconciler.receiveComponent(prevChild, nextElement, transaction, context);
	        nextChildren[name] = prevChild;
	      } else {
	        if (prevChild) {
	          removedNodes[name] = ReactReconciler.getHostNode(prevChild);
	          ReactReconciler.unmountComponent(prevChild, false);
	        }
	        // The child must be instantiated before it's mounted.
	        var nextChildInstance = instantiateReactComponent(nextElement, true);
	        nextChildren[name] = nextChildInstance;
	        // Creating mount image now ensures refs are resolved in right order
	        // (see https://github.com/facebook/react/pull/7101 for explanation).
	        var nextChildMountImage = ReactReconciler.mountComponent(nextChildInstance, transaction, hostParent, hostContainerInfo, context, selfDebugID);
	        mountImages.push(nextChildMountImage);
	      }
	    }
	    // Unmount children that are no longer present.
	    for (name in prevChildren) {
	      if (prevChildren.hasOwnProperty(name) && !(nextChildren && nextChildren.hasOwnProperty(name))) {
	        prevChild = prevChildren[name];
	        removedNodes[name] = ReactReconciler.getHostNode(prevChild);
	        ReactReconciler.unmountComponent(prevChild, false);
	      }
	    }
	  },
	
	  /**
	   * Unmounts all rendered children. This should be used to clean up children
	   * when this component is unmounted.
	   *
	   * @param {?object} renderedChildren Previously initialized set of children.
	   * @internal
	   */
	  unmountChildren: function (renderedChildren, safely) {
	    for (var name in renderedChildren) {
	      if (renderedChildren.hasOwnProperty(name)) {
	        var renderedChild = renderedChildren[name];
	        ReactReconciler.unmountComponent(renderedChild, safely);
	      }
	    }
	  }
	
	};
	
	module.exports = ReactChildReconciler;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(41)))

/***/ },
/* 316 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactComponentBrowserEnvironment
	 */
	
	'use strict';
	
	var DOMChildrenOperations = __webpack_require__(52);
	var ReactDOMIDOperations = __webpack_require__(325);
	
	/**
	 * Abstracts away all functionality of the reconciler that requires knowledge of
	 * the browser context. TODO: These callers should be refactored to avoid the
	 * need for this injection.
	 */
	var ReactComponentBrowserEnvironment = {
	
	  processChildrenUpdates: ReactDOMIDOperations.dangerouslyProcessChildrenUpdates,
	
	  replaceNodeWithMarkup: DOMChildrenOperations.dangerouslyReplaceNodeWithMarkup
	
	};
	
	module.exports = ReactComponentBrowserEnvironment;

/***/ },
/* 317 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactCompositeComponent
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(3),
	    _assign = __webpack_require__(6);
	
	var ReactComponentEnvironment = __webpack_require__(59);
	var ReactCurrentOwner = __webpack_require__(23);
	var ReactElement = __webpack_require__(13);
	var ReactErrorUtils = __webpack_require__(61);
	var ReactInstanceMap = __webpack_require__(36);
	var ReactInstrumentation = __webpack_require__(11);
	var ReactNodeTypes = __webpack_require__(115);
	var ReactPropTypeLocations = __webpack_require__(64);
	var ReactReconciler = __webpack_require__(28);
	
	var checkReactTypeSpec = __webpack_require__(359);
	var emptyObject = __webpack_require__(30);
	var invariant = __webpack_require__(2);
	var shallowEqual = __webpack_require__(47);
	var shouldUpdateReactComponent = __webpack_require__(72);
	var warning = __webpack_require__(4);
	
	var CompositeTypes = {
	  ImpureClass: 0,
	  PureClass: 1,
	  StatelessFunctional: 2
	};
	
	function StatelessComponent(Component) {}
	StatelessComponent.prototype.render = function () {
	  var Component = ReactInstanceMap.get(this)._currentElement.type;
	  var element = Component(this.props, this.context, this.updater);
	  warnIfInvalidElement(Component, element);
	  return element;
	};
	
	function warnIfInvalidElement(Component, element) {
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(element === null || element === false || ReactElement.isValidElement(element), '%s(...): A valid React element (or null) must be returned. You may have ' + 'returned undefined, an array or some other invalid object.', Component.displayName || Component.name || 'Component') : void 0;
	    process.env.NODE_ENV !== 'production' ? warning(!Component.childContextTypes, '%s(...): childContextTypes cannot be defined on a functional component.', Component.displayName || Component.name || 'Component') : void 0;
	  }
	}
	
	function invokeComponentDidMountWithTimer() {
	  var publicInstance = this._instance;
	  if (this._debugID !== 0) {
	    ReactInstrumentation.debugTool.onBeginLifeCycleTimer(this._debugID, 'componentDidMount');
	  }
	  publicInstance.componentDidMount();
	  if (this._debugID !== 0) {
	    ReactInstrumentation.debugTool.onEndLifeCycleTimer(this._debugID, 'componentDidMount');
	  }
	}
	
	function invokeComponentDidUpdateWithTimer(prevProps, prevState, prevContext) {
	  var publicInstance = this._instance;
	  if (this._debugID !== 0) {
	    ReactInstrumentation.debugTool.onBeginLifeCycleTimer(this._debugID, 'componentDidUpdate');
	  }
	  publicInstance.componentDidUpdate(prevProps, prevState, prevContext);
	  if (this._debugID !== 0) {
	    ReactInstrumentation.debugTool.onEndLifeCycleTimer(this._debugID, 'componentDidUpdate');
	  }
	}
	
	function shouldConstruct(Component) {
	  return !!(Component.prototype && Component.prototype.isReactComponent);
	}
	
	function isPureComponent(Component) {
	  return !!(Component.prototype && Component.prototype.isPureReactComponent);
	}
	
	/**
	 * ------------------ The Life-Cycle of a Composite Component ------------------
	 *
	 * - constructor: Initialization of state. The instance is now retained.
	 *   - componentWillMount
	 *   - render
	 *   - [children's constructors]
	 *     - [children's componentWillMount and render]
	 *     - [children's componentDidMount]
	 *     - componentDidMount
	 *
	 *       Update Phases:
	 *       - componentWillReceiveProps (only called if parent updated)
	 *       - shouldComponentUpdate
	 *         - componentWillUpdate
	 *           - render
	 *           - [children's constructors or receive props phases]
	 *         - componentDidUpdate
	 *
	 *     - componentWillUnmount
	 *     - [children's componentWillUnmount]
	 *   - [children destroyed]
	 * - (destroyed): The instance is now blank, released by React and ready for GC.
	 *
	 * -----------------------------------------------------------------------------
	 */
	
	/**
	 * An incrementing ID assigned to each component when it is mounted. This is
	 * used to enforce the order in which `ReactUpdates` updates dirty components.
	 *
	 * @private
	 */
	var nextMountID = 1;
	
	/**
	 * @lends {ReactCompositeComponent.prototype}
	 */
	var ReactCompositeComponentMixin = {
	
	  /**
	   * Base constructor for all composite component.
	   *
	   * @param {ReactElement} element
	   * @final
	   * @internal
	   */
	  construct: function (element) {
	    this._currentElement = element;
	    this._rootNodeID = 0;
	    this._compositeType = null;
	    this._instance = null;
	    this._hostParent = null;
	    this._hostContainerInfo = null;
	
	    // See ReactUpdateQueue
	    this._updateBatchNumber = null;
	    this._pendingElement = null;
	    this._pendingStateQueue = null;
	    this._pendingReplaceState = false;
	    this._pendingForceUpdate = false;
	
	    this._renderedNodeType = null;
	    this._renderedComponent = null;
	    this._context = null;
	    this._mountOrder = 0;
	    this._topLevelWrapper = null;
	
	    // See ReactUpdates and ReactUpdateQueue.
	    this._pendingCallbacks = null;
	
	    // ComponentWillUnmount shall only be called once
	    this._calledComponentWillUnmount = false;
	
	    if (false) {
	      this._warnedAboutRefsInRender = false;
	    }
	  },
	
	  /**
	   * Initializes the component, renders markup, and registers event listeners.
	   *
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {?object} hostParent
	   * @param {?object} hostContainerInfo
	   * @param {?object} context
	   * @return {?string} Rendered markup to be inserted into the DOM.
	   * @final
	   * @internal
	   */
	  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
	    this._context = context;
	    this._mountOrder = nextMountID++;
	    this._hostParent = hostParent;
	    this._hostContainerInfo = hostContainerInfo;
	
	    var publicProps = this._currentElement.props;
	    var publicContext = this._processContext(context);
	
	    var Component = this._currentElement.type;
	
	    var updateQueue = transaction.getUpdateQueue();
	
	    // Initialize the public class
	    var doConstruct = shouldConstruct(Component);
	    var inst = this._constructComponent(doConstruct, publicProps, publicContext, updateQueue);
	    var renderedElement;
	
	    // Support functional components
	    if (!doConstruct && (inst == null || inst.render == null)) {
	      renderedElement = inst;
	      warnIfInvalidElement(Component, renderedElement);
	      !(inst === null || inst === false || ReactElement.isValidElement(inst)) ?  false ? invariant(false, '%s(...): A valid React element (or null) must be returned. You may have returned undefined, an array or some other invalid object.', Component.displayName || Component.name || 'Component') : _prodInvariant('105', Component.displayName || Component.name || 'Component') : void 0;
	      inst = new StatelessComponent(Component);
	      this._compositeType = CompositeTypes.StatelessFunctional;
	    } else {
	      if (isPureComponent(Component)) {
	        this._compositeType = CompositeTypes.PureClass;
	      } else {
	        this._compositeType = CompositeTypes.ImpureClass;
	      }
	    }
	
	    if (false) {
	      // This will throw later in _renderValidatedComponent, but add an early
	      // warning now to help debugging
	      if (inst.render == null) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '%s(...): No `render` method found on the returned component ' + 'instance: you may have forgotten to define `render`.', Component.displayName || Component.name || 'Component') : void 0;
	      }
	
	      var propsMutated = inst.props !== publicProps;
	      var componentName = Component.displayName || Component.name || 'Component';
	
	      process.env.NODE_ENV !== 'production' ? warning(inst.props === undefined || !propsMutated, '%s(...): When calling super() in `%s`, make sure to pass ' + 'up the same props that your component\'s constructor was passed.', componentName, componentName) : void 0;
	    }
	
	    // These should be set up in the constructor, but as a convenience for
	    // simpler class abstractions, we set them up after the fact.
	    inst.props = publicProps;
	    inst.context = publicContext;
	    inst.refs = emptyObject;
	    inst.updater = updateQueue;
	
	    this._instance = inst;
	
	    // Store a reference from the instance back to the internal representation
	    ReactInstanceMap.set(inst, this);
	
	    if (false) {
	      // Since plain JS classes are defined without any special initialization
	      // logic, we can not catch common errors early. Therefore, we have to
	      // catch them here, at initialization time, instead.
	      process.env.NODE_ENV !== 'production' ? warning(!inst.getInitialState || inst.getInitialState.isReactClassApproved, 'getInitialState was defined on %s, a plain JavaScript class. ' + 'This is only supported for classes created using React.createClass. ' + 'Did you mean to define a state property instead?', this.getName() || 'a component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(!inst.getDefaultProps || inst.getDefaultProps.isReactClassApproved, 'getDefaultProps was defined on %s, a plain JavaScript class. ' + 'This is only supported for classes created using React.createClass. ' + 'Use a static property to define defaultProps instead.', this.getName() || 'a component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(!inst.propTypes, 'propTypes was defined as an instance property on %s. Use a static ' + 'property to define propTypes instead.', this.getName() || 'a component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(!inst.contextTypes, 'contextTypes was defined as an instance property on %s. Use a ' + 'static property to define contextTypes instead.', this.getName() || 'a component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(typeof inst.componentShouldUpdate !== 'function', '%s has a method called ' + 'componentShouldUpdate(). Did you mean shouldComponentUpdate()? ' + 'The name is phrased as a question because the function is ' + 'expected to return a value.', this.getName() || 'A component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(typeof inst.componentDidUnmount !== 'function', '%s has a method called ' + 'componentDidUnmount(). But there is no such lifecycle method. ' + 'Did you mean componentWillUnmount()?', this.getName() || 'A component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(typeof inst.componentWillRecieveProps !== 'function', '%s has a method called ' + 'componentWillRecieveProps(). Did you mean componentWillReceiveProps()?', this.getName() || 'A component') : void 0;
	    }
	
	    var initialState = inst.state;
	    if (initialState === undefined) {
	      inst.state = initialState = null;
	    }
	    !(typeof initialState === 'object' && !Array.isArray(initialState)) ?  false ? invariant(false, '%s.state: must be set to an object or null', this.getName() || 'ReactCompositeComponent') : _prodInvariant('106', this.getName() || 'ReactCompositeComponent') : void 0;
	
	    this._pendingStateQueue = null;
	    this._pendingReplaceState = false;
	    this._pendingForceUpdate = false;
	
	    var markup;
	    if (inst.unstable_handleError) {
	      markup = this.performInitialMountWithErrorHandling(renderedElement, hostParent, hostContainerInfo, transaction, context);
	    } else {
	      markup = this.performInitialMount(renderedElement, hostParent, hostContainerInfo, transaction, context);
	    }
	
	    if (inst.componentDidMount) {
	      if (false) {
	        transaction.getReactMountReady().enqueue(invokeComponentDidMountWithTimer, this);
	      } else {
	        transaction.getReactMountReady().enqueue(inst.componentDidMount, inst);
	      }
	    }
	
	    return markup;
	  },
	
	  _constructComponent: function (doConstruct, publicProps, publicContext, updateQueue) {
	    if (false) {
	      ReactCurrentOwner.current = this;
	      try {
	        return this._constructComponentWithoutOwner(doConstruct, publicProps, publicContext, updateQueue);
	      } finally {
	        ReactCurrentOwner.current = null;
	      }
	    } else {
	      return this._constructComponentWithoutOwner(doConstruct, publicProps, publicContext, updateQueue);
	    }
	  },
	
	  _constructComponentWithoutOwner: function (doConstruct, publicProps, publicContext, updateQueue) {
	    var Component = this._currentElement.type;
	    var instanceOrElement;
	    if (doConstruct) {
	      if (false) {
	        if (this._debugID !== 0) {
	          ReactInstrumentation.debugTool.onBeginLifeCycleTimer(this._debugID, 'ctor');
	        }
	      }
	      instanceOrElement = new Component(publicProps, publicContext, updateQueue);
	      if (false) {
	        if (this._debugID !== 0) {
	          ReactInstrumentation.debugTool.onEndLifeCycleTimer(this._debugID, 'ctor');
	        }
	      }
	    } else {
	      // This can still be an instance in case of factory components
	      // but we'll count this as time spent rendering as the more common case.
	      if (false) {
	        if (this._debugID !== 0) {
	          ReactInstrumentation.debugTool.onBeginLifeCycleTimer(this._debugID, 'render');
	        }
	      }
	      instanceOrElement = Component(publicProps, publicContext, updateQueue);
	      if (false) {
	        if (this._debugID !== 0) {
	          ReactInstrumentation.debugTool.onEndLifeCycleTimer(this._debugID, 'render');
	        }
	      }
	    }
	    return instanceOrElement;
	  },
	
	  performInitialMountWithErrorHandling: function (renderedElement, hostParent, hostContainerInfo, transaction, context) {
	    var markup;
	    var checkpoint = transaction.checkpoint();
	    try {
	      markup = this.performInitialMount(renderedElement, hostParent, hostContainerInfo, transaction, context);
	    } catch (e) {
	      if (false) {
	        if (this._debugID !== 0) {
	          ReactInstrumentation.debugTool.onError();
	        }
	      }
	      // Roll back to checkpoint, handle error (which may add items to the transaction), and take a new checkpoint
	      transaction.rollback(checkpoint);
	      this._instance.unstable_handleError(e);
	      if (this._pendingStateQueue) {
	        this._instance.state = this._processPendingState(this._instance.props, this._instance.context);
	      }
	      checkpoint = transaction.checkpoint();
	
	      this._renderedComponent.unmountComponent(true);
	      transaction.rollback(checkpoint);
	
	      // Try again - we've informed the component about the error, so they can render an error message this time.
	      // If this throws again, the error will bubble up (and can be caught by a higher error boundary).
	      markup = this.performInitialMount(renderedElement, hostParent, hostContainerInfo, transaction, context);
	    }
	    return markup;
	  },
	
	  performInitialMount: function (renderedElement, hostParent, hostContainerInfo, transaction, context) {
	    var inst = this._instance;
	    if (inst.componentWillMount) {
	      if (false) {
	        if (this._debugID !== 0) {
	          ReactInstrumentation.debugTool.onBeginLifeCycleTimer(this._debugID, 'componentWillMount');
	        }
	      }
	      inst.componentWillMount();
	      if (false) {
	        if (this._debugID !== 0) {
	          ReactInstrumentation.debugTool.onEndLifeCycleTimer(this._debugID, 'componentWillMount');
	        }
	      }
	      // When mounting, calls to `setState` by `componentWillMount` will set
	      // `this._pendingStateQueue` without triggering a re-render.
	      if (this._pendingStateQueue) {
	        inst.state = this._processPendingState(inst.props, inst.context);
	      }
	    }
	
	    // If not a stateless component, we now render
	    if (renderedElement === undefined) {
	      renderedElement = this._renderValidatedComponent();
	    }
	
	    var nodeType = ReactNodeTypes.getType(renderedElement);
	    this._renderedNodeType = nodeType;
	    var child = this._instantiateReactComponent(renderedElement, nodeType !== ReactNodeTypes.EMPTY /* shouldHaveDebugID */
	    );
	    this._renderedComponent = child;
	
	    var selfDebugID = 0;
	    if (false) {
	      selfDebugID = this._debugID;
	    }
	    var markup = ReactReconciler.mountComponent(child, transaction, hostParent, hostContainerInfo, this._processChildContext(context), selfDebugID);
	
	    if (false) {
	      if (this._debugID !== 0) {
	        ReactInstrumentation.debugTool.onSetChildren(this._debugID, child._debugID !== 0 ? [child._debugID] : []);
	      }
	    }
	
	    return markup;
	  },
	
	  getHostNode: function () {
	    return ReactReconciler.getHostNode(this._renderedComponent);
	  },
	
	  /**
	   * Releases any resources allocated by `mountComponent`.
	   *
	   * @final
	   * @internal
	   */
	  unmountComponent: function (safely) {
	    if (!this._renderedComponent) {
	      return;
	    }
	    var inst = this._instance;
	
	    if (inst.componentWillUnmount && !inst._calledComponentWillUnmount) {
	      inst._calledComponentWillUnmount = true;
	      if (false) {
	        if (this._debugID !== 0) {
	          ReactInstrumentation.debugTool.onBeginLifeCycleTimer(this._debugID, 'componentWillUnmount');
	        }
	      }
	      if (safely) {
	        var name = this.getName() + '.componentWillUnmount()';
	        ReactErrorUtils.invokeGuardedCallback(name, inst.componentWillUnmount.bind(inst));
	      } else {
	        inst.componentWillUnmount();
	      }
	      if (false) {
	        if (this._debugID !== 0) {
	          ReactInstrumentation.debugTool.onEndLifeCycleTimer(this._debugID, 'componentWillUnmount');
	        }
	      }
	    }
	
	    if (this._renderedComponent) {
	      ReactReconciler.unmountComponent(this._renderedComponent, safely);
	      this._renderedNodeType = null;
	      this._renderedComponent = null;
	      this._instance = null;
	    }
	
	    // Reset pending fields
	    // Even if this component is scheduled for another update in ReactUpdates,
	    // it would still be ignored because these fields are reset.
	    this._pendingStateQueue = null;
	    this._pendingReplaceState = false;
	    this._pendingForceUpdate = false;
	    this._pendingCallbacks = null;
	    this._pendingElement = null;
	
	    // These fields do not really need to be reset since this object is no
	    // longer accessible.
	    this._context = null;
	    this._rootNodeID = 0;
	    this._topLevelWrapper = null;
	
	    // Delete the reference from the instance to this internal representation
	    // which allow the internals to be properly cleaned up even if the user
	    // leaks a reference to the public instance.
	    ReactInstanceMap.remove(inst);
	
	    // Some existing components rely on inst.props even after they've been
	    // destroyed (in event handlers).
	    // TODO: inst.props = null;
	    // TODO: inst.state = null;
	    // TODO: inst.context = null;
	  },
	
	  /**
	   * Filters the context object to only contain keys specified in
	   * `contextTypes`
	   *
	   * @param {object} context
	   * @return {?object}
	   * @private
	   */
	  _maskContext: function (context) {
	    var Component = this._currentElement.type;
	    var contextTypes = Component.contextTypes;
	    if (!contextTypes) {
	      return emptyObject;
	    }
	    var maskedContext = {};
	    for (var contextName in contextTypes) {
	      maskedContext[contextName] = context[contextName];
	    }
	    return maskedContext;
	  },
	
	  /**
	   * Filters the context object to only contain keys specified in
	   * `contextTypes`, and asserts that they are valid.
	   *
	   * @param {object} context
	   * @return {?object}
	   * @private
	   */
	  _processContext: function (context) {
	    var maskedContext = this._maskContext(context);
	    if (false) {
	      var Component = this._currentElement.type;
	      if (Component.contextTypes) {
	        this._checkContextTypes(Component.contextTypes, maskedContext, ReactPropTypeLocations.context);
	      }
	    }
	    return maskedContext;
	  },
	
	  /**
	   * @param {object} currentContext
	   * @return {object}
	   * @private
	   */
	  _processChildContext: function (currentContext) {
	    var Component = this._currentElement.type;
	    var inst = this._instance;
	    if (false) {
	      ReactInstrumentation.debugTool.onBeginProcessingChildContext();
	    }
	    var childContext = inst.getChildContext && inst.getChildContext();
	    if (false) {
	      ReactInstrumentation.debugTool.onEndProcessingChildContext();
	    }
	    if (childContext) {
	      !(typeof Component.childContextTypes === 'object') ?  false ? invariant(false, '%s.getChildContext(): childContextTypes must be defined in order to use getChildContext().', this.getName() || 'ReactCompositeComponent') : _prodInvariant('107', this.getName() || 'ReactCompositeComponent') : void 0;
	      if (false) {
	        this._checkContextTypes(Component.childContextTypes, childContext, ReactPropTypeLocations.childContext);
	      }
	      for (var name in childContext) {
	        !(name in Component.childContextTypes) ?  false ? invariant(false, '%s.getChildContext(): key "%s" is not defined in childContextTypes.', this.getName() || 'ReactCompositeComponent', name) : _prodInvariant('108', this.getName() || 'ReactCompositeComponent', name) : void 0;
	      }
	      return _assign({}, currentContext, childContext);
	    }
	    return currentContext;
	  },
	
	  /**
	   * Assert that the context types are valid
	   *
	   * @param {object} typeSpecs Map of context field to a ReactPropType
	   * @param {object} values Runtime values that need to be type-checked
	   * @param {string} location e.g. "prop", "context", "child context"
	   * @private
	   */
	  _checkContextTypes: function (typeSpecs, values, location) {
	    checkReactTypeSpec(typeSpecs, values, location, this.getName(), null, this._debugID);
	  },
	
	  receiveComponent: function (nextElement, transaction, nextContext) {
	    var prevElement = this._currentElement;
	    var prevContext = this._context;
	
	    this._pendingElement = null;
	
	    this.updateComponent(transaction, prevElement, nextElement, prevContext, nextContext);
	  },
	
	  /**
	   * If any of `_pendingElement`, `_pendingStateQueue`, or `_pendingForceUpdate`
	   * is set, update the component.
	   *
	   * @param {ReactReconcileTransaction} transaction
	   * @internal
	   */
	  performUpdateIfNecessary: function (transaction) {
	    if (this._pendingElement != null) {
	      ReactReconciler.receiveComponent(this, this._pendingElement, transaction, this._context);
	    } else if (this._pendingStateQueue !== null || this._pendingForceUpdate) {
	      this.updateComponent(transaction, this._currentElement, this._currentElement, this._context, this._context);
	    } else {
	      this._updateBatchNumber = null;
	    }
	  },
	
	  /**
	   * Perform an update to a mounted component. The componentWillReceiveProps and
	   * shouldComponentUpdate methods are called, then (assuming the update isn't
	   * skipped) the remaining update lifecycle methods are called and the DOM
	   * representation is updated.
	   *
	   * By default, this implements React's rendering and reconciliation algorithm.
	   * Sophisticated clients may wish to override this.
	   *
	   * @param {ReactReconcileTransaction} transaction
	   * @param {ReactElement} prevParentElement
	   * @param {ReactElement} nextParentElement
	   * @internal
	   * @overridable
	   */
	  updateComponent: function (transaction, prevParentElement, nextParentElement, prevUnmaskedContext, nextUnmaskedContext) {
	    var inst = this._instance;
	    !(inst != null) ?  false ? invariant(false, 'Attempted to update component `%s` that has already been unmounted (or failed to mount).', this.getName() || 'ReactCompositeComponent') : _prodInvariant('136', this.getName() || 'ReactCompositeComponent') : void 0;
	
	    var willReceive = false;
	    var nextContext;
	
	    // Determine if the context has changed or not
	    if (this._context === nextUnmaskedContext) {
	      nextContext = inst.context;
	    } else {
	      nextContext = this._processContext(nextUnmaskedContext);
	      willReceive = true;
	    }
	
	    var prevProps = prevParentElement.props;
	    var nextProps = nextParentElement.props;
	
	    // Not a simple state update but a props update
	    if (prevParentElement !== nextParentElement) {
	      willReceive = true;
	    }
	
	    // An update here will schedule an update but immediately set
	    // _pendingStateQueue which will ensure that any state updates gets
	    // immediately reconciled instead of waiting for the next batch.
	    if (willReceive && inst.componentWillReceiveProps) {
	      if (false) {
	        if (this._debugID !== 0) {
	          ReactInstrumentation.debugTool.onBeginLifeCycleTimer(this._debugID, 'componentWillReceiveProps');
	        }
	      }
	      inst.componentWillReceiveProps(nextProps, nextContext);
	      if (false) {
	        if (this._debugID !== 0) {
	          ReactInstrumentation.debugTool.onEndLifeCycleTimer(this._debugID, 'componentWillReceiveProps');
	        }
	      }
	    }
	
	    var nextState = this._processPendingState(nextProps, nextContext);
	    var shouldUpdate = true;
	
	    if (!this._pendingForceUpdate) {
	      if (inst.shouldComponentUpdate) {
	        if (false) {
	          if (this._debugID !== 0) {
	            ReactInstrumentation.debugTool.onBeginLifeCycleTimer(this._debugID, 'shouldComponentUpdate');
	          }
	        }
	        shouldUpdate = inst.shouldComponentUpdate(nextProps, nextState, nextContext);
	        if (false) {
	          if (this._debugID !== 0) {
	            ReactInstrumentation.debugTool.onEndLifeCycleTimer(this._debugID, 'shouldComponentUpdate');
	          }
	        }
	      } else {
	        if (this._compositeType === CompositeTypes.PureClass) {
	          shouldUpdate = !shallowEqual(prevProps, nextProps) || !shallowEqual(inst.state, nextState);
	        }
	      }
	    }
	
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(shouldUpdate !== undefined, '%s.shouldComponentUpdate(): Returned undefined instead of a ' + 'boolean value. Make sure to return true or false.', this.getName() || 'ReactCompositeComponent') : void 0;
	    }
	
	    this._updateBatchNumber = null;
	    if (shouldUpdate) {
	      this._pendingForceUpdate = false;
	      // Will set `this.props`, `this.state` and `this.context`.
	      this._performComponentUpdate(nextParentElement, nextProps, nextState, nextContext, transaction, nextUnmaskedContext);
	    } else {
	      // If it's determined that a component should not update, we still want
	      // to set props and state but we shortcut the rest of the update.
	      this._currentElement = nextParentElement;
	      this._context = nextUnmaskedContext;
	      inst.props = nextProps;
	      inst.state = nextState;
	      inst.context = nextContext;
	    }
	  },
	
	  _processPendingState: function (props, context) {
	    var inst = this._instance;
	    var queue = this._pendingStateQueue;
	    var replace = this._pendingReplaceState;
	    this._pendingReplaceState = false;
	    this._pendingStateQueue = null;
	
	    if (!queue) {
	      return inst.state;
	    }
	
	    if (replace && queue.length === 1) {
	      return queue[0];
	    }
	
	    var nextState = _assign({}, replace ? queue[0] : inst.state);
	    for (var i = replace ? 1 : 0; i < queue.length; i++) {
	      var partial = queue[i];
	      _assign(nextState, typeof partial === 'function' ? partial.call(inst, nextState, props, context) : partial);
	    }
	
	    return nextState;
	  },
	
	  /**
	   * Merges new props and state, notifies delegate methods of update and
	   * performs update.
	   *
	   * @param {ReactElement} nextElement Next element
	   * @param {object} nextProps Next public object to set as properties.
	   * @param {?object} nextState Next object to set as state.
	   * @param {?object} nextContext Next public object to set as context.
	   * @param {ReactReconcileTransaction} transaction
	   * @param {?object} unmaskedContext
	   * @private
	   */
	  _performComponentUpdate: function (nextElement, nextProps, nextState, nextContext, transaction, unmaskedContext) {
	    var inst = this._instance;
	
	    var hasComponentDidUpdate = Boolean(inst.componentDidUpdate);
	    var prevProps;
	    var prevState;
	    var prevContext;
	    if (hasComponentDidUpdate) {
	      prevProps = inst.props;
	      prevState = inst.state;
	      prevContext = inst.context;
	    }
	
	    if (inst.componentWillUpdate) {
	      if (false) {
	        if (this._debugID !== 0) {
	          ReactInstrumentation.debugTool.onBeginLifeCycleTimer(this._debugID, 'componentWillUpdate');
	        }
	      }
	      inst.componentWillUpdate(nextProps, nextState, nextContext);
	      if (false) {
	        if (this._debugID !== 0) {
	          ReactInstrumentation.debugTool.onEndLifeCycleTimer(this._debugID, 'componentWillUpdate');
	        }
	      }
	    }
	
	    this._currentElement = nextElement;
	    this._context = unmaskedContext;
	    inst.props = nextProps;
	    inst.state = nextState;
	    inst.context = nextContext;
	
	    this._updateRenderedComponent(transaction, unmaskedContext);
	
	    if (hasComponentDidUpdate) {
	      if (false) {
	        transaction.getReactMountReady().enqueue(invokeComponentDidUpdateWithTimer.bind(this, prevProps, prevState, prevContext), this);
	      } else {
	        transaction.getReactMountReady().enqueue(inst.componentDidUpdate.bind(inst, prevProps, prevState, prevContext), inst);
	      }
	    }
	  },
	
	  /**
	   * Call the component's `render` method and update the DOM accordingly.
	   *
	   * @param {ReactReconcileTransaction} transaction
	   * @internal
	   */
	  _updateRenderedComponent: function (transaction, context) {
	    var prevComponentInstance = this._renderedComponent;
	    var prevRenderedElement = prevComponentInstance._currentElement;
	    var nextRenderedElement = this._renderValidatedComponent();
	    if (shouldUpdateReactComponent(prevRenderedElement, nextRenderedElement)) {
	      ReactReconciler.receiveComponent(prevComponentInstance, nextRenderedElement, transaction, this._processChildContext(context));
	    } else {
	      var oldHostNode = ReactReconciler.getHostNode(prevComponentInstance);
	      ReactReconciler.unmountComponent(prevComponentInstance, false);
	
	      var nodeType = ReactNodeTypes.getType(nextRenderedElement);
	      this._renderedNodeType = nodeType;
	      var child = this._instantiateReactComponent(nextRenderedElement, nodeType !== ReactNodeTypes.EMPTY /* shouldHaveDebugID */
	      );
	      this._renderedComponent = child;
	
	      var selfDebugID = 0;
	      if (false) {
	        selfDebugID = this._debugID;
	      }
	      var nextMarkup = ReactReconciler.mountComponent(child, transaction, this._hostParent, this._hostContainerInfo, this._processChildContext(context), selfDebugID);
	
	      if (false) {
	        if (this._debugID !== 0) {
	          ReactInstrumentation.debugTool.onSetChildren(this._debugID, child._debugID !== 0 ? [child._debugID] : []);
	        }
	      }
	
	      this._replaceNodeWithMarkup(oldHostNode, nextMarkup, prevComponentInstance);
	    }
	  },
	
	  /**
	   * Overridden in shallow rendering.
	   *
	   * @protected
	   */
	  _replaceNodeWithMarkup: function (oldHostNode, nextMarkup, prevInstance) {
	    ReactComponentEnvironment.replaceNodeWithMarkup(oldHostNode, nextMarkup, prevInstance);
	  },
	
	  /**
	   * @protected
	   */
	  _renderValidatedComponentWithoutOwnerOrContext: function () {
	    var inst = this._instance;
	
	    if (false) {
	      if (this._debugID !== 0) {
	        ReactInstrumentation.debugTool.onBeginLifeCycleTimer(this._debugID, 'render');
	      }
	    }
	    var renderedComponent = inst.render();
	    if (false) {
	      if (this._debugID !== 0) {
	        ReactInstrumentation.debugTool.onEndLifeCycleTimer(this._debugID, 'render');
	      }
	    }
	
	    if (false) {
	      // We allow auto-mocks to proceed as if they're returning null.
	      if (renderedComponent === undefined && inst.render._isMockFunction) {
	        // This is probably bad practice. Consider warning here and
	        // deprecating this convenience.
	        renderedComponent = null;
	      }
	    }
	
	    return renderedComponent;
	  },
	
	  /**
	   * @private
	   */
	  _renderValidatedComponent: function () {
	    var renderedComponent;
	    if (("production") !== 'production' || this._compositeType !== CompositeTypes.StatelessFunctional) {
	      ReactCurrentOwner.current = this;
	      try {
	        renderedComponent = this._renderValidatedComponentWithoutOwnerOrContext();
	      } finally {
	        ReactCurrentOwner.current = null;
	      }
	    } else {
	      renderedComponent = this._renderValidatedComponentWithoutOwnerOrContext();
	    }
	    !(
	    // TODO: An `isValidNode` function would probably be more appropriate
	    renderedComponent === null || renderedComponent === false || ReactElement.isValidElement(renderedComponent)) ?  false ? invariant(false, '%s.render(): A valid React element (or null) must be returned. You may have returned undefined, an array or some other invalid object.', this.getName() || 'ReactCompositeComponent') : _prodInvariant('109', this.getName() || 'ReactCompositeComponent') : void 0;
	
	    return renderedComponent;
	  },
	
	  /**
	   * Lazily allocates the refs object and stores `component` as `ref`.
	   *
	   * @param {string} ref Reference name.
	   * @param {component} component Component to store as `ref`.
	   * @final
	   * @private
	   */
	  attachRef: function (ref, component) {
	    var inst = this.getPublicInstance();
	    !(inst != null) ?  false ? invariant(false, 'Stateless function components cannot have refs.') : _prodInvariant('110') : void 0;
	    var publicComponentInstance = component.getPublicInstance();
	    if (false) {
	      var componentName = component && component.getName ? component.getName() : 'a component';
	      process.env.NODE_ENV !== 'production' ? warning(publicComponentInstance != null, 'Stateless function components cannot be given refs ' + '(See ref "%s" in %s created by %s). ' + 'Attempts to access this ref will fail.', ref, componentName, this.getName()) : void 0;
	    }
	    var refs = inst.refs === emptyObject ? inst.refs = {} : inst.refs;
	    refs[ref] = publicComponentInstance;
	  },
	
	  /**
	   * Detaches a reference name.
	   *
	   * @param {string} ref Name to dereference.
	   * @final
	   * @private
	   */
	  detachRef: function (ref) {
	    var refs = this.getPublicInstance().refs;
	    delete refs[ref];
	  },
	
	  /**
	   * Get a text description of the component that can be used to identify it
	   * in error messages.
	   * @return {string} The name or null.
	   * @internal
	   */
	  getName: function () {
	    var type = this._currentElement.type;
	    var constructor = this._instance && this._instance.constructor;
	    return type.displayName || constructor && constructor.displayName || type.name || constructor && constructor.name || null;
	  },
	
	  /**
	   * Get the publicly accessible representation of this component - i.e. what
	   * is exposed by refs and returned by render. Can be null for stateless
	   * components.
	   *
	   * @return {ReactComponent} the public component instance.
	   * @internal
	   */
	  getPublicInstance: function () {
	    var inst = this._instance;
	    if (this._compositeType === CompositeTypes.StatelessFunctional) {
	      return null;
	    }
	    return inst;
	  },
	
	  // Stub
	  _instantiateReactComponent: null
	
	};
	
	var ReactCompositeComponent = {
	
	  Mixin: ReactCompositeComponentMixin
	
	};
	
	module.exports = ReactCompositeComponent;

/***/ },
/* 318 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDOM
	 */
	
	/* globals __REACT_DEVTOOLS_GLOBAL_HOOK__*/
	
	'use strict';
	
	var ReactDOMComponentTree = __webpack_require__(8);
	var ReactDefaultInjection = __webpack_require__(333);
	var ReactMount = __webpack_require__(113);
	var ReactReconciler = __webpack_require__(28);
	var ReactUpdates = __webpack_require__(14);
	var ReactVersion = __webpack_require__(117);
	
	var findDOMNode = __webpack_require__(361);
	var getHostComponentFromComposite = __webpack_require__(122);
	var renderSubtreeIntoContainer = __webpack_require__(368);
	var warning = __webpack_require__(4);
	
	ReactDefaultInjection.inject();
	
	var ReactDOM = {
	  findDOMNode: findDOMNode,
	  render: ReactMount.render,
	  unmountComponentAtNode: ReactMount.unmountComponentAtNode,
	  version: ReactVersion,
	
	  /* eslint-disable camelcase */
	  unstable_batchedUpdates: ReactUpdates.batchedUpdates,
	  unstable_renderSubtreeIntoContainer: renderSubtreeIntoContainer
	};
	
	// Inject the runtime into a devtools global hook regardless of browser.
	// Allows for debugging when the hook is injected on the page.
	/* eslint-enable camelcase */
	if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ !== 'undefined' && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.inject === 'function') {
	  __REACT_DEVTOOLS_GLOBAL_HOOK__.inject({
	    ComponentTree: {
	      getClosestInstanceFromNode: ReactDOMComponentTree.getClosestInstanceFromNode,
	      getNodeFromInstance: function (inst) {
	        // inst is an internal instance (but could be a composite)
	        if (inst._renderedComponent) {
	          inst = getHostComponentFromComposite(inst);
	        }
	        if (inst) {
	          return ReactDOMComponentTree.getNodeFromInstance(inst);
	        } else {
	          return null;
	        }
	      }
	    },
	    Mount: ReactMount,
	    Reconciler: ReactReconciler
	  });
	}
	
	if (false) {
	  var ExecutionEnvironment = require('fbjs/lib/ExecutionEnvironment');
	  if (ExecutionEnvironment.canUseDOM && window.top === window.self) {
	
	    // First check if devtools is not installed
	    if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined') {
	      // If we're in Chrome or Firefox, provide a download link if not installed.
	      if (navigator.userAgent.indexOf('Chrome') > -1 && navigator.userAgent.indexOf('Edge') === -1 || navigator.userAgent.indexOf('Firefox') > -1) {
	        // Firefox does not have the issue with devtools loaded over file://
	        var showFileUrlMessage = window.location.protocol.indexOf('http') === -1 && navigator.userAgent.indexOf('Firefox') === -1;
	        console.debug('Download the React DevTools ' + (showFileUrlMessage ? 'and use an HTTP server (instead of a file: URL) ' : '') + 'for a better development experience: ' + 'https://fb.me/react-devtools');
	      }
	    }
	
	    var testFunc = function testFn() {};
	    process.env.NODE_ENV !== 'production' ? warning((testFunc.name || testFunc.toString()).indexOf('testFn') !== -1, 'It looks like you\'re using a minified copy of the development build ' + 'of React. When deploying React apps to production, make sure to use ' + 'the production build which skips development warnings and is faster. ' + 'See https://fb.me/react-minification for more details.') : void 0;
	
	    // If we're in IE8, check to see if we are in compatibility mode and provide
	    // information on preventing compatibility mode
	    var ieCompatibilityMode = document.documentMode && document.documentMode < 8;
	
	    process.env.NODE_ENV !== 'production' ? warning(!ieCompatibilityMode, 'Internet Explorer is running in compatibility mode; please add the ' + 'following tag to your HTML to prevent this from happening: ' + '<meta http-equiv="X-UA-Compatible" content="IE=edge" />') : void 0;
	
	    var expectedFeatures = [
	    // shims
	    Array.isArray, Array.prototype.every, Array.prototype.forEach, Array.prototype.indexOf, Array.prototype.map, Date.now, Function.prototype.bind, Object.keys, String.prototype.split, String.prototype.trim];
	
	    for (var i = 0; i < expectedFeatures.length; i++) {
	      if (!expectedFeatures[i]) {
	        process.env.NODE_ENV !== 'production' ? warning(false, 'One or more ES5 shims expected by React are not available: ' + 'https://fb.me/react-warning-polyfills') : void 0;
	        break;
	      }
	    }
	  }
	}
	
	if (false) {
	  var ReactInstrumentation = require('./ReactInstrumentation');
	  var ReactDOMUnknownPropertyHook = require('./ReactDOMUnknownPropertyHook');
	  var ReactDOMNullInputValuePropHook = require('./ReactDOMNullInputValuePropHook');
	
	  ReactInstrumentation.debugTool.addHook(ReactDOMUnknownPropertyHook);
	  ReactInstrumentation.debugTool.addHook(ReactDOMNullInputValuePropHook);
	}
	
	module.exports = ReactDOM;

/***/ },
/* 319 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDOMButton
	 */
	
	'use strict';
	
	var DisabledInputUtils = __webpack_require__(42);
	
	/**
	 * Implements a <button> host component that does not receive mouse events
	 * when `disabled` is set.
	 */
	var ReactDOMButton = {
	  getHostProps: DisabledInputUtils.getHostProps
	};
	
	module.exports = ReactDOMButton;

/***/ },
/* 320 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDOMComponent
	 */
	
	/* global hasOwnProperty:true */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(3),
	    _assign = __webpack_require__(6);
	
	var AutoFocusUtils = __webpack_require__(305);
	var CSSPropertyOperations = __webpack_require__(307);
	var DOMLazyTree = __webpack_require__(26);
	var DOMNamespaces = __webpack_require__(53);
	var DOMProperty = __webpack_require__(27);
	var DOMPropertyOperations = __webpack_require__(104);
	var EventConstants = __webpack_require__(18);
	var EventPluginHub = __webpack_require__(34);
	var EventPluginRegistry = __webpack_require__(54);
	var ReactBrowserEventEmitter = __webpack_require__(43);
	var ReactDOMButton = __webpack_require__(319);
	var ReactDOMComponentFlags = __webpack_require__(107);
	var ReactDOMComponentTree = __webpack_require__(8);
	var ReactDOMInput = __webpack_require__(326);
	var ReactDOMOption = __webpack_require__(327);
	var ReactDOMSelect = __webpack_require__(108);
	var ReactDOMTextarea = __webpack_require__(330);
	var ReactInstrumentation = __webpack_require__(11);
	var ReactMultiChild = __webpack_require__(338);
	var ReactServerRenderingTransaction = __webpack_require__(343);
	
	var emptyFunction = __webpack_require__(10);
	var escapeTextContentForBrowser = __webpack_require__(45);
	var invariant = __webpack_require__(2);
	var isEventSupported = __webpack_require__(71);
	var keyOf = __webpack_require__(20);
	var shallowEqual = __webpack_require__(47);
	var validateDOMNesting = __webpack_require__(74);
	var warning = __webpack_require__(4);
	
	var Flags = ReactDOMComponentFlags;
	var deleteListener = EventPluginHub.deleteListener;
	var getNode = ReactDOMComponentTree.getNodeFromInstance;
	var listenTo = ReactBrowserEventEmitter.listenTo;
	var registrationNameModules = EventPluginRegistry.registrationNameModules;
	
	// For quickly matching children type, to test if can be treated as content.
	var CONTENT_TYPES = { 'string': true, 'number': true };
	
	var STYLE = keyOf({ style: null });
	var HTML = keyOf({ __html: null });
	var RESERVED_PROPS = {
	  children: null,
	  dangerouslySetInnerHTML: null,
	  suppressContentEditableWarning: null
	};
	
	// Node type for document fragments (Node.DOCUMENT_FRAGMENT_NODE).
	var DOC_FRAGMENT_TYPE = 11;
	
	function getDeclarationErrorAddendum(internalInstance) {
	  if (internalInstance) {
	    var owner = internalInstance._currentElement._owner || null;
	    if (owner) {
	      var name = owner.getName();
	      if (name) {
	        return ' This DOM node was rendered by `' + name + '`.';
	      }
	    }
	  }
	  return '';
	}
	
	function friendlyStringify(obj) {
	  if (typeof obj === 'object') {
	    if (Array.isArray(obj)) {
	      return '[' + obj.map(friendlyStringify).join(', ') + ']';
	    } else {
	      var pairs = [];
	      for (var key in obj) {
	        if (Object.prototype.hasOwnProperty.call(obj, key)) {
	          var keyEscaped = /^[a-z$_][\w$_]*$/i.test(key) ? key : JSON.stringify(key);
	          pairs.push(keyEscaped + ': ' + friendlyStringify(obj[key]));
	        }
	      }
	      return '{' + pairs.join(', ') + '}';
	    }
	  } else if (typeof obj === 'string') {
	    return JSON.stringify(obj);
	  } else if (typeof obj === 'function') {
	    return '[function object]';
	  }
	  // Differs from JSON.stringify in that undefined because undefined and that
	  // inf and nan don't become null
	  return String(obj);
	}
	
	var styleMutationWarning = {};
	
	function checkAndWarnForMutatedStyle(style1, style2, component) {
	  if (style1 == null || style2 == null) {
	    return;
	  }
	  if (shallowEqual(style1, style2)) {
	    return;
	  }
	
	  var componentName = component._tag;
	  var owner = component._currentElement._owner;
	  var ownerName;
	  if (owner) {
	    ownerName = owner.getName();
	  }
	
	  var hash = ownerName + '|' + componentName;
	
	  if (styleMutationWarning.hasOwnProperty(hash)) {
	    return;
	  }
	
	  styleMutationWarning[hash] = true;
	
	   false ? warning(false, '`%s` was passed a style object that has previously been mutated. ' + 'Mutating `style` is deprecated. Consider cloning it beforehand. Check ' + 'the `render` %s. Previous style: %s. Mutated style: %s.', componentName, owner ? 'of `' + ownerName + '`' : 'using <' + componentName + '>', friendlyStringify(style1), friendlyStringify(style2)) : void 0;
	}
	
	/**
	 * @param {object} component
	 * @param {?object} props
	 */
	function assertValidProps(component, props) {
	  if (!props) {
	    return;
	  }
	  // Note the use of `==` which checks for null or undefined.
	  if (voidElementTags[component._tag]) {
	    !(props.children == null && props.dangerouslySetInnerHTML == null) ?  false ? invariant(false, '%s is a void element tag and must neither have `children` nor use `dangerouslySetInnerHTML`.%s', component._tag, component._currentElement._owner ? ' Check the render method of ' + component._currentElement._owner.getName() + '.' : '') : _prodInvariant('137', component._tag, component._currentElement._owner ? ' Check the render method of ' + component._currentElement._owner.getName() + '.' : '') : void 0;
	  }
	  if (props.dangerouslySetInnerHTML != null) {
	    !(props.children == null) ?  false ? invariant(false, 'Can only set one of `children` or `props.dangerouslySetInnerHTML`.') : _prodInvariant('60') : void 0;
	    !(typeof props.dangerouslySetInnerHTML === 'object' && HTML in props.dangerouslySetInnerHTML) ?  false ? invariant(false, '`props.dangerouslySetInnerHTML` must be in the form `{__html: ...}`. Please visit https://fb.me/react-invariant-dangerously-set-inner-html for more information.') : _prodInvariant('61') : void 0;
	  }
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(props.innerHTML == null, 'Directly setting property `innerHTML` is not permitted. ' + 'For more information, lookup documentation on `dangerouslySetInnerHTML`.') : void 0;
	    process.env.NODE_ENV !== 'production' ? warning(props.suppressContentEditableWarning || !props.contentEditable || props.children == null, 'A component is `contentEditable` and contains `children` managed by ' + 'React. It is now your responsibility to guarantee that none of ' + 'those nodes are unexpectedly modified or duplicated. This is ' + 'probably not intentional.') : void 0;
	    process.env.NODE_ENV !== 'production' ? warning(props.onFocusIn == null && props.onFocusOut == null, 'React uses onFocus and onBlur instead of onFocusIn and onFocusOut. ' + 'All React events are normalized to bubble, so onFocusIn and onFocusOut ' + 'are not needed/supported by React.') : void 0;
	  }
	  !(props.style == null || typeof props.style === 'object') ?  false ? invariant(false, 'The `style` prop expects a mapping from style properties to values, not a string. For example, style={{marginRight: spacing + \'em\'}} when using JSX.%s', getDeclarationErrorAddendum(component)) : _prodInvariant('62', getDeclarationErrorAddendum(component)) : void 0;
	}
	
	function enqueuePutListener(inst, registrationName, listener, transaction) {
	  if (transaction instanceof ReactServerRenderingTransaction) {
	    return;
	  }
	  if (false) {
	    // IE8 has no API for event capturing and the `onScroll` event doesn't
	    // bubble.
	    process.env.NODE_ENV !== 'production' ? warning(registrationName !== 'onScroll' || isEventSupported('scroll', true), 'This browser doesn\'t support the `onScroll` event') : void 0;
	  }
	  var containerInfo = inst._hostContainerInfo;
	  var isDocumentFragment = containerInfo._node && containerInfo._node.nodeType === DOC_FRAGMENT_TYPE;
	  var doc = isDocumentFragment ? containerInfo._node : containerInfo._ownerDocument;
	  listenTo(registrationName, doc);
	  transaction.getReactMountReady().enqueue(putListener, {
	    inst: inst,
	    registrationName: registrationName,
	    listener: listener
	  });
	}
	
	function putListener() {
	  var listenerToPut = this;
	  EventPluginHub.putListener(listenerToPut.inst, listenerToPut.registrationName, listenerToPut.listener);
	}
	
	function inputPostMount() {
	  var inst = this;
	  ReactDOMInput.postMountWrapper(inst);
	}
	
	function textareaPostMount() {
	  var inst = this;
	  ReactDOMTextarea.postMountWrapper(inst);
	}
	
	function optionPostMount() {
	  var inst = this;
	  ReactDOMOption.postMountWrapper(inst);
	}
	
	var setContentChildForInstrumentation = emptyFunction;
	if (false) {
	  setContentChildForInstrumentation = function (content) {
	    var hasExistingContent = this._contentDebugID != null;
	    var debugID = this._debugID;
	    // This ID represents the inlined child that has no backing instance:
	    var contentDebugID = -debugID;
	
	    if (content == null) {
	      if (hasExistingContent) {
	        ReactInstrumentation.debugTool.onUnmountComponent(this._contentDebugID);
	      }
	      this._contentDebugID = null;
	      return;
	    }
	
	    this._contentDebugID = contentDebugID;
	    if (hasExistingContent) {
	      ReactInstrumentation.debugTool.onBeforeUpdateComponent(contentDebugID, content);
	      ReactInstrumentation.debugTool.onUpdateComponent(contentDebugID);
	    } else {
	      ReactInstrumentation.debugTool.onBeforeMountComponent(contentDebugID, content, debugID);
	      ReactInstrumentation.debugTool.onMountComponent(contentDebugID);
	      ReactInstrumentation.debugTool.onSetChildren(debugID, [contentDebugID]);
	    }
	  };
	}
	
	// There are so many media events, it makes sense to just
	// maintain a list rather than create a `trapBubbledEvent` for each
	var mediaEvents = {
	  topAbort: 'abort',
	  topCanPlay: 'canplay',
	  topCanPlayThrough: 'canplaythrough',
	  topDurationChange: 'durationchange',
	  topEmptied: 'emptied',
	  topEncrypted: 'encrypted',
	  topEnded: 'ended',
	  topError: 'error',
	  topLoadedData: 'loadeddata',
	  topLoadedMetadata: 'loadedmetadata',
	  topLoadStart: 'loadstart',
	  topPause: 'pause',
	  topPlay: 'play',
	  topPlaying: 'playing',
	  topProgress: 'progress',
	  topRateChange: 'ratechange',
	  topSeeked: 'seeked',
	  topSeeking: 'seeking',
	  topStalled: 'stalled',
	  topSuspend: 'suspend',
	  topTimeUpdate: 'timeupdate',
	  topVolumeChange: 'volumechange',
	  topWaiting: 'waiting'
	};
	
	function trapBubbledEventsLocal() {
	  var inst = this;
	  // If a component renders to null or if another component fatals and causes
	  // the state of the tree to be corrupted, `node` here can be null.
	  !inst._rootNodeID ?  false ? invariant(false, 'Must be mounted to trap events') : _prodInvariant('63') : void 0;
	  var node = getNode(inst);
	  !node ?  false ? invariant(false, 'trapBubbledEvent(...): Requires node to be rendered.') : _prodInvariant('64') : void 0;
	
	  switch (inst._tag) {
	    case 'iframe':
	    case 'object':
	      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent(EventConstants.topLevelTypes.topLoad, 'load', node)];
	      break;
	    case 'video':
	    case 'audio':
	
	      inst._wrapperState.listeners = [];
	      // Create listener for each media event
	      for (var event in mediaEvents) {
	        if (mediaEvents.hasOwnProperty(event)) {
	          inst._wrapperState.listeners.push(ReactBrowserEventEmitter.trapBubbledEvent(EventConstants.topLevelTypes[event], mediaEvents[event], node));
	        }
	      }
	      break;
	    case 'source':
	      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent(EventConstants.topLevelTypes.topError, 'error', node)];
	      break;
	    case 'img':
	      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent(EventConstants.topLevelTypes.topError, 'error', node), ReactBrowserEventEmitter.trapBubbledEvent(EventConstants.topLevelTypes.topLoad, 'load', node)];
	      break;
	    case 'form':
	      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent(EventConstants.topLevelTypes.topReset, 'reset', node), ReactBrowserEventEmitter.trapBubbledEvent(EventConstants.topLevelTypes.topSubmit, 'submit', node)];
	      break;
	    case 'input':
	    case 'select':
	    case 'textarea':
	      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent(EventConstants.topLevelTypes.topInvalid, 'invalid', node)];
	      break;
	  }
	}
	
	function postUpdateSelectWrapper() {
	  ReactDOMSelect.postUpdateWrapper(this);
	}
	
	// For HTML, certain tags should omit their close tag. We keep a whitelist for
	// those special-case tags.
	
	var omittedCloseTags = {
	  'area': true,
	  'base': true,
	  'br': true,
	  'col': true,
	  'embed': true,
	  'hr': true,
	  'img': true,
	  'input': true,
	  'keygen': true,
	  'link': true,
	  'meta': true,
	  'param': true,
	  'source': true,
	  'track': true,
	  'wbr': true
	};
	
	// NOTE: menuitem's close tag should be omitted, but that causes problems.
	var newlineEatingTags = {
	  'listing': true,
	  'pre': true,
	  'textarea': true
	};
	
	// For HTML, certain tags cannot have children. This has the same purpose as
	// `omittedCloseTags` except that `menuitem` should still have its closing tag.
	
	var voidElementTags = _assign({
	  'menuitem': true
	}, omittedCloseTags);
	
	// We accept any tag to be rendered but since this gets injected into arbitrary
	// HTML, we want to make sure that it's a safe tag.
	// http://www.w3.org/TR/REC-xml/#NT-Name
	
	var VALID_TAG_REGEX = /^[a-zA-Z][a-zA-Z:_\.\-\d]*$/; // Simplified subset
	var validatedTagCache = {};
	var hasOwnProperty = {}.hasOwnProperty;
	
	function validateDangerousTag(tag) {
	  if (!hasOwnProperty.call(validatedTagCache, tag)) {
	    !VALID_TAG_REGEX.test(tag) ?  false ? invariant(false, 'Invalid tag: %s', tag) : _prodInvariant('65', tag) : void 0;
	    validatedTagCache[tag] = true;
	  }
	}
	
	function isCustomComponent(tagName, props) {
	  return tagName.indexOf('-') >= 0 || props.is != null;
	}
	
	var globalIdCounter = 1;
	
	/**
	 * Creates a new React class that is idempotent and capable of containing other
	 * React components. It accepts event listeners and DOM properties that are
	 * valid according to `DOMProperty`.
	 *
	 *  - Event listeners: `onClick`, `onMouseDown`, etc.
	 *  - DOM properties: `className`, `name`, `title`, etc.
	 *
	 * The `style` property functions differently from the DOM API. It accepts an
	 * object mapping of style properties to values.
	 *
	 * @constructor ReactDOMComponent
	 * @extends ReactMultiChild
	 */
	function ReactDOMComponent(element) {
	  var tag = element.type;
	  validateDangerousTag(tag);
	  this._currentElement = element;
	  this._tag = tag.toLowerCase();
	  this._namespaceURI = null;
	  this._renderedChildren = null;
	  this._previousStyle = null;
	  this._previousStyleCopy = null;
	  this._hostNode = null;
	  this._hostParent = null;
	  this._rootNodeID = 0;
	  this._domID = 0;
	  this._hostContainerInfo = null;
	  this._wrapperState = null;
	  this._topLevelWrapper = null;
	  this._flags = 0;
	  if (false) {
	    this._ancestorInfo = null;
	    setContentChildForInstrumentation.call(this, null);
	  }
	}
	
	ReactDOMComponent.displayName = 'ReactDOMComponent';
	
	ReactDOMComponent.Mixin = {
	
	  /**
	   * Generates root tag markup then recurses. This method has side effects and
	   * is not idempotent.
	   *
	   * @internal
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {?ReactDOMComponent} the parent component instance
	   * @param {?object} info about the host container
	   * @param {object} context
	   * @return {string} The computed markup.
	   */
	  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
	    this._rootNodeID = globalIdCounter++;
	    this._domID = hostContainerInfo._idCounter++;
	    this._hostParent = hostParent;
	    this._hostContainerInfo = hostContainerInfo;
	
	    var props = this._currentElement.props;
	
	    switch (this._tag) {
	      case 'audio':
	      case 'form':
	      case 'iframe':
	      case 'img':
	      case 'link':
	      case 'object':
	      case 'source':
	      case 'video':
	        this._wrapperState = {
	          listeners: null
	        };
	        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
	        break;
	      case 'button':
	        props = ReactDOMButton.getHostProps(this, props, hostParent);
	        break;
	      case 'input':
	        ReactDOMInput.mountWrapper(this, props, hostParent);
	        props = ReactDOMInput.getHostProps(this, props);
	        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
	        break;
	      case 'option':
	        ReactDOMOption.mountWrapper(this, props, hostParent);
	        props = ReactDOMOption.getHostProps(this, props);
	        break;
	      case 'select':
	        ReactDOMSelect.mountWrapper(this, props, hostParent);
	        props = ReactDOMSelect.getHostProps(this, props);
	        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
	        break;
	      case 'textarea':
	        ReactDOMTextarea.mountWrapper(this, props, hostParent);
	        props = ReactDOMTextarea.getHostProps(this, props);
	        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
	        break;
	    }
	
	    assertValidProps(this, props);
	
	    // We create tags in the namespace of their parent container, except HTML
	    // tags get no namespace.
	    var namespaceURI;
	    var parentTag;
	    if (hostParent != null) {
	      namespaceURI = hostParent._namespaceURI;
	      parentTag = hostParent._tag;
	    } else if (hostContainerInfo._tag) {
	      namespaceURI = hostContainerInfo._namespaceURI;
	      parentTag = hostContainerInfo._tag;
	    }
	    if (namespaceURI == null || namespaceURI === DOMNamespaces.svg && parentTag === 'foreignobject') {
	      namespaceURI = DOMNamespaces.html;
	    }
	    if (namespaceURI === DOMNamespaces.html) {
	      if (this._tag === 'svg') {
	        namespaceURI = DOMNamespaces.svg;
	      } else if (this._tag === 'math') {
	        namespaceURI = DOMNamespaces.mathml;
	      }
	    }
	    this._namespaceURI = namespaceURI;
	
	    if (false) {
	      var parentInfo;
	      if (hostParent != null) {
	        parentInfo = hostParent._ancestorInfo;
	      } else if (hostContainerInfo._tag) {
	        parentInfo = hostContainerInfo._ancestorInfo;
	      }
	      if (parentInfo) {
	        // parentInfo should always be present except for the top-level
	        // component when server rendering
	        validateDOMNesting(this._tag, this, parentInfo);
	      }
	      this._ancestorInfo = validateDOMNesting.updatedAncestorInfo(parentInfo, this._tag, this);
	    }
	
	    var mountImage;
	    if (transaction.useCreateElement) {
	      var ownerDocument = hostContainerInfo._ownerDocument;
	      var el;
	      if (namespaceURI === DOMNamespaces.html) {
	        if (this._tag === 'script') {
	          // Create the script via .innerHTML so its "parser-inserted" flag is
	          // set to true and it does not execute
	          var div = ownerDocument.createElement('div');
	          var type = this._currentElement.type;
	          div.innerHTML = '<' + type + '></' + type + '>';
	          el = div.removeChild(div.firstChild);
	        } else if (props.is) {
	          el = ownerDocument.createElement(this._currentElement.type, props.is);
	        } else {
	          // Separate else branch instead of using `props.is || undefined` above becuase of a Firefox bug.
	          // See discussion in https://github.com/facebook/react/pull/6896
	          // and discussion in https://bugzilla.mozilla.org/show_bug.cgi?id=1276240
	          el = ownerDocument.createElement(this._currentElement.type);
	        }
	      } else {
	        el = ownerDocument.createElementNS(namespaceURI, this._currentElement.type);
	      }
	      ReactDOMComponentTree.precacheNode(this, el);
	      this._flags |= Flags.hasCachedChildNodes;
	      if (!this._hostParent) {
	        DOMPropertyOperations.setAttributeForRoot(el);
	      }
	      this._updateDOMProperties(null, props, transaction);
	      var lazyTree = DOMLazyTree(el);
	      this._createInitialChildren(transaction, props, context, lazyTree);
	      mountImage = lazyTree;
	    } else {
	      var tagOpen = this._createOpenTagMarkupAndPutListeners(transaction, props);
	      var tagContent = this._createContentMarkup(transaction, props, context);
	      if (!tagContent && omittedCloseTags[this._tag]) {
	        mountImage = tagOpen + '/>';
	      } else {
	        mountImage = tagOpen + '>' + tagContent + '</' + this._currentElement.type + '>';
	      }
	    }
	
	    switch (this._tag) {
	      case 'input':
	        transaction.getReactMountReady().enqueue(inputPostMount, this);
	        if (props.autoFocus) {
	          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
	        }
	        break;
	      case 'textarea':
	        transaction.getReactMountReady().enqueue(textareaPostMount, this);
	        if (props.autoFocus) {
	          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
	        }
	        break;
	      case 'select':
	        if (props.autoFocus) {
	          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
	        }
	        break;
	      case 'button':
	        if (props.autoFocus) {
	          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
	        }
	        break;
	      case 'option':
	        transaction.getReactMountReady().enqueue(optionPostMount, this);
	        break;
	    }
	
	    return mountImage;
	  },
	
	  /**
	   * Creates markup for the open tag and all attributes.
	   *
	   * This method has side effects because events get registered.
	   *
	   * Iterating over object properties is faster than iterating over arrays.
	   * @see http://jsperf.com/obj-vs-arr-iteration
	   *
	   * @private
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {object} props
	   * @return {string} Markup of opening tag.
	   */
	  _createOpenTagMarkupAndPutListeners: function (transaction, props) {
	    var ret = '<' + this._currentElement.type;
	
	    for (var propKey in props) {
	      if (!props.hasOwnProperty(propKey)) {
	        continue;
	      }
	      var propValue = props[propKey];
	      if (propValue == null) {
	        continue;
	      }
	      if (registrationNameModules.hasOwnProperty(propKey)) {
	        if (propValue) {
	          enqueuePutListener(this, propKey, propValue, transaction);
	        }
	      } else {
	        if (propKey === STYLE) {
	          if (propValue) {
	            if (false) {
	              // See `_updateDOMProperties`. style block
	              this._previousStyle = propValue;
	            }
	            propValue = this._previousStyleCopy = _assign({}, props.style);
	          }
	          propValue = CSSPropertyOperations.createMarkupForStyles(propValue, this);
	        }
	        var markup = null;
	        if (this._tag != null && isCustomComponent(this._tag, props)) {
	          if (!RESERVED_PROPS.hasOwnProperty(propKey)) {
	            markup = DOMPropertyOperations.createMarkupForCustomAttribute(propKey, propValue);
	          }
	        } else {
	          markup = DOMPropertyOperations.createMarkupForProperty(propKey, propValue);
	        }
	        if (markup) {
	          ret += ' ' + markup;
	        }
	      }
	    }
	
	    // For static pages, no need to put React ID and checksum. Saves lots of
	    // bytes.
	    if (transaction.renderToStaticMarkup) {
	      return ret;
	    }
	
	    if (!this._hostParent) {
	      ret += ' ' + DOMPropertyOperations.createMarkupForRoot();
	    }
	    ret += ' ' + DOMPropertyOperations.createMarkupForID(this._domID);
	    return ret;
	  },
	
	  /**
	   * Creates markup for the content between the tags.
	   *
	   * @private
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {object} props
	   * @param {object} context
	   * @return {string} Content markup.
	   */
	  _createContentMarkup: function (transaction, props, context) {
	    var ret = '';
	
	    // Intentional use of != to avoid catching zero/false.
	    var innerHTML = props.dangerouslySetInnerHTML;
	    if (innerHTML != null) {
	      if (innerHTML.__html != null) {
	        ret = innerHTML.__html;
	      }
	    } else {
	      var contentToUse = CONTENT_TYPES[typeof props.children] ? props.children : null;
	      var childrenToUse = contentToUse != null ? null : props.children;
	      if (contentToUse != null) {
	        // TODO: Validate that text is allowed as a child of this node
	        ret = escapeTextContentForBrowser(contentToUse);
	        if (false) {
	          setContentChildForInstrumentation.call(this, contentToUse);
	        }
	      } else if (childrenToUse != null) {
	        var mountImages = this.mountChildren(childrenToUse, transaction, context);
	        ret = mountImages.join('');
	      }
	    }
	    if (newlineEatingTags[this._tag] && ret.charAt(0) === '\n') {
	      // text/html ignores the first character in these tags if it's a newline
	      // Prefer to break application/xml over text/html (for now) by adding
	      // a newline specifically to get eaten by the parser. (Alternately for
	      // textareas, replacing "^\n" with "\r\n" doesn't get eaten, and the first
	      // \r is normalized out by HTMLTextAreaElement#value.)
	      // See: <http://www.w3.org/TR/html-polyglot/#newlines-in-textarea-and-pre>
	      // See: <http://www.w3.org/TR/html5/syntax.html#element-restrictions>
	      // See: <http://www.w3.org/TR/html5/syntax.html#newlines>
	      // See: Parsing of "textarea" "listing" and "pre" elements
	      //  from <http://www.w3.org/TR/html5/syntax.html#parsing-main-inbody>
	      return '\n' + ret;
	    } else {
	      return ret;
	    }
	  },
	
	  _createInitialChildren: function (transaction, props, context, lazyTree) {
	    // Intentional use of != to avoid catching zero/false.
	    var innerHTML = props.dangerouslySetInnerHTML;
	    if (innerHTML != null) {
	      if (innerHTML.__html != null) {
	        DOMLazyTree.queueHTML(lazyTree, innerHTML.__html);
	      }
	    } else {
	      var contentToUse = CONTENT_TYPES[typeof props.children] ? props.children : null;
	      var childrenToUse = contentToUse != null ? null : props.children;
	      if (contentToUse != null) {
	        // TODO: Validate that text is allowed as a child of this node
	        if (false) {
	          setContentChildForInstrumentation.call(this, contentToUse);
	        }
	        DOMLazyTree.queueText(lazyTree, contentToUse);
	      } else if (childrenToUse != null) {
	        var mountImages = this.mountChildren(childrenToUse, transaction, context);
	        for (var i = 0; i < mountImages.length; i++) {
	          DOMLazyTree.queueChild(lazyTree, mountImages[i]);
	        }
	      }
	    }
	  },
	
	  /**
	   * Receives a next element and updates the component.
	   *
	   * @internal
	   * @param {ReactElement} nextElement
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {object} context
	   */
	  receiveComponent: function (nextElement, transaction, context) {
	    var prevElement = this._currentElement;
	    this._currentElement = nextElement;
	    this.updateComponent(transaction, prevElement, nextElement, context);
	  },
	
	  /**
	   * Updates a DOM component after it has already been allocated and
	   * attached to the DOM. Reconciles the root DOM node, then recurses.
	   *
	   * @param {ReactReconcileTransaction} transaction
	   * @param {ReactElement} prevElement
	   * @param {ReactElement} nextElement
	   * @internal
	   * @overridable
	   */
	  updateComponent: function (transaction, prevElement, nextElement, context) {
	    var lastProps = prevElement.props;
	    var nextProps = this._currentElement.props;
	
	    switch (this._tag) {
	      case 'button':
	        lastProps = ReactDOMButton.getHostProps(this, lastProps);
	        nextProps = ReactDOMButton.getHostProps(this, nextProps);
	        break;
	      case 'input':
	        lastProps = ReactDOMInput.getHostProps(this, lastProps);
	        nextProps = ReactDOMInput.getHostProps(this, nextProps);
	        break;
	      case 'option':
	        lastProps = ReactDOMOption.getHostProps(this, lastProps);
	        nextProps = ReactDOMOption.getHostProps(this, nextProps);
	        break;
	      case 'select':
	        lastProps = ReactDOMSelect.getHostProps(this, lastProps);
	        nextProps = ReactDOMSelect.getHostProps(this, nextProps);
	        break;
	      case 'textarea':
	        lastProps = ReactDOMTextarea.getHostProps(this, lastProps);
	        nextProps = ReactDOMTextarea.getHostProps(this, nextProps);
	        break;
	    }
	
	    assertValidProps(this, nextProps);
	    this._updateDOMProperties(lastProps, nextProps, transaction);
	    this._updateDOMChildren(lastProps, nextProps, transaction, context);
	
	    switch (this._tag) {
	      case 'input':
	        // Update the wrapper around inputs *after* updating props. This has to
	        // happen after `_updateDOMProperties`. Otherwise HTML5 input validations
	        // raise warnings and prevent the new value from being assigned.
	        ReactDOMInput.updateWrapper(this);
	        break;
	      case 'textarea':
	        ReactDOMTextarea.updateWrapper(this);
	        break;
	      case 'select':
	        // <select> value update needs to occur after <option> children
	        // reconciliation
	        transaction.getReactMountReady().enqueue(postUpdateSelectWrapper, this);
	        break;
	    }
	  },
	
	  /**
	   * Reconciles the properties by detecting differences in property values and
	   * updating the DOM as necessary. This function is probably the single most
	   * critical path for performance optimization.
	   *
	   * TODO: Benchmark whether checking for changed values in memory actually
	   *       improves performance (especially statically positioned elements).
	   * TODO: Benchmark the effects of putting this at the top since 99% of props
	   *       do not change for a given reconciliation.
	   * TODO: Benchmark areas that can be improved with caching.
	   *
	   * @private
	   * @param {object} lastProps
	   * @param {object} nextProps
	   * @param {?DOMElement} node
	   */
	  _updateDOMProperties: function (lastProps, nextProps, transaction) {
	    var propKey;
	    var styleName;
	    var styleUpdates;
	    for (propKey in lastProps) {
	      if (nextProps.hasOwnProperty(propKey) || !lastProps.hasOwnProperty(propKey) || lastProps[propKey] == null) {
	        continue;
	      }
	      if (propKey === STYLE) {
	        var lastStyle = this._previousStyleCopy;
	        for (styleName in lastStyle) {
	          if (lastStyle.hasOwnProperty(styleName)) {
	            styleUpdates = styleUpdates || {};
	            styleUpdates[styleName] = '';
	          }
	        }
	        this._previousStyleCopy = null;
	      } else if (registrationNameModules.hasOwnProperty(propKey)) {
	        if (lastProps[propKey]) {
	          // Only call deleteListener if there was a listener previously or
	          // else willDeleteListener gets called when there wasn't actually a
	          // listener (e.g., onClick={null})
	          deleteListener(this, propKey);
	        }
	      } else if (isCustomComponent(this._tag, lastProps)) {
	        if (!RESERVED_PROPS.hasOwnProperty(propKey)) {
	          DOMPropertyOperations.deleteValueForAttribute(getNode(this), propKey);
	        }
	      } else if (DOMProperty.properties[propKey] || DOMProperty.isCustomAttribute(propKey)) {
	        DOMPropertyOperations.deleteValueForProperty(getNode(this), propKey);
	      }
	    }
	    for (propKey in nextProps) {
	      var nextProp = nextProps[propKey];
	      var lastProp = propKey === STYLE ? this._previousStyleCopy : lastProps != null ? lastProps[propKey] : undefined;
	      if (!nextProps.hasOwnProperty(propKey) || nextProp === lastProp || nextProp == null && lastProp == null) {
	        continue;
	      }
	      if (propKey === STYLE) {
	        if (nextProp) {
	          if (false) {
	            checkAndWarnForMutatedStyle(this._previousStyleCopy, this._previousStyle, this);
	            this._previousStyle = nextProp;
	          }
	          nextProp = this._previousStyleCopy = _assign({}, nextProp);
	        } else {
	          this._previousStyleCopy = null;
	        }
	        if (lastProp) {
	          // Unset styles on `lastProp` but not on `nextProp`.
	          for (styleName in lastProp) {
	            if (lastProp.hasOwnProperty(styleName) && (!nextProp || !nextProp.hasOwnProperty(styleName))) {
	              styleUpdates = styleUpdates || {};
	              styleUpdates[styleName] = '';
	            }
	          }
	          // Update styles that changed since `lastProp`.
	          for (styleName in nextProp) {
	            if (nextProp.hasOwnProperty(styleName) && lastProp[styleName] !== nextProp[styleName]) {
	              styleUpdates = styleUpdates || {};
	              styleUpdates[styleName] = nextProp[styleName];
	            }
	          }
	        } else {
	          // Relies on `updateStylesByID` not mutating `styleUpdates`.
	          styleUpdates = nextProp;
	        }
	      } else if (registrationNameModules.hasOwnProperty(propKey)) {
	        if (nextProp) {
	          enqueuePutListener(this, propKey, nextProp, transaction);
	        } else if (lastProp) {
	          deleteListener(this, propKey);
	        }
	      } else if (isCustomComponent(this._tag, nextProps)) {
	        if (!RESERVED_PROPS.hasOwnProperty(propKey)) {
	          DOMPropertyOperations.setValueForAttribute(getNode(this), propKey, nextProp);
	        }
	      } else if (DOMProperty.properties[propKey] || DOMProperty.isCustomAttribute(propKey)) {
	        var node = getNode(this);
	        // If we're updating to null or undefined, we should remove the property
	        // from the DOM node instead of inadvertently setting to a string. This
	        // brings us in line with the same behavior we have on initial render.
	        if (nextProp != null) {
	          DOMPropertyOperations.setValueForProperty(node, propKey, nextProp);
	        } else {
	          DOMPropertyOperations.deleteValueForProperty(node, propKey);
	        }
	      }
	    }
	    if (styleUpdates) {
	      CSSPropertyOperations.setValueForStyles(getNode(this), styleUpdates, this);
	    }
	  },
	
	  /**
	   * Reconciles the children with the various properties that affect the
	   * children content.
	   *
	   * @param {object} lastProps
	   * @param {object} nextProps
	   * @param {ReactReconcileTransaction} transaction
	   * @param {object} context
	   */
	  _updateDOMChildren: function (lastProps, nextProps, transaction, context) {
	    var lastContent = CONTENT_TYPES[typeof lastProps.children] ? lastProps.children : null;
	    var nextContent = CONTENT_TYPES[typeof nextProps.children] ? nextProps.children : null;
	
	    var lastHtml = lastProps.dangerouslySetInnerHTML && lastProps.dangerouslySetInnerHTML.__html;
	    var nextHtml = nextProps.dangerouslySetInnerHTML && nextProps.dangerouslySetInnerHTML.__html;
	
	    // Note the use of `!=` which checks for null or undefined.
	    var lastChildren = lastContent != null ? null : lastProps.children;
	    var nextChildren = nextContent != null ? null : nextProps.children;
	
	    // If we're switching from children to content/html or vice versa, remove
	    // the old content
	    var lastHasContentOrHtml = lastContent != null || lastHtml != null;
	    var nextHasContentOrHtml = nextContent != null || nextHtml != null;
	    if (lastChildren != null && nextChildren == null) {
	      this.updateChildren(null, transaction, context);
	    } else if (lastHasContentOrHtml && !nextHasContentOrHtml) {
	      this.updateTextContent('');
	      if (false) {
	        ReactInstrumentation.debugTool.onSetChildren(this._debugID, []);
	      }
	    }
	
	    if (nextContent != null) {
	      if (lastContent !== nextContent) {
	        this.updateTextContent('' + nextContent);
	        if (false) {
	          setContentChildForInstrumentation.call(this, nextContent);
	        }
	      }
	    } else if (nextHtml != null) {
	      if (lastHtml !== nextHtml) {
	        this.updateMarkup('' + nextHtml);
	      }
	      if (false) {
	        ReactInstrumentation.debugTool.onSetChildren(this._debugID, []);
	      }
	    } else if (nextChildren != null) {
	      if (false) {
	        setContentChildForInstrumentation.call(this, null);
	      }
	
	      this.updateChildren(nextChildren, transaction, context);
	    }
	  },
	
	  getHostNode: function () {
	    return getNode(this);
	  },
	
	  /**
	   * Destroys all event registrations for this instance. Does not remove from
	   * the DOM. That must be done by the parent.
	   *
	   * @internal
	   */
	  unmountComponent: function (safely) {
	    switch (this._tag) {
	      case 'audio':
	      case 'form':
	      case 'iframe':
	      case 'img':
	      case 'link':
	      case 'object':
	      case 'source':
	      case 'video':
	        var listeners = this._wrapperState.listeners;
	        if (listeners) {
	          for (var i = 0; i < listeners.length; i++) {
	            listeners[i].remove();
	          }
	        }
	        break;
	      case 'html':
	      case 'head':
	      case 'body':
	        /**
	         * Components like <html> <head> and <body> can't be removed or added
	         * easily in a cross-browser way, however it's valuable to be able to
	         * take advantage of React's reconciliation for styling and <title>
	         * management. So we just document it and throw in dangerous cases.
	         */
	         true ?  false ? invariant(false, '<%s> tried to unmount. Because of cross-browser quirks it is impossible to unmount some top-level components (eg <html>, <head>, and <body>) reliably and efficiently. To fix this, have a single top-level component that never unmounts render these elements.', this._tag) : _prodInvariant('66', this._tag) : void 0;
	        break;
	    }
	
	    this.unmountChildren(safely);
	    ReactDOMComponentTree.uncacheNode(this);
	    EventPluginHub.deleteAllListeners(this);
	    this._rootNodeID = 0;
	    this._domID = 0;
	    this._wrapperState = null;
	
	    if (false) {
	      setContentChildForInstrumentation.call(this, null);
	    }
	  },
	
	  getPublicInstance: function () {
	    return getNode(this);
	  }
	
	};
	
	_assign(ReactDOMComponent.prototype, ReactDOMComponent.Mixin, ReactMultiChild.Mixin);
	
	module.exports = ReactDOMComponent;

/***/ },
/* 321 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDOMContainerInfo
	 */
	
	'use strict';
	
	var validateDOMNesting = __webpack_require__(74);
	
	var DOC_NODE_TYPE = 9;
	
	function ReactDOMContainerInfo(topLevelWrapper, node) {
	  var info = {
	    _topLevelWrapper: topLevelWrapper,
	    _idCounter: 1,
	    _ownerDocument: node ? node.nodeType === DOC_NODE_TYPE ? node : node.ownerDocument : null,
	    _node: node,
	    _tag: node ? node.nodeName.toLowerCase() : null,
	    _namespaceURI: node ? node.namespaceURI : null
	  };
	  if (false) {
	    info._ancestorInfo = node ? validateDOMNesting.updatedAncestorInfo(null, info._tag, null) : null;
	  }
	  return info;
	}
	
	module.exports = ReactDOMContainerInfo;

/***/ },
/* 322 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDOMEmptyComponent
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(6);
	
	var DOMLazyTree = __webpack_require__(26);
	var ReactDOMComponentTree = __webpack_require__(8);
	
	var ReactDOMEmptyComponent = function (instantiate) {
	  // ReactCompositeComponent uses this:
	  this._currentElement = null;
	  // ReactDOMComponentTree uses these:
	  this._hostNode = null;
	  this._hostParent = null;
	  this._hostContainerInfo = null;
	  this._domID = 0;
	};
	_assign(ReactDOMEmptyComponent.prototype, {
	  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
	    var domID = hostContainerInfo._idCounter++;
	    this._domID = domID;
	    this._hostParent = hostParent;
	    this._hostContainerInfo = hostContainerInfo;
	
	    var nodeValue = ' react-empty: ' + this._domID + ' ';
	    if (transaction.useCreateElement) {
	      var ownerDocument = hostContainerInfo._ownerDocument;
	      var node = ownerDocument.createComment(nodeValue);
	      ReactDOMComponentTree.precacheNode(this, node);
	      return DOMLazyTree(node);
	    } else {
	      if (transaction.renderToStaticMarkup) {
	        // Normally we'd insert a comment node, but since this is a situation
	        // where React won't take over (static pages), we can simply return
	        // nothing.
	        return '';
	      }
	      return '<!--' + nodeValue + '-->';
	    }
	  },
	  receiveComponent: function () {},
	  getHostNode: function () {
	    return ReactDOMComponentTree.getNodeFromInstance(this);
	  },
	  unmountComponent: function () {
	    ReactDOMComponentTree.uncacheNode(this);
	  }
	});
	
	module.exports = ReactDOMEmptyComponent;

/***/ },
/* 323 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDOMFactories
	 */
	
	'use strict';
	
	var ReactElement = __webpack_require__(13);
	
	/**
	 * Create a factory that creates HTML tag elements.
	 *
	 * @private
	 */
	var createDOMFactory = ReactElement.createFactory;
	if (false) {
	  var ReactElementValidator = require('./ReactElementValidator');
	  createDOMFactory = ReactElementValidator.createFactory;
	}
	
	/**
	 * Creates a mapping from supported HTML tags to `ReactDOMComponent` classes.
	 * This is also accessible via `React.DOM`.
	 *
	 * @public
	 */
	var ReactDOMFactories = {
	  a: createDOMFactory('a'),
	  abbr: createDOMFactory('abbr'),
	  address: createDOMFactory('address'),
	  area: createDOMFactory('area'),
	  article: createDOMFactory('article'),
	  aside: createDOMFactory('aside'),
	  audio: createDOMFactory('audio'),
	  b: createDOMFactory('b'),
	  base: createDOMFactory('base'),
	  bdi: createDOMFactory('bdi'),
	  bdo: createDOMFactory('bdo'),
	  big: createDOMFactory('big'),
	  blockquote: createDOMFactory('blockquote'),
	  body: createDOMFactory('body'),
	  br: createDOMFactory('br'),
	  button: createDOMFactory('button'),
	  canvas: createDOMFactory('canvas'),
	  caption: createDOMFactory('caption'),
	  cite: createDOMFactory('cite'),
	  code: createDOMFactory('code'),
	  col: createDOMFactory('col'),
	  colgroup: createDOMFactory('colgroup'),
	  data: createDOMFactory('data'),
	  datalist: createDOMFactory('datalist'),
	  dd: createDOMFactory('dd'),
	  del: createDOMFactory('del'),
	  details: createDOMFactory('details'),
	  dfn: createDOMFactory('dfn'),
	  dialog: createDOMFactory('dialog'),
	  div: createDOMFactory('div'),
	  dl: createDOMFactory('dl'),
	  dt: createDOMFactory('dt'),
	  em: createDOMFactory('em'),
	  embed: createDOMFactory('embed'),
	  fieldset: createDOMFactory('fieldset'),
	  figcaption: createDOMFactory('figcaption'),
	  figure: createDOMFactory('figure'),
	  footer: createDOMFactory('footer'),
	  form: createDOMFactory('form'),
	  h1: createDOMFactory('h1'),
	  h2: createDOMFactory('h2'),
	  h3: createDOMFactory('h3'),
	  h4: createDOMFactory('h4'),
	  h5: createDOMFactory('h5'),
	  h6: createDOMFactory('h6'),
	  head: createDOMFactory('head'),
	  header: createDOMFactory('header'),
	  hgroup: createDOMFactory('hgroup'),
	  hr: createDOMFactory('hr'),
	  html: createDOMFactory('html'),
	  i: createDOMFactory('i'),
	  iframe: createDOMFactory('iframe'),
	  img: createDOMFactory('img'),
	  input: createDOMFactory('input'),
	  ins: createDOMFactory('ins'),
	  kbd: createDOMFactory('kbd'),
	  keygen: createDOMFactory('keygen'),
	  label: createDOMFactory('label'),
	  legend: createDOMFactory('legend'),
	  li: createDOMFactory('li'),
	  link: createDOMFactory('link'),
	  main: createDOMFactory('main'),
	  map: createDOMFactory('map'),
	  mark: createDOMFactory('mark'),
	  menu: createDOMFactory('menu'),
	  menuitem: createDOMFactory('menuitem'),
	  meta: createDOMFactory('meta'),
	  meter: createDOMFactory('meter'),
	  nav: createDOMFactory('nav'),
	  noscript: createDOMFactory('noscript'),
	  object: createDOMFactory('object'),
	  ol: createDOMFactory('ol'),
	  optgroup: createDOMFactory('optgroup'),
	  option: createDOMFactory('option'),
	  output: createDOMFactory('output'),
	  p: createDOMFactory('p'),
	  param: createDOMFactory('param'),
	  picture: createDOMFactory('picture'),
	  pre: createDOMFactory('pre'),
	  progress: createDOMFactory('progress'),
	  q: createDOMFactory('q'),
	  rp: createDOMFactory('rp'),
	  rt: createDOMFactory('rt'),
	  ruby: createDOMFactory('ruby'),
	  s: createDOMFactory('s'),
	  samp: createDOMFactory('samp'),
	  script: createDOMFactory('script'),
	  section: createDOMFactory('section'),
	  select: createDOMFactory('select'),
	  small: createDOMFactory('small'),
	  source: createDOMFactory('source'),
	  span: createDOMFactory('span'),
	  strong: createDOMFactory('strong'),
	  style: createDOMFactory('style'),
	  sub: createDOMFactory('sub'),
	  summary: createDOMFactory('summary'),
	  sup: createDOMFactory('sup'),
	  table: createDOMFactory('table'),
	  tbody: createDOMFactory('tbody'),
	  td: createDOMFactory('td'),
	  textarea: createDOMFactory('textarea'),
	  tfoot: createDOMFactory('tfoot'),
	  th: createDOMFactory('th'),
	  thead: createDOMFactory('thead'),
	  time: createDOMFactory('time'),
	  title: createDOMFactory('title'),
	  tr: createDOMFactory('tr'),
	  track: createDOMFactory('track'),
	  u: createDOMFactory('u'),
	  ul: createDOMFactory('ul'),
	  'var': createDOMFactory('var'),
	  video: createDOMFactory('video'),
	  wbr: createDOMFactory('wbr'),
	
	  // SVG
	  circle: createDOMFactory('circle'),
	  clipPath: createDOMFactory('clipPath'),
	  defs: createDOMFactory('defs'),
	  ellipse: createDOMFactory('ellipse'),
	  g: createDOMFactory('g'),
	  image: createDOMFactory('image'),
	  line: createDOMFactory('line'),
	  linearGradient: createDOMFactory('linearGradient'),
	  mask: createDOMFactory('mask'),
	  path: createDOMFactory('path'),
	  pattern: createDOMFactory('pattern'),
	  polygon: createDOMFactory('polygon'),
	  polyline: createDOMFactory('polyline'),
	  radialGradient: createDOMFactory('radialGradient'),
	  rect: createDOMFactory('rect'),
	  stop: createDOMFactory('stop'),
	  svg: createDOMFactory('svg'),
	  text: createDOMFactory('text'),
	  tspan: createDOMFactory('tspan')
	};
	
	module.exports = ReactDOMFactories;

/***/ },
/* 324 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDOMFeatureFlags
	 */
	
	'use strict';
	
	var ReactDOMFeatureFlags = {
	  useCreateElement: true
	};
	
	module.exports = ReactDOMFeatureFlags;

/***/ },
/* 325 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDOMIDOperations
	 */
	
	'use strict';
	
	var DOMChildrenOperations = __webpack_require__(52);
	var ReactDOMComponentTree = __webpack_require__(8);
	
	/**
	 * Operations used to process updates to DOM nodes.
	 */
	var ReactDOMIDOperations = {
	
	  /**
	   * Updates a component's children by processing a series of updates.
	   *
	   * @param {array<object>} updates List of update configurations.
	   * @internal
	   */
	  dangerouslyProcessChildrenUpdates: function (parentInst, updates) {
	    var node = ReactDOMComponentTree.getNodeFromInstance(parentInst);
	    DOMChildrenOperations.processUpdates(node, updates);
	  }
	};
	
	module.exports = ReactDOMIDOperations;

/***/ },
/* 326 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDOMInput
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(3),
	    _assign = __webpack_require__(6);
	
	var DisabledInputUtils = __webpack_require__(42);
	var DOMPropertyOperations = __webpack_require__(104);
	var LinkedValueUtils = __webpack_require__(57);
	var ReactDOMComponentTree = __webpack_require__(8);
	var ReactUpdates = __webpack_require__(14);
	
	var invariant = __webpack_require__(2);
	var warning = __webpack_require__(4);
	
	var didWarnValueLink = false;
	var didWarnCheckedLink = false;
	var didWarnValueDefaultValue = false;
	var didWarnCheckedDefaultChecked = false;
	var didWarnControlledToUncontrolled = false;
	var didWarnUncontrolledToControlled = false;
	
	function forceUpdateIfMounted() {
	  if (this._rootNodeID) {
	    // DOM component is still mounted; update
	    ReactDOMInput.updateWrapper(this);
	  }
	}
	
	function isControlled(props) {
	  var usesChecked = props.type === 'checkbox' || props.type === 'radio';
	  return usesChecked ? props.checked !== undefined : props.value !== undefined;
	}
	
	/**
	 * Implements an <input> host component that allows setting these optional
	 * props: `checked`, `value`, `defaultChecked`, and `defaultValue`.
	 *
	 * If `checked` or `value` are not supplied (or null/undefined), user actions
	 * that affect the checked state or value will trigger updates to the element.
	 *
	 * If they are supplied (and not null/undefined), the rendered element will not
	 * trigger updates to the element. Instead, the props must change in order for
	 * the rendered element to be updated.
	 *
	 * The rendered element will be initialized as unchecked (or `defaultChecked`)
	 * with an empty value (or `defaultValue`).
	 *
	 * @see http://www.w3.org/TR/2012/WD-html5-20121025/the-input-element.html
	 */
	var ReactDOMInput = {
	  getHostProps: function (inst, props) {
	    var value = LinkedValueUtils.getValue(props);
	    var checked = LinkedValueUtils.getChecked(props);
	
	    var hostProps = _assign({
	      // Make sure we set .type before any other properties (setting .value
	      // before .type means .value is lost in IE11 and below)
	      type: undefined,
	      // Make sure we set .step before .value (setting .value before .step
	      // means .value is rounded on mount, based upon step precision)
	      step: undefined,
	      // Make sure we set .min & .max before .value (to ensure proper order
	      // in corner cases such as min or max deriving from value, e.g. Issue #7170)
	      min: undefined,
	      max: undefined
	    }, DisabledInputUtils.getHostProps(inst, props), {
	      defaultChecked: undefined,
	      defaultValue: undefined,
	      value: value != null ? value : inst._wrapperState.initialValue,
	      checked: checked != null ? checked : inst._wrapperState.initialChecked,
	      onChange: inst._wrapperState.onChange
	    });
	
	    return hostProps;
	  },
	
	  mountWrapper: function (inst, props) {
	    if (false) {
	      LinkedValueUtils.checkPropTypes('input', props, inst._currentElement._owner);
	
	      var owner = inst._currentElement._owner;
	
	      if (props.valueLink !== undefined && !didWarnValueLink) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '`valueLink` prop on `input` is deprecated; set `value` and `onChange` instead.') : void 0;
	        didWarnValueLink = true;
	      }
	      if (props.checkedLink !== undefined && !didWarnCheckedLink) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '`checkedLink` prop on `input` is deprecated; set `value` and `onChange` instead.') : void 0;
	        didWarnCheckedLink = true;
	      }
	      if (props.checked !== undefined && props.defaultChecked !== undefined && !didWarnCheckedDefaultChecked) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '%s contains an input of type %s with both checked and defaultChecked props. ' + 'Input elements must be either controlled or uncontrolled ' + '(specify either the checked prop, or the defaultChecked prop, but not ' + 'both). Decide between using a controlled or uncontrolled input ' + 'element and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
	        didWarnCheckedDefaultChecked = true;
	      }
	      if (props.value !== undefined && props.defaultValue !== undefined && !didWarnValueDefaultValue) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '%s contains an input of type %s with both value and defaultValue props. ' + 'Input elements must be either controlled or uncontrolled ' + '(specify either the value prop, or the defaultValue prop, but not ' + 'both). Decide between using a controlled or uncontrolled input ' + 'element and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
	        didWarnValueDefaultValue = true;
	      }
	    }
	
	    var defaultValue = props.defaultValue;
	    inst._wrapperState = {
	      initialChecked: props.checked != null ? props.checked : props.defaultChecked,
	      initialValue: props.value != null ? props.value : defaultValue,
	      listeners: null,
	      onChange: _handleChange.bind(inst)
	    };
	
	    if (false) {
	      inst._wrapperState.controlled = isControlled(props);
	    }
	  },
	
	  updateWrapper: function (inst) {
	    var props = inst._currentElement.props;
	
	    if (false) {
	      var controlled = isControlled(props);
	      var owner = inst._currentElement._owner;
	
	      if (!inst._wrapperState.controlled && controlled && !didWarnUncontrolledToControlled) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '%s is changing an uncontrolled input of type %s to be controlled. ' + 'Input elements should not switch from uncontrolled to controlled (or vice versa). ' + 'Decide between using a controlled or uncontrolled input ' + 'element for the lifetime of the component. More info: https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
	        didWarnUncontrolledToControlled = true;
	      }
	      if (inst._wrapperState.controlled && !controlled && !didWarnControlledToUncontrolled) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '%s is changing a controlled input of type %s to be uncontrolled. ' + 'Input elements should not switch from controlled to uncontrolled (or vice versa). ' + 'Decide between using a controlled or uncontrolled input ' + 'element for the lifetime of the component. More info: https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
	        didWarnControlledToUncontrolled = true;
	      }
	    }
	
	    // TODO: Shouldn't this be getChecked(props)?
	    var checked = props.checked;
	    if (checked != null) {
	      DOMPropertyOperations.setValueForProperty(ReactDOMComponentTree.getNodeFromInstance(inst), 'checked', checked || false);
	    }
	
	    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	    var value = LinkedValueUtils.getValue(props);
	    if (value != null) {
	
	      // Cast `value` to a string to ensure the value is set correctly. While
	      // browsers typically do this as necessary, jsdom doesn't.
	      var newValue = '' + value;
	
	      // To avoid side effects (such as losing text selection), only set value if changed
	      if (newValue !== node.value) {
	        node.value = newValue;
	      }
	    } else {
	      if (props.value == null && props.defaultValue != null) {
	        node.defaultValue = '' + props.defaultValue;
	      }
	      if (props.checked == null && props.defaultChecked != null) {
	        node.defaultChecked = !!props.defaultChecked;
	      }
	    }
	  },
	
	  postMountWrapper: function (inst) {
	    var props = inst._currentElement.props;
	
	    // This is in postMount because we need access to the DOM node, which is not
	    // available until after the component has mounted.
	    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	
	    // Detach value from defaultValue. We won't do anything if we're working on
	    // submit or reset inputs as those values & defaultValues are linked. They
	    // are not resetable nodes so this operation doesn't matter and actually
	    // removes browser-default values (eg "Submit Query") when no value is
	    // provided.
	
	    switch (props.type) {
	      case 'submit':
	      case 'reset':
	        break;
	      case 'color':
	      case 'date':
	      case 'datetime':
	      case 'datetime-local':
	      case 'month':
	      case 'time':
	      case 'week':
	        // This fixes the no-show issue on iOS Safari and Android Chrome:
	        // https://github.com/facebook/react/issues/7233
	        node.value = '';
	        node.value = node.defaultValue;
	        break;
	      default:
	        node.value = node.value;
	        break;
	    }
	
	    // Normally, we'd just do `node.checked = node.checked` upon initial mount, less this bug
	    // this is needed to work around a chrome bug where setting defaultChecked
	    // will sometimes influence the value of checked (even after detachment).
	    // Reference: https://bugs.chromium.org/p/chromium/issues/detail?id=608416
	    // We need to temporarily unset name to avoid disrupting radio button groups.
	    var name = node.name;
	    if (name !== '') {
	      node.name = '';
	    }
	    node.defaultChecked = !node.defaultChecked;
	    node.defaultChecked = !node.defaultChecked;
	    if (name !== '') {
	      node.name = name;
	    }
	  }
	};
	
	function _handleChange(event) {
	  var props = this._currentElement.props;
	
	  var returnValue = LinkedValueUtils.executeOnChange(props, event);
	
	  // Here we use asap to wait until all updates have propagated, which
	  // is important when using controlled components within layers:
	  // https://github.com/facebook/react/issues/1698
	  ReactUpdates.asap(forceUpdateIfMounted, this);
	
	  var name = props.name;
	  if (props.type === 'radio' && name != null) {
	    var rootNode = ReactDOMComponentTree.getNodeFromInstance(this);
	    var queryRoot = rootNode;
	
	    while (queryRoot.parentNode) {
	      queryRoot = queryRoot.parentNode;
	    }
	
	    // If `rootNode.form` was non-null, then we could try `form.elements`,
	    // but that sometimes behaves strangely in IE8. We could also try using
	    // `form.getElementsByName`, but that will only return direct children
	    // and won't include inputs that use the HTML5 `form=` attribute. Since
	    // the input might not even be in a form, let's just use the global
	    // `querySelectorAll` to ensure we don't miss anything.
	    var group = queryRoot.querySelectorAll('input[name=' + JSON.stringify('' + name) + '][type="radio"]');
	
	    for (var i = 0; i < group.length; i++) {
	      var otherNode = group[i];
	      if (otherNode === rootNode || otherNode.form !== rootNode.form) {
	        continue;
	      }
	      // This will throw if radio buttons rendered by different copies of React
	      // and the same name are rendered into the same form (same as #1939).
	      // That's probably okay; we don't support it just as we don't support
	      // mixing React radio buttons with non-React ones.
	      var otherInstance = ReactDOMComponentTree.getInstanceFromNode(otherNode);
	      !otherInstance ?  false ? invariant(false, 'ReactDOMInput: Mixing React and non-React radio inputs with the same `name` is not supported.') : _prodInvariant('90') : void 0;
	      // If this is a controlled radio button group, forcing the input that
	      // was previously checked to update will cause it to be come re-checked
	      // as appropriate.
	      ReactUpdates.asap(forceUpdateIfMounted, otherInstance);
	    }
	  }
	
	  return returnValue;
	}
	
	module.exports = ReactDOMInput;

/***/ },
/* 327 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDOMOption
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(6);
	
	var ReactChildren = __webpack_require__(105);
	var ReactDOMComponentTree = __webpack_require__(8);
	var ReactDOMSelect = __webpack_require__(108);
	
	var warning = __webpack_require__(4);
	var didWarnInvalidOptionChildren = false;
	
	function flattenChildren(children) {
	  var content = '';
	
	  // Flatten children and warn if they aren't strings or numbers;
	  // invalid types are ignored.
	  ReactChildren.forEach(children, function (child) {
	    if (child == null) {
	      return;
	    }
	    if (typeof child === 'string' || typeof child === 'number') {
	      content += child;
	    } else if (!didWarnInvalidOptionChildren) {
	      didWarnInvalidOptionChildren = true;
	       false ? warning(false, 'Only strings and numbers are supported as <option> children.') : void 0;
	    }
	  });
	
	  return content;
	}
	
	/**
	 * Implements an <option> host component that warns when `selected` is set.
	 */
	var ReactDOMOption = {
	  mountWrapper: function (inst, props, hostParent) {
	    // TODO (yungsters): Remove support for `selected` in <option>.
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(props.selected == null, 'Use the `defaultValue` or `value` props on <select> instead of ' + 'setting `selected` on <option>.') : void 0;
	    }
	
	    // Look up whether this option is 'selected'
	    var selectValue = null;
	    if (hostParent != null) {
	      var selectParent = hostParent;
	
	      if (selectParent._tag === 'optgroup') {
	        selectParent = selectParent._hostParent;
	      }
	
	      if (selectParent != null && selectParent._tag === 'select') {
	        selectValue = ReactDOMSelect.getSelectValueContext(selectParent);
	      }
	    }
	
	    // If the value is null (e.g., no specified value or after initial mount)
	    // or missing (e.g., for <datalist>), we don't change props.selected
	    var selected = null;
	    if (selectValue != null) {
	      var value;
	      if (props.value != null) {
	        value = props.value + '';
	      } else {
	        value = flattenChildren(props.children);
	      }
	      selected = false;
	      if (Array.isArray(selectValue)) {
	        // multiple
	        for (var i = 0; i < selectValue.length; i++) {
	          if ('' + selectValue[i] === value) {
	            selected = true;
	            break;
	          }
	        }
	      } else {
	        selected = '' + selectValue === value;
	      }
	    }
	
	    inst._wrapperState = { selected: selected };
	  },
	
	  postMountWrapper: function (inst) {
	    // value="" should make a value attribute (#6219)
	    var props = inst._currentElement.props;
	    if (props.value != null) {
	      var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	      node.setAttribute('value', props.value);
	    }
	  },
	
	  getHostProps: function (inst, props) {
	    var hostProps = _assign({ selected: undefined, children: undefined }, props);
	
	    // Read state only from initial mount because <select> updates value
	    // manually; we need the initial state only for server rendering
	    if (inst._wrapperState.selected != null) {
	      hostProps.selected = inst._wrapperState.selected;
	    }
	
	    var content = flattenChildren(props.children);
	
	    if (content) {
	      hostProps.children = content;
	    }
	
	    return hostProps;
	  }
	
	};
	
	module.exports = ReactDOMOption;

/***/ },
/* 328 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDOMSelection
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(9);
	
	var getNodeForCharacterOffset = __webpack_require__(364);
	var getTextContentAccessor = __webpack_require__(124);
	
	/**
	 * While `isCollapsed` is available on the Selection object and `collapsed`
	 * is available on the Range object, IE11 sometimes gets them wrong.
	 * If the anchor/focus nodes and offsets are the same, the range is collapsed.
	 */
	function isCollapsed(anchorNode, anchorOffset, focusNode, focusOffset) {
	  return anchorNode === focusNode && anchorOffset === focusOffset;
	}
	
	/**
	 * Get the appropriate anchor and focus node/offset pairs for IE.
	 *
	 * The catch here is that IE's selection API doesn't provide information
	 * about whether the selection is forward or backward, so we have to
	 * behave as though it's always forward.
	 *
	 * IE text differs from modern selection in that it behaves as though
	 * block elements end with a new line. This means character offsets will
	 * differ between the two APIs.
	 *
	 * @param {DOMElement} node
	 * @return {object}
	 */
	function getIEOffsets(node) {
	  var selection = document.selection;
	  var selectedRange = selection.createRange();
	  var selectedLength = selectedRange.text.length;
	
	  // Duplicate selection so we can move range without breaking user selection.
	  var fromStart = selectedRange.duplicate();
	  fromStart.moveToElementText(node);
	  fromStart.setEndPoint('EndToStart', selectedRange);
	
	  var startOffset = fromStart.text.length;
	  var endOffset = startOffset + selectedLength;
	
	  return {
	    start: startOffset,
	    end: endOffset
	  };
	}
	
	/**
	 * @param {DOMElement} node
	 * @return {?object}
	 */
	function getModernOffsets(node) {
	  var selection = window.getSelection && window.getSelection();
	
	  if (!selection || selection.rangeCount === 0) {
	    return null;
	  }
	
	  var anchorNode = selection.anchorNode;
	  var anchorOffset = selection.anchorOffset;
	  var focusNode = selection.focusNode;
	  var focusOffset = selection.focusOffset;
	
	  var currentRange = selection.getRangeAt(0);
	
	  // In Firefox, range.startContainer and range.endContainer can be "anonymous
	  // divs", e.g. the up/down buttons on an <input type="number">. Anonymous
	  // divs do not seem to expose properties, triggering a "Permission denied
	  // error" if any of its properties are accessed. The only seemingly possible
	  // way to avoid erroring is to access a property that typically works for
	  // non-anonymous divs and catch any error that may otherwise arise. See
	  // https://bugzilla.mozilla.org/show_bug.cgi?id=208427
	  try {
	    /* eslint-disable no-unused-expressions */
	    currentRange.startContainer.nodeType;
	    currentRange.endContainer.nodeType;
	    /* eslint-enable no-unused-expressions */
	  } catch (e) {
	    return null;
	  }
	
	  // If the node and offset values are the same, the selection is collapsed.
	  // `Selection.isCollapsed` is available natively, but IE sometimes gets
	  // this value wrong.
	  var isSelectionCollapsed = isCollapsed(selection.anchorNode, selection.anchorOffset, selection.focusNode, selection.focusOffset);
	
	  var rangeLength = isSelectionCollapsed ? 0 : currentRange.toString().length;
	
	  var tempRange = currentRange.cloneRange();
	  tempRange.selectNodeContents(node);
	  tempRange.setEnd(currentRange.startContainer, currentRange.startOffset);
	
	  var isTempRangeCollapsed = isCollapsed(tempRange.startContainer, tempRange.startOffset, tempRange.endContainer, tempRange.endOffset);
	
	  var start = isTempRangeCollapsed ? 0 : tempRange.toString().length;
	  var end = start + rangeLength;
	
	  // Detect whether the selection is backward.
	  var detectionRange = document.createRange();
	  detectionRange.setStart(anchorNode, anchorOffset);
	  detectionRange.setEnd(focusNode, focusOffset);
	  var isBackward = detectionRange.collapsed;
	
	  return {
	    start: isBackward ? end : start,
	    end: isBackward ? start : end
	  };
	}
	
	/**
	 * @param {DOMElement|DOMTextNode} node
	 * @param {object} offsets
	 */
	function setIEOffsets(node, offsets) {
	  var range = document.selection.createRange().duplicate();
	  var start, end;
	
	  if (offsets.end === undefined) {
	    start = offsets.start;
	    end = start;
	  } else if (offsets.start > offsets.end) {
	    start = offsets.end;
	    end = offsets.start;
	  } else {
	    start = offsets.start;
	    end = offsets.end;
	  }
	
	  range.moveToElementText(node);
	  range.moveStart('character', start);
	  range.setEndPoint('EndToStart', range);
	  range.moveEnd('character', end - start);
	  range.select();
	}
	
	/**
	 * In modern non-IE browsers, we can support both forward and backward
	 * selections.
	 *
	 * Note: IE10+ supports the Selection object, but it does not support
	 * the `extend` method, which means that even in modern IE, it's not possible
	 * to programmatically create a backward selection. Thus, for all IE
	 * versions, we use the old IE API to create our selections.
	 *
	 * @param {DOMElement|DOMTextNode} node
	 * @param {object} offsets
	 */
	function setModernOffsets(node, offsets) {
	  if (!window.getSelection) {
	    return;
	  }
	
	  var selection = window.getSelection();
	  var length = node[getTextContentAccessor()].length;
	  var start = Math.min(offsets.start, length);
	  var end = offsets.end === undefined ? start : Math.min(offsets.end, length);
	
	  // IE 11 uses modern selection, but doesn't support the extend method.
	  // Flip backward selections, so we can set with a single range.
	  if (!selection.extend && start > end) {
	    var temp = end;
	    end = start;
	    start = temp;
	  }
	
	  var startMarker = getNodeForCharacterOffset(node, start);
	  var endMarker = getNodeForCharacterOffset(node, end);
	
	  if (startMarker && endMarker) {
	    var range = document.createRange();
	    range.setStart(startMarker.node, startMarker.offset);
	    selection.removeAllRanges();
	
	    if (start > end) {
	      selection.addRange(range);
	      selection.extend(endMarker.node, endMarker.offset);
	    } else {
	      range.setEnd(endMarker.node, endMarker.offset);
	      selection.addRange(range);
	    }
	  }
	}
	
	var useIEOffsets = ExecutionEnvironment.canUseDOM && 'selection' in document && !('getSelection' in window);
	
	var ReactDOMSelection = {
	  /**
	   * @param {DOMElement} node
	   */
	  getOffsets: useIEOffsets ? getIEOffsets : getModernOffsets,
	
	  /**
	   * @param {DOMElement|DOMTextNode} node
	   * @param {object} offsets
	   */
	  setOffsets: useIEOffsets ? setIEOffsets : setModernOffsets
	};
	
	module.exports = ReactDOMSelection;

/***/ },
/* 329 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDOMTextComponent
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(3),
	    _assign = __webpack_require__(6);
	
	var DOMChildrenOperations = __webpack_require__(52);
	var DOMLazyTree = __webpack_require__(26);
	var ReactDOMComponentTree = __webpack_require__(8);
	
	var escapeTextContentForBrowser = __webpack_require__(45);
	var invariant = __webpack_require__(2);
	var validateDOMNesting = __webpack_require__(74);
	
	/**
	 * Text nodes violate a couple assumptions that React makes about components:
	 *
	 *  - When mounting text into the DOM, adjacent text nodes are merged.
	 *  - Text nodes cannot be assigned a React root ID.
	 *
	 * This component is used to wrap strings between comment nodes so that they
	 * can undergo the same reconciliation that is applied to elements.
	 *
	 * TODO: Investigate representing React components in the DOM with text nodes.
	 *
	 * @class ReactDOMTextComponent
	 * @extends ReactComponent
	 * @internal
	 */
	var ReactDOMTextComponent = function (text) {
	  // TODO: This is really a ReactText (ReactNode), not a ReactElement
	  this._currentElement = text;
	  this._stringText = '' + text;
	  // ReactDOMComponentTree uses these:
	  this._hostNode = null;
	  this._hostParent = null;
	
	  // Properties
	  this._domID = 0;
	  this._mountIndex = 0;
	  this._closingComment = null;
	  this._commentNodes = null;
	};
	
	_assign(ReactDOMTextComponent.prototype, {
	
	  /**
	   * Creates the markup for this text node. This node is not intended to have
	   * any features besides containing text content.
	   *
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @return {string} Markup for this text node.
	   * @internal
	   */
	  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
	    if (false) {
	      var parentInfo;
	      if (hostParent != null) {
	        parentInfo = hostParent._ancestorInfo;
	      } else if (hostContainerInfo != null) {
	        parentInfo = hostContainerInfo._ancestorInfo;
	      }
	      if (parentInfo) {
	        // parentInfo should always be present except for the top-level
	        // component when server rendering
	        validateDOMNesting('#text', this, parentInfo);
	      }
	    }
	
	    var domID = hostContainerInfo._idCounter++;
	    var openingValue = ' react-text: ' + domID + ' ';
	    var closingValue = ' /react-text ';
	    this._domID = domID;
	    this._hostParent = hostParent;
	    if (transaction.useCreateElement) {
	      var ownerDocument = hostContainerInfo._ownerDocument;
	      var openingComment = ownerDocument.createComment(openingValue);
	      var closingComment = ownerDocument.createComment(closingValue);
	      var lazyTree = DOMLazyTree(ownerDocument.createDocumentFragment());
	      DOMLazyTree.queueChild(lazyTree, DOMLazyTree(openingComment));
	      if (this._stringText) {
	        DOMLazyTree.queueChild(lazyTree, DOMLazyTree(ownerDocument.createTextNode(this._stringText)));
	      }
	      DOMLazyTree.queueChild(lazyTree, DOMLazyTree(closingComment));
	      ReactDOMComponentTree.precacheNode(this, openingComment);
	      this._closingComment = closingComment;
	      return lazyTree;
	    } else {
	      var escapedText = escapeTextContentForBrowser(this._stringText);
	
	      if (transaction.renderToStaticMarkup) {
	        // Normally we'd wrap this between comment nodes for the reasons stated
	        // above, but since this is a situation where React won't take over
	        // (static pages), we can simply return the text as it is.
	        return escapedText;
	      }
	
	      return '<!--' + openingValue + '-->' + escapedText + '<!--' + closingValue + '-->';
	    }
	  },
	
	  /**
	   * Updates this component by updating the text content.
	   *
	   * @param {ReactText} nextText The next text content
	   * @param {ReactReconcileTransaction} transaction
	   * @internal
	   */
	  receiveComponent: function (nextText, transaction) {
	    if (nextText !== this._currentElement) {
	      this._currentElement = nextText;
	      var nextStringText = '' + nextText;
	      if (nextStringText !== this._stringText) {
	        // TODO: Save this as pending props and use performUpdateIfNecessary
	        // and/or updateComponent to do the actual update for consistency with
	        // other component types?
	        this._stringText = nextStringText;
	        var commentNodes = this.getHostNode();
	        DOMChildrenOperations.replaceDelimitedText(commentNodes[0], commentNodes[1], nextStringText);
	      }
	    }
	  },
	
	  getHostNode: function () {
	    var hostNode = this._commentNodes;
	    if (hostNode) {
	      return hostNode;
	    }
	    if (!this._closingComment) {
	      var openingComment = ReactDOMComponentTree.getNodeFromInstance(this);
	      var node = openingComment.nextSibling;
	      while (true) {
	        !(node != null) ?  false ? invariant(false, 'Missing closing comment for text component %s', this._domID) : _prodInvariant('67', this._domID) : void 0;
	        if (node.nodeType === 8 && node.nodeValue === ' /react-text ') {
	          this._closingComment = node;
	          break;
	        }
	        node = node.nextSibling;
	      }
	    }
	    hostNode = [this._hostNode, this._closingComment];
	    this._commentNodes = hostNode;
	    return hostNode;
	  },
	
	  unmountComponent: function () {
	    this._closingComment = null;
	    this._commentNodes = null;
	    ReactDOMComponentTree.uncacheNode(this);
	  }
	
	});
	
	module.exports = ReactDOMTextComponent;

/***/ },
/* 330 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDOMTextarea
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(3),
	    _assign = __webpack_require__(6);
	
	var DisabledInputUtils = __webpack_require__(42);
	var LinkedValueUtils = __webpack_require__(57);
	var ReactDOMComponentTree = __webpack_require__(8);
	var ReactUpdates = __webpack_require__(14);
	
	var invariant = __webpack_require__(2);
	var warning = __webpack_require__(4);
	
	var didWarnValueLink = false;
	var didWarnValDefaultVal = false;
	
	function forceUpdateIfMounted() {
	  if (this._rootNodeID) {
	    // DOM component is still mounted; update
	    ReactDOMTextarea.updateWrapper(this);
	  }
	}
	
	/**
	 * Implements a <textarea> host component that allows setting `value`, and
	 * `defaultValue`. This differs from the traditional DOM API because value is
	 * usually set as PCDATA children.
	 *
	 * If `value` is not supplied (or null/undefined), user actions that affect the
	 * value will trigger updates to the element.
	 *
	 * If `value` is supplied (and not null/undefined), the rendered element will
	 * not trigger updates to the element. Instead, the `value` prop must change in
	 * order for the rendered element to be updated.
	 *
	 * The rendered element will be initialized with an empty value, the prop
	 * `defaultValue` if specified, or the children content (deprecated).
	 */
	var ReactDOMTextarea = {
	  getHostProps: function (inst, props) {
	    !(props.dangerouslySetInnerHTML == null) ?  false ? invariant(false, '`dangerouslySetInnerHTML` does not make sense on <textarea>.') : _prodInvariant('91') : void 0;
	
	    // Always set children to the same thing. In IE9, the selection range will
	    // get reset if `textContent` is mutated.  We could add a check in setTextContent
	    // to only set the value if/when the value differs from the node value (which would
	    // completely solve this IE9 bug), but Sebastian+Ben seemed to like this solution.
	    // The value can be a boolean or object so that's why it's forced to be a string.
	    var hostProps = _assign({}, DisabledInputUtils.getHostProps(inst, props), {
	      value: undefined,
	      defaultValue: undefined,
	      children: '' + inst._wrapperState.initialValue,
	      onChange: inst._wrapperState.onChange
	    });
	
	    return hostProps;
	  },
	
	  mountWrapper: function (inst, props) {
	    if (false) {
	      LinkedValueUtils.checkPropTypes('textarea', props, inst._currentElement._owner);
	      if (props.valueLink !== undefined && !didWarnValueLink) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '`valueLink` prop on `textarea` is deprecated; set `value` and `onChange` instead.') : void 0;
	        didWarnValueLink = true;
	      }
	      if (props.value !== undefined && props.defaultValue !== undefined && !didWarnValDefaultVal) {
	        process.env.NODE_ENV !== 'production' ? warning(false, 'Textarea elements must be either controlled or uncontrolled ' + '(specify either the value prop, or the defaultValue prop, but not ' + 'both). Decide between using a controlled or uncontrolled textarea ' + 'and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components') : void 0;
	        didWarnValDefaultVal = true;
	      }
	    }
	
	    var value = LinkedValueUtils.getValue(props);
	    var initialValue = value;
	
	    // Only bother fetching default value if we're going to use it
	    if (value == null) {
	      var defaultValue = props.defaultValue;
	      // TODO (yungsters): Remove support for children content in <textarea>.
	      var children = props.children;
	      if (children != null) {
	        if (false) {
	          process.env.NODE_ENV !== 'production' ? warning(false, 'Use the `defaultValue` or `value` props instead of setting ' + 'children on <textarea>.') : void 0;
	        }
	        !(defaultValue == null) ?  false ? invariant(false, 'If you supply `defaultValue` on a <textarea>, do not pass children.') : _prodInvariant('92') : void 0;
	        if (Array.isArray(children)) {
	          !(children.length <= 1) ?  false ? invariant(false, '<textarea> can only have at most one child.') : _prodInvariant('93') : void 0;
	          children = children[0];
	        }
	
	        defaultValue = '' + children;
	      }
	      if (defaultValue == null) {
	        defaultValue = '';
	      }
	      initialValue = defaultValue;
	    }
	
	    inst._wrapperState = {
	      initialValue: '' + initialValue,
	      listeners: null,
	      onChange: _handleChange.bind(inst)
	    };
	  },
	
	  updateWrapper: function (inst) {
	    var props = inst._currentElement.props;
	
	    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	    var value = LinkedValueUtils.getValue(props);
	    if (value != null) {
	      // Cast `value` to a string to ensure the value is set correctly. While
	      // browsers typically do this as necessary, jsdom doesn't.
	      var newValue = '' + value;
	
	      // To avoid side effects (such as losing text selection), only set value if changed
	      if (newValue !== node.value) {
	        node.value = newValue;
	      }
	      if (props.defaultValue == null) {
	        node.defaultValue = newValue;
	      }
	    }
	    if (props.defaultValue != null) {
	      node.defaultValue = props.defaultValue;
	    }
	  },
	
	  postMountWrapper: function (inst) {
	    // This is in postMount because we need access to the DOM node, which is not
	    // available until after the component has mounted.
	    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	
	    // Warning: node.value may be the empty string at this point (IE11) if placeholder is set.
	    node.value = node.textContent; // Detach value from defaultValue
	  }
	};
	
	function _handleChange(event) {
	  var props = this._currentElement.props;
	  var returnValue = LinkedValueUtils.executeOnChange(props, event);
	  ReactUpdates.asap(forceUpdateIfMounted, this);
	  return returnValue;
	}
	
	module.exports = ReactDOMTextarea;

/***/ },
/* 331 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDOMTreeTraversal
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(3);
	
	var invariant = __webpack_require__(2);
	
	/**
	 * Return the lowest common ancestor of A and B, or null if they are in
	 * different trees.
	 */
	function getLowestCommonAncestor(instA, instB) {
	  !('_hostNode' in instA) ?  false ? invariant(false, 'getNodeFromInstance: Invalid argument.') : _prodInvariant('33') : void 0;
	  !('_hostNode' in instB) ?  false ? invariant(false, 'getNodeFromInstance: Invalid argument.') : _prodInvariant('33') : void 0;
	
	  var depthA = 0;
	  for (var tempA = instA; tempA; tempA = tempA._hostParent) {
	    depthA++;
	  }
	  var depthB = 0;
	  for (var tempB = instB; tempB; tempB = tempB._hostParent) {
	    depthB++;
	  }
	
	  // If A is deeper, crawl up.
	  while (depthA - depthB > 0) {
	    instA = instA._hostParent;
	    depthA--;
	  }
	
	  // If B is deeper, crawl up.
	  while (depthB - depthA > 0) {
	    instB = instB._hostParent;
	    depthB--;
	  }
	
	  // Walk in lockstep until we find a match.
	  var depth = depthA;
	  while (depth--) {
	    if (instA === instB) {
	      return instA;
	    }
	    instA = instA._hostParent;
	    instB = instB._hostParent;
	  }
	  return null;
	}
	
	/**
	 * Return if A is an ancestor of B.
	 */
	function isAncestor(instA, instB) {
	  !('_hostNode' in instA) ?  false ? invariant(false, 'isAncestor: Invalid argument.') : _prodInvariant('35') : void 0;
	  !('_hostNode' in instB) ?  false ? invariant(false, 'isAncestor: Invalid argument.') : _prodInvariant('35') : void 0;
	
	  while (instB) {
	    if (instB === instA) {
	      return true;
	    }
	    instB = instB._hostParent;
	  }
	  return false;
	}
	
	/**
	 * Return the parent instance of the passed-in instance.
	 */
	function getParentInstance(inst) {
	  !('_hostNode' in inst) ?  false ? invariant(false, 'getParentInstance: Invalid argument.') : _prodInvariant('36') : void 0;
	
	  return inst._hostParent;
	}
	
	/**
	 * Simulates the traversal of a two-phase, capture/bubble event dispatch.
	 */
	function traverseTwoPhase(inst, fn, arg) {
	  var path = [];
	  while (inst) {
	    path.push(inst);
	    inst = inst._hostParent;
	  }
	  var i;
	  for (i = path.length; i-- > 0;) {
	    fn(path[i], false, arg);
	  }
	  for (i = 0; i < path.length; i++) {
	    fn(path[i], true, arg);
	  }
	}
	
	/**
	 * Traverses the ID hierarchy and invokes the supplied `cb` on any IDs that
	 * should would receive a `mouseEnter` or `mouseLeave` event.
	 *
	 * Does not invoke the callback on the nearest common ancestor because nothing
	 * "entered" or "left" that element.
	 */
	function traverseEnterLeave(from, to, fn, argFrom, argTo) {
	  var common = from && to ? getLowestCommonAncestor(from, to) : null;
	  var pathFrom = [];
	  while (from && from !== common) {
	    pathFrom.push(from);
	    from = from._hostParent;
	  }
	  var pathTo = [];
	  while (to && to !== common) {
	    pathTo.push(to);
	    to = to._hostParent;
	  }
	  var i;
	  for (i = 0; i < pathFrom.length; i++) {
	    fn(pathFrom[i], true, argFrom);
	  }
	  for (i = pathTo.length; i-- > 0;) {
	    fn(pathTo[i], false, argTo);
	  }
	}
	
	module.exports = {
	  isAncestor: isAncestor,
	  getLowestCommonAncestor: getLowestCommonAncestor,
	  getParentInstance: getParentInstance,
	  traverseTwoPhase: traverseTwoPhase,
	  traverseEnterLeave: traverseEnterLeave
	};

/***/ },
/* 332 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDefaultBatchingStrategy
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(6);
	
	var ReactUpdates = __webpack_require__(14);
	var Transaction = __webpack_require__(38);
	
	var emptyFunction = __webpack_require__(10);
	
	var RESET_BATCHED_UPDATES = {
	  initialize: emptyFunction,
	  close: function () {
	    ReactDefaultBatchingStrategy.isBatchingUpdates = false;
	  }
	};
	
	var FLUSH_BATCHED_UPDATES = {
	  initialize: emptyFunction,
	  close: ReactUpdates.flushBatchedUpdates.bind(ReactUpdates)
	};
	
	var TRANSACTION_WRAPPERS = [FLUSH_BATCHED_UPDATES, RESET_BATCHED_UPDATES];
	
	function ReactDefaultBatchingStrategyTransaction() {
	  this.reinitializeTransaction();
	}
	
	_assign(ReactDefaultBatchingStrategyTransaction.prototype, Transaction.Mixin, {
	  getTransactionWrappers: function () {
	    return TRANSACTION_WRAPPERS;
	  }
	});
	
	var transaction = new ReactDefaultBatchingStrategyTransaction();
	
	var ReactDefaultBatchingStrategy = {
	  isBatchingUpdates: false,
	
	  /**
	   * Call the provided function in a context within which calls to `setState`
	   * and friends are batched such that components aren't updated unnecessarily.
	   */
	  batchedUpdates: function (callback, a, b, c, d, e) {
	    var alreadyBatchingUpdates = ReactDefaultBatchingStrategy.isBatchingUpdates;
	
	    ReactDefaultBatchingStrategy.isBatchingUpdates = true;
	
	    // The code is written this way to avoid extra allocations
	    if (alreadyBatchingUpdates) {
	      callback(a, b, c, d, e);
	    } else {
	      transaction.perform(callback, null, a, b, c, d, e);
	    }
	  }
	};
	
	module.exports = ReactDefaultBatchingStrategy;

/***/ },
/* 333 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDefaultInjection
	 */
	
	'use strict';
	
	var BeforeInputEventPlugin = __webpack_require__(306);
	var ChangeEventPlugin = __webpack_require__(308);
	var DefaultEventPluginOrder = __webpack_require__(310);
	var EnterLeaveEventPlugin = __webpack_require__(311);
	var HTMLDOMPropertyConfig = __webpack_require__(313);
	var ReactComponentBrowserEnvironment = __webpack_require__(316);
	var ReactDOMComponent = __webpack_require__(320);
	var ReactDOMComponentTree = __webpack_require__(8);
	var ReactDOMEmptyComponent = __webpack_require__(322);
	var ReactDOMTreeTraversal = __webpack_require__(331);
	var ReactDOMTextComponent = __webpack_require__(329);
	var ReactDefaultBatchingStrategy = __webpack_require__(332);
	var ReactEventListener = __webpack_require__(335);
	var ReactInjection = __webpack_require__(336);
	var ReactReconcileTransaction = __webpack_require__(341);
	var SVGDOMPropertyConfig = __webpack_require__(345);
	var SelectEventPlugin = __webpack_require__(346);
	var SimpleEventPlugin = __webpack_require__(347);
	
	var alreadyInjected = false;
	
	function inject() {
	  if (alreadyInjected) {
	    // TODO: This is currently true because these injections are shared between
	    // the client and the server package. They should be built independently
	    // and not share any injection state. Then this problem will be solved.
	    return;
	  }
	  alreadyInjected = true;
	
	  ReactInjection.EventEmitter.injectReactEventListener(ReactEventListener);
	
	  /**
	   * Inject modules for resolving DOM hierarchy and plugin ordering.
	   */
	  ReactInjection.EventPluginHub.injectEventPluginOrder(DefaultEventPluginOrder);
	  ReactInjection.EventPluginUtils.injectComponentTree(ReactDOMComponentTree);
	  ReactInjection.EventPluginUtils.injectTreeTraversal(ReactDOMTreeTraversal);
	
	  /**
	   * Some important event plugins included by default (without having to require
	   * them).
	   */
	  ReactInjection.EventPluginHub.injectEventPluginsByName({
	    SimpleEventPlugin: SimpleEventPlugin,
	    EnterLeaveEventPlugin: EnterLeaveEventPlugin,
	    ChangeEventPlugin: ChangeEventPlugin,
	    SelectEventPlugin: SelectEventPlugin,
	    BeforeInputEventPlugin: BeforeInputEventPlugin
	  });
	
	  ReactInjection.HostComponent.injectGenericComponentClass(ReactDOMComponent);
	
	  ReactInjection.HostComponent.injectTextComponentClass(ReactDOMTextComponent);
	
	  ReactInjection.DOMProperty.injectDOMPropertyConfig(HTMLDOMPropertyConfig);
	  ReactInjection.DOMProperty.injectDOMPropertyConfig(SVGDOMPropertyConfig);
	
	  ReactInjection.EmptyComponent.injectEmptyComponentFactory(function (instantiate) {
	    return new ReactDOMEmptyComponent(instantiate);
	  });
	
	  ReactInjection.Updates.injectReconcileTransaction(ReactReconcileTransaction);
	  ReactInjection.Updates.injectBatchingStrategy(ReactDefaultBatchingStrategy);
	
	  ReactInjection.Component.injectEnvironment(ReactComponentBrowserEnvironment);
	}
	
	module.exports = {
	  inject: inject
	};

/***/ },
/* 334 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactEventEmitterMixin
	 */
	
	'use strict';
	
	var EventPluginHub = __webpack_require__(34);
	
	function runEventQueueInBatch(events) {
	  EventPluginHub.enqueueEvents(events);
	  EventPluginHub.processEventQueue(false);
	}
	
	var ReactEventEmitterMixin = {
	
	  /**
	   * Streams a fired top-level event to `EventPluginHub` where plugins have the
	   * opportunity to create `ReactEvent`s to be dispatched.
	   */
	  handleTopLevel: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    var events = EventPluginHub.extractEvents(topLevelType, targetInst, nativeEvent, nativeEventTarget);
	    runEventQueueInBatch(events);
	  }
	};
	
	module.exports = ReactEventEmitterMixin;

/***/ },
/* 335 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactEventListener
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(6);
	
	var EventListener = __webpack_require__(79);
	var ExecutionEnvironment = __webpack_require__(9);
	var PooledClass = __webpack_require__(22);
	var ReactDOMComponentTree = __webpack_require__(8);
	var ReactUpdates = __webpack_require__(14);
	
	var getEventTarget = __webpack_require__(70);
	var getUnboundedScrollPosition = __webpack_require__(152);
	
	/**
	 * Find the deepest React component completely containing the root of the
	 * passed-in instance (for use when entire React trees are nested within each
	 * other). If React trees are not nested, returns null.
	 */
	function findParent(inst) {
	  // TODO: It may be a good idea to cache this to prevent unnecessary DOM
	  // traversal, but caching is difficult to do correctly without using a
	  // mutation observer to listen for all DOM changes.
	  while (inst._hostParent) {
	    inst = inst._hostParent;
	  }
	  var rootNode = ReactDOMComponentTree.getNodeFromInstance(inst);
	  var container = rootNode.parentNode;
	  return ReactDOMComponentTree.getClosestInstanceFromNode(container);
	}
	
	// Used to store ancestor hierarchy in top level callback
	function TopLevelCallbackBookKeeping(topLevelType, nativeEvent) {
	  this.topLevelType = topLevelType;
	  this.nativeEvent = nativeEvent;
	  this.ancestors = [];
	}
	_assign(TopLevelCallbackBookKeeping.prototype, {
	  destructor: function () {
	    this.topLevelType = null;
	    this.nativeEvent = null;
	    this.ancestors.length = 0;
	  }
	});
	PooledClass.addPoolingTo(TopLevelCallbackBookKeeping, PooledClass.twoArgumentPooler);
	
	function handleTopLevelImpl(bookKeeping) {
	  var nativeEventTarget = getEventTarget(bookKeeping.nativeEvent);
	  var targetInst = ReactDOMComponentTree.getClosestInstanceFromNode(nativeEventTarget);
	
	  // Loop through the hierarchy, in case there's any nested components.
	  // It's important that we build the array of ancestors before calling any
	  // event handlers, because event handlers can modify the DOM, leading to
	  // inconsistencies with ReactMount's node cache. See #1105.
	  var ancestor = targetInst;
	  do {
	    bookKeeping.ancestors.push(ancestor);
	    ancestor = ancestor && findParent(ancestor);
	  } while (ancestor);
	
	  for (var i = 0; i < bookKeeping.ancestors.length; i++) {
	    targetInst = bookKeeping.ancestors[i];
	    ReactEventListener._handleTopLevel(bookKeeping.topLevelType, targetInst, bookKeeping.nativeEvent, getEventTarget(bookKeeping.nativeEvent));
	  }
	}
	
	function scrollValueMonitor(cb) {
	  var scrollPosition = getUnboundedScrollPosition(window);
	  cb(scrollPosition);
	}
	
	var ReactEventListener = {
	  _enabled: true,
	  _handleTopLevel: null,
	
	  WINDOW_HANDLE: ExecutionEnvironment.canUseDOM ? window : null,
	
	  setHandleTopLevel: function (handleTopLevel) {
	    ReactEventListener._handleTopLevel = handleTopLevel;
	  },
	
	  setEnabled: function (enabled) {
	    ReactEventListener._enabled = !!enabled;
	  },
	
	  isEnabled: function () {
	    return ReactEventListener._enabled;
	  },
	
	  /**
	   * Traps top-level events by using event bubbling.
	   *
	   * @param {string} topLevelType Record from `EventConstants`.
	   * @param {string} handlerBaseName Event name (e.g. "click").
	   * @param {object} handle Element on which to attach listener.
	   * @return {?object} An object with a remove function which will forcefully
	   *                  remove the listener.
	   * @internal
	   */
	  trapBubbledEvent: function (topLevelType, handlerBaseName, handle) {
	    var element = handle;
	    if (!element) {
	      return null;
	    }
	    return EventListener.listen(element, handlerBaseName, ReactEventListener.dispatchEvent.bind(null, topLevelType));
	  },
	
	  /**
	   * Traps a top-level event by using event capturing.
	   *
	   * @param {string} topLevelType Record from `EventConstants`.
	   * @param {string} handlerBaseName Event name (e.g. "click").
	   * @param {object} handle Element on which to attach listener.
	   * @return {?object} An object with a remove function which will forcefully
	   *                  remove the listener.
	   * @internal
	   */
	  trapCapturedEvent: function (topLevelType, handlerBaseName, handle) {
	    var element = handle;
	    if (!element) {
	      return null;
	    }
	    return EventListener.capture(element, handlerBaseName, ReactEventListener.dispatchEvent.bind(null, topLevelType));
	  },
	
	  monitorScrollValue: function (refresh) {
	    var callback = scrollValueMonitor.bind(null, refresh);
	    EventListener.listen(window, 'scroll', callback);
	  },
	
	  dispatchEvent: function (topLevelType, nativeEvent) {
	    if (!ReactEventListener._enabled) {
	      return;
	    }
	
	    var bookKeeping = TopLevelCallbackBookKeeping.getPooled(topLevelType, nativeEvent);
	    try {
	      // Event queue being processed in the same cycle allows
	      // `preventDefault`.
	      ReactUpdates.batchedUpdates(handleTopLevelImpl, bookKeeping);
	    } finally {
	      TopLevelCallbackBookKeeping.release(bookKeeping);
	    }
	  }
	};
	
	module.exports = ReactEventListener;

/***/ },
/* 336 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactInjection
	 */
	
	'use strict';
	
	var DOMProperty = __webpack_require__(27);
	var EventPluginHub = __webpack_require__(34);
	var EventPluginUtils = __webpack_require__(55);
	var ReactComponentEnvironment = __webpack_require__(59);
	var ReactClass = __webpack_require__(106);
	var ReactEmptyComponent = __webpack_require__(109);
	var ReactBrowserEventEmitter = __webpack_require__(43);
	var ReactHostComponent = __webpack_require__(111);
	var ReactUpdates = __webpack_require__(14);
	
	var ReactInjection = {
	  Component: ReactComponentEnvironment.injection,
	  Class: ReactClass.injection,
	  DOMProperty: DOMProperty.injection,
	  EmptyComponent: ReactEmptyComponent.injection,
	  EventPluginHub: EventPluginHub.injection,
	  EventPluginUtils: EventPluginUtils.injection,
	  EventEmitter: ReactBrowserEventEmitter.injection,
	  HostComponent: ReactHostComponent.injection,
	  Updates: ReactUpdates.injection
	};
	
	module.exports = ReactInjection;

/***/ },
/* 337 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactMarkupChecksum
	 */
	
	'use strict';
	
	var adler32 = __webpack_require__(358);
	
	var TAG_END = /\/?>/;
	var COMMENT_START = /^<\!\-\-/;
	
	var ReactMarkupChecksum = {
	  CHECKSUM_ATTR_NAME: 'data-react-checksum',
	
	  /**
	   * @param {string} markup Markup string
	   * @return {string} Markup string with checksum attribute attached
	   */
	  addChecksumToMarkup: function (markup) {
	    var checksum = adler32(markup);
	
	    // Add checksum (handle both parent tags, comments and self-closing tags)
	    if (COMMENT_START.test(markup)) {
	      return markup;
	    } else {
	      return markup.replace(TAG_END, ' ' + ReactMarkupChecksum.CHECKSUM_ATTR_NAME + '="' + checksum + '"$&');
	    }
	  },
	
	  /**
	   * @param {string} markup to use
	   * @param {DOMElement} element root React element
	   * @returns {boolean} whether or not the markup is the same
	   */
	  canReuseMarkup: function (markup, element) {
	    var existingChecksum = element.getAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME);
	    existingChecksum = existingChecksum && parseInt(existingChecksum, 10);
	    var markupChecksum = adler32(markup);
	    return markupChecksum === existingChecksum;
	  }
	};
	
	module.exports = ReactMarkupChecksum;

/***/ },
/* 338 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactMultiChild
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(3);
	
	var ReactComponentEnvironment = __webpack_require__(59);
	var ReactInstanceMap = __webpack_require__(36);
	var ReactInstrumentation = __webpack_require__(11);
	var ReactMultiChildUpdateTypes = __webpack_require__(114);
	
	var ReactCurrentOwner = __webpack_require__(23);
	var ReactReconciler = __webpack_require__(28);
	var ReactChildReconciler = __webpack_require__(315);
	
	var emptyFunction = __webpack_require__(10);
	var flattenChildren = __webpack_require__(362);
	var invariant = __webpack_require__(2);
	
	/**
	 * Make an update for markup to be rendered and inserted at a supplied index.
	 *
	 * @param {string} markup Markup that renders into an element.
	 * @param {number} toIndex Destination index.
	 * @private
	 */
	function makeInsertMarkup(markup, afterNode, toIndex) {
	  // NOTE: Null values reduce hidden classes.
	  return {
	    type: ReactMultiChildUpdateTypes.INSERT_MARKUP,
	    content: markup,
	    fromIndex: null,
	    fromNode: null,
	    toIndex: toIndex,
	    afterNode: afterNode
	  };
	}
	
	/**
	 * Make an update for moving an existing element to another index.
	 *
	 * @param {number} fromIndex Source index of the existing element.
	 * @param {number} toIndex Destination index of the element.
	 * @private
	 */
	function makeMove(child, afterNode, toIndex) {
	  // NOTE: Null values reduce hidden classes.
	  return {
	    type: ReactMultiChildUpdateTypes.MOVE_EXISTING,
	    content: null,
	    fromIndex: child._mountIndex,
	    fromNode: ReactReconciler.getHostNode(child),
	    toIndex: toIndex,
	    afterNode: afterNode
	  };
	}
	
	/**
	 * Make an update for removing an element at an index.
	 *
	 * @param {number} fromIndex Index of the element to remove.
	 * @private
	 */
	function makeRemove(child, node) {
	  // NOTE: Null values reduce hidden classes.
	  return {
	    type: ReactMultiChildUpdateTypes.REMOVE_NODE,
	    content: null,
	    fromIndex: child._mountIndex,
	    fromNode: node,
	    toIndex: null,
	    afterNode: null
	  };
	}
	
	/**
	 * Make an update for setting the markup of a node.
	 *
	 * @param {string} markup Markup that renders into an element.
	 * @private
	 */
	function makeSetMarkup(markup) {
	  // NOTE: Null values reduce hidden classes.
	  return {
	    type: ReactMultiChildUpdateTypes.SET_MARKUP,
	    content: markup,
	    fromIndex: null,
	    fromNode: null,
	    toIndex: null,
	    afterNode: null
	  };
	}
	
	/**
	 * Make an update for setting the text content.
	 *
	 * @param {string} textContent Text content to set.
	 * @private
	 */
	function makeTextContent(textContent) {
	  // NOTE: Null values reduce hidden classes.
	  return {
	    type: ReactMultiChildUpdateTypes.TEXT_CONTENT,
	    content: textContent,
	    fromIndex: null,
	    fromNode: null,
	    toIndex: null,
	    afterNode: null
	  };
	}
	
	/**
	 * Push an update, if any, onto the queue. Creates a new queue if none is
	 * passed and always returns the queue. Mutative.
	 */
	function enqueue(queue, update) {
	  if (update) {
	    queue = queue || [];
	    queue.push(update);
	  }
	  return queue;
	}
	
	/**
	 * Processes any enqueued updates.
	 *
	 * @private
	 */
	function processQueue(inst, updateQueue) {
	  ReactComponentEnvironment.processChildrenUpdates(inst, updateQueue);
	}
	
	var setChildrenForInstrumentation = emptyFunction;
	if (false) {
	  var getDebugID = function (inst) {
	    if (!inst._debugID) {
	      // Check for ART-like instances. TODO: This is silly/gross.
	      var internal;
	      if (internal = ReactInstanceMap.get(inst)) {
	        inst = internal;
	      }
	    }
	    return inst._debugID;
	  };
	  setChildrenForInstrumentation = function (children) {
	    var debugID = getDebugID(this);
	    // TODO: React Native empty components are also multichild.
	    // This means they still get into this method but don't have _debugID.
	    if (debugID !== 0) {
	      ReactInstrumentation.debugTool.onSetChildren(debugID, children ? Object.keys(children).map(function (key) {
	        return children[key]._debugID;
	      }) : []);
	    }
	  };
	}
	
	/**
	 * ReactMultiChild are capable of reconciling multiple children.
	 *
	 * @class ReactMultiChild
	 * @internal
	 */
	var ReactMultiChild = {
	
	  /**
	   * Provides common functionality for components that must reconcile multiple
	   * children. This is used by `ReactDOMComponent` to mount, update, and
	   * unmount child components.
	   *
	   * @lends {ReactMultiChild.prototype}
	   */
	  Mixin: {
	
	    _reconcilerInstantiateChildren: function (nestedChildren, transaction, context) {
	      if (false) {
	        var selfDebugID = getDebugID(this);
	        if (this._currentElement) {
	          try {
	            ReactCurrentOwner.current = this._currentElement._owner;
	            return ReactChildReconciler.instantiateChildren(nestedChildren, transaction, context, selfDebugID);
	          } finally {
	            ReactCurrentOwner.current = null;
	          }
	        }
	      }
	      return ReactChildReconciler.instantiateChildren(nestedChildren, transaction, context);
	    },
	
	    _reconcilerUpdateChildren: function (prevChildren, nextNestedChildrenElements, mountImages, removedNodes, transaction, context) {
	      var nextChildren;
	      var selfDebugID = 0;
	      if (false) {
	        selfDebugID = getDebugID(this);
	        if (this._currentElement) {
	          try {
	            ReactCurrentOwner.current = this._currentElement._owner;
	            nextChildren = flattenChildren(nextNestedChildrenElements, selfDebugID);
	          } finally {
	            ReactCurrentOwner.current = null;
	          }
	          ReactChildReconciler.updateChildren(prevChildren, nextChildren, mountImages, removedNodes, transaction, this, this._hostContainerInfo, context, selfDebugID);
	          return nextChildren;
	        }
	      }
	      nextChildren = flattenChildren(nextNestedChildrenElements, selfDebugID);
	      ReactChildReconciler.updateChildren(prevChildren, nextChildren, mountImages, removedNodes, transaction, this, this._hostContainerInfo, context, selfDebugID);
	      return nextChildren;
	    },
	
	    /**
	     * Generates a "mount image" for each of the supplied children. In the case
	     * of `ReactDOMComponent`, a mount image is a string of markup.
	     *
	     * @param {?object} nestedChildren Nested child maps.
	     * @return {array} An array of mounted representations.
	     * @internal
	     */
	    mountChildren: function (nestedChildren, transaction, context) {
	      var children = this._reconcilerInstantiateChildren(nestedChildren, transaction, context);
	      this._renderedChildren = children;
	
	      var mountImages = [];
	      var index = 0;
	      for (var name in children) {
	        if (children.hasOwnProperty(name)) {
	          var child = children[name];
	          var selfDebugID = 0;
	          if (false) {
	            selfDebugID = getDebugID(this);
	          }
	          var mountImage = ReactReconciler.mountComponent(child, transaction, this, this._hostContainerInfo, context, selfDebugID);
	          child._mountIndex = index++;
	          mountImages.push(mountImage);
	        }
	      }
	
	      if (false) {
	        setChildrenForInstrumentation.call(this, children);
	      }
	
	      return mountImages;
	    },
	
	    /**
	     * Replaces any rendered children with a text content string.
	     *
	     * @param {string} nextContent String of content.
	     * @internal
	     */
	    updateTextContent: function (nextContent) {
	      var prevChildren = this._renderedChildren;
	      // Remove any rendered children.
	      ReactChildReconciler.unmountChildren(prevChildren, false);
	      for (var name in prevChildren) {
	        if (prevChildren.hasOwnProperty(name)) {
	           true ?  false ? invariant(false, 'updateTextContent called on non-empty component.') : _prodInvariant('118') : void 0;
	        }
	      }
	      // Set new text content.
	      var updates = [makeTextContent(nextContent)];
	      processQueue(this, updates);
	    },
	
	    /**
	     * Replaces any rendered children with a markup string.
	     *
	     * @param {string} nextMarkup String of markup.
	     * @internal
	     */
	    updateMarkup: function (nextMarkup) {
	      var prevChildren = this._renderedChildren;
	      // Remove any rendered children.
	      ReactChildReconciler.unmountChildren(prevChildren, false);
	      for (var name in prevChildren) {
	        if (prevChildren.hasOwnProperty(name)) {
	           true ?  false ? invariant(false, 'updateTextContent called on non-empty component.') : _prodInvariant('118') : void 0;
	        }
	      }
	      var updates = [makeSetMarkup(nextMarkup)];
	      processQueue(this, updates);
	    },
	
	    /**
	     * Updates the rendered children with new children.
	     *
	     * @param {?object} nextNestedChildrenElements Nested child element maps.
	     * @param {ReactReconcileTransaction} transaction
	     * @internal
	     */
	    updateChildren: function (nextNestedChildrenElements, transaction, context) {
	      // Hook used by React ART
	      this._updateChildren(nextNestedChildrenElements, transaction, context);
	    },
	
	    /**
	     * @param {?object} nextNestedChildrenElements Nested child element maps.
	     * @param {ReactReconcileTransaction} transaction
	     * @final
	     * @protected
	     */
	    _updateChildren: function (nextNestedChildrenElements, transaction, context) {
	      var prevChildren = this._renderedChildren;
	      var removedNodes = {};
	      var mountImages = [];
	      var nextChildren = this._reconcilerUpdateChildren(prevChildren, nextNestedChildrenElements, mountImages, removedNodes, transaction, context);
	      if (!nextChildren && !prevChildren) {
	        return;
	      }
	      var updates = null;
	      var name;
	      // `nextIndex` will increment for each child in `nextChildren`, but
	      // `lastIndex` will be the last index visited in `prevChildren`.
	      var nextIndex = 0;
	      var lastIndex = 0;
	      // `nextMountIndex` will increment for each newly mounted child.
	      var nextMountIndex = 0;
	      var lastPlacedNode = null;
	      for (name in nextChildren) {
	        if (!nextChildren.hasOwnProperty(name)) {
	          continue;
	        }
	        var prevChild = prevChildren && prevChildren[name];
	        var nextChild = nextChildren[name];
	        if (prevChild === nextChild) {
	          updates = enqueue(updates, this.moveChild(prevChild, lastPlacedNode, nextIndex, lastIndex));
	          lastIndex = Math.max(prevChild._mountIndex, lastIndex);
	          prevChild._mountIndex = nextIndex;
	        } else {
	          if (prevChild) {
	            // Update `lastIndex` before `_mountIndex` gets unset by unmounting.
	            lastIndex = Math.max(prevChild._mountIndex, lastIndex);
	            // The `removedNodes` loop below will actually remove the child.
	          }
	          // The child must be instantiated before it's mounted.
	          updates = enqueue(updates, this._mountChildAtIndex(nextChild, mountImages[nextMountIndex], lastPlacedNode, nextIndex, transaction, context));
	          nextMountIndex++;
	        }
	        nextIndex++;
	        lastPlacedNode = ReactReconciler.getHostNode(nextChild);
	      }
	      // Remove children that are no longer present.
	      for (name in removedNodes) {
	        if (removedNodes.hasOwnProperty(name)) {
	          updates = enqueue(updates, this._unmountChild(prevChildren[name], removedNodes[name]));
	        }
	      }
	      if (updates) {
	        processQueue(this, updates);
	      }
	      this._renderedChildren = nextChildren;
	
	      if (false) {
	        setChildrenForInstrumentation.call(this, nextChildren);
	      }
	    },
	
	    /**
	     * Unmounts all rendered children. This should be used to clean up children
	     * when this component is unmounted. It does not actually perform any
	     * backend operations.
	     *
	     * @internal
	     */
	    unmountChildren: function (safely) {
	      var renderedChildren = this._renderedChildren;
	      ReactChildReconciler.unmountChildren(renderedChildren, safely);
	      this._renderedChildren = null;
	    },
	
	    /**
	     * Moves a child component to the supplied index.
	     *
	     * @param {ReactComponent} child Component to move.
	     * @param {number} toIndex Destination index of the element.
	     * @param {number} lastIndex Last index visited of the siblings of `child`.
	     * @protected
	     */
	    moveChild: function (child, afterNode, toIndex, lastIndex) {
	      // If the index of `child` is less than `lastIndex`, then it needs to
	      // be moved. Otherwise, we do not need to move it because a child will be
	      // inserted or moved before `child`.
	      if (child._mountIndex < lastIndex) {
	        return makeMove(child, afterNode, toIndex);
	      }
	    },
	
	    /**
	     * Creates a child component.
	     *
	     * @param {ReactComponent} child Component to create.
	     * @param {string} mountImage Markup to insert.
	     * @protected
	     */
	    createChild: function (child, afterNode, mountImage) {
	      return makeInsertMarkup(mountImage, afterNode, child._mountIndex);
	    },
	
	    /**
	     * Removes a child component.
	     *
	     * @param {ReactComponent} child Child to remove.
	     * @protected
	     */
	    removeChild: function (child, node) {
	      return makeRemove(child, node);
	    },
	
	    /**
	     * Mounts a child with the supplied name.
	     *
	     * NOTE: This is part of `updateChildren` and is here for readability.
	     *
	     * @param {ReactComponent} child Component to mount.
	     * @param {string} name Name of the child.
	     * @param {number} index Index at which to insert the child.
	     * @param {ReactReconcileTransaction} transaction
	     * @private
	     */
	    _mountChildAtIndex: function (child, mountImage, afterNode, index, transaction, context) {
	      child._mountIndex = index;
	      return this.createChild(child, afterNode, mountImage);
	    },
	
	    /**
	     * Unmounts a rendered child.
	     *
	     * NOTE: This is part of `updateChildren` and is here for readability.
	     *
	     * @param {ReactComponent} child Component to unmount.
	     * @private
	     */
	    _unmountChild: function (child, node) {
	      var update = this.removeChild(child, node);
	      child._mountIndex = null;
	      return update;
	    }
	
	  }
	
	};
	
	module.exports = ReactMultiChild;

/***/ },
/* 339 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactOwner
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(3);
	
	var invariant = __webpack_require__(2);
	
	/**
	 * ReactOwners are capable of storing references to owned components.
	 *
	 * All components are capable of //being// referenced by owner components, but
	 * only ReactOwner components are capable of //referencing// owned components.
	 * The named reference is known as a "ref".
	 *
	 * Refs are available when mounted and updated during reconciliation.
	 *
	 *   var MyComponent = React.createClass({
	 *     render: function() {
	 *       return (
	 *         <div onClick={this.handleClick}>
	 *           <CustomComponent ref="custom" />
	 *         </div>
	 *       );
	 *     },
	 *     handleClick: function() {
	 *       this.refs.custom.handleClick();
	 *     },
	 *     componentDidMount: function() {
	 *       this.refs.custom.initialize();
	 *     }
	 *   });
	 *
	 * Refs should rarely be used. When refs are used, they should only be done to
	 * control data that is not handled by React's data flow.
	 *
	 * @class ReactOwner
	 */
	var ReactOwner = {
	
	  /**
	   * @param {?object} object
	   * @return {boolean} True if `object` is a valid owner.
	   * @final
	   */
	  isValidOwner: function (object) {
	    return !!(object && typeof object.attachRef === 'function' && typeof object.detachRef === 'function');
	  },
	
	  /**
	   * Adds a component by ref to an owner component.
	   *
	   * @param {ReactComponent} component Component to reference.
	   * @param {string} ref Name by which to refer to the component.
	   * @param {ReactOwner} owner Component on which to record the ref.
	   * @final
	   * @internal
	   */
	  addComponentAsRefTo: function (component, ref, owner) {
	    !ReactOwner.isValidOwner(owner) ?  false ? invariant(false, 'addComponentAsRefTo(...): Only a ReactOwner can have refs. You might be adding a ref to a component that was not created inside a component\'s `render` method, or you have multiple copies of React loaded (details: https://fb.me/react-refs-must-have-owner).') : _prodInvariant('119') : void 0;
	    owner.attachRef(ref, component);
	  },
	
	  /**
	   * Removes a component by ref from an owner component.
	   *
	   * @param {ReactComponent} component Component to dereference.
	   * @param {string} ref Name of the ref to remove.
	   * @param {ReactOwner} owner Component on which the ref is recorded.
	   * @final
	   * @internal
	   */
	  removeComponentAsRefFrom: function (component, ref, owner) {
	    !ReactOwner.isValidOwner(owner) ?  false ? invariant(false, 'removeComponentAsRefFrom(...): Only a ReactOwner can have refs. You might be removing a ref to a component that was not created inside a component\'s `render` method, or you have multiple copies of React loaded (details: https://fb.me/react-refs-must-have-owner).') : _prodInvariant('120') : void 0;
	    var ownerPublicInstance = owner.getPublicInstance();
	    // Check that `component`'s owner is still alive and that `component` is still the current ref
	    // because we do not want to detach the ref if another component stole it.
	    if (ownerPublicInstance && ownerPublicInstance.refs[ref] === component.getPublicInstance()) {
	      owner.detachRef(ref);
	    }
	  }
	
	};
	
	module.exports = ReactOwner;

/***/ },
/* 340 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactPureComponent
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(6);
	
	var ReactComponent = __webpack_require__(58);
	var ReactNoopUpdateQueue = __webpack_require__(62);
	
	var emptyObject = __webpack_require__(30);
	
	/**
	 * Base class helpers for the updating state of a component.
	 */
	function ReactPureComponent(props, context, updater) {
	  // Duplicated from ReactComponent.
	  this.props = props;
	  this.context = context;
	  this.refs = emptyObject;
	  // We initialize the default updater but the real one gets injected by the
	  // renderer.
	  this.updater = updater || ReactNoopUpdateQueue;
	}
	
	function ComponentDummy() {}
	ComponentDummy.prototype = ReactComponent.prototype;
	ReactPureComponent.prototype = new ComponentDummy();
	ReactPureComponent.prototype.constructor = ReactPureComponent;
	// Avoid an extra prototype jump for these methods.
	_assign(ReactPureComponent.prototype, ReactComponent.prototype);
	ReactPureComponent.prototype.isPureReactComponent = true;
	
	module.exports = ReactPureComponent;

/***/ },
/* 341 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactReconcileTransaction
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(6);
	
	var CallbackQueue = __webpack_require__(103);
	var PooledClass = __webpack_require__(22);
	var ReactBrowserEventEmitter = __webpack_require__(43);
	var ReactInputSelection = __webpack_require__(112);
	var ReactInstrumentation = __webpack_require__(11);
	var Transaction = __webpack_require__(38);
	var ReactUpdateQueue = __webpack_require__(66);
	
	/**
	 * Ensures that, when possible, the selection range (currently selected text
	 * input) is not disturbed by performing the transaction.
	 */
	var SELECTION_RESTORATION = {
	  /**
	   * @return {Selection} Selection information.
	   */
	  initialize: ReactInputSelection.getSelectionInformation,
	  /**
	   * @param {Selection} sel Selection information returned from `initialize`.
	   */
	  close: ReactInputSelection.restoreSelection
	};
	
	/**
	 * Suppresses events (blur/focus) that could be inadvertently dispatched due to
	 * high level DOM manipulations (like temporarily removing a text input from the
	 * DOM).
	 */
	var EVENT_SUPPRESSION = {
	  /**
	   * @return {boolean} The enabled status of `ReactBrowserEventEmitter` before
	   * the reconciliation.
	   */
	  initialize: function () {
	    var currentlyEnabled = ReactBrowserEventEmitter.isEnabled();
	    ReactBrowserEventEmitter.setEnabled(false);
	    return currentlyEnabled;
	  },
	
	  /**
	   * @param {boolean} previouslyEnabled Enabled status of
	   *   `ReactBrowserEventEmitter` before the reconciliation occurred. `close`
	   *   restores the previous value.
	   */
	  close: function (previouslyEnabled) {
	    ReactBrowserEventEmitter.setEnabled(previouslyEnabled);
	  }
	};
	
	/**
	 * Provides a queue for collecting `componentDidMount` and
	 * `componentDidUpdate` callbacks during the transaction.
	 */
	var ON_DOM_READY_QUEUEING = {
	  /**
	   * Initializes the internal `onDOMReady` queue.
	   */
	  initialize: function () {
	    this.reactMountReady.reset();
	  },
	
	  /**
	   * After DOM is flushed, invoke all registered `onDOMReady` callbacks.
	   */
	  close: function () {
	    this.reactMountReady.notifyAll();
	  }
	};
	
	/**
	 * Executed within the scope of the `Transaction` instance. Consider these as
	 * being member methods, but with an implied ordering while being isolated from
	 * each other.
	 */
	var TRANSACTION_WRAPPERS = [SELECTION_RESTORATION, EVENT_SUPPRESSION, ON_DOM_READY_QUEUEING];
	
	if (false) {
	  TRANSACTION_WRAPPERS.push({
	    initialize: ReactInstrumentation.debugTool.onBeginFlush,
	    close: ReactInstrumentation.debugTool.onEndFlush
	  });
	}
	
	/**
	 * Currently:
	 * - The order that these are listed in the transaction is critical:
	 * - Suppresses events.
	 * - Restores selection range.
	 *
	 * Future:
	 * - Restore document/overflow scroll positions that were unintentionally
	 *   modified via DOM insertions above the top viewport boundary.
	 * - Implement/integrate with customized constraint based layout system and keep
	 *   track of which dimensions must be remeasured.
	 *
	 * @class ReactReconcileTransaction
	 */
	function ReactReconcileTransaction(useCreateElement) {
	  this.reinitializeTransaction();
	  // Only server-side rendering really needs this option (see
	  // `ReactServerRendering`), but server-side uses
	  // `ReactServerRenderingTransaction` instead. This option is here so that it's
	  // accessible and defaults to false when `ReactDOMComponent` and
	  // `ReactDOMTextComponent` checks it in `mountComponent`.`
	  this.renderToStaticMarkup = false;
	  this.reactMountReady = CallbackQueue.getPooled(null);
	  this.useCreateElement = useCreateElement;
	}
	
	var Mixin = {
	  /**
	   * @see Transaction
	   * @abstract
	   * @final
	   * @return {array<object>} List of operation wrap procedures.
	   *   TODO: convert to array<TransactionWrapper>
	   */
	  getTransactionWrappers: function () {
	    return TRANSACTION_WRAPPERS;
	  },
	
	  /**
	   * @return {object} The queue to collect `onDOMReady` callbacks with.
	   */
	  getReactMountReady: function () {
	    return this.reactMountReady;
	  },
	
	  /**
	   * @return {object} The queue to collect React async events.
	   */
	  getUpdateQueue: function () {
	    return ReactUpdateQueue;
	  },
	
	  /**
	   * Save current transaction state -- if the return value from this method is
	   * passed to `rollback`, the transaction will be reset to that state.
	   */
	  checkpoint: function () {
	    // reactMountReady is the our only stateful wrapper
	    return this.reactMountReady.checkpoint();
	  },
	
	  rollback: function (checkpoint) {
	    this.reactMountReady.rollback(checkpoint);
	  },
	
	  /**
	   * `PooledClass` looks for this, and will invoke this before allowing this
	   * instance to be reused.
	   */
	  destructor: function () {
	    CallbackQueue.release(this.reactMountReady);
	    this.reactMountReady = null;
	  }
	};
	
	_assign(ReactReconcileTransaction.prototype, Transaction.Mixin, Mixin);
	
	PooledClass.addPoolingTo(ReactReconcileTransaction);
	
	module.exports = ReactReconcileTransaction;

/***/ },
/* 342 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactRef
	 */
	
	'use strict';
	
	var ReactOwner = __webpack_require__(339);
	
	var ReactRef = {};
	
	function attachRef(ref, component, owner) {
	  if (typeof ref === 'function') {
	    ref(component.getPublicInstance());
	  } else {
	    // Legacy ref
	    ReactOwner.addComponentAsRefTo(component, ref, owner);
	  }
	}
	
	function detachRef(ref, component, owner) {
	  if (typeof ref === 'function') {
	    ref(null);
	  } else {
	    // Legacy ref
	    ReactOwner.removeComponentAsRefFrom(component, ref, owner);
	  }
	}
	
	ReactRef.attachRefs = function (instance, element) {
	  if (element === null || element === false) {
	    return;
	  }
	  var ref = element.ref;
	  if (ref != null) {
	    attachRef(ref, instance, element._owner);
	  }
	};
	
	ReactRef.shouldUpdateRefs = function (prevElement, nextElement) {
	  // If either the owner or a `ref` has changed, make sure the newest owner
	  // has stored a reference to `this`, and the previous owner (if different)
	  // has forgotten the reference to `this`. We use the element instead
	  // of the public this.props because the post processing cannot determine
	  // a ref. The ref conceptually lives on the element.
	
	  // TODO: Should this even be possible? The owner cannot change because
	  // it's forbidden by shouldUpdateReactComponent. The ref can change
	  // if you swap the keys of but not the refs. Reconsider where this check
	  // is made. It probably belongs where the key checking and
	  // instantiateReactComponent is done.
	
	  var prevEmpty = prevElement === null || prevElement === false;
	  var nextEmpty = nextElement === null || nextElement === false;
	
	  return (
	    // This has a few false positives w/r/t empty components.
	    prevEmpty || nextEmpty || nextElement.ref !== prevElement.ref ||
	    // If owner changes but we have an unchanged function ref, don't update refs
	    typeof nextElement.ref === 'string' && nextElement._owner !== prevElement._owner
	  );
	};
	
	ReactRef.detachRefs = function (instance, element) {
	  if (element === null || element === false) {
	    return;
	  }
	  var ref = element.ref;
	  if (ref != null) {
	    detachRef(ref, instance, element._owner);
	  }
	};
	
	module.exports = ReactRef;

/***/ },
/* 343 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactServerRenderingTransaction
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(6);
	
	var PooledClass = __webpack_require__(22);
	var Transaction = __webpack_require__(38);
	var ReactInstrumentation = __webpack_require__(11);
	var ReactServerUpdateQueue = __webpack_require__(344);
	
	/**
	 * Executed within the scope of the `Transaction` instance. Consider these as
	 * being member methods, but with an implied ordering while being isolated from
	 * each other.
	 */
	var TRANSACTION_WRAPPERS = [];
	
	if (false) {
	  TRANSACTION_WRAPPERS.push({
	    initialize: ReactInstrumentation.debugTool.onBeginFlush,
	    close: ReactInstrumentation.debugTool.onEndFlush
	  });
	}
	
	var noopCallbackQueue = {
	  enqueue: function () {}
	};
	
	/**
	 * @class ReactServerRenderingTransaction
	 * @param {boolean} renderToStaticMarkup
	 */
	function ReactServerRenderingTransaction(renderToStaticMarkup) {
	  this.reinitializeTransaction();
	  this.renderToStaticMarkup = renderToStaticMarkup;
	  this.useCreateElement = false;
	  this.updateQueue = new ReactServerUpdateQueue(this);
	}
	
	var Mixin = {
	  /**
	   * @see Transaction
	   * @abstract
	   * @final
	   * @return {array} Empty list of operation wrap procedures.
	   */
	  getTransactionWrappers: function () {
	    return TRANSACTION_WRAPPERS;
	  },
	
	  /**
	   * @return {object} The queue to collect `onDOMReady` callbacks with.
	   */
	  getReactMountReady: function () {
	    return noopCallbackQueue;
	  },
	
	  /**
	   * @return {object} The queue to collect React async events.
	   */
	  getUpdateQueue: function () {
	    return this.updateQueue;
	  },
	
	  /**
	   * `PooledClass` looks for this, and will invoke this before allowing this
	   * instance to be reused.
	   */
	  destructor: function () {},
	
	  checkpoint: function () {},
	
	  rollback: function () {}
	};
	
	_assign(ReactServerRenderingTransaction.prototype, Transaction.Mixin, Mixin);
	
	PooledClass.addPoolingTo(ReactServerRenderingTransaction);
	
	module.exports = ReactServerRenderingTransaction;

/***/ },
/* 344 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactServerUpdateQueue
	 * 
	 */
	
	'use strict';
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var ReactUpdateQueue = __webpack_require__(66);
	var Transaction = __webpack_require__(38);
	var warning = __webpack_require__(4);
	
	function warnNoop(publicInstance, callerName) {
	  if (false) {
	    var constructor = publicInstance.constructor;
	    process.env.NODE_ENV !== 'production' ? warning(false, '%s(...): Can only update a mounting component. ' + 'This usually means you called %s() outside componentWillMount() on the server. ' + 'This is a no-op. Please check the code for the %s component.', callerName, callerName, constructor && (constructor.displayName || constructor.name) || 'ReactClass') : void 0;
	  }
	}
	
	/**
	 * This is the update queue used for server rendering.
	 * It delegates to ReactUpdateQueue while server rendering is in progress and
	 * switches to ReactNoopUpdateQueue after the transaction has completed.
	 * @class ReactServerUpdateQueue
	 * @param {Transaction} transaction
	 */
	
	var ReactServerUpdateQueue = function () {
	  /* :: transaction: Transaction; */
	
	  function ReactServerUpdateQueue(transaction) {
	    _classCallCheck(this, ReactServerUpdateQueue);
	
	    this.transaction = transaction;
	  }
	
	  /**
	   * Checks whether or not this composite component is mounted.
	   * @param {ReactClass} publicInstance The instance we want to test.
	   * @return {boolean} True if mounted, false otherwise.
	   * @protected
	   * @final
	   */
	
	
	  ReactServerUpdateQueue.prototype.isMounted = function isMounted(publicInstance) {
	    return false;
	  };
	
	  /**
	   * Enqueue a callback that will be executed after all the pending updates
	   * have processed.
	   *
	   * @param {ReactClass} publicInstance The instance to use as `this` context.
	   * @param {?function} callback Called after state is updated.
	   * @internal
	   */
	
	
	  ReactServerUpdateQueue.prototype.enqueueCallback = function enqueueCallback(publicInstance, callback, callerName) {
	    if (this.transaction.isInTransaction()) {
	      ReactUpdateQueue.enqueueCallback(publicInstance, callback, callerName);
	    }
	  };
	
	  /**
	   * Forces an update. This should only be invoked when it is known with
	   * certainty that we are **not** in a DOM transaction.
	   *
	   * You may want to call this when you know that some deeper aspect of the
	   * component's state has changed but `setState` was not called.
	   *
	   * This will not invoke `shouldComponentUpdate`, but it will invoke
	   * `componentWillUpdate` and `componentDidUpdate`.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @internal
	   */
	
	
	  ReactServerUpdateQueue.prototype.enqueueForceUpdate = function enqueueForceUpdate(publicInstance) {
	    if (this.transaction.isInTransaction()) {
	      ReactUpdateQueue.enqueueForceUpdate(publicInstance);
	    } else {
	      warnNoop(publicInstance, 'forceUpdate');
	    }
	  };
	
	  /**
	   * Replaces all of the state. Always use this or `setState` to mutate state.
	   * You should treat `this.state` as immutable.
	   *
	   * There is no guarantee that `this.state` will be immediately updated, so
	   * accessing `this.state` after calling this method may return the old value.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object|function} completeState Next state.
	   * @internal
	   */
	
	
	  ReactServerUpdateQueue.prototype.enqueueReplaceState = function enqueueReplaceState(publicInstance, completeState) {
	    if (this.transaction.isInTransaction()) {
	      ReactUpdateQueue.enqueueReplaceState(publicInstance, completeState);
	    } else {
	      warnNoop(publicInstance, 'replaceState');
	    }
	  };
	
	  /**
	   * Sets a subset of the state. This only exists because _pendingState is
	   * internal. This provides a merging strategy that is not available to deep
	   * properties which is confusing. TODO: Expose pendingState or don't use it
	   * during the merge.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object|function} partialState Next partial state to be merged with state.
	   * @internal
	   */
	
	
	  ReactServerUpdateQueue.prototype.enqueueSetState = function enqueueSetState(publicInstance, partialState) {
	    if (this.transaction.isInTransaction()) {
	      ReactUpdateQueue.enqueueSetState(publicInstance, partialState);
	    } else {
	      warnNoop(publicInstance, 'setState');
	    }
	  };
	
	  return ReactServerUpdateQueue;
	}();
	
	module.exports = ReactServerUpdateQueue;

/***/ },
/* 345 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule SVGDOMPropertyConfig
	 */
	
	'use strict';
	
	var NS = {
	  xlink: 'http://www.w3.org/1999/xlink',
	  xml: 'http://www.w3.org/XML/1998/namespace'
	};
	
	// We use attributes for everything SVG so let's avoid some duplication and run
	// code instead.
	// The following are all specified in the HTML config already so we exclude here.
	// - class (as className)
	// - color
	// - height
	// - id
	// - lang
	// - max
	// - media
	// - method
	// - min
	// - name
	// - style
	// - target
	// - type
	// - width
	var ATTRS = {
	  accentHeight: 'accent-height',
	  accumulate: 0,
	  additive: 0,
	  alignmentBaseline: 'alignment-baseline',
	  allowReorder: 'allowReorder',
	  alphabetic: 0,
	  amplitude: 0,
	  arabicForm: 'arabic-form',
	  ascent: 0,
	  attributeName: 'attributeName',
	  attributeType: 'attributeType',
	  autoReverse: 'autoReverse',
	  azimuth: 0,
	  baseFrequency: 'baseFrequency',
	  baseProfile: 'baseProfile',
	  baselineShift: 'baseline-shift',
	  bbox: 0,
	  begin: 0,
	  bias: 0,
	  by: 0,
	  calcMode: 'calcMode',
	  capHeight: 'cap-height',
	  clip: 0,
	  clipPath: 'clip-path',
	  clipRule: 'clip-rule',
	  clipPathUnits: 'clipPathUnits',
	  colorInterpolation: 'color-interpolation',
	  colorInterpolationFilters: 'color-interpolation-filters',
	  colorProfile: 'color-profile',
	  colorRendering: 'color-rendering',
	  contentScriptType: 'contentScriptType',
	  contentStyleType: 'contentStyleType',
	  cursor: 0,
	  cx: 0,
	  cy: 0,
	  d: 0,
	  decelerate: 0,
	  descent: 0,
	  diffuseConstant: 'diffuseConstant',
	  direction: 0,
	  display: 0,
	  divisor: 0,
	  dominantBaseline: 'dominant-baseline',
	  dur: 0,
	  dx: 0,
	  dy: 0,
	  edgeMode: 'edgeMode',
	  elevation: 0,
	  enableBackground: 'enable-background',
	  end: 0,
	  exponent: 0,
	  externalResourcesRequired: 'externalResourcesRequired',
	  fill: 0,
	  fillOpacity: 'fill-opacity',
	  fillRule: 'fill-rule',
	  filter: 0,
	  filterRes: 'filterRes',
	  filterUnits: 'filterUnits',
	  floodColor: 'flood-color',
	  floodOpacity: 'flood-opacity',
	  focusable: 0,
	  fontFamily: 'font-family',
	  fontSize: 'font-size',
	  fontSizeAdjust: 'font-size-adjust',
	  fontStretch: 'font-stretch',
	  fontStyle: 'font-style',
	  fontVariant: 'font-variant',
	  fontWeight: 'font-weight',
	  format: 0,
	  from: 0,
	  fx: 0,
	  fy: 0,
	  g1: 0,
	  g2: 0,
	  glyphName: 'glyph-name',
	  glyphOrientationHorizontal: 'glyph-orientation-horizontal',
	  glyphOrientationVertical: 'glyph-orientation-vertical',
	  glyphRef: 'glyphRef',
	  gradientTransform: 'gradientTransform',
	  gradientUnits: 'gradientUnits',
	  hanging: 0,
	  horizAdvX: 'horiz-adv-x',
	  horizOriginX: 'horiz-origin-x',
	  ideographic: 0,
	  imageRendering: 'image-rendering',
	  'in': 0,
	  in2: 0,
	  intercept: 0,
	  k: 0,
	  k1: 0,
	  k2: 0,
	  k3: 0,
	  k4: 0,
	  kernelMatrix: 'kernelMatrix',
	  kernelUnitLength: 'kernelUnitLength',
	  kerning: 0,
	  keyPoints: 'keyPoints',
	  keySplines: 'keySplines',
	  keyTimes: 'keyTimes',
	  lengthAdjust: 'lengthAdjust',
	  letterSpacing: 'letter-spacing',
	  lightingColor: 'lighting-color',
	  limitingConeAngle: 'limitingConeAngle',
	  local: 0,
	  markerEnd: 'marker-end',
	  markerMid: 'marker-mid',
	  markerStart: 'marker-start',
	  markerHeight: 'markerHeight',
	  markerUnits: 'markerUnits',
	  markerWidth: 'markerWidth',
	  mask: 0,
	  maskContentUnits: 'maskContentUnits',
	  maskUnits: 'maskUnits',
	  mathematical: 0,
	  mode: 0,
	  numOctaves: 'numOctaves',
	  offset: 0,
	  opacity: 0,
	  operator: 0,
	  order: 0,
	  orient: 0,
	  orientation: 0,
	  origin: 0,
	  overflow: 0,
	  overlinePosition: 'overline-position',
	  overlineThickness: 'overline-thickness',
	  paintOrder: 'paint-order',
	  panose1: 'panose-1',
	  pathLength: 'pathLength',
	  patternContentUnits: 'patternContentUnits',
	  patternTransform: 'patternTransform',
	  patternUnits: 'patternUnits',
	  pointerEvents: 'pointer-events',
	  points: 0,
	  pointsAtX: 'pointsAtX',
	  pointsAtY: 'pointsAtY',
	  pointsAtZ: 'pointsAtZ',
	  preserveAlpha: 'preserveAlpha',
	  preserveAspectRatio: 'preserveAspectRatio',
	  primitiveUnits: 'primitiveUnits',
	  r: 0,
	  radius: 0,
	  refX: 'refX',
	  refY: 'refY',
	  renderingIntent: 'rendering-intent',
	  repeatCount: 'repeatCount',
	  repeatDur: 'repeatDur',
	  requiredExtensions: 'requiredExtensions',
	  requiredFeatures: 'requiredFeatures',
	  restart: 0,
	  result: 0,
	  rotate: 0,
	  rx: 0,
	  ry: 0,
	  scale: 0,
	  seed: 0,
	  shapeRendering: 'shape-rendering',
	  slope: 0,
	  spacing: 0,
	  specularConstant: 'specularConstant',
	  specularExponent: 'specularExponent',
	  speed: 0,
	  spreadMethod: 'spreadMethod',
	  startOffset: 'startOffset',
	  stdDeviation: 'stdDeviation',
	  stemh: 0,
	  stemv: 0,
	  stitchTiles: 'stitchTiles',
	  stopColor: 'stop-color',
	  stopOpacity: 'stop-opacity',
	  strikethroughPosition: 'strikethrough-position',
	  strikethroughThickness: 'strikethrough-thickness',
	  string: 0,
	  stroke: 0,
	  strokeDasharray: 'stroke-dasharray',
	  strokeDashoffset: 'stroke-dashoffset',
	  strokeLinecap: 'stroke-linecap',
	  strokeLinejoin: 'stroke-linejoin',
	  strokeMiterlimit: 'stroke-miterlimit',
	  strokeOpacity: 'stroke-opacity',
	  strokeWidth: 'stroke-width',
	  surfaceScale: 'surfaceScale',
	  systemLanguage: 'systemLanguage',
	  tableValues: 'tableValues',
	  targetX: 'targetX',
	  targetY: 'targetY',
	  textAnchor: 'text-anchor',
	  textDecoration: 'text-decoration',
	  textRendering: 'text-rendering',
	  textLength: 'textLength',
	  to: 0,
	  transform: 0,
	  u1: 0,
	  u2: 0,
	  underlinePosition: 'underline-position',
	  underlineThickness: 'underline-thickness',
	  unicode: 0,
	  unicodeBidi: 'unicode-bidi',
	  unicodeRange: 'unicode-range',
	  unitsPerEm: 'units-per-em',
	  vAlphabetic: 'v-alphabetic',
	  vHanging: 'v-hanging',
	  vIdeographic: 'v-ideographic',
	  vMathematical: 'v-mathematical',
	  values: 0,
	  vectorEffect: 'vector-effect',
	  version: 0,
	  vertAdvY: 'vert-adv-y',
	  vertOriginX: 'vert-origin-x',
	  vertOriginY: 'vert-origin-y',
	  viewBox: 'viewBox',
	  viewTarget: 'viewTarget',
	  visibility: 0,
	  widths: 0,
	  wordSpacing: 'word-spacing',
	  writingMode: 'writing-mode',
	  x: 0,
	  xHeight: 'x-height',
	  x1: 0,
	  x2: 0,
	  xChannelSelector: 'xChannelSelector',
	  xlinkActuate: 'xlink:actuate',
	  xlinkArcrole: 'xlink:arcrole',
	  xlinkHref: 'xlink:href',
	  xlinkRole: 'xlink:role',
	  xlinkShow: 'xlink:show',
	  xlinkTitle: 'xlink:title',
	  xlinkType: 'xlink:type',
	  xmlBase: 'xml:base',
	  xmlns: 0,
	  xmlnsXlink: 'xmlns:xlink',
	  xmlLang: 'xml:lang',
	  xmlSpace: 'xml:space',
	  y: 0,
	  y1: 0,
	  y2: 0,
	  yChannelSelector: 'yChannelSelector',
	  z: 0,
	  zoomAndPan: 'zoomAndPan'
	};
	
	var SVGDOMPropertyConfig = {
	  Properties: {},
	  DOMAttributeNamespaces: {
	    xlinkActuate: NS.xlink,
	    xlinkArcrole: NS.xlink,
	    xlinkHref: NS.xlink,
	    xlinkRole: NS.xlink,
	    xlinkShow: NS.xlink,
	    xlinkTitle: NS.xlink,
	    xlinkType: NS.xlink,
	    xmlBase: NS.xml,
	    xmlLang: NS.xml,
	    xmlSpace: NS.xml
	  },
	  DOMAttributeNames: {}
	};
	
	Object.keys(ATTRS).forEach(function (key) {
	  SVGDOMPropertyConfig.Properties[key] = 0;
	  if (ATTRS[key]) {
	    SVGDOMPropertyConfig.DOMAttributeNames[key] = ATTRS[key];
	  }
	});
	
	module.exports = SVGDOMPropertyConfig;

/***/ },
/* 346 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule SelectEventPlugin
	 */
	
	'use strict';
	
	var EventConstants = __webpack_require__(18);
	var EventPropagators = __webpack_require__(35);
	var ExecutionEnvironment = __webpack_require__(9);
	var ReactDOMComponentTree = __webpack_require__(8);
	var ReactInputSelection = __webpack_require__(112);
	var SyntheticEvent = __webpack_require__(19);
	
	var getActiveElement = __webpack_require__(81);
	var isTextInputElement = __webpack_require__(126);
	var keyOf = __webpack_require__(20);
	var shallowEqual = __webpack_require__(47);
	
	var topLevelTypes = EventConstants.topLevelTypes;
	
	var skipSelectionChangeEvent = ExecutionEnvironment.canUseDOM && 'documentMode' in document && document.documentMode <= 11;
	
	var eventTypes = {
	  select: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onSelect: null }),
	      captured: keyOf({ onSelectCapture: null })
	    },
	    dependencies: [topLevelTypes.topBlur, topLevelTypes.topContextMenu, topLevelTypes.topFocus, topLevelTypes.topKeyDown, topLevelTypes.topMouseDown, topLevelTypes.topMouseUp, topLevelTypes.topSelectionChange]
	  }
	};
	
	var activeElement = null;
	var activeElementInst = null;
	var lastSelection = null;
	var mouseDown = false;
	
	// Track whether a listener exists for this plugin. If none exist, we do
	// not extract events. See #3639.
	var hasListener = false;
	var ON_SELECT_KEY = keyOf({ onSelect: null });
	
	/**
	 * Get an object which is a unique representation of the current selection.
	 *
	 * The return value will not be consistent across nodes or browsers, but
	 * two identical selections on the same node will return identical objects.
	 *
	 * @param {DOMElement} node
	 * @return {object}
	 */
	function getSelection(node) {
	  if ('selectionStart' in node && ReactInputSelection.hasSelectionCapabilities(node)) {
	    return {
	      start: node.selectionStart,
	      end: node.selectionEnd
	    };
	  } else if (window.getSelection) {
	    var selection = window.getSelection();
	    return {
	      anchorNode: selection.anchorNode,
	      anchorOffset: selection.anchorOffset,
	      focusNode: selection.focusNode,
	      focusOffset: selection.focusOffset
	    };
	  } else if (document.selection) {
	    var range = document.selection.createRange();
	    return {
	      parentElement: range.parentElement(),
	      text: range.text,
	      top: range.boundingTop,
	      left: range.boundingLeft
	    };
	  }
	}
	
	/**
	 * Poll selection to see whether it's changed.
	 *
	 * @param {object} nativeEvent
	 * @return {?SyntheticEvent}
	 */
	function constructSelectEvent(nativeEvent, nativeEventTarget) {
	  // Ensure we have the right element, and that the user is not dragging a
	  // selection (this matches native `select` event behavior). In HTML5, select
	  // fires only on input and textarea thus if there's no focused element we
	  // won't dispatch.
	  if (mouseDown || activeElement == null || activeElement !== getActiveElement()) {
	    return null;
	  }
	
	  // Only fire when selection has actually changed.
	  var currentSelection = getSelection(activeElement);
	  if (!lastSelection || !shallowEqual(lastSelection, currentSelection)) {
	    lastSelection = currentSelection;
	
	    var syntheticEvent = SyntheticEvent.getPooled(eventTypes.select, activeElementInst, nativeEvent, nativeEventTarget);
	
	    syntheticEvent.type = 'select';
	    syntheticEvent.target = activeElement;
	
	    EventPropagators.accumulateTwoPhaseDispatches(syntheticEvent);
	
	    return syntheticEvent;
	  }
	
	  return null;
	}
	
	/**
	 * This plugin creates an `onSelect` event that normalizes select events
	 * across form elements.
	 *
	 * Supported elements are:
	 * - input (see `isTextInputElement`)
	 * - textarea
	 * - contentEditable
	 *
	 * This differs from native browser implementations in the following ways:
	 * - Fires on contentEditable fields as well as inputs.
	 * - Fires for collapsed selection.
	 * - Fires after user input.
	 */
	var SelectEventPlugin = {
	
	  eventTypes: eventTypes,
	
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    if (!hasListener) {
	      return null;
	    }
	
	    var targetNode = targetInst ? ReactDOMComponentTree.getNodeFromInstance(targetInst) : window;
	
	    switch (topLevelType) {
	      // Track the input node that has focus.
	      case topLevelTypes.topFocus:
	        if (isTextInputElement(targetNode) || targetNode.contentEditable === 'true') {
	          activeElement = targetNode;
	          activeElementInst = targetInst;
	          lastSelection = null;
	        }
	        break;
	      case topLevelTypes.topBlur:
	        activeElement = null;
	        activeElementInst = null;
	        lastSelection = null;
	        break;
	
	      // Don't fire the event while the user is dragging. This matches the
	      // semantics of the native select event.
	      case topLevelTypes.topMouseDown:
	        mouseDown = true;
	        break;
	      case topLevelTypes.topContextMenu:
	      case topLevelTypes.topMouseUp:
	        mouseDown = false;
	        return constructSelectEvent(nativeEvent, nativeEventTarget);
	
	      // Chrome and IE fire non-standard event when selection is changed (and
	      // sometimes when it hasn't). IE's event fires out of order with respect
	      // to key and input events on deletion, so we discard it.
	      //
	      // Firefox doesn't support selectionchange, so check selection status
	      // after each key entry. The selection changes after keydown and before
	      // keyup, but we check on keydown as well in the case of holding down a
	      // key, when multiple keydown events are fired but only one keyup is.
	      // This is also our approach for IE handling, for the reason above.
	      case topLevelTypes.topSelectionChange:
	        if (skipSelectionChangeEvent) {
	          break;
	        }
	      // falls through
	      case topLevelTypes.topKeyDown:
	      case topLevelTypes.topKeyUp:
	        return constructSelectEvent(nativeEvent, nativeEventTarget);
	    }
	
	    return null;
	  },
	
	  didPutListener: function (inst, registrationName, listener) {
	    if (registrationName === ON_SELECT_KEY) {
	      hasListener = true;
	    }
	  }
	};
	
	module.exports = SelectEventPlugin;

/***/ },
/* 347 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule SimpleEventPlugin
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(3);
	
	var EventConstants = __webpack_require__(18);
	var EventListener = __webpack_require__(79);
	var EventPropagators = __webpack_require__(35);
	var ReactDOMComponentTree = __webpack_require__(8);
	var SyntheticAnimationEvent = __webpack_require__(348);
	var SyntheticClipboardEvent = __webpack_require__(349);
	var SyntheticEvent = __webpack_require__(19);
	var SyntheticFocusEvent = __webpack_require__(352);
	var SyntheticKeyboardEvent = __webpack_require__(354);
	var SyntheticMouseEvent = __webpack_require__(44);
	var SyntheticDragEvent = __webpack_require__(351);
	var SyntheticTouchEvent = __webpack_require__(355);
	var SyntheticTransitionEvent = __webpack_require__(356);
	var SyntheticUIEvent = __webpack_require__(37);
	var SyntheticWheelEvent = __webpack_require__(357);
	
	var emptyFunction = __webpack_require__(10);
	var getEventCharCode = __webpack_require__(68);
	var invariant = __webpack_require__(2);
	var keyOf = __webpack_require__(20);
	
	var topLevelTypes = EventConstants.topLevelTypes;
	
	var eventTypes = {
	  abort: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onAbort: true }),
	      captured: keyOf({ onAbortCapture: true })
	    }
	  },
	  animationEnd: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onAnimationEnd: true }),
	      captured: keyOf({ onAnimationEndCapture: true })
	    }
	  },
	  animationIteration: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onAnimationIteration: true }),
	      captured: keyOf({ onAnimationIterationCapture: true })
	    }
	  },
	  animationStart: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onAnimationStart: true }),
	      captured: keyOf({ onAnimationStartCapture: true })
	    }
	  },
	  blur: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onBlur: true }),
	      captured: keyOf({ onBlurCapture: true })
	    }
	  },
	  canPlay: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onCanPlay: true }),
	      captured: keyOf({ onCanPlayCapture: true })
	    }
	  },
	  canPlayThrough: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onCanPlayThrough: true }),
	      captured: keyOf({ onCanPlayThroughCapture: true })
	    }
	  },
	  click: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onClick: true }),
	      captured: keyOf({ onClickCapture: true })
	    }
	  },
	  contextMenu: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onContextMenu: true }),
	      captured: keyOf({ onContextMenuCapture: true })
	    }
	  },
	  copy: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onCopy: true }),
	      captured: keyOf({ onCopyCapture: true })
	    }
	  },
	  cut: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onCut: true }),
	      captured: keyOf({ onCutCapture: true })
	    }
	  },
	  doubleClick: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onDoubleClick: true }),
	      captured: keyOf({ onDoubleClickCapture: true })
	    }
	  },
	  drag: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onDrag: true }),
	      captured: keyOf({ onDragCapture: true })
	    }
	  },
	  dragEnd: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onDragEnd: true }),
	      captured: keyOf({ onDragEndCapture: true })
	    }
	  },
	  dragEnter: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onDragEnter: true }),
	      captured: keyOf({ onDragEnterCapture: true })
	    }
	  },
	  dragExit: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onDragExit: true }),
	      captured: keyOf({ onDragExitCapture: true })
	    }
	  },
	  dragLeave: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onDragLeave: true }),
	      captured: keyOf({ onDragLeaveCapture: true })
	    }
	  },
	  dragOver: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onDragOver: true }),
	      captured: keyOf({ onDragOverCapture: true })
	    }
	  },
	  dragStart: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onDragStart: true }),
	      captured: keyOf({ onDragStartCapture: true })
	    }
	  },
	  drop: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onDrop: true }),
	      captured: keyOf({ onDropCapture: true })
	    }
	  },
	  durationChange: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onDurationChange: true }),
	      captured: keyOf({ onDurationChangeCapture: true })
	    }
	  },
	  emptied: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onEmptied: true }),
	      captured: keyOf({ onEmptiedCapture: true })
	    }
	  },
	  encrypted: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onEncrypted: true }),
	      captured: keyOf({ onEncryptedCapture: true })
	    }
	  },
	  ended: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onEnded: true }),
	      captured: keyOf({ onEndedCapture: true })
	    }
	  },
	  error: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onError: true }),
	      captured: keyOf({ onErrorCapture: true })
	    }
	  },
	  focus: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onFocus: true }),
	      captured: keyOf({ onFocusCapture: true })
	    }
	  },
	  input: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onInput: true }),
	      captured: keyOf({ onInputCapture: true })
	    }
	  },
	  invalid: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onInvalid: true }),
	      captured: keyOf({ onInvalidCapture: true })
	    }
	  },
	  keyDown: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onKeyDown: true }),
	      captured: keyOf({ onKeyDownCapture: true })
	    }
	  },
	  keyPress: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onKeyPress: true }),
	      captured: keyOf({ onKeyPressCapture: true })
	    }
	  },
	  keyUp: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onKeyUp: true }),
	      captured: keyOf({ onKeyUpCapture: true })
	    }
	  },
	  load: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onLoad: true }),
	      captured: keyOf({ onLoadCapture: true })
	    }
	  },
	  loadedData: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onLoadedData: true }),
	      captured: keyOf({ onLoadedDataCapture: true })
	    }
	  },
	  loadedMetadata: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onLoadedMetadata: true }),
	      captured: keyOf({ onLoadedMetadataCapture: true })
	    }
	  },
	  loadStart: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onLoadStart: true }),
	      captured: keyOf({ onLoadStartCapture: true })
	    }
	  },
	  // Note: We do not allow listening to mouseOver events. Instead, use the
	  // onMouseEnter/onMouseLeave created by `EnterLeaveEventPlugin`.
	  mouseDown: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onMouseDown: true }),
	      captured: keyOf({ onMouseDownCapture: true })
	    }
	  },
	  mouseMove: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onMouseMove: true }),
	      captured: keyOf({ onMouseMoveCapture: true })
	    }
	  },
	  mouseOut: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onMouseOut: true }),
	      captured: keyOf({ onMouseOutCapture: true })
	    }
	  },
	  mouseOver: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onMouseOver: true }),
	      captured: keyOf({ onMouseOverCapture: true })
	    }
	  },
	  mouseUp: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onMouseUp: true }),
	      captured: keyOf({ onMouseUpCapture: true })
	    }
	  },
	  paste: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onPaste: true }),
	      captured: keyOf({ onPasteCapture: true })
	    }
	  },
	  pause: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onPause: true }),
	      captured: keyOf({ onPauseCapture: true })
	    }
	  },
	  play: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onPlay: true }),
	      captured: keyOf({ onPlayCapture: true })
	    }
	  },
	  playing: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onPlaying: true }),
	      captured: keyOf({ onPlayingCapture: true })
	    }
	  },
	  progress: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onProgress: true }),
	      captured: keyOf({ onProgressCapture: true })
	    }
	  },
	  rateChange: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onRateChange: true }),
	      captured: keyOf({ onRateChangeCapture: true })
	    }
	  },
	  reset: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onReset: true }),
	      captured: keyOf({ onResetCapture: true })
	    }
	  },
	  scroll: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onScroll: true }),
	      captured: keyOf({ onScrollCapture: true })
	    }
	  },
	  seeked: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onSeeked: true }),
	      captured: keyOf({ onSeekedCapture: true })
	    }
	  },
	  seeking: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onSeeking: true }),
	      captured: keyOf({ onSeekingCapture: true })
	    }
	  },
	  stalled: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onStalled: true }),
	      captured: keyOf({ onStalledCapture: true })
	    }
	  },
	  submit: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onSubmit: true }),
	      captured: keyOf({ onSubmitCapture: true })
	    }
	  },
	  suspend: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onSuspend: true }),
	      captured: keyOf({ onSuspendCapture: true })
	    }
	  },
	  timeUpdate: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onTimeUpdate: true }),
	      captured: keyOf({ onTimeUpdateCapture: true })
	    }
	  },
	  touchCancel: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onTouchCancel: true }),
	      captured: keyOf({ onTouchCancelCapture: true })
	    }
	  },
	  touchEnd: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onTouchEnd: true }),
	      captured: keyOf({ onTouchEndCapture: true })
	    }
	  },
	  touchMove: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onTouchMove: true }),
	      captured: keyOf({ onTouchMoveCapture: true })
	    }
	  },
	  touchStart: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onTouchStart: true }),
	      captured: keyOf({ onTouchStartCapture: true })
	    }
	  },
	  transitionEnd: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onTransitionEnd: true }),
	      captured: keyOf({ onTransitionEndCapture: true })
	    }
	  },
	  volumeChange: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onVolumeChange: true }),
	      captured: keyOf({ onVolumeChangeCapture: true })
	    }
	  },
	  waiting: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onWaiting: true }),
	      captured: keyOf({ onWaitingCapture: true })
	    }
	  },
	  wheel: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onWheel: true }),
	      captured: keyOf({ onWheelCapture: true })
	    }
	  }
	};
	
	var topLevelEventsToDispatchConfig = {
	  topAbort: eventTypes.abort,
	  topAnimationEnd: eventTypes.animationEnd,
	  topAnimationIteration: eventTypes.animationIteration,
	  topAnimationStart: eventTypes.animationStart,
	  topBlur: eventTypes.blur,
	  topCanPlay: eventTypes.canPlay,
	  topCanPlayThrough: eventTypes.canPlayThrough,
	  topClick: eventTypes.click,
	  topContextMenu: eventTypes.contextMenu,
	  topCopy: eventTypes.copy,
	  topCut: eventTypes.cut,
	  topDoubleClick: eventTypes.doubleClick,
	  topDrag: eventTypes.drag,
	  topDragEnd: eventTypes.dragEnd,
	  topDragEnter: eventTypes.dragEnter,
	  topDragExit: eventTypes.dragExit,
	  topDragLeave: eventTypes.dragLeave,
	  topDragOver: eventTypes.dragOver,
	  topDragStart: eventTypes.dragStart,
	  topDrop: eventTypes.drop,
	  topDurationChange: eventTypes.durationChange,
	  topEmptied: eventTypes.emptied,
	  topEncrypted: eventTypes.encrypted,
	  topEnded: eventTypes.ended,
	  topError: eventTypes.error,
	  topFocus: eventTypes.focus,
	  topInput: eventTypes.input,
	  topInvalid: eventTypes.invalid,
	  topKeyDown: eventTypes.keyDown,
	  topKeyPress: eventTypes.keyPress,
	  topKeyUp: eventTypes.keyUp,
	  topLoad: eventTypes.load,
	  topLoadedData: eventTypes.loadedData,
	  topLoadedMetadata: eventTypes.loadedMetadata,
	  topLoadStart: eventTypes.loadStart,
	  topMouseDown: eventTypes.mouseDown,
	  topMouseMove: eventTypes.mouseMove,
	  topMouseOut: eventTypes.mouseOut,
	  topMouseOver: eventTypes.mouseOver,
	  topMouseUp: eventTypes.mouseUp,
	  topPaste: eventTypes.paste,
	  topPause: eventTypes.pause,
	  topPlay: eventTypes.play,
	  topPlaying: eventTypes.playing,
	  topProgress: eventTypes.progress,
	  topRateChange: eventTypes.rateChange,
	  topReset: eventTypes.reset,
	  topScroll: eventTypes.scroll,
	  topSeeked: eventTypes.seeked,
	  topSeeking: eventTypes.seeking,
	  topStalled: eventTypes.stalled,
	  topSubmit: eventTypes.submit,
	  topSuspend: eventTypes.suspend,
	  topTimeUpdate: eventTypes.timeUpdate,
	  topTouchCancel: eventTypes.touchCancel,
	  topTouchEnd: eventTypes.touchEnd,
	  topTouchMove: eventTypes.touchMove,
	  topTouchStart: eventTypes.touchStart,
	  topTransitionEnd: eventTypes.transitionEnd,
	  topVolumeChange: eventTypes.volumeChange,
	  topWaiting: eventTypes.waiting,
	  topWheel: eventTypes.wheel
	};
	
	for (var type in topLevelEventsToDispatchConfig) {
	  topLevelEventsToDispatchConfig[type].dependencies = [type];
	}
	
	var ON_CLICK_KEY = keyOf({ onClick: null });
	var onClickListeners = {};
	
	function getDictionaryKey(inst) {
	  // Prevents V8 performance issue:
	  // https://github.com/facebook/react/pull/7232
	  return '.' + inst._rootNodeID;
	}
	
	var SimpleEventPlugin = {
	
	  eventTypes: eventTypes,
	
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    var dispatchConfig = topLevelEventsToDispatchConfig[topLevelType];
	    if (!dispatchConfig) {
	      return null;
	    }
	    var EventConstructor;
	    switch (topLevelType) {
	      case topLevelTypes.topAbort:
	      case topLevelTypes.topCanPlay:
	      case topLevelTypes.topCanPlayThrough:
	      case topLevelTypes.topDurationChange:
	      case topLevelTypes.topEmptied:
	      case topLevelTypes.topEncrypted:
	      case topLevelTypes.topEnded:
	      case topLevelTypes.topError:
	      case topLevelTypes.topInput:
	      case topLevelTypes.topInvalid:
	      case topLevelTypes.topLoad:
	      case topLevelTypes.topLoadedData:
	      case topLevelTypes.topLoadedMetadata:
	      case topLevelTypes.topLoadStart:
	      case topLevelTypes.topPause:
	      case topLevelTypes.topPlay:
	      case topLevelTypes.topPlaying:
	      case topLevelTypes.topProgress:
	      case topLevelTypes.topRateChange:
	      case topLevelTypes.topReset:
	      case topLevelTypes.topSeeked:
	      case topLevelTypes.topSeeking:
	      case topLevelTypes.topStalled:
	      case topLevelTypes.topSubmit:
	      case topLevelTypes.topSuspend:
	      case topLevelTypes.topTimeUpdate:
	      case topLevelTypes.topVolumeChange:
	      case topLevelTypes.topWaiting:
	        // HTML Events
	        // @see http://www.w3.org/TR/html5/index.html#events-0
	        EventConstructor = SyntheticEvent;
	        break;
	      case topLevelTypes.topKeyPress:
	        // Firefox creates a keypress event for function keys too. This removes
	        // the unwanted keypress events. Enter is however both printable and
	        // non-printable. One would expect Tab to be as well (but it isn't).
	        if (getEventCharCode(nativeEvent) === 0) {
	          return null;
	        }
	      /* falls through */
	      case topLevelTypes.topKeyDown:
	      case topLevelTypes.topKeyUp:
	        EventConstructor = SyntheticKeyboardEvent;
	        break;
	      case topLevelTypes.topBlur:
	      case topLevelTypes.topFocus:
	        EventConstructor = SyntheticFocusEvent;
	        break;
	      case topLevelTypes.topClick:
	        // Firefox creates a click event on right mouse clicks. This removes the
	        // unwanted click events.
	        if (nativeEvent.button === 2) {
	          return null;
	        }
	      /* falls through */
	      case topLevelTypes.topContextMenu:
	      case topLevelTypes.topDoubleClick:
	      case topLevelTypes.topMouseDown:
	      case topLevelTypes.topMouseMove:
	      case topLevelTypes.topMouseOut:
	      case topLevelTypes.topMouseOver:
	      case topLevelTypes.topMouseUp:
	        EventConstructor = SyntheticMouseEvent;
	        break;
	      case topLevelTypes.topDrag:
	      case topLevelTypes.topDragEnd:
	      case topLevelTypes.topDragEnter:
	      case topLevelTypes.topDragExit:
	      case topLevelTypes.topDragLeave:
	      case topLevelTypes.topDragOver:
	      case topLevelTypes.topDragStart:
	      case topLevelTypes.topDrop:
	        EventConstructor = SyntheticDragEvent;
	        break;
	      case topLevelTypes.topTouchCancel:
	      case topLevelTypes.topTouchEnd:
	      case topLevelTypes.topTouchMove:
	      case topLevelTypes.topTouchStart:
	        EventConstructor = SyntheticTouchEvent;
	        break;
	      case topLevelTypes.topAnimationEnd:
	      case topLevelTypes.topAnimationIteration:
	      case topLevelTypes.topAnimationStart:
	        EventConstructor = SyntheticAnimationEvent;
	        break;
	      case topLevelTypes.topTransitionEnd:
	        EventConstructor = SyntheticTransitionEvent;
	        break;
	      case topLevelTypes.topScroll:
	        EventConstructor = SyntheticUIEvent;
	        break;
	      case topLevelTypes.topWheel:
	        EventConstructor = SyntheticWheelEvent;
	        break;
	      case topLevelTypes.topCopy:
	      case topLevelTypes.topCut:
	      case topLevelTypes.topPaste:
	        EventConstructor = SyntheticClipboardEvent;
	        break;
	    }
	    !EventConstructor ?  false ? invariant(false, 'SimpleEventPlugin: Unhandled event type, `%s`.', topLevelType) : _prodInvariant('86', topLevelType) : void 0;
	    var event = EventConstructor.getPooled(dispatchConfig, targetInst, nativeEvent, nativeEventTarget);
	    EventPropagators.accumulateTwoPhaseDispatches(event);
	    return event;
	  },
	
	  didPutListener: function (inst, registrationName, listener) {
	    // Mobile Safari does not fire properly bubble click events on
	    // non-interactive elements, which means delegated click listeners do not
	    // fire. The workaround for this bug involves attaching an empty click
	    // listener on the target node.
	    if (registrationName === ON_CLICK_KEY) {
	      var key = getDictionaryKey(inst);
	      var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	      if (!onClickListeners[key]) {
	        onClickListeners[key] = EventListener.listen(node, 'click', emptyFunction);
	      }
	    }
	  },
	
	  willDeleteListener: function (inst, registrationName) {
	    if (registrationName === ON_CLICK_KEY) {
	      var key = getDictionaryKey(inst);
	      onClickListeners[key].remove();
	      delete onClickListeners[key];
	    }
	  }
	
	};
	
	module.exports = SimpleEventPlugin;

/***/ },
/* 348 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule SyntheticAnimationEvent
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(19);
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/css3-animations/#AnimationEvent-interface
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/AnimationEvent
	 */
	var AnimationEventInterface = {
	  animationName: null,
	  elapsedTime: null,
	  pseudoElement: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticEvent}
	 */
	function SyntheticAnimationEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticAnimationEvent, AnimationEventInterface);
	
	module.exports = SyntheticAnimationEvent;

/***/ },
/* 349 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule SyntheticClipboardEvent
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(19);
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/clipboard-apis/
	 */
	var ClipboardEventInterface = {
	  clipboardData: function (event) {
	    return 'clipboardData' in event ? event.clipboardData : window.clipboardData;
	  }
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticClipboardEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticClipboardEvent, ClipboardEventInterface);
	
	module.exports = SyntheticClipboardEvent;

/***/ },
/* 350 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule SyntheticCompositionEvent
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(19);
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/#events-compositionevents
	 */
	var CompositionEventInterface = {
	  data: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticCompositionEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticCompositionEvent, CompositionEventInterface);
	
	module.exports = SyntheticCompositionEvent;

/***/ },
/* 351 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule SyntheticDragEvent
	 */
	
	'use strict';
	
	var SyntheticMouseEvent = __webpack_require__(44);
	
	/**
	 * @interface DragEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var DragEventInterface = {
	  dataTransfer: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticDragEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticMouseEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticMouseEvent.augmentClass(SyntheticDragEvent, DragEventInterface);
	
	module.exports = SyntheticDragEvent;

/***/ },
/* 352 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule SyntheticFocusEvent
	 */
	
	'use strict';
	
	var SyntheticUIEvent = __webpack_require__(37);
	
	/**
	 * @interface FocusEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var FocusEventInterface = {
	  relatedTarget: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticFocusEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticUIEvent.augmentClass(SyntheticFocusEvent, FocusEventInterface);
	
	module.exports = SyntheticFocusEvent;

/***/ },
/* 353 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule SyntheticInputEvent
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(19);
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/2013/WD-DOM-Level-3-Events-20131105
	 *      /#events-inputevents
	 */
	var InputEventInterface = {
	  data: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticInputEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticInputEvent, InputEventInterface);
	
	module.exports = SyntheticInputEvent;

/***/ },
/* 354 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule SyntheticKeyboardEvent
	 */
	
	'use strict';
	
	var SyntheticUIEvent = __webpack_require__(37);
	
	var getEventCharCode = __webpack_require__(68);
	var getEventKey = __webpack_require__(363);
	var getEventModifierState = __webpack_require__(69);
	
	/**
	 * @interface KeyboardEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var KeyboardEventInterface = {
	  key: getEventKey,
	  location: null,
	  ctrlKey: null,
	  shiftKey: null,
	  altKey: null,
	  metaKey: null,
	  repeat: null,
	  locale: null,
	  getModifierState: getEventModifierState,
	  // Legacy Interface
	  charCode: function (event) {
	    // `charCode` is the result of a KeyPress event and represents the value of
	    // the actual printable character.
	
	    // KeyPress is deprecated, but its replacement is not yet final and not
	    // implemented in any major browser. Only KeyPress has charCode.
	    if (event.type === 'keypress') {
	      return getEventCharCode(event);
	    }
	    return 0;
	  },
	  keyCode: function (event) {
	    // `keyCode` is the result of a KeyDown/Up event and represents the value of
	    // physical keyboard key.
	
	    // The actual meaning of the value depends on the users' keyboard layout
	    // which cannot be detected. Assuming that it is a US keyboard layout
	    // provides a surprisingly accurate mapping for US and European users.
	    // Due to this, it is left to the user to implement at this time.
	    if (event.type === 'keydown' || event.type === 'keyup') {
	      return event.keyCode;
	    }
	    return 0;
	  },
	  which: function (event) {
	    // `which` is an alias for either `keyCode` or `charCode` depending on the
	    // type of the event.
	    if (event.type === 'keypress') {
	      return getEventCharCode(event);
	    }
	    if (event.type === 'keydown' || event.type === 'keyup') {
	      return event.keyCode;
	    }
	    return 0;
	  }
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticKeyboardEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticUIEvent.augmentClass(SyntheticKeyboardEvent, KeyboardEventInterface);
	
	module.exports = SyntheticKeyboardEvent;

/***/ },
/* 355 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule SyntheticTouchEvent
	 */
	
	'use strict';
	
	var SyntheticUIEvent = __webpack_require__(37);
	
	var getEventModifierState = __webpack_require__(69);
	
	/**
	 * @interface TouchEvent
	 * @see http://www.w3.org/TR/touch-events/
	 */
	var TouchEventInterface = {
	  touches: null,
	  targetTouches: null,
	  changedTouches: null,
	  altKey: null,
	  metaKey: null,
	  ctrlKey: null,
	  shiftKey: null,
	  getModifierState: getEventModifierState
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticTouchEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticUIEvent.augmentClass(SyntheticTouchEvent, TouchEventInterface);
	
	module.exports = SyntheticTouchEvent;

/***/ },
/* 356 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule SyntheticTransitionEvent
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(19);
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/2009/WD-css3-transitions-20090320/#transition-events-
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/TransitionEvent
	 */
	var TransitionEventInterface = {
	  propertyName: null,
	  elapsedTime: null,
	  pseudoElement: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticEvent}
	 */
	function SyntheticTransitionEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticTransitionEvent, TransitionEventInterface);
	
	module.exports = SyntheticTransitionEvent;

/***/ },
/* 357 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule SyntheticWheelEvent
	 */
	
	'use strict';
	
	var SyntheticMouseEvent = __webpack_require__(44);
	
	/**
	 * @interface WheelEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var WheelEventInterface = {
	  deltaX: function (event) {
	    return 'deltaX' in event ? event.deltaX :
	    // Fallback to `wheelDeltaX` for Webkit and normalize (right is positive).
	    'wheelDeltaX' in event ? -event.wheelDeltaX : 0;
	  },
	  deltaY: function (event) {
	    return 'deltaY' in event ? event.deltaY :
	    // Fallback to `wheelDeltaY` for Webkit and normalize (down is positive).
	    'wheelDeltaY' in event ? -event.wheelDeltaY :
	    // Fallback to `wheelDelta` for IE<9 and normalize (down is positive).
	    'wheelDelta' in event ? -event.wheelDelta : 0;
	  },
	  deltaZ: null,
	
	  // Browsers without "deltaMode" is reporting in raw wheel delta where one
	  // notch on the scroll is always +/- 120, roughly equivalent to pixels.
	  // A good approximation of DOM_DELTA_LINE (1) is 5% of viewport size or
	  // ~40 pixels, for DOM_DELTA_SCREEN (2) it is 87.5% of viewport size.
	  deltaMode: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticMouseEvent}
	 */
	function SyntheticWheelEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticMouseEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticMouseEvent.augmentClass(SyntheticWheelEvent, WheelEventInterface);
	
	module.exports = SyntheticWheelEvent;

/***/ },
/* 358 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule adler32
	 * 
	 */
	
	'use strict';
	
	var MOD = 65521;
	
	// adler32 is not cryptographically strong, and is only used to sanity check that
	// markup generated on the server matches the markup generated on the client.
	// This implementation (a modified version of the SheetJS version) has been optimized
	// for our use case, at the expense of conforming to the adler32 specification
	// for non-ascii inputs.
	function adler32(data) {
	  var a = 1;
	  var b = 0;
	  var i = 0;
	  var l = data.length;
	  var m = l & ~0x3;
	  while (i < m) {
	    var n = Math.min(i + 4096, m);
	    for (; i < n; i += 4) {
	      b += (a += data.charCodeAt(i)) + (a += data.charCodeAt(i + 1)) + (a += data.charCodeAt(i + 2)) + (a += data.charCodeAt(i + 3));
	    }
	    a %= MOD;
	    b %= MOD;
	  }
	  for (; i < l; i++) {
	    b += a += data.charCodeAt(i);
	  }
	  a %= MOD;
	  b %= MOD;
	  return a | b << 16;
	}
	
	module.exports = adler32;

/***/ },
/* 359 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule checkReactTypeSpec
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(3);
	
	var ReactPropTypeLocationNames = __webpack_require__(63);
	var ReactPropTypesSecret = __webpack_require__(65);
	
	var invariant = __webpack_require__(2);
	var warning = __webpack_require__(4);
	
	var ReactComponentTreeHook;
	
	if (typeof process !== 'undefined' && process.env && ("production") === 'test') {
	  // Temporary hack.
	  // Inline requires don't work well with Jest:
	  // https://github.com/facebook/react/issues/7240
	  // Remove the inline requires when we don't need them anymore:
	  // https://github.com/facebook/react/pull/7178
	  ReactComponentTreeHook = __webpack_require__(60);
	}
	
	var loggedTypeFailures = {};
	
	/**
	 * Assert that the values match with the type specs.
	 * Error messages are memorized and will only be shown once.
	 *
	 * @param {object} typeSpecs Map of name to a ReactPropType
	 * @param {object} values Runtime values that need to be type-checked
	 * @param {string} location e.g. "prop", "context", "child context"
	 * @param {string} componentName Name of the component for error messages.
	 * @param {?object} element The React element that is being type-checked
	 * @param {?number} debugID The React component instance that is being type-checked
	 * @private
	 */
	function checkReactTypeSpec(typeSpecs, values, location, componentName, element, debugID) {
	  for (var typeSpecName in typeSpecs) {
	    if (typeSpecs.hasOwnProperty(typeSpecName)) {
	      var error;
	      // Prop type validation may throw. In case they do, we don't want to
	      // fail the render phase where it didn't fail before. So we log it.
	      // After these have been cleaned up, we'll let them throw.
	      try {
	        // This is intentionally an invariant that gets caught. It's the same
	        // behavior as without this statement except with a better message.
	        !(typeof typeSpecs[typeSpecName] === 'function') ?  false ? invariant(false, '%s: %s type `%s` is invalid; it must be a function, usually from React.PropTypes.', componentName || 'React class', ReactPropTypeLocationNames[location], typeSpecName) : _prodInvariant('84', componentName || 'React class', ReactPropTypeLocationNames[location], typeSpecName) : void 0;
	        error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret);
	      } catch (ex) {
	        error = ex;
	      }
	       false ? warning(!error || error instanceof Error, '%s: type specification of %s `%s` is invalid; the type checker ' + 'function must return `null` or an `Error` but returned a %s. ' + 'You may have forgotten to pass an argument to the type checker ' + 'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' + 'shape all require an argument).', componentName || 'React class', ReactPropTypeLocationNames[location], typeSpecName, typeof error) : void 0;
	      if (error instanceof Error && !(error.message in loggedTypeFailures)) {
	        // Only monitor this failure once because there tends to be a lot of the
	        // same error.
	        loggedTypeFailures[error.message] = true;
	
	        var componentStackInfo = '';
	
	        if (false) {
	          if (!ReactComponentTreeHook) {
	            ReactComponentTreeHook = require('./ReactComponentTreeHook');
	          }
	          if (debugID !== null) {
	            componentStackInfo = ReactComponentTreeHook.getStackAddendumByID(debugID);
	          } else if (element !== null) {
	            componentStackInfo = ReactComponentTreeHook.getCurrentStackAddendum(element);
	          }
	        }
	
	         false ? warning(false, 'Failed %s type: %s%s', location, error.message, componentStackInfo) : void 0;
	      }
	    }
	  }
	}
	
	module.exports = checkReactTypeSpec;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(41)))

/***/ },
/* 360 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule dangerousStyleValue
	 */
	
	'use strict';
	
	var CSSProperty = __webpack_require__(102);
	var warning = __webpack_require__(4);
	
	var isUnitlessNumber = CSSProperty.isUnitlessNumber;
	var styleWarnings = {};
	
	/**
	 * Convert a value into the proper css writable value. The style name `name`
	 * should be logical (no hyphens), as specified
	 * in `CSSProperty.isUnitlessNumber`.
	 *
	 * @param {string} name CSS property name such as `topMargin`.
	 * @param {*} value CSS property value such as `10px`.
	 * @param {ReactDOMComponent} component
	 * @return {string} Normalized style value with dimensions applied.
	 */
	function dangerousStyleValue(name, value, component) {
	  // Note that we've removed escapeTextForBrowser() calls here since the
	  // whole string will be escaped when the attribute is injected into
	  // the markup. If you provide unsafe user data here they can inject
	  // arbitrary CSS which may be problematic (I couldn't repro this):
	  // https://www.owasp.org/index.php/XSS_Filter_Evasion_Cheat_Sheet
	  // http://www.thespanner.co.uk/2007/11/26/ultimate-xss-css-injection/
	  // This is not an XSS hole but instead a potential CSS injection issue
	  // which has lead to a greater discussion about how we're going to
	  // trust URLs moving forward. See #2115901
	
	  var isEmpty = value == null || typeof value === 'boolean' || value === '';
	  if (isEmpty) {
	    return '';
	  }
	
	  var isNonNumeric = isNaN(value);
	  if (isNonNumeric || value === 0 || isUnitlessNumber.hasOwnProperty(name) && isUnitlessNumber[name]) {
	    return '' + value; // cast to string
	  }
	
	  if (typeof value === 'string') {
	    if (false) {
	      // Allow '0' to pass through without warning. 0 is already special and
	      // doesn't require units, so we don't need to warn about it.
	      if (component && value !== '0') {
	        var owner = component._currentElement._owner;
	        var ownerName = owner ? owner.getName() : null;
	        if (ownerName && !styleWarnings[ownerName]) {
	          styleWarnings[ownerName] = {};
	        }
	        var warned = false;
	        if (ownerName) {
	          var warnings = styleWarnings[ownerName];
	          warned = warnings[name];
	          if (!warned) {
	            warnings[name] = true;
	          }
	        }
	        if (!warned) {
	          process.env.NODE_ENV !== 'production' ? warning(false, 'a `%s` tag (owner: `%s`) was passed a numeric string value ' + 'for CSS property `%s` (value: `%s`) which will be treated ' + 'as a unitless number in a future version of React.', component._currentElement.type, ownerName || 'unknown', name, value) : void 0;
	        }
	      }
	    }
	    value = value.trim();
	  }
	  return value + 'px';
	}
	
	module.exports = dangerousStyleValue;

/***/ },
/* 361 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule findDOMNode
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(3);
	
	var ReactCurrentOwner = __webpack_require__(23);
	var ReactDOMComponentTree = __webpack_require__(8);
	var ReactInstanceMap = __webpack_require__(36);
	
	var getHostComponentFromComposite = __webpack_require__(122);
	var invariant = __webpack_require__(2);
	var warning = __webpack_require__(4);
	
	/**
	 * Returns the DOM node rendered by this element.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#reactdom.finddomnode
	 *
	 * @param {ReactComponent|DOMElement} componentOrElement
	 * @return {?DOMElement} The root node of this element.
	 */
	function findDOMNode(componentOrElement) {
	  if (false) {
	    var owner = ReactCurrentOwner.current;
	    if (owner !== null) {
	      process.env.NODE_ENV !== 'production' ? warning(owner._warnedAboutRefsInRender, '%s is accessing findDOMNode inside its render(). ' + 'render() should be a pure function of props and state. It should ' + 'never access something that requires stale data from the previous ' + 'render, such as refs. Move this logic to componentDidMount and ' + 'componentDidUpdate instead.', owner.getName() || 'A component') : void 0;
	      owner._warnedAboutRefsInRender = true;
	    }
	  }
	  if (componentOrElement == null) {
	    return null;
	  }
	  if (componentOrElement.nodeType === 1) {
	    return componentOrElement;
	  }
	
	  var inst = ReactInstanceMap.get(componentOrElement);
	  if (inst) {
	    inst = getHostComponentFromComposite(inst);
	    return inst ? ReactDOMComponentTree.getNodeFromInstance(inst) : null;
	  }
	
	  if (typeof componentOrElement.render === 'function') {
	     true ?  false ? invariant(false, 'findDOMNode was called on an unmounted component.') : _prodInvariant('44') : void 0;
	  } else {
	     true ?  false ? invariant(false, 'Element appears to be neither ReactComponent nor DOMNode (keys: %s)', Object.keys(componentOrElement)) : _prodInvariant('45', Object.keys(componentOrElement)) : void 0;
	  }
	}
	
	module.exports = findDOMNode;

/***/ },
/* 362 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule flattenChildren
	 * 
	 */
	
	'use strict';
	
	var KeyEscapeUtils = __webpack_require__(56);
	var traverseAllChildren = __webpack_require__(73);
	var warning = __webpack_require__(4);
	
	var ReactComponentTreeHook;
	
	if (typeof process !== 'undefined' && process.env && ("production") === 'test') {
	  // Temporary hack.
	  // Inline requires don't work well with Jest:
	  // https://github.com/facebook/react/issues/7240
	  // Remove the inline requires when we don't need them anymore:
	  // https://github.com/facebook/react/pull/7178
	  ReactComponentTreeHook = __webpack_require__(60);
	}
	
	/**
	 * @param {function} traverseContext Context passed through traversal.
	 * @param {?ReactComponent} child React child component.
	 * @param {!string} name String name of key path to child.
	 * @param {number=} selfDebugID Optional debugID of the current internal instance.
	 */
	function flattenSingleChildIntoContext(traverseContext, child, name, selfDebugID) {
	  // We found a component instance.
	  if (traverseContext && typeof traverseContext === 'object') {
	    var result = traverseContext;
	    var keyUnique = result[name] === undefined;
	    if (false) {
	      if (!ReactComponentTreeHook) {
	        ReactComponentTreeHook = require('./ReactComponentTreeHook');
	      }
	      if (!keyUnique) {
	        process.env.NODE_ENV !== 'production' ? warning(false, 'flattenChildren(...): Encountered two children with the same key, ' + '`%s`. Child keys must be unique; when two children share a key, only ' + 'the first child will be used.%s', KeyEscapeUtils.unescape(name), ReactComponentTreeHook.getStackAddendumByID(selfDebugID)) : void 0;
	      }
	    }
	    if (keyUnique && child != null) {
	      result[name] = child;
	    }
	  }
	}
	
	/**
	 * Flattens children that are typically specified as `props.children`. Any null
	 * children will not be included in the resulting object.
	 * @return {!object} flattened children keyed by name.
	 */
	function flattenChildren(children, selfDebugID) {
	  if (children == null) {
	    return children;
	  }
	  var result = {};
	
	  if (false) {
	    traverseAllChildren(children, function (traverseContext, child, name) {
	      return flattenSingleChildIntoContext(traverseContext, child, name, selfDebugID);
	    }, result);
	  } else {
	    traverseAllChildren(children, flattenSingleChildIntoContext, result);
	  }
	  return result;
	}
	
	module.exports = flattenChildren;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(41)))

/***/ },
/* 363 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule getEventKey
	 */
	
	'use strict';
	
	var getEventCharCode = __webpack_require__(68);
	
	/**
	 * Normalization of deprecated HTML5 `key` values
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent#Key_names
	 */
	var normalizeKey = {
	  'Esc': 'Escape',
	  'Spacebar': ' ',
	  'Left': 'ArrowLeft',
	  'Up': 'ArrowUp',
	  'Right': 'ArrowRight',
	  'Down': 'ArrowDown',
	  'Del': 'Delete',
	  'Win': 'OS',
	  'Menu': 'ContextMenu',
	  'Apps': 'ContextMenu',
	  'Scroll': 'ScrollLock',
	  'MozPrintableKey': 'Unidentified'
	};
	
	/**
	 * Translation from legacy `keyCode` to HTML5 `key`
	 * Only special keys supported, all others depend on keyboard layout or browser
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent#Key_names
	 */
	var translateToKey = {
	  8: 'Backspace',
	  9: 'Tab',
	  12: 'Clear',
	  13: 'Enter',
	  16: 'Shift',
	  17: 'Control',
	  18: 'Alt',
	  19: 'Pause',
	  20: 'CapsLock',
	  27: 'Escape',
	  32: ' ',
	  33: 'PageUp',
	  34: 'PageDown',
	  35: 'End',
	  36: 'Home',
	  37: 'ArrowLeft',
	  38: 'ArrowUp',
	  39: 'ArrowRight',
	  40: 'ArrowDown',
	  45: 'Insert',
	  46: 'Delete',
	  112: 'F1', 113: 'F2', 114: 'F3', 115: 'F4', 116: 'F5', 117: 'F6',
	  118: 'F7', 119: 'F8', 120: 'F9', 121: 'F10', 122: 'F11', 123: 'F12',
	  144: 'NumLock',
	  145: 'ScrollLock',
	  224: 'Meta'
	};
	
	/**
	 * @param {object} nativeEvent Native browser event.
	 * @return {string} Normalized `key` property.
	 */
	function getEventKey(nativeEvent) {
	  if (nativeEvent.key) {
	    // Normalize inconsistent values reported by browsers due to
	    // implementations of a working draft specification.
	
	    // FireFox implements `key` but returns `MozPrintableKey` for all
	    // printable characters (normalized to `Unidentified`), ignore it.
	    var key = normalizeKey[nativeEvent.key] || nativeEvent.key;
	    if (key !== 'Unidentified') {
	      return key;
	    }
	  }
	
	  // Browser does not implement `key`, polyfill as much of it as we can.
	  if (nativeEvent.type === 'keypress') {
	    var charCode = getEventCharCode(nativeEvent);
	
	    // The enter-key is technically both printable and non-printable and can
	    // thus be captured by `keypress`, no other non-printable key should.
	    return charCode === 13 ? 'Enter' : String.fromCharCode(charCode);
	  }
	  if (nativeEvent.type === 'keydown' || nativeEvent.type === 'keyup') {
	    // While user keyboard layout determines the actual meaning of each
	    // `keyCode` value, almost all function keys have a universal value.
	    return translateToKey[nativeEvent.keyCode] || 'Unidentified';
	  }
	  return '';
	}
	
	module.exports = getEventKey;

/***/ },
/* 364 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule getNodeForCharacterOffset
	 */
	
	'use strict';
	
	/**
	 * Given any node return the first leaf node without children.
	 *
	 * @param {DOMElement|DOMTextNode} node
	 * @return {DOMElement|DOMTextNode}
	 */
	
	function getLeafNode(node) {
	  while (node && node.firstChild) {
	    node = node.firstChild;
	  }
	  return node;
	}
	
	/**
	 * Get the next sibling within a container. This will walk up the
	 * DOM if a node's siblings have been exhausted.
	 *
	 * @param {DOMElement|DOMTextNode} node
	 * @return {?DOMElement|DOMTextNode}
	 */
	function getSiblingNode(node) {
	  while (node) {
	    if (node.nextSibling) {
	      return node.nextSibling;
	    }
	    node = node.parentNode;
	  }
	}
	
	/**
	 * Get object describing the nodes which contain characters at offset.
	 *
	 * @param {DOMElement|DOMTextNode} root
	 * @param {number} offset
	 * @return {?object}
	 */
	function getNodeForCharacterOffset(root, offset) {
	  var node = getLeafNode(root);
	  var nodeStart = 0;
	  var nodeEnd = 0;
	
	  while (node) {
	    if (node.nodeType === 3) {
	      nodeEnd = nodeStart + node.textContent.length;
	
	      if (nodeStart <= offset && nodeEnd >= offset) {
	        return {
	          node: node,
	          offset: offset - nodeStart
	        };
	      }
	
	      nodeStart = nodeEnd;
	    }
	
	    node = getLeafNode(getSiblingNode(node));
	  }
	}
	
	module.exports = getNodeForCharacterOffset;

/***/ },
/* 365 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule getVendorPrefixedEventName
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(9);
	
	/**
	 * Generate a mapping of standard vendor prefixes using the defined style property and event name.
	 *
	 * @param {string} styleProp
	 * @param {string} eventName
	 * @returns {object}
	 */
	function makePrefixMap(styleProp, eventName) {
	  var prefixes = {};
	
	  prefixes[styleProp.toLowerCase()] = eventName.toLowerCase();
	  prefixes['Webkit' + styleProp] = 'webkit' + eventName;
	  prefixes['Moz' + styleProp] = 'moz' + eventName;
	  prefixes['ms' + styleProp] = 'MS' + eventName;
	  prefixes['O' + styleProp] = 'o' + eventName.toLowerCase();
	
	  return prefixes;
	}
	
	/**
	 * A list of event names to a configurable list of vendor prefixes.
	 */
	var vendorPrefixes = {
	  animationend: makePrefixMap('Animation', 'AnimationEnd'),
	  animationiteration: makePrefixMap('Animation', 'AnimationIteration'),
	  animationstart: makePrefixMap('Animation', 'AnimationStart'),
	  transitionend: makePrefixMap('Transition', 'TransitionEnd')
	};
	
	/**
	 * Event names that have already been detected and prefixed (if applicable).
	 */
	var prefixedEventNames = {};
	
	/**
	 * Element to check for prefixes on.
	 */
	var style = {};
	
	/**
	 * Bootstrap if a DOM exists.
	 */
	if (ExecutionEnvironment.canUseDOM) {
	  style = document.createElement('div').style;
	
	  // On some platforms, in particular some releases of Android 4.x,
	  // the un-prefixed "animation" and "transition" properties are defined on the
	  // style object but the events that fire will still be prefixed, so we need
	  // to check if the un-prefixed events are usable, and if not remove them from the map.
	  if (!('AnimationEvent' in window)) {
	    delete vendorPrefixes.animationend.animation;
	    delete vendorPrefixes.animationiteration.animation;
	    delete vendorPrefixes.animationstart.animation;
	  }
	
	  // Same as above
	  if (!('TransitionEvent' in window)) {
	    delete vendorPrefixes.transitionend.transition;
	  }
	}
	
	/**
	 * Attempts to determine the correct vendor prefixed event name.
	 *
	 * @param {string} eventName
	 * @returns {string}
	 */
	function getVendorPrefixedEventName(eventName) {
	  if (prefixedEventNames[eventName]) {
	    return prefixedEventNames[eventName];
	  } else if (!vendorPrefixes[eventName]) {
	    return eventName;
	  }
	
	  var prefixMap = vendorPrefixes[eventName];
	
	  for (var styleProp in prefixMap) {
	    if (prefixMap.hasOwnProperty(styleProp) && styleProp in style) {
	      return prefixedEventNames[eventName] = prefixMap[styleProp];
	    }
	  }
	
	  return '';
	}
	
	module.exports = getVendorPrefixedEventName;

/***/ },
/* 366 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule onlyChild
	 */
	'use strict';
	
	var _prodInvariant = __webpack_require__(3);
	
	var ReactElement = __webpack_require__(13);
	
	var invariant = __webpack_require__(2);
	
	/**
	 * Returns the first child in a collection of children and verifies that there
	 * is only one child in the collection.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.only
	 *
	 * The current implementation of this function assumes that a single child gets
	 * passed without a wrapper, but the purpose of this helper function is to
	 * abstract away the particular structure of children.
	 *
	 * @param {?object} children Child collection structure.
	 * @return {ReactElement} The first and only `ReactElement` contained in the
	 * structure.
	 */
	function onlyChild(children) {
	  !ReactElement.isValidElement(children) ?  false ? invariant(false, 'React.Children.only expected to receive a single React element child.') : _prodInvariant('143') : void 0;
	  return children;
	}
	
	module.exports = onlyChild;

/***/ },
/* 367 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule quoteAttributeValueForBrowser
	 */
	
	'use strict';
	
	var escapeTextContentForBrowser = __webpack_require__(45);
	
	/**
	 * Escapes attribute value to prevent scripting attacks.
	 *
	 * @param {*} value Value to escape.
	 * @return {string} An escaped string.
	 */
	function quoteAttributeValueForBrowser(value) {
	  return '"' + escapeTextContentForBrowser(value) + '"';
	}
	
	module.exports = quoteAttributeValueForBrowser;

/***/ },
/* 368 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	* @providesModule renderSubtreeIntoContainer
	*/
	
	'use strict';
	
	var ReactMount = __webpack_require__(113);
	
	module.exports = ReactMount.renderSubtreeIntoContainer;

/***/ },
/* 369 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	function createThunkMiddleware(extraArgument) {
	  return function (_ref) {
	    var dispatch = _ref.dispatch;
	    var getState = _ref.getState;
	    return function (next) {
	      return function (action) {
	        if (typeof action === 'function') {
	          return action(dispatch, getState, extraArgument);
	        }
	
	        return next(action);
	      };
	    };
	  };
	}
	
	var thunk = createThunkMiddleware();
	thunk.withExtraArgument = createThunkMiddleware;
	
	exports['default'] = thunk;

/***/ },
/* 370 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports['default'] = applyMiddleware;
	
	var _compose = __webpack_require__(128);
	
	var _compose2 = _interopRequireDefault(_compose);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	/**
	 * Creates a store enhancer that applies middleware to the dispatch method
	 * of the Redux store. This is handy for a variety of tasks, such as expressing
	 * asynchronous actions in a concise manner, or logging every action payload.
	 *
	 * See `redux-thunk` package as an example of the Redux middleware.
	 *
	 * Because middleware is potentially asynchronous, this should be the first
	 * store enhancer in the composition chain.
	 *
	 * Note that each middleware will be given the `dispatch` and `getState` functions
	 * as named arguments.
	 *
	 * @param {...Function} middlewares The middleware chain to be applied.
	 * @returns {Function} A store enhancer applying the middleware.
	 */
	function applyMiddleware() {
	  for (var _len = arguments.length, middlewares = Array(_len), _key = 0; _key < _len; _key++) {
	    middlewares[_key] = arguments[_key];
	  }
	
	  return function (createStore) {
	    return function (reducer, preloadedState, enhancer) {
	      var store = createStore(reducer, preloadedState, enhancer);
	      var _dispatch = store.dispatch;
	      var chain = [];
	
	      var middlewareAPI = {
	        getState: store.getState,
	        dispatch: function dispatch(action) {
	          return _dispatch(action);
	        }
	      };
	      chain = middlewares.map(function (middleware) {
	        return middleware(middlewareAPI);
	      });
	      _dispatch = _compose2['default'].apply(undefined, chain)(store.dispatch);
	
	      return _extends({}, store, {
	        dispatch: _dispatch
	      });
	    };
	  };
	}

/***/ },
/* 371 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports['default'] = bindActionCreators;
	function bindActionCreator(actionCreator, dispatch) {
	  return function () {
	    return dispatch(actionCreator.apply(undefined, arguments));
	  };
	}
	
	/**
	 * Turns an object whose values are action creators, into an object with the
	 * same keys, but with every function wrapped into a `dispatch` call so they
	 * may be invoked directly. This is just a convenience method, as you can call
	 * `store.dispatch(MyActionCreators.doSomething())` yourself just fine.
	 *
	 * For convenience, you can also pass a single function as the first argument,
	 * and get a function in return.
	 *
	 * @param {Function|Object} actionCreators An object whose values are action
	 * creator functions. One handy way to obtain it is to use ES6 `import * as`
	 * syntax. You may also pass a single function.
	 *
	 * @param {Function} dispatch The `dispatch` function available on your Redux
	 * store.
	 *
	 * @returns {Function|Object} The object mimicking the original object, but with
	 * every action creator wrapped into the `dispatch` call. If you passed a
	 * function as `actionCreators`, the return value will also be a single
	 * function.
	 */
	function bindActionCreators(actionCreators, dispatch) {
	  if (typeof actionCreators === 'function') {
	    return bindActionCreator(actionCreators, dispatch);
	  }
	
	  if (typeof actionCreators !== 'object' || actionCreators === null) {
	    throw new Error('bindActionCreators expected an object or a function, instead received ' + (actionCreators === null ? 'null' : typeof actionCreators) + '. ' + 'Did you write "import ActionCreators from" instead of "import * as ActionCreators from"?');
	  }
	
	  var keys = Object.keys(actionCreators);
	  var boundActionCreators = {};
	  for (var i = 0; i < keys.length; i++) {
	    var key = keys[i];
	    var actionCreator = actionCreators[key];
	    if (typeof actionCreator === 'function') {
	      boundActionCreators[key] = bindActionCreator(actionCreator, dispatch);
	    }
	  }
	  return boundActionCreators;
	}

/***/ },
/* 372 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports['default'] = combineReducers;
	
	var _createStore = __webpack_require__(129);
	
	var _isPlainObject = __webpack_require__(48);
	
	var _isPlainObject2 = _interopRequireDefault(_isPlainObject);
	
	var _warning = __webpack_require__(130);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function getUndefinedStateErrorMessage(key, action) {
	  var actionType = action && action.type;
	  var actionName = actionType && '"' + actionType.toString() + '"' || 'an action';
	
	  return 'Given action ' + actionName + ', reducer "' + key + '" returned undefined. ' + 'To ignore an action, you must explicitly return the previous state.';
	}
	
	function getUnexpectedStateShapeWarningMessage(inputState, reducers, action, unexpectedKeyCache) {
	  var reducerKeys = Object.keys(reducers);
	  var argumentName = action && action.type === _createStore.ActionTypes.INIT ? 'preloadedState argument passed to createStore' : 'previous state received by the reducer';
	
	  if (reducerKeys.length === 0) {
	    return 'Store does not have a valid reducer. Make sure the argument passed ' + 'to combineReducers is an object whose values are reducers.';
	  }
	
	  if (!(0, _isPlainObject2['default'])(inputState)) {
	    return 'The ' + argumentName + ' has unexpected type of "' + {}.toString.call(inputState).match(/\s([a-z|A-Z]+)/)[1] + '". Expected argument to be an object with the following ' + ('keys: "' + reducerKeys.join('", "') + '"');
	  }
	
	  var unexpectedKeys = Object.keys(inputState).filter(function (key) {
	    return !reducers.hasOwnProperty(key) && !unexpectedKeyCache[key];
	  });
	
	  unexpectedKeys.forEach(function (key) {
	    unexpectedKeyCache[key] = true;
	  });
	
	  if (unexpectedKeys.length > 0) {
	    return 'Unexpected ' + (unexpectedKeys.length > 1 ? 'keys' : 'key') + ' ' + ('"' + unexpectedKeys.join('", "') + '" found in ' + argumentName + '. ') + 'Expected to find one of the known reducer keys instead: ' + ('"' + reducerKeys.join('", "') + '". Unexpected keys will be ignored.');
	  }
	}
	
	function assertReducerSanity(reducers) {
	  Object.keys(reducers).forEach(function (key) {
	    var reducer = reducers[key];
	    var initialState = reducer(undefined, { type: _createStore.ActionTypes.INIT });
	
	    if (typeof initialState === 'undefined') {
	      throw new Error('Reducer "' + key + '" returned undefined during initialization. ' + 'If the state passed to the reducer is undefined, you must ' + 'explicitly return the initial state. The initial state may ' + 'not be undefined.');
	    }
	
	    var type = '@@redux/PROBE_UNKNOWN_ACTION_' + Math.random().toString(36).substring(7).split('').join('.');
	    if (typeof reducer(undefined, { type: type }) === 'undefined') {
	      throw new Error('Reducer "' + key + '" returned undefined when probed with a random type. ' + ('Don\'t try to handle ' + _createStore.ActionTypes.INIT + ' or other actions in "redux/*" ') + 'namespace. They are considered private. Instead, you must return the ' + 'current state for any unknown actions, unless it is undefined, ' + 'in which case you must return the initial state, regardless of the ' + 'action type. The initial state may not be undefined.');
	    }
	  });
	}
	
	/**
	 * Turns an object whose values are different reducer functions, into a single
	 * reducer function. It will call every child reducer, and gather their results
	 * into a single state object, whose keys correspond to the keys of the passed
	 * reducer functions.
	 *
	 * @param {Object} reducers An object whose values correspond to different
	 * reducer functions that need to be combined into one. One handy way to obtain
	 * it is to use ES6 `import * as reducers` syntax. The reducers may never return
	 * undefined for any action. Instead, they should return their initial state
	 * if the state passed to them was undefined, and the current state for any
	 * unrecognized action.
	 *
	 * @returns {Function} A reducer function that invokes every reducer inside the
	 * passed object, and builds a state object with the same shape.
	 */
	function combineReducers(reducers) {
	  var reducerKeys = Object.keys(reducers);
	  var finalReducers = {};
	  for (var i = 0; i < reducerKeys.length; i++) {
	    var key = reducerKeys[i];
	
	    if (false) {
	      if (typeof reducers[key] === 'undefined') {
	        (0, _warning2['default'])('No reducer provided for key "' + key + '"');
	      }
	    }
	
	    if (typeof reducers[key] === 'function') {
	      finalReducers[key] = reducers[key];
	    }
	  }
	  var finalReducerKeys = Object.keys(finalReducers);
	
	  if (false) {
	    var unexpectedKeyCache = {};
	  }
	
	  var sanityError;
	  try {
	    assertReducerSanity(finalReducers);
	  } catch (e) {
	    sanityError = e;
	  }
	
	  return function combination() {
	    var state = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	    var action = arguments[1];
	
	    if (sanityError) {
	      throw sanityError;
	    }
	
	    if (false) {
	      var warningMessage = getUnexpectedStateShapeWarningMessage(state, finalReducers, action, unexpectedKeyCache);
	      if (warningMessage) {
	        (0, _warning2['default'])(warningMessage);
	      }
	    }
	
	    var hasChanged = false;
	    var nextState = {};
	    for (var i = 0; i < finalReducerKeys.length; i++) {
	      var key = finalReducerKeys[i];
	      var reducer = finalReducers[key];
	      var previousStateForKey = state[key];
	      var nextStateForKey = reducer(previousStateForKey, action);
	      if (typeof nextStateForKey === 'undefined') {
	        var errorMessage = getUndefinedStateErrorMessage(key, action);
	        throw new Error(errorMessage);
	      }
	      nextState[key] = nextStateForKey;
	      hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
	    }
	    return hasChanged ? nextState : state;
	  };
	}

/***/ },
/* 373 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(374);


/***/ },
/* 374 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _ponyfill = __webpack_require__(375);
	
	var _ponyfill2 = _interopRequireDefault(_ponyfill);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var root = undefined; /* global window */
	
	if (typeof global !== 'undefined') {
		root = global;
	} else if (typeof window !== 'undefined') {
		root = window;
	}
	
	var result = (0, _ponyfill2['default'])(root);
	exports['default'] = result;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 375 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports['default'] = symbolObservablePonyfill;
	function symbolObservablePonyfill(root) {
		var result;
		var _Symbol = root.Symbol;
	
		if (typeof _Symbol === 'function') {
			if (_Symbol.observable) {
				result = _Symbol.observable;
			} else {
				result = _Symbol('observable');
				_Symbol.observable = result;
			}
		} else {
			result = '@@observable';
		}
	
		return result;
	};

/***/ },
/* 376 */
/***/ function(module, exports, __webpack_require__) {

	var map = {
		"./1.json": 298,
		"./2.json": 299,
		"./3.json": 300
	};
	function webpackContext(req) {
		return __webpack_require__(webpackContextResolve(req));
	};
	function webpackContextResolve(req) {
		return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
	};
	webpackContext.keys = function webpackContextKeys() {
		return Object.keys(map);
	};
	webpackContext.resolve = webpackContextResolve;
	module.exports = webpackContext;
	webpackContext.id = 376;


/***/ },
/* 377 */
/***/ function(module, exports, __webpack_require__) {

	var map = {
		"./0B0WQeAm03_OZWDhCVDluLVNGRHM": 92,
		"./0B0WQeAm03_OZWDhCVDluLVNGRHM.js": 92,
		"./0B7M38pRihZntUThVLXlqdFdxdDQ": 93,
		"./0B7M38pRihZntUThVLXlqdFdxdDQ.js": 93,
		"./0B7M38pRihZntVlgzV3dERVU0cG8": 94,
		"./0B7M38pRihZntVlgzV3dERVU0cG8.js": 94
	};
	function webpackContext(req) {
		return __webpack_require__(webpackContextResolve(req));
	};
	function webpackContextResolve(req) {
		return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
	};
	webpackContext.keys = function webpackContextKeys() {
		return Object.keys(map);
	};
	webpackContext.resolve = webpackContextResolve;
	module.exports = webpackContext;
	webpackContext.id = 377;


/***/ }
/******/ ])));


/** WEBPACK FOOTER **
 ** static/js/main.9c66ea7d.js
 **/